/**
 * This file was automatically generated by `TranslationsCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source English locale translations at
 * `src/locales/en-US/*.json`, and run `yarn i18n:codegen` to regenerate this file.
 */

import type { TOptions } from 'i18next';
export type TranslateFunction = (options?: TOptions) => string;

export type LeafNodeValue = string | TranslateFunction;

export type AccommodationsAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Showing <aiText/> of <boldCount/> hotels<distanceInfo/><priceInfo/>'
   */
  venueAreaSummary: T;

  quick: {
    /**
     * @default 'When they do, you'll see their hotel bookings here. Nearby hotels fill up quickly, so send a reminder to help guests lock in the best rates.'
     */
    '49554': T;

    /**
     * @default '{{0}} guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} guest
     * - plural: {{0}} guests
     */
    '7s6hI': T;

    /**
     * @default '{{0}} adult'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} adult
     * - plural: {{0}} adults
     */
    LyIUS: T;

    /**
     * @default '{{0}} child'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} child
     * - plural: {{0}} children
     */
    XdwYV: T;

    /**
     * @default 'Unknown hotel'
     */
    W7J7a: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Stay dates'
     */
    '6aZ5d': T;

    /**
     * @default 'Room type'
     */
    PsIPm: T;

    /**
     * @default 'Occupancy'
     */
    fz51z: T;

    /**
     * @default 'Includes children'
     */
    kkLbR: T;

    /**
     * @default 'Adults only'
     */
    DugZV: T;

    /**
     * @default 'Booking date'
     */
    '535lc': T;

    /**
     * @default 'Last {{0}} days'
     */
    '50xeu': T;

    /**
     * @default 'Before you go - would a different layout work better?'
     */
    AAFBt: T;

    /**
     * @default 'Sometimes a new look is all the page needs. Pick a layout to preview it with your content.'
     */
    kPpzR: T;

    /**
     * @default 'Select a layout'
     */
    vIkEF: T;

    /**
     * @default 'Turn Off the Page'
     */
    '64aQH': T;

    /**
     * @default 'Apply This Layout'
     */
    wIxNm: T;

    /**
     * @default 'Header Style'
     */
    YRPfC: T;

    /**
     * @default 'Select layout'
     */
    egWLo: T;

    /**
     * @default 'Layout options'
     */
    UHzfB: T;

    /**
     * @default 'Hotel removed.'
     */
    qtnAJ: T;

    /**
     * @default 'Hotels removed.'
     */
    XM2Zm: T;

    /**
     * @default 'Couldn't delete hotels. Try again.'
     */
    lA0Zb: T;

    /**
     * @default 'Some hotels couldn't be deleted. Try again.'
     */
    ShrYA: T;

    /**
     * @default 'Hotel removed successfully.'
     */
    rrZrQ: T;

    /**
     * @default 'An error occurred while deleting the hotel. Please try again.'
     */
    '13oks': T;

    /**
     * @default 'Failed to cancel room block'
     */
    '6KY0z': T;

    /**
     * @default 'Room block cancelled'
     */
    HGC6H: T;

    /**
     * @default 'Edit Hotel'
     */
    '0b1S2': T;

    /**
     * @default 'Add Hotel'
     */
    TDwjJ: T;

    /**
     * @default 'How Guests See It'
     */
    vsr8K: T;

    /**
     * @default 'Edit how this hotel is shown to guests on your website. Choose the cover photo, let guests know where you’re staying and write a personal note why you’re recommending it.'
     */
    KPUIE: T;

    /**
     * @default 'More info'
     */
    '17u51': T;

    /**
     * @default 'Are you sure you want to delete this item?'
     */
    PsQI1: T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'Remove Stay from Page'
     */
    '4swaB': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Add Venue'
     */
    oK4pK: T;

    /**
     * @default 'Your event is {{0}}, but these hotel dates are {{1}}. Guests will see these dates when they search for a room.'
     */
    '6VelM': T;

    /**
     * @default 'Update Dates'
     */
    kGxlO: T;

    /**
     * @default 'Map and Hotel Tiles'
     */
    '8LIry': T;

    /**
     * @default 'Editorial'
     */
    T3cjm: T;

    /**
     * @default 'Side by Side'
     */
    jPKbB: T;

    /**
     * @default 'Side by Side Elegant'
     */
    jRtEH: T;

    /**
     * @default 'Full Width Photo'
     */
    pqmo1: T;

    /**
     * @default 'Typographic'
     */
    OEt4f: T;

    /**
     * @default 'Stylish with Hover Effect'
     */
    xmieQ: T;

    /**
     * @default 'Map and a stack of hotel cards'
     */
    KAvat: T;

    /**
     * @default 'Spotlight imagery with overlay text'
     */
    hrpMK: T;

    /**
     * @default 'Two columns with a photo and details'
     */
    bQEC0: T;

    /**
     * @default 'Editorial with caption and a button'
     */
    lTIDH: T;

    /**
     * @default 'Full width photo with overlay text'
     */
    OJB0Q: T;

    /**
     * @default 'Text-forward, no large imagery'
     */
    RwOaD: T;

    /**
     * @default 'Cards that animate on hover'
     */
    Et75H: T;

    /**
     * @default 'Close tooltip'
     */
    xSDvO: T;

    /**
     * @default 'Preview mode'
     */
    Do3Zk: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Map'
     */
    '4pWAA': T;

    /**
     * @default 'See your hotels on a map and explore nearby options.'
     */
    csUQL: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default '{{0}} recommended'
     */
    BLq4f: T;

    /**
     * @default ' within {{0}} mi.'
     */
    NV3JU: T;

    /**
     * @default ' Prices from {{0}}/night.'
     */
    nhzwe: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Your venue area'
     */
    zW92q: T;

    /**
     * @default 'No hotels found in this area.'
     */
    yEpsX: T;

    /**
     * @default 'Loading hotel data...'
     */
    YnJAh: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Neighborhoods'
     */
    v2yGJ: T;

    /**
     * @default 'Bookings'
     */
    mV0kh: T;

    /**
     * @default 'An error occurred while canceling your room block. Please try again.'
     */
    Je3Md: T;

    /**
     * @default 'Your room block cancellation request has been sent.'
     */
    pjmis: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'View Hotel'
     */
    VnGJE: T;

    /**
     * @default 'Cancel Room Block'
     */
    Oabtb: T;

    /**
     * @default 'Delete Hotel Room Block'
     */
    ZheRl: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Guests Bookings'
     */
    rGq8Z: T;

    /**
     * @default 'Guests haven't booked yet'
     */
    W2DJQ: T;

    /**
     * @default 'Remind Guests to Book'
     */
    KhgiN: T;

    /**
     * @default 'Remove {{0}} filter'
     */
    YK0cm: T;

    /**
     * @default 'Add {{0}} filter'
     */
    Rvxti: T;

    /**
     * @default 'Filter Bookings'
     */
    eQfx7: T;

    /**
     * @default 'Close filters'
     */
    nU0q9: T;

    /**
     * @default 'Clear All'
     */
    UcfzE: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'No bookings match'
     */
    eaf2z: T;

    /**
     * @default 'Try adjusting your search or filters to see more bookings.'
     */
    U86U8: T;

    /**
     * @default 'Clear search & filters'
     */
    eFA5B: T;

    /**
     * @default 'Most Recent'
     */
    '8GlIq': T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Sort guests'
     */
    NFqTD: T;

    /**
     * @default 'Sort:'
     */
    whR6G: T;

    /**
     * @default 'Sort options'
     */
    YiS7H: T;

    /**
     * @default '{{0}} hotel'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} hotel
     * - plural: {{0}} hotels
     */
    dB6VR: T;

    /**
     * @default '{{0}} · {{1}}'
     */
    UsBX1: T;

    /**
     * @default 'Filter ({{0}} active)'
     */
    LytVW: T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'By Lodging'
     */
    hrJIH: T;

    /**
     * @default 'By Guest'
     */
    Fbl0e: T;

    /**
     * @default 'Search by guest or hotel...'
     */
    '6Nsgd': T;

    /**
     * @default '1 guest hasn't booked yet.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest hasn't booked yet.
     * - plural: {{0}} guests haven't booked yet.
     */
    MDIFv: T;

    /**
     * @default 'Everyone who RSVP'd has booked their stay.'
     */
    '6trkC': T;

    /**
     * @default 'Remind your guests to book their stay.'
     */
    k3lHX: T;

    /**
     * @default '{{0}} hasn't booked a room yet.'
     */
    RxwlV: T;

    /**
     * @default '{{0}} and {{1}} haven't booked rooms yet.'
     */
    '9GzbQ': T;

    /**
     * @default '{{0}} and {{1}} others haven't booked yet.'
     */
    gV12b: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'View RSVP Response'
     */
    z9Bxw: T;

    /**
     * @default 'Delete 1 item?'
     */
    '28H54': T;

    /**
     * @default 'Delete {{0}} items?'
     */
    ihT5v: T;

    /**
     * @default 'Delete 1 item'
     */
    Bf8Mg: T;

    /**
     * @default 'Delete {{0}} items'
     */
    L7get: T;

    /**
     * @default 'Our Pick'
     */
    Fg6wn: T;

    /**
     * @default 'Room Block'
     */
    uV3Vh: T;

    /**
     * @default 'Discard reorder changes?'
     */
    douGF: T;

    /**
     * @default 'Your pending order will not be saved.'
     */
    Hzs83: T;

    /**
     * @default 'Discard'
     */
    CIW2C: T;

    /**
     * @default 'Keep editing'
     */
    fPEvp: T;

    /**
     * @default '{{0}} place'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} place
     * - plural: {{0}} places
     */
    vRgQH: T;

    /**
     * @default '{{0}} stay'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} stay
     * - plural: {{0}} stays
     */
    zJN2X: T;

    /**
     * @default '{{0}} · no stay details yet'
     */
    Z2WtT: T;

    /**
     * @default 'We couldn't load your guest list'
     */
    '1H6Sj': T;

    /**
     * @default 'Refresh the page to try again.'
     */
    TL6hC: T;

    /**
     * @default 'We couldn't load your guest stays'
     */
    hxWAD: T;

    /**
     * @default 'No guests match your search'
     */
    QtNcm: T;

    /**
     * @default 'Clear search and filters'
     */
    XPw2O: T;

    /**
     * @default 'Everyone has shared their stay'
     */
    '7p5i0': T;

    /**
     * @default 'When someone new joins your guest list, they'll appear here until you know where they're staying.'
     */
    eUTua: T;

    /**
     * @default 'No stays match your search'
     */
    tFmbA: T;

    /**
     * @default 'No guest-shared stays yet'
     */
    xHJVL: T;

    /**
     * @default 'When guests share where they're staying, they'll show up here.'
     */
    tLkhp: T;

    /**
     * @default 'No stays to show yet'
     */
    bq0aQ: T;

    /**
     * @default 'Stays booked through Joy appear here as soon as your guests reserve a room.'
     */
    HZf8M: T;

    /**
     * @default 'Request Stay Details'
     */
    GTeFm: T;

    /**
     * @default 'Sort lodgings'
     */
    '5B41D': T;

    /**
     * @default 'Most guests'
     */
    w96Cl: T;

    /**
     * @default 'Most recent'
     */
    eBQ3C: T;

    /**
     * @default 'Largest party'
     */
    UDBQ7: T;

    /**
     * @default 'All types'
     */
    SqMqN: T;

    /**
     * @default 'Vacation rental'
     */
    zypbm: T;

    /**
     * @default 'Stay type'
     */
    XmgPd: T;

    /**
     * @default 'Arriving on or before'
     */
    v4Llb: T;

    /**
     * @default 'Clear filters'
     */
    '0Ev5m': T;

    /**
     * @default 'These filters describe a stay, so they don't change the Missing details list.'
     */
    '8X53z': T;

    /**
     * @default 'Guest stays'
     */
    yj0Cl: T;

    /**
     * @default 'Everyone's stay, all in one place. Booked on Joy or shared by your guests.'
     */
    '72MFR': T;

    /**
     * @default 'Show where guests are staying on a map'
     */
    WMJhR: T;

    /**
     * @default 'Shared by your guests · waiting on the hotel'
     */
    KpcLV: T;

    /**
     * @default 'Hotel not shared yet'
     */
    i2aRa: T;

    /**
     * @default 'Available on Joy'
     */
    qDjCh: T;

    /**
     * @default '{{0}} place on the map'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} place on the map
     * - plural: {{0}} places on the map
     */
    LFLV7: T;

    /**
     * @default '{{0}} place has no location, so it isn't on the map.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} place has no location, so it isn't on the map.
     * - plural: {{0}} places have no location, so they aren't on the map.
     */
    gPrlH: T;

    /**
     * @default 'Where everyone's staying'
     */
    bpqWU: T;

    /**
     * @default 'No stays on the map yet'
     */
    xnbMx: T;

    /**
     * @default 'Map of where everyone's staying'
     */
    mPlFy: T;

    /**
     * @default 'No stays to map yet.'
     */
    '43GAh': T;

    /**
     * @default 'None of these stays have a location we can map yet.'
     */
    CpLeR: T;

    /**
     * @default 'Awaiting details'
     */
    eAHYM: T;

    /**
     * @default 'Request details'
     */
    '1XOSo': T;

    /**
     * @default 'Missing details doesn't mean a guest hasn't booked. They may be staying somewhere else.'
     */
    KcoSB: T;

    /**
     * @default 'All stays'
     */
    jVZkN: T;

    /**
     * @default 'Booked on Joy'
     */
    fYZWg: T;

    /**
     * @default 'Guest-shared'
     */
    I2ibg: T;

    /**
     * @default 'Missing details'
     */
    Ofw26: T;

    /**
     * @default 'Filter stays by status'
     */
    HT0PA: T;

    /**
     * @default '{{0}} vacation rental'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} vacation rental
     * - plural: {{0}} vacation rentals
     */
    '12A8s': T;

    /**
     * @default '1 guest hasn't shared yet'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest hasn't shared yet
     * - plural: {{0}} guests haven't shared yet
     */
    '0yWIH': T;

    /**
     * @default 'guests'
     */
    XOwGN: T;

    /**
     * @default '/ {{0}} guests'
     */
    '2s11Q': T;

    /**
     * @default 'With stay details'
     */
    p91EI: T;

    /**
     * @default 'Guests with stay details'
     */
    EdFcS: T;

    /**
     * @default 'places to stay'
     */
    cm1rx: T;

    /**
     * @default 'We couldn't load your guest list.'
     */
    rZ7ZC: T;

    /**
     * @default 'We couldn't load your guest stays.'
     */
    TXIMl: T;

    /**
     * @default 'Lodging'
     */
    yBbH0: T;

    /**
     * @default 'Party size'
     */
    nU7ad: T;

    /**
     * @default 'Stay source'
     */
    IbcaW: T;

    /**
     * @default 'Delete Custom Property'
     */
    Zl7ta: T;

    /**
     * @default 'Delete Accommodation'
     */
    VQJHt: T;

    /**
     * @default 'A mix for different budgets'
     */
    vQfSs: T;

    /**
     * @default 'More affordable'
     */
    zF2Bs: T;

    /**
     * @default 'More upscale'
     */
    gYK3U: T;

    /**
     * @default 'Closer'
     */
    QcAEp: T;

    /**
     * @default 'I'd rather just suggest neighborhoods'
     */
    BKoul: T;

    /**
     * @default 'Some affordable, some upscale'
     */
    PQiOc: T;

    /**
     * @default 'Budget-friendly options'
     */
    nBPAl: T;

    /**
     * @default 'Higher-end hotels'
     */
    mQLJw: T;

    /**
     * @default 'Convenience over everything'
     */
    kxllG: T;

    /**
     * @default 'Skip specific hotels — point guests to the right areas'
     */
    ZfQj9: T;

    /**
     * @default 'What kind of hotels should we add?'
     */
    '5SnwC': T;

    /**
     * @default 'Tell us what you're looking for and we'll suggest better matches.'
     */
    '9bbVQ': T;

    /**
     * @default 'No thanks, I'll keep editing'
     */
    '7wCGR': T;

    /**
     * @default 'Add hotel recommendations to save guests time and money'
     */
    UAOFc: T;

    /**
     * @default 'Give your guests the best rates on hotels close to your venue, available exclusively to the millions of people using Joy.'
     */
    NBBGD: T;

    /**
     * @default 'Suggest Hotels Nearby'
     */
    c3b9O: T;

    /**
     * @default 'Failed to update accommodation. Please try again.'
     */
    aGStD: T;

    /**
     * @default 'Favorite hotel must remain first in the list'
     */
    PfdT7: T;

    /**
     * @default 'Hotels with Instant Room Blocks must remain at the top of the list'
     */
    '1vOtU': T;

    /**
     * @default 'Failed to update order'
     */
    HCvlD: T;

    /**
     * @default 'Order updated'
     */
    ZfOoh: T;

    /**
     * @default 'Suggest hotels'
     */
    fzqu6: T;

    /**
     * @default 'Edit hotels'
     */
    pknxI: T;

    /**
     * @default 'Why these picks'
     */
    Rfi0N: T;

    /**
     * @default 'Select All ({{0}}/{{1}})'
     */
    ykwGU: T;

    /**
     * @default 'Clear'
     */
    NdJoF: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Manage'
     */
    JaHpE: T;

    /**
     * @default 'Suggest'
     */
    WmiYP: T;

    /**
     * @default 'Newly Added'
     */
    '37YII': T;

    /**
     * @default 'Book by: {{0}}'
     */
    aB472: T;

    /**
     * @default 'Room rates not released yet'
     */
    iBjRC: T;

    /**
     * @default 'Rooms not currently available'
     */
    i8w0s: T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Error saving dates'
     */
    bWj9V: T;

    /**
     * @default 'Suggested Stay Dates'
     */
    rBDNf: T;

    /**
     * @default 'Help guests book hotels with the right dates from the start.'
     */
    jiXy9: T;

    /**
     * @default 'Check-In Date'
     */
    YMM6E: T;

    /**
     * @default 'Add check-in date'
     */
    rJAGa: T;

    /**
     * @default 'Check-Out Date'
     */
    jHfIJ: T;

    /**
     * @default 'Add check-out date'
     */
    '6G1hz': T;

    /**
     * @default 'Your event date doesn't fall within these hotel dates. Guests may book for the wrong dates.'
     */
    '2Wkot': T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'This looks like your wedding venue'
     */
    hgMlt: T;

    /**
     * @default 'Tag it so guests spot it first.'
     */
    '3EswZ': T;

    /**
     * @default 'Tag as Our Pick'
     */
    PD7Nk: T;

    /**
     * @default 'We're staying here'
     */
    '1uRUs': T;

    /**
     * @default 'Recommended'
     */
    '1pIEc': T;

    /**
     * @default 'Same address as {{0}}. Turn on a tag below so guests spot it first.'
     */
    wCbB9: T;

    /**
     * @default 'Turn on a tag below so guests spot it first.'
     */
    Q3SfA: T;

    /**
     * @default 'Browse Hotels'
     */
    fDEDd: T;

    /**
     * @default 'Browse Hotels on Map'
     */
    '6Lk36': T;

    /**
     * @default 'Help me find hotels and deals for my guests near venue.'
     */
    ueHJm: T;

    /**
     * @default 'Add Room Block'
     */
    vLk3w: T;

    /**
     * @default 'Add room block you already secured for your guests.'
     */
    sBQoR: T;

    /**
     * @default 'Get Room Block'
     */
    Qax59: T;

    /**
     * @default 'Search for available rooms blocks with exclusive upgrades near your event.'
     */
    Yevlv: T;

    /**
     * @default 'Add Rental Home, Campsite or More'
     */
    '8X61k': T;

    /**
     * @default 'Add a link to a rental home, campsite or any other unique stays.'
     */
    B4C3j: T;

    /**
     * @default 'Search for a hotel you have in mind'
     */
    GOuZA: T;

    /**
     * @default 'Renaissance Chelsea, New York'
     */
    '0EEYY': T;

    /**
     * @default 'Add Place to Stay'
     */
    O0HA1: T;

    /**
     * @default 'Add a hotel suggestion for your guests to make their trip planning easier.'
     */
    Ryz2N: T;

    /**
     * @default 'Alternatively, select from the options below'
     */
    SUUAp: T;

    /**
     * @default 'Edit Hotel Link'
     */
    sgJOj: T;

    /**
     * @default 'Add your own stay'
     */
    RO2AI: T;

    /**
     * @default 'Edit existing room block, homes or other unique stays link to your page.'
     */
    aYyXa: T;

    /**
     * @default 'Add an existing room block you secured for your guests.'
     */
    '01czl': T;

    /**
     * @default 'Add an existing room block, homes or other unique stays link to your page.'
     */
    YEH4A: T;

    /**
     * @default 'An error occurred while canceling the room block. Please try again.'
     */
    '5RJ0H': T;

    /**
     * @default 'You can share a note with your guests here!'
     */
    Opm2e: T;
  };
};

export type AccommodationsConsoleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Explore Hotels'
     */
    exploreHotels: T;

    /**
     * @default 'Show only couple’s recommendations'
     */
    pickedByCouple: T;

    rooms: {
      /**
       * @default '1 Room'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Room
       * - plural: {{ rooms }} Rooms
       */
      rooms: T;
    };
    guests: {
      /**
       * @default '1 Guest'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Guest
       * - plural: {{ guests }} Guests
       */
      guests: T;
    };
  };
  mobileSearch: {
    /**
     * @default 'Search Location'
     */
    title: T;

    /**
     * @default 'Select Dates'
     */
    selectDates: T;

    /**
     * @default 'Save'
     */
    save: T;
  };
  filterPanel: {
    /**
     * @default 'Browse CUG Rates Hotels'
     */
    title: T;

    /**
     * @default 'Filters'
     */
    filters: T;

    /**
     * @default 'Picked by the couple'
     */
    pickedByCouple: T;

    /**
     * @default 'Browse hotels with exclusive rates available only for our guests.'
     */
    findHotels: T;

    /**
     * @default 'Reset All Filters'
     */
    resetAllFilters: T;

    /**
     * @default 'Show Results'
     */
    showResults: T;

    showAvailableOnly: {
      /**
       * @default 'Show available hotels first'
       */
      title: T;
    };
    joyTravelBenefits: {
      /**
       * @default 'Joy Travel Benefits'
       */
      title: T;

      /**
       * @default 'Closed User Group Rates'
       */
      closedUserGroupRates: T;

      /**
       * @default 'Closed User Group (CUG) rates are special discounted hotel prices offered only to a specific group of people, in this case Joy guests. These rates are not listed publicly on standard travel websites. To access them, you just need to book through Joy.'
       */
      closedUserGroupRatesTooltipContent: T;
    };
    guestRating: {
      /**
       * @default 'Guest Rating'
       */
      title: T;

      /**
       * @default 'Wonderful: 9+'
       */
      wonderful: T;

      /**
       * @default 'Very Good: 8+'
       */
      veryGood: T;

      /**
       * @default 'Good: 7+'
       */
      good: T;

      /**
       * @default 'Pleasant: 6+'
       */
      pleasant: T;
    };
    priceRange: {
      /**
       * @default 'Price per night'
       */
      title: T;

      /**
       * @default 'Includes all taxes and fees'
       */
      description: T;

      /**
       * @default 'Min'
       */
      min: T;

      /**
       * @default 'Max'
       */
      max: T;
    };
    starRating: {
      /**
       * @default 'Star Rating'
       */
      title: T;

      /**
       * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
       */
      description: T;

      /**
       * @default '{{star}} Star'
       */
      starWithCount: T;
    };
    facilities: {
      /**
       * @default 'Facilities'
       */
      title: T;

      /**
       * @default 'Parking'
       */
      parking: T;

      /**
       * @default 'Restaurant'
       */
      restaurant: T;

      /**
       * @default 'Internet'
       */
      internet: T;

      /**
       * @default 'Spa'
       */
      spa: T;

      /**
       * @default 'Bar'
       */
      bar: T;

      /**
       * @default 'Breakfast'
       */
      breakfast: T;

      /**
       * @default 'ATM'
       */
      atm: T;

      /**
       * @default 'Swimming Pool'
       */
      swimmingPool: T;

      /**
       * @default 'Air Conditioning'
       */
      airConditioning: T;

      /**
       * @default 'Pets Allowed'
       */
      petsAllowed: T;

      /**
       * @default 'Non Smoking'
       */
      nonSmoking: T;
    };
  };
  listingsPanel: {
    /**
     * @default 'Browse Hotels'
     */
    title: T;

    /**
     * @default 'Book before {{cutoffDate}}'
     */
    cutoffDate: T;

    /**
     * @default 'more'
     */
    readMore: T;

    /**
     * @default 'Added'
     */
    added: T;

    /**
     * @default 'less'
     */
    readLess: T;

    /**
     * @default 'Show only couple’s recommendations'
     */
    pickedByCouple: T;

    /**
     * @default 'This hotel has no availability for the dates selected.'
     */
    soldOutMessage: T;

    /**
     * @default 'Map'
     */
    map: T;

    resetFiltersHeader: {
      /**
       * @default 'Reset All'
       */
      resetAll: T;

      /**
       * @default 'Price: {{min}} - {{max}}'
       */
      price: T;

      /**
       * @default 'Guest Rating: {{guestRating}}'
       */
      guestRating: T;

      /**
       * @default 'Star Rating: {{starRating}}'
       */
      starRating: T;
    };
    specialEventRates: {
      /**
       * @default 'Special Event Rates'
       */
      title: T;

      /**
       * @default 'Discounted Rates for Joy Guests'
       */
      tooltipTitle: T;

      /**
       * @default 'Benefit from exclusive rates up to 40% less compared to Expedia.'
       */
      tooltipContent: T;
    };

    /**
     * @default 'Couple's Pick'
     */
    couplesPick: T;

    /**
     * @default 'Room Block'
     */
    couplesPickRoomBlock: T;

    /**
     * @default 'Our Room Block'
     */
    ourRoomBlock: T;

    /**
     * @default 'Show More'
     */
    showMore: T;

    costBreakdown: {
      /**
       * @default '{{percentage}}% off'
       */
      discount: T;

      /**
       * @default '/ night'
       */
      perNight: T;

      /**
       * @default '{{totalCost}} total'
       */
      totalAfterTax: T;

      /**
       * @default '1 night, 1 room, incl. taxes and fees'
       */
      singleRoomSingleNight: T;

      /**
       * @default '1 night, {{rooms}} rooms, incl. taxes and fees'
       */
      multiRoomSingleNight: T;

      /**
       * @default '{{nights}} nights, 1 room, incl. taxes and fees'
       */
      singleRoomMultiNight: T;

      /**
       * @default '{{nights}} nights, {{rooms}} rooms, incl. taxes and fees'
       */
      multiRoomMultiNight: T;
    };
    hotelCTA: {
      /**
       * @default 'See Availability'
       */
      title: T;

      /**
       * @default 'Remove Hotel'
       */
      couplePicksButtonText: T;

      /**
       * @default 'Add Hotel'
       */
      coupleHotelButtonText: T;

      /**
       * @default 'See Availability'
       */
      hotelButtonText: T;
    };
    userRatings: {
      category: {
        /**
         * @default 'Wonderful'
         */
        wonderful: T;

        /**
         * @default 'Excellent'
         */
        excellent: T;

        /**
         * @default 'Fabulous'
         */
        fabulous: T;

        /**
         * @default 'Very Good'
         */
        veryGood: T;

        /**
         * @default 'Good'
         */
        good: T;

        /**
         * @default 'Pleasant'
         */
        pleasant: T;

        /**
         * @default 'Fair'
         */
        fair: T;
      };

      /**
       * @default '{{reviewCount}} reviews'
       */
      reviewCounts: T;
    };
    userRatingCategory: {
      /**
       * @default 'Wonderful'
       */
      wonderful: T;

      /**
       * @default 'Excellent'
       */
      excellent: T;

      /**
       * @default 'Fabulous'
       */
      fabulous: T;

      /**
       * @default 'Very Good'
       */
      veryGood: T;

      /**
       * @default 'Good'
       */
      good: T;

      /**
       * @default 'Pleasant'
       */
      pleasant: T;

      /**
       * @default 'Fair'
       */
      fair: T;
    };
    exploreMore: {
      /**
       * @default 'Explore More Hotels'
       */
      title: T;

      /**
       * @default 'Browse {{count}} other hotels near the wedding venue loved by Joy guests. '
       */
      subTitle: T;

      /**
       * @default 'Browse {{count}} More Stays'
       */
      buttonText: T;
    };
  };
  map: {
    /**
     * @default 'Search this area'
     */
    searchCta: T;

    /**
     * @default 'Stays in Map area'
     */
    areaSearchLocationValue: T;

    /**
     * @default 'Wedding venue'
     */
    weddingVenue: T;
  };
  emptyState: {
    /**
     * @default 'No Exact Matches'
     */
    title: T;

    /**
     * @default 'Try changing or removing some of your filters or adjusting your search area.'
     */
    content: T;

    /**
     * @default 'Show Nearest Hotels'
     */
    buttonText: T;
  };
  sort: {
    /**
     * @default 'Sort by'
     */
    title: T;

    /**
     * @default 'Sort by:'
     */
    sortPrefix: T;

    /**
     * @default 'Couple's Picks'
     */
    couplesPicks: T;

    /**
     * @default 'Price Low to High'
     */
    priceLowToHigh: T;

    /**
     * @default 'Price High to Low'
     */
    priceHighToLow: T;

    /**
     * @default 'Top Matches'
     */
    topMatches: T;

    /**
     * @default 'Most Savings'
     */
    mostSavings: T;

    /**
     * @default 'Highest Discount'
     */
    highestDiscount: T;

    /**
     * @default 'Distance'
     */
    distance: T;

    /**
     * @default 'Done'
     */
    done: T;
  };
  quick: {
    /**
     * @default 'View List'
     */
    ZZ4yU: T;

    /**
     * @default 'Map'
     */
    '4pWAA': T;

    /**
     * @default 'Save extra with your cash fund'
     */
    SoWyw: T;

    /**
     * @default 'Booking your own stay? Get an additional discount when you pay using your cash fund.'
     */
    tcORS: T;

    /**
     * @default 'View Cash Fund Offer'
     */
    bticP: T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'Highest Discount'
     */
    XT5eB: T;

    /**
     * @default 'Very Good: {{0}}+'
     */
    SHihJ: T;

    /**
     * @default 'Parking'
     */
    wABHN: T;

    /**
     * @default 'Swimming Pool'
     */
    rbKpB: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Breakfast'
     */
    '9vDBH': T;

    /**
     * @default 'Breakfast Included'
     */
    PaqdW: T;

    /**
     * @default 'Free Cancellation'
     */
    Z77Qm: T;

    /**
     * @default 'Walk to venue'
     */
    zdrKW: T;

    /**
     * @default 'Highest Fund Savings'
     */
    mnFdf: T;

    /**
     * @default 'Guest Rating'
     */
    XZAT2: T;

    /**
     * @default 'Loading all hotels around your event'
     */
    KBasV: T;

    /**
     * @default 'Finding the best hotels near the venue'
     */
    xlwWN: T;

    /**
     * @default 'Selecting hotels loved by Joy guests'
     */
    LgbBE: T;

    /**
     * @default 'Unlocking your exclusive Joy rates'
     */
    sDxLt: T;

    /**
     * @default 'Calculating walk and drive time'
     */
    '6KxZ1': T;

    /**
     * @default 'Finding hotels with exclusive event rates, up to 40% off.'
     */
    '7Ptps': T;

    /**
     * @default 'Retry Search'
     */
    uzBqV: T;

    /**
     * @default 'We’re having trouble loading hotels'
     */
    TSDNI: T;

    /**
     * @default 'Something went wrong on our end. Please try again in a moment.'
     */
    qbF71: T;

    /**
     * @default 'Wonderful: 9+'
     */
    '2X5DE': T;

    /**
     * @default 'Very Good: 8+'
     */
    EgsNS: T;

    /**
     * @default 'Good: 7+'
     */
    nLJKE: T;

    /**
     * @default 'Pleasant: 6+'
     */
    JF3Fk: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Vacation Rental'
     */
    T4ArP: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Price (per night)'
     */
    '1wUQU': T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Browse hotels with exclusive rates just for our guests.'
     */
    '6ZcbY': T;

    /**
     * @default 'Search by property name'
     */
    LeMdS: T;

    /**
     * @default 'e.g., Marriott'
     */
    KcHZo: T;

    /**
     * @default 'Show available hotels first'
     */
    '35dsA': T;

    /**
     * @default 'We prioritize showing available hotels, but you can choose to see them all.'
     */
    '0uU41': T;

    /**
     * @default 'Joy Travel Benefits'
     */
    Yc2nX: T;

    /**
     * @default 'Reservation policy'
     */
    m4bA4: T;

    /**
     * @default 'Free cancellation'
     */
    TQbyK: T;

    /**
     * @default 'Brand'
     */
    pBEkF: T;

    /**
     * @default 'Property Type'
     */
    vyVno: T;

    /**
     * @default 'Star Rating'
     */
    t9Xyc: T;

    /**
     * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
     */
    I5J8P: T;

    /**
     * @default 'Facilities'
     */
    '9ibd4': T;

    /**
     * @default 'Show Hotels'
     */
    i756F: T;

    /**
     * @default 'Reset All Filters'
     */
    bnE3D: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;

    /**
     * @default 'Your honeymoon fund has {{0}} available — switch to {{1}} to use it on this stay.'
     */
    k0dAw: T;

    /**
     * @default 'Your honeymoon fund uses this currency.'
     */
    rRidi: T;

    /**
     * @default 'Select currency to browse hotels in another currency without your fund.'
     */
    '0A9b9': T;

    /**
     * @default 'Close tooltip'
     */
    xSDvO: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'No stays in this map area — showing all nearby stays. Move or zoom out the map to focus on a different area.'
     */
    VWUux: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Exclusive Offer'
     */
    '8bRUM': T;

    /**
     * @default 'Sort:'
     */
    whR6G: T;

    /**
     * @default 'Sort by'
     */
    '1pqZA': T;

    /**
     * @default 'Back to Browse'
     */
    o7BYB: T;

    /**
     * @default 'YOUR FUND'
     */
    ivc9B: T;

    /**
     * @default 'ready to spend'
     */
    APgwT: T;

    /**
     * @default 'Use your cash fund to book stays'
     */
    WaUle: T;

    /**
     * @default 'Use your {{0}} for a honeymoon or getaway. Save up to an extra {{1}} ({{2}}) on rates only for Joy couples.'
     */
    '7q0RR': T;

    /**
     * @default 'Use your {{0}} for a honeymoon or getaway. Save up to an extra {{1}} on rates only for Joy couples.'
     */
    '02jDN': T;

    /**
     * @default 'Put your {{0}} toward a honeymoon or getaway, on rates only for Joy couples.'
     */
    Bo3FN: T;

    /**
     * @default 'Save more, travel further'
     */
    '4O0W0': T;

    /**
     * @default 'About this filter'
     */
    vbC7P: T;

    /**
     * @default 'Only show stays your honeymoon fund fully covers — no out-of-pocket cost.'
     */
    uC2Ef: T;

    /**
     * @default 'Honeymoon Rate'
     */
    caAsS: T;

    /**
     * @default 'Find your honeymoon'
     */
    iJNxP: T;

    /**
     * @default 'Hotels picked for honeymoons, wherever you are going.'
     */
    '4sCfB': T;

    /**
     * @default 'Are you sure you want to delete this item?'
     */
    PsQI1: T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'Remove Hotel'
     */
    '8jLre': T;

    /**
     * @default 'Add Hotel'
     */
    TDwjJ: T;

    /**
     * @default 'Independent'
     */
    GAMXf: T;

    /**
     * @default 'Show {{0}} on Map'
     */
    '2FeXZ': T;

    /**
     * @default 'Show on Map'
     */
    IeS7u: T;

    /**
     * @default 'Popular Filters'
     */
    '046kN': T;

    /**
     * @default '{{0}} → {{1}}+'
     */
    Eb8SD: T;

    /**
     * @default 'Min'
     */
    IuWAA: T;

    /**
     * @default 'Max'
     */
    CqWAA: T;

    /**
     * @default 'Honeymoon stays'
     */
    gCtwm: T;

    /**
     * @default 'Beach'
     */
    rYGiF: T;

    /**
     * @default 'Wellness'
     */
    Dn28y: T;

    /**
     * @default 'Nature'
     */
    FLUUH: T;

    /**
     * @default 'Luxury'
     */
    DBCoD: T;

    /**
     * @default 'Adventure'
     */
    '6eImY': T;

    /**
     * @default 'Show only'
     */
    R74NB: T;

    /**
     * @default 'Only stays matching every checked tag are shown. Uncheck to see more hotels.'
     */
    d4EzT: T;

    /**
     * @default '1 night, 1 room, incl. taxes, fees & property charges'
     */
    zlyqM: T;

    /**
     * @default '1 night, 1 room, incl. taxes and fees'
     */
    UWI50: T;

    /**
     * @default '1 night, {{0}} rooms, incl. taxes, fees & property charges'
     */
    HqqBB: T;

    /**
     * @default '1 night, {{0}} rooms, incl. taxes and fees'
     */
    SORZ7: T;

    /**
     * @default '{{0}} nights, 1 room, incl. taxes, fees & property charges'
     */
    nmqAS: T;

    /**
     * @default '{{0}} nights, 1 room, incl. taxes and fees'
     */
    cJEr8: T;

    /**
     * @default '{{0}} nights, {{1}} rooms, incl. taxes, fees & property charges'
     */
    imgEP: T;

    /**
     * @default '{{0}} nights, {{1}} rooms, incl. taxes and fees'
     */
    Bq2q3: T;

    /**
     * @default '/ night'
     */
    bjrXI: T;

    /**
     * @default '{{0}} total'
     */
    WvV3l: T;

    /**
     * @default 'Our Room Block'
     */
    S62hp: T;

    /**
     * @default 'Room Block'
     */
    uV3Vh: T;

    /**
     * @default 'Couple's Pick'
     */
    LvN7o: T;

    /**
     * @default 'Hide Filters'
     */
    LGxmU: T;

    /**
     * @default 'Original nightly price'
     */
    NrWp0: T;

    /**
     * @default 'Joy Discount'
     */
    '1dm1n': T;

    /**
     * @default '-{{0}}'
     */
    '9QMWF': T;

    /**
     * @default 'You're getting a reduced rate for Joy hosts and guests only.'
     */
    '2WlwE': T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Discount price breakdown'
     */
    JIMUv: T;

    /**
     * @default 'Book on Joy'
     */
    '22I4P': T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'venue'
     */
    '914sJ': T;

    /**
     * @default '🛌 Room Block'
     */
    haDTr: T;

    /**
     * @default '🏩 Couple's Pick'
     */
    '4rp9X': T;

    /**
     * @default 'Honeymoon'
     */
    mfnfF: T;

    /**
     * @default 'Discounted Rates for Joy Guests'
     */
    TDKaE: T;

    /**
     * @default 'Benefit from exclusive rates up to 40% less compared to Expedia.'
     */
    gG0BF: T;

    /**
     * @default 'Special Event Rates'
     */
    ugPDv: T;

    /**
     * @default 'Ad'
     */
    NkAAA: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} {{1}} from {{2}}'
     */
    '32NZW': T;

    /**
     * @default '{{0}} {{1}} walk'
     */
    '0uoli': T;

    /**
     * @default '{{0}} {{1}} drive'
     */
    hNVO9: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default 'Invalid location'
     */
    Kj3OT: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Search for a city or venue'
     */
    pHKXn: T;

    /**
     * @default 'Center Park Boathouse'
     */
    bda8R: T;

    /**
     * @default 'List'
     */
    KR7LA: T;

    /**
     * @default 'Book before {{0}}'
     */
    q8D6D: T;

    /**
     * @default 'Public rate for {{0}}. Final price confirmed on {{1}}.'
     */
    oi768: T;

    /**
     * @default 'Public rate for {{0}}. Final price confirmed at the property.'
     */
    VoWmR: T;

    /**
     * @default 'Final price confirmed on {{0}}.'
     */
    tPwcB: T;

    /**
     * @default 'Final price confirmed at the property.'
     */
    '5slBn': T;

    /**
     * @default 'Featured stay'
     */
    FSsmh: T;

    /**
     * @default 'Booked direct with {{0}}'
     */
    JRjfH: T;

    /**
     * @default 'Book on {{0}}'
     */
    qZSfe: T;

    /**
     * @default 'Selected with {{0}} · book direct · public rates for {{1}}'
     */
    '1Vb5X': T;

    /**
     * @default 'Selected with {{0}} · book direct · public rates'
     */
    '3IOTD': T;

    /**
     * @default 'Selected with our booking partners · book direct · public rates for {{0}}'
     */
    SZ9HN: T;

    /**
     * @default 'Selected with our booking partners · book direct · public rates'
     */
    tWVon: T;

    /**
     * @default 'Featured stays near {{0}}'
     */
    '0XjFE': T;

    /**
     * @default 'Featured stays'
     */
    SdNRe: T;

    /**
     * @default 'From {{0}} / night'
     */
    rvqvA: T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default 'Rates on {{0}}'
     */
    OHhvT: T;

    /**
     * @default 'Rates on the property's site'
     */
    flTYn: T;

    /**
     * @default 'Remove {{0}} filter'
     */
    YK0cm: T;

    /**
     * @default 'Price: {{0}} - {{1}}'
     */
    VB2mg: T;

    /**
     * @default 'Star Rating: {{0}}'
     */
    DV4W5: T;

    /**
     * @default 'Guest Rating: {{0}}'
     */
    '1pP9f': T;

    /**
     * @default 'Reset all filters'
     */
    '7pziF': T;

    /**
     * @default 'Reset All'
     */
    IqkBQ: T;

    /**
     * @default 'Explore Hotels'
     */
    ucmCV: T;

    /**
     * @default 'Explore More Hotels'
     */
    BmXGM: T;

    /**
     * @default 'Browse hotels with our special rates'
     */
    vIzdJ: T;

    /**
     * @default 'Browse more hotels with our special rates'
     */
    '0J7l4': T;
  };
};

export type AccommodationsGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Our Pick'
     */
    Fg6wn: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} walk'
     */
    pVA2E: T;

    /**
     * @default '{{0}} drive'
     */
    '8pImk': T;

    /**
     * @default 'The couple has arranged a room block for their guests at {{0}}. Please book by {{1}}.'
     */
    En1rN: T;

    /**
     * @default 'Book Now'
     */
    '72qZh': T;

    /**
     * @default 'Close room block banner'
     */
    a70Gz: T;

    /**
     * @default 'Book Your Room'
     */
    RFAQh: T;

    /**
     * @default 'Guest rate'
     */
    YYDwA: T;

    /**
     * @default 'Free Cancellation'
     */
    Z77Qm: T;

    /**
     * @default '{{0}} is a {{1}} star hotel that is {{2}} ({{3}}) from the venue.'
     */
    '7RTR4': T;

    /**
     * @default '{{0}} is a {{1}} star hotel.'
     */
    wXUQD: T;

    /**
     * @default '{{0}} is {{1}} ({{2}}) from the venue.'
     */
    '8ZlpE': T;

    /**
     * @default 'less'
     */
    BTvQA: T;

    /**
     * @default 'more'
     */
    hd7QA: T;

    /**
     * @default 'Book directly on Marriott'
     */
    C44dJ: T;

    /**
     * @default 'Book with Group Rate'
     */
    '4kePf': T;

    /**
     * @default 'Reserved for our guests'
     */
    Eek0C: T;

    /**
     * @default '{{0}} rooms'
     */
    gaXtl: T;

    /**
     * @default 'We've reserved rooms at {{0}}'
     */
    bM4yj: T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Special Group Rate'
     */
    YfgAI: T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default 'Book by {{0}}.'
     */
    gCCC6: T;

    /**
     * @default 'Also find a car rental'
     */
    nx2OG: T;

    /**
     * @default 'Shows cars for your dates in this tab'
     */
    Ut2PZ: T;

    /**
     * @default 'You're attending'
     */
    '9Ap1s': T;

    /**
     * @default 'Now, where you'll stay - book now with free cancellation.'
     */
    RGWUe: T;

    /**
     * @default 'Now, where you'll stay'
     */
    ivLbY: T;

    /**
     * @default 'Your guest rate is ready. Book early for the best pick of rooms and change plans later at no cost.'
     */
    '0Ic6R': T;

    /**
     * @default 'Your guest rate is ready. Book early for the best pick of rooms near the celebration.'
     */
    tQHos: T;

    /**
     * @default 'See All Hotels'
     */
    brcot: T;

    /**
     * @default 'See Flexible Options'
     */
    Iig62: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Also, you'll secure your spot right where {{0}}'s guests are staying.'
     */
    YHnUA: T;

    /**
     * @default 'Also, you'll secure your spot right where the other wedding guests are staying.'
     */
    BoICL: T;

    /**
     * @default 'Close price match guarantee'
     */
    '6uVqF': T;

    /**
     * @default 'Price Match Guarantee Badge'
     */
    TALIb: T;

    /**
     * @default 'Best Price Guaranteed'
     */
    r9kw6: T;

    /**
     * @default 'Book with confidence, if you find the same room at a lower price, we'll refund the difference.'
     */
    XBNmd: T;

    /**
     * @default 'Secure my spot'
     */
    '7KjAY': T;

    /**
     * @default 'Maybe later'
     */
    UzExj: T;

    /**
     * @default 'Same hotel, room type, dates and cancellation policy, publicly available rates only.'
     */
    iCLIR: T;

    /**
     * @default 'Read Terms & Conditions'
     */
    LQr4T: T;

    /**
     * @default '{{0}} guests interested'
     */
    eugAd: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;

    /**
     * @default 'Starting from'
     */
    IKBXI: T;

    /**
     * @default 'Event-Only Rate'
     */
    TvGKq: T;

    /**
     * @default '{{0}}'s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    BzVlk: T;

    /**
     * @default 'Exclusive Rate'
     */
    c0Mip: T;

    /**
     * @default 'Compared to'
     */
    SWS2n: T;

    /**
     * @default 'Book before'
     */
    EDAQC: T;

    /**
     * @default 'Group Rate'
     */
    '7rn7p': T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    ISKAR: T;
  };
};

export type AccommodationsSharedTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Wonderful'
     */
    MZVfM: T;

    /**
     * @default 'Fabulous'
     */
    Z6jq4: T;

    /**
     * @default 'Very Good'
     */
    Pif9F: T;

    /**
     * @default 'Good'
     */
    BMOLA: T;

    /**
     * @default 'Pleasant'
     */
    '8SCnL': T;

    /**
     * @default 'H'
     */
    KBAAA: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Car Rentals'
     */
    BJ6NG: T;

    /**
     * @default 'Getting to the event?'
     */
    lDMj8: T;

    /**
     * @default 'Add a car rental at guest-only rates.'
     */
    lDSzt: T;

    /**
     * @default 'Close tooltip'
     */
    xSDvO: T;

    /**
     * @default 'Search product'
     */
    Tqcfk: T;

    /**
     * @default 'Cars'
     */
    b1iKA: T;
  };
};

export type AccountTranslations<T extends LeafNodeValue = TranslateFunction> = {
  signin: {
    /**
     * @default 'Sign in with Google'
     */
    google: T;

    /**
     * @default 'Continue with Facebook'
     */
    facebook: T;

    /**
     * @default 'Sign in to Joy'
     */
    signInToJoy: T;

    /**
     * @default 'Don't have an account?'
     */
    donthaveaccount: T;

    /**
     * @default 'Create an account'
     */
    createAnAccount: T;

    /**
     * @default 'Email'
     */
    enterEmail: T;

    /**
     * @default 'Password'
     */
    enterPassword: T;

    /**
     * @default 'Sign In'
     */
    signin: T;

    /**
     * @default 'Continue with your email and password'
     */
    or: T;
  };
  signup: {
    /**
     * @default 'Sign up with Google'
     */
    google: T;

    /**
     * @default 'Continue with Facebook'
     */
    facebook: T;

    /**
     * @default 'Sign Up for Joy'
     */
    signUpForJoy: T;

    /**
     * @default 'Sign Up'
     */
    signup: T;
  };

  /**
   * @default 'Already signed up? <signInLink/>'
   */
  alreadyAccount: T;

  forgotpassword: {
    /**
     * @default 'Forgot your password'
     */
    forgotPassword: T;

    /**
     * @default 'Send password reset'
     */
    sendPasswordReset: T;
  };

  /**
   * @default 'By signing up, you agree to our <termsLink/> and <privacyLink/>.'
   */
  termsandprivacy: T;

  /**
   * @default 'Terms'
   */
  terms: T;

  /**
   * @default 'Privacy Policy'
   */
  privacyPolicy: T;

  /**
   * @default ' See '
   */
  privacyNoticeSee: T;

  /**
   * @default 'CA Privacy Notice'
   */
  privacyNotice: T;

  formWarnings: {
    /**
     * @default 'Invalid email'
     */
    invalidEmail: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'The email or password you entered is incorrect.'
     */
    invalidCredentials: T;
  };

  /**
   * @default 'Sign out'
   */
  signout: T;

  /**
   * @default 'You are signed in as {{name}}'
   */
  signedinas: T;

  eventPicker: {
    /**
     * @default 'Create New Event'
     */
    createNew: T;

    /**
     * @default 'Current Event'
     */
    currentEvent: T;
  };
  verifyEmailSuccess: {
    /**
     * @default 'We’ve verified your email. Thanks!'
     */
    message: T;
  };
  sentResetPassword: {
    /**
     * @default 'Change Password'
     */
    title: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;

    /**
     * @default 'We sent an email to {{email}} with instructions to change your password. '
     */
    sentEmail: T;

    /**
     * @default 'If this was a mistake, just ignore the email and your password will remain the same.'
     */
    ignoreClause: T;
  };
  deleteUser: {
    /**
     * @default 'Delete Account'
     */
    title: T;

    /**
     * @default 'Delete Account'
     */
    confirmButton: T;

    /**
     * @default 'Deleting your account is irreversible. If you delete your account, we will not be able to restore it.'
     */
    message: T;

    /**
     * @default 'Type DELETE to confirm you want to delete your account:'
     */
    fieldTitle: T;
  };
  mustLeaveEvents: {
    /**
     * @default 'Delete Account'
     */
    title: T;

    /**
     * @default 'Before deleting your account, please delete any events you have created and leave any events you have joined.'
     */
    message: T;

    /**
     * @default 'Learn More'
     */
    linkText: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;
  };
  leaveEvent: {
    /**
     * @default 'Are you sure?'
     */
    title: T;

    /**
     * @default 'Are you sure you’d like to leave this event?'
     */
    titleV2: T;

    /**
     * @default 'Please confirm you’d like to leave this event.'
     */
    message: T;

    /**
     * @default 'Leave Event'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Event Name'
     */
    label: T;

    /**
     * @default 'Please Note'
     */
    warningLabel: T;

    /**
     * @default 'If you leave this event we will remove it from your Joy account.'
     */
    warningMessage: T;

    /**
     * @default 'You have successfully left this event'
     */
    successToast: T;

    /**
     * @default 'We were unable to remove you from this event'
     */
    failureToast: T;

    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  deleteEvent: {
    /**
     * @default 'Are you sure you’d like to delete this event?'
     */
    title: T;

    /**
     * @default 'Delete Event'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Deleting your event will permanently remove your entire event from Joy. This includes all event details, your website, invitations, photos and guest list.'
     */
    confirmMessage: T;

    /**
     * @default 'If you would like to continue, please type'
     */
    confirm1: T;

    /**
     * @default 'in the field below to permanently delete your event from Joy.'
     */
    confirm2: T;

    /**
     * @default 'Please Note:'
     */
    warningLabel: T;

    /**
     * @default 'Deleting your event is an irreversible change.'
     */
    warningMessage: T;

    /**
     * @default 'Your event has been successfully deleted.'
     */
    successToast: T;

    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  deleteEventSuccess: {
    /**
     * @default 'We’re sorry to see you go!'
     */
    title: T;

    /**
     * @default 'Done'
     */
    confirmButton: T;

    /**
     * @default 'Your event was deleted successfully.'
     */
    confirmMessage: T;

    /**
     * @default 'Before you go, would you mind sharing why you’re leaving? Your feedback would be greatly appreciated.'
     */
    message: T;

    /**
     * @default 'I deleted my Joy event because...'
     */
    placeholderText: T;
  };
  savePersonInfoFailure: {
    /**
     * @default 'An error occured'
     */
    title: T;

    /**
     * @default 'Unfortunately your changes could not be saved.'
     */
    message: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;

    /**
     * @default 'Your email could not be updated to {{targetEmail}}, because an account with that email address already exists.'
     */
    userAlreadyExists: T;

    /**
     * @default 'If you want to use {{targetEmail}} for an event, you can <userAlreadyExistsLink/> to the account with that email address.'
     */
    userAlreadyExistsSuggestion: T;

    /**
     * @default 'transfer ownership of the event'
     */
    userAlreadyExistsLinkText: T;
  };
  eventsPage: {
    /**
     * @default 'What kind of event would you like to create?'
     */
    createDialogTitle: T;

    /**
     * @default 'Upcoming Events'
     */
    myEventsTitle: T;

    /**
     * @default 'Past Events'
     */
    pastEventsTitle: T;

    newEventOptions: {
      /**
       * @default 'Baby Registry'
       */
      baby: T;

      /**
       * @default 'Wedding'
       */
      wedding: T;

      /**
       * @default 'Other'
       */
      custom: T;

      /**
       * @default 'Professional'
       */
      professional: T;

      /**
       * @default 'AI Planner'
       */
      aiPlanner: T;
    };
    createCustomEvent: {
      /**
       * @default 'Create Custom Event'
       */
      buttonTitle: T;
    };
    findEventButton: {
      /**
       * @default 'Find Event'
       */
      value: T;
    };
    createEventButton: {
      /**
       * @default 'Create Event'
       */
      value: T;
    };
    copyLink: {
      /**
       * @default 'Copy Link'
       */
      buttonTitle: T;

      /**
       * @default '✨ Link Copied to Clipboard ✨'
       */
      toastMessage: T;
    };
    editEvent: {
      /**
       * @default 'Edit'
       */
      buttonTitle: T;
    };
    rsvpEvent: {
      /**
       * @default 'RSVP'
       */
      buttonTitle: T;
    };
    shareEvent: {
      /**
       * @default 'Share'
       */
      buttonTitle: T;
    };
    previewEvent: {
      /**
       * @default 'Preview'
       */
      buttonTitle: T;
    };
    deleteEvent: {
      /**
       * @default 'Delete'
       */
      buttonTitle: T;
    };
    leaveEvent: {
      /**
       * @default 'Leave This Event'
       */
      buttonTitle: T;
    };

    /**
     * @default 'Coming up! 🎉'
     */
    eventComingUp: T;

    /**
     * @default 'Attending'
     */
    eventAttending: T;

    /**
     * @default 'Not Attending'
     */
    eventNotAttending: T;

    /**
     * @default 'Event'
     */
    event: T;

    /**
     * @default 'Manage Event'
     */
    manageEvent: T;

    status: {
      /**
       * @default 'Owner'
       */
      owner: T;

      /**
       * @default 'Admin'
       */
      admin: T;

      /**
       * @default 'Collaborator'
       */
      collaborator: T;

      /**
       * @default 'Guest'
       */
      guest: T;
    };
  };
  personalInfoForm: {
    /**
     * @default 'Email address'
     */
    emailTitle: T;

    /**
     * @default 'Password'
     */
    passwordTitle: T;

    /**
     * @default 'Change Password'
     */
    passwordChangeActionText: T;

    /**
     * @default 'First name'
     */
    firstNameTitle: T;

    /**
     * @default 'Last name'
     */
    lastNameTitle: T;

    /**
     * @default 'Save'
     */
    submitButtonText: T;

    /**
     * @default 'Your personal info has been updated'
     */
    submitToastText: T;

    /**
     * @default 'Customer Support'
     */
    customerSupport: T;
  };

  /**
   * @default 'Delete Account'
   */
  deleteAccountButtonText: T;

  verfiyEmailWarning: {
    /**
     * @default 'Email address needs verification. <verifyLink/>'
     */
    message: T;

    /**
     * @default 'Verify email address'
     */
    linkText: T;
  };
  MFASettings: {
    /**
     * @default 'Turn Off Two-Factor Authentication'
     */
    disableButtonTitle: T;

    /**
     * @default 'Set Up Two-Factor Authentication'
     */
    enableButtonTitle: T;

    /**
     * @default 'Please contact <Link/> for assistance.'
     */
    notSupportedText: T;

    /**
     * @default 'Two-Factor Authentication not available for this account.'
     */
    notSupportedTitle: T;

    /**
     * @default 'Enable Two-Factor Authentication'
     */
    title: T;

    /**
     * @default 'Two-Factor Authentication is On'
     */
    titleEnabled: T;

    /**
     * @default 'Your account is protected with a required login code from your authentication app.'
     */
    enabledTextDescription: T;

    /**
     * @default 'Protect your account with a login code when you sign in on a device we don’t recognize.'
     */
    description: T;

    /**
     * @default 'Two-factor authentication is now enabled'
     */
    successMFA: T;

    /**
     * @default 'Two-factor is now enabled'
     */
    successMFAMobile: T;

    /**
     * @default 'Two-factor authentication has been disabled'
     */
    successMFAReseted: T;

    /**
     * @default 'Two-factor is now disabled'
     */
    successMFAResetedMobile: T;
  };
  resetMFA: {
    /**
     * @default 'Two-Factor Authentication is Enabled'
     */
    title: T;

    /**
     * @default 'Remove Two-Factor Authentication'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Your account is more secure when you need a password and a login code to sign in. If you remove this extra layer of security, you will only be asked for a password when you sign in. You will have to sign in again after removing two-factor authentication.'
     */
    message: T;
  };
  noEventsSection: {
    /**
     * @default 'Create your first event'
     */
    heading: T;

    /**
     * @default 'Get your wedding plans started or add the perfect gifts for your baby registry.'
     */
    description: T;
  };
  quick: {
    /**
     * @default 'There was an error signing in. Please try again.'
     */
    H2zq6: T;

    /**
     * @default 'There was an error creating your account. Please try again.'
     */
    iEg0c: T;

    /**
     * @default 'Load more'
     */
    '5lJ2f': T;

    /**
     * @default 'Something went wrong. Try again.'
     */
    KNRCj: T;

    /**
     * @default 'Showing {{0}} of {{1}}'
     */
    '1eVVT': T;

    /**
     * @default 'Email address needs verification.'
     */
    qiSGJ: T;

    /**
     * @default 'Verify email address'
     */
    DGLm1: T;

    /**
     * @default 'First name'
     */
    heZ8G: T;

    /**
     * @default 'Last name'
     */
    hAZ8J: T;

    /**
     * @default 'Email address'
     */
    oPt87: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'Change Password'
     */
    Joc4Z: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Two-Factor Authentication is On'
     */
    XsM6u: T;

    /**
     * @default 'Enable Two-Factor Authentication'
     */
    tQckJ: T;

    /**
     * @default 'Your account is protected with a required login code from your authentication app.'
     */
    '4PpBj': T;

    /**
     * @default 'Protect your account with a login code when you sign in on a device we don’t recognize.'
     */
    tGkcg: T;

    /**
     * @default 'Two-Factor Authentication not available for this account.'
     */
    GyuXH: T;

    /**
     * @default 'Please contact'
     */
    k7CGK: T;

    /**
     * @default 'Customer Support'
     */
    '30ahK': T;

    /**
     * @default 'for assistance.'
     */
    TKhmH: T;

    /**
     * @default 'Sign out of all devices'
     */
    ADubM: T;

    /**
     * @default 'Delete Account'
     */
    '0sjnh': T;

    /**
     * @default 'International'
     */
    '6HZNj': T;

    /**
     * @default 'Select an Event'
     */
    H3m0Q: T;

    /**
     * @default 'We couldn't delete your account. Please try again.'
     */
    aDFZ6: T;

    /**
     * @default 'Your account was deleted, but we couldn't finish signing you out. Please reload the page.'
     */
    DRmHA: T;

    /**
     * @default 'Sign out of all devices?'
     */
    '7ZQG6': T;

    /**
     * @default 'You'll be signed out of Joy everywhere you're currently signed in, including this device. You'll need to sign in again to get back to your event.'
     */
    QLFal: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'We couldn't sign you out of your devices. Please try again.'
     */
    GU82q: T;

    /**
     * @default 'We signed you out of your other devices, but couldn't finish signing out here. Please reload the page.'
     */
    sXnLU: T;
  };
};

export type ActionBarTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Now Live'
     */
    qVdWI: T;

    /**
     * @default 'Join Livestream'
     */
    wEPDO: T;
  };
};

export type AddFromFriendsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  banner: {
    /**
     * @default 'Only with Joy'
     */
    eyebrow: T;

    /**
     * @default 'Add gifts from'
     */
    title: T;

    /**
     * @default 'anyone’s registry'
     */
    titleAnyones: T;

    /**
     * @default 'a friend’s registry'
     */
    titleFriends: T;

    /**
     * @default 'a family’s registry'
     */
    titleFamily: T;

    /**
     * @default 'a celebrity’s registry'
     */
    titleCelebrities: T;

    /**
     * @default 'We’ll collect their gifts so you can pick what to add.'
     */
    content: T;

    /**
     * @default 'Registry URL'
     */
    inputTitle: T;

    /**
     * @default 'https://myfriendsregistry.com/gifts'
     */
    inputPlaceholder: T;

    /**
     * @default 'Supported Registries: Babylist, Amazon, Target'
     */
    inputHint: T;

    /**
     * @default 'Get Started'
     */
    ctaText: T;

    errors: {
      /**
       * @default 'This URL seems incorrect.'
       */
      registryUrlInvalid: T;

      /**
       * @default 'Please enter URL.'
       */
      registryUrlRequired: T;

      reasonCode: {
        /**
         * @default 'Sorry! We don’t support that platform or retailer yet.'
         */
        unsupportedDomain: T;

        /**
         * @default 'Oops! This URL seems not right. Copy the link once again and give it another go!'
         */
        invalidRegistryUrl: T;

        /**
         * @default 'Uh oh, it looks like the registry exists, but it's not public yet.'
         */
        registryIsPrivate: T;

        /**
         * @default 'Oops! Something went wrong. Please try again later!'
         */
        registryUnavailable: T;
      };
    };
  };
  scannedRegistriesTracker: {
    /**
     * @default 'Your Friends’ Registries'
     */
    title: T;

    /**
     * @default 'Browse Registries'
     */
    titleMobile: T;

    /**
     * @default 'Only the items you select will be added to your Registry.'
     */
    textMobile: T;

    table: {
      /**
       * @default '{{registryName}} Registry'
       */
      registry: T;

      /**
       * @default 'Registry Name'
       */
      registryName: T;

      /**
       * @default 'Registry URL'
       */
      registryURL: T;

      /**
       * @default 'Scan Date'
       */
      scanDate: T;

      /**
       * @default 'Progress'
       */
      progress: T;

      /**
       * @default 'View Gifts'
       */
      viewGifts: T;
    };

    /**
     * @default 'Show All'
     */
    showAll: T;

    status: {
      /**
       * @default 'Failed'
       */
      failed: T;

      /**
       * @default 'Scanning'
       */
      inProgress: T;

      /**
       * @default 'Scanned'
       */
      ready: T;
    };
    menu: {
      /**
       * @default 'Browse Gifts'
       */
      share: T;

      /**
       * @default 'View Friend’s Registry'
       */
      preview: T;

      /**
       * @default 'Remove Registry'
       */
      delete: T;
    };
    shareRegistryDialog: {
      /**
       * @default 'Share this Registry Page'
       */
      title: T;

      /**
       * @default 'Gifts Scan Page'
       */
      subTitle: T;

      /**
       * @default 'Open New Tab'
       */
      openNewTabButton: T;

      /**
       * @default '✨ Registry Link Copied to Clipboard ✨'
       */
      toastText: T;
    };
    deleteRegistryDialog: {
      /**
       * @default 'Are you sure you want to remove {{registryName}} from your Add from Friend's Registry list?'
       */
      title: T;

      /**
       * @default 'Deleting this registry will remove it from the list of registries from which you can add gifts. If you change your mind, you can always add the registry again in the future.'
       */
      text: T;

      /**
       * @default 'Note: This will not affect the gifts that you already added to your Registry.'
       */
      note: T;

      /**
       * @default 'Delete Registry'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'All Done!'
       */
      deleteConfirmTitle: T;

      /**
       * @default '{{registryName}} was deleted successfully.'
       */
      deleteConfirmSubTitle: T;

      /**
       * @default 'If you change your mind, you can always enter the Registry URL and scan it again.'
       */
      deleteConfirmText: T;

      /**
       * @default 'Done'
       */
      deleteConfirmCta: T;
    };
  };
  scannedRegistriesWidget: {
    /**
     * @default 'Add From Friend’s Registry'
     */
    title: T;

    /**
     * @default '{{registryName}} Registry'
     */
    registryName: T;

    /**
     * @default 'See All'
     */
    seeAllCta: T;

    /**
     * @default 'Add New Registry'
     */
    addNewRegistryCta: T;

    emptyState: {
      /**
       * @default 'Add gifts from your friend’s registry. We’ll collect their gifts so you can pick what to add.'
       */
      message: T;

      /**
       * @default 'Get Started'
       */
      ctaText: T;
    };
  };
  howItWorks: {
    /**
     * @default 'How It Works'
     */
    title: T;

    /**
     * @default 'Start with adding gifts from the registries of those around you, it’s so simple and fun.'
     */
    text: T;

    steps: [
      {
        /**
         * @default 'Step One'
         */
        eyebrow: T;

        /**
         * @default 'Get your friend's registry link.'
         */
        title: T;

        /**
         * @default 'Copy the link from a friend’s registry and paste it at the top of this page.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Two'
         */
        eyebrow: T;

        /**
         * @default 'Let the scanning magic happen.'
         */
        title: T;

        /**
         * @default 'We’ll gather your friend’s registry gifts, so you choose which gifts you’d like to add to yours.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Three'
         */
        eyebrow: T;

        /**
         * @default 'Browse gifts to add to your registry.'
         */
        title: T;

        /**
         * @default 'Select the gifts you want to add to your registry.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Four'
         */
        eyebrow: T;

        /**
         * @default 'Add gifts to your registry.'
         */
        title: T;

        /**
         * @default 'Click on the Add Gifts button and that’s it. You’ve successfully added gifts to your Baby Registry.'
         */
        text: T;
      },
    ];
  };
  faqs: {
    /**
     * @default 'Frequently Asked Questions'
     */
    title: T;

    questions: {
      baby: [
        {
          /**
           * @default '1'
           */
          id: T;

          /**
           * @default 'Which platforms do you currently support?'
           */
          Q: T;

          /**
           * @default 'We currently support Amazon, Target and Babylist! we also support more stores from our wedding registry product.'
           */
          A: T;
        },
        {
          /**
           * @default '2'
           */
          id: T;

          /**
           * @default 'How long does it take to gather gifts from the external registry?'
           */
          Q: T;

          /**
           * @default 'It takes around 10-30 seconds for most registries, but it can take longer for larger registries. Hang tight, it shouldn’t take too long.'
           */
          A: T;
        },
        {
          /**
           * @default '3'
           */
          id: T;

          /**
           * @default 'What if I accidentally close the page when the gifts are being gathered?'
           */
          Q: T;

          /**
           * @default 'Scanning will continue in the background. You can always access the page again by clicking on the banner on the Shop Homepage or from the widget on the left side of your Manage Page.'
           */
          A: T;
        },
        {
          /**
           * @default '4'
           */
          id: T;

          /**
           * @default 'Do I have to use a friend’s registry?'
           */
          Q: T;

          /**
           * @default 'No, it could be also be a registry from a family member, coworker, or influencer. Friends, family, and coworkers shared their registry links with us when we had our own little ones. Finding and picking gifts can be overwhelming who better to trust than those around you who have done it first! Now you can use this feature to shop their registries and quickly draw inspiration for your own.'
           */
          A: T;
        },
        {
          /**
           * @default '5'
           */
          id: T;

          /**
           * @default 'Are these registries publicly visible to my gift-givers?'
           */
          Q: T;

          /**
           * @default 'No, they are only visible to you and other admins of your registry. Registries in the “Add From Friends” feature are never shown to your gift-givers, or on your public registry. This feature allows you to more easily shop from your friend’s registries.'
           */
          A: T;
        },
        {
          /**
           * @default '6'
           */
          id: T;

          /**
           * @default 'How many registries can I bring in?'
           */
          Q: T;

          /**
           * @default 'You can add as many registries as you want, that’s totally up to you. If the registry you scanned was updated, you can delete it and rescan it.'
           */
          A: T;
        },
        {
          /**
           * @default '7'
           */
          id: T;

          /**
           * @default 'Do I have to add all the gifts from the registry?'
           */
          Q: T;

          /**
           * @default 'No, you can pick and choose which items to add. Nothing is stopping you from adding them all though with one click if that’s what you want.'
           */
          A: T;
        },
        {
          /**
           * @default '8'
           */
          id: T;

          /**
           * @default 'If I delete a scanned Registry from Add From Friend’s Registry page, does it delete the gifts in my registry?'
           */
          Q: T;

          /**
           * @default 'No, deleting the scanned registry will keep the items you added in your registry. When you delete one of these Add From Friend’s Registries, you won’t see it in the list and you will not be able to add more items to your registry from your friend’s registry, unless you decide to scan it again.'
           */
          A: T;
        },
      ];

      wedding: [
        {
          /**
           * @default '1'
           */
          id: T;

          /**
           * @default 'Which platforms do you currently support?'
           */
          Q: T;

          /**
           * @default 'We currently support All the same registries that we offer for syncing including Amazon, Target, Crate & Barrel and many more.'
           */
          A: T;
        },
        {
          /**
           * @default '2'
           */
          id: T;

          /**
           * @default 'How long does it take to gather gifts from the external registry?'
           */
          Q: T;

          /**
           * @default 'It takes around 10-30 seconds for most registries, but it can take longer for larger registries. Hang tight, it shouldn’t take too long.'
           */
          A: T;
        },
        {
          /**
           * @default '3'
           */
          id: T;

          /**
           * @default 'What if I accidentally close the page when the gifts are being gathered?'
           */
          Q: T;

          /**
           * @default 'Scanning will continue in the background. You can always access the page again by clicking on the banner on the Shop Homepage or from the widget on the left side of your Manage Page.'
           */
          A: T;
        },
        {
          /**
           * @default '4'
           */
          id: T;

          /**
           * @default 'Do I have to use a friend’s registry?'
           */
          Q: T;

          /**
           * @default 'No, it could be also be a registry from a family member, coworker, or influencer. Finding and picking gifts can be overwhelming who better to trust than those around you who have done it first! Now you can use this feature to shop their registries and quickly draw inspiration for your own wedding registry.'
           */
          A: T;
        },
        {
          /**
           * @default '5'
           */
          id: T;

          /**
           * @default 'Are these registries publicly visible to my gift-givers?'
           */
          Q: T;

          /**
           * @default 'No, they are only visible to you and other admins of your registry. Registries in the “Add From Friends” feature are never shown to your gift-givers, or on your public registry. This feature allows you to more easily shop from your friend’s registries.'
           */
          A: T;
        },
        {
          /**
           * @default '6'
           */
          id: T;

          /**
           * @default 'How many registries can I bring in?'
           */
          Q: T;

          /**
           * @default 'You can add as many registries as you want, that’s totally up to you. If the registry you scanned was updated, you can delete it and rescan it. '
           */
          A: T;
        },
        {
          /**
           * @default '7'
           */
          id: T;

          /**
           * @default 'Do I have to add all the gifts from the registry?'
           */
          Q: T;

          /**
           * @default 'No, you can pick and choose which items to add. Nothing is stopping you from adding them all though with one click if that’s what you want. '
           */
          A: T;
        },
        {
          /**
           * @default '8'
           */
          id: T;

          /**
           * @default 'If I delete a scanned Registry from Add From Friend’s Registry page, does it delete the gifts in my registry?'
           */
          Q: T;

          /**
           * @default 'No, deleting the scanned registry will keep the items you added in your registry. When you delete one of these Add From Friend’s Registries, you won’t see it in the list and you will not be able to add more items to your registry from your friend’s registry, unless you decide to scan it again.'
           */
          A: T;
        },
      ];
    };
  };
  scanned: {
    /**
     * @default 'Back'
     */
    backCta: T;

    /**
     * @default 'Scanned {{scannedDate}}'
     */
    scannedDate: T;

    /**
     * @default 'Latest gift scan: {{scannedDate}}'
     */
    latestScannedDate: T;

    /**
     * @default 'Add from {{registryName}}'
     */
    addFromTitle: T;

    /**
     * @default 'How do I edit a gift?'
     */
    howToEditGift: T;

    /**
     * @default 'Select All'
     */
    selectAllCta: T;

    /**
     * @default 'Select Gifts to Add'
     */
    selectGiftsCta: T;

    /**
     * @default 'Add {{count}} Gift'
     */
    addGiftCta: T;

    /**
     * @default 'Add {{count}} Gifts'
     */
    addGiftsCta: T;

    /**
     * @default 'You can edit gift details, such as quantity, title, etc. after you add the gift to your registry.'
     */
    tooltip: T;

    /**
     * @default 'How to add a gift'
     */
    tooltipAlt: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default '🎉 Yay! We’ve added {{count}} gift to your registry!'
     */
    addedItemToRegistry: T;

    /**
     * @default '🎉 Yay! We’ve added {{count}} gifts to your registry!'
     */
    addedItemsToRegistry: T;

    giftsNotFound: {
      /**
       * @default 'This Registry doesn’t seem to have any items.'
       */
      message: T;

      /**
       * @default 'Please check again'
       */
      ctaText: T;
    };
  };
  scannerDialog: {
    inProgress: {
      /**
       * @default 'Gathering gifts for your inspiration…'
       */
      title: T;

      /**
       * @default 'This will only take a moment.'
       */
      text: T;
    };
    failed: {
      /**
       * @default 'Gathering gifts for your inspiration…'
       */
      title: T;

      /**
       * @default 'This will only take a moment.'
       */
      text: T;
    };
    ready: {
      /**
       * @default 'All done!'
       */
      title: T;

      /**
       * @default 'Now you can select gifts you’d like to add.'
       */
      text: T;
    };

    /**
     * @default 'Select Gifts'
     */
    ctaText: T;
  };
};

export type AddressDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'This is not a valid ZIP Code.'
     */
    yOJPd: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Full name'
     */
    SLCaY: T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Invalid Phone Number'
     */
    Gsdpn: T;

    /**
     * @default 'Address Line 1'
     */
    r2ebI: T;

    /**
     * @default 'Address'
     */
    gDl5Q: T;

    /**
     * @default 'Address Line 2'
     */
    s2ebI: T;

    /**
     * @default 'Apartment, Suite, etc. (optional)'
     */
    LK85B: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State'
     */
    Be76G: T;

    /**
     * @default 'State/Province/Territory'
     */
    LLPZf: T;

    /**
     * @default 'Postal Code'
     */
    WCbuM: T;

    /**
     * @default 'It is possible the following modified address will ensure a more successful delivery.'
     */
    xbcbf: T;

    /**
     * @default 'Please select the address you’d like to use.'
     */
    WwYZN: T;

    /**
     * @default 'We couldn’t validate your address, please make sure it’s correct before proceeding to the next step.'
     */
    '36y0m': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Confirm Address'
     */
    oOcdq: T;

    /**
     * @default 'Edit Address'
     */
    okfYJ: T;

    /**
     * @default 'Original Address'
     */
    '91oNV': T;

    /**
     * @default 'Address Provided'
     */
    jsYfj: T;

    /**
     * @default 'Suggested Address'
     */
    lUF8U: T;

    /**
     * @default 'Please confirm your event country.'
     */
    NXZZs: T;
  };
};

export type AddToCalendarTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Google'
   */
  google: T;

  /**
   * @default 'iCal'
   */
  ical: T;

  /**
   * @default 'Outlook'
   */
  outlook: T;

  /**
   * @default 'Cancel'
   */
  cancel: T;

  /**
   * @default 'Apple'
   */
  apple: T;
};

export type AdminDashboardV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  inviteAdminDialog: {
    /**
     * @default 'Event Admins'
     */
    title: T;
  };
  sections: {
    registry: {
      /**
       * @default 'Registry'
       */
      title: T;

      children: {
        overview: {
          /**
           * @default 'Overview'
           */
          title: T;

          /**
           * @default 'Registry'
           */
          experimentTitle: T;
        };
        track: {
          /**
           * @default 'Track & Thank'
           */
          title: T;
        };
        manage: {
          /**
           * @default 'Manage Registry'
           */
          title: T;
        };
        shop: {
          /**
           * @default 'Add Gifts'
           */
          title: T;

          /**
           * @default 'Add Gifts'
           */
          experimentTitle: T;
        };
      };
    };
    website: {
      /**
       * @default 'Website'
       */
      title: T;

      children: {
        editPages: {
          /**
           * @default 'Edit Pages'
           */
          title: T;
        };
      };
    };
    invites: {
      /**
       * @default 'Cards & Messaging'
       */
      title: T;

      children: {
        saveTheDates: {
          /**
           * @default 'Save the Dates'
           */
          title: T;

          children: {
            print: {
              /**
               * @default 'Paper Cards'
               */
              title: T;
            };
            digital: {
              /**
               * @default 'Digital Cards'
               */
              title: T;
            };
          };
        };
        invitations: {
          /**
           * @default 'Invitations'
           */
          title: T;

          children: {
            print: {
              /**
               * @default 'Paper Cards'
               */
              title: T;
            };
            digital: {
              /**
               * @default 'Digital Cards'
               */
              title: T;
            };
          };
        };
        dayOfStationery: {
          /**
           * @default 'Day-of'
           */
          title: T;

          children: {
            signs: {
              /**
               * @default 'Signs'
               */
              title: T;
            };
            menus: {
              /**
               * @default 'Menus'
               */
              title: T;
            };
            napkins: {
              /**
               * @default 'Napkins'
               */
              title: T;
            };
          };
        };
        thankYou: {
          /**
           * @default 'Thank You Cards'
           */
          title: T;
        };
        customCards: {
          /**
           * @default 'Custom Card'
           */
          title: T;
        };
        print: {
          /**
           * @default 'Paper Cards'
           */
          title: T;

          children: {
            invitations: {
              /**
               * @default 'Invitations'
               */
              title: T;
            };
            saveTheDates: {
              /**
               * @default 'Save the Dates'
               */
              title: T;
            };
            thankYou: {
              /**
               * @default 'Thank You'
               */
              title: T;
            };
          };
        };
        digital: {
          /**
           * @default 'Digital Cards'
           */
          title: T;

          children: {
            invitations: {
              /**
               * @default 'Invitations'
               */
              title: T;
            };
            saveTheDates: {
              /**
               * @default 'Save the Dates'
               */
              title: T;
            };
            customCard: {
              /**
               * @default 'Custom Cards'
               */
              title: T;
            };
          };
        };
        emails: {
          /**
           * @default 'Emails'
           */
          title: T;

          children: {
            reminder: {
              /**
               * @default 'Reminder Email'
               */
              title: T;
            };
            general: {
              /**
               * @default 'General Message'
               */
              title: T;
            };
          };
        };
        messaging: {
          /**
           * @default 'Messaging'
           */
          title: T;

          children: {
            rsvp: {
              /**
               * @default 'RSVP Reminder'
               */
              title: T;
            };
            reminder: {
              /**
               * @default 'Reminder Email'
               */
              title: T;
            };
            hotel: {
              /**
               * @default 'Hotel Reminder'
               */
              title: T;
            };
            general: {
              /**
               * @default 'General Message'
               */
              title: T;
            };
            tracking: {
              /**
               * @default 'Tracking'
               */
              title: T;
            };
          };
        };
      };
    };
    guestList: {
      /**
       * @default 'Planning & RSVP'
       */
      title: T;

      children: {
        guestList: {
          /**
           * @default 'Guest List'
           */
          title: T;
        };
        contactCollector: {
          /**
           * @default 'Contact Collector'
           */
          title: T;
        };
        rsvp: {
          /**
           * @default 'Manage RSVP'
           */
          title: T;
        };
        weddingShop: {
          /**
           * @default 'Decor & Favors'
           */
          title: T;
        };
        hotels: {
          /**
           * @default 'Hotels'
           */
          title: T;

          children: {
            roomBlocks: {
              /**
               * @default 'Room Blocks'
               */
              title: T;
            };
            honeymoon: {
              /**
               * @default 'Honeymoon'
               */
              title: T;
            };
          };
        };
      };
    };
  };
  websitePreview: {
    /**
     * @default '{{count}} Public Page'
     * @param {number} count - The number of occurrences.
     * - singular: {{count}} Public Page
     * - plural: {{count}} Public Pages
     */
    publicPage: T;

    /**
     * @default '{{count}} Protected'
     */
    protectedPage: T;

    /**
     * @default '{{count}} Off'
     */
    off: T;

    /**
     * @default 'Edit Design'
     */
    editDesignCta: T;

    /**
     * @default 'View Website'
     */
    viewWebsiteCta: T;
  };
  reEngagementPopup: {
    hotelBlock: {
      /**
       * @default 'Finish requesting your room block'
       */
      title: T;

      /**
       * @default '{{numberOfHotels}} hotels selected'
       */
      subTitle: T;
    };
    print: {
      /**
       * @default 'Your drafts are waiting — finalize your card'
       */
      title: T;

      subTitle: {
        /**
         * @default '{{numberOfDrafts}} draft in progress'
         */
        singular: T;

        /**
         * @default '{{numberOfDrafts}} drafts in progress'
         */
        plural: T;
      };

      /**
       * @default 'Your Save The Dates are waiting'
       */
      saveTheDateTitle: T;

      /**
       * @default 'Your Invitations are waiting'
       */
      invitationTitle: T;

      /**
       * @default 'Your Thank You Cards are waiting'
       */
      thankYouTitle: T;

      /**
       * @default 'Add the finishing touches.'
       */
      cardSubtile: T;
    };
    hotelReminder: {
      /**
       * @default 'Remind your guests about accommodations'
       */
      title: T;

      /**
       * @default 'Send a friendly reminder.'
       */
      subTitle: T;
    };
  };
  thingsToDo: {
    /**
     * @default 'Introducing Things To Do'
     */
    title: T;

    /**
     * @default 'Joy has a new page to help your guests have a great trip. We’ve added top things to do in {{eventCity}} to get you started. Take a look, add your own, and make it yours.'
     */
    subtitle: T;

    /**
     * @default 'Explore Things to Do'
     */
    cta: T;

    /**
     * @default 'I’ll do this later'
     */
    ctaLater: T;
  };
  honeymoonPlanning: {
    /**
     * @default 'Introducing Local Honeymoon Experts'
     */
    title: T;

    /**
     * @default 'Your honeymoon should be as unforgettable as your wedding day. Joy has partnered with regional experts to design the trip of a lifetime.'
     */
    subtitle: T;

    /**
     * @default 'Get a free intro to a local expert'
     */
    primaryCta: T;

    /**
     * @default 'Remind me later'
     */
    secondaryCta: T;

    /**
     * @default 'I'm not interested'
     */
    notInterestedCta: T;
  };
  honeymoonSurvey: {
    /**
     * @default 'Connect with a local travel expert.'
     */
    title: T;

    /**
     * @default 'Tell us a little about your dream honeymoon.'
     */
    description: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'First Name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Last Name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'my@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Phone Number'
     */
    phone: T;

    /**
     * @default '+1-555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Budget Range'
     */
    budgetRange: T;

    /**
     * @default 'Under $2,500'
     */
    budgetUnder2500: T;

    /**
     * @default '$2,500 - $5,000'
     */
    budget2500to5000: T;

    /**
     * @default '$5,000 - $7,500'
     */
    budget5000to7500: T;

    /**
     * @default '$7,500 - $10,000'
     */
    budget7500to10000: T;

    /**
     * @default 'Over $10,000'
     */
    budgetOver10000: T;

    /**
     * @default 'Loading...'
     */
    loading: T;

    /**
     * @default 'No options available'
     */
    noOptionsAvailable: T;

    /**
     * @default 'Select...'
     */
    select: T;

    /**
     * @default 'When is your ideal honeymoon?'
     */
    whenIsYourIdealHoneymoon: T;

    /**
     * @default 'Departure Date'
     */
    departureDate: T;

    /**
     * @default 'Return Date'
     */
    returnDate: T;

    /**
     * @default 'Where are you traveling from?'
     */
    whereAreYouTravelingFrom: T;

    /**
     * @default 'Departure City'
     */
    departureCity: T;

    /**
     * @default 'San Francisco, CA'
     */
    departureCityPlaceholder: T;

    /**
     * @default 'Where would you like to go?'
     */
    whereWouldYouLikeToGo: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default 'Add Another Country'
     */
    addAnotherCountry: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Please complete all the fields above'
     */
    pleaseCompleteAllFields: T;

    /**
     * @default 'What is your budget range?'
     */
    budgetRangeTitle: T;

    /**
     * @default 'Couples spend an average of $5-10k.'
     */
    budgetRangeDescription: T;
  };
  honeymoonConfirmation: {
    /**
     * @default 'Thank you for your interest!'
     */
    title: T;

    /**
     * @default 'A local planning expert will reach out soon.'
     */
    subtitle: T;

    /**
     * @default 'Sounds Good'
     */
    cta: T;
  };
  quick: {
    /**
     * @default 'Introducing Websites 2'
     */
    s5bVC: T;

    /**
     * @default 'We’ve reimagined Joy websites from the ground up. More control over your design, editing right on the page, and AI tools to help you take your ideas further. All with a faster experience for you and your guests.'
     */
    j6ZWT: T;

    /**
     * @default 'Use the early preview and help shape what comes next. You can switch back to your current version anytime.'
     */
    gYnpo: T;

    /**
     * @default 'We couldn’t load your website. Refresh the page and try again.'
     */
    JN1D4: T;

    /**
     * @default 'Switching your website…'
     */
    swruh: T;

    /**
     * @default 'Loading your website…'
     */
    CItal: T;

    /**
     * @default 'Your website couldn’t be switched. Please try again.'
     */
    RLkwq: T;

    /**
     * @default 'Try now'
     */
    zqrHi: T;

    /**
     * @default 'Maybe later'
     */
    UzExj: T;

    /**
     * @default 'Super-admin debug'
     */
    wU9MJ: T;

    /**
     * @default 'Skip adapters'
     */
    JRjrD: T;

    /**
     * @default 'Adapter status'
     */
    hKERp: T;

    /**
     * @default 'Skip adapters flips the event flag only — no V1 design copy, no site creation.'
     */
    cpxdP: T;

    /**
     * @default 'Checking your V1 design…'
     */
    Yzs4x: T;

    /**
     * @default 'Couldn’t load the compatibility report.'
     */
    ltdfx: T;

    /**
     * @default 'Every V1 design feature is carried. Nothing will be skipped.'
     */
    '4yngS': T;

    /**
     * @default '{{0}} · skipped'
     */
    Xytm9: T;

    /**
     * @default '{{0}} · carried with changes'
     */
    '2ebk0': T;

    /**
     * @default 'Meet Websites 2'
     */
    N9cAU: T;

    /**
     * @default 'Edit right on your website and explore new layouts with AI. Now in early preview. You can switch back anytime.'
     */
    d3bbP: T;

    /**
     * @default 'Learn more'
     */
    tks4L: T;

    /**
     * @default 'Meet Websites 2 — a product introduction'
     */
    JvY8T: T;

    /**
     * @default 'Watch video'
     */
    YxOoc: T;

    /**
     * @default 'Early Preview'
     */
    fIkqJ: T;

    /**
     * @default 'Add Your Photo'
     */
    QVT8f: T;

    /**
     * @default 'Edit Site'
     */
    '5vqJg': T;

    /**
     * @default 'Swap Photo'
     */
    LnQfM: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Dialog motion'
     */
    OaLef: T;

    /**
     * @default 'Candidate v1. A quick rise and gentle settle, followed by a shorter downward exit. The whole dialog moves together.'
     */
    xMulC: T;

    /**
     * @default 'The backdrop runs independently. Reduced motion removes movement and fades. The mobile example is a Joy trial, not a verified Airbnb behavior.'
     */
    wn0d3: T;

    /**
     * @default 'Open dialog'
     */
    ohXuJ: T;

    /**
     * @default 'Desktop timing reference'
     */
    HjyXG: T;

    /**
     * @default 'Enter: 100px upward travel over 400ms; opacity 0 to 1 over the first 75ms.'
     */
    nHkYZ: T;

    /**
     * @default 'Exit: 50px downward travel over 150ms; opacity stays at 1 for 75ms, then fades over 75ms.'
     */
    ab0TQ: T;

    /**
     * @default 'Backdrop: 400ms in, 250ms out, at 40% opacity on #222222.'
     */
    JH0Ro: T;

    /**
     * @default 'No scale, bounce, overshoot, or content stagger.'
     */
    DjMLN: T;

    /**
     * @default 'Use the Controls panel to adjust playback speed or select the Slow Motion and Reduced Motion stories. Close with Escape, the close button, or the backdrop.'
     */
    THixL: T;

    /**
     * @default 'Preset values'
     */
    JbuRQ: T;

    /**
     * @default 'Dialog motion example'
     */
    '0jTdS': T;

    /**
     * @default 'Close motion example'
     */
    sSCre: T;

    /**
     * @default 'One surface. One motion.'
     */
    lb8cO: T;

    /**
     * @default 'Watch the dialog rise and settle as a single unit. The backdrop fades on its own timeline.'
     */
    SDUnt: T;

    /**
     * @default 'This example uses the measured desktop surface size and corner radius. Those values are not part of the motion preset.'
     */
    lRsfF: T;

    /**
     * @default 'Replay entrance'
     */
    TFxcB: T;

    /**
     * @default 'Dismiss dialog'
     */
    iRvUJ: T;

    /**
     * @default 'Close and reopen quickly'
     */
    G3LG6: T;

    /**
     * @default 'Mini dialog motion'
     */
    Vt47T: T;

    /**
     * @default 'The same rise and settle, with less travel for a smaller surface. No backdrop or focus trap.'
     */
    XsHFD: T;

    /**
     * @default 'Enter: 24px over 400ms, with a 75ms fade. Exit: 12px over 150ms, fading during the final 75ms.'
     */
    ZYjNr: T;

    /**
     * @default 'Try dismissing and immediately reopening. Reduced motion removes all movement and fades.'
     */
    IseDW: T;

    /**
     * @default 'Show mini dialog'
     */
    oj32H: T;

    /**
     * @default 'Mini dialog motion example'
     */
    ZzrIe: T;

    /**
     * @default 'Joy websites, reimagined from the ground up. Now in early preview.'
     */
    Q6b2Z: T;

    /**
     * @default 'Dismiss mini dialog'
     */
    dc7Rh: T;

    /**
     * @default 'Full dialog motion example'
     */
    '9gMZg': T;

    /**
     * @default 'Return to mini dialog'
     */
    coZqm: T;

    /**
     * @default 'The mini dialog exits as this dialog enters. Close this dialog to bring the mini dialog back.'
     */
    '0PKTP': T;

    /**
     * @default 'Turn one photo into your website'
     */
    njQkf: T;

    /**
     * @default 'Add a photo you love and we'll design websites in its colours.'
     */
    JIgPZ: T;

    /**
     * @default 'Add a photo'
     */
    ICGPL: T;

    /**
     * @default 'Your website designs are ready'
     */
    '0yBpd': T;

    /**
     * @default 'We designed them around the colours in your photo. Pick one to start.'
     */
    Gb58D: T;

    /**
     * @default 'See your designs'
     */
    '3bKQ5': T;

    /**
     * @default 'Dismiss custom designs reminder'
     */
    '8pmNE': T;

    /**
     * @default 'Play website animation'
     */
    jHBkL: T;

    /**
     * @default 'Pause website animation'
     */
    PRHRf: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'We crafted designs just for you, matching your photo'
     */
    '2FuLH': T;

    /**
     * @default 'Each one is built around the colours in your photo, so it already feels like you. Pick one to start and change anything you like.'
     */
    Vuem2: T;

    /**
     * @default 'Start with where you want to go.'
     */
    TIi98: T;

    /**
     * @default 'We’ll show you the stays we’d pick for a honeymoon.'
     */
    '6oopP': T;

    /**
     * @default 'Find Stays'
     */
    '31CkU': T;

    /**
     * @default 'Hawaii'
     */
    '1Dbb1': T;

    /**
     * @default 'Japan'
     */
    uUXLG: T;

    /**
     * @default 'Italy'
     */
    fSMJG: T;

    /**
     * @default 'Greece'
     */
    ZpHH0: T;

    /**
     * @default 'Maldives'
     */
    rTmNI: T;

    /**
     * @default 'Indonesia'
     */
    sBIam: T;

    /**
     * @default 'Mexico'
     */
    BMjAF: T;

    /**
     * @default 'Fiji'
     */
    aGDLA: T;

    /**
     * @default 'Search a destination'
     */
    Dh0h1: T;

    /**
     * @default 'More…'
     */
    DdccG: T;

    /**
     * @default 'Browse more destinations'
     */
    svvG6: T;

    /**
     * @default 'Up to {{0}}% off'
     */
    wK1n5: T;

    /**
     * @default 'Joy’s honeymoon picks'
     */
    o2Q9a: T;

    /**
     * @default 'Honeymoon stays'
     */
    gCtwm: T;

    /**
     * @default 'Beach, city, or somewhere wild?'
     */
    B7a0F: T;

    /**
     * @default 'Pick where you’re dreaming of.'
     */
    Jahu1: T;

    /**
     * @default 'We’ll show Joy’s honeymoon picks there, at rates only Joy couples get.'
     */
    j6yAS: T;

    /**
     * @default 'Explore Stays'
     */
    fQxiW: T;

    /**
     * @default 'Add Event Date'
     */
    PXcRO: T;

    /**
     * @default 'Share when your event takes place.'
     */
    BSLVq: T;

    /**
     * @default 'Share event information'
     */
    '9twNQ': T;

    /**
     * @default 'Preview website'
     */
    xMFBT: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Collect Contacts'
     */
    v9WNU: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Photo Moments'
     */
    n7PqX: T;

    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Questions'
     */
    h1BuU: T;

    /**
     * @default 'Responses'
     */
    MX96s: T;

    /**
     * @default 'Activity'
     */
    dgmnl: T;

    /**
     * @default 'Send RSVP Reminder'
     */
    LYQuO: T;

    /**
     * @default 'RSVP Settings'
     */
    a76AP: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Plan Your Honeymoon'
     */
    uuTXF: T;

    /**
     * @default 'Instant Room Blocks'
     */
    EQiiM: T;

    /**
     * @default 'Car Rentals'
     */
    BJ6NG: T;

    /**
     * @default 'Send Hotel Reminder'
     */
    '6RDvN': T;

    /**
     * @default 'Where Guests Are Staying'
     */
    x4dPP: T;

    /**
     * @default 'Website Pages'
     */
    Hsfjx: T;

    /**
     * @default 'For Your Guests'
     */
    lQzQw: T;

    /**
     * @default 'For the Two of You'
     */
    m3POR: T;

    /**
     * @default 'Website editor preview'
     */
    '636rM': T;

    /**
     * @default 'This story simulates switching. Your event site hasn’t changed.'
     */
    trTq1: T;

    /**
     * @default 'Restart preview'
     */
    tdXb3: T;

    /**
     * @default 'Your dashboard'
     */
    BH5ap: T;

    /**
     * @default 'Dismiss Websites 2 reminder'
     */
    '8D1GH': T;

    /**
     * @default 'Your website couldn’t be switched. Reopen to try again.'
     */
    jn2IT: T;

    /**
     * @default 'Easier editing. Faster websites. Now in early preview.'
     */
    C5ZR9: T;

    /**
     * @default 'Thailand'
     */
    '7pHY8': T;

    /**
     * @default 'Costa Rica'
     */
    bdUrM: T;

    /**
     * @default 'Bali'
     */
    ccZKA: T;

    /**
     * @default 'St. Lucia'
     */
    n6QkL: T;

    /**
     * @default 'Bora Bora'
     */
    csNsp: T;

    /**
     * @default 'Cape Town'
     */
    PdL8g: T;

    /**
     * @default 'Vietnam'
     */
    wgFWm: T;

    /**
     * @default 'Riviera Maya'
     */
    '8ta62': T;

    /**
     * @default 'Portugal'
     */
    sT8HT: T;

    /**
     * @default 'Iceland'
     */
    a5Q3w: T;

    /**
     * @default 'Croatia'
     */
    PAP9A: T;

    /**
     * @default 'Tanzania'
     */
    KmOqD: T;

    /**
     * @default 'Tahiti'
     */
    '9BsLX': T;

    /**
     * @default 'Kenya'
     */
    c26QG: T;

    /**
     * @default 'Sicily'
     */
    '3ZiKV': T;

    /**
     * @default 'Morocco'
     */
    '0ZgU5': T;

    /**
     * @default 'Egypt'
     */
    '3hbxF': T;

    /**
     * @default 'Turks & Caicos'
     */
    xGDYK: T;

    /**
     * @default 'Building your honeymoon…'
     */
    '1NvvO': T;

    /**
     * @default 'Book'
     */
    '9bdKA': T;

    /**
     * @default '$1,860'
     */
    hTNYl: T;

    /**
     * @default 'SFO ⇄ Osaka (KIX) for 2'
     */
    Z2lwl: T;

    /**
     * @default 'Flights'
     */
    RiVKS: T;

    /**
     * @default '$2,325'
     */
    aXKdl: T;

    /**
     * @default '$2,140'
     */
    RzJdl: T;

    /**
     * @default 'Kyoto ryokan + Naoshima villa'
     */
    RCqBN: T;

    /**
     * @default 'Stays'
     */
    '4g76G': T;

    /**
     * @default '$2,675'
     */
    wQLdl: T;

    /**
     * @default '$220'
     */
    QKpFA: T;

    /**
     * @default 'Shinkansen seats + island ferries'
     */
    C1O1y: T;

    /**
     * @default 'Getting around'
     */
    ZBzXv: T;

    /**
     * @default '$275'
     */
    ANpFA: T;

    /**
     * @default 'Reserved'
     */
    oGlsj: T;

    /**
     * @default '$620'
     */
    gSqFA: T;

    /**
     * @default 'Kaiseki dinner + island tables'
     */
    '4xf41': T;

    /**
     * @default 'Tables'
     */
    FpyKX: T;

    /**
     * @default '$775'
     */
    zmqFA: T;

    /**
     * @default '$480'
     */
    kwpFA: T;

    /**
     * @default 'Gardens + Setouchi art islands'
     */
    o0ew3: T;

    /**
     * @default 'Experiences'
     */
    FTJtS: T;

    /**
     * @default '$600'
     */
    cRqFA: T;

    /**
     * @default 'Start with just a destination or idea.'
     */
    BwDbC: T;

    /**
     * @default 'We’ll turn it into a bookable trip for two.'
     */
    Rhpx9: T;

    /**
     * @default 'Try this idea'
     */
    YZtsR: T;

    /**
     * @default 'Now for Honeymoons.'
     */
    yT5jO: T;

    /**
     * @default 'Type your own idea — “a quiet beach in Greece”'
     */
    xHsQX: T;

    /**
     * @default '20% off'
     */
    MpKQQ: T;

    /**
     * @default 'Book Trip'
     */
    iipri: T;

    /**
     * @default 'Seto Islands'
     */
    DxITy: T;

    /**
     * @default '7 nights in Japan'
     */
    nfbSI: T;

    /**
     * @default 'Kyoto, Japan'
     */
    GDBX0: T;

    /**
     * @default '$5,700'
     */
    yBHsl: T;

    /**
     * @default '$4,560'
     */
    HAInl: T;

    /**
     * @default 'Kyoto & the Seto Islands'
     */
    aSwsT: T;

    /**
     * @default 'Pick a place you love, and Joy plans the trip with you.'
     */
    QjLIG: T;

    /**
     * @default 'Pick a place'
     */
    FcsWQ: T;

    /**
     * @default 'Plan your honeymoon'
     */
    IjbJR: T;

    /**
     * @default 'We’ll let you know when Joy Honeymoon is ready.'
     */
    vh4uH: T;

    /**
     * @default 'Added to honeymoon waitlist'
     */
    O0XqX: T;

    /**
     * @default 'or'
     */
    '58AAA': T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'Saving your spot…'
     */
    '1N6MQ': T;

    /**
     * @default 'Idea saved'
     */
    kXQwp: T;

    /**
     * @default 'Your spot is saved.'
     */
    IzEKV: T;

    /**
     * @default 'We saved your honeymoon idea. When Joy Honeymoon is ready, we’ll help you turn it into a trip you can book.'
     */
    tjfsF: T;

    /**
     * @default 'Back to dashboard'
     */
    wMnJ3: T;

    /**
     * @default 'An error occurred while submitting your form. Please try again.'
     */
    xl21f: T;

    /**
     * @default 'Honeymoon'
     */
    mfnfF: T;

    /**
     * @default 'Add Event Location'
     */
    QMt5A: T;

    /**
     * @default 'Share what city or town your event takes place.'
     */
    v3lS0: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Specific Guests'
     */
    '3Tybq': T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Toggle {{0}} menu'
     */
    '3cc78': T;

    /**
     * @default 'Finish Card'
     */
    LK7jh: T;

    /**
     * @default 'Send Reminder'
     */
    '2juHR': T;

    /**
     * @default 'Dismiss accommodations reminder'
     */
    TGDgP: T;

    /**
     * @default 'Finish Request'
     */
    '2So7P': T;

    /**
     * @default 'Dismiss room block reminder'
     */
    sDNsQ: T;

    /**
     * @default 'View Drafts'
     */
    LSsxD: T;

    /**
     * @default 'Dismiss drafts reminder'
     */
    SM1l1: T;

    /**
     * @default 'Dismiss Save the Date reminder'
     */
    '2FJus': T;

    /**
     * @default 'Dismiss invitation reminder'
     */
    hHrT9: T;

    /**
     * @default 'Dismiss thank-you card reminder'
     */
    S9vzl: T;

    /**
     * @default 'See Hotels'
     */
    mvDzV: T;

    /**
     * @default 'Dismiss hotel suggestions reminder'
     */
    ZypqC: T;

    /**
     * @default 'Seating Chart'
     */
    '77iMR': T;

    /**
     * @default 'RSVP Tracking'
     */
    wLLdm: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Create'
     */
    IERgp: T;

    /**
     * @default 'Drafts'
     */
    q93Js: T;

    /**
     * @default 'Scheduled'
     */
    '542mo': T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Stationery'
     */
    khI0P: T;

    /**
     * @default 'Add Gifts'
     */
    '8lzdJ': T;

    /**
     * @default 'Website Editor'
     */
    '4bCWI': T;

    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Story & Tidbits'
     */
    MZCpe: T;

    /**
     * @default 'Guest Q&A'
     */
    gMg7F: T;

    /**
     * @default 'Wedding Party'
     */
    QfgiL: T;

    /**
     * @default 'Edit Pages'
     */
    '28e42': T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Add New Page'
     */
    wsKWg: T;

    /**
     * @default 'Manage Pages'
     */
    Ljvjt: T;

    /**
     * @default 'Orders'
     */
    HqnSL: T;

    /**
     * @default 'Enclosure Cards'
     */
    FmHhX: T;

    /**
     * @default 'Holiday Cards'
     */
    bGMf1: T;

    /**
     * @default 'Stack reveal'
     */
    '9u9Ie': T;

    /**
     * @default 'A deliberate reveal and a quicker retreat. The front card stays anchored.'
     */
    qJ86p: T;

    /**
     * @default 'Hover or focus a card to expand. On touch, use +N on the front card. Drag the front card left, or use the arrow, to push the stack aside; tap the peek to bring it back.'
     */
    ibd5b: T;

    /**
     * @default 'Reset cards'
     */
    '8cHuO': T;

    /**
     * @default 'Dismiss Honeymoon reminder'
     */
    YFAWf: T;

    /**
     * @default 'Honeymoon selected'
     */
    '3XL4J': T;

    /**
     * @default 'Websites 2 selected'
     */
    Rg8yz: T;

    /**
     * @default 'Updates'
     */
    Qn1Wf: T;

    /**
     * @default 'Collapse Updates'
     */
    JmLOT: T;

    /**
     * @default 'Show All Updates'
     */
    '2NJ8l': T;

    /**
     * @default 'Show Updates ({{0}})'
     */
    uP0Fd: T;

    /**
     * @default 'Hide Updates'
     */
    gqDfp: T;
  };
};

export type AdminDashboardV3Translations<T extends LeafNodeValue = TranslateFunction> = {
  adminMenu: {
    /**
     * @default 'Event Settings'
     */
    eventSettings: T;

    /**
     * @default 'Invite Collaborator'
     */
    inviteCollaborator: T;

    /**
     * @default 'Leave a Suggestion'
     */
    leaveSuggestion: T;

    /**
     * @default 'Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Help'
     */
    help: T;

    /**
     * @default 'Manage Events'
     */
    manageEvents: T;

    /**
     * @default 'Account Info'
     */
    accountInfo: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;

    /**
     * @default 'Edit Photos'
     */
    editPhotos: T;
  };
  quick: {
    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Preview Website'
     */
    XdIft: T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Invite Collaborator'
     */
    '5lFSE': T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Manage Events'
     */
    CGUli: T;

    /**
     * @default 'Account Info'
     */
    bZS93: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;

    /**
     * @default 'Switch to Website V1'
     */
    jQZTM: T;

    /**
     * @default 'Try Website V2'
     */
    E7LwC: T;

    /**
     * @default 'Reposition Photo'
     */
    MxxdX: T;

    /**
     * @default 'Next Steps'
     */
    ikR0l: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Invitations'
     */
    KVw3t: T;

    /**
     * @default 'Start with the photo you love'
     */
    IgU87: T;

    /**
     * @default 'Upload your favorite photo(s) and we'll create custom website designs that match it perfectly.'
     */
    as5eq: T;

    /**
     * @default 'Add Your Photo'
     */
    QVT8f: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'We're building your website…'
     */
    QQmlX: T;

    /**
     * @default 'This usually takes a few minutes. Feel free to explore the rest of Joy while we get ready for you.'
     */
    H8gH6: T;

    /**
     * @default 'We couldn't finish your website.'
     */
    '7p731': T;

    /**
     * @default 'Something went wrong while it was being generated.'
     */
    '4ekU3': T;

    /**
     * @default 'Open Website Editor'
     */
    YQFoq: T;

    /**
     * @default 'Your website is ready.'
     */
    tAlCR: T;

    /**
     * @default 'Open the editor to preview it and publish when you're happy.'
     */
    '7KdzQ': T;

    /**
     * @default 'This event doesn't have a website yet.'
     */
    Y1AL1: T;

    /**
     * @default 'Create Website'
     */
    hTJjk: T;

    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Specific Guests'
     */
    '3Tybq': T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Joy Home Page'
     */
    MAxNh: T;

    /**
     * @default 'Search pages and actions'
     */
    O0lKY: T;

    /**
     * @default 'Edit Photos'
     */
    '30HpG': T;

    /**
     * @default 'Complete Your Venue Setup'
     */
    Cx7iI: T;

    /**
     * @default 'Add Your Venue'
     */
    tFsbg: T;

    /**
     * @default 'Make it easy for your guests to plan their trip.'
     */
    Veb8n: T;

    /**
     * @default 'Include it on your website, invitations, and other guest facing communication.'
     */
    LpEsL: T;

    /**
     * @default 'Default stationary banner'
     */
    HFxDO: T;

    /**
     * @default 'Designs for Every Wedding Moment'
     */
    '9O4u8': T;

    /**
     * @default 'Create Save the Dates and invitations that match your wedding website, then send them digitally or printed.'
     */
    vJUEd: T;

    /**
     * @default 'Browse cards'
     */
    p58hE: T;

    /**
     * @default 'Save the date preview'
     */
    ModOf: T;

    /**
     * @default 'Invitation preview'
     */
    RVanN: T;

    /**
     * @default 'Designs that match your website'
     */
    VKDyN: T;

    /**
     * @default 'Front preview of your most recent stationery order'
     */
    NyIPD: T;

    /**
     * @default 'Your most recent order'
     */
    RH3e8: T;

    /**
     * @default 'View orders'
     */
    I3Gr3: T;

    /**
     * @default 'Preview of your stationery draft'
     */
    xuFWX: T;

    /**
     * @default 'Continue your design'
     */
    wzDbB: T;

    /**
     * @default 'View drafts'
     */
    rMXia: T;

    /**
     * @default 'Text card preview'
     */
    LXLnn: T;

    /**
     * @default 'Studio art card preview'
     */
    jmLtC: T;

    /**
     * @default 'Photo card preview'
     */
    kfwOT: T;

    /**
     * @default 'A wedding card made just for you'
     */
    '6otEU': T;

    /**
     * @default 'We illustrated your photo and found matching designs to help you start your stationery search.'
     */
    HZy3M: T;

    /**
     * @default 'See the card'
     */
    OVNi1: T;

    /**
     * @default 'Browse all designs'
     */
    w2fbH: T;

    /**
     * @default 'Your card draft'
     */
    '4zakU': T;

    /**
     * @default 'Card design'
     */
    gQbxt: T;

    /**
     * @default 'Save the date back preview'
     */
    H32iI: T;

    /**
     * @default 'Browse Cards'
     */
    Zhu8B: T;

    /**
     * @default 'Add Event Venue'
     */
    '456a7': T;

    /**
     * @default 'Share the venue where your event takes place.'
     */
    MHQEV: T;

    /**
     * @default 'Collect Contacts'
     */
    v9WNU: T;

    /**
     * @default 'Collect guest contact details.'
     */
    CKQI0: T;

    /**
     * @default 'Share a magic link to gather guest information automatically.'
     */
    kRhoB: T;

    /**
     * @default 'Set Up'
     */
    '7Z22U': T;

    /**
     * @default 'Complete Setup'
     */
    WULcD: T;

    /**
     * @default 'Share Magic Link'
     */
    myqVK: T;

    /**
     * @default 'Edit Settings'
     */
    '1bS0v': T;

    /**
     * @default 'Upload your contacts in a tap.'
     */
    U7Ume: T;

    /**
     * @default 'Get the Joy app to import your phone contacts and build your guest list in seconds.'
     */
    '0IMOu': T;

    /**
     * @default 'Get the App'
     */
    '2YLcL': T;

    /**
     * @default 'Maybe Later'
     */
    Eb0Nh: T;

    /**
     * @default 'Select Guests'
     */
    NFyEb: T;

    /**
     * @default 'Add More'
     */
    m1urO: T;

    /**
     * @default 'Import Contacts'
     */
    '0NCRO': T;

    /**
     * @default 'Add Manually'
     */
    AyEMA: T;

    /**
     * @default 'Send Link'
     */
    sG09N: T;

    /**
     * @default 'Add your guests.'
     */
    xQC5D: T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'View your event stats'
     */
    BbIsJ: T;

    /**
     * @default 'Hide Details'
     */
    SlaeC: T;

    /**
     * @default 'See All'
     */
    wrBB4: T;

    /**
     * @default 'Overview statistics details'
     */
    O1pcK: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Potential Guests'
     */
    '7eBlB': T;

    /**
     * @default 'Contact Collected'
     */
    HCmSZ: T;

    /**
     * @default 'Save the Dates'
     */
    Js2r5: T;

    /**
     * @default 'Prints Ordered'
     */
    H7zPM: T;

    /**
     * @default 'Digital Sent'
     */
    '6VAFf': T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Hotels Added'
     */
    fdzeE: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Gifts Available'
     */
    GY05C: T;

    /**
     * @default 'Reserved & Purchased'
     */
    v5mGq: T;

    /**
     * @default 'Updated 1 Day Ago'
     * @param {number} count - The number of occurrences.
     * - singular: Updated 1 Day Ago
     * - plural: Updated {{0}} Days Ago
     */
    CVDvP: T;

    /**
     * @default 'Updated Today'
     */
    M4bqR: T;

    /**
     * @default 'Updated {{0}}'
     */
    '5jF0U': T;

    /**
     * @default 'Order Placed'
     */
    P7nyi: T;

    /**
     * @default 'In Production'
     */
    slvEW: T;

    /**
     * @default 'Paused'
     */
    qo2mM: T;

    /**
     * @default 'Ready to Ship'
     */
    '6fgOk': T;

    /**
     * @default 'Shipped'
     */
    '1mzdC': T;

    /**
     * @default 'Delivered'
     */
    SbKKi: T;

    /**
     * @default 'Canceled'
     */
    TqO5I: T;

    /**
     * @default 'Refunded'
     */
    '3DziC': T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Card'
     */
    M1iKA: T;

    /**
     * @default 'Track Order'
     */
    p4ghO: T;

    /**
     * @default 'Edit Design'
     */
    YqPok: T;

    /**
     * @default 'View More Designs'
     */
    '3SGsJ': T;

    /**
     * @default 'Print'
     */
    DdvrG: T;

    /**
     * @default 'Print and digital invitations.'
     */
    qb6TK: T;

    /**
     * @default 'Explore Designs'
     */
    Wh0Py: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Share your wedding schedule.'
     */
    FNdaJ: T;

    /**
     * @default 'Add ceremonies, parties, and events so guests know where to be.'
     */
    WQpmr: T;

    /**
     * @default 'Add Events'
     */
    melSd: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Edit Schedule'
     */
    hv6rG: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Share nearby hotels with wedding rates.'
     */
    oVytz: T;

    /**
     * @default 'Add Hotels'
     */
    cOmsk: T;

    /**
     * @default 'Remind Guests to Book'
     */
    KhgiN: T;

    /**
     * @default 'Edit Hotels'
     */
    Jq8Cw: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Edit Website'
     */
    nH6Xt: T;

    /**
     * @default 'Design your wedding website.'
     */
    QAve9: T;

    /**
     * @default 'Personalize your pages and share every detail with your guests.'
     */
    ZniEh: T;

    /**
     * @default 'Share Website'
     */
    k5DXO: T;
  };
};

export type AdminHeaderBarTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} admin header'
     */
    '6gYbV': T;

    /**
     * @default 'Admin header'
     */
    ohLyn: T;

    /**
     * @default 'Resize panel'
     */
    Wm6Ky: T;

    /**
     * @default 'Show panel'
     */
    Zkmxz: T;

    /**
     * @default 'Hide panel'
     */
    '8LN60': T;
  };
};

export type AiReviewTextareaTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Proofread'
     */
    iCHDI: T;

    /**
     * @default 'Rewrite'
     */
    MHRQg: T;

    /**
     * @default 'Concise'
     */
    '2b372': T;

    /**
     * @default 'Friendly'
     */
    dcMbs: T;

    /**
     * @default 'Professional'
     */
    '5obWB': T;

    /**
     * @default 'New Draft'
     */
    To0LY: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Compose'
     */
    qK442: T;

    /**
     * @default 'Generating...'
     */
    qOw0Q: T;

    /**
     * @default 'Revert'
     */
    oASPS: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Describe your change'
     */
    qqEcP: T;

    /**
     * @default 'Failed to improve text, please try again.'
     */
    UZS1M: T;
  };
};

export type AllyPartnershipAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Partnered with Joy'
     */
    XKmBS: T;

    /**
     * @default 'Get $200 with a new Ally account.'
     */
    uSWri: T;

    /**
     * @default 'Open with Joy — no fees, no minimums.'
     */
    E7hlN: T;

    /**
     * @default 'Open an Ally account'
     */
    q1StO: T;

    /**
     * @default 'No thanks'
     */
    yauuo: T;

    /**
     * @default '$200 bonus offer subject to Ally Bank terms and conditions. Must open a new qualifying savings account.'
     */
    txyb7: T;

    /**
     * @default 'Something borrowed. Nothing owed.'
     */
    SDInS: T;

    /**
     * @default 'Spending and savings tools built for life today.'
     */
    x4NpY: T;

    /**
     * @default 'Ally Bank, Member FDIC.'
     */
    OoQTX: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Spend on the dance.'
     */
    '5sY86': T;

    /**
     * @default 'Save for France.'
     */
    prMAP: T;

    /**
     * @default 'Automatically save'
     */
    q1YfK: T;

    /**
     * @default 'while you spend.'
     */
    sTIZu: T;

    /**
     * @default 'Learn more with Ally.'
     */
    JoSsc: T;
  };
};

export type ArtUploadTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Upload Your Art'
     */
    v8hGl: T;

    /**
     * @default 'Upload Your Own'
     */
    O9lGl: T;

    /**
     * @default 'Guide to Custom Artwork'
     */
    sz8Q4: T;

    /**
     * @default 'Upload Art'
     */
    aHKxO: T;

    /**
     * @default 'Desktop Photo'
     */
    KVbd8: T;

    /**
     * @default 'Replace Desktop Photo'
     */
    EeGqB: T;

    /**
     * @default 'Remove Desktop Photo'
     */
    E3fgu: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Mobile Photo'
     */
    uG8aE: T;

    /**
     * @default 'Replace Mobile Photo'
     */
    C2eeW: T;

    /**
     * @default 'Remove Mobile Photo'
     */
    oAGq2: T;

    /**
     * @default 'Select Art'
     */
    tpboI: T;

    /**
     * @default 'Your Art'
     */
    y2ASg: T;

    /**
     * @default 'Background Art'
     */
    JtMpx: T;

    /**
     * @default 'Page Transparency'
     */
    L81oP: T;

    /**
     * @default 'Phones show your theme's art'
     */
    rLn4S: T;

    /**
     * @default 'Same as desktop'
     */
    yXsKX: T;

    /**
     * @default 'More info about Background Art'
     */
    TVoR4: T;

    /**
     * @default 'Desktop art shows beside your page. Phones show your mobile image, or your theme's art if you haven't added one.'
     */
    '4DXiI': T;

    /**
     * @default 'Desktop and mobile each show their own image. Mobile starts out the same as desktop.'
     */
    cKhE2: T;

    /**
     * @default 'Desktop'
     */
    UpyS2: T;

    /**
     * @default 'Add Desktop Image'
     */
    OMsUG: T;

    /**
     * @default 'Replace Desktop Image'
     */
    '5i7HB': T;

    /**
     * @default 'Remove Desktop Image'
     */
    '57W8t': T;

    /**
     * @default 'Mobile'
     */
    YsAvF: T;

    /**
     * @default 'Add Mobile Image'
     */
    Yq4Yy: T;

    /**
     * @default 'Replace Mobile Image'
     */
    '36V6V': T;

    /**
     * @default 'Remove Mobile Image'
     */
    fF7H2: T;

    /**
     * @default 'Use Desktop Image'
     */
    KKJsR: T;

    /**
     * @default 'More info about Page Transparency'
     */
    HdZyL: T;

    /**
     * @default 'Lets your background art show through your page. Turn it off to hide the art on phones.'
     */
    GdhZy: T;

    /**
     * @default 'Mobile Top Banner'
     */
    jtY71: T;

    /**
     * @default 'More info about Mobile Top Banner'
     */
    fO6Gy: T;

    /**
     * @default 'A strip of art at the top of your site on phones. It only uses the banner image you add here.'
     */
    IBZ8v: T;

    /**
     * @default 'Your header style doesn't show a banner on your website. It still shows on your registry page.'
     */
    XyYx6: T;

    /**
     * @default 'Banner Image'
     */
    pC7vI: T;

    /**
     * @default 'Add Banner Image'
     */
    chCS3: T;

    /**
     * @default 'Replace Banner Image'
     */
    '7xdza': T;

    /**
     * @default 'Remove Banner Image'
     */
    j6EB7: T;

    /**
     * @default 'An error occurred while uploading your art. Please try again.'
     */
    BB4FO: T;

    /**
     * @default 'No art selected. Please select an art to upload.'
     */
    vL0pC: T;

    /**
     * @default 'Custom Theme'
     */
    '8rmoz': T;

    /**
     * @default 'An error occurred while removing your art. Please try again.'
     */
    '5ZBOk': T;
  };
};

export type AutoPopulationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Your hotel suggestions are ready.'
     */
    NuetS: T;

    /**
     * @default 'We looked for great hotel deals near your venue and found a few you might like.'
     */
    sksHn: T;

    /**
     * @default 'See Hotel Suggestions'
     */
    cIKIw: T;

    /**
     * @default 'Remind Me Later'
     */
    vxjAH: T;

    /**
     * @default 'Close Auto Population Completed Dialog'
     */
    f23hG: T;

    /**
     * @default 'We found 1 hotel suggestion with up to 40% lower rates.'
     * @param {number} count - The number of occurrences.
     * - singular: We found 1 hotel suggestion with up to 40% lower rates.
     * - plural: We found {{0}} hotel suggestions with up to 40% lower rates.
     */
    OiIFC: T;

    /**
     * @default 'Room Blocks without the Contract.'
     */
    sWplI: T;

    /**
     * @default '1'
     */
    xAAAA: T;

    /**
     * @default '2'
     */
    yAAAA: T;

    /**
     * @default '3'
     */
    zAAAA: T;

    /**
     * @default '4'
     */
    '0AAAA': T;

    /**
     * @default '5'
     */
    '1AAAA': T;

    /**
     * @default 'Close feedback form'
     */
    '3EIQ8': T;

    /**
     * @default 'Were these hotel suggestions helpful?'
     */
    MHBs9: T;

    /**
     * @default 'Your feedback helps us refine the list for your guests.'
     */
    b1TGW: T;

    /**
     * @default 'We're improving our recommendation engine, tell us how can we do better.'
     */
    wZiB2: T;

    /**
     * @default 'Tell us what worked, what didn't, and what you'd like to see instead.'
     */
    TjD6S: T;

    /**
     * @default 'Type your reply here'
     */
    zdiAG: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Finding hotels near your venue with exclusive event rates, up to 40% off.'
     */
    r35s8: T;
  };
};

export type BookmarkletTranslations<T extends LeafNodeValue = TranslateFunction> = {
  bookmarklet: {
    /**
     * @default 'You can add items to your registry from any store!'
     */
    title: T;

    /**
     * @default 'Drag the button below to your Bookmarks bar to get started'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    button: T;

    /**
     * @default 'Please drag and drop this button to the Bookmarks bar'
     */
    dragAlert: T;

    steps: [
      {
        /**
         * @default 'Make sure your Bookmarks bar is visible'
         */
        step: T;

        /**
         * @default 'In Chrome's top menu, go to View and make sure there's a checkmark next to Always Show Bookmarks Bar.'
         */
        description: T;
      },
      {
        /**
         * @default 'Click and drag the Add to Joy button to your Bookmarks bar'
         */
        step: T;

        /**
         * @default ' '
         */
        description: T;
      },
      {
        /**
         * @default 'Now try it out!'
         */
        step: T;

        /**
         * @default 'Visit any store and click your new Registry button.'
         */
        description: T;
      },
    ];
  };
  validation: {
    /**
     * @default 'Invalid URL'
     */
    invalidDomain: T;

    /**
     * @default 'Required'
     */
    required: T;
  };
  joyButtonDialog: {
    /**
     * @default 'Easily add items from any store with the Joy bookmark button'
     */
    title: T;

    /**
     * @default 'Drag the button below to your browser’s Bookmark bar to save it.'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    addToJoy: T;

    /**
     * @default 'All done? Let’s test it out'
     */
    alreadyAdded: T;

    /**
     * @default 'Read the guide'
     */
    watchTurtorial: T;

    /**
     * @default 'Nice work! Now try testing it by adding the item below'
     */
    trySubtitle: T;

    /**
     * @default 'Try Adding This Item'
     */
    tryButton: T;

    /**
     * @default 'Start over'
     */
    startOver: T;

    /**
     * @default 'Still need help?'
     */
    stillNeedHelp: T;
  };
  addGiftDialog: {
    /**
     * @default 'Choose your registry'
     */
    multipleEventSelectTitle: T;

    /**
     * @default 'Add Gift'
     */
    actionText: T;

    /**
     * @default 'Choose Image'
     */
    giftImageLabel: T;

    /**
     * @default 'Title'
     */
    nameInputLabel: T;

    /**
     * @default 'Price'
     */
    priceInputLabel: T;

    /**
     * @default 'Qty'
     */
    qtyInputLabel: T;

    /**
     * @default 'Gift Type'
     */
    typeInputLabel: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteInputLabel: T;

    /**
     * @default 'Add an optional note here to help your gift-givers.'
     */
    noteInputPlaceholder: T;
  };
  successContent: {
    /**
     * @default 'Awesome!'
     */
    successTitle: T;

    /**
     * @default '{{title}} has been successfully added to your registry.'
     */
    successMessage: T;

    /**
     * @default 'Go to registry'
     */
    successCta: T;

    /**
     * @default 'add your shipping address'
     */
    shippingAddressLinkText: T;

    /**
     * @default 'Don’t forget to <shippingAddressLink/> so gift givers know where to send your gift!'
     */
    shippingAddressReminderText: T;
  };
  failContent: {
    /**
     * @default 'Your Registry'
     */
    yourRegistry: T;

    /**
     * @default 'Item Could Not Be Added'
     */
    failTitle: T;

    /**
     * @default 'This item failed to be added. Go to <br /><yourRegistry/> to manually add this item'
     */
    failMessage: T;
  };
  noAuthDialog: {
    /**
     * @default 'You are no longer signed in to Joy.'
     */
    title: T;

    /**
     * @default 'Login at withjoy.com and try again.'
     */
    subtitle: T;

    /**
     * @default 'Sign In'
     */
    signIn: T;

    /**
     * @default 'Connect your Joy account first to start adding items to your registry.'
     */
    notConnected: T;

    /**
     * @default 'Connect'
     */
    connect: T;

    /**
     * @default 'Your Joy account is now connected, you can start adding gifts to your registry!'
     */
    accountConnected: T;
  };
  browserButton: {
    /**
     * @default 'This store doesn’t work with the Joy Browser button. Copy the URL and add this item manually on your manage page in Joy.'
     */
    scriptLoadError: T;
  };
  popupTrigger: {
    /**
     * @default 'Popup May Have Been Blocked'
     */
    heading: T;

    /**
     * @default 'Click the button below to launch Add to Joy in another window'
     */
    instructions: T;

    /**
     * @default 'Open Add to Joy'
     */
    button: T;

    /**
     * @default 'Looks like we couldn't get past your popup blocker. Could you please disable it just so we can figure out what product you're trying to add to your registry?'
     */
    error: T;
  };
  quick: {
    /**
     * @default 'Add a price greater than 0'
     */
    iKNKd: T;
  };
};

export type BudgetTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Budget'
     */
    Z51Gn: T;
  };
};

export type CardGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Pause music'
     */
    phGEQ: T;

    /**
     * @default 'Play music'
     */
    zqULm: T;

    /**
     * @default 'Hmm… we can't find that.'
     */
    rtQKD: T;

    /**
     * @default 'This digital card may have been changed or is temporarily unavailable.'
     */
    gZeKX: T;

    /**
     * @default 'Find a Couple'
     */
    SabMC: T;

    /**
     * @default 'You've Got a Card'
     */
    '6dNaO': T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Guest Help'
     */
    JytpA: T;

    /**
     * @default 'About'
     */
    t7tcF: T;

    /**
     * @default 'Browse Joy Cards'
     */
    x6hmq: T;

    /**
     * @default 'Check out what's inside. Hope you enjoy it!'
     */
    '0vnnk': T;
  };
};

export type CarouselTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Previous'
     */
    RGyWS: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;
  };
};

export type CarRentalConsoleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'See all cars'
     */
    DSull: T;

    /**
     * @default 'Requests cannot be guaranteed as they are subject to availability. Payment due at pick-up.'
     */
    '6hI57': T;

    /**
     * @default 'All-terrain'
     */
    vuq0U: T;

    /**
     * @default 'Car'
     */
    S0TAA: T;

    /**
     * @default 'Convertible'
     */
    tg0cO: T;

    /**
     * @default 'Limousine'
     */
    Zuiea: T;

    /**
     * @default 'Motorhome'
     */
    sB0c2: T;

    /**
     * @default 'Pickup truck'
     */
    hofpD: T;

    /**
     * @default 'Station wagon'
     */
    '0p3G1': T;

    /**
     * @default 'SUV'
     */
    eQYAA: T;

    /**
     * @default 'Van'
     */
    '7NZAA': T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Compact'
     */
    fE042: T;

    /**
     * @default 'Compact elite'
     */
    kNWPL: T;

    /**
     * @default 'Economy'
     */
    '4nKv0': T;

    /**
     * @default 'Economy elite'
     */
    jJ9V3: T;

    /**
     * @default 'Full-size'
     */
    t7fdZ: T;

    /**
     * @default 'Intermediate'
     */
    JRVoQ: T;

    /**
     * @default 'Intermediate elite'
     */
    iUz5T: T;

    /**
     * @default 'Luxury'
     */
    DBCoD: T;

    /**
     * @default 'Midsize'
     */
    HHPUo: T;

    /**
     * @default 'Mini'
     */
    '7jGMA': T;

    /**
     * @default 'Mini elite'
     */
    '2bUI3': T;

    /**
     * @default 'Premium'
     */
    P2hvj: T;

    /**
     * @default 'Special'
     */
    xo88B: T;

    /**
     * @default 'Standard'
     */
    FIpp0: T;

    /**
     * @default 'Subcompact'
     */
    xw0kZ: T;

    /**
     * @default 'Automatic'
     */
    r6YaO: T;

    /**
     * @default 'Manual'
     */
    WCNpE: T;

    /**
     * @default 'Diesel'
     */
    mUwbr: T;

    /**
     * @default 'Electric'
     */
    lx0rd: T;

    /**
     * @default 'Petrol'
     */
    '8Jn6M': T;

    /**
     * @default 'Hybrid'
     */
    W0vT3: T;

    /**
     * @default 'All-wheel drive'
     */
    '7pz8o': T;

    /**
     * @default 'Front-wheel drive'
     */
    LrkIE: T;

    /**
     * @default 'Rear-wheel drive'
     */
    ILL7g: T;

    /**
     * @default 'Four-wheel drive'
     */
    GhtAO: T;

    /**
     * @default 'Unspecified'
     */
    tfIoC: T;

    /**
     * @default 'Empty to empty'
     */
    pMCri: T;

    /**
     * @default 'Full to empty'
     */
    lMW8o: T;

    /**
     * @default 'Full to full'
     */
    zv96h: T;

    /**
     * @default 'Same to same'
     */
    HCRLE: T;

    /**
     * @default 'Collision Damage Waiver'
     */
    BIyiR: T;

    /**
     * @default 'Fully refundable'
     */
    arido: T;

    /**
     * @default 'Free cancellation'
     */
    TQbyK: T;

    /**
     * @default 'Cancellation available'
     */
    KwrDt: T;

    /**
     * @default 'Pay now and save'
     */
    cEXE9: T;

    /**
     * @default 'Pay at pick-up'
     */
    Yg6B4: T;

    /**
     * @default 'Reserve with a card'
     */
    FzhCK: T;

    /**
     * @default 'Reserve with a card and save'
     */
    fFeFH: T;

    /**
     * @default 'Reserve without a credit card'
     */
    YBqvs: T;

    /**
     * @default 'No upfront payment required'
     */
    G2gIF: T;

    /**
     * @default 'You will not be charged yet'
     */
    pa4DP: T;

    /**
     * @default 'Pay now'
     */
    g1ieN: T;

    /**
     * @default 'Pay later'
     */
    a4EBl: T;

    /**
     * @default 'You can cancel for free anytime before pick-up, no fees or charges.'
     */
    twpFP: T;

    /**
     * @default 'You can cancel for free until this date. After that, cancellation fees apply.'
     */
    '7vZO5': T;

    /**
     * @default 'If you cancel after {{0}}, you will be charged a {{1}} fee or the total booking amount, whichever is less.'
     */
    jDPVf: T;

    /**
     * @default 'If you cancel before {{0}}, you will be charged a {{1}} fee or the total booking amount, whichever is less.'
     */
    gZD9x: T;

    /**
     * @default 'If you cancel, you will be charged a {{0}} fee or the total booking amount, whichever is less.'
     */
    cLYja: T;

    /**
     * @default 'After'
     */
    gnWdF: T;

    /**
     * @default 'Until'
     */
    urFGH: T;

    /**
     * @default 'Cancellation policy'
     */
    rRDVP: T;

    /**
     * @default 'Cancellation fee'
     */
    ZqovZ: T;

    /**
     * @default 'Today'
     */
    h6LBH: T;

    /**
     * @default 'Pick-up'
     */
    fBJvL: T;

    /**
     * @default 'Fees apply'
     */
    '9esFy': T;

    /**
     * @default 'Cancellation fees are estimates and may vary slightly.'
     */
    L7PiZ: T;

    /**
     * @default 'Drop-off'
     */
    '1YaiW': T;

    /**
     * @default 'Hours of operation'
     */
    DInhn: T;

    /**
     * @default '{{0}} - {{1}}'
     */
    iy4m2: T;

    /**
     * @default 'View in map'
     */
    oytTn: T;

    /**
     * @default 'Car hire location'
     */
    PQeYF: T;

    /**
     * @default 'Pick-up requirements'
     */
    da3FM: T;

    /**
     * @default 'Valid driving license'
     */
    gzzSd: T;

    /**
     * @default 'Your credit card. Check rental policies to see if debit cards are accepted.'
     */
    dQpK6: T;

    /**
     * @default 'Rental policy'
     */
    Sgn3o: T;

    /**
     * @default 'Map showing car hire location'
     */
    Gp2BL: T;

    /**
     * @default '{{0}} verified rating'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} verified rating
     * - plural: {{0}} verified ratings
     */
    H5XB9: T;

    /**
     * @default 'Wonderful'
     */
    MZVfM: T;

    /**
     * @default 'Fabulous'
     */
    Z6jq4: T;

    /**
     * @default 'Very good'
     */
    XsUEG: T;

    /**
     * @default 'Good'
     */
    BMOLA: T;

    /**
     * @default 'Pleasant'
     */
    '8SCnL': T;

    /**
     * @default 'See rating details'
     */
    Ua0xo: T;

    /**
     * @default 'Extras'
     */
    '1z2Uv': T;

    /**
     * @default 'per day'
     */
    lE0rl: T;

    /**
     * @default 'Lock in this price today. Cancel free of charge up to {{0}} hour before pick-up.'
     * @param {number} count - The number of occurrences.
     * - singular: Lock in this price today. Cancel free of charge up to {{0}} hour before pick-up.
     * - plural: Lock in this price today. Cancel free of charge up to {{0}} hours before pick-up.
     */
    zngwR: T;

    /**
     * @default 'Lock in this price today. Cancel free of charge anytime before pick-up.'
     */
    sRk9q: T;

    /**
     * @default 'total'
     */
    m1ekJ: T;

    /**
     * @default 'Price details'
     */
    pe7Sv: T;

    /**
     * @default 'Reserve'
     */
    IGc4f: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default '{{0}} Passenger'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} Passenger
     * - plural: {{0}} Passengers
     */
    XYdxL: T;

    /**
     * @default '{{0}} Door'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} Door
     * - plural: {{0}} Doors
     */
    '1xIDO': T;

    /**
     * @default 'Air conditioning'
     */
    heHCp: T;

    /**
     * @default 'Drive unlimited distance with this car at no extra cost.'
     */
    vK78X: T;

    /**
     * @default 'Vehicle to be returned with the same amount of fuel as start of the trip to avoid refuelling charges.'
     */
    Kf5EM: T;

    /**
     * @default 'Fuel: {{0}}'
     */
    Ceej8: T;

    /**
     * @default 'Rental car'
     */
    qvqTS: T;

    /**
     * @default 'at {{0}}'
     */
    '5YnwD': T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Policies'
     */
    UkRTC: T;

    /**
     * @default 'Rules and restrictions'
     */
    h1qXS: T;

    /**
     * @default 'Car hire fee x 1 day'
     * @param {number} count - The number of occurrences.
     * - singular: Car hire fee x 1 day
     * - plural: Car hire fee x {{0}} days
     */
    '84kyE': T;

    /**
     * @default 'Taxes and fees'
     */
    tvthM: T;

    /**
     * @default 'included'
     */
    UwFm5: T;

    /**
     * @default 'Included'
     */
    uXyQw: T;

    /**
     * @default 'Free cancellation, you can cancel for free anytime before pick-up, no fees or charges.'
     */
    Gjxch: T;

    /**
     * @default 'Cancel for a full refund until {{0}} at {{1}} UTC'
     */
    TESmP: T;

    /**
     * @default 'After that, the estimated cancellation fee is {{0}} or the total booking amount, whichever is less, until {{1}} at {{2}} UTC'
     */
    exCBv: T;

    /**
     * @default 'After that, the estimated cancellation fee is {{0}} or the total booking amount, whichever is less'
     */
    mdlUP: T;

    /**
     * @default 'The estimated cancellation fee is {{0}} or the total booking amount, whichever is less, until {{1}} at {{2}} UTC'
     */
    t0I5C: T;

    /**
     * @default 'The estimated cancellation fee is {{0}} or the total booking amount, whichever is less'
     */
    '52LvE': T;

    /**
     * @default 'Recommended'
     */
    '1pIEc': T;

    /**
     * @default 'Total price'
     */
    plYlg: T;

    /**
     * @default 'Distance'
     */
    '3I584': T;

    /**
     * @default 'Customer rating'
     */
    rKeHO: T;

    /**
     * @default 'Driver age'
     */
    vBdFU: T;

    /**
     * @default 'Age'
     */
    JUTAA: T;

    /**
     * @default 'Driver under 30 or over 70 years old'
     */
    S3oCS: T;

    /**
     * @default 'Young or senior drivers may be required to pay an additional fee.'
     */
    YobeC: T;

    /**
     * @default 'Enter an age between {{0}} and {{1}}.'
     */
    Yb7HZ: T;

    /**
     * @default 'Something went wrong starting your reservation. Please try again.'
     */
    TWFYa: T;

    /**
     * @default 'We couldn't start your reservation. Please try again.'
     */
    QGn4y: T;

    /**
     * @default 'Back to event website'
     */
    zb3eG: T;

    /**
     * @default 'Hours of Operation'
     */
    '7Om2V': T;

    /**
     * @default 'View Policy'
     */
    vI7Wj: T;

    /**
     * @default 'Promo code {{0}} applied'
     */
    JxqRS: T;

    /**
     * @default 'Mileage: {{0}}'
     */
    UzIiF: T;

    /**
     * @default 'Policies, Rules & Restrictions'
     */
    uiPdM: T;

    /**
     * @default 'Booking changes'
     */
    sFk0H: T;

    /**
     * @default 'Changes to an existing reservation are not allowed. If you need to change your dates, vehicle, pickup location, or other reservation details after booking, you'll need to cancel and make a new reservation at the current available price. Cancellation policies still apply.'
     */
    sjUdE: T;

    /**
     * @default 'Show less'
     */
    '6ZaNB': T;

    /**
     * @default 'Show all rules and restrictions'
     */
    fdhxG: T;

    /**
     * @default 'Deposit details'
     */
    '4RGQd': T;

    /**
     * @default 'A refundable security deposit of {{0}} will be held on your credit card at the time of pick-up. This amount is refundable and will be automatically released if there is no theft or damage during the rental period.'
     */
    axMgo: T;

    /**
     * @default 'Payable at counter'
     */
    '5zyxS': T;

    /**
     * @default 'Not included in your total'
     */
    tRGKj: T;

    /**
     * @default 'Refundable deposit'
     */
    o0YwL: T;

    /**
     * @default '{{0}} / day'
     */
    hUBKg: T;

    /**
     * @default '{{0}} total'
     */
    WvV3l: T;

    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default 'includes taxes & fees'
     */
    '54nid': T;

    /**
     * @default '{{0}} Airport'
     */
    LtkkW: T;

    /**
     * @default '{{0}} {{1}} away'
     */
    xNbii: T;

    /**
     * @default 'Pick-up & drop-off'
     */
    YGexq: T;

    /**
     * @default 'Group rate'
     */
    F2cCq: T;

    /**
     * @default 'Cancellation details'
     */
    z4W1M: T;

    /**
     * @default 'Fully electric'
     */
    Xwg2T: T;

    /**
     * @default 'Can't find what you're looking for?'
     */
    ETuUC: T;

    /**
     * @default 'Explore similar rentals'
     */
    vdpu8: T;

    /**
     * @default 'Edit dates'
     */
    X4Eg4: T;

    /**
     * @default 'These dates are too far in the future'
     */
    yr5e9: T;

    /**
     * @default 'Rental cars can’t be searched more than {{0}} days ahead. Update your pick-up and drop-off dates to continue.'
     */
    OcYSo: T;

    /**
     * @default 'Searching for rental cars near your event'
     */
    '9K2oC': T;

    /**
     * @default 'Comparing rates across vehicle classes'
     */
    mB5wF: T;

    /**
     * @default 'Finding cars loved by Joy guests'
     */
    '0FK1W': T;

    /**
     * @default 'Unlocking your exclusive Joy rates'
     */
    sDxLt: T;

    /**
     * @default 'Finding rental cars with exclusive event rates.'
     */
    bpWwh: T;

    /**
     * @default 'Pick-up location'
     */
    m0jPG: T;

    /**
     * @default 'Drop-off location'
     */
    '244Kk': T;

    /**
     * @default 'Pick-up time'
     */
    '08hxR': T;

    /**
     * @default 'Drop-off time'
     */
    u7lAA: T;

    /**
     * @default 'Select dates'
     */
    xyVOA: T;

    /**
     * @default 'These dates are too far in the future. Choose dates within the next {{0}} days.'
     */
    uU7Qu: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Locating pick-up location'
     */
    jqfpM: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Reset filters'
     */
    IINw9: T;

    /**
     * @default 'No rental cars match your search'
     */
    C8XrF: T;

    /**
     * @default 'Search for a pick-up location'
     */
    IOj5m: T;

    /**
     * @default 'Try adjusting your filters or search a different pick-up location and dates.'
     */
    jivtT: T;

    /**
     * @default 'Enter a pick-up location and dates above to see rental cars with exclusive event rates.'
     */
    S1hRL: T;

    /**
     * @default 'Retry search'
     */
    Quqas: T;

    /**
     * @default 'We’re having trouble loading rental cars'
     */
    '9bDWJ': T;

    /**
     * @default 'Something went wrong on our end. Please try again in a moment.'
     */
    qbF71: T;

    /**
     * @default 'Reset All Filters'
     */
    bnE3D: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Browse rental cars with exclusive rates for our guests.'
     */
    qqbXH: T;

    /**
     * @default 'Close filters'
     */
    nU0q9: T;

    /**
     * @default 'Airport pickup available'
     */
    AfjqB: T;

    /**
     * @default 'Payment option'
     */
    bcFev: T;

    /**
     * @default 'Car type'
     */
    O99KO: T;

    /**
     * @default 'Cancellation'
     */
    huYTg: T;

    /**
     * @default 'Capacity'
     */
    MDYDO: T;

    /**
     * @default '{{0}}+ passengers'
     */
    ycBl1: T;

    /**
     * @default 'Car hire company'
     */
    P5M5P: T;

    /**
     * @default 'Search by car'
     */
    fUcuH: T;

    /**
     * @default 'e.g., Toyota Corolla'
     */
    KBM5F: T;

    /**
     * @default 'Sort by'
     */
    '1pqZA': T;

    /**
     * @default '{{0}} → {{1}}+'
     */
    Eb8SD: T;

    /**
     * @default 'Price (total)'
     */
    kaWkM: T;

    /**
     * @default 'Min'
     */
    IuWAA: T;

    /**
     * @default 'Max'
     */
    CqWAA: T;

    /**
     * @default 'Specifications'
     */
    cmdQP: T;

    /**
     * @default 'Edit car search'
     */
    UnrYw: T;

    /**
     * @default 'Search cars'
     */
    Vl1i3: T;

    /**
     * @default 'Close search'
     */
    OJ0US: T;

    /**
     * @default '{{0}} result'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} result
     * - plural: {{0}} results
     */
    BQ2pG: T;

    /**
     * @default 'Sort: {{0}}'
     */
    '8lmj1': T;

    /**
     * @default 'Browse Car Rentals'
     */
    '31FmL': T;

    /**
     * @default 'Guest reward unlocked'
     */
    qSFJ7: T;

    /**
     * @default 'Save up to 25% on cars'
     */
    NCEu6: T;

    /**
     * @default 'You booked your stay for {{0}}’s wedding through Joy, so group rates are unlocked.'
     */
    '41m18': T;

    /**
     * @default 'We use your hotel as the pickup point. Prefer an airport or venue? Update it here.'
     */
    UniLc: T;

    /**
     * @default 'We use your event's airport as the pickup point. Prefer your hotel or the venue? Update it here.'
     */
    nMZw4: T;

    /**
     * @default 'We use your event venue as the pickup point. Prefer an airport or your hotel? Update it here.'
     */
    '7ArUs': T;
  };
};

export type CashFundsAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Add bank account'
     */
    mcfzQ: T;

    /**
     * @default 'No bank account added'
     */
    k0vyV: T;

    /**
     * @default 'Default for payouts'
     */
    tyGco: T;

    /**
     * @default 'Choose where your payouts land'
     */
    f8am0: T;

    /**
     * @default 'Add one from your Stripe dashboard'
     */
    bjCgT: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Accounts'
     */
    '0SyF3': T;

    /**
     * @default 'Payout bank account'
     */
    RlbN2: T;

    /**
     * @default 'We couldn't open your payout settings. Please try again in a moment.'
     */
    Lp1ki: T;

    /**
     * @default 'Transfer to bank'
     */
    ebLmY: T;

    /**
     * @default 'You'll transfer your full available balance.'
     */
    azb9u: T;

    /**
     * @default 'Available balance'
     */
    rs5MJ: T;

    /**
     * @default 'New balance:'
     */
    odtXa: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'How much would you like to transfer?'
     */
    jwVDZ: T;

    /**
     * @default 'You can transfer from {{0}} up to {{1}} now'
     */
    rfeCP: T;

    /**
     * @default 'You can transfer from {{0}} now'
     */
    A4FVK: T;

    /**
     * @default 'You can transfer up to {{0}} now'
     */
    Ym9qA: T;

    /**
     * @default 'Transfer to Bank'
     */
    WRWhY: T;

    /**
     * @default 'Transferrable Balance'
     */
    rr7kp: T;

    /**
     * @default 'Connect Bank Account'
     */
    lXrYh: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default '{{0}} transfer fee · min. {{1}}'
     */
    jgldX: T;

    /**
     * @default '{{0}} transfer fee'
     */
    rRxND: T;

    /**
     * @default 'How soon do you need it?'
     */
    BwfvV: T;

    /**
     * @default 'Instant'
     */
    fzaKR: T;

    /**
     * @default 'within 24 hours'
     */
    '2oBur': T;

    /**
     * @default 'Unavailable'
     */
    MM6n8: T;

    /**
     * @default 'Not available for this payment method.'
     */
    aG67g: T;

    /**
     * @default '5–7 business days'
     */
    I8P6u: T;

    /**
     * @default 'Account security checks may require additional time to make funds available.'
     */
    qublo: T;

    /**
     * @default 'Instant typically posts immediately but can take up to 24 hours.'
     */
    efaUP: T;

    /**
     * @default 'Instant transfer fee is {{0}} with a minimum {{1}} fee and maximum transfer of {{2}}.'
     */
    zaIV8: T;

    /**
     * @default 'Instant transfer fee is {{0}} with a minimum {{1}} fee.'
     */
    YFPCL: T;

    /**
     * @default 'Instant transfer fee is {{0}} and maximum transfer of {{1}}.'
     */
    IMPgq: T;

    /**
     * @default 'Instant transfer fee is {{0}}.'
     */
    eJLDA: T;

    /**
     * @default 'Transfer {{0}}'
     */
    T1ZH1: T;

    /**
     * @default 'Sorry! No balance is available for transfer.'
     */
    sfVXh: T;

    /**
     * @default 'Got it'
     */
    D2I4z: T;

    /**
     * @default 'Account under review'
     */
    '5qoxa': T;

    /**
     * @default 'Stripe is still verifying your payout account. You can transfer funds as soon as the review is complete. Contact us if it takes longer than a few days.'
     */
    BdW9c: T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'More information needed'
     */
    KgPda: T;

    /**
     * @default 'Stripe needs more information before you can transfer funds to your bank. Add the missing details in your Stripe account, or contact us if you need help.'
     */
    kxbHk: T;

    /**
     * @default 'Stripe needs more information before you can transfer funds to your bank. Our support team can help you find out what's missing.'
     */
    XIVLI: T;

    /**
     * @default 'Manage Stripe Account'
     */
    xWozs: T;

    /**
     * @default 'Transfer not available yet'
     */
    FYLHs: T;

    /**
     * @default 'For your account's security, there's a short waiting period between transfers. You can send your next one at the time below.'
     */
    zQTom: T;

    /**
     * @default 'Next transfer available'
     */
    dcUeO: T;

    /**
     * @default 'It's on its way.'
     */
    fQ50E: T;

    /**
     * @default 'Expected to arrive by'
     */
    '3dthT': T;

    /**
     * @default 'You'll receive an email from Stripe when your payment has processed.'
     */
    KirMc: T;

    /**
     * @default 'We couldn't complete your transfer. Please contact support.'
     */
    WtXqm: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'More options'
     */
    LeY4P: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'Active Funds'
     */
    CbGF4: T;

    /**
     * @default 'New Fund'
     */
    RBqUG: T;

    /**
     * @default 'Inactive Funds'
     */
    lZKxc: T;

    /**
     * @default 'Cash fund archived successfully.'
     */
    Tr2cB: T;

    /**
     * @default 'Failed to archive cash fund. Please try again.'
     */
    f4VFX: T;

    /**
     * @default 'Cash fund reactivated successfully.'
     */
    pphCQ: T;

    /**
     * @default 'Failed to reactivate cash fund. Please try again.'
     */
    Vqep6: T;

    /**
     * @default 'Cash fund duplicated successfully.'
     */
    QN66d: T;

    /**
     * @default 'Failed to duplicate cash fund. Please try again.'
     */
    erjem: T;

    /**
     * @default 'Copy of {{0}}'
     */
    QIgEL: T;

    /**
     * @default 'Copy of Cash Fund'
     */
    '8ajfU': T;

    /**
     * @default '1 Contribution'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Contribution
     * - plural: {{0}} Contributions
     */
    qrePD: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default '{{0}} Collected'
     */
    h9ErH: T;

    /**
     * @default 'Sorry, there's been an error. Please refresh the page.'
     */
    JNbvd: T;

    /**
     * @default 'All Funds'
     */
    PJr8J: T;

    /**
     * @default 'Edit Fund'
     */
    TkwHg: T;

    /**
     * @default 'Request Payment'
     */
    rQLGa: T;

    /**
     * @default 'Contribute to my Cash Fund'
     */
    Y6a1H: T;

    /**
     * @default 'Help us celebrate! Contribute to our cash fund.'
     */
    Rx3Im: T;

    /**
     * @default '✨ Cash Fund link copied to clipboard ✨'
     */
    '7JcJK': T;

    /**
     * @default 'Contribute'
     */
    VZXCJ: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Add Cash Fund'
     */
    H3BH7: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Edit Cash Fund'
     */
    wPahI: T;

    /**
     * @default 'Button Label'
     */
    '8mjEE': T;

    /**
     * @default 'Delete Cash Fund'
     */
    n697d: T;

    /**
     * @default 'Need Assistance?'
     */
    XxPx8: T;

    /**
     * @default 'Contact Us'
     */
    mf53u: T;

    /**
     * @default 'Set up a Cash Fund'
     */
    uarbV: T;

    /**
     * @default 'For bachelorette trips, room blocks, or other group plans.'
     */
    KMi21: T;

    /**
     * @default 'Share With Guests'
     */
    gz8mZ: T;

    /**
     * @default 'Share a contribution link with your guests before or after the event.'
     */
    Rpqj9: T;

    /**
     * @default 'Collect Contributions'
     */
    LD3Fc: T;

    /**
     * @default 'Watch contributions roll in and see who's contributed.'
     */
    vaILE: T;

    /**
     * @default 'Create a fund to collect contributions for shared plans.'
     */
    MUtmO: T;

    /**
     * @default 'Create Cash Fund'
     */
    gerG6: T;

    /**
     * @default '✨ Email copied to clipboard ✨'
     */
    ttFhK: T;

    /**
     * @default 'Received'
     */
    vGhoO: T;

    /**
     * @default 'Anonymous'
     */
    F6mAC: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Message from Guest'
     */
    pM2XN: T;

    /**
     * @default 'Zero state icon'
     */
    CEE6F: T;

    /**
     * @default 'No contributions yet'
     */
    '4lxAt': T;

    /**
     * @default 'Contributions will appear here once guests start giving.'
     */
    gGZaa: T;

    /**
     * @default 'Host setup required'
     */
    qX9k6: T;

    /**
     * @default 'To create and edit cash funds here, you'll need to set up your host information first in the Cash Fund Dashboard.'
     */
    qNqji: T;

    /**
     * @default 'Go to Cash Funds'
     */
    uRPWq: T;

    /**
     * @default 'New Cash Fund'
     */
    KOikK: T;

    /**
     * @default 'Select Cash Fund'
     */
    Y8jqb: T;

    /**
     * @default 'Select a fund...'
     */
    '6FmaS': T;

    /**
     * @default 'Host information saved successfully.'
     */
    YbcJs: T;

    /**
     * @default 'Failed to save host information. Please try again.'
     */
    WxDgr: T;

    /**
     * @default 'Fund created successfully.'
     */
    QoA5U: T;

    /**
     * @default 'Failed to create fund. Please try again.'
     */
    yCIaQ: T;

    /**
     * @default 'We couldn't check your registry currency. Please try again.'
     */
    Ybwux: T;

    /**
     * @default 'Your details are saved, but we couldn't update your registry currency. Please try again.'
     */
    Edn1w: T;

    /**
     * @default 'Host information is required. Please complete the contact form first.'
     */
    NqwaL: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Partnered with Joy'
     */
    XKmBS: T;

    /**
     * @default 'Your new life starts with a little extra.'
     */
    '3m70C': T;

    /**
     * @default 'Open an Ally savings account with Joy and get $200 on us — no fees, no minimums.'
     */
    ZWtaM: T;

    /**
     * @default 'Learn more'
     */
    tks4L: T;

    /**
     * @default 'No thanks'
     */
    yauuo: T;

    /**
     * @default '$200 bonus offer subject to Ally Bank terms and conditions. Must open a new qualifying savings account.'
     */
    txyb7: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Approval is taking longer than expected'
     */
    RjULU: T;

    /**
     * @default 'Your account is being reviewed'
     */
    CzJ31: T;

    /**
     * @default 'This will only take a minute'
     */
    '07bGD': T;

    /**
     * @default 'Check Stripe Status'
     */
    '3tBjr': T;

    /**
     * @default 'Resolve Stripe Issue'
     */
    gM2q9: T;

    /**
     * @default 'Transfer processing...'
     */
    CHg1I: T;

    /**
     * @default 'We couldn't complete one of your transfers. Please contact support.'
     */
    uQVER: T;

    /**
     * @default 'Your payout method has been updated.'
     */
    DXcnd: T;

    /**
     * @default 'Available to transfer'
     */
    fVhYn: T;

    /**
     * @default 'Money you can transfer to your bank now.'
     */
    CFXzD: T;

    /**
     * @default 'Stripe needs a bit more information before you can transfer.'
     */
    EQ0yv: T;

    /**
     * @default 'Verify your account to transfer'
     */
    '1Ggcb': T;

    /**
     * @default 'More information needed.'
     */
    '2hgjB': T;

    /**
     * @default 'You don't have any funds available to transfer yet.'
     */
    a41yU: T;

    /**
     * @default 'Used on Joy stays'
     */
    qz0qX: T;

    /**
     * @default 'Applied toward hotel bookings made on Joy.'
     */
    M0qiE: T;

    /**
     * @default 'Lifetime total received'
     */
    Q9zfd: T;

    /**
     * @default 'Total cash contributions collected from registry funds and cash funds via Stripe.'
     */
    pSP5N: T;

    /**
     * @default 'Processing'
     */
    '7B9SY': T;

    /**
     * @default 'Guest contributions are under review and usually become available within a few days.'
     */
    w7Z9b: T;

    /**
     * @default 'Available'
     */
    d8nEm: T;

    /**
     * @default 'Ready to transfer to your bank.'
     */
    nvKra: T;

    /**
     * @default 'Transfer in progress'
     */
    pK5Th: T;

    /**
     * @default 'On the way to your bank.'
     */
    bWVHG: T;

    /**
     * @default 'Transferred'
     */
    Y8MAL: T;

    /**
     * @default 'Successfully received by your bank.'
     */
    qDfCF: T;

    /**
     * @default 'View Transactions'
     */
    iX0OS: T;

    /**
     * @default 'Reactivate Fund'
     */
    PtCdW: T;

    /**
     * @default 'Duplicate'
     */
    djRAg: T;

    /**
     * @default 'Deactivate'
     */
    g1L73: T;

    /**
     * @default 'Activate'
     */
    nPknl: T;

    /**
     * @default 'Contributed'
     */
    tTNlH: T;

    /**
     * @default 'Goal'
     */
    rEOLA: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'First name is required'
     */
    '8niW2': T;

    /**
     * @default 'Last name is required'
     */
    cLL4a: T;

    /**
     * @default 'Country is required'
     */
    '94Fcd': T;

    /**
     * @default 'First, a little paperwork.'
     */
    y95K8: T;

    /**
     * @default 'Enter the name on a valid government ID. It must match your bank account exactly.'
     */
    TVict: T;

    /**
     * @default 'Legal First Name'
     */
    iEzPE: T;

    /**
     * @default 'Legal Last Name'
     */
    '0bdvm': T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'Set by your country. Can't be changed after saving'
     */
    eJtMr: T;

    /**
     * @default 'Guests give with Credit or Debit Card'
     */
    UeKs6: T;

    /**
     * @default 'Collect donations on your website. Automatic tracking.'
     */
    mw1Iv: T;

    /**
     * @default 'Transaction fees apply.'
     */
    nHnH6: T;

    /**
     * @default 'Secure, fast checkout with'
     */
    tLJHH: T;

    /**
     * @default 'Fixed Amount'
     */
    '0UmcM': T;

    /**
     * @default 'Any Amount'
     */
    QGaMT: T;

    /**
     * @default 'Total Goal'
     */
    drMGO: T;

    /**
     * @default 'Hide goal from guests'
     */
    cwGJY: T;

    /**
     * @default 'No goal? Just leave it blank.'
     */
    Hlk3p: T;

    /**
     * @default 'Quantity'
     */
    tT8ln: T;

    /**
     * @default 'Choose photo'
     */
    zSfiV: T;

    /**
     * @default 'Fund photo'
     */
    hN4UL: T;

    /**
     * @default 'Fund Name'
     */
    Ezomg: T;

    /**
     * @default 'Enter fund name'
     */
    IENXH: T;

    /**
     * @default 'Note to Guests'
     */
    oExcX: T;

    /**
     * @default 'Optional: Tell folks what this fund means to you'
     */
    JcPuG: T;

    /**
     * @default 'Fund created successfully!'
     */
    DoA5U: T;

    /**
     * @default 'We couldn't use that photo. Please choose a different one.'
     */
    '77EEE': T;

    /**
     * @default 'Fund updated successfully!'
     */
    sLj9Q: T;

    /**
     * @default 'Failed to update fund. Please try again.'
     */
    '3X1ay': T;

    /**
     * @default 'Fund name is required'
     */
    '7sgdb': T;

    /**
     * @default 'Fixed amount is required'
     */
    '1sHb4': T;

    /**
     * @default 'Amount must be greater than 0'
     */
    fjMil: T;

    /**
     * @default 'Quantity is required'
     */
    E8WlC: T;

    /**
     * @default 'Quantity must be at least 1'
     */
    wpOZ2: T;

    /**
     * @default 'Quantity must be a whole number'
     */
    Euc61: T;

    /**
     * @default 'Total goal must be at least {{0}}'
     */
    rHmGg: T;

    /**
     * @default 'Total goal must be a whole number'
     */
    uVxXH: T;

    /**
     * @default 'Failed to create a payout account session'
     */
    sIzxL: T;
  };
};

export type CashFundsGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Contribution Details'
     */
    YnBbD: T;

    /**
     * @default 'Contribution'
     */
    yJedr: T;

    /**
     * @default 'Processing Fee'
     */
    nDV7d: T;

    /**
     * @default 'Sales Tax'
     */
    pqyDA: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Contributor: {{0}}'
     */
    jNPeu: T;

    /**
     * @default 'Make Another Contribution'
     */
    tdvws: T;

    /**
     * @default 'View Registry'
     */
    gIPTc: T;

    /**
     * @default 'Book Your Stay'
     */
    dtKQh: T;

    /**
     * @default 'RSVP Now'
     */
    hxWxD: T;

    /**
     * @default 'Visit Wedding Website'
     */
    '6PorS': T;

    /**
     * @default 'Thank you for your contribution!'
     */
    AhRRd: T;

    /**
     * @default 'Contribution #{{0}}'
     */
    ncx4B: T;

    /**
     * @default 'We'll send you an email confirmation for your contribution shortly.'
     */
    vm6qq: T;

    /**
     * @default 'Your contribution to "{{0}}" has been received and will be available to the couple.'
     */
    qnv9H: T;

    /**
     * @default 'Next Steps'
     */
    ikR0l: T;

    /**
     * @default '{{0}} per person'
     */
    YTHGq: T;

    /**
     * @default 'Contribute'
     */
    VZXCJ: T;

    /**
     * @default 'Fund progress'
     */
    C6zX6: T;

    /**
     * @default 'Special characters < and > are not allowed'
     */
    Ta6NW: T;

    /**
     * @default 'Amount is required'
     */
    FSO9s: T;

    /**
     * @default 'Please enter a valid amount'
     */
    rJbRQ: T;

    /**
     * @default 'Minimum contribution is {{0}}{{1}}'
     */
    P57sD: T;

    /**
     * @default 'Maximum contribution is {{0}}{{1}}'
     */
    TmN8q: T;

    /**
     * @default 'Unable to calculate fees. Fees will be shown at checkout.'
     */
    Rxd8g: T;

    /**
     * @default 'Payment information is incomplete'
     */
    '23cxK': T;

    /**
     * @default 'Payment failed. Please try again.'
     */
    W11FM: T;

    /**
     * @default 'An unexpected error occurred. Please try again.'
     */
    CSDsd: T;

    /**
     * @default 'Contribute Another Way'
     */
    j3l9E: T;

    /**
     * @default 'Unable to load fund information'
     */
    '7rOQX': T;

    /**
     * @default 'Fund not found'
     */
    mMJHa: T;

    /**
     * @default 'This cash fund is no longer active.'
     */
    YvnVO: T;

    /**
     * @default 'Please contact the host for more details.'
     */
    XyGtx: T;

    /**
     * @default 'Amount'
     */
    '6xj0j': T;

    /**
     * @default 'Add a note (optional)'
     */
    je2JC: T;

    /**
     * @default 'Add a personal message...'
     */
    PTB6A: T;

    /**
     * @default 'Quick amount selection'
     */
    BdOJs: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'Failed to create checkout session. Please try again.'
     */
    '3IBmV': T;

    /**
     * @default 'Please share your details to help {{0}} track your contribution.'
     */
    iV0dq: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'First and last name'
     */
    wq1cY: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Continue to Checkout'
     */
    mw2yB: T;
  };
};

export type CashFundsSharedTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Previous cover options'
     */
    mhrDN: T;

    /**
     * @default 'Choose cover image {{0}}'
     */
    '7uFua': T;

    /**
     * @default 'Next cover options'
     */
    c9gX6: T;
  };
};

export type CashFundsTransferTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'About {{0}}'
     */
    fUvFd: T;

    /**
     * @default 'Transfer Cash'
     */
    k0yYS: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'A radically new way to bank.'
     */
    O8uGQ: T;

    /**
     * @default 'Checking, savings, and cards that put you in control of your money.'
     */
    '6r7hY': T;

    /**
     * @default 'Cards for the way you spend.'
     */
    N5kaz: T;

    /**
     * @default 'Create physical and virtual debit cards for everyday spending, travel, or subscriptions. Set a spending limit for each.'
     */
    z09Ee: T;

    /**
     * @default 'Your travel partner for fewer fees.'
     */
    YTU5J: T;

    /**
     * @default 'Mercury reimburses ATM fees worldwide. For purchases in another currency, Mastercard fees may apply.'
     */
    W7bXx: T;

    /**
     * @default 'A honeymoon here. A future home there.'
     */
    YFh7K: T;

    /**
     * @default 'Keep your honeymoon, home deposit, and everyday spending separate. Set up automatic transfers to keep each account funded.'
     */
    ucVcN: T;

    /**
     * @default 'Peace of mind you can trust.'
     */
    MZAAE: T;

    /**
     * @default 'Eligible deposits are FDIC-insured up to $5 million through Mercury's partner banks and sweep networks.'
     */
    PHmrM: T;

    /**
     * @default 'Applications are subject to Mercury's approval. Joy may receive a referral fee if you open and fund an account through our link.'
     */
    lB0K1: T;

    /**
     * @default 'Mercury is a fintech company, not an FDIC-insured bank. Banking services provided through Choice Financial Group and Column N.A., Members FDIC.'
     */
    '9d9tO': T;

    /**
     * @default 'Enter an amount'
     */
    LVM4h: T;

    /**
     * @default 'Enter at least {{0}}.'
     */
    igK8r: T;

    /**
     * @default 'Enter {{0}} or less.'
     */
    oCcGu: T;

    /**
     * @default 'Enter {{0}} or less per transfer.'
     */
    oEmrP: T;

    /**
     * @default 'Usually within minutes'
     */
    lHUAk: T;

    /**
     * @default 'May take up to 24 hours'
     */
    T4AxB: T;

    /**
     * @default 'Up to 7 business days'
     */
    SxT0k: T;

    /**
     * @default 'Estimated by {{0}}'
     */
    ze5SJ: T;

    /**
     * @default 'Couldn't refresh your bank details'
     */
    QG7CU: T;

    /**
     * @default 'Try again before transferring your money.'
     */
    sYUk6: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Up to {{0}} at a time'
     */
    d6p8G: T;

    /**
     * @default 'Your whole balance'
     */
    Sd7eg: T;

    /**
     * @default 'You have {{0}} available. Up to {{1}} at a time.'
     */
    sadku: T;

    /**
     * @default 'You have {{0}} available.'
     */
    '0ug5O': T;

    /**
     * @default 'Use maximum'
     */
    '9v7CT': T;

    /**
     * @default 'Use full balance'
     */
    aE9w6: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Connect your bank with Stripe'
     */
    oQS14: T;

    /**
     * @default 'You'll verify your identity and add your bank account on Stripe. Setup takes about 5 minutes. Then return to Joy to transfer your money.'
     */
    Bwlzg: T;

    /**
     * @default 'Have these handy'
     */
    RQ4K1: T;

    /**
     * @default 'Date of birth and Social Security number'
     */
    tZW1H: T;

    /**
     * @default 'Home address and phone number'
     */
    j5D7u: T;

    /**
     * @default 'Bank routing and account number, or a debit card'
     */
    '1MSfp': T;

    /**
     * @default 'Your gifts stay in Joy until you transfer them.'
     */
    E4HQl: T;

    /**
     * @default 'Continue to Stripe'
     */
    LUPsK: T;

    /**
     * @default 'Not now'
     */
    '54drU': T;

    /**
     * @default 'Deposit a total of {{0}} into the {{1}} account you opened through Joy within {{2}} days of opening it to qualify for {{3}}.'
     */
    KDMQp: T;

    /**
     * @default 'Open your {{0}} account through Joy and deposit a total of {{1}} within {{2}} days of opening it to qualify for {{3}}.'
     */
    psDvi: T;

    /**
     * @default 'You can make more than one deposit. Once you qualify, Joy adds {{0}} to your cash fund balance. The reward is separate from your transfer.'
     */
    R82bv: T;

    /**
     * @default 'One reward per cash fund.'
     */
    ESC8c: T;

    /**
     * @default 'About the {{0}}'
     */
    m3xCf: T;

    /**
     * @default 'View offer terms'
     */
    oqLzj: T;

    /**
     * @default 'Got it'
     */
    D2I4z: T;

    /**
     * @default 'Your bank'
     */
    FpAVw: T;

    /**
     * @default 'Up to 7 business days.'
     */
    EdiL1: T;

    /**
     * @default 'Add your bank account with Stripe. Transfers take up to 7 business days.'
     */
    JAezu: T;

    /**
     * @default 'Apply in minutes.'
     */
    GVDtz: T;

    /**
     * @default 'Apply in minutes, get {{0}}.'
     */
    qJvJN: T;

    /**
     * @default 'Share expenses with virtual cards without combining all your finances. Open an account through Joy and deposit a total of {{0}} to qualify for {{1}} from Joy.'
     */
    xOgev: T;

    /**
     * @default 'Meet {{0}}, Joy's pick for couples.'
     */
    '4XiDu': T;

    /**
     * @default 'Amount {{0}}. Edit amount'
     */
    '4eAAk': T;

    /**
     * @default 'Edit amount'
     */
    ADiF0: T;

    /**
     * @default 'Transfer to'
     */
    Q2z9K: T;

    /**
     * @default 'New account with {{0}}'
     */
    dt4UV: T;

    /**
     * @default 'Why {{0}}'
     */
    s2OgS: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Please wait before making another transfer'
     */
    '1Vlkd': T;

    /**
     * @default 'You can transfer again at {{0}} on {{1}}.'
     */
    pEXT3: T;

    /**
     * @default 'We couldn't confirm your transfer'
     */
    m4Cgm: T;

    /**
     * @default 'We couldn't start your transfer'
     */
    ADz9A: T;

    /**
     * @default 'We couldn't confirm whether your transfer went through. Check your recent transfers before trying again. If you're unsure, contact Joy.'
     */
    icGBb: T;

    /**
     * @default 'Your balance hasn't changed. Try again, or contact Joy if you need help.'
     */
    VpCSg: T;

    /**
     * @default 'View recent transfers'
     */
    QCoBD: T;

    /**
     * @default 'Contact Joy'
     */
    EXmwr: T;

    /**
     * @default 'Loading your transfer details'
     */
    UE5rm: T;

    /**
     * @default 'Get {{0}} on us.'
     */
    rUqth: T;

    /**
     * @default 'A little extra from Joy for whatever comes next when you transfer {{0}} or more to {{1}}. Apply online in {{2}} minutes and experience a radically new way to bank.'
     */
    kwdIu: T;

    /**
     * @default 'A Mercury debit card named Honeymoon with a custom spending limit'
     */
    YlZnK: T;

    /**
     * @default 'Honeymoon'
     */
    mfnfF: T;

    /**
     * @default 'Savings account'
     */
    '8YVhD': T;

    /**
     * @default 'Future home'
     */
    aj86T: T;

    /**
     * @default 'Everyday'
     */
    bvH6g: T;

    /**
     * @default 'Checking account'
     */
    nBLlS: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Subscriptions'
     */
    '6vvWp': T;

    /**
     * @default '{{0}} offer'
     */
    OIDdl: T;

    /**
     * @default 'Your first year is on us.'
     */
    '1BFUz': T;

    /**
     * @default 'First year free through Joy, then {{0}} a year.'
     */
    pogEX: T;

    /**
     * @default 'How to qualify'
     */
    GZc5F: T;

    /**
     * @default 'Open your {{0}} account'
     */
    '22rzZ': T;

    /**
     * @default 'Use Joy's link when you apply.'
     */
    GKuok: T;

    /**
     * @default 'Deposit a total of {{0}}'
     */
    '2iKRK': T;

    /**
     * @default 'Add it within {{0}} days of opening your account, in one deposit or several.'
     */
    PhPSl: T;

    /**
     * @default 'Get {{0}} from Joy'
     */
    qKG9Y: T;

    /**
     * @default 'Once you qualify, Joy adds {{0}} to your cash fund balance. The reward is separate from your transfer.'
     */
    aADEB: T;

    /**
     * @default 'Allow about {{0}} minutes to apply. Have your photo ID, Social Security number, and U.S. address handy.'
     */
    '5NzF9': T;

    /**
     * @default 'Apply with {{0}}'
     */
    '2yyjQ': T;

    /**
     * @default '{{0}} reviews your application. Once approved, add your account in Joy to transfer your gifts.'
     */
    Q4OKD: T;

    /**
     * @default 'Offer Details'
     */
    '8eOqJ': T;

    /**
     * @default 'your {{0}} account ending {{1}}'
     */
    '6Auin': T;

    /**
     * @default 'your bank account ending {{0}}'
     */
    JUpln: T;

    /**
     * @default 'Usually within minutes, up to 24 hours.'
     */
    '6Vyhh': T;

    /**
     * @default 'Bank transfers take up to 7 business days.'
     */
    pnaES: T;

    /**
     * @default 'Deposits totaling {{0}} qualify you for {{1}} from Joy.'
     */
    '3tZOl': T;

    /**
     * @default 'is on its way to {{0}}.'
     */
    X2AyJ: T;

    /**
     * @default 'Stripe will email you when your transfer is sent. You can also check its status in Activity.'
     */
    Cz10F: T;

    /**
     * @default 'Standard'
     */
    FIpp0: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Instant'
     */
    fzaKR: T;

    /**
     * @default 'Unavailable'
     */
    MM6n8: T;

    /**
     * @default 'Instant isn't available for this transfer. Choose Standard to continue.'
     */
    T3xb7: T;

    /**
     * @default 'Timing is the same for any U.S. checking account.'
     */
    D3IUy: T;

    /**
     * @default 'Instant transfers require an eligible debit card. You can add one under Transfer to.'
     */
    el5fK: T;

    /**
     * @default 'Returned your last transfer. Check the details or replace it.'
     */
    qTOcD: T;

    /**
     * @default 'Checking'
     */
    qL0jP: T;

    /**
     * @default 'Bank account'
     */
    '5o6v7': T;

    /**
     * @default '{{0}} account'
     */
    vpgAp: T;

    /**
     * @default 'New account. Deposit a total of {{0}} to qualify for {{1}} from Joy.'
     */
    pIa8V: T;

    /**
     * @default 'Add a bank account'
     */
    x9PS3: T;

    /**
     * @default 'Another bank account or a debit card'
     */
    '0lTvE': T;

    /**
     * @default 'Takes about 5 minutes on Stripe'
     */
    '5ASS7': T;

    /**
     * @default 'Send {{0}} or more to get the {{1}} from Joy'
     */
    Lvd1n: T;

    /**
     * @default 'Deposits totaling {{0}} qualify you for {{1}} from Joy'
     */
    JDaFd: T;

    /**
     * @default 'Plus {{0}} from Joy'
     */
    clwLf: T;

    /**
     * @default 'Amount {{0}}. {{1}}. Edit amount'
     */
    ZptwB: T;

    /**
     * @default 'Amount {{0}}, plus {{1}} from Joy. Edit amount'
     */
    lxCtD: T;

    /**
     * @default 'Stripe needs a little more information before you can transfer.'
     */
    '7wIhR': T;

    /**
     * @default 'Stripe is reviewing your information. You can transfer once it's approved.'
     */
    VIQK9: T;

    /**
     * @default 'Transfers are unavailable. Contact Joy and we'll help you with the next step.'
     */
    kXBGz: T;

    /**
     * @default 'Add your {{0}} account'
     */
    xgjny: T;

    /**
     * @default 'Once your account is approved, add it here to transfer your gifts.'
     */
    qeq6B: T;

    /**
     * @default 'Continue with {{0}}'
     */
    Bckfq: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'New {{0}} account'
     */
    HQ65B: T;

    /**
     * @default 'Not added yet'
     */
    dyjEV: T;

    /**
     * @default 'Arrives'
     */
    yzQwh: T;

    /**
     * @default '{{0}} fee'
     */
    '88R5Z': T;

    /**
     * @default 'How it works'
     */
    f7Woo: T;

    /**
     * @default 'Open a {{0}} account through Joy's link. It takes about {{1}} minutes.'
     */
    vbhYB: T;

    /**
     * @default 'Once it's open, come back and add it here.'
     */
    kPNad: T;

    /**
     * @default 'Deposit a total of {{0}} within {{1}} days of opening it to qualify for {{2}} from Joy.'
     */
    '0UExM': T;

    /**
     * @default 'Learn more'
     */
    tks4L: T;

    /**
     * @default 'Continue with Stripe'
     */
    QqHyJ: T;

    /**
     * @default 'Transfer'
     */
    hkBzA: T;

    /**
     * @default 'Use a different bank'
     */
    rn1uA: T;

    /**
     * @default 'Transfers are processed securely by Stripe.'
     */
    OXtQD: T;
  };
};

export type CatalogRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  addProduct: {
    /**
     * @default 'Add to Registry'
     */
    addToRegistry: T;

    /**
     * @default 'Add to Cart'
     */
    addToCart: T;

    /**
     * @default 'The item was added to your registry!'
     */
    notificationText: T;

    /**
     * @default 'Added to Registry'
     */
    addedToRegistry: T;

    /**
     * @default 'Edit Gift...'
     */
    editGift: T;
  };
  sidebarNav: {
    /**
     * @default 'Shop All {{categoryName}}'
     */
    showAll: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Shop'
     */
    shop: T;

    /**
     * @default 'Departments'
     */
    departmentTitle: T;
  };
  productDetailPage: {
    /**
     * @default 'Sold by'
     */
    soldBy: T;

    /**
     * @default 'Fulfilled by'
     */
    fulfilledBy: T;

    /**
     * @default 'Exclusively with Joy'
     */
    joyExclusive: T;

    /**
     * @default 'Buy Now'
     */
    buyNow: T;

    /**
     * @default 'Quantity'
     */
    quantity: T;

    /**
     * @default 'Why We Love It'
     */
    whyWeLoveIt: T;

    /**
     * @default 'Specs'
     */
    specs: T;

    /**
     * @default 'Description'
     */
    description: T;

    /**
     * @default 'Return to {{title}}'
     */
    returnTo: T;

    /**
     * @default 'Please select a {{label}}'
     */
    pleaseSelect: T;

    /**
     * @default 'View Details'
     */
    viewDetails: T;

    /**
     * @default 'Quick Add'
     */
    quickAddToRegistry: T;

    /**
     * @default 'Coming Soon'
     */
    comingSoonItemTitle: T;

    /**
     * @default 'This item will be available on Joy soon. You can add to your registry now.'
     */
    comingSoonItemNote: T;

    /**
     * @default 'No longer available'
     */
    discontinuedItemTitle: T;

    /**
     * @default 'This item is no longer available in our catalog.'
     */
    discontinuedItemNote: T;

    /**
     * @default 'Back in Stock Soon'
     */
    backorderedItemTitle: T;

    /**
     * @default 'This item is temporarily out of stock. We're expecting it to be back soon. You can still add it to your registry.'
     */
    backorderedItemNote: T;

    /**
     * @default 'Or'
     */
    buttonsDividerText: T;
  };
  emptyCategoryContent: {
    /**
     * @default 'We're stocking our shelves'
     */
    title: T;

    /**
     * @default 'In the meantime, you can add gifts from any online store to your registry using the Joy App'
     */
    subtitle: T;

    /**
     * @default 'Add Gifts'
     */
    iosButton: T;
  };
  babyCatalogEmptyStateContent: {
    /**
     * @default 'Coming Soon!'
     */
    title: T;

    /**
     * @default 'We're working on bringing the best collection of <b>{{selectedCategory}}</b> for you.'
     */
    subtitle: T;
  };
  cashFundCatalog: {
    /**
     * @default 'Edit and Add'
     */
    editAndAdd: T;

    /**
     * @default '{{title}} added'
     */
    fundAddedTitle: T;

    /**
     * @default 'You'll be notified when friends and family start contributing!'
     */
    fundSuccessSubtitle: T;

    /**
     * @default 'Create Your Own {{fund}}'
     */
    createYourOwn: T;

    /**
     * @default 'You May Also Like'
     */
    collectionMembersTitle: T;

    /**
     * @default 'View Registry'
     */
    viewRegistry: T;
  };
  seo: {
    wedding: {
      /**
       * @default 'Shop | Joy | The All-In-One Wedding Registry'
       */
      shopIndexTitle: T;

      /**
       * @default 'Shop on Joy to create the best all-in-one wedding registry experience from hundreds of brands across kitchen, tabletop, bed & bath, home, travel, cash funds, charities, experiences and more.'
       */
      shopIndexDescription: T;

      /**
       * @default '{{category}} | Joy'
       */
      shopCategoryTitle: T;

      /**
       * @default 'Shop from {{category}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCategoryDescription: T;

      /**
       * @default 'Curations | Joy | The All-In-One Wedding Registry'
       */
      shopCurationIndexTitle: T;

      /**
       * @default 'Shop from Joy Curations created by our team of registry experts to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationIndexDescription: T;

      /**
       * @default '{{curation}} | Joy'
       */
      shopCurationDetailsTitle: T;

      /**
       * @default 'Shop from {{curation}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationDetailsDescription: T;

      /**
       * @default 'Brands | Joy'
       */
      shopBrandIndexTitle: T;

      /**
       * @default 'Shop from Brands on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandIndexDescription: T;

      /**
       * @default ' {{brand}} | Joy'
       */
      shopBrandDetailsTitle: T;

      /**
       * @default 'Shop {{brand}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandDetailsDescription: T;
    };
    baby: {
      /**
       * @default 'Baby Shop | Joy | The Universal Baby Registry'
       */
      shopIndexTitle: T;

      /**
       * @default 'Shop on Joy to add everything for you and your new bundle of Joy from  hundreds of brands across clothing, strollers & car seats, travel & gear, feeding & nursing, nursery, health & safety, bath & potty, toys & activity, and cash funds.'
       */
      shopIndexDescription: T;

      /**
       * @default '{{category}} | Joy'
       */
      shopCategoryTitle: T;

      /**
       * @default 'Shop from {{category}} on Joy to build a complete baby registry for you and your new bundle of Joy'
       */
      shopCategoryDescription: T;

      /**
       * @default 'Curations | Joy | The Universal Baby Registry'
       */
      shopCurationIndexTitle: T;

      /**
       * @default 'Shop from Joy Curations created by our team of baby registry experts to build the complete registry for your new bundle of Joy.'
       */
      shopCurationIndexDescription: T;

      /**
       * @default '{{curation}} | Joy'
       */
      shopCurationDetailsTitle: T;

      /**
       * @default 'Shop from {{curation}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationDetailsDescription: T;

      /**
       * @default 'Brands | Joy'
       */
      shopBrandIndexTitle: T;

      /**
       * @default 'Shop from Brands on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandIndexDescription: T;

      /**
       * @default '{{brand}} | Joy'
       */
      shopBrandDetailsTitle: T;

      /**
       * @default 'Shop {{brand}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandDetailsDescription: T;
    };
  };
  currencyWarningDialog: {
    /**
     * @default 'Delivery for these items is not available outside the United States.'
     */
    title: T;

    /**
     * @default 'Instead add items from stores that can ship to you in two easy ways:'
     */
    subtitle: T;

    /**
     * @default 'Instead add items from stores that can ship to you via the Joy App.'
     */
    mobileSubtitle: T;

    /**
     * @default 'Add items to your registry from other retailers'
     */
    ctaOne: T;

    /**
     * @default 'Install Browser Button'
     */
    ctaOneButton: T;

    /**
     * @default 'Paste a link to an item and fill out the details'
     */
    ctaTwo: T;

    /**
     * @default 'Add Item Manually'
     */
    ctaTwoButton: T;

    /**
     * @default 'Get the App'
     */
    mobileButton: T;

    /**
     * @default 'Dismiss'
     */
    dismiss: T;

    /**
     * @default 'Add Item Anyway'
     */
    addAnyway: T;
  };
  refinementsPanel: {
    /**
     * @default 'Refine'
     */
    refineFilters: T;

    /**
     * @default 'Clear All'
     */
    clearAll: T;

    clearAllFilters: {
      /**
       * @default 'Clear {{count}} filter'
       */
      messageWithCountOne: T;

      /**
       * @default 'Clear {{count}} filters'
       */
      messageWithCountMoreThanOne: T;
    };

    /**
     * @default 'Filter'
     */
    filter: T;

    /**
     * @default 'Filters'
     */
    filters: T;

    /**
     * @default 'Hide Filter'
     */
    hideFilter: T;

    /**
     * @default 'Hide Filters'
     */
    hideFilters: T;

    /**
     * @default 'Price: >${{minValue}}'
     */
    priceGraterThan: T;

    /**
     * @default 'Price: <=${{maxValue}}'
     */
    priceLowerThan: T;

    /**
     * @default 'Price: ${{minValue}} - ${{maxValue}}'
     */
    priceRange: T;

    /**
     * @default 'Price: '
     */
    pricePrefix: T;

    /**
     * @default '${{maxValue}} or less'
     */
    priceAndLess: T;

    /**
     * @default '${{minValue}} or more'
     */
    priceAndMore: T;

    /**
     * @default '${{minValue}} - ${{maxValue}}'
     */
    priceBucketRange: T;

    /**
     * @default 'Custom'
     */
    custom: T;

    /**
     * @default 'Show Filter'
     */
    showFilter: T;

    /**
     * @default 'Show Filters'
     */
    showFilters: T;

    /**
     * @default 'Sort'
     */
    sort: T;

    sortByPriceOptions: {
      /**
       * @default 'Recommended'
       */
      featured: T;

      /**
       * @default 'Price: Low to High'
       */
      priceAsc: T;

      /**
       * @default 'Price: High to Low'
       */
      priceDesc: T;
    };
  };
  searchBar: {
    /**
     * @default 'Search brands, products, and more'
     */
    searchInputPlaceholder: T;

    /**
     * @default 'Search'
     */
    searchInputPlaceholderMobile: T;

    /**
     * @default 'Couples are searching for…'
     */
    coupleTrendsTitle: T;

    /**
     * @default '{{quantity}} in the last hour'
     */
    lastHour: T;
  };
  searchHeader: {
    /**
     * @default 'Searching for...'
     */
    titleSearching: T;

    /**
     * @default 'Showing results for'
     */
    titleShowResult: T;

    /**
     * @default 'Item{{plural}} Found'
     */
    subTitle: T;

    /**
     * @default 'No items were found matching'
     */
    subTitleNoItemsFound: T;

    /**
     * @default '{{count}} item{{pluralization}} for “{{searchTerm}}”'
     */
    itemsFoundV2: T;

    breadcrumbs: {
      /**
       * @default 'Shop'
       */
      root: T;

      /**
       * @default 'Search Results'
       */
      current: T;
    };
    noSearchResults: {
      /**
       * @default 'Add From Any Store'
       */
      hed: T;

      /**
       * @default 'You can add top items from any store'
       */
      dek: T;
    };
  };
  searchResult: {
    /**
     * @default 'Modify your search'
     */
    modifySearchButtonText: T;

    /**
     * @default 'Or'
     */
    modifySearchText: T;

    modifySearchExplore: {
      /**
       * @default 'Explore Popular Couple Picks'
       */
      wedding: T;

      /**
       * @default 'Explore Popular Picks For Your Baby'
       */
      baby: T;
    };
  };
  curationList: {
    /**
     * @default 'Top Curations'
     */
    title: T;

    /**
     * @default 'Browse All'
     */
    cta: T;

    /**
     * @default 'Explore More Curations'
     */
    title2: T;

    /**
     * @default 'See All Curations'
     */
    cta2: T;

    /**
     * @default 'Show All {{total}}'
     */
    cta3: T;
  };
  categoryRecommendationsCarousel: {
    /**
     * @default 'Explore {{title}}'
     */
    explore: T;

    /**
     * @default 'Show All {{length}}'
     */
    showAll: T;

    /**
     * @default 'Explore {{title}} Top Picks'
     */
    explorePopularStores: T;
  };
  curationHeroHeader: {
    billboard: {
      /**
       * @default 'Shop the Curation'
       */
      exploreButton: T;

      /**
       * @default 'Watch the Video'
       */
      watchButton: T;

      /**
       * @default 'Shop {{brandName}}'
       */
      shopButton: T;
    };
  };
  curationHero: {
    /**
     * @default 'Read more'
     */
    readMore: T;

    /**
     * @default 'less'
     */
    less: T;
  };
  browseCategoryBanner: {
    /**
     * @default 'Browse All Gifts'
     */
    browseButton: T;

    /**
     * @default 'Interested in more gifts from {{categoryTitle}}?'
     */
    bannerText: T;
  };
  recommendedProductsSection: {
    wedding: {
      /**
       * @default 'Your Personalized Picks'
       */
      sectionTitle: T;
    };
    baby: {
      /**
       * @default 'Baby Registry Essentials'
       */
      sectionTitle: T;
    };
  };
  brandPage: {
    /**
     * @default 'Show more'
     */
    showMore: T;

    /**
     * @default 'Less'
     */
    less: T;
  };
  productTile: {
    /**
     * @default '{{lowerBound}} - {{upperBound}}'
     */
    priceRange: T;
  };
  brandsMarquee: {
    /**
     * @default 'Over 10,000+ items from all the best brands'
     */
    weddingTitle: T;

    /**
     * @default 'Top items from all the best brands'
     */
    babyRegistryTitle: T;

    /**
     * @default 'Shop Your Favorite Brands'
     */
    titleOverview: T;
  };
  curationsSection: {
    /**
     * @default 'View'
     */
    button: T;

    /**
     * @default 'Explore'
     */
    explore: T;

    /**
     * @default 'Gift Inspo '
     */
    titleR1: T;

    /**
     * @default 'From the Experts'
     */
    titleR2: T;

    /**
     * @default 'Registry recommendations you'll love (and why you need them).'
     */
    subtitle: T;
  };
  categoryPage: {
    /**
     * @default 'Browse'
     */
    buttonHover: T;
  };
  productGrid: {
    /**
     * @default 'Explore All Products'
     */
    exploreAllProducts: T;

    /**
     * @default 'Explore all {{categoryTitle}}'
     */
    exploreAllCategory: T;

    /**
     * @default 'Top {{title}} Gifts Added <br />by Joy Couples'
     */
    popularCategory: T;

    /**
     * @default 'Explore More {{parentTitle}}'
     */
    exploreMore: T;

    /**
     * @default 'Explore More'
     */
    exploreMoreTitle: T;
  };
  storefrontNavigator: {
    /**
     * @default 'New'
     */
    badgeNew: T;

    /**
     * @default 'Joy Wedding'
     */
    labelStorefrontWedding: T;

    /**
     * @default 'Joy Baby'
     */
    labelStorefrontBaby: T;
  };
  departmentNavSection: {
    /**
     * @default 'Browse by Department'
     */
    title: T;

    /**
     * @default 'Explore {{categoryTitle}}'
     */
    exploreCategory: T;
  };
  valuePropsTopBar: {
    wedding: {
      shipping: {
        /**
         * @default 'Free Shipping'
         */
        title: T;
      };
      completionDiscount: {
        /**
         * @default 'Registry Completion Discount'
         */
        title: T;
      };
      priceMatchPromise: {
        /**
         * @default 'Price Match Promise'
         */
        title: T;
      };
      easyReturns: {
        /**
         * @default 'Easy Returns'
         */
        title: T;
      };
    };
    baby: {
      shipping: {
        /**
         * @default 'Free Shipping'
         */
        title: T;
      };
      completionDiscount: {
        /**
         * @default '20% Completion Discount'
         */
        title: T;
      };
      priceMatchPromise: {
        /**
         * @default 'Price Match Promise'
         */
        title: T;
      };
      easyReturns: {
        /**
         * @default 'Easy Returns'
         */
        title: T;
      };
    };
  };
  valuePropsSection: {
    /**
     * @default 'Every Joy Registry Deserves'
     */
    title: T;

    /**
     * @default 'Perks of Registering with Joy'
     */
    titleOverview: T;

    /**
     * @default 'Free Shipping over ${{price}}'
     */
    freeShipping: T;

    /**
     * @default 'Delay Shipping If You Need It'
     */
    delayShipping: T;

    /**
     * @default 'AI-Assisted Thank You Notes'
     */
    thankYouNotes: T;

    /**
     * @default '20% Completion Discount'
     */
    postWeddingDiscount: T;

    /**
     * @default '20% Completion Discount'
     */
    completionDiscountBaby: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    zeroFeeCashFunds: T;

    /**
     * @default 'Universal Registry'
     */
    universalRegistry: T;

    /**
     * @default 'Price Match Promise'
     */
    priceMatchPromise: T;

    /**
     * @default 'Easy Returns'
     */
    easyReturns: T;
  };
  productRating: {
    /**
     * @default ''
     */
    noLabel: T;

    /**
     * @default '{{averageRating}}'
     */
    averageRating: T;

    /**
     * @default '{{averageRating}} ({{totalReviewCount}} Reviews)'
     */
    averageRatingWithCount: T;

    /**
     * @default '{{averageRating}} ({{totalReviewCount}})'
     */
    averageRatingWithCountShort: T;

    /**
     * @default '({{totalReviewCount}} Reviews)'
     */
    totalReviewCount: T;

    /**
     * @default '({{totalReviewCount}})'
     */
    totalReviewCountShort: T;
  };
  catalogItemCustomerReviewsSection: {
    wedding: {
      /**
       * @default 'Ratings & Reviews'
       */
      sectionTitle: T;
    };
    baby: {
      /**
       * @default 'Ratings & Reviews'
       */
      sectionTitle: T;
    };
    statsSummary: {
      /**
       * @default '{{reviewCount}} Reviews'
       */
      totalReviewCount: T;
    };
    reviewList: {
      /**
       * @default 'Reviews'
       */
      header: T;

      /**
       * @default 'Show More'
       */
      showMoreButton: T;

      /**
       * @default 'Anonymous'
       */
      unknownReviewAuthor: T;

      /**
       * @default 'Originally posted on {{source}}'
       */
      syndicationSourceNotice: T;
    };
  };
  universalSearch: {
    productgrid: {
      /**
       * @default 'Add From Anywhere'
       */
      sectionHed: T;

      /**
       * @default 'Explore top items from other shops.'
       */
      sectionDek: T;

      productTile: {
        /**
         * @default 'View Product'
         */
        viewProductCta: T;

        /**
         * @default 'Create Registry'
         */
        createRegistryCta: T;
      };
    };
    pdpModal: {
      formFields: {
        price: {
          /**
           * @default 'Price'
           */
          label: T;

          /**
           * @default 'Missing a price'
           */
          error: T;
        };
        title: {
          /**
           * @default 'Title'
           */
          label: T;

          /**
           * @default 'Missing a title'
           */
          error: T;
        };
        quantity: {
          /**
           * @default 'Quantity'
           */
          label: T;
        };
        note: {
          /**
           * @default 'Note'
           */
          label: T;

          /**
           * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it — have fun with it.'
           */
          placeholder: T;
        };
      };

      /**
       * @default 'View on {{shopName}}'
       */
      viewShopOnLink: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Add to Registry'
       */
      addCta: T;
    };

    /**
     * @default 'This product cannot be loaded at the moment. Please try again later.'
     */
    getProductByIdError: T;

    /**
     * @default 'This product cannot be added to the registry at the moment. Please try again later.'
     */
    addProductToRegistryError: T;
  };
  brands: {
    /**
     * @default 'Our Brands'
     */
    ourBrands: T;

    /**
     * @default 'Shop by'
     */
    shopBy: T;

    /**
     * @default 'Filter'
     */
    filter: T;

    /**
     * @default 'Clear All'
     */
    clearAll: T;

    /**
     * @default 'Confirm'
     */
    confirm: T;

    /**
     * @default 'All Brands'
     */
    allBrands: T;

    /**
     * @default 'Brands'
     */
    brands: T;
  };
  recentlyAddedRegistryItemUpdateDrawer: {
    /**
     * @default 'Added to your registry!'
     */
    drawerTitle: T;

    /**
     * @default 'You can also mark this gift as:'
     */
    updateSectionHeader: T;

    /**
     * @default 'Your change has been saved.'
     */
    updateConfirmationMessage: T;

    markAsMostWantedToggle: {
      /**
       * @default 'Our Most Wanted'
       */
      label: T;

      /**
       * @default 'Let your guests know your must-have gifts!'
       */
      tooltipMessage: T;
    };

    /**
     * @default 'Mark Gift as Most Wanted'
     */
    updateCtaMessage: T;

    /**
     * @default 'Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Remove from Most Wanted'
     */
    removeFromMostWanted: T;

    /**
     * @default 'Adding item to registry...'
     */
    loadingMessage: T;
  };
  salesPrice: {
    /**
     * @default 'Sale'
     */
    message: T;
  };
  doYouHaveRegistry: {
    /**
     * @default 'Quick Question'
     */
    eyebrow: T;

    /**
     * @default 'Do you already have
a registry somewhere else?'
*/
    question: T;

    /**
     * @default 'Yes'
     */
    yes: T;

    /**
     * @default 'No'
     */
    no: T;
  };
  quick: {
    /**
     * @default 'Your event is outside the US, where the Joy store isn't available yet. You can still add cash funds, and gifts from any other store.'
     */
    iz0zC: T;

    /**
     * @default 'Joy store gifts only ship to US addresses. You can still add cash funds, and gifts from any other store.'
     */
    B8xO0: T;

    /**
     * @default 'Shop'
     */
    yYANA: T;

    /**
     * @default 'Temporarily Out of Stock'
     */
    HrCwH: T;

    /**
     * @default 'This item is temporarily out of stock. Since you control when you ship, we'll let your guest purchase for now. You can also hide or replace this gift with something else.'
     */
    wAlr2: T;

    /**
     * @default 'Min'
     */
    IuWAA: T;

    /**
     * @default 'Max'
     */
    CqWAA: T;

    /**
     * @default 'View Item on Registry'
     */
    wU8bu: T;

    /**
     * @default 'It looks like you're shopping from {{0}}'
     */
    nNxY5: T;

    /**
     * @default 'It looks like you're shopping from outside the US'
     */
    ldNTq: T;

    /**
     * @default 'If so, we'll take you to the gift list experience for your region.'
     */
    WNWsY: T;

    /**
     * @default 'Region & language'
     */
    s9dDA: T;

    /**
     * @default 'Continue to gift list'
     */
    '6G4wG': T;

    /**
     * @default 'Explore Cash Funds'
     */
    '2sQ0u': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Unavailable'
     */
    MM6n8: T;

    /**
     * @default 'Joy only ships this gift within the United States.'
     */
    mZYFT: T;

    /**
     * @default 'Most Recent'
     */
    '8GlIq': T;

    /**
     * @default 'Highest Rating'
     */
    v7iUL: T;

    /**
     * @default 'Lowest Rating'
     */
    '9Pjts': T;

    /**
     * @default 'Edit and Add'
     */
    GaAMJ: T;

    /**
     * @default 'Price'
     */
    '7WvrG': T;

    /**
     * @default 'AI summary of 1 review'
     * @param {number} count - The number of occurrences.
     * - singular: AI summary of 1 review
     * - plural: AI summary of {{0}} reviews
     */
    mgF1x: T;

    /**
     * @default '+1 more theme'
     * @param {number} count - The number of occurrences.
     * - singular: +1 more theme
     * - plural: +{{0}} more themes
     */
    obv33: T;

    /**
     * @default 'This summary was generated by AI from verified customer reviews of this product. It may not reflect every reviewer's experience.'
     */
    anj8w: T;

    /**
     * @default 'About AI-generated summaries'
     */
    HsgbK: T;

    /**
     * @default '{{0}} of 1 review'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} of 1 review
     * - plural: {{0}} of {{1}} reviews
     */
    xdB1I: T;

    /**
     * @default 'Show 1 more topic'
     * @param {number} count - The number of occurrences.
     * - singular: Show 1 more topic
     * - plural: Show {{0}} more topics
     */
    '6i7LQ': T;

    /**
     * @default 'What reviewers talk about'
     */
    Da8dy: T;

    /**
     * @default 'Select a topic to read those reviews'
     */
    NdxqA: T;

    /**
     * @default '1 star'
     * @param {number} count - The number of occurrences.
     * - singular: 1 star
     * - plural: {{0}} stars
     */
    SZOo2: T;

    /**
     * @default 'Rating breakdown'
     */
    CIWFK: T;
  };
};

export type CheckInAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Checked in'
     */
    OGtlr: T;

    /**
     * @default 'Already checked in'
     */
    oSRTz: T;

    /**
     * @default 'Invalid or unrecognised QR code'
     */
    kGBSu: T;

    /**
     * @default 'Ticket not found'
     */
    '52hSB': T;

    /**
     * @default 'Ticket is cancelled and cannot be checked in'
     */
    MZHEk: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Camera access is required to scan tickets. Please allow camera access in your browser settings.'
     */
    '20fJU': T;

    /**
     * @default 'QR code scanner'
     */
    IaN80: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Check In'
     */
    '3LfjP': T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Your event'
     */
    NQLJS: T;

    /**
     * @default 'Point your camera at a guest's ticket QR code. We'll confirm their ticket and check them in. You can also open the attendee list to search or check someone in manually.'
     */
    KRTOY: T;

    /**
     * @default 'Scanner'
     */
    iupky: T;

    /**
     * @default 'Attendee list'
     */
    cDA2U: T;

    /**
     * @default 'Attendees'
     */
    '5OebK': T;

    /**
     * @default 'Search by name, email, or ticket number'
     */
    EemQQ: T;

    /**
     * @default 'Search attendees'
     */
    Rtb0b: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'No matching tickets.'
     */
    nlwKU: T;

    /**
     * @default 'Not checked in'
     */
    HmHd2: T;

    /**
     * @default 'Cancelled'
     */
    JVlxD: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Check in guest'
     */
    vFec2: T;

    /**
     * @default 'Ticket'
     */
    OzvyX: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Valid'
     */
    qZEJH: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'All'
     */
    '5WTAA': T;

    /**
     * @default 'Start camera'
     */
    xrTOc: T;

    /**
     * @default 'Refresh camera'
     */
    qJ0Oo: T;

    /**
     * @default 'Searching {{0}} loaded attendees — scroll to load more.'
     */
    '18HBF': T;

    /**
     * @default 'Camera access was blocked. Open your browser's site settings to allow camera access, then try again.'
     */
    A9DEK: T;

    /**
     * @default 'Unavailable'
     */
    MM6n8: T;

    /**
     * @default 'Not eligible'
     */
    GI0La: T;

    /**
     * @default 'This order isn't eligible for check-in'
     */
    JHpGt: T;
  };
};

export type ChecklistTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Verify your email'
     */
    ggVTZ: T;

    /**
     * @default 'Check wedding location'
     */
    VCiyJ: T;

    /**
     * @default 'Set ceremony date'
     */
    oyWOK: T;

    /**
     * @default 'Add countdown'
     */
    WANcW: T;

    /**
     * @default 'Check password and privacy'
     */
    ofmoq: T;

    /**
     * @default 'Upload and manage photos'
     */
    aUtxE: T;

    /**
     * @default 'Design your website'
     */
    gIVb3: T;

    /**
     * @default 'Avoid repeated guest questions'
     */
    C9mi0: T;

    /**
     * @default 'Finalize your event schedule'
     */
    ifDsm: T;

    /**
     * @default 'Upload video'
     */
    KPGfD: T;

    /**
     * @default 'Set your Joy URL'
     */
    CTVYt: T;

    /**
     * @default 'Set up privacy options'
     */
    ZVlt4: T;

    /**
     * @default 'Toggle pages'
     */
    k3DIJ: T;

    /**
     * @default 'Invite partner or friend to help'
     */
    WpXoZ: T;

    /**
     * @default 'Collect guest information'
     */
    aVdAX: T;

    /**
     * @default 'Upload contacts'
     */
    irKYX: T;

    /**
     * @default 'Design paper cards'
     */
    X4oVm: T;

    /**
     * @default 'Design and send digital cards'
     */
    '6ESfe': T;

    /**
     * @default 'Add gifts to your registry'
     */
    VmmUN: T;

    /**
     * @default 'Add cash funds'
     */
    CjZzO: T;

    /**
     * @default 'Order gifts from your registry'
     */
    P5k9j: T;

    /**
     * @default 'Set photo update note'
     */
    PAWdt: T;

    /**
     * @default 'Set shipping address'
     */
    qXys3: T;

    /**
     * @default 'Install Joy button'
     */
    bb0Og: T;

    /**
     * @default 'Connect another registry'
     */
    QyqmZ: T;

    /**
     * @default 'Try auto thank you notes'
     */
    uTV1Q: T;

    /**
     * @default 'Apply post-wedding discount'
     */
    CJpKQ: T;

    /**
     * @default 'Save on Hertz car rentals'
     */
    '2zojR': T;

    /**
     * @default 'Save on hotel bookings'
     */
    iZRuO: T;

    /**
     * @default 'Give guests travel tips'
     */
    CPCJ1: T;

    /**
     * @default 'Set up ground transportation'
     */
    Eslvc: T;

    /**
     * @default 'Chat with concierge'
     */
    FluRO: T;

    /**
     * @default 'Organize your guest list'
     */
    CI0Ou: T;

    /**
     * @default 'Finalize your guest list'
     */
    nNIHd: T;

    /**
     * @default 'Set up RSVP questions'
     */
    pVeWQ: T;

    /**
     * @default 'Use tags for RSVP questions'
     */
    XFDMS: T;

    /**
     * @default 'Finalize details'
     */
    IA0ul: T;

    /**
     * @default 'Edit accommodations'
     */
    JXzoR: T;

    /**
     * @default 'Edit travel tips'
     */
    AkNdZ: T;

    /**
     * @default 'Remind guests'
     */
    yIYVg: T;

    /**
     * @default 'Add Places to Stay'
     */
    dOTDN: T;
  };
};

export type CollaborationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'This invite is invalid or has expired.'
     */
    kRjbZ: T;

    /**
     * @default 'Please contact the event organizer for a new invitation.'
     */
    xnDAB: T;

    /**
     * @default 'You've been invited to become a collaborator.'
     */
    tyxin: T;

    /**
     * @default 'Join as {{0}}'
     */
    g6WMa: T;

    /**
     * @default 'Sign out and use another account'
     */
    ZpUuS: T;

    /**
     * @default 'Go back to event'
     */
    '8U60b': T;

    /**
     * @default 'Log In or Create Account'
     */
    z21SR: T;

    /**
     * @default 'Error accepting invite. Please contact customer support.'
     */
    GP67i: T;
  };
};

export type ColorsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Pick any color from your photo or anywhere to apply it.'
     */
    BxfRy: T;

    /**
     * @default 'Pick color from screen'
     */
    MtQFT: T;

    /**
     * @default 'Open color picker'
     */
    tPo8a: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;
  };
};

export type ComboboxTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} selected'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} selected
     * - plural: {{0}} selected
     */
    ohVrd: T;

    /**
     * @default 'Select...'
     */
    S8Eo2: T;

    /**
     * @default 'No results found'
     */
    Py80B: T;

    /**
     * @default 'Search...'
     */
    SJKn9: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Searching…'
     */
    eghpU: T;

    /**
     * @default 'Suggestions'
     */
    JzeyJ: T;
  };
};

export type CommandPaletteAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Cards & Messaging'
     */
    rdIA0: T;

    /**
     * @default 'Guest List & RSVP'
     */
    fjraK: T;

    /**
     * @default 'Quick Actions'
     */
    MTwDG: T;

    /**
     * @default 'Command menu'
     */
    EgY6M: T;

    /**
     * @default 'Search pages and actions…'
     */
    kkVUU: T;

    /**
     * @default 'No results found.'
     */
    zB62V: T;

    /**
     * @default 'Search pages and actions'
     */
    O0lKY: T;

    /**
     * @default 'schedule'
     */
    V8KVv: T;

    /**
     * @default 'agenda'
     */
    CF0F6: T;

    /**
     * @default 'timeline'
     */
    tVRQr: T;

    /**
     * @default 'itinerary'
     */
    RfRkC: T;

    /**
     * @default 'ceremony'
     */
    Yfu8Z: T;

    /**
     * @default 'travel'
     */
    WKV7Z: T;

    /**
     * @default 'transportation'
     */
    g4esk: T;

    /**
     * @default 'directions'
     */
    KzmXt: T;

    /**
     * @default 'getting there'
     */
    GuKhc: T;

    /**
     * @default 'where to stay'
     */
    '3SfgZ': T;

    /**
     * @default 'hotel'
     */
    ouwmI: T;

    /**
     * @default 'lodging'
     */
    MKvSE: T;

    /**
     * @default 'accommodations'
     */
    L711p: T;

    /**
     * @default 'rooms'
     */
    wggaJ: T;

    /**
     * @default 'stay'
     */
    Z02RA: T;

    /**
     * @default 'guest q&a'
     */
    MKqmX: T;

    /**
     * @default 'faq'
     */
    CvdAA: T;

    /**
     * @default 'questions'
     */
    nuCZm: T;

    /**
     * @default 'help'
     */
    t0JQA: T;

    /**
     * @default 'q&a'
     */
    kWgAA: T;

    /**
     * @default 'wedding party'
     */
    Gw9lM: T;

    /**
     * @default 'bridesmaids'
     */
    bwvis: T;

    /**
     * @default 'groomsmen'
     */
    '3C35T': T;

    /**
     * @default 'bridal party'
     */
    '0POSe': T;

    /**
     * @default 'story & tidbits'
     */
    Uf18n: T;

    /**
     * @default 'our story'
     */
    X0aiZ: T;

    /**
     * @default 'about us'
     */
    fWESJ: T;

    /**
     * @default 'how we met'
     */
    '4sIG8': T;

    /**
     * @default 'rsvp'
     */
    PYtRA: T;

    /**
     * @default 'respond'
     */
    fuCcF: T;

    /**
     * @default 'attendance'
     */
    HA0IQ: T;

    /**
     * @default 'reply'
     */
    mTBZJ: T;

    /**
     * @default 'confirm'
     */
    wNSec: T;

    /**
     * @default 'guest list'
     */
    '4eKQC': T;

    /**
     * @default 'guests'
     */
    XOwGN: T;

    /**
     * @default 'attendees'
     */
    '9g2vG': T;

    /**
     * @default 'invitees'
     */
    fuVWY: T;

    /**
     * @default 'photos'
     */
    zz0kO: T;

    /**
     * @default 'gallery'
     */
    yjhMy: T;

    /**
     * @default 'pictures'
     */
    bycpt: T;

    /**
     * @default 'images'
     */
    EBtuR: T;

    /**
     * @default 'design'
     */
    WQl4D: T;

    /**
     * @default 'theme'
     */
    BRXjJ: T;

    /**
     * @default 'template'
     */
    sSXhG: T;

    /**
     * @default 'layout'
     */
    IvpcD: T;

    /**
     * @default 'style'
     */
    jlSgJ: T;

    /**
     * @default 'overview'
     */
    TQJwu: T;

    /**
     * @default 'home'
     */
    tqMQA: T;

    /**
     * @default 'main'
     */
    '9a3QA': T;

    /**
     * @default 'dashboard'
     */
    s2EZW: T;

    /**
     * @default 'save the dates'
     */
    palDh: T;

    /**
     * @default 'save the date'
     */
    eE03Y: T;

    /**
     * @default 'std'
     */
    RlhAA: T;

    /**
     * @default 'invitations'
     */
    SPNYh: T;

    /**
     * @default 'invite'
     */
    '5h22R': T;

    /**
     * @default 'stationery'
     */
    odHVR: T;

    /**
     * @default 'paper'
     */
    uzcOJ: T;

    /**
     * @default 'thank you'
     */
    dBULK: T;

    /**
     * @default 'thanks'
     */
    jzhJZ: T;

    /**
     * @default 'thank you cards'
     */
    oyD24: T;

    /**
     * @default 'preview'
     */
    '8l0SJ': T;

    /**
     * @default 'view'
     */
    LyRSA: T;

    /**
     * @default 'website'
     */
    '3sVGF': T;

    /**
     * @default 'live site'
     */
    tcOxI: T;

    /**
     * @default 'settings'
     */
    pogda: T;

    /**
     * @default 'preferences'
     */
    u6Ipy: T;

    /**
     * @default 'configuration'
     */
    '0eWn6': T;

    /**
     * @default 'setup'
     */
    RCBeJ: T;

    /**
     * @default 'share'
     */
    ppXeJ: T;

    /**
     * @default 'link'
     */
    eYwQA: T;

    /**
     * @default 'url'
     */
    dJiAA: T;

    /**
     * @default 'send'
     */
    gryRA: T;

    /**
     * @default 'video'
     */
    fSdtJ: T;

    /**
     * @default 'film'
     */
    qR2PA: T;

    /**
     * @default 'recording'
     */
    BkfF1: T;

    /**
     * @default 'clip'
     */
    '6DbPA': T;

    /**
     * @default 'registry'
     */
    zlalN: T;

    /**
     * @default 'gifts'
     */
    TT0gI: T;

    /**
     * @default 'presents'
     */
    '8Qicb': T;

    /**
     * @default 'wish list'
     */
    DSoXZ: T;

    /**
     * @default 'wishlist'
     */
    xxodN: T;

    /**
     * @default 'shop'
     */
    '6izRA': T;

    /**
     * @default 'browse'
     */
    ywUo9: T;

    /**
     * @default 'store'
     */
    HzPgJ: T;

    /**
     * @default 'catalog'
     */
    '7se21': T;

    /**
     * @default 'manage'
     */
    ntJFG: T;

    /**
     * @default 'edit'
     */
    uerPA: T;

    /**
     * @default 'update'
     */
    vQ7bc: T;

    /**
     * @default 'organize'
     */
    Pqhu1: T;

    /**
     * @default 'track'
     */
    zh1kJ: T;

    /**
     * @default 'orders'
     */
    l9psM: T;

    /**
     * @default 'shipping'
     */
    IlV4z: T;

    /**
     * @default 'delivery'
     */
    Ya4Ay: T;

    /**
     * @default 'tracking'
     */
    DeXQJ: T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Share Event'
     */
    LjEc4: T;

    /**
     * @default 'Preview Website'
     */
    XdIft: T;

    /**
     * @default 'RSVP Responses'
     */
    fTbFT: T;

    /**
     * @default 'RSVP Activity'
     */
    wmrLO: T;

    /**
     * @default 'Invite Collaborator'
     */
    '5lFSE': T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Manage Events'
     */
    CGUli: T;

    /**
     * @default 'Account Info'
     */
    bZS93: T;
  };
};

export type CompanyPoliciesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  shippingPolicy: {
    seo: {
      /**
       * @default 'With Joy Shipping Policy'
       */
      title: T;

      /**
       * @default 'Joy Shipping policy. Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was placed. Estimated shipping times are counted in business days, excluding weekends and holidays, after the order has shipped.'
       */
      description: T;
    };
    hero: {
      /**
       * @default 'Shipping Info'
       */
      title: T;

      /**
       * @default 'Last Updated: December 12, 2023'
       */
      date: T;

      /**
       * @default 'Don’t you just love it when something special is on its way? Here’s what to expect when it comes to shipping with Joy…'
       */
      subtitle: T;
    };

    paragraphs: [
      {
        /**
         * @default '<strong>Items Added from the Joy Shop:</strong> Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was placed. Estimated shipping times are counted in business days, excluding weekends and holidays, after the order has shipped.'
         */
        text: T;
      },
      {
        /**
         * @default 'Expedited Shipping is not always available. If applicable, you’ll see which items are eligible during checkout.'
         */
        text: T;
      },
      {
        /**
         * @default 'For gifts added from the Joy shop, you can enjoy free shipping on all orders over $75. For gifts added from external registries, the shipping terms will typically align with the policies of the retailer itself. In this case, the shipping fees, delivery times, and any additional details will be determined by the external retailer’s shipping policies. Any shipping and handling fees will be listed during checkout.'
         */
        text: T;
      },
      {
        /**
         * @default 'For Joy physical and eligible items, subtotals equal to or more than $75 will ship for free.'
         */
        text: T;
      },
      {
        /**
         * @default '<strong>These items include</strong>: Physical Joy Shop products and Joy Gift Wrap eCards.'
         */
        text: T;
      },
      {
        /**
         * @default 'Items that <strong>are not eligible</strong> or may not include free shipping include: Gift cards or eGift cards, Cash gifts or cash contributions, Experiences or other email vouchers, Gifts added from external registries.'
         */
        text: T;
      },
      {
        /**
         * @default 'Shipping is only available in the contiguous U.S. and items cannot be shipped to a PO Box or APO/FPO/DPO. Additional surcharges may apply depending on the item and location and will be shown at checkout when applicable. Please note, shipping fees are non-refundable.'
         */
        text: T;
      },
      {
        /**
         * @default '<strong>Items Added from External Registries or Retailers:</strong> The shipping terms, including fees, delivery times, and details for these items will typically align with the policies of the retailer itself. Any shipping and handling fees will be listed during checkout.'
         */
        text: T;
      },
    ];
  };
  returnPolicy: {
    seo: {
      /**
       * @default 'With Joy Return Policy'
       */
      title: T;

      /**
       * @default 'Experience the Joy return policy, allowing for returns on most items within a generous 90-day window. Discover more about our policy.'
       */
      description: T;
    };
    hero: {
      /**
       * @default 'Returns & Exchanges'
       */
      title: T;

      /**
       * @default 'Last Updated: September 12, 2024'
       */
      date: T;

      /**
       * @default 'We always strive to deliver Joy, but in case you’d like to return or exchange an item, here are the details.'
       */
      subtitle: T;
    };
    topSection: {
      /**
       * @default 'Purchases on Joy'
       */
      title: T;

      /**
       * @default 'When you purchase a gift on our site, you're buying the equivalent in Joy Credit, which is equal to the full price of the item at the time of purchase, including taxes and shipping. The gift recipient can use that value to have the selected item shipped at their convenience. If the item's price increases after purchase or during a shipping hold, we’ll cover the difference. They can also choose to apply that value toward a different item on Joy.'
       */
      description: T;

      listItems: [
        {
          /**
           * @default '<strong>Joy Credit </strong> never expires and can be used on physical products and experiences sold by Joy. You cannot use credit for cash gifts, honeymoon funds, digital gift cards, or items from other websites. It also cannot be applied to past orders. Promo codes may be offered occasionally and may have expiration dates or additional terms and conditions.'
           */
          text: T;
        },
        {
          /**
           * @default 'We reserve the right to cancel or decline to process orders for reasons such as pricing errors, concerns about fraud, or out-of-stock items. If that happens, you will not be charged, or we’ll issue a refund.'
           */
          text: T;
        },
        {
          /**
           * @default 'We accept returns on select items; please refer to our Return Policy below for details. While we strive to provide accurate product information, we can’t guarantee all content is error-free. If something is incorrect, your primary option will be to return the item.'
           */
          text: T;
        },
        {
          /**
           * @default 'Occasionally, product listings may be outdated or inaccurate. We reserve the right to update or correct information without notice and may cancel orders placed at incorrect prices.'
           */
          text: T;
        },
        {
          /**
           * @default 'By purchasing or registering for an item on our site, you agree to our shipping and return policies. We don’t sell alcohol, but some third-party gift cards may be redeemable for alcohol from other sellers. You must be at least 21 years of age to purchase these products and comply with all applicable state laws.'
           */
          text: T;
        },
      ];
    };

    sections: [
      {
        /**
         * @default 'Registry Purchases'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Most items can be returned within 90 days. Don’t worry! If you’re returning a gift that was purchased for you, the gift giver will not be notified.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'You must request a return or exchange no more than 90 days after your event OR no more than 90 days after purchase, whichever date is later. There are no exceptions.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'In order for eligible item(s) to be returned, proof of purchase is required and returned item(s) must be in the same condition received, unopened, unused, and in the original packaging.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'You’ll be issued a refund in the form of a merchandise credit in the amount of the full value originally paid, less any shipping and restocking fees if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item was purchased through a Third Party’s website, for example, Amazon.com or Target.com, that store’s return policy applies. Any return, refund, or exchange should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Please note: Joy retains the right to review and/or deny any return request on a case-by-case basis.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Printed Cards and Paper'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'We want you to be 100% happy with your prints. That’s why each order has a 24 hour window to make any last minute changes, be it a typo, updated shipping address, or other minor change. Simply reach out to our customer support team at printsupport@withjoy.com with your change or cancellation request.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Given that each paper order is custom printed to your specifications, all sales are final after the 24-hour grace period.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an error was detected after the 24-hour grace period, you may reach out to our customer support team at printsupport@withjoy.com, and our agents will review your request on a case-by-case basis.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'In the rare event that a printing issue affected your order, please reach out to our customer support team at printsupport@withjoy.com with the following information:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Name'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Order number'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Brief description of the issue'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Photo showing the issue and how many items were impacted'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If we determine that there is a quality issue with our printing process, we will refund your order or reprint free of charge.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'All Other Purchases'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Most items can be returned within 30 days.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'An order may be canceled provided the item hasn’t shipped yet.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item has already shipped, you must request a refund or exchange no more than 30 days after purchase. There are no exceptions.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item was purchased through a Third Party’s website, for example, Amazon.com or Target.com, that store’s return policy applies. Any return, refund, or exchange should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Refund Policy'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'In order for the eligible item(s) to be refunded, you must ensure that:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Returned item(s) must be in the same condition received, unopened, unused, and in the original packaging.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Proof of purchase is provided.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Please note: Joy retains the right to review and/or deny any return request on a case-by-case basis.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Proof of purchase is required to issue an appropriate exchange, credit, or refund of an eligible item(s), as well as any taxes due to be refunded in accordance with applicable state law. For your convenience, any of the following is accepted as proof of your purchase:'
             */
            title: T;

            listItems: [];

            listIndentedItems: [
              {
                /**
                 * @default 'Gift Receipt'
                 */
                text: T;
              },
              {
                /**
                 * @default 'eReceipt'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Original Packing Slip'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift Packing Slip'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Order Number'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift Registry Number'
                 */
                text: T;
              },
            ];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'There are a few items that can’t be returned:'
             */
            title: T;

            listItems: [];

            listIndentedItems: [
              {
                /**
                 * @default 'Opened and assembled furniture items'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift cards and eGift cards'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Redeemed experiences'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Personalized items or custom orders'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Shipping fees, if applicable, are non-refundable'
                 */
                text: T;
              },
            ];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Restocking fees may apply to certain items:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Any restocking fee will be deducted from your refund total once the return has been processed.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Experiences'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Joy partners with third-party providers to offer our registrants a wide variety of experiences and event ticket options.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Unredeemed experiences can be returned for a merchandise credit but are not eligible for a refund.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Third-party providers offer site-specific return policies. Gifts purchased through a third party are subject to those policies, if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Spur offers cash back refunds up to 30 days after the purchase on un-redeemed experiences.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'After 30 days, customers can exchange experiences for credit to their e-wallet.  These funds never expire and can be used towards other Spur experiences as well as tickets to sporting events and concerts. Experience vouchers never expire. However, some experience providers may change their offerings over time. If the experience is no longer offered, the total amount of the voucher will be credited to the user’s e-wallet. Spur’s full policy details can be viewed here.  <a href='https://spurexperiences.com/terms-conditions' target='blank'>https://spurexperiences.com/terms-conditions</a>'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Third Party and External Items'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Joy’s registry platform allows registrants to add items from other stores so they can manage their registry all in one place. If you’d like to return or exchange an item purchased through a third party, please be aware that:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Items purchased from other websites are subject to the return policy of the store from which they were purchased.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Any customer service inquiry, return, refund, or exchange for these items should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Delivery Issues'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'If an item is damaged upon delivery:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 30 days of delivery.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A photo of the damaged item and any packaging in the order must be provided in order to process any requests.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A replacement or merchandise credit will be issued.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an item is defective:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 90 days of delivery and provide a photo of any visible defects and any information pertaining to the issue, regular care and use, and any possible troubleshooting of the issue.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'For all other defective items, please refer to the manufacturer’s warranty.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If a replacement is not desired, the value of the item will be issued as a merchandise credit.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an item is lost or missing in transit:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 14 days of scheduled delivery.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'After 14 days, your order may not be able to be replaced.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'For back ordered items, including items that were purchased and are no longer available or items delayed from the manufacturer:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'You may cancel the order prior to the item being shipped.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A merchandise credit will be issued for the full value paid less any fees, if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A replacement item of equal or greater value may be offered in certain circumstances.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Questions?'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'If you’re unable to find the answer to your question here, please contact Joy customer support at <a href='mailto:support@withjoy.com'>support@withjoy.com</a> and we’d be happy to help!'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
    ];
  };
};

export type ContactCollectorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  admin: {
    /**
     * @default 'Can you share your current mailing address? {{names}} would love to send you something special! 💌'
     */
    messagePlaceholder: T;

    /**
     * @default 'Hey! Mind sharing your current mailing address? 📮 {{names}} are excited to send you a little something special!'
     */
    messagePlaceholder0: T;

    /**
     * @default 'Hey! 👋 {{names}} are gathering addresses to send you something special! Could you share yours?'
     */
    messagePlaceholder1: T;

    /**
     * @default 'Hi! Could you share your mailing address? {{names}} have a special surprise to send your way!'
     */
    messagePlaceholder2: T;

    /**
     * @default 'You’re invited! But first, we need your mailing address. Click the link to share with {{names}}.'
     */
    messagePlaceholder3: T;

    /**
     * @default 'Hey! {{names}} are collecting addresses to mail you a special invitation. Can you provide yours? 📬'
     */
    messagePlaceholder4: T;

    /**
     * @default 'Can you provide your mailing address? {{names}} want to send something your way!'
     */
    messagePlaceholder5: T;

    /**
     * @default 'Hey! {{names}} are getting ready to send you something special. Can you share your address with them?'
     */
    messagePlaceholder6: T;

    /**
     * @default '{{names}} are collecting addresses for their event. Please click the link to share.'
     */
    messagePlaceholder7: T;

    /**
     * @default 'Collect guest details.'
     */
    createTitle: T;

    /**
     * @default 'Customize the message and design.'
     */
    createSubTitle: T;

    /**
     * @default 'Edit Design'
     */
    editDesign: T;

    /**
     * @default 'Design Your Collector'
     */
    design: T;

    /**
     * @default 'Customize how it looks to your heart’s delight.'
     */
    customize: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Text Message Preview'
     */
    textMessagePreview: T;

    /**
     * @default 'How does it work?'
     */
    instructionsTitle: T;

    /**
     * @default 'Share via text or email.'
     */
    instructionsFirst: T;

    /**
     * @default 'Your guests fill out a form.'
     */
    instructionsSecond: T;

    /**
     * @default 'Your guest list updates!'
     */
    instructionsThird: T;

    /**
     * @default 'Design'
     */
    visual: T;

    /**
     * @default 'Photo source'
     */
    photo: T;

    /**
     * @default 'Message'
     */
    note: T;

    /**
     * @default 'Your Message'
     */
    message: T;

    /**
     * @default 'Include Event Website'
     */
    linkWebsite: T;

    /**
     * @default 'Show Event Date'
     */
    displayEventDate: T;

    /**
     * @default 'Event Date'
     */
    eventDate: T;

    /**
     * @default 'Edit Date'
     */
    editDate: T;

    /**
     * @default 'Your Event Date is currently set to private. If you’d like it displayed here, please update your preferences in'
     */
    privateDate: T;

    /**
     * @default ', and refresh this page.'
     */
    refresh: T;

    /**
     * @default 'Create Magic Link'
     */
    createMagicLink: T;

    /**
     * @default 'Save Contact Collector'
     */
    updateMagicLink: T;

    /**
     * @default 'There was an error creating the Magic Link'
     */
    magicLinkError: T;

    /**
     * @default 'There was an error clearing the Contact List'
     */
    clearContactListError: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Your Contact Collector'
     */
    previewTitle: T;

    /**
     * @default 'Send this link to your guests. They’ll fill out their details and we’ll update your guest list.'
     */
    previewSubTitle: T;

    /**
     * @default 'Your Contact Collector is disabled to collecting households.'
     */
    disabledCollectHouseholdHelper: T;

    /**
     * @default 'Clear Contact List'
     */
    clearContactList: T;

    /**
     * @default 'I understand that by clicking Clear Contact List, I will no longer be able to recover the contacts.'
     */
    clearContactListDialog: T;

    /**
     * @default 'Recent Updates'
     */
    recentUpdates: T;

    /**
     * @default 'Edit Guest List'
     */
    editGuestList: T;

    /**
     * @default 'Start sharing!'
     */
    startSharing: T;

    /**
     * @default 'Your updated contacts will appear here.'
     */
    recentUpdatesPlaceholder: T;

    /**
     * @default 'Animation'
     */
    selectAnimation: T;

    /**
     * @default 'Image'
     */
    selectImage: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    errorPageTitle: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    errorPageSubTitle: T;

    /**
     * @default 'There was an error fetching the Contacts Updates.'
     */
    recentUpdatesError: T;

    /**
     * @default 'Contact Collector'
     */
    title: T;

    /**
     * @default 'Your details will only be shared with {{names}}.'
     */
    landingPageMessage: T;

    /**
     * @default 'Provide Details'
     */
    provideDetails: T;

    /**
     * @default 'Visit Event Website'
     */
    visitEventWebsite: T;

    /**
     * @default 'The Couple'
     */
    theCouple: T;

    /**
     * @default 'Please Add Your Info'
     */
    addYourInfo: T;

    /**
     * @default 'Contact Info'
     */
    contactInfo: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Mobile Phone'
     */
    phoneNumber: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Mailing Address'
     */
    mailingAddress: T;

    /**
     * @default 'Address Line 1'
     */
    address1: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    address2: T;

    /**
     * @default 'Zip/Postal Code'
     */
    postalCode: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'State/Province/Territory'
     */
    region: T;

    /**
     * @default 'Country/Region'
     */
    country: T;

    /**
     * @default 'Save Details'
     */
    saveDetails: T;

    /**
     * @default 'Add a member to this party'
     */
    addMember: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'Invalid Email'
     */
    invalidEmail: T;

    /**
     * @default 'Invalid Phone Number'
     */
    invalidPhoneNumber: T;

    /**
     * @default 'Does this look right?'
     */
    looksRight: T;

    /**
     * @default 'Modify Details'
     */
    modifyDetails: T;

    /**
     * @default 'Looks Good'
     */
    looksGood: T;

    /**
     * @default 'There was an error creating the contact'
     */
    contactError: T;

    /**
     * @default '*Required fields'
     */
    requiredFields: T;

    /**
     * @default 'You’re all set, {{name}}!'
     */
    allSet: T;

    /**
     * @default 'We’ve sent your details to {{names}}!'
     */
    successMessage: T;

    /**
     * @default 'Address Suggestion'
     */
    addressSuggestion: T;

    /**
     * @default 'It is possible the following modified address will ensure a more successful delivery.'
     */
    addressSuggestionText1: T;

    /**
     * @default 'Please select the address you’d like to use.'
     */
    addressSuggestionText2: T;

    /**
     * @default 'Original Address'
     */
    originalAddress: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddress: T;

    /**
     * @default 'Confirm Address'
     */
    confirmAddress: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'We couldn’t validate your address.'
     */
    addressValidationError: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    /**
     * @default 'By clicking “Save Details”, you agree to Joy’s'
     */
    termsAndConditions1: T;

    /**
     * @default 'and'
     */
    termsAndConditions2: T;

    /**
     * @default 'and consent to receive messages for this event via SMS. Message and data rates apply.'
     */
    termsAndConditions3: T;

    /**
     * @default 'By entering your phone number, you consent to receive messages for this event via SMS. Message and data rates may apply. Reply STOP to opt out proceeding, you confirm that you have read and agree to Joy’s'
     */
    termsAndConditions4: T;

    /**
     * @default 'Help'
     */
    help: T;

    csvUpload: {
      /**
       * @default 'Upload Spreadsheet'
       */
      title: T;

      /**
       * @default '🎉 Success! Upload Completed!'
       */
      successTitle: T;

      /**
       * @default '😑 Something went wrong'
       */
      errorTitle: T;

      /**
       * @default 'contacts'
       */
      contacts: T;

      /**
       * @default 'valid'
       */
      valid: T;

      /**
       * @default 'invalid'
       */
      invalid: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Import Valid Contacts'
       */
      importCta: T;

      /**
       * @default 'Upload Spreadsheet'
       */
      uploadCta: T;

      /**
       * @default 'Upload Your Spreadsheet'
       */
      uploadYourCta: T;

      /**
       * @default 'Already have a list of contacts?'
       */
      haveAList: T;

      /**
       * @default 'Get a head start by uploading a spreadsheet of your contacts.'
       */
      getAHead: T;

      /**
       * @default 'Seems like something went wrong. Please try to submit your spreadsheet again.'
       */
      error: T;

      /**
       * @default 'Please'
       */
      please: T;

      /**
       * @default 'Please make sure that all the required fields are filled in as per spreadsheet'
       */
      pleaseLong: T;

      /**
       * @default 'template'
       */
      template: T;

      /**
       * @default 'download the template'
       */
      download: T;

      /**
       * @default 'and follow the instructions on'
       */
      follow: T;

      /**
       * @default 'this page.'
       */
      thisPage: T;

      /**
       * @default 'Important:'
       */
      important: T;

      /**
       * @default 'Uploading a spreadsheet will create a new contact in your Guest List for each row. If you already have contacts in your guest list, we recommend editing them directly in your recipient selector or'
       */
      importantText: T;

      /**
       * @default 'Guest List'
       */
      guestList: T;

      /**
       * @default 'to avoid duplicates.'
       */
      avoid: T;

      /**
       * @default 'Download Template'
       */
      downloadCta: T;

      /**
       * @default 'Upload File'
       */
      uploadFileCta: T;

      /**
       * @default 'Upload New File'
       */
      uploadNewFileCta: T;

      /**
       * @default 'We’ve successfully imported {{quantity}} contacts from the spreadsheet.'
       */
      validContacts: T;

      /**
       * @default 'View Contacts'
       */
      viewContactsCta: T;

      /**
       * @default 'The spreadsheet couldn’t be uploaded due to incorrect formatting.'
       */
      fileFormatError: T;

      /**
       * @default 'The spreadsheet couldn’t have been uploaded due to the required column missing.'
       */
      fileRequiredColumnsError: T;

      /**
       * @default 'Learn More'
       */
      learnMore: T;
    };

    /**
     * @default 'Contact'
     */
    contact: T;

    /**
     * @default 'created successfully.'
     */
    created: T;
  };
  quick: {
    /**
     * @default 'Names can’t contain commas, quotes or line breaks, or start with = + - @'
     */
    RgkvJ: T;

    /**
     * @default 'Enter one person per name. Add the other person as an additional guest.'
     */
    '4RTCJ': T;

    /**
     * @default 'The Couple'
     */
    P9H7j: T;

    /**
     * @default 'Can you share your current mailing address? {{0}} would love to send you something special! 💌'
     */
    yIFF9: T;

    /**
     * @default '{{0}} & {{1}}'
     */
    '7eUJY': T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'At least one contact method must be required.'
     */
    ksou0: T;

    /**
     * @default 'Hmm… we're having some trouble.'
     */
    MLsxY: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    t6ozN: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Collect Contacts'
     */
    v9WNU: T;

    /**
     * @default 'Contact Collector'
     */
    pHmSZ: T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Suffix'
     */
    jtrIW: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Activity'
     */
    dgmnl: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Contact Collector navigation'
     */
    b2VUW: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Invalid Email'
     */
    zS8sb: T;

    /**
     * @default 'Contact updated successfully.'
     */
    '0Tolw': T;

    /**
     * @default 'Contacts created successfully.'
     */
    AvgRB: T;

    /**
     * @default 'Contact created successfully.'
     */
    NXs1L: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    iPvSw: T;

    /**
     * @default '1 Contact missing country code'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Contact missing country code
     * - plural: {{0}} Contacts missing country code
     */
    yspUh: T;

    /**
     * @default 'Start by'
     */
    TNqB1: T;

    /**
     * @default 'downloading the template'
     */
    PioHM: T;

    /**
     * @default 'and following the'
     */
    L5rsg: T;

    /**
     * @default 'formatting instructions.'
     */
    MPcoc: T;

    /**
     * @default 'Note: Every row creates a new contact. Update existing contacts in your'
     */
    O0Hwx: T;

    /**
     * @default 'Guest List'
     */
    sYWqA: T;

    /**
     * @default 'to avoid duplicates.'
     */
    '4z4uF': T;

    /**
     * @default 'Download Template'
     */
    '2zRsI': T;

    /**
     * @default 'Upload File'
     */
    t6fgB: T;

    /**
     * @default 'The spreadsheet couldn't be uploaded due to incorrect formatting.'
     */
    L5Cce: T;

    /**
     * @default 'The spreadsheet couldn't have been uploaded due to the required column missing.'
     */
    GsAYt: T;

    /**
     * @default 'contacts'
     */
    llnjS: T;

    /**
     * @default 'valid'
     */
    '6xSsJ': T;

    /**
     * @default 'invalid'
     */
    f61hf: T;

    /**
     * @default 'warning'
     */
    ofXw5: T;

    /**
     * @default 'Missing {{0}}'
     */
    C8ypP: T;

    /**
     * @default 'Invalid Postal Code: {{0}}'
     */
    hThmi: T;

    /**
     * @default 'Please make sure that all the required fields are filled in as per spreadsheet'
     */
    CDIYz: T;

    /**
     * @default 'template'
     */
    sSXhG: T;

    /**
     * @default 'and follow the instructions on'
     */
    LPneO: T;

    /**
     * @default 'this page.'
     */
    h9pbJ: T;

    /**
     * @default 'Important:'
     */
    QCzuR: T;

    /**
     * @default 'Uploading a spreadsheet will create a new contact in your Guest List for each row. If you already have contacts in your guest list, we recommend editing them directly in your recipient selector or'
     */
    xkiqY: T;

    /**
     * @default 'Select a value to default below, or re-upload again.'
     */
    Xq4c0: T;

    /**
     * @default 'Upload New File'
     */
    ZrJJL: T;

    /**
     * @default 'Import Valid Contacts'
     */
    UXJ63: T;

    /**
     * @default 'Seems like something went wrong. Please try to submit your spreadsheet again.'
     */
    OgyFY: T;

    /**
     * @default 'Something went wrong'
     */
    X1dnv: T;

    /**
     * @default 'Some Rows Weren't Imported'
     */
    nyP0I: T;

    /**
     * @default 'Success! Upload Completed!'
     */
    nRO61: T;

    /**
     * @default 'Here's what happened with your spreadsheet.'
     */
    OfGuz: T;

    /**
     * @default 'Upload Spreadsheet'
     */
    bH6LG: T;

    /**
     * @default 'Have a contact list already?'
     */
    WCpz9: T;

    /**
     * @default 'Need to export your guest list?'
     */
    JxbIw: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default '✨ Link copied! ✨'
     */
    NlEES: T;

    /**
     * @default 'Couldn't copy link — please try selecting and copying manually.'
     */
    pkAER: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Contact Collector is On'
     */
    MK1Iw: T;

    /**
     * @default 'Contact Collector is Off'
     */
    cZEYL: T;

    /**
     * @default '+1s On'
     */
    E0QG4: T;

    /**
     * @default '+1s Off'
     */
    qIwq4: T;

    /**
     * @default 'Share Link'
     */
    F4p3q: T;

    /**
     * @default 'Please enable Contact Collector.'
     */
    Gmkte: T;

    /**
     * @default 'Share Magic Link'
     */
    myqVK: T;

    /**
     * @default 'Paste this in any chat to collect contacts from friends and family.'
     */
    yAfIL: T;

    /**
     * @default 'Magic link URL'
     */
    ywmH3: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Collect Guest Details'
     */
    a7Ods: T;

    /**
     * @default 'Allow guests to add +1s'
     */
    '1AkA5': T;

    /**
     * @default 'Allow guests to add their family members or plus one to their contact information.'
     */
    '9OXBO': T;

    /**
     * @default 'Turn on to share your link.'
     */
    DOq3x: T;

    /**
     * @default 'There was an error updating the Contact Collector'
     */
    e3l5D: T;

    /**
     * @default 'Failed to update contact.'
     */
    N4stg: T;

    /**
     * @default 'Please try again.'
     */
    ZxAeI: T;

    /**
     * @default 'Confirm Address'
     */
    oOcdq: T;

    /**
     * @default 'Edit Guest'
     */
    '83sO2': T;

    /**
     * @default 'You have unsaved changes'
     */
    Imr9T: T;

    /**
     * @default 'Would you like to save or discard them?'
     */
    n21tG: T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'Discard Changes'
     */
    '9jhfJ': T;

    /**
     * @default 'Get free, effortless envelope addressing on your Save the Dates and Invitations.'
     */
    D8uS0: T;

    /**
     * @default 'Browse Card Designs'
     */
    '1Y392': T;

    /**
     * @default 'Address Envelopes Effortlessly.'
     */
    XiRsN: T;

    /**
     * @default 'Use our contact collector to gather all the guest information and reach everyone.'
     */
    fXX0g: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Edit Guest List'
     */
    YzM5R: T;

    /**
     * @default 'Track new contacts as your guests respond.'
     */
    TXE6O: T;

    /**
     * @default 'Provide Details'
     */
    '99HMQ': T;

    /**
     * @default 'Visit Event Website'
     */
    ok1gv: T;

    /**
     * @default 'No default country — keep numbers as written'
     */
    OpUgw: T;

    /**
     * @default 'Default country for phone numbers'
     */
    gvFed: T;

    /**
     * @default 'We'll use this only for phone numbers that don't have a Country in your spreadsheet. Numbers with their own Country or starting with + aren't affected.'
     */
    KmXbE: T;

    /**
     * @default 'Phone numbers without a Country or + will be imported exactly as written. You can fix them later in your Guest List.'
     */
    FPFSy: T;

    /**
     * @default 'Select a country'
     */
    xUDQK: T;

    /**
     * @default 'We couldn't download your guest list. Please try again.'
     */
    IemfF: T;

    /**
     * @default 'Your guest list has been downloaded.'
     */
    '2HU6P': T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default '1 of {{0}} New Guest Added'
     * @param {number} count - The number of occurrences.
     * - singular: 1 of {{0}} New Guest Added
     * - plural: {{0}} of {{1}} New Guests Added
     */
    FXKps: T;

    /**
     * @default '1 Possible Duplicate'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Possible Duplicate
     * - plural: {{0}} Possible Duplicates
     */
    u90NG: T;

    /**
     * @default '1 Existing Guest Updated'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Existing Guest Updated
     * - plural: {{0}} Existing Guests Updated
     */
    MWGi9: T;

    /**
     * @default '1 Row Not Saved'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Row Not Saved
     * - plural: {{0}} Rows Not Saved
     */
    KjWa3: T;

    /**
     * @default 'There was a problem on our side. Check your Guest List before uploading it again.'
     * @param {number} count - The number of occurrences.
     * - singular: There was a problem on our side. Check your Guest List before uploading it again.
     * - plural: There was a problem on our side. Check your Guest List before uploading them again.
     */
    ttCa0: T;

    /**
     * @default '1 Row Skipped'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Row Skipped
     * - plural: {{0}} Rows Skipped
     */
    QC0H9: T;

    /**
     * @default 'Its ID doesn't match any existing contact.'
     * @param {number} count - The number of occurrences.
     * - singular: Its ID doesn't match any existing contact.
     * - plural: Their IDs don't match any existing contact.
     */
    pYfXC: T;

    /**
     * @default '1 Address Not Saved'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Address Not Saved
     * - plural: {{0}} Addresses Not Saved
     */
    Hl4a1: T;

    /**
     * @default '1 Incomplete Address'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Incomplete Address
     * - plural: {{0}} Incomplete Addresses
     */
    Ba8jF: T;

    /**
     * @default '1 Phone Number Formatted'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Phone Number Formatted
     * - plural: {{0}} Phone Numbers Formatted
     */
    iewYj: T;

    /**
     * @default 'We assumed it's from {{0}}.'
     * @param {number} count - The number of occurrences.
     * - singular: We assumed it's from {{0}}.
     * - plural: We assumed they're from {{0}}.
     */
    H2zZx: T;

    /**
     * @default 'We couldn't tell which guest to update, so we added them as new guests. Check if any were already on your list.'
     */
    dJHHn: T;

    /**
     * @default 'They were already on your list, so we didn't add them again.'
     */
    YqHSJ: T;

    /**
     * @default 'If any of them is actually a different person, add that person as a new guest.'
     */
    MPWuu: T;

    /**
     * @default 'We saved these guests, but their mailing address is missing some details.'
     */
    '9H349': T;

    /**
     * @default 'The download only has the rows that weren't imported. Fix them and upload that file, so nothing gets added twice.'
     */
    SpVIK: T;

    /**
     * @default 'Download Rows to Fix'
     */
    RQXav: T;

    /**
     * @default 'Hey! Mind sharing your current mailing address? 📮 {{0}} are excited to send you a little something special!'
     */
    '7b0y0': T;

    /**
     * @default 'Hey! 👋 {{0}} are gathering addresses to send you something special! Could you share yours?'
     */
    sSeKB: T;

    /**
     * @default 'Hi! Could you share your mailing address? {{0}} have a special surprise to send your way!'
     */
    rOanI: T;

    /**
     * @default 'You're invited! But first, we need your mailing address. Click the link to share with {{0}}.'
     */
    F7YcN: T;

    /**
     * @default 'Hey! {{0}} are collecting addresses to mail you a special invitation. Can you provide yours? 📬'
     */
    BH6Qt: T;

    /**
     * @default 'Can you provide your mailing address? {{0}} want to send something your way!'
     */
    LMalE: T;

    /**
     * @default 'Hey! {{0}} are getting ready to send you something special. Can you share your address with them?'
     */
    jLSdU: T;

    /**
     * @default '{{0}} are collecting addresses for their event. Please click the link to share.'
     */
    UEr51: T;

    /**
     * @default 'Cover Art'
     */
    M1bpq: T;

    /**
     * @default 'Shown on your link preview, email, and landing page.'
     */
    ucuxo: T;

    /**
     * @default 'Photo source'
     */
    jmBIs: T;

    /**
     * @default 'Link Preview Text'
     */
    RWydV: T;

    /**
     * @default 'Include Event Website'
     */
    '9MDDg': T;

    /**
     * @default 'Show Event Date'
     */
    DdeoQ: T;

    /**
     * @default 'Suggest'
     */
    WmiYP: T;

    /**
     * @default 'Edit Date'
     */
    '8QYHg': T;

    /**
     * @default 'Your Event Date is currently set to private. If you'd like it displayed here, please update your preferences in'
     */
    MWOUX: T;

    /**
     * @default ', and refresh this page.'
     */
    HRbiZ: T;

    /**
     * @default 'Save Contact Collector'
     */
    GkL9g: T;

    /**
     * @default 'Create Magic Link'
     */
    pToeX: T;

    /**
     * @default 'There was an error creating the Magic Link'
     */
    NS4UT: T;

    /**
     * @default 'Clear Contact List'
     */
    ZvT7O: T;

    /**
     * @default 'I understand that by clicking Clear Contact List, I will no longer be able to recover the contacts.'
     */
    pxZtb: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'The guest list is being imported. Try again in a minute.'
     */
    FN5sg: T;

    /**
     * @default 'There was an error clearing the Contact List'
     */
    I5H10: T;

    /**
     * @default 'Cleared {{0}} of {{1}} contacts. The rest were not cleared.'
     */
    MaZ1E: T;

    /**
     * @default 'SUPER ADMIN ONLY'
     */
    E398l: T;

    /**
     * @default 'This wedding's guest list is stored in Firebase. Clearing the Contact List would also remove every guest from the guest list, so it is turned off here.'
     */
    '3Sifp': T;

    /**
     * @default 'View Details'
     */
    zvlhe: T;

    /**
     * @default 'Added'
     */
    AZ9cF: T;

    /**
     * @default 'Updated'
     */
    Bn1Wf: T;

    /**
     * @default 'Start sharing!'
     */
    '76tqf': T;

    /**
     * @default 'Your updated contacts will appear here.'
     */
    expNm: T;

    /**
     * @default 'Guest {{0}}'
     */
    '4Qerl': T;

    /**
     * @default 'First Name*'
     */
    f49kf: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name*'
     */
    dVHQv: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Mobile Phone*'
     */
    '80mWM': T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Email*'
     */
    KGPZu: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'your@email.com'
     */
    GHzC1: T;

    /**
     * @default 'Mailing Address'
     */
    RvleZ: T;

    /**
     * @default 'Envelope Name'
     */
    vyb70: T;

    /**
     * @default 'The Smith Family, Mr. and Mrs. Smith, etc'
     */
    ndLjC: T;

    /**
     * @default 'Address Line 1*'
     */
    lMvoK: T;

    /**
     * @default 'Address Line 1'
     */
    r2ebI: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    FR7Qu: T;

    /**
     * @default 'City*'
     */
    Z1vnF: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State/Province/Territory*'
     */
    '1ZAce': T;

    /**
     * @default 'State/Province/Territory'
     */
    LLPZf: T;

    /**
     * @default 'Zip/Postal Code*'
     */
    oHAyT: T;

    /**
     * @default 'Zip/Postal Code'
     */
    Ya5jy: T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'Individual'
     */
    '1Ilox': T;

    /**
     * @default 'Couple'
     */
    ISzTp: T;

    /**
     * @default 'Family'
     */
    '4DiHw': T;

    /**
     * @default 'By clicking "{{0}}", you agree to receive event updates from the host via SMS or email. Msg & data rates may apply. Reply STOP to opt out.'
     */
    YPM0J: T;

    /**
     * @default 'Terms'
     */
    bgu9G: T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Hide Names'
     */
    ueBNy: T;

    /**
     * @default 'See Names'
     */
    r1qBv: T;

    /**
     * @default '1 Row Not Imported'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Row Not Imported
     * - plural: {{0}} Rows Not Imported
     */
    EDOLW: T;

    /**
     * @default '1 Name With Special Characters'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Name With Special Characters
     * - plural: {{0}} Names With Special Characters
     */
    '0muIu': T;

    /**
     * @default '1 Row With More Than One Person'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Row With More Than One Person
     * - plural: {{0}} Rows With More Than One Person
     */
    SUYCQ: T;

    /**
     * @default 'The file you download says what to change in each row.'
     */
    Viqtr: T;

    /**
     * @default 'Hide Reasons'
     */
    z3Kno: T;

    /**
     * @default 'See Reasons'
     */
    '4GPOA': T;

    /**
     * @default 'Enter one person per row. To keep people together, give them the same Party.'
     */
    nJMtY: T;

    /**
     * @default 'Optional'
     */
    KozAy: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'What to collect'
     */
    bfmjw: T;

    /**
     * @default 'Choose which details guests must, may, or won't share.'
     */
    mgS0s: T;

    /**
     * @default 'Animation'
     */
    i5SX2: T;

    /**
     * @default 'Image'
     */
    HyIIG: T;

    /**
     * @default 'Text Message Preview'
     */
    '4qOcj': T;

    /**
     * @default 'How it Works'
     */
    PjIFm: T;

    /**
     * @default 'Share via text or email.'
     */
    '3Ol0I': T;

    /**
     * @default 'Your guests fill out a form.'
     */
    SvWK1: T;

    /**
     * @default 'Your Guest List updates.'
     */
    hbTMO: T;
  };
};

export type CountriesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Afghanistan'
   */
  af: T;

  /**
   * @default 'Albania'
   */
  al: T;

  /**
   * @default 'Algeria'
   */
  dz: T;

  /**
   * @default 'American Samoa'
   */
  as: T;

  /**
   * @default 'Andorra'
   */
  ad: T;

  /**
   * @default 'Angola'
   */
  ao: T;

  /**
   * @default 'Anguilla'
   */
  ai: T;

  /**
   * @default 'Antarctica'
   */
  aq: T;

  /**
   * @default 'Antigua and Barbuda'
   */
  ag: T;

  /**
   * @default 'Argentina'
   */
  ar: T;

  /**
   * @default 'Armenia'
   */
  am: T;

  /**
   * @default 'Aruba'
   */
  aw: T;

  /**
   * @default 'Australia'
   */
  au: T;

  /**
   * @default 'Austria'
   */
  at: T;

  /**
   * @default 'Azerbaijan'
   */
  az: T;

  /**
   * @default 'Bahamas'
   */
  bs: T;

  /**
   * @default 'Bahrain'
   */
  bh: T;

  /**
   * @default 'Bangladesh'
   */
  bd: T;

  /**
   * @default 'Barbados'
   */
  bb: T;

  /**
   * @default 'Belarus'
   */
  by: T;

  /**
   * @default 'Belgium'
   */
  be: T;

  /**
   * @default 'Belize'
   */
  bz: T;

  /**
   * @default 'Benin'
   */
  bj: T;

  /**
   * @default 'Bermuda'
   */
  bm: T;

  /**
   * @default 'Bhutan'
   */
  bt: T;

  /**
   * @default 'Bolivia'
   */
  bo: T;

  /**
   * @default 'Bonaire, Sint Eustatius and Saba'
   */
  bq: T;

  /**
   * @default 'Bosnia and Herzegovina'
   */
  ba: T;

  /**
   * @default 'Botswana'
   */
  bw: T;

  /**
   * @default 'Bouvet Island'
   */
  bv: T;

  /**
   * @default 'Brazil'
   */
  br: T;

  /**
   * @default 'British Indian Ocean Territory'
   */
  io: T;

  /**
   * @default 'Brunei Darussalam'
   */
  bn: T;

  /**
   * @default 'Bulgaria'
   */
  bg: T;

  /**
   * @default 'Burkina Faso'
   */
  bf: T;

  /**
   * @default 'Burundi'
   */
  bi: T;

  /**
   * @default 'Cabo Verde'
   */
  cv: T;

  /**
   * @default 'Cambodia'
   */
  kh: T;

  /**
   * @default 'Cameroon'
   */
  cm: T;

  /**
   * @default 'Canada'
   */
  ca: T;

  /**
   * @default 'Cayman Islands'
   */
  ky: T;

  /**
   * @default 'Central African Republic'
   */
  cf: T;

  /**
   * @default 'Chad'
   */
  td: T;

  /**
   * @default 'Chile'
   */
  cl: T;

  /**
   * @default 'China'
   */
  cn: T;

  /**
   * @default 'Christmas Island'
   */
  cx: T;

  /**
   * @default 'Cocos (Keeling) Islands'
   */
  cc: T;

  /**
   * @default 'Colombia'
   */
  co: T;

  /**
   * @default 'Comoros'
   */
  km: T;

  /**
   * @default 'Congo'
   */
  cg: T;

  /**
   * @default 'Congo (Democratic Republic of the)'
   */
  cd: T;

  /**
   * @default 'Cook Islands'
   */
  ck: T;

  /**
   * @default 'Costa Rica'
   */
  cr: T;

  /**
   * @default 'Côte d'Ivoire'
   */
  ci: T;

  /**
   * @default 'Croatia'
   */
  hr: T;

  /**
   * @default 'Cuba'
   */
  cu: T;

  /**
   * @default 'Curaçao'
   */
  cw: T;

  /**
   * @default 'Cyprus'
   */
  cy: T;

  /**
   * @default 'Czechia'
   */
  cz: T;

  /**
   * @default 'Denmark'
   */
  dk: T;

  /**
   * @default 'Djibouti'
   */
  dj: T;

  /**
   * @default 'Dominica'
   */
  dm: T;

  /**
   * @default 'Dominican Republic'
   */
  do: T;

  /**
   * @default 'Ecuador'
   */
  ec: T;

  /**
   * @default 'Egypt'
   */
  eg: T;

  /**
   * @default 'El Salvador'
   */
  sv: T;

  /**
   * @default 'Equatorial Guinea'
   */
  gq: T;

  /**
   * @default 'Eritrea'
   */
  er: T;

  /**
   * @default 'Estonia'
   */
  ee: T;

  /**
   * @default 'Eswatini'
   */
  sz: T;

  /**
   * @default 'Ethiopia'
   */
  et: T;

  /**
   * @default 'Falkland Islands (Malvinas)'
   */
  fk: T;

  /**
   * @default 'Faroe Islands'
   */
  fo: T;

  /**
   * @default 'Fiji'
   */
  fj: T;

  /**
   * @default 'Finland'
   */
  fi: T;

  /**
   * @default 'France'
   */
  fr: T;

  /**
   * @default 'French Guiana'
   */
  gf: T;

  /**
   * @default 'French Polynesia'
   */
  pf: T;

  /**
   * @default 'French Southern Territories'
   */
  tf: T;

  /**
   * @default 'Gabon'
   */
  ga: T;

  /**
   * @default 'Gambia'
   */
  gm: T;

  /**
   * @default 'Georgia'
   */
  ge: T;

  /**
   * @default 'Germany'
   */
  de: T;

  /**
   * @default 'Ghana'
   */
  gh: T;

  /**
   * @default 'Gibraltar'
   */
  gi: T;

  /**
   * @default 'Greece'
   */
  gr: T;

  /**
   * @default 'Greenland'
   */
  gl: T;

  /**
   * @default 'Grenada'
   */
  gd: T;

  /**
   * @default 'Guadeloupe'
   */
  gp: T;

  /**
   * @default 'Guam'
   */
  gu: T;

  /**
   * @default 'Guatemala'
   */
  gt: T;

  /**
   * @default 'Guernsey'
   */
  gg: T;

  /**
   * @default 'Guinea'
   */
  gn: T;

  /**
   * @default 'Guinea-Bissau'
   */
  gw: T;

  /**
   * @default 'Guyana'
   */
  gy: T;

  /**
   * @default 'Haiti'
   */
  ht: T;

  /**
   * @default 'Heard Island and McDonald Islands'
   */
  hm: T;

  /**
   * @default 'Holy See'
   */
  va: T;

  /**
   * @default 'Honduras'
   */
  hn: T;

  /**
   * @default 'Hong Kong'
   */
  hk: T;

  /**
   * @default 'Hungary'
   */
  hu: T;

  /**
   * @default 'Iceland'
   */
  is: T;

  /**
   * @default 'India'
   */
  in: T;

  /**
   * @default 'Indonesia'
   */
  id: T;

  /**
   * @default 'Iran'
   */
  ir: T;

  /**
   * @default 'Iraq'
   */
  iq: T;

  /**
   * @default 'Ireland'
   */
  ie: T;

  /**
   * @default 'Isle of Man'
   */
  im: T;

  /**
   * @default 'Israel'
   */
  il: T;

  /**
   * @default 'Italy'
   */
  it: T;

  /**
   * @default 'Jamaica'
   */
  jm: T;

  /**
   * @default 'Japan'
   */
  jp: T;

  /**
   * @default 'Jersey'
   */
  je: T;

  /**
   * @default 'Jordan'
   */
  jo: T;

  /**
   * @default 'Kazakhstan'
   */
  kz: T;

  /**
   * @default 'Kenya'
   */
  ke: T;

  /**
   * @default 'Kiribati'
   */
  ki: T;

  /**
   * @default 'Korea (Democratic People's Republic of)'
   */
  kp: T;

  /**
   * @default 'Korea (Republic of)'
   */
  kr: T;

  /**
   * @default 'Kuwait'
   */
  kw: T;

  /**
   * @default 'Kyrgyzstan'
   */
  kg: T;

  /**
   * @default 'Lao People's Democratic Republic'
   */
  la: T;

  /**
   * @default 'Latvia'
   */
  lv: T;

  /**
   * @default 'Lebanon'
   */
  lb: T;

  /**
   * @default 'Lesotho'
   */
  ls: T;

  /**
   * @default 'Liberia'
   */
  lr: T;

  /**
   * @default 'Libya'
   */
  ly: T;

  /**
   * @default 'Liechtenstein'
   */
  li: T;

  /**
   * @default 'Lithuania'
   */
  lt: T;

  /**
   * @default 'Luxembourg'
   */
  lu: T;

  /**
   * @default 'Macao'
   */
  mo: T;

  /**
   * @default 'Madagascar'
   */
  mg: T;

  /**
   * @default 'Malawi'
   */
  mw: T;

  /**
   * @default 'Malaysia'
   */
  my: T;

  /**
   * @default 'Maldives'
   */
  mv: T;

  /**
   * @default 'Mali'
   */
  ml: T;

  /**
   * @default 'Malta'
   */
  mt: T;

  /**
   * @default 'Marshall Islands'
   */
  mh: T;

  /**
   * @default 'Martinique'
   */
  mq: T;

  /**
   * @default 'Mauritania'
   */
  mr: T;

  /**
   * @default 'Mauritius'
   */
  mu: T;

  /**
   * @default 'Mayotte'
   */
  yt: T;

  /**
   * @default 'Mexico'
   */
  mx: T;

  /**
   * @default 'Micronesia (Federated States of)'
   */
  fm: T;

  /**
   * @default 'Moldova'
   */
  md: T;

  /**
   * @default 'Monaco'
   */
  mc: T;

  /**
   * @default 'Mongolia'
   */
  mn: T;

  /**
   * @default 'Montenegro'
   */
  me: T;

  /**
   * @default 'Montserrat'
   */
  ms: T;

  /**
   * @default 'Morocco'
   */
  ma: T;

  /**
   * @default 'Mozambique'
   */
  mz: T;

  /**
   * @default 'Myanmar'
   */
  mm: T;

  /**
   * @default 'Namibia'
   */
  na: T;

  /**
   * @default 'Nauru'
   */
  nr: T;

  /**
   * @default 'Nepal'
   */
  np: T;

  /**
   * @default 'Netherlands'
   */
  nl: T;

  /**
   * @default 'New Caledonia'
   */
  nc: T;

  /**
   * @default 'New Zealand'
   */
  nz: T;

  /**
   * @default 'Nicaragua'
   */
  ni: T;

  /**
   * @default 'Niger'
   */
  ne: T;

  /**
   * @default 'Nigeria'
   */
  ng: T;

  /**
   * @default 'Niue'
   */
  nu: T;

  /**
   * @default 'Norfolk Island'
   */
  nf: T;

  /**
   * @default 'North Macedonia'
   */
  mk: T;

  /**
   * @default 'Northern Mariana Islands'
   */
  mp: T;

  /**
   * @default 'Norway'
   */
  no: T;

  /**
   * @default 'Oman'
   */
  om: T;

  /**
   * @default 'Pakistan'
   */
  pk: T;

  /**
   * @default 'Palau'
   */
  pw: T;

  /**
   * @default 'Palestine, State of'
   */
  ps: T;

  /**
   * @default 'Panama'
   */
  pa: T;

  /**
   * @default 'Papua New Guinea'
   */
  pg: T;

  /**
   * @default 'Paraguay'
   */
  py: T;

  /**
   * @default 'Peru'
   */
  pe: T;

  /**
   * @default 'Philippines'
   */
  ph: T;

  /**
   * @default 'Pitcairn'
   */
  pn: T;

  /**
   * @default 'Poland'
   */
  pl: T;

  /**
   * @default 'Portugal'
   */
  pt: T;

  /**
   * @default 'Puerto Rico'
   */
  pr: T;

  /**
   * @default 'Qatar'
   */
  qa: T;

  /**
   * @default 'Réunion'
   */
  re: T;

  /**
   * @default 'Romania'
   */
  ro: T;

  /**
   * @default 'Russian Federation'
   */
  ru: T;

  /**
   * @default 'Rwanda'
   */
  rw: T;

  /**
   * @default 'Saint Barthélemy'
   */
  bl: T;

  /**
   * @default 'Saint Helena, Ascension and Tristan da Cunha'
   */
  sh: T;

  /**
   * @default 'Saint Kitts and Nevis'
   */
  kn: T;

  /**
   * @default 'Saint Lucia'
   */
  lc: T;

  /**
   * @default 'Saint Martin (French part)'
   */
  mf: T;

  /**
   * @default 'Saint Pierre and Miquelon'
   */
  pm: T;

  /**
   * @default 'Saint Vincent and the Grenadines'
   */
  vc: T;

  /**
   * @default 'Samoa'
   */
  ws: T;

  /**
   * @default 'San Marino'
   */
  sm: T;

  /**
   * @default 'Sao Tome and Principe'
   */
  st: T;

  /**
   * @default 'Saudi Arabia'
   */
  sa: T;

  /**
   * @default 'Senegal'
   */
  sn: T;

  /**
   * @default 'Serbia'
   */
  rs: T;

  /**
   * @default 'Seychelles'
   */
  sc: T;

  /**
   * @default 'Sierra Leone'
   */
  sl: T;

  /**
   * @default 'Singapore'
   */
  sg: T;

  /**
   * @default 'Sint Maarten (Dutch part)'
   */
  sx: T;

  /**
   * @default 'Slovakia'
   */
  sk: T;

  /**
   * @default 'Slovenia'
   */
  si: T;

  /**
   * @default 'Solomon Islands'
   */
  sb: T;

  /**
   * @default 'Somalia'
   */
  so: T;

  /**
   * @default 'South Africa'
   */
  za: T;

  /**
   * @default 'South Georgia and the South Sandwich Islands'
   */
  gs: T;

  /**
   * @default 'South Sudan'
   */
  ss: T;

  /**
   * @default 'Spain'
   */
  es: T;

  /**
   * @default 'Sri Lanka'
   */
  lk: T;

  /**
   * @default 'Sudan'
   */
  sd: T;

  /**
   * @default 'Suriname'
   */
  sr: T;

  /**
   * @default 'Svalbard and Jan Mayen'
   */
  sj: T;

  /**
   * @default 'Sweden'
   */
  se: T;

  /**
   * @default 'Switzerland'
   */
  ch: T;

  /**
   * @default 'Syrian Arab Republic'
   */
  sy: T;

  /**
   * @default 'Taiwan'
   */
  tw: T;

  /**
   * @default 'Tajikistan'
   */
  tj: T;

  /**
   * @default 'Tanzania'
   */
  tz: T;

  /**
   * @default 'Thailand'
   */
  th: T;

  /**
   * @default 'Timor-Leste'
   */
  tl: T;

  /**
   * @default 'Togo'
   */
  tg: T;

  /**
   * @default 'Tokelau'
   */
  tk: T;

  /**
   * @default 'Tonga'
   */
  to: T;

  /**
   * @default 'Trinidad and Tobago'
   */
  tt: T;

  /**
   * @default 'Tunisia'
   */
  tn: T;

  /**
   * @default 'Turkey'
   */
  tr: T;

  /**
   * @default 'Turkmenistan'
   */
  tm: T;

  /**
   * @default 'Turks and Caicos Islands'
   */
  tc: T;

  /**
   * @default 'Tuvalu'
   */
  tv: T;

  /**
   * @default 'Uganda'
   */
  ug: T;

  /**
   * @default 'Ukraine'
   */
  ua: T;

  /**
   * @default 'United Arab Emirates'
   */
  ae: T;

  /**
   * @default 'United Kingdom'
   */
  gb: T;

  /**
   * @default 'United States Minor Outlying Islands'
   */
  um: T;

  /**
   * @default 'United States'
   */
  us: T;

  /**
   * @default 'Uruguay'
   */
  uy: T;

  /**
   * @default 'Uzbekistan'
   */
  uz: T;

  /**
   * @default 'Vanuatu'
   */
  vu: T;

  /**
   * @default 'Venezuela'
   */
  ve: T;

  /**
   * @default 'Viet Nam'
   */
  vn: T;

  /**
   * @default 'Virgin Islands (British)'
   */
  vg: T;

  /**
   * @default 'Virgin Islands (U.S.)'
   */
  vi: T;

  /**
   * @default 'Wallis and Futuna'
   */
  wf: T;

  /**
   * @default 'Western Sahara'
   */
  eh: T;

  /**
   * @default 'Yemen'
   */
  ye: T;

  /**
   * @default 'Zambia'
   */
  zm: T;

  /**
   * @default 'Zimbabwe'
   */
  zw: T;
};

export type CreateBabyRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Create your Joy Event'
   */
  title: T;

  /**
   * @default 'Start creating your registry today and celebrate this special milestone with Joy!'
   */
  description: T;

  /**
   * @default 'Congratulations! You’re in for an amazing journey.'
   */
  heroText: T;

  /**
   * @default 'Let’s get your registry started.<helpChangeDetails/>'
   */
  helpText: T;

  /**
   * @default 'You can change these details later.'
   */
  helpChangeDetails: T;

  createEventForm: {
    /**
     * @default 'Your First Name'
     */
    ownerFirstName: T;

    /**
     * @default 'Your Last Name'
     */
    ownerLastName: T;

    /**
     * @default 'Pat'
     */
    ownerFirstNamePlaceholder: T;

    /**
     * @default 'Smith'
     */
    ownerLastNamePlaceholder: T;

    /**
     * @default 'Baby’s Estimated Arrival Date'
     */
    babyArrivalDate: T;

    /**
     * @default 'Not sure yet'
     */
    skipDateDefinition: T;

    /**
     * @default 'Create Registry'
     */
    createEventCta: T;

    errors: {
      /**
       * @default 'First name is required.'
       */
      ownerFirstNameRequired: T;

      /**
       * @default 'Last name is required.'
       */
      ownerLastNameRequired: T;

      /**
       * @default 'Baby’s estimated arrival date is required.'
       */
      registryDateRequired: T;
    };
  };
};

export type CreateEventTranslations<T extends LeafNodeValue = TranslateFunction> = {
  createAccount: {
    general: {
      /**
       * @default ''
       */
      devAlertMessage: T;
    };
    wedding: {
      /**
       * @default 'This is a test environment for the Joy engineering team. Are you sure you want to create an event here? Click cancel to be redirected to our main site.'
       */
      devAlertMessage: T;
    };
    babyRegistry: {
      /**
       * @default 'This is a test environment for the Joy engineering team. Are you sure you want to create a baby registry here? Click cancel to be redirected to our main site.'
       */
      devAlertMessage: T;

      /**
       * @default 'Celebrate life’s joyful moments.'
       */
      heroText: T;

      /**
       * @default 'Create one account for all your Joy events. Sign up or'
       */
      helpText: T;
    };
    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email address'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };

    /**
     * @default 'log in.'
     */
    signIn: T;

    /**
     * @default 'Sign in with Facebook'
     */
    signInWithFacebook: T;

    /**
     * @default 'Sign in with Google'
     */
    signInWithGoogle: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Create Account'
     */
    createAccountCta: T;

    /**
     * @default 'privacy policy'
     */
    privacyPolicy: T;

    /**
     * @default 'terms of service'
     */
    termsOfService: T;

    /**
     * @default 'CA Privacy Notice.'
     */
    privacyNotice: T;

    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;
  };
  socialAccount: {
    /**
     * @default 'To create a baby registry, sign in with email and password'
     */
    createEventTitle: T;

    /**
     * @default 'You're currently signed in with {{provider}}, and creating baby registry with {{provider}} is no longer supported.'
     */
    currentAuthDisclaimer: T;

    /**
     * @default 'The good news is you can still create a baby registry by signing in with email and password.'
     */
    goodNews: T;

    /**
     * @default 'Create registry with email and password'
     */
    createEventCta: T;
  };
  searchBanner: {
    /**
     * @default 'Looking for an event or registry?'
     */
    text: T;
  };
  notYou: {
    /**
     * @default 'Not {{email}}?'
     */
    changeAccount: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;
  };
  tyingTheKnot: {
    /**
     * @default 'We've thought of everything, so you don't have to.'
     */
    loadingText: T;

    /**
     * @default 'Help Center'
     */
    helpCenter: T;

    /**
     * @default 'Oops! Something’s amiss. Disable Adblocker or VPN and try again. If the issue continues, visit our <HelpCenter/>'
     */
    errorText: T;
  };
  quick: {
    /**
     * @default 'There was an error creating your account. Please try again.'
     */
    iEg0c: T;
  };
};

export type CreateGeneralTranslations<T extends LeafNodeValue = TranslateFunction> = {
  createGeneralForm: {
    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;
  };
  quick: {
    /**
     * @default 'Let's get started!'
     */
    '7iAU4': T;

    /**
     * @default 'Fill in the details to create your {{0}}.
They can be adjusted later if needed.'
*/
    Sx1oK: T;

    /**
     * @default 'Create Event'
     */
    yIXZw: T;

    /**
     * @default 'There was an issue creating your event. Please try again.'
     */
    ueZxA: T;

    /**
     * @default 'Choose Event Category'
     */
    zX514: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Please enter an email'
     */
    fwiR3: T;

    /**
     * @default 'Please enter a password'
     */
    WdKje: T;

    /**
     * @default 'An account with this email already exists. Please sign in.'
     */
    mBHbJ: T;

    /**
     * @default 'There was an error creating your account. Please try again.'
     */
    iEg0c: T;

    /**
     * @default 'Hi! Let's get started.'
     */
    cr4mg: T;

    /**
     * @default 'Already have an account?'
     */
    RsKwS: T;

    /**
     * @default 'Log in'
     */
    '10NHD': T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'Create Account'
     */
    TZwKT: T;

    /**
     * @default 'Please select an event type'
     */
    rjg9N: T;

    /**
     * @default 'Please enter a name for your event'
     */
    kX9j6: T;

    /**
     * @default 'Please enter a location'
     */
    OQjB2: T;

    /**
     * @default 'Description must be {{0}} characters or fewer'
     */
    qEbg8: T;

    /**
     * @default 'Please describe your website'
     */
    bR5SP: T;

    /**
     * @default 'Event start time cannot be in the past. Setting to next available time.'
     */
    deN0L: T;

    /**
     * @default 'End date must be after start date. Setting to next available time.'
     */
    JxgLc: T;

    /**
     * @default 'Select event type'
     */
    oKAyu: T;

    /**
     * @default 'Describe your website'
     */
    HUnHI: T;

    /**
     * @default 'We'll design your website from this. You can change everything later.'
     */
    V2gD0: T;

    /**
     * @default 'e.g. A relaxed summer party site with the schedule, directions, and an RSVP. Bright colors, playful type.'
     */
    oiBou: T;

    /**
     * @default 'Event Start'
     */
    gQM8O: T;

    /**
     * @default 'Event End'
     */
    dKqb6: T;

    /**
     * @default 'Event Timezone'
     */
    '1oUd0': T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'There was an error resetting your password. Please try again.'
     */
    cOoZh: T;

    /**
     * @default 'Forgot your password?'
     */
    KylRy: T;

    /**
     * @default 'Enter the email you used to signup for Joy and we'll send you an email to reset it.'
     */
    guSNM: T;

    /**
     * @default 'Reset Password'
     */
    c9fHt: T;

    /**
     * @default 'New to Joy?'
     */
    MXi7b: T;

    /**
     * @default 'There was an error signing in. Please try again.'
     */
    H2zq6: T;

    /**
     * @default 'Log into Joy. 🎉'
     */
    Bm1HF: T;

    /**
     * @default 'Don't have an account?'
     */
    '3kFXl': T;

    /**
     * @default 'Forgot password?'
     */
    lxOzM: T;
  };
};

export type CreateRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  addRegistryDialog: {
    /**
     * @default 'Link Registry'
     */
    title: T;

    /**
     * @default 'Edit Registry'
     */
    updateTitle: T;

    /**
     * @default 'Update Registry'
     */
    actionUpdateText: T;

    /**
     * @default 'Save'
     */
    actionText: T;

    /**
     * @default 'Cancel'
     */
    cancelActionText: T;

    /**
     * @default 'Registry Link'
     */
    urlInputLabel: T;

    /**
     * @default 'Registry Title'
     */
    nameInputLabel: T;

    /**
     * @default 'Link'
     */
    urlInputPlaceholder: T;

    /**
     * @default 'Title'
     */
    nameInputPlaceholder: T;

    /**
     * @default 'Registry Image'
     */
    registryImageLabel: T;

    /**
     * @default 'Delete Registry'
     */
    deleteActionText: T;

    /**
     * @default 'Test Registry Link'
     */
    testLink: T;
  };
  experiments: {
    installBrowserButton: {
      native: {
        /**
         * @default 'Find and Add'
         */
        buttonText: T;
      };
      mobile: {
        /**
         * @default 'Open Joy App'
         */
        buttonText: T;
      };
      default: {
        /**
         * @default 'Get the Quick Add Button'
         */
        buttonText: T;
      };
    };
  };
  transferRegistry: {
    /**
     * @default 'Don’t forget to make your old registry private'
     */
    publicReminderTitle: T;

    /**
     * @default 'The registry you transferred to Joy is still publicly visible, which can result in duplicate gifts. We recommend hiding the following registry:'
     */
    publicReminderSubtitle: T;

    /**
     * @default 'Continue adding gifts from your favorite stores using the'
     */
    publicReminderDesc: T;

    /**
     * @default 'Joy Browser Button'
     */
    publicReminderCTA: T;

    /**
     * @default ' or the '
     */
    publicReminderCTACont: T;

    /**
     * @default 'Joy App'
     */
    publicReminderCTAApp: T;

    /**
     * @default 'Got It'
     */
    publicReminderButton: T;

    /**
     * @default 'Set your {{storeName}} registry private to avoid duplicate gifts.'
     */
    bannerTitle: T;

    /**
     * @default 'Your registry was last seen as public at {{lastCheckDate}}.'
     */
    bannerSubtitle: T;

    /**
     * @default 'Fix Privacy'
     */
    bannerButton: T;

    /**
     * @default 'We only check this once a day, so if it doesn't seem accurate please check back tomorrow.'
     */
    bannerTooltip: T;

    /**
     * @default 'Learn How'
     */
    learnHow: T;
  };
};

export type CreateWeddingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Create your Joy Event'
   */
  title: T;

  /**
   * @default 'Craft your dream wedding with Joy and become part of a community of over one million  couples who effortlessly planned their special day with joy and ease!'
   */
  description: T;

  createAccount: {
    scenarios: {
      default: {
        /**
         * @default 'Hi! Let’s get started.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'save-the-date': {
        /**
         * @default 'Smarter Save the Dates, coming right up.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      invitation: {
        /**
         * @default 'Smarter invitations, coming right up.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'wedding-website': {
        /**
         * @default 'Let’s get ready to get planning'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'guest-list': {
        /**
         * @default 'Start building your smarter guest list.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      registry: {
        /**
         * @default 'Start building your all-in-one registry.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      app: {
        /**
         * @default 'The smarter app for you and your guests.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'imagine-your-card': {
        /**
         * @default 'Sign up for free to finish creating your card'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
    };
    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };

    /**
     * @default 'Sign In.'
     */
    signIn: T;

    /**
     * @default 'Sign in with Facebook'
     */
    signInWithFacebook: T;

    /**
     * @default 'Sign in with Google'
     */
    signInWithGoogle: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Create Account'
     */
    createAccountCta: T;

    /**
     * @default 'privacy policy'
     */
    privacyPolicy: T;

    /**
     * @default 'terms of service'
     */
    termsOfService: T;

    /**
     * @default 'CA Privacy Notice.'
     */
    privacyNotice: T;

    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;

    /**
     * @default 'Attending as a guest?'
     */
    findCoupleText: T;

    /**
     * @default 'Find a Couple'
     */
    findCoupleLink: T;

    /**
     * @default 'Join over one million happy couples who planned their wedding with Joy.'
     */
    sidebarText: T;
  };
  signIn: {
    /**
     * @default 'Log into Joy. 🎉'
     */
    heroText: T;

    /**
     * @default 'Don't have an account?'
     */
    helpText: T;

    /**
     * @default 'Create Account.'
     */
    createAccount: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Login'
     */
    login: T;

    /**
     * @default 'Forgot password?'
     */
    forgotCredentials: T;

    /**
     * @default 'Join over one million happy couples'
     */
    socialProofBanner: T;

    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };
  };
  forgotPassword: {
    /**
     * @default 'Forgot your password?'
     */
    heroText: T;

    /**
     * @default 'Enter the email you used to signup for Joy and we’ll send you an email to reset it.'
     */
    helpText: T;

    /**
     * @default 'Enter your email'
     */
    email: T;

    /**
     * @default 'Reset Password'
     */
    resetPassword: T;

    /**
     * @default 'Already have an account?'
     */
    accountExists: T;

    /**
     * @default 'Log in'
     */
    login: T;

    /**
     * @default 'New to Joy?'
     */
    createAccountCta: T;

    /**
     * @default 'Create An Account'
     */
    createAccount: T;
  };
  tyingTheKnot: {
    /**
     * @default 'We've thought of everything, so you don't have to.'
     */
    loadingText: T;

    /**
     * @default 'Help Center'
     */
    helpCenter: T;

    /**
     * @default 'Oops! Something’s amiss. Disable Adblocker or VPN and try again. If the issue continues, visit our <HelpCenter/>'
     */
    errorText: T;

    /**
     * @default 'You’re rocking event creation! To keep things smooth for everyone, kindly space out your event creations and try again in about an hour. If the issue continues, visit our <HelpCenter/>'
     */
    rateLimitErrorText: T;
  };
  quick: {
    /**
     * @default 'Smarter Save the Dates, coming right up.'
     */
    FesyD: T;

    /**
     * @default 'Smarter invitations, coming right up.'
     */
    C18js: T;

    /**
     * @default 'Let's get ready to plan.'
     */
    UAvKT: T;

    /**
     * @default 'Start building your smarter guest list.'
     */
    rkqWq: T;

    /**
     * @default 'Start building your all-in-one registry.'
     */
    '03cjm': T;

    /**
     * @default 'The smarter app for you and your guests.'
     */
    xb18K: T;

    /**
     * @default 'Sign up for free to finish creating your card'
     */
    ZEKmP: T;

    /**
     * @default 'Hi! Let's get started.'
     */
    cr4mg: T;

    /**
     * @default 'Loading form'
     */
    ENsVe: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Print'
     */
    DdvrG: T;

    /**
     * @default 'A website designed just for the two of you'
     */
    rpIjf: T;

    /**
     * @default 'A beautiful new website for the two of you'
     */
    '5dXLB': T;

    /**
     * @default 'Tell us your story and we'll design a site with as much personality as you. Or start from a designer template and make it yours.'
     */
    gwL4m: T;

    /**
     * @default 'Choose from our selection of professionally designed templates.'
     */
    CTThM: T;

    /**
     * @default 'Design my website'
     */
    Huons: T;

    /**
     * @default 'Choose my design'
     */
    dQJsU: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Skip'
     */
    TMBNA: T;

    /**
     * @default 'NEW · BETA'
     */
    VGtOB: T;

    /**
     * @default 'Prefer the website builder you know?'
     */
    g7iTO: T;

    /**
     * @default 'Use the classic Joy website'
     */
    HZM6K: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Please enter an email'
     */
    fwiR3: T;

    /**
     * @default 'Please enter a password'
     */
    WdKje: T;

    /**
     * @default 'An account with this email already exists. Please sign in.'
     */
    mBHbJ: T;

    /**
     * @default 'There was an error creating your account. Please try again.'
     */
    iEg0c: T;

    /**
     * @default 'Already have an account?'
     */
    RsKwS: T;

    /**
     * @default 'Sign In'
     */
    M4Z7E: T;

    /**
     * @default 'Sign in with Facebook'
     */
    '8Jxc7': T;

    /**
     * @default 'Sign in with Google'
     */
    xQMwM: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'We need your first name.'
     */
    '4d4cM': T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    '5dGnM': T;

    /**
     * @default 'You can add a venue you’re considering and update this later — or check the box to skip for now.'
     */
    cg24B: T;

    /**
     * @default 'Your First Name'
     */
    '6LL3C': T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Your Partner's First Name'
     */
    u2PMt: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'We didn't find any venues. Try searching for a specific venue name.'
     */
    '4Vq6v': T;

    /**
     * @default 'We’re still deciding'
     */
    ppZGU: T;

    /**
     * @default 'Event Date'
     */
    M6IZn: T;

    /**
     * @default 'Create Event'
     */
    yIXZw: T;

    /**
     * @default 'Not {{0}}?'
     */
    Y6pbU: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;

    /**
     * @default 'There was an error resetting your password. Please try again.'
     */
    cOoZh: T;

    /**
     * @default 'Forgot your password?'
     */
    KylRy: T;

    /**
     * @default 'Enter the email you used to signup for Joy and we’ll send you a link to reset it.'
     */
    '4B8Jp': T;

    /**
     * @default 'Enter your email'
     */
    '94moV': T;

    /**
     * @default 'Reset Password'
     */
    c9fHt: T;

    /**
     * @default 'New to Joy?'
     */
    MXi7b: T;

    /**
     * @default 'Create An Account'
     */
    oylbR: T;

    /**
     * @default 'There was an error signing in. Please try again.'
     */
    H2zq6: T;

    /**
     * @default 'Don't have an account?'
     */
    '3kFXl': T;

    /**
     * @default 'Create One'
     */
    o3xZ0: T;

    /**
     * @default 'Don't remember?'
     */
    ykaTt: T;

    /**
     * @default 'To create an event, sign in with email and password'
     */
    '81Ny9': T;

    /**
     * @default 'You're currently signed in with {{0}}, and creating events with {{1}} is no longer supported.'
     */
    uO4QH: T;

    /**
     * @default 'The good news is you can still create an event by signing in with email and password.'
     */
    ybVjw: T;

    /**
     * @default 'Create event with email and password'
     */
    m5b8g: T;

    /**
     * @default 'We've thought of everything, so you don't have to.'
     */
    ZpUAs: T;

    /**
     * @default 'Your Wedding'
     */
    fDMR7: T;

    /**
     * @default 'You're on a roll!'
     */
    B9Bfs: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Start over'
     */
    CCbKJ: T;

    /**
     * @default 'Can't reach our servers'
     */
    erCUo: T;

    /**
     * @default 'We're having trouble saving your event'
     */
    F2Xh8: T;

    /**
     * @default 'Looks like a browser extension, VPN, or network issue is blocking the connection. Try disabling your adblocker or VPN, then tap Retry.'
     */
    '0RfkI': T;

    /**
     * @default 'Our side is taking longer than usual — not your fault. Tap Retry to try again.'
     */
    uCub1: T;

    /**
     * @default 'Your event details are saved.'
     */
    yJ2hw: T;

    /**
     * @default '✨ Attending an event?'
     */
    ukIOa: T;

    /**
     * @default 'Find Event'
     */
    '7arcT': T;

    /**
     * @default 'We'll need a few details first.'
     */
    Y5suL: T;

    /**
     * @default 'Invalid template settings payload'
     */
    MZ3tl: T;

    /**
     * @default 'Invalid website design settings'
     */
    JARlU: T;

    /**
     * @default 'Failed to parse website design settings'
     */
    z7LVU: T;
  };
};

export type CurationsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  curations: {
    /**
     * @default 'Curations'
     */
    departmentTitle: T;

    /**
     * @default 'Home'
     */
    defaultDepartmentTitle: T;
  };
  sections: {
    /**
     * @default 'Explore more collections'
     */
    exploreOthersTitle: T;

    /**
     * @default 'Add All'
     */
    addAll: T;

    /**
     * @default 'Added'
     */
    addedAll: T;

    /**
     * @default 'Added to Registry'
     */
    addedAllToRegistry: T;

    /**
     * @default 'Add All to Registry'
     */
    addAllToRegistry: T;
  };
};

export type CurrenciesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'United States Dollar'
     */
    '91iKh': T;

    /**
     * @default 'Euro'
     */
    '5N7KA': T;

    /**
     * @default 'Pound Sterling'
     */
    '01bzz': T;

    /**
     * @default 'Canadian Dollar'
     */
    d8ElE: T;

    /**
     * @default 'Australian Dollar'
     */
    qEwoZ: T;

    /**
     * @default 'Japanese Yen'
     */
    ziRcO: T;

    /**
     * @default 'New Zealand Dollar'
     */
    tvakv: T;

    /**
     * @default 'Singapore Dollar'
     */
    QPHVg: T;

    /**
     * @default 'UAE Dirham'
     */
    A61Mt: T;

    /**
     * @default 'Afghan Afghani'
     */
    V5sCv: T;

    /**
     * @default 'Albanian Lek'
     */
    '8jLSw': T;

    /**
     * @default 'Armenian Dram'
     */
    NJvdK: T;

    /**
     * @default 'Netherlands Antillean Guilder'
     */
    Y2qpd: T;

    /**
     * @default 'Angolan Kwanza'
     */
    cKzts: T;

    /**
     * @default 'Argentine Peso'
     */
    '08sBl': T;

    /**
     * @default 'Aruban Florin'
     */
    vOEc0: T;

    /**
     * @default 'Azerbaijani Manat'
     */
    jN0jL: T;

    /**
     * @default 'Bosnia-Herzegovina Convertible Mark'
     */
    nSUo4: T;

    /**
     * @default 'Barbadian Dollar'
     */
    mIbUD: T;

    /**
     * @default 'Bangladeshi Taka'
     */
    r0ccU: T;

    /**
     * @default 'Bulgarian Lev'
     */
    sWVPQ: T;

    /**
     * @default 'Bahraini Dinar'
     */
    Q0r5i: T;

    /**
     * @default 'Burundian Franc'
     */
    CCliJ: T;

    /**
     * @default 'Bermudan Dollar'
     */
    Kd3mh: T;

    /**
     * @default 'Brunei Dollar'
     */
    txArX: T;

    /**
     * @default 'Bolivian Boliviano'
     */
    '70FIj': T;

    /**
     * @default 'Brazilian Real'
     */
    Wryle: T;

    /**
     * @default 'Bahamian Dollar'
     */
    '3mD77': T;

    /**
     * @default 'Bhutanese Ngultrum'
     */
    Pv9Fa: T;

    /**
     * @default 'Botswanan Pula'
     */
    Z9y5S: T;

    /**
     * @default 'Belarusian Ruble'
     */
    GRZLz: T;

    /**
     * @default 'Belize Dollar'
     */
    jtG33: T;

    /**
     * @default 'Congolese Franc'
     */
    '9ApBH': T;

    /**
     * @default 'Swiss Franc'
     */
    '7a3S7': T;

    /**
     * @default 'Chilean Peso'
     */
    D80O0: T;

    /**
     * @default 'Chinese Yuan'
     */
    QuuK8: T;

    /**
     * @default 'Colombian Peso'
     */
    lTfAX: T;

    /**
     * @default 'Costa Rican Colón'
     */
    gjjWF: T;

    /**
     * @default 'Cuban Peso'
     */
    aVYI7: T;

    /**
     * @default 'Cape Verdean Escudo'
     */
    Pppmh: T;

    /**
     * @default 'Czech Koruna'
     */
    VWjfg: T;

    /**
     * @default 'Djiboutian Franc'
     */
    r2hWE: T;

    /**
     * @default 'Danish Krone'
     */
    ykh7O: T;

    /**
     * @default 'Dominican Peso'
     */
    NYljL: T;

    /**
     * @default 'Algerian Dinar'
     */
    vNHAg: T;

    /**
     * @default 'Egyptian Pound'
     */
    RdiD4: T;

    /**
     * @default 'Eritrean Nakfa'
     */
    Z1fCS: T;

    /**
     * @default 'Ethiopian Birr'
     */
    iLzFe: T;

    /**
     * @default 'Fijian Dollar'
     */
    xHF5Y: T;

    /**
     * @default 'Falkland Islands Pound'
     */
    rTl7T: T;

    /**
     * @default 'Georgian Lari'
     */
    GhWB2: T;

    /**
     * @default 'Ghanaian Cedi'
     */
    '6ltPy': T;

    /**
     * @default 'Gibraltar Pound'
     */
    ae4s2: T;

    /**
     * @default 'Gambian Dalasi'
     */
    jl3bQ: T;

    /**
     * @default 'Guinean Franc'
     */
    t6s91: T;

    /**
     * @default 'Guatemalan Quetzal'
     */
    xkRLb: T;

    /**
     * @default 'Guyanaese Dollar'
     */
    '2fkjR': T;

    /**
     * @default 'Hong Kong Dollar'
     */
    x4gZG: T;

    /**
     * @default 'Honduran Lempira'
     */
    zxOou: T;

    /**
     * @default 'Croatian Kuna'
     */
    UMxwW: T;

    /**
     * @default 'Haitian Gourde'
     */
    avcFq: T;

    /**
     * @default 'Hungarian Forint'
     */
    dvsUS: T;

    /**
     * @default 'Indonesian Rupiah'
     */
    tawpm: T;

    /**
     * @default 'Israeli New Shekel'
     */
    HGTx3: T;

    /**
     * @default 'Indian Rupee'
     */
    sGtkI: T;

    /**
     * @default 'Iraqi Dinar'
     */
    '0GvWn': T;

    /**
     * @default 'Iranian Rial'
     */
    IP2ZD: T;

    /**
     * @default 'Icelandic Króna'
     */
    ZNhV4: T;

    /**
     * @default 'Jamaican Dollar'
     */
    '8X3b0': T;

    /**
     * @default 'Jordanian Dinar'
     */
    OX9Yb: T;

    /**
     * @default 'Kenyan Shilling'
     */
    mrODp: T;

    /**
     * @default 'Kyrgystani Som'
     */
    O1OJf: T;

    /**
     * @default 'Cambodian Riel'
     */
    kD1xc: T;

    /**
     * @default 'Comorian Franc'
     */
    A32bV: T;

    /**
     * @default 'North Korean Won'
     */
    VXkNf: T;

    /**
     * @default 'South Korean Won'
     */
    D8HqL: T;

    /**
     * @default 'Kuwaiti Dinar'
     */
    a959r: T;

    /**
     * @default 'Cayman Islands Dollar'
     */
    Nk217: T;

    /**
     * @default 'Kazakhstani Tenge'
     */
    '2jZFM': T;

    /**
     * @default 'Laotian Kip'
     */
    '40DCy': T;

    /**
     * @default 'Lebanese Pound'
     */
    J6Eu1: T;

    /**
     * @default 'Sri Lankan Rupee'
     */
    '8geaW': T;

    /**
     * @default 'Liberian Dollar'
     */
    AWEaF: T;

    /**
     * @default 'Lesotho Loti'
     */
    k1XYe: T;

    /**
     * @default 'Libyan Dinar'
     */
    ZMzsI: T;

    /**
     * @default 'Moroccan Dirham'
     */
    ziqKC: T;

    /**
     * @default 'Moldovan Leu'
     */
    eMIoa: T;

    /**
     * @default 'Malagasy Ariary'
     */
    vcWhH: T;

    /**
     * @default 'Macedonian Denar'
     */
    pOZBn: T;

    /**
     * @default 'Myanma Kyat'
     */
    CZXim: T;

    /**
     * @default 'Mongolian Tugrik'
     */
    kDfuX: T;

    /**
     * @default 'Macanese Pataca'
     */
    H4wyi: T;

    /**
     * @default 'Mauritanian Ouguiya'
     */
    o62aO: T;

    /**
     * @default 'Mauritian Rupee'
     */
    fyO5o: T;

    /**
     * @default 'Maldivian Rufiyaa'
     */
    A9qlC: T;

    /**
     * @default 'Malawian Kwacha'
     */
    NSaFH: T;

    /**
     * @default 'Mexican Peso'
     */
    az28P: T;

    /**
     * @default 'Malaysian Ringgit'
     */
    xNldb: T;

    /**
     * @default 'Mozambican Metical'
     */
    gAkuI: T;

    /**
     * @default 'Namibian Dollar'
     */
    HxM38: T;

    /**
     * @default 'Nigerian Naira'
     */
    MY7o3: T;

    /**
     * @default 'Nicaraguan Córdoba'
     */
    LOobO: T;

    /**
     * @default 'Norwegian Krone'
     */
    rLxwL: T;

    /**
     * @default 'Nepalese Rupee'
     */
    A50YX: T;

    /**
     * @default 'Omani Rial'
     */
    GzNL4: T;

    /**
     * @default 'Panamanian Balboa'
     */
    '3Pvej': T;

    /**
     * @default 'Peruvian Sol'
     */
    SHb9j: T;

    /**
     * @default 'Papua New Guinean Kina'
     */
    nSW0R: T;

    /**
     * @default 'Philippine Peso'
     */
    n3Qio: T;

    /**
     * @default 'Pakistani Rupee'
     */
    PpUtC: T;

    /**
     * @default 'Polish Zloty'
     */
    THneg: T;

    /**
     * @default 'Paraguayan Guarani'
     */
    QCvPe: T;

    /**
     * @default 'Qatari Riyal'
     */
    hFRnY: T;

    /**
     * @default 'Romanian Leu'
     */
    '3y8hs': T;

    /**
     * @default 'Serbian Dinar'
     */
    oNLFw: T;

    /**
     * @default 'Russian Ruble'
     */
    Pssd8: T;

    /**
     * @default 'Rwandan Franc'
     */
    '5YFfp': T;

    /**
     * @default 'Saudi Riyal'
     */
    Fr0T1: T;

    /**
     * @default 'Solomon Islands Dollar'
     */
    HcbL9: T;

    /**
     * @default 'Seychellois Rupee'
     */
    nF4bm: T;

    /**
     * @default 'Sudanese Pound'
     */
    EfKEr: T;

    /**
     * @default 'Swedish Krona'
     */
    ALwNz: T;

    /**
     * @default 'Saint Helena Pound'
     */
    YZ9Td: T;

    /**
     * @default 'Sierra Leonean Leone'
     */
    X076T: T;

    /**
     * @default 'Somali Shilling'
     */
    vijPc: T;

    /**
     * @default 'Surinamese Dollar'
     */
    sp0MN: T;

    /**
     * @default 'South Sudanese Pound'
     */
    bzZLJ: T;

    /**
     * @default 'São Tomé and Príncipe Dobra'
     */
    JlOSX: T;

    /**
     * @default 'Salvadoran Colón'
     */
    '89OgX': T;

    /**
     * @default 'Syrian Pound'
     */
    aDcF0: T;

    /**
     * @default 'Swazi Lilangeni'
     */
    BE4HK: T;

    /**
     * @default 'Thai Baht'
     */
    hMFVj: T;

    /**
     * @default 'Tajikistani Somoni'
     */
    WNRc9: T;

    /**
     * @default 'Turkmenistani Manat'
     */
    zCwK6: T;

    /**
     * @default 'Tunisian Dinar'
     */
    zlgmG: T;

    /**
     * @default 'Tongan Paʻanga'
     */
    ABXOY: T;

    /**
     * @default 'Turkish Lira'
     */
    i4OlD: T;

    /**
     * @default 'Trinidad and Tobago Dollar'
     */
    qr8j1: T;

    /**
     * @default 'New Taiwan Dollar'
     */
    EkwWK: T;

    /**
     * @default 'Tanzanian Shilling'
     */
    aiaqp: T;

    /**
     * @default 'Ukrainian Hryvnia'
     */
    HquPr: T;

    /**
     * @default 'Ugandan Shilling'
     */
    qDtgg: T;

    /**
     * @default 'Uruguayan Peso'
     */
    e5jQw: T;

    /**
     * @default 'Uzbekistan Som'
     */
    bUNZJ: T;

    /**
     * @default 'Venezuelan Bolívar'
     */
    kAB7y: T;

    /**
     * @default 'Vietnamese Dong'
     */
    XLkxZ: T;

    /**
     * @default 'Vanuatu Vatu'
     */
    CvSv9: T;

    /**
     * @default 'Samoan Tala'
     */
    XpfSR: T;

    /**
     * @default 'Central African CFA Franc'
     */
    N2gqo: T;

    /**
     * @default 'East Caribbean Dollar'
     */
    eime6: T;

    /**
     * @default 'West African CFA Franc'
     */
    L2LIA: T;

    /**
     * @default 'CFP Franc'
     */
    na8YI: T;

    /**
     * @default 'Yemeni Rial'
     */
    nsG9b: T;

    /**
     * @default 'South African Rand'
     */
    cKf1f: T;

    /**
     * @default 'Zambian Kwacha'
     */
    '3Fd6G': T;

    /**
     * @default 'Zimbabwean Dollar'
     */
    yQv8v: T;
  };
};

export type CurrencySelectorV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select currency...'
     */
    pyibc: T;

    /**
     * @default 'Search currencies...'
     */
    NdqvD: T;

    /**
     * @default 'No currencies found'
     */
    sq1Ai: T;

    /**
     * @default 'Choose Currency'
     */
    MoS3a: T;

    /**
     * @default 'Popular Currencies'
     */
    '0LMNd': T;

    /**
     * @default 'All Currencies'
     */
    WzVjY: T;
  };
};

export type CustomBlockConfigTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Wedding Party'
     */
    QfgiL: T;

    /**
     * @default 'Guest Q&A'
     */
    gMg7F: T;

    /**
     * @default 'VIPs'
     */
    uYTNA: T;

    /**
     * @default 'FAQs'
     */
    ri1KA: T;
  };
};

export type CustomDomainTranslations<T extends LeafNodeValue = TranslateFunction> = {
  domainSearch: {
    /**
     * @default 'Personalize Your URL'
     */
    personalizeURL: T;

    /**
     * @default 'may be available'
     */
    domainSuggestion: T;

    /**
     * @default 'Custom domains are an optional service provided by GoDaddy, not Joy. Domain masking is not supported.'
     */
    poweredByText: T;

    /**
     * @default 'Learn more'
     */
    learnMoreText: T;
  };
  addDomainDialog: {
    /**
     * @default 'How would you like to add a custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Find the Perfect Domain'
     */
    buttonText: T;

    /**
     * @default 'I already have a domain'
     */
    linkText: T;
  };
  connectDomainDialog: {
    /**
     * @default 'Did you just buy a new domain?'
     */
    dialogTitle: T;

    /**
     * @default 'We’ll walk you through how to connect your domain to your Joy website.'
     */
    dialogSubtitle: T;

    /**
     * @default 'Yes, Connect My Domain'
     */
    buttonText: T;

    /**
     * @default 'No, but maybe later'
     */
    laterText: T;

    /**
     * @default 'No, I’m not interested'
     */
    notInterestedText: T;

    dialogActions: [
      {
        /**
         * @default 'Search Again'
         */
        title: T;

        /**
         * @default 'Find the domain you’re looking for.'
         */
        description: T;

        /**
         * @default 'Search Domains'
         */
        actionText: T;
      },
      {
        /**
         * @default 'Have More Questions?'
         */
        title: T;

        /**
         * @default 'Our FAQ section may have the answers.'
         */
        description: T;

        /**
         * @default 'Explore FAQs'
         */
        actionText: T;
      },
      {
        /**
         * @default 'We’re Here For You'
         */
        title: T;

        /**
         * @default 'Our team is just a chat bubble away.'
         */
        description: T;

        /**
         * @default 'Talk to Us'
         */
        actionText: T;
      },
    ];
  };
  findDomainDialog: {
    /**
     * @default 'may be available...'
     */
    dialogTitlePart: T;

    /**
     * @default 'Personalize your site and make it easier to share with a custom domain.'
     */
    dialogSubtitle: T;

    /**
     * @default 'Find the Perfect Domain'
     */
    buttonText: T;

    /**
     * @default 'Settings'
     */
    settingsText: T;

    /**
     * @default 'Your withjoy.com URL can be changed in <SettingsLink/>.'
     */
    urlChangeNotice: T;
  };
  inputDomainDialog: {
    /**
     * @default 'What is your custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Having trouble? '
     */
    dialogHelpText: T;

    /**
     * @default 'We’re here to help'
     */
    dialogHelpTextLink: T;

    /**
     * @default 'Test URL'
     */
    testButtonText: T;

    /**
     * @default 'Save'
     */
    saveButtonText: T;

    /**
     * @default 'Domain cannot be blank'
     */
    blankDomainError: T;

    /**
     * @default 'Not a valid domain'
     */
    notValidDomainError: T;
  };
  removeDomainDialog: {
    /**
     * @default 'Are you sure you want to remove your custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Removing your custom domain removes it from your eCards, but it will not disconnect it with your provider.'
     */
    descriptionText: T;

    /**
     * @default 'Need help disconnecting your domain?'
     */
    linkText: T;

    /**
     * @default 'Remove Domain'
     */
    buttonText: T;

    /**
     * @default 'Cancel'
     */
    cancelText: T;
  };
  soundsGoodDialog: {
    /**
     * @default 'Sounds Good!'
     */
    dialogTitle: T;

    /**
     * @default 'You can come back to search for a custom domain anytime. '
     */
    dialogSubtitle: T;
  };
  quick: {
    /**
     * @default '{{0}} and {{1}}'
     */
    ifsOv: T;
  };
};

export type CustomPageTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'An error occurred while deleting the accommodation. Please try again.'
     */
    '5m93k': T;
  };
};

export type CustomPhotoPreviewButtonTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Preview With Your Photo'
     */
    xLr2O: T;

    /**
     * @default 'Change Your Photos'
     */
    eMfqM: T;

    /**
     * @default 'Change Your Photo'
     */
    LIJ8i: T;
  };
};

export type DatesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  translatedDates: {
    /**
     * @default 'Today'
     */
    today: T;

    weekdayNames: [
      /**
       * @default 'Sunday'
       */
      T,
      /**
       * @default 'Monday'
       */
      T,
      /**
       * @default 'Tuesday'
       */
      T,
      /**
       * @default 'Wednesday'
       */
      T,
      /**
       * @default 'Thursday'
       */
      T,
      /**
       * @default 'Friday'
       */
      T,
      /**
       * @default 'Saturday'
       */
      T,
    ];

    monthNames: [
      /**
       * @default 'January'
       */
      T,
      /**
       * @default 'February'
       */
      T,
      /**
       * @default 'March'
       */
      T,
      /**
       * @default 'April'
       */
      T,
      /**
       * @default 'May'
       */
      T,
      /**
       * @default 'June'
       */
      T,
      /**
       * @default 'July'
       */
      T,
      /**
       * @default 'August'
       */
      T,
      /**
       * @default 'September'
       */
      T,
      /**
       * @default 'October'
       */
      T,
      /**
       * @default 'November'
       */
      T,
      /**
       * @default 'December'
       */
      T,
    ];
  };
  time: {
    minutesFromNow: {
      /**
       * @default '{{count}} minute ago'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} minute ago
       * - plural: {{count}} minutes ago
       */
      minute: T;
    };
    hoursFromNow: {
      /**
       * @default '{{count}} hour ago'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} hour ago
       * - plural: {{count}} hours ago
       */
      hour: T;
    };
  };
  quick: {
    /**
     * @default '{{0}} minute ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} minute ago
     * - plural: {{0}} minutes ago
     */
    DjUH3: T;

    /**
     * @default '{{0}} m ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} m ago
     * - plural: {{0}} m ago
     */
    '29b6L': T;

    /**
     * @default '{{0}} hour ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} hour ago
     * - plural: {{0}} hours ago
     */
    Bkd8v: T;

    /**
     * @default '{{0}} h ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} h ago
     * - plural: {{0}} h ago
     */
    OGVll: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} on {{1}}'
     */
    g1iYS: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;
  };
};

export type DiscountedRatesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'This property has discounted rates applied.'
     */
    xnheG: T;

    /**
     * @default 'View Rates'
     */
    O2u4E: T;

    /**
     * @default 'You will lose access to our exclusive pricing if you update the URL for this hotel.'
     */
    JzkUn: T;

    /**
     * @default 'We provide up to 30% discounts through our hotel partners.'
     */
    tgrBu: T;

    /**
     * @default 'Keep discount for my guests'
     */
    IrJUO: T;

    /**
     * @default 'Remove this discount'
     */
    PcyaI: T;
  };
};

export type EmailPreferencesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Joy - Email Preferences'
   */
  title: T;

  content: {
    /**
     * @default 'Update your email preferences.'
     */
    heading: T;

    /**
     * @default 'How much Joy do you want in your life? Select the email communications you’d like to receive.'
     */
    body: T;

    /**
     * @default 'Managing preferences for:'
     */
    managingPreferences: T;

    /**
     * @default 'Announcements'
     */
    prefAnnouncements: T;

    /**
     * @default 'Get the scoop on amazing new products, helpful features, and more.'
     */
    prefAnnouncementsBody: T;

    /**
     * @default 'Advice & Inspiration'
     */
    prefAdvice: T;

    /**
     * @default 'Stay organized with guides, checklists, registry progress reports, and articles.'
     */
    prefAdviceBody: T;

    /**
     * @default 'Registry Ideas'
     */
    prefRegistry: T;

    /**
     * @default 'Explore features and learn insider tips for creating your ultimate gift list.'
     */
    prefRegistryBody: T;

    /**
     * @default 'Unsubscribe'
     */
    unsubscribe: T;

    /**
     * @default 'If you no longer wish to receive marketing emails from Joy, please check this option.'
     */
    unsubscribeBody: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;

    /**
     * @default 'Updated Email Preferences!'
     */
    successMessage: T;
  };
  errors: {
    email: {
      /**
       * @default 'Missing Email ID'
       */
      required: T;

      /**
       * @default 'Invalid Email ID'
       */
      validate: T;
    };
  };
};

export type EmailsAndEcardsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  emailEditor: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Don’t forget about the wedding rehearsal!'
     */
    emailSubjectPlaceholder: T;

    /**
     * @default 'Email Subject is required'
     */
    emailSubjectErrorMessage: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Photo'
     */
    photoLabel: T;

    photoOptions: [
      /**
       * @default 'Welcome photo'
       */
      T,
      /**
       * @default 'Custom photo'
       */
      T,
    ];

    /**
     * @default 'Drag & drop a new image here or '
     */
    photoDragAndDropText: T;

    /**
     * @default 'choose an image...'
     */
    photoChooseImageText: T;

    /**
     * @default 'Headline'
     */
    headlineLabel: T;

    /**
     * @default 'You have an event display name {{headline}} that looks like a link. For security reasons we do not allow links to be posted in emails. Please change the event display name to proceed.'
     */
    headlineError: T;

    /**
     * @default 'Subheadline'
     */
    subheadlineLabel: T;

    /**
     * @default 'We’re getting married!'
     */
    subheadlinePlaceholder: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Hello'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Include guest name(s)'
     */
    includeGuestNamesLabel: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message to our guest'
     */
    messagePlaceholder: T;

    /**
     * @default 'Link'
     */
    linkLabel: T;

    /**
     * @default 'Button Text'
     */
    buttonTextLabel: T;

    /**
     * @default 'View Card'
     */
    buttonTextPlaceholder: T;

    /**
     * @default 'Button Text is required'
     */
    buttonTextError: T;

    /**
     * @default 'Date hidden'
     */
    dateHidden: T;

    generalMessageEmailOptions: [
      {
        /**
         * @default 'Display link to your website'
         */
        hed: T;

        /**
         * @default 'Guests can visit your website for additional wedding details.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Display event password'
         */
        hed: T;

        /**
         * @default 'Guests may need your event password to access some content.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Display links to install Joy app'
         */
        hed: T;

        /**
         * @default 'Guests can view and share photos while staying up-to-date on the go.'
         */
        dek: T;
      },
    ];

    ecardEmailOptions: [
      {
        /**
         * @default 'Include event date'
         */
        hed: T;
      },
      {
        /**
         * @default 'Include “Add to Calendar” link'
         */
        hed: T;

        /**
         * @default 'So people can add it to their calendar '
         */
        dek: T;
      },
    ];

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Your email has been updated.'
     */
    doneTooltipText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Password is required when you include a link to download the Joy app.'
     */
    passwordToggleTooltip: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the message of the email.'
     */
    invalidMessageIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subject of the email.'
     */
    invalidSubjectIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the headline of the email.'
     */
    invalidHeadlineIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subheadline of the email.'
     */
    invalidSubheadlineIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the salutation of the email.'
     */
    invalidSalutationIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the button text of the email.'
     */
    invalidButtonTextIsEmailOrUrlError: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    footerText: {
      /**
       * @default 'This message was sent from withjoy.com on behalf of {{names}}.'
       */
      sentFrom: T;

      /**
       * @default 'Send replies to {{email}}.'
       */
      sendRepliesTo: T;
    };
  };
  emailEditorPhotoSaveTheDate: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Subject'
     */
    subjectLabel: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Photo Source'
     */
    photoSourceLabel: T;

    /**
     * @default 'Headline'
     */
    headlineLabel: T;

    /**
     * @default 'Subheadline'
     */
    subheadlineLabel: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Dear'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Use guest name(s)'
     */
    useGuestNamesLabel: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message Body'
     */
    messagePlaceholder: T;

    /**
     * @default 'Button Text'
     */
    buttonTextLabel: T;

    /**
     * @default 'View Photo Save the Date'
     */
    buttonTextPlaceholder: T;

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Email Information'
     */
    emailInformationLabel: T;
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    /**
     * @default 'Email Personalized Cards'
     */
    emailHeader: T;

    /**
     * @default 'Each email will be addressed to the guest selected, and tracking of delivered and opened messages will be visible in your guest list.'
     */
    emailBody: T;

    /**
     * @default 'Share with a Link'
     */
    shareTitle: T;

    /**
     * @default 'Easily share a direct link to your cards with anyone.'
     */
    shareBody: T;

    /**
     * @default 'Copy Link'
     */
    shareAction: T;

    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Add or remove recipients
           */
          guest: T;
        };

        /**
         * @default 'Each guest will receive a unique invitation.'
         */
        dek: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testEmail: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test Email'
         */
        buttonText: T;
      };
      send: {
        /**
         * @default 'Send and track'
         */
        hed: T;

        /**
         * @default 'Keep an eye on replies and poke the slow pokes.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
      verifyEmail: {
        /**
         * @default 'First, verify your email address'
         */
        hed: T;

        /**
         * @default 'Only verified accounts can send cards.'
         */
        dek: T;

        /**
         * @default 'Verify Email Address'
         */
        buttonText: T;
      };
      copyLink: {
        /**
         * @default 'Shareable link'
         */
        hed: T;

        /**
         * @default 'A direct link to your eCard that is not addressed to a specific guest. Tracking not available.'
         */
        dek: T;

        /**
         * @default 'Copy Link'
         */
        buttonText: T;
      };
    };
    emailSentSuccessMessage: {
      /**
       * @default 'Your email is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your email is on the way!
       * - plural: Your emails are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong. Please allow 1 hour for the last email status to update. If blank, please send again.'
     */
    emailSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your message has been sent'
       */
      hed: T;

      dek: {
        /**
         * @default 'Your message has been sent to {{count}} guest. Track which guests have received and opened your card in '
         * @param {number} count - The number of occurrences.
         * - singular: Your message has been sent to {{count}} guest. Track which guests have received and opened your card in
         * - plural: Your message has been sent to {{count}} guests. Track which guests have received and opened your card in
         */
        dek: T;
      };

      /**
       * @default 'Guest List'
       */
      linkText: T;

      /**
       * @default 'View Your Guest List'
       */
      buttonText: T;

      /**
       * @default 'Add Paper Cards'
       */
      printTitle: T;

      /**
       * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them!'
       */
      printDesc: T;

      /**
       * @default 'Create Paper Card'
       */
      printAction: T;
    };
    confirmationScreenThankYou: {
      /**
       * @default 'Your thank you note has been sent'
       */
      hed: T;

      /**
       * @default 'An email has been sent to {{ name }}.'
       */
      dek_name: T;

      /**
       * @default 'An email has been sent to {{ number }} People.'
       */
      dek_number: T;

      /**
       * @default 'Thank Another Guest'
       */
      buttonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      testEmailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'your@email.com'
       */
      testEmailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      testEmailErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
  };
  ecardEditor: {
    ecardEditPanel: {
      /**
       * @default 'Edit Card'
       */
      header: T;

      /**
       * @default 'Save'
       */
      doneButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;

      /**
       * @default 'Your card has been updated.'
       */
      doneTooltipText: T;
    };
    ecardEditorSwitch: {
      /**
       * @default 'Content'
       */
      content: T;

      /**
       * @default 'Design'
       */
      design: T;
    };
    ecardContentEditor: {
      /**
       * @default 'Title'
       */
      titleLabel: T;

      /**
       * @default 'Subtitle'
       */
      subtitleLabel: T;

      /**
       * @default 'Date Format'
       */
      dateFormatLabel: T;

      /**
       * @default 'Date'
       */
      dateLabel: T;

      /**
       * @default '1 May, 2020'
       */
      datePlaceholder: T;

      /**
       * @default 'Edit Date'
       */
      editDate: T;

      /**
       * @default 'Date hidden'
       */
      dateHidden: T;

      /**
       * @default 'Location hidden'
       */
      locationHidden: T;

      /**
       * @default 'Location'
       */
      locationLabel: T;

      /**
       * @default 'Los Angeles, CA, USA'
       */
      locationPlaceholder: T;

      /**
       * @default 'Edit Location'
       */
      editLocation: T;

      /**
       * @default 'Message'
       */
      messageLabel: T;

      linkOptions: [
        {
          /**
           * @default 'Display link to your website'
           */
          hed: T;

          /**
           * @default 'Guests can visit your website for additional wedding details.'
           */
          dek: T;
        },
        {
          /**
           * @default 'Image links to event website'
           */
          hed: T;

          /**
           * @default 'This link personalizes your website, schedule, and RSVP for each guest.'
           */
          dek: T;
        },
        {
          /**
           * @default 'Links Unlock Guest-Only Content'
           */
          hed: T;

          /**
           * @default 'Website pages that require a password will be auto-unlocked.'
           */
          dek: T;
        },
      ];

      /**
       * @default 'Additional Information'
       */
      additionalInformation: T;

      /**
       * @default 'Choose up to two additional links to display'
       */
      chooseLinkTitle: T;

      /**
       * @default 'Additional Message'
       */
      additionalMessageLabel: T;

      /**
       * @default 'We’re doing it! We’re getting married. And we’d be delighted if you could attend. Our website has all the important details—most importantly the RSVP.'
       */
      additionalMessagePlaceholder: T;

      /**
       * @default 'Website Options'
       */
      websiteOptions: T;

      /**
       * @default 'Your URL'
       */
      yourURL: T;

      /**
       * @default 'Change URL'
       */
      editURL: T;

      /**
       * @default ' may be available!'
       */
      URLAvailable: T;

      /**
       * @default 'You’re Using a Custom Design'
       */
      usingCustomDesign: T;

      /**
       * @default 'All your event details are included in your image.'
       */
      usingCustomDesignDesc1: T;

      /**
       * @default 'You can revert back to using themes.'
       */
      usingCustomDesignDesc2: T;

      /**
       * @default 'Revert to Joy Theme'
       */
      revertToJoyTheme: T;
    };
  };
  ecardEditorPhotoSaveTheDate: {
    ecardEditPanel: {
      /**
       * @default 'Edit Card'
       */
      header: T;

      /**
       * @default 'Save'
       */
      doneButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    ecardEditorSwitch: {
      /**
       * @default 'Content'
       */
      content: T;

      /**
       * @default 'Design'
       */
      design: T;
    };
    ecardDesignEditor: {
      /**
       * @default 'Photo Source'
       */
      photoSourceLabel: T;

      /**
       * @default 'Adjust Photo Position'
       */
      adjustPhotoLabel: T;

      /**
       * @default 'Templates'
       */
      templatesLabel: T;

      /**
       * @default 'Reset Position'
       */
      resetPosition: T;

      /**
       * @default 'Edit Design'
       */
      editDesignButton: T;

      /**
       * @default 'Edit Content'
       */
      editContentButton: T;
    };
    ecardPhotoAdjustmentEditor: {
      /**
       * @default 'Zoom & drag photo to adjust position'
       */
      title: T;
    };
    ecardContentEditor: {
      /**
       * @default 'Name Format'
       */
      nameFormatLabel: T;

      /**
       * @default 'Edit Names'
       */
      editNameFormatLabel: T;

      /**
       * @default 'Date Format'
       */
      dateFormatLabel: T;

      /**
       * @default 'Edit Date'
       */
      editDateFormatLabel: T;

      /**
       * @default 'Location Format'
       */
      locationFormatLabel: T;

      /**
       * @default 'Edit Location'
       */
      editLocationFormatLabel: T;

      /**
       * @default 'Note'
       */
      inviteLabel: T;

      /**
       * @default 'Invitation to Follow'
       */
      invitePlaceholder: T;

      /**
       * @default 'Additional Info'
       */
      additionalInformationTitle: T;

      /**
       * @default 'Additional links to display'
       */
      additionalLinksLabel: T;

      /**
       * @default 'Optional Message'
       */
      optionalMessageLabel: T;

      /**
       * @default 'Website Options'
       */
      websiteOptionsTitle: T;

      displayEventLink: {
        /**
         * @default 'Display link to your website'
         */
        title: T;

        /**
         * @default 'Guests can visit your website for additional wedding details.'
         */
        subtitle: T;
      };
      unlockGuestOnlyContent: {
        /**
         * @default 'Unlock Guest-Only Content'
         */
        title: T;

        /**
         * @default 'Website pages that require a password will be auto-unlocked with this link.'
         */
        subtitle: T;
      };

      /**
       * @default 'Your URL'
       */
      yourURLLabel: T;

      /**
       * @default 'Edit URL'
       */
      editYourURLLabel: T;

      /**
       * @default 'Guest Help'
       */
      guestHelpLink: T;

      /**
       * @default 'About'
       */
      aboutLink: T;

      /**
       * @default 'Made with'
       */
      madeWithText: T;

      /**
       * @default 'Password:'
       */
      passwordLabel: T;
    };
    premiumUpsell: {
      banner: {
        /**
         * @default 'Switch to Premium Card Designer'
         */
        title: T;

        /**
         * @default 'Try premium editor to change fonts, move text around, upload your own image, and more.'
         */
        description: T;

        /**
         * @default 'Try Premium'
         */
        cta: T;
      };
      dialog: {
        /**
         * @default 'Try Premium Card and Customize Your Way!'
         */
        title: T;

        /**
         * @default 'Edit all your details inline on the card.'
         */
        valuePropEdit: T;

        /**
         * @default 'Customize your card exactly how you like it, with hundreds of font styles, photo, and layout options.'
         */
        valuePropCustomize: T;

        /**
         * @default 'Choose silhouette of your card and wallpaper color.'
         */
        valuePropSilhoutte: T;

        /**
         * @default 'Try Premium'
         */
        cta: T;

        /**
         * @default 'Back to Free'
         */
        cancel: T;
      };
    };
  };
  ecardDefaults: {
    /**
     * @default '✨ Link copied. Share away! ✨'
     */
    copiedLinkTooltip: T;

    changethedate: {
      ecardContent: {
        /**
         * @default 'Change the Date'
         */
        title: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        subtitle: T;

        /**
         * @default 'We've had to change the date for our big day but we can't wait to celebrate with you soon. Please check our wedding website for updates!'
         */
        message: T;

        /**
     * @default 'Visit our website to RSVP and to view the details of our wedding ceremony, reception, accommodations, registry, and more.

We can’t wait to celebrate with you!'
*/
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'We're changing the date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're changing the date!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've had to change the date for our big day but we can't wait to celebrate with you soon. Please check our wedding website for updates!'
         */
        message: T;

        /**
         * @default 'View Card'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Change the Dates'
         */
        title: T;
      };
    };
    savethedate: {
      ecardContent: {
        /**
         * @default 'Save the Date'
         */
        title: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        subtitle: T;

        /**
         * @default 'Invitation to follow. Please visit our website for more details and photos.'
         */
        message: T;

        /**
     * @default 'Visit our website to RSVP and to view the details of our wedding ceremony, reception, accommodations, registry, and more.

We can’t wait to celebrate with you!'
*/
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Save the Date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've set a date for our big day and we can't wait to share it with you.'
         */
        message: T;

        /**
         * @default 'Open Save The Date'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Save the Dates'
         */
        title: T;
      };
    };
    invitation: {
      ecardContent: {
        /**
         * @default '{{ eventDisplayName }}'
         */
        title: T;

        /**
         * @default ' '
         */
        subtitle: T;

        /**
         * @default 'We are so excited and can't wait to see you.'
         */
        message: T;

        /**
     * @default 'Visit our website to RSVP and to view the details of our wedding ceremony, reception, accommodations, registry, and more.

We can’t wait to celebrate with you!'
*/
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'We're getting married!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
     * @default 'We’re making it official, and you’re cordially invited! We have a wedding
 website and app with all the details—from travel and lodging to the day-of schedule and what to wear. Take
 a look to RSVP and find more information. We hope you can join us! '
*/
        message: T;

        /**
         * @default 'View Invitation'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Invitations'
         */
        title: T;
      };
    };
    custom: {
      ecardContent: {
        /**
         * @default 'Party Time'
         */
        title: T;

        /**
         * @default 'Will you join us?'
         */
        subtitle: T;

        /**
         * @default 'We are so excited and can't wait to see you.'
         */
        message: T;

        /**
         * @default 'We are so excited and can't wait to see you.'
         */
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Party Time!'
         */
        subject: T;

        /**
         * @default 'Party Time!'
         */
        headline: T;

        /**
         * @default 'We're having a party!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We're having a party and we can't wait to see you.'
         */
        message: T;

        /**
         * @default 'Open Card'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Custom eCards'
         */
        title: T;
      };
    };
    savethedatephoto: {
      ecardContent: {
        /**
         * @default 'Save the Date'
         */
        title: T;

        /**
         * @default 'Invitation to follow'
         */
        subtitle: T;

        /**
         * @default 'Please visit our website for more details and photos.'
         */
        message: T;

        /**
     * @default 'Visit our website to RSVP and to view the details of our wedding ceremony, reception, accommodations, registry, and more.

We can’t wait to celebrate with you!'
*/
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Save the Date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've set a date for our big day and we can't wait to share it with you.'
         */
        message: T;

        /**
         * @default 'Open Save The Date'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Save the Dates'
         */
        title: T;
      };
    };
  };
  ecardNavBar: {
    /**
     * @default 'Edit Card'
     */
    design: T;

    /**
     * @default 'Edit Email'
     */
    email: T;

    /**
     * @default 'Confirm & Send'
     */
    confirm: T;
  };
  unsavedChangesDialog: {
    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Discard'
     */
    discardButtonText: T;

    /**
     * @default 'Unsaved Changes'
     */
    unsavedChangesWarningHed: T;

    /**
     * @default 'Are you sure you want to stop editing your {{ warningMessageContent }}? Doing so will discard all unsaved changes.'
     */
    unsavedChangesWarningDek: T;
  };
  genericEcard: {
    /**
     * @default 'Edit eCard'
     */
    editEcard: T;

    /**
     * @default 'To:'
     */
    toPerson: T;

    /**
     * @default 'Not'
     */
    notPerson: T;

    /**
     * @default 'Not you?'
     */
    notYou: T;

    /**
     * @default '[First Name(s)]'
     */
    toPersonNames: T;

    /**
     * @default 'Next'
     */
    next: T;
  };
  genericEmail: {
    /**
     * @default 'Event Password:'
     */
    eventPassword: T;

    /**
     * @default 'View Our Website'
     */
    viewOurWebsite: T;

    /**
     * @default 'Download Our App'
     */
    downloadOurApp: T;

    /**
     * @default 'Get the Joy app to view and share photos and stay up-to-date with details on the go.'
     */
    appDescription: T;
  };
  ecardLanding: {
    ecardLandingLeftPane: {
      /**
       * @default 'Make the big announcement in a big way'
       */
      titleLanding: T;

      /**
       * @default 'Send Beautiful Digital Cards'
       */
      title: T;

      /**
       * @default 'Match your wedding website or pick from beautiful designs for every taste.'
       */
      desc: T;

      /**
       * @default 'Create Digital Card'
       */
      customize: T;

      /**
       * @default 'Track Your eCard Delivery'
       */
      trackTitle: T;

      /**
       * @default 'Already sent? Track delivery in guest list'
       */
      trackLandingTitle: T;

      /**
       * @default 'Track which guests have received and opened your Digital Card in the “Email Status” column of your guest list.'
       */
      trackDesc: T;

      /**
       * @default 'Track in Guest List'
       */
      trackButtonText: T;

      /**
       * @default 'Matching Stationery is Available'
       */
      printsTitle: T;

      /**
       * @default 'Matching stationery is available for your current art card design'
       */
      printsLandingTitle: T;

      /**
       * @default 'Your website theme has matching stationery. Order {{ ecardTypeDisplayName }} prints that match your wedding website.'
       */
      printsDesc: T;

      /**
       * @default 'Order Save the Date prints that match your wedding website.'
       */
      printsLandingDesc: T;

      /**
       * @default 'US and international shipping available.'
       */
      paperlustDesc: T;

      /**
       * @default 'Shipping only available in the United States.'
       */
      paperCultureDesc: T;

      /**
       * @default 'View and Order Prints'
       */
      printsButtonText: T;

      /**
       * @default 'Our partner Paper Culture can only send cards to a US address. They do, however, ship to all United States addresses, including military and APO/FPO addresses, and US Territories.'
       */
      printsPaperCultureTooltipText: T;

      /**
       * @default 'Paperlust has express worldwide shipping to all countries including the USA, Canada, New Zealand, the UK and Europe. Please note that you are responsible for any local duties, tariffs, taxes or fees payable on delivery.'
       */
      printsPaperlustTooltipText: T;

      /**
       * @default 'Explore Our Print Partners'
       */
      exploreTitle: T;

      /**
       * @default 'Explore our print partners'
       */
      exploreLandingTitle: T;

      /**
       * @default 'International Shipping'
       */
      internationalShipping: T;

      /**
       * @default 'U.S.-Only Shipping'
       */
      USOnlyShipping: T;

      /**
       * @default 'Please use the desktop browser. Don’t worry, your guests will be able to see and experience the eCard on their phones.'
       */
      mobileAlertTextSubTitle: T;

      /**
       * @default 'Photo Digital Cards'
       */
      landingPhotoTitle: T;

      /**
       * @default 'Add your own photos and choose from ten stunning custom-designed Photo Digital Cards to announce your big day.'
       */
      landingPhotoSubTitle: T;

      /**
       * @default 'Customize Photo Digital Card'
       */
      landingPhotoButtonTitle: T;

      /**
       * @default 'Art Digital Cards'
       */
      landingArtTitle: T;

      /**
       * @default 'Select from a variety of beautiful custom-designed Art Digital Cards to make your big announcement stand out.'
       */
      landingArtSubTitle: T;

      /**
       * @default 'Customize Art Digital Card'
       */
      landingArtButtonTitle: T;

      /**
       * @default 'Add Paper Cards'
       */
      landingPrintTitle: T;

      /**
       * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them.'
       */
      landingPrintSubTitle: T;

      /**
       * @default 'Customize Paper Card'
       */
      landingPrintButtonTitle: T;

      /**
       * @default 'New'
       */
      chipNew: T;
    };
    ecardLandingRightPane: {
      /**
       * @default 'eCard'
       */
      ecard: T;

      /**
       * @default 'Print'
       */
      print: T;

      /**
       * @default 'Explore Prints'
       */
      explorePrints: T;
    };
  };
  ecardGuest: {
    /**
     * @default 'A special message from {{event}}'
     */
    title: T;

    error: {
      /**
       * @default 'Hmm… we can’t find that.'
       */
      title: T;

      /**
       * @default 'This eCard may have been changed or is temporarily unavailable.'
       */
      subtitle: T;

      /**
       * @default 'Find a Couple'
       */
      linkText: T;
    };
    toolTip: {
      /**
       * @default 'Guests are addressed by first name.'
       */
      firstPart: T;

      /**
       * @default 'If the recipient is in a party, all first names in the party will be included. e.g. “Sam, Sue, & Fred“, or “Suzy & Guest“'
       */
      secondPart: T;
    };
  };
  ecardFooter: {
    /**
     * @default 'Plan your forever, better.'
     */
    label: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    /**
     * @default 'Terms and Conditions'
     */
    termsAndConditions: T;
  };
  quick: {
    /**
     * @default '✨ Link copied. Share away! ✨'
     */
    oV6ax: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default '{{0}} and {{1}}'
     */
    ifsOv: T;

    /**
     * @default 'This message was sent from withjoy.com on behalf of {{0}}.'
     */
    VnvYf: T;

    /**
     * @default 'Send replies to {{0}}.'
     */
    '19vJq': T;

    /**
     * @default 'Date hidden'
     */
    '2EfMO': T;

    /**
     * @default 'Location hidden'
     */
    x0fMi: T;

    /**
     * @default 'Social'
     */
    XYZoV: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Must be at least {{0}} characters in length. Generic or placeholder text may prevent delivery.'
     */
    cCMCJ: T;

    /**
     * @default 'Please enter a valid reply-to email address.'
     */
    '7Pto5': T;

    /**
     * @default 'Your email has been updated.'
     */
    I1h8O: T;

    /**
     * @default 'Email Subject is required'
     */
    hMTsq: T;

    /**
     * @default 'Reply-to Email is required'
     */
    TvNTr: T;

    /**
     * @default 'Button Text is required'
     */
    EhDuc: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subject of the email.'
     */
    '4w8vI': T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the headline of the email.'
     */
    sZEGU: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the salutation of the email.'
     */
    oqseB: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subheadline of the email.'
     */
    OrPEX: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the message of the email.'
     */
    NUkYd: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the button text of the email.'
     */
    jDfXS: T;

    /**
     * @default 'Premium Digital Available'
     */
    aEZRP: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'View Schedule'
     */
    A4Wso: T;

    /**
     * @default 'View Travel Details'
     */
    '9dd3R': T;

    /**
     * @default 'View Website'
     */
    QNwvH: T;

    /**
     * @default 'Enter Mailing Address'
     */
    LXQLq: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default '[First Name(s)]'
     */
    l0QDU: T;

    /**
     * @default 'Guests are addressed by first name.'
     */
    '6X8VI': T;

    /**
     * @default 'If the recipient is in a party, all first names in the party will be included. e.g. "Sam, Sue, & Fred", or "Suzy & Guest"'
     */
    i1skY: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Select Guests'
     */
    NFyEb: T;

    /**
     * @default 'About Shareable Card Links'
     */
    ZYRi8: T;

    /**
     * @default 'Unlike cards sent via email, cards shared via link will not be addressed to a specific guest or tracked on your guest list.'
     */
    z6jrN: T;

    /**
     * @default 'Card contents will be visible to anyone with the link, regardless of your event privacy settings.'
     */
    mB31j: T;

    /**
     * @default 'This includes your event date, location, and website password (if you have included it on the card).'
     */
    iTYZM: T;

    /**
     * @default 'Contents of your website, including schedule visibility and RSVP, will continue to be protected by your existing privacy settings.'
     */
    OVtP7: T;

    /**
     * @default 'Couldn't create the link. Try again.'
     */
    kxL2e: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Send Beautiful Digital Cards'
     */
    qmAlO: T;

    /**
     * @default 'Match your wedding website or pick from beautiful designs for every taste.'
     */
    capG8: T;

    /**
     * @default 'Create Digital Card'
     */
    kAQHO: T;

    /**
     * @default 'Add Paper Cards'
     */
    W8G94: T;

    /**
     * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them.'
     */
    bOOoY: T;

    /**
     * @default 'Customize Paper Card'
     */
    bV1Kq: T;

    /**
     * @default 'Already sent? Track delivery in message Tracking'
     */
    lhkKk: T;

    /**
     * @default 'Track which guests have received and opened your Digital Card in the message tracker.'
     */
    OUXlG: T;

    /**
     * @default 'View Message Tracker'
     */
    '2TfeF': T;

    /**
     * @default 'Your Website Theme'
     */
    nVYHd: T;

    /**
     * @default 'Use My Color'
     */
    gZ5aV: T;

    /**
     * @default 'Password:'
     */
    NIOBY: T;

    /**
     * @default 'Guest Help'
     */
    JytpA: T;

    /**
     * @default 'About'
     */
    t7tcF: T;

    /**
     * @default 'Made with'
     */
    DatKQ: T;

    /**
     * @default '{{0}} and 1 other guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} and 1 other guest
     * - plural: {{0}} and {{1}} other guests
     */
    PSvDN: T;

    /**
     * @default 'No recipients selected'
     */
    QYFnS: T;

    /**
     * @default 'To: '
     */
    '3PLNA': T;
  };
};

export type EmailTemplatesAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'General Message'
     */
    LWh4S: T;

    /**
     * @default 'Registration Approval'
     */
    '8EDAq': T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Email Templates'
     */
    PeJs6: T;

    /**
     * @default 'Create Template'
     */
    O9HMQ: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Failed to load templates.'
     */
    '7tzzv': T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'No templates yet. Create one to get started.'
     */
    '0v1CR': T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Salutation'
     */
    gkDux: T;

    /**
     * @default 'Include Recipient Name'
     */
    USARc: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Button URL'
     */
    '9lRdM': T;

    /**
     * @default 'Reason'
     */
    omLMS: T;

    /**
     * @default 'Email subject line'
     */
    AeZxO: T;

    /**
     * @default 'e.g. Hi, Hello'
     */
    JebkC: T;

    /**
     * @default 'Email message body'
     */
    naGwF: T;

    /**
     * @default 'e.g. Learn More, RSVP'
     */
    '67ce8': T;

    /**
     * @default 'https://'
     */
    NpibG: T;

    /**
     * @default 'Approval message to the guest'
     */
    GQY2W: T;

    /**
     * @default 'e.g. Visit Our Website'
     */
    Sx2bV: T;

    /**
     * @default 'Leave blank to use "View Event Details"'
     */
    WZM1K: T;

    /**
     * @default 'Leave blank to link to your Joy event page'
     */
    '7X9TW': T;

    /**
     * @default 'Reason for approval (visible to admins)'
     */
    OiigY: T;

    /**
     * @default 'Enter a valid link, e.g. https://example.com'
     */
    Pz1BG: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Link must be 2048 characters or fewer'
     */
    i2iru: T;

    /**
     * @default 'Template name is required'
     */
    qQ40P: T;

    /**
     * @default 'Edit Template'
     */
    '2egjG': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Template Type'
     */
    gxoUw: T;

    /**
     * @default 'Template Name'
     */
    l2nTw: T;

    /**
     * @default 'e.g. Event Update, Welcome Message'
     */
    '0TFTs': T;

    /**
     * @default 'Delete Template'
     */
    jsTfN: T;

    /**
     * @default 'Are you sure you want to delete "{{0}}"? This action cannot be undone.'
     */
    N14nh: T;

    /**
     * @default 'Save Template'
     */
    nIheg: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Save as new template'
     */
    FQdwn: T;

    /**
     * @default 'Template saved'
     */
    noyGK: T;

    /**
     * @default 'Template updated'
     */
    FnjMg: T;

    /**
     * @default 'Template'
     */
    I4FM7: T;

    /**
     * @default 'Save as Template'
     */
    PUAp0: T;

    /**
     * @default 'Select a template'
     */
    VattR: T;
  };
};

export type EmailVerificationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Verify email'
     */
    pUnEO: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'I have verified my email'
     */
    rh2HG: T;

    /**
     * @default 'Resend in {{0}}s'
     */
    hBDGL: T;

    /**
     * @default 'Resend'
     */
    X5zOS: T;

    /**
     * @default 'First let's verify your email'
     */
    TqVIS: T;

    /**
     * @default 'Verifying your email helps us make sure that Joy can reach you for any issues related to your site.'
     */
    dWY2W: T;

    /**
     * @default 'Verifying your email…'
     */
    g0ErK: T;

    /**
     * @default 'We sent a new link to {{0}}. Check your mailbox for next steps, then come back to this screen.'
     */
    XIyXj: T;

    /**
     * @default 'We sent you a new link. Check your mailbox for next steps, then come back to this screen.'
     */
    ZaPaJ: T;

    /**
     * @default 'Please check your mailbox {{0}} for next steps to verify your email. And then come back to this screen.'
     */
    JARTv: T;

    /**
     * @default 'We couldn't check your email just now. Please try again.'
     */
    AyrLT: T;

    /**
     * @default 'Your email isn't verified yet. Please check your inbox and try again.'
     */
    r1qNX: T;

    /**
     * @default 'We couldn't send the verification email. Please try again.'
     */
    BdQUQ: T;
  };
};

export type ErrorsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  errorSplash: {
    /**
     * @default 'Hmm… we're having trouble with that.'
     */
    title: T;

    /**
     * @default 'This page can’t be loaded at the moment. Please try again later.'
     */
    subtitle: T;
  };
  contributionError: {
    /**
     * @default 'Hmm… we can’t find that.'
     */
    title: T;

    /**
     * @default 'The item may have been changed or removed from the couple’s registry.'
     */
    subtitle: T;

    /**
     * @default 'Go to Registry'
     */
    linkText: T;
  };
  registryHidden: {
    /**
     * @default 'Hmm… we can’t find that.'
     */
    title: T;

    /**
     * @default 'It seems that the couple may have hidden their registry.'
     */
    subtitle: T;
  };
  componentError: {
    /**
     * @default 'An error occurred. Please refresh to try again.'
     */
    message: T;
  };
  quick: {
    /**
     * @default 'This section couldn’t load. '
     */
    XLzA6: T;

    /**
     * @default 'Something went wrong loading this section. '
     */
    eW862: T;

    /**
     * @default 'Reload page'
     */
    cwoNQ: T;
  };
};

export type EventCountdownTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default '{{dateTime}} ago'
   */
  eventDateWithAgoText: T;
};

export type EventCountdownCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Days, Hours, Minutes, Seconds'
     */
    c3BPk: T;

    /**
     * @default 'Days, Hours, Minutes'
     */
    '9tVTc': T;

    /**
     * @default 'Days, Hours'
     */
    '24of2': T;

    /**
     * @default 'Days Only'
     */
    Nrf42: T;

    /**
     * @default 'Countdown Format'
     */
    S4sdu: T;

    /**
     * @default 'Select format...'
     */
    rWxc7: T;

    /**
     * @default 'Event Countdown'
     */
    hlzOJ: T;

    /**
     * @default 'An error occurred while updating the event countdown. Please try again.'
     */
    I9STG: T;

    /**
     * @default 'Event countdown updated successfully.'
     */
    RonAa: T;

    /**
     * @default 'An error occurred while adding the event countdown. Please try again.'
     */
    ZEC0h: T;

    /**
     * @default 'Event countdown added successfully.'
     */
    cshOJ: T;

    /**
     * @default 'Main Event Countdown'
     */
    yRO2D: T;

    /**
     * @default 'Countdown'
     */
    n91ap: T;

    /**
     * @default 'Display event countdown'
     */
    HpJo6: T;

    /**
     * @default 'Countdown is only shown when your event date is visible.'
     */
    '95l5x': T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;
  };
};

export type EventDetailsCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'MM/DD/YYYY'
     */
    oiQg8: T;

    /**
     * @default 'Month Day, Year'
     */
    XhfsH: T;

    /**
     * @default 'Weekday, Month Day, Year'
     */
    '5DNmC': T;

    /**
     * @default 'Date range…'
     */
    '5cUEo': T;

    /**
     * @default 'NEW'
     */
    KsWAA: T;

    /**
     * @default 'Date Format'
     */
    vaDAI: T;

    /**
     * @default 'Select format...'
     */
    rWxc7: T;

    /**
     * @default 'Custom'
     */
    ZzYxp: T;

    /**
     * @default 'Display format'
     */
    ZVepC: T;

    /**
     * @default 'e.g. Labor Day Weekend 2027'
     */
    '61PRm': T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Venue name, city, state or country'
     */
    pR5yJ: T;

    /**
     * @default 'City, state or country'
     */
    vIlXM: T;

    /**
     * @default 'City only'
     */
    v0x6w: T;

    /**
     * @default 'Please re-enter the date in {{0}} format'
     */
    nmssF: T;

    /**
     * @default 'End date must be after the start date'
     */
    K3S0U: T;

    /**
     * @default 'Please enter your custom date text'
     */
    DDCcO: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Event Date'
     */
    M6IZn: T;

    /**
     * @default 'Show date in website and app'
     */
    vpmnG: T;

    /**
     * @default 'When you hide your date, it won't appear on your website or app and your countdown will be disabled.'
     */
    erGSc: T;

    /**
     * @default 'Start date'
     */
    CXqIJ: T;

    /**
     * @default 'End date'
     */
    DT2Gz: T;

    /**
     * @default 'This range spans more than 14 days. Double-check the dates are correct.'
     */
    oQXbF: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Event Location'
     */
    '1F8sC': T;

    /**
     * @default 'Location Format'
     */
    qMEAc: T;
  };
};

export type EventDisplayNameCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Display Name'
     */
    rZqZK: T;

    /**
     * @default 'Event Display Name is required.'
     */
    OvJID: T;

    /**
     * @default 'Enter your event display name'
     */
    mSBCX: T;
  };
};

export type EventFormDisplayTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Attendance'
     */
    DE1nO: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Not Attending'
     */
    RXHya: T;

    /**
     * @default 'Contact Information'
     */
    ghluB: T;

    /**
     * @default 'Guest Name'
     */
    BwmqA: T;

    /**
     * @default 'Back to Website'
     */
    dNvtn: T;

    /**
     * @default 'Update Registration'
     */
    OqP1B: T;

    /**
     * @default 'All done!'
     */
    aZEXM: T;

    /**
     * @default 'Thanks for sharing your answers.'
     */
    MCn9k: T;

    /**
     * @default 'Edit Response'
     */
    zt3SF: T;

    /**
     * @default 'Your answers didn’t load. Try again.'
     */
    B0A2v: T;

    /**
     * @default 'Unknown state'
     */
    '9Ej0b': T;

    /**
     * @default 'Your party'
     */
    '7Sy8S': T;

    /**
     * @default 'You're responding for {{0}} people. Answer for each of them below.'
     */
    GXsJE: T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'Guest {{0}}'
     */
    '4Qerl': T;

    /**
     * @default 'Will {{0}} be attending?'
     */
    aHU0s: T;

    /**
     * @default 'Answer for each guest in your party.'
     */
    Q2SD0: T;

    /**
     * @default 'Yes, attending'
     */
    p5blo: T;

    /**
     * @default 'No, not attending'
     */
    gQ6kX: T;

    /**
     * @default 'About your party'
     */
    '6evu7': T;

    /**
     * @default 'Questions for {{0}}'
     */
    MhkDZ: T;

    /**
     * @default 'These answers apply to everyone in your party.'
     */
    '6WeGc': T;

    /**
     * @default 'Some of these apply to your whole party.'
     */
    '3k2q8': T;

    /**
     * @default 'Answered just for this guest.'
     */
    I4FpN: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Review your party's RSVP'
     */
    UNjaU: T;

    /**
     * @default 'Check everything looks right before you send it.'
     */
    sFrEQ: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'We couldn't save everyone's response. Please try again.'
     */
    GUm2H: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'We couldn’t save your registration. Please try again.'
     */
    sSTvC: T;

    /**
     * @default 'Error saving form. Please try again later.'
     */
    tTVh2: T;

    /**
     * @default 'Answered for your party by {{0}}'
     */
    m2KPv: T;

    /**
     * @default 'Already answered for your party'
     */
    jBaFC: T;

    /**
     * @default 'Not attending'
     */
    XQIds: T;

    /**
     * @default 'In progress'
     */
    YSegC: T;

    /**
     * @default 'Not started'
     */
    a3pNs: T;

    /**
     * @default '{{0}} (you)'
     */
    wDpyf: T;

    /**
     * @default 'For your party'
     */
    ct5yX: T;

    /**
     * @default 'Edit {{0}}'
     */
    srIa6: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'No answers needed'
     */
    ZErfG: T;

    /**
     * @default 'No questions for this guest'
     */
    jKgaZ: T;

    /**
     * @default 'We couldn’t save {{0}}.'
     */
    XOGDN: T;

    /**
     * @default 'We couldn’t save your party.'
     */
    odVVZ: T;

    /**
     * @default 'We saved {{0}} of your party, but couldn't save {{1}}.'
     */
    E2a75: T;

    /**
     * @default 'We saved {{0}} of your party, but couldn't save everyone.'
     */
    e75dI: T;

    /**
     * @default 'Nothing you've entered is lost. Try again to send the remaining guest.'
     */
    We7M4: T;

    /**
     * @default 'Nothing you've entered is lost. Try again to send the remaining {{0}} guests.'
     */
    PNHdV: T;

    /**
     * @default 'Your RSVP is saved, but we couldn't add your guests. Please ask the host to add them.'
     */
    XbFT6: T;

    /**
     * @default 'Find your invitation'
     */
    '9ex6A': T;

    /**
     * @default 'Enter your name to RSVP'
     */
    QiKzi: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Please enter your first and last name.'
     */
    Tr22K: T;

    /**
     * @default 'The name you've entered does not match any on the guest list.'
     */
    ZU6M9: T;

    /**
     * @default 'Check your spelling and try again. "David" vs. "Dave," for example.'
     */
    bYLRN: T;

    /**
     * @default 'Please enter your name only. "Kevin" vs "Kevin and/& Eva"'
     */
    bIj0J: T;

    /**
     * @default 'You've got a popular name! Enter your email to clarify which guest you are.'
     */
    bUx3b: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'The email you've entered does not match any on the guest list. Please contact the host to update your email.'
     */
    gkqCt: T;

    /**
     * @default 'Something went wrong. Please try again later.'
     */
    UzWaL: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'The name you've entered does not match any on the guest list. Check your spelling and try again.'
     */
    '4iGXY': T;

    /**
     * @default 'This ticket is no longer available. Please select another.'
     */
    '4SmDT': T;

    /**
     * @default 'Registered'
     */
    sbiSK: T;

    /**
     * @default 'Pending'
     */
    XhQCC: T;

    /**
     * @default 'Not paid'
     */
    zyOfA: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Edit: {{0}}'
     */
    oeZgj: T;

    /**
     * @default 'Show Less'
     */
    yPlIB: T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default 'Will you be attending the event?'
     */
    elIlh: T;

    /**
     * @default 'Yes'
     */
    '1GaAA': T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default 'Payment'
     */
    SKIqN: T;

    /**
     * @default 'Preparing your checkout...'
     */
    rw1Tv: T;

    /**
     * @default 'No payment due'
     */
    leI4F: T;

    /**
     * @default 'There's no payment due for this registration right now. Your registration is saved.'
     */
    e9ANt: T;

    /**
     * @default 'Payment already started'
     */
    ziAhT: T;

    /**
     * @default 'Something went wrong'
     */
    X1dnv: T;

    /**
     * @default 'A payment for this email is already in progress or completed for this event. Use the Update Registration link in the email you received when you registered to view or change it.'
     */
    '0krMT': T;

    /**
     * @default 'We couldn't set up your checkout. Please go back and try again.'
     */
    JoWWC: T;

    /**
     * @default 'No payment session was created. Please go back and try again.'
     */
    '9YPhp': T;

    /**
     * @default 'Complete your ticket purchase'
     */
    LIPiw: T;

    /**
     * @default 'Payment verification failed.'
     */
    SlfCM: T;

    /**
     * @default 'Could not verify payment status.'
     */
    PNsxf: T;

    /**
     * @default 'Payment was not completed. Please try again.'
     */
    SL6bS: T;

    /**
     * @default 'An unexpected error occurred. Please try again.'
     */
    CSDsd: T;

    /**
     * @default 'Order Summary'
     */
    '8XV9D': T;

    /**
     * @default 'Ticket price'
     */
    B9y59: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Payment failed. Please try again.'
     */
    W11FM: T;

    /**
     * @default 'Failed to load payment form.'
     */
    '44cG2': T;

    /**
     * @default 'Pay {{0}}'
     */
    slURm: T;

    /**
     * @default 'We couldn’t sign you out. Please try again.'
     */
    jhYxf: T;

    /**
     * @default 'Welcome back, {{0}}'
     */
    '5q98d': T;

    /**
     * @default 'Welcome back'
     */
    nXLLr: T;

    /**
     * @default 'Welcome, {{0}}'
     */
    wufJX: T;

    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'Continue as {{0}}'
     */
    RMoso: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Not You?'
     */
    D1zbA: T;

    /**
     * @default 'By continuing, you agree to get event texts and emails. Msg & data rates may apply.'
     */
    KJA93: T;

    /**
     * @default 'Terms'
     */
    bgu9G: T;

    /**
     * @default '&'
     */
    mAAAA: T;

    /**
     * @default 'Privacy'
     */
    CovGk: T;

    /**
     * @default 'Enter a valid phone number.'
     */
    A65KO: T;

    /**
     * @default 'Enter your mobile phone number.'
     */
    Sek0n: T;

    /**
     * @default 'First name'
     */
    heZ8G: T;

    /**
     * @default 'Last name'
     */
    hAZ8J: T;

    /**
     * @default 'Mobile phone'
     */
    obMAH: T;

    /**
     * @default 'your@email.com'
     */
    GHzC1: T;

    /**
     * @default 'optional'
     */
    uCHW7: T;

    /**
     * @default '(optional)'
     */
    jghot: T;

    /**
     * @default 'Mailing address'
     */
    reiA9: T;

    /**
     * @default 'Street address'
     */
    THSqe: T;

    /**
     * @default 'Apartment, suite, etc.'
     */
    abbpN: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State, province or territory'
     */
    uPEPS: T;

    /**
     * @default 'ZIP or postal code'
     */
    Wcbhc: T;

    /**
     * @default 'Country or region'
     */
    v53WF: T;

    /**
     * @default 'Enter your first name.'
     */
    WxWrB: T;

    /**
     * @default 'Enter your last name.'
     */
    Agcyl: T;

    /**
     * @default 'Enter your email address.'
     */
    '3JT1s': T;

    /**
     * @default 'Enter a valid email address.'
     */
    DqvUM: T;

    /**
     * @default 'Enter your street address.'
     */
    kO0i1: T;

    /**
     * @default 'Enter your city.'
     */
    MAKeV: T;

    /**
     * @default 'Enter your state, province or territory.'
     */
    plxsE: T;

    /**
     * @default 'Enter your ZIP or postal code.'
     */
    '7Leen': T;

    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'No longer accepting responses'
     */
    s4cRR: T;

    /**
     * @default '{{0}} is closed. Please contact the host if you have any questions.'
     */
    '8JK59': T;

    /**
     * @default 'This event allows one additional guest.'
     * @param {number} count - The number of occurrences.
     * - singular: This event allows one additional guest.
     * - plural: This event allows up to {{0}} additional guests.
     */
    zyHPM: T;

    /**
     * @default 'Is anyone coming with you?'
     */
    '9vrCI': T;

    /**
     * @default 'Add them here if so. If you're coming on your own, just continue.'
     */
    Km2Mv: T;

    /**
     * @default 'We'll ask about each of them after your own details.'
     */
    wvEYJ: T;

    /**
     * @default 'Remove guest {{0}}'
     */
    aknNH: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Add a guest'
     */
    YHOiK: T;

    /**
     * @default 'Add another guest'
     */
    '2Ouio': T;

    /**
     * @default 'Add a first name for each guest, or remove the empty row.'
     */
    MOtC1: T;

    /**
     * @default 'Review & Submit'
     */
    epYCv: T;

    /**
     * @default 'Request to Join'
     */
    wGiEF: T;

    /**
     * @default 'Save Answer'
     */
    N3O17: T;

    /**
     * @default 'Answer this question to continue.'
     */
    '8TqFS': T;

    /**
     * @default 'Registration submitted'
     */
    gAZ76: T;

    /**
     * @default 'Awaiting approval from the host'
     */
    QIFTV: T;

    /**
     * @default 'Pending approval'
     */
    QhTeE: T;

    /**
     * @default 'Your {{0}} ticket is pending approval. You'll be notified once the host reviews your registration.'
     */
    '9kUtC': T;

    /**
     * @default 'Your ticket is pending approval. You'll be notified once the host reviews your registration.'
     */
    HPnlw: T;

    /**
     * @default 'You're all set!'
     */
    Lz3uB: T;

    /**
     * @default 'Your registration is confirmed'
     */
    n1qTN: T;

    /**
     * @default 'Payment successful'
     */
    ojfib: T;

    /**
     * @default 'Your {{0}} ticket has been confirmed.'
     */
    EZvQ8: T;

    /**
     * @default 'Your ticket has been confirmed.'
     */
    u4SDU: T;

    /**
     * @default 'Order Details'
     */
    AroHV: T;

    /**
     * @default 'Order Number'
     */
    PpyQe: T;

    /**
     * @default 'Amount Paid'
     */
    '2Mj38': T;

    /**
     * @default 'Fees'
     */
    p5BLA: T;

    /**
     * @default 'You'll receive a confirmation email with your ticket details shortly.'
     */
    JKrbe: T;
  };
};

export type EventMenuTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Edit Event'
   */
  editEvent: T;

  quick: {
    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Edit Event'
     */
    aL5E2: T;

    /**
     * @default 'This page can't be previewed in the editor.'
     */
    dO6tM: T;

    /**
     * @default 'View in guest preview'
     */
    w8pin: T;

    /**
     * @default 'Edit Website'
     */
    nH6Xt: T;
  };
};

export type EventPersonGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Before you 💙 that…'
     */
    dkqgA: T;

    /**
     * @default 'Drop your name so the couple and other guests know who's been admiring their photos.'
     */
    PeQO7: T;

    /**
     * @default 'Your Name'
     */
    '2p9Rw': T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;
  };
};

export type EventPhotoPickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;
  };
};

export type EventRedirectTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Pick Your Event'
   */
  pickYourEvent: T;

  /**
   * @default 'Or create a new one'
   */
  orCreateNewOne: T;
};

export type EventServiceCenterTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Service Center'
     */
    cBGKN: T;

    /**
     * @default 'Extend upload expiry?'
     */
    PfzUF: T;

    /**
     * @default 'This adds 365 days to the guest upload window (from today or the current expiry, whichever is later) and increases the extension count by 1.'
     */
    Q5sYc: T;

    /**
     * @default 'This can't be undone from here — correct a mistake by setting the dates manually.'
     */
    UFdsI: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Extend'
     */
    MQzUv: T;

    /**
     * @default 'Storage expiry is required'
     */
    fsXEv: T;

    /**
     * @default 'Required — to close the upload window, set a past date instead'
     */
    fo1WF: T;

    /**
     * @default 'This event has no photo expiry policy row — dates can't be set.'
     */
    RGLHA: T;

    /**
     * @default 'Failed to update photo expiry dates'
     */
    '3Ike4': T;

    /**
     * @default 'Photo expiry dates updated'
     */
    ltyOI: T;

    /**
     * @default 'Upload expiry extended to {{0}} (UTC)'
     */
    X4ijm: T;

    /**
     * @default 'Upload expiry extended'
     */
    rOuO0: T;

    /**
     * @default 'Failed to extend upload expiry'
     */
    Kor0V: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Failed to load photo expiry state'
     */
    QSQr8: T;

    /**
     * @default 'Active'
     */
    uFgDj: T;

    /**
     * @default 'Expired'
     */
    '7Jwbu': T;

    /**
     * @default 'Not included'
     */
    bxKhM: T;

    /**
     * @default 'Unlimited'
     */
    '9Boct': T;

    /**
     * @default 'Photo Expiry'
     */
    vGEVG: T;

    /**
     * @default 'Current state'
     */
    C7URD: T;

    /**
     * @default 'Storage:'
     */
    NvatG: T;

    /**
     * @default '{{0}} · expires {{1}} (UTC)'
     */
    '1ISz4': T;

    /**
     * @default 'Upload:'
     */
    '7MrCg': T;

    /**
     * @default 'Extensions: Storage {{0}} · Upload {{1}}'
     */
    '6XyxB': T;

    /**
     * @default 'No event date — suggestions anchor to event creation + 365 days.'
     */
    HJjtD: T;

    /**
     * @default 'Enable the 'Photos Monetization' event flag (Service Center home → feature flags) to edit expiry dates.'
     */
    qLL6O: T;

    /**
     * @default 'This event has no photo expiry policy yet (created on first Photos enrollment/purchase) — dates can't be set.'
     */
    K1OmQ: T;

    /**
     * @default 'Storage expires'
     */
    '3pIQp': T;

    /**
     * @default 'This date is in the past — storage access expires immediately.'
     */
    '1VR6A': T;

    /**
     * @default 'UTC, end of day'
     */
    '0Vwrf': T;

    /**
     * @default 'Suggested: {{0}} (UTC)'
     */
    UfjCD: T;

    /**
     * @default 'Fill'
     */
    hHDLA: T;

    /**
     * @default 'Upload expires'
     */
    RkjeC: T;

    /**
     * @default 'Upload expiry requires a Plus or Premium photos plan.'
     */
    '7fXBM': T;

    /**
     * @default 'No upload window granted — leave blank to keep it closed.'
     */
    LLEGC: T;

    /**
     * @default 'This date is in the past — the guest upload window closes immediately.'
     */
    p7ROA: T;

    /**
     * @default 'Suggestions are guidance only — verify the computed expiry before updating.'
     */
    s72Un: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Extend upload expiry (+365 days)'
     */
    dsN4k: T;

    /**
     * @default 'Save or revert your date changes before extending the upload window.'
     */
    VhqpS: T;

    /**
     * @default 'Unknown error'
     */
    Q9psa: T;

    /**
     * @default 'POI not found'
     */
    '1EKyn': T;

    /**
     * @default 'Updating POIs {{0}}/{{1}}...'
     */
    paHSJ: T;

    /**
     * @default 'Update done'
     */
    '1Ejmw': T;

    /**
     * @default 'Update error'
     */
    dciSR: T;

    /**
     * @default 'Unknown update error'
     */
    t8s9o: T;

    /**
     * @default 'Update ThingsToDo using TSV files'
     */
    IMnmu: T;

    /**
     * @default 'Select POIs file'
     */
    PKyjt: T;

    /**
     * @default 'Select Tours file'
     */
    '10ijw': T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Design Layout'
     */
    WFny2: T;

    /**
     * @default 'TSV Editor'
     */
    CNrwH: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Change location'
     */
    lzIs6: T;

    /**
     * @default 'Start typing to see options'
     */
    lwIoN: T;

    /**
     * @default 'Nothing To Do'
     */
    vZ4sR: T;

    /**
     * @default 'Fee rate is required'
     */
    piDj2: T;

    /**
     * @default 'Only numbers and . are allowed'
     */
    xDbVb: T;

    /**
     * @default 'Enter a value between 0.0% and 10.0%'
     */
    AM41v: T;

    /**
     * @default 'Joy Platform Fee updated'
     */
    UN56o: T;

    /**
     * @default 'Failed to update Joy Platform Fee'
     */
    ElOYS: T;

    /**
     * @default 'Failed to load Joy Platform Fee'
     */
    Nv6z3: T;

    /**
     * @default 'Joy Platform Fee'
     */
    HYqp7: T;

    /**
     * @default 'Current platform fee'
     */
    qBAET: T;

    /**
     * @default 'Set Joy Platform Fee for {{0}}'
     */
    c9KIN: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Standard Joy platform fee is 5.0% · Accepted range: 0.0% – 10.0%'
     */
    '7lLKi': T;

    /**
     * @default 'Home'
     */
    lgXLA: T;

    /**
     * @default 'Registry Orders'
     */
    '8mOAm': T;

    /**
     * @default 'Travel Offers'
     */
    '3YNlG': T;

    /**
     * @default 'Things To Do'
     */
    Hms92: T;

    /**
     * @default 'Website Pages'
     */
    Hsfjx: T;

    /**
     * @default 'Product Verticals'
     */
    e0INi: T;

    /**
     * @default 'Ticketing'
     */
    wFtV1: T;

    /**
     * @default 'Handle & Aliases'
     */
    cebl7: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Card Lab'
     */
    fneaT: T;

    /**
     * @default 'Guest List Actions'
     */
    '3hW78': T;

    /**
     * @default 'Transfer contacts to guestlist'
     */
    VZA91: T;

    /**
     * @default 'Transfer contacts to guestlist script completed successfully'
     */
    E3R13: T;

    /**
     * @default 'Create missing invitees'
     */
    VQU2c: T;

    /**
     * @default 'Creates Firebase invitees for contacts that have no guestId. Transfer only updates existing invitees.'
     */
    r8VCn: T;

    /**
     * @default 'Create missing invitees script completed successfully'
     */
    '23xEa': T;

    /**
     * @default 'Resync recipients from guestlist'
     */
    yYWN5: T;

    /**
     * @default 'Resync recipients from guestlist script completed successfully'
     */
    BixrF: T;

    /**
     * @default 'Rebuild contacts from guestlist'
     */
    MfMOT: T;

    /**
     * @default 'Last Resort: this deletes contacts and rebuilds it from guest list'
     */
    adpJd: T;

    /**
     * @default 'Rebuild contacts from guestlist script completed successfully'
     */
    X35NN: T;

    /**
     * @default 'Missing Event ID'
     */
    BAUPb: T;

    /**
     * @default 'Missing Auth Token'
     */
    dOtxo: T;

    /**
     * @default 'Missing User JWT'
     */
    '4fVKJ': T;

    /**
     * @default 'Another sync is already in progress for this event. Please wait 2 minutes.'
     */
    pvmt8: T;

    /**
     * @default 'There was an error running the script: {{0}}'
     */
    '1O5ac': T;

    /**
     * @default 'Owner'
     */
    bCjnG: T;

    /**
     * @default 'Admin'
     */
    X9BdF: T;

    /**
     * @default 'unknown'
     */
    yZKLA: T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Your Current Role'
     */
    Yiw2S: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'Your role is unavailable'
     */
    V0RWy: T;

    /**
     * @default 'Role:'
     */
    oMR1G: T;

    /**
     * @default 'User ID:'
     */
    CiKgO: T;

    /**
     * @default 'Email:'
     */
    aGPZu: T;

    /**
     * @default 'unavailable'
     */
    UGXIw: T;

    /**
     * @default 'Secret updated to: {{0}}'
     */
    Yb8pC: T;

    /**
     * @default 'Error resetting secret'
     */
    xYNwj: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Event Details (Legacy)'
     */
    QvvWR: T;

    /**
     * @default 'Event Secret:'
     */
    '8hKgI': T;

    /**
     * @default 'Creation Date (UTC):'
     */
    A7exn: T;

    /**
     * @default 'Epoch (UTC):'
     */
    i8Hyh: T;

    /**
     * @default 'New Secret'
     */
    y98p7: T;

    /**
     * @default 'leave blank for random'
     */
    X9yfR: T;

    /**
     * @default 'Reset'
     */
    PsxzG: T;

    /**
     * @default 'Cannot sync'
     */
    y9cJG: T;

    /**
     * @default 'Not syncable'
     */
    sHBez: T;

    /**
     * @default 'Sync disabled by user'
     */
    rq2oi: T;

    /**
     * @default 'Syncable'
     */
    '9GC3D': T;

    /**
     * @default 'Registry synced'
     */
    z6aly: T;

    /**
     * @default 'Error syncing registry'
     */
    A9Sy2: T;

    /**
     * @default 'Registries'
     */
    DbdUK: T;

    /**
     * @default 'Registries are unavailable'
     */
    NGbOM: T;

    /**
     * @default 'No registries found'
     */
    M18Di: T;

    /**
     * @default 'Registry logo'
     */
    OUXPg: T;

    /**
     * @default 'Items:'
     */
    S3gj5: T;

    /**
     * @default 'Last sync:'
     */
    X60Ry: T;

    /**
     * @default 'Sync Now'
     */
    rxItD: T;

    /**
     * @default 'Search engine visibility is unavailable'
     */
    WLNGV: T;

    /**
     * @default 'Hidden from search engines'
     */
    '19hO7': T;

    /**
     * @default 'Hidden from search engines (Google, Joy search)'
     */
    '9YTfk': T;

    /**
     * @default 'Visible to search engines'
     */
    smYuQ: T;

    /**
     * @default 'ID:'
     */
    VRVAA: T;

    /**
     * @default 'Email Verified:'
     */
    QkYjO: T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default 'Owners & Admins'
     */
    '6vD98': T;

    /**
     * @default 'Owners and admins are unavailable'
     */
    FOQ8S: T;

    /**
     * @default 'Owners'
     */
    MtBtL: T;

    /**
     * @default 'No owners found'
     */
    fWhww: T;

    /**
     * @default 'Admins'
     */
    EGbHj: T;

    /**
     * @default 'No admins found'
     */
    x6Sw7: T;

    /**
     * @default 'Schedule & Label Sync'
     */
    ggcK9: T;

    /**
     * @default 'Forces a fresh reimport of the event. Use when a guest unlocked a private/label-gated schedule but stopped seeing those events after RSVP — the reimport restores their schedule label access.'
     */
    LulVW: T;

    /**
     * @default 'Trigger Schedule & Label Sync'
     */
    '2FoxE': T;

    /**
     * @default 'Missing Firebase Event ID'
     */
    UL7ke: T;

    /**
     * @default 'Reimport triggered. Schedule & label data will resync within a couple of minutes.'
     */
    UJeqd: T;

    /**
     * @default 'There was an error triggering the reimport. Please try again.'
     */
    svQJN: T;
  };
};

export type EventSiteTranslations<T extends LeafNodeValue = TranslateFunction> = {
  eventRedirect: {
    eventNotFoundError: {
      /**
       * @default 'Hmm... we're having trouble with that.'
       */
      hed: T;

      /**
       * @default 'This event can no longer be found. We wish we knew more.'
       */
      dek: T;
    };
    graphqlError: {
      /**
       * @default 'Hmm... we're having trouble with that.'
       */
      hed: T;

      /**
       * @default 'This page can't be loaded at the moment. Please try again later.'
       */
      dek: T;
    };
  };
};

export type EventSiteAppsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Get the app'
     */
    '6cUcL': T;

    /**
     * @default 'Download Joy and join our app using our event handle {{0}}. View and share photos and stay up-to-date with details on the go.'
     */
    K04sP: T;

    /**
     * @default 'App Store'
     */
    CU1mB: T;

    /**
     * @default 'Google Play'
     */
    HqOj8: T;
  };
};

export type EventWorkspaceTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Design and customize your event website'
     */
    MkOnb: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Manage your wedding gift registry and cash funds with ease'
     */
    XfYWE: T;

    /**
     * @default 'Guest Stays'
     */
    iLmdi: T;

    /**
     * @default 'Simplify guest accommodations while saving them money'
     */
    '3PJUq': T;

    /**
     * @default 'Contacts'
     */
    BNWOJ: T;

    /**
     * @default 'Collect and manage contacts for your event'
     */
    FOezj: T;

    /**
     * @default 'Guest List'
     */
    sYWqA: T;

    /**
     * @default 'Manage the guests attending your event, including RSVPs, dietary restrictions, and more'
     */
    WDfhd: T;

    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Communicate with your guests through messaging'
     */
    MVgJc: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Event schedule to define times and locations for various activities during the event'
     */
    LOcW4: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Create and send a Save the Date for your wedding'
     */
    ShQXW: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Manage your event RSVPs, including guest responses and dietary restrictions'
     */
    BGJ4A: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Design and send invitations for your wedding'
     */
    pXFX1: T;

    /**
     * @default 'Day of'
     */
    fwl0q: T;

    /**
     * @default 'Browse signs, menus, and other stationery for your wedding'
     */
    FEsFb: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Manage your event photos and albums'
     */
    AlKkR: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Event settings to manage your event details, including title, date, location, and more'
     */
    qwg1U: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'Concierge'
     */
    NvCRC: T;

    /**
     * @default 'Event Site'
     */
    Jbbbn: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Make Planning Simple with Joy Concierge'
     */
    '6Xk6D': T;

    /**
     * @default 'Joy offers concierge services for venues, marketing materials, event swag, and more. Use the link below to submit a concierge request and our team will be in touch within 24 business hours.'
     */
    '9oNFD': T;

    /**
     * @default 'Create Request'
     */
    DRlvk: T;

    /**
     * @default 'Speakers'
     */
    IloSD: T;

    /**
     * @default 'Manage the your event speakers'
     */
    Vacbs: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Error: Event information is not available.'
     */
    '0m4i3': T;

    /**
     * @default 'Ask me anything...'
     */
    vl43F: T;

    /**
     * @default 'Clear search input'
     */
    P9iqC: T;
  };
};

export type FaqCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'FAQs'
     */
    ri1KA: T;

    /**
     * @default '{{0}} item'
     */
    '3w8zE': T;

    /**
     * @default '{{0}} items'
     */
    MtSBl: T;

    /**
     * @default 'What's Guest Q&A'
     */
    ALdaA: T;

    /**
     * @default 'Collect and answer frequently asked questions in one place.'
     */
    feDBD: T;

    /**
     * @default 'confirm'
     */
    wNSec: T;

    /**
     * @default 'cancel'
     */
    q0r5A: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Untitled'
     */
    rHPYf: T;

    /**
     * @default 'No answer'
     */
    RsBSM: T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default 'Failed to save FAQ'
     */
    NhBGT: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Back to list'
     */
    gGzoj: T;

    /**
     * @default 'Exit without saving?'
     */
    pUbF1: T;

    /**
     * @default 'Are you sure you want to exit without saving? All unsaved changes will be lost.'
     */
    Y7YP9: T;

    /**
     * @default 'Exit'
     */
    '497KA': T;

    /**
     * @default 'Question {{0}}'
     */
    W3Iq4: T;

    /**
     * @default 'Question'
     */
    ubqly: T;

    /**
     * @default 'Answer'
     */
    gMK6j: T;

    /**
     * @default 'Type your response here'
     */
    SLUdS: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Enter your question'
     */
    p8Px6: T;

    /**
     * @default 'Your Reply'
     */
    VrHkQ: T;
  };
};

export type FocusPointTranslations<T extends LeafNodeValue = TranslateFunction> = {
  editPhoto: {
    /**
     * @default 'Edit Photo'
     */
    actionEditText: T;
  };
};

export type FormTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Root value must be an object.'
     */
    '377jP': T;

    /**
     * @default '"components" must be an array.'
     */
    szObT: T;

    /**
     * @default 'components[{{0}}] must be an object.'
     */
    wngcm: T;

    /**
     * @default 'components[{{0}}].id must be a string.'
     */
    x9i0f: T;

    /**
     * @default 'components[{{0}}].required must be a boolean.'
     */
    w0zD7: T;

    /**
     * @default 'components[{{0}}].title must be a string when provided.'
     */
    b61LV: T;

    /**
     * @default 'components[{{0}}].placeholder must be a string.'
     */
    Ph4PX: T;

    /**
     * @default 'components[{{0}}].options must be an array.'
     */
    '0gIO0': T;

    /**
     * @default 'components[{{0}}].options[{{1}}] must be an object.'
     */
    Fy5kz: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].label must be a string.'
     */
    JUl6l: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].value must be a string.'
     */
    Q1B5L: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].next must be a string.'
     */
    oEPjF: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].checked must be a boolean when provided.'
     */
    swOUF: T;

    /**
     * @default 'components[{{0}}].type "{{1}}" is not supported.'
     */
    '6lxYo': T;

    /**
     * @default 'Add at least one question.'
     */
    Np5gA: T;

    /**
     * @default 'Question {{0}}: id is required.'
     */
    orUJL: T;

    /**
     * @default 'Question {{0}}: duplicate id "{{1}}".'
     */
    bbgDi: T;

    /**
     * @default 'Question {{0}}: required must be a boolean.'
     */
    igkwi: T;

    /**
     * @default 'Question {{0}}: placeholder is required.'
     */
    Mwjfy: T;

    /**
     * @default 'Question {{0}}: add at least one option.'
     */
    g9rES: T;

    /**
     * @default 'Question {{0}} option {{1}}: label is required.'
     */
    N5pN6: T;

    /**
     * @default 'Question {{0}} option {{1}}: value is required.'
     */
    a7GFS: T;

    /**
     * @default 'Question {{0}} option {{1}}: checked must be a boolean.'
     */
    '2Q3w2': T;

    /**
     * @default 'Short Answer'
     */
    '0isuN': T;

    /**
     * @default 'Paragraph'
     */
    sx99g: T;

    /**
     * @default 'Multiple Choice'
     */
    xnpsD: T;

    /**
     * @default 'Checkboxes'
     */
    fS1Yr: T;

    /**
     * @default 'Question'
     */
    ubqly: T;

    /**
     * @default 'Go to question'
     */
    '1chcl': T;

    /**
     * @default 'Go to next question'
     */
    wUwhh: T;

    /**
     * @default 'Submit form'
     */
    ssRg5: T;

    /**
     * @default 'Question {{0}}'
     */
    W3Iq4: T;

    /**
     * @default 'type'
     */
    gtDSA: T;

    /**
     * @default 'Question title'
     */
    qI4E4: T;

    /**
     * @default 'Clear title'
     */
    jXJy2: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Placeholder'
     */
    '9DreF': T;

    /**
     * @default 'Clear placeholder'
     */
    gP8xe: T;

    /**
     * @default 'Options'
     */
    Uw6kb: T;

    /**
     * @default 'Option {{0}}'
     */
    FKOI3: T;

    /**
     * @default 'Clear option label'
     */
    '44SIR': T;

    /**
     * @default 'When selected go to'
     */
    Q8zCS: T;

    /**
     * @default 'Remove option {{0}}'
     */
    '3Wz4P': T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Checked by default'
     */
    bkDjI: T;

    /**
     * @default 'Add option'
     */
    mItFQ: T;

    /**
     * @default 'Remove question'
     */
    aQVdI: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Add question'
     */
    hwC7X: T;

    /**
     * @default 'Add Question'
     */
    '7XvlO': T;

    /**
     * @default 'Change question type?'
     */
    J5Mhu: T;

    /**
     * @default 'Changing this question{{0}}{{1}} will reset type-specific settings such as answer options.'
     */
    yI0yS: T;

    /**
     * @default 'Are you sure you want to continue?'
     */
    '8Vw4Q': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Change'
     */
    cH8ro: T;

    /**
     * @default 'Remove question?'
     */
    VMWSA: T;

    /**
     * @default 'Deleting this question cannot be undone.'
     */
    '7nEU8': T;

    /**
     * @default 'Are you sure you want to remove it?'
     */
    MQ7Wj: T;

    /**
     * @default 'Fix the following issues:'
     */
    '7eoaq': T;
  };
};

export type FormCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Form'
     */
    I2ELA: T;

    /**
     * @default 'Made with'
     */
    DatKQ: T;

    /**
     * @default 'Create Your Own'
     */
    X8GSz: T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default 'Step {{0}} of {{1}}'
     */
    sXRsT: T;

    /**
     * @default 'Registering For'
     */
    otJj5: T;

    /**
     * @default 'Requesting to Join'
     */
    oFzmu: T;

    /**
     * @default 'Updating Registration For'
     */
    Uzuvx: T;

    /**
     * @default 'Updating · {{0}}'
     */
    pPERW: T;

    /**
     * @default 'This form isn’t available'
     */
    c6NX4: T;

    /**
     * @default 'The link may be out of date, or the form didn’t load. Try again, or go back to the event’s website.'
     */
    oLOyd: T;

    /**
     * @default 'The link may be out of date. Go back to the event’s website.'
     */
    oIa0r: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Back to Website'
     */
    dNvtn: T;

    /**
     * @default 'The form will be displayed directly on your website page. Visitors can fill out the form without leaving the page.'
     */
    UMuJc: T;

    /**
     * @default 'A link to the form will be displayed on your website page. Visitors will need to click the link to open and fill out the form.'
     */
    s0lsR: T;

    /**
     * @default 'Choose Form'
     */
    hWMiA: T;

    /**
     * @default 'Please select a form.'
     */
    rFzC6: T;

    /**
     * @default 'Display Type'
     */
    KL7DB: T;

    /**
     * @default 'Embedded'
     */
    gVjRv: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Register for the Event'
     */
    HujDV: T;

    /**
     * @default 'Subtitle'
     */
    '0Yy27': T;

    /**
     * @default 'To join the event, register below'
     */
    '0KoqJ': T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Enter button text (e.g. 'Go To RSVP')'
     */
    SgQ37: T;

    /**
     * @default 'No forms found. Please create a form first.'
     */
    ljWWc: T;

    /**
     * @default 'Registration Closed'
     */
    bFTnn: T;

    /**
     * @default 'This event is no longer accepting registrations'
     */
    Qf1Yx: T;

    /**
     * @default 'Update Registration'
     */
    OqP1B: T;

    /**
     * @default 'Register Now'
     */
    jfRIv: T;

    /**
     * @default 'Open Form'
     */
    KGMj3: T;

    /**
     * @default 'Event Registration'
     */
    TPiGx: T;

    /**
     * @default 'Thanks, {{0}}. Your request is in for review.'
     */
    VeVlB: T;

    /**
     * @default 'Thanks! Your request is in for review.'
     */
    gshQb: T;

    /**
     * @default 'Submitting registration…'
     */
    NZjmv: T;

    /**
     * @default 'Registration submitted'
     */
    gAZ76: T;

    /**
     * @default 'Request sent'
     */
    xTWky: T;

    /**
     * @default 'You’ve responded'
     */
    FwWrr: T;

    /**
     * @default 'You’re registered'
     */
    rsANX: T;

    /**
     * @default 'Payment received. Your request is in for review.'
     */
    ff10n: T;

    /**
     * @default 'Payment successful. Your ticket details are on their way by email.'
     */
    '0ygjE': T;

    /**
     * @default 'Thanks for the heads-up.'
     */
    IRQiW: T;

    /**
     * @default 'Order number'
     */
    vjdB1: T;

    /**
     * @default 'Amount paid'
     */
    AXY88: T;

    /**
     * @default 'Your order'
     */
    '3mU6S': T;
  };
};

export type GeneralEventScheduleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Schedule'
     */
    RrFg4: T;

    /**
     * @default 'Agenda'
     */
    gKLVj: T;

    /**
     * @default 'Failed to add agenda. Please try again.'
     */
    aM9wH: T;
  };
};

export type GeneralEventScheduleEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Timeline'
     */
    J794h: T;

    /**
     * @default 'Events on a vertical timeline indicator'
     */
    PlR3x: T;

    /**
     * @default 'Centered'
     */
    oJFOH: T;

    /**
     * @default 'Centered single column layout'
     */
    I6Vgl: T;

    /**
     * @default 'Compact'
     */
    fE042: T;

    /**
     * @default 'Accordion — tap to expand each event'
     */
    HHYPu: T;

    /**
     * @default 'Cards'
     */
    PVimF: T;

    /**
     * @default 'Each event in its own contained tile'
     */
    PRfrI: T;

    /**
     * @default 'Classic'
     */
    UZCBu: T;

    /**
     * @default 'Simple columns for each day'
     */
    pKzQs: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Setting up your new Schedule view'
     */
    Cd13K: T;

    /**
     * @default 'Failed to update schedule layout'
     */
    Evabe: T;

    /**
     * @default 'Failed to load schedule. Please try again later.'
     */
    qunZy: T;

    /**
     * @default 'Failed to edit schedule'
     */
    xl1yj: T;

    /**
     * @default 'Failed to add schedule'
     */
    '2AYLS': T;

    /**
     * @default 'Event Schedule'
     */
    RrFg4: T;

    /**
     * @default '{{0}} - {{1}}'
     */
    iy4m2: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Date To Be Announced'
     */
    VRIWE: T;

    /**
     * @default 'Start building your schedule'
     */
    eToYI: T;

    /**
     * @default 'Add Event'
     */
    '3wzVJ': T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default '…and 1 more person'
     * @param {number} count - The number of occurrences.
     * - singular: …and 1 more person
     * - plural: …and {{0}} more people
     */
    LDQK1: T;

    /**
     * @default 'Guests with an empty schedule'
     */
    yQmb9: T;

    /**
     * @default 'These guests aren't included in any of the events on this schedule. Add them from the guest list to fix it.'
     */
    mHpwS: T;

    /**
     * @default 'We couldn't load these guests. Please close this dialog and try again.'
     */
    C4h2v: T;

    /**
     * @default 'Everyone on the guest list can now see at least one event.'
     */
    QZ3Be: T;

    /**
     * @default 'Unnamed Guest'
     */
    s4P35: T;

    /**
     * @default '1 guest isn't included in any of these events, so they will see an empty schedule.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest isn't included in any of these events, so they will see an empty schedule.
     * - plural: {{0}} guests aren't included in any of these events, so they will see an empty schedule.
     */
    UbTaG: T;

    /**
     * @default 'Show guests'
     */
    U0Cfa: T;

    /**
     * @default 'Go to Guest List'
     */
    vRGzv: T;

    /**
     * @default 'All Guests'
     */
    IwnQp: T;

    /**
     * @default 'Still loading your schedule. Please try again in a moment.'
     */
    t38SU: T;

    /**
     * @default '{{0}} events deleted from your schedule'
     */
    GlYU4: T;

    /**
     * @default 'Deleted {{0}} events. {{1}} failed to delete.'
     */
    wYjlc: T;

    /**
     * @default 'Event deleted from your schedule'
     */
    z9WL9: T;

    /**
     * @default 'Failed to delete. Please try again.'
     */
    '0S0eI': T;

    /**
     * @default 'Failed to save. Please try again.'
     */
    WDfiJ: T;
  };
};

export type GeneralFormValidationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Invalid Email'
   */
  invalidEmail: T;

  /**
   * @default 'Required'
   */
  required: T;

  /**
   * @default 'You must agree to continue'
   */
  mustAgreeToContinue: T;

  quick: {
    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;
  };
};

export type GetStartedOnboardingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'You're all set'
     */
    AMUXy: T;

    /**
     * @default 'Explore website templates'
     */
    Z6Tic: T;

    /**
     * @default 'Browse designs and preview them with your own photo'
     */
    '9zvJi': T;

    /**
     * @default 'Add your photo to all templates'
     */
    nb5ha: T;

    /**
     * @default 'See every template with your own photo in it before you commit to one.'
     */
    '5ywbh': T;

    /**
     * @default 'Style your homepage header'
     */
    l9HFT: T;

    /**
     * @default 'Pick a header style — it is the first thing guests see'
     */
    emyKU: T;

    /**
     * @default 'Pick your header and navigation'
     */
    ioK74: T;

    /**
     * @default 'Photo trio, video, monogram, split view and more — every header pairs with the navigation style you pick.'
     */
    bu4r6: T;

    /**
     * @default 'Start building your schedule'
     */
    eToYI: T;

    /**
     * @default 'Tell guests where to be and when — and who each event is for'
     */
    '1CMwa': T;

    /**
     * @default 'Add each event guests need to know about — the timeline builds itself as you go.'
     */
    h9FeT: T;

    /**
     * @default 'Add "Where to Stay" details'
     */
    '8zhNo': T;

    /**
     * @default 'Guests will thank you — especially the out-of-towners'
     */
    DaIqM: T;

    /**
     * @default 'Add Where to Stay details'
     */
    '8R5mm': T;

    /**
     * @default 'Your hotel picks show up on Where to Stay — so guests can book in one place, with your event's group code ready to use.'
     */
    VO8DP: T;

    /**
     * @default 'Add your photos'
     */
    TBrBm: T;

    /**
     * @default 'The ones you love, in one place — guests can see them too'
     */
    LBGyC: T;

    /**
     * @default 'Drop in the photos you want to share. Sort them into albums whenever you like, and add more as the day gets closer.'
     */
    aMLdp: T;

    /**
     * @default 'Invite your partner'
     */
    agaFG: T;

    /**
     * @default 'Plan it together — they get the same access you have'
     */
    KWTF9: T;

    /**
     * @default 'Send them an invite and you can build the site together, from either account — no passing one login back and forth.'
     */
    o0jXr: T;

    /**
     * @default 'Customize your Joy URL'
     */
    L01iV: T;

    /**
     * @default 'Claim a short link that is easy to say out loud'
     */
    ceqLr: T;

    /**
     * @default 'Claim a short link guests can actually remember, then copy it and share.'
     */
    bUr5l: T;

    /**
     * @default 'We're creating designs to match your photo'
     */
    FaZJB: T;

    /**
     * @default 'They'll be ready in a moment, in the meantime you can start exploring all the designs.'
     */
    '9ViGZ': T;

    /**
     * @default 'Bespoke templates from your photo'
     */
    hymqk: T;

    /**
     * @default 'The first three designs are made just for you. Swap the photo or add more to see different ones.'
     */
    cj7Q1: T;

    /**
     * @default 'View designs'
     */
    cOw9D: T;

    /**
     * @default 'Try it'
     */
    q3gkY: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Get started'
     */
    zUfsR: T;

    /**
     * @default 'Restart tour'
     */
    PEaGN: T;

    /**
     * @default 'Close tour'
     */
    Yingr: T;

    /**
     * @default 'Close checklist'
     */
    C3vcY: T;

    /**
     * @default 'You're all set, {{0}}'
     */
    enziQ: T;

    /**
     * @default 'Your website is looking lovely. Share it with your guests whenever you're ready — they'll find everything they need in one place.'
     */
    '9uyUB': T;

    /**
     * @default 'Done — nice work.'
     */
    OU9sJ: T;

    /**
     * @default 'Mark "{{0}}" as done'
     */
    rdABm: T;

    /**
     * @default 'Completed'
     */
    NwyhL: T;
  };
};

export type GiftNoteGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Wishing you joy and happiness on this special occasion. Hope you love this gift!'
     */
    LafbE: T;

    /**
     * @default 'Congratulations on your special day! I'm so excited for you and hope this brings many wonderful moments.'
     */
    uwBrj: T;

    /**
     * @default 'Sending you warm wishes and lots of love. I hope this gift adds to the joy of your celebration!'
     */
    '3yIqr': T;

    /**
     * @default 'So happy to celebrate with you! Wishing you all the best and hope you enjoy this gift.'
     */
    V1jAg: T;

    /**
     * @default '{{0}} and {{1}}'
     */
    ifsOv: T;

    /**
     * @default 'the couple'
     */
    zzvM8: T;

    /**
     * @default 'Dear {{0}},'
     */
    wSvKp: T;

    /**
     * @default 'Warmly,'
     */
    MWSQW: T;
  };
};

export type GraphErrorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  code: {
    /**
     * @default 'An unknown error occurred.'
     */
    UNKNOWN: T;

    /**
     * @default 'Multiple Cash Fund accounts are associated with your profile.'
     */
    PAYOUT_ACCOUNT_MULTIPLE_PRIMARY: T;

    /**
     * @default 'There is an issue with the US postal code in your address.'
     */
    PAYOUT_ACCOUNT_INVALID_US_POSTAL_CODE: T;

    /**
     * @default 'There is an issue with the US state in your address.'
     */
    PAYOUT_ACCOUNT_INVALID_US_STATE: T;

    /**
     * @default 'There is an issue with the Country of your address.'
     */
    PAYOUT_ACCOUNT_INVALID_COUNTRY_CODE: T;
  };
  shared: {
    /**
     * @default 'Contact us at {{email}}.'
     */
    contactUs: T;
  };
  quick: {
    /**
     * @default 'An unknown error occurred.'
     */
    '8D8Bp': T;
  };
};

export type GraphicAccentCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Graphic Accent'
     */
    uJOr5: T;

    /**
     * @default 'Please select a graphic accent.'
     */
    BcTwU: T;

    /**
     * @default 'An error occurred while updating the graphic accent. Please try again.'
     */
    tHkVI: T;

    /**
     * @default 'Success! Graphic accent has been updated.'
     */
    rlcAI: T;

    /**
     * @default 'An error occurred while adding the graphic accent. Please try again.'
     */
    klMXA: T;

    /**
     * @default 'Success! Graphic accent has been added.'
     */
    C3gzE: T;

    /**
     * @default 'Current Selection'
     */
    Rmj9W: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Decorative accent for your page'
     */
    noAwf: T;

    /**
     * @default 'Select Graphic Accent'
     */
    '2jd1X': T;

    /**
     * @default 'Change →'
     */
    mNJ1F: T;
  };
};

export type GreetingMessageComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Greeting Message'
     */
    '2kB74': T;

    /**
     * @default 'Greeting message is required.'
     */
    rzSpo: T;
  };
};

export type GroupMessagingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'View your Messaging+ features'
     */
    Ani58: T;

    /**
     * @default 'Upgrade to Messaging+'
     */
    AErUZ: T;

    /**
     * @default 'Billing country: {{0}}'
     */
    bsvOO: T;

    /**
     * @default 'Messaging+ preview'
     */
    JlJDi: T;

    /**
     * @default 'Messaging+ is yours.'
     */
    p0PHb: T;

    /**
     * @default 'It's active for your event. Here's everything you've unlocked.'
     */
    aglKQ: T;

    /**
     * @default 'Got It'
     */
    BlI4z: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Upgrade to'
     */
    FvLPP: T;

    /**
     * @default 'Messaging+'
     */
    NwvUY: T;

    /**
     * @default 'Plus'
     */
    ahjMA: T;

    /**
     * @default 'Reach Everyone'
     */
    uZl8E: T;

    /**
     * @default 'Send texts, {{0}}, and emails to everyone in one go.*'
     */
    nsifu: T;

    /**
     * @default 'Blast texts and email, all at once.*'
     */
    '8Y14a': T;

    /**
     * @default 'Blast texts and email, all at once.'
     */
    Er0T1: T;

    /**
     * @default 'Schedule in Advance'
     */
    Uz2oF: T;

    /**
     * @default 'Set up reminders now, to send later.'
     */
    J0nCg: T;

    /**
     * @default 'Writing Assistant & Styles'
     */
    yh6CI: T;

    /**
     * @default 'AI writing tools, links, lists and more.'
     */
    FjJjX: T;

    /**
     * @default 'SMS pricing is unavailable.'
     */
    Hlo6K: T;

    /**
     * @default 'You can still send this message by email.'
     */
    '7gluP': T;

    /**
     * @default 'Please try again later.'
     */
    Fn2ol: T;

    /**
     * @default 'Plus applicable taxes'
     */
    aCQ65: T;

    /**
     * @default 'Includes taxes'
     */
    GhCst: T;

    /**
     * @default 'Messaging+ is Active'
     */
    d0TKX: T;

    /**
     * @default 'SMS Messaging is Active'
     */
    Famwy: T;

    /**
     * @default 'Messaging+ is already active for this event. You can send messages, schedule sends, and use rich emails right away.'
     */
    qHKIi: T;

    /**
     * @default 'SMS messaging is already active for this event. You can send text messages to your guests right away.'
     */
    HiSGa: T;

    /**
     * @default 'Text message example'
     */
    KqQ4g: T;

    /**
     * @default '{{0}}. Plan. Send.'
     */
    '7spfJ': T;

    /**
     * @default 'Text. Plan. Send.'
     */
    '6DSrG': T;

    /**
     * @default 'Send messages on {{0}}.'
     */
    DHoLz: T;

    /**
     * @default 'Send messages by text.'
     */
    m5RNE: T;

    /**
     * @default 'One-time purchase for your event.'
     */
    VH0RL: T;

    /**
     * @default 'One-time purchase. Message everyone, or just the wedding party.*'
     */
    PG9gm: T;

    /**
     * @default 'Unlock & Send'
     */
    kGf3y: T;

    /**
     * @default 'Send via Email'
     */
    a84YF: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default '*Numbers outside the U.S. and Canada will be sent via {{0}}. Text blasts go to U.S. and Canadian numbers only.'
     */
    Zx7au: T;

    /**
     * @default '*Currently available for U.S. and Canadian phone numbers only.'
     */
    GYe35: T;

    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;

    /**
     * @default 'Sender name must be {{0}} characters or fewer.'
     */
    gjs6q: T;

    /**
     * @default 'As we prepare to celebrate together, we're updating our guest contact details. Please share your mailing address and contact details.'
     */
    Jmhi1: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    A3Epe: T;

    /**
     * @default 'Message sent successfully!'
     */
    d2F6T: T;

    /**
     * @default 'Share your contact info'
     */
    i00U7: T;

    /**
     * @default 'Share Your Contact Info'
     */
    WamcE: T;

    /**
     * @default 'Untitled contact collection - {{0}}'
     */
    w7hiA: T;

    /**
     * @default 'Dear'
     */
    QMtKA: T;

    /**
     * @default 'There was an error updating the Contact Collector.'
     */
    shKpF: T;

    /**
     * @default 'You can still share your Contact Collector with guests — use the share link above to send it however you like.'
     */
    bzaE7: T;

    /**
     * @default 'Turn on your Contact Collector to start sharing it with guests.'
     */
    '7Owfq': T;

    /**
     * @default 'Set up your Contact Collector to start collecting guest info.'
     */
    IlTI8: T;

    /**
     * @default 'Text messaging isn't available for your event yet.'
     */
    pudgU: T;

    /**
     * @default 'Turn on Contact Collector'
     */
    '94jyH': T;

    /**
     * @default 'Set Up Contact Collector'
     */
    U42Hy: T;

    /**
     * @default 'Thank you, feature requested.'
     */
    '5zUvg': T;

    /**
     * @default 'Request This Feature'
     */
    B4pZS: T;

    /**
     * @default 'Collect Contacts'
     */
    v9WNU: T;

    /**
     * @default 'Note: 1 guest does not have the required contact information for the selected delivery method.'
     * @param {number} count - The number of occurrences.
     * - singular: Note: 1 guest does not have the required contact information for the selected delivery method.
     * - plural: Note: {{0}} guests do not have the required contact information for the selected delivery method.
     */
    UcMqD: T;

    /**
     * @default '1 Text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Text
     * - plural: {{0}} Texts
     */
    AF6wP: T;

    /**
     * @default '1 {{0}}'
     * @param {number} count - The number of occurrences.
     * - singular: 1 {{0}}
     * - plural: {{0}} {{1}}
     */
    uaGyV: T;

    /**
     * @default '1 Email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Email
     * - plural: {{0}} Emails
     */
    '06HnF': T;

    /**
     * @default 'Edit Recipients'
     */
    QInCZ: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'Select a recipient'
     */
    mXpRV: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Select an admin'
     */
    wKRDT: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Messaging+ is active. You can now schedule messages and text your guests.'
     */
    TC4p2: T;

    /**
     * @default 'Payment was not completed. You can try again when you're ready.'
     */
    tlQsK: T;

    /**
     * @default 'Payment received, but activation is taking longer than expected. Please refresh the page.'
     */
    VHGYp: T;

    /**
     * @default 'Your message to guests'
     */
    mkfzl: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Subject (Email only)'
     */
    '91kvm': T;

    /**
     * @default 'Subject line for email'
     */
    b4dB9: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'This is your Contact Collector link. Guests will use it to submit their contact information.'
     */
    ErvZO: T;

    /**
     * @default 'Contact collector link'
     */
    HbqJf: T;

    /**
     * @default 'Contact collector bulk messages require phone numbers or email addresses in your guest list.'
     */
    J9DCa: T;

    /**
     * @default 'Add contacts from your phone'
     */
    XjT3C: T;

    /**
     * @default 'Upload a spreadsheet'
     */
    Ax8Os: T;

    /**
     * @default 'Add manually in guest list'
     */
    bw9jB: T;

    /**
     * @default 'We're reviewing your message before delivery'
     */
    '5msPb': T;

    /**
     * @default 'We couldn't save your message. Please try again.'
     */
    YuoZ4: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Send Now'
     */
    Ow0GV: T;

    /**
     * @default 'Confirm & Send'
     */
    KYpY4: T;

    /**
     * @default 'Review the details below and send your contact collector link to your guests.'
     */
    klKte: T;

    /**
     * @default 'Something Went Wrong'
     */
    DhQjr: T;

    /**
     * @default 'We weren't able to send your messages. Please check your connection and try again.'
     */
    '9YSw9': T;

    /**
     * @default 'Review & Resend'
     */
    '5QGJr': T;

    /**
     * @default 'Back to Compose'
     */
    qYQEB: T;

    /**
     * @default '1 Message Sent'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Message Sent
     * - plural: {{0}} Messages Sent
     */
    AVxf8: T;

    /**
     * @default '1 email sent'
     * @param {number} count - The number of occurrences.
     * - singular: 1 email sent
     * - plural: {{0}} emails sent
     */
    IqLr6: T;

    /**
     * @default '1 email could not be delivered'
     * @param {number} count - The number of occurrences.
     * - singular: 1 email could not be delivered
     * - plural: {{0}} emails could not be delivered
     */
    MRsij: T;

    /**
     * @default '1 text sent'
     * @param {number} count - The number of occurrences.
     * - singular: 1 text sent
     * - plural: {{0}} texts sent
     */
    wRTvM: T;

    /**
     * @default '1 text could not be delivered'
     * @param {number} count - The number of occurrences.
     * - singular: 1 text could not be delivered
     * - plural: {{0}} texts could not be delivered
     */
    ci7io: T;

    /**
     * @default '+ 1 more'
     * @param {number} count - The number of occurrences.
     * - singular: + 1 more
     * - plural: + {{0}} more
     */
    Ldd7I: T;

    /**
     * @default 'Message Under Review'
     */
    HLZe7: T;

    /**
     * @default 'Your message is being reviewed by our team to ensure delivery quality. It will be sent to your guests once approved.'
     */
    R3xzW: T;

    /**
     * @default 'Back to Contact Collector'
     */
    tfsrW: T;

    /**
     * @default 'Send to More Guests'
     */
    PwjK1: T;

    /**
     * @default 'Messages Could Not Be Delivered'
     */
    BdvVi: T;

    /**
     * @default 'None of the selected recipients could be reached. This usually means their contact information is missing or invalid. You can update their details in your guest list.'
     */
    Cywg6: T;

    /**
     * @default 'Go to Guest List'
     */
    vRGzv: T;

    /**
     * @default 'Your contact collector link is on its way.'
     */
    AOT3g: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Some recipients could not be reached. Their contact info may need to be updated in your guest list.'
     */
    hxxc9: T;

    /**
     * @default '1 Person Selected…'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    HsBfd: T;

    /**
     * @default 'Please select recipients to continue.'
     */
    Wab1K: T;

    /**
     * @default '+1s are on'
     */
    Wx69p: T;

    /**
     * @default '+1s are off'
     */
    y0q8P: T;

    /**
     * @default 'Allow guests to add their family members or plus one to their contact information.'
     */
    '9OXBO': T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default '✨ Link copied! ✨'
     */
    NlEES: T;

    /**
     * @default 'Couldn't copy link — please try selecting and copying manually.'
     */
    pkAER: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Modify Recipients'
     */
    Yv9UB: T;

    /**
     * @default 'Compose Message'
     */
    lBM1t: T;

    /**
     * @default 'Customize the message that will be sent with your contact collector link.'
     */
    fx8Ua: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'Want to share another way? '
     */
    nV5ua: T;

    /**
     * @default 'Use the share link'
     */
    '9ZFu2': T;

    /**
     * @default 'Edit Cover Art'
     */
    g6wwm: T;

    /**
     * @default 'Review Scheduled Message'
     */
    iXF6X: T;

    /**
     * @default 'This message is locked while it's scheduled. Use "Edit Message" to make changes.'
     */
    W23tA: T;

    /**
     * @default 'Reschedule send'
     */
    qm0u7: T;

    /**
     * @default 'Reschedule'
     */
    '82rNl': T;
  };
};

export type GuestGuideTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Edit RSVP Response'
   */
  buttonTextEditRSVP: T;

  quick: {
    /**
     * @default 'Guest guide to what's next.'
     */
    uZmEA: T;

    /**
     * @default 'Not You?'
     */
    D1zbA: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;

    /**
     * @default 'View Guest Guide'
     */
    fBVQW: T;

    /**
     * @default 'Hi {{0}}!'
     */
    qYySE: T;

    /**
     * @default 'Change Response'
     */
    tA6un: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Not Attending'
     */
    RXHya: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default '1 day to the big event!'
     * @param {number} count - The number of occurrences.
     * - singular: 1 day to the big event!
     * - plural: {{0}} days to the big event!
     */
    GOcVI: T;

    /**
     * @default 'It's the big day!'
     */
    hiBXY: T;

    /**
     * @default 'Book your stay if you haven't already.'
     */
    ulWZ5: T;

    /**
     * @default 'Book your stay, before rooms sell out.'
     */
    SxcqR: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'Book a Car Rental'
     */
    OXwRt: T;

    /**
     * @default 'Explore Car Rentals'
     */
    YbFLF: T;

    /**
     * @default '1 day to the big event - book your stay, before rooms sell out.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 day to the big event - book your stay, before rooms sell out.
     * - plural: {{0}} days to the big event - book your stay, before rooms sell out.
     */
    AjuzJ: T;

    /**
     * @default 'Guest Only Hotel Deals'
     */
    HIAVy: T;

    /**
     * @default 'Book Event-Exclusive Stays'
     */
    OsMGN: T;

    /**
     * @default 'See Event-Exclusive Stays'
     */
    gAGcC: T;

    /**
     * @default 'It's the big day - book your stay if you haven't already.'
     */
    Pp9rI: T;

    /**
     * @default 'Remind to Book'
     */
    lCxDC: T;
  };
};

export type GuestInAppBrowserBannerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'For the best experience, open this page in your browser.'
     */
    HbqYl: T;

    /**
     * @default 'Open'
     */
    cLbMA: T;
  };
};

export type GuestKitTranslations<T extends LeafNodeValue = TranslateFunction> = {
  components: {
    virtualEventBlock: {
      /**
       * @default 'at'
       */
      at: T;

      /**
       * @default 'Join Livestream'
       */
      joinCta: T;

      /**
       * @default 'Join With Zoom'
       */
      joinCtaZoom: T;

      /**
       * @default 'Now Live'
       */
      eventLive: T;

      /**
       * @default 'The event has not yet started.'
       */
      eventUpcoming: T;

      /**
       * @default 'Starts in {{startsInMin}} minutes.'
       */
      eventStartsSoon: T;

      /**
       * @default 'This event has passed.'
       */
      eventPassed: T;

      /**
       * @default 'Time to be announced'
       */
      eventTba: T;

      /**
       * @default 'Your Local Time ({{offset}})'
       */
      localTimezoneOffset: T;

      /**
       * @default 'Streaming by'
       */
      streamingProvider: T;

      /**
       * @default 'Having trouble with the app?'
       */
      troubleWithApp: T;

      /**
       * @default 'Watch in a browser'
       */
      watchInBrowser: T;
    };
  };
  widgetRegistry: {
    /**
     * @default 'Visit {{name}} registry'
     */
    visitNamedRegistry: T;

    /**
     * @default 'Visit registry'
     */
    visitUnnamedRegistry: T;

    /**
     * @default 'Browse Our Registry'
     */
    buttonText: T;
  };
  common: {
    /**
     * @default '{{start}} to {{end}}'
     */
    timeframe: T;

    /**
     * @default '{{start}} to {{end}} ({{timezoneAbbr}})'
     */
    timeframeTz: T;

    /**
     * @default '{{startDate}} {{startTime}} to
{{endDate}} {{endTime}}'
*/
    timeframeMultiDay: T;

    /**
     * @default '{{startDate}} {{startTime}} to
{{endDate}} {{endTime}} ({{timezoneAbbr}})'
*/
    timeframeMultiDayTz: T;

    /**
     * @default '{{time}} ({{timezoneAbbr}})'
     */
    timeTz: T;

    /**
     * @default 'Add to Calendar'
     */
    addToCalendar: T;

    /**
     * @default 'Where to Stay'
     */
    whereToStay: T;

    /**
     * @default 'Add to Cal'
     */
    addToCal: T;

    /**
     * @default 'Discount Code'
     */
    discountCodeLabel: T;

    /**
     * @default 'Dress Code'
     */
    dressCode: T;

    /**
     * @default 'Directions'
     */
    getDirections: T;

    /**
     * @default 'menu'
     */
    menu: T;

    /**
     * @default 'For more details'
     */
    moreDetails: T;

    /**
     * @default 'To Be Announced'
     */
    toBeAnnouncedHeader: T;

    /**
     * @default 'Details for this event will be shared at a later date.'
     */
    toBeAnnouncedDescription: T;

    /**
     * @default 'Text Copied!'
     */
    textCopiedNotificationLabel: T;
  };
  quick: {
    /**
     * @default 'Map for {{0}}'
     */
    bjYyE: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Dress Code'
     */
    '4K6cX': T;

    /**
     * @default 'Directions'
     */
    G3n2r: T;

    /**
     * @default 'For more details'
     */
    MGEK8: T;

    /**
     * @default '{{0}} ({{1}})'
     */
    YPUxD: T;

    /**
     * @default '{{0}} {{1}} to
{{2}} {{3}} ({{4}})'
*/
    e1blL: T;

    /**
     * @default '{{0}} {{1}} to
{{2}} {{3}}'
*/
    '5ttKD': T;

    /**
     * @default '{{0}} to {{1}} ({{2}})'
     */
    TigjO: T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;

    /**
     * @default 'To Be Announced'
     */
    tG3lp: T;

    /**
     * @default 'Details for this event will be shared at a later date.'
     */
    ncOcz: T;

    /**
     * @default 'Greetings'
     */
    O7KTk: T;

    /**
     * @default 'Page Note'
     */
    pr8sf: T;

    /**
     * @default 'Video Background'
     */
    FJLTh: T;

    /**
     * @default 'Video background fallback'
     */
    xpMpC: T;

    /**
     * @default 'Error loading video background'
     */
    fCVmY: T;
  };
};

export type GuestListTranslations<T extends LeafNodeValue = TranslateFunction> = {
  admin: {
    /**
     * @default 'Guest'
     */
    guest: T;

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'created'
     */
    created: T;

    /**
     * @default 'updated'
     */
    updated: T;

    /**
     * @default 'deleted'
     */
    deleted: T;

    /**
     * @default 'successfully'
     */
    successfully: T;

    /**
     * @default 'There was an error performing the'
     */
    error: T;

    /**
     * @default 'create'
     */
    create: T;

    /**
     * @default 'update'
     */
    update: T;

    /**
     * @default 'delete'
     */
    delete: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'Invalid Email'
     */
    invalidEmail: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    errorPageTitle: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    errorPageSubTitle: T;

    /**
     * @default 'Are you sure that you want to delete the following'
     */
    confirmDelete: T;

    /**
     * @default 'from your guest list? This cannot be undone'
     */
    confirmDeleteCont: T;

    /**
     * @default 'Delete Guest'
     */
    deleteGuest: T;

    /**
     * @default 'Delete Guests'
     */
    deleteGuests: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Delete'
     */
    deleteCta: T;

    /**
     * @default 'Add Guest'
     */
    addGuest: T;

    /**
     * @default 'Selected'
     */
    selected: T;

    /**
     * @default 'Filter by'
     */
    filterBy: T;

    /**
     * @default 'Missing Addresses'
     */
    missingAddresses: T;

    /**
     * @default 'No Guests were found'
     */
    noGuests: T;

    /**
     * @default 'Select All'
     */
    selectAll: T;

    /**
     * @default 'Unselect All'
     */
    unSelectAll: T;

    /**
     * @default 'Clear all filters'
     */
    clearAllFilters: T;

    /**
     * @default 'Guest List'
     */
    guestList: T;

    /**
     * @default 'Jump start your guest list.'
     */
    emptyJumpStartTitle: T;

    /**
     * @default 'Add Your Contacts'
     */
    emptyAddContactsCta: T;

    /**
     * @default 'Collect everyone's contact info, instantly.'
     */
    emptyCollectInfoTitle: T;

    /**
     * @default 'Send your guests a magic link and build your guest list faster.'
     */
    emptyCollectInfoBody: T;

    /**
     * @default 'Collect Contacts'
     */
    emptyCollectContactsCta: T;

    /**
     * @default 'Already started?'
     */
    emptyAlreadyStartedTitle: T;

    /**
     * @default 'Import a CSV file of your guest list.'
     */
    emptyImportCsvBody: T;

    /**
     * @default 'Attending'
     */
    attendingLabel: T;

    /**
     * @default 'Declined'
     */
    declinedLabel: T;

    /**
     * @default 'Pending'
     */
    pendingLabel: T;

    /**
     * @default 'Add contacts'
     */
    altAddContacts: T;

    /**
     * @default 'CSV import options'
     */
    altCsvImportOptions: T;

    /**
     * @default '-'
     */
    hyphen: T;
  };
  quick: {
    /**
     * @default 'Guest List'
     */
    sYWqA: T;

    /**
     * @default 'Sort by:'
     */
    JSspN: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Accepted'
     */
    RAUR2: T;

    /**
     * @default 'Declined'
     */
    kUvCR: T;

    /**
     * @default 'Pending'
     */
    XhQCC: T;
  };
};

export type GuestRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageTitle: {
    /**
     * @default '🎁 Did you purchase it?'
     */
    confirmPaymentTitle: T;

    /**
     * @default 'Registry'
     */
    registryPage: T;

    /**
     * @default 'Already Gifted'
     */
    alreadyGifted: T;
  };
  coupleHeader: {
    /**
     * @default 'Manage Registry'
     */
    dashboardBtn: T;

    /**
     * @default 'Continue reading…'
     */
    readMore: T;

    /**
     * @default 'Collapse note…'
     */
    readLess: T;

    /**
     * @default '…'
     */
    readMoreText: T;

    /**
     * @default 'Change Photo'
     */
    photoButton: T;

    /**
     * @default 'Add Photo'
     */
    addPhotoButton: T;

    /**
     * @default 'Edit Note'
     */
    noteButton: T;

    /**
     * @default 'Add Note'
     */
    addNoteButton: T;

    /**
     * @default 'Menu'
     */
    menu: T;

    /**
     * @default 'Edit Event'
     */
    editEvent: T;

    /**
     * @default 'Logout'
     */
    logout: T;

    /**
     * @default 'More…'
     */
    more: T;

    defaultName: {
      /**
       * @default 'Baby Registry'
       */
      babyRegistry: T;

      /**
       * @default 'Jack & Jill's Registry'
       */
      wedding: T;

      /**
       * @default 'Registry'
       */
      general: T;
    };
  };
  productTile: {
    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default '{{amount}} Remaining'
     */
    remaining: T;

    /**
     * @default '{{amount}} Requested'
     */
    requested: T;

    /**
     * @default 'Trending'
     */
    labelTrending: T;

    /**
     * @default 'Purchased by you'
     */
    purchasedByYou: T;

    /**
     * @default 'Reserved by you'
     */
    reservedByYou: T;

    /**
     * @default '<StillNeeded/> more needed'
     */
    needed: T;

    /**
     * @default 'Contribute what you wish'
     */
    contributionAnyAmountText: T;

    /**
     * @default 'Goal Reached!'
     */
    goalReachedText: T;

    /**
     * @default '{{goal}} Goal Reached!'
     */
    goalReachedWithPriceText: T;

    /**
     * @default 'Charity'
     */
    charity: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default 'Funded'
     */
    funded: T;

    /**
     * @default 'Our Most Wanted'
     */
    ourMostWanted: T;
  };
  emptyFilter: {
    /**
     * @default 'Nothing to see here (yet).'
     */
    title: T;

    /**
     * @default 'There are no current items that appear in this category.'
     */
    subtitle: T;
  };
  productDialog: {
    /**
     * @default 'Registered on'
     */
    availableToPurchaseOn: T;

    /**
     * @default 'Purchase on Retailer'
     */
    clickToBuy: T;

    /**
     * @default 'Retailer'
     */
    retailer: T;

    /**
     * @default 'How do I mark this gift as purchased?'
     */
    markAsPurchased: T;

    /**
     * @default 'This gift is from a {{storeName}} registry'
     */
    markAsPurchasedTitle: T;

    /**
     * @default 'Mark your item as purchased on that registry. We check and update the purchase status daily.'
     */
    markAsPurchasedSubtitle: T;
  };
  purchaseDialog: {
    /**
     * @default 'How many are you purchasing?'
     */
    howManyRequest: T;

    /**
     * @default '<StillNeeded/> more needed'
     */
    needed: T;

    /**
     * @default 'Your Name'
     */
    fieldNameLabel: T;

    /**
     * @default 'Email'
     */
    fieldEmailLabel: T;

    /**
     * @default 'First and last name'
     */
    fieldNamePlaceholder: T;

    /**
     * @default 'Your email address'
     */
    fieldEmailPlaceholder: T;

    /**
     * @default 'Gift Note'
     */
    fieldNoteLabel: T;

    /**
     * @default 'Add a note (optional)'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Reserve & Purchase'
     */
    formButtonReservePurchase: T;

    /**
     * @default 'Buy Now'
     */
    formButtonBuyNow: T;

    /**
     * @default 'Add to Cart'
     */
    formButtonAddToCart: T;

    /**
     * @default 'Purchase Now'
     */
    formButtonPurchaseNow: T;

    /**
     * @default 'I've Already Purchased This'
     */
    formButtonAlreadyPurchase: T;

    /**
     * @default 'Mark as Purchased'
     */
    formButtonMarkAsPurchased: T;

    /**
     * @default 'Hide description'
     */
    hideDescription: T;

    /**
     * @default 'Read More'
     */
    readMore: T;

    /**
     * @default 'Out of Stock'
     */
    outOfStock: T;

    /**
     * @default 'This gift is not available for purchase right now. Browse <link/>'
     */
    isNotPurchasableText: T;

    /**
     * @default 'Unavailable'
     */
    isNotPurchasableButton: T;

    /**
     * @default 'Description'
     */
    descriptionLabel: T;

    /**
     * @default 'Added from {{storeName}}'
     */
    detailsLinkText: T;

    /**
     * @default 'Note'
     */
    noteLabel: T;

    /**
     * @default ' other gifts'
     */
    otherGifts: T;

    /**
     * @default 'Have Questions?'
     */
    questionLinkText: T;

    /**
     * @default 'Have questions? We’re here to help.'
     */
    questionV2LinkText: T;

    /**
     * @default 'This item will be fulfilled by Joy'
     */
    fulfilledByJoy: T;

    /**
     * @default 'This item will be fulfilled by {{storeName}}'
     */
    fulfilledByExternal: T;

    /**
     * @default 'Add to Cart & Reserve'
     */
    formButtonAddCartReserve: T;

    /**
     * @default 'Please enter your name'
     */
    requiredNameWarning: T;

    /**
     * @default 'Please enter your email'
     */
    requiredEmailWarning: T;

    /**
     * @default 'Please enter a valid email'
     */
    validEmailWarning: T;

    /**
     * @default 'We could not process your order at this time.'
     */
    purchaseErrorMsg: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;

    /**
     * @default 'Quantity'
     */
    quantityTitle: T;

    /**
     * @default 'Subtotal'
     */
    subtotalTitle: T;

    /**
     * @default '{{quantity}} x {{price}}'
     */
    quantityTimesPrice: T;

    /**
     * @default 'Total {{total}}'
     */
    totalPriceTitleText: T;

    /**
     * @default 'Gift'
     */
    giftTitle: T;

    /**
     * @default '🎁 Item added to cart 🎁'
     */
    itemAddedSuccess: T;

    /**
     * @default 'Free shipping fulfilled by Joy'
     */
    freeShippingByJoy: T;

    /**
     * @default 'Fulfilled by Joy'
     */
    fulfilledByJoyShort: T;

    /**
     * @default 'Free Shipping'
     */
    freeShipping: T;

    /**
     * @default 'For orders over ${{price}}'
     */
    freeShippingDescription: T;

    /**
     * @default 'Every Joy Registry Deserves'
     */
    everyJoyRegistryDeserves: T;

    /**
     * @default 'Price Match Promise'
     */
    priceMatchPromise: T;

    /**
     * @default 'We'll match any retailer'
     */
    priceMatchPromiseDescription: T;

    /**
     * @default 'Easy Returns'
     */
    easyReturns: T;

    /**
     * @default 'Free online returns'
     */
    easyReturnsDescription: T;

    /**
     * @default 'Your Details'
     */
    backToDetails: T;

    /**
     * @default 'Where's it going?'
     */
    backToMissingCoupleAddress: T;

    /**
     * @default 'Add optional gift note'
     */
    giftNoteTitle: T;

    /**
     * @default 'Gift Details'
     */
    backToGiftDetails: T;

    /**
     * @default 'Greeting Card'
     */
    backToGreetingCard: T;

    /**
     * @default 'Upgrade My Gift Note'
     */
    upgradeGiftNote: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Subject to third party shipping.'
     */
    shippingInfo: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;

    missingCoupleAddress: {
      /**
       * @default 'Where's it going?'
       */
      title: T;

      /**
       * @default 'Missing Recipient's Address'
       */
      warningTitle: T;

      /**
       * @default 'Please contact the recipient to complete this purchase.'
       */
      warningBody: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default 'Another U.S. Address'
       */
      anotherAddressTitle: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      anotherAddressTooltip: T;

      /**
       * @default 'We'll tell the recipient it was purchased.'
       */
      anotherAddressBody: T;

      /**
       * @default 'Add Shipping Address'
       */
      button: T;
    };
    otherAddress: {
      /**
       * @default 'Shipping Address'
       */
      title: T;

      /**
       * @default 'Name'
       */
      nameLabel: T;

      /**
       * @default 'Only one recipient name is recommended'
       */
      namePlaceholder: T;

      /**
       * @default 'Jamie Lee'
       */
      nameGhost: T;

      /**
       * @default 'Address Line 1'
       */
      addressLine1Label: T;

      /**
       * @default 'Only Non-P.O. Box addresses in the United States'
       */
      addressLine1Placeholder: T;

      /**
       * @default 'Address Line 2'
       */
      addressLine2Label: T;

      /**
       * @default 'City'
       */
      cityLabel: T;

      /**
       * @default 'State'
       */
      stateLabel: T;

      /**
       * @default 'Zip/Postal Code'
       */
      postalCode: T;

      /**
       * @default '*Required fields'
       */
      requiredFields: T;

      /**
       * @default 'We cannot ship to P.O. boxes'
       */
      poBoxWarningCaption: T;

      /**
       * @default 'Review Details'
       */
      button: T;
    };
    groupGifting: {
      /**
       * @default 'Buy Entire Gift'
       */
      buyEntireGift: T;

      /**
       * @default 'Contribute'
       */
      contribute: T;

      /**
       * @default 'Contribute {{amount}} to Gift'
       */
      contributeToGiftBtn: T;

      /**
       * @default 'Contribute to Gift'
       */
      contributeToGiftBtnMobile: T;

      /**
       * @default 'Contribute Remaining Amount'
       */
      contributeRemainingAmount: T;

      /**
       * @default 'Contribute a Partial Amount'
       */
      contributePartialAmount: T;

      /**
       * @default '{{amount}} Remaining'
       */
      amountRemaining: T;
    };
  };
  confirmationPage: {
    /**
     * @default 'Quantity'
     */
    quantity: T;

    /**
     * @default 'Subtotal'
     */
    subtotal: T;

    /**
     * @default 'Shipping and Handling'
     */
    shipping: T;

    /**
     * @default 'Est Taxes'
     */
    estimatedTaxes: T;

    /**
     * @default 'eCard Fee'
     */
    eCardFee: T;

    /**
     * @default 'total'
     */
    total: T;

    /**
     * @default 'Thank you for your order!'
     */
    giftPurchased: T;

    /**
     * @default 'Your gift will ship directly to them in <addressText/>'
     */
    giftPurchasedSubtitle: T;

    /**
     * @default 'Order #{{orderId}}'
     */
    giftPurchasedOrderNumber: T;

    /**
     * @default 'We'll send you an email confirmation for your order shortly. {{host}} will also receive an email notifying them of your gift.'
     */
    giftPurchasedSendEmail: T;

    /**
     * @default 'We'll send you an email confirmation for your order shortly.'
     */
    giftPurchasedEmail: T;

    /**
     * @default '{{host}} will also receive an email notifying them of your gift.'
     */
    giftPurchasedCouple: T;

    /**
     * @default 'Your gift will be delivered electronically to them.'
     */
    giftPurchasedSubtitleState1Paragraph3: T;

    /**
     * @default 'Your item will ship directly to them in {{address}}'
     */
    giftPurchasedSubtitleState2Paragraph3: T;

    /**
     * @default 'Paid via {{card}} {{cardLastDigits}}'
     */
    paidNote: T;

    /**
     * @default 'Back to Registry'
     */
    backToRegistryBtn: T;

    /**
     * @default 'Go to Wedding Website'
     */
    goToWeddingWebsiteBtn: T;

    /**
     * @default 'Have you purchased your gift?'
     */
    confirmQuestion: T;

    /**
     * @default 'Yes, I've Purchased This'
     */
    confirmButtonPage: T;

    /**
     * @default 'Yes'
     */
    confirmButton: T;

    /**
     * @default 'Please confirm your gift was purchased, and we'll let the recipient know.'
     */
    confirmSubtitle: T;

    /**
     * @default 'No'
     */
    noButton: T;

    /**
     * @default 'Something wrong?'
     */
    somethingWrongTitle: T;

    /**
     * @default 'Go back'
     */
    somethingWrongAction: T;

    /**
     * @default 'Changed your mind?'
     */
    changedMindTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    changedMindAction: T;

    /**
     * @default 'Have Questions?'
     */
    haveQuestions: T;

    /**
     * @default 'Just to be safe, please double check that you've sent it to the right address.'
     */
    justToBeSafe: T;

    /**
     * @default 'Like what you see?'
     */
    likeWhatYouSee: T;

    /**
     * @default 'Treat yourself'
     */
    treatYourself: T;

    /**
     * @default 'We won't tell anyone if you want to buy it for yourself — it'll be our little secret.'
     */
    weWontTellAnyone: T;

    /**
     * @default 'Buy Now'
     */
    buyNowBtn: T;

    /**
     * @default 'Next Steps'
     */
    nextSteps: T;

    /**
     * @default 'Book your place to stay  🛏️'
     */
    bookYourPlaceToStay: T;

    /**
     * @default 'Rooms can book up quickly and discounted rates can expire.'
     */
    roomsBookUpQuickly: T;

    /**
     * @default 'Visit event website  👩‍💻'
     */
    visitEventWebsite: T;

    /**
     * @default 'For important travel, schedule and details for this event'
     */
    detailsForTheEvent: T;

    /**
     * @default 'Continue shopping  🎁'
     */
    continueShopping: T;

    /**
     * @default 'Have you booked your stay for {{eventName}}’s event?'
     */
    haveYouBookedStay: T;

    /**
     * @default '{{eventName}} have picked some hotels to help you stay close to the venue.'
     */
    pickedHotels: T;

    /**
     * @default 'Confirmation has been sent to'
     */
    confirmationSentTo: T;

    /**
     * @default 'Prices can expire and rooms are filling up.'
     */
    pricesExpiring: T;

    /**
     * @default 'Book Your Stay'
     */
    bookYourStay: T;

    /**
     * @default 'Check In'
     */
    checkIn: T;

    /**
     * @default 'Check Out'
     */
    checkOut: T;
  };
  confirmationPurchaseModal: {
    /**
     * @default 'Ready to head to {{retailer}}?'
     */
    title: T;

    /**
     * @default 'After purchasing, we will ask you to confirm that you've completed your purchase.'
     */
    afterPurchasing: T;

    /**
     * @default 'We don't have a shipping address for the recipient. Please ask them where they would like to receive their gifts.'
     */
    dontHaveAddress: T;

    /**
     * @default 'Continue to {{retailer}}'
     */
    button: T;

    /**
     * @default '✨ Address copied ✨'
     */
    addressCopied: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Shipping Address'
     */
    couplesAddressTitle: T;

    /**
     * @default 'Joy may earn an affiliate commission on purchases.'
     */
    legal: T;

    /**
     * @default 'Before you leave, you'll need the recipient's address.'
     */
    addressNote: T;

    /**
     * @default 'When you're done, come back here to mark the gift as purchased on the registry.'
     */
    purchaseNote: T;

    /**
     * @default 'Got It'
     */
    buttonGotIt: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;
  };
  intentToPurchaseModal: {
    /**
     * @default 'Do you still intend to purchase this gift?'
     */
    title: T;

    /**
     * @default 'Yes, just not right now'
     */
    ctaYes: T;

    /**
     * @default 'No, cancel my reservation'
     */
    ctaNo: T;

    /**
     * @default 'How “Mark as Purchased” works:'
     */
    titleHowTo: T;

    /**
     * @default 'Purchase the item from any store'
     */
    howTo1: T;

    /**
     * @default 'Return to Joy with your order number and mark the item as purchased'
     */
    howTo2: T;

    /**
     * @default 'How sending a cash gift works:'
     */
    titleHowToDonation: T;

    /**
     * @default 'Send your gift via {{platform}}'
     */
    howTo1Donation: T;

    /**
     * @default 'Return to Joy and mark the item as purchased'
     */
    howTo2Donation: T;
  };
  createOrderAndPurchaseModal: {
    /**
     * @default 'Great! Now add your purchase details.'
     */
    title: T;

    /**
     * @default 'How many did you purchase?'
     */
    qtyPurchased: T;

    /**
     * @default '{{qty}} needed'
     */
    qtyNeeded: T;

    /**
     * @default 'Your Name'
     */
    nameLabel: T;

    /**
     * @default 'First and last name'
     */
    namePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailLabel: T;

    /**
     * @default 'Your email address'
     */
    emailPlaceholder: T;

    /**
     * @default 'Done'
     */
    doneButton: T;

    /**
     * @default 'Didn't purchase this gift?'
     */
    cancelTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelButton: T;
  };
  purchaseGift: {
    /**
     * @default 'Your gift is reserved. Please complete your purchase.'
     */
    reservedTitle: T;

    /**
     * @default 'Didn't mean to reserve this item?'
     */
    reservedGift: T;

    /**
     * @default 'Complete your order on {{retailer}} and make sure you mark it as a gift to include a gift receipt.'
     */
    purchaseDescription: T;

    /**
     * @default 'Your gift is reserved. Please complete your purchase.'
     */
    customPurchaseTitle: T;

    /**
     * @default 'Complete your order and make sure you mark it as a gift to include a gift receipt.'
     */
    customPurchaseDescription: T;

    /**
     * @default 'Complete your order on Amazon and make sure you mark it as a gift to include a gift receipt.'
     */
    customPurchaseDescriptionAmazon: T;

    /**
     * @default 'Address is not filled out automatically.'
     */
    purchaseTip: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;

    /**
     * @default '✨ Address copied ✨'
     */
    copyToClipboard: T;

    /**
     * @default 'Back to Registry'
     */
    backToRegistry: T;

    /**
     * @default 'Complete Purchase'
     */
    completeButton: T;

    /**
     * @default 'Buy on {{storeText}}'
     */
    buyOn: T;

    /**
     * @default 'Thanks for buying this gift!'
     */
    thanksTitle: T;

    /**
     * @default 'Please confirm that you've bought this item so it can be marked as purchased.'
     */
    thanksDescription: T;

    /**
     * @default 'All Done'
     */
    thanksButton: T;

    /**
     * @default 'Copy'
     */
    copyAddress: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Undo'
     */
    undo: T;

    /**
     * @default ' Didn't complete purchase?'
     */
    didntCompletePurchase: T;

    /**
     * @default 'The recipient hasn't indicated a shipping address. Please ask them about where they would like to receive their gifts.'
     */
    missingShippingAddress: T;

    /**
     * @default 'Retailer'
     */
    retailer: T;

    /**
     * @default 'Address doesn't transfer automatically.'
     */
    addressWarning: T;
  };
  contributeToFund: {
    /**
     * @default 'Via {{platform}}'
     */
    viaPlatform: T;

    /**
     * @default 'Now, let's send it.'
     */
    contributeTitle: T;

    /**
     * @default 'Need help?'
     */
    needHelp: T;

    /**
     * @default 'All Done'
     */
    allDone: T;

    /**
     * @default '{{amount}} for {{fundTitle}}'
     */
    contributeDetails: T;

    /**
     * @default '{{handle}} on {{platform}}'
     */
    contributeDetailsPayment: T;

    /**
     * @default 'Send Gift on {{donationPlatform}}'
     */
    contributeButtonSend: T;

    /**
     * @default 'Go to Donation Site'
     */
    contributeButtonTextCharity: T;

    /**
     * @default 'Suggested Note'
     */
    contributeSuggestedNoteLabel: T;

    /**
     * @default 'Copy'
     */
    contributeCopyText: T;

    /**
     * @default 'Copied'
     */
    contributeCopiedText: T;

    /**
     * @default 'For your {{fundTitle}} on Joy ❤️'
     */
    contributeSuggestedNoteString: T;

    /**
     * @default 'Have you sent your gift?'
     */
    contributeConfirmationHeader: T;

    /**
     * @default 'Please confirm your gift was sent, and we'll let the recipient know.'
     */
    contributeConfirmationBody: T;

    /**
     * @default 'Yes, I've Sent My Gift'
     */
    contributeConfirmationButtonText: T;

    /**
     * @default 'Changed your mind?'
     */
    contributeCancelQuestion: T;

    /**
     * @default 'Cancel Reservation'
     */
    contributeCancelText: T;

    /**
     * @default 'Thanks for giving to this gift!'
     */
    contributeConfirmationTitle: T;

    /**
     * @default 'Thanks for buying this gift!'
     */
    contributeConfirmationTitleProduct: T;

    /**
     * @default 'This gift has been marked as purchased and is unavailable for purchase by other gift givers.'
     */
    contributeConfirmationDescription: T;

    /**
     * @default 'Back to Registry'
     */
    contributeBackToRegistryText: T;

    /**
     * @default 'We've reserved your gift'
     */
    reservedCashOrCheckDonationTitle: T;

    /**
     * @default 'Bring your gift to the wedding or mail it to them at this address. We'll let them know that you plan to give them this gift.'
     */
    reservedCashOrCheckDonationInstructions: T;
  };
  undoPurchase: {
    /**
     * @default 'Would you like to cancel your reservation?'
     */
    undoPurchaseTitle: T;

    /**
     * @default 'The recipient will no longer see this gift as reserved, and the item will be available again for purchase.'
     */
    undoPurchaseBody: T;

    /**
     * @default 'Cancel Reservation'
     */
    undoPurchaseButtonText: T;

    /**
     * @default 'Nevermind'
     */
    undoPurchaseCancelText: T;

    /**
     * @default 'Reservation canceled'
     */
    undoPurchaseConfirmationTitle: T;

    /**
     * @default 'Back to Registry'
     */
    undoPurchaseBackText: T;

    /**
     * @default 'thanks for buying'
     */
    thanksForBuying: T;

    /**
     * @default 'contribute'
     */
    contribute: T;

    /**
     * @default 'purchase gift'
     */
    purchaseGift: T;
  };
  giveGiftDialog: {
    /**
     * @default 'Gift Amount'
     */
    fieldAmountLabel: T;

    /**
     * @default 'Your Name'
     */
    fieldNameLabel: T;

    /**
     * @default 'Email'
     */
    fieldEmailLabel: T;

    /**
     * @default 'Gift Note'
     */
    fieldNoteLabel: T;

    /**
     * @default 'First and last name'
     */
    fieldNamePlaceholder: T;

    /**
     * @default 'Your email address'
     */
    fieldEmailPlaceholder: T;

    /**
     * @default 'Add a note (optional)'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Reserve and Give'
     */
    formButtonReserveGive: T;

    /**
     * @default 'Provide your name so the recipient knows who to thank.'
     */
    nameEmptyError: T;

    /**
     * @default 'Provide your email so the recipient knows who to thank.'
     */
    emailEmptyError: T;

    /**
     * @default 'Not a valid email.'
     */
    emailNotValidError: T;

    /**
     * @default 'How does this work?'
     */
    explanationLink: T;

    /**
     * @default 'Also registered at'
     */
    alsoRegisteredAt: T;

    /**
     * @default 'Please enter a gift amount.'
     */
    amountEmptyError: T;

    /**
     * @default 'Payment Method'
     */
    paymentMethodLabel: T;

    /**
     * @default 'Select...'
     */
    paymentMethodSelectPlaceholder: T;

    /**
     * @default 'Select a payment method'
     */
    paymentMethodError: T;

    /**
     * @default 'Cash/Check'
     */
    cashOrCheckGuestSelectLabel: T;

    /**
     * @default 'Add to Cart & Reserve'
     */
    formButtonAddCartReserve: T;

    /**
     * @default 'Update Reservation'
     */
    formButtonUpdateDonation: T;
  };
  registryHidden: {
    /**
     * @default 'This registry isn't ready.'
     */
    title: T;

    /**
     * @default 'You'll be redirected to the event website in a moment. Otherwise, '
     */
    subtitle: T;

    /**
     * @default 'click here to be redirected now.'
     */
    link: T;
  };
  retailerRedirect: {
    /**
     * @default 'We're taking you to {{storeName}}...'
     */
    title: T;

    /**
     * @default 'Don't forget!'
     */
    markGiftTitle: T;

    /**
     * @default 'After purchasing, go back to your previous tab to mark your gift as purchased. ✅ 🎁'
     */
    markGiftDescription: T;

    /**
     * @default 'This will help the host know who to thank.'
     */
    coupleMessage: T;

    /**
     * @default 'Click here if you haven't been redirected'
     */
    link: T;
  };
  browserWindow: {
    /**
     * @default '🎁  Did you purchase it?'
     */
    joyBrowserTabTitle: T;
  };
  registryProtected: {
    /**
     * @default 'This event is protected'
     */
    title: T;

    /**
     * @default 'Please enter the password'
     */
    subtitle: T;

    /**
     * @default 'Password'
     */
    inputPlaceholder: T;

    /**
     * @default 'Unlock Registry'
     */
    actionButton: T;

    /**
     * @default 'Sign In'
     */
    signInButton: T;

    /**
     * @default 'Contact Host'
     */
    contactButton: T;

    /**
     * @default 'Incorrect Password. Please try again.'
     */
    incorrectPass: T;
  };
  contactTheHost: {
    /**
     * @default 'Request Password'
     */
    title: T;

    /**
     * @default 'Tell the host who you are, so they can email you back with their event password.'
     */
    subtitle: T;

    /**
     * @default 'Your Full Name'
     */
    namePlaceholder: T;

    /**
     * @default 'Your Email'
     */
    emailPlaceholder: T;

    /**
     * @default 'Send Request'
     */
    actionButton: T;

    /**
     * @default 'We've sent the host an email'
     */
    successTitle: T;

    /**
     * @default 'In the meantime, we'll redirect you to their website. '
     */
    sucessSubtitle: T;

    /**
     * @default 'Click here to be redirected now.'
     */
    successLink: T;

    /**
     * @default 'Invalid Email. Please try again.'
     */
    emailInputError: T;
  };
  confirmationSection: {
    /**
     * @default 'Cancel Reservation'
     */
    cancelText: T;

    /**
     * @default 'Change Payment Method'
     */
    changeGiftingMethod: T;

    /**
     * @default 'Changed your mind?'
     */
    cancelQuestion: T;

    /**
     * @default 'Have Questions?'
     */
    haveQuestions: T;

    /**
     * @default 'Your gift is reserved.'
     */
    itsReserved: T;
  };
  alreadyReserveSection: {
    /**
     * @default 'It looks like you've already reserved this gift with that email address.'
     */
    title: T;

    /**
     * @default 'We've sent you an email with a link to your reservation so you can complete your purchase or cancel your reservation.'
     */
    subTitle: T;

    /**
     * @default 'Check your  “{{email}}” email inbox.'
     */
    checkEmail: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;
  };
  reserveItem: {
    /**
     * @default 'Did you reserve {{itemName}}?'
     */
    title: T;

    /**
     * @default 'Enter the email address you used to reserve this gift and we'll send you a link to your reservation.'
     */
    subTitle: T;

    /**
     * @default 'Email address'
     */
    inputLabel: T;

    /**
     * @default 'Find Reservation'
     */
    buttonLabel: T;

    /**
     * @default 'Cancel'
     */
    cancelText: T;

    /**
     * @default 'We've sent a link to your reservation! Check your email at {{email}}.'
     */
    successMessage: T;

    /**
     * @default 'This gift was not reserved with this email.'
     */
    errorMessage: T;

    /**
     * @default 'Did you reserve a gift for {{itemName}}?'
     */
    cashFundTitle: T;
  };
  registryFooter: {
    /**
     * @default 'About'
     */
    about: T;

    /**
     * @default 'Help'
     */
    help: T;
  };
  trackingSection: {
    /**
     * @default 'Update Tracking'
     */
    updateCta: T;

    /**
     * @default 'Add Tracking Info'
     */
    addTrackingCta: T;

    /**
     * @default 'Add Tracking Info for recipient'
     */
    addTrackingInfoCta: T;

    /**
     * @default 'Help the recipient keep track of this gift by providing your Order and Tracking Numbers.'
     */
    addTrackingTooltip: T;

    /**
     * @default 'Order Number (Required)'
     */
    orderNumberLabel: T;

    /**
     * @default 'Please enter an order number'
     */
    orderNumberRequiredError: T;

    /**
     * @default 'Tracking Number'
     */
    trackingNumberLabel: T;

    /**
     * @default 'Test Link'
     */
    testLink: T;

    /**
     * @default 'Save'
     */
    saveCta: T;

    /**
     * @default 'Save Tracking Info'
     */
    saveTrakingInfoCta: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;
  };
  changeEmailSection: {
    /**
     * @default 'Are you sure you want to change your email?'
     */
    title: T;

    /**
     * @default 'Continuing with a new email will clear your shopping cart and past purchases, and start a new one.'
     */
    subTitle: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;

    /**
     * @default 'Email'
     */
    email: T;
  };
  checkoutDialog: {
    /**
     * @default '{{amount}} Contribution'
     */
    contributionAmount: T;

    /**
     * @default 'Read more'
     */
    readMoreButton: T;

    /**
     * @default 'Read less'
     */
    readLessButton: T;

    giftMethodBadge: {
      /**
       * @default 'Cash / Check'
       */
      cashCheckLabel: T;

      /**
       * @default 'Charity'
       */
      charityLabel: T;
    };
    donationProgressBar: {
      /**
       * @default 'funded of {{amount}} goal'
       */
      fundedLabelWithoutGift: T;

      /**
       * @default 'funded of {{amount}} goal (with your gift)'
       */
      fundedLabelWithGift: T;
    };
    shippingAddress: {
      /**
       * @default 'The recipient hasn't indicated a shipping address. Please ask them where they would like to receive their gifts.'
       */
      noShippingAddress: T;

      /**
       * @default 'Mailing Address'
       */
      shippingAddressTitle: T;

      /**
       * @default 'Copy'
       */
      copy: T;

      /**
       * @default 'Address copied'
       */
      copied: T;
    };
    stateBackLabels: {
      /**
       * @default 'Payment Method'
       */
      gifterDetails: T;

      /**
       * @default 'Your Details'
       */
      giftWrap: T;

      /**
       * @default 'Gift Wrap'
       */
      giftWrapNote: T;

      /**
       * @default 'Gift Wrap'
       */
      externalCheckoutInstructionsGiftWrapIdle: T;

      /**
       * @default 'Gift'
       */
      paymentMethod: T;

      /**
       * @default 'Payment Method'
       */
      paperCheckoutInstructions: T;

      /**
       * @default 'Gift Wrap'
       */
      paperCheckoutInstructionsGiftWrapIdle: T;

      /**
       * @default 'Address'
       */
      paperCheckoutConfirmAndNotify: T;

      /**
       * @default 'Payment Method'
       */
      externalCheckoutInstructions: T;

      /**
       * @default 'Your Details'
       */
      externalCheckoutInstructionsAffiliate: T;

      /**
       * @default 'Your Details'
       */
      externalCheckoutInstructionsCharity: T;

      /**
       * @default 'Instructions'
       */
      externalCheckoutCopyAddress: T;

      /**
       * @default 'Instructions'
       */
      externalCheckoutReview: T;

      /**
       * @default 'Address'
       */
      externalCheckoutReviewAffiliate: T;

      /**
       * @default 'Confirm Gift'
       */
      cancelGiftIntent: T;
    };
    screens: {
      externalCheckoutInstructions: {
        /**
         * @default 'Great! Here's how it works:'
         */
        title: T;

        steps: {
          step1: {
            venmo: {
              /**
               * @default '<strong>On mobile</strong>, we'll take you to the Venmo app to send your gift.'
               */
              mobile: T;

              /**
               * @default '<strong>On desktop</strong>, we'll take you to the Venmo website to send your gift.'
               */
              desktop: T;
            };

            /**
             * @default 'You'll be taken to the recipient's PayPal page to send your gift.'
             */
            paypal: T;

            /**
             * @default 'You'll be taken to the recipient's Cash App page to send your gift.'
             */
            cashapp: T;

            /**
             * @default 'You'll be taken to the charity website.'
             */
            charity: T;

            /**
             * @default '<strong>You'll be taken to {{retailer}}</strong> and your gift will be added to the cart in this registry.'
             */
            affiliate: T;
          };
          step2: {
            /**
             * @default 'Venmo account: <strong>{{couplesAccount}}</strong>'
             */
            venmo: T;

            /**
             * @default 'PayPal.me account is: <strong>{{couplesAccount}}</strong>'
             */
            paypal: T;

            /**
             * @default 'Open Cash App on your phone and <strong>tap the QR Scanner</strong> on the top left corner of the home screen.'
             */
            cashapp: T;

            /**
             * @default 'Amount you're donating: <br><strong>{{amount}}</strong>'
             */
            charity: T;

            /**
             * @default 'Purchase your gift at <strong>{{retailer}}.</strong>'
             */
            affiliate: T;
          };
          step3: {
            /**
             * @default 'Amount you're sending: <strong>{{amount}}</strong>'
             */
            venmo: T;

            /**
             * @default 'Amount you're sending: <strong>{{amount}}</strong>'
             */
            paypal: T;

            /**
             * @default 'Hold your camera over the QR code generated on your desktop to scan it.'
             */
            cashapp: T;

            /**
             * @default 'Give your donation.'
             */
            charity: T;

            /**
             * @default '<strong>Come back to this tab</strong> to confirm your purchase and we'll notify the recipient.'
             */
            affiliate: T;
          };
        };
        stepsGiftWrap: {
          step1: {
            /**
             * @default 'Pay for your personalized eCard.'
             */
            venmo: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            paypal: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            cashapp: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            affiliate: T;
          };
          step2: {
            /**
             * @default 'You'll be taken to the Venmo app to send your gift.'
             */
            venmo: T;

            /**
             * @default 'You'll be taken to the couple's PayPal page to send your gift.'
             */
            paypal: T;

            /**
             * @default 'We'll take you to the Cash App to send your gift.'
             */
            cashapp: T;

            /**
             * @default '<strong>You'll then be taken to {{retailer}}</strong> to purchase your gift.'
             */
            affiliate: T;
          };
          step3: {
            /**
             * @default 'Venmo account: @{{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            venmo: T;

            /**
             * @default 'Paypal.me account: @{{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            paypal: T;

            /**
             * @default 'Cash App account: ${{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            cashapp: T;

            /**
             * @default '<strong>After purchase, come back to this tab</strong> to confirm your purchase.'
             */
            affiliate: T;
          };
        };

        /**
         * @default 'When you're done: '
         */
        alertTitle: T;

        /**
         * @default 'Come back to this tab to confirm your gift and we'll notify the recipient.'
         */
        alertText: T;

        /**
         * @default 'While gifts are in your cart, they won't be available for other gifts givers to purchase.'
         */
        alertTextAffiliate: T;

        /**
         * @default 'Copy {{account}} Account'
         */
        copyButton: T;

        /**
         * @default 'Got it'
         */
        gotItButton: T;
      };
      externalCheckoutReview: {
        /**
     * @default 'Almost done!
You're headed to {{platform}}...'
*/
        title: T;

        /**
         * @default 'Let's go to {{platform}}'
         */
        goToButton: T;

        /**
         * @default 'Cancel Gift'
         */
        cancelButton: T;

        /**
         * @default 'Go to Charity'
         */
        goToCharityButton: T;
      };
      giftAmount: {
        /**
         * @default 'Give {{amount}} Now'
         */
        giveNow: T;

        /**
         * @default 'Give Now'
         */
        giveNowWithAmount: T;

        /**
         * @default 'Additional Payment Options'
         */
        additionalPaymentOptions: T;

        /**
         * @default 'A gift amount is required'
         */
        amountEmptyError: T;
      };
      gifterDetails: {
        /**
         * @default 'Add your details'
         */
        title: T;

        /**
         * @default 'Share your details to mark this gift as purchased'
         */
        titleDeferred: T;

        /**
         * @default 'Please share your details to help {{host}} track your gift.'
         */
        description: T;

        /**
         * @default 'Add Details'
         */
        cta: T;

        /**
         * @default 'Email'
         */
        fieldEmailLabel: T;

        /**
         * @default 'Your email address'
         */
        fieldEmailPlaceholder: T;

        /**
         * @default 'Sharing your email is required'
         */
        fieldEmailMissing: T;

        /**
         * @default 'Name'
         */
        fieldNameLabel: T;

        /**
         * @default 'First and last name'
         */
        fieldNamePlaceholder: T;

        /**
         * @default 'Sharing your name is required'
         */
        fieldNameMissing: T;

        /**
         * @default 'Gift Note'
         */
        fieldNoteLabel: T;

        /**
         * @default 'Add an optional note'
         */
        fieldNotePlaceholder: T;

        /**
         * @default 'Come back to this tab to confirm your gift and we'll notify the recipient.'
         */
        warningText: T;
      };
      paymentMethod: {
        /**
         * @default 'How would you like to give?'
         */
        title: T;

        /**
         * @default '{{host}} would like to receive their gifts using one of the methods below:'
         */
        description: T;

        /**
         * @default 'Select a method below to contribute to {{fundName}}'
         */
        descriptionDonation: T;

        /**
         * @default 'Next'
         */
        cta: T;

        /**
         * @default 'Cash / Check'
         */
        cashCheck: T;

        /**
         * @default 'Credit or Debit Card'
         */
        creditCard: T;

        /**
         * @default 'Enter Card Manually'
         */
        enterCardManually: T;
      };
      paperCheckoutInstructions: {
        /**
         * @default 'You'll need the recipient's address to mail your gift:'
         */
        title: T;

        /**
         * @default 'Got it'
         */
        cta: T;
      };
      paperCheckoutInstructionsGiftWrap: {
        /**
         * @default 'Great! Here's how it works:'
         */
        title: T;

        /**
         * @default 'You'll need the couple's address if you're mailing your gift:'
         */
        subtitle: T;

        stepsGiftWrap: {
          /**
           * @default 'Pay for your personalized eCard.'
           */
          step1: T;

          /**
           * @default 'Confirm your gift details and we'll send your eCard.'
           */
          step2: T;

          /**
           * @default 'Send your check gift by mail or bring cash or check with you to the event.'
           */
          step3: T;
        };

        /**
         * @default 'Got it'
         */
        cta: T;
      };
      paperCheckoutConfirmAndNotify: {
        /**
         * @default 'Great!'
         */
        title: T;

        /**
         * @default 'Once you confirm below, we'll let the recipient know you're contributing to this gift.'
         */
        description: T;

        /**
         * @default 'Confirm & Notify recipient'
         */
        cta: T;

        /**
         * @default 'Cancel Gift'
         */
        cancelButton: T;
      };
      externalCheckoutConfirmAndNotify: {
        /**
         * @default 'Did you send your gift with {{platform}}?'
         */
        title: T;

        /**
         * @default 'Did you give to the charity in the recipient's name?'
         */
        titleCharity: T;

        /**
         * @default 'Have you purchased your gift?'
         */
        titleAffiliate: T;

        /**
         * @default 'When you confirm your gift, we'll let the recipient know it's headed their way and mark your gift as purchased.'
         */
        subtitle: T;

        /**
         * @default 'Yes, I did'
         */
        affirmativeButton: T;

        /**
         * @default 'No, I didn't'
         */
        negativeButton: T;

        /**
         * @default 'Not sure what to do?'
         */
        helpText: T;

        /**
         * @default 'Get help'
         */
        helpButton: T;
      };
      cancelGiftIntent: {
        /**
         * @default 'Do you still intend to send this gift?'
         */
        title: T;

        /**
         * @default 'Keep this gift in your cart and send it later, or cancel your reservation.'
         */
        subtitle: T;

        /**
         * @default 'Yes, I'll send it later'
         */
        affirmativeButton: T;

        /**
         * @default 'No, Cancel Gift'
         */
        negativeButton: T;
      };
      cancelGiftWarning: {
        /**
         * @default 'Are you sure you want to cancel this gift?'
         */
        title: T;

        /**
         * @default 'The recipient will no longer see this gift as reserved and it will be available again for others to purchase.'
         */
        subtitle: T;

        /**
         * @default 'Cancel Gift'
         */
        affirmativeButton: T;

        /**
         * @default 'Nevermind'
         */
        negativeButton: T;
      };
      confirmedPurchase: {
        /**
         * @default 'Thank You!'
         */
        title: T;

        /**
         * @default 'We've just let {{host}} know that you sent this gift with {{platform}}.'
         */
        subtitle: T;

        /**
         * @default 'We've just let {{host}} know that you plan to give this gift.'
         */
        subtitleForCashCheckMethod: T;

        /**
         * @default 'All Done'
         */
        affirmativeButton: T;
      };
      cancelGiftConfirmation: {
        /**
         * @default 'Your gift has been cancelled'
         */
        title: T;

        /**
         * @default 'This gift was removed from your shopping cart and is now available for others to buy.'
         */
        subtitle: T;

        /**
         * @default 'Done'
         */
        buttonLabel: T;
      };
      externalCheckoutCopyAddress: {
        /**
         * @default 'You'll need the recipient address to mail your gift:'
         */
        title: T;

        /**
         * @default 'Mailing Address'
         */
        coupleMailingAddress: T;

        /**
         * @default 'Copy'
         */
        copyButton: T;

        /**
         * @default 'Got it'
         */
        cta: T;

        /**
         * @default 'The recipient hasn't indicated a shipping address. Please ask them about where they would like to receive their gifts.'
         */
        missingShippingAddress: T;

        /**
         * @default 'Copied to clipboard'
         */
        copyToClipboard: T;
      };
      creditCardCheckoutError: {
        /**
         * @default 'Oops! An error has ocurred.'
         */
        title: T;

        /**
         * @default 'Please try again later.  If you continue to receive this error, try contacting the owner of this event, or contact Joy support at support@withjoy.com.'
         */
        description: T;

        /**
         * @default 'Close'
         */
        close: T;

        /**
         * @default 'Oops, that didn't work.'
         */
        checkoutErrorTitle: T;

        /**
         * @default 'We're sorry, but there was an error while processing your order. Please try again later or contact our support team at support@withjoy.com for assistance. Thank you for your patience.'
         */
        checkoutErrorText: T;

        /**
         * @default 'Back'
         */
        checkoutErrorAction: T;

        /**
         * @default 'We're sorry, but there seems to be an issue with your address. Please double-check the address in your account settings to ensure everything is correct. If you need further assistance, feel free to reach out to our support team at support@withjoy.com'
         */
        badAddress: T;

        /**
         * @default 'It looks like your transaction is still being verified. Check back soon and thank you for your patience.'
         */
        registryError: T;

        /**
         * @default 'We're sorry, but the item you're looking for is currently out of stock. We're working to replenish our inventory, so please check back later or explore similar options.'
         */
        outOfStock: T;
      };
    };
  };
  sortByOptions: {
    /**
     * @default 'Sort by'
     */
    sortBy: T;

    /**
     * @default 'Featured'
     */
    featured: T;

    /**
     * @default 'Price: Low to High'
     */
    priceLowToHigh: T;

    /**
     * @default 'Price: High to Low'
     */
    priceHighToLow: T;
  };
  orderTrackingDialog: {
    /**
     * @default 'Great! Now add your purchase details.'
     */
    orderTrackingDialogTitle: T;

    /**
     * @default 'Help {{host}} keep track of this gift by providing your Order Number'
     */
    orderTrackingDialogSubTitle: T;

    /**
     * @default 'Enter Order Number'
     */
    orderNumberPlaceholder: T;

    /**
     * @default 'Add Order Number'
     */
    submit: T;

    /**
     * @default 'Add Later'
     */
    addLater: T;

    /**
     * @default 'Please enter an Order Number'
     */
    requiredMessage: T;

    /**
     * @default 'Not sure where to find it? Check your confirmation email from {{retailer}}.'
     */
    orderTrackingDialogDetail: T;

    /**
     * @default 'Didn't purchase this gift?'
     */
    didntPurchase: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default '✨ Thank you, Order Number submitted ✨'
     */
    successMessage: T;

    /**
     * @default 'Something went wrong, try again later'
     */
    errorMessage: T;

    /**
     * @default '🚫 Your gift reservation has been canceled. 🚫'
     */
    removeSuccess: T;

    /**
     * @default '🎉 This item has been marked as purchased. 🎉'
     */
    purchaseSuccess: T;
  };
  photoMenu: {
    /**
     * @default 'Update Photo'
     */
    updatePhoto: T;

    /**
     * @default 'Delete Photo'
     */
    deletePhoto: T;

    /**
     * @default 'An error occurred uploading your image. Please try again'
     */
    error: T;

    /**
     * @default 'Your image has been updated'
     */
    success: T;
  };
  checkoutGiftCard: {
    /**
     * @default 'Elevate your gift with a personalized eCard'
     */
    title: T;

    /**
     * @default 'Wrap your gift note in a beautiful design.'
     */
    subtitle: T;

    /**
     * @default 'Select Design'
     */
    selectDesign: T;

    /**
     * @default 'Edit Message'
     */
    editMessage: T;

    /**
     * @default 'Unwrap My Gift'
     */
    unwrap: T;

    /**
     * @default 'Add Greeting Card'
     */
    addGreetingCard: T;

    /**
     * @default 'No Thanks'
     */
    noThanks: T;

    /**
     * @default 'Sent with'
     */
    sentWith: T;

    /**
     * @default 'Collapse theme list'
     */
    collapseThemeList: T;

    /**
     * @default 'Expand theme list'
     */
    expandThemeList: T;

    otherGifts: {
      /**
       * @default '... and {{count}} other gift!'
       */
      single: T;

      /**
       * @default '... and {{count}} other gifts!'
       */
      plural: T;
    };

    /**
     * @default 'Next'
     */
    next: T;
  };
  host: {
    /**
     * @default 'the recipient'
     */
    defaultValue: T;
  };
  expressCheckout: {
    shippingAddress: {
      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      onlyUSAddress: T;

      /**
       * @default 'Ship to me, I’ll give it to them.'
       */
      shipToMe: T;

      /**
       * @default 'You will add a shipping address during payment.'
       */
      shippingAddressDuringPayment: T;

      /**
       * @default 'Shipping address pending'
       */
      shippingAddressPending: T;
    };

    /**
     * @default 'We’ve written you a nice first draft gift note, please edit it before purchase, or use as-is.'
     */
    giftWrapUneditedMessageWarning: T;

    errorDialog: {
      /**
       * @default 'An error occurred, please try again'
       */
      header: T;

      /**
       * @default 'Error code'
       */
      code: T;

      /**
       * @default 'An unexpected error occurred with your purchase, please check your information and try again. If the problem persists, please '
       */
      defaultMessageBeginning: T;

      /**
       * @default 'contact our support team'
       */
      defaultMessageContactSupport: T;

      /**
       * @default 'Okay'
       */
      okay: T;
    };
  };
  quick: {
    /**
     * @default 'On your wedding day'
     */
    mJKyg: T;

    /**
     * @default 'Congratulations'
     */
    xEhgX: T;

    /**
     * @default 'Replay'
     */
    '1uZOS': T;

    /**
     * @default '... and {{0}} other gift!'
     * @param {number} count - The number of occurrences.
     * - singular: ... and {{0}} other gift!
     * - plural: ... and {{0}} other gifts!
     */
    FNjI1: T;

    /**
     * @default 'Open My Gift'
     */
    ML3M1: T;

    /**
     * @default 'Visit {{0}} registry'
     */
    OpRDE: T;

    /**
     * @default 'Visit registry'
     */
    CTzOZ: T;

    /**
     * @default 'Browse Our Registry'
     */
    nJhnM: T;

    /**
     * @default 'Quick amount selection'
     */
    BdOJs: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'e.g. Evan & Julia, or The Sanchez Family'
     */
    rdwxY: T;

    /**
     * @default 'Let the couple know who this gift is from'
     */
    JQXB5: T;

    /**
     * @default 'This gift isn't available'
     */
    keswx: T;

    /**
     * @default 'We couldn't load this gift. It may have been removed from the registry, or the connection dropped. Please close this window and try again.'
     */
    '40kzM': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Write a welcome note'
     */
    o1et4: T;

    /**
     * @default 'Joy only ships this gift within the United States.'
     */
    mZYFT: T;

    /**
     * @default 'RESERVE'
     */
    o2M0b: T;

    /**
     * @default 'MARK AS PURCHASED'
     */
    sZrnt: T;

    /**
     * @default 'BUY NOW'
     */
    QofLq: T;
  };
};

export type GuestSiteCustomTranslations<T extends LeafNodeValue = TranslateFunction> = {
  thingsToDo: {
    /**
     * @default 'Attraction'
     */
    attraction: T;

    /**
     * @default 'Activity'
     */
    activity: T;

    /**
     * @default 'Bar'
     */
    bar: T;

    /**
     * @default 'Wine Bar'
     */
    wineBar: T;

    /**
     * @default 'Beach'
     */
    beach: T;

    /**
     * @default 'Breakfast'
     */
    breakfast: T;

    /**
     * @default 'Brewery'
     */
    brewery: T;

    /**
     * @default 'Brunch'
     */
    brunch: T;

    /**
     * @default 'Cocktail Bar'
     */
    cocktailBar: T;

    /**
     * @default 'Caffeine'
     */
    caffeine: T;

    /**
     * @default 'Dinner'
     */
    dinner: T;

    /**
     * @default 'Dive Bar'
     */
    diveBar: T;

    /**
     * @default 'Event'
     */
    event: T;

    /**
     * @default 'Food Truck'
     */
    foodTruck: T;

    /**
     * @default 'Landmark'
     */
    landmark: T;

    /**
     * @default 'Late Night'
     */
    lateNight: T;

    /**
     * @default 'Lunch'
     */
    lunch: T;

    /**
     * @default 'Museum'
     */
    museum: T;

    /**
     * @default 'Neighborhood'
     */
    neighborhood: T;

    /**
     * @default 'Park'
     */
    park: T;

    /**
     * @default 'Playground'
     */
    playground: T;

    /**
     * @default 'Hangout Spot'
     */
    hangoutSpot: T;

    /**
     * @default 'Hike'
     */
    hike: T;

    /**
     * @default 'Restaurant'
     */
    restaurant: T;

    /**
     * @default 'Shopping'
     */
    shopping: T;

    /**
     * @default 'Tour'
     */
    tour: T;

    /**
     * @default 'Walk'
     */
    walk: T;

    /**
     * @default 'Workout'
     */
    workout: T;

    /**
     * @default 'Custom'
     */
    custom: T;

    /**
     * @default 'Here are some tours we think would be interesting:'
     */
    interestingTours: T;
  };
  accommodations: {
    /**
     * @default 'Venue'
     */
    venue: T;

    /**
     * @default 'Book before {{date}}'
     */
    beforeDate: T;

    /**
     * @default 'This hotel has no availability for the event dates.'
     */
    soldOutMessage: T;

    numberOfBookings: {
      /**
       * @default '{{reservationsCount}} booking'
       * @param {number} count - The number of occurrences.
       * - singular: {{reservationsCount}} booking
       * - plural: {{reservationsCount}} bookings
       */
      numberOfBookings: T;
    };
    bookedTooltipTitle: {
      /**
       * @default '{{reservationsCount}} Guest Booked This Hotel'
       * @param {number} count - The number of occurrences.
       * - singular: {{reservationsCount}} Guest Booked This Hotel
       * - plural: {{reservationsCount}} Guests Booked This Hotel
       */
      bookedTooltipTitle: T;
    };
    bookedTooltipBody: {
      /**
       * @default 'Joy has seen {{reservationsCount}} booking at this hotel across our events recently. It's a popular spot. You should book soon.'
       * @param {number} count - The number of occurrences.
       * - singular: Joy has seen {{reservationsCount}} booking at this hotel across our events recently. It's a popular spot. You should book soon.
       * - plural: Joy has seen {{reservationsCount}} bookings at this hotel across our events recently. It's a popular spot. You should book soon.
       */
      bookedTooltipBody: T;
    };

    /**
     * @default 'EVENT TAKES PLACE IN:'
     */
    countdownTitle: T;

    /**
     * @default '{{days}} DAYS'
     */
    countdownDays: T;

    /**
     * @default 'Explore Hotels Nearby'
     */
    exploreHotelsNearby: T;

    /**
     * @default 'From ${{strikeoutPricePerNight}}'
     */
    fromPrice: T;

    /**
     * @default '{{miles}} miles away'
     */
    milesAway: T;

    /**
     * @default '{{miles}} mi from venue'
     */
    milesFromVenue: T;

    /**
     * @default '{{interestedGuestCount}} guests interested'
     */
    guestsInterested: T;

    /**
     * @default 'We reserved {{rooms}} rooms'
     */
    reservedRooms: T;

    /**
     * @default 'Per night'
     */
    perNight: T;

    /**
     * @default 'Book before'
     */
    bookBefore: T;

    /**
     * @default 'Group Rate'
     */
    groupRate: T;

    /**
     * @default 'Swipe to Preview Hotels'
     */
    swipeRightForQuickView: T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    groupRateTooltip: T;

    /**
     * @default 'Our Favorite Hotel'
     */
    favoriteHotel: T;

    /**
     * @default 'Hotel Room Block'
     */
    hotelRoomBlock: T;

    /**
     * @default 'Room Block'
     */
    roomBlockEyebrow: T;

    /**
     * @default 'Risk-free cancellation.'
     */
    riskFreeCancellation: T;

    /**
     * @default 'See Availability'
     */
    seeAvailability: T;

    /**
     * @default 'Select Rooms'
     */
    selectCTARoomBlock: T;

    /**
     * @default 'Select Hotel'
     */
    selectCTAHotel: T;

    /**
     * @default 'Select Property'
     */
    selectCTACustom: T;

    /**
     * @default '{{rooms}} Rooms Available'
     */
    roomsAvailable: T;

    /**
     * @default '{{rooms}} Room Available'
     */
    roomAvailable: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default 'more'
     */
    more: T;

    /**
     * @default 'less'
     */
    less: T;

    /**
     * @default 'guests are interested'
     */
    guestCount: T;

    /**
     * @default 'View More'
     */
    viewMore: T;

    leadGenDialog: {
      /**
       * @default 'Unlock your guest accommodations page'
       */
      title: T;

      /**
       * @default 'Add courtesy room blocks to your site with our free hotel concierge service. We offer discounted hotel rates with zero deposit requirements.'
       */
      content: T;

      /**
       * @default 'Get Started'
       */
      cta: T;
    };

    /**
     * @default 'Explore On Map'
     */
    exploreOnMap: T;

    /**
     * @default 'Exclusive block rate for our guests!'
     */
    exclusiveBlockRate: T;

    /**
     * @default 'Starting from'
     */
    roomsStartingFrom: T;

    /**
     * @default '{{price}} / night'
     */
    pricePerNight: T;

    /**
     * @default 'Exclusive Rate'
     */
    exclusiveRate: T;

    /**
     * @default 'Event-Only Rate'
     */
    eventOnlyRate: T;

    /**
     * @default 'Save {{percentage}}%'
     */
    percentageOff: T;

    /**
     * @default '{{name}}’s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    eventOnlyRateInfo: T;

    /**
     * @default 'compared to {{price}}'
     */
    comparedToPublicRates: T;

    /**
     * @default 'Special Event Rate'
     */
    specialEventRate: T;

    /**
     * @default 'Joy Travel'
     */
    joyTravel: T;

    /**
     * @default 'Compared to public rates'
     */
    comparedTo: T;

    linkInterceptor: {
      /**
       * @default 'Others'
       */
      others: T;

      /**
       * @default 'Compared to'
       */
      comparedTo: T;

      /**
       * @default 'View Joy Rates'
       */
      viewJoyRates: T;

      /**
       * @default 'and Others'
       */
      expediaAndOthers: T;

      /**
       * @default 'Guest only price'
       */
      guestOnlyPrice: T;

      /**
       * @default 'Save {{percentage}}%'
       */
      savePercentage: T;

      /**
       * @default 'Compare Prices Before You Book'
       */
      title: T;

      /**
       * @default 'Open external link instead'
       */
      openExternalLink: T;
    };
  };

  /**
   * @default '👀 {{count}} people looking'
   */
  peopleCurrentlyViewing: T;

  /**
   * @default '{{count}} Guests Currently Looking At This Hotel'
   */
  peopleCurrentlyViewingTooltipTitle: T;

  /**
   * @default 'Rooms are filling up fast. Don’t miss the chance to get exclusive rates for Joy guests.'
   */
  peopleCurrentlyLookingTooltipBody: T;

  photoGallery: {
    emptyState: {
      /**
       * @default 'This album is currently set to Hidden, so your guests won’t be able to see it. You can change its visibility by setting it to Public to make it visible.'
       */
      content: T;
    };
  };
  reminderModal: {
    /**
     * @default 'Not ready to book?'
     */
    title: T;

    /**
     * @default 'Set a reminder to come back later.'
     */
    subtitle: T;

    tabs: {
      /**
       * @default 'Text'
       */
      text: T;

      /**
       * @default 'Email'
       */
      email: T;
    };

    /**
     * @default 'Send Reminder'
     */
    sendReminder: T;

    /**
     * @default 'Email'
     */
    emailLabel: T;

    /**
     * @default 'your@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Please enter a valid email address'
     */
    emailErrorText: T;

    /**
     * @default 'Set Reminder'
     */
    setReminder: T;

    /**
     * @default 'No, Thanks'
     */
    noThanks: T;

    /**
     * @default 'By proceeding, you confirm that you have read and agree to Joy’s <terms/> and <privacyPolicy/>.'
     */
    consentTextEmail: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    durationOptions: {
      /**
       * @default 'in 1 week'
       */
      '1week': T;

      /**
       * @default 'in 2 weeks'
       */
      '2weeks': T;

      /**
       * @default 'in 3 weeks'
       */
      '3weeks': T;

      /**
       * @default 'in 4 weeks'
       */
      '4weeks': T;

      /**
       * @default 'in 5 weeks'
       */
      '5weeks': T;

      /**
       * @default 'in 6 weeks'
       */
      '6weeks': T;
    };
    success: {
      /**
       * @default 'All done!'
       */
      title: T;

      subtitle: {
        /**
         * @default 'We'll send you a reminder in {{count}} week.'
         * @param {number} count - The number of occurrences.
         * - singular: We'll send you a reminder in {{count}} week.
         * - plural: We'll send you a reminder in {{count}} weeks.
         */
        text: T;
      };

      /**
       * @default 'Done'
       */
      doneButton: T;
    };
  };
  quick: {
    /**
     * @default 'Photo viewer'
     */
    GHZiz: T;

    /**
     * @default 'Unlike photo'
     */
    miw0P: T;

    /**
     * @default 'Like photo'
     */
    zOMt7: T;

    /**
     * @default 'See who liked this photo'
     */
    QhmgF: T;

    /**
     * @default 'See comments'
     */
    fwzd4: T;

    /**
     * @default '{{0}} (You)'
     */
    o3ztf: T;

    /**
     * @default 'Reactions ({{0}})'
     */
    r7xAU: T;

    /**
     * @default 'Explore on Map'
     */
    SYWso: T;

    /**
     * @default 'Cars'
     */
    b1iKA: T;

    /**
     * @default 'Venue'
     */
    tdqJH: T;

    /**
     * @default 'Edited'
     */
    xVsrt: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default '1 comment'
     * @param {number} count - The number of occurrences.
     * - singular: 1 comment
     * - plural: {{0}} comments
     */
    W2wwk: T;

    /**
     * @default 'Your comment has been updated'
     */
    reYSK: T;

    /**
     * @default 'Couldn't update your comment — please try again'
     */
    y2tVi: T;

    /**
     * @default 'Thanks for sharing — your comment is up'
     */
    fs5rY: T;

    /**
     * @default 'Couldn't post your comment — please try again'
     */
    dMUOp: T;

    /**
     * @default 'Comment deleted'
     */
    iKrKK: T;

    /**
     * @default 'Couldn't delete your comment — please try again'
     */
    iUs3F: T;

    /**
     * @default 'No comments yet'
     */
    '5MvVc': T;

    /**
     * @default 'Be the first to leave one'
     */
    K6Jxn: T;

    /**
     * @default 'Edit your comment...'
     */
    CWhBi: T;

    /**
     * @default 'Add a comment...'
     */
    '7OWWQ': T;

    /**
     * @default 'Edit your comment'
     */
    qh4Ch: T;

    /**
     * @default 'Add a comment'
     */
    JgdCp: T;

    /**
     * @default 'Cancel editing'
     */
    '6IuHQ': T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Post'
     */
    EXkMA: T;

    /**
     * @default 'Delete this comment?'
     */
    fTfhB: T;

    /**
     * @default 'This can't be undone.'
     */
    rwANi: T;

    /**
     * @default 'Keep it'
     */
    '2GeUA': T;

    /**
     * @default '1 person loves this'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person loves this
     * - plural: {{0}} people love this
     */
    ObRGV: T;

    /**
     * @default 'now'
     */
    GJgAA: T;

    /**
     * @default '{{0}}m'
     */
    NMOGt: T;

    /**
     * @default '{{0}}h'
     */
    IMOGt: T;

    /**
     * @default '{{0}}d'
     */
    EMOGt: T;

    /**
     * @default '{{0}}w'
     */
    XMOGt: T;

    /**
     * @default 'Previous photo'
     */
    '57rT3': T;

    /**
     * @default 'Next photo'
     */
    rHzIo: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Coming Soon'
     */
    ODxS0: T;

    /**
     * @default 'Check back closer to the event.'
     */
    jE84O: T;

    /**
     * @default 'Unable to Load Content'
     */
    PVAkV: T;

    /**
     * @default 'Please try again later.'
     */
    Fn2ol: T;

    /**
     * @default 'Error code: {{0}}'
     */
    d9jm2: T;

    /**
     * @default 'View photo'
     */
    dYEVH: T;

    /**
     * @default 'View more'
     */
    wl43U: T;

    /**
     * @default 'Map showing event places'
     */
    tbUsJ: T;

    /**
     * @default 'Close modal'
     */
    RZhyD: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'per person'
     */
    GQCme: T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'Explore More'
     */
    OiwZP: T;

    /**
     * @default 'Popular Nearby'
     */
    c4E38: T;

    /**
     * @default 'See more tickets & tours'
     */
    sBqjL: T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default 'View Hotel'
     */
    VnGJE: T;

    /**
     * @default 'Explore Hotels Nearby'
     */
    F3uMA: T;

    /**
     * @default 'Book with Free Cancellation'
     */
    Ksxow: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Map showing accommodations'
     */
    iIHuf: T;

    /**
     * @default 'Compare Prices Before You Book'
     */
    WjQlM: T;

    /**
     * @default 'Booking Options'
     */
    JgLga: T;

    /**
     * @default 'Visit External Link'
     */
    anXNm: T;

    /**
     * @default 'You'll leave the site to visit this page.'
     */
    '8QwTv': T;

    /**
     * @default 'Price'
     */
    '7WvrG': T;

    /**
     * @default 'Book on Joy'
     */
    '22I4P': T;

    /**
     * @default 'Exclusive prices for couples and guests.'
     */
    kWNwr: T;

    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default 'Guest price'
     */
    '1Zoxk': T;

    /**
     * @default 'N/A'
     */
    GgWAA: T;
  };
};

export type GuestSiteTravelTranslations<T extends LeafNodeValue = TranslateFunction> = {
  booking: {
    /**
     * @default 'Suggested Stay:'
     */
    suggestedStayDatesTitle: T;

    /**
     * @default 'Search'
     */
    searchButtonTitle: T;

    /**
     * @default 'Guests'
     */
    guestOptionPlural: T;

    /**
     * @default 'Guest'
     */
    guestOptionSingle: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;
  };
  accommodationLink: {
    /**
     * @default 'For more information on where to stay'
     */
    linkText: T;

    /**
     * @default 'More'
     */
    readMore: T;

    /**
     * @default 'Less'
     */
    readLess: T;
  };
  interceptorRedirectDialog: {
    /**
     * @default '{{hotelName}} isn’t available for your dates.'
     */
    titleWithHotelName: T;

    /**
     * @default 'This hotel isn’t available for your dates.'
     */
    title: T;

    /**
     * @default 'We’ve found similar hotels nearby with availability — some up to 40% off per night. You can also return to the list of hotels recommended by your host.'
     */
    accommodationPlaceContent: T;

    /**
     * @default 'We’ve found similar hotels nearby with the best prices — up to 40% off per night.'
     */
    content: T;

    /**
     * @default 'Search Similar Stays'
     */
    acceptCta: T;

    /**
     * @default 'See Nearby Hotels'
     */
    seeNearbyHotels: T;

    /**
     * @default 'Not Interested'
     */
    declineCta: T;

    /**
     * @default 'Back to Host's Hotel List'
     */
    backToHostsHotelList: T;
  };
  quick: {
    /**
     * @default '🏨 The couple has arranged guest lodging through Joy. Please book your room using group code {{0}}. Booking through our site allows us to know where everyone is staying to help with our planning.'
     */
    IzvMC: T;

    /**
     * @default '🏨 The couple has arranged guest lodging through Joy. Please book your room using group code {{0}}.'
     */
    pfX06: T;

    /**
     * @default 'Book your room with group code {{0}}'
     */
    prcTz: T;

    /**
     * @default 'All guests receive up to 25% off car rentals, booked directly with us. Why not extend your visit and enjoy your trip beyond our big day!'
     */
    sC5FI: T;

    /**
     * @default 'For Our Guests: Rental Car Savings'
     */
    '1A71p': T;

    /**
     * @default 'Search Rental Cars'
     */
    DNdZf: T;

    /**
     * @default 'Available from Hertz • Thrifty • Dollar • and more'
     */
    EFDAd: T;

    /**
     * @default 'From {{0}}'
     */
    SXEqF: T;

    /**
     * @default 'Map showing rental car pickup locations'
     */
    PN1PA: T;

    /**
     * @default 'View All Rental Cars'
     */
    zi1CP: T;
  };
};

export type GuestSiteWelcomeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'View Details'
     */
    zvlhe: T;
  };
};

export type GuestUnlockTranslations<T extends LeafNodeValue = TranslateFunction> = {
  findInviteForm: {
    /**
     * @default 'Let’s find your invitation'
     */
    title: T;

    /**
     * @default 'Enter your name to get your event schedule.'
     */
    subtitle: T;

    /**
     * @default 'First name'
     */
    firstNameLabel: T;

    /**
     * @default 'Last name'
     */
    lastNameLabel: T;

    /**
     * @default 'e.g. Sarah'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'e.g. Smith'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Find Invitation'
     */
    submitButtonText: T;

    /**
     * @default 'Searching...'
     */
    loadingButtonText: T;

    /**
     * @default '{{firstName}} {{lastName}} is not on the guest list. Try an alternative spelling or nickname. You can still view the public schedule.'
     */
    notFoundErrorText: T;

    /**
     * @default 'All fields are required'
     */
    required: T;
  };
  verifyEmailForm: {
    /**
     * @default 'Enter your email'
     */
    title: T;

    /**
     * @default 'We found multiple guests with the name {{firstName}} {{lastName}}. Please provide your email to confirm your identity.'
     */
    subtitle: T;

    /**
     * @default 'Email (Only visible to the host)'
     */
    emailLabel: T;

    /**
     * @default 'Find Invitation'
     */
    submitButtonText: T;

    /**
     * @default 'Searching...'
     */
    loadingButtonText: T;

    /**
     * @default 'We couldn’t find {{firstName}} {{lastName}} with that email on the guest list. Please try another email address.'
     */
    notFoundErrorText: T;

    /**
     * @default 'Email is required'
     */
    required: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    inputPlaceholder: T;
  };
  findInviteSuccessForm: {
    /**
     * @default 'Welcome {{firstName}}!'
     */
    title: T;

    /**
     * @default 'You’ve unlocked guest-only details.'
     */
    subtitle: T;

    /**
     * @default 'Explore the Event'
     */
    submitButtonText: T;
  };
  askHostForm: {
    /**
     * @default 'Ask the host'
     */
    title: T;

    /**
     * @default 'Tell the host who you are, so they can email you back with their event password.'
     */
    subtitle: T;

    /**
     * @default 'Your Full Name'
     */
    fullNameLabel: T;

    /**
     * @default 'Your Email'
     */
    emailLabel: T;

    /**
     * @default 'e.g. Sarah Smith'
     */
    namePlaceholder: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Send Request'
     */
    submitButtonText: T;

    /**
     * @default 'Sending...'
     */
    loadingButtonText: T;

    /**
     * @default 'All fields are required'
     */
    required: T;

    /**
     * @default 'Please enter a valid email'
     */
    validEmailWarning: T;
  };
  askHostSuccessForm: {
    /**
     * @default 'Your message has been sent'
     */
    title: T;

    /**
     * @default 'We’ve sent the host an email letting them know you’ve requested their event password.'
     */
    subtitle: T;

    /**
     * @default 'Return to Site'
     */
    submitButtonText: T;
  };
  quick: {
    /**
     * @default 'Password’s required'
     */
    '8U1Bi': T;

    /**
     * @default 'Wrong password. Double-check what you’ve typed, or try copying and pasting.'
     */
    ncD4c: T;

    /**
     * @default 'Private Event'
     */
    bLwtK: T;

    /**
     * @default 'Use the password shared by your host to see event details. '
     */
    eIQH6: T;

    /**
     * @default 'Need it?'
     */
    c8fBa: T;

    /**
     * @default 'Ask the Host'
     */
    u4Kzl: T;

    /**
     * @default 'Event Password'
     */
    '9SjQp': T;

    /**
     * @default 'eg. xy4686'
     */
    X0zlv: T;

    /**
     * @default 'View Event'
     */
    '5WK5D': T;

    /**
     * @default 'Sign In'
     */
    M4Z7E: T;

    /**
     * @default '🙌 Yay! You can now access all event details.'
     */
    jtQJK: T;

    /**
     * @default 'Welcome, {{0}}!'
     */
    diEuw: T;

    /**
     * @default 'You're all set!'
     */
    Lz3uB: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Find your invitation'
     */
    '9ex6A': T;

    /**
     * @default 'Please enter a valid email'
     */
    '3hdNF': T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'Let us find your invitation'
     */
    OwFUe: T;

    /**
     * @default 'Enter the email address associated with your invitation.'
     */
    v0dOQ: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    zPEWs: T;

    /**
     * @default 'Verify'
     */
    JQhzc: T;

    /**
     * @default 'Continue as guest'
     */
    xwcGn: T;

    /**
     * @default 'Code must be 6 digits'
     */
    rJdnF: T;

    /**
     * @default 'Verification code is required'
     */
    PqQUy: T;

    /**
     * @default 'Invalid or expired code. Please try again.'
     */
    '1gNEe': T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Code resent.'
     */
    qiH1C: T;

    /**
     * @default 'Failed to resend code. Please try again.'
     */
    ZadKH: T;

    /**
     * @default 'Check your email'
     */
    btFgC: T;

    /**
     * @default 'Enter the 6-digit code we sent to {{0}}.'
     */
    lSPxG: T;

    /**
     * @default 'Verification code'
     */
    mYcRM: T;

    /**
     * @default 'Resend code'
     */
    gUzDn: T;

    /**
     * @default 'All fields are required'
     */
    '90FY0': T;

    /**
     * @default 'Ask the host'
     */
    '2EA4l': T;

    /**
     * @default 'Tell the host who you are, so they can help you find your invitation.'
     */
    EFpP3: T;

    /**
     * @default 'Your Full Name'
     */
    boaCW: T;

    /**
     * @default 'e.g. Sarah Smith'
     */
    SlxSk: T;

    /**
     * @default 'Your Email'
     */
    PijiP: T;

    /**
     * @default 'Send Request'
     */
    nwBjs: T;

    /**
     * @default 'Your message has been sent'
     */
    KV5CV: T;

    /**
     * @default 'We’ve let the host know you’re looking for your invitation, so they can reach out to you.'
     */
    ThmLC: T;

    /**
     * @default 'Return to Site'
     */
    QIuK9: T;

    /**
     * @default 'Need help?'
     */
    YKWTW: T;
  };
};

export type HeaderHelpMenuTranslations<T extends LeafNodeValue = TranslateFunction> = {
  menuItems: {
    /**
     * @default 'Leave a Suggestion'
     */
    suggestion: T;

    /**
     * @default 'Contact Support'
     */
    support: T;

    /**
     * @default 'Help Guides'
     */
    help: T;
  };
};

export type HeaderLayoutUpgradeTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type HotelBlockTranslations<T extends LeafNodeValue = TranslateFunction> = {
  leadGenerationForm: {
    /**
     * @default 'Destination'
     */
    destination: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'Rooms Per Night'
     */
    roomsPerNight: T;

    /**
     * @default 'Full Name'
     */
    fullName: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'Who should we contact?'
     */
    sendQuotes: T;

    /**
     * @default 'Continue'
     */
    cont: T;

    /**
     * @default 'Your full name will help us know who to contact.'
     */
    fullNameError: T;

    /**
     * @default 'Please share your email address.'
     */
    emailError: T;

    /**
     * @default 'Please select the number of rooms per night.'
     */
    numberRoomsError: T;

    /**
     * @default 'Search for a city or venue for your event.'
     */
    locationError: T;

    /**
     * @default 'Add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Search for a city or venue'
     */
    locationPlaceholder: T;

    /**
     * @default 'Add a date'
     */
    datePlaceholder: T;

    /**
     * @default 'Choose your best estimate'
     */
    numberRoomsPlaceholder: T;

    /**
     * @default 'Almost Done!'
     */
    almostDone: T;

    /**
     * @default 'Get the best hotel rates by answering a few more optional questions below.'
     */
    additionalInfoTitle: T;

    /**
     * @default 'Any additional details we should know?'
     */
    additionalInfoSubtext: T;

    /**
     * @default 'You can tell us about hotel brand preferences, any special needs, or even specific neighborhoods.'
     */
    notePlaceholder: T;

    /**
     * @default 'How would you like to be contacted?'
     */
    howContacted: T;

    /**
     * @default 'Your phone number is kept confidential and not shared with other parties. SMS data rates apply.'
     */
    confidential: T;

    /**
     * @default 'Phone Number'
     */
    phoneLabel: T;

    /**
     * @default 'Interested in scheduling a call with our concierge team?'
     */
    scheduleCall: T;

    /**
     * @default 'Select a date and time'
     */
    scheduleCallCTA: T;

    /**
     * @default 'Concierge Call Confirmed'
     */
    callConfirmed: T;

    /**
     * @default 'Finish'
     */
    finishCTA: T;

    /**
     * @default 'All Set!'
     */
    allSet: T;

    /**
     * @default 'A member of our concierge team will contact you.'
     */
    allSetText: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'Please share your cell phone number.'
     */
    smsRequiredError: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    timeSlotRequiredError: T;
  };
  hotelSelection: {
    informativeDialog: {
      /**
       * @default 'What happens next?'
       */
      title: T;

      /**
       * @default 'Select hotels near your venue and let our concierge team do the work of negotiating discounted rates.'
       */
      item1: T;

      /**
       * @default 'Review your personalized hotel group rates with your personal concierge and select your favorite hotel for your guests.'
       */
      item2: T;

      /**
       * @default 'View Hotels'
       */
      btn: T;
    };
    addManuallyHotelDialog: {
      /**
       * @default 'Manually add hotel'
       */
      title: T;

      /**
       * @default 'Hotel'
       */
      inputHotelTitle: T;

      /**
       * @default 'Find Hotel'
       */
      inputHotelPlaceholder: T;

      /**
       * @default 'URL'
       */
      inputHotelLocationTitle: T;

      /**
       * @default 'company.com'
       */
      inputHotelLocationPlaceholder: T;

      /**
       * @default 'Add Hotel'
       */
      btn: T;
    };
    confirmationDialog: {
      /**
       * @default 'Are you sure you want to continue?'
       */
      title: T;

      /**
       * @default 'You can add up to five hotels to your group rate request.'
       */
      subtitle: T;

      /**
       * @default 'Confirm Hotels'
       */
      btn: T;
    };
    list: {
      search: {
        /**
         * @default 'Event Venue or Destination'
         */
        location: T;

        /**
         * @default 'Near'
         */
        near: T;

        /**
         * @default '{{roomBlocks}} Room Blocks'
         */
        roomBlocks: T;

        /**
         * @default 'Destination or Hotel'
         */
        locationV2: T;

        /**
         * @default 'Check in'
         */
        checkIn: T;

        /**
         * @default 'Check out'
         */
        checkOut: T;

        /**
         * @default '{{startDate}} - {{endDate}}'
         */
        dateRange: T;

        /**
         * @default 'Search for a city or venue for your event.'
         */
        locationError: T;

        /**
         * @default 'Add a check in date.'
         */
        checkInDateError: T;

        /**
         * @default 'Add a check out date.'
         */
        checkOutDateError: T;

        /**
         * @default 'Check in date must be before check out date'
         */
        checkInDateRangeError: T;

        /**
         * @default 'Check out date must be after check in date'
         */
        checkOutDateRangeError: T;

        /**
         * @default 'Central Park Boathouse'
         */
        locationPlaceholder: T;

        /**
         * @default 'Date'
         */
        datePlaceholder: T;

        /**
         * @default 'Search'
         */
        searchCTA: T;
      };
      hotelList: {
        /**
         * @default 'Select Your Hotels'
         */
        selectHotels: T;

        /**
         * @default 'Show More'
         */
        showMore: T;

        /**
         * @default 'Top Picks'
         */
        filterPopularity: T;

        /**
         * @default 'Distance'
         */
        filterDistance: T;
      };
      hotelItem: {
        /**
         * @default 'Add Hotel'
         */
        addHotelTxt: T;

        /**
         * @default 'miles away'
         */
        distance: T;

        /**
         * @default 'Remove'
         */
        removeHotelTxt: T;

        /**
         * @default 'Interested Property'
         */
        interestedLabel: T;

        /**
         * @default 'Couple Favorite'
         */
        preferredHotelTooltipTitle: T;

        /**
         * @default 'Get a room block with one of Joy's partner hotels and get the best group rates fast. We hand picked these properties based on reviews from other Joy couples, competitive rates, and a great fit for larger groups.'
         */
        preferredHotelTooltipDescription: T;

        /**
         * @default 'Couple Favorite'
         */
        preferredHotelMobileViewLabel: T;
      };
      hotelCart: {
        /**
         * @default 'Confirm Hotels'
         */
        btnConfirm: T;

        /**
         * @default 'Your Hotels'
         */
        yourHotels: T;

        /**
         * @default '{{hotelsCount}} of {{maxHotels}}'
         */
        hotelsCountLabel: T;

        /**
         * @default 'Add your first hotel!'
         */
        noHotels: T;

        /**
         * @default 'You can add a maximum of 5 hotels.'
         */
        onlyFive: T;
      };
      addManuallyBanner: {
        /**
         * @default 'Manually Add Hotel'
         */
        addHotelManually: T;

        /**
         * @default 'Not finding what you’re looking for?'
         */
        label: T;
      };
      noResults: {
        /**
         * @default 'Sorry, no results found.'
         */
        label: T;

        /**
         * @default 'Update your search area to see hotel options.'
         */
        eyeBrow: T;
      };
      noItem: {
        /**
         * @default 'Not finding what you’re looking for?'
         */
        label: T;

        /**
         * @default 'Manually Add Hotel'
         */
        manualAddCTA: T;

        /**
         * @default 'Contact Concierge Team'
         */
        buttonCTA: T;

        /**
         * @default 'Chat'
         */
        intercomButtonCTA: T;
      };
      addManuallyDialog: {
        /**
         * @default 'Manually add hotel'
         */
        title: T;

        /**
         * @default 'Search for hotels'
         */
        label: T;

        /**
         * @default 'Hotel Name'
         */
        placeholder: T;

        /**
         * @default 'Add Hotel'
         */
        addHotelCTA: T;

        /**
         * @default 'Remove Hotel'
         */
        removeHotelCTA: T;
      };
    };
  };
  hotelConfirmation: {
    /**
     * @default 'Confirm and Request Rates'
     */
    title: T;

    /**
     * @default 'Review and request rates'
     */
    titleV2: T;

    /**
     * @default 'Request Hotel Rates'
     */
    buttonCTA: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Search Area'
     */
    hotelSearchArea: T;

    personalDetailSection: {
      /**
       * @default 'Personal Details'
       */
      header: T;

      /**
       * @default 'Partner One'
       */
      partnerOneHeader: T;

      /**
       * @default 'Partner Two'
       */
      partnerTwoHeader: T;

      /**
       * @default 'First Name'
       */
      firstNamePlaceholder: T;

      /**
       * @default 'Last Name'
       */
      lastNamePlaceholder: T;
    };

    /**
     * @default 'Event Name'
     */
    requestName: T;

    /**
     * @default 'your@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Dates'
     */
    dates: T;

    /**
     * @default 'Add a date'
     */
    datePlaceholder: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'We don’t have a venue (yet)'
     */
    venueNotSelectedCheckBoxText: T;

    /**
     * @default 'Venue Name'
     */
    venueNamePlaceholder: T;

    /**
     * @default 'Address'
     */
    venueAddressPlaceholder: T;

    /**
     * @default 'Venue Address'
     */
    venueAddressTitle: T;

    /**
     * @default 'Please enter a venue address to help us find your properties.'
     */
    venueAddressFieldError: T;

    /**
     * @default 'Please enter a location to help us find your properties.'
     */
    hotelSearchAreaFieldError: T;

    /**
     * @default 'Please share your venue address to help us locate the most relevant properties for your guests.'
     */
    venueAddressTooltipText: T;

    /**
     * @default 'Search for a city or venue for your event.'
     */
    locationError: T;

    /**
     * @default 'Add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Search for a city or venue'
     */
    locationPlaceholder: T;

    /**
     * @default 'Additional Notes'
     */
    additionalNotes: T;

    /**
     * @default 'You can tell us about hotel brand preferences, any special needs, or even specific neighborhoods you like.'
     */
    additionalNotesText: T;

    /**
     * @default 'Your Contact Details'
     */
    contact: T;

    /**
     * @default 'Contact Preference'
     */
    contactPreference: T;

    /**
     * @default 'Please enter a valid phone number.'
     */
    invalidPhoneNumberError: T;

    /**
     * @default 'How would you like us to contact you?'
     */
    contactYou: T;

    /**
     * @default 'How would you like to receive your rates?'
     */
    howWouldYouLikeToRecieveRates: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    contactError: T;

    /**
     * @default 'Please provdie a phone number.'
     */
    contactPhoneError: T;

    /**
     * @default 'Phone Number'
     */
    phoneNumber: T;

    /**
     * @default 'Please select the number of rooms per night.'
     */
    numberRoomsError: T;

    /**
     * @default 'Choose your best estimate'
     */
    numberRoomsPlaceholder: T;

    /**
     * @default 'Mininum is 10'
     */
    minNumberRoomsError: T;

    /**
     * @default 'Maximum is 999'
     */
    maxNumberRoomsError: T;

    /**
     * @default 'Must be a number'
     */
    mustBeNumberRoomsError: T;

    /**
     * @default 'More than 50'
     */
    moreThanFifty: T;

    /**
     * @default 'Estimated Rooms Per Night'
     */
    roomsPerNight: T;

    /**
     * @default 'You can change this later.'
     */
    roomsPerNightSubtitle: T;

    /**
     * @default 'Schedule a call'
     */
    scheduleCall: T;

    /**
     * @default 'Text Message'
     */
    textMessage: T;

    /**
     * @default 'Concierge Call Confirmed'
     */
    callConfirmed: T;

    /**
     * @default 'Phone Number'
     */
    phoneLabel: T;

    /**
     * @default 'Choose a slot that suits you.'
     */
    timeSlotLabel: T;

    /**
     * @default 'Select a date and time'
     */
    scheduleCallCTA: T;

    /**
     * @default 'Please add a name for your event.'
     */
    eventNameError: T;

    /**
     * @default 'Please add a first name for partner one.'
     */
    partnerOneFirstNameError: T;

    /**
     * @default 'Please add a last name for partner one.'
     */
    partnerOneLastNameError: T;

    /**
     * @default 'Please add a first name for partner two.'
     */
    partnerTwoFirstNameError: T;

    /**
     * @default 'Please add a last name for partner two.'
     */
    partnerTwoLastNameError: T;

    /**
     * @default 'Your phone number is kept confidential and not shared with other parties. SMS data rates apply.'
     */
    confidential: T;

    /**
     * @default 'Your Hotels'
     */
    yourHotels: T;

    /**
     * @default 'Edit'
     */
    changeCTA: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'An error occurred while submitting your request. Please refresh the page and try again'
     */
    authError: T;

    /**
     * @default 'Please share your cell phone number.'
     */
    smsRequiredError: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    timeSlotRequiredError: T;

    /**
     * @default 'Remove'
     */
    remove: T;

    /**
     * @default 'Hotel image'
     */
    hotelImage: T;

    /**
     * @default 'We suggest considering both out-of-town and in-town guests when calculating the number of rooms needed per night.'
     */
    tooltipText: T;

    /**
     * @default 'Please share a location to help us locate the most relevant properties for your guests.'
     */
    hotelSearchAreaTooltipText: T;

    /**
     * @default 'You need at least one accommodation to submit your rate request.'
     */
    minimumShortlistError: T;

    /**
     * @default 'Email'
     */
    contactViaEmail: T;

    /**
     * @default 'Email Address'
     */
    emailAddress: T;

    /**
     * @default 'Please share your email address.'
     */
    emailError: T;

    /**
     * @default 'Name'
     */
    fullName: T;

    /**
     * @default 'John Smith'
     */
    fullNamePlaceholder: T;

    /**
     * @default 'Your full name will help us know who to contact.'
     */
    fullNameError: T;

    informativeBox: {
      /**
       * @default 'You're just a step away from our free hotel concierge service!'
       */
      title: T;

      /**
       * @default 'Joy concierge does the work so you don’t have to.'
       */
      item1: T;

      /**
       * @default 'Exclusively negotiated discounts up to 30% off.'
       */
      item2: T;

      /**
       * @default 'Hotel perks and upgrades.'
       */
      item3: T;
    };
  };
  hotelAdmin: {
    /**
     * @default 'Room Blocks'
     */
    menu: T;

    /**
     * @default 'Request Submitted!'
     */
    title: T;

    /**
     * @default 'Our concierge team is working with our hotel partners to secure the best group rates possible. We'll contact you via your preferred channel once we have all the details. 🌟'
     */
    subTitle: T;

    /**
     * @default 'Event Name'
     */
    eventName: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Dates'
     */
    hotelDates: T;

    /**
     * @default 'Rooms Requested'
     */
    roomsRequested: T;

    /**
     * @default 'Additional Details'
     */
    additionalDetails: T;

    /**
     * @default 'Need Help? Contact Our Team'
     */
    helpText: T;

    /**
     * @default 'Email Us'
     */
    emailUsCta: T;

    /**
     * @default 'Chat Now'
     */
    chatNowCta: T;
  };
  hotelRoomBlockFunnel: {
    /**
     * @default 'Room Blocks'
     */
    menu: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Event Name'
     */
    eventName: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Dates'
     */
    hotelDates: T;

    /**
     * @default 'Chat with us'
     */
    headerChat: T;

    /**
     * @default 'Chat'
     */
    headerChatMobile: T;

    /**
     * @default 'Rooms Requested'
     */
    roomsRequested: T;

    /**
     * @default 'Additional Details'
     */
    additionalDetails: T;

    /**
     * @default 'We’re working on getting you the best deals.'
     */
    subTitleV2: T;

    /**
     * @default 'Rates are coming in slower than expected but rest assure they’re coming.'
     */
    slowProgressInfoMessage: T;

    /**
     * @default 'Need Changes Made?'
     */
    conciergeMemberDetailsCardHeader: T;

    /**
     * @default '🙌 At your service!'
     */
    atYourService: T;

    /**
     * @default 'Joy concierge team is here to assist you'
     */
    conciergeMemberNotAvailableCardText: T;

    /**
     * @default 'Chat with Concierge'
     */
    chatWithConcierge: T;

    heading: {
      /**
       * @default 'Your search has begun!'
       */
      workingOnRequest: T;

      /**
       * @default 'We’re reaching out to your hotels.'
       */
      gettingTheBestRates: T;

      /**
       * @default 'Success! We got great rates!'
       */
      ratesReadyForReview: T;

      /**
       * @default 'Your hotel are almost ready.'
       */
      finalizingHotelDeals: T;
    };
    info: {
      /**
       * @default 'We’re assigning your hotel requests to one of our concierge to help you throughout this process. Leave it up to us!'
       */
      workingOnRequest: T;

      /**
       * @default 'We’re working on getting you the best deals. The typical request takes 6 days. We’ll contact you when your rates are ready.'
       */
      gettingTheBestRates: T;

      /**
       * @default 'We’ve received hotel offers and they’re ready for you to review.'
       */
      ratesReadyForReview: T;

      /**
       * @default 'We’re crossing t’s and dotting i’s to make sure your deals are locked in. Your guests will soon have the best deals.'
       */
      finalizingHotelDeals: T;
    };
    progressBarStates: {
      /**
       * @default 'Working on'
       */
      workingOnRequestPart1: T;

      /**
       * @default 'request'
       */
      workingOnRequestPart2: T;

      /**
       * @default 'Getting the'
       */
      gettingTheBestRatesPart1: T;

      /**
       * @default 'Best Rates'
       */
      gettingTheBestRatesPart2: T;

      /**
       * @default 'Rates Ready'
       */
      ratesReadyForReviewPart1: T;

      /**
       * @default 'for Review'
       */
      ratesReadyForReviewPart2: T;

      /**
       * @default 'Finalizing'
       */
      finalizingHotelDetailsPart1: T;

      /**
       * @default 'Hotels Deals'
       */
      finalizingHotelDetailspart2: T;

      /**
       * @default 'Time to'
       */
      timeToPartyParty1: T;

      /**
       * @default 'Party!'
       */
      timeToPartyParty2: T;
    };
  };
  headerSection: {
    /**
     * @default 'Hotels'
     */
    headerTitle: T;

    /**
     * @default 'Help'
     */
    help: T;
  };
  hotelBlockV4: {
    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Hotels'
     */
    headerTitle: T;

    /**
     * @default 'Chat with us'
     */
    headerChat: T;

    /**
     * @default 'Chat'
     */
    headerChatMobile: T;

    /**
     * @default 'Request discounted rates for hotels near your venue.'
     */
    headerSubtitle: T;

    /**
     * @default 'Find Your Perfect Wedding Stay'
     */
    header: T;

    /**
     * @default 'We unlock exclusive rates by bringing together the bargaining power of all Joy couples.'
     */
    headerSubtitleV2: T;

    /**
     * @default 'Potential Hotels Near Your Destination'
     */
    title: T;

    /**
     * @default 'Load More Hotels'
     */
    btnLoadMore: T;

    /**
     * @default 'Introducing Group Reservations with Joy'
     */
    valuePropHeaderEyeBrow: T;

    /**
     * @default 'Take care of your guests with great rates and no fees.'
     */
    valuePropHeaderTitle: T;

    /**
     * @default 'Your personal Joy concierge agent will help you get the best room block rates for you and your guests.'
     */
    valuePropHeaderSubtitle: T;

    /**
     * @default 'Save up to 30% Off Room Rates'
     */
    valuePropOneTitle: T;

    /**
     * @default 'Zero Deposit Requirements'
     */
    valuePropTwoTitle: T;

    /**
     * @default 'Dedicated Concierge'
     */
    valuePropThreeTitle: T;

    /**
     * @default 'Good to Know'
     */
    remindMeHeaderEyeBrow: T;

    /**
     * @default '86% of Joy couples share hotels with their guests.'
     */
    remindMeHeaderTitle: T;

    /**
     * @default 'When do you wish to begin selecting your hotels?'
     */
    remindMeTitle: T;

    /**
     * @default 'We’ll help you get started with your hotel search on time.'
     */
    remindMeSubtitle: T;

    /**
     * @default 'Remind me in 2 weeks.'
     */
    remindMeOpt1: T;

    /**
     * @default 'Remind me in 4 weeks'
     */
    remindMeOpt2: T;

    /**
     * @default 'Remind me in 8 weeks'
     */
    remindMeOpt3: T;

    /**
     * @default 'Set a Reminder'
     */
    remindMeBtn: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'An error occurred while submitting your request. Please refresh the page and try again.'
     */
    authError: T;

    /**
     * @default 'Thank You!'
     */
    reminderThankYouTitle: T;

    /**
     * @default 'your email address'
     */
    reminderThankYouEmailText: T;

    /**
     * @default 'We’ll send you an email reminder at <Email/> in {{reminderSelected}}'
     */
    reminderThankYouMessage: T;
  };
  roomBlockManager: {
    /**
     * @default 'Your Room Blocks'
     */
    title: T;

    /**
     * @default 'Your room blocks are ready'
     */
    titleV2: T;

    /**
     * @default 'Share your booking link with guests. Help them get the best rates before they expire.'
     */
    subTitle: T;

    /**
     * @default 'Share your booking link with guests to ensure they get the best rates before they expire.'
     */
    subTitleV2: T;

    /**
     * @default 'Rate expires {{date}}'
     */
    rateExpires: T;

    /**
     * @default '{{rooms}} Rooms'
     */
    rooms: T;

    /**
     * @default 'night'
     */
    night: T;

    /**
     * @default 'Share Booking Link'
     */
    shareBookingLink: T;

    /**
     * @default 'Copy Hotel Booking Link'
     */
    copyBookingLink: T;

    /**
     * @default 'Need help or have questions?'
     */
    helpText: T;

    /**
     * @default 'Chat With Us'
     */
    chatWithUs: T;

    /**
     * @default '✨ Link Copied ✨'
     */
    copied: T;

    /**
     * @default '{{miles}} miles from the venue'
     */
    milesFromVenue: T;

    errorState: {
      /**
       * @default 'Something went wrong. We're unable to display your reserved room blocks right now.'
       */
      title: T;

      /**
       * @default 'You can still copy your hotels page link below and share with your guests.'
       */
      subTitle: T;

      /**
       * @default 'Copy Link'
       */
      copyLink: T;
    };

    /**
     * @default 'Room Block Cancelled'
     */
    roomBlockCancelled: T;

    contactCollector: {
      /**
       * @default 'Smart Tip'
       */
      smartTip: T;

      /**
       * @default 'Gather contacts and share your room block.'
       */
      title: T;

      /**
       * @default 'Easily gather guest info and share your room block with everyone on your list.'
       */
      text: T;

      /**
       * @default 'Gather Contacts'
       */
      cta: T;
    };
    progressBar: {
      roomsBooked: {
        /**
         * @default '{{numberRoomsGuestBooked}} Room Booked'
         */
        singular: T;

        /**
         * @default '{{numberRoomsGuestBooked}} Rooms Booked'
         */
        plural: T;
      };

      /**
       * @default '{{totalRoomsBooked}} Total'
       */
      totalRoomsBooked: T;
    };
  };
  roomBlockManagerIncentives: {
    /**
     * @default 'Unlock Joy perks when your guests book'
     */
    title: T;

    /**
     * @default 'Speak with your Joy concierge to unlock perks as you reach your booking milestones.'
     */
    subTitle: T;

    /**
     * @default 'Level 1: 40% Nights Filled  '
     */
    titleTierOne: T;

    /**
     * @default 'Claim one of the Joy perks below when your guests book 40% of your room block.'
     */
    subtitleTierOne: T;

    /**
     * @default 'Discounts on printed invitations and save the dates.'
     */
    subtitleTierOneNoRegistry: T;

    /**
     * @default '40% Discount on Printed Cards'
     */
    discountPrint: T;

    /**
     * @default '40% Off Printed Cards'
     */
    discountPrintV2: T;

    /**
     * @default '$50 Registry Gift Card'
     */
    registryGiftCard: T;

    /**
     * @default 'Learn More'
     */
    cta: T;

    /**
     * @default 'Level 2: 60% Nights Filled'
     */
    titleTierTwo: T;

    /**
     * @default 'Earn points towards your next reservation at participating US properties.'
     */
    subtitleTierTwo: T;

    /**
     * @default 'Available for room blocks at Marriott, Hilton, IHG, or Wyndham properties in the United States.'
     */
    tierTwoTooltip: T;

    /**
     * @default 'More Info'
     */
    moreInfo: T;

    /**
     * @default '15,000 Hotel Points'
     */
    hotelPoints: T;

    /**
     * @default 'Let your guests know about your room block:'
     */
    titleNextSteps: T;

    /**
     * @default 'Share your room block with your guests:'
     */
    titleNextStepsV2: T;

    /**
     * @default 'Add a note in your invitation or save the date'
     */
    nextStepOne: T;

    /**
     * @default 'Send a message to your guests'
     */
    nextStepTwo: T;

    /**
     * @default 'Add an announcement note on your website'
     */
    nextStepThree: T;

    /**
     * @default 'Nights Filled:'
     */
    titleV2: T;

    /**
     * @default 'Milestones:'
     */
    milestones: T;

    /**
     * @default 'Perk 1'
     */
    perkOne: T;

    /**
     * @default 'Perk 2'
     */
    perkTwo: T;

    /**
     * @default 'Learn more about Joy room block perks'
     */
    subtitleV2: T;

    /**
     * @default 'Room Block Perks'
     */
    subtitleV2Mobile: T;

    /**
     * @default 'Room Block Perks'
     */
    subtitleNoUtilData: T;

    /**
     * @default 'Perk 1: 40% Nights Filled'
     */
    titlePerkOne: T;

    /**
     * @default 'Send thank you notes and invitations to your guests.'
     */
    subtitlePerkOne: T;

    /**
     * @default 'Perk 2: 60% Nights Filled'
     */
    titlePerkTwo: T;

    /**
     * @default 'Claim one of the Joy perks below.'
     */
    subtitlePerkTwo: T;

    /**
     * @default 'Claim Perk'
     */
    claimPerkCta: T;

    printPerkDialog: {
      /**
       * @default 'You’ve unlocked {{percentageDiscount}}% off all printed cards from Joy.'
       */
      title: T;

      /**
       * @default 'We’re unable to retrieve your promo code at this time.'
       */
      titleError: T;

      /**
       * @default 'Excludes concierge premium prints.'
       */
      subtitle: T;

      /**
       * @default 'Please contact our concierge team if your continue to experience this issue.'
       */
      subtitleError: T;

      /**
       * @default 'Use this promo code at checkout:'
       */
      promoCodeHeader: T;

      /**
       * @default 'View Printed Cards'
       */
      cta: T;

      /**
       * @default 'Contact Concierge'
       */
      ctaError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
    registryPerkDialog: {
      /**
       * @default 'You’ve unlocked ${{dollarDiscount}} off a registry gift from Joy.'
       */
      title: T;

      /**
       * @default 'We’re unable to retrieve your promo code at this time.'
       */
      titleError: T;

      /**
       * @default 'Promo code is valid on orders of $75 or more, after promotions and discounts are applied. Excludes gift cards, cash funds, and gifts added to a Joy Registry from external stores and websites.'
       */
      subtitle: T;

      /**
       * @default 'Please contact our concierge team if your continue to experience this issue.'
       */
      subtitleError: T;

      /**
       * @default 'Use this promo code at checkout:'
       */
      promoCodeHeader: T;

      /**
       * @default 'View Registry'
       */
      cta: T;

      /**
       * @default 'Contact Concierge'
       */
      ctaError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };

    /**
     * @default 'incentive'
     */
    incentive: T;
  };
  quick: {
    /**
     * @default 'Perk Intercom workflow test'
     */
    Gsou7: T;

    /**
     * @default 'Details'
     */
    CiOW2: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Short Listing Flow Selection'
     */
    mBfDm: T;

    /**
     * @default 'Radius (in miles)'
     */
    SQacL: T;

    /**
     * @default 'Keyword'
     */
    jPa7B: T;

    /**
     * @default 'Key'
     */
    DJWAA: T;

    /**
     * @default 'Value'
     */
    FgEJH: T;

    /**
     * @default 'Add Custom Prop'
     */
    T3mBH: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Map Area'
     */
    fACQN: T;

    /**
     * @default 'Wedding Venue'
     */
    R07CM: T;

    /**
     * @default 'Show List'
     */
    FYmIB: T;

    /**
     * @default 'Risk-Free'
     */
    '0M38T': T;

    /**
     * @default 'No financial commitment required.'
     */
    CAt3N: T;

    /**
     * @default 'Make it easy'
     */
    ZM1TV: T;

    /**
     * @default 'Share hotel options with guests on your website.'
     */
    LwJgX: T;

    /**
     * @default 'Discounts & Perks'
     */
    fQ8xY: T;

    /**
     * @default 'Get up to 30% off market rates and enjoy hotel upgrades.'
     */
    '7sm6o': T;

    /**
     * @default 'Free Concierge'
     */
    LxmW6: T;

    /**
     * @default 'We negotiate exclusive group booking rates so you don't have to.'
     */
    '1q4r3': T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Secure a Hotel Room Block for Your Guests'
     */
    PX9FF: T;

    /**
     * @default 'Request discounted rates through our free concierge service'
     */
    FfRj2: T;

    /**
     * @default 'Hotel Room Blocks'
     */
    BBkTy: T;

    /**
     * @default 'We'll secure discounted group rates at the hotels you've chosen — at no cost to you.'
     */
    Juvbe: T;

    /**
     * @default 'Add Hotels With Room Blocks'
     */
    JZAbf: T;

    /**
     * @default 'What is a room block'
     */
    '7P7wV': T;

    /**
     * @default 'A room block is a reservation of a grouping of rooms (typically 10 or more) that are usually at the same hotel.'
     */
    dWfQX: T;

    /**
     * @default 'Show Map'
     */
    DQ7y6: T;

    /**
     * @default 'Manually add hotel'
     */
    '8yIET': T;

    /**
     * @default 'Search for hotels'
     */
    cWXYq: T;

    /**
     * @default 'Hotel Name'
     */
    Jgj9R: T;

    /**
     * @default 'Remove Hotel'
     */
    '8jLre': T;

    /**
     * @default 'Add Hotel'
     */
    TDwjJ: T;

    /**
     * @default 'Event Venue or Destination'
     */
    GnCfE: T;

    /**
     * @default 'Central Park Boathouse'
     */
    J0o6B: T;

    /**
     * @default 'perk'
     */
    '2qWRA': T;
  };
};

export type HotelReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Send Hotels Reminder'
   */
  title: T;

  emailPreview: {
    /**
     * @default 'Subject:'
     */
    subject: T;

    /**
     * @default 'From {{from}} via Joy'
     */
    fromViaJoy: T;

    /**
     * @default 'View Hotels'
     */
    viewHotels: T;
  };

  /**
   * @default 'Edit Message'
   */
  editMessage: T;

  /**
   * @default 'Confirm & Send'
   */
  confirmAndSendLabel: T;

  createReminder: {
    /**
     * @default 'Remind your guests to book their stay.'
     */
    title: T;

    /**
     * @default 'Send your guests a quick reminder about booking their accommodations, so they can celebrate without a worry in the world.'
     */
    description: T;

    /**
     * @default 'From'
     */
    fromLabel: T;

    /**
     * @default 'Your Message'
     */
    messageLabel: T;

    /**
     * @default 'Accommodations Link'
     */
    linkLabel: T;

    /**
     * @default 'Link is not editable to prevent abuse and misuse of the platform.'
     */
    linkLabelHint: T;

    tabs: {
      /**
       * @default 'Text Preview'
       */
      text: T;

      /**
       * @default 'Email Preview'
       */
      email: T;
    };
    howItWorks: {
      /**
       * @default 'How does it work?'
       */
      title: T;

      /**
       * @default 'Write your message. Pick guests to remind. Reminder sent!'
       */
      description: T;

      steps: {
        /**
         * @default 'Write your message.'
         */
        writeMessage: T;

        /**
         * @default 'Pick guests to remind.'
         */
        pickGuests: T;

        /**
         * @default 'Reminder sent!'
         */
        reminderSent: T;
      };
    };
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Add or remove recipients
           */
          guest: T;
        };

        /**
         * @default 'Each guest will receive the SMS reminder, or email in case their phone number is missing.'
         */
        dekSMS: T;

        /**
         * @default 'Each guest will receive the email reminder.'
         */
        dekEmail: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testSMS: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test SMS'
         */
        buttonTextSMS: T;

        /**
         * @default 'Send Test Email'
         */
        buttonTextEmail: T;
      };
      send: {
        /**
         * @default 'Send Reminder'
         */
        hed: T;

        /**
         * @default 'Send reminder to all guests you picked.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
    };
    SMSSentSuccessMessage: {
      /**
       * @default 'Your reminder is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your reminder is on the way!
       * - plural: Your reminders are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    SMSSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    /**
     * @default 'Phone Number is not valid'
     */
    testNumberInvalidMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your reminder to book has been sent to {{count}} people.'
       */
      hed: T;

      /**
       * @default 'Patience is a virtue, but these great rates won’t wait!'
       */
      dek: T;

      /**
       * @default 'View Your Guests List'
       */
      buttonText: T;
    };
    sendTestSMSDialog: {
      /**
       * @default 'Send Test SMS'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Phone number'
       */
      testNumberLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default '+1-555-555-5555'
       */
      testNumberPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Phone Number is required'
       */
      testNumberErrorMessage: T;

      /**
       * @default 'Should be a valid phone number'
       */
      testNumberInvalidErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      testEmailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'hello@gmail.com'
       */
      testEmailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      testEmailErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
  };
  nav: {
    /**
     * @default 'Next'
     */
    next: T;
  };
  quick: {
    /**
     * @default 'Must be at least {{0}} characters in length. Generic or placeholder text may prevent delivery.'
     */
    cCMCJ: T;

    /**
     * @default 'Sender name must be {{0}} characters or fewer.'
     */
    gjs6q: T;

    /**
     * @default 'A little reminder for our upcoming wedding – we've handpicked some wonderful places for you to stay. Be sure to book your room before they fill up! Can't wait to celebrate with you all! 🥂 Hotel details here:'
     */
    hDEnC: T;

    /**
     * @default 'View Hotels'
     */
    GodMO: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    A3Epe: T;

    /**
     * @default 'Have you booked yet?'
     */
    W8eoJ: T;

    /**
     * @default 'Browse Accommodations'
     */
    '36qrb': T;

    /**
     * @default 'Whether your stay is sorted or you're still deciding, here's what to do next.'
     */
    oyzAG: T;

    /**
     * @default 'A quick reminder to book your stay'
     */
    uCiq9: T;

    /**
     * @default 'Untitled stay details request - {{0}}'
     */
    CqiYb: T;

    /**
     * @default 'Untitled hotel reminder - {{0}}'
     */
    KFegL: T;

    /**
     * @default 'Dear'
     */
    QMtKA: T;

    /**
     * @default 'Message sent successfully!'
     */
    d2F6T: T;

    /**
     * @default 'Tell your friends and family'
     */
    G3I1R: T;

    /**
     * @default 'Collect Stay Details'
     */
    zlvRR: T;

    /**
     * @default 'Hotels Reminder'
     */
    Rqgjc: T;

    /**
     * @default 'Messaging+ is active. You can now schedule messages and text your guests.'
     */
    TC4p2: T;

    /**
     * @default 'Payment was not completed. You can try again when you're ready.'
     */
    tlQsK: T;

    /**
     * @default 'Payment received, but activation is taking longer than expected. Please refresh the page.'
     */
    VHGYp: T;

    /**
     * @default 'Your reminder to book has been sent to {{0}} people.'
     */
    pCHNw: T;

    /**
     * @default 'Patience is a virtue, but these great rates won't wait!'
     */
    oIH9s: T;

    /**
     * @default 'View Your Guests List'
     */
    '1esP9': T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Subject (Email only)'
     */
    '91kvm': T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Room Block Link'
     */
    cXc7X: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Preview and edit your message to your guests.'
     */
    '2ms2C': T;

    /**
     * @default '{{0}} day to your event.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} day to your event.
     * - plural: {{0}} days to your event.
     */
    v0Bfm: T;

    /**
     * @default 'Subject:'
     */
    sHXE7: T;

    /**
     * @default 'Already booked?'
     */
    hUl1f: T;

    /**
     * @default 'Let {{0}} know where you're staying so they can plan around you.'
     */
    Ouj5P: T;

    /**
     * @default 'Share My Stay'
     */
    CaF77: T;

    /**
     * @default 'Not yet?'
     */
    ALmgA: T;

    /**
     * @default 'Browse the places to stay that {{0}} have selected for you.'
     */
    '7wjl4': T;

    /**
     * @default 'Not interested?'
     */
    fWT11: T;

    /**
     * @default 'Stop these emails'
     */
    '0R6in': T;

    /**
     * @default 'Plan your forever, better.'
     */
    NZaqE: T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Terms and Conditions'
     */
    i5MF4: T;

    /**
     * @default 'Optional Test Email'
     */
    UbuTN: T;

    /**
     * @default 'Never hurts to make sure everything is just right.'
     */
    dEpA1: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'Everyone who RSVP'd yes (1 person)'
     * @param {number} count - The number of occurrences.
     * - singular: Everyone who RSVP'd yes (1 person)
     * - plural: Everyone who RSVP'd yes ({{0}} people)
     */
    dV4mR: T;

    /**
     * @default 'We couldn't check who's RSVP'd. Pick guests from your list instead.'
     */
    xyyr8: T;

    /**
     * @default 'No one has RSVP'd yes yet.'
     */
    G0RYA: T;

    /**
     * @default 'Everyone who RSVP'd yes'
     */
    wzgp4: T;

    /**
     * @default 'Select people from guest list'
     */
    NYyzl: T;

    /**
     * @default 'No guests selected yet.'
     * @param {number} count - The number of occurrences.
     * - zero: No guests selected yet.
     * - singular: 1 guest selected.
     * - plural: {{0}} guests selected.
     */
    t0nZk: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'Send to 1 Person'
     * @param {number} count - The number of occurrences.
     * - singular: Send to 1 Person
     * - plural: Send to {{0}} People
     */
    XqD7N: T;

    /**
     * @default 'Send Message'
     */
    bkLsr: T;

    /**
     * @default 'Keep an eye on replies and poke the slow pokes.'
     */
    cqENB: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Send to (No Guests Selected)'
     */
    xdSso: T;

    /**
     * @default 'Select an admin'
     */
    wKRDT: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Optional Test SMS'
     */
    zNsov: T;

    /**
     * @default 'We're reviewing your message before delivery'
     */
    '5msPb': T;

    /**
     * @default 'We couldn't save your message. Please try again.'
     */
    YuoZ4: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Send Now'
     */
    Ow0GV: T;

    /**
     * @default 'Confirm & Send'
     */
    KYpY4: T;

    /**
     * @default 'Review the recipients below.'
     */
    IYyKi: T;

    /**
     * @default '1 Person Selected…'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    HsBfd: T;

    /**
     * @default 'Modify Recipients'
     */
    Yv9UB: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'Guests receive a fixed email. Only the sender name can be changed.'
     */
    PuuqE: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Photo (Email only)'
     */
    d8IIe: T;

    /**
     * @default 'Compose Message'
     */
    lBM1t: T;

    /**
     * @default 'Let your guests know you’ve saved them rooms near the venue.'
     */
    cmSYD: T;

    /**
     * @default 'Nudge guests to share where they're staying — or to book, if they haven't yet.'
     */
    veuUB: T;

    /**
     * @default 'Send a quick reminder so no one forgets or misses out on nearby hotels.'
     */
    rNkeP: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Review Scheduled Reminder'
     */
    vriLd: T;

    /**
     * @default 'This reminder is locked while it's scheduled. Use "Edit Message" to make changes.'
     */
    dPkS1: T;

    /**
     * @default 'Reschedule send'
     */
    qm0u7: T;

    /**
     * @default 'Reschedule'
     */
    '82rNl': T;
  };
};

export type HotelSearchGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Hotels near {{0}} · {{1}}'
     */
    '7Lo9L': T;

    /**
     * @default 'Hotels near {{0}}'
     */
    RCeO8: T;

    /**
     * @default 'Hotel search · {{0}}'
     */
    XV5Vi: T;

    /**
     * @default 'Hotel search'
     */
    gzq2K: T;

    /**
     * @default 'Search hotels near {{0}}.'
     */
    HdT4w: T;

    /**
     * @default 'Search hotels for your trip.'
     */
    MmOGS: T;

    /**
     * @default 'Joy logo'
     */
    reVEU: T;
  };
};

export type HotelSuggestionDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Save Link with Exclusive Rates'
     */
    aT97C: T;

    /**
     * @default 'Keep the Original Link'
     */
    Tpsjr: T;

    /**
     * @default 'We found this hotel with exclusive rates for Joy couples and guests.'
     */
    rOY2J: T;

    /**
     * @default 'Save your guests money by adding the link to your hotel with exclusive discount up to 40%.'
     */
    adxvJ: T;

    /**
     * @default 'Guest only price'
     */
    '5KMxV': T;
  };
};

export type HotelTileTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} {{1}} walk'
     */
    '0uoli': T;

    /**
     * @default '{{0}} {{1}} drive'
     */
    hNVO9: T;

    /**
     * @default 'Nightly price from'
     */
    uS1D2: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;

    /**
     * @default '1 Room Reserved'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Room Reserved
     * - plural: {{0}} Rooms Reserved
     */
    QVs30: T;

    /**
     * @default 'Room block'
     */
    AuH5j: T;

    /**
     * @default 'Cancel free until {{0}}'
     */
    EenWM: T;

    /**
     * @default 'Free Cancellation'
     */
    Z77Qm: T;

    /**
     * @default 'Free cancellation'
     */
    TQbyK: T;

    /**
     * @default 'Close hotel details'
     */
    '6FKw2': T;

    /**
     * @default 'Event thumbnail'
     */
    '6ANfT': T;

    /**
     * @default 'more'
     */
    hd7QA: T;

    /**
     * @default 'Special Event Price'
     */
    aSy5u: T;

    /**
     * @default '{{0}}'s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    BzVlk: T;

    /**
     * @default 'Price per night · {{0}}-night min'
     */
    c3wHQ: T;

    /**
     * @default 'Price per night'
     */
    GlaeW: T;

    /**
     * @default 'Non-refundable rate'
     */
    U2bNd: T;

    /**
     * @default 'One Guest Booked This Hotel'
     * @param {number} count - The number of occurrences.
     * - singular: One Guest Booked This Hotel
     * - plural: {{0}} Guests Booked This Hotel
     */
    b1pcW: T;

    /**
     * @default 'Joy has seen a booking at this hotel across our events recently. It's a popular spot. You should book soon.'
     * @param {number} count - The number of occurrences.
     * - singular: Joy has seen a booking at this hotel across our events recently. It's a popular spot. You should book soon.
     * - plural: Joy has seen {{0}} bookings at this hotel across our events recently. It's a popular spot. You should book soon.
     */
    o8Ba0: T;

    /**
     * @default '1 booking'
     * @param {number} count - The number of occurrences.
     * - singular: 1 booking
     * - plural: {{0}} bookings
     */
    YLzDq: T;

    /**
     * @default 'Book before'
     */
    EDAQC: T;

    /**
     * @default 'Group Rate'
     */
    '7rn7p': T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    ISKAR: T;

    /**
     * @default '{{0}}/night'
     */
    xgoHP: T;
  };
};

export type ImageFilePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  toast: {
    /**
     * @default 'An error occurred while uploading photo. Please try again.'
     */
    toastPhotoUploadFailed: T;
  };
  quick: {
    /**
     * @default 'Image uploaded but could not be added to gallery. The image is still usable.'
     */
    s2Mep: T;

    /**
     * @default 'Photo upload failed. Please try again.'
     */
    ffkLv: T;
  };
};

export type ImagineYourCardTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type ImpermissibleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Hmm… we're having trouble with that.'
   */
  headerText: T;

  /**
   * @default 'If you already have an account, we don't recognize these credentials, please <Action/>'
   */
  alreadyHaveAccountSuggestion: T;

  /**
   * @default 'try another sign in method.'
   */
  alreadyHaveAccountAction: T;

  /**
   * @default 'Creating a new account? We're phasing out Facebook and Gmail sign up. Please <Action/>'
   */
  newAccountSuggestion: T;

  /**
   * @default 'sign up with your email.'
   */
  newAccountAction: T;
};

export type InlineEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    '5dGnM': T;

    /**
     * @default 'Text should be {{0}} characters or less.'
     */
    n9ZYR: T;

    /**
     * @default 'Page Settings'
     */
    qiWuC: T;

    /**
     * @default 'Customize Names'
     */
    hTrwJ: T;

    /**
     * @default 'Edit Content'
     */
    DV8xG: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Powered by Google'
     */
    CgX6S: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Monogram'
     */
    ggmVN: T;

    /**
     * @default '{{0}} is required.'
     */
    zSBzL: T;

    /**
     * @default 'This field is required.'
     */
    '7kfXn': T;
  };
};

export type InstantRoomBlocksAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '1 guest · Change'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest · Change
     * - plural: {{0}} guests · Change
     */
    '0plDt': T;

    /**
     * @default '+{{0}} more'
     */
    uEi8l: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Your event is {{0}}, but this room block is for {{1}}. Guests can only book these dates.'
     */
    Glp5L: T;

    /**
     * @default 'Pause the film'
     */
    vmFCU: T;

    /**
     * @default 'Play the film'
     */
    LSABA: T;

    /**
     * @default 'Film time'
     */
    f0mZF: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default 'How Instant Room Blocks work'
     */
    '7nGJJ': T;

    /**
     * @default 'Close the film'
     */
    hTfnK: T;

    /**
     * @default 'Your Room Block'
     */
    Pm1AI: T;

    /**
     * @default '{{0}} of {{1}} rooms booked'
     */
    moXFB: T;

    /**
     * @default 'Only {{0}} of the {{1}} rooms you asked for could be reserved'
     */
    lVe8Y: T;

    /**
     * @default 'Only {{0}} of the {{1}} rooms you asked for could be reserved · answer by {{2}}'
     */
    '7Ap9S': T;

    /**
     * @default 'Instant Room Blocks'
     */
    EQiiM: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Your room block'
     * @param {number} count - The number of occurrences.
     * - singular: Your room block
     * - plural: Your room blocks
     */
    NayiZ: T;

    /**
     * @default 'Room block'
     */
    AuH5j: T;

    /**
     * @default 'Manage {{0}}'
     */
    BSZFx: T;

    /**
     * @default 'Manage room block'
     */
    LhCyv: T;

    /**
     * @default 'Manage'
     */
    JaHpE: T;

    /**
     * @default 'Get another room block'
     */
    NKow0: T;

    /**
     * @default 'You're all set on instant room blocks'
     */
    TrDmg: T;

    /**
     * @default 'If you need more rooms, we can set that up for you.'
     */
    tKg0i: T;

    /**
     * @default 'Talk to our team'
     */
    QEN0V: T;

    /**
     * @default 'Hi! My event has reached its instant room block limit. Can you help me set up another room block?'
     */
    BPsXW: T;

    /**
     * @default 'Request a traditional block'
     */
    Aq1s9: T;

    /**
     * @default 'Rooms near your venue at a group rate. No deposits. No minimum spend.'
     */
    '6fgMW': T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default '{{0}} of {{1}} rooms booked · Book by {{2}}'
     */
    FyYxU: T;

    /**
     * @default 'Reserving rooms'
     */
    XxqzQ: T;

    /**
     * @default 'Needs your answer'
     */
    '6sLsw': T;

    /**
     * @default 'Open for guests'
     */
    qFH3J: T;

    /**
     * @default 'Booking window ended'
     */
    '7rx7Z': T;

    /**
     * @default 'Closing'
     */
    BxoIv: T;

    /**
     * @default 'Closed'
     */
    CcAEp: T;

    /**
     * @default 'Not created'
     */
    fhTwK: T;

    /**
     * @default 'Offer declined'
     */
    '0BkVP': T;

    /**
     * @default 'Offer expired'
     */
    T0sRl: T;

    /**
     * @default 'Something went wrong. Please try again in a moment.'
     */
    glY2l: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Instant room blocks'
     */
    qdBdB: T;

    /**
     * @default 'We couldn't load your room blocks. Please try again.'
     */
    zy1t4: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Step {{0}} of {{1}}'
     */
    sXRsT: T;

    /**
     * @default '{{0}}/{{1}}'
     */
    yVyMQ: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Why we ask for a card'
     */
    BgtM2: T;

    /**
     * @default 'We’re reserving real hotel rooms in your name, so we need to know a real person is behind the request - like a restaurant holding your table.'
     */
    qKVJd: T;

    /**
     * @default 'The small hold, under a dollar, only confirms the card is live. It’s released within a few days and never becomes a charge.'
     */
    fdYxv: T;

    /**
     * @default 'Your card is never used for the rooms - not now, not at the wedding, not after.'
     */
    Q9hHz: T;

    /**
     * @default 'Charged to your card'
     */
    U7RfF: T;

    /**
     * @default '$0'
     */
    '6TAAA': T;

    /**
     * @default 'I accept the reserved rate of {{0}} a night ({{1}} per room incl. taxes & fees, {{2}}). Guests can book until {{3}}; any rooms still unbooked go back to the hotel on {{4}} at no cost to me.'
     */
    PldMm: T;

    /**
     * @default 'We couldn't load the card check. Please try again.'
     */
    '45t6G': T;

    /**
     * @default 'No card check this time – yours is already verified.'
     */
    f0ZK2: T;

    /**
     * @default 'Card confirmed'
     */
    '3ZzkA': T;

    /**
     * @default 'Never charged · a small temporary hold, under a dollar, released within a few days'
     */
    aC3FC: T;

    /**
     * @default 'Handled by our payment provider - your full card number never reaches Joy.'
     */
    JHDoH: T;

    /**
     * @default 'One quick card check'
     */
    Jn3GB: T;

    /**
     * @default 'No charge. The hold clears in a few days.'
     */
    sCOgp: T;

    /**
     * @default 'Reserve {{0}} Rooms'
     */
    SRzGE: T;

    /**
     * @default 'Card details'
     */
    WHED6: T;

    /**
     * @default 'The hotel’s rate moved while you were setting this up. The final held rate is {{0}} per night – {{1}} when you started.'
     */
    j2NkB: T;

    /**
     * @default 'Please accept to continue'
     */
    At7eH: T;

    /**
     * @default 'We couldn't load your room blocks.'
     */
    enLjB: T;

    /**
     * @default 'Fill in the first name, last name and email the rooms are held under.'
     */
    UVRhl: T;

    /**
     * @default 'Something didn't load. Press Try Again on the page, then reserve.'
     */
    uegsB: T;

    /**
     * @default 'Still getting things ready. Try again in a moment.'
     */
    v2jSk: T;

    /**
     * @default 'Enter your card details to continue.'
     */
    ljvrG: T;

    /**
     * @default 'We couldn't load the card form. Please try again.'
     */
    kIjKB: T;

    /**
     * @default 'Rooms will be held under'
     */
    C0swC: T;

    /**
     * @default 'First name'
     */
    heZ8G: T;

    /**
     * @default 'Last name'
     */
    hAZ8J: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Room blocks available'
     */
    QucN2: T;

    /**
     * @default 'Get a room block at {{0}}'
     */
    acrsp: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Your dates changed, so pick your hotel again.'
     */
    q5Ycs: T;

    /**
     * @default 'Rated 8+'
     */
    Z3qsA: T;

    /**
     * @default 'Free parking'
     */
    aaE9G: T;

    /**
     * @default 'Where should your guests stay?'
     */
    IwRNx: T;

    /**
     * @default 'Distance from Venue'
     */
    iAI0q: T;

    /**
     * @default 'Price, low to high'
     */
    kkWQ0: T;

    /**
     * @default 'Biggest Discount'
     */
    e8m24: T;

    /**
     * @default 'Guest Rating'
     */
    XZAT2: T;

    /**
     * @default 'Distance'
     */
    '3I584': T;

    /**
     * @default 'Price'
     */
    '7WvrG': T;

    /**
     * @default 'Discount'
     */
    '1Ydo3': T;

    /**
     * @default 'Rating'
     */
    RWG5R: T;

    /**
     * @default 'Room block available'
     */
    btENq: T;

    /**
     * @default 'Room blocks not available'
     */
    DRFb7: T;

    /**
     * @default 'Couldn't check this hotel'
     */
    w3Ob5: T;

    /**
     * @default 'per night'
     */
    dCADS: T;

    /**
     * @default 'Selected'
     */
    '5gqDQ': T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Congrats, your room block is ready!'
     */
    gtKpN: T;

    /**
     * @default 'We’ve added it to your Accommodations page.'
     */
    fPryP: T;

    /**
     * @default 'View Page'
     */
    wadzU: T;

    /**
     * @default 'What’s next?'
     */
    kPYVi: T;

    /**
     * @default 'Tell your friends and family'
     */
    G3I1R: T;

    /**
     * @default 'Now'
     */
    CFXAA: T;

    /**
     * @default 'Send your booking link by text or email, or copy it and share it yourself.'
     */
    '8gl33': T;

    /**
     * @default 'Send a message blast'
     */
    QL5Tq: T;

    /**
     * @default 'Copy the booking link'
     */
    bsYMZ: T;

    /**
     * @default 'Guests book their rooms'
     */
    '8ZMhQ': T;

    /**
     * @default 'Until {{0}}'
     */
    KlXAB: T;

    /**
     * @default 'You’ll see each booking in Bookings as it comes in. We’ll nudge anyone who hasn’t booked.'
     */
    '6WaGF': T;

    /**
     * @default 'Add a second hotel'
     */
    CmVZG: T;

    /**
     * @default 'If it fills up'
     */
    '1t0SH': T;

    /**
     * @default 'Same few minutes. We won’t ask for your card again.'
     */
    zhvpj: T;

    /**
     * @default 'Pick Another Hotel'
     */
    '86PwN': T;

    /**
     * @default 'Anything unbooked goes back to the hotel on {{0}}. You’re never billed for an empty room.'
     */
    IOQCz: T;

    /**
     * @default '{{0}} · 1 night'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} · 1 night
     * - plural: {{0}} · {{1}} nights
     */
    roNVO: T;

    /**
     * @default '1 room'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room
     * - plural: {{0}} rooms
     */
    UzoYX: T;

    /**
     * @default '{{0}} · {{1}} from venue'
     */
    dX8KK: T;

    /**
     * @default '{{0}} from venue'
     */
    XmNNS: T;

    /**
     * @default 'per night · group rate'
     */
    LxIRH: T;

    /**
     * @default 'Taxes & fees {{0}}'
     */
    uKV4S: T;

    /**
     * @default 'Mandatory {{0}} (Due at property) {{1}}'
     */
    ZoIgT: T;

    /**
     * @default '{{0}} {{1}} · {{2}} review'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} {{1}} · {{2}} review
     * - plural: {{0}} {{1}} · {{2}} reviews
     */
    BTgKM: T;

    /**
     * @default '{{0}} · {{1}} review'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} · {{1}} review
     * - plural: {{0}} · {{1}} reviews
     */
    '3y7LS': T;

    /**
     * @default 'Check in from {{0}} · Check out by {{1}}'
     */
    eagjI: T;

    /**
     * @default 'Check in from {{0}} · Check out from {{1}}'
     */
    pFTky: T;

    /**
     * @default 'Check in from {{0}}'
     */
    vJBhd: T;

    /**
     * @default 'Check out by {{0}}'
     */
    x42jj: T;

    /**
     * @default 'Check out from {{0}}'
     */
    E9g0o: T;

    /**
     * @default 'We couldn’t load this hotel. Please try again.'
     */
    fk8KA: T;

    /**
     * @default 'Amenities'
     */
    Zz3IV: T;

    /**
     * @default 'Hotel details'
     */
    '4jaPQ': T;

    /**
     * @default 'Your book by date is {{0}}. Unbooked rooms will be released back to the hotel after the book by date.'
     */
    iycuw: T;

    /**
     * @default 'Your book by date was {{0}}. Unbooked rooms go back to the hotel on {{1}}.'
     */
    AjRZ5: T;

    /**
     * @default 'Your book by date was {{0}}. Unbooked rooms were released back to the hotel after the book by date.'
     */
    dOwK5: T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default '{{0}} · Released'
     */
    ibK9N: T;

    /**
     * @default '{{0}} · Available'
     */
    Wxduc: T;

    /**
     * @default '{{0}} just booked Room {{1}} · {{2}}'
     */
    NoNQU: T;

    /**
     * @default '{{0}} just booked Room {{1}}'
     */
    O97x2: T;

    /**
     * @default 'Still available'
     */
    vn0DH: T;

    /**
     * @default 'Booked'
     */
    wyqom: T;

    /**
     * @default 'Released'
     */
    JAjIR: T;

    /**
     * @default 'Share with Guests'
     */
    otZHN: T;

    /**
     * @default 'Link Copied'
     */
    oxFZd: T;

    /**
     * @default 'Copy Room Block Link'
     */
    tglOC: T;

    /**
     * @default 'Release Unbooked Rooms'
     */
    o04T0: T;

    /**
     * @default 'Try Another Hotel'
     */
    qhndx: T;

    /**
     * @default 'View Hotel'
     */
    VnGJE: T;

    /**
     * @default 'Room block link'
     */
    odQhZ: T;

    /**
     * @default 'Copy the room block link'
     */
    GiIcT: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Invite More Guests'
     */
    NcsLj: T;

    /**
     * @default 'Instant Room Block'
     */
    DbJ94: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'We couldn’t load this room block. Please try again.'
     */
    bc29z: T;

    /**
     * @default 'Your room block'
     */
    j6EFM: T;

    /**
     * @default 'I’ll do this later'
     */
    ndUGP: T;

    /**
     * @default 'Send Reminder'
     */
    '2juHR': T;

    /**
     * @default 'Keep 1 Room'
     * @param {number} count - The number of occurrences.
     * - singular: Keep 1 Room
     * - plural: Keep {{0}} Rooms
     */
    u5NdY: T;

    /**
     * @default 'Only {{0}} of the {{1}} rooms you asked for could be reserved at {{2}}. Keep the {{3}}-room block?'
     */
    j1dXe: T;

    /**
     * @default 'The offer has expired'
     */
    Wj0KT: T;

    /**
     * @default 'Answer within {{0}}'
     */
    BbktR: T;

    /**
     * @default 'Release Them'
     */
    JlKVR: T;

    /**
     * @default 'Booked {{0}}'
     */
    '8yH4S': T;

    /**
     * @default 'Invite a Guest'
     */
    A0gYS: T;

    /**
     * @default 'Joy reference'
     */
    FgRd6: T;

    /**
     * @default 'Showing {{0}} of 1 room'
     * @param {number} count - The number of occurrences.
     * - singular: Showing {{0}} of 1 room
     * - plural: Showing {{0}} of {{1}} rooms
     */
    '95ttF': T;

    /**
     * @default 'Rooms'
     */
    gIS1G: T;

    /**
     * @default 'Room'
     */
    FC3MA: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Phone'
     */
    '4pRqG': T;

    /**
     * @default 'Confirmation'
     */
    FAtsR: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Latest activity'
     */
    Mbvpv: T;

    /**
     * @default 'Your 1 room is booked'
     * @param {number} count - The number of occurrences.
     * - singular: Your 1 room is booked
     * - plural: All {{0}} rooms are booked
     */
    Oqm8B: T;

    /**
     * @default '1 room ready for your guests'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room ready for your guests
     * - plural: {{0}} rooms ready for your guests
     */
    a2NT0: T;

    /**
     * @default '1 room left for your guests'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room left for your guests
     * - plural: {{0}} rooms left for your guests
     */
    '0Btkf': T;

    /**
     * @default 'The other 1 goes back to the hotel on {{0}}.'
     * @param {number} count - The number of occurrences.
     * - singular: The other 1 goes back to the hotel on {{0}}.
     * - plural: The other {{0}} go back to the hotel on {{1}}.
     */
    IgBH8: T;

    /**
     * @default 'Your 1 room went back to the hotel.'
     * @param {number} count - The number of occurrences.
     * - singular: Your 1 room went back to the hotel.
     * - plural: All {{0}} rooms went back to the hotel.
     */
    CTvjO: T;

    /**
     * @default '1 room booked.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room booked.
     * - plural: {{0}} rooms booked.
     */
    SSlWR: T;

    /**
     * @default '{{0}} of 1 room booked'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} of 1 room booked
     * - plural: {{0}} of {{1}} rooms booked
     */
    LBU3D: T;

    /**
     * @default '1 room goes back'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room goes back
     * - plural: {{0}} rooms go back
     */
    abavr: T;

    /**
     * @default '1 room released'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room released
     * - plural: {{0}} rooms released
     */
    UKoJL: T;

    /**
     * @default '1 night'
     * @param {number} count - The number of occurrences.
     * - singular: 1 night
     * - plural: {{0}} nights
     */
    MwVDX: T;

    /**
     * @default '1 of {{0}} rooms booked. 1 room left at your group rate.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 of {{0}} rooms booked. 1 room left at your group rate.
     * - plural: 1 of {{0}} rooms booked. {{1}} rooms left at your group rate.
     */
    LGH88: T;

    /**
     * @default 'Your guests are booking. 1 room left at your group rate.'
     * @param {number} count - The number of occurrences.
     * - singular: Your guests are booking. 1 room left at your group rate.
     * - plural: Your guests are booking. {{0}} rooms left at your group rate.
     */
    wCU2H: T;

    /**
     * @default 'Your 1 room has a guest.'
     * @param {number} count - The number of occurrences.
     * - singular: Your 1 room has a guest.
     * - plural: All {{0}} rooms have a guest.
     */
    '8a5B9': T;

    /**
     * @default 'Booking closed {{0}}. 1 room goes back to the hotel on {{1}}.'
     * @param {number} count - The number of occurrences.
     * - singular: Booking closed {{0}}. 1 room goes back to the hotel on {{1}}.
     * - plural: Booking closed {{0}}. {{1}} rooms go back to the hotel on {{2}}.
     */
    YkivY: T;

    /**
     * @default '1 unbooked room is going back to the hotel.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 unbooked room is going back to the hotel.
     * - plural: {{0}} unbooked rooms are going back to the hotel.
     */
    cHsVj: T;

    /**
     * @default 'Reserving your rooms'
     */
    '2pkKH': T;

    /**
     * @default 'This takes about a minute. You can leave this page.'
     */
    '78gbG': T;

    /**
     * @default 'Every room in your block has a guest.'
     */
    Qo1JU: T;

    /**
     * @default 'They can book until {{0}}. Unbooked rooms go back to the hotel on {{1}}.'
     */
    ZZ9Mv: T;

    /**
     * @default 'Booking closed with {{0}} of {{1}} rooms booked'
     */
    hwWWz: T;

    /**
     * @default 'Closing your room block'
     */
    a098I: T;

    /**
     * @default 'Rooms nobody booked are being released. Rooms your guests booked are unaffected.'
     */
    EA3ZL: T;

    /**
     * @default 'None of your guests booked a room'
     */
    f9nkk: T;

    /**
     * @default 'Your room block is finalized'
     */
    HpbhJ: T;

    /**
     * @default '{{0}} went back to the hotel.'
     */
    VOFG8: T;

    /**
     * @default 'This room block could not be created'
     */
    J9k5v: T;

    /**
     * @default 'No rooms are held.'
     */
    '8IJ2n': T;

    /**
     * @default 'You released this room block'
     */
    Wu2Ok: T;

    /**
     * @default 'Only {{0}} of {{1}} rooms could be reserved, and you chose not to keep them. No rooms are held.'
     */
    LnrGO: T;

    /**
     * @default 'This offer expired'
     */
    X68ja: T;

    /**
     * @default 'Only {{0}} of {{1}} rooms could be reserved, and the offer was not answered in time. No rooms are held.'
     */
    JKNp1: T;

    /**
     * @default '{{0}} · Book by {{1}} · Unbooked rooms go back to the hotel on {{2}}.'
     */
    QA2v8: T;

    /**
     * @default '{{0}} · Booking closed {{1}} · {{2}} on {{3}}.'
     */
    '4hVzb': T;

    /**
     * @default '{{0}} · All {{1}} rooms released.'
     */
    Y6MoU: T;

    /**
     * @default 'Your room block is ready. Share it so guests can start booking.'
     */
    k9AIR: T;

    /**
     * @default 'Your first guest just booked!'
     */
    y0Iqe: T;

    /**
     * @default 'Every room is booked!'
     */
    FwzzK: T;

    /**
     * @default 'Your room block is finalized.'
     */
    f8Czu: T;

    /**
     * @default 'None of your guests booked a room.'
     */
    '97S0s': T;

    /**
     * @default 'Reserving'
     */
    RAxEQ: T;

    /**
     * @default 'Booking with the hotel'
     */
    '8rTMn': T;

    /**
     * @default 'Available'
     */
    d8nEm: T;

    /**
     * @default 'Reserved'
     */
    oGlsj: T;

    /**
     * @default 'Reserved by Joy'
     */
    lgA72: T;

    /**
     * @default 'Booking in progress'
     */
    n1kJP: T;

    /**
     * @default 'A guest is booking this room'
     */
    ZTyxJ: T;

    /**
     * @default 'Cancelled'
     */
    JVlxD: T;

    /**
     * @default 'Not held'
     */
    oLDeA: T;

    /**
     * @default 'Guest cancelled'
     */
    xVzUz: T;

    /**
     * @default 'Cancelled by the guest'
     */
    bQ77Z: T;

    /**
     * @default 'Sending name to hotel'
     */
    OHOMH: T;

    /**
     * @default 'The 1 room we reserved will be released, and no rooms will be held.'
     * @param {number} count - The number of occurrences.
     * - singular: The 1 room we reserved will be released, and no rooms will be held.
     * - plural: The {{0}} rooms we reserved will be released, and no rooms will be held.
     */
    WzZnh: T;

    /**
     * @default 'The 1 room no one has booked will go back to the hotel. Rooms your guests already booked stay booked.'
     * @param {number} count - The number of occurrences.
     * - singular: The 1 room no one has booked will go back to the hotel. Rooms your guests already booked stay booked.
     * - plural: The {{0}} rooms no one has booked will go back to the hotel. Rooms your guests already booked stay booked.
     */
    cNRD3: T;

    /**
     * @default 'Release 1 Room'
     * @param {number} count - The number of occurrences.
     * - singular: Release 1 Room
     * - plural: Release {{0}} Rooms
     */
    WXGEa: T;

    /**
     * @default '1 room your guests keep'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room your guests keep
     * - plural: {{0}} rooms your guests keep
     */
    '2DpXG': T;

    /**
     * @default 'We couldn’t refresh this room block. Reload the page to see the latest.'
     */
    SNXbe: T;

    /**
     * @default 'We couldn’t keep these rooms. Please try again.'
     */
    '7XJSZ': T;

    /**
     * @default 'Release these rooms?'
     */
    nDgzA: T;

    /**
     * @default 'Keep Block'
     */
    '0w59k': T;

    /**
     * @default 'We couldn’t release these rooms. Please try again.'
     */
    '1uv39': T;

    /**
     * @default 'Release unbooked rooms?'
     */
    rwlf0: T;

    /**
     * @default 'Keep Rooms'
     */
    THASm: T;

    /**
     * @default 'We couldn’t release the unbooked rooms. Please try again.'
     */
    '0aNhk': T;

    /**
     * @default 'Room block closed. {{0}}, {{1}}.'
     */
    fQNZW: T;

    /**
     * @default 'Room block link copied.'
     */
    iDLIr: T;

    /**
     * @default 'We couldn’t copy the link. Please copy it from the page.'
     */
    kGIS9: T;

    /**
     * @default 'Group rates, already negotiated.'
     */
    '0sKbi': T;

    /**
     * @default '$0 charged, no calls, no contract.'
     */
    pNUaK: T;

    /**
     * @default 'Maybe Later'
     */
    Eb0Nh: T;

    /**
     * @default 'Get my room block'
     */
    '4FGnw': T;

    /**
     * @default 'Hi! My event is on {{0}}, less than 30 days away. Can you help me set up a room block?'
     */
    Ghhg3: T;

    /**
     * @default 'Hi! My event is less than 30 days away. Can you help me set up a room block?'
     */
    VrUuN: T;

    /**
     * @default 'This event has reached its room block limit.'
     */
    d9bjv: T;

    /**
     * @default 'A room block,
in minutes.'
*/
    ftRwu: T;

    /**
     * @default 'Find a hotel'
     */
    E9T5l: T;

    /**
     * @default 'Pick how many rooms'
     */
    sZKVA: T;

    /**
     * @default 'Guests book'
     */
    UD0zq: T;

    /**
     * @default 'At your group rate'
     */
    HRSAT: T;

    /**
     * @default 'The rest goes back'
     */
    uinJs: T;

    /**
     * @default 'On your release date, free'
     */
    LRIQD: T;

    /**
     * @default 'Instant Room Blocks isn't available for this event yet.'
     */
    DIoeK: T;

    /**
     * @default 'If you need a room block, we can set that up for you.'
     */
    '9zuIN': T;

    /**
     * @default 'Hi! Instant Room Blocks isn't available for my event yet. Can you help me set up a room block?'
     */
    YF0BP: T;

    /**
     * @default 'Instant room blocks need at least 30 days before your event'
     */
    Q5Sho: T;

    /**
     * @default 'Your room blocks'
     */
    aAYCu: T;

    /**
     * @default 'Reserving your rooms…'
     */
    cz5Sd: T;

    /**
     * @default 'This can take up to a minute.'
     */
    Iceyy: T;

    /**
     * @default 'Hi! I tried to reserve {{0}} rooms at {{1}} for {{2}}, but it didn’t go through. Can you help?'
     */
    bLYTh: T;

    /**
     * @default 'Hi! I tried to reserve a room block, but it didn’t go through. Can you help?'
     */
    JvhBh: T;

    /**
     * @default 'You’ve reached the room block limit.'
     */
    fmwmJ: T;

    /**
     * @default 'No rooms were reserved, and nothing was charged.'
     */
    pIL5C: T;

    /**
     * @default 'See Your Room Blocks'
     */
    RjdZv: T;

    /**
     * @default 'You’ve reserved the most rooms for today.'
     */
    fM5kR: T;

    /**
     * @default 'Try again tomorrow. No rooms were reserved, and nothing was charged.'
     */
    HewHi: T;

    /**
     * @default 'Your card was declined.'
     */
    oBxuW: T;

    /**
     * @default 'No rooms were reserved. Chat with our concierge team to use another card.'
     */
    bOw2J: T;

    /**
     * @default 'Your bank didn’t confirm this card.'
     */
    NOpMT: T;

    /**
     * @default 'No rooms were reserved. Try again, or chat with our concierge team.'
     */
    suu1J: T;

    /**
     * @default 'This hotel’s rate just changed.'
     */
    ADkyt: T;

    /**
     * @default 'It can’t be held as a room block anymore. No rooms were reserved, and nothing was charged.'
     */
    xH4Gz: T;

    /**
     * @default 'The hotel couldn’t hold these rooms.'
     */
    JmsuF: T;

    /**
     * @default 'The hotel is busy right now, and nothing was charged. Try again in a few minutes.'
     */
    tlrVB: T;

    /**
     * @default 'We couldn’t confirm your rooms.'
     */
    f3QRw: T;

    /**
     * @default 'We could not confirm whether your rooms were reserved. Check your room blocks before trying again.'
     */
    '38oeS': T;

    /**
     * @default 'Your card needs another check.'
     */
    '3nvSU': T;

    /**
     * @default 'We couldn’t find a saved card for this event. Check your card again to reserve the rooms.'
     */
    X5jyN: T;

    /**
     * @default 'Check Your Card'
     */
    '17q6J': T;

    /**
     * @default 'The dates have changed.'
     */
    gfbKt: T;

    /**
     * @default 'The book-by and release dates for these rooms have changed. Check the room count again to get the hotel’s current offer.'
     */
    tecTF: T;

    /**
     * @default 'Check the Room Count Again'
     */
    '3rZK9': T;

    /**
     * @default 'Instant room blocks aren’t available right now.'
     */
    ocmRj: T;

    /**
     * @default 'No rooms were reserved and your card wasn’t charged.'
     */
    es68h: T;

    /**
     * @default 'Back to Hotels'
     */
    '7aBDR': T;

    /**
     * @default 'There’s nothing to reserve here.'
     */
    iXYrR: T;

    /**
     * @default 'Your room blocks show every block you’ve reserved.'
     */
    '8YFka': T;

    /**
     * @default 'Something went wrong.'
     */
    NF7BG: T;

    /**
     * @default 'We couldn’t reserve your rooms. Check your room blocks before trying again.'
     */
    xwfus: T;

    /**
     * @default 'One room fewer'
     */
    G1LiA: T;

    /**
     * @default 'Number of rooms'
     */
    YZCOR: T;

    /**
     * @default 'One room more'
     */
    '2krxk': T;

    /**
     * @default 'Check in'
     */
    '5cfjP': T;

    /**
     * @default 'Check out'
     */
    OY43P: T;

    /**
     * @default 'How many rooms would you like to block?'
     */
    HBWEB: T;

    /**
     * @default 'Your rooms will be held for your guests until {{0}}.'
     */
    wPlUM: T;

    /**
     * @default 'You pay nothing to reserve them.'
     */
    xSXOq: T;

    /**
     * @default 'Continue with {{0}} rooms'
     */
    N4d0c: T;

    /**
     * @default '{{0}} · {{1}} · {{2}} per night'
     */
    '8FaxA': T;

    /**
     * @default '{{0}} · {{1}}'
     */
    UsBX1: T;

    /**
     * @default 'Change Dates'
     */
    D8Rfc: T;

    /**
     * @default '{{0}}–{{1}} rooms'
     */
    Oj7Yr: T;

    /**
     * @default 'Use {{0}} Rooms'
     */
    Dtpwx: T;

    /**
     * @default 'Hi! I'd like a room block of more than {{0}} rooms at {{1}} for {{2}}. Can you check availability for me?'
     */
    gKgnZ: T;

    /**
     * @default 'Hi! I'd like a room block of {{0}} rooms at {{1}} for {{2}}. That's more than the {{3}} I can set up instantly. Can you check availability for me?'
     */
    lN4vE: T;

    /**
     * @default 'Need more than {{0}} rooms? Request a larger block and we’ll confirm availability for you.'
     */
    eoOis: T;

    /**
     * @default 'Request a Larger Block'
     */
    oJNF1: T;

    /**
     * @default 'Blocks this size are set up with our concierge team. Reach out and we’ll help you lock it in.'
     */
    soAu9: T;

    /**
     * @default 'Checking the rate for {{0}} rooms…'
     */
    QHX5F: T;

    /**
     * @default 'Checking the rate…'
     */
    lBFl2: T;

    /**
     * @default 'We couldn't check this hotel right now.'
     */
    '8TWUI': T;

    /**
     * @default 'This is on our side. Give it another try.'
     */
    wCdo2: T;

    /**
     * @default 'Try again to continue.'
     */
    fdCLM: T;

    /**
     * @default 'This hotel can't hold {{0}} rooms for your dates.'
     */
    f7TnJ: T;

    /**
     * @default 'Try fewer rooms, or pick another hotel.'
     */
    '5PdBV': T;

    /**
     * @default 'Use fewer rooms to continue.'
     */
    GlSdv: T;

    /**
     * @default 'Only {{0}} rooms are available here for your dates.'
     */
    cKzui: T;

    /**
     * @default 'Block those {{0}}, or pick another hotel.'
     */
    XpSgd: T;

    /**
     * @default 'Use {{0}} rooms to continue.'
     */
    rwc14: T;

    /**
     * @default 'This hotel is sold out for your dates.'
     */
    TAN3o: T;

    /**
     * @default 'Try different dates, or pick another hotel.'
     */
    yUFrV: T;

    /**
     * @default 'Pick another hotel to continue.'
     */
    WENrS: T;

    /**
     * @default 'This hotel can't hold rooms until {{0}}.'
     */
    awKqq: T;

    /**
     * @default 'Its free cancellation ends too soon for a room block.'
     */
    eHG4F: T;

    /**
     * @default 'Room blocks aren't available at this hotel.'
     */
    aTmHk: T;

    /**
     * @default 'Pick another hotel near your venue.'
     */
    gdBYh: T;

    /**
     * @default 'Blocks this size are set up with our concierge team.'
     */
    QMUpJ: T;

    /**
     * @default 'Reach out and we’ll help you lock it in.'
     */
    qX0II: T;

    /**
     * @default 'Pick another hotel, or get started with concierge.'
     */
    pAM7L: T;
  };
};

export type InstantRoomBlocksGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'The room block booking window has ended'
     */
    ANW9l: T;

    /**
     * @default 'Room block fully booked'
     */
    mfAqN: T;

    /**
     * @default 'This room block is closed'
     */
    MtrTD: T;

    /**
     * @default 'Guests pay {{0}} total per room{{1}}1 night incl. taxes, fees & property charges'
     * @param {number} count - The number of occurrences.
     * - singular: Guests pay {{0}} total per room{{1}}1 night incl. taxes, fees & property charges
     * - plural: Guests pay {{0}} total per room{{1}}{{2}} nights incl. taxes, fees & property charges
     */
    MvaS5: T;

    /**
     * @default 'Guests pay {{0}} total per room{{1}}1 night incl. taxes & fees'
     * @param {number} count - The number of occurrences.
     * - singular: Guests pay {{0}} total per room{{1}}1 night incl. taxes & fees
     * - plural: Guests pay {{0}} total per room{{1}}{{2}} nights incl. taxes & fees
     */
    MZaJM: T;

    /**
     * @default '{{0}} total{{1}}1 night incl. taxes, fees & property charges'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} total{{1}}1 night incl. taxes, fees & property charges
     * - plural: {{0}} total{{1}}{{2}} nights incl. taxes, fees & property charges
     */
    iZt6X: T;

    /**
     * @default '{{0}} total{{1}}1 night incl. taxes & fees'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} total{{1}}1 night incl. taxes & fees
     * - plural: {{0}} total{{1}}{{2}} nights incl. taxes & fees
     */
    aNEPL: T;

    /**
     * @default 'This room block isn't available right now.'
     */
    a0Vkw: T;

    /**
     * @default 'Continue Your Payment'
     */
    Os1ZV: T;

    /**
     * @default 'We couldn't load this room block. Please try again.'
     */
    Xhb6C: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Group Rate · Save {{0}}%'
     */
    '2b7tY': T;

    /**
     * @default 'Group Rate'
     */
    '7rn7p': T;

    /**
     * @default 'Those rooms were just taken'
     */
    NJDZE: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default '1 room left'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room left
     * - plural: {{0}} rooms left
     */
    mZaR4: T;

    /**
     * @default 'from'
     */
    W14PA: T;

    /**
     * @default '/ night'
     */
    bjrXI: T;

    /**
     * @default 'The group rate covers {{0}}.'
     */
    ET3wM: T;

    /**
     * @default 'Book by {{0}}'
     */
    UPWp6: T;

    /**
     * @default '{{0}}'s room block'
     */
    wJDdS: T;

    /**
     * @default '{{0}} · 1 night'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} · 1 night
     * - plural: {{0}} · {{1}} nights
     */
    roNVO: T;

    /**
     * @default 'Only rooms in {{0}}'s room block are shown.'
     */
    KxKMr: T;

    /**
     * @default 'Free cancellation until {{0}}'
     */
    LyR4f: T;

    /**
     * @default 'Room Policy'
     */
    fzx8H: T;

    /**
     * @default 'Last room in the block'
     * @param {number} count - The number of occurrences.
     * - singular: Last room in the block
     * - plural: {{0}} left in the block
     */
    KIgV9: T;

    /**
     * @default 'Sleeps {{0}}'
     */
    GfxyH: T;

    /**
     * @default 'Continue Booking'
     */
    UnMpG: T;

    /**
     * @default 'Your room is held for you'
     */
    pSZOZ: T;

    /**
     * @default 'Fully Booked'
     */
    WvuAf: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default 'Non-Refundable'
     */
    ocyBM: T;

    /**
     * @default 'View Policy'
     */
    vI7Wj: T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default 'See all rooms at this hotel'
     */
    '3uDHi': T;

    /**
     * @default 'Need other dates or more nights? {{0}} (regular rates).'
     */
    jU7x4: T;

    /**
     * @default 'Choose a Room'
     */
    '3qXcW': T;

    /**
     * @default '(1 Adult)'
     * @param {number} count - The number of occurrences.
     * - singular: (1 Adult)
     * - plural: ({{0}} Adults)
     */
    umqOM: T;

    /**
     * @default 'Room block by {{0}}'
     */
    NtetI: T;

    /**
     * @default '{{0}} per night'
     */
    '5Wdad': T;

    /**
     * @default 'You save {{0}} with the group rate'
     */
    CYEEQ: T;

    /**
     * @default 'Payments are processed securely by Stripe.'
     */
    '1O5ir': T;

    /**
     * @default '1 night'
     * @param {number} count - The number of occurrences.
     * - singular: 1 night
     * - plural: {{0}} nights
     */
    MwVDX: T;

    /**
     * @default '1 room remaining'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room remaining
     * - plural: {{0}} rooms remaining
     */
    '6O7XK': T;

    /**
     * @default 'the hotel'
     */
    bt3yH: T;

    /**
     * @default 'You can still find a room at {{0}}'
     */
    PYpbK: T;

    /**
     * @default 'You can still find a room at the hotel'
     */
    G9z0P: T;

    /**
     * @default 'Our room block'
     */
    mQGmt: T;

    /**
     * @default 'Book Room'
     */
    uDWri: T;
  };
};

export type JoykitTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Back'
   */
  back: T;

  /**
   * @default 'Frequently Asked Questions'
   */
  frequentlyAskedQuestions: T;

  /**
   * @default 'Animated'
   */
  animated: T;

  /**
   * @default 'Congratulations! Your email has been verified!'
   */
  emailVerificationSuccess: T;

  drawer: {
    /**
     * @default 'Drawer'
     */
    rootLabel: T;

    /**
     * @default 'Close'
     */
    closeButtonLabel: T;
  };
  locationInput: {
    /**
     * @default 'Start typing to see options'
     */
    noOptionsMessage: T;
  };
  emailVerificationFailed: {
    /**
     * @default 'We're having trouble verifying your email address.'
     */
    title: T;

    /**
     * @default 'The attempt to verify your email didn't quite work. Please try again.'
     */
    description: T;

    /**
     * @default 'Resend Verification Email'
     */
    ctaLabel: T;
  };
  deleteDialog: {
    /**
     * @default 'Are you sure you want to delete this item?'
     */
    title: T;

    /**
     * @default 'This cannot be undone.'
     */
    message: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Delete'
     */
    deleteCta: T;
  };
  inviteAdmin: {
    /**
     * @default 'Add Collaborator'
     */
    addCollaborator: T;

    /**
     * @default 'Verify your email address to invite collaborators'
     */
    verifyYourEmail: T;

    /**
     * @default 'Owner'
     */
    owner: T;

    /**
     * @default 'Collaborators'
     */
    collaborators: T;

    /**
     * @default 'Pending Invites'
     */
    pendingInvites: T;

    /**
     * @default 'You'
     */
    you: T;

    /**
     * @default 'Transfer Ownership'
     */
    transferOwnership: T;

    /**
     * @default 'Resend Invite'
     */
    resendInvite: T;

    /**
     * @default 'Revoke Invite'
     */
    revokeInvite: T;

    /**
     * @default 'Done'
     */
    done: T;

    /**
     * @default 'First name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Email is required'
     */
    emailRequired: T;

    /**
     * @default 'Invalid email format'
     */
    invalidEmail: T;

    /**
     * @default 'Add Collaborator'
     */
    addAdminTitle: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Send Invite'
     */
    sendInvite: T;

    /**
     * @default 'First name'
     */
    firstNameAriaLabel: T;

    /**
     * @default 'First Name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last name'
     */
    lastNameAriaLabel: T;

    /**
     * @default 'Last Name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailAriaLabel: T;

    /**
     * @default 'name@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Revoke Invitation?'
     */
    revokeAdminInvitationTitle: T;

    /**
     * @default 'Are you sure you want to revoke <fullname/> admin privileges?'
     */
    revokeAdminMessage: T;

    /**
     * @default 'Revoke'
     */
    revoke: T;

    /**
     * @default 'Transfer'
     */
    transfer: T;

    /**
     * @default 'Transfer Ownership?'
     */
    transferOwnershipTitle: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to <fullname/>?'
     */
    transferOwnershipMessage: T;

    /**
     * @default 'You will no longer be the primary account owner and your account will be downgraded to an admin account for this event.'
     */
    transferOwnershipConfirmation: T;

    /**
     * @default 'Enter '{{confirmationWord}}' to Confirm'
     */
    transferOwnershipInputLabel: T;

    /**
     * @default 'Email verification is required.'
     */
    emailVerificationRequired: T;

    /**
     * @default 'Verify Email'
     */
    verifyEmail: T;

    /**
     * @default 'Transfer Account'
     */
    transferAccount: T;
  };
  deleteEvent: {
    /**
     * @default 'Are you sure you want to delete this event?'
     */
    title: T;

    /**
     * @default 'Permanently deleting your Joy event includes all event details, your website, admin dashboard, photos, and guests.'
     */
    message1: T;

    /**
     * @default 'If you would like to continue, please type ‘DELETE’ in the field below to permanently delete your event and all its associated information from Joy.'
     */
    message2: T;

    /**
     * @default 'This is an IRREVERSIBLE change.'
     */
    message3: T;

    /**
     * @default 'Enter ‘DELETE’ to Confirm'
     */
    inputTitle: T;

    /**
     * @default 'DELETE'
     */
    delete: T;

    /**
     * @default 'Delete My Joy Event'
     */
    deleteMyJoyEvent: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'We were unable to delete the event.'
     */
    deleteEventFailureMessage: T;
  };
  focusPointDialog: {
    /**
     * @default 'Edit Page Photo'
     */
    title: T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    note: T;

    /**
     * @default 'Delete'
     */
    delete: T;

    /**
     * @default 'Change'
     */
    change: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Photo settings updated successfully.'
     */
    photoSettingsUpdateSuccess: T;

    /**
     * @default 'Failed to update photo settings.'
     */
    photoSettingsUpdateFailure: T;

    /**
     * @default 'Photo has been deleted'
     */
    photoDeleteSuccess: T;

    /**
     * @default 'Failed to delete photo.'
     */
    photoDeleteError: T;

    /**
     * @default 'Replace Photo'
     */
    replacePhoto: T;

    /**
     * @default 'Photo Layout'
     */
    photoLayout: T;

    /**
     * @default 'Full Width Photo'
     */
    fullWidthPhoto: T;

    /**
     * @default 'Photo'
     */
    centeredPhoto: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    fullWidthCropNote: T;

    photoLayoutDropDown: {
      fullWidth: {
        /**
         * @default 'Screen Width Photo'
         */
        title: T;
      };
      centered: {
        /**
         * @default 'Photo'
         */
        title: T;
      };
      pageWidth: {
        /**
         * @default 'Page Width Photo'
         */
        title: T;
      };
    };
    cancelConfirmationDialog: {
      /**
       * @default 'Save Changes?'
       */
      title: T;

      /**
       * @default 'Would you like to save this photo and the settings selected to your website? '
       */
      content: T;

      /**
       * @default 'Discard Changes'
       */
      discardChanges: T;

      /**
       * @default 'Save'
       */
      save: T;
    };
  };
  inlineEditor: {
    /**
     * @default 'Content'
     */
    content: T;

    /**
     * @default 'Font Styles'
     */
    fontStyles: T;

    /**
     * @default 'Font Size'
     */
    fontSize: T;

    /**
     * @default 'Alignment'
     */
    alignement: T;

    /**
     * @default 'Photo'
     */
    photo: T;

    /**
     * @default 'Colors'
     */
    colors: T;

    /**
     * @default 'This page is public.'
     */
    pagePublic: T;

    /**
     * @default 'This page is password protected.'
     */
    pageProtected: T;

    /**
     * @default 'This page is hidden.'
     */
    pageHidden: T;

    /**
     * @default 'Edit Photo'
     */
    editPhoto: T;

    /**
     * @default 'Edit Monogram'
     */
    editMonogram: T;

    /**
     * @default 'Add Page Photo'
     */
    addPagePhoto: T;

    /**
     * @default 'Edit Color'
     */
    editColor: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Edit Content'
     */
    editContent: T;

    /**
     * @default 'Event info has been saved'
     */
    eventInfoUpdateSuccess: T;

    /**
     * @default 'Error updating event info. Please try again later.'
     */
    eventInfoUpdateError: T;

    /**
     * @default 'Display Name'
     */
    displayName: T;

    /**
     * @default 'Event Date'
     */
    eventDate: T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    invalidDate: T;

    /**
     * @default 'Greetings'
     */
    greetings: T;

    /**
     * @default 'Text should be {{max}} characters or less.'
     */
    maxCharacters: T;

    /**
     * @default 'Event Location'
     */
    eventLocation: T;

    /**
     * @default 'Buttons'
     */
    buttons: T;

    /**
     * @default 'Navigation'
     */
    navigation: T;

    /**
     * @default 'Powered by Google'
     */
    poweredBy: T;

    /**
     * @default 'Theme'
     */
    theme: T;

    /**
     * @default 'Page Settings'
     */
    pageSettings: T;

    /**
     * @default 'Graphic Accent'
     */
    graphicAccent: T;

    /**
     * @default 'Couple’s Name'
     */
    couplesName: T;

    /**
     * @default 'Customize Names'
     */
    customizeNames: T;

    type: {
      /**
       * @default 'Photo'
       */
      photo: T;

      /**
       * @default 'Monogram'
       */
      monogram: T;
    };
  };
  colorPalettePicker: {
    /**
     * @default 'Reset to default'
     */
    resetToDefault: T;
  };
  photoMenu: {
    /**
     * @default 'Update Photo'
     */
    update: T;

    /**
     * @default 'Reset to Default'
     */
    reset: T;

    /**
     * @default 'Delete Photo'
     */
    delete: T;
  };
  editEventUrl: {
    /**
     * @default 'Event URL'
     */
    eventUrl: T;

    /**
     * @default 'Joy Event URL'
     */
    joyEventURL: T;

    /**
     * @default 'Please Note:'
     */
    pleaseNote: T;

    /**
     * @default 'Your old Joy URL will no longer work - this means you'll need to let all your guests know the new address so they can still access your website. Please note that if you have a custom domain, you will also need to update your forwarding URL to point to this new Joy URL.'
     */
    eventUrlNote: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;
  };
  photoPicker: {
    /**
     * @default 'Choose Your Photo'
     */
    chooseYourPhoto: T;

    /**
     * @default 'All your photos will appear here.'
     */
    allYourPhotosWillAppearHere: T;

    /**
     * @default 'Upload Photos'
     */
    uploadPhotos: T;

    /**
     * @default 'Save Photo'
     */
    savePhoto: T;

    /**
     * @default 'Uploads'
     */
    uploads: T;

    /**
     * @default 'All Photos'
     */
    allPhotos: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    savePhotoError: T;

    /**
     * @default 'This album is currently hidden. Would you like to make it public?'
     */
    alertHiddenCollectionTitle: T;

    /**
     * @default 'This will allow your guests to view the photos from this album on your site.'
     */
    alertHiddenCollectionSubtitle: T;

    /**
     * @default 'Yes, Change to Public'
     */
    changeToPublicCTA: T;

    /**
     * @default 'No, Keep Private'
     */
    keepPrivateCTA: T;
  };
  hotelSuggestionDialog: {
    /**
     * @default 'Compare prices before you book.'
     */
    title: T;

    /**
     * @default 'You’re heading to an external site to view <HotelName/>.'
     */
    descriptionLine1: T;

    /**
     * @default 'You can also book this hotel through Joy - our exclusive rates for couples and guests often beat other sites.'
     */
    descriptionLine2: T;

    /**
     * @default 'Continue to External Site'
     */
    continueToExternalSite: T;

    /**
     * @default 'Check Rates on Joy'
     */
    checkRatesOnJoy: T;
  };
  pageNote: {
    /**
     * @default 'You can share a note with your guests here!'
     */
    defaultNote: T;

    /**
     * @default 'Page Note'
     */
    title: T;

    /**
     * @default 'Need some ideas? Use suggest and we'll write a message that Joy couples have found helpful.'
     */
    hint: T;

    tooltip: {
      /**
       * @default 'Tell Guests Why'
       */
      title: T;

      /**
       * @default 'Add a note for your guests — this will show on your Places to Stay page. It’s a great spot to share travel tips or booking details. Don’t forget to mention that guests should book here to get the group discount! Need help? Hit “Suggest” and we’ll write it for you with AI.'
       */
      content: T;
    };

    /**
     * @default 'Note to Guests'
     */
    noteLabel: T;

    /**
     * @default 'Suggest'
     */
    suggestion: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Save'
     */
    saveCta: T;
  };
  photoAdjustDialog: {
    /**
     * @default 'Crop Photo'
     */
    cropTitle: T;

    /**
     * @default 'Focus Point'
     */
    focusPointTitle: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    cropNote: T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    focusPointNote: T;
  };
  quick: {
    /**
     * @default 'Previous Month'
     */
    HMlg0: T;

    /**
     * @default 'Next Month'
     */
    '3VsVl': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Photo has been deleted'
     */
    XG519: T;

    /**
     * @default 'Failed to delete photo.'
     */
    VTRSR: T;

    /**
     * @default 'Edit Page Photo'
     */
    '3b7U6': T;

    /**
     * @default 'Photo settings updated successfully.'
     */
    t063A: T;

    /**
     * @default 'Failed to update photo settings.'
     */
    '4oJdX': T;

    /**
     * @default 'Unable to save page photo. Please try refreshing the page.'
     */
    '4CJHJ': T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    FG3cr: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Swap Photo'
     */
    LnQfM: T;

    /**
     * @default 'Adjust Photo'
     */
    HBowN: T;

    /**
     * @default 'Crop Photo'
     */
    EnCSr: T;

    /**
     * @default 'Remove Photo'
     */
    '064Tf': T;

    /**
     * @default 'The maximum number of photos have been selected for this header layout'
     */
    nWp59: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Default hotel image'
     */
    '8smrM': T;

    /**
     * @default '1 photo uploaded'
     * @param {number} count - The number of occurrences.
     * - singular: 1 photo uploaded
     * - plural: {{0}} photos uploaded
     */
    '6zWFR': T;

    /**
     * @default 'Something went wrong. Please refresh and try again.'
     */
    '8sZt7': T;

    /**
     * @default 'Upload failed'
     */
    '6yP3V': T;

    /**
     * @default 'Could not start upload'
     */
    byJEk: T;

    /**
     * @default 'Drag & drop your photos'
     */
    bH2oe: T;

    /**
     * @default 'or click to browse'
     */
    QmKcX: T;

    /**
     * @default 'Uploads'
     */
    '2NrCg': T;

    /**
     * @default 'Uploading…'
     */
    vVZ8O: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Single Photo'
     */
    k2lkI: T;

    /**
     * @default 'Multi-photo'
     */
    IJBtx: T;

    /**
     * @default 'Animated'
     */
    nET1O: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Monogram'
     */
    ggmVN: T;

    /**
     * @default 'Minimal'
     */
    dpfGp: T;

    /**
     * @default '{{0}} · {{1}}'
     */
    UsBX1: T;

    /**
     * @default 'Not helpful'
     */
    XptR9: T;

    /**
     * @default 'Very helpful'
     */
    uYANy: T;

    /**
     * @default 'Rate {{0}}'
     */
    a5XB1: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Browse Designs'
     */
    vQAeM: T;

    /**
     * @default '{{0}} guests'
     */
    nsjy1: T;

    /**
     * @default 'Event URL'
     */
    Ncub6: T;

    /**
     * @default 'Joy Event URL'
     */
    VfEw4: T;

    /**
     * @default 'Please Note:'
     */
    Mfx1e: T;

    /**
     * @default 'Your old Joy URL will no longer work - this means you'll need to let all your guests know the new address so they can still access your website. Please note that if you have a custom domain, you will also need to update your forwarding URL to point to this new Joy URL.'
     */
    ppeFI: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    EEF5U: T;

    /**
     * @default 'Event URL updated'
     */
    kkQyZ: T;

    /**
     * @default 'That URL is too short. Use at least {{0}} characters.'
     */
    rlsJx: T;

    /**
     * @default '{{0}} days'
     */
    vzIzE: T;

    /**
     * @default '{{0}} days {{1}} hrs'
     */
    PY6PD: T;

    /**
     * @default '{{0}} days {{1}} hrs {{2}} mins {{3}} secs'
     */
    RexSU: T;

    /**
     * @default '{{0}} days {{1}} hrs {{2}} mins'
     */
    kq8hO: T;

    /**
     * @default '{{0}} ago'
     */
    XkQ5Z: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Theme'
     */
    v2IAH: T;

    /**
     * @default 'Continue in the App'
     */
    YnvtC: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Select...'
     */
    S8Eo2: T;

    /**
     * @default 'Reorder'
     */
    hdbmf: T;

    /**
     * @default 'Drag items to reorder'
     */
    UvwqH: T;

    /**
     * @default 'Delete ({{0}})'
     */
    QqK6f: T;

    /**
     * @default 'Add Item'
     */
    IwKrO: T;

    /**
     * @default 'No items yet. Click "Add Item" to get started.'
     */
    LZMQi: T;

    /**
     * @default 'Drag to reorder'
     */
    UEgfY: T;

    /**
     * @default 'Select item {{0}}'
     */
    rYbZR: T;

    /**
     * @default 'Delete item {{0}}'
     */
    Mf5qU: T;

    /**
     * @default '{{0}} selected'
     */
    pGpPG: T;

    /**
     * @default 'Sheet'
     */
    '9SK5G': T;

    /**
     * @default 'Collapse sheet'
     */
    OF43s: T;

    /**
     * @default 'Expand sheet'
     */
    Fy2oG: T;

    /**
     * @default 'This page is public.'
     */
    YJ0JV: T;

    /**
     * @default 'This page is password protected.'
     */
    MuVlu: T;

    /**
     * @default 'This page is hidden.'
     */
    L8O8Q: T;

    /**
     * @default 'This page is shown to specific guests.'
     */
    eADBR: T;

    /**
     * @default 'Content'
     */
    '3MbA3': T;

    /**
     * @default 'Font Styles'
     */
    NVIxG: T;

    /**
     * @default 'Edit Photo'
     */
    syk52: T;

    /**
     * @default 'Edit Monogram'
     */
    QHDtW: T;

    /**
     * @default 'Edit Color'
     */
    '7r631': T;

    /**
     * @default 'Add Page Photo'
     */
    Qca8P: T;

    /**
     * @default 'Edit Video'
     */
    r9hZ3: T;

    /**
     * @default 'Close Dialog'
     */
    gtifn: T;

    /**
     * @default 'Couple's Name'
     */
    n226o: T;

    /**
     * @default 'Event Display Name'
     */
    rZqZK: T;

    /**
     * @default 'Left Aligned'
     */
    VL4Um: T;

    /**
     * @default 'Center Aligned'
     */
    VsYrl: T;

    /**
     * @default 'Right Aligned'
     */
    ohXmy: T;
  };
};

export type LanguagePickerV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select language...'
     */
    '8lP63': T;

    /**
     * @default 'Search languages...'
     */
    pDXnx: T;

    /**
     * @default 'No languages found.'
     */
    k5rSZ: T;

    /**
     * @default 'English (United States)'
     */
    WL26h: T;

    /**
     * @default 'English (United Kingdom)'
     */
    vdW8S: T;

    /**
     * @default 'English (Australia)'
     */
    BgEQj: T;

    /**
     * @default 'English (Canada)'
     */
    DISfD: T;

    /**
     * @default 'German (Germany)'
     */
    yob0B: T;

    /**
     * @default 'Spanish (Spain)'
     */
    Ab4hs: T;

    /**
     * @default 'Spanish (United States)'
     */
    Yuimt: T;

    /**
     * @default 'French (France)'
     */
    '6M1E2': T;

    /**
     * @default 'French (Canada)'
     */
    P8qgm: T;

    /**
     * @default 'Italian (Italy)'
     */
    KmAty: T;

    /**
     * @default 'Japanese (Japan)'
     */
    aq5NW: T;

    /**
     * @default 'Choose Language'
     */
    Z6KVm: T;

    /**
     * @default 'English (New Zealand)'
     */
    kSJej: T;

    /**
     * @default 'English (Ireland)'
     */
    oxXXN: T;

    /**
     * @default '{{0}} languages'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} languages
     * - plural: {{0}} languages
     */
    cjW2v: T;

    /**
     * @default 'Choose Languages'
     */
    c8H7z: T;

    /**
     * @default 'English (Singapore)'
     */
    nwPwQ: T;

    /**
     * @default 'Choose language'
     */
    '9Ucqv': T;
  };
};

export type LayoutEngineTranslations<T extends LeafNodeValue = TranslateFunction> = {
  components: {
    announcement: {
      /**
       * @default 'Close'
       */
      close: T;

      /**
       * @default 'Continue'
       */
      continue: T;
    };
    eventCta: {
      /**
       * @default 'Not You?'
       */
      buttonNotYouText: T;
    };
  };
  quick: {
    /**
     * @default 'Unlock Your Schedule'
     */
    ybxpH: T;

    /**
     * @default 'Unlock Guest Details'
     */
    eKWZY: T;

    /**
     * @default 'You are attending'
     */
    DUoV0: T;

    /**
     * @default 'You are not attending'
     */
    qdFsO: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Don't Forget to RSVP'
     */
    F6q94: T;

    /**
     * @default 'Not You?'
     */
    D1zbA: T;

    /**
     * @default 'Hello, {{0}}.'
     */
    yUHtT: T;

    /**
     * @default 'RSVP by {{0}}'
     */
    stX5U: T;

    /**
     * @default 'Guest Help'
     */
    JytpA: T;

    /**
     * @default 'About'
     */
    t7tcF: T;

    /**
     * @default 'Browse Designs'
     */
    vQAeM: T;

    /**
     * @default 'Hide controls'
     */
    QZaTA: T;

    /**
     * @default 'Toggle Layout:'
     */
    a8Kqy: T;

    /**
     * @default 'Use Portrait Photo:'
     */
    qmOyC: T;

    /**
     * @default 'Use Landscape Photo:'
     */
    ky5Bk: T;

    /**
     * @default 'Toggle'
     */
    gNNTY: T;

    /**
     * @default 'Toggle Translation:'
     */
    lhKUU: T;

    /**
     * @default 'Spanish'
     */
    MltqB: T;

    /**
     * @default 'English'
     */
    SIUPT: T;

    /**
     * @default 'Show controls'
     */
    '12n6u': T;
  };
};

export type LocationDatesOccupantsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '1 Room'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Room
     * - plural: {{0}} Rooms
     */
    YfpCH: T;

    /**
     * @default '1 Guest'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Guest
     * - plural: {{0}} Guests
     */
    smTdz: T;

    /**
     * @default 'Search location'
     */
    DolLE: T;

    /**
     * @default 'Select dates'
     */
    xyVOA: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Edit Search'
     */
    KdrUO: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Invalid dates'
     */
    eVfLe: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default 'Configuring Rooms'
     */
    NJwkV: T;

    /**
     * @default 'Add Room'
     */
    SkfsO: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default 'Remove Room'
     */
    J7AzN: T;

    /**
     * @default 'Adults'
     */
    '9woIj': T;

    /**
     * @default 'Age 18 or above'
     */
    '2JQeH': T;

    /**
     * @default 'Children'
     */
    jbb2a: T;

    /**
     * @default 'Age 17 or under'
     */
    '6FDhE': T;

    /**
     * @default 'Child {{0}}'
     */
    '2LJOz': T;

    /**
     * @default 'Select Age'
     */
    njboI: T;

    /**
     * @default 'Under 1'
     */
    zCCFa: T;
  };
};

export type LocationVenueSyncDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Failed to update venue. Please try again.'
     */
    Pu4SG: T;

    /**
     * @default 'Failed to update location. Please try again.'
     */
    rf3wB: T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Would you like to update your location to match your venue?'
     */
    OdYjc: T;

    /**
     * @default 'Would you like to update your venue to match your location?'
     */
    aN9BN: T;

    /**
     * @default 'New event location: {{0}}'
     */
    '1TMcy': T;

    /**
     * @default 'Please search and select your wedding venue, so we can help you plan better.'
     */
    e1bzf: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'Update your venue'
     */
    nT5yS: T;

    /**
     * @default 'Yes, Update Location'
     */
    BajQ2: T;

    /**
     * @default 'Save Venue'
     */
    U5GvJ: T;

    /**
     * @default 'No, Keep Original Location'
     */
    cizlA: T;

    /**
     * @default 'No, thanks'
     */
    '6kQyP': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type MarcomTranslations<T extends LeafNodeValue = TranslateFunction> = {
  topLevelLinks: {
    /**
     * @default 'Joy Wedding'
     */
    joyWedding: T;

    /**
     * @default 'Joy Baby'
     */
    joyBaby: T;

    /**
     * @default 'Find an Event'
     */
    findACouple: T;

    /**
     * @default 'Log In'
     */
    login: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Returns'
     */
    returns: T;

    /**
     * @default 'Newsroom'
     */
    newsroom: T;

    /**
     * @default 'Careers'
     */
    careers: T;

    /**
     * @default 'About Joy'
     */
    aboutJoy: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy'
     */
    privacy: T;

    /**
     * @default 'Checklist'
     */
    giftBasketWidget: T;

    /**
     * @default 'California Privacy Notice'
     */
    californiaPrivacyNotice: T;

    /**
     * @default 'Do not share my personal information.'
     */
    doNotShareInformation: T;
  };
  linkGroupHeaders: {
    /**
     * @default 'Plan & Invite'
     */
    planInvite: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Expert Advice'
     */
    expertAdvice: T;
  };
  planInvite: {
    /**
     * @default 'Wedding Website'
     */
    weddingWebsite: T;

    /**
     * @default 'Guest List'
     */
    guestList: T;

    /**
     * @default 'Save the Dates'
     */
    saveTheDates: T;

    /**
     * @default 'Invitations'
     */
    invitations: T;

    /**
     * @default 'Smart RSVP'
     */
    smartRsvp: T;

    /**
     * @default 'Hotel Room Blocks'
     */
    hotelRoomBlocks: T;

    /**
     * @default 'Mobile App'
     */
    mobileApp: T;
  };
  registry: {
    /**
     * @default 'Wedding Registry'
     */
    weddingRegistry: T;

    /**
     * @default 'The Registry Store'
     */
    shopWedding: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    zeroFeeCashFunds: T;

    /**
     * @default 'Honeymoon Funds'
     */
    honeymoonFunds: T;

    /**
     * @default 'Baby Registry'
     */
    babyRegistry: T;

    /**
     * @default 'Shop Baby Gifts'
     */
    shopBabyGift: T;
  };
  expertAdvice: {
    /**
     * @default 'Wedding Guides & Ideas'
     */
    weddingGuidesIdeas: T;

    /**
     * @default 'Wedding Guides'
     */
    weddingGuidesIdeasMobile: T;

    /**
     * @default 'Baby & Parenting Guides'
     */
    babyParentingGuides: T;

    /**
     * @default 'Baby Guides'
     */
    babyParentingGuidesMobile: T;

    /**
     * @default 'FAQs'
     */
    faq: T;

    /**
     * @default 'Help & Support'
     */
    support: T;

    blogs: {
      /**
       * @default 'Wedding Planning'
       */
      weddingPlanning: T;

      /**
       * @default 'Budget'
       */
      budget: T;

      /**
       * @default 'Tips & Tricks'
       */
      tipsTricks: T;

      /**
       * @default 'Venues'
       */
      venues: T;

      /**
       * @default 'Photography'
       */
      photography: T;

      /**
       * @default 'Food & Drink'
       */
      foodDrink: T;

      /**
       * @default 'Wedding Guests'
       */
      weddingGuests: T;

      /**
       * @default 'Registry & Gift Ideas'
       */
      registryGiftIdeas: T;

      /**
       * @default 'Real Weddings'
       */
      realWeddings: T;

      /**
       * @default 'Proposal Ideas'
       */
      proposalIdeas: T;

      /**
       * @default 'Honeymoons'
       */
      honeymoons: T;

      /**
       * @default 'Pregnancy'
       */
      pregnancy: T;

      /**
       * @default 'Planning'
       */
      planning: T;

      /**
       * @default 'Parties'
       */
      parties: T;

      /**
       * @default 'Parenting'
       */
      parenting: T;

      /**
       * @default 'View All Categories'
       */
      viewAllCategories: T;
    };
  };
  identityWidget: {
    /**
     * @default 'Dashboard'
     */
    toDashboard: T;

    /**
     * @default 'Registry'
     */
    toRegistry: T;

    /**
     * @default 'Settings'
     */
    toSettings: T;

    /**
     * @default 'Manage Account'
     */
    toManageAcct: T;

    /**
     * @default 'Invite Collaborator'
     */
    toInvite: T;

    /**
     * @default 'Help'
     */
    toHelp: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    /**
     * @default 'Switch Event'
     */
    switchEvent: T;

    /**
     * @default 'Select Event'
     */
    selectEvent: T;

    /**
     * @default 'No Event Selected'
     */
    noEventSelected: T;
  };
  footerNav: {
    /**
     * @default 'New'
     */
    new: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default '© {{year}} Joy. All rights reserved.'
     */
    copyright: T;
  };
  footerMenu: {
    primary: {
      /**
       * @default 'Wedding Website'
       */
      weddingWebsite: T;

      /**
       * @default 'Guest List'
       */
      guestList: T;

      /**
       * @default 'Save the Dates'
       */
      saveTheDates: T;

      /**
       * @default 'Invitations'
       */
      invitations: T;

      /**
       * @default 'Smart RSVP'
       */
      smartRsvp: T;

      /**
       * @default 'Registry'
       */
      registry: T;

      /**
       * @default 'Hotel Room Blocks'
       */
      hotelRoomBlocks: T;

      /**
       * @default 'Mobile App'
       */
      mobileApp: T;

      /**
       * @default 'Baby Registry'
       */
      babyRegistry: T;

      /**
       * @default 'Shop Baby Gifts'
       */
      shopBabyGifts: T;

      /**
       * @default 'Zero-Fee Cash Funds'
       */
      zeroFeeCashFunds: T;
    };
    secondary: {
      /**
       * @default 'Design Templates'
       */
      designTemplates: T;

      /**
       * @default 'Ideas & Inspiration'
       */
      ideasInspiration: T;

      /**
       * @default 'Common Questions'
       */
      commonQuestions: T;

      /**
       * @default 'Help & Support'
       */
      helpSupport: T;

      /**
       * @default 'Pricing'
       */
      pricing: T;

      /**
       * @default 'Baby & Parenting Guides'
       */
      babyParentingGuides: T;

      /**
       * @default 'FAQs'
       */
      faqs: T;
    };
  };
};

export type MessageTranslations<T extends LeafNodeValue = TranslateFunction> = {
  shared: {
    recipientPickerDialog: {
      /**
       * @default 'Select Recipients'
       */
      title: T;

      /**
       * @default 'Search'
       */
      searchPlaceholder: T;

      /**
       * @default 'No recipients found.'
       */
      noRecipients: T;

      /**
       * @default 'Selected ({{count}})'
       */
      selected: T;

      /**
       * @default 'Unselect All'
       */
      unselectAll: T;

      /**
       * @default 'Select All'
       */
      selectAll: T;

      /**
       * @default 'Select Recipients ({{count}})'
       */
      cta: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
    editLinkDialog: {
      /**
       * @default 'Select Link'
       */
      websiteLinkTitle: T;

      /**
       * @default 'Edit Link'
       */
      websiteLinkTitleDigital: T;

      /**
       * @default 'Edit Your Website Details'
       */
      handleAndPasswordTitle: T;

      websiteLink: {
        /**
         * @default 'Select the link users will navigate to, making it easy for them to see the most relevant information.'
         */
        description: T;

        /**
         * @default 'Add a link to your card, so guests can easily access your wedding website and see all the details.'
         */
        linkDescription: T;

        /**
         * @default 'Your Website'
         */
        yourWebsiteTitle: T;

        /**
         * @default 'Edit'
         */
        edit: T;

        /**
         * @default 'Edit URL and Password'
         */
        editURLAndPassword: T;

        /**
         * @default 'Uh oh! Your website link seems a bit long, you can edit it to make it shorter and more personal to make it easier for your guests.'
         */
        longHandleWarning: T;

        /**
         * @default 'Your Custom Link'
         */
        customLinkTitle: T;

        /**
         * @default 'Contact Collector'
         */
        contactCollectorTitle: T;

        /**
         * @default 'Please ensure you're using the correct format, starting with http:// or https://'
         */
        invalidCustomLinkError: T;

        /**
         * @default 'Select a Page'
         */
        selectAPage: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Save'
         */
        save: T;
      };
      editLinkAndPassword: {
        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'This URL is available'
         */
        urlAvailable: T;

        /**
         * @default ' This URL is not available'
         */
        urlNotAvailable: T;

        /**
         * @default '/60 Max Chars'
         */
        urlCharsCounter: T;

        /**
         * @default 'URL cannot be blank.'
         */
        urlRequiredError: T;

        /**
         * @default 'URL must be less than 60 characters long.'
         */
        urlLengthError: T;

        /**
         * @default 'Only letters, numbers and '-' are allowed in your URL.'
         */
        urlCharactersError: T;

        /**
         * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
         */
        urlWarning: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Password cannot be blank.'
         */
        passwordRequiredError: T;

        /**
         * @default 'Your password can only contain letters and numbers.'
         */
        passwordCharactersError: T;

        /**
         * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
         */
        passwordWarning: T;

        /**
         * @default 'Cancel'
         */
        cancel: T;

        /**
         * @default 'Update Details'
         */
        updateDetails: T;

        /**
         * @default 'Your Event Website has been updated.'
         */
        successToast: T;

        /**
         * @default 'An error occurred while updating your Event Website. Please try again.'
         */
        errorToast: T;
      };
    };
  };
  quick: {
    /**
     * @default 'Selected recipient has not verified their email.'
     */
    NwJTi: T;

    /**
     * @default 'Request Funds'
     */
    BYgHF: T;

    /**
     * @default 'Send Message'
     */
    bkLsr: T;

    /**
     * @default 'Send General Message'
     */
    x2sdC: T;

    /**
     * @default 'Add Block'
     */
    '8ebFJ': T;

    /**
     * @default 'Change Card'
     */
    eVLKd: T;

    /**
     * @default 'Image'
     */
    HyIIG: T;

    /**
     * @default 'Salutation'
     */
    gkDux: T;

    /**
     * @default 'Headline'
     */
    EhWwE: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Button'
     */
    CRVJn: T;

    /**
     * @default 'App Download'
     */
    LH1To: T;

    /**
     * @default 'Event Password'
     */
    '9SjQp': T;

    /**
     * @default 'Premium Digital Card'
     */
    Vbieg: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'First Last'
     */
    kqR3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Last First'
     */
    '4khnu': T;

    /**
     * @default 'Title Last'
     */
    '6AxFS': T;

    /**
     * @default 'Envelope Name'
     */
    vyb70: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Contribute'
     */
    VZXCJ: T;

    /**
     * @default 'Download Our App'
     */
    ltjjX: T;

    /**
     * @default 'Get the Joy app to view and share photos and stay up-to-date with details on the go.'
     */
    hA1tq: T;

    /**
     * @default 'Event Password:'
     */
    HuLz1: T;

    /**
     * @default 'Subject:'
     */
    sHXE7: T;

    /**
     * @default 'Recipient Name'
     */
    yNxhf: T;

    /**
     * @default 'Host Your Event'
     */
    To11c: T;

    /**
     * @default '140 Keller Street #229, Petaluma, CA 94952'
     */
    xqEQs: T;

    /**
     * @default 'Help Center'
     */
    '0H3Rt': T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Terms and Conditions'
     */
    i5MF4: T;

    /**
     * @default 'This message was sent from withjoy.com on behalf of {{0}}. Send replies to {{1}}.'
     */
    '59Fuw': T;

    /**
     * @default 'This message was sent from withjoy.com on behalf of {{0}}.'
     */
    VnvYf: T;

    /**
     * @default 'Plan your forever, better.'
     */
    NZaqE: T;

    /**
     * @default 'Messaging+ is active. Review your time, then schedule your message.'
     */
    xuf7z: T;

    /**
     * @default 'Untitled message - {{0}}'
     */
    BDA67: T;

    /**
     * @default 'We couldn't load your card. Try again before you send.'
     */
    eWYdL: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something went wrong'
     */
    kkwz0: T;

    /**
     * @default 'Select at least one guest with an email address to send an email.'
     */
    hpTfA: T;

    /**
     * @default 'Select at least one guest with a mobile number to send a text.'
     */
    hl8A9: T;

    /**
     * @default 'Still loading — try again in a moment'
     */
    '3xxnI': T;

    /**
     * @default 'We're reviewing your message before delivery'
     */
    '5msPb': T;

    /**
     * @default 'Sent. Schedule cancelled.'
     */
    GIuKs: T;

    /**
     * @default '1 text'
     */
    wxYnI: T;

    /**
     * @default '{{0}} texts'
     */
    ij11l: T;

    /**
     * @default '1 email'
     */
    JG9xP: T;

    /**
     * @default '{{0}} emails'
     */
    Hgr1v: T;

    /**
     * @default 'Message sent — {{0}} delivered, {{1}} skipped.'
     */
    sJYj1: T;

    /**
     * @default 'Message sent — {{0}} and {{1}} on the way.'
     */
    wumx6: T;

    /**
     * @default 'Message sent — {{0}} on the way.'
     */
    '8CiwF': T;

    /**
     * @default 'Pick a time at least {{0}} minutes from now.'
     */
    g2jG7: T;

    /**
     * @default 'Pick a date within the next year.'
     */
    '4ChIg': T;

    /**
     * @default 'Rescheduled for {{0}}'
     */
    TI5PA: T;

    /**
     * @default 'Scheduled for {{0}}'
     */
    IqZad: T;

    /**
     * @default 'This message is already being sent.'
     */
    MEZgA: T;

    /**
     * @default 'Your test email is on the way!'
     */
    rgeEE: T;

    /**
     * @default 'To:'
     */
    bvYAA: T;

    /**
     * @default 'View Card'
     */
    b9fxU: T;

    /**
     * @default 'Your card envelope'
     */
    PIUzZ: T;

    /**
     * @default 'This email was sent from withjoy.com on behalf of {{0}}.'
     */
    S4hwV: T;

    /**
     * @default 'Test Recipient'
     */
    lf11J: T;

    /**
     * @default 'Must be at least {{0}} characters in length. Generic or placeholder text may prevent delivery.'
     */
    cCMCJ: T;

    /**
     * @default 'Thanks for helping with our plans'
     */
    pZGFQ: T;

    /**
     * @default 'We set this up to make it easy to chip in for things we’ve already taken care of. If you’d like to contribute, we really appreciate it — thank you for being part of this with us!'
     */
    Ulm6b: T;

    /**
     * @default 'Hi'
     */
    BoAAA: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Exciting info about our upcoming event!'
     */
    VMWLg: T;

    /**
     * @default 'We're excited to share the latest news and updates for our upcoming event.

Thank you for being a part of our community!'
*/
    d61x2: T;

    /**
     * @default 'Drag to reorder'
     */
    UEgfY: T;

    /**
     * @default 'Remove block'
     */
    '3ZFwg': T;

    /**
     * @default 'Delete this block?'
     */
    Fy5CQ: T;

    /**
     * @default 'This block will be removed from your email. You can add it back from the block menu, but your content won't be saved.'
     */
    updaA: T;

    /**
     * @default 'No link yet — this button won't go anywhere until you add one.'
     */
    h5UCE: T;

    /**
     * @default 'Button text'
     */
    dQLVI: T;

    /**
     * @default 'Button URL'
     */
    '9lRdM': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Add a headline'
     */
    irwZ4: T;

    /**
     * @default 'Change photo'
     */
    '4oQDg': T;

    /**
     * @default 'Add a photo'
     */
    ICGPL: T;

    /**
     * @default 'Click to add a photo'
     */
    '7dnuD': T;

    /**
     * @default 'Add block'
     */
    O3poL: T;

    /**
     * @default 'Set an event password'
     */
    yvbuc: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Greeting'
     */
    rTebL: T;

    /**
     * @default '+ Add Name'
     */
    XBkAB: T;

    /**
     * @default 'Add your message'
     */
    BmmEz: T;

    /**
     * @default 'Create New Fund'
     */
    VfFAE: T;

    /**
     * @default 'Select Fund to Link'
     */
    oR0DK: T;

    /**
     * @default 'Select…'
     */
    '6Kcu4': T;

    /**
     * @default 'Dismiss cash funds suggestion'
     */
    tJQjC: T;

    /**
     * @default 'Introducing Cash Fund Requests'
     */
    Ub0CB: T;

    /**
     * @default 'Now there's an easy way to request cash from your guests for anything.'
     */
    SThFj: T;

    /**
     * @default 'Add Fund to Message'
     */
    k7WL1: T;

    /**
     * @default 'Drafts are auto-saved.'
     */
    J1jvp: T;

    /**
     * @default 'View Drafts'
     */
    LSsxD: T;

    /**
     * @default '1 guest with a phone number outside the U.S. and Canada gets this by WhatsApp.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest with a phone number outside the U.S. and Canada gets this by WhatsApp.
     * - plural: {{0}} guests with a phone number outside the U.S. and Canada get this by WhatsApp.
     */
    F1of9: T;

    /**
     * @default 'WhatsApp preview'
     */
    KkeSM: T;

    /**
     * @default 'On WhatsApp, the button reads “{{0}}”.'
     */
    EwKz7: T;

    /**
     * @default 'URL cannot be blank.'
     */
    J5Tmm: T;

    /**
     * @default 'URL must be less than 60 characters long.'
     */
    Rynku: T;

    /**
     * @default 'Only letters, numbers and '-' are allowed in your URL.'
     */
    W2Ipy: T;

    /**
     * @default 'Use at least {{0}} characters'
     */
    '7O76U': T;

    /**
     * @default 'Password cannot be blank.'
     */
    rOdcd: T;

    /**
     * @default 'Your password can only contain letters and numbers.'
     */
    I7Iqq: T;

    /**
     * @default 'Your Event Website has been updated.'
     */
    Bf3aG: T;

    /**
     * @default 'That URL is too short. Use at least {{0}} characters.'
     */
    rlsJx: T;

    /**
     * @default 'An error occurred while updating your Event Website. Please try again.'
     */
    QnDcv: T;

    /**
     * @default 'password input'
     */
    LuDfw: T;

    /**
     * @default 'Couldn't load the password. Try again.'
     */
    XGBs8: T;

    /**
     * @default 'Hide password'
     */
    fHzwN: T;

    /**
     * @default 'Show password'
     */
    IMpuT: T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Show'
     */
    '5YANA': T;

    /**
     * @default 'This draft can't be opened right now'
     */
    SeX1S: T;

    /**
     * @default 'It was written in the new message editor, which isn't available at the moment. Your draft is saved as it was — check back soon to pick up where you left off.'
     */
    iNBxg: T;

    /**
     * @default 'Back to Drafts'
     */
    CFQoG: T;

    /**
     * @default 'We couldn't load your card'
     */
    dg4dX: T;

    /**
     * @default 'Your text needs the link to your card before it can send. Try again, and if this keeps happening, contact Joy.'
     */
    vs0MG: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Add recipients'
     * @param {number} count - The number of occurrences.
     * - zero: Add recipients
     * - singular: Add or remove recipients
     * - plural: Add or remove recipients
     */
    Z6jMa: T;

    /**
     * @default 'Select Recipients'
     * @param {number} count - The number of occurrences.
     * - zero: Select Recipients
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    Hoe7A: T;

    /**
     * @default 'Almost done!'
     */
    '5p88K': T;

    /**
     * @default 'Select guests manually or use tags to select groups of guests.'
     */
    cMaYX: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Send Now'
     */
    Ow0GV: T;

    /**
     * @default 'Do an optional final check'
     */
    '2fi6E': T;

    /**
     * @default 'Never hurts to make sure everything is just right.'
     */
    dEpA1: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'Send this message to all selected guests.'
     */
    dyTwn: T;

    /**
     * @default 'We couldn't save your message. Please try again.'
     */
    YuoZ4: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Edit Recipients'
     */
    QInCZ: T;

    /**
     * @default 'Confirm & Send'
     */
    KYpY4: T;

    /**
     * @default 'Review your cash fund invite and send it to your guests.'
     */
    rPRyx: T;

    /**
     * @default 'Review your message and send it to your guests.'
     */
    RvaiL: T;

    /**
     * @default 'Add a text message?'
     */
    xbqeY: T;

    /**
     * @default 'Add an email?'
     */
    f80dd: T;

    /**
     * @default 'You haven't written one yet. You'll go back to the composer to write it.'
     */
    BMaYR: T;

    /**
     * @default 'Your email isn't ready to send yet. You'll go back to the designer to finish it.'
     */
    Vws6n: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Select at least one guest to send to.'
     */
    '8fisp': T;

    /**
     * @default 'Nobody selected has an email address, so the email can't go out.'
     */
    VQiIR: T;

    /**
     * @default 'Nobody selected has a mobile number, so the text can't go out.'
     */
    NfiVI: T;

    /**
     * @default 'Your text message is empty. Go back and write it.'
     */
    SmTGg: T;

    /**
     * @default 'Your text is too long. Go back and shorten it.'
     */
    qPRHF: T;

    /**
     * @default 'Pick a send date and time.'
     */
    gWhDa: T;

    /**
     * @default 'We couldn't save your draft, so you're still in this editor. Check your connection and try again.'
     */
    fHTAC: T;

    /**
     * @default 'Start over in the new editor?'
     */
    '8T34m': T;

    /**
     * @default 'Your message won't come with you: the new editor uses a different format, so you'll start with a blank message. We'll save what you've written in Drafts, and your recipients will carry over.'
     */
    lklDT: T;

    /**
     * @default 'Save to Drafts & Switch'
     */
    auEYW: T;

    /**
     * @default 'Start over in the classic editor?'
     */
    obK6E: T;

    /**
     * @default 'Your message won't come with you: the classic editor uses a different format, so you'll start with a blank message. We'll save what you've written in Drafts, and your recipients will carry over.'
     */
    hqTdd: T;

    /**
     * @default 'Try the new message editor'
     */
    ErYx5: T;

    /**
     * @default 'Write and format your message right where you'll see it, with a live preview. Messages don't move between editors, so switch before you start writing.'
     */
    '8ZIh9': T;

    /**
     * @default 'Try the New Editor'
     */
    D7jRS: T;

    /**
     * @default 'You're using the new editor'
     */
    Pqm21: T;

    /**
     * @default 'Classic Editor'
     */
    '3vo81': T;

    /**
     * @default '1 Person Selected…'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    HsBfd: T;

    /**
     * @default 'Recipients'
     */
    krwxH: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Modify Recipients'
     */
    Yv9UB: T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Include Recipient Name'
     */
    USARc: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Display Button in Email'
     */
    P1HsB: T;

    /**
     * @default 'Display Links to Install the Joy App'
     */
    '7LcsH': T;

    /**
     * @default 'Display Event Password'
     */
    '51jO4': T;

    /**
     * @default 'Included automatically with app download links.'
     */
    ffLhK: T;

    /**
     * @default 'Pause this scheduled message to change its card.'
     */
    pOehT: T;

    /**
     * @default 'This message is sending, so its card can’t change.'
     */
    e5SNG: T;

    /**
     * @default 'Remove 1 block to continue.'
     */
    kgHsM: T;

    /**
     * @default 'Remove {{0}} blocks to continue.'
     */
    '8XfNQ': T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Your cash fund counts as one. Remove a block to add another.'
     */
    nlGkp: T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Remove a block to add another.'
     */
    GoxQn: T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Your cash fund counts as one. Remove 1 block to continue.'
     */
    OVrQv: T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Remove 1 block to continue.'
     */
    PxSoX: T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Your cash fund counts as one. Remove {{1}} blocks to continue.'
     */
    zAKlj: T;

    /**
     * @default 'Emails can have up to {{0}} blocks. Remove {{1}} blocks to continue.'
     */
    uPMzy: T;

    /**
     * @default 'Select fewer guests to fit your card's recipient limit.'
     */
    '3xUtZ': T;

    /**
     * @default 'Add a subject line before continuing.'
     */
    fjkJG: T;

    /**
     * @default 'Fill in the highlighted part of your message.'
     */
    uoSlJ: T;

    /**
     * @default 'Add your card back from Add Block before continuing.'
     */
    ysO5o: T;

    /**
     * @default 'Write your text message before continuing.'
     */
    HUTPJ: T;

    /**
     * @default 'Your text is too long. Shorten it to continue.'
     */
    '4xcAH': T;

    /**
     * @default 'Remove some blocks to continue.'
     */
    igbfm: T;

    /**
     * @default 'Add a Text block with your message before continuing.'
     */
    jTzkO: T;

    /**
     * @default 'Continue to Text'
     */
    '35UVK': T;

    /**
     * @default 'Continue to Email'
     */
    wIWfx: T;

    /**
     * @default 'Continue to Review'
     */
    uCA2G: T;

    /**
     * @default 'Sent with the app links — guests need it to open your event. Remove the app block to drop it.'
     */
    bahVP: T;

    /**
     * @default 'Select People'
     */
    Vkiox: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Sender name'
     */
    Id5ua: T;

    /**
     * @default 'To (Bcc)'
     */
    KXCt6: T;

    /**
     * @default 'Copied from your email. Edit as needed.'
     */
    qY0ie: T;

    /**
     * @default 'We couldn’t load your cards.'
     */
    MW4Hf: T;

    /**
     * @default 'Digital cards you buy appear here, ready to add to your message.'
     */
    rGqST: T;

    /**
     * @default 'Your current card'
     */
    Q2uc1: T;

    /**
     * @default 'This is the only card you can send here.'
     */
    wgFFC: T;

    /**
     * @default 'Choose a Card'
     */
    AgDaW: T;

    /**
     * @default 'Browse Cards'
     */
    Zhu8B: T;

    /**
     * @default 'In this message'
     */
    arsWN: T;

    /**
     * @default 'We couldn’t change the card, so your message still has the original. Try again.'
     */
    O0Uy2: T;

    /**
     * @default 'We couldn’t add the card. Try again.'
     */
    BakqS: T;

    /**
     * @default 'We couldn’t load a preview of your card. It’s still part of your message.'
     */
    elu01: T;

    /**
     * @default 'The front of your card'
     */
    EwxoS: T;

    /**
     * @default 'Card Preview'
     */
    eTZSZ: T;

    /**
     * @default 'Guests open this card from the envelope or button in their email. Each guest gets their own link, so you can see who viewed it.'
     */
    '92UVW': T;

    /**
     * @default 'View as Guest'
     */
    '5rbP8': T;

    /**
     * @default 'Compose steps'
     */
    Nm9Ax: T;

    /**
     * @default 'Step {{0}}'
     */
    WRKib: T;

    /**
     * @default 'Event password updated.'
     */
    ysWrT: T;

    /**
     * @default 'Couldn't update the event password. Please try again.'
     */
    '8tB19': T;

    /**
     * @default 'Edit Event Password'
     */
    '7sgDR': T;

    /**
     * @default 'Guests use this password to access your event website.'
     */
    '8lcXV': T;

    /**
     * @default 'Event password'
     */
    jr0ly: T;

    /**
     * @default '+{{0}} More'
     */
    m4s3l: T;

    /**
     * @default 'Loading recipients…'
     */
    '4R3dD': T;

    /**
     * @default '1 won't receive this'
     * @param {number} count - The number of occurrences.
     * - singular: 1 won't receive this
     * - plural: {{0}} won't receive this
     */
    FKXZK: T;

    /**
     * @default '1 text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 text
     * - plural: {{0}} texts
     */
    '6Y5Ig': T;

    /**
     * @default '1 {{0}}'
     * @param {number} count - The number of occurrences.
     * - singular: 1 {{0}}
     * - plural: {{0}} {{1}}
     */
    uaGyV: T;

    /**
     * @default '1 email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 email
     * - plural: {{0}} emails
     */
    q7Mgd: T;

    /**
     * @default 'Message from {{0}}'
     */
    ZASjR: T;

    /**
     * @default 'That doesn't look like a web address. Check it and try again.'
     */
    '3FKfr': T;

    /**
     * @default 'Remove this photo?'
     */
    ZbfWa: T;

    /**
     * @default 'Your message will send as text only. You can add another photo any time.'
     */
    NnqAb: T;

    /**
     * @default 'Remove this link?'
     */
    vGE4a: T;

    /**
     * @default 'Guests won't get a link to your website in this message. You can add another link any time.'
     */
    omKVA: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'This page is password protected. Include the event password in your message so guests can open it.'
     */
    f14ZG: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Edit link'
     */
    ibcNg: T;

    /**
     * @default 'Remove link'
     */
    iT42N: T;

    /**
     * @default '+ Add Link'
     */
    QlTAB: T;

    /**
     * @default '+ Add Photo'
     */
    midzs: T;

    /**
     * @default 'Edit photo'
     */
    '8Mze5': T;

    /**
     * @default 'Remove photo'
     */
    GVJ3h: T;

    /**
     * @default 'Message image'
     */
    gwe4X: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'Edit message'
     */
    XmePS: T;

    /**
     * @default 'Your message to guests'
     */
    mkfzl: T;

    /**
     * @default 'Phones show link images as tap-to-load.'
     */
    OYMXQ: T;

    /**
     * @default '+ Add first name'
     */
    No8eM: T;

    /**
     * @default 'First name'
     */
    heZ8G: T;

    /**
     * @default 'Remove first name'
     */
    bWEjv: T;

    /**
     * @default '{{0}} · Password protected'
     */
    aJtl8: T;

    /**
     * @default 'Password protected'
     */
    Tr6Rs: T;

    /**
     * @default '{{0}} · Hidden'
     */
    V3thl: T;

    /**
     * @default '{{0}} · Specific guests'
     */
    '2B1wD': T;

    /**
     * @default 'Custom URL'
     */
    '4XlYn': T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'This page is password protected. Add an Event Password block so guests get the password along with the link.'
     */
    PijnL: T;

    /**
     * @default '1 guest with a phone number outside the U.S. and Canada gets this by WhatsApp, inside a message from Joy. Line breaks become spaces there. You’ll see how it looks before you send.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest with a phone number outside the U.S. and Canada gets this by WhatsApp, inside a message from Joy. Line breaks become spaces there. You’ll see how it looks before you send.
     * - plural: {{0}} guests with a phone number outside the U.S. and Canada get this by WhatsApp, inside a message from Joy. Line breaks become spaces there. You’ll see how it looks before you send.
     */
    f6HYS: T;

    /**
     * @default '1 guest with a U.S. or Canadian phone number gets this by text. You’ll see how it looks before you send.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest with a U.S. or Canadian phone number gets this by text. You’ll see how it looks before you send.
     * - plural: {{0}} guests with a U.S. or Canadian phone number get this by text. You’ll see how it looks before you send.
     */
    TS6K4: T;

    /**
     * @default 'This is over WhatsApp’s {{0}}-character limit, so guests with a phone number outside the U.S. and Canada would get it as a text instead. Shorten it to send by WhatsApp.'
     */
    Zuvqc: T;

    /**
     * @default 'WhatsApp: {{0}} of {{1}} characters'
     */
    q94fI: T;

    /**
     * @default 'Line breaks become spaces in WhatsApp.'
     */
    ZVi48: T;

    /**
     * @default 'Something went wrong with checkout. Please try again.'
     */
    MYTVo: T;
  };
};

export type MessagesV2ServiceCenterTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}}+'
     */
    JLOGt: T;

    /**
     * @default 'Switch to V1'
     */
    uhWHP: T;

    /**
     * @default 'BETA'
     */
    OTRKA: T;

    /**
     * @default 'Search internal message records across email, SMS and WhatsApp channels'
     */
    tBsr6: T;

    /**
     * @default 'Showing {{0}} of {{1}} results'
     */
    XImFp: T;

    /**
     * @default '← Prev'
     */
    JE36Y: T;

    /**
     * @default 'Next →'
     */
    Z00oH: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Rejected'
     */
    '6Kc0L': T;

    /**
     * @default 'Undelivered'
     */
    Bpct4: T;

    /**
     * @default 'Complained'
     */
    qxhUn: T;

    /**
     * @default 'Delivered'
     */
    SbKKi: T;

    /**
     * @default 'Opened'
     */
    Jb2IL: T;

    /**
     * @default 'Clicked'
     */
    rmYmu: T;

    /**
     * @default 'Read'
     */
    '0E0MA': T;

    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Queued'
     */
    '5wM0Q': T;

    /**
     * @default 'Sending'
     */
    '6XP44': T;

    /**
     * @default 'Accepted'
     */
    RAUR2: T;

    /**
     * @default 'Scheduled'
     */
    '542mo': T;

    /**
     * @default 'Created'
     */
    k0dLA: T;

    /**
     * @default 'Preparing'
     */
    '2DgRI': T;

    /**
     * @default 'Canceled'
     */
    TqO5I: T;

    /**
     * @default 'Unsubscribed'
     */
    VuaZT: T;

    /**
     * @default 'Suppressed'
     */
    O2bSt: T;

    /**
     * @default 'Unconfirmed'
     */
    OMReL: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'WhatsApp'
     */
    qJ8WP: T;

    /**
     * @default 'SMS'
     */
    LMYAA: T;

    /**
     * @default 'Links'
     */
    jpgWG: T;

    /**
     * @default 'Clicked {{0}}'
     */
    pvNoP: T;

    /**
     * @default 'Not clicked'
     */
    o40hQ: T;

    /**
     * @default 'card:'
     */
    kswLI: T;

    /**
     * @default 'Search for messages'
     */
    l84tB: T;

    /**
     * @default 'Enter a customer email, phone number, event ID, or batch ID to find messages'
     */
    '3qA7b': T;

    /**
     * @default 'No messages found'
     */
    XdHf1: T;

    /**
     * @default 'Note: phone numbers must be in E.164 format — the tool auto-formats as you type'
     */
    elKsD: T;

    /**
     * @default 'Search failed'
     */
    Rr4kQ: T;

    /**
     * @default 'List'
     */
    KR7LA: T;

    /**
     * @default 'Stepper'
     */
    NzxlM: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Channel'
     */
    TlaZj: T;

    /**
     * @default 'Provider'
     */
    r2z0s: T;

    /**
     * @default 'Recipient'
     */
    Z1BYT: T;

    /**
     * @default 'Message type'
     */
    v8YI3: T;

    /**
     * @default 'Last status'
     */
    wujZ8: T;

    /**
     * @default 'Status message'
     */
    TFcoZ: T;

    /**
     * @default 'Event ID'
     */
    PeJlg: T;

    /**
     * @default 'Batch ID'
     */
    DaYOv: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Select all email messages on this page'
     */
    FlsOF: T;

    /**
     * @default 'person:'
     */
    '5OZ4l': T;

    /**
     * @default 'guest:'
     */
    cNwGN: T;

    /**
     * @default 'View email'
     */
    dbBdG: T;

    /**
     * @default 'View WhatsApp'
     */
    '5dbFS': T;

    /**
     * @default 'View SMS'
     */
    cZVe0: T;

    /**
     * @default 'Status history'
     */
    gzBPj: T;

    /**
     * @default 'View email in viewer'
     */
    IwrhA: T;

    /**
     * @default 'View WhatsApp Preview'
     */
    Hf1H2: T;

    /**
     * @default 'View SMS Preview'
     */
    '0MjHk': T;

    /**
     * @default 'Original message'
     */
    qSBuI: T;

    /**
     * @default 'Loading the original…'
     */
    mG6x2: T;

    /**
     * @default 'Original not found — it may have been deleted.'
     */
    BUJaZ: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Provider id'
     */
    '27m80': T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'No status history available'
     */
    ECb7M: T;

    /**
     * @default 'All'
     */
    '5WTAA': T;

    /**
     * @default 'Errors only'
     */
    RfRf0: T;

    /**
     * @default 'filter...'
     */
    Cb1Iv: T;

    /**
     * @default 'Clear filters'
     */
    '0Ev5m': T;

    /**
     * @default 'Resent'
     */
    n5zOS: T;

    /**
     * @default 'Not sent'
     */
    '3CsfA': T;

    /**
     * @default 'Resending 1 message…'
     */
    '3y8FG': T;

    /**
     * @default 'Resending {{0}} messages…'
     */
    Hp2EL: T;

    /**
     * @default 'Resent {{0}} of {{1}}'
     */
    PYgXY: T;

    /**
     * @default 'Resent {{0}} of {{1}} — {{2}} failed'
     */
    '4Hmyn': T;

    /**
     * @default 'Resend 1 message?'
     */
    G0S2o: T;

    /**
     * @default 'Resend {{0}} messages?'
     */
    M03dy: T;

    /**
     * @default 'Each message is sent again to its original recipient. This cannot be undone.'
     */
    ohqYN: T;

    /**
     * @default '(no message type)'
     */
    lCnLh: T;

    /**
     * @default 'Not sent — see the new row in the table for the reason'
     */
    TUfjS: T;

    /**
     * @default 'Not sent — the request failed and no row was created. Safe to try again.'
     */
    M1N0M: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Resending…'
     */
    '9o0fU': T;

    /**
     * @default 'Resend'
     */
    X5zOS: T;

    /**
     * @default '1 message selected'
     */
    djiO3: T;

    /**
     * @default '{{0}} messages selected'
     */
    B4IYt: T;

    /**
     * @default 'Clear'
     */
    NdJoF: T;

    /**
     * @default 'ATTEMPT {{0}}'
     */
    LCcfE: T;

    /**
     * @default 'Attempt {{0}}, counting the first send. Expand this row to see the original.'
     */
    HGNNS: T;

    /**
     * @default 'A later attempt at this message is listed. Resend that one instead.'
     */
    nkVIF: T;

    /**
     * @default 'SMS resend isn't available yet'
     */
    m396T: T;

    /**
     * @default 'Select message for resend'
     */
    FUgWi: T;

    /**
     * @default 'A later attempt at this message is listed'
     */
    rWLab: T;

    /**
     * @default 'SMS resend is not available yet'
     */
    uF4w3: T;

    /**
     * @default 'Please enter a valid email'
     */
    '3hdNF': T;

    /**
     * @default 'Edit search'
     */
    owtuP: T;

    /**
     * @default 'To Email'
     */
    VtyJ9: T;

    /**
     * @default 'From email'
     */
    i5r2D: T;

    /**
     * @default 'Reply-to'
     */
    Q2gVc: T;

    /**
     * @default 'To Phone'
     */
    '9m1BA': T;

    /**
     * @default 'More identifiers'
     */
    nbuy3: T;

    /**
     * @default 'Person ID'
     */
    OZC8M: T;

    /**
     * @default 'Guest key'
     */
    nHo7F: T;

    /**
     * @default 'Card order ID'
     */
    ZdV4B: T;

    /**
     * @default 'Created from'
     */
    gIbKS: T;

    /**
     * @default 'Created to'
     */
    PW0j0: T;

    /**
     * @default 'Page size'
     */
    u7gyf: T;

    /**
     * @default 'Add an email, phone, or event ID to enable search'
     */
    cPFuq: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Collapse'
     */
    f8LSD: T;

    /**
     * @default 'Export CSV'
     */
    IXrvA: T;
  };
};

export type MessagingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  messageList: {
    item: {
      /**
       * @default 'Track'
       */
      track: T;

      /**
       * @default 'Forward'
       */
      forwardIconTitle: T;

      status: {
        /**
         * @default 'Sent'
         */
        sent: T;

        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Failed'
         */
        failed: T;

        /**
         * @default 'In Review'
         */
        inReview: T;

        /**
         * @default 'Your message will be sent once it has been reviewed. Please contact support if you have any questions.'
         */
        inReviewTooltip: T;
      };
    };
  };
  messageDetailsBottomSheet: {
    /**
     * @default 'Recipient Name'
     */
    recipientNameTitle: T;

    /**
     * @default 'Recipient Email'
     */
    emailTitle: T;

    /**
     * @default 'Status'
     */
    statusTitle: T;

    /**
     * @default 'Details'
     */
    detailsTitle: T;

    /**
     * @default 'View Message'
     */
    viewMessageTitle: T;

    tableHeaders: {
      /**
       * @default 'Recipient Name'
       */
      recipientName: T;

      /**
       * @default 'Recipient Email'
       */
      email: T;

      /**
       * @default 'Status'
       */
      status: T;

      /**
       * @default 'Details'
       */
      details: T;

      /**
       * @default 'View Message'
       */
      viewMessage: T;
    };
  };
  quick: {
    /**
     * @default '1 recipient'
     * @param {number} count - The number of occurrences.
     * - singular: 1 recipient
     * - plural: {{0}} recipients
     */
    An6UT: T;

    /**
     * @default 'Digital card'
     */
    mzYHf: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Thank You'
     */
    TEKg2: T;

    /**
     * @default 'Holiday'
     */
    mOSz3: T;

    /**
     * @default 'Enclosure'
     */
    qJ0d5: T;

    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Napkin'
     */
    R2pTH: T;

    /**
     * @default 'Sign'
     */
    FmANA: T;

    /**
     * @default 'Monogram'
     */
    ggmVN: T;

    /**
     * @default 'Envelope'
     */
    cnOVq: T;

    /**
     * @default 'Unlimited'
     */
    '9Boct': T;

    /**
     * @default 'None left'
     */
    NVCQD: T;

    /**
     * @default '{{0}} of {{1}} left'
     */
    R8oTG: T;

    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Create'
     */
    IERgp: T;

    /**
     * @default 'Drafts'
     */
    q93Js: T;

    /**
     * @default 'Scheduled'
     */
    '542mo': T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Templates'
     */
    PwUcN: T;

    /**
     * @default 'Messaging navigation'
     */
    WECjB: T;

    /**
     * @default '{{0}} selected'
     */
    pGpPG: T;

    /**
     * @default 'Deselect'
     */
    hqp16: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'General'
     */
    ojXaZ: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'Text Blast'
     */
    jYY9B: T;

    /**
     * @default 'RSVP Reminder'
     */
    d6QBS: T;

    /**
     * @default 'Hotel Reminder'
     */
    kNSK9: T;

    /**
     * @default 'Collect Stay Details'
     */
    zlvRR: T;

    /**
     * @default 'Contact Collection'
     */
    cYJPu: T;

    /**
     * @default 'All'
     */
    '5WTAA': T;

    /**
     * @default 'Sorry, something went wrong'
     */
    kkwz0: T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Message Type'
     */
    nyjD3: T;

    /**
     * @default 'Recipients'
     */
    krwxH: T;

    /**
     * @default 'Last Updated'
     */
    lVU0Z: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Select all drafts'
     */
    Re8vp: T;

    /**
     * @default 'Select draft'
     */
    TXzQA: T;

    /**
     * @default 'Search drafts…'
     */
    mjE4D: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'New…'
     */
    K9QMA: T;

    /**
     * @default 'Loading drafts…'
     */
    E2mNi: T;

    /**
     * @default 'We couldn't load your drafts.'
     */
    hwVNL: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Your drafts can't be opened right now'
     */
    K3mmb: T;

    /**
     * @default 'They were written in the new message editor, which isn't available at the moment. They're saved as they were — check back soon to pick up where you left off.'
     */
    '6uv6M': T;

    /**
     * @default 'No drafts yet.'
     */
    fTGQ3: T;

    /**
     * @default 'Drafts you start show up here until you send them.'
     */
    UKiwW: T;

    /**
     * @default 'No drafts matching "{{0}}"'
     */
    kGCGg: T;

    /**
     * @default 'No drafts match the selected filter'
     */
    eA4Ao: T;

    /**
     * @default 'Try a different search term or filter'
     */
    QOkTu: T;

    /**
     * @default 'Deselect all drafts'
     */
    Ogc74: T;

    /**
     * @default 'Deselect all'
     */
    GU5cs: T;

    /**
     * @default 'Select all'
     */
    dqkoI: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Select…'
     */
    '6Kcu4': T;

    /**
     * @default 'Delete 1 draft?'
     */
    gwJA7: T;

    /**
     * @default 'Delete {{0}} drafts?'
     */
    ADVh7: T;

    /**
     * @default 'This can't be undone.'
     */
    rwANi: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Pick a date within the next year.'
     */
    '4ChIg': T;

    /**
     * @default 'Pick a time at least {{0}} minutes from now.'
     */
    g2jG7: T;

    /**
     * @default 'Times shown in {{0}}{{1}}'
     */
    VEfaR: T;

    /**
     * @default '1 scheduled message didn't send'
     * @param {number} count - The number of occurrences.
     * - singular: 1 scheduled message didn't send
     * - plural: {{0}} scheduled messages didn't send
     */
    O9PnQ: T;

    /**
     * @default 'This message is already being sent.'
     */
    MEZgA: T;

    /**
     * @default 'Scheduled For'
     */
    gIwfk: T;

    /**
     * @default 'Sending shortly…'
     */
    rSbYp: T;

    /**
     * @default 'Preparing'
     */
    '2DgRI': T;

    /**
     * @default 'Soon'
     */
    tXCNA: T;

    /**
     * @default 'Sending…'
     */
    wVCSV: T;

    /**
     * @default 'Reschedule'
     */
    '82rNl': T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'Tap a failed message below to fix and resend.'
     */
    pQrKN: T;

    /**
     * @default 'Loading scheduled messages…'
     */
    zH2IR: T;

    /**
     * @default 'We couldn't load your scheduled messages.'
     */
    YRPeI: T;

    /**
     * @default 'Nothing scheduled yet.'
     */
    mFBdd: T;

    /**
     * @default 'Schedule messages to send later and you'll see them here.'
     */
    OY2Wn: T;

    /**
     * @default 'Reschedule send'
     */
    qm0u7: T;

    /**
     * @default 'Delete scheduled message?'
     */
    oKfJ8: T;

    /**
     * @default 'It won't be sent. This can't be undone.'
     */
    uCrVL: T;

    /**
     * @default 'Message deleted.'
     */
    OwhV0: T;

    /**
     * @default 'Rescheduled for {{0}}'
     */
    TI5PA: T;

    /**
     * @default 'Leave without scheduling?'
     */
    SM9jB: T;

    /**
     * @default 'This message is no longer scheduled. Save it as a draft, or schedule it to send.'
     */
    '2h1Lt': T;

    /**
     * @default 'Save Draft'
     */
    wabVI: T;

    /**
     * @default 'Schedule Send'
     */
    x1OLf: T;

    /**
     * @default 'This card's order isn't paid or is no longer active. Check it in the Cards area.'
     */
    tCDT4: T;

    /**
     * @default 'Failed: texting guests requires Messaging Plus'
     */
    LKwzD: T;

    /**
     * @default 'Failed: rich text emails require Messaging Plus'
     */
    ulG3E: T;

    /**
     * @default 'Failed: scheduling requires Messaging Plus'
     */
    VhDXN: T;

    /**
     * @default 'Failed: this message requires Messaging Plus'
     */
    '2yXSR': T;

    /**
     * @default 'Failed: another message used this event's remaining emails'
     */
    bIti6: T;

    /**
     * @default 'Failed: this message has more recipients than this event can email'
     */
    '2R3mq': T;

    /**
     * @default 'Failed: this event doesn't have enough emails left to send this'
     */
    eUtLL: T;

    /**
     * @default 'Failed: this event reached its daily email limit'
     */
    Xiv8c: T;

    /**
     * @default 'Failed: this event used all of its emails'
     */
    '9FyzC': T;

    /**
     * @default 'Failed: this message couldn't be verified'
     */
    LFMeH: T;

    /**
     * @default 'Failed: the guest list changed while it was sending'
     */
    x7RvH: T;

    /**
     * @default 'Failed: this card doesn't have enough recipients left to send this'
     */
    '5077v': T;

    /**
     * @default 'Failed: this card order doesn't include text messages'
     */
    YrW3O: T;

    /**
     * @default 'Failed: this card's order isn't paid or is no longer active'
     */
    p3Tce: T;

    /**
     * @default 'Failed: this card couldn't be loaded'
     */
    '5QKYc': T;

    /**
     * @default 'Failed: none of the guests on this message could be found'
     */
    '8UIom': T;

    /**
     * @default 'Failed to send'
     */
    O0TYq: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'This event has reached its total email limit.'
     */
    L8qqA: T;

    /**
     * @default 'This event can send {{0}} emails total. Try fewer recipients.'
     */
    PU4Zu: T;

    /**
     * @default 'Only {{0}} of {{1}} total emails remain. Try fewer recipients.'
     */
    XfdKM: T;

    /**
     * @default 'This event just reached its {{0}}-email total limit. Please try again.'
     */
    '5qDHj': T;

    /**
     * @default 'This event has used all {{0}} of its emails.'
     */
    YZsLJ: T;

    /**
     * @default 'Today's email limit is reached. Resets {{0}}.'
     */
    '2vtoF': T;

    /**
     * @default 'Today's email limit is reached. Please try again later.'
     */
    xLNLs: T;

    /**
     * @default 'Your daily limit is {{0}} emails. Upgrade to Messaging Plus.'
     */
    JwENl: T;

    /**
     * @default 'You can send {{0}} emails per day. Try fewer recipients.'
     */
    lhson: T;

    /**
     * @default '{{0}} of {{1}} daily emails left. Upgrade to Messaging Plus.'
     */
    sQJJr: T;

    /**
     * @default '{{0}} of {{1}} daily emails left. Send fewer, or wait until {{2}}.'
     */
    '0PYH0': T;

    /**
     * @default '{{0}} of {{1}} daily emails left. Try fewer recipients.'
     */
    fpRLw: T;

    /**
     * @default 'You just reached today's {{0}}-email limit. Please try again.'
     */
    NxyGf: T;

    /**
     * @default 'Daily limit of {{0}} emails reached. Upgrade to Messaging Plus.'
     */
    T2Icj: T;

    /**
     * @default 'Daily limit of {{0}} emails reached. Resets {{1}}.'
     */
    z1YTN: T;

    /**
     * @default 'Daily limit of {{0}} emails reached. Please try again later.'
     */
    '7cmsg': T;

    /**
     * @default 'Resets {{0}}.'
     */
    I45JB: T;

    /**
     * @default 'Dismiss alert'
     */
    '6Z1Vc': T;

    /**
     * @default '+{{0}} more alerts'
     */
    lQLVS: T;

    /**
     * @default 'N/A'
     */
    GgWAA: T;

    /**
     * @default 'History'
     */
    Afkgo: T;

    /**
     * @default 'View →'
     */
    TVjHd: T;

    /**
     * @default 'Close drawer'
     */
    '5RD9A': T;

    /**
     * @default 'Delivery'
     */
    yBnpo: T;

    /**
     * @default 'Resend'
     */
    X5zOS: T;

    /**
     * @default 'Resend the card'
     */
    OHl5l: T;

    /**
     * @default 'Choose the best way to reach {{0}}.'
     */
    '3vjSI': T;

    /**
     * @default 'Open not tracked'
     */
    tW0yi: T;

    /**
     * @default 'First viewed {{0}}'
     */
    gOU9U: T;

    /**
     * @default 'Show each channel for {{0}}'
     */
    UNwPF: T;

    /**
     * @default '{{0}} channels'
     */
    eRwYR: T;

    /**
     * @default 'Close and return to drafts'
     */
    wQ4CN: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Close and return to scheduled messages'
     */
    jBvTp: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'What would you like to send?'
     */
    '5shzK': T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Text message'
     */
    mSegh: T;

    /**
     * @default 'WhatsApp'
     */
    qJ8WP: T;

    /**
     * @default 'Draft'
     */
    L9AuF: T;

    /**
     * @default 'Sending'
     */
    '6XP44': T;

    /**
     * @default 'Partially Failed'
     */
    zisbF: T;

    /**
     * @default 'Digital Card'
     */
    epjCf: T;

    /**
     * @default 'General Message'
     */
    LWh4S: T;

    /**
     * @default 'Go back'
     */
    Pyxnt: T;

    /**
     * @default 'Message History'
     */
    bI7u7: T;

    /**
     * @default 'Close message history'
     */
    p2cGz: T;

    /**
     * @default 'No status history available'
     */
    ECb7M: T;

    /**
     * @default 'View Message →'
     */
    Q5LHy: T;

    /**
     * @default 'Undeliverable'
     */
    UjPJQ: T;

    /**
     * @default '1 message will be sent in the next 48 hours'
     * @param {number} count - The number of occurrences.
     * - singular: 1 message will be sent in the next 48 hours
     * - plural: {{0}} messages will be sent in the next 48 hours
     */
    O1l2S: T;

    /**
     * @default 'View Message'
     */
    k8XHH: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Message sent! It may take a few minutes to appear in your sent messages.'
     */
    j0aiM: T;

    /**
     * @default 'Card'
     */
    M1iKA: T;

    /**
     * @default 'Save the Dates, Invites, and more.'
     */
    r0pLA: T;

    /**
     * @default 'Reminders, texts, and emails.'
     */
    LT6VP: T;

    /**
     * @default 'Thank You Card'
     */
    f1sdv: T;

    /**
     * @default 'Enclosure Card'
     */
    odTgJ: T;

    /**
     * @default 'Email Message'
     */
    hyyx7: T;

    /**
     * @default 'Request Funds'
     */
    BYgHF: T;

    /**
     * @default 'Collect Contacts'
     */
    v9WNU: T;

    /**
     * @default 'Announce your date with a beautiful design'
     */
    qFTMv: T;

    /**
     * @default 'Invite guests with a custom card'
     */
    AchEx: T;

    /**
     * @default 'Send a designed thank-you card'
     */
    sGgRr: T;

    /**
     * @default 'Include extra details with an enclosure card'
     */
    llaaL: T;

    /**
     * @default 'Nudge guests who haven't responded yet'
     */
    rm48q: T;

    /**
     * @default 'Remind guests to book their hotel room'
     */
    JeAaG: T;

    /**
     * @default 'Ask guests to share where they're staying'
     */
    g7ote: T;

    /**
     * @default 'Start with an empty email'
     */
    gE8fE: T;

    /**
     * @default 'Send an SMS to your guests'
     */
    LRije: T;

    /**
     * @default 'Ask guests to contribute to your cash fund'
     */
    iws17: T;

    /**
     * @default 'Gather contact info from your guests'
     */
    VeW0m: T;

    /**
     * @default 'RSVP closes in {{0}} days — {{1}} guests haven't responded'
     */
    B43aK: T;

    /**
     * @default 'Send Reminder'
     */
    '2juHR': T;

    /**
     * @default 'Edit scheduled message?'
     */
    JFbie: T;

    /**
     * @default 'This will pause the scheduled send time. You can reschedule it after editing.'
     */
    LEW4W: T;

    /**
     * @default 'Pause and Edit'
     */
    LaESM: T;

    /**
     * @default '1 Text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Text
     * - plural: {{0}} Texts
     */
    AF6wP: T;

    /**
     * @default '1 {{0}}'
     * @param {number} count - The number of occurrences.
     * - singular: 1 {{0}}
     * - plural: {{0}} {{1}}
     */
    uaGyV: T;

    /**
     * @default '1 Email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Email
     * - plural: {{0}} Emails
     */
    '06HnF': T;

    /**
     * @default 'Note: 1 guest can't be reached on their selected delivery method.'
     * @param {number} count - The number of occurrences.
     * - singular: Note: 1 guest can't be reached on their selected delivery method.
     * - plural: Note: {{0}} guests can't be reached on their selected delivery method.
     */
    Q9Sex: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default '1 SMS'
     * @param {number} count - The number of occurrences.
     * - singular: 1 SMS
     * - plural: {{0}} SMS
     */
    '78B66': T;

    /**
     * @default 'Note: 1 guest does not have an email address.'
     * @param {number} count - The number of occurrences.
     * - singular: Note: 1 guest does not have an email address.
     * - plural: Note: {{0}} guests do not have an email address.
     */
    ycS8V: T;

    /**
     * @default 'Note: 1 guest does not have a phone number.'
     * @param {number} count - The number of occurrences.
     * - singular: Note: 1 guest does not have a phone number.
     * - plural: Note: {{0}} guests do not have a phone number.
     */
    osiPk: T;

    /**
     * @default 'Send Test SMS'
     */
    P33MK: T;

    /**
     * @default 'Sending {{0}} at {{1}}'
     */
    MvwA5: T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'This message has already sent.'
     */
    zKtaA: T;

    /**
     * @default 'Rescheduled.'
     */
    '2SxSH': T;

    /**
     * @default 'Now'
     */
    CFXAA: T;

    /**
     * @default 'Pick a date & time'
     */
    FLtdY: T;

    /**
     * @default 'Remember to replace or remove this photo placeholder. It won't be sent.'
     */
    RL0MO: T;

    /**
     * @default 'Add photo'
     */
    bytvM: T;

    /**
     * @default 'Remove photo'
     */
    GVJ3h: T;

    /**
     * @default 'Default Photo Removed'
     */
    j9AH3: T;

    /**
     * @default 'To add a photo to your message, go back and replace it.'
     */
    JTgrJ: T;

    /**
     * @default 'Replace Photo'
     */
    '6czvN': T;

    /**
     * @default 'This template photo won't be sent. Add your own to include one.'
     */
    T4DYd: T;

    /**
     * @default 'Holiday Card'
     */
    '6t7Pp': T;

    /**
     * @default 'Custom Card'
     */
    DT6YD: T;

    /**
     * @default 'Today {{0}}'
     */
    VIV3I: T;

    /**
     * @default 'Yesterday {{0}}'
     */
    q0iKk: T;

    /**
     * @default 'Message not found'
     */
    '2YV7J': T;

    /**
     * @default 'Message image'
     */
    gwe4X: T;

    /**
     * @default 'Text Message'
     */
    OKKVT: T;

    /**
     * @default '1 sent'
     * @param {number} count - The number of occurrences.
     * - singular: 1 sent
     * - plural: {{0}} sent
     */
    pQFzq: T;

    /**
     * @default '1 scheduled'
     * @param {number} count - The number of occurrences.
     * - singular: 1 scheduled
     * - plural: {{0}} scheduled
     */
    HMla0: T;

    /**
     * @default '{{0}} of 1 recipient left'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} of 1 recipient left
     * - plural: {{0}} of {{1}} recipients left
     */
    '5BZGC': T;

    /**
     * @default 'Review Scheduled Message'
     */
    iXF6X: T;

    /**
     * @default 'This message is locked while it's scheduled. Use "Edit Message" to make changes.'
     */
    W23tA: T;

    /**
     * @default 'This message is in draft mode. Schedule it to send.'
     */
    x0Ktf: T;

    /**
     * @default 'Send Time'
     */
    H3CBO: T;

    /**
     * @default 'Edit send time'
     */
    nalhG: T;

    /**
     * @default 'Send time'
     */
    PD2FO: T;

    /**
     * @default 'No drafts yet'
     */
    '72xub': T;

    /**
     * @default 'No scheduled messages'
     */
    IhS1c: T;

    /**
     * @default 'No sent messages yet'
     */
    d8XK3: T;

    /**
     * @default 'Untitled message'
     */
    aQ3t6: T;

    /**
     * @default 'View All'
     */
    MkQe0: T;

    /**
     * @default 'Scroll left'
     */
    ITQ7X: T;

    /**
     * @default 'Scroll right'
     */
    N2BXC: T;

    /**
     * @default 'Copy card link for {{0}}, {{1}}'
     */
    jy2eP: T;

    /**
     * @default 'Copy card link for {{0}}'
     */
    Wyc99: T;

    /**
     * @default 'Send {{0}}, {{1}}'
     */
    x3vrZ: T;

    /**
     * @default 'Send {{0}}'
     */
    '8BuZ0': T;

    /**
     * @default 'Ordered {{0}}'
     */
    zdfwJ: T;

    /**
     * @default 'Last sent {{0}}'
     */
    aopAA: T;

    /**
     * @default 'Not sent yet'
     */
    '7dBpw': T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Your Cards'
     */
    OH3WP: T;

    /**
     * @default 'Digital cards you buy appear here, ready to send.'
     */
    Pr6W8: T;

    /**
     * @default 'Browse Cards'
     */
    Zhu8B: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Delivered'
     */
    SbKKi: T;

    /**
     * @default 'Method'
     */
    Jm79E: T;

    /**
     * @default 'Search recipients…'
     */
    mCcAk: T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default 'Sent from Cards'
     */
    fu4LT: T;

    /**
     * @default 'Sent from Messaging'
     */
    mrJ10: T;

    /**
     * @default '{{0}} · {{1}} · {{2}}'
     */
    xu9dB: T;

    /**
     * @default 'All sends'
     */
    SmMiN: T;

    /**
     * @default 'Message Details'
     */
    bk8P0: T;

    /**
     * @default 'Recipient Name'
     */
    yNxhf: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Viewed'
     */
    CthHd: T;

    /**
     * @default 'Create Message'
     */
    '1Ev4j': T;

    /**
     * @default 'Your Templates'
     */
    gZiJL: T;

    /**
     * @default 'Messages'
     */
    suCiD: T;

    /**
     * @default 'Explore Paper & Digital Cards'
     */
    ECwXK: T;

    /**
     * @default 'Reminders, updates, and more.'
     */
    JzCyR: T;

    /**
     * @default 'New Email'
     */
    YbEQY: T;

    /**
     * @default 'Send an SMS to your guests.'
     */
    Zjf5M: T;

    /**
     * @default 'New Text Message'
     */
    eXdob: T;

    /**
     * @default 'New Card'
     */
    OVIUG: T;

    /**
     * @default 'New Message'
     */
    '19DPE': T;

    /**
     * @default 'Nothing sent yet.'
     */
    '5MwcH': T;

    /**
     * @default 'When you send invitations, reminders, and updates, you'll see them here.'
     */
    S90zL: T;

    /**
     * @default 'What do you want to send first?'
     */
    y4Gtc: T;

    /**
     * @default 'Date Sent'
     */
    '0mqzQ': T;

    /**
     * @default 'We couldn't refresh your messages. Showing the most recent data we have.'
     */
    '4iU9D': T;

    /**
     * @default 'Retry'
     */
    yGyzG: T;

    /**
     * @default 'We couldn't load your messages'
     */
    PANev: T;

    /**
     * @default 'Something went wrong on our end. Please try again.'
     */
    '4OH8c': T;

    /**
     * @default 'No messages matching "{{0}}"'
     */
    c69Hm: T;

    /**
     * @default 'No messages match the selected filters'
     */
    pg9B9: T;

    /**
     * @default 'Try a different search term or clear your filters'
     */
    V29pE: T;

    /**
     * @default 'Try a different search term'
     */
    ZikE6: T;

    /**
     * @default 'Try adjusting your filters'
     */
    wwoW3: T;

    /**
     * @default 'Clear all filters'
     */
    By7YR: T;

    /**
     * @default 'Basic'
     */
    cJkhF: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Plus'
     */
    ahjMA: T;

    /**
     * @default 'Failed to update messaging tier. Please try again.'
     */
    kPDEW: T;

    /**
     * @default 'Messaging Tier'
     */
    gL2iq: T;

    /**
     * @default 'Search messages…'
     */
    gecgK: T;

    /**
     * @default 'Superuser Settings (Not visible to Couples)'
     */
    '9QKxF': T;

    /**
     * @default 'Collapse'
     */
    f8LSD: T;

    /**
     * @default 'Expand'
     */
    atMUv: T;
  };
};

export type MothersDayDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Get Started with Joy Studio'
     */
    tOxxR: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Mother's Day card preview'
     */
    fKW8A: T;

    /**
     * @default 'Mother's Day, May 10th'
     */
    plKY3: T;

    /**
     * @default 'A card <em>only you</em><br>could send.'
     */
    CoZlx: T;

    /**
     * @default 'Turn a favorite photo into a Mother's Day card — <br>or one for any occasion.'
     */
    flxtn: T;

    /**
     * @default 'Add your favorite photo'
     */
    UH91R: T;

    /**
     * @default 'Browse cards with your illustration'
     */
    '0MioF': T;

    /**
     * @default 'Write your message'
     */
    jC8gL: T;

    /**
     * @default 'Share the way you'd like'
     */
    g9ZNn: T;
  };
};

export type MultiPhotoSelectorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    FG3cr: T;

    /**
     * @default 'Focus Point'
     */
    '4dv0n': T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Crop Photo'
     */
    EnCSr: T;
  };
};

export type PageNotFoundTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageNotFound: {
    /**
     * @default 'Error on Aisle 404'
     */
    textEyebrow: T;

    /**
     * @default 'Let’s get this cleaned up.'
     */
    textTitle: T;

    /**
     * @default 'That link doesn’t seem to exist.'
     */
    textInfoOne: T;

    /**
     * @default 'Double check it or try one of these options:'
     */
    textInfoTwo: T;

    /**
     * @default 'Find an Event'
     */
    findBtn: T;

    /**
     * @default 'Start a Registry'
     */
    registryBtn: T;

    /**
     * @default 'Explore the Joy Shop'
     */
    shopBtn: T;

    /**
     * @default 'Get Started with Joy'
     */
    getStartedBtn: T;

    /**
     * @default 'Need Help?'
     */
    helpBtn: T;

    /**
     * @default 'Home'
     */
    homeBtn: T;
  };
};

export type PageSettingsDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageSettingsDialog: {
    /**
     * @default '{{pageDisplayName}} Settings'
     */
    title: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Password Protected'
     */
    passwordProtected: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Please Note:'
     */
    passwordNoteTitle: T;

    /**
     * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordNoteMessage: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'Your password must be atleast 3 characters and only contain letters, numbers and '!', '&', '+'.'
     */
    passwordError: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Copy'
     */
    copy: T;

    /**
     * @default 'Title'
     */
    titleLabel: T;

    /**
     * @default 'Visibility'
     */
    visibility: T;

    /**
     * @default 'Require password for guest uploads'
     */
    requirePasswordForGuestPhotos: T;

    /**
     * @default 'Note: This will password-protect your entire event for guests using the Joy app.'
     */
    requirePasswordForGuestPhotosNote: T;

    /**
     * @default 'All Pages'
     */
    allPages: T;

    /**
     * @default 'Override your current page visibility settings and set them all to one option.'
     */
    allPagesNote: T;

    /**
     * @default 'Edit Page Photo'
     */
    editPagePhoto: T;

    /**
     * @default 'Copy Event Password'
     */
    copyEventPassword: T;

    /**
     * @default 'Please add a page title.'
     */
    pageTitleRequiredError: T;

    /**
     * @default 'Page title must be less than {{maxLength}} characters long.'
     */
    pageTitleMaxLengthError: T;

    /**
     * @default 'Delete Page'
     */
    deletePageCta: T;

    /**
     * @default 'Page Path'
     */
    pagePath: T;

    /**
     * @default 'Be sure to share the new URL with your guests if you've already shared a link to this page.'
     */
    pagePathNote: T;

    /**
     * @default '{{maxLength}} Max Chars'
     */
    pagePathMax: T;

    /**
     * @default 'This page path is available'
     */
    pagePathAvailable: T;

    /**
     * @default 'This page path is not available.'
     */
    pagePathNotAvailable: T;

    /**
     * @default 'Oops! Something went wrong. 
 Please reload the page and try again.'
*/
    pagePathError: T;

    /**
     * @default 'Coming Soon'
     */
    comingSoon: T;

    /**
     * @default 'Optional'
     */
    optional: T;

    /**
     * @default 'Allow Your Guests to Browse Hotels with Exclusive Rates'
     */
    areYouSure: T;

    /**
     * @default 'We've found that keeping this page on your website encourages guests to book early and confidently plan their attendance, knowing their stays are secured.'
     */
    disableAccommodationNote: T;

    /**
     * @default 'Lowest rates - up to 40% off'
     */
    lowestRatesPossible: T;

    /**
     * @default 'The best rates available through group discounts that is only through your website.'
     */
    lowestRatesPossibleNote: T;

    /**
     * @default 'Help guest decide on attendance'
     */
    helpOnAttendance: T;

    /**
     * @default 'We’ve seen it help out-of-town guests RSVP when they know where they will be staying.'
     */
    helpOnAttendanceNote: T;

    /**
     * @default 'Know where guests are staying'
     */
    whereGuestsAreStaying: T;

    /**
     * @default 'Plan your event better and know where guests will be staying.'
     */
    whereGuestsAreStayingNote: T;

    /**
     * @default 'Keep the Page'
     */
    keepPageCta: T;

    /**
     * @default 'Remove the Page'
     */
    continueCta: T;

    accommodationModalV2: {
      /**
       * @default 'Tests messaging focused on most-visited page angle - emphasizes that this is the most visited page and 80% of guests ask questions'
       */
      _comment: string;

      /**
       * @default 'This is the most visited page for guests.'
       */
      title: T;

      /**
       * @default 'We've found that on average 80% of guests ask questions about accommodations. Having suggestions helps them confidently plan their attendance.'
       */
      description: T;
    };
    accommodationModalV3: {
      /**
       * @default 'Tests messaging focused on RSVP speed benefit - emphasizes 25% faster RSVP rate for couples who list hotels'
       */
      _comment: string;

      /**
       * @default 'Couples who list hotels on Joy see a 25% faster RSVP rate'
       */
      title: T;

      /**
       * @default 'We've found that keeping this page on your website encourages guests to RSVP faster as they can confidently plan their attendance, knowing their stays are secured.'
       */
      description: T;
    };
    accommodationModalV4: {
      /**
       * @default 'Tests messaging focused on guest questions angle - emphasizes that 80% of guests will ask questions and hotel suggestions help'
       */
      _comment: string;

      /**
       * @default 'On average, 80% of guests will ask you questions about place to stay.'
       */
      title: T;

      /**
       * @default 'Couples who list hotels on Joy see a much faster RSVP response. Having hotel suggestions help your guests confidently plan their attendance.'
       */
      description: T;
    };

    /**
     * @default 'Edit Website Header'
     */
    editWebsiteHeader: T;

    customNativePageStep: {
      /**
       * @default 'Did you know?'
       */
      subtitleIntro: T;

      /**
       * @default 'There’s a page for this.'
       */
      subtitle: T;

      /**
       * @default 'We’re always looking to improve our built-in pages. Could you share what made you choose a custom one instead?'
       */
      feedbackSubtitle: T;

      /**
       * @default 'It didn’t work for me because…'
       */
      feedbackPlaceholder: T;

      useNativePage: {
        /**
         * @default 'Use "{{pageName}}" Page'
         */
        title: T;
      };
      useCustomPage: {
        /**
         * @default 'Empty Custom Page'
         */
        title: T;

        /**
         * @default 'Start with a generic blank page I’ll customize myself.'
         */
        subtitle: T;
      };
    };
  };
  quick: {
    /**
     * @default 'Some text couldn't be translated.'
     */
    EmgHU: T;

    /**
     * @default 'You've translated a lot of pages today. Try again tomorrow.'
     */
    xjgwm: T;

    /**
     * @default 'This page is too long to translate.'
     */
    gv08w: T;

    /**
     * @default 'We couldn't translate this page right now.'
     */
    P6v3G: T;

    /**
     * @default 'The copy will keep that text in the original language. You can edit it after the page is created.'
     */
    kfnKU: T;

    /**
     * @default 'You can still make a copy of this page without translating it.'
     */
    BWDwI: T;

    /**
     * @default 'Copy Anyway'
     */
    MmrdJ: T;

    /**
     * @default 'Try Again Later'
     */
    PwqeD: T;

    /**
     * @default '{{0}} (copy)'
     */
    E0A2e: T;

    /**
     * @default '{{0}} ({{1}})'
     */
    YPUxD: T;

    /**
     * @default 'Please add a page title.'
     */
    ZKPaS: T;

    /**
     * @default 'Page title must be less than {{0}} characters long.'
     */
    dvki5: T;

    /**
     * @default 'Please add a page path.'
     */
    '2THYp': T;

    /**
     * @default 'Page path must be less than {{0}} characters long.'
     */
    iGT5a: T;

    /**
     * @default 'Don't translate'
     */
    EzRRL: T;

    /**
     * @default 'Duplicate Page'
     */
    gOVuD: T;

    /**
     * @default 'Note: This copies the page's visibility, guest list access and content onto a new page.'
     */
    b96HU: T;

    /**
     * @default 'Wedding party members are shared with the original page, so changes to members show on both.'
     */
    nrSIr: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default '{{0}}/{{1}} maximum characters'
     */
    ERXIH: T;

    /**
     * @default 'Translate into'
     */
    afF39: T;

    /**
     * @default 'Text is translated once. Any future changes are not automatically translated. Photos, links, dates, and times stay the same.'
     */
    g5vvt: T;

    /**
     * @default 'We couldn't check this page path. Edit it to continue.'
     */
    '5hf0d': T;

    /**
     * @default 'Duplicate and Translate'
     */
    iDAkk: T;

    /**
     * @default 'Duplicate'
     */
    djRAg: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Translating…'
     */
    hEfZQ: T;

    /**
     * @default 'Don't duplicate'
     */
    NTivE: T;

    /**
     * @default 'Or duplicate an existing page'
     */
    Pik3P: T;

    /**
     * @default 'Couldn't load the password. Try again.'
     */
    XGBs8: T;

    /**
     * @default 'Password copied.'
     */
    xqQJ0: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Specific Guests'
     */
    '3Tybq': T;

    /**
     * @default 'All Pages'
     */
    zTZtK: T;

    /**
     * @default 'Override your current page visibility settings and set them all to one option.'
     */
    iMcs2: T;

    /**
     * @default 'Edit Website Header'
     */
    SqTJ2: T;

    /**
     * @default 'Edit Page Photo'
     */
    '3b7U6': T;

    /**
     * @default '{{0}} maximum characters'
     */
    Ou38X: T;

    /**
     * @default 'Visibility'
     */
    OZrIO: T;

    /**
     * @default 'Choose tags'
     */
    yVEpA: T;

    /**
     * @default 'Choose guests'
     */
    YcdNt: T;

    /**
     * @default 'Loading tags…'
     */
    BXm9R: T;

    /**
     * @default 'Loading guests…'
     */
    '1ZdDO': T;

    /**
     * @default 'Unnamed Guest'
     */
    s4P35: T;

    /**
     * @default 'No guests have the tag {{0}} yet. This page won't be visible to anyone until you assign guests to it from the guest list.'
     */
    RhAsQ: T;

    /**
     * @default 'No guests have the tags {{0}} yet. This page won't be visible to anyone until you assign guests to them from the guest list.'
     */
    B38Yp: T;

    /**
     * @default 'Event Password'
     */
    '9SjQp': T;

    /**
     * @default 'Hide password'
     */
    fHzwN: T;

    /**
     * @default 'Show password'
     */
    IMpuT: T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Show'
     */
    '5YANA': T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'password input'
     */
    LuDfw: T;

    /**
     * @default 'copy password'
     */
    MtXom: T;

    /**
     * @default 'Copy Event Password'
     */
    UoHgZ: T;

    /**
     * @default 'Your password must be atleast 3 characters and only contain letters, numbers and '!', '&', '+'.'
     */
    kE4zZ: T;

    /**
     * @default 'Please Note:'
     */
    Mfx1e: T;

    /**
     * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
     */
    VoaFJ: T;

    /**
     * @default 'Require password for guest uploads'
     */
    TaSaQ: T;

    /**
     * @default 'Note: This will password-protect your entire event for guests using the Joy app.'
     */
    PMNXJ: T;

    /**
     * @default 'This page can't be duplicated due to dynamic content.'
     */
    '7WY1b': T;

    /**
     * @default 'Delete Page'
     */
    kU5A1: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Did you know?'
     */
    '0ivyN': T;

    /**
     * @default 'There's a page for this.'
     */
    tinTv: T;

    /**
     * @default 'Use "{{0}}" Page'
     */
    i2ekg: T;

    /**
     * @default 'Empty Custom Page'
     */
    FHEQ8: T;

    /**
     * @default 'Start with a generic blank page I'll customize myself.'
     */
    kP0cC: T;

    /**
     * @default 'We're always looking to improve our built-in pages. Could you share what made you choose a custom one instead?'
     */
    Mst9d: T;

    /**
     * @default 'It didn't work for me because…'
     */
    Ry1E9: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Select tags to show this page only to those guests'
     */
    htvvy: T;

    /**
     * @default 'Add tags...'
     */
    '8pk9P': T;

    /**
     * @default 'Your website has reached the maximum number of pages. Delete a page you no longer need, then try again.'
     */
    r4wuN: T;

    /**
     * @default 'Couldn't duplicate this page. Try again.'
     */
    NrjnI: T;
  };
};

export type PeoplePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'No contact information'
     */
    tT4bc: T;

    /**
     * @default 'No phone number'
     */
    '6RUfl': T;

    /**
     * @default 'No email address'
     */
    FNAoO: T;

    /**
     * @default 'This number may not receive texts'
     */
    Eqnzu: T;

    /**
     * @default '{{0}}: sending'
     */
    K4sXh: T;

    /**
     * @default '{{0}}: available'
     */
    FtUqT: T;

    /**
     * @default 'Text: sending'
     */
    ht0Qt: T;

    /**
     * @default 'Text: available'
     */
    KBSqK: T;

    /**
     * @default 'Email: sending'
     */
    QhT0x: T;

    /**
     * @default 'Email: available'
     */
    dHBSw: T;

    /**
     * @default 'Select 0 People'
     * @param {number} count - The number of occurrences.
     * - zero: Select 0 People
     * - singular: Select 1 Person
     * - plural: Select {{0}} People
     */
    mtB3G: T;

    /**
     * @default 'Edit Guest List'
     */
    YzM5R: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default '1 person doesn't have a phone number and won't receive this message'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person doesn't have a phone number and won't receive this message
     * - plural: {{0}} people don't have a phone number and won't receive this message
     */
    H5DYv: T;

    /**
     * @default '1 person doesn't have an email address and won't receive this message'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person doesn't have an email address and won't receive this message
     * - plural: {{0}} people don't have an email address and won't receive this message
     */
    BrS6Q: T;

    /**
     * @default '1 person has no contact information and won't receive this message'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person has no contact information and won't receive this message
     * - plural: {{0}} people have no contact information and won't receive this message
     */
    LAVsB: T;

    /**
     * @default '1 selected guest is outside the pre-selected group'
     * @param {number} count - The number of occurrences.
     * - singular: 1 selected guest is outside the pre-selected group
     * - plural: {{0}} selected guests are outside the pre-selected group
     */
    ojWyI: T;

    /**
     * @default 'Preferred Delivery Method'
     */
    areNj: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Search by name or tag'
     */
    XCbAp: T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Show names'
     */
    bRpnz: T;

    /**
     * @default 'Tags'
     */
    RrHNA: T;

    /**
     * @default 'No tags were found. Add and edit tags in your'
     */
    '043kA': T;

    /**
     * @default 'guest list'
     */
    '4eKQC': T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'No guests were found. Add and edit guests in your'
     */
    '63RFT': T;

    /**
     * @default 'Selected'
     */
    '5gqDQ': T;

    /**
     * @default '1 text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 text
     * - plural: {{0}} texts
     */
    '6Y5Ig': T;

    /**
     * @default '1 email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 email
     * - plural: {{0}} emails
     */
    q7Mgd: T;

    /**
     * @default '1 undeliverable'
     * @param {number} count - The number of occurrences.
     * - singular: 1 undeliverable
     * - plural: {{0}} undeliverable
     */
    j5nFN: T;

    /**
     * @default '1 guest doesn't have the required contact info for the selected delivery method and won't receive this message.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest doesn't have the required contact info for the selected delivery method and won't receive this message.
     * - plural: {{0}} guests don't have the required contact info for the selected delivery method and won't receive this message.
     */
    iRTgK: T;

    /**
     * @default 'selected people'
     */
    S0Ryl: T;
  };
};

export type PeoplePickerButtonTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select Guests'
     */
    NFyEb: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'My Tags'
     */
    '5eeKP': T;

    /**
     * @default 'Missing email address'
     */
    C7JPB: T;

    /**
     * @default 'Missing phone number'
     */
    FIY7Q: T;

    /**
     * @default 'Phone number may be invalid'
     */
    '2pd44': T;

    /**
     * @default '{{0}}'s Guest'
     */
    m6E80: T;

    /**
     * @default 'Tags'
     */
    RrHNA: T;
  };
};

export type PhotoDownloadGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Your download has started'
     */
    yuNm6: T;

    /**
     * @default 'If it doesn't start in a few seconds, try again.'
     */
    aPLpx: T;

    /**
     * @default 'Download Again'
     */
    eBBBg: T;

    /**
     * @default 'This download link has expired'
     */
    dhowz: T;

    /**
     * @default 'Zips are kept for 7 days.'
     */
    rsrA1: T;

    /**
     * @default 'You can request a new one from your photos.'
     */
    bK7Mc: T;

    /**
     * @default 'To get a new one, open the album link you were shared and choose Download All.'
     */
    '0SMji': T;

    /**
     * @default 'Go to your photos'
     */
    Jc7ZB: T;

    /**
     * @default 'This download link isn't valid'
     */
    XaOpa: T;

    /**
     * @default 'Make sure you opened the full link from your email.'
     */
    Wh1pR: T;

    /**
     * @default 'Preparing your download…'
     */
    '1Ch6p': T;

    /**
     * @default 'Download photos'
     */
    Lpvyd: T;
  };
};

export type PhotoGalleryLayoutTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Grid'
     */
    g9OLA: T;

    /**
     * @default 'Masonry'
     */
    tgnUU: T;

    /**
     * @default 'Featured'
     */
    Sb94y: T;

    /**
     * @default 'Default'
     */
    NwmO1: T;

    /**
     * @default 'A clean, even photo layout'
     */
    MjIUq: T;

    /**
     * @default 'An editorial mix of sizes'
     */
    Vap7L: T;

    /**
     * @default 'Highlight one favorite photo'
     */
    MkCho: T;

    /**
     * @default 'Balanced for your photos'
     */
    FEipm: T;
  };
};

export type PhotoPickerDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Crop'
     */
    YonKA: T;

    /**
     * @default 'Rotate 90°'
     */
    seGif: T;

    /**
     * @default 'Edit preview'
     */
    GJvvB: T;

    /**
     * @default 'Add photos'
     */
    sTaFS: T;

    /**
     * @default 'Uploads are temporarily unavailable.'
     */
    SYQbf: T;

    /**
     * @default 'Preparing the uploader…'
     */
    RjEoj: T;

    /**
     * @default 'We can't crop this photo here. Convert it to JPEG or PNG and try again.'
     */
    obro4: T;

    /**
     * @default 'We couldn't crop this photo. Please try again.'
     */
    FFPIb: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Upload 1 photo'
     * @param {number} count - The number of occurrences.
     * - singular: Upload 1 photo
     * - plural: Upload {{0}} photos
     */
    GKSHI: T;

    /**
     * @default 'Reset'
     */
    PsxzG: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Upload'
     */
    FiLDb: T;

    /**
     * @default 'Your Library'
     */
    Ig7oB: T;

    /**
     * @default 'My Device'
     */
    cTSVO: T;

    /**
     * @default 'Phone'
     */
    '4pRqG': T;

    /**
     * @default 'Link (URL)'
     */
    WG0DN: T;

    /**
     * @default 'Unsplash Search'
     */
    WhSNL: T;

    /**
     * @default 'Facebook'
     */
    qGpB6: T;

    /**
     * @default 'Dropbox'
     */
    kZpFF: T;

    /**
     * @default 'Add photos from'
     */
    IF348: T;

    /**
     * @default 'Drag & drop your photos or videos'
     */
    gCTDg: T;

    /**
     * @default 'Drag & drop your photos'
     */
    bH2oe: T;

    /**
     * @default 'or click to browse your device'
     */
    BP8VF: T;

    /**
     * @default 'Paste a direct link to an image and we'll fetch it for you.'
     */
    rcoKy: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Enter a full image link starting with http:// or https://'
     */
    NJbPQ: T;

    /**
     * @default 'Search free high-resolution photos from Unsplash.'
     */
    qEHVP: T;

    /**
     * @default 'Search photos…'
     */
    NwxDK: T;

    /**
     * @default 'Searching…'
     */
    eghpU: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'No photos found. Try another search.'
     */
    ulVcs: T;

    /**
     * @default 'Photo by {{0}} on Unsplash'
     */
    ubGgA: T;

    /**
     * @default 'By {{0}}'
     */
    zOBCj: T;

    /**
     * @default 'Photo by'
     */
    '7Fhqq': T;

    /**
     * @default 'on'
     */
    '18AAA': T;

    /**
     * @default 'Pasted image'
     */
    mJ0UI: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Selected photos'
     */
    '6KWPC': T;

    /**
     * @default 'Remove all'
     */
    '1biwg': T;

    /**
     * @default 'Edited'
     */
    xVsrt: T;

    /**
     * @default 'Ready'
     */
    nlszG: T;

    /**
     * @default 'Processing…'
     */
    hzqwY: T;

    /**
     * @default 'Adding…'
     */
    bdT4Q: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Remove {{0}}'
     */
    '0zcyi': T;

    /**
     * @default 'Uploading…'
     */
    vVZ8O: T;

    /**
     * @default 'Edit Image'
     */
    j3bX2: T;

    /**
     * @default 'You can add up to 1 photo.'
     * @param {number} count - The number of occurrences.
     * - singular: You can add up to 1 photo.
     * - plural: You can add up to {{0}} photos.
     */
    a7oWA: T;

    /**
     * @default '1 file uploaded'
     * @param {number} count - The number of occurrences.
     * - singular: 1 file uploaded
     * - plural: {{0}} files uploaded
     */
    Ot3sf: T;

    /**
     * @default '1 photo uploaded'
     * @param {number} count - The number of occurrences.
     * - singular: 1 photo uploaded
     * - plural: {{0}} photos uploaded
     */
    '6zWFR': T;

    /**
     * @default 'Not signed in'
     */
    IbW7V: T;

    /**
     * @default 'The uploader is unavailable right now.'
     */
    jVLpO: T;

    /**
     * @default 'Unsupported format'
     */
    '2gxF0': T;

    /**
     * @default '{{0}} files aren't supported yet. Please use JPG, PNG or MP4.'
     */
    DoMGE: T;

    /**
     * @default '{{0}} files aren't supported yet. Please convert to JPG or PNG first.'
     */
    VK7VP: T;

    /**
     * @default 'Could not start upload'
     */
    byJEk: T;

    /**
     * @default 'Videos aren't supported here. Please use a JPG or PNG photo.'
     */
    mKMZr: T;

    /**
     * @default 'Upload failed'
     */
    '6yP3V': T;

    /**
     * @default 'This is taking too long. Please try again.'
     */
    Bi1vV: T;

    /**
     * @default 'Could not import from Unsplash'
     */
    breTC: T;

    /**
     * @default 'Could not fetch the link'
     */
    PdzKN: T;

    /**
     * @default 'We couldn't add some photos. Please try again.'
     */
    vYZXY: T;

    /**
     * @default 'From link'
     */
    '8Dv0D': T;

    /**
     * @default 'Search failed'
     */
    Rr4kQ: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Select Photos'
     */
    rRf3x: T;

    /**
     * @default 'Pick the part of the image that you’d like to show on your site for all desktop devices.'
     */
    UyKOF: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Pick the part of the image that you’d like to show on your site for all mobile devices.'
     */
    '0jSCH': T;

    /**
     * @default 'Select Photo'
     * @param {number} count - The number of occurrences.
     * - zero: Select Photo
     * - singular: Select 1 Photo
     * - plural: Select {{0}} Photos
     */
    ubkwt: T;

    /**
     * @default 'Add to Album'
     */
    douf3: T;

    /**
     * @default 'Select Photo'
     */
    It1n8: T;

    /**
     * @default 'Desktop Crop'
     */
    a66yX: T;

    /**
     * @default 'Mobile Crop'
     */
    '4wt0O': T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Desktop'
     */
    UpyS2: T;

    /**
     * @default 'Mobile'
     */
    YsAvF: T;
  };
};

export type PhotoUploaderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} photo(s) failed to upload'
     */
    zECdN: T;

    /**
     * @default 'All photos successfully uploaded'
     */
    P3gVJ: T;

    /**
     * @default 'Upload failed — your photo storage has expired. Add storage to continue uploading.'
     */
    YdsWU: T;

    /**
     * @default 'Add storage'
     */
    Mtjip: T;

    /**
     * @default 'You've reached the photo limit for this event.'
     */
    WVKo5: T;

    /**
     * @default 'Upgrade'
     */
    urQof: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    h4DHM: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    bJz4t: T;

    /**
     * @default 'Photos added to album.'
     */
    fVd3i: T;

    /**
     * @default 'Add photos to {{0}}'
     */
    tm8bp: T;

    /**
     * @default 'Add photos from this device'
     */
    me8FR: T;

    /**
     * @default 'Tap "Upload photos" below to add photos from this device.'
     */
    dVHbO: T;

    /**
     * @default 'Retry upload'
     */
    tJeny: T;

    /**
     * @default 'Upload more photos'
     */
    rDyXg: T;

    /**
     * @default 'Upload photos'
     */
    Q3G7w: T;

    /**
     * @default 'Powered by Joy'
     */
    '5NNq0': T;

    /**
     * @default 'Photo storage has expired'
     */
    uFiU6: T;

    /**
     * @default 'Session expired'
     */
    TppmS: T;

    /**
     * @default 'New photos can't be added until the event's photo storage is extended.'
     */
    mVbnS: T;

    /**
     * @default 'This QR code has expired. Ask for a new one to keep uploading.'
     */
    '509XL': T;

    /**
     * @default 'Add photos'
     */
    sTaFS: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    '32yZ1': T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'QR code to upload photos from your phone'
     */
    s8ziF: T;

    /**
     * @default 'Phone upload isn't available here.'
     */
    '1JfTv': T;

    /**
     * @default 'Couldn't start a phone upload session. Please try again.'
     */
    lX8aP: T;

    /**
     * @default 'This code has expired. Close and reopen to generate a new one.'
     */
    '5cqO1': T;

    /**
     * @default 'I'm done'
     */
    L8sGd: T;

    /**
     * @default 'Scan the code with your phone to add photos.'
     */
    tYinN: T;

    /**
     * @default 'Scan the code with your phone to add photos. The session ends in {{0}}.'
     */
    BCzth: T;

    /**
     * @default 'Copied!'
     */
    zRtI3: T;

    /**
     * @default 'Copy upload link'
     */
    GU6FD: T;
  };
};

export type PkpassGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'View Wedding Website'
     */
    QYudS: T;

    /**
     * @default 'We couldn't open your wallet pass from this link. Open the Add to Wallet link in your RSVP email again, or find the wedding details on the website.'
     */
    MVQXc: T;

    /**
     * @default 'We couldn't load your wallet pass. Please try again later. The wedding details are on the wedding website.'
     */
    YJZKk: T;

    /**
     * @default '{{0}} - Wallet pass'
     */
    '1wkzw': T;

    /**
     * @default 'Wallet pass'
     */
    eRxMe: T;

    /**
     * @default 'Save your wedding pass'
     */
    '5VC8K': T;

    /**
     * @default 'Keep the date, venue and wedding website on your phone.'
     */
    '1JZRN': T;

    /**
     * @default 'For the best experience, open this page on your phone.'
     */
    Tj41C: T;

    /**
     * @default 'Add to Apple Wallet'
     */
    v4IxF: T;

    /**
     * @default 'Add to Google Wallet'
     */
    mkFkU: T;

    /**
     * @default 'Google Wallet isn't available for this pass yet.'
     */
    msROe: T;

    /**
     * @default 'We couldn't add your pass to Google Wallet. Try again in a moment.'
     */
    vuzH3: T;

    /**
     * @default 'This ticket was canceled, so a wallet pass isn't available anymore'
     */
    ohwGD: T;

    /**
     * @default 'Your wallet pass link has expired. Please request a new link from your ticket email.'
     */
    T3rG5: T;

    /**
     * @default 'We couldn't load your pass. Please use the link from your ticket email.'
     */
    Bxp2P: T;

    /**
     * @default 'Save Your Ticket'
     */
    MZqYO: T;

    /**
     * @default 'You'll need to use your mobile device to save this ticket.'
     */
    BT86o: T;

    /**
     * @default 'Wedding'
     */
    YtFsf: T;

    /**
     * @default 'The wedding of'
     */
    '0wbzn': T;

    /**
     * @default 'When'
     */
    '8rlNA': T;

    /**
     * @default 'Where'
     */
    rcEPH: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'Time'
     */
    vAKNA: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Event'
     */
    '8FmzF': T;

    /**
     * @default 'Ticket type'
     */
    EJ5Yr: T;

    /**
     * @default 'View Event'
     */
    '5WK5D': T;

    /**
     * @default 'Copy URL'
     */
    UnwvO: T;

    /**
     * @default 'Download PDF'
     */
    EfpdB: T;
  };
};

export type PlaceToStayComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Please add an address'
     */
    WTsxe: T;

    /**
     * @default 'Please select an address from the dropdown'
     */
    ZmjX1: T;

    /**
     * @default 'Please search for a hotel'
     */
    sWJYp: T;

    /**
     * @default 'Please enter a valid URL.'
     */
    oFDkI: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Are you sure you want to delete this place to stay?'
     */
    tWwMI: T;

    /**
     * @default 'The contents of this section will be lost. This action can't be undone.'
     */
    Ddyiq: T;

    /**
     * @default 'Delete Place to Stay'
     */
    aDWC0: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Place to stay has been deleted.'
     */
    c1FTv: T;

    /**
     * @default 'An error occurred while deleting this place to stay. Please try again.'
     */
    PApPT: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'What's Place to Stay'
     */
    TwBQK: T;

    /**
     * @default 'Quick add hotels or other stays with photos, addresses, and notes.'
     */
    HHfQP: T;

    /**
     * @default 'Place to Stay'
     */
    DpU5D: T;

    /**
     * @default 'Edit Place to Stay'
     */
    '7Yj5u': T;

    /**
     * @default 'Add Place to Stay'
     */
    O0HA1: T;

    /**
     * @default 'Update the hotel suggestion for your guests.'
     */
    Zz71B: T;

    /**
     * @default 'Add a hotel suggestion for your guests to make their trip planning easier.'
     */
    Ryz2N: T;

    /**
     * @default 'Search for a hotel'
     */
    UnhAH: T;

    /**
     * @default 'Renaissance Chelsea, New York'
     */
    '0EEYY': T;

    /**
     * @default 'Side by side simple'
     */
    x75ov: T;

    /**
     * @default 'Side by side elegant'
     */
    '3TJIP': T;

    /**
     * @default 'Full width photo'
     */
    D9Rsr: T;

    /**
     * @default 'Flashlight'
     */
    kLQdg: T;

    /**
     * @default 'Select Layout'
     */
    ANUvm: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Booking link'
     */
    X4Knc: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Note for Guests'
     */
    ijXsE: T;

    /**
     * @default 'A note to share with your guests about this hotel.'
     */
    wYK19: T;
  };
};

export type PlaceToStayGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'View Hotel'
     */
    VnGJE: T;
  };
};

export type PlanningAccommodationsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  browse: {
    /**
     * @default 'Venue'
     */
    venue: T;

    /**
     * @default 'Show More'
     */
    showMore: T;

    /**
     * @default 'Add Manually'
     */
    addCustomLink: T;

    /**
     * @default 'Can't find your hotel? Add your own listing.'
     */
    cantFindHotel: T;

    /**
     * @default 'Our Top Picks'
     */
    filterPopularity: T;

    /**
     * @default 'Distance'
     */
    filterDistance: T;

    /**
     * @default 'Top Picks'
     */
    topPicks: T;

    /**
     * @default '{{ price }} / night'
     */
    pricePerNight: T;

    /**
     * @default 'An error occurred while updating hotel order. Please try again.'
     */
    changeBlockOrderFailed: T;

    /**
     * @default '{{ count }} hotels near the venue'
     */
    hotelsNear: T;

    /**
     * @default 'Price'
     */
    price: T;

    /**
     * @default 'Rating'
     */
    rating: T;

    hotelItem: {
      /**
       * @default 'Add Hotel'
       */
      addHotelTxt: T;

      /**
       * @default 'miles away'
       */
      distance: T;

      /**
       * @default 'Remove Hotel'
       */
      removeHotelTxt: T;

      /**
       * @default 'Request Group Rates'
       */
      requestGroupRates: T;

      /**
       * @default 'View Your Request'
       */
      viewYourRequest: T;

      /**
       * @default 'Interested Property'
       */
      interestedLabel: T;

      /**
       * @default 'Read More'
       */
      readMore: T;

      /**
       * @default 'Read Less'
       */
      readLess: T;

      /**
       * @default 'Need a room block?'
       */
      preferredHotelTooltipTitle: T;

      /**
       * @default 'Get a room block with one of Joy's partner hotels and get the best group rates fast. We hand picked these properties based on reviews from other Joy couples, competitive rates, and a great fit for larger groups. '
       */
      preferredHotelTooltipDescription: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Room Block Requested'
       */
      roomBlockRequested: T;

      /**
       * @default 'Our Room Block'
       */
      ourRoomBlock: T;

      /**
       * @default 'Couple Favorite'
       */
      preferredHotelMobileViewLabel: T;

      /**
       * @default 'View Hotel'
       */
      viewHotel: T;

      /**
       * @default 'Group Rate'
       */
      groupRate: T;

      /**
       * @default 'Standard Price'
       */
      standardPrice: T;

      ratingCategory: {
        /**
         * @default 'Wonderful'
         */
        wonderful: T;

        /**
         * @default 'Excellent'
         */
        excellent: T;

        /**
         * @default 'Fabulous'
         */
        fabulous: T;

        /**
         * @default 'Very Good'
         */
        veryGood: T;

        /**
         * @default 'Good'
         */
        good: T;

        /**
         * @default 'Pleasant'
         */
        pleasant: T;

        /**
         * @default 'Fair'
         */
        fair: T;
      };

      /**
       * @default '{{miles}} miles away'
       */
      milesAway: T;

      /**
       * @default '{{minutes}} min walk'
       * @param {number} count - The number of occurrences.
       * - singular: {{minutes}} min walk
       * - plural: {{minutes}} min drive
       */
      venueDistance: T;

      /**
       * @default '{{rooms}} rooms'
       */
      roomsTotal: T;

      /**
       * @default 'Compared to'
       */
      comparedTo: T;

      /**
       * @default 'Starting at'
       */
      startingAt: T;

      /**
       * @default '{{reviews}} reviews'
       */
      reviews: T;
    };
    noResults: {
      /**
       * @default 'Sorry, no results found.'
       */
      label: T;

      /**
       * @default 'Update your search area to see hotel options.'
       */
      eyeBrow: T;
    };
    failedSearchApi: {
      /**
       * @default 'Sorry, something went wrong.'
       */
      label: T;

      /**
       * @default 'An error occurred while retrieving hotel information.'
       */
      eyeBrow: T;

      /**
       * @default 'Try Again'
       */
      cta: T;
    };
    manualItem: {
      /**
       * @default 'Not finding what you’re looking for?'
       */
      label: T;

      /**
       * @default 'Manually Add Hotel'
       */
      manualAddCTA: T;

      /**
       * @default 'Contact Concierge Team'
       */
      buttonCTA: T;

      /**
       * @default 'Chat'
       */
      intercomButtonCTA: T;
    };
    starRatingFilter: {
      /**
       * @default 'Star Rating'
       */
      title: T;

      /**
       * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
       */
      description: T;

      /**
       * @default 'Reset Filter'
       */
      resetFilter: T;

      /**
       * @default '{{ rating }} Star'
       */
      star: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    priceFilter: {
      /**
       * @default 'Price range'
       */
      title: T;

      /**
       * @default 'Nightly Price, includes all taxes and fees'
       */
      description: T;

      /**
       * @default 'Min'
       */
      min: T;

      /**
       * @default 'Max'
       */
      max: T;

      /**
       * @default 'Reset Filter'
       */
      resetFilter: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    sortComponent: {
      /**
       * @default 'Sort by'
       */
      title: T;

      /**
       * @default 'Top picks ranked by Joy using couple preferences, amenities, and venue distance.'
       */
      topPicksDescription: T;

      /**
       * @default 'Show hotels based on distance starting with the closest to your venue.'
       */
      distanceDescription: T;

      /**
       * @default 'Top Picks'
       */
      topPicks: T;

      /**
       * @default 'Distance from Venue'
       */
      distance: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    informativeDialog: {
      /**
       * @default 'What happens next?'
       */
      title: T;

      /**
       * @default 'Select hotels near your venue and let our concierge team do the work of negotiating discounted rates.'
       */
      item1: T;

      /**
       * @default 'Review your personalized hotel group rates with your personal concierge and select your favorite hotel for your guests.'
       */
      item2: T;

      /**
       * @default 'View Hotels'
       */
      btn: T;

      ourPicks: {
        /**
         * @default 'Why add hotels to your website?  ✨ '
         */
        title: T;

        picks: [
          {
            /**
             * @default 'Save Guests Money'
             */
            title: T;

            /**
             * @default 'Because we help millions of guests, we are able to get cheaper group rates than Expedia—up to 40% off nightly rates.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Something for Everyone'
             */
            title: T;

            /**
             * @default 'A range of price points that include hotels with the best event friendly amenities.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Stay Close to the Venue'
             */
            title: T;

            /**
             * @default 'Balancing travel time and distance, we’ve picked the most popular and conveniently located hotels near your event.'
             */
            subTitle: T;
          },
        ];
      };
    };
    addManuallyDialog: {
      /**
       * @default 'Manually add hotel'
       */
      title: T;

      /**
       * @default 'Search for hotels'
       */
      label: T;

      /**
       * @default 'Hotel Name'
       */
      placeholder: T;

      /**
       * @default 'Add Hotel'
       */
      addHotelCTA: T;

      /**
       * @default 'Remove Hotel'
       */
      removeHotelCTA: T;
    };

    /**
     * @default 'An error occurred while saving your accommodations place. Please try again.'
     */
    addAccommodationsPlaceFailed: T;

    /**
     * @default 'An error occurred while deleting your hotel. Please try again.'
     */
    deleteAccommodationsPlaceFailed: T;

    /**
     * @default '✨ Hotel added to page'
     */
    addedToPageSuccess: T;

    /**
     * @default '✨ Hotel removed from page'
     */
    removedFromPageSuccess: T;
  };
  hotelSearch: {
    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'Add dates'
     */
    addDates: T;

    /**
     * @default 'City or Venue'
     */
    cityOrVenue: T;

    /**
     * @default 'Check in'
     */
    checkInFallback: T;

    /**
     * @default 'Check out'
     */
    checkOutFallback: T;

    /**
     * @default 'Rooms Needed'
     */
    roomsNeeded: T;

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'Search For Hotels'
     */
    searchForHotels: T;

    /**
     * @default 'Search'
     */
    search: T;

    /**
     * @default 'Rooms needed'
     */
    roomsNeededLabel: T;

    /**
     * @default 'Just an estimate'
     */
    justAnEstimate: T;

    /**
     * @default 'More than 50'
     */
    moreThan50: T;
  };
};

export type PostcardRecipientsCustomizerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Add return address'
     */
    fyr5d: T;

    /**
     * @default 'Please confirm by ticking the checkbox.'
     */
    G2cnl: T;

    /**
     * @default 'Edit Guest Details'
     */
    '2JUaL': T;

    /**
     * @default 'Add Missing Address'
     */
    lqQty: T;

    /**
     * @default 'Postcard Preview'
     */
    oPcrg: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default 'Previous postcard'
     */
    xaObQ: T;

    /**
     * @default 'Next postcard'
     */
    B3vaC: T;

    /**
     * @default 'Edit Recipients'
     */
    QInCZ: T;

    /**
     * @default 'Recipient Addressing'
     */
    bMBSv: T;

    /**
     * @default 'Have your guests' addresses printed on the back of each postcard.'
     */
    qz6Qu: T;

    /**
     * @default 'FREE'
     */
    KQ6KA: T;

    /**
     * @default 'Print Addresses'
     */
    tfbOC: T;

    /**
     * @default 'Leave Blank'
     */
    f3Pd3: T;

    /**
     * @default 'Print Recipient Addresses'
     */
    K8lPI: T;

    /**
     * @default 'Select an option to upload your guests' addresses to be printed on the postcard.'
     */
    J7At0: T;

    /**
     * @default 'Skip and Add After Ordering'
     */
    tN9BE: T;

    /**
     * @default 'Select Recipients Now'
     */
    iuBQE: T;

    /**
     * @default 'How it works:'
     */
    JTmeh: T;

    /**
     * @default 'Select "Print Addresses" and place your order. You'll choose your recipients after the order is placed.'
     */
    '2FWCb': T;

    /**
     * @default 'After ordering, you'll be able to access your order and select your guests for postcard addressing from your Joy guest list or Contact Collector.'
     */
    Ujvnm: T;

    /**
     * @default 'Your order will be paused until we receive your addresses, and sent to print when you're ready.'
     */
    DlLZs: T;

    /**
     * @default 'Changed your mind? No problem! Send your order to be printed without recipient addressing at any time.'
     */
    zdi9k: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'I understand my order will be paused until I add recipient addressing or send it to print without it.'
     */
    UULDA: T;

    /**
     * @default 'Print Guest Addresses'
     */
    '57KZL': T;

    /**
     * @default 'These addresses will be printed on the postcards.'
     */
    X0V3a: T;

    /**
     * @default 'postcards'
     */
    NTvgT: T;

    /**
     * @default 'addressed'
     */
    dxfFS: T;

    /**
     * @default 'blank'
     */
    QUYII: T;

    /**
     * @default 'Add New Recipient'
     */
    SGSnE: T;

    /**
     * @default 'Next: Review'
     */
    NZGhm: T;

    /**
     * @default 'No recipients are selected. You can proceed to review and add recipient addresses after ordering.'
     */
    zmIHN: T;

    /**
     * @default 'Your Guest Name'
     */
    inNq6: T;

    /**
     * @default 'Your Guest Address'
     */
    l8u1M: T;

    /**
     * @default 'Will add later'
     */
    zJaw9: T;

    /**
     * @default 'Return address'
     */
    '0Xc66': T;

    /**
     * @default 'Show country in return address'
     */
    QDY7c: T;
  };
};

export type PostOfficeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Send General Message'
     */
    generic: T;

    /**
     * @default 'Send Reminder'
     */
    reminder: T;

    /**
     * @default 'Send Thank You'
     */
    thankyou: T;
  };
  emailEditor: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Don’t forget about the wedding rehearsal!'
     */
    emailSubjectPlaceholder: T;

    /**
     * @default 'Email Subject is required'
     */
    emailSubjectErrorMessage: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message to our guest'
     */
    messagePlaceholder: T;

    emailEditorOptions: [
      {
        /**
         * @default 'Include link to download Joy app'
         */
        hed: T;

        /**
         * @default 'Guests can view & share photos and stay up-to-date on the go.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Include link to your website'
         */
        hed: T;

        /**
         * @default 'Guests can visit your website for wedding details.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Include event password'
         */
        hed: T;

        /**
         * @default 'Guests need an event password to gain access to your website and app.'
         */
        dek: T;
      },
    ];

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Discard'
     */
    discardButtonText: T;

    /**
     * @default 'Unsaved Changes'
     */
    undavedChangesWarningHed: T;

    /**
     * @default 'Are you sure you want to stop editing your digital message? Doing so will discard all unsaved changes.'
     */
    undavedChangesWarningDek: T;

    /**
     * @default 'Password is required when you include link to download the Joy app.'
     */
    passwordToggleTooltip: T;

    /**
     * @default 'Sorry. Something went wrong. Try again later.'
     */
    saveDraftError: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Hello'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Include guest name(s)'
     */
    includeGuestNamesLabel: T;

    /**
     * @default 'Generating first draft...'
     */
    generatingDraft: T;
  };
  bottomSheet: {
    sendAndTrack: {
      /**
       * @default 'Send and Track'
       */
      title: T;

      /**
       * @default 'Keep an eye on replies and poke the slow pokes.'
       */
      description: T;

      /**
       * @default 'Send to 1 Person'
       */
      sendToSingular: T;

      /**
       * @default 'Send to {{count}} People'
       */
      sendTo: T;

      /**
       * @default 'Send to {{name}}'
       */
      sendToName: T;

      /**
       * @default 'Send to (No Guests Selected)'
       */
      sendToDisabled: T;
    };
    confirm: {
      /**
       * @default 'Your message has been sent'
       */
      title: T;

      /**
       * @default 'Your thank you note has been sent'
       */
      titleThankYou: T;

      /**
       * @default 'Your email has been sent to {{count}} guests. Track which guests have received and opened your card in Guest List.'
       */
      description: T;

      /**
       * @default 'An email has been sent to {{ name }}.'
       */
      descriptionThankYouName: T;

      /**
       * @default 'An email has been sent to {{ count }} People.'
       */
      descriptionThankYouCount: T;

      /**
       * @default 'Back to Dashboard'
       */
      button: T;

      /**
       * @default 'Thank Another Guest'
       */
      buttonThankYou: T;
    };
    designEmail: {
      /**
       * @default 'Design Email'
       */
      title: T;

      /**
       * @default 'Preview and edit your message to your guests.'
       */
      description: T;

      /**
       * @default 'Edit Email'
       */
      editEmail: T;
    };
    designEcard: {
      /**
       * @default 'Design Card'
       */
      title: T;

      /**
       * @default 'Upload your design and edit your message content.'
       */
      description: T;

      /**
       * @default 'Edit Card'
       */
      editEmail: T;
    };
    optionalTestEmail: {
      /**
       * @default 'Optional Test Email'
       */
      title: T;

      /**
       * @default 'Never hurts to make sure everything is just right.'
       */
      description: T;

      /**
       * @default 'Send Test'
       */
      sendTest: T;
    };
    selectRecipients: {
      /**
       * @default 'Select Recipients'
       */
      title: T;

      /**
       * @default 'Edit Guests'
       */
      editGuests: T;

      /**
       * @default 'Add Guests'
       */
      addGuests: T;

      /**
       * @default 'Share With a Link'
       */
      shareLink: T;

      /**
       * @default 'Easily share a direct link to your eCards with anyone.'
       */
      shareLinkDescription: T;

      /**
       * @default 'Copy Link'
       */
      shareLinkCTA: T;

      /**
       * @default 'Delivery Method'
       */
      deliveryMethod: T;

      /**
       * @default 'How would you like to share your eCard?'
       */
      deliveryMethodDescription: T;

      /**
       * @default 'Send by Email'
       */
      deliveryMethodEmailCTA: T;

      /**
       * @default 'Share with a Link'
       */
      deliveryMethodLinkCTA: T;
    };
  };
  defaults: {
    generic: {
      /**
       * @default 'A new outdoor location'
       */
      subject: T;

      /**
     * @default 'With the storm no longer in the forecast, we're happy to be able to move the reception outside.

After the ceremony, please arrive at the park by 6pm.'
*/
      message: T;

      /**
       * @default 'Hello'
       */
      salutation: T;
    };
    reminder: {
      /**
       * @default 'It's almost time…'
       */
      subject: T;

      /**
     * @default 'We know you're busy (trust us, we're planning a wedding, so we know busy), but we just wanted to send a friendly reminder about some of our wedding details.

We can't wait to see you at the wedding!'
*/
      message: T;

      /**
       * @default 'Hello'
       */
      salutation: T;
    };
    thankyou: {
      /**
       * @default 'Thank you!'
       */
      subject: T;

      /**
     * @default 'Thank you so much for celebrating with us on our special day! We are grateful for your presence, warm wishes, and generous gifts.

We look forward to our future together and making more memories with you!'
*/
      message: T;
    };
  };
  quick: {
    /**
     * @default 'No guests selected yet.'
     * @param {number} count - The number of occurrences.
     * - zero: No guests selected yet.
     * - singular: 1 guest selected.
     * - plural: {{0}} guests selected.
     */
    t0nZk: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Social'
     */
    XYZoV: T;

    /**
     * @default 'Select Guests'
     */
    NFyEb: T;

    /**
     * @default 'Plan your forever, better.'
     */
    NZaqE: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Terms and Conditions'
     */
    i5MF4: T;
  };
};

export type ProductSelectionDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  text: {
    /**
     * @default 'What would you like to use?'
     */
    title: T;

    /**
     * @default 'Select all that interest you. You can always change your mind later.'
     */
    subtitle: T;

    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Cards & Messaging'
     */
    invitations: T;

    /**
     * @default 'Guest List & RSVP'
     */
    guestList: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Your interests were updated successfully'
     */
    success: T;

    /**
     * @default 'An error occurred while updating your interests'
     */
    error: T;
  };
};

export type PromoCodeAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Promo Codes'
     */
    ZPI8O: T;

    /**
     * @default 'Create Code'
     */
    lxLYS: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'No promo codes yet. Create a discount code to share with your guests.'
     */
    NnPyv: T;

    /**
     * @default 'Code name is required'
     */
    zJ4jb: T;

    /**
     * @default 'Use letters and numbers only, no spaces'
     */
    NCoUi: T;

    /**
     * @default 'Enter a valid amount greater than 0'
     */
    Y0kdZ: T;

    /**
     * @default 'Percentage cannot exceed 100'
     */
    qNwSE: T;

    /**
     * @default 'Select at least one ticket type'
     */
    '0zOcP': T;

    /**
     * @default 'Usage limit can't be below the {{0}} uses so far'
     */
    Xdixo: T;

    /**
     * @default 'Enter a start date'
     */
    zaN98: T;

    /**
     * @default 'Enter an end date'
     */
    AZlC3: T;

    /**
     * @default 'Start date must be before end date'
     */
    aHqoN: T;

    /**
     * @default 'immutable'
     */
    qBcdJ: T;

    /**
     * @default '(optional)'
     */
    jghot: T;

    /**
     * @default 'Flat amount'
     */
    ZtfI2: T;

    /**
     * @default 'Percentage'
     */
    uOBRr: T;

    /**
     * @default 'Edit Promo Code'
     */
    '0ZnQB': T;

    /**
     * @default 'Create Promo Code'
     */
    '6FVDR': T;

    /**
     * @default 'Code name'
     */
    C9hs9: T;

    /**
     * @default 'Stored uppercase. Letters and numbers only.'
     */
    '9ANx0': T;

    /**
     * @default 'e.g. SUMMER25'
     */
    WzgtC: T;

    /**
     * @default 'Discount type'
     */
    VxEdN: T;

    /**
     * @default '% Percentage'
     */
    pnMh0: T;

    /**
     * @default '$ Flat amount'
     */
    hDPT0: T;

    /**
     * @default 'Amount'
     */
    '6xj0j': T;

    /**
     * @default 'Applies to'
     */
    H5bmc: T;

    /**
     * @default 'All ticket types'
     */
    I7c8F: T;

    /**
     * @default 'Specific tickets'
     */
    xg9PT: T;

    /**
     * @default 'Select tickets eligible for this promo code.'
     */
    lEzEe: T;

    /**
     * @default 'Sold out'
     */
    G6gzR: T;

    /**
     * @default 'Inactive'
     */
    JLePq: T;

    /**
     * @default 'Some selected tickets use a different currency than this code. The flat discount may not convert as expected.'
     */
    MRTTd: T;

    /**
     * @default 'Usage limit'
     */
    IgJHQ: T;

    /**
     * @default 'Max total tickets discounted'
     */
    LK7Wk: T;

    /**
     * @default 'e.g. 50'
     */
    lw2ae: T;

    /**
     * @default 'Active dates'
     */
    HhYb6: T;

    /**
     * @default 'Always active'
     */
    '5ac1O': T;

    /**
     * @default 'Until a date'
     */
    rapeo: T;

    /**
     * @default 'From a date'
     */
    '5byVx': T;

    /**
     * @default 'Between dates'
     */
    dtGGr: T;

    /**
     * @default 'This code never expires and is active immediately.'
     */
    GDYEU: T;

    /**
     * @default 'Start date'
     */
    CXqIJ: T;

    /**
     * @default 'End date'
     */
    DT2Gz: T;

    /**
     * @default 'Enable Auto Approve'
     */
    dGBpd: T;

    /**
     * @default 'When enabled, attendees who use this promo code are approved automatically, no review required.'
     */
    zPcBK: T;

    /**
     * @default 'Anyone with this code will bypass your guest approval process. Only share it with people you trust.'
     */
    Ae8nD: T;

    /**
     * @default 'Internal note'
     */
    ZlVKI: T;

    /**
     * @default '(optional · never shown to guests)'
     */
    '38Jdc': T;

    /**
     * @default 'e.g. Partner discount for sponsors'
     */
    PyA6y: T;

    /**
     * @default 'Auto approve attendees?'
     */
    yokCn: T;

    /**
     * @default 'Make sure you only share this promo code with people you trust. Anyone using it will be auto-approved.'
     */
    whypN: T;

    /**
     * @default 'Enable'
     */
    '5nLeu': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save changes'
     */
    KtA9U: T;

    /**
     * @default 'Create code'
     */
    t7AdS: T;

    /**
     * @default 'Delete promo code?'
     */
    '6uBfN': T;

    /**
     * @default 'will be removed from your list. All usage history is preserved permanently.'
     */
    xdwK4: T;

    /**
     * @default 'You can restore this code later if needed.'
     */
    '46Lkv': T;

    /**
     * @default 'Delete code'
     */
    '030D1': T;

    /**
     * @default '{{0}} off'
     */
    lhU5Z: T;

    /**
     * @default '{{0}} ticket types'
     */
    '9cB4r': T;

    /**
     * @default '{{0}} – {{1}}'
     */
    iFldr: T;

    /**
     * @default 'Expires {{0}}'
     */
    uvCfi: T;

    /**
     * @default 'From {{0}}'
     */
    SXEqF: T;

    /**
     * @default 'Uses'
     */
    AIWNA: T;

    /**
     * @default 'Remaining'
     */
    SePp9: T;

    /**
     * @default 'Discount given'
     */
    '2k3tS': T;

    /**
     * @default 'Active'
     */
    uFgDj: T;

    /**
     * @default 'Auto-approve'
     */
    hL05L: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Edit code'
     */
    '14HMg': T;

    /**
     * @default 'Deactivate'
     */
    g1L73: T;

    /**
     * @default 'Reactivate'
     */
    '0iY1k': T;

    /**
     * @default 'More options'
     */
    LeY4P: T;

    /**
     * @default 'Active {{0}} – {{1}}'
     */
    Odf2t: T;

    /**
     * @default 'Active from {{0}}'
     */
    '8WWvy': T;

    /**
     * @default 'Tickets discounted'
     */
    dughj: T;

    /**
     * @default 'Total discount given'
     */
    K2i2D: T;

    /**
     * @default 'Uses remaining'
     */
    qYuNh: T;

    /**
     * @default 'Back to Tickets'
     */
    rK90Q: T;

    /**
     * @default 'Auto-approve ON'
     */
    '257on': T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Usage history'
     */
    '3MaSL': T;

    /**
     * @default 'No usage recorded yet.'
     */
    eGSK5: T;

    /**
     * @default 'Order'
     */
    ocvmG: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Tickets'
     */
    r6mrI: T;

    /**
     * @default 'Discount'
     */
    '1Ydo3': T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Load more'
     */
    '5lJ2f': T;
  };
};

export type PromoCodeGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Have a promo code?'
     */
    '4O0Q4': T;

    /**
     * @default 'Code applied: {{0}}'
     */
    iNzQm: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default '{{0}} off'
     */
    lhU5Z: T;

    /**
     * @default 'Remove promo code'
     */
    KaoWD: T;

    /**
     * @default 'Enter code'
     */
    RGHPh: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Invalid code'
     */
    w99NA: T;

    /**
     * @default 'Promo: {{0}}'
     */
    h5qGI: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Order Summary'
     */
    '8XV9D': T;

    /**
     * @default 'Ticket price'
     */
    B9y59: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Your promo code is no longer valid. Please review your order and try again.'
     */
    I0Blz: T;

    /**
     * @default 'We couldn't verify your promo code. Please try again.'
     */
    lQq2a: T;
  };
};

export type PublishReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '🥳 Your website has been successfully published!'
     */
    rQbtw: T;

    /**
     * @default '😬 Failed to publish website. Please try again.'
     */
    QWLqh: T;

    /**
     * @default 'Your 'Where to Stay' page is hidden from guests. Enable it when you're ready to share.'
     */
    EUd3x: T;

    /**
     * @default 'Your 'Where to Stay' page is hidden from guests.'
     */
    '4VyRZ': T;

    /**
     * @default 'Update Visibility'
     */
    zIY9L: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Not seeing your design changes? Check that you've applied changes in the design page'
     */
    yAKtN: T;

    /**
     * @default 'Your website is hidden from guests for now. Publish it when you're ready to share.'
     */
    qDmAQ: T;

    /**
     * @default 'Your website is hidden from guests for now. Publish before sharing.'
     */
    Co1yR: T;

    /**
     * @default 'Publish Website'
     */
    C04Ki: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;
  };
};

export type QrCodeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Failed to generate QR code'
     */
    nxbUE: T;

    /**
     * @default 'QR code'
     */
    '2e50g': T;
  };
};

export type RegistrationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'An error occurred'
     */
    UY1ZW: T;

    /**
     * @default 'An error occurred while initializing registration form'
     */
    p5VtS: T;

    /**
     * @default 'No form templates available'
     */
    JsC7w: T;

    /**
     * @default 'Registration template not found in template list'
     */
    LC1zD: T;

    /**
     * @default 'Failed to create registration form'
     */
    l1Wrz: T;

    /**
     * @default 'An error occurred while creating registration form'
     */
    HlWoP: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'Published. Manage form visibility'
     */
    '51z1y': T;

    /**
     * @default 'Unpublished. Manage form visibility'
     */
    wLv2l: T;

    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Unpublished'
     */
    F7vbD: T;

    /**
     * @default 'Unpublish form'
     */
    mgugR: T;

    /**
     * @default 'Publish form'
     */
    VJegv: T;

    /**
     * @default 'Currently live and accepting responses'
     */
    bkITI: T;

    /**
     * @default 'Currently hidden from guests'
     */
    '7oCuq': T;

    /**
     * @default 'Forms'
     */
    H0k3F: T;

    /**
     * @default 'Tickets'
     */
    r6mrI: T;

    /**
     * @default 'Check In'
     */
    '3LfjP': T;

    /**
     * @default 'Payments'
     */
    b9CHm: T;

    /**
     * @default 'Registration navigation'
     */
    B3gtU: T;

    /**
     * @default 'Accepting responses'
     */
    uPSZi: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Flow'
     */
    AAELA: T;

    /**
     * @default 'Simulate'
     */
    C9Xm5: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Tracking'
     */
    dFG59: T;

    /**
     * @default 'Attendance'
     */
    DE1nO: T;

    /**
     * @default 'Yes'
     */
    '1GaAA': T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default 'Form published successfully'
     */
    zTD6P: T;

    /**
     * @default 'Form unpublished successfully'
     */
    Wx4hP: T;

    /**
     * @default 'Short Answer'
     */
    '0isuN': T;

    /**
     * @default 'Long Answer'
     */
    ufu35: T;

    /**
     * @default 'Multiple Choice'
     */
    xnpsD: T;

    /**
     * @default 'Email Address'
     */
    OgwcY: T;

    /**
     * @default 'Phone Number'
     */
    fwf1p: T;

    /**
     * @default 'Dropdown'
     */
    ntsqW: T;

    /**
     * @default 'Some tag changes could not be saved. Please try again.'
     */
    '4Aec9': T;

    /**
     * @default 'Option 1'
     */
    mEzAy: T;

    /**
     * @default 'Option 2'
     */
    nEzAy: T;

    /**
     * @default 'Enable form'
     */
    '57SSw': T;

    /**
     * @default 'When enabled, guests can access and submit the registration form.'
     */
    t6pcN: T;

    /**
     * @default 'Disabling the form will prevent guests from registering. Any existing registrations will remain unaffected.'
     */
    OiXQN: T;

    /**
     * @default 'Untitled'
     */
    rHPYf: T;

    /**
     * @default 'Next question'
     */
    z6ATf: T;

    /**
     * @default 'End form'
     */
    R7OHz: T;

    /**
     * @default 'Deleted question'
     */
    FtLLh: T;

    /**
     * @default 'Enable branching'
     */
    HUvvP: T;

    /**
     * @default 'Route each answer to a destination'
     */
    '43lfP': T;

    /**
     * @default 'This route points to a question that no longer exists. Guests will take this answer's usual path instead — pick a new destination.'
     */
    SGdBa: T;

    /**
     * @default '"{{0}}" is only visible to {{1}}. Guests without those tags will hit a dead end.'
     */
    QemBV: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Optional'
     */
    KozAy: T;

    /**
     * @default 'Fields'
     */
    RJKuw: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Address'
     */
    gDl5Q: T;

    /**
     * @default 'Visibility'
     */
    OZrIO: T;

    /**
     * @default 'Contact fields are always shown to everyone. They cannot be targeted to specific audiences.'
     */
    '7JrUi': T;

    /**
     * @default 'Contact Information'
     */
    ghluB: T;

    /**
     * @default 'Attendance (RSVP)'
     */
    zWnqE: T;

    /**
     * @default 'Edit Question'
     */
    gntTT: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Option {{0}}'
     */
    FKOI3: T;

    /**
     * @default 'Remove option {{0}}'
     */
    '3Wz4P': T;

    /**
     * @default 'Add Option'
     */
    GOEV3: T;

    /**
     * @default 'This is a follow-up to a question each guest answers individually, so it cannot be asked per group — guests in a party may answer the main question differently.'
     */
    f6LUH: T;

    /**
     * @default 'This question has a follow-up that is asked per group, so it cannot be asked to each guest.'
     */
    ETjDL: T;

    /**
     * @default 'Ask'
     */
    naTAA: T;

    /**
     * @default 'Question'
     */
    ubqly: T;

    /**
     * @default 'Enter your question...'
     */
    d3MIz: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Optional helper text shown below the question'
     */
    gIrWM: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Options'
     */
    Uw6kb: T;

    /**
     * @default 'Who sees it'
     */
    DiDgJ: T;

    /**
     * @default 'Audience tags aren't available while all questions show on one page — every guest sees the same list. Turn that setting off to target this question.'
     */
    '2X7hI': T;

    /**
     * @default 'Rules'
     */
    VTL2G: T;

    /**
     * @default 'Logic'
     */
    EvYXG: T;

    /**
     * @default 'Delete question'
     */
    voLQO: T;

    /**
     * @default 'Ask per group'
     */
    H2ALv: T;

    /**
     * @default 'Answered once for the guest's whole party'
     */
    Fh3t8: T;

    /**
     * @default 'Each guest answers individually'
     */
    GOO9J: T;

    /**
     * @default 'Include attendance question'
     */
    BVzwL: T;

    /**
     * @default 'Ask guests if they will attend'
     */
    lVoe7: T;

    /**
     * @default 'Attendance questions are special. Guests should answer this individually, in case not everyone in a group can attend.'
     */
    ptfkU: T;

    /**
     * @default 'Behavior'
     */
    YgmQM: T;

    /**
     * @default 'Every guest in your list must respond to this question. Their attendance status syncs directly to your guest list so you can track who's coming and who's not. Best for invite-only events like weddings, private dinners, or fixed attendee conferences. For open registration where submitting the form means attending, turn this off.'
     */
    ea6pQ: T;

    /**
     * @default '+ Add Question'
     */
    S5TO9: T;

    /**
     * @default 'Guests must RSVP. Best for invite-only events like weddings.'
     */
    v1ekH: T;

    /**
     * @default 'Everyone'
     */
    P9K6g: T;

    /**
     * @default 'Branching'
     */
    A2qMD: T;

    /**
     * @default ', '
     */
    '6XAAA': T;

    /**
     * @default 'Always first'
     */
    pQkIS: T;

    /**
     * @default 'Pinned'
     */
    g3lPN: T;

    /**
     * @default 'Drag to reorder'
     */
    UEgfY: T;

    /**
     * @default 'Untitled question'
     */
    ztmKY: T;

    /**
     * @default 'Only: {{0}}'
     */
    W79TM: T;

    /**
     * @default 'Questions'
     */
    h1BuU: T;

    /**
     * @default 'No custom questions yet'
     */
    '1mnsT': T;

    /**
     * @default 'Add a question to collect more information from your guests.'
     */
    WHcVe: T;

    /**
     * @default 'Add Question'
     */
    '7XvlO': T;

    /**
     * @default 'Issues to fix before publishing'
     */
    SQzyI: T;

    /**
     * @default '"{{0}}" → option "{{1}}" routes to "{{2}}" which is hidden from {{3}}'
     */
    FWgFm: T;

    /**
     * @default 'Close preview'
     */
    QKJ9Y: T;

    /**
     * @default 'Attach a calendar invite to RSVP confirmations'
     */
    T9iDq: T;

    /**
     * @default 'Guests who register as attending get the event added to their calendar in one tap. The confirmation email sends either way.'
     */
    tS4wg: T;

    /**
     * @default 'Registration confirmations send without a calendar invitation. Guests who already added the event keep it.'
     */
    tBoRh: T;

    /**
     * @default 'Custom Redirect for Attending Guests'
     */
    LzI51: T;

    /**
     * @default 'When enabled, guests who register as attending will be redirected to a custom URL after completing registration.'
     */
    c3xCO: T;

    /**
     * @default 'Please enter a valid URL starting with https://'
     */
    jgzsy: T;

    /**
     * @default 'Custom Redirect for Non-Attending Guests'
     */
    jf6xw: T;

    /**
     * @default 'When enabled, guests who register as not attending will be redirected to a custom URL after completing registration.'
     */
    nUDFP: T;

    /**
     * @default 'Enable the attendance question to use this setting.'
     */
    v0XRv: T;

    /**
     * @default 'Custom Redirect for Pending Guests'
     */
    GTzdz: T;

    /**
     * @default 'When enabled, guests who require approval will be redirected to a custom URL after completing registration.'
     */
    NqlYo: T;

    /**
     * @default 'Enable Require Attendee Approval to use this setting.'
     */
    '5PDKP': T;

    /**
     * @default 'Each guest can bring one other person, for a party of {{0}}.'
     * @param {number} count - The number of occurrences.
     * - singular: Each guest can bring one other person, for a party of {{0}}.
     * - plural: Each guest can bring up to {{0}} other people, for a party of {{1}}.
     */
    DwaFn: T;

    /**
     * @default 'Let guests add their own party'
     */
    HZNMI: T;

    /**
     * @default 'Not available for ticketed events — each guest needs their own ticket, so they register themselves.'
     */
    em3hK: T;

    /**
     * @default 'Guests register only themselves. You add anyone else to your guest list.'
     */
    '79BVP': T;

    /**
     * @default 'Guests can name the people they're bringing, and everyone they add joins your approval queue for review.'
     */
    opWg8: T;

    /**
     * @default 'Guests can name the people they're bringing, and everyone they add is added to your guest list and confirmed without review.'
     */
    LFVnX: T;

    /**
     * @default 'Party size limit'
     */
    CKf0A: T;

    /**
     * @default 'Decrease party size limit'
     */
    CcZFq: T;

    /**
     * @default 'Increase party size limit'
     */
    kS5cT: T;

    /**
     * @default 'Send registration updates to collaborators'
     */
    dmxeJ: T;

    /**
     * @default 'We could not load this setting. Refresh the page to try again.'
     */
    '9AcbB': T;

    /**
     * @default 'Add an email to your account before turning this off — otherwise no one would receive registration updates.'
     */
    '6OOmY': T;

    /**
     * @default 'You and your collaborators receive every RSVP, answers included.'
     */
    CBZKw: T;

    /**
     * @default 'You and your collaborators receive every registration update for this event.'
     */
    PfW7u: T;

    /**
     * @default 'Only you receive RSVPs and their answers. Collaborators won't get them.'
     */
    K0o0I: T;

    /**
     * @default 'Only you receive registration updates, including approval requests. Collaborators won't get them.'
     */
    ntKlk: T;

    /**
     * @default 'Require Attendee Approval'
     */
    AgPak: T;

    /**
     * @default 'Registrations are marked as pending and require your approval before guests are confirmed.'
     */
    kNUT2: T;

    /**
     * @default 'Attendees register and receive a ticket immediately.'
     */
    pxgN8: T;

    /**
     * @default 'Require approval for guests you add'
     */
    qMCUb: T;

    /**
     * @default 'Guests you add to your guest list also need your approval when they register.'
     */
    DZ7VA: T;

    /**
     * @default 'Guests you add to your guest list are confirmed automatically when they register.'
     */
    '0NVcF': T;

    /**
     * @default 'Make Registration look like my site'
     */
    SEXNT: T;

    /**
     * @default 'Match the registration form to the design of your website.'
     */
    '022go': T;

    /**
     * @default 'Show all questions on one page'
     */
    '7NAWf': T;

    /**
     * @default 'Not available for ticketed events — ticket selection and checkout keep their own steps, so questions stay one per screen.'
     */
    fWlId: T;

    /**
     * @default 'Not available while questions use audience tags — one page means every guest sees the same questions. Remove the tags to enable this.'
     */
    mRdqI: T;

    /**
     * @default 'Save or discard your tag changes first — this setting unlocks once they're persisted.'
     */
    xUpsT: T;

    /**
     * @default 'Checking this form's audience tags…'
     */
    JoFVN: T;

    /**
     * @default 'Guests see every question on one scrollable page and submit once. Questions that follow a choice appear as soon as it's answered.'
     */
    XtwSo: T;

    /**
     * @default 'Guests answer your questions one screen at a time.'
     */
    w1BUd: T;

    /**
     * @default 'Path Simulator'
     */
    RSYMU: T;

    /**
     * @default 'Walk through the form as a specific guest. Choose a tag, then simulate their answers to see exactly which path they'd take — including any branching logic.'
     */
    '36v1U': T;

    /**
     * @default 'Simulate as:'
     */
    ojMWH: T;

    /**
     * @default 'Branch end'
     */
    bFVQE: T;

    /**
     * @default '1 step in this guest's path'
     */
    '3WIiv': T;

    /**
     * @default '{{0}} steps in this guest's path'
     */
    zJlhU: T;

    /**
     * @default '1 step in this path'
     */
    xODfs: T;

    /**
     * @default '{{0}} steps in this path'
     */
    P6WfL: T;

    /**
     * @default 'Not visible to {{0}} — this guest would hit a dead end'
     */
    C7WTO: T;

    /**
     * @default 'Branched'
     */
    tpRRe: T;

    /**
     * @default 'Conflict'
     */
    qaXII: T;

    /**
     * @default 'Form ends here (thank you screen)'
     */
    MTgM8: T;

    /**
     * @default 'Thank you screen'
     */
    dzzwh: T;

    /**
     * @default 'Name, Email, Phone'
     */
    HaEl4: T;

    /**
     * @default 'Name, Email'
     */
    vxKgE: T;

    /**
     * @default '{{0}} · Branching'
     */
    '1F4hi': T;

    /**
     * @default 'Answer:'
     */
    s3bSX: T;

    /**
     * @default 'Goes to:'
     */
    '7CLzo': T;

    /**
     * @default 'Unable to load attendance data.'
     */
    PvGiK: T;

    /**
     * @default 'responses'
     */
    SQAmA: T;

    /**
     * @default 'ticket sold'
     * @param {number} count - The number of occurrences.
     * - singular: ticket sold
     * - plural: tickets sold
     */
    '9pPzj': T;

    /**
     * @default 'Unable to load ticket data.'
     */
    '20Wyp': T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Maybe'
     */
    eaVaG: T;

    /**
     * @default 'Pending'
     */
    XhQCC: T;

    /**
     * @default 'Declined'
     */
    kUvCR: T;

    /**
     * @default 'Form updated successfully'
     */
    IwUlp: T;

    /**
     * @default 'RSVP Settings'
     */
    a76AP: T;

    /**
     * @default 'Attendance Question'
     */
    bYFSy: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Enabled'
     */
    nS8tS: T;

    /**
     * @default 'Enable for RSVP experience where your guest list will contain all guests with their attendance status of attending and not going. Keep disabled for event registration where filling out the form means the guest is attending.'
     */
    OUGjw: T;

    /**
     * @default 'Ask all guests to RSVP, enabling you to track guests who cannot attend.'
     */
    '6DWSA': T;

    /**
     * @default 'Question {{0}}'
     */
    W3Iq4: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Please review and submit your responses'
     */
    '82fvl': T;

    /**
     * @default 'enabled'
     */
    DC5P2: T;

    /**
     * @default 'disabled'
     */
    mlxxC: T;

    /**
     * @default 'Form {{0}} successfully'
     */
    JC90g: T;

    /**
     * @default 'First and Last Name'
     */
    inBtG: T;

    /**
     * @default 'Name is required. When sending invitations via Joy or using our Smart links, this will be pre-filled from your guest list'
     */
    bedU9: T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Email is required. When sending invitations via Joy or using our Smart links, this will be pre-filled from your guest list'
     */
    qkOoJ: T;

    /**
     * @default 'Mailing Address'
     */
    RvleZ: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;
  };
};

export type RegistrationFormGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select a ticket'
     */
    Vgs0a: T;

    /**
     * @default 'Sorry, no tickets are currently available.'
     */
    OKJqA: T;

    /**
     * @default 'I will not attend the event'
     */
    ZmWmU: T;
  };
};

export type RegistrationPostRsvpTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'We sent a new code.'
     */
    IjKuH: T;

    /**
     * @default 'Almost done!'
     */
    '5p88K': T;

    /**
     * @default 'Want updates about this event? We'll email your RSVP confirmation and let you know if any of the details change.'
     */
    jXCtx: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'email@example.com'
     */
    Lp6KJ: T;

    /**
     * @default 'Please enter a valid email.'
     */
    '9bG0a': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Yes, keep me updated'
     */
    XyyOB: T;

    /**
     * @default 'By choosing “Yes, keep me updated”, I agree to receive communications about this event only. No spam.'
     */
    IF7TI: T;

    /**
     * @default 'Continue Without Texts'
     */
    hQEyN: T;

    /**
     * @default 'No, Thanks'
     */
    cROYO: T;

    /**
     * @default 'Mobile number'
     */
    bhM1e: T;

    /**
     * @default 'Update Mobile Number'
     */
    '4shs2': T;

    /**
     * @default 'Add a mobile number for texts'
     */
    aip6C: T;

    /**
     * @default 'Share with others in the party?'
     */
    ZPA0L: T;

    /**
     * @default 'Add their email and we'll send them their RSVP confirmation and a personal link to edit their response.'
     */
    bggKi: T;

    /**
     * @default 'Add their emails and we'll send them their RSVP confirmations and personal links to edit their responses.'
     */
    yKYnL: T;

    /**
     * @default 'Party member'
     */
    g8EED: T;

    /**
     * @default 'Email for {{0}}'
     */
    HUK7g: T;

    /**
     * @default 'Share details'
     */
    jN0oK: T;

    /**
     * @default 'By choosing “Share details”, I confirm I have permission to share this RSVP with the people I selected.'
     */
    '3UhLg': T;

    /**
     * @default 'By tapping “Yes, keep me updated”, I agree to receive SMS event reminders and updates from Joy at the phone number provided. Message frequency may vary. Standard message and data rates may apply. Reply STOP to opt out. Reply HELP for help. We will not share mobile information with third parties for promotional or marketing purposes. See our'
     */
    '3WOuJ': T;

    /**
     * @default 'Terms of Service'
     */
    PlP4t: T;

    /**
     * @default 'and'
     */
    '5bcAA': T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Verify your phone number'
     */
    j8512: T;

    /**
     * @default 'We sent a 6-digit code to {{0}}.'
     */
    lbUNU: T;

    /**
     * @default 'Verification code'
     */
    mYcRM: T;

    /**
     * @default 'Verify'
     */
    JQhzc: T;

    /**
     * @default 'Send Code Again'
     */
    pg9FJ: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Texts are available for US and Canadian numbers.'
     */
    AILCY: T;

    /**
     * @default 'Enter a valid mobile number.'
     */
    '4799R': T;

    /**
     * @default 'Too many codes requested. Try again later or continue without texts.'
     */
    CLwer: T;

    /**
     * @default 'We couldn't send a code right now.'
     */
    qME80: T;

    /**
     * @default 'That code didn't match. Try again.'
     */
    Ar985: T;

    /**
     * @default 'That code expired. Send a new one.'
     */
    yVuoL: T;

    /**
     * @default 'Too many tries. Send a new code or continue without texts.'
     */
    I4V6F: T;

    /**
     * @default 'We couldn't verify your number right now.'
     */
    jVsGR: T;
  };
};

export type RegistrationResumeGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'You’re almost there. Pay for your ticket to finish registering.'
     */
    SRfKm: T;

    /**
     * @default 'Sorry, that ticket sold out before you finished. Pick another to keep going.'
     */
    U6F4C: T;

    /**
     * @default 'Sales for this ticket have closed.'
     */
    NTgUG: T;

    /**
     * @default 'Sales for this ticket haven't opened yet.'
     */
    vm8qM: T;

    /**
     * @default 'This ticket is no longer available.'
     */
    TkUKE: T;

    /**
     * @default 'Complete Payment · {{0}}'
     */
    qSmMn: T;

    /**
     * @default 'Choose Another Ticket'
     */
    qMtkV: T;

    /**
     * @default 'Change my ticket or answers'
     */
    IuyGN: T;
  };
};

export type RegistryChecklistTranslations<T extends LeafNodeValue = TranslateFunction> = {
  zeroState: {
    /**
     * @default 'Need Some Ideas?'
     */
    title: T;

    /**
     * @default 'Use our checklist as a starting point to build your registry.'
     */
    subtitle: T;

    /**
     * @default 'Try Checklist'
     */
    primaryButton: T;

    /**
     * @default 'No Thanks'
     */
    secondaryButton: T;
  };
};

export type RegistryOnboardingSurveyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  newRegistryOnboardingCards: {
    'onbrd-reg-add-shipping-address': {
      /**
       * @default 'Where should we ship your gifts?'
       */
      title: T;

      /**
       * @default 'Add a shipping address'
       */
      titleV2: T;
    };
    'onbrd-reg-set-currency': {
      /**
       * @default 'Set registry currency'
       */
      title: T;

      /**
       * @default 'Set registry currency'
       */
      titleV2: T;
    };
    'reg-shop': {
      /**
       * @default 'Start shopping'
       */
      title: T;

      /**
       * @default 'Enjoy a 20% Registry Completion Discount'
       */
      titleV2: T;
    };
    'reg-browse-cash-funds': {
      /**
       * @default 'Explore zero-fee cash funds'
       */
      title: T;

      /**
       * @default 'Explore zero-fee cash funds'
       */
      titleV2: T;
    };
    'reg-connect-registries': {
      /**
       * @default 'Connect a registry from another store'
       */
      title: T;

      /**
       * @default 'Connect a registry from another store'
       */
      titleV2: T;
    };
    'onbrd-reg-install-browser-button': {
      /**
       * @default 'Install the Quick Add Button to shop anywhere'
       */
      title: T;

      /**
       * @default 'Install the Joy Quick Add Button to shop anywhere'
       */
      titleV2: T;
    };
    'onbrd-reg-add-external-gift': {
      /**
       * @default 'Add a gift from another store'
       */
      title: T;

      /**
       * @default 'Add a gift from another store'
       */
      titleV2: T;
    };
    'onboarding-invite-admin': {
      /**
       * @default 'Invite your partner'
       */
      title: T;

      /**
       * @default 'Invite your partner'
       */
      titleV2: T;
    };
    'onbrd-reg-download-app': {
      /**
       * @default 'Download the App and add gifts on the go'
       */
      title: T;

      /**
       * @default 'Download the mobile app and add gifts on the go'
       */
      titleV2: T;
    };
    'onbrd-reg-add-registry-photo': {
      /**
       * @default 'Select a photo for your registry'
       */
      title: T;

      /**
       * @default 'Select a registry photo'
       */
      titleV2: T;
    };
    'onbrd-reg-write-page-greeting': {
      /**
       * @default 'Write a page greeting'
       */
      title: T;

      /**
       * @default 'Write a page greeting'
       */
      titleV2: T;
    };
    'onbrd-reg-share-registry': {
      /**
       * @default 'Share your registry'
       */
      title: T;

      /**
       * @default 'Share your registry'
       */
      titleV2: T;
    };
  };
  newRegistryOnboardingMeta: {
    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default '{{completed}} / {{count}} done'
     */
    completedCards: T;
  };
};

export type RegistryOnboardingSurveyV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  ctaBlocks: {
    /**
     * @default 'Sounds good'
     */
    primaryCtaSoundsGood: T;

    /**
     * @default 'Skip Survey'
     */
    secondaryCTASkipSurvey: T;

    /**
     * @default 'Turn On Recommendations'
     */
    primaryCtaRecommend: T;

    /**
     * @default 'Turn on Cash Funds '
     */
    primaryCtaCashFunds: T;

    /**
     * @default 'All Done'
     */
    allDone: T;
  };
  intro: {
    /**
     * @default 'Recommendations'
     */
    eyebrowText: T;

    /**
     * @default 'Let’s Personalize Your Joy Registry Experience'
     */
    hed: T;

    /**
     * @default 'Let's personalize your shopping experience based on your interests. We'll make gift recommendations based on couples like you.'
     */
    dek: T;
  };
  collectGiftCatalogInterest: {
    /**
     * @default 'Browse the Best Gifts'
     */
    hed: T;

    /**
     * @default 'Enjoy shopping from over 10,000 best wedding gifts selected by our team and delivered right to your doorstep with free shipping.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Physical Gifts'
     */
    secondaryCta: T;
  };
  collectCashFundCatalogInterest: {
    /**
     * @default 'Zero-Fee Cash Funds'
     */
    hed: T;

    /**
     * @default 'No fees. No, really. From your honeymoon to your first home, make your dreams come true without paying pesky fees when you use your Paypal, Venmo, or CashApp account.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Cash Funds'
     */
    secondaryCta: T;
  };
  collectExperiencesCatalogInterest: {
    /**
     * @default 'Unforgettable Experiences'
     */
    hed: T;

    /**
     * @default 'Discover our Experience gifts and crowdfund memories that will last a lifetime. Learn to surf in Costa Rica, explore the open ocean on a private cruise, or hike across Yosemite National Park.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Experiences'
     */
    secondaryCta: T;
  };
  saveLater: {
    /**
     * @default 'Register Now, Save Later.'
     */
    hed: T;

    /**
     * @default 'Register now and save later with 20% off all remaining registry items.'
     */
    dek: T;

    /**
     * @default 'Love It'
     */
    primaryCta: T;

    /**
     * @default 'Not Interested in Saving Later'
     */
    secondaryCta: T;
  };
  browserButton: {
    /**
     * @default 'Your Universal Registry'
     */
    hed: T;

    /**
     * @default 'Shop on Joy or your favorite stores, connect another registry, and give guests one place to more easily shop from your wedding website.'
     */
    dek: T;

    /**
     * @default 'Not Interested'
     */
    secondaryCta: T;
  };
  giftsPersonalization: {
    /**
     * @default 'What are you interested in?'
     */
    hed: T;

    /**
     * @default 'We’ll help you find the best gifts from each category.'
     */
    dek: T;

    /**
     * @default 'Select Interests'
     */
    primaryCta: T;

    /**
     * @default 'Please choose your interests first.'
     */
    primaryCtaError: T;

    /**
     * @default 'Maybe Later'
     */
    secondaryCta: T;

    types: {
      /**
       * @default 'Travel & Experiences'
       */
      'travel-and-experiences': T;

      /**
       * @default 'Cooking Together'
       */
      'cooking-together': T;

      /**
       * @default 'Outdoor Adventures'
       */
      'outdoor-adventures': T;

      /**
       * @default 'Decorating Our Place'
       */
      'decorating-our-place': T;

      /**
       * @default 'Baking'
       */
      baking: T;

      /**
       * @default 'Happy Hour'
       */
      'happy-hour': T;

      /**
       * @default 'Sleeping In'
       */
      'sleeping-in': T;

      /**
       * @default 'Date Night'
       */
      'date-night': T;

      /**
       * @default 'Outdoor Entertaining'
       */
      'outdoor-entertaining': T;

      /**
       * @default 'Coffee & Tea'
       */
      'coffee-and-tea': T;

      /**
       * @default 'Spa Worthy Essentials'
       */
      'spa-worthy-essentials': T;

      /**
       * @default 'Cleaning & Organization'
       */
      'cleaning-and-organization': T;
    };
  };
  giftRecommendations: {
    /**
     * @default 'That’s it. We’ll use this to help you find gifts you love...starting now!'
     */
    hed: T;

    /**
     * @default 'The item was added to your registry!'
     */
    notificationText: T;
  };
};

export type RegistryOnboardingV3AdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Start your registry.'
     */
    '2bPfe': T;

    /**
     * @default 'Make it yours.'
     */
    JP6pS: T;

    /**
     * @default 'What do you love?'
     */
    VAdSI: T;

    /**
     * @default 'What your registry can do.'
     */
    T0XRv: T;

    /**
     * @default 'A few basics to get you started. Not sure? You can change these at any time. We'll use this to personalize your recommendations.'
     */
    CVIMN: T;

    /**
     * @default 'Help Joy suggest gifts for your registry.'
     */
    HSROC: T;

    /**
     * @default 'Start Adding Gifts'
     */
    ycygF: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Skip'
     */
    TMBNA: T;

    /**
     * @default 'Your registry is ready to build.'
     */
    '6oiNf': T;

    /**
     * @default '{{0}} gifts selected.'
     */
    mRCjo: T;

    /**
     * @default 'Start with curated recommendations.'
     */
    sGA7Y: T;

    /**
     * @default 'Step {{0}} of {{1}}'
     */
    sXRsT: T;

    /**
     * @default 'How many guests are you expecting?'
     */
    rn5JI: T;

    /**
     * @default 'Most couples start with 80–150.'
     */
    '32d5F': T;

    /**
     * @default 'What's your ideal gift price?'
     */
    '6XVxm': T;

    /**
     * @default 'Most guests spend $75–150.'
     */
    PmjcR: T;

    /**
     * @default 'Add gifts from anywhere.'
     */
    VJaAO: T;

    /**
     * @default 'Search popular brands or paste a link from any store.'
     */
    tfGwx: T;

    /**
     * @default 'Create cash funds.'
     */
    lYl5w: T;

    /**
     * @default 'For travel, experiences, or anything you’re planning.'
     */
    rHcS6: T;

    /**
     * @default 'Choose when gifts ship.'
     */
    Udmgy: T;

    /**
     * @default 'Send everything now or wait until you’re ready.'
     */
    fBsh1: T;

    /**
     * @default 'Easy returns.'
     */
    d3vHS: T;

    /**
     * @default 'Returns are free and simple.'
     */
    cSA2T: T;

    /**
     * @default 'Keep everything in one place.'
     */
    OsKX7: T;

    /**
     * @default 'Bring in registries from other stores.'
     */
    grpko: T;

    /**
     * @default 'Stay on top of thank-yous.'
     */
    r2Mr1: T;

    /**
     * @default 'Generate notes for each gift you receive.'
     */
    GhK5I: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'A few ideas for your registry.'
     */
    w3xOr: T;

    /**
     * @default 'Uncheck anything you don't want and add the rest.'
     */
    '3MYUg': T;

    /**
     * @default 'Deselect all'
     */
    GU5cs: T;

    /**
     * @default 'Select all'
     */
    dqkoI: T;

    /**
     * @default 'Building your registry…'
     */
    cOJVU: T;

    /**
     * @default 'Add {{0}} Gifts'
     */
    qEH1l: T;

    /**
     * @default 'Finish Setup'
     */
    QjWGe: T;

    /**
     * @default 'Continue without adding'
     */
    etHax: T;

    /**
     * @default 'Travel & Experiences'
     */
    '9FhhA': T;

    /**
     * @default 'Cooking Together'
     */
    YyewW: T;

    /**
     * @default 'Outdoor Adventures'
     */
    tK1eb: T;

    /**
     * @default 'Decorating Our Place'
     */
    NPD4w: T;

    /**
     * @default 'Baking'
     */
    WvZgl: T;

    /**
     * @default 'Happy Hour'
     */
    '2tl09': T;

    /**
     * @default 'Sleeping In'
     */
    OYWlS: T;

    /**
     * @default 'Date Night'
     */
    YSxcG: T;

    /**
     * @default 'Outdoor Entertaining'
     */
    GjteN: T;

    /**
     * @default 'Coffee & Tea'
     */
    wWXPM: T;

    /**
     * @default 'Spa Worthy Essentials'
     */
    '4uwol': T;

    /**
     * @default 'Cleaning & Organization'
     */
    E0WZv: T;

    /**
     * @default 'Fully stocked'
     */
    NG2SZ: T;

    /**
     * @default 'Combining households'
     */
    AMBLY: T;

    /**
     * @default 'Need most things'
     */
    '4EVnO': T;

    /**
     * @default 'Have the basics, want better'
     */
    '666PR': T;

    /**
     * @default 'Curated and intentional'
     */
    UeMpM: T;

    /**
     * @default 'Not sure yet'
     */
    '0d2ID': T;

    /**
     * @default 'Physical Gifts'
     */
    MfdNe: T;

    /**
     * @default 'Experiences & Tickets'
     */
    M4hbh: T;

    /**
     * @default 'Gift Cards'
     */
    nwm5C: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'Group Gifts'
     */
    uW62N: T;

    /**
     * @default 'All of the above'
     */
    UeXhB: T;

    /**
     * @default 'Where are you starting?'
     */
    xFRiQ: T;

    /**
     * @default 'Select all that apply.'
     */
    w1WaL: T;

    /**
     * @default 'What are your gift types?'
     */
    TdUGA: T;
  };
};

export type RegistryOverviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  helpLinks: {
    /**
     * @default 'Preview'
     */
    previewRegistry: T;

    shareRegistry: {
      /**
       * @default 'Share'
       */
      title: T;

      /**
       * @default '✨ Link copied! Share it with gift givers so they can shop in one place!'
       */
      toast: T;
    };

    /**
     * @default 'Public'
     */
    registryIsPublic: T;

    /**
     * @default 'Hidden'
     */
    registryIsHidden: T;

    /**
     * @default 'Protected'
     */
    registryIsPasswordProtected: T;

    settings: {
      /**
       * @default 'Settings'
       */
      title: T;

      /**
       * @default 'Registry Settings'
       */
      navTitle: T;

      /**
       * @default 'Event Settings'
       */
      event: T;

      /**
       * @default 'Shipping Address'
       */
      shippingAddress: T;

      /**
       * @default 'Set Currency'
       */
      currencyZeroState: T;

      /**
       * @default 'Currency ({{code}} - {{symbol}})'
       */
      currency: T;

      /**
       * @default 'Edit Welcome Note'
       */
      note: T;

      /**
       * @default 'Your presence is enough of a present to us! But for those of you who are stubborn, we've put together a wish-list to help you out.'
       */
      defaultNote: T;

      /**
       * @default 'Invite Collaborator'
       */
      invite: T;

      /**
       * @default 'Connect a Registry'
       */
      connect: T;

      /**
       * @default 'Seamless checkout (On)'
       */
      seamlessCheckoutOn: T;

      /**
       * @default 'Seamless checkout (Off)'
       */
      seamlessCheckoutOff: T;
    };
  };
  checklist: {
    /**
     * @default 'Registry Checklist'
     */
    title: T;

    /**
     * @default 'Use our checklist as a starting point to build your registry.'
     */
    subtitle: T;

    /**
     * @default 'Try Checklist'
     */
    button: T;
  };
  registry101: {
    /**
     * @default 'Registry 101'
     */
    title: T;

    /**
     * @default 'Need some guidance? Try one of these:'
     */
    subtitle: T;

    /**
     * @default 'Registry Walkthrough'
     */
    registryWalkthrough: T;

    /**
     * @default 'Tips & Tricks'
     */
    tipsTricks: T;

    /**
     * @default 'FAQs'
     */
    faqs: T;
  };
  registryPerks: {
    /**
     * @default 'Registry Completion Discount'
     */
    header: T;

    /**
     * @default 'Save 20% on Products'
     */
    title1: T;

    /**
     * @default 'You 100% Love.'
     */
    title2: T;

    /**
     * @default 'Use your completion discount up to six months after the big day.'
     */
    subTitle: T;

    /**
     * @default 'Explore All Benefits'
     */
    button: T;

    perksDialog: {
      /**
       * @default 'Registry Perks & Benefits'
       */
      header: T;

      /**
       * @default 'For You'
       */
      forYou: T;

      /**
       * @default 'For Your Guests'
       */
      forGuest: T;

      /**
       * @default 'Easy Returns'
       */
      easyReturns: T;

      /**
       * @default 'Free online returns let you get the gifts you want without any cost or inconvenience.'
       */
      easyReturnsSubTitle: T;

      /**
       * @default '20% Completion Discount'
       */
      registryCompletionDiscount: T;

      /**
       * @default 'Enjoy 20% off eligible gifts remaining on your registry up to 6 months after the big day.'
       */
      registryCompletionDiscountSubTitle: T;

      /**
       * @default 'Universal Registry'
       */
      universalRegistry: T;

      /**
       * @default 'Add gifts and experiences from the Joy Shop or any online store, plus connect or transfer another registry.'
       */
      universalRegistrySubTitle: T;

      /**
       * @default 'Zero-Fee Cash Funds'
       */
      zeroCashFund: T;

      /**
       * @default 'Save for your dreams faster by creating a cash fund for anything from your honeymoon to a new home.'
       */
      zeroCashFundSubTitle: T;

      /**
       * @default 'Joy Consultation'
       */
      joyConsultation: T;

      /**
       * @default 'Elevate your wedding planning with complimentary expert advice and creative ideas from the pros.'
       */
      joyConsultationSubTitle: T;

      /**
       * @default 'Gift Tracking'
       */
      giftNotifications: T;

      /**
       * @default 'See which gifts have been purchased, view your cash fund’s progress, and send free online thank you notes.'
       */
      giftNotificationsSubTitle: T;

      /**
       * @default 'Flexible, Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Guests can choose to ship to you or to themselves so they can bring your gifts with them to your event.'
       */
      freeShippingSubTitle: T;

      /**
       * @default 'Price Match Promise'
       */
      priceMatch: T;

      /**
       * @default 'If your guests find a better price on a qualifying product from our eligible retailers, we'll match it.'
       */
      priceMatchSubTitle: T;

      /**
       * @default 'Group Gifting'
       */
      groupGifting: T;

      /**
       * @default 'A win-win for everyone, add big gifts over $350 and let your friends and family contribute what they want.'
       */
      groupGiftingSubTitle: T;

      /**
       * @default 'Fast Checkout'
       */
      fastCheckout: T;

      /**
       * @default 'Convenient payment options, like ApplePay and GooglePay, plus a streamlined checkout simplify gifting.'
       */
      fastCheckoutSubTitle: T;

      /**
       * @default 'Data Protection'
       */
      dataProtection: T;

      /**
       * @default 'Keeping personal data secure is our priority and we will never sell or compromise that information.'
       */
      dataProtectionSubTitle: T;

      /**
       * @default 'Priority Picks'
       */
      priorityPicks: T;

      /**
       * @default 'We’ll help your guests see which items are your must-haves, taking the guesswork out of picking the right gifts.'
       */
      priorityPicksSubTitle: T;

      /**
       * @default 'See Details'
       */
      seeDetails: T;
    };
  };
  virtualConsultation: {
    /**
     * @default 'Need Help?'
     */
    needHelp: T;

    /**
     * @default 'Get expert registry advice.'
     */
    title: T;

    /**
     * @default 'Build your registry like a pro with the help of expert advice.'
     */
    subTitle: T;

    /**
     * @default 'Book An Appointment'
     */
    button: T;
  };
  registryTools: {
    quickAdd: {
      /**
       * @default 'Install the Joy Quick Add Button'
       */
      title: T;

      /**
       * @default 'Add anything as you browse the web.'
       */
      subtitle: T;

      /**
       * @default 'Get the button'
       */
      button: T;
    };
    mobileApp: {
      /**
       * @default 'Shop on Your Phone'
       */
      title: T;

      /**
       * @default 'Add items from wherever, whenever.'
       */
      subtitle: T;

      /**
       * @default 'Download App'
       */
      button: T;
    };
    externalRegistries: {
      /**
       * @default 'Add Anything from Any Store'
       */
      title: T;

      /**
       * @default 'Joy lets you do you.'
       */
      subtitle: T;

      /**
       * @default 'Connect a Registry'
       */
      button: T;

      /**
       * @default 'Add a Gift'
       */
      buttonBaby: T;

      /**
       * @default 'Gifts'
       */
      gifts: T;

      /**
       * @default 'Cash Funds'
       */
      cashFunds: T;

      /**
       * @default 'Experiences'
       */
      experiences: T;

      /**
       * @default 'Charity'
       */
      charity: T;

      /**
       * @default 'Babymoons'
       */
      babymoons: T;
    };
  };
  registryToolsV2: {
    mobileApp: {
      /**
       * @default 'Add gifts on the go<lineBreak/>with the Joy App.'
       */
      title: T;

      /**
       * @default 'Get the App'
       */
      button: T;
    };
    universalRegistry: {
      /**
       * @default ' Already registered?<lineBreak/>Make it easier for your guests.'
       */
      title: T;

      /**
       * @default 'Connect a Registry'
       */
      button: T;
    };
  };
  departmentShowcase: {
    /**
     * @default 'Explore Departments'
     */
    title: T;
  };
  curationShowcase: {
    /**
     * @default 'Shop by Collection'
     */
    title: T;
  };
  faqs: {
    /**
     * @default 'Frequently Asked Questions'
     */
    title: T;

    /**
     * @default 'Our most commonly asked questions are here, and you can reach our support team <0>here</0>.'
     */
    subtitle: T;

    questions: [
      {
        /**
         * @default '1'
         */
        id: T;

        /**
         * @default 'Why do we need a registry?'
         */
        Q: T;

        /**
         * @default 'With your big day around the corner, we’re sure your friends and family are excited to shower you with gifts. Chances are they’ll buy something for you even if you don’t have a registry and those gifts may not exactly be what you need or want. Having a wedding registry ensures you'll receive stuff, experiences, or even cash fund gifts that you truly need and want. So, it's a win-win for you and your guests–you’ll get what you love, and your guests feel awesome knowing they've given you something you'll cherish.'
         */
        A: T;
      },
      {
        /**
         * @default '2'
         */
        id: T;

        /**
         * @default 'Why should we register with Joy?'
         */
        Q: T;

        /**
         * @default 'The Joy wedding registry is a truly all-in-one registry that has been designed to make the registering process simple and fun for you and your guests. We've stocked our online <0>Joy Shop</0> with tons of products from top-name brands, <1>zero-fee cash funds</1> to make your dreams come true, and even the option to give back with charitable donations. We have gift cards, <2>honeymoon funds</2>, and <3>experiences</3> to make your future even more memorable, too.<br><br>And here's the icing on the cake: Joy's a universal registry wizard. You can register for items from any online store, and even transfer or connect existing registries, giving you and your guests one super-convenient place to shop for absolutely everything you desire.<br><br>We know weddings are expensive and time-consuming, so we’re always rolling out more features and perks to save you money and time. We promise to match prices, ship items free, offer convenient group gifting, make returns a breeze, and even give you a 20% Post-Wedding Completion Discount for most items left on your registry. It's like a wedding gift that keeps on giving! So why register with Joy? Because we're here to make your journey as stress-free and seamless as possible.'
         */
        A: T;
      },
      {
        /**
         * @default '3'
         */
        id: T;

        /**
         * @default 'When should we start our registry?'
         */
        Q: T;

        /**
         * @default 'Creating your wedding registry about 8-9 months before your wedding date is a fantastic idea because it gives you time to thoughtfully select items and gives guests time to browse and choose the perfect gifts. You definitely want to have your wedding registry finalized before sending out any shower or wedding invitations. When you start early, it takes away any last-minute rushing and gives everyone the chance to find the most meaningful and thoughtful presents for you and your future spouse.'
         */
        A: T;
      },
      {
        /**
         * @default '4'
         */
        id: T;

        /**
         * @default 'What should we add to our wedding registry?'
         */
        Q: T;

        /**
         * @default 'What you add to your wedding registry really comes down to your lifestyle and preferences. It's your opportunity to curate a list of items that will truly enhance your married life together. A couple who is moving into a new space for the first time together will likely have a different registry than a couple who is planning to travel the world. To strike a good balance, consider a mix of physical gifts like kitchen gadgets, home essentials, and comfy linens, which can make everyday life more enjoyable. Including options like cash funds for future plans or even charitable donations adds a meaningful touch to your registry. But don't stop there! Registering for experiences is a way for you to create beautiful memories that will last a lifetime. So, go ahead and make it a reflection of your needs and wants, knowing that your loved ones are excited to support your journey in whichever way they can. It's all about making your wedding registry uniquely yours.<br><br>Still not sure what to add? We recommend starting with our Registry Checklist, which you can find at the top of your registry page. We’ll guide you through the must-have items and tell you how many of each you might need. Check out the checklist.'
         */
        A: T;
      },
      {
        /**
         * @default '5'
         */
        id: T;

        /**
         * @default 'How many gifts should we register for?'
         */
        Q: T;

        /**
         * @default 'Ah, the age-old question, right? How many gifts should you put on that wedding registry? The thing is, there's no one-size-fits-all answer here. It really boils down to your unique situation. But here's a helpful rule of thumb: aim to have more items on your registry than you have guests. This gives folks a range of options to choose from. To make it easier, we’ve created your personal Registry Calculator, found within the “Overview” and “Gifts” sections of your registry. Tell us how many guests you’re inviting and we’ll give you a recommendation of how many gifts to register for. You’ll also be able to see how many gifts you have on your registry per price range.<br><br>Include a mix of essentials and fun stuff, all at different price points. That way, your guests can pick something that suits their budget and your new life together. And, don’t stress about over-registering. You can use your 20% Post-Wedding Discount on most items remaining on your registry after the big day. Learn more about how your discount works <0>here</0>.'
         */
        A: T;
      },
      {
        /**
         * @default '6'
         */
        id: T;

        /**
         * @default 'What is the Joy Shop and how are the products selected?'
         */
        Q: T;

        /**
         * @default 'While the Joy registry is truly universal and you can add any item from any online store when you download the Joy Browser Button, there are over 10,000 products from top brands, niche brands, and artisans around the world right in the <0>Joy Shop</0>.<br><br>Our product selection process is driven by a passionate commitment to deliver an exceptional catalog that feels hand-selected, intentional, and truly special. We take great pride in offering a diverse range of products chosen with a commitment to quality and longevity. The Joy Shop is thoughtfully curated to cater to every couples’ and guest's budget, ensuring there's something special for everyone to choose from. We also pay close attention to what our Joy couples love and listen to your suggestions. Your input helps us refine our product selection and introduce new items that cater to your evolving preferences and needs.'
         */
        A: T;
      },
      {
        /**
         * @default '7'
         */
        id: T;

        /**
         * @default 'Is it rude to ask for money instead of wedding gifts?'
         */
        Q: T;

        /**
         * @default 'Not at all! In fact, in many places outside of the US, giving money in lieu of traditional gifts is quite common and sometimes expected. Cash gifting has become increasingly popular in recent years as it allows couples to focus on experiences rather than material possessions. Joy has made it easier than ever to create cash registries, where you can politely express your preference for cash gifts. With Joy, you can create a general cash fund for your honeymoon or house downpayment, or customize cash funds for specific experiences like airfare, future date nights, or whatever you dream up.<br><br>Just remember to express gratitude for any type of gift you receive. You can send free, online thank you notes right from your Gift Tracker, quickly and easily. We’ll even help you write them.'
         */
        A: T;
      },
      {
        /**
         * @default '8'
         */
        id: T;

        /**
         * @default 'How do Joy's zero fee-cash funds work?'
         */
        Q: T;

        /**
         * @default 'Just like any product, you can register for a zero-fee cash fund right from the <0>Joy Shop</0>. Select one or create your own, make any edits to the amount, and add to your registry. Using Venmo, PayPal, or CashApp, your loved ones can sprinkle a little monetary magic your way without those pesky credit card fees. Whether you're dreaming of a honeymoon getaway, saving for that first home, or looking to fly high with airfare funds, the sky's the limit when it comes to crafting the perfect cash gifts for your newlywed journey.<br><br>P.S. Don’t stress if your guests want to pay in a more traditional way. They’ll also have the option to contribute via cash or check.'
         */
        A: T;
      },
      {
        /**
         * @default '9'
         */
        id: T;

        /**
         * @default 'How can we explain to our guests that we are using a cash registry?'
         */
        Q: T;

        /**
         * @default 'For loved ones who are more accustomed to traditional gift registries, it's a lovely idea to leave them a little note. You can write a note right in your Joy registry to let them know how much you appreciate their generosity, and share what your cash gift will be used for–whether it's your dream honeymoon, saving for a cozy home, or any other exciting adventure you're planning. It's all about making your guests feel connected to your journey and showing them that every contribution, big or small, means the world to you.'
         */
        A: T;
      },
      {
        /**
         * @default '10'
         */
        id: T;

        /**
         * @default 'Does Joy offer a post-wedding or completion discount?'
         */
        Q: T;

        /**
         * @default 'Absolutely! We’re here for you before, during, and after your wedding. Our 20% Post-Wedding discount can be used on eligible items that are still left on your registry after your big day. It's our way of helping you grab those items you've had your eye on at an even better price, so don’t be shy about adding everything you need and everything you love to your registry now. Use it as MANY times as you’d like, up to 6 months after your wedding date. Learn more about it here.'
         */
        A: T;
      },
      {
        /**
         * @default '11'
         */
        id: T;

        /**
         * @default 'Does Joy offer price matching?'
         */
        Q: T;

        /**
         * @default 'Yes! At Joy, we've got your back when it comes to getting the most value out of your purchases, so we’re happy to offer our Price Match Promise. If you find a better price for a qualifying product from one of our eligible retailers within 48 hours of making your order, just give us a shout. Learn more about it <0>here</0>.'
         */
        A: T;
      },
      {
        /**
         * @default '12'
         */
        id: T;

        /**
         * @default 'We already have a registry with another store. Can we link it to Joy?'
         */
        Q: T;

        /**
         * @default 'We know you’ve got your eyes on some fantastic finds from various stores. Imagine registering at a bunch of different stores and combining all of those registries into one glorious display on your wedding website. Let’s dive into how you can add external registries to your Joy Registry:<br><br><strong>1</strong>. Linking: Simply add a link to any external registry for guests’ convenience.<br><strong>2</strong>. Transfer: Move an external registry into Joy, manage items, and see gift details within Joy. Supported for specific registries.<br><strong>3</strong>. Syncing: Automatically import items from an external registry into Joy, though changes must be made on the external registry. Supported for specific registries.'
         */
        A: T;
      },
      {
        /**
         * @default '13'
         */
        id: T;

        /**
         * @default 'Does Joy cost anything to use?'
         */
        Q: T;

        /**
         * @default 'Joy's wedding websites, planning tools, registry, and online Save the Dates, invitations, and thank you notes are all available for free, so you can save on wedding costs and enjoy a stress-free planning experience.'
         */
        A: T;
      },
      {
        /**
         * @default '14'
         */
        id: T;

        /**
         * @default 'Do you have a support team we can reach out to if we have questions?'
         */
        Q: T;

        /**
         * @default 'Our awesome support squad has whipped up a fantastic collection of FAQs and nifty tips in our Help Center, all designed to make your wedding planning journey easier. This treasure trove of information is here to give you lightning-fast and super-detailed answers, so you can get the most out of your Joy experience. Visit our <0>Help Center</0>.'
         */
        A: T;
      },
    ];
  };
  highlights: {
    cashFundPromo: {
      /**
       * @default 'Cash in Your Dreams'
       */
      eyebrow: T;

      /**
     * @default 'Joy accepts the most
 Cash Fund payment options.'
*/
      title: T;

      /**
       * @default 'Create Cash Fund'
       */
      buttonLabel: T;

      /**
       * @default 'Honeymoon Fund'
       */
      progressBarLabel: T;
    };
    completionDiscountPromo: {
      /**
       * @default 'Post-Wedding Completion Discount'
       */
      eyebrow: T;

      /**
       * @default 'Celebrate all over again with 20% off registry gifts after your wedding.'
       */
      title: T;

      /**
       * @default 'Learn More'
       */
      buttonLabel: T;
    };
    curationsPromo: {
      /**
       * @default 'Expert Curations'
       */
      eyebrow: T;

      /**
       * @default 'Hot recs from industry pros to craft your registry.'
       */
      title: T;

      /**
       * @default 'Explore Curations'
       */
      buttonLabel: T;
    };
    customerSupportPromo: {
      /**
       * @default 'Customer support for you and your guests at every step.'
       */
      title: T;
    };
    delayShippingPromo: {
      /**
       * @default 'Avoid Honeymoon Deliveries'
       */
      eyebrow: T;

      /**
       * @default 'With Joy, only you decide when your gifts should ship.'
       */
      title: T;

      /**
       * @default 'Set Up Delay Shipping'
       */
      buttonLabel: T;
    };
    etsyPromo: {
      /**
       * @default 'Shop the Best of Etsy Wedding Supplies'
       */
      title: T;

      /**
       * @default 'Explore Wedding Shop'
       */
      buttonLabel: T;
    };
    framesPromo: {
      /**
       * @default 'Upload and frame your wedding photos.'
       */
      title: T;

      /**
       * @default 'Joy and Frameology bring you gorgeous frames at great prices.'
       */
      description: T;

      /**
       * @default 'Shop Frames'
       */
      buttonLabel: T;
    };
    printPromo: {
      /**
       * @default 'Ready to share your registry?'
       */
      title: T;

      /**
       * @default 'Joy paper and digital cards make it easy with built in QR codes and links.'
       */
      description: T;

      /**
       * @default 'Add to Save the Dates'
       */
      buttonLabel: T;

      /**
       * @default 'Add to Invites'
       */
      buttonLabel2: T;
    };
    groupGiftingPromo: {
      /**
       * @default 'Group Gifting'
       */
      eyebrow: T;

      /**
       * @default 'Let guests chip in together on your dreamiest gifts.'
       */
      title: T;

      progressBar: {
        /**
         * @default 'Sofa Sectional 🎉 You’re almost there!'
         */
        leftLabel: T;

        /**
         * @default '$4,000 Goal'
         */
        rightLabel: T;
      };
    };
    universalSearchPromo: {
      /**
       * @default 'Universal Search'
       */
      eyebrow: T;

      /**
     * @default 'If it’s on Google,
it’s on Joy.'
*/
      title: T;

      /**
       * @default 'Search for anything. Yes, really.'
       */
      buttonLabel: T;
    };
    weddingThankYouNotes: {
      /**
     * @default 'Thank You Notes
Made Easy'
*/
      title: T;

      /**
       * @default 'Introducing'
       */
      eyebrow: T;

      /**
       * @default 'Watch the Video'
       */
      buttonLabel: T;
    };
    weddingChecklist: {
      /**
     * @default 'Not sure where
to start?'
*/
      title: T;

      /**
       * @default 'Try Checklist'
       */
      buttonLabel: T;
    };
    weddingCashFunds: {
      /**
     * @default 'Zero-Fee
Cash Funds.'
*/
      title: T;

      /**
       * @default 'Explore Cash Funds'
       */
      buttonLabel: T;
    };
    weddingBrowserButton: {
      /**
     * @default 'Add anything from
anywhere. Like, literally.'
*/
      title: T;

      /**
       * @default 'Install Quick Add Button'
       */
      buttonLabel: T;
    };
    weddingMobileApp: {
      /**
     * @default 'Add anything from
anywhere. Like, literally.'
*/
      title: T;

      /**
       * @default 'Install Quick Add Button'
       */
      buttonLabel: T;
    };
    babyFriendsRegistry: {
      /**
       * @default 'Only with Joy'
       */
      eyebrow: T;

      /**
     * @default 'Add items from
anyone’s registry.'
*/
      title: T;

      /**
       * @default 'We’ll collect their gifts so you can pick what to add.'
       */
      text: T;

      /**
       * @default 'Scan and Add Gifts'
       */
      buttonLabel: T;
    };
    babyBrowserButton: {
      /**
     * @default 'Register for
anything. Literally.'
*/
      title: T;

      /**
       * @default 'Install the Quick Add Button'
       */
      buttonLabel: T;
    };
    babyCashFunds: {
      /**
     * @default 'Zero-Fee
Cash Funds.'
*/
      title: T;

      /**
       * @default 'Explore Cash Funds'
       */
      buttonLabel: T;
    };
    babyChecklists: {
      /**
     * @default 'Don't know
what to add?'
*/
      title: T;

      /**
       * @default 'Try Checklist'
       */
      buttonLabel: T;
    };
    babyThankYouNotes: {
      /**
     * @default 'Automagic
Thank You Notes.'
*/
      title: T;

      /**
       * @default 'Watch the Video'
       */
      buttonLabel: T;
    };
  };
  mainPromo: {
    /**
     * @default 'Meet the best registry on earth.'
     */
    title: T;

    /**
     * @default 'Shop the top brands, gift cards and experiences in one place. Create unlimited cash funds with zero fees. Add gifts from any store and share them with one link.'
     */
    description: T;

    /**
     * @default 'See All Perks'
     */
    ctaText: T;
  };

  /**
   * @default 'Explore'
   */
  explore: T;

  /**
   * @default 'View All'
   */
  viewAll: T;

  exploreRegistry: {
    /**
     * @default 'Explore Your Registry'
     */
    headerTitle: T;

    /**
     * @default 'Check out
The Check List'
*/
    tryCheckListTitle: T;

    /**
     * @default 'Top Gifts
Under $100'
*/
    topGiftsTitle: T;

    /**
     * @default 'Add a
Cash Fund'
*/
    addCashFundTitle: T;

    /**
     * @default 'Go Dutch'
     */
    goDutchTitle: T;

    /**
     * @default 'Shop by Brand'
     */
    shopByBrandTitle: T;

    /**
     * @default 'Explore
Curations'
*/
    exploreCurationsTitle: T;
  };
  productRecommendations: {
    /**
     * @default 'No product recommendations here yet.
Select your interests from the dropdown.'
*/
    emptyState: T;

    /**
     * @default 'Show All {{count}}'
     */
    showAll: T;

    interestsDropdown: {
      /**
       * @default 'Select your interests'
       */
      empty: T;

      /**
       * @default 'Because you like <interest/>'
       */
      liked: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Remove'
       */
      remove: T;
    };
  };
  quick: {
    /**
     * @default 'Thank you notes'
     */
    s6ZoA: T;
  };
};

export type ReplaceDefaultPhotosTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Replace the placeholder photos with yours?'
     */
    '0Zew2': T;

    /**
     * @default 'We'll fill your website pages with photos you've uploaded, instead of our defaults.'
     */
    FDq39: T;

    /**
     * @default 'Yes, Swap Them'
     */
    Wc24h: T;

    /**
     * @default 'No, I'll Do It Myself'
     */
    Jcskt: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;
  };
};

export type RichTextEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Resize editor'
     */
    NATQc: T;

    /**
     * @default 'Lists'
     */
    LKiWG: T;

    /**
     * @default 'Bulleted list'
     */
    B8hUe: T;

    /**
     * @default 'Numbered list'
     */
    '8R5cl': T;

    /**
     * @default 'Are you sure you want to delete this text block?'
     */
    Yg4ea: T;

    /**
     * @default 'The contents of this section will be lost. This action can’t be undone.'
     */
    T0G41: T;

    /**
     * @default 'Delete Text Block'
     */
    FHdDL: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Text has been deleted.'
     */
    I1TIT: T;

    /**
     * @default 'An error occurred while deleting your text. Please try again.'
     */
    kLC95: T;

    /**
     * @default 'Share a great story with your guests'
     */
    Ibdf4: T;

    /**
     * @default 'Insert'
     */
    bbuH5: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Inserting...'
     */
    jt1kg: T;

    /**
     * @default 'Updating...'
     */
    SspdD: T;

    /**
     * @default 'URL'
     */
    '1xYAA': T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'https://'
     */
    NpibG: T;

    /**
     * @default 'Unlink'
     */
    N6M3a: T;

    /**
     * @default 'Do you want to keep extra formatting for this text?'
     */
    MEQs9: T;

    /**
     * @default 'We noticed this text includes some extra formatting. It might not match your site's style. You can keep it if it's intentional or remove it for a consistent look.'
     */
    Th3tq: T;

    /**
     * @default 'Don't show this message again'
     */
    wHeOZ: T;

    /**
     * @default 'Remove formatting'
     */
    lKKes: T;

    /**
     * @default 'Keep extra formatting'
     */
    mjDds: T;
  };
};

export type RsvpAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  messageCardHelper: {
    /**
     * @default 'We've added some common questions to get you started. <learnHowToCustomizeLink/>'
     */
    commonQuestionsAdded: T;
  };
  rsvpOff: {
    /**
     * @default 'Please disable RSVP in <settingsLink/> if you have not done so already.'
     */
    disableRsvpMessage: T;
  };
  cardFooter: {
    /**
     * @default 'and {{count}} other guest'
     * @param {number} count - The number of occurrences.
     * - singular: and {{count}} other guest
     * - plural: and {{count}} other guests
     */
    andOtherGuests: T;

    /**
     * @default '{{count}} Guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{count}} Guest
     * - plural: {{count}} Guests
     */
    guestCount: T;
  };
  hoverInfo: {
    /**
     * @default 'Ask {{count}} guest'
     * @param {number} count - The number of occurrences.
     * - singular: Ask {{count}} guest
     * - plural: Ask {{count}} guests
     */
    askGuestCount: T;
  };
  quick: {
    /**
     * @default 'Rsvp Responses'
     */
    DNV66: T;

    /**
     * @default 'RSVP Activity'
     */
    wmrLO: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Updated {{0}}'
     */
    '5jF0U': T;

    /**
     * @default 'Updated'
     */
    Bn1Wf: T;

    /**
     * @default 'Responded {{0}}'
     */
    SNbi7: T;

    /**
     * @default 'Responded'
     */
    eH56s: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Declined'
     */
    kUvCR: T;

    /**
     * @default 'Awaiting Response'
     */
    JneOW: T;

    /**
     * @default 'Cannot delete choice'
     */
    hY80K: T;

    /**
     * @default 'A follow-up question is currently being asked if this choice is selected. Delete that follow-up question first, then you can delete this choice.'
     */
    ri9aq: T;

    /**
     * @default 'Ok'
     */
    wrAAA: T;

    /**
     * @default 'Connection trouble'
     */
    XDrUl: T;

    /**
     * @default 'Apologies, we weren’t able to auto-save your changes. Please click “Try again” to reconnect.'
     */
    FcOEK: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Uh oh, it’s still not working...'
     */
    '1KDw6': T;

    /**
     * @default 'Unfortunately, auto-save still isn’t working. Please refresh to try again. We’re very sorry about that.'
     */
    xbGA0: T;

    /**
     * @default 'Refresh'
     */
    jQp3e: T;

    /**
     * @default 'Set up your questions'
     */
    '57WCi': T;

    /**
     * @default 'How to customize RSVP.'
     */
    bNjCp: T;

    /**
     * @default 'No need to ask for contact info — guests update it when they RSVP.'
     */
    IF42w: T;

    /**
     * @default 'Add Question'
     */
    '7XvlO': T;

    /**
     * @default 'Select Guests and Tags'
     */
    Trok2: T;

    /**
     * @default '1 guest will be asked this question'
     */
    YKVBA: T;

    /**
     * @default '{{0}} guests will be asked this question'
     */
    Upe18: T;

    /**
     * @default 'Tags'
     */
    RrHNA: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Your privacy settings were unable to be saved.'
     */
    '7sEwI': T;

    /**
     * @default '{{0}}'s Guest'
     */
    m6E80: T;

    /**
     * @default 'Choose who will be asked this question.'
     */
    yZ3TN: T;

    /**
     * @default 'Please try reloading'
     */
    Ad073: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Choice {{0}}'
     */
    vsBkX: T;

    /**
     * @default 'Attending answer'
     */
    '0dBW0': T;

    /**
     * @default 'Declining answer'
     */
    puWPJ: T;

    /**
     * @default 'Ask follow-up question'
     */
    eFyc8: T;

    /**
     * @default 'Yikes! Looks like you forgot to fill in your question and one of your answer choices.'
     */
    CoBrq: T;

    /**
     * @default 'Uh oh! Looks like you forgot to fill in your question.'
     */
    eg2Gw: T;

    /**
     * @default 'Hmm…looks like you forgot to fill in one of your answer choices.'
     */
    uarO1: T;

    /**
     * @default 'No one will see this question because it is set to ask 0 guests.'
     */
    scMXD: T;

    /**
     * @default 'Please fill in your choice field'
     */
    CEj0N: T;

    /**
     * @default 'Please fill in your question here'
     */
    '91wAj': T;

    /**
     * @default 'Guests will be able to type a response here.'
     */
    p6Yky: T;

    /**
     * @default 'Choose a question type'
     */
    UezlI: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Suggestions'
     */
    JzeyJ: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Attendance'
     */
    DE1nO: T;

    /**
     * @default 'An Attendance question looks like any regular multiple choice question, but it helps Joy figure out how many people are coming to your wedding.'
     */
    txJqt: T;

    /**
     * @default 'You can add follow-up questions to each choice.'
     */
    '5K6zA': T;

    /**
     * @default 'Multiple Choice'
     */
    xnpsD: T;

    /**
     * @default 'Give your guests options to choose from.'
     */
    PSxT5: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Provide a text box for your guests to fill in their answer.'
     */
    mvjoA: T;

    /**
     * @default 'Song Requests'
     */
    ZpB3Q: T;

    /**
     * @default 'Songs'
     */
    gTQ6G: T;

    /**
     * @default 'Request songs to get down to on the dance floor'
     */
    qpvP7: T;

    /**
     * @default 'Meal'
     */
    zUFMA: T;

    /**
     * @default 'Find out what each guest would like to eat, so you can give your caterer a count.'
     */
    IsY7V: T;

    /**
     * @default 'Hotel Accommodations'
     */
    '9ybdB': T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Make sure your guests have a place to stay on your big day.'
     */
    fazLQ: T;

    /**
     * @default 'Advice'
     */
    oIxIj: T;

    /**
     * @default 'Ask your guests for the best piece of marriage advice they’ve heard.'
     */
    K2wI5: T;

    /**
     * @default 'Honeymoon Ideas'
     */
    G2UXj: T;

    /**
     * @default 'Honeymoon'
     */
    mfnfF: T;

    /**
     * @default 'Crowdsource honeymoon ideas.'
     */
    WnMzI: T;

    /**
     * @default 'Image indicating that RSVP is turned off.'
     */
    SPhfD: T;

    /**
     * @default 'You have no enabled questions.'
     */
    eCyuJ: T;

    /**
     * @default 'settings'
     */
    pogda: T;

    /**
     * @default 'Saving...'
     */
    '60ObM': T;

    /**
     * @default 'Changes saved'
     */
    aL6C5: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Page Settings'
     */
    qiWuC: T;

    /**
     * @default 'Visibility'
     */
    OZrIO: T;

    /**
     * @default 'Guest List'
     */
    sYWqA: T;

    /**
     * @default '12 hours'
     */
    qn8XW: T;

    /**
     * @default '24 hours'
     */
    nmRbd: T;

    /**
     * @default '36 hours'
     */
    klkek: T;

    /**
     * @default '2 days'
     */
    '99KPL': T;

    /**
     * @default '3 days'
     */
    A4X3N: T;

    /**
     * @default '5 days'
     */
    CsxLT: T;

    /**
     * @default '7 days'
     */
    C5kJD: T;

    /**
     * @default '6 hours'
     */
    bWwDR: T;

    /**
     * @default '18 hours'
     */
    wtTxw: T;

    /**
     * @default '4 days'
     */
    BykhQ: T;

    /**
     * @default '{{0}} hours'
     */
    '9Co5k': T;

    /**
     * @default 'The RSVP deadline and grace period have passed. Guests can no longer RSVP.'
     */
    wbJB2: T;

    /**
     * @default 'The deadline has passed but guests can still RSVP during the grace period.'
     */
    TeJoc: T;

    /**
     * @default 'Set an RSVP deadline'
     */
    '40ppx': T;

    /**
     * @default 'Set a date after which guests can no longer RSVP.'
     */
    QNZgq: T;

    /**
     * @default 'Deadline date'
     */
    mRGlQ: T;

    /**
     * @default 'Select date'
     */
    eE8RG: T;

    /**
     * @default 'Select a date to save your RSVP deadline.'
     */
    P4caZ: T;

    /**
     * @default 'Deadlines end at midnight ({{0}})'
     */
    KK3Hy: T;

    /**
     * @default 'Tip: Add a grace period so guests in other timezones don't miss the RSVP deadline.'
     */
    OmEws: T;

    /**
     * @default 'Show deadline to guests'
     */
    xy2KE: T;

    /**
     * @default 'Display the RSVP deadline on your website so guests know when to respond by.'
     */
    '44JwA': T;

    /**
     * @default 'Allow late RSVPs (grace period)'
     */
    BO3rT: T;

    /**
     * @default 'Allow guests to still RSVP for a period after the deadline has passed.'
     */
    kVVaH: T;

    /**
     * @default 'Grace period'
     */
    zNhh9: T;

    /**
     * @default 'RSVPs will close on {{0}} ({{1}})'
     */
    TKDEr: T;

    /**
     * @default 'Post-deadline message'
     */
    MVHID: T;

    /**
     * @default 'Shown to guests in place of the RSVP button once the deadline has passed. Leave blank to show no message.'
     */
    HXryg: T;

    /**
     * @default 'Sorry, our RSVP deadline has passed. Please contact us at...'
     */
    Dx2Ot: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Questions'
     */
    h1BuU: T;

    /**
     * @default 'Responses'
     */
    MX96s: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Activity'
     */
    dgmnl: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'RSVP navigation'
     */
    '3kLEI': T;

    /**
     * @default 'On'
     */
    zrAAA: T;

    /**
     * @default 'Off'
     */
    hRXAA: T;

    /**
     * @default 'A guest'
     */
    nxbZs: T;

    /**
     * @default 'View {{0}}'s responses'
     */
    Zpara: T;

    /**
     * @default 'Couldn't load RSVP activity. Please refresh the page.'
     */
    ZHUKP: T;

    /**
     * @default 'No responses yet'
     */
    LRsHd: T;

    /**
     * @default 'As guests RSVP and update their answers, their activity will show up here.'
     */
    QkhfC: T;

    /**
     * @default 'Open filters'
     */
    xt1EW: T;

    /**
     * @default 'Filtered by'
     */
    gzS7M: T;

    /**
     * @default 'Clear all'
     */
    YgozE: T;

    /**
     * @default 'No response'
     */
    UMmde: T;

    /**
     * @default 'Try the new RSVP Responses'
     */
    NPgTU: T;

    /**
     * @default 'We've redesigned this page with search, filters, and a per-guest view. Take it for a spin, you can switch back anytime.'
     */
    CdMDJ: T;

    /**
     * @default 'Try the New Design'
     */
    i1xtP: T;

    /**
     * @default 'You're previewing the new RSVP Responses. We'd love your feedback!'
     */
    dvDlT: T;

    /**
     * @default 'Classic View'
     */
    BAL8N: T;

    /**
     * @default 'Give Feedback'
     */
    WD4Ao: T;

    /**
     * @default 'Asked to all guests'
     */
    xnRLL: T;

    /**
     * @default 'Asked to'
     */
    xbcgU: T;

    /**
     * @default 'Unable to load bookings. Please try again later.'
     */
    l5y7E: T;

    /**
     * @default 'No bookings yet'
     */
    zijUd: T;

    /**
     * @default 'Hotel bookings from your guests will show up here, grouped by where they're staying.'
     */
    LTcAK: T;

    /**
     * @default 'Riviera'
     */
    c5uuq: T;

    /**
     * @default 'Vaporwave'
     */
    jguYu: T;

    /**
     * @default 'Lagoon'
     */
    CH59B: T;

    /**
     * @default 'Macintosh'
     */
    sZB7c: T;

    /**
     * @default 'Aperitivo'
     */
    PC6yv: T;

    /**
     * @default 'Tropicália'
     */
    EYDxZ: T;

    /**
     * @default 'Memphis'
     */
    lntbe: T;

    /**
     * @default 'Color scheme'
     */
    Q6qOM: T;

    /**
     * @default 'Color scheme options'
     */
    MaOaI: T;

    /**
     * @default 'Colors'
     */
    U5cSp: T;

    /**
     * @default 'Choose event for summary'
     */
    C9SJb: T;

    /**
     * @default 'Event options'
     */
    GgcjP: T;

    /**
     * @default 'Guests Attending'
     */
    dGqcc: T;

    /**
     * @default 'Other Responses'
     */
    Qq0tk: T;

    /**
     * @default 'Guests Declined'
     */
    pFlaJ: T;

    /**
     * @default 'Guests Awaiting Response'
     */
    YJwVM: T;

    /**
     * @default 'Filter ({{0}} active)'
     */
    LytVW: T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default '{{0}} is hidden by your active filters.'
     */
    nXbWQ: T;

    /**
     * @default 'Clear Filters'
     */
    aVyZD: T;

    /**
     * @default 'Search guests...'
     */
    RxziX: T;

    /**
     * @default 'Filter Guests'
     */
    pUIWl: T;

    /**
     * @default 'Close filters'
     */
    nU0q9: T;

    /**
     * @default 'No options available'
     */
    GuGvA: T;

    /**
     * @default 'Clear All'
     */
    UcfzE: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'This guest'
     */
    q94QH: T;

    /**
     * @default '{{0}} hasn't RSVP'd yet.'
     */
    zQG4F: T;

    /**
     * @default 'Send RSVP Reminder'
     */
    LYQuO: T;

    /**
     * @default 'No contact info to send a reminder.'
     */
    vul88: T;

    /**
     * @default 'No matching question types'
     */
    nZo0G: T;

    /**
     * @default 'Custom'
     */
    ZzYxp: T;

    /**
     * @default 'Couldn't save the change. Please try again.'
     */
    RzA2J: T;

    /**
     * @default 'Edit {{0}}'s answer to {{1}} (currently {{2}})'
     */
    HgA3A: T;

    /**
     * @default 'Answer options for {{0}}: {{1}}'
     */
    OiDfE: T;

    /**
     * @default 'Saving…'
     */
    QFC8u: T;

    /**
     * @default 'Meal selections'
     */
    uZNXm: T;

    /**
     * @default '{{0}} Responded'
     */
    '8CBpP': T;

    /**
     * @default 'Meal selection breakdown'
     */
    eeav5: T;

    /**
     * @default 'Meals'
     */
    AH0aG: T;

    /**
     * @default 'Catering'
     */
    P3XAZ: T;

    /**
     * @default 'Copy Summary'
     */
    f38PO: T;

    /**
     * @default 'Spreadsheet'
     */
    uv8d6: T;

    /**
     * @default 'Filter to guests who picked {{0}}'
     */
    IpDCt: T;

    /**
     * @default 'No matching guests'
     */
    phV3q: T;

    /**
     * @default 'Unable to load the RSVP summary. Please try again later.'
     */
    PP2F2: T;

    /**
     * @default '1 of these guests needs a reminder.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 of these guests needs a reminder.
     * - plural: {{0}} of these guests need a reminder.
     */
    CHHjU: T;

    /**
     * @default 'Create Reminder…'
     */
    '6H54E': T;

    /**
     * @default 'Turn On RSVP'
     */
    XPmiv: T;

    /**
     * @default 'Extend Deadline'
     */
    clLMM: T;

    /**
     * @default 'View Pending'
     */
    MWQi9: T;

    /**
     * @default '{{0}} of {{1}} guests have responded'
     */
    jJSa5: T;

    /**
     * @default '{{0}}% Responded'
     */
    HXsCF: T;

    /**
     * @default '{{0}} Group'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} Group
     * - plural: {{0}} Groups
     */
    dWjqG: T;

    /**
     * @default '{{0}} group attending'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} group attending
     * - plural: {{0}} groups attending
     */
    JokI2: T;

    /**
     * @default '{{0}} Asked'
     */
    IgIyh: T;

    /**
     * @default 'Filter to attending'
     */
    r2ADM: T;

    /**
     * @default 'Filter to other'
     */
    '76zFm': T;

    /**
     * @default 'Filter to declined'
     */
    '3fknp': T;

    /**
     * @default 'Filter to awaiting response'
     */
    YW8Oi: T;

    /**
     * @default 'Remove {{0}} filter'
     */
    YK0cm: T;

    /**
     * @default 'Add {{0}} filter'
     */
    Rvxti: T;

    /**
     * @default 'No Responses'
     */
    NHkG2: T;

    /**
     * @default 'Answered'
     */
    vDuJq: T;

    /**
     * @default 'Left Blank'
     */
    XKwGQ: T;

    /**
     * @default 'View RSVP Response'
     */
    z9Bxw: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'Show Groups'
     */
    zZ8gD: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Awaiting'
     */
    qtPV1: T;

    /**
     * @default 'Group Size'
     */
    SXz7p: T;

    /**
     * @default 'Latest Update'
     */
    I0CdF: T;

    /**
     * @default 'Sort guests'
     */
    NFqTD: T;

    /**
     * @default 'Sort:'
     */
    whR6G: T;

    /**
     * @default 'Sort options'
     */
    YiS7H: T;

    /**
     * @default '{{0}} Guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} Guest
     * - plural: {{0}} Guests
     */
    Hs1ou: T;

    /**
     * @default 'Show all statuses'
     */
    AvTlj: T;

    /**
     * @default 'Show only {{0}}'
     */
    '5HIFK': T;

    /**
     * @default 'Showing only'
     */
    '3nSUv': T;

    /**
     * @default 'Show only'
     */
    R74NB: T;

    /**
     * @default 'Responses copied'
     */
    '0j8Nu': T;

    /**
     * @default 'Copy responses'
     */
    TPk9a: T;

    /**
     * @default '{{0}} of {{1}} responded'
     */
    SwYXc: T;

    /**
     * @default 'Choice breakdown'
     */
    WvMo4: T;

    /**
     * @default 'Response progress'
     */
    '61P1e': T;

    /**
     * @default 'View {{0}} Awaiting'
     */
    jMnN7: T;

    /**
     * @default 'View {{0}} Responses'
     */
    bJ1if: T;

    /**
     * @default 'Hide Responses'
     */
    wMXlh: T;

    /**
     * @default 'Unable to load responses. Please try again later.'
     */
    loRc3: T;

    /**
     * @default 'Search questions…'
     */
    vAsHi: T;

    /**
     * @default 'No questions or responses match "{{0}}".'
     */
    E5wNy: T;

    /**
     * @default 'No questions match the selected filters.'
     */
    kPSB6: T;

    /**
     * @default 'Copy All Responses'
     */
    K2ium: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Unable to load question stats. Please try again later.'
     */
    W06lC: T;

    /**
     * @default 'Edit responses in'
     */
    Li6iu: T;

    /**
     * @default '{{0}} of {{1}} guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} of {{1}} guest
     * - plural: {{0}} of {{1}} guests
     */
    dtTYE: T;

    /**
     * @default '{{0}} group'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} group
     * - plural: {{0}} groups
     */
    TXoje: T;

    /**
     * @default 'All Events'
     */
    CELDk: T;

    /**
     * @default '{{0}} & {{1}}'
     */
    '7eUJY': T;

    /**
     * @default 'By Question'
     */
    d9Y8H: T;

    /**
     * @default 'By Guest'
     */
    Fbl0e: T;

    /**
     * @default 'By Lodging'
     */
    hrJIH: T;

    /**
     * @default 'At a Glance'
     */
    kyeFV: T;

    /**
     * @default 'Browse Responses'
     */
    WjXj8: T;

    /**
     * @default 'Due {{0}} · 1 day left'
     * @param {number} count - The number of occurrences.
     * - singular: Due {{0}} · 1 day left
     * - plural: Due {{0}} · {{1}} days left
     */
    HltSc: T;

    /**
     * @default '1 day left'
     * @param {number} count - The number of occurrences.
     * - singular: 1 day left
     * - plural: {{0}} days left
     */
    YF6EO: T;

    /**
     * @default 'Set Deadline'
     */
    yy1C7: T;

    /**
     * @default 'Closed {{0}}'
     */
    wJZnN: T;

    /**
     * @default 'Closed'
     */
    CcAEp: T;

    /**
     * @default 'Grace until {{0}} · {{1}}h left'
     */
    li0XU: T;

    /**
     * @default 'Grace until {{0}}'
     */
    '6mcMP': T;

    /**
     * @default 'Grace Period'
     */
    TT2wm: T;

    /**
     * @default 'Due today'
     */
    bOc2g: T;

    /**
     * @default 'Primary invitee'
     */
    AQW2j: T;

    /**
     * @default 'Household member'
     */
    pfgJU: T;

    /**
     * @default 'Plus-one'
     */
    fgbR3: T;

    /**
     * @default 'Short Answer'
     */
    '0isuN': T;

    /**
     * @default 'Song Request'
     */
    uhJOE: T;

    /**
     * @default 'Phone Number'
     */
    fwf1p: T;

    /**
     * @default 'Events'
     */
    vloIv: T;

    /**
     * @default 'No attendance questions on this event'
     */
    sZnIu: T;

    /**
     * @default 'Attendance Status'
     */
    '3uYAm': T;

    /**
     * @default 'Guest Type'
     */
    '6qnrA': T;

    /**
     * @default 'Plus-one matches extra guests added without a name; named plus-ones count as household members.'
     */
    MDKrv: T;

    /**
     * @default 'Question Types'
     */
    tIEi1: T;

    /**
     * @default 'Filters the question rows shown inside each guest's expanded card.'
     */
    OpwEJ: T;

    /**
     * @default 'No question types on this event'
     */
    '7RaIA': T;

    /**
     * @default 'Guest Tags'
     */
    zygrA: T;

    /**
     * @default 'No tags created yet'
     */
    '81H5v': T;

    /**
     * @default 'Catering order copied'
     */
    rVNpt: T;

    /**
     * @default 'Group'
     */
    RmA9F: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Count'
     */
    FKqoF: T;

    /**
     * @default 'Total Responded'
     */
    '2TMj6': T;

    /**
     * @default 'Catering plan downloaded'
     */
    tm49G: T;

    /**
     * @default 'Turn on RSVP so your 1 guest can respond.'
     * @param {number} count - The number of occurrences.
     * - singular: Turn on RSVP so your 1 guest can respond.
     * - plural: Turn on RSVP so your {{0}} guests can respond.
     */
    aiMjW: T;

    /**
     * @default '1 guest missed the RSVP deadline.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest missed the RSVP deadline.
     * - plural: {{0}} guests missed the RSVP deadline.
     */
    eux9G: T;

    /**
     * @default '1 guest needs an RSVP reminder.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest needs an RSVP reminder.
     * - plural: {{0}} guests need an RSVP reminder.
     */
    VX5Mj: T;

    /**
     * @default '{{0}} missed the RSVP deadline.'
     */
    H71Ip: T;

    /**
     * @default '{{0}} and {{1}} others missed the RSVP deadline.'
     */
    K2QIg: T;

    /**
     * @default '{{0}} needs an RSVP reminder.'
     */
    '3121t': T;

    /**
     * @default '{{0}} and {{1}} need an RSVP reminder.'
     */
    gTfP1: T;

    /**
     * @default '{{0}} and {{1}} others need an RSVP reminder.'
     */
    '3CkE4': T;

    /**
     * @default 'All responses copied'
     */
    '1Tg4A': T;

    /**
     * @default 'Responses downloaded'
     */
    j2xZ5: T;

    /**
     * @default 'Adding...'
     */
    bv3l8: T;

    /**
     * @default 'Your Attendance question isn't working'
     */
    KfayM: T;

    /**
     * @default '"{{0}}" is missing its answer options, so Joy can't track who's coming or send reminders. Contact us and we'll fix it.'
     */
    VZ0od: T;

    /**
     * @default 'You need an Attendance question'
     */
    nKr90: T;

    /**
     * @default 'Joy uses the Attendance question to track who's coming and who needs a reminder. Multiple Choice answers won't update RSVP status.'
     */
    l0YGP: T;

    /**
     * @default '"{{0}}" is archived. Turn it back on to start tracking again.'
     */
    CAaeK: T;

    /**
     * @default 'Review Archived Questions'
     */
    J7mJM: T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Add Attendance Question'
     */
    K5G1P: T;

    /**
     * @default 'Active ({{0}})'
     */
    RG4rs: T;

    /**
     * @default 'Inactive ({{0}})'
     */
    ok3L6: T;

    /**
     * @default 'Will you be attending our [name of event]?'
     */
    h3HQ1: T;

    /**
     * @default 'What meal would you prefer?'
     */
    k3sdy: T;

    /**
     * @default 'Do you need help finding hotel accommodations?'
     */
    ObWa8: T;

    /**
     * @default 'Can you provide a cell phone number where your group may be reached?'
     */
    urh2l: T;

    /**
     * @default 'What song will get you out on the dance floor?'
     */
    Yd5OY: T;

    /**
     * @default 'Just for fun, where should we go on our honeymoon?'
     */
    '8QIKW': T;

    /**
     * @default 'Just for fun, what's the best piece of marriage advice you've heard?'
     */
    gomtj: T;

    /**
     * @default 'Not Attending'
     */
    RXHya: T;

    /**
     * @default 'Chicken'
     */
    xAjBk: T;

    /**
     * @default 'Steak'
     */
    Qc86G: T;

    /**
     * @default 'Pasta (vegetarian)'
     */
    ehPVO: T;

    /**
     * @default 'Yes, I could use help finding a hotel'
     */
    HsmDy: T;

    /**
     * @default 'No, I already have a place to stay'
     */
    klwxR: T;

    /**
     * @default 'Maybe'
     */
    eaVaG: T;

    /**
     * @default 'Leaving this site? Changes you made have not been saved.'
     */
    JDjEc: T;

    /**
     * @default 'Guest List Guests'
     */
    B3hrq: T;

    /**
     * @default 'includes +1s'
     */
    GcszY: T;

    /**
     * @default 'Guest List Households'
     */
    '4r0ED': T;

    /**
     * @default 'Unable to load RSVP stats. Please try again later.'
     */
    '31TVn': T;

    /**
     * @default 'Not attending'
     */
    XQIds: T;

    /**
     * @default 'Neither'
     */
    dvSh3: T;

    /**
     * @default 'Guests who pick this option are counted as attending.'
     */
    t9qOG: T;

    /**
     * @default 'Guests who pick this option are counted as not attending.'
     */
    CH0z1: T;

    /**
     * @default 'Guests who pick this option have responded, but are counted as neither attending nor not attending.'
     */
    jO2tM: T;

    /**
     * @default 'The first option is tagged Attending, and Joy keeps it that way. Edit its text to change what guests see.'
     */
    eX1Dt: T;

    /**
     * @default 'The second option is tagged Not attending, and Joy keeps it that way. Edit its text to change what guests see.'
     */
    hCnjS: T;

    /**
     * @default 'Attendance meaning: {{0}}'
     */
    O5NiJ: T;

    /**
     * @default 'This option means'
     */
    bTmjx: T;

    /**
     * @default 'Choice already selected by guests'
     */
    syPTq: T;

    /**
     * @default 'Guests who have selected this choice will have their answers updated. Are you sure you want to update this choice?'
     */
    MebsG: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'For guests who have selected this choice, their answers would disappear. We strongly advise that you not delete this choice.'
     */
    '4BP1R': T;

    /**
     * @default 'Delete Anyway'
     */
    OT12S: T;

    /**
     * @default 'Adding answer choice...'
     */
    oC45P: T;

    /**
     * @default 'Add answer choice'
     */
    S5Jup: T;

    /**
     * @default 'If'
     */
    foAAA: T;

    /**
     * @default 'Anyone who visits your website'
     */
    G9yvi: T;

    /**
     * @default 'Anyone who has your event password'
     */
    IIYEA: T;

    /**
     * @default 'Specific guests'
     */
    Xn01r: T;

    /**
     * @default 'Specific guests with your event password'
     */
    xg6fk: T;

    /**
     * @default 'Show this question to your guests.'
     */
    s6bHU: T;

    /**
     * @default 'Individual'
     */
    '1Ilox': T;

    /**
     * @default 'Attendance questions are special. Guests should answer this individually, in case not everyone in a group can attend.'
     */
    ptfkU: T;

    /**
     * @default 'Follow-up questions to questions that are ask once per group, cannot be set to ask per guest.'
     */
    y1mmd: T;

    /**
     * @default 'If a main question has a follow-up question that is set to ask once per guest, the main question cannot be set to ask per group.'
     */
    Mbxce: T;

    /**
     * @default 'Unnamed Guest'
     */
    s4P35: T;

    /**
     * @default 'No one can see this question'
     */
    cfqhy: T;

    /**
     * @default 'Question Visibility'
     */
    c4vpq: T;

    /**
     * @default 'Choose who to show this question to.'
     */
    '0o8YM': T;

    /**
     * @default 'Ask'
     */
    naTAA: T;

    /**
     * @default 'All Guests'
     */
    IwnQp: T;

    /**
     * @default 'Ask once per'
     */
    XyMxJ: T;

    /**
     * @default 'Receive one response per guest/plus one or group.'
     */
    '4kREU': T;

    /**
     * @default 'Guest list column'
     */
    uWYiU: T;

    /**
     * @default 'Column header'
     */
    nG34e: T;

    /**
     * @default 'Delete question'
     */
    voLQO: T;

    /**
     * @default 'Unarchive'
     */
    J6WZA: T;

    /**
     * @default 'Delete Question?'
     */
    '0BU7Q': T;

    /**
     * @default 'This will permanently delete the question from your RSVP Questions.'
     */
    Irmb4: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Cannot delete question'
     */
    '2yD64': T;

    /**
     * @default 'Looks like you currently have a follow-up question attached to this question. Delete that follow-up question first to delete this question.'
     */
    McH6T: T;

    /**
     * @default 'Archive'
     */
    SQajg: T;

    /**
     * @default 'Sorry we can't delete this question'
     */
    N7pUr: T;

    /**
     * @default 'We can’t delete it because this question has collected responses already. You can archive this question instead, to hide it from guests.'
     */
    WL5nB: T;

    /**
     * @default 'Rename guest list column'
     */
    yCfin: T;

    /**
     * @default 'Responses to this question will appear in a column in your '
     */
    EtCaR: T;

    /**
     * @default 'guest list.'
     */
    GG26X: T;

    /**
     * @default 'Custom column name'
     */
    iASIG: T;

    /**
     * @default 'E.g. Rehearsal Dinner'
     */
    Tqe3s: T;

    /**
     * @default 'You can rename the column tag on Guest List. These columns will automatically populate with guest responses after guests RSVP'
     */
    g2gWV: T;

    /**
     * @default 'Guest List Column Header'
     */
    jUezM: T;

    /**
     * @default 'OK'
     */
    QrAAA: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Ask all guests'
     */
    Rje4P: T;

    /**
     * @default 'once per guest'
     */
    cOD3i: T;

    /**
     * @default 'once per group'
     */
    NCo2i: T;

    /**
     * @default 'Add events to your Schedule page to link them here.'
     */
    VFSjx: T;

    /**
     * @default 'Choose the events this question belongs to.'
     */
    S6D3X: T;

    /**
     * @default 'Select Events'
     */
    HXV1V: T;

    /**
     * @default 'Edit Schedule'
     */
    hv6rG: T;

    /**
     * @default 'Whole event'
     */
    jxo0i: T;

    /**
     * @default 'Meal for'
     */
    AnRem: T;

    /**
     * @default 'Unarchive Question'
     */
    F6FDH: T;

    /**
     * @default '+ Add tag'
     */
    ynx5X: T;

    /**
     * @default 'Tag as'
     */
    M0NLX: T;

    /**
     * @default 'Remove tag'
     */
    otnwg: T;

    /**
     * @default 'Collapse question'
     */
    NFIVX: T;

    /**
     * @default 'Expand question'
     */
    m1hj7: T;

    /**
     * @default 'Supports follow-up questions'
     */
    MSEdX: T;

    /**
     * @default 'Leave this choice empty?'
     */
    WSJlV: T;

    /**
     * @default 'You have a follow-up question attached to this choice. It will not be shown to any guests if this choice is empty.'
     */
    qmyZ8: T;

    /**
     * @default 'Multiple choice'
     */
    R7rIF: T;

    /**
     * @default '{{0}} questions always need to be answered.'
     */
    pWFft: T;
  };
};

export type RsvpCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'RSVP button text is required'
     */
    P1T9S: T;

    /**
     * @default 'Unlock button text is required'
     */
    oxVMB: T;

    /**
     * @default 'Unlock Guest Details'
     */
    eKWZY: T;

    /**
     * @default 'Success! RSVP block has been updated.'
     */
    XuSV0: T;

    /**
     * @default 'Success! RSVP block has been saved.'
     */
    '9Bn0F': T;

    /**
     * @default 'An error occurred while saving the RSVP block. Please try again.'
     */
    LxP7T: T;

    /**
     * @default 'RSVP/Unlock Button'
     */
    Ck0Zi: T;

    /**
     * @default 'RSVP Button Text'
     */
    Um52l: T;

    /**
     * @default 'Enter RSVP button text'
     */
    QdTz4: T;

    /**
     * @default 'Unlock Button Text'
     */
    jZv2N: T;

    /**
     * @default 'Enter unlock button text'
     */
    jsYmF: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Access to RSVP for your guests'
     */
    hOVHX: T;

    /**
     * @default 'RSVP/Unlock Button component is not editable.'
     */
    MlqAC: T;
  };
};

export type RsvpDeadlineStatusTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'RSVP Closed'
     */
    NC1tL: T;

    /**
     * @default 'RSVP Grace Period'
     */
    eddn7: T;

    /**
     * @default 'The RSVP deadline and grace period have passed. Guests can no longer RSVP.'
     */
    wbJB2: T;

    /**
     * @default 'The RSVP deadline has passed. Guests can still RSVP during the grace period.'
     */
    jZSqY: T;

    /**
     * @default 'Grace Period · {{0}} hours left'
     */
    yTJ9P: T;

    /**
     * @default 'Grace Period'
     */
    TT2wm: T;

    /**
     * @default 'RSVP Open'
     */
    BiOnC: T;
  };
};

export type RsvpReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Send RSVP Reminder'
   */
  title: T;

  editMessage: {
    /**
     * @default 'From'
     */
    fromLabel: T;

    /**
     * @default 'Your message'
     */
    messageLabel: T;

    /**
     * @default 'RSVP Link'
     */
    rsvpLinkLabel: T;

    /**
     * @default 'Link is not editable to prevent abuse and misuse of the platform.'
     */
    rsvpLinkLabelHint: T;

    /**
     * @default 'Remind your guests to RSVP'
     */
    title: T;

    /**
     * @default 'Send email to make sure your guests don’t miss the chance to RSVP to your event.'
     */
    description: T;

    /**
     * @default 'How does it work?'
     */
    howItWorks: T;

    /**
     * @default 'Write your message.'
     */
    howItWorksStep1: T;

    /**
     * @default 'Pick guests to remind.'
     */
    howItWorksStep2: T;

    /**
     * @default 'Reminder sent!'
     */
    howItWorksStep3: T;
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    /**
     * @default 'Has not RSVPd'
     */
    hasNotRSVPdLabel: T;

    /**
     * @default 'All guests with contact info in the guest list have RSVP’d'
     */
    hasNotRSVPdLabelInfo: T;

    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Edit recipients
           */
          guest: T;
        };

        /**
         * @default 'We have preselected guests who have not RSVP’d, but you can edit our selection if you wish.'
         */
        dek: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testEmail: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test Email'
         */
        buttonText: T;
      };
      send: {
        /**
         * @default 'Send Reminder'
         */
        hed: T;

        /**
         * @default 'Send reminder to all guests you picked.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
    };
    EmailSentSuccessMessage: {
      /**
       * @default 'Your email is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your email is on the way!
       * - plural: Your emails are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    EmailSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    /**
     * @default 'Email is not valid'
     */
    emailInvalidMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your reminder to RSVP has been sent to {{count}} people.'
       */
      hed: T;

      /**
       * @default 'Patience is a virtue, but these great rates won’t wait!'
       */
      dek: T;

      /**
       * @default 'You can track their responses by clicking the link below.'
       */
      buttonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      emailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'pat@withjoy.com'
       */
      emailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      emailErrorMessage: T;

      /**
       * @default 'Should be a valid email address'
       */
      emailInvalidErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    message: {
      /**
       * @default 'Our wedding is right around the corner 🎉. We can’t wait to celebrate with you! Friendly reminder that our RSVP deadline is coming up. Let us know as soon as possible if you will be in attendance.'
       */
      default: T;
    };

    /**
     * @default 'Confirm & Send'
     */
    confirmAndSendLabel: T;

    /**
     * @default 'Edit Message'
     */
    editMessageLabel: T;

    /**
     * @default 'Next'
     */
    nextButtonText: T;

    /**
     * @default 'To:'
     */
    toLabel: T;

    /**
     * @default 'Subject:'
     */
    subjectLabel: T;
  };
  quick: {
    /**
     * @default 'Must be at least {{0}} characters in length. Generic or placeholder text may prevent delivery.'
     */
    cCMCJ: T;

    /**
     * @default 'Sender name must be {{0}} characters or fewer.'
     */
    gjs6q: T;

    /**
     * @default 'Our wedding is right around the corner 🎉. We can't wait to celebrate with you! Friendly reminder that our RSVP deadline is coming up. Let us know as soon as possible if you will be in attendance.'
     */
    e3PKk: T;

    /**
     * @default 'Don't forget to RSVP for {{0}}'
     */
    y3T3A: T;

    /**
     * @default 'Don't forget to RSVP'
     */
    VQLwd: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    A3Epe: T;

    /**
     * @default 'Untitled RSVP reminder - {{0}}'
     */
    '5FiMK': T;

    /**
     * @default 'Dear'
     */
    QMtKA: T;

    /**
     * @default 'Message sent successfully!'
     */
    d2F6T: T;

    /**
     * @default 'RSVP Reminder'
     */
    d6QBS: T;

    /**
     * @default 'Messaging+ is active. You can now schedule messages and text your guests.'
     */
    TC4p2: T;

    /**
     * @default 'Payment was not completed. You can try again when you're ready.'
     */
    tlQsK: T;

    /**
     * @default 'Payment received, but activation is taking longer than expected. Please refresh the page.'
     */
    VHGYp: T;

    /**
     * @default '1 selected guest wasn't in the group you started with'
     * @param {number} count - The number of occurrences.
     * - singular: 1 selected guest wasn't in the group you started with
     * - plural: {{0}} selected guests weren't in the group you started with
     */
    CTDXT: T;

    /**
     * @default '1 selected guest doesn't need a reminder'
     * @param {number} count - The number of occurrences.
     * - singular: 1 selected guest doesn't need a reminder
     * - plural: {{0}} selected guests don't need a reminder
     */
    YotMu: T;

    /**
     * @default 'Awaiting RSVP'
     */
    HYm6a: T;

    /**
     * @default 'RSVP reminders always go to guests who haven't responded yet. Pick tags to send to fewer of them.'
     */
    yvpop: T;

    /**
     * @default 'We couldn't check who still owes you an RSVP. Add guests yourself, or try again in a moment.'
     */
    EHPaP: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Select All Awaiting'
     */
    pMnKb: T;

    /**
     * @default 'Not asked to RSVP'
     */
    ZjzzO: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Declined'
     */
    kUvCR: T;

    /**
     * @default 'Already responded'
     */
    CWapN: T;

    /**
     * @default 'Your reminder to book has been sent to {{0}} people.'
     */
    pCHNw: T;

    /**
     * @default 'Patience is a virtue, but these great rates won’t wait!'
     */
    y8ZWz: T;

    /**
     * @default 'View Your Guests List'
     */
    '1esP9': T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Subject (Email only)'
     */
    '91kvm': T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Preview and edit your message to your guests.'
     */
    '2ms2C': T;

    /**
     * @default 'Optional Test Email'
     */
    UbuTN: T;

    /**
     * @default 'Never hurts to make sure everything is just right.'
     */
    dEpA1: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'No guests selected yet.'
     * @param {number} count - The number of occurrences.
     * - zero: No guests selected yet.
     * - singular: 1 guest selected.
     * - plural: {{0}} guests selected.
     */
    t0nZk: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'Edit Guests'
     */
    Zoa0t: T;

    /**
     * @default 'Add Guests'
     */
    sMEgi: T;

    /**
     * @default 'Send to 1 Person'
     * @param {number} count - The number of occurrences.
     * - singular: Send to 1 Person
     * - plural: Send to {{0}} People
     */
    XqD7N: T;

    /**
     * @default 'Send Message'
     */
    bkLsr: T;

    /**
     * @default 'Keep an eye on replies and poke the slow pokes.'
     */
    cqENB: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Send to (No Guests Selected)'
     */
    xdSso: T;

    /**
     * @default 'Select an admin'
     */
    wKRDT: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'We're reviewing your message before delivery'
     */
    '5msPb': T;

    /**
     * @default 'We couldn't save your message. Please try again.'
     */
    YuoZ4: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Send Now'
     */
    Ow0GV: T;

    /**
     * @default 'Confirm & Send'
     */
    KYpY4: T;

    /**
     * @default 'Review the details below and send your RSVP reminder to your guests.'
     */
    ATWF9: T;

    /**
     * @default '1 Person Selected…'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    HsBfd: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'Modify Recipients'
     */
    Yv9UB: T;

    /**
     * @default 'Compose Message'
     */
    lBM1t: T;

    /**
     * @default 'Send a nudge to your guests to RSVP.'
     */
    nUmcH: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Photo (Email only)'
     */
    d8IIe: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Review Scheduled Reminder'
     */
    vriLd: T;

    /**
     * @default 'This reminder is locked while it's scheduled. Use "Edit Message" to make changes.'
     */
    dPkS1: T;

    /**
     * @default 'Reschedule send'
     */
    qm0u7: T;

    /**
     * @default 'Reschedule'
     */
    '82rNl': T;
  };
};

export type RsvpSettingsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Upgrade to'
     */
    FvLPP: T;

    /**
     * @default 'Plus'
     */
    ahjMA: T;

    /**
     * @default 'Send event details message after RSVP completion'
     */
    MDcd0: T;

    /**
     * @default 'Event Details Message'
     */
    vjRwC: T;

    /**
     * @default 'This is the second message after someone completes RSVP that includes a helpful summary of event details and important links.'
     */
    TvpQ0: T;

    /**
     * @default 'Learn more about the event details message'
     */
    '6oTj9': T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Declined'
     */
    kUvCR: T;

    /**
     * @default 'Both'
     */
    ledKA: T;

    /**
     * @default 'Custom RSVP Redirect Links'
     */
    laMlG: T;

    /**
     * @default 'Attending URL'
     */
    JiNzZ: T;

    /**
     * @default 'Redirect URL for guests who are attending'
     */
    x578Y: T;

    /**
     * @default 'Declined URL'
     */
    rcSuK: T;

    /**
     * @default 'Redirect URL for guests who declined'
     */
    xkv5b: T;

    /**
     * @default 'Enter a valid URL starting with https://'
     */
    '5GkrV': T;

    /**
     * @default 'Upgrade to RSVP Plus'
     */
    MbbRU: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Unlock advanced RSVP tools.'
     */
    saxyC: T;

    /**
     * @default 'Customize how guests RSVP and what happens next.'
     */
    KEuS9: T;

    /**
     * @default 'Embed your RSVP'
     */
    Rx8nN: T;

    /**
     * @default 'Just link directly from any site.'
     */
    xBh23: T;

    /**
     * @default 'Custom Redirects'
     */
    '23asT': T;

    /**
     * @default 'Send guests anywhere after RSVP.'
     */
    lNO6Q: T;

    /**
     * @default 'Custom Confirmation Emails'
     */
    pfdEQ: T;

    /**
     * @default 'Customize your post-RSVP emails.'
     */
    LbPrE: T;

    /**
     * @default 'RSVP Plus'
     */
    '93WnC': T;

    /**
     * @default 'By purchasing you are acquiring a license to access digital products and agree to Joy's '
     */
    E43nC: T;

    /**
     * @default 'terms'
     */
    r48iJ: T;

    /**
     * @default ' and '
     */
    HQXyC: T;

    /**
     * @default 'privacy'
     */
    cXsmJ: T;

    /**
     * @default 'Basic'
     */
    cJkhF: T;

    /**
     * @default 'Failed to update RSVP tier. Please try again.'
     */
    hZ8EG: T;

    /**
     * @default 'RSVP Tier'
     */
    RT7nC: T;

    /**
     * @default 'Unable to load RSVP settings. Please try refreshing.'
     */
    sIbEj: T;

    /**
     * @default 'Enable RSVP'
     */
    KyJPw: T;

    /**
     * @default 'Show RSVP on your website'
     */
    JTSso: T;

    /**
     * @default 'Turning RSVP on or off will add or remove it from your website and app.'
     */
    afx2e: T;

    /**
     * @default 'The RSVP deadline has passed. Guests can no longer RSVP.'
     */
    YlURY: T;

    /**
     * @default 'The RSVP deadline has passed. Guests can still RSVP until {{0}}.'
     */
    QpWOe: T;

    /**
     * @default 'The RSVP deadline has passed. Guests can still RSVP during the grace period.'
     */
    jZSqY: T;

    /**
     * @default 'Privacy'
     */
    CovGk: T;

    /**
     * @default 'Require Password'
     */
    qvrpI: T;

    /**
     * @default 'Guests can only RSVP after entering a '
     */
    FyAz8: T;

    /**
     * @default 'password'
     */
    DkoFg: T;

    /**
     * @default 'Restrict RSVP to Guest List'
     */
    GsnFI: T;

    /**
     * @default 'Only allow people on your guest list to RSVP. Guests must confirm their names with an exact match.'
     */
    R983A: T;

    /**
     * @default 'Allow guests to add their own +1s'
     */
    '9SlDn': T;

    /**
     * @default 'Let any guest add +1s during RSVP without you assigning them individually. Popular for large weddings and families.'
     */
    CxT9H: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'RSVP Deadline'
     */
    rzp9I: T;

    /**
     * @default 'Advanced'
     */
    MzOVu: T;

    /**
     * @default 'Most users leave these set to defaults.'
     */
    CVW2l: T;

    /**
     * @default 'Automatically remind guests about important event details'
     */
    '42wf4': T;

    /**
     * @default 'Automatic Event Reminders'
     */
    Izk2R: T;

    /**
     * @default 'Sometimes guests forget to read FAQs, check the schedule, or plan what to wear. Keep your event top of mind and occasionally remind attending guests about event details and send them links to the event.'
     */
    RBdzP: T;

    /**
     * @default 'Learn more about automatic event reminders'
     */
    COzUC: T;

    /**
     * @default 'Keep your event top of mind by occasionally reminding attending guests about event details.'
     */
    '1qILU': T;

    /**
     * @default 'Send RSVP summary emails to collaborators'
     */
    enw9b: T;

    /**
     * @default 'RSVP Summary Emails'
     */
    S36dr: T;

    /**
     * @default 'When enabled, the event owner and all collaborators receive a summary email each time a guest RSVPs. When disabled, only the event owner receives it. This doesn't affect any other emails.'
     */
    WjW4T: T;

    /**
     * @default 'Learn more about who receives RSVP summary emails'
     */
    YWxnS: T;

    /**
     * @default 'When disabled, only the event owner receives RSVP summary emails.'
     */
    Af3A8: T;

    /**
     * @default 'Superuser Settings'
     */
    XKrML: T;

    /**
     * @default 'Attach a calendar invite to RSVP confirmations'
     */
    T9iDq: T;

    /**
     * @default 'Calendar Invite'
     */
    XphII: T;

    /**
     * @default 'Adds a calendar invitation to the confirmation email for guests who RSVP yes, so the event is one tap away instead of sitting behind a link they have to find again. Turning this off removes the invitation only — the confirmation email still sends, and guests who already added the event keep it.'
     */
    mT852: T;

    /**
     * @default 'Learn more about calendar invites'
     */
    gkdEX: T;

    /**
     * @default 'Guests who RSVP yes can add the event to their calendar in one tap. The email sends either way.'
     */
    gVQNq: T;

    /**
     * @default 'Enable custom redirect for guests who RSVP Yes'
     */
    KFYij: T;

    /**
     * @default 'Custom Redirect for Yes RSVP'
     */
    OnW7r: T;

    /**
     * @default 'When enabled, guests who RSVP Yes will be redirected to a custom URL after submitting their RSVP. This can be used to provide additional information or resources for those who are attending.'
     */
    '4M3Ee': T;

    /**
     * @default 'Learn more about the custom redirect for Yes RSVPs'
     */
    '0CBGE': T;

    /**
     * @default 'Redirect URL for guests who RSVP Yes'
     */
    '7FgAu': T;

    /**
     * @default 'Enable custom redirect for guests who RSVP No'
     */
    IuEk1: T;

    /**
     * @default 'Custom Redirect for No RSVP'
     */
    '0kuPT': T;

    /**
     * @default 'When enabled, guests who RSVP No will be redirected to a custom URL after submitting their RSVP. This can be used to provide additional information or resources for those who are unable to attend.'
     */
    '4UN0U': T;

    /**
     * @default 'Learn more about the custom redirect for No RSVPs'
     */
    '2TQiJ': T;

    /**
     * @default 'Redirect URL for guests who RSVP No'
     */
    XtAUS: T;

    /**
     * @default 'Guests might miss key details if you turn this off.'
     */
    vrb8H: T;

    /**
     * @default 'Reminders help guests stay on top of your event (and save you from last-minute texts).'
     */
    f5507: T;

    /**
     * @default 'How Reminders Work:'
     */
    MM8GM: T;

    /**
     * @default 'Sent only to guests who RSVP "Yes" and opt in'
     */
    '1AAOc': T;

    /**
     * @default 'Brings them back to your event website'
     */
    FZMtn: T;

    /**
     * @default 'Helps guests feel prepared and excited'
     */
    ld7zK: T;

    /**
     * @default 'Keep Reminding Guests'
     */
    RAx5z: T;

    /**
     * @default 'Turn Off Reminders'
     */
    dipwv: T;
  };
};

export type SaveStateAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Fix 1 field to save'
     * @param {number} count - The number of occurrences.
     * - singular: Fix 1 field to save
     * - plural: Fix {{0}} fields to save
     */
    OKvPO: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'All changes saved'
     */
    toOmQ: T;

    /**
     * @default 'Unsaved changes'
     */
    bsDEC: T;

    /**
     * @default 'Saving…'
     */
    QFC8u: T;

    /**
     * @default '✓ Saved just now'
     */
    kGAld: T;

    /**
     * @default 'Not saved'
     */
    Akbin: T;

    /**
     * @default 'Couldn’t save. Your changes are still here.'
     */
    '7JCbj': T;

    /**
     * @default 'Retry'
     */
    yGyzG: T;

    /**
     * @default 'Nothing to save yet'
     */
    Rn8hJ: T;

    /**
     * @default 'Nothing to revert'
     */
    IPcdM: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Leave {{0}} without saving?'
     */
    semeT: T;

    /**
     * @default 'You have unsaved changes. Save them before leaving, or they’ll be lost.'
     */
    '3MnVN': T;

    /**
     * @default 'Fix the invalid fields before saving, or choose Don’t Save.'
     */
    WMLue: T;

    /**
     * @default 'Couldn’t save. Your changes are still here. Try again, or choose Don’t Save.'
     */
    n9dsy: T;

    /**
     * @default 'Don’t Save'
     */
    pW0GK: T;

    /**
     * @default 'Unsaved preview'
     */
    g8ibC: T;
  };
};

export type ScheduleEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  form: {
    /**
     * @default 'Event Title'
     */
    nameFieldTitle: T;

    /**
     * @default 'Event Title'
     */
    nameFieldPlaceholder: T;

    /**
     * @default 'Description'
     */
    descriptionFieldTitle: T;

    /**
     * @default 'Description (Optional)'
     */
    descriptionFieldPlaceholder: T;

    /**
     * @default 'Event Time Zone'
     */
    timezoneFieldTitle: T;

    /**
     * @default 'Select your time zone'
     */
    timezoneFieldPlaceholder: T;

    /**
     * @default 'Start Date'
     */
    startDateTitle: T;

    /**
     * @default 'End Date'
     */
    endDateTitle: T;

    eventTimeSelector: {
      /**
       * @default 'Date and Time'
       */
      title: T;

      /**
       * @default 'Start Only'
       */
      startOnly: T;

      /**
       * @default 'Start + End'
       */
      startEnd: T;

      /**
       * @default 'TBA'
       */
      tba: T;
    };
    eventTypeSelector: {
      /**
       * @default 'Event Type'
       */
      title: T;

      /**
       * @default 'In Person'
       */
      inPerson: T;

      /**
       * @default 'Virtual'
       */
      virtual: T;

      /**
       * @default 'Both'
       */
      both: T;

      /**
       * @default 'Connect a Livestream'
       */
      eventTypeHeading: T;

      /**
       * @default 'Paste your livestream link below. Only guests who have access to this event will be able to see the link.'
       */
      eventTypeBody: T;

      /**
       * @default 'Virtual Event Link'
       */
      eventLinkHeading: T;

      /**
       * @default 'https://zoom.us/j/12345...'
       */
      eventLinkPlaceholder: T;

      /**
       * @default 'Test Livestream Link'
       */
      testLivestreamCTA: T;

      /**
       * @default 'Don’t have a link? Create one:'
       */
      createStreamHeading: T;

      /**
       * @default 'Which one is right for me?'
       */
      whichIsRight: T;
    };

    /**
     * @default 'Choose who can see "{{eventTitle}}" listed on your schedule page. Make this a <PrivateEvent/> by selecting individual guests or groups, using <Tags/>.'
     */
    privacyDescription: T;

    /**
     * @default 'Save'
     */
    primaryCTA: T;

    /**
     * @default 'Cancel'
     */
    secondaryCTA: T;

    /**
     * @default 'Delete Event'
     */
    destroyCTA: T;
  };
  quick: {
    /**
     * @default 'Just checking — delete this event?'
     * @param {number} count - The number of occurrences.
     * - singular: Just checking — delete this event?
     * - plural: Just checking — delete {{0}} events?
     */
    ru6jw: T;

    /**
     * @default 'You won't be able to get it back.'
     * @param {number} count - The number of occurrences.
     * - singular: You won't be able to get it back.
     * - plural: You won't be able to get them back.
     */
    dCNa4: T;

    /**
     * @default 'Delete Event'
     * @param {number} count - The number of occurrences.
     * - singular: Delete Event
     * - plural: Delete {{0}} Events
     */
    bhLt0: T;

    /**
     * @default 'Just checking — discard your changes?'
     */
    '5lai9': T;

    /**
     * @default 'You won't be able to get them back.'
     */
    JLJef: T;

    /**
     * @default 'Discard Changes'
     */
    '9jhfJ': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Just checking — delete this event?'
     */
    wxtsY: T;

    /**
     * @default 'You won't be able to get it back.'
     */
    qolzt: T;

    /**
     * @default 'Delete Event'
     */
    LBdpE: T;

    /**
     * @default 'Failed to load schedule item. Please try again.'
     */
    ZwCFy: T;

    /**
     * @default 'This schedule item is no longer available. It may have been deleted.'
     */
    U5Y7g: T;

    /**
     * @default 'Event deleted from your schedule'
     */
    z9WL9: T;

    /**
     * @default 'Failed to delete. Please try again.'
     */
    '0S0eI': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Edit Schedule Item'
     */
    OSCKM: T;

    /**
     * @default 'Add Schedule Item'
     */
    ftkOS: T;

    /**
     * @default 'Event date updated.'
     */
    B83uA: T;

    /**
     * @default 'Couldn't update event date. Try again from Settings.'
     */
    PEZ7B: T;

    /**
     * @default 'Failed to refresh schedule data. Please reload.'
     */
    B9FEd: T;

    /**
     * @default 'Update your event date?'
     */
    zTlcn: T;

    /**
     * @default 'Set your event date?'
     */
    kn7nL: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Set date'
     */
    m4bXK: T;

    /**
     * @default 'Keep current date'
     */
    IzFaC: T;

    /**
     * @default 'Not now'
     */
    '54drU': T;

    /**
     * @default 'Your main event date is currently {{0}}.'
     */
    auMnz: T;

    /**
     * @default 'You haven't set a main event date yet.'
     */
    IiKO2: T;

    /**
     * @default '"{{0}}" starts on {{1}}.'
     */
    Je9Wq: T;

    /**
     * @default 'Would you like to change your event date to {{0}} to match?'
     */
    FZrdK: T;

    /**
     * @default 'Would you like to use this as your event date?'
     */
    FHa7L: T;

    /**
     * @default 'Still loading your schedule. Please try again in a moment.'
     */
    t38SU: T;

    /**
     * @default 'Basic Info'
     */
    Kg1oX: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Event Title'
     */
    oQlBP: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Description (Optional)'
     */
    HIV4n: T;

    /**
     * @default 'Virtual events will display for guests in their local time.'
     */
    bCq3A: T;

    /**
     * @default 'Show 'Add to Calendar' button for this event'
     */
    Q7iWS: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'Show 'Get Directions' link for this event'
     */
    yosCN: T;

    /**
     * @default 'Directions'
     */
    G3n2r: T;

    /**
     * @default 'Schedule event privacy is only available on the main schedule page. Control who can see this page under page privacy.'
     */
    DJGrZ: T;

    /**
     * @default 'Dress Code'
     */
    '4K6cX': T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Business Casual'
     */
    vt8SH: T;

    /**
     * @default 'Select tags to show only to these guests'
     */
    ur9GJ: T;

    /**
     * @default 'Add tags...'
     */
    '8pk9P': T;

    /**
     * @default 'No guests have the tag {{0}} yet. This event won't be visible to anyone until you assign guests to it from the guest list.'
     */
    '273Fk': T;

    /**
     * @default 'No guests have the tags {{0}} yet. This event won't be visible to anyone until you assign guests to them from the guest list.'
     */
    W7UZN: T;

    /**
     * @default 'Event Type'
     */
    qRpbn: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Venue name or Address'
     */
    PE1OU: T;

    /**
     * @default 'Search for a location'
     */
    P4KWW: T;

    /**
     * @default 'Show map of location on schedule page'
     */
    mTBg7: T;

    /**
     * @default 'Maps require a venue with an address'
     */
    tnp06: T;

    /**
     * @default 'Map for {{0}}'
     */
    bjYyE: T;

    /**
     * @default 'Event Privacy'
     */
    aP73J: T;

    /**
     * @default 'Who should be able to see this item on your schedule?'
     */
    X6R6K: T;

    /**
     * @default 'Anyone who visits your website'
     */
    G9yvi: T;

    /**
     * @default 'Specific guests'
     */
    Xn01r: T;

    /**
     * @default 'Date and Time'
     */
    uDcZF: T;

    /**
     * @default 'Start Only'
     */
    OpjFJ: T;

    /**
     * @default 'Start + End'
     */
    '2PO4c': T;

    /**
     * @default 'TBA'
     */
    lXYAA: T;

    /**
     * @default 'Unnamed Guest'
     */
    s4P35: T;

    /**
     * @default 'this event'
     */
    MNGmI: T;

    /**
     * @default 'Learn about private events'
     */
    JsBRh: T;

    /**
     * @default 'private event'
     */
    RcPxL: T;

    /**
     * @default 'tags'
     */
    Z16RA: T;

    /**
     * @default 'Show this to guests with the tag:'
     */
    SkeP2: T;

    /**
     * @default 'In addition to the following guests:'
     */
    DTanK: T;

    /**
     * @default 'Choose tags'
     */
    yVEpA: T;

    /**
     * @default 'Choose guests'
     */
    YcdNt: T;

    /**
     * @default 'Select at least one label or person so guests can see this item.'
     */
    j3Pl2: T;

    /**
     * @default 'Show 'Where to Stay' link for this event'
     */
    xkPnB: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;
  };
};

export type SeatingChartTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Seating Chart'
     */
    '77iMR': T;
  };
};

export type ServiceCenterTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Good morning'
     */
    NPtIC: T;

    /**
     * @default 'Good afternoon'
     */
    jbKUS: T;

    /**
     * @default 'Search for an event'
     */
    GA4ba: T;

    /**
     * @default 'Restore a deleted event'
     */
    '6qCgV': T;

    /**
     * @default '0 Reviews'
     * @param {number} count - The number of occurrences.
     * - zero: 0 Reviews
     * - singular: 1 Review
     * - plural: {{0}} Reviews
     */
    x3KBd: T;

    /**
     * @default 'Fill out the search fields to query hotel results'
     */
    uzPWc: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Error: {{0}}'
     */
    iT0vr: T;

    /**
     * @default 'Price'
     */
    '7WvrG': T;

    /**
     * @default 'Distance'
     */
    '3I584': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Relevance'
     */
    dUkMH: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Failed to add accommodation. Please try again.'
     */
    KRR5O: T;

    /**
     * @default '{{0}}-star hotel'
     */
    '9pYlI': T;

    /**
     * @default '{{0}}/10'
     */
    UCSTN: T;

    /**
     * @default 'Less'
     */
    '3I6LA': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Joy Place ID: {{0}}'
     */
    '2IWKz': T;

    /**
     * @default 'Accommodations Place ID: {{0}}'
     */
    '1Y4vX': T;

    /**
     * @default 'Remove Hotel'
     */
    '8jLre': T;

    /**
     * @default 'Add Hotel'
     */
    TDwjJ: T;

    /**
     * @default 'There was an error updating the flag: {{0}}.'
     */
    LOXQL: T;

    /**
     * @default 'Draft design applied to live successfully.'
     */
    '2TOHO': T;

    /**
     * @default 'Failed to apply draft design to live.'
     */
    IbUTr: T;

    /**
     * @default 'Catalog Items Count: 0'
     * @param {number} count - The number of occurrences.
     * - zero: Catalog Items Count: 0
     * - singular: Catalog Item Count: 1
     * - plural: Catalog Items Count: {{0}}
     */
    MAuwC: T;

    /**
     * @default 'Event Info'
     */
    YP7Zn: T;

    /**
     * @default 'Event Display Name:'
     */
    veUA1: T;

    /**
     * @default 'Event Type:'
     */
    Co9DP: T;

    /**
     * @default 'Event Handle:'
     */
    wuxq2: T;

    /**
     * @default 'Event Id:'
     */
    tMrb6: T;

    /**
     * @default 'Event Id copied!'
     */
    McmPx: T;

    /**
     * @default 'Firebase Event Id:'
     */
    sVIbM: T;

    /**
     * @default 'Firebase Event Id copied!'
     */
    '1I6Pf': T;

    /**
     * @default 'Event Creation Date:'
     */
    RlUnr: T;

    /**
     * @default 'Days Since Creating:'
     */
    oriwp: T;

    /**
     * @default 'Active Flags:'
     */
    T6N8r: T;

    /**
     * @default 'none'
     */
    CxGRA: T;

    /**
     * @default 'Website Actions'
     */
    '0EUpH': T;

    /**
     * @default 'Apply the event's draft website design to the live site. Use this to restore a user's unpublished design changes after the website published state migration.'
     */
    bEqvP: T;

    /**
     * @default 'This event has unpublished design changes.'
     */
    SyXeG: T;

    /**
     * @default 'Draft and live designs are in sync.'
     */
    '3WCzI': T;

    /**
     * @default 'Apply Draft Design to Live'
     */
    wQViX: T;

    /**
     * @default 'No draft design found for this event.'
     */
    rOTRC: T;

    /**
     * @default 'Registry Actions'
     */
    '6IAaD': T;

    /**
     * @default 'Catalog Item Count: Loading'
     */
    PK69L: T;

    /**
     * @default 'Reset Onboarding Survey'
     */
    qFVKl: T;

    /**
     * @default 'Reset Shipping Address'
     */
    RxjuQ: T;

    /**
     * @default 'Delete External Registries & Items'
     */
    fC58o: T;

    /**
     * @default 'Delete Catalog & Custom Items'
     */
    h6zrn: T;

    /**
     * @default 'Refresh Post Transfer Items'
     */
    MwCPU: T;

    /**
     * @default 'Reset Checklist'
     */
    bbMFn: T;

    /**
     * @default 'Event not found'
     */
    LG0AY: T;

    /**
     * @default 'Messaging — all messaging emails (date reminders + post-RSVP hotel)'
     */
    ZmzxX: T;

    /**
     * @default 'Messaging — date reminders only (6, 3 and 1 month)'
     */
    rUmEl: T;

    /**
     * @default 'Hotel — all hotel emails for this event'
     */
    xQgiC: T;

    /**
     * @default 'Print — stationery cart reminders'
     */
    '0T2si': T;

    /**
     * @default 'Registry — gift cart reminders'
     */
    iYkzQ: T;

    /**
     * @default 'No matching subscription was found for this email.'
     */
    RC1lT: T;

    /**
     * @default 'Enter a valid email address'
     */
    v7tIl: T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'Provide an Event ID or an Event Handle'
     */
    ViH3C: T;

    /**
     * @default 'Choose which emails to stop'
     */
    Kz5Ej: T;

    /**
     * @default 'Manually unsubscribe an email address from one family of emails for an event. Enter the event's ID or its handle, and choose which emails to stop.'
     */
    zxdTL: T;

    /**
     * @default 'This cannot be undone from any screen — reversing it needs an engineer. No single option stops every Joy email: hotel, print and registry emails each need their own pick.'
     */
    '8cmbI': T;

    /**
     * @default 'Aug 21: Please use the Event ID instead for now while we debug why the Event Handle doesn't work consistently.'
     */
    l5iMr: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Event ID or Event Handle'
     */
    oL5vC: T;

    /**
     * @default 'Which emails to stop'
     */
    vgwB9: T;

    /**
     * @default 'Choose a family of emails'
     */
    Q0h5z: T;

    /**
     * @default 'Unsubscribe email'
     */
    N0W8Z: T;

    /**
     * @default '{{0}} was unsubscribed successfully.'
     */
    jYzxH: T;

    /**
     * @default 'Failed to unsubscribe {{0}}'
     */
    Vscyv: T;

    /**
     * @default 'Unsubscribe another email'
     */
    YvNmy: T;

    /**
     * @default 'An unknown error occurred.'
     */
    '8D8Bp': T;

    /**
     * @default 'Event ID must be a valid UUID'
     */
    tBD2i: T;

    /**
     * @default 'Event ID is required and must be a valid UUID'
     */
    TI1Uq: T;

    /**
     * @default 'If an event was accidentally deleted, you can restore it here. You will need the event ID (NOT from Firebase) to restore the event.'
     */
    BKgyv: T;

    /**
     * @default 'Event ID'
     */
    PeJlg: T;

    /**
     * @default 'Restore Event'
     */
    SI1mu: T;

    /**
     * @default 'Event {{0}} restored successfully.'
     */
    jJ5pR: T;

    /**
     * @default 'Failed to restore event {{0}}'
     */
    IbLsH: T;

    /**
     * @default 'Restore another event'
     */
    VFDcw: T;

    /**
     * @default 'Event Name or Event ID or Firebase ID'
     */
    WsFyS: T;

    /**
     * @default 'No events found for the given search term.'
     */
    FDFty: T;

    /**
     * @default 'This event has no Firebase ID — use its handle, URL, or event UUID instead'
     */
    Pe4HN: T;

    /**
     * @default 'Event Name:'
     */
    rVfgO: T;

    /**
     * @default 'Event ID:'
     */
    r5qb6: T;

    /**
     * @default 'Firebase ID:'
     */
    mLqwH: T;

    /**
     * @default 'Settings:'
     */
    fwPYF: T;

    /**
     * @default 'Event Service Center'
     */
    '8GfXS': T;

    /**
     * @default 'Copied to clipboard'
     */
    HMshf: T;

    /**
     * @default 'Paste stationery template JSON'
     */
    tSPCP: T;

    /**
     * @default 'Active'
     */
    uFgDj: T;

    /**
     * @default 'Inactive'
     */
    JLePq: T;

    /**
     * @default 'Expired'
     */
    '7Jwbu': T;

    /**
     * @default 'Consumed'
     */
    QXbMJ: T;

    /**
     * @default 'All redemptions used or budget exhausted — no new guests can apply this code'
     */
    gCChU: T;

    /**
     * @default 'Yes'
     */
    '1GaAA': T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default '+ Create Coupon'
     */
    nQFjb: T;

    /**
     * @default 'Not Fraud'
     */
    Po98j: T;

    /**
     * @default 'Canceled — Fraud Suspected'
     */
    P9I8x: T;

    /**
     * @default 'Canceled — EFW Actionable'
     */
    NRdfT: T;

    /**
     * @default 'Canceled — Identity Collision'
     */
    lK6eF: T;

    /**
     * @default 'Canceled — Identity Fraud Activity'
     */
    cgUs2: T;

    /**
     * @default 'Canceled — Non-Refundable Risk'
     */
    '4qAnE': T;

    /**
     * @default 'Pass'
     */
    JZgMA: T;

    /**
     * @default 'Quarantine'
     */
    izx1E: T;

    /**
     * @default 'Pending'
     */
    XhQCC: T;

    /**
     * @default 'Fraud'
     */
    aI83F: T;

    /**
     * @default 'Couldn't resolve this candidate. Try again.'
     */
    '0oJ9d': T;

    /**
     * @default 'Matched. The candidate was merged into the source place.'
     */
    '6TTaP': T;

    /**
     * @default 'Discarded as a false positive.'
     */
    '46Mmq': T;

    /**
     * @default 'Retry'
     */
    yGyzG: T;

    /**
     * @default 'Loading match candidates…'
     */
    xMKgA: T;

    /**
     * @default 'Couldn't load match candidates.'
     */
    '3MV1c': T;

    /**
     * @default 'No places match these filters.'
     */
    '4rk20': T;

    /**
     * @default 'Nothing is waiting for review.'
     */
    Ld5ZE: T;

    /**
     * @default 'Each place is listed with every candidate the matcher couldn't auto-confirm. Expand a place to compare and decide.'
     */
    '5u9if': T;

    /**
     * @default 'Couldn't refresh the queue. Showing the last loaded results.'
     */
    '0KwmH': T;

    /**
     * @default 'Below auto-match threshold'
     */
    JC1cE: T;

    /**
     * @default 'Competing candidates'
     */
    o7N6W: T;

    /**
     * @default 'LLM asked for review'
     */
    iO84D: T;

    /**
     * @default 'Cluster already has a row from this provider'
     */
    SV0R4: T;

    /**
     * @default 'Google Place ID conflict'
     */
    h4csw: T;

    /**
     * @default 'Stale ID heal below threshold'
     */
    '2GjIX': T;

    /**
     * @default 'Stale ID heal cluster conflict'
     */
    u1gY5: T;

    /**
     * @default 'Match lock timed out'
     */
    VGwRI: T;

    /**
     * @default 'Already clustered (legacy)'
     */
    JXO67: T;

    /**
     * @default 'Couldn't load more hotels. Try again.'
     */
    ZuAga: T;

    /**
     * @default 'Loading hotels…'
     */
    Tu7YD: T;

    /**
     * @default 'Couldn't load the room review queue.'
     */
    Fn3iS: T;

    /**
     * @default 'Couldn't load more hotels.'
     */
    '2bEUQ': T;

    /**
     * @default 'Loading more hotels…'
     */
    SAHLT: T;

    /**
     * @default 'No rooms are waiting on the pages loaded so far.'
     */
    QqRRO: T;

    /**
     * @default 'Load More'
     */
    xbUxf: T;

    /**
     * @default 'No rooms from this provider are waiting for review.'
     */
    KUzXu: T;

    /**
     * @default 'No rooms are waiting for review.'
     */
    lv8xr: T;

    /**
     * @default 'Each hotel is listed with the rooms the matcher couldn't place, the longest-waiting first. Expand a hotel, pick a case, and say which room it is.'
     */
    C3Mu8: T;

    /**
     * @default 'LLM thinks it is the same room'
     */
    xHwWM: T;

    /**
     * @default 'Different bed setup'
     */
    nCAkV: T;

    /**
     * @default 'Different view'
     */
    WOI7L: T;

    /**
     * @default 'Different tier'
     */
    Bhz6L: T;

    /**
     * @default 'Different size or occupancy'
     */
    aTLvf: T;

    /**
     * @default 'Accessibility mismatch'
     */
    QnxHl: T;

    /**
     * @default 'Missing feature'
     */
    gRohD: T;

    /**
     * @default 'Not enough to go on'
     */
    LziYK: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'LLM's pick contradicts a room member'
     */
    kHLHr: T;

    /**
     * @default 'Only one side names a view'
     */
    '1ag1a': T;

    /**
     * @default 'Only one side states accessibility'
     */
    TNfUV: T;

    /**
     * @default 'Only one side says it sleeps more than two'
     */
    oJp8L: T;

    /**
     * @default 'LLM made a new room, but another room has this name'
     */
    sri8Y: T;

    /**
     * @default 'LLM answer was unusable'
     */
    n6Twu: T;

    /**
     * @default 'Beds'
     */
    mgaKA: T;

    /**
     * @default 'Bedrooms'
     */
    J1VBD: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Tier'
     */
    s6JNA: T;

    /**
     * @default 'Smoking'
     */
    Oj6LQ: T;

    /**
     * @default 'Accessible'
     */
    SS2Fz: T;

    /**
     * @default 'Deterministic'
     */
    qBvyS: T;

    /**
     * @default 'LLM'
     */
    lMWAA: T;

    /**
     * @default 'Manual'
     */
    WCNpE: T;

    /**
     * @default 'ZH'
     */
    ExAAA: T;

    /**
     * @default 'Nuitee'
     */
    '0LL4I': T;

    /**
     * @default 'Hopper'
     */
    iAHi2: T;

    /**
     * @default 'Confirmed'
     */
    hjlPK: T;

    /**
     * @default 'Submitted'
     */
    RaTTG: T;

    /**
     * @default 'Draft'
     */
    L9AuF: T;

    /**
     * @default 'Processing'
     */
    '7B9SY': T;

    /**
     * @default 'Pending confirmation'
     */
    iGM3Q: T;

    /**
     * @default 'Needs verification'
     */
    ysu6B: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Cancellation failed'
     */
    eeeDJ: T;

    /**
     * @default 'Cancelled'
     */
    JVlxD: T;

    /**
     * @default 'Captured'
     */
    qdqmP: T;

    /**
     * @default 'Refund failed'
     */
    f3who: T;

    /**
     * @default 'Refund initiated'
     */
    vG72Y: T;

    /**
     * @default 'Released'
     */
    JAjIR: T;

    /**
     * @default 'Succeeded'
     */
    JY11E: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Admin'
     */
    X9BdF: T;

    /**
     * @default 'System'
     */
    XPneW: T;

    /**
     * @default 'Car'
     */
    S0TAA: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Honeymoon Fund'
     */
    '90RqS': T;

    /**
     * @default 'Honeymoon Fund + Card'
     */
    '4JWaG': T;

    /**
     * @default 'Card'
     */
    M1iKA: T;

    /**
     * @default '1 reservation found'
     * @param {number} count - The number of occurrences.
     * - singular: 1 reservation found
     * - plural: {{0}} reservations found
     */
    QAS9h: T;

    /**
     * @default 'Bulk Search'
     */
    ePB6H: T;

    /**
     * @default 'Only the first {{0}} can be browsed — refine your search to narrow the results.'
     */
    hel4f: T;

    /**
     * @default 'Import {{0}} row'
     * @param {number} count - The number of occurrences.
     * - singular: Import {{0}} row
     * - plural: Import {{0}} rows
     */
    HhxEz: T;

    /**
     * @default '{{0}} row'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} row
     * - plural: {{0}} rows
     */
    '7k8sO': T;

    /**
     * @default '{{0}} column'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} column
     * - plural: {{0}} columns
     */
    bQZoH: T;

    /**
     * @default 'Importing…'
     */
    L0DwR: T;

    /**
     * @default 'Import'
     */
    bsWC5: T;

    /**
     * @default 'The import was refused.'
     */
    NDrA5: T;

    /**
     * @default 'Upload the reconciled statement once it has been reviewed and approved. This records the reconciliation so later statements can be checked against it — no money moves from this screen. Mark it paid below only after the transfer has gone out.'
     */
    NmFXx: T;

    /**
     * @default 'Provider'
     */
    r2z0s: T;

    /**
     * @default 'Statement reference'
     */
    o0TfJ: T;

    /**
     * @default 'Reconciled CSV'
     */
    k8myt: T;

    /**
     * @default '{{0}} KB'
     */
    '9AOTN': T;

    /**
     * @default 'No file chosen yet.'
     */
    '33lyN': T;

    /**
     * @default 'Choose a different file'
     */
    tw1lW: T;

    /**
     * @default 'Choose a CSV'
     */
    WuxKU: T;

    /**
     * @default 'This statement has already been paid'
     */
    BpJKQ: T;

    /**
     * @default 'Tick this only after the transfer has gone out. Every booking clear to pay is then recorded as paid, and a later statement cannot bill it again.'
     */
    DcasW: T;

    /**
     * @default 'Choose a file to continue.'
     */
    ObkA7: T;

    /**
     * @default 'Joy could not read any rows in this file. Check it has rows below the header, then choose it again.'
     */
    ugDdY: T;

    /**
     * @default 'No active aliases yet.'
     * @param {number} count - The number of occurrences.
     * - zero: No active aliases yet.
     * - singular: 1 active alias.
     * - plural: {{0}} active aliases.
     */
    GQLaO: T;

    /**
     * @default 'That handle is too short for the server to accept.'
     */
    jYwnw: T;

    /**
     * @default 'There was an error changing the event handle.'
     */
    AEAmN: T;

    /**
     * @default 'Only a Super Admin can keep the old handle working as an alias.'
     */
    i0cme: T;

    /**
     * @default 'Handle aliases are turned off on the server, so the old handle can't be preserved.'
     */
    yTcnB: T;

    /**
     * @default 'You don't have permission to rename this event's handle.'
     */
    JjpZR: T;

    /**
     * @default 'This event is already at the server's limit for active handle aliases, so the rename was rejected. No existing alias was removed.'
     */
    '4NPta': T;

    /**
     * @default 'Could not change the handle: {{0}}'
     */
    D9T4C: T;

    /**
     * @default 'Handle changed. The old handle now redirects to this event.'
     */
    mNcB2: T;

    /**
     * @default 'This only changes the handle's capitalization, which the server treats as a no-op — the rename would save but no alias would be created. Pick a different handle.'
     */
    GJtE8: T;

    /**
     * @default 'Event Handle & Aliases'
     */
    QF0EK: T;

    /**
     * @default 'Rename the event's handle. The old one is kept as an alias that still resolves to this event.'
     */
    xSITZ: T;

    /**
     * @default 'Same rename the couple can do in Settings › Website, plus the part they can't: keeping the handle being replaced as an alias that still resolves to this event. Use it when links are already out in the world — printed cards, QR codes, save-the-dates, vendor sites.'
     */
    fxihQ: T;

    /**
     * @default 'Renames made here always preserve the old handle — it keeps resolving to this event instead of being freed for anyone to claim. Preserving is super-admin only, which is why it lives here and not in the couple's Settings.'
     */
    '0x6CN': T;

    /**
     * @default 'Current Handle:'
     */
    bxSn2: T;

    /**
     * @default 'New Handle'
     */
    G6XPe: T;

    /**
     * @default 'The server caps active aliases per event; at the cap it rejects the rename outright rather than removing an existing alias.'
     */
    NIfLv: T;

    /**
     * @default 'Change Handle & Keep Old One Working'
     */
    DeOo6: T;

    /**
     * @default 'Existing Aliases'
     */
    HFAiq: T;

    /**
     * @default 'No aliases — only the current handle resolves to this event.'
     */
    N7rYq: T;

    /**
     * @default 'resolving'
     */
    '90Bu7': T;

    /**
     * @default 'inactive'
     */
    tjvkz: T;

    /**
     * @default 'created {{0}}'
     */
    iRaaI: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'Could not load this event's handle and aliases: {{0}}'
     */
    XSL9O: T;

    /**
     * @default 'Could not load this event: {{0}}'
     */
    O1ULC: T;

    /**
     * @default 'This event is not opted out of any product.'
     * @param {number} count - The number of occurrences.
     * - zero: This event is not opted out of any product.
     * - singular: This event is opted out of 1 product.
     * - plural: This event is opted out of {{0}} products.
     */
    L9hJz: T;

    /**
     * @default 'Opt out of Website'
     */
    NTVVU: T;

    /**
     * @default 'ON = the couple is opted OUT of the website. Every website page is hidden from guests, overriding each page's own visibility setting — a page set to Public still will not render.'
     */
    CA2vo: T;

    /**
     * @default 'This opts the couple OUT of the website. Every page — including pages set to Public — is hidden from guests until this is turned back off.'
     */
    MAmUs: T;

    /**
     * @default 'The couple is now opted OUT of the website.'
     */
    A8Rjx: T;

    /**
     * @default 'The couple is now opted back IN to the website.'
     */
    aUgK0: T;

    /**
     * @default 'Opt out of Registry'
     */
    XJVkS: T;

    /**
     * @default 'ON = the couple is opted OUT of the registry. Registry surfaces are turned off for this event.'
     */
    VMhp2: T;

    /**
     * @default 'This opts the couple OUT of the registry. Registry surfaces are turned off for this event until this is turned back off.'
     */
    L4emK: T;

    /**
     * @default 'The couple is now opted OUT of the registry.'
     */
    q80Jb: T;

    /**
     * @default 'The couple is now opted back IN to the registry.'
     */
    '6pkSS': T;

    /**
     * @default 'Opt out of Guest List & RSVP'
     */
    '9suLV': T;

    /**
     * @default 'ON = the couple is opted OUT of guest list and RSVP. Those surfaces are turned off for this event.'
     */
    Ffpqp: T;

    /**
     * @default 'This opts the couple OUT of guest list and RSVP. Those surfaces are turned off for this event until this is turned back off.'
     */
    XFSGH: T;

    /**
     * @default 'The couple is now opted OUT of guest list and RSVP.'
     */
    ewVG5: T;

    /**
     * @default 'The couple is now opted back IN to guest list and RSVP.'
     */
    gcisA: T;

    /**
     * @default 'Opt out of Invites & Save the Dates'
     */
    HVDiz: T;

    /**
     * @default 'ON = the couple is opted OUT of invites and save the dates. Those surfaces are turned off for this event.'
     */
    tZRUQ: T;

    /**
     * @default 'This opts the couple OUT of invites and save the dates. Those surfaces are turned off for this event until this is turned back off.'
     */
    zP7zW: T;

    /**
     * @default 'The couple is now opted OUT of invites and save the dates.'
     */
    mKLxh: T;

    /**
     * @default 'The couple is now opted back IN to invites and save the dates.'
     */
    wkVXQ: T;

    /**
     * @default 'Failed to save product verticals.'
     */
    '1rXVC': T;

    /**
     * @default 'Loading event information...'
     */
    cMp3G: T;

    /**
     * @default 'Error loading event information.'
     */
    '8fUig': T;

    /**
     * @default 'Loading product verticals...'
     */
    cx9VN: T;

    /**
     * @default 'Error loading product verticals.'
     */
    anGw8: T;

    /**
     * @default 'Product Verticals'
     */
    e0INi: T;

    /**
     * @default 'Every row below is an OPT-OUT, not an enable. Toggle ON = the couple is opted OUT of that product. Toggle OFF (the default) = the product is available.'
     */
    MkLbx: T;

    /**
     * @default 'Opting out of the website hides the entire website: the opt-out overrides each page's own visibility, so pages set to Public are hidden too.'
     */
    C5V43: T;

    /**
     * @default 'Opt-out'
     */
    U43bb: T;

    /**
     * @default 'Current state'
     */
    C7URD: T;

    /**
     * @default 'Opted out'
     */
    EaXHo: T;

    /**
     * @default 'Opted OUT'
     */
    cEOHo: T;

    /**
     * @default 'Available'
     */
    d8nEm: T;

    /**
     * @default 'Confirm opt-out'
     */
    '2yrfa': T;

    /**
     * @default 'Turning this ON opts the couple OUT.'
     */
    '3X4ZR': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Opt out'
     */
    JX6Zb: T;

    /**
     * @default '0 selected'
     * @param {number} count - The number of occurrences.
     * - zero: 0 selected
     * - singular: 1 selected
     * - plural: {{0}} selected
     */
    mUrVB: T;

    /**
     * @default '(items unknown)'
     */
    jaRWc: T;

    /**
     * @default 'View order link'
     */
    BoXLD: T;

    /**
     * @default 'Cancel order'
     */
    mohdn: T;

    /**
     * @default 'Ship order'
     */
    oixbK: T;

    /**
     * @default 'Order Number'
     */
    PpyQe: T;

    /**
     * @default 'Items'
     */
    MbNJG: T;

    /**
     * @default 'Status (Seen by Couple)'
     */
    xL8zX: T;

    /**
     * @default 'Raw Status Graph'
     */
    mVdUD: T;

    /**
     * @default 'Purchaser Name'
     */
    WcA2S: T;

    /**
     * @default 'Total Value'
     */
    hWdde: T;

    /**
     * @default 'Creation Date'
     */
    dDH0W: T;

    /**
     * @default 'Action'
     */
    KCgDj: T;

    /**
     * @default '(unfulfilled)'
     */
    pbyGM: T;

    /**
     * @default '(dropship)'
     */
    UTHIR: T;

    /**
     * @default '(affiliate)'
     */
    yoTjA: T;

    /**
     * @default 'Error loading event information. Please try again.'
     */
    '5ewLu': T;

    /**
     * @default 'No event handle found. Cannot load registry orders.'
     */
    gJOpb: T;

    /**
     * @default 'Loading registry orders...'
     */
    O5Fsg: T;

    /**
     * @default 'Error loading registry orders. Please try again.'
     */
    ZQ3wF: T;

    /**
     * @default 'No registry orders found.'
     */
    rU3s1: T;

    /**
     * @default 'Registry Orders Manager'
     */
    lxaNA: T;

    /**
     * @default 'Filters:'
     */
    NXdm3: T;

    /**
     * @default 'All'
     */
    '5WTAA': T;

    /**
     * @default 'Ready to Ship'
     */
    '6fgOk': T;

    /**
     * @default 'Cancelable'
     */
    EpMXB: T;

    /**
     * @default 'Joy fulfillment'
     */
    '8cSlt': T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'GCE Orders'
     */
    SS6nu: T;

    /**
     * @default 'Affiliate'
     */
    '9a9Ft': T;

    /**
     * @default 'Cancel Selected'
     */
    Bj9uX: T;

    /**
     * @default 'Ship Selected'
     */
    z1ztl: T;

    /**
     * @default 'Cancelation reason is required'
     */
    EpzFt: T;

    /**
     * @default 'Ship Registry Orders'
     */
    ShlLb: T;

    /**
     * @default 'Cancel Registry Orders'
     */
    IPt2a: T;

    /**
     * @default 'The following registry orders are about to be shipped. Do you want to proceed?'
     */
    KFoww: T;

    /**
     * @default 'The following registry orders are about to be canceled. Do you want to proceed?'
     */
    Yp5Lt: T;

    /**
     * @default 'Cancelation Reason'
     */
    rzLBO: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Cancel Order Now'
     */
    mQiVN: T;

    /**
     * @default 'Ship Order Now'
     */
    G33YR: T;

    /**
     * @default 'Canceling...'
     */
    O2NXZ: T;

    /**
     * @default 'Shipping...'
     */
    gMtC2: T;

    /**
     * @default 'No pages found'
     * @param {number} count - The number of occurrences.
     * - zero: No pages found
     * - singular: 1 page
     * - plural: {{0}} pages
     */
    '5cLKO': T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Failed to save page order.'
     */
    iYBbW: T;

    /**
     * @default 'Page order saved.'
     */
    y46WS: T;

    /**
     * @default 'Loading website pages...'
     */
    VlIwc: T;

    /**
     * @default 'Error loading website pages.'
     */
    Rif6C: T;

    /**
     * @default 'Website Pages'
     */
    Hsfjx: T;

    /**
     * @default 'Drag the handle on the left to reorder pages. Order is shared with /edit/settings/website.'
     */
    o4aNg: T;

    /**
     * @default 'Page Name'
     */
    Cq4sf: T;

    /**
     * @default 'Page Slug'
     */
    qlstf: T;

    /**
     * @default 'Page Type'
     */
    '7k5tf': T;

    /**
     * @default 'Origin'
     */
    g4YTL: T;

    /**
     * @default 'Visibility'
     */
    OZrIO: T;

    /**
     * @default '(untitled)'
     */
    QnkbM: T;

    /**
     * @default 'User Generated'
     */
    '81XSX': T;

    /**
     * @default 'Default'
     */
    NwmO1: T;

    /**
     * @default 'Delete page'
     */
    seuF1: T;

    /**
     * @default '—'
     */
    cICAA: T;

    /**
     * @default 'Page deleted.'
     */
    C0ySj: T;

    /**
     * @default 'Failed to delete page.'
     */
    GSZ4O: T;

    /**
     * @default 'Delete Page'
     */
    kU5A1: T;

    /**
     * @default 'Are you sure you want to delete this page? This action cannot be undone.'
     */
    W3HnI: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Disable international registry'
     */
    DnWTF: T;

    /**
     * @default 'Opt this registry out of the international experience (/registry/intl). When on, the couple uses the standard US registry at /registry.'
     */
    PVfAY: T;

    /**
     * @default 'On'
     */
    zrAAA: T;

    /**
     * @default 'Off'
     */
    hRXAA: T;

    /**
     * @default 'Service Center'
     */
    cBGKN: T;

    /**
     * @default 'Messages (v1)'
     */
    Mk7CJ: T;

    /**
     * @default 'Messages'
     */
    suCiD: T;

    /**
     * @default 'Spam queue'
     */
    C8Fzz: T;

    /**
     * @default 'Event safety rating'
     */
    f8PIR: T;

    /**
     * @default 'Print order'
     */
    H9VhN: T;

    /**
     * @default 'Print orders'
     */
    kCZbh: T;

    /**
     * @default 'Stationery tags'
     */
    xit4q: T;

    /**
     * @default 'Email unsubscribe'
     */
    pyGgZ: T;

    /**
     * @default 'Travel reservation search'
     */
    MB7gE: T;

    /**
     * @default 'Travel CX'
     */
    '1Ssj6': T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'User admin'
     */
    cMNIP: T;

    /**
     * @default 'Fraud case'
     */
    YDRxc: T;

    /**
     * @default 'Fraud review'
     */
    qJlrF: T;

    /**
     * @default 'Vendor reconciliation'
     */
    zfNdy: T;

    /**
     * @default 'Match review'
     */
    '3AkFa': T;

    /**
     * @default 'Room review'
     */
    vUA5N: T;

    /**
     * @default 'Discount coupon'
     */
    '9eB9a': T;

    /**
     * @default 'Discount coupons'
     */
    I6DeS: T;

    /**
     * @default 'Service Center header'
     */
    ZLySY: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Print'
     */
    DdvrG: T;

    /**
     * @default 'Switch to V2'
     */
    vhWHP: T;

    /**
     * @default 'Loading print order…'
     */
    '18g0H': T;

    /**
     * @default 'We couldn't load print order {{0}}. Try again.'
     */
    SHjwN: T;

    /**
     * @default 'No print order matches {{0}}.'
     */
    nbukx: T;

    /**
     * @default 'Are you sure you want to set this order as refunded?'
     */
    MNjC4: T;

    /**
     * @default 'This is the confirmation that the refund has been processed manually.'
     */
    Jt9af: T;

    /**
     * @default 'Set to Refunded'
     */
    Yk9jr: T;

    /**
     * @default 'Go to Order in Stripe'
     */
    TqJGv: T;

    /**
     * @default 'Are you sure you want to cancel this order?'
     */
    rUZgw: T;

    /**
     * @default 'Once you cancel the order, it will be removed from the queue for the print orders.'
     */
    FdShM: T;

    /**
     * @default 'Cancel Order'
     */
    WQT4k: T;

    /**
     * @default 'Keep Order'
     */
    bbdDm: T;

    /**
     * @default 'Are you sure you want to pause this order?'
     */
    JFGzI: T;

    /**
     * @default 'Once you pause the order, it will be removed from the queue for the print orders.'
     */
    bw4xZ: T;

    /**
     * @default 'Pause Order'
     */
    q0SoN: T;

    /**
     * @default 'Are you sure you want to resume this order?'
     */
    uGYYH: T;

    /**
     * @default 'Once you resume the order, it will be added to the queue for the print orders.'
     */
    BmQMn: T;

    /**
     * @default 'Resume Order'
     */
    fByvk: T;

    /**
     * @default 'Are you sure you want to immediately process this order?'
     */
    Ay0jk: T;

    /**
     * @default 'Once you process the order, it will be sent to the print vendor, and no longer will be able to be modified or canceled without interacting with the print partner customer support.'
     */
    prJ3u: T;

    /**
     * @default 'Process Now'
     */
    '9PflY': T;

    /**
     * @default 'Manage Order'
     */
    ZIVht: T;

    /**
     * @default 'Couldn't load gift details, so gifting and refunds are off.'
     */
    '7RYbp': T;

    /**
     * @default 'Set as Refunded'
     */
    P1mkd: T;

    /**
     * @default 'Edit Shipping Address'
     */
    Gk258: T;

    /**
     * @default 'Event Admin Dashboard'
     */
    Bz6C0: T;

    /**
     * @default 'Printable Card PDF'
     */
    V2vYf: T;

    /**
     * @default 'Printable Envelope PDF'
     */
    rJogG: T;

    /**
     * @default 'User's Email Address:'
     */
    v3Q6J: T;

    /**
     * @default 'Complimentary Card Gifted:'
     */
    nSw3Y: T;

    /**
     * @default 'Complimentary for:'
     */
    x47ZQ: T;

    /**
     * @default 'There was an error performing the {{0}}.'
     */
    gwDlO: T;

    /**
     * @default 'Order Number:'
     */
    tXO7C: T;

    /**
     * @default 'ID:'
     */
    VRVAA: T;

    /**
     * @default 'Price:'
     */
    Tnk7N: T;

    /**
     * @default 'Quantity:'
     */
    JwwiK: T;

    /**
     * @default 'Owner ID:'
     */
    mIHkY: T;

    /**
     * @default 'Template ID:'
     */
    raHmU: T;

    /**
     * @default 'Template Theme ID:'
     */
    '2Stkt': T;

    /**
     * @default 'Template Category:'
     */
    A03Q2: T;

    /**
     * @default 'Concierge Suite Name:'
     */
    uXbXA: T;

    /**
     * @default 'Delivery Method:'
     */
    '7cRly': T;

    /**
     * @default 'Sales Order ID:'
     */
    '5hjVS': T;

    /**
     * @default 'Status:'
     */
    ErgSM: T;

    /**
     * @default 'Created At:'
     */
    '74baC': T;

    /**
     * @default 'Go to Order Detail'
     */
    Ia3Rk: T;

    /**
     * @default '0 templates shown ({{0}} total) · {{1}} selected'
     * @param {number} count - The number of occurrences.
     * - zero: 0 templates shown ({{0}} total) · {{1}} selected
     * - singular: 1 template shown ({{0}} total) · {{1}} selected
     * - plural: {{0}} templates shown ({{1}} total) · {{2}} selected
     */
    egTfp: T;

    /**
     * @default 'Hide Tag Definitions'
     */
    M9ca2: T;

    /**
     * @default 'Manage Tag Definitions'
     */
    F2aax: T;

    /**
     * @default 'Category'
     */
    Ixu8Y: T;

    /**
     * @default 'Tag Status'
     */
    UsZWB: T;

    /**
     * @default 'Filter by Style'
     */
    UJMWF: T;

    /**
     * @default 'Filter by Color'
     */
    givDE: T;

    /**
     * @default 'Loading templates…'
     */
    dbn2e: T;

    /**
     * @default 'We couldn't load these templates. Try again.'
     */
    T0Px8: T;

    /**
     * @default 'No templates match these filters.'
     */
    VqEPs: T;

    /**
     * @default 'Travel Reservation Search'
     */
    EP0Sz: T;

    /**
     * @default 'Travel Fraud'
     */
    Ysazx: T;

    /**
     * @default 'Match Review'
     */
    XG5UD: T;

    /**
     * @default 'Room Review'
     */
    RB8eM: T;

    /**
     * @default 'Filter by {{0}} ({{1}} selected)'
     */
    wILUf: T;

    /**
     * @default 'Filter by {{0}}'
     */
    Ri7jI: T;

    /**
     * @default 'Nothing to filter on here.'
     */
    fmz2c: T;

    /**
     * @default '{{0}} ({{1}})'
     */
    YPUxD: T;

    /**
     * @default 'Clear'
     */
    NdJoF: T;

    /**
     * @default '1 inbox is not fully loaded'
     * @param {number} count - The number of occurrences.
     * - singular: 1 inbox is not fully loaded
     * - plural: {{0}} inboxes are not fully loaded
     */
    N8PDf: T;

    /**
     * @default 'Never checked — Joy has no Intercom data for this inbox, so none of its tickets are in the table below.'
     */
    rNuqQ: T;

    /**
     * @default 'Intercom returned only part of this inbox, so it holds at least {{0}} open tickets and may hold more.'
     */
    ItSnB: T;

    /**
     * @default 'Linked conversation'
     * @param {number} count - The number of occurrences.
     * - singular: Linked conversation
     * - plural: Linked conversations
     */
    pDzFL: T;

    /**
     * @default 'Ticket / Customer'
     */
    ZcFkv: T;

    /**
     * @default 'Inbox'
     */
    '2fSIG': T;

    /**
     * @default 'Partner'
     */
    oeYIN: T;

    /**
     * @default 'Booking ID'
     */
    cFX9r: T;

    /**
     * @default 'Age'
     */
    JUTAA: T;

    /**
     * @default 'Flags'
     */
    b5D3F: T;

    /**
     * @default 'State'
     */
    Be76G: T;

    /**
     * @default 'Sort by {{0}}. Shift-click to add it to the current sort.'
     */
    qxcGc: T;

    /**
     * @default 'Sorted by {{0}}, ascending, sort priority {{1}}. Click to sort by {{2}} alone.'
     */
    '2VOot': T;

    /**
     * @default 'Sorted by {{0}}, descending, sort priority {{1}}. Click to sort by {{2}} alone.'
     */
    eRWxN: T;

    /**
     * @default 'Sorted by {{0}}, ascending. Click to remove it from the sort.'
     */
    rFAwN: T;

    /**
     * @default 'Sorted by {{0}}, ascending. Click to reverse it.'
     */
    sV6H5: T;

    /**
     * @default 'Sorted by {{0}}, descending. Click to remove it from the sort.'
     */
    Zmroe: T;

    /**
     * @default 'Sorted by {{0}}, descending. Click to reverse it.'
     */
    CuBKp: T;

    /**
     * @default 'The linked customer conversation is closed, so this ticket may be stale.'
     */
    I3kk7: T;

    /**
     * @default 'Closed'
     */
    CcAEp: T;

    /**
     * @default 'Open {{0}} — past the {{1}}-day SLA.'
     */
    lK640: T;

    /**
     * @default 'SLA'
     */
    WLYAA: T;

    /**
     * @default 'Open in Intercom'
     */
    '24VGi': T;

    /**
     * @default 'Hide ticket details'
     */
    wwj5R: T;

    /**
     * @default 'Show ticket details'
     */
    Rr4qg: T;

    /**
     * @default 'Issue'
     */
    fHIJG: T;

    /**
     * @default 'No description available.'
     */
    ICvew: T;

    /**
     * @default 'None linked'
     */
    '7e6CV': T;

    /**
     * @default 'Details'
     */
    CiOW2: T;

    /**
     * @default 'Ticket ID'
     */
    TFYV1: T;

    /**
     * @default 'Booking'
     */
    hez9y: T;

    /**
     * @default 'Created'
     */
    k0dLA: T;

    /**
     * @default 'Not reported by Intercom'
     */
    g1TgF: T;

    /**
     * @default 'Joy could not read this conversation from Intercom, so whether it is closed is unknown.'
     */
    MQ5oA: T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Open'
     */
    cLbMA: T;

    /**
     * @default '1 open ticket, and nothing needs attention.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 open ticket, and nothing needs attention.
     * - plural: {{0}} open tickets, and nothing needs attention.
     */
    cX3Ji: T;

    /**
     * @default 'Not checked yet'
     */
    clof1: T;

    /**
     * @default ' · {{0}} not checked'
     */
    bOg6u: T;

    /**
     * @default ' (oldest inbox)'
     */
    GV4g6: T;

    /**
     * @default 'Data from {{0}}'
     */
    eqnfI: T;

    /**
     * @default 'Within SLA (≤{{0}}d)'
     */
    afgqE: T;

    /**
     * @default '6–30 days'
     */
    '5ILHi': T;

    /**
     * @default 'Over 30 days'
     */
    gmvYq: T;

    /**
     * @default 'Age unknown'
     */
    bD6e3: T;

    /**
     * @default 'Has booking ID'
     */
    wVF7P: T;

    /**
     * @default 'Missing booking ID'
     */
    '4A4Ve': T;

    /**
     * @default 'Ticket'
     */
    OzvyX: T;

    /**
     * @default 'Customer'
     */
    myQkb: T;

    /**
     * @default 'Created at'
     */
    NM0j0: T;

    /**
     * @default 'SLA breach'
     */
    xqWCA: T;

    /**
     * @default 'Closed convo'
     */
    FLcqL: T;

    /**
     * @default 'No partner'
     */
    '5oiHs': T;

    /**
     * @default 'No state'
     */
    yg9B2: T;

    /**
     * @default 'Open back-office tickets whose customer conversation is closed, or that have been open longer than {{0}} days.'
     */
    DaXiA: T;

    /**
     * @default 'Checking…'
     */
    Aj6EQ: T;

    /**
     * @default 'Check All Inboxes'
     */
    F767H: T;

    /**
     * @default 'We couldn't load the inboxes'
     */
    xk3Gq: T;

    /**
     * @default 'Joy could not reach the ticket service, so no tickets are shown — this is not an all-clear.'
     */
    RJki0: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'No inboxes available.'
     */
    kOT2i: T;

    /**
     * @default 'Joy could not refresh this page, so these tickets may be out of date.'
     */
    lRerK: T;

    /**
     * @default 'Checking {{0}}… ({{1}} of {{2}})'
     */
    bKt0B: T;

    /**
     * @default 'SLA breach (>{{0}}d)'
     */
    mPeJS: T;

    /**
     * @default 'Both — amber row'
     */
    MOmxe: T;

    /**
     * @default 'No tickets match'
     */
    x2dJp: T;

    /**
     * @default 'Nothing in view matches the search and filters you have on.'
     */
    bFFBQ: T;

    /**
     * @default 'Clear Search and Filters'
     */
    VoX3w: T;

    /**
     * @default 'All clear'
     */
    '2RlRM': T;

    /**
     * @default 'Nothing flagged in what loaded'
     */
    TFLUW: T;

    /**
     * @default 'Nothing Joy could read needs attention, but the inboxes above did not fully load.'
     */
    I1JzT: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'Intercom returned only part of the open ticket list, so the real total is higher.'
     */
    FHHWE: T;

    /**
     * @default '{{0}} of {{1}} flagged · at least {{2}} open'
     */
    ZGVvj: T;

    /**
     * @default '{{0}} of {{1}} flagged · {{2}} open'
     */
    FJuwI: T;

    /**
     * @default 'Clear Filters ({{0}})'
     */
    lk3pe: T;

    /**
     * @default 'Search tickets, customers, booking IDs…'
     */
    BAkt1: T;

    /**
     * @default 'Export CSV'
     */
    IXrvA: T;

    /**
     * @default '1 day'
     * @param {number} count - The number of occurrences.
     * - singular: 1 day
     * - plural: {{0}} days
     */
    ehHVF: T;

    /**
     * @default 'Open for 1 day'
     * @param {number} count - The number of occurrences.
     * - singular: Open for 1 day
     * - plural: Open for {{0}} days
     */
    cZY15: T;

    /**
     * @default 'Unknown — Intercom gave no creation time'
     */
    NmSub: T;

    /**
     * @default 'Less than a day'
     */
    '9qElF': T;

    /**
     * @default 'Intercom gave no creation time for this ticket, so its age and SLA are unknown.'
     */
    yrefK: T;

    /**
     * @default 'Open for less than a day'
     */
    QttyW: T;

    /**
     * @default '{{0}}s'
     */
    TMOGt: T;

    /**
     * @default '{{0}}m'
     */
    NMOGt: T;

    /**
     * @default '{{0}}h'
     */
    IMOGt: T;

    /**
     * @default '{{0}}h {{1}}m'
     */
    '6sN6P': T;

    /**
     * @default '{{0}}d'
     */
    EMOGt: T;

    /**
     * @default 'unknown'
     */
    yZKLA: T;

    /**
     * @default 'just now'
     */
    '6QmJZ': T;

    /**
     * @default '{{0}}s ago'
     */
    Qd3TL: T;

    /**
     * @default '{{0}}m ago'
     */
    sYC0K: T;

    /**
     * @default '{{0}}h ago'
     */
    '5zJbK': T;

    /**
     * @default '{{0}}: Not checked'
     */
    WmKCF: T;

    /**
     * @default '{{0}}: {{1}} ({{2}})'
     */
    CukRE: T;

    /**
     * @default 'In progress'
     */
    YSegC: T;

    /**
     * @default 'Waiting on customer'
     */
    QnOLc: T;

    /**
     * @default 'Resolved'
     */
    cIcfk: T;

    /**
     * @default '{{0}} user found matching "{{1}}"'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} user found matching "{{1}}"
     * - plural: {{0}} users found matching "{{1}}"
     */
    DFsqZ: T;

    /**
     * @default '{{0}} user found'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} user found
     * - plural: {{0}} users found
     */
    HdbMl: T;

    /**
     * @default 'Multi-factor authentication is required for this change. Sign out, sign back in with MFA, then try again.'
     */
    rZfjJ: T;

    /**
     * @default 'Filter by email...'
     */
    T6b1F: T;

    /**
     * @default 'Filter users by email address'
     */
    zHDKS: T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default 'Failed to load users: {{0}}'
     */
    kE4DL: T;

    /**
     * @default 'Super Admin'
     */
    gkGRn: T;

    /**
     * @default 'Actions'
     */
    '79qhP': T;

    /**
     * @default 'Remove super admin from {{0}}'
     */
    aSf9P: T;

    /**
     * @default 'Promote {{0}} to super admin'
     */
    bxe64: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Promote'
     */
    iqUjk: T;

    /**
     * @default 'Previous'
     */
    RGyWS: T;

    /**
     * @default 'Page {{0}} / {{1}}'
     */
    HTjkU: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Promote to Super Admin'
     */
    DtAXP: T;

    /**
     * @default 'Remove Super Admin'
     */
    '49ySV': T;

    /**
     * @default 'Are you sure you want to promote {{0}}?'
     */
    v8F3o: T;

    /**
     * @default 'Are you sure you want to remove super admin from {{0}}?'
     */
    pt64t: T;

    /**
     * @default 'Updating...'
     */
    SspdD: T;

    /**
     * @default 'Code already exists — choose a different one'
     */
    '0utY8': T;

    /**
     * @default 'Unable to verify code — check your connection and try again'
     */
    vzBcM: T;

    /**
     * @default 'Manual (user enters code)'
     */
    uYbGY: T;

    /**
     * @default 'Auto Apply'
     */
    lDwiB: T;

    /**
     * @default 'Global'
     */
    fNvoz: T;

    /**
     * @default 'Event-specific'
     */
    huirG: T;

    /**
     * @default 'All bookers'
     */
    IXRQL: T;

    /**
     * @default 'First-time bookers'
     */
    jfPjF: T;

    /**
     * @default 'Repeat bookers'
     */
    Ih6z0: T;

    /**
     * @default 'Enter a valid max uses (min 1)'
     */
    roMGi: T;

    /**
     * @default 'Event ID is required for event-specific scope'
     */
    AjqO3: T;

    /**
     * @default 'No event found for that handle, event ID, or Firebase ID'
     */
    vDpHE: T;

    /**
     * @default 'Promotion code added successfully.'
     */
    Nv05P: T;

    /**
     * @default 'Failed to add promotion code'
     */
    TmJJ5: T;

    /**
     * @default 'Failed to add promotion code: {{0}}'
     */
    '5C89b': T;

    /**
     * @default 'Add Promotion Code'
     */
    tz1y2: T;

    /**
     * @default 'Code Settings'
     */
    '06jCb': T;

    /**
     * @default 'Code'
     */
    prmKA: T;

    /**
     * @default 'Leave blank to auto-generate a random code'
     */
    EHgyG: T;

    /**
     * @default 'e.g. SUMMER20'
     */
    RzgtC: T;

    /**
     * @default 'Application'
     */
    ynCRP: T;

    /**
     * @default 'Manual: customer enters the code. Auto Apply: applied at checkout automatically'
     */
    vjmIa: T;

    /**
     * @default 'Scope'
     */
    Gec4G: T;

    /**
     * @default 'Global: any booking. Event-specific: only for a specific event's bookings'
     */
    h4Io7: T;

    /**
     * @default 'Booker Type'
     */
    o0Dvb: T;

    /**
     * @default 'Restrict to first-time bookers, returning bookers, or allow all'
     */
    AoSNM: T;

    /**
     * @default 'Paid with'
     */
    IbCo6: T;

    /**
     * @default 'Event'
     */
    '8FmzF': T;

    /**
     * @default 'Accepts an event handle, event URL, event UUID, or Firebase ID'
     */
    znvCJ: T;

    /**
     * @default 'e.g. anitajacob, a withjoy.com URL, a UUID, or a Firebase ID'
     */
    b4ZYC: T;

    /**
     * @default 'Usage Limits'
     */
    lrGuh: T;

    /**
     * @default 'Max Uses'
     */
    Efsei: T;

    /**
     * @default 'How many times this specific code can be redeemed'
     */
    c942A: T;

    /**
     * @default 'e.g. 1000'
     */
    XR1Ac: T;

    /**
     * @default 'Min Spend (optional)'
     */
    XfPAo: T;

    /**
     * @default 'Minimum booking total required to redeem this code, in the coupon's currency ({{0}})'
     */
    outav: T;

    /**
     * @default 'e.g. 100'
     */
    jxqoT: T;

    /**
     * @default 'Restrictions'
     */
    Hbovf: T;

    /**
     * @default 'Restrict to Emails'
     */
    UBX8O: T;

    /**
     * @default ' (optional)'
     */
    pzVyL: T;

    /**
     * @default 'Restrict this code to specific customer email addresses. Only customers whose email is listed here can claim and apply this code at checkout. Leave empty to allow all customers.'
     */
    dzbeS: T;

    /**
     * @default 'Add Code'
     */
    '2PPqO': T;

    /**
     * @default 'Percentage'
     */
    uOBRr: T;

    /**
     * @default 'Fixed Amount'
     */
    '0UmcM': T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Discount'
     */
    '1Ydo3': T;

    /**
     * @default 'Uses'
     */
    AIWNA: T;

    /**
     * @default 'Valid Period'
     */
    ZRVvk: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Enabled'
     */
    nS8tS: T;

    /**
     * @default 'Loading coupons…'
     */
    X6eiU: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'No discount coupons found.'
     */
    FLiuN: T;

    /**
     * @default 'Key is required'
     */
    cjCPS: T;

    /**
     * @default 'Key already exists'
     */
    BzAaU: T;

    /**
     * @default 'Key'
     */
    DJWAA: T;

    /**
     * @default 'Value'
     */
    FgEJH: T;

    /**
     * @default 'Code {{0}}'
     */
    tb9eO: T;

    /**
     * @default 'Max Uses for this Code'
     */
    gedJF: T;

    /**
     * @default 'Percentage (%)'
     */
    '4KU0K': T;

    /**
     * @default 'Enter a valid positive value'
     */
    vkWQQ: T;

    /**
     * @default 'Percentage cannot exceed 100'
     */
    qNwSE: T;

    /**
     * @default 'Valid until date is required'
     */
    VJlYW: T;

    /**
     * @default 'Must be after valid from date'
     */
    GFGKu: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Currency is required for fixed amount'
     */
    jksV3: T;

    /**
     * @default 'Valid from date is required'
     */
    '5h6Ov': T;

    /**
     * @default 'Valid from date cannot be in the past'
     */
    OpouD: T;

    /**
     * @default 'Enter a valid budget amount'
     */
    yGoXH: T;

    /**
     * @default 'At least one product must be selected'
     */
    '8TzPs': T;

    /**
     * @default 'Coupon "{{0}}" created successfully.'
     */
    xrYVz: T;

    /**
     * @default 'Failed to create coupon'
     */
    aN6hj: T;

    /**
     * @default 'Failed to create coupon: {{0}}'
     */
    gHiiG: T;

    /**
     * @default 'Create Discount Coupon'
     */
    tC0fb: T;

    /**
     * @default 'Coupon Details'
     */
    '8Fsnv': T;

    /**
     * @default 'Internal label for this coupon — not shown to customers'
     */
    '0CHEU': T;

    /**
     * @default 'e.g. Summer 20% Off'
     */
    x1nmj: T;

    /**
     * @default 'Discount Type'
     */
    NnPYN: T;

    /**
     * @default 'Percentage reduces price by a %. Fixed Amount deducts a set sum'
     */
    '1oeKH': T;

    /**
     * @default 'Percentage (1–100)'
     */
    m5EgM: T;

    /**
     * @default 'Amount per Redemption'
     */
    e6kl0: T;

    /**
     * @default 'Enter a number between 1 and 100'
     */
    HE6o4: T;

    /**
     * @default 'Fixed amount per redemption in {{0}} (major units). e.g. enter 20 for a 20 {{1}} discount'
     */
    KN2Xv: T;

    /**
     * @default '20'
     */
    YbAAA: T;

    /**
     * @default '50'
     */
    '9cAAA': T;

    /**
     * @default 'Eligible Products'
     */
    PX8Y2: T;

    /**
     * @default 'Select the product types this coupon applies to'
     */
    WnpLk: T;

    /**
     * @default 'Max Discount Amount (optional)'
     */
    g916J: T;

    /**
     * @default 'Caps how much a single redemption can take off, in USD (major units). Leave blank for no cap. e.g. enter 50 to limit a 20%-off discount to $50.'
     */
    BV3iK: T;

    /**
     * @default 'e.g. 50'
     */
    lw2ae: T;

    /**
     * @default 'Currency'
     */
    ZpluY: T;

    /**
     * @default 'The coupon's currency — the discount amount, minimum spend and budget are all set in this currency'
     */
    rIozR: T;

    /**
     * @default 'Validity & Limits'
     */
    wVYrL: T;

    /**
     * @default 'Valid From'
     */
    ubxTu: T;

    /**
     * @default 'First day customers can redeem this coupon (UTC, start of day)'
     */
    jtx5E: T;

    /**
     * @default 'Valid Until'
     */
    ceJZO: T;

    /**
     * @default 'Last day customers can redeem this coupon (UTC, end of day)'
     */
    GSYjH: T;

    /**
     * @default 'Max Total Uses'
     */
    EZEhR: T;

    /**
     * @default 'Maximum redemptions across all promotion codes combined'
     */
    amvtY: T;

    /**
     * @default 'Enable budget limit'
     */
    v99xE: T;

    /**
     * @default 'Stop accepting redemptions once the total discount distributed (in the coupon's currency) reaches the budget'
     */
    T5t1U: T;

    /**
     * @default 'Budget Amount'
     */
    NFlxc: T;

    /**
     * @default 'Total budget in {{0}} (major units), tracked in the coupon's currency. e.g. enter 5000 for a 5000 {{1}} budget — if each redemption is 20, the coupon stops after 250 uses'
     */
    E0s2O: T;

    /**
     * @default 'e.g. 5000'
     */
    '3pcBc': T;

    /**
     * @default 'Enable coupon immediately'
     */
    bwhio: T;

    /**
     * @default 'If unchecked, the coupon is saved as disabled and must be enabled manually'
     */
    wZKkw: T;

    /**
     * @default 'Metadata'
     */
    R4GvE: T;

    /**
     * @default 'Key-value pairs stored as opaque JSON on the coupon — for internal use only, never shown to customers.'
     */
    Yz1WP: T;

    /**
     * @default 'Promotion Codes'
     */
    H9GSA: T;

    /**
     * @default '+ Add another code'
     */
    uHk6W: T;

    /**
     * @default 'Create Coupon'
     */
    QcQWO: T;

    /**
     * @default 'Coupon disabled successfully.'
     */
    fAeT0: T;

    /**
     * @default 'Coupon enabled successfully.'
     */
    SUI3o: T;

    /**
     * @default 'Failed to update coupon'
     */
    VxNHZ: T;

    /**
     * @default 'Failed to update coupon: {{0}}'
     */
    n7OAT: T;

    /**
     * @default 'Promo code disabled.'
     */
    wR29P: T;

    /**
     * @default 'Promo code enabled.'
     */
    '3D2XF': T;

    /**
     * @default 'Failed to update promo code'
     */
    VPBfD: T;

    /**
     * @default 'Failed to update promo code: {{0}}'
     */
    fJinD: T;

    /**
     * @default 'Coupon "{{0}}" deleted.'
     */
    NyNOJ: T;

    /**
     * @default 'Failed to delete coupon'
     */
    '9HSbt': T;

    /**
     * @default 'Failed to delete coupon: {{0}}'
     */
    D12zp: T;

    /**
     * @default 'Promotion code "{{0}}" deleted.'
     */
    BRtFK: T;

    /**
     * @default 'Failed to delete promotion code'
     */
    d0oPG: T;

    /**
     * @default 'Failed to delete promotion code: {{0}}'
     */
    '3keEX': T;

    /**
     * @default 'Loading coupon…'
     */
    cmIfC: T;

    /**
     * @default 'Coupon not found.'
     */
    dDERR: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Created {{0}}'
     */
    AAyQf: T;

    /**
     * @default 'Disable Coupon'
     */
    AmFSP: T;

    /**
     * @default 'Enable Coupon'
     */
    ZFlvj: T;

    /**
     * @default 'Delete Coupon'
     */
    xv94C: T;

    /**
     * @default 'Delete this coupon and all its promotion codes? This cannot be undone.'
     */
    Ai1x6: T;

    /**
     * @default 'Confirm Delete'
     */
    '3lBcR': T;

    /**
     * @default 'Redemptions'
     */
    ovm7o: T;

    /**
     * @default 'Discount Distributed'
     */
    CHo94: T;

    /**
     * @default 'Budget Used'
     */
    YySYD: T;

    /**
     * @default 'Max Discount Cap'
     */
    fUfGI: T;

    /**
     * @default 'Total Redemptions'
     */
    '4ZOWu': T;

    /**
     * @default 'Budget Limited'
     */
    xX4CX: T;

    /**
     * @default '+ Add Promotion Code'
     */
    khNKZ: T;

    /**
     * @default 'No promotion codes yet. Add one to get started.'
     */
    vx0Xw: T;

    /**
     * @default 'Booker'
     */
    Azqom: T;

    /**
     * @default 'Min Spend'
     */
    QhaLi: T;

    /**
     * @default 'Delete "{{0}}"? Cannot be undone.'
     */
    hXTLb: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Disable'
     */
    KpD2C: T;

    /**
     * @default 'Enable'
     */
    '5nLeu': T;

    /**
     * @default 'No coupons found'
     * @param {number} count - The number of occurrences.
     * - zero: No coupons found
     * - singular: 1 coupon
     * - plural: {{0}} coupons
     */
    icuO1: T;

    /**
     * @default 'All types'
     */
    SqMqN: T;

    /**
     * @default 'All products'
     */
    '3RGMo': T;

    /**
     * @default 'Search by name'
     */
    cZqGJ: T;

    /**
     * @default 'e.g. Summer 20%'
     */
    wMmfj: T;

    /**
     * @default 'Product'
     */
    dGAik: T;

    /**
     * @default 'Clear filters'
     */
    '0Ev5m': T;

    /**
     * @default 'Any'
     */
    MYTAA: T;

    /**
     * @default 'Cash fund'
     */
    kU4eM: T;

    /**
     * @default 'Cash fund + card'
     */
    '98nYz': T;

    /**
     * @default 'Car Rental'
     */
    YIlmZ: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default '"Card" means anything paid at checkout — card, Apple Pay, Google Pay, Klarna or Affirm. This rule is only about whether the cash fund is used.'
     */
    Nbc8P: T;

    /**
     * @default 'Auto Apply codes are shown on hotel pages. An email restriction will hide this code from discovery.'
     */
    fI2qi: T;

    /**
     * @default 'Email already added'
     */
    adXud: T;

    /**
     * @default 'e.g. customer@example.com'
     */
    rs0gl: T;

    /**
     * @default 'Strong'
     */
    z9jFW: T;

    /**
     * @default 'Moderate'
     */
    FiWFw: T;

    /**
     * @default 'Weak'
     */
    GzkNA: T;

    /**
     * @default 'Geo'
     */
    nAVAA: T;

    /**
     * @default 'Address'
     */
    gDl5Q: T;

    /**
     * @default 'Google Place ID'
     */
    '7QL1B': T;

    /**
     * @default 'Matched'
     */
    SCwXU: T;

    /**
     * @default 'Discarded'
     */
    '1hSvo': T;

    /**
     * @default 'Match'
     */
    PBUaG: T;

    /**
     * @default 'Discard'
     */
    CIW2C: T;

    /**
     * @default 'n/a'
     */
    qkfAA: T;

    /**
     * @default 'Sent to review: {{0}}'
     */
    h0Uej: T;

    /**
     * @default 'No rationale provided.'
     */
    nwEau: T;

    /**
     * @default 'Resolved by {{0}}'
     */
    '3guYn': T;

    /**
     * @default '1 place found'
     * @param {number} count - The number of occurrences.
     * - singular: 1 place found
     * - plural: {{0}} places found
     */
    GqXd0: T;

    /**
     * @default '1 candidate on this page'
     * @param {number} count - The number of occurrences.
     * - singular: 1 candidate on this page
     * - plural: {{0}} candidates on this page
     */
    mMLH8: T;

    /**
     * @default 'Pending review'
     */
    x1Cn6: T;

    /**
     * @default 'Resolved — Matched'
     */
    QT3ZF: T;

    /**
     * @default 'Resolved — Discarded'
     */
    VtShU: T;

    /**
     * @default 'All candidates'
     */
    '5GfWj': T;

    /**
     * @default 'All reasons'
     */
    IaEGM: T;

    /**
     * @default 'Newest first'
     */
    I94o5: T;

    /**
     * @default 'Oldest first'
     */
    Nx0pG: T;

    /**
     * @default 'Highest confidence'
     */
    U1UUS: T;

    /**
     * @default 'Lowest confidence'
     */
    e7nb6: T;

    /**
     * @default 'Evaluation state'
     */
    twVtk: T;

    /**
     * @default 'Review reason'
     */
    kHVYj: T;

    /**
     * @default 'Sort by'
     */
    '1pqZA': T;

    /**
     * @default 'Page size'
     */
    u7gyf: T;

    /**
     * @default 'Expand All'
     */
    TLrQL: T;

    /**
     * @default 'Collapse All'
     */
    iLmnM: T;

    /**
     * @default '1 pending'
     * @param {number} count - The number of occurrences.
     * - singular: 1 pending
     * - plural: {{0}} pending
     */
    jiF5t: T;

    /**
     * @default '1 candidate'
     * @param {number} count - The number of occurrences.
     * - singular: 1 candidate
     * - plural: {{0}} possible matches
     */
    oc5Iq: T;

    /**
     * @default 'Showing {{0}}–{{1}} of 1 place'
     * @param {number} count - The number of occurrences.
     * - singular: Showing {{0}}–{{1}} of 1 place
     * - plural: Showing {{0}}–{{1}} of {{2}} places
     */
    o6pdF: T;

    /**
     * @default 'Source place'
     */
    meFvN: T;

    /**
     * @default 'Candidates'
     */
    ObiYP: T;

    /**
     * @default 'Top confidence'
     */
    RMmC2: T;

    /**
     * @default 'Location unavailable'
     */
    ZcdVZ: T;

    /**
     * @default '{{0}} · existing cluster'
     */
    AU5vo: T;

    /**
     * @default '{{0}} · new singleton'
     */
    MybwS: T;

    /**
     * @default 'Source'
     */
    tOKrV: T;

    /**
     * @default 'Confirming a match folds that candidate's provider row into {{0}}.'
     */
    jdJ1U: T;

    /**
     * @default 'Confirming a match merges {{0}} with the candidate's row into one cluster.'
     */
    h83UP: T;

    /**
     * @default 'No star rating'
     */
    sGZ5q: T;

    /**
     * @default '{{0}}-star'
     */
    '93K4F': T;

    /**
     * @default 'Address unavailable'
     */
    oPer0: T;

    /**
     * @default '{{0}} ID · {{1}}'
     */
    tQ2iF: T;

    /**
     * @default 'Cluster · {{0}}'
     */
    '7N8bS': T;

    /**
     * @default 'View Listing'
     */
    DDKoN: T;

    /**
     * @default 'Google Place ID · {{0}}'
     */
    YbJcG: T;

    /**
     * @default 'No Google Place ID'
     */
    c6zFK: T;

    /**
     * @default 'View on Map'
     */
    qK0M3: T;

    /**
     * @default '1 candidate room.'
     * @param {number} count - The number of occurrences.
     * - singular: 1 candidate room.
     * - plural: {{0}} candidate rooms.
     */
    i1lPg: T;

    /**
     * @default 'No reason given'
     */
    '0Xs3M': T;

    /**
     * @default '{{0}}% confident'
     */
    '9nQ8x': T;

    /**
     * @default 'Unnamed room'
     */
    n1qyd: T;

    /**
     * @default 'No candidate rooms.'
     */
    OZTy6: T;

    /**
     * @default 'Already one of the hotel's rooms? Choose that room under Rooms. If not:'
     */
    I2Wwn: T;

    /**
     * @default 'Its Own Room'
     */
    Fe0hL: T;

    /**
     * @default 'Not a real room'
     */
    N3Fwa: T;

    /**
     * @default 'All providers'
     */
    pX1JD: T;

    /**
     * @default '1 hour'
     * @param {number} count - The number of occurrences.
     * - singular: 1 hour
     * - plural: {{0}} hours
     */
    KV8Ck: T;

    /**
     * @default '1 minute'
     * @param {number} count - The number of occurrences.
     * - singular: 1 minute
     * - plural: {{0}} minutes
     */
    SHlkr: T;

    /**
     * @default '1 case'
     * @param {number} count - The number of occurrences.
     * - singular: 1 case
     * - plural: {{0}} cases
     */
    '0a1hZ': T;

    /**
     * @default 'Showing 1 hotel. More are waiting.'
     * @param {number} count - The number of occurrences.
     * - singular: Showing 1 hotel. More are waiting.
     * - plural: Showing {{0}} hotels. More are waiting.
     */
    '4z1jA': T;

    /**
     * @default 'Showing 1 hotel.'
     * @param {number} count - The number of occurrences.
     * - singular: Showing 1 hotel.
     * - plural: Showing all {{0}} hotels.
     */
    DeqI0: T;

    /**
     * @default 'Under a minute'
     */
    z3vkL: T;

    /**
     * @default 'Open cases'
     */
    RUKCe: T;

    /**
     * @default 'Oldest waiting'
     */
    Kkfsi: T;

    /**
     * @default 'Open cases (1)'
     * @param {number} count - The number of occurrences.
     * - singular: Open cases (1)
     * - plural: Open cases ({{0}})
     */
    XHd9E: T;

    /**
     * @default 'Rooms (1)'
     * @param {number} count - The number of occurrences.
     * - singular: Rooms (1)
     * - plural: Rooms ({{0}})
     */
    Tqvjn: T;

    /**
     * @default 'Couldn't resolve this room: {{0}}'
     */
    '3IKOf': T;

    /**
     * @default 'Couldn't resolve this room. Try again.'
     */
    '2rsYy': T;

    /**
     * @default 'Assigned to the room.'
     */
    hKYMx: T;

    /**
     * @default 'Made a room of its own.'
     */
    WX9GD: T;

    /**
     * @default 'Retired. It stays out of the mapping.'
     */
    qSUCd: T;

    /**
     * @default 'Couldn't load all of this hotel's cases. The list may be incomplete.'
     */
    Qt32U: T;

    /**
     * @default 'Couldn't load this hotel's cases.'
     */
    VvbfU: T;

    /**
     * @default 'Loading cases…'
     */
    XEPdL: T;

    /**
     * @default 'No rooms are waiting here any more.'
     */
    JGoJP: T;

    /**
     * @default 'Loading more cases…'
     */
    '6QVfZ': T;

    /**
     * @default 'Couldn't load this hotel's rooms.'
     */
    MWpV9: T;

    /**
     * @default 'Loading rooms…'
     */
    ME08e: T;

    /**
     * @default 'This hotel has no rooms yet. Make the case a room of its own to start one.'
     */
    qpADp: T;

    /**
     * @default 'Rooms'
     */
    gIS1G: T;

    /**
     * @default 'Retire this room?'
     */
    HYOAB: T;

    /**
     * @default '“{{0}}” will be treated as not a real room. It stays out of the room mapping, even when a supplier sends it again.'
     */
    pj5sg: T;

    /**
     * @default 'This room will be treated as not a real room. It stays out of the room mapping, even when a supplier sends it again.'
     */
    nu4NA: T;

    /**
     * @default 'Retire Room'
     */
    Em617: T;

    /**
     * @default 'Candidate'
     */
    '7fcuG': T;

    /**
     * @default 'Room · {{0}}'
     */
    MyjuH: T;

    /**
     * @default 'Same room as this one'
     */
    Z2HPU: T;

    /**
     * @default 'This room has no members.'
     */
    rW64g: T;

    /**
     * @default 'Sleeps 1'
     * @param {number} count - The number of occurrences.
     * - singular: Sleeps 1
     * - plural: Sleeps {{0}}
     */
    j3bbi: T;

    /**
     * @default 'yes'
     */
    '5KjAA': T;

    /**
     * @default 'no'
     */
    V8AAA: T;

    /**
     * @default '{{0}} × {{1}}'
     */
    s0ViF: T;

    /**
     * @default '{{0}} m²'
     */
    '3UOTN': T;

    /**
     * @default 'Non-smoking'
     */
    IIEJV: T;

    /**
     * @default 'Not accessible'
     */
    LyQ79: T;

    /**
     * @default 'View: {{0}}'
     */
    lc4pB: T;

    /**
     * @default '{{0}}: {{1}}'
     */
    '7ggEq': T;

    /**
     * @default 'Also sold as: {{0}}'
     */
    Fl9ij: T;

    /**
     * @default 'Supplier facts'
     */
    '9kgoL': T;

    /**
     * @default 'The supplier stated nothing about this room.'
     */
    xjzDL: T;

    /**
     * @default 'Parser hints, guessed from the name'
     */
    fnlsO: T;

    /**
     * @default 'Supplier hotel · {{0}} · Room identity · {{1}}'
     */
    '71hZd': T;

    /**
     * @default 'Requested'
     */
    Iv45b: T;

    /**
     * @default 'Sent to provider'
     */
    yNSdn: T;

    /**
     * @default 'Soft amendment'
     */
    b1L54: T;

    /**
     * @default 'Hard amendment'
     */
    SVgGQ: T;

    /**
     * @default 'Check-in'
     */
    QJjjP: T;

    /**
     * @default 'Check-out'
     */
    Z515P: T;

    /**
     * @default 'Guest email'
     */
    KzH4j: T;

    /**
     * @default 'Guest first name'
     */
    dQBAn: T;

    /**
     * @default 'Guest last name'
     */
    LBnf5: T;

    /**
     * @default 'Guest phone'
     */
    ysKwk: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Room type'
     */
    PsIPm: T;

    /**
     * @default '{{0}} by {{1}}'
     */
    IGAOZ: T;

    /**
     * @default 'What was requested couldn't be read.'
     */
    kv9XI: T;

    /**
     * @default 'Failed {{0}}: {{1}}'
     */
    CZG7X: T;

    /**
     * @default 'No reason recorded.'
     */
    JJX5r: T;

    /**
     * @default 'Provider amendment: {{0}} · {{1}}'
     */
    OAYdL: T;

    /**
     * @default 'Provider amendment: {{0}}'
     */
    ma5JF: T;

    /**
     * @default 'Loading changes…'
     */
    '1wKQU': T;

    /**
     * @default 'The change history couldn't be loaded.'
     */
    z2S9x: T;

    /**
     * @default 'This booking hasn't been changed.'
     */
    '6B6hM': T;

    /**
     * @default 'Changes'
     */
    dmYZj: T;

    /**
     * @default 'Automatic'
     */
    r6YaO: T;

    /**
     * @default 'Automatic (async)'
     */
    odcJU: T;

    /**
     * @default 'Canceled'
     */
    TqO5I: T;

    /**
     * @default 'Requires action'
     */
    sdTs7: T;

    /**
     * @default 'Bank cannot process'
     */
    GCTcR: T;

    /**
     * @default 'Check returned'
     */
    '1tPWQ': T;

    /**
     * @default 'Credit not processed'
     */
    '0m5Hk': T;

    /**
     * @default 'Customer initiated'
     */
    tmpLM: T;

    /**
     * @default 'Debit not authorized'
     */
    Wbg90: T;

    /**
     * @default 'Duplicate'
     */
    djRAg: T;

    /**
     * @default 'Fraudulent'
     */
    Uzlnj: T;

    /**
     * @default 'General'
     */
    ojXaZ: T;

    /**
     * @default 'Incorrect account details'
     */
    g8L3Q: T;

    /**
     * @default 'Insufficient funds'
     */
    VLwtd: T;

    /**
     * @default 'Product not received'
     */
    '9oxb2': T;

    /**
     * @default 'Product unacceptable'
     */
    QK3g1: T;

    /**
     * @default 'Subscription canceled'
     */
    '21wHY': T;

    /**
     * @default 'Unrecognized'
     */
    JmujH: T;

    /**
     * @default 'Charge refunded'
     */
    PCjsI: T;

    /**
     * @default 'Lost'
     */
    i88LA: T;

    /**
     * @default 'Needs response'
     */
    iwBvb: T;

    /**
     * @default 'Under review'
     */
    arXyS: T;

    /**
     * @default 'Warning closed'
     */
    YooFn: T;

    /**
     * @default 'Warning — needs response'
     */
    Emssw: T;

    /**
     * @default 'Warning — under review'
     */
    CYeIn: T;

    /**
     * @default 'Won'
     */
    '8mZAA': T;

    /**
     * @default 'Pending capture'
     */
    zTVtq: T;

    /**
     * @default 'Partially refunded'
     */
    DQb8P: T;

    /**
     * @default 'Refunded'
     */
    '3DziC': T;

    /**
     * @default 'Stripe Payment'
     */
    V8Yf3: T;

    /**
     * @default 'Disputed · {{0}} · {{1}}'
     */
    '5Mqxj': T;

    /**
     * @default 'Disputed · {{0}}'
     */
    Z8SSk: T;

    /**
     * @default 'Intent Amount'
     */
    WadeM: T;

    /**
     * @default 'Dispute reason'
     */
    ec8Ku: T;

    /**
     * @default 'Charged'
     */
    uAAaj: T;

    /**
     * @default 'Capture'
     */
    GJiFS: T;

    /**
     * @default 'Net settlement'
     */
    YEBfD: T;

    /**
     * @default 'Exchange rate'
     */
    FJ11f: T;

    /**
     * @default 'Dispute status'
     */
    sXzBy: T;

    /**
     * @default 'Refunds'
     */
    ttJ4e: T;

    /**
     * @default 'PI: {{0}} · Charge: {{1}}'
     */
    dxPlg: T;

    /**
     * @default 'PI: {{0}}'
     */
    NvLTL: T;

    /**
     * @default 'Cancellation Policies'
     */
    loYgD: T;

    /**
     * @default 'Free cancellation until {{0}}.'
     */
    '5KZ8u': T;

    /**
     * @default 'Free cancellation.'
     */
    VIigP: T;

    /**
     * @default 'After {{0}}'
     */
    kjnlU: T;

    /**
     * @default '{{0}} Adult'
     */
    UL5vh: T;

    /**
     * @default '{{0}} Adults'
     */
    R2ELj: T;

    /**
     * @default '{{0}} Child'
     */
    UMa6h: T;

    /**
     * @default '{{0}} Children'
     */
    tmItH: T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default 'Room'
     */
    FC3MA: T;

    /**
     * @default 'Night'
     */
    iqbgG: T;

    /**
     * @default 'Nights'
     */
    '5EH6H': T;

    /**
     * @default 'Average per night'
     */
    qHiLx: T;

    /**
     * @default 'Total in {{0}}'
     */
    vwHqo: T;

    /**
     * @default 'Paid from Honeymoon Fund'
     */
    z2jlT: T;

    /**
     * @default 'Paid by card'
     */
    ZfoXd: T;

    /**
     * @default 'Pick-up'
     */
    fBJvL: T;

    /**
     * @default 'Drop-off'
     */
    '1YaiW': T;

    /**
     * @default 'Payment status'
     */
    EpAW6: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Loading payment details…'
     */
    i37HQ: T;

    /**
     * @default 'Loading checkout events…'
     */
    DqulP: T;

    /**
     * @default 'User Agreed to TOS : true'
     */
    wJNtj: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Copied'
     */
    SfCTp: T;

    /**
     * @default 'Are you sure you want to cancel this reservation? This action cannot be undone.'
     */
    ajE05: T;

    /**
     * @default 'Booking has been cancelled. It may take up to 10-20 minutes for changes to reflect here.'
     */
    sk1MJ: T;

    /**
     * @default 'Open Reservation'
     */
    omW8J: T;

    /**
     * @default 'Cancel Booking'
     */
    DCOpm: T;

    /**
     * @default 'Processing...'
     */
    '3wQaq': T;

    /**
     * @default 'Confirm Cancel Booking'
     */
    FqZxl: T;

    /**
     * @default 'This stay has already ended and can't be canceled.'
     */
    voplO: T;

    /**
     * @default 'Cancellation is not available while the booking is being finalized.'
     */
    n2sz5: T;

    /**
     * @default 'Event ID: {{0}}'
     */
    '9kPXl': T;

    /**
     * @default 'Authorized'
     */
    j6y3m: T;

    /**
     * @default 'Awaiting payment'
     */
    umAsh: T;

    /**
     * @default 'Needs review'
     */
    DP3MG: T;

    /**
     * @default 'Refund pending'
     */
    ZW38q: T;

    /**
     * @default 'Booking payment'
     */
    fCrwa: T;

    /**
     * @default 'Date change payment'
     */
    QJZyz: T;

    /**
     * @default 'Price difference refund'
     */
    '4vsHb': T;

    /**
     * @default 'Cancellation refund'
     */
    pW1yT: T;

    /**
     * @default 'PI: {{0}} · Refund: {{1}}'
     */
    '5iJGe': T;

    /**
     * @default 'For the change requested {{0}}'
     */
    YY0VP: T;

    /**
     * @default 'For change {{0}}'
     */
    '797cy': T;

    /**
     * @default 'Original total'
     */
    bTdS0: T;

    /**
     * @default 'Current total'
     */
    X6nVD: T;

    /**
     * @default 'Charged to card, net of refunds'
     */
    i2TBT: T;

    /**
     * @default 'Loading payments…'
     */
    rTOvL: T;

    /**
     * @default 'The payment history couldn't be loaded.'
     */
    ZnFiS: T;

    /**
     * @default 'No payments recorded.'
     */
    ipPTz: T;

    /**
     * @default 'Payments'
     */
    b9CHm: T;

    /**
     * @default 'Search by email, guest name, or booking ID…'
     */
    FtvyE: T;

    /**
     * @default 'Collapse reservation details'
     */
    Z3Uy8: T;

    /**
     * @default 'Expand reservation details'
     */
    kSicF: T;

    /**
     * @default 'Payment'
     */
    SKIqN: T;

    /**
     * @default 'Cancelled By'
     */
    gJikg: T;

    /**
     * @default 'Confirmation'
     */
    FAtsR: T;

    /**
     * @default 'Loading reservations…'
     */
    R48pq: T;

    /**
     * @default 'No reservations found for your search.'
     */
    MaoiV: T;

    /**
     * @default 'No reservation found for this booking.'
     */
    lI3KW: T;

    /**
     * @default 'Failed to open reservation. Please try again.'
     */
    zh8gE: T;

    /**
     * @default 'Could not find reservation to cancel.'
     */
    uE3OC: T;

    /**
     * @default 'Failed to cancel reservation. Please try again.'
     */
    '5UPnU': T;

    /**
     * @default 'Nothing was written. Fix these in the source file and upload it again — do not edit the file to make it pass. If a status or an amount is wrong here, it is wrong in the reconciliation too.'
     */
    R7Jgg: T;

    /**
     * @default 'Nothing was written.'
     */
    vbVEf: T;

    /**
     * @default 'row {{0}}'
     */
    uPue8: T;

    /**
     * @default '{{0}} row read for {{1}}.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} row read for {{1}}.
     * - plural: {{0}} rows read for {{1}}.
     */
    RJWKg: T;

    /**
     * @default '{{0}} booking is clear to pay.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} booking is clear to pay.
     * - plural: {{0}} bookings are clear to pay.
     */
    nzjMj: T;

    /**
     * @default '{{0}} needs someone to look at it before this statement is paid.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} needs someone to look at it before this statement is paid.
     * - plural: {{0}} need someone to look at them before this statement is paid.
     */
    q1jeL: T;

    /**
     * @default '{{0}} is already settled and is not part of this payment.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} is already settled and is not part of this payment.
     * - plural: {{0}} are already settled and are not part of this payment.
     */
    CGEDD: T;

    /**
     * @default '{{0}} carries a credit to chase on the next one.'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} carries a credit to chase on the next one.
     * - plural: {{0}} carry a credit to chase on the next one.
     */
    CkcEi: T;

    /**
     * @default 'Asked and expected agree'
     */
    pGDfU: T;

    /**
     * @default 'Pay the ask; the credit lands on a later statement'
     */
    sZdmS: T;

    /**
     * @default 'Refunded beyond what the policy allowed, and no reason is recorded'
     */
    TcmCC: T;

    /**
     * @default 'The provider's room value disagrees with Joy's'
     */
    Jv7l7: T;

    /**
     * @default 'Dates or property do not match'
     */
    '2HO3i': T;

    /**
     * @default 'The booking came through a different provider'
     */
    gQfZP: T;

    /**
     * @default 'Joy has no record of this booking'
     */
    kKMcE: T;

    /**
     * @default 'Duplicated on the statement, or the expected amount cannot be worked out'
     */
    eR4FK: T;

    /**
     * @default 'Covered by a payment recorded earlier'
     */
    qGO5c: T;

    /**
     * @default 'Part of this booking has already been paid'
     */
    Bni51: T;

    /**
     * @default 'Settled'
     */
    Zyga5: T;

    /**
     * @default '{{0}} written, {{1}} skipped.'
     */
    oQORw: T;

    /**
     * @default '{{0}} written.'
     */
    dbPbH: T;

    /**
     * @default 'Rows read'
     */
    '3Kzpa': T;

    /**
     * @default 'Inserted'
     */
    yITuG: T;

    /**
     * @default 'Updated'
     */
    Bn1Wf: T;

    /**
     * @default 'Skipped — already paid'
     */
    uhc5V: T;

    /**
     * @default 'A payment has already been recorded against these bookings, so their rows were left untouched rather than overwritten. Worth checking whether the provider has billed them twice.'
     */
    Qyvol: T;

    /**
     * @default 'Money, per currency'
     */
    wRCem: T;

    /**
     * @default 'Bookings'
     */
    mV0kh: T;

    /**
     * @default 'Expected'
     */
    w7kbc: T;

    /**
     * @default 'Difference'
     */
    '1fLZf': T;

    /**
     * @default 'Clear to pay'
     */
    CRt8C: T;

    /**
     * @default 'What needs a person'
     */
    foRtt: T;

    /**
     * @default 'Blocks payment — {{0}}'
     */
    kwZ17: T;

    /**
     * @default 'Pay now — {{0}}'
     */
    Oq4XL: T;

    /**
     * @default 'Already settled, do not pay again — {{0}}'
     */
    n3ZtV: T;

    /**
     * @default 'Credits still owed after this statement'
     */
    wwhoD: T;

    /**
     * @default 'Amount'
     */
    '6xj0j': T;

    /**
     * @default 'Twilio'
     */
    OZV7Y: T;

    /**
     * @default 'Telnyx'
     */
    Q6OgX: T;

    /**
     * @default 'SMS Provider'
     */
    mQ8jC: T;

    /**
     * @default 'Pin this event to one SMS provider. The pin takes effect on the event's next send. An unassigned event gets a provider from the rollout on its first send.'
     */
    YMh6D: T;

    /**
     * @default 'Saving…'
     */
    QFC8u: T;

    /**
     * @default 'Unassigned'
     */
    Pd9rU: T;

    /**
     * @default 'Select a provider'
     */
    '4YdYD': T;

    /**
     * @default 'Both forcing flags are stored on this event, so email_service ignores them. Select Twilio or Telnyx to clear the contradiction.'
     */
    iSt85: T;

    /**
     * @default 'Send history: loading…'
     */
    u8Z2P: T;

    /**
     * @default 'Send history: could not load.'
     */
    '2p85c': T;

    /**
     * @default 'Send history: last sent via {{0}} - {{1}}'
     */
    me0Pb: T;

    /**
     * @default 'Send history: no SMS sent for this event yet.'
     */
    Plrsf: T;

    /**
     * @default 'Send history reads past sends, so it keeps naming the old provider until the event sends again. It is not a readback of the setting above.'
     */
    fX2qJ: T;

    /**
     * @default 'There was an error updating the SMS provider. The dropdown shows what is stored now.'
     */
    '4dhBz': T;

    /**
     * @default 'There was an error updating the travel email settings.'
     */
    KiE9U: T;

    /**
     * @default 'Travel Emails (Guest Hotel Booking Reminder)'
     */
    FydHi: T;

    /**
     * @default 'Could not load travel email settings.'
     */
    nlmRl: T;

    /**
     * @default 'Keep guests updated on hotel stays and rates'
     */
    AzZvO: T;

    /**
     * @default 'Same setting the couple sees in Settings › Where to Stay. Off disables every travel marketing email for this event, not just rate alerts.'
     */
    YLAXn: T;

    /**
     * @default 'on'
     */
    '18AAA': T;

    /**
     * @default 'off'
     */
    lVgAA: T;

    /**
     * @default 'Hotel checkout & product page reminders'
     */
    xr9uE: T;

    /**
     * @default 'Sent 1 hour after an abandoned checkout and 1 day after a hotel product page view.'
     */
    wqG8O: T;

    /**
     * @default 'Turn the setting above back on to change this.'
     */
    '83hQS': T;

    /**
     * @default 'Could not load the pre and post first booking emails setting.'
     */
    Pfmr9: T;

    /**
     * @default 'Pre and post first booking emails'
     */
    EsevC: T;

    /**
     * @default 'Nudges to book a hotel before the event has one, and follow-ups (plus price-drop alerts) to host and guests once it does — separate from the abandonment series above.'
     */
    '8APMg': T;

    /**
     * @default 'Event's safety rating updated successfully'
     */
    jhieM: T;

    /**
     * @default 'EventName:'
     */
    Z2cKr: T;

    /**
     * @default 'Set Event Safety Rating:'
     */
    rjNEY: T;

    /**
     * @default 'If an event has been marked as unsafe, you can manually override the safety rating here.'
     */
    i0E9U: T;

    /**
     * @default 'Or, if you believe an event is unsafe, you can mark it as such.'
     */
    udo7A: T;

    /**
     * @default 'Safe'
     */
    '3U8MA': T;

    /**
     * @default 'Unsafe'
     */
    uCO4a: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'View Event Website'
     */
    SVErT: T;

    /**
     * @default 'View Event Messaging Page'
     */
    S1yLQ: T;

    /**
     * @default 'Service Center: Event Safety Rating'
     */
    xxm1c: T;

    /**
     * @default 'Event Website Handle: {{0}}'
     */
    v2IfL: T;

    /**
     * @default 'Way to go! You're a spam swatting superhero!'
     */
    '3uRpH': T;

    /**
     * @default 'Another spammer bites the dust!'
     */
    '5hYPs': T;

    /**
     * @default 'Good work! Spam defeated, now we can sleep tight 😇'
     */
    '7e15r': T;

    /**
     * @default 'Welcome to the bottom! Can I interest you in a snack?'
     */
    H47oT: T;

    /**
     * @default '🪰💥 spam smashed! have a taco 🌮'
     */
    bJH1a: T;

    /**
     * @default 'Whew, you blocked a lot of spam! Time for a nap 😴🛌'
     */
    xNGkb: T;

    /**
     * @default 'Spam defeated! But don't let your guard down yet... more is sure to come!'
     */
    mdUqd: T;

    /**
     * @default 'Thanks for using the Spam Service Center! Come again soon!'
     */
    Ftbfq: T;

    /**
     * @default 'CLICK FOR TACOS!'
     */
    CvJQQ: T;

    /**
     * @default 'If we had a penny for every spammer you just blocked, we could buy all our employees a pony!'
     */
    wxD6X: T;

    /**
     * @default 'Deleting 1 spam a day keeps the doctor away!'
     */
    gCMt6: T;

    /**
     * @default 'Imagine a world without spammers 🥺'
     */
    j6Kq7: T;

    /**
     * @default '1 message rejected 📧 = 1 taco 🌮'
     */
    v8IjE: T;

    /**
     * @default 'Unknown property'
     */
    r1pwT: T;

    /**
     * @default 'Unknown vehicle'
     */
    YIGcd: T;

    /**
     * @default 'AI Evaluated'
     */
    lGVDF: T;

    /**
     * @default 'Automatically flagged by the reservation evaluation pipeline.'
     */
    VeXT7: T;

    /**
     * @default 'Reviewed'
     */
    HmK7r: T;

    /**
     * @default 'Escalated'
     */
    CWeT9: T;

    /**
     * @default 'Joy reviewer'
     */
    '5Flfl': T;

    /**
     * @default 'Manual fraud review recorded.'
     */
    QUujV: T;

    /**
     * @default 'Evaluation not loaded yet.'
     */
    eUbYX: T;

    /**
     * @default 'Unknown action.'
     */
    ogTBR: T;

    /**
     * @default 'Unknown error'
     */
    Q9psa: T;

    /**
     * @default 'Nothing was submitted: this proposal is no longer pending. The dispute has been refreshed.'
     */
    L670K: T;

    /**
     * @default 'Nothing was dismissed: this proposal is no longer pending. The dispute has been refreshed.'
     */
    jQzzO: T;

    /**
     * @default 'Loading reservation details…'
     */
    gQ1Tc: T;

    /**
     * @default 'Error loading reservation details: {{0}}'
     */
    E5sbp: T;

    /**
     * @default 'Reservation not found.'
     */
    '9sMNe': T;

    /**
     * @default 'Upload a CSV containing a '
     */
    '3zVLL': T;

    /**
     * @default ' column (case-insensitive). Extra columns are ignored. Maximum {{0}} unique IDs per upload.'
     */
    NI1dS: T;

    /**
     * @default 'Choose CSV file'
     */
    bLIfa: T;

    /**
     * @default 'No file selected'
     */
    SCaOQ: T;

    /**
     * @default 'Found {{0}} unique IDs'
     */
    hVNtT: T;

    /**
     * @default ' ({{0}} duplicate(s) skipped)'
     */
    WRTGz: T;

    /**
     * @default 'Include Stripe payment details'
     */
    nM2jr: T;

    /**
     * @default 'Looking up…'
     */
    MnAO7: T;

    /**
     * @default 'Look up'
     */
    UbbA1: T;

    /**
     * @default ' — {{0}} of {{1}} switchOrderId(s) not found'
     */
    splrM: T;

    /**
     * @default '{{0}} of {{1}} switchOrderId(s) not found'
     */
    GwV5L: T;

    /**
     * @default 'Export results to CSV'
     */
    XW2uH: T;

    /**
     * @default 'View Email'
     */
    NDx3D: T;

    /**
     * @default 'Reason: {{0}}'
     */
    WAN1u: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'To Email'
     */
    VtyJ9: T;

    /**
     * @default 'replyTo Email'
     */
    zayiO: T;

    /**
     * @default 'From Email'
     */
    ShdTB: T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Last Status'
     */
    Sbh96: T;

    /**
     * @default 'Email Type'
     */
    wP2OR: T;

    /**
     * @default 'Event Id'
     */
    veJlg: T;

    /**
     * @default 'Searching messages…'
     */
    sLdBT: T;

    /**
     * @default 'We couldn't run this search. Try again.'
     */
    spOBl: T;

    /**
     * @default 'No results found'
     */
    Py80B: T;

    /**
     * @default 'Search by one or multiple fields. Text must be exact match.'
     */
    Q3GCw: T;

    /**
     * @default 'Subject search can be full subject line or FIRST word(s) of subject line, ie "Thanks for attending" or "Thanks" or "Thanks for", but not "for" or "for attending".'
     */
    iMkyb: T;

    /**
     * @default 'Reply to Email'
     */
    JFQr1: T;

    /**
     * @default 'to Email'
     */
    '5HGfI': T;

    /**
     * @default 'Leave both dates blank to search all time.'
     */
    e8DIj: T;

    /**
     * @default 'If only providing "From Date" results will show from that date to current day.'
     */
    TLBxS: T;

    /**
     * @default 'If only providing "To Date" results will show email history up until that date.'
     */
    fKO9A: T;

    /**
     * @default 'From Date'
     */
    Y3quD: T;

    /**
     * @default 'To Date'
     */
    '9SkHT': T;

    /**
     * @default 'Page Size'
     */
    mxrtf: T;

    /**
     * @default 'Go to Page'
     */
    s3IBS: T;

    /**
     * @default 'Not paused'
     */
    HU9sK: T;

    /**
     * @default 'Combine Orders'
     */
    McUng: T;

    /**
     * @default 'Loading orders…'
     */
    NRkho: T;

    /**
     * @default 'The following orders will be combined. All orders must be paused before combining. The first order will be kept and immediately sent to Taylor. The remaining orders will show as cancelled.'
     */
    Phe6v: T;

    /**
     * @default 'No related orders found.'
     */
    ZRk20: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Digital Quantity'
     */
    J8DMC: T;

    /**
     * @default 'Quantity'
     */
    tT8ln: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Edit Quantity'
     */
    ffBUI: T;

    /**
     * @default 'Gift Digital Premium'
     */
    xXhWJ: T;

    /**
     * @default 'There was an error gifting the digital card.'
     */
    pLOQE: T;

    /**
     * @default 'The couple now has a premium digital card at no charge, order #{{0}}.'
     */
    oD3Nh: T;

    /**
     * @default 'View the gift in Service Center'
     */
    X0yHf: T;

    /**
     * @default 'View the gift as the couple sees it'
     */
    OdJDh: T;

    /**
     * @default 'Give the couple a premium digital card at no charge, to make up for a problem with order #{{0}}. They can customize it and send it by email or link. This can't be undone.'
     */
    JKKRT: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Order Issues'
     */
    Kly2Q: T;

    /**
     * @default 'ID'
     */
    '7nAAA': T;

    /**
     * @default 'Target'
     */
    VzMNX: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Resolved At'
     */
    '7pI8t': T;

    /**
     * @default 'Resolve'
     */
    C355f: T;

    /**
     * @default 'Disable SMS…'
     */
    '3bvaA': T;

    /**
     * @default 'Enable SMS…'
     */
    QiTPw: T;

    /**
     * @default 'SMS Delivery'
     */
    vAYtT: T;

    /**
     * @default 'Allow sending card to recipients using phone number.'
     */
    nFPxY: T;

    /**
     * @default 'Disable SMS'
     */
    vgI54: T;

    /**
     * @default 'Enable SMS'
     */
    '4ZFGp': T;

    /**
     * @default 'Update Shipping Address'
     */
    '3ozdo': T;

    /**
     * @default 'Full name'
     */
    SLCaY: T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'Address Line 1'
     */
    r2ebI: T;

    /**
     * @default 'Address Line 2'
     */
    s2ebI: T;

    /**
     * @default 'Apartment, Suite, etc. (optional)'
     */
    LK85B: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State/Province/Territory'
     */
    LLPZf: T;

    /**
     * @default 'Postal Code'
     */
    WCbuM: T;

    /**
     * @default 'View user images'
     */
    oAa0A: T;

    /**
     * @default 'User Uploaded Images'
     */
    h1dFe: T;

    /**
     * @default 'These are the editable images uploaded by the user across the card front, and back. Click to view the full resolution image.'
     */
    tuDLX: T;

    /**
     * @default 'Open full size'
     */
    kM9MS: T;

    /**
     * @default 'Total Results: 0'
     * @param {number} count - The number of occurrences.
     * - zero: Total Results: 0
     * - singular: Total Results: 1
     * - plural: Total Results: {{0}}
     */
    '5zduV': T;

    /**
     * @default 'Filter by one or multiple fields. Text must be exact match.'
     */
    kdcou: T;

    /**
     * @default 'Taylor Order Management System'
     */
    Z4sSJ: T;

    /**
     * @default 'Event Name'
     */
    vWoan: T;

    /**
     * @default 'Owner ID'
     */
    EOWRC: T;

    /**
     * @default 'User Email'
     */
    FlL4M: T;

    /**
     * @default 'If only providing "To Date" results will show order history up until that date.'
     */
    DYDey: T;

    /**
     * @default 'Clear Date'
     */
    RwFwk: T;

    /**
     * @default 'View Detail'
     */
    eu1xC: T;

    /**
     * @default 'Id'
     */
    doAAA: T;

    /**
     * @default 'Template ID'
     */
    VA1u7: T;

    /**
     * @default 'Template Theme ID'
     */
    Sxncb: T;

    /**
     * @default 'Template Category'
     */
    qa3Jr: T;

    /**
     * @default 'Concierge Suite Name'
     */
    GuQm4: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'Vendor'
     */
    eg4yc: T;

    /**
     * @default 'Sales Order ID'
     */
    xcGoP: T;

    /**
     * @default 'Created At'
     */
    L5zj0: T;

    /**
     * @default 'Order Detail'
     */
    zmKgC: T;

    /**
     * @default 'We couldn't load these print orders. Try again.'
     */
    SJDou: T;

    /**
     * @default 'Also you can sort by Price, Quantity, Pending Issues, Template Theme ID, Template Category, Concierge Suite Name, Delivery Method, Vendor, Status or Created At, by toggling the column header.'
     */
    hO7SN: T;

    /**
     * @default 'Needs Review'
     */
    hUOct: T;

    /**
     * @default 'Approved'
     */
    fb2SB: T;

    /**
     * @default 'Denied'
     */
    dkLJr: T;

    /**
     * @default 'We couldn't load this queue. Try again.'
     */
    OtSHf: T;

    /**
     * @default 'Loading messages…'
     */
    AQFxh: T;

    /**
     * @default 'No messages in this view.'
     */
    fF2cC: T;

    /**
     * @default 'You've reviewed every single message. Refresh if you'd like to check for more.'
     */
    ELGlP: T;

    /**
     * @default 'Go Back'
     */
    Ho8it: T;

    /**
     * @default 'Approve Message'
     */
    M5uS2: T;

    /**
     * @default 'Reject Message'
     */
    c7l7u: T;

    /**
     * @default 'Message Overview'
     */
    efFvS: T;

    /**
     * @default 'Subject:'
     */
    sHXE7: T;

    /**
     * @default 'Number of Recipients:'
     */
    '8rWuY': T;

    /**
     * @default 'Content:'
     */
    zrAPJ: T;

    /**
     * @default 'The Details'
     */
    xFylW: T;

    /**
     * @default 'Reviewed at {{0}} {{1}}'
     */
    D96w4: T;

    /**
     * @default 'Message was {{0}} by'
     */
    fMpko: T;

    /**
     * @default 'The spam indicators couldn't be shown — see the console.'
     */
    ngpUo: T;

    /**
     * @default 'The message payload couldn't be shown — see the console.'
     */
    x0kKz: T;

    /**
     * @default '1 message'
     * @param {number} count - The number of occurrences.
     * - singular: 1 message
     * - plural: {{0}} messages
     */
    '0v0px': T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'Reviewed by'
     */
    A3Baz: T;

    /**
     * @default 'Message reviewed'
     */
    ePS73: T;

    /**
     * @default 'Message sent {{0}}'
     */
    RtmYJ: T;

    /**
     * @default 'Submit to Stripe'
     */
    YP9a7: T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'Confirm Submit to Stripe'
     */
    uj3jH: T;

    /**
     * @default 'Confirm Dismiss'
     */
    uEvbc: T;

    /**
     * @default 'This sends the evidence below to Stripe and closes the dispute's evidence window. Stripe allows one submission per dispute; it cannot be edited or withdrawn afterwards.'
     */
    L9MeI: T;

    /**
     * @default 'This records that Joy will not contest the dispute with this package. The proposal is kept for the audit trail but will no longer be shown as pending.'
     */
    '5dTrl': T;

    /**
     * @default 'Stripe's evidence window for this dispute closed while the confirmation was open; the package can no longer be submitted.'
     */
    bs1E1: T;

    /**
     * @default 'Submitted to Stripe on {{0}}'
     */
    goolW: T;

    /**
     * @default 'Dismissed on {{0}}'
     */
    OWEmG: T;

    /**
     * @default 'Awaiting CX review'
     */
    zB4uY: T;

    /**
     * @default 'Dispute {{0}}'
     */
    uapog: T;

    /**
     * @default 'Reason'
     */
    omLMS: T;

    /**
     * @default 'Evidence due'
     */
    vvUYM: T;

    /**
     * @default 'Customer name'
     */
    LqDs3: T;

    /**
     * @default 'Customer email'
     */
    '0JuGr': T;

    /**
     * @default 'Purchase IP'
     */
    ISyfG: T;

    /**
     * @default 'Service date'
     */
    L05JX: T;

    /**
     * @default 'Product description'
     */
    BiEpA: T;

    /**
     * @default 'Narrative sent to Stripe'
     */
    '8isDt': T;

    /**
     * @default 'The proposed package is no longer available to display.'
     */
    F4htL: T;

    /**
     * @default 'Stripe's evidence window for this dispute has closed; the package can no longer be submitted.'
     */
    LabGH: T;

    /**
     * @default 'Reviewer note (optional)'
     */
    WSv7o: T;

    /**
     * @default 'Recorded with your decision for the audit trail. Not sent to Stripe.'
     */
    v31L0: T;

    /**
     * @default 'Action Failed'
     */
    '1HvMQ': T;

    /**
     * @default 'Dispute Evidence ({{0}})'
     */
    ya3tS: T;

    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Website V2'
     */
    '7a3fl': T;

    /**
     * @default 'Website V2, live'
     */
    hFUWw: T;

    /**
     * @default 'Website V2, draft'
     */
    '4Ik6H': T;

    /**
     * @default 'Event Information'
     */
    ypaaZ: T;

    /**
     * @default 'View Event →'
     */
    '51wcQ': T;

    /**
     * @default 'View Accommodations →'
     */
    eW3ie: T;

    /**
     * @default 'Guest List (editor) →'
     */
    KmKp1: T;

    /**
     * @default 'Booked via OTA — statistically higher fraud risk'
     */
    u7wKZ: T;

    /**
     * @default 'Website Handle'
     */
    '9xZEQ': T;

    /**
     * @default 'Event Type'
     */
    qRpbn: T;

    /**
     * @default '🏨 OTA'
     */
    CTB5D: T;

    /**
     * @default 'Owner'
     */
    bCjnG: T;

    /**
     * @default 'Event Date'
     */
    M6IZn: T;

    /**
     * @default 'Website State'
     */
    sSR1x: T;

    /**
     * @default 'Event Website State (Mirror)'
     */
    krVUk: T;

    /**
     * @default 'Venue'
     */
    tdqJH: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Safety Rating'
     */
    ty0xq: T;

    /**
     * @default 'Owner Email(s)'
     */
    f0ClQ: T;

    /**
     * @default 'Click to copy reservation ID'
     */
    XwDks: T;

    /**
     * @default 'Reservation {{0}}'
     */
    ofclM: T;

    /**
     * @default 'Copied!'
     */
    zRtI3: T;

    /**
     * @default 'Pass — Not reviewable'
     */
    mwzKG: T;

    /**
     * @default 'AI Evaluated at {{0}}'
     */
    IhzRZ: T;

    /**
     * @default 'Risk Score'
     */
    ft693: T;

    /**
     * @default 'Fraud Evaluation'
     */
    KaRmC: T;

    /**
     * @default 'No fraud evaluation found for this reservation.'
     */
    CqxaU: T;

    /**
     * @default '(could not serialize — see console)'
     */
    Pxs9F: T;

    /**
     * @default 'Decision'
     */
    Q7TzQ: T;

    /**
     * @default 'AI Risk Score'
     */
    Nfk2N: T;

    /**
     * @default 'N/A'
     */
    GgWAA: T;

    /**
     * @default 'AI Evaluated At'
     */
    aEQ5l: T;

    /**
     * @default 'Mode'
     */
    '7LIMA': T;

    /**
     * @default 'Shadow'
     */
    myPFV: T;

    /**
     * @default 'Special Handling'
     */
    KSQgQ: T;

    /**
     * @default '⚠️ Risk Signals ({{0}})'
     */
    GmSFv: T;

    /**
     * @default '✅ Legitimacy Signals ({{0}})'
     */
    dNrup: T;

    /**
     * @default '💭 AI Reasoning'
     */
    uycIS: T;

    /**
     * @default '🔔 Raw Signals'
     */
    Ao51M: T;

    /**
     * @default 'Expand'
     */
    atMUv: T;

    /**
     * @default 'Collapse'
     */
    f8LSD: T;

    /**
     * @default 'Guest Information'
     */
    Yf1Em: T;

    /**
     * @default 'Phone'
     */
    '4pRqG': T;

    /**
     * @default 'Manual Review'
     */
    qxOAT: T;

    /**
     * @default 'Reviewed By'
     */
    '8lBaz': T;

    /**
     * @default 'Reviewed At'
     */
    WlBaz: T;

    /**
     * @default 'Disposition'
     */
    NAs7D: T;

    /**
     * @default 'Note'
     */
    GqRMA: T;

    /**
     * @default 'Payment Attempts'
     */
    wqNKF: T;

    /**
     * @default 'No payment attempts found.'
     */
    pbvJb: T;

    /**
     * @default 'Payment Attempts ({{0}})'
     */
    npnKe: T;

    /**
     * @default 'Booking Email'
     */
    '3xzET': T;

    /**
     * @default 'Stripe Risk'
     */
    W5ncH: T;

    /**
     * @default 'EFW'
     */
    mKUAA: T;

    /**
     * @default 'Disputed'
     */
    '2wDs4': T;

    /**
     * @default 'open'
     */
    kVQRA: T;

    /**
     * @default '⚠️ Yes'
     */
    Qo8qQ: T;

    /**
     * @default '🔴 Yes'
     */
    '8t2BN': T;

    /**
     * @default 'Reservation Details'
     */
    AKNtW: T;

    /**
     * @default 'View Reservation →'
     */
    bGmnd: T;

    /**
     * @default 'Product Type'
     */
    RnGJL: T;

    /**
     * @default 'Pick-up Address'
     */
    '15JtK': T;

    /**
     * @default 'Hotel Address'
     */
    '8V0SF': T;

    /**
     * @default 'Confirmation Code'
     */
    AQDNG: T;

    /**
     * @default 'Rooms ({{0}})'
     */
    zBwyG: T;

    /**
     * @default 'Adults'
     */
    '9woIj': T;

    /**
     * @default 'Children'
     */
    jbb2a: T;

    /**
     * @default 'Refundability'
     */
    WYVrr: T;

    /**
     * @default 'Are you sure you want to approve this reservation?'
     */
    MGbBt: T;

    /**
     * @default 'Are you sure you want to reject this reservation? This action cannot be undone.'
     */
    '5beov': T;

    /**
     * @default 'This reservation has been {{0}}. No further actions available.'
     */
    zGlyG: T;

    /**
     * @default 'Review Actions'
     */
    RVTKc: T;

    /**
     * @default 'Note (required)'
     */
    '0Omfz': T;

    /**
     * @default 'Include the signals that informed your decision and any information or tooling you wish you had while making the determination.'
     */
    q0Mvh: T;

    /**
     * @default 'What signals informed your decision? e.g. Stripe risk score was low, card has been on file 6+ months, IP closely matches billing address, guest name and email are consistent.'
     */
    dUyDc: T;

    /**
     * @default 'Confirm {{0}}'
     */
    sjARV: T;

    /**
     * @default 'Backend Contract Gap'
     */
    CwBzd: T;

    /**
     * @default 'Review History'
     */
    WbzdM: T;

    /**
     * @default 'No review history available.'
     */
    s223X: T;

    /**
     * @default 'No results found'
     * @param {number} count - The number of occurrences.
     * - zero: No results found
     * - singular: 1 reservation found
     * - plural: {{0}} reservations found
     */
    '1KYGT': T;

    /**
     * @default 'Quarantine — Pending'
     */
    '7r5JT': T;

    /**
     * @default 'Quarantine — Reviewed (Fraud)'
     */
    yG9I7: T;

    /**
     * @default 'Quarantine — Reviewed (Not Fraud)'
     */
    Z5VO1: T;

    /**
     * @default 'AI Evaluated Date (Newest)'
     */
    y6zg2: T;

    /**
     * @default 'AI Evaluated Date (Oldest)'
     */
    Bv9lN: T;

    /**
     * @default 'Risk Score (Highest)'
     */
    mExUv: T;

    /**
     * @default 'Risk Score (Lowest)'
     */
    WbnhP: T;

    /**
     * @default 'Evaluation State'
     */
    dYHKi: T;

    /**
     * @default 'Sort By'
     */
    zYqZA: T;

    /**
     * @default 'Reservation ID'
     */
    LaqCT: T;

    /**
     * @default 'Loading the fraud queue…'
     */
    EKLGF: T;

    /**
     * @default 'Error loading fraud queue'
     */
    LCIp4: T;

    /**
     * @default 'No flagged reservations match your filters.'
     */
    vOv8Y: T;

    /**
     * @default 'Resolve the Issue'
     */
    IrIBC: T;

    /**
     * @default 'Are you sure you want to resolve this issue?'
     */
    KAxom: T;

    /**
     * @default 'There was an error resolving the issue.'
     */
    PrRS0: T;
  };
};

export type SettingsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Event Settings'
     */
    eventSettings: T;

    /**
     * @default 'Home'
     */
    home: T;

    /**
     * @default 'Help'
     */
    help: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;
  };
  nav: {
    /**
     * @default 'General'
     */
    general: T;

    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Admins'
     */
    admins: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Where to Stay'
     */
    whereToStay: T;

    /**
     * @default 'You’ve got unsaved changes. Are you sure you want to navigate away from this page?'
     */
    blockedMessages: T;
  };
  inputJoyUrl: {
    /**
     * @default 'withjoy.com/'
     */
    prefix: T;

    /**
     * @default 'This URL is available'
     */
    available: T;

    /**
     * @default 'This URL is not available'
     */
    notAvailable: T;

    /**
     * @default 'Oops! Something went wrong. 
 Please reload the page and try again.'
*/
    error: T;

    /**
     * @default 'Max characters'
     */
    labelMaxCharacters: T;
  };
  registry: {
    /**
     * @default 'Registry'
     */
    title: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;

    /**
     * @default 'Gifts fulfilled by Joy can ship to the contiguous United States (excluding Non-Continental United States territories).'
     */
    shippingAddressNote: T;

    /**
     * @default 'Currency'
     */
    currency: T;

    /**
     * @default 'Set the currency which is displayed on your manually added registry gifts and new cash funds. This will not affect existing cash funds or gifts added from the Joy shop.'
     */
    currencyNote: T;

    /**
     * @default 'Delay Shipping'
     */
    delayShipping: T;

    /**
     * @default 'You decide when you want gifts fulfilled by Joy to ship.'
     */
    delayShippingNote: T;

    /**
     * @default 'On'
     */
    on: T;

    /**
     * @default 'Off'
     */
    off: T;

    /**
     * @default 'Delay Shipping is'
     */
    toggleLabel: T;

    /**
     * @default 'Seamless Checkout'
     */
    seamlessCheckout: T;

    /**
     * @default 'Simplify your guests' checkout experience for eligible gifts when possible.'
     */
    seamlessCheckoutNote: T;

    /**
     * @default 'Seamless Checkout is'
     */
    seamlessCheckoutToggleLabel: T;

    /**
     * @default 'Cash Fund Setup'
     */
    cashFundSetup: T;

    /**
     * @default 'Let your guests contribute to your cash funds with their credit cards.'
     */
    cashFundSetupNote: T;

    /**
     * @default 'Manage Account'
     */
    manageAccount: T;

    /**
     * @default 'Connect to Stripe'
     */
    stripeConnect: T;

    /**
     * @default 'Connected Registries'
     */
    connectedRegistries: T;

    /**
     * @default 'Connect a Registry'
     */
    connectRegistry: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'No Shipping Address.'
     */
    noShippingAddress: T;

    /**
     * @default 'Add'
     */
    add: T;

    /**
     * @default 'Bank Account'
     */
    bankAccount: T;

    /**
     * @default 'Exchange eligible gifts for cash, allow gift givers to contribute to your cash funds using a credit card, and more when you create a Joy Wallet!'
     */
    joyCreditNote: T;

    /**
     * @default 'Continue'
     */
    continue: T;

    /**
     * @default 'Already registered somewhere else? Connect it to Joy to make your registry a success'
     */
    connectRegistryNote: T;

    /**
     * @default 'You need to add a valid US shipping address'
     */
    addValidShippingAddress: T;

    /**
     * @default 'Advanced Settings'
     */
    advancedSettings: T;

    /**
     * @default 'Most users leave these set to defaults.'
     */
    advancedSettingsNote: T;

    /**
     * @default 'Help guests find my registry'
     */
    findMyRegistryInMessagingSettingTitle: T;

    /**
     * @default 'Keep it easy for guests to contribute to your registry.'
     */
    titleConfirmationDialog: T;

    /**
     * @default '87% of guests want to give to wedding registries. Joy helps millions of people make the best decisions during this important moment in their lives.'
     */
    findMyRegistryInMessagingSettingNote: T;

    /**
     * @default 'Help guests find my registry'
     */
    findMyRegistryInMessagingSettingConfirm: T;

    /**
     * @default 'Don't help guests find my registry'
     */
    findMyRegistryInMessagingSettingCancel: T;

    /**
     * @default 'Tastefully links guests to your registry'
     */
    benefit1: T;

    /**
     * @default 'Avoids unwanted and duplicate gifts'
     */
    benefit2: T;

    /**
     * @default 'Reduces “Where's your registry??” questions'
     */
    benefit3: T;

    /**
     * @default 'Helps guests who can't attend send a gift'
     */
    benefit4: T;

    /**
     * @default 'Keeping this on:'
     */
    keepSettingOn: T;

    /**
     * @default 'Joy will help guests find your registry after RSVP and in confirmation messages to guests.'
     */
    findMyRegistryTooltip: T;
  };
  whereToStay: {
    /**
     * @default 'Where to Stay'
     */
    title: T;

    /**
     * @default 'Hotel Booking Alerts'
     */
    hotelBookingAlerts: T;

    smsNotifications: {
      /**
       * @default 'SMS Notifications'
       */
      title: T;

      /**
       * @default 'Receive a text message when a guest books a Joy Travel hotel on your website. <NoteLink/>'
       */
      note: T;

      /**
       * @default 'Add a mobile phone number to get alerts.'
       */
      noteLink: T;
    };
    emailNotifications: {
      /**
       * @default 'Email Notifications'
       */
      title: T;

      /**
       * @default 'Receive an email when a guest books a Joy Travel hotel on your website.'
       */
      note: T;
    };

    /**
     * @default 'Guest Hotel Booking Reminder'
     */
    guestHotelBookingReminder: T;

    guestHotelReminder: {
      /**
       * @default 'Booking Auto-Reminder'
       */
      title: T;

      /**
       * @default 'Remind guests who RSVP'd with a “yes” about booking accommodations with discounted prices. <NoteLink/>'
       */
      note: T;

      /**
       * @default 'Learn more'
       */
      noteLink: T;

      dialog: {
        /**
         * @default 'Don’t let guests miss out on rooms.'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Prevent Last Minute Mishaps'
             */
            title: T;

            /**
             * @default 'Remind guests to book early and save. Hotels near your venue can sell out quickly. '
             */
            note: T;
          },
          {
            /**
             * @default 'How it Works'
             */
            title: T;

            /**
             * @default 'Joy will send attending guests a reminder to book 7 days after they RSVP, linking them to your hotel recs. '
             */
            note: T;
          },
        ];

        /**
         * @default 'Remind Guests to Book'
         */
        keepCta: T;

        /**
         * @default 'I’ll risk my guests missing out'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'Guest Perks & Smart Tools'
     */
    guestPerksSmartTools: T;

    scheduleWhereToStay: {
      /**
       * @default 'Show 'Where to Stay' on Schedule'
       */
      title: T;

      /**
       * @default 'Link to your ‘Where to Stay’ page from your Schedule'
       */
      note: T;
    };
    exploreMoreHotels: {
      /**
       * @default 'Show 'Explore More Hotels' Button'
       */
      title: T;

      /**
       * @default 'Give guests more options — let them browse and book other nearby hotels with ease.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Allow Your Guests to Browse Hotels with Exclusive Rates'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Broader hotel selection'
             */
            title: T;

            /**
             * @default 'Guests can easily find more hotel options with the same exclusive rates.'
             */
            note: T;
          },
          {
            /**
             * @default 'Track where your guests are staying'
             */
            title: T;

            /**
             * @default 'We’ll notify you when a guest books, and you can view all bookings to help with planning.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Keep Explore Other Options'
         */
        keepCta: T;

        /**
         * @default 'Remove Explore More'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'Advanced Hotel Settings'
     */
    advancedHotelSettings: T;

    tripProfit: {
      /**
       * @default 'Share Joy’s exclusive hotel discounts when available'
       */
      title: T;

      /**
       * @default 'Joy gets special discounts through Closed User Group rates. Enable this to offer these discounts to your guests.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Show Discounted Partner Hotel Rates'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Show the most competitive offer to your guests'
             */
            title: T;

            /**
             * @default 'Joy gets special discounts as a part of closed user group rates. Enable these for your guests.'
             */
            note: T;
          },
          {
            /**
             * @default 'Exclusive Event Only Access '
             */
            title: T;

            /**
             * @default 'Allow your guests to book with rates available only to Joy couples and guests.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Suggest Partner Hotel Rates'
         */
        keepCta: T;

        /**
         * @default 'Remove Suggestions'
         */
        removeCta: T;
      };
    };
    priceCompare: {
      /**
       * @default 'Help guests compare and find the lowest rate before booking'
       */
      title: T;

      /**
       * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Display Hotel Price Comparisons'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Offer Rate Insights'
             */
            title: T;

            /**
             * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
             */
            note: T;
          },
          {
            /**
             * @default 'Offer More Booking Options'
             */
            title: T;

            /**
             * @default 'Allow guests to choose the most suitable place to book their stay.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Display Hotel Price Comparisons'
         */
        keepCta: T;

        /**
         * @default 'Remove Comparison'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'There was an error getting the settings values.'
     */
    queryError: T;

    /**
     * @default 'There was an error performing the update.'
     */
    mutationError: T;
  };
  website: {
    /**
     * @default 'Website'
     */
    title: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Copy Event Password'
     */
    copyPassword: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Edit Password'
     */
    editPassword: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Please Note:'
     */
    pleaseNote: T;

    /**
     * @default 'If you changed your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordChangeNote: T;

    /**
     * @default 'Guests will need to know your Joy event URL and event password to find and join your event on the app.'
     */
    passwordNote: T;

    /**
     * @default 'Password protect event date'
     */
    protectEventDate: T;

    /**
     * @default 'Password protect your event date so guests with password can access this information.'
     */
    protectEventDateNote: T;

    /**
     * @default 'Password protect event location'
     */
    protectEventLocation: T;

    /**
     * @default 'Password protect your event location so guests with password can access this information.'
     */
    protectEventLocationNote: T;

    /**
     * @default 'Event Settings saved'
     */
    settingsUpdateSuccess: T;

    /**
     * @default 'Error updating settings. Please try again later.'
     */
    settingsUpdateError: T;

    /**
     * @default 'Page settings saved.'
     */
    pageSettingsSaved: T;

    /**
     * @default 'Error saving page settings. Please try again later.'
     */
    pageSettingsError: T;

    /**
     * @default 'Page order saved.'
     */
    pageOrderSaved: T;

    /**
     * @default 'Error saving page order. Please try again later.'
     */
    pageOrderError: T;

    /**
     * @default 'Search Privacy'
     */
    searchPrivacy: T;

    /**
     * @default 'Allow guests to search for my event on Joy'
     */
    showOnGuestSearch: T;

    /**
     * @default 'Help guests find your website and registry if they’ve lost the link. Search results are not guaranteed.'
     */
    showOnGuestSearchNote: T;

    /**
     * @default 'Allow my event to be found on Google etc.'
     */
    showOnSearchEngine: T;

    /**
     * @default 'Search engine changes may take anywhere from a few days to weeks to take effect. Search results are not guaranteed.'
     */
    showOnSearchEngineNote: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Email verification is required.'
     */
    emailVerificationRequired: T;

    /**
     * @default 'Verify Email'
     */
    verifyEmail: T;

    /**
     * @default 'Pages'
     */
    pages: T;

    /**
     * @default 'Modify All…'
     */
    modifyAll: T;

    /**
     * @default 'Password Protections'
     */
    passwordProtections: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'None of your pages are password protected.'
     */
    nonePasswordProtected: T;

    /**
     * @default 'Some of your pages are password protected.'
     */
    somePagesProtected: T;

    /**
     * @default 'All of your pages are password protected.'
     */
    allPagesProtected: T;

    /**
     * @default 'All of your pages are hidden.'
     */
    allPagesHidden: T;

    /**
     * @default 'Announcement Banner'
     */
    announcementBanner: T;

    /**
     * @default 'Display announcement banner'
     */
    displayAnnouncementBanner: T;

    /**
     * @default 'Make sure guests don't miss an update or important detail when they arrive on your website.'
     */
    displayAnnouncementBannerNote: T;

    /**
     * @default 'Title'
     */
    bannerTitle: T;

    /**
     * @default 'Message'
     */
    message: T;

    /**
     * @default 'Preview Banner'
     */
    previewBanner: T;

    /**
     * @default 'Countdown and App Link'
     */
    countdownAndAppLink: T;

    /**
     * @default 'Display event countdown'
     */
    displayEventCountdown: T;

    /**
     * @default 'Countdown to your {{eventName}} for {{date}}. You can edit event times in your'
     */
    displayCountdownNoteWithEvent: T;

    /**
     * @default 'Countdown to {{date}}.'
     */
    displayCountdownNoteWithoutEvent: T;

    /**
     * @default 'Schedule.'
     */
    schedule: T;

    /**
     * @default 'Schedule Event'
     */
    scheduleEvent: T;

    /**
     * @default 'Display "Get the App" link'
     */
    getTheAppTitle: T;

    /**
     * @default 'Give guests a link to download the Joy app so they can upload photos and access event details on the go.'
     */
    getTheAppSubtitle: T;

    /**
     * @default 'App Photo'
     */
    appPhoto: T;

    /**
     * @default 'Update Photo'
     */
    updatePhoto: T;

    /**
     * @default 'Delete Photo'
     */
    deletePhoto: T;

    /**
     * @default 'Error uploading photo. Please try again later.'
     */
    uploadError: T;

    /**
     * @default 'Photo uploaded successfully.'
     */
    uploadSuccess: T;

    /**
     * @default 'Error deleting photo. Please try again later.'
     */
    deletePhotoError: T;

    /**
     * @default 'Photo deleted successfully.'
     */
    deletePhotoSuccess: T;

    /**
     * @default 'Add an event to your schedule to customize'
     */
    scheduleEmptyPlaceholder: T;

    /**
     * @default 'Select...'
     */
    scheduleNotSelectedPlaceholder: T;

    /**
     * @default 'We have determined that your website contains potentially dangerous content which is in breach of our terms of service. Please contact our customer support team to resolve this issue.'
     */
    unSafeEventInfoText: T;

    /**
     * @default 'Contact Us'
     */
    contactSupport: T;

    /**
     * @default 'No page photo'
     */
    noPagePhoto: T;

    /**
     * @default 'Advanced Hotel Settings'
     */
    advancedHotelSettings: T;

    /**
     * @default 'Most users keep these set to defaults.'
     */
    advancedHotelSettingsNote: T;

    /**
     * @default 'There was an error getting the settings values.'
     */
    advancedHotelSettingsQueryError: T;

    /**
     * @default 'There was an error performing the update.'
     */
    advancedHotelSettingsMutationError: T;

    /**
     * @default 'Disable Closed User Group (CUG) discounted hotel rates for my guests'
     */
    tripProfitTitle: T;

    /**
     * @default 'Joy secures exclusive hotel discounts called Closed User Group (CUG) rates by supporting millions of events and hundreds of millions of guests. These private rates are not available anywhere else online and are shown only when relevant. If you have arranged room blocks with specific hotels, Joy will automatically exclude those from showing CUG rates. Most couples keep this setting on. See real-world discounts before deciding to turn it off.'
     */
    tripProfitNote: T;

    /**
     * @default 'Let my guests compare rates and choose what works best for them'
     */
    interceptorTitle: T;

    /**
     * @default 'Joy supports millions of events and hundreds of millions of guests, unlocking exclusive Closed User Group (CUG) hotel rates. When a hotel link is shared, Joy may show guests a choice between the original link and a lower private rate. Room blocks you arrange are automatically respected, and this will not interfere with them. Rates can change from day to day, so we recommend not turning this off based on a single day's comparison. Most couples leave this on so guests can choose what works best for them. Turn off only if you are using an attrition-based room block with financial guarantees.'
     */
    interceptorNote: T;

    pageVisibility: {
      /**
       * @default 'Public'
       */
      public: T;

      /**
       * @default 'Password'
       */
      passwordProtected: T;

      /**
       * @default 'Hidden'
       */
      hidden: T;
    };

    /**
     * @default 'Page Settings'
     */
    pageDisplayName: T;

    /**
     * @default 'Advanced Schedule Settings'
     */
    advancedScheduleSettings: T;

    addToCalendar: {
      /**
       * @default 'Show 'Add to Calendar' on Schedule'
       */
      title: T;

      /**
       * @default 'Allow guests to easily add your event details to their calendar.'
       */
      note: T;

      /**
       * @default 'Default for all schedule items. Items can override this individually in the schedule editor.'
       */
      noteV2: T;

      dialog: {
        /**
         * @default 'Guests rely on Add to Calendar to avoid missing important events.'
         */
        title: T;

        /**
         * @default 'Disabling this option may make it harder for them to remember times and locations. We recommend keeping it on to ensure a smoother experience for your guests.'
         */
        note: T;

        /**
         * @default 'Keep Add to Calendar'
         */
        keepCta: T;

        /**
         * @default 'Remove Add to Calendar'
         */
        removeCta: T;
      };
      bulkReset: {
        /**
         * @default 'Some events have custom settings'
         */
        title: T;

        /**
         * @default '{{count}} events override 'Add to Calendar'. Reset all to inherit this new setting?'
         */
        body: T;

        /**
         * @default 'Reset to inherit'
         */
        confirmCta: T;

        /**
         * @default 'Keep overrides'
         */
        dismissCta: T;
      };
    };
  };
  general: {
    /**
     * @default 'General'
     */
    title: T;

    /**
     * @default 'Joy Event URL'
     */
    joyEventURL: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Add a Custom Domain'
     */
    addCustomDomain: T;

    /**
     * @default 'Copy Event URL'
     */
    copyEventURL: T;

    /**
     * @default 'Event URL copied.'
     */
    eventUrlCopiedToast: T;

    /**
     * @default 'Custom domain URL copied.'
     */
    customDomainCopiedToast: T;

    /**
     * @default 'Event URL'
     */
    eventUrl: T;

    /**
     * @default 'Your old Joy URL will no longer work - this means you'll need to let all your guests know the new address so they can still access your website. Please note that if you have a custom domain, you will also need to update your forwarding URL to point to this new Joy URL.'
     */
    eventUrlNote: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;

    /**
     * @default 'Personal Info'
     */
    personalInfo: T;

    /**
     * @default 'Partner One'
     */
    partnerOne: T;

    /**
     * @default 'Partner Two'
     */
    partnerTwo: T;

    /**
     * @default 'Event Display Name'
     */
    eventDisplayName: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'First name is required'
     */
    firstNameError: T;

    /**
     * @default 'Event display name cannot be blank'
     */
    eventDisplayNameError: T;

    /**
     * @default 'Date'
     */
    date: T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    invalidDate: T;

    /**
     * @default 'Show date in website and app'
     */
    showDateInApp: T;

    /**
     * @default 'When you hide your date, it won’t appear on your website or app and your countdown will be disabled.'
     */
    showDateInAppInfo: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Powered by Google'
     */
    poweredBy: T;

    /**
     * @default 'Time Zone'
     */
    timeZone: T;

    /**
     * @default 'Delete Event'
     */
    deleteEvent: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Custom Domain'
     */
    customDomain: T;

    /**
     * @default 'Remove Domain'
     */
    removeDomain: T;

    /**
     * @default 'Copy Custom Domain URL'
     */
    copyCustomDomainUrl: T;

    /**
     * @default 'Need Help?'
     */
    needHelp: T;

    /**
     * @default 'Custom domain updated'
     */
    customDomainUpdateSuccess: T;

    /**
     * @default 'Error updating custom domain. Please try again later.'
     */
    customDomainUpdateError: T;

    /**
     * @default 'Custom domain removed'
     */
    customDomainRemoveSuccess: T;

    /**
     * @default 'Error removing custom domain. Please try again later.'
     */
    customDomainRemoveError: T;

    findCustomDomainDialog: {
      /**
       * @default 'How would you like to add a custom domain?'
       */
      title: T;

      /**
       * @default 'Find the perfect domain'
       */
      ctaLabel1: T;

      /**
       * @default 'I already have a domain'
       */
      ctaLabel2: T;

      /**
       * @default 'Custom domains are an option service provided by GoDaddy not Joy. Domain masking is not supported.'
       */
      note: T;
    };
    addCustomDomainDialog: {
      /**
       * @default 'What’s your custom domain?'
       */
      title: T;

      /**
       * @default 'We’ll walk you through how to connect your domain to your Joy website.'
       */
      subtitle: T;

      /**
       * @default 'Save'
       */
      ctaLabel1: T;

      /**
       * @default 'Cancel'
       */
      ctaLabel2: T;

      /**
       * @default 'Custom domains are an option service provided by GoDaddy not Joy. Domain masking is not supported.'
       */
      note: T;

      /**
       * @default 'Your Domain Name'
       */
      yourDomainName: T;

      /**
       * @default 'yourdomain.com'
       */
      placeholder: T;

      /**
       * @default 'Test URL'
       */
      testUrl: T;

      /**
       * @default 'Domain name cannot be blank'
       */
      blankDomainError: T;

      /**
       * @default 'Not a valid domain'
       */
      notValidDomainError: T;

      quickAccess: [
        {
          /**
           * @default 'search_domain'
           */
          id: T;

          /**
           * @default 'Search Again'
           */
          title: T;

          /**
           * @default 'Find the domain you’re looking for.'
           */
          subtitle: T;

          /**
           * @default 'Search Domains'
           */
          ctaLabel: T;
        },
        {
          /**
           * @default 'faq'
           */
          id: T;

          /**
           * @default 'Have Questions?'
           */
          title: T;

          /**
           * @default 'Our FAQ section may have the answers.'
           */
          subtitle: T;

          /**
           * @default 'Explore FAQs'
           */
          ctaLabel: T;
        },
        {
          /**
           * @default 'chat'
           */
          id: T;

          /**
           * @default 'Have More Questions'
           */
          title: T;

          /**
           * @default 'Our team is just a chat bubble away.'
           */
          subtitle: T;

          /**
           * @default 'Chat with Us'
           */
          ctaLabel: T;
        },
      ];
    };
    removeCustomDomainDialog: {
      /**
       * @default 'Remove your custom domain?'
       */
      title: T;

      /**
       * @default 'Removing your custom domain removes it from your eCards but it will not disconnect it with your domain host.'
       */
      subtitle: T;

      /**
       * @default 'Need help?'
       */
      needHelp: T;

      /**
       * @default 'Remove Domain'
       */
      ctaLabel1: T;

      /**
       * @default 'Cancel'
       */
      ctaLabel2: T;
    };
  };
  users: {
    /**
     * @default 'Admins'
     */
    title: T;
  };
  quick: {
    /**
     * @default 'Oops! Something went wrong. 
 Please reload the page and try again.'
*/
    g9zYN: T;

    /**
     * @default 'Use at least {{0}} characters'
     */
    '7O76U': T;

    /**
     * @default 'This URL is available'
     */
    KJsEA: T;

    /**
     * @default 'This URL is not available'
     */
    '10V1O': T;

    /**
     * @default 'withjoy.com/'
     */
    qSXt9: T;

    /**
     * @default 'Max characters'
     */
    wRKQf: T;

    /**
     * @default 'Language & Currency'
     */
    r7OFL: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'View site'
     */
    OBx4U: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Don't let guests miss out on rooms.'
     */
    PGS08: T;

    /**
     * @default 'Hotels near your venue can sell out quickly. Make sure your guests have a place to stay, and save money too.'
     */
    AeYnp: T;

    /**
     * @default 'How It Works:'
     */
    jGjZO: T;

    /**
     * @default 'Joy will send attending guests a reminder to book 7 days after they RSVP, linking them to your hotel recs. That way, they book early and you don't have to worry.'
     */
    GnFtl: T;

    /**
     * @default 'Remind Guests to Book'
     */
    KhgiN: T;

    /**
     * @default 'I'll risk my guests missing out'
     */
    ECZeA: T;

    /**
     * @default 'You're all set!'
     */
    Lz3uB: T;

    /**
     * @default 'We'll send the reminder to attending guests 7 days after they RSVP.'
     */
    p87Bx: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Registry Currency'
     */
    '27F8l': T;

    /**
     * @default 'You can also change this in Registry settings.'
     */
    '5DWKD': T;

    /**
     * @default 'Where to Stay Currency'
     */
    '6iT3C': T;

    /**
     * @default 'You can also change this in Where to Stay settings.'
     */
    bZ8h8: T;

    /**
     * @default 'Transfer Ownership'
     */
    '2ZKfN': T;

    /**
     * @default 'Remove Admin'
     */
    '7MpGe': T;

    /**
     * @default 'Admins'
     */
    EGbHj: T;

    /**
     * @default 'Owner'
     */
    bCjnG: T;

    /**
     * @default 'Collaborators'
     */
    '3wCvR': T;

    /**
     * @default 'Add Collaborator'
     */
    V0CJK: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Hotel Booking Alerts'
     */
    o4QTr: T;

    /**
     * @default 'Page Currency'
     */
    A8sWK: T;

    /**
     * @default 'Suggested Dates'
     */
    KXSbH: T;

    /**
     * @default 'Select Layout'
     */
    ANUvm: T;

    /**
     * @default 'Choose how hotels appear to your guests.'
     */
    '6UAAa': T;

    /**
     * @default 'Guest Hotel Booking Reminder'
     */
    '7yzyF': T;

    /**
     * @default 'Help Guests Find a Place to Stay'
     */
    JlU0E: T;

    /**
     * @default 'Control what links and sections appear on your site'
     */
    x78q3: T;

    /**
     * @default 'Vacation Rentals'
     */
    '2Mm3T': T;

    /**
     * @default 'Let guests discover homes and rentals.'
     */
    bZfo1: T;

    /**
     * @default 'Neighborhoods'
     */
    v2yGJ: T;

    /**
     * @default 'Help guests explore the best areas to stay near your venue.'
     */
    s0rTR: T;

    /**
     * @default 'Advanced Hotel Settings'
     */
    tNIuC: T;

    /**
     * @default 'Share Joy's exclusive hotel discounts when available'
     */
    '4tbfd': T;

    /**
     * @default 'Joy gets special discounts through Closed User Group rates. Enable this to offer these discounts to your guests.'
     */
    ao0uf: T;

    /**
     * @default 'Show Discounted Partner Hotel Rates'
     */
    k1Gla: T;

    /**
     * @default 'Show the most competitive offer to your guests'
     */
    FGXRO: T;

    /**
     * @default 'Joy gets special discounts as a part of closed user group rates. Enable these for your guests.'
     */
    xwbFA: T;

    /**
     * @default 'Exclusive Event Only Access'
     */
    WAMN5: T;

    /**
     * @default 'Allow your guests to book with rates available only to Joy couples and guests.'
     */
    t8zyl: T;

    /**
     * @default 'Suggest Partner Hotel Rates'
     */
    '33OZM': T;

    /**
     * @default 'Remove Suggestions'
     */
    hON01: T;

    /**
     * @default 'Help guests compare and find the lowest rate before booking'
     */
    klFRU: T;

    /**
     * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
     */
    txLeS: T;

    /**
     * @default 'Display Hotel Price Comparisons'
     */
    J93Zv: T;

    /**
     * @default 'Offer Rate Insights'
     */
    '93OcK': T;

    /**
     * @default 'Offer More Booking Options'
     */
    OIDAj: T;

    /**
     * @default 'Allow guests to choose the most suitable place to book their stay.'
     */
    tu4Ha: T;

    /**
     * @default 'Remove Comparison'
     */
    hAioy: T;

    /**
     * @default 'Display hotel booking links after registry purchases'
     */
    xk1Bq: T;

    /**
     * @default 'Automatically include hotel links on guests’ registry confirmation pages.'
     */
    P8zLC: T;

    /**
     * @default 'Currency'
     */
    ZpluY: T;

    /**
     * @default 'Set the currency which is displayed on your manually added registry gifts and new cash funds. This will not affect existing cash funds or gifts added from the Joy shop.'
     */
    Ivwug: T;

    /**
     * @default 'Your payout method has been updated.'
     */
    DXcnd: T;

    /**
     * @default 'Manage Account'
     */
    WYWHP: T;

    /**
     * @default 'Bank Account'
     */
    f59PY: T;

    /**
     * @default 'Exchange eligible gifts for cash, allow gift givers to contribute to your cash funds using a credit card, and more when you create a Joy Wallet!'
     */
    P3ULv: T;

    /**
     * @default 'You are an editor but not the owner of this event. Only the account owner can connect a bank account.'
     */
    '7gnr0': T;

    /**
     * @default 'Update Bank Account'
     */
    '4GEsH': T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Transfer to Bank'
     */
    WRWhY: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'You need to add a valid US shipping address'
     */
    e88Wi: T;

    /**
     * @default 'Connect to Stripe'
     */
    MYwDu: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Email Address'
     */
    OgwcY: T;

    /**
     * @default 'Send Invite'
     */
    h6nET: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Revoke Access?'
     */
    bZHfj: T;

    /**
     * @default 'Revoke Invitation?'
     */
    Gn4TP: T;

    /**
     * @default 'Are you sure you want to revoke {{0}} admin privileges?'
     */
    WduJH: T;

    /**
     * @default 'Are you sure you want to revoke {{0}} invitation?'
     */
    '4pYLB': T;

    /**
     * @default 'this'
     */
    a18RA: T;

    /**
     * @default 'Revoke'
     */
    UwUPS: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Pending Invites'
     */
    FRnfG: T;

    /**
     * @default 'Resend Invite'
     */
    cOU21: T;

    /**
     * @default 'Copy Invite Link'
     */
    '8SepB': T;

    /**
     * @default 'Invite link copied to clipboard!'
     */
    ZCqp9: T;

    /**
     * @default 'Revoke Invite'
     */
    xZvez: T;

    /**
     * @default 'TRANSFER'
     */
    nnzOX: T;

    /**
     * @default 'Enter '{{0}}' to confirm'
     */
    h8LBR: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to:'
     */
    XRbst: T;

    /**
     * @default 'You will no longer be the primary account owner and your account will be downgraded to an admin account for this event.'
     */
    pYslU: T;

    /**
     * @default 'Transfer Ownership?'
     */
    p9pkJ: T;

    /**
     * @default 'You'
     */
    NMaAA: T;

    /**
     * @default 'Please wait before resending invitation'
     */
    k1dNs: T;

    /**
     * @default 'Invitation Resent'
     */
    cVNO8: T;

    /**
     * @default 'Access Revoked'
     */
    sjnYU: T;

    /**
     * @default 'Error revoking access'
     */
    ts3We: T;

    /**
     * @default 'Invitation Revoked!'
     */
    SygZ1: T;

    /**
     * @default 'Error revoking invitation'
     */
    e7PiM: T;

    /**
     * @default 'Error sending invitation'
     */
    nW7cf: T;

    /**
     * @default 'Invitation Sent'
     */
    RlADB: T;

    /**
     * @default 'Something went wrong, please try again'
     */
    mmJyj: T;

    /**
     * @default 'Error transferring ownership'
     */
    cZpuK: T;

    /**
     * @default 'Ownership Transferred'
     */
    PwarE: T;

    /**
     * @default 'MM/DD/YYYY'
     */
    oiQg8: T;

    /**
     * @default 'Month Day, Year'
     */
    XhfsH: T;

    /**
     * @default 'Weekday, Month Day, Year'
     */
    '5DNmC': T;

    /**
     * @default 'Please re-enter the date in {{0}} format'
     */
    nmssF: T;

    /**
     * @default 'End date must be after the start date'
     */
    K3S0U: T;

    /**
     * @default 'Please enter your custom date text'
     */
    DDCcO: T;

    /**
     * @default 'Date range…'
     */
    '5cUEo': T;

    /**
     * @default 'Start date'
     */
    CXqIJ: T;

    /**
     * @default 'End date'
     */
    DT2Gz: T;

    /**
     * @default 'This range spans more than 14 days. Double-check the dates are correct.'
     */
    oQXbF: T;

    /**
     * @default 'Date Format'
     */
    vaDAI: T;

    /**
     * @default 'Please enter a year between {{0}} and {{1}}'
     */
    gUgs7: T;

    /**
     * @default 'My event date'
     */
    gjVbf: T;

    /**
     * @default 'Best for most events.'
     */
    xRR9r: T;

    /**
     * @default 'A date range'
     */
    iPwTS: T;

    /**
     * @default 'Useful if most of your guests are attending multiple events.'
     */
    kZqSe: T;

    /**
     * @default 'Don't show a date yet'
     */
    W2lWQ: T;

    /**
     * @default 'Hide it from your website and app for now.'
     */
    K0wRF: T;

    /**
     * @default 'Show date in website and app'
     */
    vpmnG: T;

    /**
     * @default 'When you hide your date, it won't appear on your website or app.'
     */
    whElI: T;

    /**
     * @default 'When you hide your date, it won't appear on your website or app and your countdown will be disabled.'
     */
    erGSc: T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Event Date'
     */
    M6IZn: T;

    /**
     * @default 'We'll still use this for your countdown and reminder emails. Guests won't see it.'
     */
    hLARy: T;

    /**
     * @default 'Used for your countdown and reminder emails.'
     */
    Ow1lA: T;

    /**
     * @default 'Powered by Google'
     */
    CgX6S: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'Time Zone'
     */
    fgL2h: T;

    /**
     * @default 'and'
     */
    '5bcAA': T;

    /**
     * @default 'Update currency?'
     */
    zddQw: T;

    /**
     * @default 'Your {{0}} currency will be updated to {{1}}. This will change how prices are displayed to your guests.'
     */
    QF6Qy: T;

    /**
     * @default 'Update currency'
     */
    yeYbz: T;

    /**
     * @default 'Keep current currency'
     */
    RH0gU: T;

    /**
     * @default 'Automatic (follows language)'
     */
    ewxiD: T;

    /**
     * @default '12-hour ({{0}})'
     */
    JLf68: T;

    /**
     * @default '24-hour ({{0}})'
     */
    ETt2G: T;

    /**
     * @default 'Registry and Where to Stay'
     */
    H0p3e: T;

    /**
     * @default 'We couldn't check your payout account, so your Registry currency wasn't changed.'
     */
    tq9HV: T;

    /**
     * @default 'Your {{0}} page currency has been updated to {{1}}.'
     */
    cfKOP: T;

    /**
     * @default 'Default Event Language'
     */
    pPG51: T;

    /**
     * @default 'Default language for your event website and emails.'
     */
    GNvTQ: T;

    /**
     * @default 'Language'
     */
    m7dMk: T;

    /**
     * @default 'Default currency: {{0}} · Default distance: miles'
     */
    fNMqA: T;

    /**
     * @default 'Default currency: {{0}} · Default distance: kilometers'
     */
    aWDct: T;

    /**
     * @default 'Time Format'
     */
    ib57E: T;

    /**
     * @default 'How times show on your website.'
     */
    iEJyL: T;

    /**
     * @default 'Languages your guests can choose'
     */
    '8yBjT': T;

    /**
     * @default 'Guests can view Joy's menus and buttons in their language. Your content stays exactly as you wrote it.'
     */
    '6pAgw': T;

    /**
     * @default 'Would you like to save the changes to the announcement banner?'
     */
    NeVZO: T;

    /**
     * @default 'Congrats! All changes are saved.'
     */
    bnSHP: T;

    /**
     * @default 'You set your announcement banner to public - would you like to save those changes?'
     */
    SaxOz: T;

    /**
     * @default 'We saved the changes you made to your announcement banner. Now you can see the preview.'
     */
    zoxBr: T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'No, thanks'
     */
    '6kQyP': T;

    /**
     * @default 'Announcement Banner'
     */
    '56Np9': T;

    /**
     * @default 'Display announcement banner'
     */
    feHP3: T;

    /**
     * @default 'Make sure guests don't miss an update or important detail when they arrive on your website.'
     */
    '4puPL': T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Preview Banner'
     */
    mtJFj: T;

    /**
     * @default 'Update Photo'
     */
    LZhkP: T;

    /**
     * @default 'Display "Get the App" link'
     */
    eaUoZ: T;

    /**
     * @default 'Give guests a link to download the Joy app so they can upload photos and access event details on the go.'
     */
    '13Jbn': T;

    /**
     * @default 'App Photo'
     */
    bmHWB: T;

    /**
     * @default 'Couldn't load the password. Try again.'
     */
    XGBs8: T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Show'
     */
    '5YANA': T;

    /**
     * @default 'Hide password'
     */
    fHzwN: T;

    /**
     * @default 'Show password'
     */
    IMpuT: T;

    /**
     * @default 'Guest Guide'
     */
    MdFgh: T;

    /**
     * @default 'Display Guest Guide'
     */
    i1pSG: T;

    /**
     * @default 'Provide your guests with a quick menu of helpful links and actions they should take as a guest.'
     */
    l8mSQ: T;

    /**
     * @default 'Show 1 Page'
     * @param {number} count - The number of occurrences.
     * - singular: Show 1 Page
     * - plural: Show all {{0}} pages
     */
    p8MNq: T;

    /**
     * @default 'Show Fewer Pages'
     */
    aQaPC: T;

    /**
     * @default 'Save your changes before you publish?'
     */
    FAEba: T;

    /**
     * @default 'You'll publish from the website designer, after a few quick checks. Save your changes here first so they aren't lost.'
     */
    VCS61: T;

    /**
     * @default 'Save and Continue'
     */
    nc0hJ: T;

    /**
     * @default 'Website Visibility'
     */
    NvtPx: T;

    /**
     * @default 'Publish your website'
     */
    rvvgD: T;

    /**
     * @default 'Keep your site unpublished while you're building it. Publish it when you're ready for guests to visit.'
     */
    pEWL3: T;

    /**
     * @default 'Show rental car pickup locations on the accommodations map.'
     */
    mtLRo: T;

    /**
     * @default 'Car rental pickup'
     */
    SjtnG: T;

    /**
     * @default 'Automatically remind attending guests to book accommodations.'
     */
    UhJfI: T;

    /**
     * @default 'Learn more'
     */
    tks4L: T;

    /**
     * @default 'Remind guests to book their hotel'
     */
    '4ggdD': T;

    /**
     * @default 'Prevent Last Minute Mishaps'
     */
    Xaj8Z: T;

    /**
     * @default 'Remind guests to book early and save. Hotels near your venue can sell out quickly.'
     */
    aWMfc: T;

    /**
     * @default 'How it Works'
     */
    PjIFm: T;

    /**
     * @default 'Joy will send attending guests a reminder to book 7 days after they RSVP, linking them to your hotel recs.'
     */
    YsuXU: T;

    /**
     * @default 'Display accommodations group code banner'
     */
    ntQBg: T;

    /**
     * @default 'Guests who RSVP see a banner sharing a group code for accommodations'
     */
    RQlUN: T;

    /**
     * @default 'Keep guests booking with your group'
     */
    '9Mh3d': T;

    /**
     * @default 'This banner points guests to your accommodations page, where they can access your group rates and have their stay details added to your '
     */
    QycNZ: T;

    /**
     * @default 'Bookings'
     */
    mV0kh: T;

    /**
     * @default ' tab.'
     */
    '3LL1C': T;

    /**
     * @default 'Turning it off may lead guests to book elsewhere, leaving you with less visibility while planning.'
     */
    N0NFY: T;

    /**
     * @default 'Turn off'
     */
    ixbLR: T;

    /**
     * @default 'Keep guest stays visible'
     */
    ruUwB: T;

    /**
     * @default 'More Hotels'
     */
    oTOJN: T;

    /**
     * @default 'Let guests browse additional nearby hotels.'
     */
    '7VYzH': T;

    /**
     * @default 'Allow Your Guests to Browse Hotels with Exclusive Rates'
     */
    '40uxS': T;

    /**
     * @default 'Broader hotel selection'
     */
    LVKdq: T;

    /**
     * @default 'Guests can easily find more hotel options with the same exclusive rates.'
     */
    '82ghr': T;

    /**
     * @default 'Track where your guests are staying'
     */
    FQvqS: T;

    /**
     * @default 'We'll notify you when a guest books, and you can view all bookings to help with planning.'
     */
    XF6Ao: T;

    /**
     * @default 'Keep Explore Other Options'
     */
    y8EhB: T;

    /**
     * @default 'Remove Explore More'
     */
    Ic4oD: T;

    /**
     * @default 'Keep guests updated on hotel stays and rates'
     */
    AzZvO: T;

    /**
     * @default 'We'll let attending guests know when availability changes and alert them when hotel rates drop.'
     */
    '3AGZw': T;

    /**
     * @default 'Keep your guests in the loop.'
     */
    BzX1I: T;

    /**
     * @default 'Never Miss a Rate Drop'
     */
    '6qEFx': T;

    /**
     * @default 'Guests get notified the moment hotel rates near your venue drop, so they can book for less.'
     */
    hvFUU: T;

    /**
     * @default 'Joy checks room availability and rates regularly, and notifies attending guests when something changes.'
     */
    yddrT: T;

    /**
     * @default 'Keep Guests Updated'
     */
    dPS4u: T;

    /**
     * @default 'I'll risk my guests overpaying'
     */
    '0VDM9': T;

    /**
     * @default 'Error loading date settings'
     */
    '3gUqg': T;

    /**
     * @default 'Help guests book hotels with the right dates from the start.'
     */
    jiXy9: T;

    /**
     * @default 'Check-In Date'
     */
    YMM6E: T;

    /**
     * @default 'Add check-in date'
     */
    rJAGa: T;

    /**
     * @default 'Check-Out Date'
     */
    jHfIJ: T;

    /**
     * @default 'Add check-out date'
     */
    '6G1hz': T;

    /**
     * @default 'Your event date doesn't fall within these hotel dates. Guests may book for the wrong dates.'
     */
    '2Wkot': T;

    /**
     * @default 'Keep dates in sync with event schedule'
     */
    vZW40: T;

    /**
     * @default 'We'll ask you to update hotel dates when your event schedule changes.'
     */
    XVPPR: T;

    /**
     * @default 'Error loading currency settings'
     */
    aHmYC: T;

    /**
     * @default 'Currency shown to guests for hotel prices.'
     */
    RDV4D: T;

    /**
     * @default 'Default Currency'
     */
    EEdII: T;

    /**
     * @default 'Select a currency'
     */
    ow1mE: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'No page photo'
     */
    iR56F: T;
  };
};

export type ShareAccommodationsHostTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'We couldn't load this event.'
     */
    CTArK: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Here's where to stay {{0}} — book your room 🪩'
     */
    PCbzB: T;

    /**
     * @default 'Here's where to stay — book your room 🪩'
     */
    pjVlG: T;

    /**
     * @default 'Where to stay'
     */
    VB3Ww: T;

    /**
     * @default 'Tell your guests where to stay for your big day.'
     */
    SILm5: T;

    /**
     * @default 'A note from you goes further than any email we could send. Pick a channel, tweak the message, send.'
     */
    NldnH: T;

    /**
     * @default 'Share Accommodations'
     */
    '6B1Tf': T;
  };
};

export type SharedComponentsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  registryGiftBasket: {
    giftOverlay: {
      giftList: {
        /**
         * @default '{{count}} Gifts'
         */
        tabLabel: T;

        /**
         * @default 'Advisor'
         */
        tabLabelV2: T;

        /**
         * @default 'Recently Added Gifts'
         */
        headerMsg: T;

        /**
         * @default 'Plus {{count}} more gifts in your registry'
         */
        overflowMsg: T;

        /**
         * @default 'Add some gifts and we’ll help you keep track of your most recent adds here.'
         */
        zeroStateMsg: T;

        /**
         * @default 'Manage Gifts'
         */
        fabBtn: T;
      };
      giftTracker: {
        /**
         * @default '{{count}} Tracked'
         */
        tabLabel: T;

        /**
         * @default 'Recently Reserved or Purchased'
         */
        headerMsg: T;

        /**
         * @default 'Plus {{count}} more gifts tracked in your registry'
         */
        overflowMsg: T;

        /**
         * @default 'There are no gifts reserved (yet!). Once gifts are reserved or purchased, you can preview them here.'
         */
        zeroStateMsg: T;

        /**
         * @default 'Track Gifts'
         */
        fabBtn: T;
      };
      checklist: {
        /**
         * @default 'Building your Checklist…'
         */
        buildingChecklist: T;

        /**
         * @default 'Checklist'
         */
        tabLabel: T;

        /**
         * @default ''
         */
        headerMsg: T;

        /**
         * @default ''
         */
        overflowMsg: T;

        /**
         * @default ''
         */
        zeroStateMsg: T;

        /**
         * @default ''
         */
        fabBtn: T;
      };
      shoppingCart: {
        /**
         * @default 'Cart'
         */
        tabLabel: T;

        /**
         * @default ''
         */
        headerMsg: T;

        /**
         * @default ''
         */
        overflowMsg: T;

        /**
         * @default ''
         */
        zeroStateMsg: T;

        /**
         * @default ''
         */
        fabBtn: T;
      };

      /**
       * @default 'There are no gifts in your registry yet. Once you start adding gifts, you can preview recently added items here.'
       */
      giftListZeroState: T;

      /**
       * @default 'There are no gifts reserved (yet!). Once gifts are reserved or purchased, you can preview them here.'
       */
      giftTrackerZeroState: T;

      trackedGiftBadges: {
        /**
         * @default 'Reserved'
         */
        reserved: T;

        /**
         * @default 'Purchased'
         */
        purchased: T;

        /**
         * @default 'Shipped'
         */
        shipped: T;

        /**
         * @default 'Processing'
         */
        processing: T;

        /**
         * @default 'Given'
         */
        given: T;
      };
    };
    floatingWidget: {
      /**
       * @default '{{count}} Gifts'
       */
      giftCount: T;

      /**
       * @default 'Checklist'
       */
      checklist: T;
    };
  };
  giftProgress: {
    /**
     * @default 'Start adding some gifts! 🎁'
     */
    progressNotStarted: T;

    /**
     * @default 'Keep going, you're doing great! 👍'
     */
    progressLessThanHalf: T;

    /**
     * @default 'You're halfway there! 🙌'
     */
    halfwayProgress: T;

    /**
     * @default 'You're so close! 💃'
     */
    progressAlmostComplete: T;

    /**
     * @default 'Congrats, you did it! 🎉'
     */
    progressComplete: T;

    /**
     * @default 'You're super awesome! 🦄✨'
     */
    progressBeyondComplete: T;

    /**
     * @default '{{count}} gifts added!'
     */
    giftsAdded: T;
  };
  registryTabsNavigation: {
    tabs: {
      /**
       * @default 'Overview'
       */
      overview: T;

      /**
       * @default 'Add Gifts'
       */
      gifts: T;

      /**
       * @default 'Track'
       */
      trackNative: T;

      /**
       * @default 'Track Gifts'
       */
      track: T;

      /**
       * @default 'Manage'
       */
      manageNative: T;

      /**
       * @default 'Manage Registry'
       */
      manage: T;

      /**
       * @default 'Menu'
       */
      menu: T;

      /**
       * @default 'Add'
       */
      giftsNative: T;
    };
  };
  countdownGiftCount: {
    greeting: {
      /**
       * @default '🎊 {{count}} day to go!'
       * @param {number} count - The number of occurrences.
       * - singular: 🎊 {{count}} day to go!
       * - plural: 🎊 {{count}} days to go!
       */
      countdownToWedding: T;

      /**
       * @default '{{count}} days ago ️💘'
       */
      countdownPostWedding: T;

      /**
       * @default 'Today's the big day! 🥂'
       */
      weddingDay: T;

      /**
       * @default 'Happy {{dayOfWeek}}!'
       */
      dailyMessage: T;
    };
    counters: {
      /**
       * @default 'Gifts Available'
       */
      giftsAddedLabel: T;

      /**
       * @default 'Reserved & Purchased'
       */
      reservedAndPurchaseLabel: T;
    };
  };
  missingGifts: {
    /**
     * @default 'Looking for a gift?'
     */
    missingGiftsLabel: T;

    /**
     * @default 'To track gifts on linked or synced registries, please visit those registries directly.'
     */
    trackGiftsLabel: T;
  };
  dialog: {
    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  registryGiftCounts: {
    /**
     * @default 'Registry Advisor'
     */
    registryGuide: T;

    /**
     * @default 'Gift Counts by Price'
     */
    countsByPrice: T;

    /**
     * @default 'Goal: {{targetCount}}'
     */
    giftCounts: T;

    /**
     * @default '{{giftCount}} of {{targetCount}} Gift Goal'
     */
    giftCountWithTarget: T;

    /**
     * @default '{{giftCount}} gifts added!'
     */
    totalCompletionCount: T;

    /**
     * @default 'Gift count is calculated with your potential guest count. Remember to include potential guests for engagement parties and showers.'
     */
    toolTip: T;

    /**
     * @default 'Please enter a valid number.'
     */
    inputError: T;

    /**
     * @default 'Save Estimate'
     */
    save: T;

    /**
     * @default 'How many guests are you inviting?'
     */
    howManyGuests: T;

    /**
     * @default 'Not sure? Just guess for now.'
     */
    guessForNow: T;

    /**
     * @default 'Under {{price}}'
     */
    underPrice: T;

    /**
     * @default 'Over {{price}}'
     */
    overPrice: T;

    /**
     * @default 'Edit Guest Count'
     */
    ariaEditLabel: T;

    /**
     * @default 'Browse'
     */
    button: T;

    /**
     * @default 'of '
     */
    of: T;

    /**
     * @default ' Gift Goal'
     */
    giftGoal: T;

    /**
     * @default ' Gifts Added'
     */
    giftsAdded: T;
  };
  safeLink: {
    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Proceed'
     */
    proceed: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default 'You are now leaving our website'
     */
    safeLinkTitle: T;

    /**
     * @default 'Unsafe link detected'
     */
    unsafeLinkTitle: T;

    /**
     * @default 'You are about to leave Joy. We are not responsible for the content or availability of the linked site. Please review the site's privacy and security policy as they may differ from Joy's.'
     */
    safeLinkMessage: T;

    /**
     * @default 'External Link'
     */
    externalLinkLabel: T;

    /**
     * @default 'We have determined that this external link is not safe to visit. Please contact the event owner for more details.'
     */
    unsafeLinkMessage: T;

    /**
     * @default 'Thank you for visiting!'
     */
    emptyTabTitle: T;

    /**
     * @default 'our site'
     */
    ourSite: T;

    /**
     * @default 'You can now close this tab and continue exploring <ourSiteLink/>.'
     */
    emptyTabMessage: T;
  };
  shippingAddressDialog: {
    /**
     * @default 'Add Your Shipping Address for Registry'
     */
    reminderTitle: T;

    /**
     * @default 'Add Shipping Address'
     */
    addShippingAddressBtn: T;

    /**
     * @default 'Avoid missing packages and awkward texts, we’ll take care of the rest.'
     */
    reminderDescription: T;

    /**
     * @default 'Remind me Later'
     */
    remindMeLater: T;

    /**
     * @default 'Where should guests send your gifts?'
     */
    shippingAdressFormTitle: T;

    /**
     * @default 'Address Suggestion'
     */
    addressSuggestion: T;

    /**
     * @default 'Please select the address you’d like to use.'
     */
    addressSuggestionDescription: T;

    /**
     * @default 'Confirm'
     */
    confirmAddress: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Save Address'
     */
    saveAddressBtn: T;

    /**
     * @default 'Clear Address'
     */
    clearBtn: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Only one recipient name is recommended'
     */
    nameSubtext: T;

    /**
     * @default 'Phone Number'
     */
    mobilePhone: T;

    /**
     * @default 'By entering your phone number, you agree to receive account notifications. You can opt out at any time.'
     */
    phoneDisclaimer: T;

    /**
     * @default 'Street Address'
     */
    address1: T;

    /**
     * @default 'We cannot ship to P.O. boxes'
     */
    address1Subtext: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    address2: T;

    /**
     * @default 'City/Town'
     */
    city: T;

    /**
     * @default 'State/Province/County'
     */
    state: T;

    /**
     * @default 'Postal/Zip code'
     */
    zipCode: T;

    /**
     * @default 'Country/Region'
     */
    country: T;

    /**
     * @default '*Required fields'
     */
    requiredText: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddressText: T;

    /**
     * @default 'Original Address'
     */
    originalAddressText: T;

    /**
     * @default 'We could not validate your address.'
     */
    addressValidationError: T;

    syncAndTransfer: {
      /**
       * @default 'Tell Guests where to send your gifts!'
       */
      formTitle: T;

      /**
       * @default 'Please note: items sold by Joy can only be shipped within the contingent United States.'
       */
      formDescription: T;
    };
  };
  searchBar: {
    /**
     * @default 'Search brands, products, or paste a URL'
     */
    placeholder: T;
  };
  eventInfoToast: {
    /**
     * @default '✨ Event ID Copied ✨'
     */
    copiedTextToast: T;

    /**
     * @default 'The event id has been copied to your clipboard:'
     */
    copiedText: T;

    /**
     * @default 'event ID:'
     */
    eventId: T;

    /**
     * @default 'firebase event ID:'
     */
    firebaseEventId: T;

    /**
     * @default 'Go to Firebase'
     */
    goToFirebase: T;
  };
  viewMore: {
    /**
     * @default 'View More'
     */
    viewMoreTitle: T;

    /**
     * @default '{{count}} of {{total}} products'
     */
    productCountSummary: T;
  };
  registryGiftAdvisorV2: {
    /**
     * @default 'Registry Advisor'
     */
    registryAdvisor: T;

    /**
     * @default '{{count}} Guests'
     */
    guestSummary: T;

    /**
     * @default 'Gifts<br>Available'
     */
    giftsAvailable: T;

    /**
     * @default 'Reserved & <br> Purchased'
     */
    reservedAndPurchased: T;

    /**
     * @default '{{count}} Gifts <br> Needed'
     */
    giftCount: T;

    /**
     * @default '1 Cash Fund <br> Needed'
     */
    cashFundCount: T;

    /**
     * @default 'Gift Price Balance'
     */
    giftPriceBalance: T;

    /**
     * @default 'Shop Now'
     */
    shopNow: T;

    /**
     * @default 'Cash Funds <br> Completed'
     */
    cashFundCompleted: T;

    /**
     * @default 'Gifts <br> Completed'
     */
    giftsCompleted: T;
  };
  guestPreferenceMessage: {
    /**
     * @default 'Next Tip'
     */
    nextTip: T;

    /**
     * @default 'Your registry is ready for gifts! You need at least {{targetedGiftCount}} gifts and 1 cash fund for {{guestCount}} invited guests.'
     */
    initialMessageWhenZero: T;

    /**
     * @default 'You’re {{giftsCompletionPercent}}% towards your goal! You need at least {{targetedGiftCount}} gifts and 1 cash fund for {{guestCount}} invited guests.'
     */
    initialMessageWhenGreaterThanZero: T;

    /**
     * @default 'Congratulations, you have enough gifts for your guests!'
     */
    initialMessageWhenGiftOnlyCompleted: T;

    /**
     * @default 'You’re {{giftsCompletionPercent}}% towards your goal! You still need at least {{targetedGiftCount}} gifts for {{guestCount}} invited guests.'
     */
    initialMessageWhenCashFundOnlyCompleted: T;

    facts: {
      /**
       * @default 'Have everything you need? Your wedding is the perfect time for a little upgrade.'
       */
      messageTitle1: T;

      /**
       * @default 'From a bigger food processor to a better vacuum, cash in on upgrade season.'
       */
      messageSubtitle1: T;

      /**
       * @default '67% of guests prefer to give physical gifts over cash—they are more personal and memorable.'
       */
      messageTitle2: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle2: T;

      /**
       * @default '67% of guests prefer to give physical gifts over cash. Figuring out how much to give can feel awkward and impersonal.'
       */
      messageTitle3: T;

      /**
       * @default 'Keep adding more gifts, so you have something for everyone.'
       */
      messageSubtitle3: T;

      /**
       * @default '33% of guests prefer to give cash over physical gifts, especially if it is for a clear purpose.'
       */
      messageTitle4: T;

      /**
       * @default 'Use gift cards and experiences to craft a story.'
       */
      messageSubtitle4: T;

      /**
       * @default 'Have everything you need? Gift cards are a great compliment to any registry.'
       */
      messageTitle5: T;

      /**
       * @default 'From Airbnb to Starbucks and Delta, we’ve got you.'
       */
      messageSubtitle5: T;

      /**
       * @default 'Did you know that the KitchenAid Stand Mixer and Airbnb gift cards are the most popular gifts in every state?'
       */
      messageTitle6: T;

      /**
       * @default 'Turns out we’re not all that different after all.'
       */
      messageSubtitle6: T;

      /**
       * @default 'Kitchen is the number one registry category, from appliances to bakeware.'
       */
      messageTitle7: T;

      /**
       * @default 'Bed and bath essentials, home tech, and cleaning gadgets are doing their best to catch up, though!'
       */
      messageSubtitle7: T;

      /**
       * @default 'The average honeymoon fund was $5700 last year, but this excludes travel-related gift cards.'
       */
      messageTitle8: T;

      /**
       * @default 'Enhance your travels with travel-related gifts and gift cards.'
       */
      messageSubtitle8: T;

      /**
       * @default 'Nearly 20% of couples are raising money for home down payments.'
       */
      messageTitle9: T;

      /**
       * @default 'Keep adding more gifts—your future home (and guests!) will thank you.'
       */
      messageSubtitle9: T;

      /**
       * @default 'Group gifts are popular with couples but not with guests, who want to give you something unique.'
       */
      messageTitle10: T;

      /**
       * @default 'Keep adding more gifts to make sure there’s something for everyone.'
       */
      messageSubtitle10: T;

      /**
       * @default 'Outdoor gear was the fastest growing registry category last year!'
       */
      messageTitle11: T;

      /**
       * @default 'Add gifts and let your guests help you get out there!'
       */
      messageSubtitle11: T;

      /**
       * @default 'Your registry can help you be more sustainable.'
       */
      messageTitle12: T;

      /**
       * @default 'Help your guests, help the planet with eco-friendly picks like food storage!'
       */
      messageSubtitle12: T;

      /**
       * @default '94% of wedding guests say that registries are helpful.'
       */
      messageTitle13: T;

      /**
       * @default 'Keep adding and avoid returning unwanted gifts.'
       */
      messageSubtitle13: T;

      /**
       * @default '70% of gifts are purchased from a registry.'
       */
      messageTitle14: T;

      /**
       * @default 'Having your registry complete before sending your invitations is a great way to avoid unwanted gifts.'
       */
      messageSubtitle14: T;

      /**
       * @default '78% of guests will purchase a gift for a registry.'
       */
      messageTitle15: T;

      /**
       * @default 'Joy helps make sure you have enough gifts.'
       */
      messageSubtitle15: T;

      /**
       * @default '40% of guests pick a gift based on the price they want to spend.'
       */
      messageTitle16: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle16: T;

      /**
       * @default '38% of guests choose a gift they think is practical for your new life together.'
       */
      messageTitle17: T;

      /**
       * @default 'Guests love to get you things you'll actually use.'
       */
      messageSubtitle17: T;

      /**
       * @default 'Kitchen tools and cookware often get snatched up first.'
       */
      messageTitle18: T;

      /**
       * @default 'Make sure your guests don't go hungry for gifts with dinnerware and tech up next.'
       */
      messageSubtitle18: T;

      /**
       * @default 'Some guests love to give big, so don't be shy!'
       */
      messageTitle19: T;

      /**
       * @default 'In fact, it's mid-priced items that can often go ungifted compared to big and small items.'
       */
      messageSubtitle19: T;

      /**
       * @default 'Guests prefer to give gifts for fun experiences.'
       */
      messageTitle20: T;

      /**
       * @default 'Use experiences, gift cards, and cash funds to tell a story about what you intend to do together.'
       */
      messageSubtitle20: T;

      /**
       * @default 'Guests generally spend between $50 and $200.'
       */
      messageTitle21: T;

      /**
       * @default 'Don't be shy with those big gifts, people love you!'
       */
      messageSubtitle21: T;

      /**
       * @default 'Family members often spend $150-$200, close friends $100-$150.'
       */
      messageTitle22: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle22: T;

      /**
       * @default '57% of boomers would prefer to spend more on a physical gift if they can't attend the wedding.'
       */
      messageTitle23: T;

      /**
       * @default 'That's more than okay, boomers.'
       */
      messageSubtitle23: T;

      /**
       * @default '72% of younger guests prefer to spend more joining the celebration.'
       */
      messageTitle24: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle24: T;

      /**
       * @default 'Alaska loves waffle makers, while the Midwest favors cast iron skillets.'
       */
      messageTitle25: T;

      /**
       * @default 'Joy will help you make sure you have gifts that appeal to everyone, at every price range.'
       */
      messageSubtitle25: T;

      /**
       * @default '80% of registries include a cash fund, while only 33% of guests prefer to give cash.'
       */
      messageTitle26: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle26: T;

      /**
       * @default 'Just over 10% of registries include charity donation options.'
       */
      messageTitle27: T;

      /**
       * @default 'Joy lets you easily add a charity to your registry.'
       */
      messageSubtitle27: T;

      /**
       * @default '91% of registries include physical gifts.'
       */
      messageTitle28: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle28: T;

      /**
       * @default 'Did you know? Registries with cash AND gifts get more gifts from their guests.'
       */
      messageTitle29: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle29: T;

      /**
       * @default 'Over $19 Billion is spent on registries every year in the United States.'
       */
      messageTitle30: T;

      /**
       * @default 'You'll get more if you have gifts AND cash funds.'
       */
      messageSubtitle30: T;

      /**
       * @default '88% of cash funds go to honeymoons or travel.'
       */
      messageTitle31: T;

      /**
       * @default 'Add gifts and have something to come home to.'
       */
      messageSubtitle31: T;

      /**
       * @default '39% of guests are NOT in favor of couples requesting only cash for their registry.'
       */
      messageTitle32: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle32: T;

      /**
       * @default '95% of couples wish asking for cash were more socially acceptable.'
       */
      messageTitle33: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle33: T;

      /**
       * @default '70% of couples say they'd love to receive cash gifts, while only 54% of those same couples say they're comfortable giving cash gifts.'
       */
      messageTitle34: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle34: T;

      /**
       * @default 'Avoid unwanted gifts — your guests are less likely to buy you something random if you have physical gifts on your registry.'
       */
      messageTitle35: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle35: T;

      /**
       * @default 'Be sure to hide large cash fund goals to avoid looking greedy or fantastical.'
       */
      messageTitle36: T;

      /**
       * @default 'It's easy, just check the box 'hide goal amount.''
       */
      messageSubtitle36: T;

      /**
       * @default 'Don't worry about having too many gifts, we'll give you a 20% discount on anything left after your wedding.'
       */
      messageTitle37: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle37: T;
    };
  };
  quick: {
    /**
     * @default 'Other (USD)'
     */
    Xihhd: T;

    /**
     * @default 'Unable to start checkout. Please refresh and try again.'
     */
    tiXcb: T;

    /**
     * @default '{{0}} is already active for this event.'
     */
    l0vIP: T;

    /**
     * @default 'Something went wrong while setting up checkout. Please try again.'
     */
    AKvFu: T;

    /**
     * @default 'We couldn't confirm your card. Please try again.'
     */
    EGOPN: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Discard changes?'
     */
    iAMyr: T;

    /**
     * @default 'Your changes haven't been saved. Leaving now discards them.'
     */
    bEmDK: T;

    /**
     * @default 'Discard'
     */
    CIW2C: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Address not found'
     */
    hZpcm: T;

    /**
     * @default 'Keep typing to display more results'
     */
    Uz04g: T;

    /**
     * @default '-- Add Address Manually --'
     */
    gzfUX: T;

    /**
     * @default 'Click for {{0}} more entries'
     */
    EDLGg: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'View all {{0}} photos'
     */
    nZbqI: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} to venue'
     */
    yYdQ3: T;

    /**
     * @default '{{0}} from venue'
     */
    XmNNS: T;

    /**
     * @default 'Try the New Version'
     */
    MY925: T;

    /**
     * @default 'Try the new version'
     */
    uBX3S: T;

    /**
     * @default 'We've rebuilt this page. Take it for a spin, you can switch back anytime.'
     */
    h1CWL: T;

    /**
     * @default 'You're previewing the new version. We'd love your feedback!'
     */
    scCoL: T;

    /**
     * @default 'Give Feedback'
     */
    WD4Ao: T;

    /**
     * @default 'Classic View'
     */
    BAL8N: T;

    /**
     * @default 'We couldn't save your work, so nothing has changed. Check your connection and try again.'
     */
    VzTLZ: T;

    /**
     * @default 'Based on {{0}} reviews'
     */
    bP9ML: T;

    /**
     * @default '{{0}} reviews'
     */
    '3hCTS': T;

    /**
     * @default '{{0}} is a {{1}} star hotel that is {{2}} ({{3}}) from the venue.'
     */
    '7RTR4': T;

    /**
     * @default '{{0}} is a {{1}} star hotel.'
     */
    wXUQD: T;

    /**
     * @default '{{0}} is {{1}} ({{2}}) from the venue.'
     */
    '8ZlpE': T;

    /**
     * @default 'Your location has been updated.'
     */
    pRNlk: T;

    /**
     * @default 'Your venue has been updated.'
     */
    Zqwxg: T;

    /**
     * @default 'We successfully updated your event location to reflect the new venue.'
     */
    opqHH: T;

    /**
     * @default 'We successfully updated your venue to reflect the new location.'
     */
    YMBMZ: T;

    /**
     * @default 'Update Your Schedule →'
     */
    ts7aS: T;

    /**
     * @default 'Update Where to Stay →'
     */
    eh2OT: T;

    /**
     * @default 'We couldn't play this video. Try again later.'
     */
    ifu9u: T;

    /**
     * @default 'Your browser can't play this video.'
     */
    '5LW7p': T;

    /**
     * @default 'Play Video'
     */
    bbATk: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Hotel photo'
     */
    uSpLP: T;

    /**
     * @default 'Uploaded preview'
     */
    Uqc06: T;

    /**
     * @default 'Replace Photo'
     */
    '6czvN': T;

    /**
     * @default 'Delete Photo'
     */
    doIgF: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    '32yZ1': T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default '1 Text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Text
     * - plural: {{0}} Texts
     */
    AF6wP: T;

    /**
     * @default '1 Email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Email
     * - plural: {{0}} Emails
     */
    '06HnF': T;

    /**
     * @default '+ 1 more'
     * @param {number} count - The number of occurrences.
     * - singular: + 1 more
     * - plural: + {{0}} more
     */
    Ldd7I: T;

    /**
     * @default 'Edit Recipients'
     */
    QInCZ: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Message image'
     */
    gwe4X: T;

    /**
     * @default 'Invalid Phone Number'
     */
    Gsdpn: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Text Message'
     */
    OKKVT: T;

    /**
     * @default 'Joy'
     */
    y6VAA: T;

    /**
     * @default 'Business account'
     */
    tqgyr: T;

    /**
     * @default 'Today'
     */
    h6LBH: T;

    /**
     * @default 'Yesterday'
     */
    OAhju: T;

    /**
     * @default 'Open Link'
     */
    YcEk3: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Your message is too long for SMS. Remove 1 character to send it.'
     * @param {number} count - The number of occurrences.
     * - singular: Your message is too long for SMS. Remove 1 character to send it.
     * - plural: Your message is too long for SMS. Remove {{0}} characters to send it.
     */
    '6OCHN': T;

    /**
     * @default 'SMS: {{0}}/{{1}} characters'
     */
    f1Q9t: T;

    /**
     * @default 'Hotel Availability'
     */
    PyvwN: T;

    /**
     * @default 'Rooms haven't been released for these dates yet.'
     */
    xYF3V: T;

    /**
     * @default 'Rooms haven't been released for the event dates yet.'
     */
    bAvKt: T;

    /**
     * @default 'Hotels can open bookings anywhere from 5 to 12 months in advance. We'll show prices here as soon as availability opens. Check back as your date gets closer.'
     */
    '7NvrC': T;

    /**
     * @default 'No rooms are available for these dates.'
     */
    fTpX4: T;

    /**
     * @default 'This hotel may have minimum stay requirements. Try expanding your dates to see availability.'
     */
    Iwnai: T;

    /**
     * @default 'Actions'
     */
    '79qhP': T;

    /**
     * @default 'How travel credit works'
     */
    JyWGE: T;

    /**
     * @default 'Save {{0}} to your board'
     */
    VwnNq: T;

    /**
     * @default 'Save to your board'
     */
    ZaXvo: T;

    /**
     * @default '{{0}} is saved. Change board'
     */
    DCdJi: T;

    /**
     * @default 'Saved. Change board'
     */
    F5NlD: T;

    /**
     * @default 'Save {{0}} to a board'
     */
    lJawO: T;

    /**
     * @default 'Save to a board'
     */
    '3ojZd': T;

    /**
     * @default 'Saved'
     */
    '5pL4G': T;

    /**
     * @default 'That didn’t save. Please try again.'
     */
    jbpQV: T;

    /**
     * @default 'your board'
     */
    NHKYT: T;

    /**
     * @default 'Search boards'
     */
    '3JjGH': T;

    /**
     * @default 'Your boards'
     */
    m0Btf: T;

    /**
     * @default 'We couldn’t load your boards.'
     */
    ykvip: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Loading your boards…'
     */
    IxuCE: T;

    /**
     * @default 'Quick save'
     */
    YsTEy: T;

    /**
     * @default 'All boards'
     */
    aRxRy: T;

    /**
     * @default 'No board by that name.'
     */
    iHdft: T;

    /**
     * @default 'You have the most boards you can make. Delete one to start another.'
     */
    Gvo3T: T;

    /**
     * @default 'Your partner saved this'
     */
    '0RXHA': T;

    /**
     * @default 'Create Board'
     */
    uDXJw: T;

    /**
     * @default 'Board name'
     */
    rlMJQ: T;

    /**
     * @default 'Create'
     */
    IERgp: T;

    /**
     * @default 'Saved to {{0}}'
     */
    O80qq: T;

    /**
     * @default 'Removed from {{0}}'
     */
    wVgan: T;

    /**
     * @default 'On your board'
     */
    GvlX3: T;

    /**
     * @default 'Off your board'
     */
    SytKW: T;

    /**
     * @default 'View Board'
     */
    '1RKpD': T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Our honeymoon'
     */
    OCQ7O: T;

    /**
     * @default 'This image is too large to upload. Please try a smaller photo.'
     */
    o4dUm: T;

    /**
     * @default 'We couldn't upload your photo. Please try again.'
     */
    lTgyO: T;

    /**
     * @default 'Photo upload is temporarily unavailable. Please refresh the page and try again.'
     */
    SxLml: T;

    /**
     * @default 'Message from {{0}}'
     */
    ZASjR: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;

    /**
     * @default 'Unverified'
     */
    Bg8qF: T;

    /**
     * @default 'Invite another admin…'
     */
    JN0ag: T;

    /**
     * @default 'This admin's email isn't verified — the test may not be delivered.'
     */
    oeinj: T;

    /**
     * @default 'Valentine's Day'
     */
    cNdNV: T;

    /**
     * @default 'Why is this unavailable?'
     */
    pNEsD: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'QR code for this link'
     */
    PeQli: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Our Pick'
     */
    Fg6wn: T;

    /**
     * @default 'We're staying here'
     */
    '1uRUs': T;

    /**
     * @default 'Room block'
     */
    AuH5j: T;

    /**
     * @default '{{0}} room'
     */
    DlT1E: T;

    /**
     * @default '{{0}} rooms'
     */
    gaXtl: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default 'San Francisco, CA'
     */
    iOTJK: T;

    /**
     * @default 'Start typing to see options'
     */
    lwIoN: T;

    /**
     * @default 'Hide actions'
     */
    lLN1n: T;

    /**
     * @default 'Show actions'
     */
    G4rSY: T;

    /**
     * @default 'Actions revealed'
     */
    laEjF: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Pick a time at least {{0}} minutes from now.'
     */
    g2jG7: T;

    /**
     * @default 'Pick a date within the next year.'
     */
    '4ChIg': T;

    /**
     * @default 'Sorry, something went wrong'
     */
    kkwz0: T;

    /**
     * @default 'Rescheduled for {{0}}'
     */
    TI5PA: T;

    /**
     * @default 'Scheduled for {{0}}'
     */
    IqZad: T;

    /**
     * @default 'This message is already being sent.'
     */
    MEZgA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Manage'
     */
    JaHpE: T;

    /**
     * @default 'Track'
     */
    jJnBH: T;
  };
};

export type ShareDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type SharedRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  shoppingCart: {
    /**
     * @default 'eCard Fee'
     */
    eCardFee: T;

    /**
     * @default 'Cart'
     */
    cartTitle: T;

    /**
     * @default 'Purchase History'
     */
    purchaseHistoryTitle: T;

    /**
     * @default 'Estimated Total: '
     */
    estimatedTotal: T;

    /**
     * @default '{{count}} Gift'
     */
    cartGiftCount: T;

    /**
     * @default '{{count}} Gifts'
     */
    cartGiftCounts: T;

    /**
     * @default 'Quantity: {{quantity}} x {{price}}'
     */
    quantity: T;

    /**
     * @default 'Order #: {{orderNumber}}'
     */
    orderNumber: T;

    /**
     * @default 'Tracking #: {{trackingNumber}}'
     */
    trackingNumber: T;

    /**
     * @default 'Didn't purchase this item?'
     */
    didntPurchase: T;

    /**
     * @default 'Continue to Purchase'
     */
    continuePurchase: T;

    /**
     * @default 'Mark Purchased'
     */
    markPurchased: T;

    /**
     * @default 'Mark as Sent'
     */
    markAsSent: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Donate Online'
     */
    donationNow: T;

    /**
     * @default 'Send with {{type}}'
     */
    donationSendPlatform: T;

    /**
     * @default 'Send Payment'
     */
    donationSendPayment: T;

    /**
     * @default '🚫 Your gift reservation has been canceled. 🚫'
     */
    removeSuccess: T;

    /**
     * @default 'I did not mean to reserve this gift'
     */
    looking: T;

    /**
     * @default 'The item was not available'
     */
    available: T;

    /**
     * @default 'Changed my mind'
     */
    changed: T;

    /**
     * @default 'Could you tell us what happened?'
     */
    removeTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    removeItem: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default '🎉 This item has been marked as purchased. 🎉'
     */
    purchaseSuccess: T;

    /**
     * @default '🎁 We've moved this item back to your cart. 🎁'
     */
    reservedSuccess: T;

    /**
     * @default 'Your Cart is Empty'
     */
    cartEmptyTitle: T;

    /**
     * @default 'Send {{type}}'
     */
    donationPlatform: T;

    /**
     * @default 'Donate Online'
     */
    donateOnline: T;

    /**
     * @default '{{count}} View Your Gifts'
     */
    viewGifts: T;

    /**
     * @default 'Start Checkout'
     */
    viewGift: T;

    /**
     * @default '🎁 Item added to cart 🎁'
     */
    itemAddedSuccess: T;

    /**
     * @default 'How does this work?'
     */
    helpText: T;

    /**
     * @default 'Something went wrong, try again later'
     */
    errorMessage: T;

    /**
     * @default 'View Order Details'
     */
    viewOrderDetails: T;

    /**
     * @default 'This gift is no longer available'
     */
    hideWarningTitle: T;

    /**
     * @default 'It has been removed from the registry. Please select another gift to give {{host}} instead.'
     */
    hideWarning: T;

    /**
     * @default 'Gift Message'
     */
    giftMessage: T;

    /**
     * @default 'Edit'
     */
    editGiftNote: T;

    /**
     * @default 'Leave a note for the recipient.'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Save'
     */
    saveNote: T;

    /**
     * @default 'Add Gift Message'
     */
    addGiftNote: T;

    /**
     * @default 'Your gift note is set to go!'
     */
    messageUpdateSuccess: T;

    /**
     * @default 'Hmmm we had trouble updating your message.'
     */
    messageUpdateError: T;

    /**
     * @default 'Subtotal'
     */
    subtotal: T;

    /**
     * @default 'Total'
     */
    total: T;

    /**
     * @default 'Delivery'
     */
    delivery: T;

    /**
     * @default 'Sales tax'
     */
    salesTax: T;

    /**
     * @default 'FREE'
     */
    freeDeliveryPriceText: T;

    /**
     * @default 'Personalized eCard'
     */
    eCard: T;

    /**
     * @default 'Amount pending'
     */
    pendingSalesTaxPriceText: T;

    /**
     * @default 'Item'
     */
    item: T;

    /**
     * @default 'Items'
     */
    items: T;

    /**
     * @default 'Ordered'
     */
    ordered: T;

    /**
     * @default 'Paid via {{card}} {{cardLastDigits}}'
     */
    paidNote: T;

    /**
     * @default 'Check Out'
     */
    checkout: T;

    /**
     * @default 'No items are in your cart... yet!'
     */
    cartEmptyMessage: T;

    /**
     * @default 'Cart'
     */
    cart: T;

    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Details'
     */
    details: T;

    /**
     * @default 'Payment'
     */
    payment: T;

    /**
     * @default 'Order Summary'
     */
    orderSummary: T;

    /**
     * @default 'Close Order Summary'
     */
    closeOrderSummary: T;

    /**
     * @default 'Have you completed your purchase of {{productName}}?'
     */
    completePurchaseConfirmation: T;

    /**
     * @default 'Let us know'
     */
    completePurchaseConfirmationAction: T;

    /**
     * @default 'Out of Stock'
     */
    outOfStock: T;

    /**
     * @default 'Unavailable'
     */
    isNotPurchasableButton: T;

    metadataAtoms: {
      /**
       * @default 'Gift Message'
       */
      giftMessage: T;

      /**
       * @default 'Order Number'
       */
      orderNumber: T;

      /**
       * @default 'Shipping to'
       */
      shippingTo: T;

      /**
       * @default 'Tracking'
       */
      tracking: T;

      /**
       * @default 'Leave a note for the recipient.'
       */
      leaveNoteForCouple: T;

      /**
       * @default 'Save Gift Message'
       */
      saveGiftNoteButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;
    };
    addressAtoms: {
      /**
       * @default 'We're missing the recipient's address'
       */
      missingCoupleAddress: T;

      /**
       * @default 'Please contact the recipient or ship to yourself.'
       */
      contactTheCouple: T;
    };

    /**
     * @default 'Edit Gift Message'
     */
    editGiftMessage: T;

    /**
     * @default 'Buy Now'
     */
    buyNow: T;

    /**
     * @default 'Give Now'
     */
    giveNow: T;

    /**
     * @default 'I Already Purchased'
     */
    alreadyPurchased: T;

    /**
     * @default 'I Already Gave'
     */
    alreadyGave: T;

    /**
     * @default 'Did you purchase this?'
     */
    isPurchased: T;

    /**
     * @default 'Purchased from Joy'
     */
    purchasedFromJoy: T;

    /**
     * @default 'Purchased Elsewhere'
     */
    purchasedElsewhere: T;

    /**
     * @default '{{shippingMethod}} to {{addressName}}'
     */
    cartFooterAddressText: T;

    /**
     * @default 'Modify'
     */
    modifyButton: T;

    /**
     * @default 'Check Out'
     */
    checkOutButton: T;

    /**
     * @default 'Continue to Details'
     */
    continueToDetailsButton: T;

    /**
     * @default 'Continue to Payment'
     */
    continueToPaymentButton: T;

    /**
     * @default 'Continue to Message'
     */
    continueToMessageButton: T;

    uneditedMessageWarning: {
      /**
       * @default 'Unedited Message'
       */
      title: T;

      /**
       * @default 'Are you sure you want to continue without editing the gift message?'
       */
      message: T;

      /**
       * @default 'Back'
       */
      back: T;

      /**
       * @default 'Yes, continue'
       */
      continue: T;
    };
    steps: {
      /**
       * @default 'Cart'
       */
      cart: T;

      /**
       * @default 'Shipping'
       */
      shipping: T;

      /**
       * @default 'Details'
       */
      details: T;

      /**
       * @default 'Message'
       */
      message: T;

      /**
       * @default 'Payment'
       */
      payment: T;
    };
    cartStep: {
      /**
       * @default 'History'
       */
      historyTitle: T;

      /**
       * @default 'Cart'
       */
      cartTitle: T;

      /**
       * @default 'Where are we shipping?'
       */
      addressTitle: T;
    };
    shippingAddressStep: {
      /**
       * @default 'Where are we shipping?'
       */
      'whereAreWeShipping?': T;

      addressForm: {
        /**
         * @default 'Name*'
         */
        nameLabel: T;

        /**
         * @default 'Only one recipient name is recommended'
         */
        nameCaption: T;

        /**
         * @default 'Email*'
         */
        emailLabel: T;

        /**
         * @default 'Address Line 1*'
         */
        addressLine1Label: T;

        /**
         * @default 'Only Non-P.O. Box addresses in the United States'
         */
        addressLine1Caption: T;

        /**
         * @default 'Address Line 2'
         */
        addressLine2Label: T;

        /**
         * @default 'City*'
         */
        cityLabel: T;

        /**
         * @default 'State*'
         */
        stateLabel: T;

        /**
         * @default 'Zip/Postal Code*'
         */
        postalCodeLabel: T;

        /**
         * @default '*Required fields'
         */
        requiredFields: T;

        /**
         * @default 'Save Shipping Address'
         */
        saveButton: T;

        /**
         * @default 'Continue to Checkout'
         */
        saveButtonBilling: T;

        /**
         * @default 'Cancel'
         */
        cancelButton: T;

        /**
         * @default 'Edit Shipping Address'
         */
        editButton: T;
      };

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      /**
       * @default 'Shipping'
       */
      shipping: T;

      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Another U.S. Address'
       */
      anotherAddress: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      onlyUSAddress: T;

      /**
       * @default 'Ship to a different address'
       */
      shipToMe: T;

      /**
       * @default 'We'll tell the recipient about the purchase.'
       */
      weWillTellAboutPurchase: T;
    };
    detailsStep: {
      /**
       * @default 'Shipping Address'
       */
      shippingAddress: T;

      /**
       * @default 'Edit'
       */
      editShippingAddress: T;

      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      detailsForm: {
        /**
         * @default 'Your Email'
         */
        emailLabel: T;

        /**
         * @default 'Email address'
         */
        emailPlaceholder: T;

        /**
         * @default 'Please enter a valid email'
         */
        validEmailError: T;

        /**
         * @default 'Your Name(s)'
         */
        nameLabel: T;

        /**
         * @default 'Full name or recipient name'
         */
        namePlaceholder: T;

        /**
         * @default 'Gift Message (Optional)'
         */
        messageLabel: T;

        /**
         * @default 'Add an optional note'
         */
        messagePlaceholder: T;
      };
    };
    messageStep: {
      /**
       * @default 'Include a Message (Optional)'
       */
      title: T;

      /**
       * @default 'Personalized eCard'
       */
      wrapTitle: T;

      /**
       * @default 'Wrap your gift note in a beautiful design.'
       */
      wrapDescription: T;

      /**
       * @default 'Basic Gift Note'
       */
      noteTitle: T;

      /**
       * @default 'Gift Note'
       */
      textareaLabel: T;

      /**
       * @default 'Add a note to the couple (optional)'
       */
      textAreaPlaceholder: T;

      /**
       * @default '[Your Name]'
       */
      giverNamePlaceholder: T;
    };
    paymentStep: {
      /**
       * @default 'Some items in your cart have already been purchased. Please check and try again'
       */
      notNeededErrorText: T;

      /**
       * @default 'Oops, that didn't work.'
       */
      checkoutErrorTitle: T;

      /**
       * @default 'We're sorry, but there was an error while processing your order. Please try again later or contact our support team at support@withjoy.com for assistance. Thank you for your patience.'
       */
      checkoutErrorText: T;

      /**
       * @default 'Back'
       */
      checkoutErrorAction: T;

      /**
       * @default 'We're sorry, but there seems to be an issue with your address. Please double-check the address in your account settings to ensure everything is correct. If you need further assistance, feel free to reach out to our support team at support@withjoy.com'
       */
      badAddress: T;

      /**
       * @default 'It looks like your transaction is still being verified. Check back soon and thank you for your patience.'
       */
      registryError: T;

      /**
       * @default 'We're sorry, but the item you're looking for is currently out of stock. We're working to replenish our inventory, so please check back later or explore similar options.'
       */
      inventoryLow: T;
    };
  };
  shoppingCartHelp: {
    /**
     * @default 'How My Cart Works'
     */
    helpTitle: T;

    /**
     * @default 'Reserving Gifts'
     */
    reservingGifts: T;

    /**
     * @default 'When a gift is added to your cart, it is automatically reserved in your name and made unavailable for other gift givers to purchase. Reserved gifts appear at the top of your cart.'
     */
    reservingGiftsDescription: T;

    /**
     * @default 'Purchasing Gifts'
     */
    purchasingGifts: T;

    /**
     * @default 'To check out, just click Continue to Purchase and you can complete your purchase from the retailer that the recipient selected. Please note: Once you're done, be sure to come back here and mark that you have completed your purchase.'
     */
    purchasingGiftsDescription: T;

    /**
     * @default 'What does “mark as purchased” mean?'
     */
    markPurchased: T;

    /**
     * @default 'After you've purchased an item, please mark it as purchased so we can tell the recipient. This is important because it allows the recipient to thank you while also tracking still needed gifts. Purchased gifts appear at the bottom of your cart.'
     */
    markPurchasedDescription: T;

    /**
     * @default 'Where are my past purchases?'
     */
    pastPurchases: T;

    /**
     * @default 'Because Joy doesn't require gift givers to create an account, we use a cookie to track your past purchases. If you need to modify a purchased item that you don't see in your cart, just click on the item you purchased in the registry and enter the email address you used. You'll receive a special link to see your purchase history again.'
     */
    pastPurchasesDescription: T;

    /**
     * @default 'Cancelling Reservations'
     */
    cancelling: T;

    /**
     * @default 'Changed your mind? Please cancel your reservation so other gift givers can purchase the gift.'
     */
    cancellingDescription: T;

    /**
     * @default 'Still need help?'
     */
    stillHelp: T;

    /**
     * @default 'Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Return Policy'
     */
    returnPolicy: T;
  };
  pageNote: {
    /**
     * @default 'Welcome Note'
     */
    title: T;

    /**
     * @default 'Add a personal message to the top of your registry page for your guests.'
     */
    subtitle: T;

    /**
     * @default 'Note to Guests'
     */
    inputPlaceholder: T;

    /**
     * @default 'of 2000 Max Characters'
     */
    maxCharacters: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save Note'
     */
    save: T;

    /**
     * @default 'Your presence is enough of a present to us! But for those of you who are stubborn, we've put together a wish-list to help you out, including two charities that are near and dear to our hearts.'
     */
    defaultNote: T;
  };
  giftDialog: {
    /**
     * @default 'Add Gift'
     */
    addGiftTitle: T;

    /**
     * @default 'Edit Gift'
     */
    editGiftTitle: T;

    /**
     * @default 'Link'
     */
    linkField: T;

    /**
     * @default 'Title'
     */
    titleField: T;

    /**
     * @default 'Price'
     */
    priceField: T;

    /**
     * @default 'Quantity'
     */
    qtyField: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteField: T;

    /**
     * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
     */
    noteFieldPlaceholder: T;

    /**
     * @default 'Upload your own photo or search for photos on Unsplash.'
     */
    photoField: T;

    /**
     * @default 'Add Gift'
     */
    addGiftButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Delete'
     */
    deleteButton: T;

    /**
     * @default 'Save Gift'
     */
    saveGiftButton: T;

    /**
     * @default 'Invalid Link'
     */
    linkInvalid: T;

    /**
     * @default 'Missing title'
     */
    missingTitle: T;

    /**
     * @default 'Gift Type'
     */
    giftTypeTitleTooltip: T;

    /**
     * @default 'Each gift type requires different information.'
     */
    giftTypeBodyTooltip: T;

    /**
     * @default 'Quantity must be greater than 0'
     */
    quantityMinError: T;

    /**
     * @default 'Change your registry currency'
     */
    changeCurrencyTitle: T;

    /**
     * @default 'You can change the currency for your entire registry <currencyLink/>.'
     */
    changeCurrencyBody: T;

    /**
     * @default 'here'
     */
    currencyLinkText: T;

    /**
     * @default 'Joy lets you add gifts from anywhere – just paste a link and enter your gift info.'
     */
    helpText: T;

    /**
     * @default 'Read More'
     */
    readMoreText: T;

    /**
     * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
     */
    receivedQuantityError: T;

    /**
     * @default 'View Product Details'
     */
    pdpLinkText: T;

    /**
     * @default 'MSRP'
     */
    msrpTitle: T;

    /**
     * @default 'We use the MSRP (manufacturer’s suggested retail price). Prices are subject to change based on retailer.'
     */
    msrpDescription: T;

    /**
     * @default 'Allow Group Gifting'
     */
    allowGroupGifting: T;

    /**
     * @default 'Gift givers will be able to contribute any amount.'
     */
    groupGiftingDescription: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;

    /**
     * @default 'Payment Settings'
     */
    paymentSettings: T;

    /**
     * @default 'Select how you would like guests to contribute.'
     */
    selectPaymentMethod: T;

    /**
     * @default 'By turning on group gifting, we will turn this gift into a cash fund and help you collect money towards this gift using PayPal, Venmo, or CashApp. You can use that money to purchase the gift. The gift will not automatically get bought and delivered when it is funded. Group gifting is only available for gifts over $350. '
     */
    groupGiftingTooltip: T;

    /**
     * @default 'For more details,'
     */
    moreDetails: T;

    /**
     * @default 'Group Gift'
     */
    groupGift: T;

    /**
     * @default 'Mark gift as…'
     */
    markGiftAs: T;

    /**
     * @default 'Our Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Let your guests know your must-have gifts!'
     */
    mostWantedDescription: T;

    /**
     * @default 'Sorry we were unable to retrieve that product, please enter your gift manually.'
     */
    autocompleteError: T;

    /**
     * @default 'MSRP Price ({{currency}})'
     */
    msrpLabel: T;

    /**
     * @default 'Select Purchase Options'
     */
    selectPurchaseOption: T;

    /**
     * @default 'Direct friends and family to the store's website'
     */
    selectPurchaseExternalTitle: T;

    /**
     * @default 'We'll share your address with your friends and family so they can buy and ship the gift themselves.'
     */
    selectPurchaseExternalDescription: T;

    /**
     * @default 'Get cash for my gift'
     */
    getCashEquivalentTitle: T;

    /**
     * @default 'Get cash equivalent for this gift; recommended for optimal guest experience.'
     */
    getCashEquivalentDescription: T;

    /**
     * @default '(U.S only)'
     */
    usOnly: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Make this a group gift'
     */
    makeGroupGift: T;

    /**
     * @default 'Gift givers will be able to contribute any amount.'
     */
    makeGroupGiftDescription: T;
  };
  cashFundDialog: {
    wedding: {
      /**
       * @default 'Cash Fund Name'
       */
      nameLabel: T;

      /**
       * @default 'Cash/Check'
       */
      cashOrCheckText: T;

      /**
       * @default 'Please enter a gift name.'
       */
      nameEmptyError: T;

      /**
       * @default 'Next'
       */
      nextButton: T;

      /**
       * @default 'Gift Size'
       */
      amountLabel: T;

      /**
       * @default 'Gift size required.'
       */
      amountRequiredError: T;

      /**
       * @default 'Quantity'
       */
      quantityLabel: T;

      /**
       * @default 'Minimum of 1 required.'
       */
      quantityRequiredError: T;

      /**
       * @default 'Please use whole numbers'
       */
      quantityIntegerError: T;

      /**
       * @default 'Total Goal'
       */
      totalGoalLabel: T;

      /**
       * @default 'Payment Method'
       */
      paymentMethodText: T;

      /**
       * @default 'App Payment'
       */
      appPayment: T;

      /**
       * @default 'Venmo, Cash App, or PayPal'
       */
      appPaymentDescription: T;

      /**
       * @default 'Zero fees. Note that app payments are not automatically tracked by Joy.'
       */
      appPaymentNote: T;

      /**
       * @default 'Credit or Debit Card'
       */
      creditCardOption: T;

      /**
       * @default 'Easiest for your guests.'
       */
      creditCardOptionDescription: T;

      /**
       * @default 'No pesky redirects. Automatic tracking. Transaction fees apply. US only.'
       */
      creditCardOptionNote: T;

      /**
       * @default 'Fast Checkout with'
       */
      fastCheckoutWith: T;

      /**
       * @default 'RECOMMENDED'
       */
      recommended: T;

      /**
       * @default 'Connect Bank Account'
       */
      connectBankAccount: T;

      /**
       * @default '(U.S. only)'
       */
      usOnly: T;

      /**
       * @default 'Continue'
       */
      continueText: T;

      /**
       * @default 'Credit Card'
       */
      enableJoyCreditText: T;

      /**
       * @default 'Guests Contribution Methods'
       */
      paymentSettingsText: T;

      /**
       * @default 'Cash or Check'
       */
      enableCashOrCheckText: T;

      /**
       * @default 'Given in-person or by mail.'
       */
      enableCashOrCheckDescription: T;

      /**
       * @default 'Use your favorite payment app to avoid extra fees.'
       */
      paymentMethodDescription: T;

      /**
       * @default 'Select Provider'
       */
      paymentMethodLabel: T;

      /**
       * @default 'No payment selected'
       */
      selectPaymentEmptyError: T;

      /**
       * @default 'Invalid username'
       */
      invalidUsernameError: T;

      /**
       * @default 'Your username should not be an e-mail address'
       */
      invalidUsernameIsEmailError: T;

      /**
       * @default 'Test payment link'
       */
      testPaymentLinkText: T;

      /**
       * @default 'Test link'
       */
      testLinkText: T;

      /**
       * @default 'Gift of'
       */
      giftOfText: T;

      /**
       * @default 'Gifts of'
       */
      giftsOfText: T;

      /**
       * @default 'Total'
       */
      totalText: T;

      /**
       * @default 'Note to Family and Friends'
       */
      descriptionLabel: T;

      /**
       * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
       */
      descriptionPlaceholder: T;

      /**
       * @default 'Add to Registry'
       */
      addtoRegistryButton: T;

      /**
       * @default 'has been added to your registry'
       */
      confirmationHeader: T;

      /**
       * @default 'Sounds like it’ll be rad!'
       */
      confirmationSubHeader: T;

      /**
       * @default 'Discard registry item?'
       */
      cancelHeader: T;

      /**
       * @default 'This gift won’t be added to your registry.'
       */
      cancelText: T;

      /**
       * @default 'Discard Item'
       */
      yesText: T;

      /**
       * @default 'Nevermind'
       */
      noText: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Max Chars'
       */
      maxCharacters: T;

      /**
       * @default 'Edit'
       */
      editText: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Delete'
       */
      deleteButton: T;

      cashFundNameSuggestions: [
        /**
         * @default 'Our Newlywed Fund'
         */
        T,
        /**
         * @default '🛣 Roadtrip!'
         */
        T,
        /**
         * @default '🚙 Family Car Fund'
         */
        T,
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default 'Our Honeymoon Fund'
         */
        T,
        /**
         * @default '🖼 Museum Membership'
         */
        T,
        /**
         * @default 'New Backpacking Gear'
         */
        T,
        /**
         * @default 'Couples Spa Day'
         */
        T,
        /**
         * @default '🍽 Future Kitchen Fund'
         */
        T,
        /**
         * @default '🏕 Camping Adventure'
         */
        T,
      ];

      /**
       * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
       */
      newQtyError: T;

      /**
       * @default 'The total goal cannot be less than the amount you’ve already received for this gift.'
       */
      newAmountError: T;

      /**
       * @default 'At least one guest has already sent a payment with your previous payment method. Don’t forget!'
       */
      newPaymentMethodWarning: T;

      /**
       * @default 'Charity Fund Name'
       */
      nameLabelCharity: T;

      /**
       * @default 'Donation Method'
       */
      donationMethodText: T;

      /**
       * @default 'Link to Charity'
       */
      donationMethodOptionOneText: T;

      /**
       * @default 'Collect Myself'
       */
      donationMethodOptionTwoText: T;

      /**
       * @default 'Charity Link'
       */
      charityLinkLabel: T;

      /**
       * @default 'ourcharity.org/donate'
       */
      charityLinkPlaceholder: T;

      /**
       * @default 'Invalid link'
       */
      charityLinkInvalidError: T;

      /**
       * @default 'Charity Link Required'
       */
      charityLinkRequiredError: T;

      /**
       * @default 'Use your favorite payment app to collect and donate later.'
       */
      charityPaymentDescription: T;

      charityFundNameSuggestions: [
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default '🐶 ASPCA'
         */
        T,
        /**
         * @default '✨ Make-A-Wish Foundation'
         */
        T,
        /**
         * @default 'World Wildlife Fund'
         */
        T,
        /**
         * @default 'Leukemia & Lymphoma Society'
         */
        T,
        /**
         * @default 'American Cancer Society'
         */
        T,
        /**
         * @default 'Special Olympics'
         */
        T,
        /**
         * @default 'UNICEF'
         */
        T,
        /**
         * @default 'Habitat for Humanity'
         */
        T,
        /**
         * @default 'United Way Worldwide'
         */
        T,
      ];

      /**
       * @default 'Allow Gifts In'
       */
      goalStepLabel: T;

      /**
       * @default 'Any Amount'
       */
      anyAmountText: T;

      /**
       * @default 'Fixed Amount'
       */
      fixedAmountText: T;

      /**
       * @default 'Hide goal from guests'
       */
      hideGoalLabel: T;

      /**
       * @default 'No goal? Just leave it blank.'
       */
      noGoalCaption: T;

      /**
       * @default 'No Goal'
       */
      noGoalText: T;

      /**
       * @default 'Select at least one payment method'
       */
      errorValidation: T;

      /**
       * @default 'Turn on credit card payments to give your guests more flexibility.'
       */
      proTipTitle: T;

      /**
       * @default 'Some guests are less familiar with payment apps and get confused or even forget to complete payment. We recommend allowing gifts by credit card, just to be safe.'
       */
      proTipDescription: T;
    };
    babyRegistry: {
      /**
       * @default 'Name'
       */
      nameLabel: T;

      /**
       * @default 'Cash/Check'
       */
      cashOrCheckText: T;

      /**
       * @default 'Please enter a gift name.'
       */
      nameEmptyError: T;

      /**
       * @default 'Next'
       */
      nextButton: T;

      /**
       * @default 'Gift Size'
       */
      amountLabel: T;

      /**
       * @default 'Gift size required.'
       */
      amountRequiredError: T;

      /**
       * @default 'Quantity'
       */
      quantityLabel: T;

      /**
       * @default 'Minimum of 1 required.'
       */
      quantityRequiredError: T;

      /**
       * @default 'Please use whole numbers'
       */
      quantityIntegerError: T;

      /**
       * @default 'Total Goal'
       */
      totalGoalLabel: T;

      /**
       * @default 'Payment Method'
       */
      paymentMethodText: T;

      /**
       * @default 'App Payment'
       */
      appPayment: T;

      /**
       * @default 'Venmo, Cash App, or PayPal'
       */
      appPaymentDescription: T;

      /**
       * @default 'Zero fees. Please note that app payments are not automatically tracked by Joy.'
       */
      appPaymentNote: T;

      /**
       * @default 'Credit or Debit Card'
       */
      creditCardOption: T;

      /**
       * @default 'Easiest for your guests.'
       */
      creditCardOptionDescription: T;

      /**
       * @default 'No pesky redirects. Automatic tracking. Transaction fees apply. US only.'
       */
      creditCardOptionNote: T;

      /**
       * @default 'Fast Checkout with'
       */
      fastCheckoutWith: T;

      /**
       * @default 'RECOMMENDED'
       */
      recommended: T;

      /**
       * @default 'Connect Bank Account'
       */
      connectBankAccount: T;

      /**
       * @default '(U.S. only)'
       */
      usOnly: T;

      /**
       * @default 'Continue'
       */
      continueText: T;

      /**
       * @default 'Credit Card'
       */
      enableJoyCreditText: T;

      /**
       * @default 'Guests Contribution Methods'
       */
      paymentSettingsText: T;

      /**
       * @default 'Cash or Check'
       */
      enableCashOrCheckText: T;

      /**
       * @default 'Given in-person or by mail.'
       */
      enableCashOrCheckDescription: T;

      /**
       * @default 'Use your favorite payment app to avoid extra fees.'
       */
      paymentMethodDescription: T;

      /**
       * @default 'Select Provider'
       */
      paymentMethodLabel: T;

      /**
       * @default 'No payment selected'
       */
      selectPaymentEmptyError: T;

      /**
       * @default 'Invalid username'
       */
      invalidUsernameError: T;

      /**
       * @default 'Your username should not be an e-mail address'
       */
      invalidUsernameIsEmailError: T;

      /**
       * @default 'Test payment link'
       */
      testPaymentLinkText: T;

      /**
       * @default 'Test link'
       */
      testLinkText: T;

      /**
       * @default 'Gift of'
       */
      giftOfText: T;

      /**
       * @default 'Gifts of'
       */
      giftsOfText: T;

      /**
       * @default 'Total'
       */
      totalText: T;

      /**
       * @default 'Note to Family and Friends'
       */
      descriptionLabel: T;

      /**
       * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
       */
      descriptionPlaceholder: T;

      /**
       * @default 'Add to Registry'
       */
      addtoRegistryButton: T;

      /**
       * @default 'has been added to your registry'
       */
      confirmationHeader: T;

      /**
       * @default 'Sounds like it’ll be rad!'
       */
      confirmationSubHeader: T;

      /**
       * @default 'Discard registry item?'
       */
      cancelHeader: T;

      /**
       * @default 'This gift won’t be added to your registry.'
       */
      cancelText: T;

      /**
       * @default 'Discard Item'
       */
      yesText: T;

      /**
       * @default 'Nevermind'
       */
      noText: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Max Chars'
       */
      maxCharacters: T;

      /**
       * @default 'Edit'
       */
      editText: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Delete'
       */
      deleteButton: T;

      cashFundNameSuggestions: [
        /**
         * @default 'Diaper Fund'
         */
        T,
        /**
         * @default 'College Fund'
         */
        T,
        /**
         * @default 'Babymoon'
         */
        T,
        /**
         * @default 'Doula Fund'
         */
        T,
        /**
         * @default 'Meal Fund'
         */
        T,
        /**
         * @default 'Parental Leave Fund'
         */
        T,
        /**
         * @default 'Childcare Fund'
         */
        T,
        /**
         * @default 'Adoption Fund'
         */
        T,
      ];

      /**
       * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
       */
      newQtyError: T;

      /**
       * @default 'The total goal cannot be less than the amount you’ve already received for this gift.'
       */
      newAmountError: T;

      /**
       * @default 'At least one guest has already sent a payment with your previous payment method. Don’t forget!'
       */
      newPaymentMethodWarning: T;

      /**
       * @default 'Charity Fund Name'
       */
      nameLabelCharity: T;

      /**
       * @default 'Donation Method'
       */
      donationMethodText: T;

      /**
       * @default 'Link to Charity'
       */
      donationMethodOptionOneText: T;

      /**
       * @default 'Collect Myself'
       */
      donationMethodOptionTwoText: T;

      /**
       * @default 'Charity Link'
       */
      charityLinkLabel: T;

      /**
       * @default 'ourcharity.org/donate'
       */
      charityLinkPlaceholder: T;

      /**
       * @default 'Invalid link'
       */
      charityLinkInvalidError: T;

      /**
       * @default 'Charity Link Required'
       */
      charityLinkRequiredError: T;

      /**
       * @default 'Use your favorite payment app to collect and donate later.'
       */
      charityPaymentDescription: T;

      charityFundNameSuggestions: [
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default '🐶 ASPCA'
         */
        T,
        /**
         * @default '✨ Make-A-Wish Foundation'
         */
        T,
        /**
         * @default 'World Wildlife Fund'
         */
        T,
        /**
         * @default 'Leukemia & Lymphoma Society'
         */
        T,
        /**
         * @default 'American Cancer Society'
         */
        T,
        /**
         * @default 'Special Olympics'
         */
        T,
        /**
         * @default 'UNICEF'
         */
        T,
        /**
         * @default 'Habitat for Humanity'
         */
        T,
        /**
         * @default 'United Way Worldwide'
         */
        T,
      ];

      /**
       * @default 'Allow Gifts In'
       */
      goalStepLabel: T;

      /**
       * @default 'Any Amount'
       */
      anyAmountText: T;

      /**
       * @default 'Fixed Amount'
       */
      fixedAmountText: T;

      /**
       * @default 'Hide goal from gift givers'
       */
      hideGoalLabel: T;

      /**
       * @default 'No goal? Just leave it blank.'
       */
      noGoalCaption: T;

      /**
       * @default 'No Goal'
       */
      noGoalText: T;

      /**
       * @default 'Select at least one payment method'
       */
      errorValidation: T;

      /**
       * @default 'Turn on credit card payments to give your guests more flexibility.'
       */
      proTipTitle: T;

      /**
       * @default 'Some guests are less familiar with payment apps and get confused or even forget to complete payment. We recommend allowing gifts by credit card, just to be safe.'
       */
      proTipDescription: T;
    };
  };
  creditCardSetUpDialog: {
    /**
     * @default 'Connect Your Bank Account'
     */
    joyWalletTitle: T;

    /**
     * @default 'Allow your guests to give you cash with their credit or debit cards by connecting your bank account.'
     */
    joyWalletDescription: T;

    /**
     * @default 'Congrats! You can now enable cash-gift options for external items and cash funds for guests wanting to use a credit card. Purchases and contributions through Stripe will be available as soon as tomorrow. Have questions? Feel free to contact us at support@withjoy.com'
     */
    successJoyWalletDescription: T;

    /**
     * @default 'Your guests can now send you cash with a credit card! See your contributions and transfer cash to your bank or debit card using Stripe.'
     */
    description: T;

    /**
     * @default 'Set Up Credit Card for Cash Funds'
     */
    title: T;

    /**
     * @default 'Here’s what you need to get started:'
     */
    subtitle: T;

    /**
     * @default 'Email & phone number'
     */
    recipient: T;

    /**
     * @default 'Need Assistance?'
     */
    needAssistance: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'U.S. home address'
     */
    address: T;

    /**
     * @default 'First and last name'
     */
    legalName: T;

    /**
     * @default 'U.S. bank account or debit card'
     */
    bank: T;

    /**
     * @default 'Let’s Get Started'
     */
    letsGo: T;

    /**
     * @default 'Accept All Major Credit Payments'
     */
    footerText: T;

    /**
     * @default 'Approval is taking longer than expected'
     */
    takingLong: T;

    /**
     * @default 'Stripe needs more information'
     */
    stripeIssue: T;

    /**
     * @default 'Check Stripe Status'
     */
    checkStripeStatus: T;

    /**
     * @default 'Resolve Stripe Issue'
     */
    resolveStripeStatus: T;

    /**
     * @default 'Your account is being reviewed'
     */
    inReview: T;

    /**
     * @default 'This will only take a minute'
     */
    inReviewDuration: T;

    /**
     * @default 'You are an editor but not the owner of this event. Only the account owner can connect a bank account.'
     */
    onlyForOwners: T;

    /**
     * @default 'You need a valid U.S address. '
     */
    onlyForUS: T;

    /**
     * @default 'Add Address'
     */
    addAddress: T;

    /**
     * @default 'Continue'
     */
    continueText: T;

    /**
     * @default 'Stripe Connect Policy'
     */
    stripeConnect: T;

    /**
     * @default 'Transaction fees apply and are subject to change.'
     */
    stripeDisclaimer: T;

    /**
     * @default 'Your Stripe Account has been Approved!'
     */
    stripeApprovedTitle: T;

    /**
     * @default 'Congrats! You can now add credit cards as a payment option for your new and existing cash funds. Guests can start contributing as soon as tomorrow. You still have the option of adding alternative contribution methods like cash, check, or mobile app payment.'
     */
    stripeApprovedDescription: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'I’ll Do This Later'
     */
    doLater: T;

    /**
     * @default 'Accept Cash Fund Credit Card Contributions'
     */
    widgetTitle: T;

    /**
     * @default 'Your guests can now send you cash with a credit card!'
     */
    widgetDescription: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Credit Card Contributions'
     */
    creditCardContributions: T;

    /**
     * @default 'Current Balance'
     */
    currentBalance: T;

    /**
     * @default 'Transfer Balance'
     */
    transferBalance: T;

    /**
     * @default 'Your available balance is updated as contributions are processed and ready to transfer. This can sometimes take 1-3 business days, but is usually instant.'
     */
    balanceTooltip: T;

    /**
     * @default 'Account'
     */
    account: T;

    /**
     * @default 'Connect Bank Account'
     */
    connectBankAccount: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;
  };
  creditCardWidgetV2: {
    /**
     * @default 'Manage'
     */
    manage: T;

    /**
     * @default 'Transfer to Bank'
     */
    transferToBank: T;

    /**
     * @default 'Joy Wallet'
     */
    joyWallet: T;

    /**
     * @default 'Cash for Gifts'
     */
    cashForGiftsText: T;

    /**
     * @default 'Credit Card Cash Funds'
     */
    cashFundsText: T;

    /**
     * @default 'Total Balance'
     */
    totalBalance: T;

    /**
     * @default 'Why is this different from my available balance?'
     */
    whyText: T;

    /**
     * @default 'You can now receive cash via:'
     */
    footerText: T;

    /**
     * @default 'credit card platforms allowed'
     */
    footerImageAlt: T;

    /**
     * @default 'Available balance sometimes takes 1-3 business days to reflect recent transactions, but is usually instant.'
     */
    balanceTooltip: T;

    /**
     * @default 'Available Balance'
     */
    availableBalance: T;

    /**
     * @default 'Connect Your Bank Account'
     */
    creditCardSetupTitle: T;

    /**
     * @default 'Allow guests to give with credit and debit cards.'
     */
    creditCardSetupDescription: T;

    /**
     * @default 'Approval pending...'
     */
    approvalPending: T;

    /**
     * @default 'More information needed.'
     */
    needMoreInfo: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Need Assistance?'
     */
    needAssistance: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'You’ll be able to accept payments from:'
     */
    alternativeFooterText: T;

    /**
     * @default 'Cash Received'
     */
    cashReceived: T;

    /**
     * @default 'Pending Transactions'
     */
    pendingTransactions: T;

    /**
     * @default 'These funds will be available soon'
     */
    pendingTransactionsHint: T;

    /**
     * @default 'Pending Withdrawals'
     */
    pendingWithdrawals: T;

    /**
     * @default 'These funds will be transferred to your bank soon'
     */
    pendingWithdrawalsHint: T;

    /**
     * @default 'Previously Withdrawn'
     */
    previouslyWithdrawn: T;

    /**
     * @default 'Total funds transferred to your bank'
     */
    previouslyWithdrawnHint: T;

    /**
     * @default 'Lifetime Received'
     */
    lifetimeReceived: T;

    /**
     * @default 'Total funds you've received with Joy'
     */
    lifetimeReceivedHint: T;

    /**
     * @default 'Transfer processing...'
     */
    transferProcessing: T;

    /**
     * @default 'Done'
     */
    transferDone: T;

    /**
     * @default 'We couldn't complete one of your transfers. Please contact support.'
     */
    transferError: T;

    /**
     * @default 'Amounts shown include cash collected from registry funds and private funds via Stripe.'
     */
    description: T;
  };
  cashFundDisclaimerDialog: {
    /**
     * @default 'Regarding {paymentMethod} Payments'
     */
    title: T;

    warning: {
      /**
       * @default 'Joy does not perform {paymentMethod} transactions for your guests. Guests will have to leave your registry and go to the payment app to send you money.'
       */
      main: T;

      /**
       * @default 'Venmo, Cash App, and PayPal often do not take responsibility in mistaken transactions, meaning you may be left at the mercy of the unintended recipient to return the money. This can create a messy and possibly unresolvable situation where you have to ask your guests to contact the unintended recipient to recover the funds.'
       */
      additional: T;
    };
    paymentAccount: {
      /**
       * @default 'Verify your payment account:'
       */
      label: T;

      /**
       * @default 'Please verify that your handle is correct by sending yourself money after clicking "Send Test Payment."'
       */
      test_warning: T;

      /**
       * @default 'Learn more about testing your account.'
       */
      learn_more: T;

      /**
       * @default 'Send Test Payment'
       */
      send_test_payment: T;
    };
    accordion: {
      howItWorks: {
        /**
         * @default 'How will payment apps work for my guests?'
         */
        title: T;

        /**
     * @default '1. Guests will enter the amount they intend to give you, and provide their name and email. This will "reserve" their gift.

2. Guests will then be redirected to sign in to the third-party app or website from your registry. If guests have an account and they can sign in, they then need to send you money.

3. If guests remember to come back to your registry, they'll be asked to confirm they sent payment. If they don't, Joy will follow up via email (you can also send reminders with Joy).'
*/
        content: T;
      };
      whatToKnow: {
        /**
         * @default 'What you need to know before proceeding'
         */
        title: T;

        /**
     * @default '1. Payment apps can be confusing if they're unfamiliar with the app.

2. If they don't have an account, they can get stuck. If they do have an account, they may have to remember their account details to sign in.

3. Some guests think they sent money when they didn't, while other guests simply forget to complete payment.'
*/
        content: T;
      };
      wrongAccount: {
        /**
         * @default 'What happens if I enter the wrong account?'
         */
        title: T;

        /**
     * @default '1. If the account handle is incorrect, funds may be sent to the wrong person, and Joy cannot intervene in these transactions.

2. Venmo, Cash App, and PayPal do not take responsibility in mistaken transactions, meaning you may be left at the mercy of the unintended recipient to return the money. This can create a messy and possibly unresolvable situation where you have to ask your guests to contact the unintended recipient to recover the funds.

'
*/
        content: T;

        /**
         * @default 'Learn more about testing your account.'
         */
        learnMoreLink: T;
      };
    };
    checkboxes: {
      /**
       * @default 'I have tested and verified the link above is correct. I understand that Joy cannot assist if funds are sent to the wrong person.'
       */
      agreement: T;

      /**
       * @default 'I understand that Joy cannot track payments received by third party apps. Joy can only record that a guest says that they've paid. Third party apps are the only source of truth regarding such transactions.'
       */
      tracking: T;
    };
    buttons: {
      /**
       * @default 'Save Payment Method'
       */
      accept: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
  };
  addressReminder: {
    /**
     * @default 'Now let’s add your shipping address'
     */
    reminderTitleLow: T;

    /**
     * @default 'You’ve picked out some great gifts!'
     */
    reminderTitleModerateLine1: T;

    /**
     * @default 'But where should we send them?'
     */
    reminderTitleModerateLine2: T;

    /**
     * @default 'Where should we send this gift?'
     */
    reminderTitleSevere: T;

    /**
     * @default 'Avoid missing packages and awkward texts!'
     */
    reminderSubtitleLowModerateLine1: T;

    /**
     * @default 'We’ll make sure gift givers know where to send your gifts.'
     */
    reminderSubtitleLowModerateLine2: T;

    /**
     * @default 'Joy requires a shipping address for events happening'
     */
    reminderSubtitleSevereLine1: T;

    /**
     * @default 'within 60 days so your gifts can happily reach you!'
     */
    reminderSubtitleSevereLine2: T;

    /**
     * @default 'Add Shipping Address'
     */
    primaryButton: T;
  };
  publicShop: {
    /**
     * @default 'The All-in-One Registry'
     */
    heroContentHeader: T;

    /**
     * @default 'Shop Here, There, Everywhere.'
     */
    heroContentTitle: T;

    /**
     * @default 'Shop on Joy'
     */
    shopTitle: T;

    /**
     * @default 'Find the perfect gift.'
     */
    shopSubtitle: T;

    /**
     * @default 'Connect Any Registry'
     */
    connectTitle: T;

    /**
     * @default 'Everything in one place.'
     */
    connectSubtitle: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    noFeeTitle: T;

    /**
     * @default 'Yes, really. No fees.'
     */
    noFeeSubtitle: T;

    /**
     * @default 'Shop the Web'
     */
    shopWebTitle: T;

    /**
     * @default 'Add from anywhere.'
     */
    shopWebSubtitle: T;
  };
  departmentNavBar: {
    /**
     * @default 'View {{departmentName}}'
     */
    navItemTooltip: T;
  };
  contact: {
    /**
     * @default '← Please keep this link in the email to make it easier for us to answer your questions.'
     */
    contactSupportMessage: T;
  };
  catalogSearchInput: {
    /**
     * @default 'Search'
     */
    shortPlaceholder: T;

    /**
     * @default 'Search brands, products, and more'
     */
    catalogRoutePlaceholder: T;

    /**
     * @default 'Find new gifts for your Registry'
     */
    manageRoutePlaceholder: T;

    /**
     * @default 'Back to Dashboard'
     */
    homeIconTooltip: T;
  };
  registryNavigationMenu: {
    /**
     * @default 'Event Dashboard'
     */
    eventDashboard: T;

    /**
     * @default 'Dashboard'
     */
    dashboard: T;

    /**
     * @default 'Overview'
     */
    overview: T;

    /**
     * @default 'Shop'
     */
    shop: T;

    /**
     * @default 'Manage'
     */
    manage: T;

    /**
     * @default 'Track'
     */
    track: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'New'
     */
    newBadge: T;

    /**
     * @default 'Registry Settings'
     */
    registrySettings: T;
  };
  alreadyReservedWarning: {
    /**
     * @default 'It looks like you’ve already reserved this gift with this email address.'
     */
    title: T;

    /**
     * @default 'We’ve sent you an email with a link to your reservation so you can complete your purchase or cancel your reservation.'
     */
    text1: T;

    /**
     * @default 'Check your inbox at {{email}}'
     */
    text2: T;
  };
  externalOrderTracking: {
    /**
     * @default 'Order & Tracking Information'
     */
    externalTrackingInfoDialogTitle: T;

    /**
     * @default 'Don’t have tracking details? We can send a request to your guest for you. '
     */
    externalTrackingInfoDialogDetails: T;

    /**
     * @default 'This information was provided by {{guestName}}.'
     */
    informationProvided: T;

    /**
     * @default 'Request Order and Tracking Info'
     */
    requestOrderTracking: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Order Number (Required)'
     */
    orderID: T;

    /**
     * @default 'Tracking Number'
     */
    trackingNumber: T;

    /**
     * @default 'Need tracking info for your gift? We’ve  got you.'
     */
    requestTrackingInfoDialogTitle: T;

    /**
     * @default 'We’ll send a one-time email to your guest to request the Order ID, Tracking Number and Shipping Carrier for this gift. Once provided, the information will appear in your gift tracker.'
     */
    requestTrackingInfoDialogSubtitle: T;

    /**
     * @default 'Send Request'
     */
    sendRequest: T;

    /**
     * @default 'Sample Email:'
     */
    sampleEmail: T;

    /**
     * @default 'Please enter an order number'
     */
    orderNumberRequiredError: T;

    /**
     * @default 'Please enter an tracking number'
     */
    trackingRequiredError: T;

    /**
     * @default 'Please enter shipping carrier number'
     */
    shippingRequiredError: T;

    /**
     * @default 'Quantity : {{qty}}'
     */
    quantity: T;

    /**
     * @default 'Test Link'
     */
    testLink: T;

    /**
     * @default '✨ Tracking info has been added to {{orderTitle}} ✨ '
     */
    successMessage: T;
  };
  subCatHighlights: {
    /**
     * @default 'Learn More'
     */
    itemButtonLabel: T;
  };
  registryPromo: {
    /**
     * @default 'With guests on their way, now’s the time to fill out your registry!'
     */
    reminderTitle: T;

    /**
     * @default 'Continue Adding Gifts'
     */
    addGiftCtaLabel: T;

    /**
     * @default 'Do you have enough gifts in your registry?'
     */
    giftCountReminderTitle: T;

    /**
     * @default 'With guests on their way, now is the time to make sure your registry is ready.'
     */
    giftCountReminderSubTitle: T;

    /**
     * @default 'Maybe Later'
     */
    maybeLaterCta: T;
  };
  quick: {
    /**
     * @default 'Something went wrong, try again later'
     */
    Q2aER: T;

    /**
     * @default 'applied to {{0}} item'
     * @param {number} count - The number of occurrences.
     * - singular: applied to {{0}} item
     * - plural: applied to {{0}} items
     */
    PRG6K: T;

    /**
     * @default 'Bulk Item Surcharge'
     */
    VM3DW: T;

    /**
     * @default 'Add a price greater than 0'
     */
    iKNKd: T;

    /**
     * @default 'Photo upload failed. Please try again.'
     */
    ffkLv: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Manage Registry'
     */
    '2GYFM': T;

    /**
     * @default 'Track Gifts'
     */
    EXX2N: T;

    /**
     * @default 'Add Gifts'
     */
    '8lzdJ': T;

    /**
     * @default 'Registry navigation'
     */
    p6h2i: T;

    /**
     * @default 'Baby Registry'
     */
    BxWMO: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'You'll set a goal, payment options, and privacy next.'
     */
    uXptD: T;

    /**
     * @default 'Set a goal or keep it open'
     */
    JoBFL: T;

    /**
     * @default 'Card, express pay & more'
     */
    '7CbqU': T;

    /**
     * @default 'Control what guests see'
     */
    d8q8Q: T;

    /**
     * @default 'Supports multiple currencies'
     */
    '11VOi': T;

    /**
     * @default 'We couldn't switch your registry currency. Please try again.'
     */
    E3SpM: T;

    /**
     * @default 'Cash funds aren't available in your region yet.'
     */
    rybXf: T;

    /**
     * @default 'Not your currency? '
     */
    wV5AK: T;

    /**
     * @default 'Change currency setting'
     */
    zsTdH: T;

    /**
     * @default 'Payout method added!'
     */
    '6mkFU': T;

    /**
     * @default 'Your bank account (or debit card) is connected and ready to go. Click Transfer to Bank to start moving your funds.'
     */
    qEWJm: T;

    /**
     * @default 'Transfer to Bank →'
     */
    KS8YC: T;

    /**
     * @default 'credit card'
     */
    tCRBN: T;

    /**
     * @default 'Use a different currency'
     */
    YmnXO: T;

    /**
     * @default 'Your honeymoon cash fund has been created.'
     */
    '5BrcJ': T;

    /**
     * @default 'Your honeymoon starts here!'
     */
    VeKkR: T;

    /**
     * @default 'You've got a cash fund ready to go. Browse destinations, save favorites, and when you're ready to book — you'll get up to 30% off as a Joy member.'
     */
    EBXWV: T;

    /**
     * @default 'Start exploring destinations'
     */
    RpHw0: T;

    /**
     * @default 'Remind me later'
     */
    lkF5S: T;

    /**
     * @default 'Your gifts ship straight to {{0}}'
     */
    '9IxVC': T;

    /**
     * @default 'This gift ships straight to {{0}}'
     */
    Ip3KR: T;

    /**
     * @default 'One or more items in your cart have limited stock, so your order can only ship to them. Their street address stays private.'
     */
    GCh34: T;

    /**
     * @default 'It has limited stock, so it can only ship to them. Their street address stays private.'
     */
    '1a7Gr': T;

    /**
     * @default 'Price match promise'
     */
    hR6bB: T;

    /**
     * @default 'Found it cheaper at a major retailer? We'll match it. Regular price only, within 48 hrs.'
     */
    J9uCW: T;

    /**
     * @default 'See details'
     */
    v6yQm: T;

    /**
     * @default 'Where should gifts ship?'
     */
    IvuPN: T;

    /**
     * @default 'We need a US address before guests can send you gifts.'
     */
    pgcsG: T;

    /**
     * @default 'Set this up later'
     */
    '9eOFD': T;

    /**
     * @default 'Automatic tracking · Apple Pay, Google Pay'
     */
    AkKQy: T;

    /**
     * @default 'No pesky redirects. Automatic tracking. Transaction fees apply.'
     */
    BKZaE: T;

    /**
     * @default 'Your registry collects in {{0}}, but your payout account is in {{1}}. <0>Switch your registry to {{2}}</0> to accept cards. Guests will then see amounts in {{3}}.'
     */
    x6ylD: T;

    /**
     * @default 'Switch your registry to {{0}}'
     */
    NMS0C: T;

    /**
     * @default 'Your registry switched to {{0}}, but this fund collects in {{1}}. <0>Create a new {{2}} fund</0> to accept cards.'
     */
    W5XOp: T;

    /**
     * @default 'Create a new {{0}} fund'
     */
    Gd2x1: T;

    /**
     * @default 'Search brands, products, and more'
     */
    '0TnRm': T;

    /**
     * @default 'Search for'
     */
    ZuceU: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'Jamie Lee'
     */
    a95PH: T;
  };
};

export type ShareEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Your Message'
     */
    '4EHf6': T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'iMessage'
     */
    '0FNiC': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Text Message'
     */
    OKKVT: T;

    /**
     * @default 'WhatsApp'
     */
    qJ8WP: T;

    /**
     * @default 'Copied!'
     */
    zRtI3: T;

    /**
     * @default 'Shared!'
     */
    OFR0B: T;

    /**
     * @default 'Opened'
     */
    Jb2IL: T;
  };
};

export type ShareRoomBlockHostTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'We couldn't load this event.'
     */
    CTArK: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'There's no room block to share right now.'
     */
    fBIKi: T;

    /**
     * @default 'Book your room'
     */
    fI09y: T;

    /**
     * @default 'Tell your guests about your room blocks.'
     */
    ArdQD: T;

    /**
     * @default 'Tell your guests about your room block.'
     */
    HyYRe: T;

    /**
     * @default 'Rooms go fast and the group rate has a deadline. Pick a channel, tweak the message, send.'
     */
    '5SixY': T;

    /**
     * @default 'Share Room Block'
     */
    d7dO1: T;

    /**
     * @default '– {{0}}'
     */
    '1Va0e': T;

    /**
     * @default 'Explore more room blocks: {{0}}'
     */
    FfQEY: T;

    /**
     * @default 'Book your room by {{0}}!'
     */
    '5NXd4': T;

    /**
     * @default 'Our group rate at {{0}} is {{1}} a night instead of {{2}}.'
     */
    XziS6: T;

    /**
     * @default 'Our group rate at {{0}} is {{1}} a night.'
     */
    '8tGsl': T;

    /**
     * @default 'We set up a group rate at {{0}}.'
     */
    UV0Ou: T;

    /**
     * @default 'Book here: {{0}}'
     */
    TBG8O: T;

    /**
     * @default 'Book your room by {{0}}! Our group rates:'
     */
    fGPAw: T;

    /**
     * @default '• {{0}} — {{1}}/night, book by {{2}}'
     */
    M2flS: T;

    /**
     * @default '• {{0}} — book by {{1}}'
     */
    '94uxE': T;
  };
};

export type ShareWebsiteDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Open link'
     */
    gm3o3: T;

    /**
     * @default 'Tap to load preview'
     */
    gj6f2: T;

    /**
     * @default 'Link preview'
     */
    Uyu1B: T;

    /**
     * @default 'Your {{0}} page is currently hidden from guests.'
     */
    '3LQjf': T;

    /**
     * @default 'Page Settings'
     */
    qiWuC: T;

    /**
     * @default 'Share Website'
     */
    k5DXO: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Share {{0}}'
     */
    dFSx8: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Website URL updated'
     */
    Zi603: T;

    /**
     * @default 'That URL is too short. Use at least {{0}} characters.'
     */
    rlsJx: T;

    /**
     * @default 'Couldn't update your URL. Try again.'
     */
    '8k1b7': T;

    /**
     * @default 'Your Website Link'
     */
    '44Ujh': T;

    /**
     * @default 'Please note: '
     */
    MVoDY: T;

    /**
     * @default 'Your old Joy URL will no longer work. Share your new URL with guests, and update your custom domain forwarding if needed.'
     */
    '9tJDU': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Visit your website'
     */
    '92a9w': T;

    /**
     * @default 'Visit site'
     */
    QsP83: T;

    /**
     * @default 'Change preview photo'
     */
    ANHu8: T;

    /**
     * @default 'Updating…'
     */
    sLXcH: T;

    /**
     * @default 'Edit Link'
     */
    aRnIg: T;

    /**
     * @default 'How your link will appear'
     */
    I8ZPA: T;

    /**
     * @default 'Password updated'
     */
    wBZXc: T;

    /**
     * @default '{{0}} of {{1}} pages protected'
     */
    oKlfS: T;

    /**
     * @default '{{0}} of {{1}} pages password protected'
     */
    '74WsW': T;

    /**
     * @default 'Couldn't load the password. Try again.'
     */
    XGBs8: T;

    /**
     * @default 'Password copied'
     */
    '11NlX': T;

    /**
     * @default 'Couldn't update password. Try again.'
     */
    LF8Gr: T;

    /**
     * @default 'Website Password'
     */
    QVIIq: T;

    /**
     * @default 'Guests will need your new password to unlock your event.'
     */
    JUo5F: T;

    /**
     * @default 'Edit Password'
     */
    PXac1: T;

    /**
     * @default 'Hide password'
     */
    fHzwN: T;

    /**
     * @default 'Show password'
     */
    IMpuT: T;

    /**
     * @default 'Hide'
     */
    auVLA: T;

    /**
     * @default 'Show'
     */
    '5YANA': T;

    /**
     * @default 'Edit password'
     */
    zvrxA: T;

    /**
     * @default 'Copy password'
     */
    obve9: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Your site is live'
     */
    ahOO7: T;

    /**
     * @default 'We couldn't confirm your Joy AI Website purchase. Try publishing again in a moment.'
     */
    r8uey: T;

    /**
     * @default 'Couldn't update publish state. Try again.'
     */
    KsL3F: T;

    /**
     * @default 'Site unpublished. Guests may still see it for a few minutes.'
     */
    PoyaD: T;

    /**
     * @default 'Site unpublished'
     */
    Kz9Ye: T;

    /**
     * @default 'You don't have a website yet. Create one in the website editor, then publish it here.'
     */
    kHXp1: T;

    /**
     * @default 'Your website is still being designed. You can publish it once it's ready.'
     */
    u0Ydi: T;

    /**
     * @default 'We couldn't finish your website. Open the website editor to try again.'
     */
    ophCS: T;

    /**
     * @default 'Your website is live.'
     */
    MavdZ: T;

    /**
     * @default 'Publish your website.'
     */
    nYab2: T;

    /**
     * @default 'Keep your site unpublished while you're building it. Publish it when you're ready for guests to visit.'
     */
    pEWL3: T;

    /**
     * @default 'Open Website Editor'
     */
    YQFoq: T;

    /**
     * @default 'Publish website'
     */
    cj1qH: T;

    /**
     * @default 'Link copied'
     */
    IHIze: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Share with Card'
     */
    lSoRz: T;

    /**
     * @default 'Beautiful paper and digital cards.'
     */
    N4qKp: T;

    /**
     * @default 'Share with Message'
     */
    QI9wE: T;

    /**
     * @default 'Text or email to share with a tap.'
     */
    IMX5P: T;
  };
};

export type ShareYourStayGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'You're all booked.'
     */
    icD0o: T;

    /**
     * @default 'Confirmation sent to {{0}}.'
     */
    qzQoR: T;

    /**
     * @default 'View Booking'
     */
    UsMLb: T;

    /**
     * @default 'We couldn't load your reservation.'
     */
    Ts6Hc: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Share your stay'
     */
    BhBoE: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Continue to your booking details'
     */
    aw3kR: T;

    /**
     * @default 'Join me — book your stay'
     */
    vzsvz: T;

    /**
     * @default 'Just booked my stay! Can't wait to celebrate — hope you can join. Use code {{0}} to get {{1}} off. 🪩'
     */
    dHa0e: T;

    /**
     * @default 'Share your stay
with family and friends.'
*/
    fqT0q: T;

    /**
     * @default 'When you stay at the same hotel as the people you know, the whole celebration feels like a reunion. One quick share and they can book the same hotel as you.'
     */
    JRhvA: T;

    /**
     * @default 'Your code: {{0}}'
     */
    wkpXz: T;

    /**
     * @default 'Anyone who books through your link gets {{0}} off their stay. You'll get {{1}} off your next stay for every booking.'
     */
    btdNV: T;

    /**
     * @default 'Share Your Stay'
     */
    xdL4w: T;

    /**
     * @default 'Just booked my stay! Can't wait to celebrate — hope you can join. 🪩

Book through my link and you'll get {{0}} off.'
*/
    q41kc: T;

    /**
     * @default 'Just booked my stay! Can't wait to celebrate — hope you can join. 🪩'
     */
    QnA4w: T;

    /**
     * @default 'Give {{0}}, get {{1}}
toward your next trip.'
*/
    '4LfCO': T;

    /**
     * @default 'Share your code and anyone who books their stay gets {{0}} off. You'll get {{1}} off your next stay for every booking — the more you share, the more you get back.'
     */
    hENp5: T;
  };
};

export type SiteStatusIndicatorAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Unpublished'
     */
    F7vbD: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Open in new window'
     */
    Fnzng: T;

    /**
     * @default 'Publish website'
     */
    cj1qH: T;

    /**
     * @default 'Edit website'
     */
    D123S: T;

    /**
     * @default 'View website'
     */
    q6sRr: T;

    /**
     * @default 'Copy link'
     */
    Xn2zA: T;
  };
};

export type SlapAdsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Your registry starts here.'
   */
  messageLine1: T;

  /**
   * @default 'Add your first items to unlock gifting.'
   */
  messageLine2: T;

  /**
   * @default 'Explore Registry'
   */
  btn: T;
};

export type SsrServerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  metatags: {
    /**
     * @default 'The only wedding app and website you need'
     */
    title: T;
  };
};

export type StationeryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Search...'
   */
  searchPlaceholder: T;

  /**
   * @default 'No search results.'
   */
  noSearchResults: T;

  /**
   * @default 'Clear'
   */
  clear: T;

  cardCustomizer: {
    editorToolbar: {
      /**
       * @default 'Font Size'
       */
      fontSize: T;

      /**
       * @default 'Line Height'
       */
      lineHeight: T;

      /**
       * @default 'Letter Spacing'
       */
      letterSpacing: T;
    };
    uploadDesignFloatingMessage: {
      /**
       * @default 'Click or tap here to upload your design.'
       */
      title: T;

      /**
       * @default 'Learn More'
       */
      cta: T;
    };
    qrCodeLinkModal: {
      /**
       * @default 'QR Code Link'
       */
      websiteLinkTitle: T;

      /**
       * @default 'Edit Link'
       */
      websiteLinkTitleDigital: T;

      /**
       * @default 'Edit Your Website Details'
       */
      handleAndPasswordTitle: T;

      websiteLink: {
        /**
         * @default 'Add QR code to your card, so guests can easily access your wedding website and see all the details.'
         */
        description: T;

        /**
         * @default 'Add a link to your card, so guests can easily access your wedding website and see all the details.'
         */
        linkDescription: T;

        /**
         * @default 'Your Website'
         */
        yourWebsiteTitle: T;

        /**
         * @default 'Edit'
         */
        edit: T;

        /**
         * @default 'Edit URL and Password'
         */
        editURLAndPassword: T;

        /**
         * @default 'Uh oh! Your website link seems a bit long, you can edit it to make it shorter and more personal to make it easier for your guests.'
         */
        longHandleWarning: T;

        /**
         * @default 'Your Custom Link'
         */
        customLinkTitle: T;

        /**
         * @default 'Contact Collector'
         */
        contactCollectorTitle: T;

        /**
         * @default 'Please ensure you're using the correct format, starting with http:// or https://'
         */
        invalidCustomLinkError: T;
      };
      editLinkAndPassword: {
        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'This URL is available'
         */
        urlAvailable: T;

        /**
         * @default ' This URL is not available'
         */
        urlNotAvailable: T;

        /**
         * @default '/60 Max Chars'
         */
        urlCharsCounter: T;

        /**
         * @default 'URL cannot be blank.'
         */
        urlRequiredError: T;

        /**
         * @default 'URL must be less than 60 characters long.'
         */
        urlLengthError: T;

        /**
         * @default 'Only letters, numbers and '-' are allowed in your URL.'
         */
        urlCharactersError: T;

        /**
         * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
         */
        urlWarning: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Password cannot be blank.'
         */
        passwordRequiredError: T;

        /**
         * @default 'Your password can only contain letters and numbers.'
         */
        passwordCharactersError: T;

        /**
         * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
         */
        passwordWarning: T;

        /**
         * @default 'Cancel'
         */
        cancel: T;

        /**
         * @default 'Update Details'
         */
        updateDetails: T;

        /**
         * @default 'Your Event Website has been updated.'
         */
        successToast: T;

        /**
         * @default 'An error occurred while updating your Event Website. Please try again.'
         */
        errorToast: T;
      };
    };
    topNavProgressBar: {
      desktop: {
        steps: {
          /**
           * @default 'Front'
           */
          cardFront: T;

          /**
           * @default 'Back'
           */
          cardBack: T;

          /**
           * @default 'Envelope'
           */
          envelope: T;

          /**
           * @default 'Recipients'
           */
          recipients: T;

          /**
           * @default 'Recipients'
           */
          postcardRecipients: T;

          /**
           * @default 'Review'
           */
          review: T;

          /**
           * @default 'Front'
           */
          digitalCardFront: T;

          /**
           * @default 'Back'
           */
          digitalCardBack: T;

          /**
           * @default 'Review'
           */
          digitalCardReview: T;
        };
      };

      /**
       * @default 'Step'
       */
      step: T;
    };
    promoCodeBlock: {
      /**
       * @default 'Promo Code'
       */
      title: T;

      /**
       * @default 'Apply'
       */
      applyCta: T;

      /**
       * @default 'Remove'
       */
      removeCta: T;

      /**
       * @default 'Enter code'
       */
      inputPlaceholder: T;

      /**
       * @default 'Promo code {{code}} applied'
       */
      promoCodeApplied: T;

      /**
       * @default 'This is not a valid promo code.'
       */
      invalidPromoCode: T;
    };
    courierErrorMessage: {
      /**
       * @default 'There seems to be an issue with your order delivery. Please visit'
       */
      text1: T;

      /**
       * @default 'the courier page'
       */
      link: T;

      /**
       * @default 'to check the details.'
       */
      text2: T;
    };
    priceSummary: {
      /**
       * @default 'Order Summary'
       */
      orderSummaryLabel: T;

      discountSection: {
        /**
         * @default 'Promo code {{code}} applied <br />(excludes shipping)'
         */
        label: T;

        /**
         * @default '-{{discount}}%'
         */
        value: T;
      };

      /**
       * @default 'Total'
       */
      totalLabel: T;

      /**
       * @default 'Sales Tax'
       */
      taxLabel: T;
    };
    checkoutErrorDialog: {
      generic: {
        /**
         * @default 'We’re having trouble placing your order.'
         */
        title: T;

        /**
         * @default 'Open Drafts'
         */
        buttonLabel: T;
      };
      address: {
        /**
         * @default 'Please check your address.'
         */
        title: T;

        /**
         * @default 'Your shipping address could not be validated. Check that the zip/postal code is correct.'
         */
        error: T;

        /**
         * @default 'Edit Shipping Address'
         */
        buttonLabel: T;
      };
      billingAddress: {
        /**
         * @default 'Please check your address.'
         */
        title: T;

        /**
         * @default 'Your billing address could not be validated. Check that the zip/postal code is correct.'
         */
        error: T;

        /**
         * @default 'Edit Billing Address'
         */
        buttonLabel: T;
      };
    };
    contactDialog: {
      /**
       * @default 'Add New Recipient'
       */
      newRecipientTitle: T;

      /**
       * @default 'Edit Recipient’s Details'
       */
      updateRecipientTitle: T;

      /**
       * @default 'There was an error saving the contact'
       */
      mutationError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Save'
       */
      save: T;

      /**
       * @default 'Edit Address'
       */
      editAddress: T;

      /**
       * @default 'Confirm Address'
       */
      confirmAddress: T;

      formValidation: {
        /**
         * @default 'Required'
         */
        required: T;

        /**
         * @default 'Invalid Email'
         */
        invalidEmail: T;
      };
      formFields: {
        /**
         * @default 'First Name'
         */
        firstName: T;

        /**
         * @default 'Last Name'
         */
        lastName: T;

        /**
         * @default 'Email'
         */
        email: T;

        /**
         * @default 'Phone Number'
         */
        phoneNumber: T;

        /**
         * @default 'Address Line'
         */
        address: T;

        /**
         * @default 'Address Line 1'
         */
        address1: T;

        /**
         * @default 'Address Line 2'
         */
        address2: T;

        /**
         * @default 'City'
         */
        city: T;

        /**
         * @default 'State'
         */
        state: T;

        /**
         * @default 'State/Province/Territory'
         */
        stateOrProvince: T;

        /**
         * @default 'Country/Region'
         */
        country: T;

        /**
         * @default 'Zip/Postal Code'
         */
        postalCode: T;

        /**
         * @default 'Mailing Address'
         */
        mailingAddress: T;

        /**
         * @default 'Guest Details'
         */
        guestDetails: T;

        /**
         * @default 'Invalid Phone Number'
         */
        invalidPhone: T;

        /**
         * @default 'Address'
         */
        address1Placeholder: T;

        /**
         * @default 'Apartment, Suite, etc. (optional)'
         */
        address2Placeholder: T;

        /**
         * @default 'Envelope Name'
         */
        envelopeName: T;

        /**
         * @default 'The Smith Family, Mr. and Mrs. Smith, etc'
         */
        envelopeNamePlaceholder: T;
      };
      addressSugestion: {
        /**
         * @default 'It is possible the following modified address will ensure a more successful delivery.'
         */
        title: T;

        /**
         * @default 'Please select the address you’d like to use.'
         */
        subTitle: T;

        /**
         * @default 'We couldn’t validate your address, please make sure it’s correct before proceeding to the next step.'
         */
        errorTitle: T;

        /**
         * @default 'Original Address'
         */
        original: T;

        /**
         * @default 'Suggested Address'
         */
        suggested: T;

        /**
         * @default 'Address Provided'
         */
        provided: T;
      };
    };
    quantityDialog: {
      /**
       * @default 'Oops, you chose more recipients than cards with envelopes.'
       */
      titleGoToReview: T;

      /**
       * @default 'Oops, you might need more cards with envelopes.'
       */
      titleChangeQuantity: T;

      /**
       * @default 'You selected {{recipientsLength}} recipients, so if you change the quantity of the cards with envelopes to {{quantity}}, that won’t match.'
       */
      subtitle: T;

      /**
       * @default 'You selected {{recipientsLength}} recipients, we currently offer suites up to {{maxQuantity}} cards with envelopes. Please get in touch with our support team, so they can make it happen.'
       */
      cardsNeededInvalid: T;

      /**
       * @default 'cards with envelopes'
       */
      cardsWithEnvelopes: T;

      /**
       * @default 'recipients selected'
       */
      recipientsSelected: T;

      /**
       * @default 'cards still needed'
       */
      cardsStillNeeded: T;

      /**
       * @default 'Get in Touch'
       */
      getInTouch: T;

      /**
       * @default 'Increase Card Quantity to {{getNewQuantity}}'
       */
      increaseQuantity: T;

      /**
       * @default 'Adjust Recipient Selection'
       */
      adjustSelection: T;
    };
    noGuestsDialog: {
      /**
       * @default 'Oops, you didn’t choose any recipients.'
       */
      title: T;

      /**
       * @default 'You requested Recipient Addressing, but no recipients were selected. Please choose recipients to print their addresses on the envelopes.'
       */
      subtitle: T;

      /**
       * @default 'If you don’t select recipients, we will proceed with printing return address, and leave the recipient address field blank, so you can address them yourself.'
       */
      warningReturnAddress: T;

      /**
       * @default 'If you don’t select recipients, we will send you blank envelopes with your cards, so you can address them yourself.'
       */
      warningNoReturnAddress: T;

      /**
       * @default 'Adjust Recipient Selection'
       */
      adjustSelection: T;

      /**
       * @default 'Proceed to Review'
       */
      proceedToReview: T;
    };
    paperTypesDialog: {
      /**
       * @default 'Our Paper Collection'
       */
      title: T;

      /**
       * @default 'Select the paper that matches your vision. All paper is sourced from Mohawk for their renowned archival quality and commitment to environmental stewardship.'
       */
      description: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    envelope: {
      addressValidation: {
        /**
         * @default 'Please fill in your return address first.'
         */
        addressText: T;

        /**
         * @default 'Please confirm that the return address is correct by ticking the checkbox.'
         */
        checkboxText: T;
      };

      /**
       * @default 'Edit Envelope'
       */
      panelTitle: T;

      quantity: {
        /**
         * @default 'Quantity'
         */
        title: T;

        /**
         * @default '{{quantity}} Cards'
         */
        value: T;
      };
      returnAddressing: {
        /**
         * @default 'Return Addressing'
         */
        title: T;

        /**
         * @default 'Print your return address on the front or back of the envelope.'
         */
        subtitle: T;

        /**
         * @default 'Address Placement'
         */
        placementTitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Address Design'
         */
        designTitle: T;
      };
      shippingAddressDialog: {
        /**
         * @default 'Your Return Address'
         */
        title: T;

        /**
         * @default 'Return Address'
         */
        modalTitle: T;

        /**
         * @default 'Please double check your address details or fill in the new one that you’d like to be printed on the envelope as a return address.'
         */
        modalDescription: T;

        /**
         * @default 'Add Return Address'
         */
        emptyButton: T;

        /**
         * @default 'Show Country/Region'
         */
        showCountry: T;
      };
      recipientAddressing: {
        /**
         * @default 'Recipient Addressing'
         */
        title: T;

        /**
         * @default 'Have your guest’s addresses printed on the front of each envelope.'
         */
        subtitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Print Addresses'
         */
        firstOption: T;

        /**
         * @default 'Leave Blank'
         */
        secondOption: T;

        /**
         * @default 'The same design you selected applies to recipient addressing. Next we’ll help you add your recipient addresses.'
         */
        description: T;
      };
      checkbox: {
        /**
         * @default 'Please confirm your return address.'
         */
        title: T;

        /**
         * @default 'My return address is correct and ready to be printed on the envelope'
         */
        description: T;
      };
      stickyCta: {
        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Recipients'
         */
        recipients: T;

        /**
         * @default 'Review'
         */
        review: T;
      };

      /**
       * @default 'Edit Return Address'
       */
      ctaEditReturnAddress: T;

      /**
       * @default 'Add Return Address'
       */
      ctaAddReturnAddress: T;
    };
    recipients: {
      /**
       * @default 'Edit Recipients'
       */
      panelTitle: T;

      quantity: {
        /**
         * @default 'Quantity'
         */
        title: T;

        /**
         * @default '{{quantity}} Cards'
         */
        value: T;

        /**
         * @default 'Changing Quantity is not available in edit mode. Please contact customer support.'
         */
        icon: T;
      };
      recipientAddressing: {
        /**
         * @default 'Recipient Addressing'
         */
        title: T;

        /**
         * @default 'Have your guests’ addresses printed on the front of each envelope.'
         */
        subtitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Leave Blank'
         */
        firstOption: T;

        /**
         * @default 'Print Addresses'
         */
        secondOption: T;

        /**
         * @default 'The same design you selected applies to recipient addressing. Next we’ll help you add your recipient addresses.'
         */
        description: T;
      };
      printRecipientAddresses: {
        /**
         * @default 'Print Recipient Addresses'
         */
        title: T;

        /**
         * @default 'Select an option to upload your guests’ addresses to be printed on the envelope.'
         */
        subtitle: T;

        /**
         * @default 'Skip and Add After Ordering'
         */
        firstOption: T;

        /**
         * @default 'Skip and Edit Later'
         */
        firstOptionEditMode: T;

        /**
         * @default 'Select Recipients Now'
         */
        secondOption: T;

        /**
         * @default 'Submit a Spreadsheet'
         */
        thirdOption: T;
      };
      info: {
        /**
         * @default 'Print Guest Addresses'
         */
        title: T;

        /**
         * @default 'These addresses will be printed on the envelopes.'
         */
        subtitle: T;

        /**
         * @default 'envelopes'
         */
        envelopes: T;

        /**
         * @default 'addressed'
         */
        addressed: T;

        /**
         * @default 'blank'
         */
        blank: T;
      };
      contactCollector: {
        /**
         * @default 'Don’t have your guest addresses yet?'
         */
        text1: T;

        /**
         * @default 'Alternatively, you can add them manually.'
         */
        text2: T;
      };

      /**
       * @default 'Add New Recipient'
       */
      addNewRecipient: T;

      stickyCta: {
        /**
         * @default 'Next: Review'
         */
        next: T;
      };

      /**
       * @default 'Please confirm that the recipients number is correct by ticking the checkbox.'
       */
      quantityConfirmation: T;

      howItWorks: {
        /**
         * @default 'How it works:'
         */
        title: T;

        steps: [
          {
            /**
             * @default 'Select “Print Addresses” and place your order. You’ll choose your recipients after the order is placed.'
             */
            title: T;
          },
          {
            /**
             * @default 'After ordering, you’ll be able to access your order and select your guests for envelope addressing from your Joy guest list or Contact Collector.'
             */
            title: T;
          },
          {
            /**
             * @default 'Your order will be paused until we receive your addresses, and sent to print when you’re ready.'
             */
            title: T;
          },
        ];

        /**
         * @default 'Changed your mind? No problem! Send your order to be printed without recipient addressing at any time.'
         */
        subTitle: T;

        /**
         * @default 'Learn More'
         */
        learnMore: T;
      };
      skipPrintType: {
        /**
         * @default 'After placing an order, you can come back any time to add and select your recipients. Your order will be paused until then.'
         */
        title: T;

        /**
         * @default 'I understand my order will be paused until I add recipient addressing or send it to print without it.'
         */
        checkBox: T;
      };
      spreadsheetPrintType: {
        steps: [
          {
            /**
             * @default 'Please download the template'
             */
            title: T;
          },
          {
            /**
             * @default 'We’ll send a digital preview of your final addressed envelopes within 2 business days of receiving the address spreadsheet.'
             */
            title: T;
          },
          {
            /**
             * @default 'When you confirm you’re happy with it, our support team will send your order to printing.'
             */
            title: T;
          },
        ];

        /**
         * @default 'here'
         */
        link: T;

        /**
         * @default 'and send it to our support team at'
         */
        sendIt: T;

        /**
         * @default 'along with your order number.'
         */
        along: T;

        /**
         * @default 'I understand my order will be paused until I submit my spreadsheet and confirm the preview as described above.'
         */
        checkBox: T;
      };

      /**
       * @default 'You sent a CSV file to'
       */
      spreadsheetPrintTypeAlreadySent1: T;

      /**
       * @default 'when you placed your order. Envelopes are typically created from your CSV within 2 business days. If it has been more than 2 business days and you have not been contacted, please reach out to'
       */
      spreadsheetPrintTypeAlreadySent2: T;

      /**
       * @default 'Edit Guest Details'
       */
      ctaEditGuestDetails: T;

      /**
       * @default 'Add Missing Address'
       */
      ctaAddMissingAddress: T;

      /**
       * @default 'Address Formatting Issue'
       */
      legacyAddressLineBreakTitle: T;

      /**
       * @default ''Street Address' and 'City, State, ZIP Code' should be on separate lines. Click Edit Guest Details to add a line break.'
       */
      legacyAddressLineBreakDescription: T;

      /**
       * @default 'Learn more.'
       */
      legacyAddressLineBreakLink: T;
    };
  };
  premiumDigitalCardCustomizer: {
    cardFront: {
      /**
       * @default 'Customize your card whenever you’d like; now, after purchase, or even after sending some cards.'
       */
      editCard: T;
    };
    digitalReview: {
      /**
       * @default 'Please add your billing details.'
       */
      addressFieldErrorMessage: T;

      /**
       * @default 'Please confirm that you checked all the details by ticking the checkbox below.'
       */
      checkboxFieldErrorMessage: T;

      /**
       * @default 'Make sure to carefully check everything before you finalize your order.'
       */
      stepDescription: T;

      /**
       * @default 'Billing Address'
       */
      billingAddressTitle: T;

      /**
       * @default 'Add Billing Address'
       */
      billingAddressEmptyMessage: T;

      /**
       * @default 'Go to Checkout'
       */
      ctaText: T;

      /**
       * @default 'Submit Changes'
       */
      ctaTextOrder: T;

      /**
       * @default 'I understand that any changes submitted will apply to previously sent cards, as well as future cards.'
       */
      orderCtaDescription: T;

      /**
       * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
       */
      deliveryDescription: T;

      /**
       * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
       */
      multiOptionsDeliveryDescription: T;

      /**
       * @default 'Delivery Methods'
       */
      deliveryTitle: T;

      /**
       * @default 'Email'
       */
      standardDeliveryTitle: T;

      /**
       * @default 'Personalized Emails'
       */
      standardDeliveryDescription: T;

      /**
       * @default 'Text, Links & Email'
       */
      premiumDeliveryTitle: T;

      /**
       * @default 'Text messaging to USA and Canada'
       */
      premiumDeliveryDescription: T;

      /**
       * @default 'Up to {{count}} guests'
       */
      emailDeliveryLimits: T;

      /**
       * @default 'Included'
       */
      included: T;

      /**
       * @default 'Personalized Emails'
       */
      valuePropEmail: T;

      /**
       * @default 'Shareable Card Link'
       */
      valuePropLink: T;

      /**
       * @default 'Text messaging to USA and Canada'
       */
      valuePropPremium: T;

      /**
       * @default 'International Text *'
       */
      valuePropDiamond: T;

      /**
       * @default 'Email'
       */
      basic: T;

      /**
       * @default 'Text Messaging'
       */
      premium: T;

      /**
       * @default 'International Text Message'
       */
      diamond: T;

      /**
       * @default '*Some country restrictions apply.'
       */
      coutryRestriction: T;

      /**
       * @default 'Learn more'
       */
      learnMore: T;
    };
    postCheckout: {
      /**
       * @default 'Track Cards Sent'
       */
      trackCardsSent: T;

      greetingBlock: {
        /**
         * @default 'Order Confirmed! Up next:'
         */
        eyebrow: T;

        /**
         * @default 'Select recipients and send your card.'
         */
        title: T;
      };
      stepBlocks: {
        step1: {
          /**
           * @default 'First, let's get your email looking great.'
           */
          label: T;

          /**
           * @default 'Edit Subject'
           */
          editSubjectCta: T;

          /**
           * @default 'Send Test Email'
           */
          sendTestEmailCta: T;

          /**
           * @default '💌 Your test email was sent to: {{email}}'
           */
          sendTestEmailToast: T;
        };
        step2: {
          /**
           * @default 'Then, select your recipients and send.'
           */
          label: T;

          /**
           * @default 'Select Recipients'
           */
          selectRecipientsCta: T;

          /**
           * @default 'Modify {{count}} Recipients...'
           */
          modifyRecipients: T;

          /**
           * @default 'Send Card'
           */
          sendCardCta: T;

          /**
           * @default 'Send Card to {{count}} Recipients'
           */
          sendCardToSelectedRecipientsCta: T;

          /**
           * @default 'There was an error sending the Card. Please try again or contact support.'
           */
          sendCardError: T;
        };
      };
      printCardSellBanner: {
        /**
         * @default 'Add Beautiful Paper Cards'
         */
        title: T;

        /**
         * @default 'Some guests prefer to receive a physical card. Create a matching (or unique) paper card for them. All your details are ready. ☺️'
         */
        description: T;

        /**
         * @default 'See it on Paper'
         */
        ctaText: T;
      };
      linkShareSection: {
        /**
         * @default 'Want to do it yourself?'
         */
        eyebrow: T;

        /**
         * @default 'Share your card link any way you want.'
         */
        title: T;

        /**
         * @default 'Copy Card Link'
         */
        ctaText: T;

        /**
         * @default '🎉 Your link has been copied.'
         */
        copyToast: T;
      };
      emailEditorDialog: {
        /**
         * @default 'Edit Your Message'
         */
        header: T;

        senderNameField: {
          /**
           * @default 'Sender Name'
           */
          label: T;
        };
        subjectField: {
          /**
           * @default 'Subject'
           */
          label: T;

          /**
           * @default 'Your message will appear as an email subject and text message.'
           */
          inputCaption: T;
        };

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Save'
         */
        saveCta: T;
      };

      /**
       * @default '<0>Contact support</0> to purchase more. <1>Pricing</1>.'
       */
      recipientLimitActions: T;

      /**
       * @default 'Please select fewer recipients, or <0>contact support</0> to purchase more. <1>Pricing</1>.'
       */
      recipientLimitActionsExceeds: T;
    };
    successStep: {
      /**
       * @default 'Congratulations! Your card has been sent.'
       */
      title: T;

      /**
       * @default 'Your message has been sent successfully.'
       */
      messageSuccess: T;

      /**
       * @default '{{count}} Messages sent'
       */
      messageSendCount: T;

      /**
       * @default '1 Message sent'
       */
      messageSendCountSingle: T;

      /**
       * @default 'Messages sent'
       */
      messageSentNoCount: T;

      /**
       * @default 'Track which guests have received and opened your card.'
       */
      trackDescription: T;

      /**
       * @default 'Track Cards Sent'
       */
      trackCardsSentCta: T;

      /**
       * @default 'View Order'
       */
      viewOrderCta: T;
    };
  };
  dashboard: {
    dynamicBanner: {
      /**
       * @default 'Free Shipping to {{countries}} Addresses'
       */
      freeShipping: T;
    };
    existingDraftsWarningDialog: {
      variants: {
        single: {
          /**
           * @default 'You already have a draft of this design. What would you like to do?'
           */
          message: T;

          /**
           * @default 'Edit Existing Draft'
           */
          ctaText: T;
        };
        multiple: {
          /**
           * @default 'You have multiple drafts of this design. What would you like to do?'
           */
          message: T;

          /**
           * @default 'View Existing Drafts'
           */
          ctaText: T;
        };
      };

      /**
       * @default 'Start New Draft'
       */
      startNewDraftCtaText: T;
    };
    restrictedInternationalShippingWarningDialog: {
      print: {
        /**
         * @default 'Do you have a supported address?'
         */
        title: T;

        /**
         * @default 'The supported country is {{countries}}.'
         */
        supportedCountriesSingular: T;

        /**
         * @default 'The supported countries are {{countries}}.'
         */
        supportedCountriesPlural: T;

        /**
         * @default 'Paper cards are currently available for the supported addresses only.'
         */
        warningMessageNonStdOrInvitationText: T;

        /**
         * @default 'Paper cards are currently available for the supported addresses only. If you are not in the supported countries you can still '
         */
        warningMessageEcardText: T;

        /**
         * @default 'If you don't have a supported address, you can send digital thank you messages to your guests'
         */
        warningMessageEmailText: T;

        /**
         * @default 'create a free basic digital card.'
         */
        warningMessageLink: T;

        /**
         * @default 'here.'
         */
        warningMessageLinkThankYou: T;

        /**
         * @default 'I have a supported address'
         */
        ctaText: T;
      };
      digital: {
        /**
         * @default 'Do you have a supported address?'
         */
        title: T;

        /**
         * @default 'The supported country is {{countries}}.'
         */
        supportedCountriesSingular: T;

        /**
         * @default 'The supported countries are {{countries}}.'
         */
        supportedCountriesPlural: T;

        /**
         * @default 'Premium digital cards are currently available for the supported addresses only.'
         */
        warningMessageNonStdOrInvitationText: T;

        /**
         * @default 'Premium digital cards are currently available for the supported addresses only. If you are not in the supported countries you can still '
         */
        warningMessageEcardText: T;

        /**
         * @default 'If you don't have a supported address, you can send digital thank you messages to your guests'
         */
        warningMessageEmailText: T;

        /**
         * @default 'create a free basic digital card.'
         */
        warningMessageLink: T;

        /**
         * @default 'here.'
         */
        warningMessageLinkThankYou: T;

        /**
         * @default 'I have a supported address'
         */
        ctaText: T;
      };
    };
    designsGallery: {
      /**
       * @default 'Learn More'
       */
      learnMore: T;

      filterOptions: {
        /**
         * @default 'Color'
         */
        color: T;

        /**
         * @default 'Foil'
         */
        foil: T;

        /**
         * @default 'With Foil'
         */
        'foil with': T;

        /**
         * @default 'Without Foil'
         */
        'foil without': T;

        /**
         * @default 'Paper & Digital'
         */
        format: T;

        /**
         * @default 'Digital'
         */
        'format digital': T;

        /**
         * @default 'Paper'
         */
        'format paper': T;

        /**
         * @default 'Orientation'
         */
        orientation: T;

        /**
         * @default 'Landscape'
         */
        'orientation landscape': T;

        /**
         * @default 'Portrait'
         */
        'orientation portrait': T;

        /**
         * @default 'Square'
         */
        'orientation square': T;

        /**
         * @default 'Photo'
         */
        photo: T;

        /**
         * @default 'With Photo'
         */
        'photo with': T;

        /**
         * @default 'Without Photo'
         */
        'photo without': T;

        /**
         * @default 'Price'
         */
        price: T;

        /**
         * @default 'Free Digital'
         */
        'price basic': T;

        /**
         * @default 'Premium Paper & Digital'
         */
        'price premium': T;

        /**
         * @default 'Style'
         */
        style: T;
      };
      filtersDrawer: {
        /**
         * @default 'Filters'
         */
        header: T;

        /**
         * @default 'Reset All Filters'
         */
        resetCta: T;

        /**
         * @default 'Show Results'
         */
        showResultsCta: T;
      };
      pagination: {
        /**
         * @default 'Previous'
         */
        previous: T;

        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Page {{page}} / {{totalPages}}'
         */
        page: T;
      };
    };
    favoritesGallery: {
      emptyState: {
        /**
         * @default 'You don't have any favorites just yet!'
         */
        title: T;

        /**
         * @default 'When you browse the gallery, you can add all the designs you like clicking the heart in the top right, and you can come back and see them here.'
         */
        description: T;

        /**
         * @default 'Browse Designs'
         */
        cta: T;
      };
    };
    draftsGallery: {
      /**
       * @default 'Your Drafts'
       */
      sectionTitle: T;

      /**
       * @default 'Edited {{timeAgo}}'
       */
      editedAtLabel: T;

      /**
       * @default 'You don’t have any drafts just yet!'
       */
      emptyStateTitle: T;

      /**
       * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
       */
      emptyStateMessage: T;

      stationerySection: {
        title: {
          /**
           * @default 'Paper Cards'
           */
          print: T;

          /**
           * @default 'Premium Digital Cards'
           */
          digital: T;
        };
        emptyStateText: {
          desktop: {
            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            print: T;

            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            digital: T;
          };
          mobile: {
            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            print: T;

            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            digital: T;
          };
        };
        emptyStateCTA: {
          /**
           * @default 'Browse Paper Cards'
           */
          print: T;

          /**
           * @default 'Browse Premium Digital Cards'
           */
          digital: T;
        };

        /**
         * @default 'Show All'
         */
        buttonTitle: T;
      };
      digitalSection: {
        /**
         * @default 'Basic Digital Cards'
         */
        title: T;

        /**
         * @default 'No Basic Digital Drafts'
         */
        emptyStateTitle: T;

        /**
         * @default 'Art Save the Date'
         */
        saveTheDate: T;

        /**
         * @default 'Photo Save the Date'
         */
        photoSaveTheDate: T;

        /**
         * @default 'Invitation'
         */
        invitation: T;

        /**
         * @default 'Custom Card'
         */
        custom: T;
      };
      deleteDraftDialog: {
        /**
         * @default 'Are you sure you want to delete this draft permanently?'
         */
        title: T;

        /**
         * @default 'You can always create a new draft, but the details saved here will no longer be saved.'
         */
        description: T;

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Delete Draft'
         */
        deleteCta: T;

        /**
         * @default 'Draft deleted successfully'
         */
        successToast: T;

        /**
         * @default 'Failed to delete draft'
         */
        errorToast: T;
      };
    };
    conciergeServiceSection: {
      dialog: {
        overviewScreen: {
          /**
           * @default 'COMING SOON'
           */
          comingSoonLabel: T;

          costLabel: {
            /**
             * @default 'From {{cost}} each for order of 100'
             */
            saveTheDate: T;

            /**
             * @default 'From {{cost}} each for order of 100 suites'
             */
            invitation: T;
          };

          /**
           * @default 'Notify Me'
           */
          notifyMeCta: T;

          /**
           * @default 'Order Now'
           */
          orderNowCta: T;

          sections: {
            suiteHighlights: {
              title: {
                /**
                 * @default 'Includes'
                 */
                saveTheDate: T;

                /**
                 * @default 'Suite Includes'
                 */
                invitation: T;
              };
            };
            overview: {
              /**
               * @default 'Design Concierge Service'
               */
              title: T;

              /**
               * @default 'After placing your order, we will provide a link to our wording submission form. You can provide your wedding details to put on the card and introduce tweaks you wish to make.'
               */
              description: T;
            };
            howItWorks: {
              /**
               * @default 'How It Works, Step By Step'
               */
              title: T;

              steps: [
                {
                  /**
                   * @default 'Customization Form'
                   */
                  title: T;

                  /**
                   * @default 'Fill out your wedding details and select your options in the customization form.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Design Preview (Within 2 Days)'
                   */
                  title: T;

                  /**
                   * @default 'Your designer begins working on your customized design. You will receive an email when its time to view your proof.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Feedback & Changes (3-5 Business days)'
                   */
                  title: T;

                  /**
                   * @default 'Work with your designer to tweak your proof and get all the details correct. We won’t move to printing until you approve your design.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Printing ({{quantity}} Business Days)'
                   */
                  title: T;

                  /**
                   * @default 'After you let your design team know your proof is ready, we move to printing phase to make your custom order. Processing times vary between suites given the use of special print techniques, such as white ink or gold foil.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Shipping (3-4 Days)'
                   */
                  title: T;

                  /**
                   * @default 'Orders include free express DHL shipping reaching most destinations in 3-4 business days.'
                   */
                  description: T;
                },
              ];
            };
          };
        };
        successScreen: {
          /**
           * @default 'Success!'
           */
          title: T;

          /**
           * @default 'We'll be in touch as soon as the concierge suites are available on Joy Paper.'
           */
          description: T;

          /**
           * @default 'All Done'
           */
          allDoneCta: T;
        };
      };
    };
    ordersList: {
      digitalOrder: {
        /**
         * @default 'Order Placed'
         */
        orderPlaced: T;

        /**
         * @default 'Order Number'
         */
        orderNumber: T;

        /**
         * @default 'Track Delivery'
         */
        trackDelivery: T;

        /**
         * @default 'Send More or Resend'
         */
        sendMore: T;

        /**
         * @default 'Select Recipients and Send'
         */
        selectRecipients: T;

        /**
         * @default 'Order Matching Paper Card'
         */
        orderMatchingPaperCard: T;

        /**
         * @default 'This order has been cancelled. Please contact customer support if you believe this is an error'
         */
        orderCanceled: T;
      };
    };
  };
  pdpModal: {
    customizationPane: {
      matchingFoilTemplate: {
        /**
         * @default 'Available in Real Foil:'
         */
        title: T;
      };
      customizeCta: {
        /**
         * @default 'Subtotal'
         */
        subtotalLabel: T;

        /**
         * @default 'Customize Now'
         */
        ctaText: T;

        /**
         * @default 'Instant Delivery via Email'
         */
        digitalDeliverySecondaryLabel: T;
      };
      printTemplateConfig: {
        inlineValueProps: {
          /**
           * @default 'Matching Website Designs'
           */
          websiteDesign: T;

          /**
           * @default 'Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'QR codes for Easy Access'
           */
          qrCodes: T;
        };
        listValueProps: {
          /**
           * @default 'All Joy Prints Include:'
           */
          sectionTitle: T;

          /**
           * @default 'Digital printing on our luxurious signature card stock with a subtle velvety texture'
           */
          paperType: T;

          /**
           * @default 'Add rounded corners and customize your card the way you want'
           */
          silhouette: T;

          /**
           * @default 'QR codes that include your website password for seamless guest digital RSVP'
           */
          qrCodes: T;

          /**
           * @default 'Premium white envelope with complimentary return address printing'
           */
          envelope: T;
        };
      };
      digitalTemplateConfig: {
        inlineValueProps: {
          /**
           * @default 'Matching Website Designs'
           */
          websiteDesign: T;

          /**
           * @default 'Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'Easy Delivery and Tracking'
           */
          delivery: T;
        };
        listValueProps: {
          /**
           * @default 'All Joy Digital Cards Include:'
           */
          sectionTitle: T;

          /**
           * @default 'Beautiful, unique designs to pick from'
           */
          designs: T;

          /**
           * @default 'Easily tracking which guests have received and opened your Digital Card'
           */
          tracking: T;

          /**
           * @default 'Seamless guests info gathering with Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'The possibility to link to your wedding website, RSVP, Add to Calendar, Registry and more'
           */
          linking: T;
        };
      };
      premiumDigitalTemplateConfig: {
        listValueProps: {
          /**
           * @default 'Premium Digital Perks'
           */
          sectionTitle: T;

          premium: {
            /**
             * @default 'Premium Designer'
             */
            title: T;

            /**
             * @default 'Customize your card exactly how you like it, with hundreds of font, photo, and layout options.'
             */
            description: T;
          };
          matchingPaperCards: {
            /**
             * @default 'Matching Paper Cards and Website'
             */
            title: T;

            /**
             * @default 'Order printed cards for special guests or keepsakes and match your cards with a free wedding website.'
             */
            description: T;
          };
          textMessage: {
            /**
             * @default 'Text Message Delivery'
             */
            title: T;

            /**
             * @default 'Text messaging to USA and Canada with recipient tracking.'
             */
            description: T;
          };
          personalizedEmail: {
            /**
             * @default 'Personalized Email Delivery'
             */
            title: T;

            /**
             * @default 'Send and easily track which guests have received and opened your digital card.'
             */
            description: T;
          };
          shareableLink: {
            /**
             * @default 'Shareable Link'
             */
            title: T;

            /**
             * @default 'Get a link to your digital card that you can share directly with family and friends.'
             */
            description: T;
          };
          contactCollector: {
            /**
             * @default 'Contact Collector'
             */
            title: T;

            /**
             * @default 'Magically collect guests' contact info in your guest list for sending cards and thank you notes.'
             */
            description: T;
          };
        };
      };

      overviewAccordionTabs: [
        {
          /**
           * @default 'Why Joy?'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
        {
          /**
           * @default 'Shipping'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
        {
          /**
           * @default 'Need help designing?'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
      ];
      foilTooltip: {
        /**
         * @default 'Learn more about foil'
         */
        cta: T;

        /**
         * @default 'Premium Foil Stamping'
         */
        title: T;

        /**
         * @default 'Elevate your design with real foil in gold, rose gold, or silver. Foil stamping uses a machine to press the foil color onto the paper for a smooth, metallic effect.'
         */
        description: T;
      };
    };
  };
  digitalFlowWelcomeNotification: {
    /**
     * @default 'Welcome to Premium Card Designer'
     */
    title: T;

    /**
     * @default 'Learn how it works.'
     */
    description: T;

    modal: {
      /**
       * @default 'Learn How the Premium Card Designer Works'
       */
      title: T;

      /**
       * @default 'Customize Your Card'
       */
      cta: T;
    };
  };
  editCardBanner: {
    /**
     * @default 'Noticed a mistake? Don’t worry, that happens! Let’s get it right.'
     */
    paperDescription: T;

    /**
     * @default 'Still working on your card? Any changes you make will be applied to previously sent cards, as well as future ones.'
     */
    digitalDescription: T;

    /**
     * @default 'You have <0>{{duration}}</0> left to make the changes needed.'
     */
    countdownMessage: T;

    /**
     * @default 'Edit Your Design'
     */
    cta: T;
  };
  premiumDigitalOrderTracking: {
    header: {
      /**
       * @default 'Card Tracking'
       */
      title: T;

      category: {
        /**
         * @default 'Digital Save the Date'
         */
        saveTheDate: T;

        /**
         * @default 'Digital Invitation'
         */
        invitation: T;

        /**
         * @default 'Digital Thank You'
         */
        thankYou: T;

        /**
         * @default 'Digital Holiday Card'
         */
        holiday: T;

        /**
         * @default 'Digital Enclosure Card'
         */
        enclosure: T;

        /**
         * @default 'Digital Card'
         */
        default: T;
      };
    };

    /**
     * @default 'Send More Cards'
     */
    sendMoreCardsCta: T;

    /**
     * @default 'Send More'
     */
    sendMoreCardsCtaMobile: T;

    /**
     * @default 'Preview as Guest'
     */
    previewAsGuestCta: T;

    /**
     * @default 'Preview'
     */
    previewAsGuestCtaMobile: T;

    statusTrackingBar: {
      sent: {
        /**
         * @default 'Recipients'
         */
        label: T;

        /**
         * @default 'Sent'
         */
        iconTitle: T;
      };
      delivered: {
        /**
         * @default 'Delivered'
         */
        label: T;

        /**
         * @default 'Delivered'
         */
        iconTitle: T;
      };
      failed: {
        /**
         * @default 'Failed'
         */
        label: T;

        /**
         * @default 'Failed'
         */
        iconTitle: T;
      };
      viewed: {
        /**
         * @default 'Viewed'
         */
        label: T;

        /**
         * @default 'Viewed'
         */
        iconTitle: T;
      };
    };
    trackingStatusPill: {
      labels: {
        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Failed'
         */
        failed: T;

        /**
         * @default 'Viewed'
         */
        viewed: T;

        /**
         * @default 'Sent'
         */
        sent: T;

        /**
         * @default 'Queued'
         */
        queued: T;
      };
    };
    tableHeaders: {
      /**
       * @default 'Recipient'
       */
      recipient: T;

      /**
       * @default 'Status'
       */
      status: T;

      /**
       * @default 'Resend'
       */
      resend: T;
    };
    resendMenuTooltip: {
      /**
       * @default 'Resend the card'
       */
      title: T;

      /**
       * @default 'Choose the best way to reach {{name}}.'
       */
      description: T;
    };
    contactActions: {
      copyLink: {
        /**
         * @default 'Copy {{name}}'s link'
         */
        title: T;
      };
      whatsapp: {
        /**
         * @default 'Send to {{name}} via WhatsApp'
         */
        title: T;

        /**
         * @default 'If you have WhatsApp app on desktop, click the button below.'
         */
        desktopSubText: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        textMessage: T;
      };
      sms: {
        /**
         * @default 'Send to {{name}} via text message'
         */
        title: T;

        /**
         * @default 'If you have text messaging app on desktop, click the button below.'
         */
        desktopSubText: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        textMessage: T;
      };
      email: {
        /**
         * @default 'Send to {{name}} via email'
         */
        title: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        subject: T;

        /**
         * @default 'Click here to view to view our card:'
         */
        body: T;
      };
    };

    /**
     * @default '✨ {{name}}'s link has been copied.'
     */
    copyLinkToast: T;

    shareLinkDialog: {
      /**
       * @default 'Send to {{name}} via WhatsApp'
       */
      title: T;

      /**
       * @default 'This is a personalized link for {{name}} to allow tracking. Don’t share it with other guests.'
       */
      infoMessage: T;

      sendFromDesktop: {
        /**
         * @default 'Send from desktop'
         */
        title: T;

        /**
         * @default 'Send Now'
         */
        cta: T;
      };
      sendFromMobile: {
        /**
         * @default 'Send from mobile'
         */
        title: T;

        /**
         * @default 'Scan QR code and switch to your mobile device.'
         */
        description: T;
      };
    };
  };
  publicShop: {
    meta: {
      saveTheDate: {
        /**
         * @default 'Save the Date Cards | Paper + Free Online Templates | Joy'
         */
        title: T;

        /**
         * @default 'Explore hundreds of unique Save the Date card templates. Our collection includes free online cards, premium digital options, and elegant paper cards, all with matching wedding websites.'
         */
        description: T;
      };
      invitation: {
        /**
         * @default 'Elegant, Affordable Wedding Invitations | Joy'
         */
        title: T;

        /**
         * @default 'Craft your dream wedding invitations with Joy. Discover stunning designs and personalize every detail. Choose between the convenience of digital cards or the timeless appeal of printed invitations to perfectly capture the spirit of your special day.'
         */
        description: T;
      };
      fallback: {
        /**
         * @default 'Joy - Wedding Website, Guest List, Invitations & More'
         */
        title: T;
      };
    };
  };
  samplePack: {
    order: {
      /**
       * @default 'Order Sample'
       */
      title: T;

      sidebar: {
        /**
         * @default 'Sample Pack'
         */
        title: T;

        /**
         * @default 'A selection of cards showcasing each paper type, trim option, and card size.'
         */
        description: T;

        /**
         * @default 'Delivery Method'
         */
        deliveryMethod: T;

        /**
         * @default 'Place Order'
         */
        cta: T;
      };
    };
  };
  numerals: {
    cardinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default 'One'
       */
      T,
      /**
       * @default 'Two'
       */
      T,
      /**
       * @default 'Three'
       */
      T,
      /**
       * @default 'Four'
       */
      T,
      /**
       * @default 'Five'
       */
      T,
      /**
       * @default 'Six'
       */
      T,
      /**
       * @default 'Seven'
       */
      T,
      /**
       * @default 'Eight'
       */
      T,
      /**
       * @default 'Nine'
       */
      T,
      /**
       * @default 'Ten'
       */
      T,
      /**
       * @default 'Eleven'
       */
      T,
      /**
       * @default 'Twelve'
       */
      T,
      /**
       * @default 'Thirteen'
       */
      T,
      /**
       * @default 'Fourteen'
       */
      T,
      /**
       * @default 'Fifteen'
       */
      T,
      /**
       * @default 'Sixteen'
       */
      T,
      /**
       * @default 'Seventeen'
       */
      T,
      /**
       * @default 'Eighteen'
       */
      T,
      /**
       * @default 'Nineteen'
       */
      T,
      /**
       * @default 'Twenty'
       */
      T,
      /**
       * @default 'Twenty-One'
       */
      T,
      /**
       * @default 'Twenty-Two'
       */
      T,
      /**
       * @default 'Twenty-Three'
       */
      T,
      /**
       * @default 'Twenty-Four'
       */
      T,
      /**
       * @default 'Twenty-Five'
       */
      T,
      /**
       * @default 'Twenty-Six'
       */
      T,
      /**
       * @default 'Twenty-Seven'
       */
      T,
      /**
       * @default 'Twenty-Eight'
       */
      T,
      /**
       * @default 'Twenty-Nine'
       */
      T,
      /**
       * @default 'Thirty'
       */
      T,
      /**
       * @default 'Thirty-One'
       */
      T,
      /**
       * @default 'Thirty-Two'
       */
      T,
      /**
       * @default 'Thirty-Three'
       */
      T,
      /**
       * @default 'Thirty-Four'
       */
      T,
      /**
       * @default 'Thirty-Five'
       */
      T,
      /**
       * @default 'Thirty-Six'
       */
      T,
      /**
       * @default 'Thirty-Seven'
       */
      T,
      /**
       * @default 'Thirty-Eight'
       */
      T,
      /**
       * @default 'Thirty-Nine'
       */
      T,
      /**
       * @default 'Forty'
       */
      T,
      /**
       * @default 'Forty-One'
       */
      T,
      /**
       * @default 'Forty-Two'
       */
      T,
      /**
       * @default 'Forty-Three'
       */
      T,
      /**
       * @default 'Forty-Four'
       */
      T,
      /**
       * @default 'Forty-Five'
       */
      T,
      /**
       * @default 'Forty-Six'
       */
      T,
      /**
       * @default 'Forty-Seven'
       */
      T,
      /**
       * @default 'Forty-Eight'
       */
      T,
      /**
       * @default 'Forty-Nine'
       */
      T,
      /**
       * @default 'Fifty'
       */
      T,
      /**
       * @default 'Fifty-One'
       */
      T,
      /**
       * @default 'Fifty-Two'
       */
      T,
      /**
       * @default 'Fifty-Three'
       */
      T,
      /**
       * @default 'Fifty-Four'
       */
      T,
      /**
       * @default 'Fifty-Five'
       */
      T,
      /**
       * @default 'Fifty-Six'
       */
      T,
      /**
       * @default 'Fifty-Seven'
       */
      T,
      /**
       * @default 'Fifty-Eight'
       */
      T,
      /**
       * @default 'Fifty-Nine'
       */
      T,
      /**
       * @default 'Sixty'
       */
      T,
      /**
       * @default 'Sixty-One'
       */
      T,
      /**
       * @default 'Sixty-Two'
       */
      T,
      /**
       * @default 'Sixty-Three'
       */
      T,
      /**
       * @default 'Sixty-Four'
       */
      T,
      /**
       * @default 'Sixty-Five'
       */
      T,
      /**
       * @default 'Sixty-Six'
       */
      T,
      /**
       * @default 'Sixty-Seven'
       */
      T,
      /**
       * @default 'Sixty-Eight'
       */
      T,
      /**
       * @default 'Sixty-Nine'
       */
      T,
      /**
       * @default 'Seventy'
       */
      T,
      /**
       * @default 'Seventy-One'
       */
      T,
      /**
       * @default 'Seventy-Two'
       */
      T,
      /**
       * @default 'Seventy-Three'
       */
      T,
      /**
       * @default 'Seventy-Four'
       */
      T,
      /**
       * @default 'Seventy-Five'
       */
      T,
      /**
       * @default 'Seventy-Six'
       */
      T,
      /**
       * @default 'Seventy-Seven'
       */
      T,
      /**
       * @default 'Seventy-Eight'
       */
      T,
      /**
       * @default 'Seventy-Nine'
       */
      T,
      /**
       * @default 'Eighty'
       */
      T,
      /**
       * @default 'Eighty-One'
       */
      T,
      /**
       * @default 'Eighty-Two'
       */
      T,
      /**
       * @default 'Eighty-Three'
       */
      T,
      /**
       * @default 'Eighty-Four'
       */
      T,
      /**
       * @default 'Eighty-Five'
       */
      T,
      /**
       * @default 'Eighty-Six'
       */
      T,
      /**
       * @default 'Eighty-Seven'
       */
      T,
      /**
       * @default 'Eighty-Eight'
       */
      T,
      /**
       * @default 'Eighty-Nine'
       */
      T,
      /**
       * @default 'Ninety'
       */
      T,
      /**
       * @default 'Ninety-One'
       */
      T,
      /**
       * @default 'Ninety-Two'
       */
      T,
      /**
       * @default 'Ninety-Three'
       */
      T,
      /**
       * @default 'Ninety-Four'
       */
      T,
      /**
       * @default 'Ninety-Five'
       */
      T,
      /**
       * @default 'Ninety-Six'
       */
      T,
      /**
       * @default 'Ninety-Seven'
       */
      T,
      /**
       * @default 'Ninety-Eight'
       */
      T,
      /**
       * @default 'Ninety-Nine'
       */
      T,
    ];

    cardinalOclockQuarters: [
      /**
       * @default 'Twelve O'Clock'
       */
      T,
      /**
       * @default 'Twelve Fifteen'
       */
      T,
      /**
       * @default 'Twelve Thirty'
       */
      T,
      /**
       * @default 'Twelve Forty-Five'
       */
      T,
      /**
       * @default 'One O'Clock'
       */
      T,
      /**
       * @default 'One Fifteen'
       */
      T,
      /**
       * @default 'One Thirty'
       */
      T,
      /**
       * @default 'One Forty-Five'
       */
      T,
      /**
       * @default 'Two O'Clock'
       */
      T,
      /**
       * @default 'Two Fifteen'
       */
      T,
      /**
       * @default 'Two Thirty'
       */
      T,
      /**
       * @default 'Two Forty-Five'
       */
      T,
      /**
       * @default 'Three O'Clock'
       */
      T,
      /**
       * @default 'Three Fifteen'
       */
      T,
      /**
       * @default 'Three Thirty'
       */
      T,
      /**
       * @default 'Three Forty-Five'
       */
      T,
      /**
       * @default 'Four O'Clock'
       */
      T,
      /**
       * @default 'Four Fifteen'
       */
      T,
      /**
       * @default 'Four Thirty'
       */
      T,
      /**
       * @default 'Four Forty-Five'
       */
      T,
      /**
       * @default 'Five O'Clock'
       */
      T,
      /**
       * @default 'Five Fifteen'
       */
      T,
      /**
       * @default 'Five Thirty'
       */
      T,
      /**
       * @default 'Five Forty-Five'
       */
      T,
      /**
       * @default 'Six O'Clock'
       */
      T,
      /**
       * @default 'Six Fifteen'
       */
      T,
      /**
       * @default 'Six Thirty'
       */
      T,
      /**
       * @default 'Six Forty-Five'
       */
      T,
      /**
       * @default 'Seven O'Clock'
       */
      T,
      /**
       * @default 'Seven Fifteen'
       */
      T,
      /**
       * @default 'Seven Thirty'
       */
      T,
      /**
       * @default 'Seven Forty-Five'
       */
      T,
      /**
       * @default 'Eight O'Clock'
       */
      T,
      /**
       * @default 'Eight Fifteen'
       */
      T,
      /**
       * @default 'Eight Thirty'
       */
      T,
      /**
       * @default 'Eight Forty-Five'
       */
      T,
      /**
       * @default 'Nine O'Clock'
       */
      T,
      /**
       * @default 'Nine Fifteen'
       */
      T,
      /**
       * @default 'Nine Thirty'
       */
      T,
      /**
       * @default 'Nine Forty-Five'
       */
      T,
      /**
       * @default 'Ten O'Clock'
       */
      T,
      /**
       * @default 'Ten Fifteen'
       */
      T,
      /**
       * @default 'Ten Thirty'
       */
      T,
      /**
       * @default 'Ten Forty-Five'
       */
      T,
      /**
       * @default 'Eleven O'Clock'
       */
      T,
      /**
       * @default 'Eleven Fifteen'
       */
      T,
      /**
       * @default 'Eleven Thirty'
       */
      T,
      /**
       * @default 'Eleven Forty-Five'
       */
      T,
    ];

    ordinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default 'First'
       */
      T,
      /**
       * @default 'Second'
       */
      T,
      /**
       * @default 'Third'
       */
      T,
      /**
       * @default 'Fourth'
       */
      T,
      /**
       * @default 'Fifth'
       */
      T,
      /**
       * @default 'Sixth'
       */
      T,
      /**
       * @default 'Seventh'
       */
      T,
      /**
       * @default 'Eighth'
       */
      T,
      /**
       * @default 'Ninth'
       */
      T,
      /**
       * @default 'Tenth'
       */
      T,
      /**
       * @default 'Eleventh'
       */
      T,
      /**
       * @default 'Twelfth'
       */
      T,
      /**
       * @default 'Thirteenth'
       */
      T,
      /**
       * @default 'Fourteenth'
       */
      T,
      /**
       * @default 'Fifteenth'
       */
      T,
      /**
       * @default 'Sixteenth'
       */
      T,
      /**
       * @default 'Seventeenth'
       */
      T,
      /**
       * @default 'Eighteenth'
       */
      T,
      /**
       * @default 'Nineteenth'
       */
      T,
      /**
       * @default 'Twentieth'
       */
      T,
      /**
       * @default 'Twenty-First'
       */
      T,
      /**
       * @default 'Twenty-Second'
       */
      T,
      /**
       * @default 'Twenty-Third'
       */
      T,
      /**
       * @default 'Twenty-Fourth'
       */
      T,
      /**
       * @default 'Twenty-Fifth'
       */
      T,
      /**
       * @default 'Twenty-Sixth'
       */
      T,
      /**
       * @default 'Twenty-Seventh'
       */
      T,
      /**
       * @default 'Twenty-Eighth'
       */
      T,
      /**
       * @default 'Twenty-Ninth'
       */
      T,
      /**
       * @default 'Thirtieth'
       */
      T,
      /**
       * @default 'Thirty-First'
       */
      T,
      /**
       * @default 'Thirty-Second'
       */
      T,
      /**
       * @default 'Thirty-Third'
       */
      T,
      /**
       * @default 'Thirty-Fourth'
       */
      T,
      /**
       * @default 'Thirty-Fifth'
       */
      T,
      /**
       * @default 'Thirty-Sixth'
       */
      T,
      /**
       * @default 'Thirty-Seventh'
       */
      T,
      /**
       * @default 'Thirty-Eighth'
       */
      T,
      /**
       * @default 'Thirty-Ninth'
       */
      T,
      /**
       * @default 'Fortieth'
       */
      T,
      /**
       * @default 'Forty-First'
       */
      T,
      /**
       * @default 'Forty-Second'
       */
      T,
      /**
       * @default 'Forty-Third'
       */
      T,
      /**
       * @default 'Forty-Fourth'
       */
      T,
      /**
       * @default 'Forty-Fifth'
       */
      T,
      /**
       * @default 'Forty-Sixth'
       */
      T,
      /**
       * @default 'Forty-Seventh'
       */
      T,
      /**
       * @default 'Forty-Eighth'
       */
      T,
      /**
       * @default 'Forty-Ninth'
       */
      T,
      /**
       * @default 'Fiftieth'
       */
      T,
      /**
       * @default 'Fifty-First'
       */
      T,
      /**
       * @default 'Fifty-Second'
       */
      T,
      /**
       * @default 'Fifty-Third'
       */
      T,
      /**
       * @default 'Fifty-Fourth'
       */
      T,
      /**
       * @default 'Fifty-Fifth'
       */
      T,
      /**
       * @default 'Fifty-Sixth'
       */
      T,
      /**
       * @default 'Fifty-Seventh'
       */
      T,
      /**
       * @default 'Fifty-Eighth'
       */
      T,
      /**
       * @default 'Fifty-Ninth'
       */
      T,
      /**
       * @default 'Sixtieth'
       */
      T,
      /**
       * @default 'Sixty-First'
       */
      T,
      /**
       * @default 'Sixty-Second'
       */
      T,
      /**
       * @default 'Sixty-Third'
       */
      T,
      /**
       * @default 'Sixty-Fourth'
       */
      T,
      /**
       * @default 'Sixty-Fifth'
       */
      T,
      /**
       * @default 'Sixty-Sixth'
       */
      T,
      /**
       * @default 'Sixty-Seventh'
       */
      T,
      /**
       * @default 'Sixty-Eighth'
       */
      T,
      /**
       * @default 'Sixty-Ninth'
       */
      T,
      /**
       * @default 'Seventieth'
       */
      T,
      /**
       * @default 'Seventy-First'
       */
      T,
      /**
       * @default 'Seventy-Second'
       */
      T,
      /**
       * @default 'Seventy-Third'
       */
      T,
      /**
       * @default 'Seventy-Fourth'
       */
      T,
      /**
       * @default 'Seventy-Fifth'
       */
      T,
      /**
       * @default 'Seventy-Sixth'
       */
      T,
      /**
       * @default 'Seventy-Seventh'
       */
      T,
      /**
       * @default 'Seventy-Eighth'
       */
      T,
      /**
       * @default 'Seventy-Ninth'
       */
      T,
      /**
       * @default 'Eightieth'
       */
      T,
      /**
       * @default 'Eighty-First'
       */
      T,
      /**
       * @default 'Eighty-Second'
       */
      T,
      /**
       * @default 'Eighty-Third'
       */
      T,
      /**
       * @default 'Eighty-Fourth'
       */
      T,
      /**
       * @default 'Eighty-Fifth'
       */
      T,
      /**
       * @default 'Eighty-Sixth'
       */
      T,
      /**
       * @default 'Eighty-Seventh'
       */
      T,
      /**
       * @default 'Eighty-Eighth'
       */
      T,
      /**
       * @default 'Eighty-Ninth'
       */
      T,
      /**
       * @default 'Ninetieth'
       */
      T,
      /**
       * @default 'Ninety-First'
       */
      T,
      /**
       * @default 'Ninety-Second'
       */
      T,
      /**
       * @default 'Ninety-Third'
       */
      T,
      /**
       * @default 'Ninety-Fourth'
       */
      T,
      /**
       * @default 'Ninety-Fifth'
       */
      T,
      /**
       * @default 'Ninety-Sixth'
       */
      T,
      /**
       * @default 'Ninety-Seventh'
       */
      T,
      /**
       * @default 'Ninety-Eighth'
       */
      T,
      /**
       * @default 'Ninety-Ninth'
       */
      T,
    ];

    numericOrdinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default '1st'
       */
      T,
      /**
       * @default '2nd'
       */
      T,
      /**
       * @default '3rd'
       */
      T,
      /**
       * @default '4th'
       */
      T,
      /**
       * @default '5th'
       */
      T,
      /**
       * @default '6th'
       */
      T,
      /**
       * @default '7th'
       */
      T,
      /**
       * @default '8th'
       */
      T,
      /**
       * @default '9th'
       */
      T,
      /**
       * @default '10th'
       */
      T,
      /**
       * @default '11th'
       */
      T,
      /**
       * @default '12th'
       */
      T,
      /**
       * @default '13th'
       */
      T,
      /**
       * @default '14th'
       */
      T,
      /**
       * @default '15th'
       */
      T,
      /**
       * @default '16th'
       */
      T,
      /**
       * @default '17th'
       */
      T,
      /**
       * @default '18th'
       */
      T,
      /**
       * @default '19th'
       */
      T,
      /**
       * @default '20th'
       */
      T,
      /**
       * @default '21st'
       */
      T,
      /**
       * @default '22nd'
       */
      T,
      /**
       * @default '23rd'
       */
      T,
      /**
       * @default '24th'
       */
      T,
      /**
       * @default '25th'
       */
      T,
      /**
       * @default '26th'
       */
      T,
      /**
       * @default '27th'
       */
      T,
      /**
       * @default '28th'
       */
      T,
      /**
       * @default '29th'
       */
      T,
      /**
       * @default '30th'
       */
      T,
      /**
       * @default '31st'
       */
      T,
    ];
    timeOfDay: {
      /**
       * @default 'Midnight'
       */
      midnight: T;

      /**
       * @default 'Noon'
       */
      noon: T;

      /**
       * @default 'in the Morning'
       */
      morning: T;

      /**
       * @default 'in the Afternoon'
       */
      afternoon: T;

      /**
       * @default 'in the Evening'
       */
      evening: T;
    };
  };
  quick: {
    /**
     * @default 'View all colors'
     */
    '87ISX': T;

    /**
     * @default 'Oops, we're experiencing some trouble!'
     */
    ApxzQ: T;

    /**
     * @default 'We're unable to process your order at this time. Our team will contact you shortly.'
     */
    Ba72G: T;

    /**
     * @default 'Go to Invitations'
     */
    '3Br2M': T;

    /**
     * @default 'Go to Save the Date'
     */
    NthuK: T;

    /**
     * @default 'Payment Details'
     */
    u1SR2: T;

    /**
     * @default 'Product Overview Video'
     */
    joJrb: T;

    /**
     * @default 'Shipping Method'
     */
    xd9PF: T;

    /**
     * @default 'Standard DHL Shipping'
     */
    Rf64T: T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'FREE'
     */
    KQ6KA: T;

    /**
     * @default 'Arrives in 3-4 business days'
     */
    '4euYd': T;

    /**
     * @default 'Order Details'
     */
    AroHV: T;

    /**
     * @default 'Ordered {{0}}'
     */
    zdfwJ: T;

    /**
     * @default 'Order Number'
     */
    PpyQe: T;

    /**
     * @default 'Shipping to'
     */
    '50pC2': T;

    /**
     * @default 'Need help with your order?'
     */
    dv5tV: T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Invitations'
     */
    KVw3t: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Design Concierge will personalize the card with all your details after the order has been placed.'
     */
    UB53j: T;

    /**
     * @default 'Please add your shipping details.'
     */
    '67hEG': T;

    /**
     * @default '{{0}} Cards {{1}} ({{2}} each)'
     */
    wh56Z: T;

    /**
     * @default 'Order Summary'
     */
    '8XV9D': T;

    /**
     * @default 'Quantity'
     */
    tT8ln: T;

    /**
     * @default '{{0}} Cards'
     */
    '9OZ5h': T;

    /**
     * @default 'Upgrade to magnet (+ {{0}} per card)'
     */
    ciTUk: T;

    /**
     * @default 'Promo code {{0}} applied'
     */
    JxqRS: T;

    /**
     * @default 'Subtotal'
     */
    '2Ys37': T;

    /**
     * @default 'in {{0}}'
     */
    PGFsa: T;

    /**
     * @default 'Shipping Details'
     */
    '2tfOM': T;

    /**
     * @default 'We currently support only addresses in the US.'
     */
    '9Nl5u': T;

    /**
     * @default 'Add Shipping Details'
     */
    Z86pJ: T;

    /**
     * @default 'Tariffs may apply.'
     */
    '2SADl': T;

    /**
     * @default 'See how we help.'
     */
    YdAck: T;

    /**
     * @default 'Buy Now'
     */
    kOZfF: T;

    /**
     * @default 'Congratulations! We’ve received your order.'
     */
    eCVOp: T;

    /**
     * @default 'Order {{0}}'
     */
    '6DQZR': T;

    /**
     * @default 'We’ve sent an email confirmation for your order and the next steps to'
     */
    DhUA5: T;

    /**
     * @default 'Includes:'
     */
    l0PnF: T;

    /**
     * @default 'The Suite Includes:'
     */
    aj2of: T;

    /**
     * @default 'Card Details'
     */
    '6XHhW': T;

    /**
     * @default 'Fill out the form below to provide details, so the design concierge team can create the first draft of your card.'
     */
    '0hYFR': T;

    /**
     * @default 'We'll send you the link to fill out the form and provide details, so the design concierge team can create the first draft of your card.'
     */
    '3X9pb': T;

    /**
     * @default 'Design Preview'
     */
    CN79V: T;

    /**
     * @default 'Design concierge team begins working on your customized design based on the information you provided in the form.'
     */
    t44Mz: T;

    /**
     * @default 'Feedback & Changes'
     */
    M69BE: T;

    /**
     * @default 'You'll receive a link via email to provide your feedback and work with your designer to get the cards just the way you want them!'
     */
    jyAHY: T;

    /**
     * @default 'Printing'
     */
    '3qcVc': T;

    /**
     * @default 'Only when you're fully satisfied with the designs, we'll send them to be printed.'
     */
    '43p2D': T;

    /**
     * @default 'What's next?'
     */
    YycnG: T;

    /**
     * @default 'Provide Card Details'
     */
    '3beEo': T;

    /**
     * @default 'Personalization with Joy concierge design services'
     */
    '5YRkd': T;

    /**
     * @default 'Recipient and return address printing'
     */
    '9xxLs': T;

    /**
     * @default 'Photographed design suggestions such as ribbons, wax seals, string, etc are not included unless specifically stated'
     */
    naVuw: T;

    /**
     * @default 'Printed on quality premium paper'
     */
    tH9mf: T;

    /**
     * @default 'Customize with your own choice of photo'
     */
    GVImG: T;

    /**
     * @default 'Wax seals are not included, but can easily be purchased externally'
     */
    lrk9Y: T;

    /**
     * @default 'Photo gatefold wedding invitation card, 10" x 7" on 380 GSM premium paper'
     */
    '7UbRR': T;

    /**
     * @default 'This bundle includes a delicate vellum bellyband, measuring 10.5" × 2" and 80 GSM, to wrap around your invitations for a finished look'
     */
    pwwDu: T;

    /**
     * @default 'Free premium white envelopes included with each invitation'
     */
    JGyRf: T;

    /**
     * @default 'Earthy tone invitation package perfect for those wanting neutral colors'
     */
    WTzEf: T;

    /**
     * @default 'This set includes a wedding invitation, a details card which has the RSVP details on the back'
     */
    WdzD9: T;

    /**
     * @default 'A bellyband to keep it all together and to add a finished touch'
     */
    Btz7i: T;

    /**
     * @default 'Almond color envelopes as seen in the video'
     */
    '1aOwQ': T;

    /**
     * @default 'Wedding invitation card, 5" x 7", on 300GSM cotton'
     */
    ldf97: T;

    /**
     * @default 'Wedding details card, 5" x 7" half arch on 300 GSM almond paper'
     */
    '3r4bP': T;

    /**
     * @default 'Bellyband 120 GSM matte'
     */
    onchm: T;

    /**
     * @default 'Premium almond color envelopes with options to select to grey, or harvest'
     */
    xSdf3: T;

    /**
     * @default 'Deep forest colors combined with elegant neutrals combine for a refined but natural look'
     */
    '3gOlE': T;

    /**
     * @default 'Each set comes with gold paper clips to keep all your cards together'
     */
    '6rxuv': T;

    /**
     * @default 'Includes premium almond color envelopes included'
     */
    F8BxQ: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on Forest Green 300GSM paper with white ink'
     */
    DVpzm: T;

    /**
     * @default 'Details card, 4.2" x 5.5" curved edge on 300 GSM Almond Paper'
     */
    gkVyq: T;

    /**
     * @default 'RSVP card, 4.2" x 2.1" land scape arch on 300GSM paper'
     */
    '2GKdQ': T;

    /**
     * @default 'Premium Almond Envelope'
     */
    OLGV9: T;

    /**
     * @default 'Gold color paper clip'
     */
    tsQ2O: T;

    /**
     * @default 'When it comes to adding all the wedding info we like to keep it simple and elegant as possible.'
     */
    W8MYl: T;

    /**
     * @default 'This set includes arch shape invitations printed on beautiful cotton paper'
     */
    bl54J: T;

    /**
     * @default 'Matching double-sided information card to include all your wedding day finer details'
     */
    lQQKj: T;

    /**
     * @default 'A small landscape arch shape RSVP card, with the option to add your wedding website QR code'
     */
    te43N: T;

    /**
     * @default 'Free black envelopes included'
     */
    AKH28: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on premium 300 GSM cotten paper'
     */
    MlVD3: T;

    /**
     * @default 'Details card,  4.2" x 5.5" rounded edge on 300 GSM almond paper'
     */
    OJItD: T;

    /**
     * @default 'RSVP card, 4.2" x 2.1" landscape arch on 270 GSM black paper with white ink'
     */
    '0cYmG': T;

    /**
     * @default 'Premium black envelopes with white ink'
     */
    wQrYv: T;

    /**
     * @default 'Make a grand entrance into your special day with this {{0}} invitation set'
     */
    eHKwD: T;

    /**
     * @default 'Printed on shimmery metallic paper for a subtle glow'
     */
    yXEsM: T;

    /**
     * @default 'Matching arch shaped wedding information card that fits perfectly with the main invitation'
     */
    '4WKhD': T;

    /**
     * @default 'A small landscape arch RSVP card, with the option to add your wedding website QR code on'
     */
    Vav9g: T;

    /**
     * @default 'Free Almond color envelopes included to match the invitation set tones'
     */
    er6sL: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on 300 GSM metallic paper'
     */
    d82We: T;

    /**
     * @default 'Details card, 5.8" x 3.7" arch on 300 GSM metallic paper'
     */
    NtkKa: T;

    /**
     * @default 'RSVP card, 4.2" x 2.1" landscape arch on 300 GSM metallic paper'
     */
    fBG0g: T;

    /**
     * @default 'Premium almond color envelope'
     */
    rOaaN: T;

    /**
     * @default 'Gold paper clips to keep all your cards together'
     */
    ixKoL: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitations set foil-printed and intertwined with delicate floral print bellyband.'
     */
    VRmWL: T;

    /**
     * @default 'A matching information card'
     */
    Q2kFM: T;

    /**
     * @default 'Transparent vellum bellyband to keep it all together and to add a finished touch'
     */
    jLfB4: T;

    /**
     * @default 'Gold foil invitation card, 5"x 7" on premium 380 GSM paper'
     */
    J4U2U: T;

    /**
     * @default 'Details card, 4.2" x 5.5" on premium 380 GSM paper'
     */
    kz3SC: T;

    /**
     * @default 'Vellum bellyband, 10.5" x 2"  80 GSM '
     */
    TIBpp: T;

    /**
     * @default 'Premium white envelope'
     */
    KCYZS: T;

    /**
     * @default 'The {{0}} invitations are a perfect way to send your guests all the info they need for the day.'
     */
    hRtWH: T;

    /**
     * @default 'Printed on our Premium paper with high quality photo printing on the outside'
     */
    BmIOV: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details, RSVP, and wedding timeline'
     */
    ZV9oP: T;

    /**
     * @default 'Harvest color envelopes included with each invitation'
     */
    Ly6np: T;

    /**
     * @default 'Gatefold Wedding Invitation, 10" x 7" on premium 380 GSM paper'
     */
    '5nCsJ': T;

    /**
     * @default 'Premium harvest color envelopes'
     */
    O5okN: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    nOEBH: T;

    /**
     * @default 'Matching double-sided information card that is big enough for all your wedding details'
     */
    iDjKU: T;

    /**
     * @default 'Small green name card that can be used as a guest name card to tie in a hint of green to this suit.'
     */
    Wpmer: T;

    /**
     * @default 'Free Grey envelopes with each invitation set.'
     */
    OI2km: T;

    /**
     * @default 'Wedding invitation card, 5"x7" arch on Premium 300 GSM Cotten Paper'
     */
    Qhe3k: T;

    /**
     * @default 'Details card,  4.2" x 5.5" half arch on 300 GSM cotton paper'
     */
    tD30z: T;

    /**
     * @default 'Guest name card,  3.1" x 3.7"'
     */
    '9mh4O': T;

    /**
     * @default 'Premium grey envelopes'
     */
    TKwBb: T;

    /**
     * @default 'The {{0}} all-in-one Gatefold design is a combination of curvy die-cut and elegant typography'
     */
    '6VeR2': T;

    /**
     * @default 'Customize with your own photo on the inside '
     */
    eOTbT: T;

    /**
     * @default 'Printed on our Premium paper with high quality photo printing'
     */
    gd1Am: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details and RSVP information'
     */
    '8GsfW': T;

    /**
     * @default 'Black envelopes included with each invitation'
     */
    K1ecZ: T;

    /**
     * @default 'Gatefold Wedding Invitation, 11.8" x 7" side wave on premium 380 GSM paper'
     */
    '4d16C': T;

    /**
     * @default 'All your invitation, RSVP, and wedding details in one gatefold card'
     */
    EAMyA: T;

    /**
     * @default 'Customize with your own photo on the inside'
     */
    IBcGq: T;

    /**
     * @default 'Free Almond color envelopes with each invitation'
     */
    LWGHg: T;

    /**
     * @default 'Premium almond color envelopes'
     */
    MrXZS: T;

    /**
     * @default 'The {{0}} invitation is for those flower and nature lovers, sure to set the tone for your special day.'
     */
    '40Tqo': T;

    /**
     * @default 'Printed on our Premium paper with high quality print showing all the vibrant colors this design has to offer'
     */
    yuACj: T;

    /**
     * @default 'Free envelopes to match for each invitation with a choice of Forest Green or Peach colored envelopes '
     */
    QqaTp: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 380GSM premium paper'
     */
    '58bK4': T;

    /**
     * @default 'Premium envelopes in forest green or peach'
     */
    '9g0s8': T;

    /**
     * @default 'Printed in white ink on our rich and vibrant Forest Green paper stock'
     */
    OmcCn: T;

    /**
     * @default 'Almond envelopes included with each invitation.'
     */
    Ao1kf: T;

    /**
     * @default 'Printed in white ink on rich and vibrant Forest Green paper'
     */
    gQYfl: T;

    /**
     * @default 'Die-cut Gatefold Wedding Invitation, 11.8" x 7" side wave on premium 300 GSM paper'
     */
    '5iYQR': T;

    /**
     * @default 'The {{0}} gatefold invitation is for those flower lovers and sure to set the tone for your special day.'
     */
    F5ZyZ: T;

    /**
     * @default 'Printed on our Premium paper with high quality print showing all the vibrant colors this design has to offer '
     */
    '4tCuO': T;

    /**
     * @default 'Tied together with a kraft color bellyband '
     */
    vfa2M: T;

    /**
     * @default ' Almond envelopes included with each invitation'
     */
    M9jBj: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 380 GSM premium paper'
     */
    Tl3Db: T;

    /**
     * @default 'Kraft bellyband, 10.5" x 2" 80 GSM'
     */
    '41lUH': T;

    /**
     * @default 'The {{0}} gatefold invitation is for those flower and nature lovers, sure to set the tone for your special day.'
     */
    ScAF2: T;

    /**
     * @default 'This all-in-one wedding invitation includes space for all your wedding day detail, RSVP and wedding day timeline information.'
     */
    dwauN: T;

    /**
     * @default 'Almond color envelopes and envelope liners included with each invitation set (Please note: envelope liners do not come assembled.'
     */
    glH6H: T;

    /**
     * @default 'Ribbon and wax seals are not included. They can be purchased externally.'
     */
    oPzVf: T;

    /**
     * @default 'Delicate Leaves envelope liners'
     */
    eONuk: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation set foil-printed '
     */
    HxrH2: T;

    /**
     * @default 'Paired with a delicate transparent (vellum) info card. '
     */
    RG3F4: T;

    /**
     * @default 'Almond color envelopes included with each invitation set.'
     */
    fiXjO: T;

    /**
     * @default 'Wedding invitation card, 5" x 7", on 380 GSM premium paper'
     */
    VjAje: T;

    /**
     * @default 'Information card, 4.2" x 5.5," on 180 GSM Vellum with white ink'
     */
    LpiAh: T;

    /**
     * @default 'All your invitation, RSVP, and wedding details in one arch shape tri-fold '
     */
    UgyNE: T;

    /**
     * @default 'Printed on our Premium Almond colored paper'
     */
    FtYrv: T;

    /**
     * @default 'This all-in-one wedding invitation includes space for all your wedding day finer details and RSVP information'
     */
    pfoOq: T;

    /**
     * @default 'Trifold wedding invitation card, 5" x 16.5" (5" x 7" folded) on 300 GSM almond colored paper'
     */
    RsPMY: T;

    /**
     * @default 'Vibrant red and blush tones invitation package is perfect for those wanting a pop of color'
     */
    zEv6v: T;

    /**
     * @default 'This set includes a wedding invitation, wedding info card with RSVP details included'
     */
    Shp7p: T;

    /**
     * @default 'An extra card on top with a customizable quote or your names printed on it'
     */
    khFnF: T;

    /**
     * @default 'Free Premium white envelopes'
     */
    '5zyT5': T;

    /**
     * @default 'Gold paperclips included with each set.'
     */
    y3TZg: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" on Blush 300 GSM paper'
     */
    GIprQ: T;

    /**
     * @default 'Details and RSVP card, 4.3" x 7" side wave edge on Red 270 GSM paper with white ink'
     */
    o7RNm: T;

    /**
     * @default 'Top card, 3.7" x 7" side wave edge on 300 GSM cotton paper'
     */
    Bb7SZ: T;

    /**
     * @default 'Premium white envelopes'
     */
    JE21w: T;

    /**
     * @default 'This set includes a: Wedding invitation, Wedding timeline (program) card with schedule information, and an information card with all the wedding details and RSVP information'
     */
    OdoCG: T;

    /**
     * @default 'Almond color envelopes included.'
     */
    bxYDG: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" on 300 GSM harvest color paper with white ink'
     */
    '5vrR6': T;

    /**
     * @default 'Program card,  4.3" x 7" side arch on 300 GSM almond color paper'
     */
    '83pUm': T;

    /**
     * @default 'Info and RSVP card, 3.7" x 5.8" side arch on 300 GSM cotton paper'
     */
    ouFNb: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning new typography and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    vrrGx: T;

    /**
     * @default 'Matching double-sided information RSVP card '
     */
    d7EAX: T;

    /**
     * @default 'Small grey name card that can be used as a guest name card and as a place card for your on-the-day stationery'
     */
    VPzif: T;

    /**
     * @default 'Seedling green envelopes included with each invitation set. '
     */
    vlf4u: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on premium 300 GSM seedling color paper with white ink'
     */
    qUMVM: T;

    /**
     * @default 'Details card,  3.7" x 5.7" arch on 300 GSM almond color paper'
     */
    FwjyO: T;

    /**
     * @default 'Guest name card,  3.1" x 3.7" half arch on 300 GSM grey color paper with white ink'
     */
    wDCsQ: T;

    /**
     * @default 'Premium seedling green color envelopes'
     */
    T29Si: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation set '
     */
    '4uyHY': T;

    /**
     * @default 'Blush RSVP post-card with your address printed on, making it easier for your guests to rsvp'
     */
    '4NPxQ': T;

    /**
     * @default 'An information card in elegant shade of grey for all the finer details of your big day'
     */
    sVBYe: T;

    /**
     * @default 'A matching foil printed bellyband to tie it all in together '
     */
    HNSBA: T;

    /**
     * @default 'Free white envelopes included with each invitation set.'
     */
    KP30y: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" on premium 380 GSM paper with gold foil'
     */
    '5dgJa': T;

    /**
     * @default 'Details card,  4.2" x 5.5" on 300 GSM grey color paper'
     */
    bzVuS: T;

    /**
     * @default 'RSVP card,  5.5" x 4.2" on 300 GSM blush color paper'
     */
    FguXm: T;

    /**
     * @default 'Bellyband, 10.5" x 2" on 120 GSM with gold foil'
     */
    WsYmO: T;

    /**
     * @default 'The {{0}} invitation blends soft duck-egg blue artwork and classic typography for a refined, romantic look.'
     */
    '6RWgi': T;

    /**
     * @default 'Three-panel, arch-top trifold keeps your invitation, details and RSVP neatly in one all-in-one format.'
     */
    WxDjN: T;

    /**
     * @default 'Printed on 300 gsm Matte Paper for a smooth, luxurious feel and crisp, high-quality reproduction of the design.'
     */
    '8o42K': T;

    /**
     * @default 'Includes a complimentary envelope in your choice of Almond or Desert Blue to complete the suite.'
     */
    SBWrb: T;

    /**
     * @default 'Trifold wedding invitation card, 5" x 16" (5" x 7" folded) on 300 GSM almond colored paper.'
     */
    Q0Ulh: T;

    /**
     * @default 'Premium almond or desert blue color envelopes.'
     */
    IGtXT: T;

    /**
     * @default 'Matching double-sided information RSVP card'
     */
    dFbnG: T;

    /**
     * @default 'Small Hunter Green name card'
     */
    ZfMEb: T;

    /**
     * @default 'Hunter Green envelopes and Delicate Leaves liners included with each invitation set.'
     */
    xdsWT: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on 300 GSM almond paper'
     */
    HFG7y: T;

    /**
     * @default 'Place card, 4.2" x 2.1" landscape arch on Hunter Green 300 GSM paper'
     */
    numpd: T;

    /**
     * @default 'RSVP card, 4.2" x 5.5" half arch on Cotton 300 GSM paper'
     */
    KZQ42: T;

    /**
     * @default 'Premium Hunter Green envelopes'
     */
    X8EDY: T;

    /**
     * @default 'Envelope liners'
     */
    b8qO3: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and minimalist elegance. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    '125OP': T;

    /**
     * @default 'Black information card that is big enough for all your wedding details and sure to stand out'
     */
    '2BjW5': T;

    /**
     * @default 'Small round RSVP card for you to place your QR code and any additional details'
     */
    RWrH0: T;

    /**
     * @default 'Grey envelopes with each invitation set'
     */
    '4DjvC': T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on 300 GSM cotton paper'
     */
    XDmYr: T;

    /**
     * @default 'Info card, 4.2" x 5.5" half arch on 270 GSM black paper with white ink'
     */
    Mg8zG: T;

    /**
     * @default 'RSVP card, 108mm circle on 300 GSM almond paper'
     */
    gCjBc: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those lavender lovers, sure to set the tone for your special day.'
     */
    K4U3W: T;

    /**
     * @default 'Customize with your own photo on the outside'
     */
    He9Jr: T;

    /**
     * @default 'Printed on our matte paper with high quality photo printing'
     */
    U1hRt: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details'
     */
    eFYcD: T;

    /**
     * @default 'Free white envelopes with each invitation'
     */
    IvnGH: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper'
     */
    '9Q7zI': T;

    /**
     * @default 'Printed on our matte paper with high quality print showing all the vibrant colors this design has to offer'
     */
    gnqbB: T;

    /**
     * @default 'Free white envelopes to match for each invitation'
     */
    XXGmn: T;

    /**
     * @default 'The {{0}} gatefold invitation is an elegant foil design, sure to set the tone for your special day.'
     */
    TMrTC: T;

    /**
     * @default 'Black envelopes included with each invitation set'
     */
    gYh0w: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with gold foil'
     */
    THkRX: T;

    /**
     * @default 'Premium black envelopes'
     */
    Fgcfb: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those nature lovers, sure to set the tone for your special day.'
     */
    kQTci: T;

    /**
     * @default 'Free white envelopes included with each invitation set'
     */
    Ckgmb: T;

    /**
     * @default 'Free Almond envelopes included with each invitation set'
     */
    scgqN: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those fine art lovers, sure to set the tone for your special day.'
     */
    C8AGl: T;

    /**
     * @default 'Free Black envelopes included with each invitation set'
     */
    Ceqvs: T;

    /**
     * @default 'Almond colour envelopes included with each invitation set'
     */
    OaNB0: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with rose gold foil'
     */
    mYeL0: T;

    /**
     * @default 'Free Almond envelopes to match for each invitation'
     */
    pF95X: T;

    /**
     * @default 'Printed on our matte paper with a combination of digital and copper color foil, showing all the vibrant colors this design has to offer'
     */
    giYzD: T;

    /**
     * @default 'Free Forest Green envelopes included with each invitation set'
     */
    nTLag: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with copper foil'
     */
    si8bw: T;

    /**
     * @default 'Premium Forest Green envelopes'
     */
    M8sCU: T;

    /**
     * @default 'Free Seedling green envelopes included with each invitation set'
     */
    RKOgU: T;

    /**
     * @default 'Inspired by the {{0}} shorelines in Australia, this arch shaped copper foil Save the Date is the perfect way to set the tone for your big day.'
     */
    A2aUA: T;

    /**
     * @default 'Upgrade to smooth magnetic backing for a fridge-friendly keepsake.'
     */
    yGEEw: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" arch on luxe 380 GSM paper with copper foil'
     */
    O2Hcy: T;

    /**
     * @default 'The {{0}} double-layer Save the Dates are a delightful blend of playfulness and elegance. The top layer, printed in white ink on delicate vellum, overlays your personalized photo on the second layer, creating a beautiful keepsake.'
     */
    wxbKT: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" on 350 GSM heavyweight paper'
     */
    lQcWN: T;

    /**
     * @default 'Sheer overlay, 4.2" x 5.5" on 180 GSM vellum with white ink'
     */
    EXIh9: T;

    /**
     * @default 'Hole punch (ribbon not included)'
     */
    '2LBNP': T;

    /**
     * @default 'Gold fastener'
     */
    GS9HG: T;

    /**
     * @default 'Where rustic charm meets minimalism, the {{0}} arch-shaped save the dates perfectly set the tone for your special day.'
     */
    '6hsXO': T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" arch on 300 GSM cotton paper'
     */
    qT3mR: T;

    /**
     * @default 'The double-arch {{0}} Save the Date features a graceful blend of blossom prints and typewriter-style fonts. It's a charming way to announce your special day with a touch of timeless elegance.'
     */
    w7hd0: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" double arch on 300 GSM cotton paper'
     */
    '3CW2e': T;

    /**
     * @default 'Modern typography meets premium cotton paper. The {{0}} is all about simplicity and elegance to set the tone for your big day.'
     */
    Vp9dS: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" on 300 GSM cotton paper'
     */
    O0ll9: T;

    /**
     * @default 'Premium almond envelopes'
     */
    jMQwO: T;

    /**
     * @default 'A blend of gold foil and digital printing, this arch-shaped Save the Date is perfect for setting the tone of your special day. '
     */
    jO9gH: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" arch on luxe 380 GSM paper with gold foil'
     */
    dBwyX: T;

    /**
     * @default 'Personalized photo cards are the perfect way to announce your big day.'
     */
    xSL1l: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" arch on luxe 380 GSM paper'
     */
    zqaXS: T;

    /**
     * @default 'This Foil and personalized photo combo is the perfect way to send out your Save the Dates in style.'
     */
    NO23V: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" on 350 GSM heavyweight paper with gold foil'
     */
    RSPdq: T;

    /**
     * @default 'Announce your big day with your own photo captured on premium stock, creating a keepsake that lasts.'
     */
    qffpG: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" on luxe 380 GSM paper'
     */
    '58Cbm': T;

    /**
     * @default 'The {{0}} double-arch Save the Date is the perfect way to announce your big day, personalized with your very own photo.'
     */
    W2JqC: T;

    /**
     * @default 'Save the Date card, 4.2" x 5.5" double arch on luxe 380 GSM paper with white ink'
     */
    lWkU0: T;

    /**
     * @default '{{0}} Save the Dates are a perfect blend of blue and orange hues, a masterpiece crafted for those who dream of warm sands and the whisper of waves.'
     */
    img8B: T;

    /**
     * @default 'Magnet Upgrade: {{0}} each'
     */
    dlzqY: T;

    /**
     * @default 'Quantity: {{0}} at {{1}} each'
     */
    CPXSB: T;

    /**
     * @default 'Ambient Synth'
     */
    '0TuIv': T;

    /**
     * @default 'Cinematic Strings'
     */
    Z1wVJ: T;

    /**
     * @default 'Gentle Piano'
     */
    qq0UT: T;

    /**
     * @default 'Graceful Harp'
     */
    EAc6x: T;

    /**
     * @default 'Rustic Guitar'
     */
    yUroP: T;

    /**
     * @default 'Serene Chimes'
     */
    DwuuP: T;

    /**
     * @default 'Warm Piano'
     */
    MLy0b: T;

    /**
     * @default 'Signature'
     */
    MTnox: T;

    /**
     * @default 'Our luxurious signature card stock has a velvety cotton texture and elegant eggshell finish.'
     */
    Ha5eU: T;

    /**
     * @default '120lb. / 324gsm'
     */
    Un4py: T;

    /**
     * @default 'Smooth'
     */
    '0ZSgV': T;

    /**
     * @default 'Similar in feel to our signature stock, but with a smooth, matte finish. Recommended for photo cards.'
     */
    sXSEO: T;

    /**
     * @default 'Semi-Gloss'
     */
    DAAEs: T;

    /**
     * @default 'Bright white with a semi-gloss finish. Recommended for photo cards.'
     */
    Xowfz: T;

    /**
     * @default '130lb. / 352gsm'
     */
    kIhL4: T;

    /**
     * @default 'Pearlescent'
     */
    '8t5mM': T;

    /**
     * @default 'Add an elegant iridescence to printed cards and a soft glow to photographs with Pearlescent paper.'
     */
    BDHx2: T;

    /**
     * @default '110lb. / 300gsm'
     */
    FJ9iE: T;

    /**
     * @default 'Double Thick'
     */
    E133j: T;

    /**
     * @default 'Twice as thick as our signature paper, with the same eggshell finish and velvety cotton texture.'
     */
    wNnxQ: T;

    /**
     * @default '240lb. / 648gsm'
     */
    We6Da: T;

    /**
     * @default 'Triple Thick'
     */
    ZPEBA: T;

    /**
     * @default 'Extra thick and luxurious, with the same eggshell finish and cottony texture as our signature paper.'
     */
    XysbF: T;

    /**
     * @default '360lb. / 972gsm'
     */
    '1WbfB': T;

    /**
     * @default 'Save the Date Postcard'
     */
    qSekp: T;

    /**
     * @default 'Thank You Postcard'
     */
    NJGUW: T;

    /**
     * @default 'Save the Date Magnet'
     */
    YnUc5: T;

    /**
     * @default 'Envelope'
     */
    cnOVq: T;

    /**
     * @default 'Economy Shipping'
     */
    KPylT: T;

    /**
     * @default 'Arrives in 14-16 days'
     */
    XPBAi: T;

    /**
     * @default 'Standard Shipping'
     */
    tFU84: T;

    /**
     * @default 'Arrives in 12-14 days'
     */
    Vuo02: T;

    /**
     * @default 'Express Shipping'
     */
    AINFP: T;

    /**
     * @default 'Arrives in 8 days'
     */
    gSIYQ: T;

    /**
     * @default 'International Economy Shipping'
     */
    QSy0U: T;

    /**
     * @default 'Arrives in 12-21 days, tracking only available while in the US'
     */
    gZvxH: T;

    /**
     * @default 'Worldwide Express Shipping'
     */
    j1Jut: T;

    /**
     * @default 'Arrives in 9-12 days'
     */
    FsyvP: T;

    /**
     * @default 'Cocktail'
     */
    '2mIap': T;

    /**
     * @default 'Luncheon'
     */
    Usg2n: T;

    /**
     * @default 'Postcard 4x6'
     */
    aQywe: T;

    /**
     * @default 'Magnet 4x6'
     */
    CCGZD: T;

    /**
     * @default 'Postcard'
     */
    '6XbtV': T;

    /**
     * @default 'Magnet'
     */
    QoHoE: T;

    /**
     * @default 'Envelopes for 5x7'
     */
    '4kJj2': T;

    /**
     * @default 'You've selected 1 new recipient.'
     * @param {number} count - The number of occurrences.
     * - singular: You've selected 1 new recipient.
     * - plural: You've selected {{0}} new recipients.
     */
    '0bHyY': T;

    /**
     * @default 'Only 1 send remains.'
     * @param {number} count - The number of occurrences.
     * - singular: Only 1 send remains.
     * - plural: Only {{0}} sends remain.
     */
    VhgaG: T;

    /**
     * @default 'You've reached your {{0}}-recipient limit.'
     */
    FnqXj: T;

    /**
     * @default 'I would like to purchase additional recipients.'
     */
    SLYjn: T;

    /**
     * @default 'Add-on Pricing'
     */
    xr7XV: T;

    /**
     * @default '{{0}} recipients'
     */
    '6q0wU': T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Queued'
     */
    '5wM0Q': T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Opted Out'
     */
    AWOHo: T;

    /**
     * @default 'This guest opted out of texts from Joy, so we didn’t send this text.'
     */
    mcZME: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Delivered'
     */
    SbKKi: T;

    /**
     * @default 'Read'
     */
    '0E0MA': T;

    /**
     * @default 'Viewed'
     */
    CthHd: T;

    /**
     * @default 'Click any text or photo on your card to change it.'
     */
    '8ysIB': T;

    /**
     * @default 'Front'
     */
    '1CC4F': T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'We couldn’t save your changes. Please try again.'
     */
    gT6Dr: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'We couldn’t load your card. Please try again.'
     */
    '0SBNc': T;

    /**
     * @default 'Edit your card'
     */
    JBgHA: T;

    /**
     * @default 'Designs'
     */
    PRcS2: T;

    /**
     * @default 'Favorites'
     */
    rOPR1: T;

    /**
     * @default 'Drafts'
     */
    q93Js: T;

    /**
     * @default 'Orders'
     */
    HqnSL: T;

    /**
     * @default 'Stationery navigation'
     */
    E5kO7: T;

    /**
     * @default 'View cart'
     */
    zJV2U: T;

    /**
     * @default 'Remove from Favorites'
     */
    bzMSe: T;

    /**
     * @default 'Add to Favorites'
     */
    Dc77o: T;

    /**
     * @default 'Coming Soon'
     */
    ODxS0: T;

    /**
     * @default 'Paper Only'
     */
    CASm0: T;

    /**
     * @default 'Paper & Digital'
     */
    yLGFv: T;

    /**
     * @default 'Disabled (Admin View Only)'
     */
    Rh21r: T;

    /**
     * @default 'Digital Only'
     */
    gebEf: T;

    /**
     * @default 'Premium Digital Available'
     */
    aEZRP: T;

    /**
     * @default 'Stationery'
     */
    khI0P: T;

    /**
     * @default 'Order Placed'
     */
    P7nyi: T;

    /**
     * @default 'Card Preview'
     */
    eTZSZ: T;

    /**
     * @default 'Refunded'
     */
    '3DziC': T;

    /**
     * @default 'Track Delivery'
     */
    TFyjY: T;

    /**
     * @default 'Send More or Resend'
     */
    '9nS7e': T;

    /**
     * @default 'Order Matching Paper Card'
     */
    pirjO: T;

    /**
     * @default 'Select Recipients and Send'
     */
    JxpZj: T;

    /**
     * @default 'Envelopes'
     */
    BSdom: T;

    /**
     * @default 'Paper Save the Date'
     */
    uWD7f: T;

    /**
     * @default 'Paper Invitation'
     */
    l0skr: T;

    /**
     * @default 'Paper Thank You Cards'
     */
    Iufik: T;

    /**
     * @default 'Paper Holiday Cards'
     */
    X00wl: T;

    /**
     * @default 'Paper Enclosure Cards'
     */
    pwTkS: T;

    /**
     * @default 'Paper Napkins'
     */
    uNIPT: T;

    /**
     * @default 'Paper Menus'
     */
    Y0ahN: T;

    /**
     * @default 'Paper Signs'
     */
    wQ1BO: T;

    /**
     * @default 'Refund is Being Processed'
     */
    hgJx3: T;

    /**
     * @default 'You will be refunded within 10 business days.'
     */
    iBWGc: T;

    /**
     * @default 'Shipping To'
     */
    '3jpC2': T;

    /**
     * @default 'Track Your Order'
     */
    CPJrN: T;

    /**
     * @default 'Order Again'
     */
    KF1rM: T;

    /**
     * @default 'Order Matching Digital Card'
     */
    zuyg4: T;

    /**
     * @default 'Order Cancelled'
     */
    FLc3T: T;

    /**
     * @default 'Your order has been successfully cancelled and your refund is being processed within 10 business days.'
     */
    hBEsO: T;

    /**
     * @default 'Order Cancelled on {{0}}'
     */
    Wl6kK: T;

    /**
     * @default 'Your order has been cancelled and your refund has been successfully processed.'
     */
    FRaZV: T;

    /**
     * @default 'We're here to get you sorted.'
     */
    LtDgK: T;

    /**
     * @default 'From {{0}} {{1}}'
     */
    h8T0U: T;

    /**
     * @default 'From {{0}}'
     */
    SXEqF: T;

    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default 'Use code {{0}} at checkout'
     */
    rEoWI: T;

    /**
     * @default 'Printed'
     */
    cPoFk: T;

    /**
     * @default 'Digital'
     */
    gTn5B: T;

    /**
     * @default 'Show Less'
     */
    yPlIB: T;

    /**
     * @default 'More Formats'
     */
    biu8A: T;

    /**
     * @default 'Foil'
     */
    UxELA: T;

    /**
     * @default 'Gold'
     */
    aKOLA: T;

    /**
     * @default 'Rose Gold'
     */
    F912N: T;

    /**
     * @default 'Silver'
     */
    DL8LV: T;

    /**
     * @default 'Paper Type'
     */
    M3Fn0: T;

    /**
     * @default 'Silhouette'
     */
    OMy5V: T;

    /**
     * @default 'Rectangle'
     */
    LZbUv: T;

    /**
     * @default 'Rounded'
     */
    fLwj6: T;

    /**
     * @default 'Arch'
     */
    m0UKA: T;

    /**
     * @default 'Return Address'
     */
    aofaX: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Recipient Addressing'
     */
    bMBSv: T;

    /**
     * @default 'Recipient Address'
     */
    HD8vL: T;

    /**
     * @default 'Have your guests’ addresses printed on the front of each envelope.'
     */
    On5OK: T;

    /**
     * @default 'Leave Blank'
     */
    f3Pd3: T;

    /**
     * @default 'Print Addresses'
     */
    tfbOC: T;

    /**
     * @default 'Card Back'
     */
    VLTu7: T;

    /**
     * @default 'Free Card Back'
     */
    TN3z1: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Delivery Methods'
     */
    '2dRly': T;

    /**
     * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
     */
    '9J3Bv': T;

    /**
     * @default 'Shareable Card Link'
     */
    Py5Au: T;

    /**
     * @default 'Personalized Emails'
     */
    '72Pe9': T;

    /**
     * @default 'Card Delivery:'
     */
    iJALc: T;

    /**
     * @default 'Email Only'
     */
    mWEOR: T;

    /**
     * @default 'Card Delivery: Email Only'
     */
    Cwkwz: T;

    /**
     * @default 'Text message (SMS) to U.S. & Canada'
     */
    Bh9u3: T;

    /**
     * @default 'WhatsApp outside U.S. & Canada'
     */
    ZBom0: T;

    /**
     * @default 'WhatsApp delivery details'
     */
    gnihi: T;

    /**
     * @default 'WhatsApp can't deliver to:'
     */
    J0XcG: T;

    /**
     * @default 'China'
     */
    lTjnF: T;

    /**
     * @default 'Crimea'
     */
    Xt5gp: T;

    /**
     * @default 'Cuba'
     */
    '5XoKA': T;

    /**
     * @default 'Donetsk'
     */
    '8EHXS': T;

    /**
     * @default 'Iran'
     */
    qmhLA: T;

    /**
     * @default 'Luhansk'
     */
    s1rTG: T;

    /**
     * @default 'North Korea'
     */
    XzBt1: T;

    /**
     * @default 'Russia'
     */
    rCggT: T;

    /**
     * @default 'Syria'
     */
    '06w7G': T;

    /**
     * @default 'Text & Email'
     */
    ptFOk: T;

    /**
     * @default 'Card Delivery: Text & Email'
     */
    '9PlHb': T;

    /**
     * @default 'International Text *'
     */
    jCsx2: T;

    /**
     * @default 'Int'l Text & Email'
     */
    '9IHDE': T;

    /**
     * @default 'Card Delivery: Int'l Text & Email'
     */
    JsCmK: T;

    /**
     * @default 'Classic Paper'
     */
    UV8gY: T;

    /**
     * @default 'Paper'
     */
    ebOpG: T;

    /**
     * @default 'Magnets'
     */
    '3etWT': T;

    /**
     * @default 'Premium Digital'
     */
    '394Gz': T;

    /**
     * @default 'Premium Digital Cards'
     */
    yY852: T;

    /**
     * @default 'Napkins'
     */
    a76dt: T;

    /**
     * @default 'Napkin'
     */
    R2pTH: T;

    /**
     * @default 'Signs'
     */
    gSU5G: T;

    /**
     * @default 'Foam Board Signs'
     */
    dVjwr: T;

    /**
     * @default 'Basic Digital'
     */
    OpJEa: T;

    /**
     * @default 'Sample Kit'
     */
    '4NNPF': T;

    /**
     * @default 'Promo Codes'
     */
    ZPI8O: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Enter code'
     */
    RGHPh: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Taxes'
     */
    DvK9G: T;

    /**
     * @default 'Sales Tax'
     */
    pqyDA: T;

    /**
     * @default 'Promo Code: {{0}}{{1}}'
     */
    '7yFLF': T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Silhouette: {{0}}'
     */
    '8gbbT': T;

    /**
     * @default 'Method'
     */
    Jm79E: T;

    /**
     * @default 'Included'
     */
    uXyQw: T;

    /**
     * @default 'Quantity: {{0}}'
     */
    DJUDt: T;

    /**
     * @default '{{0}}: {{1}} at {{2}} each'
     */
    FTpwM: T;

    /**
     * @default '{{0}}: {{1}}'
     */
    '7ggEq': T;

    /**
     * @default 'Shipping'
     */
    iMEjq: T;

    /**
     * @default '{{0}}'s Guest'
     */
    m6E80: T;

    /**
     * @default '{{0}} items at {{1}} each'
     */
    HHAkh: T;

    /**
     * @default 'Digital card preview'
     */
    yehGr: T;

    /**
     * @default 'Free Recipient & Return Addressing'
     */
    '3ECD1': T;

    /**
     * @default 'Your Favorites'
     */
    '81c8y': T;

    /**
     * @default 'Resend the card'
     */
    OHl5l: T;

    /**
     * @default 'Choose the best way to reach {{0}}.'
     */
    '3vjSI': T;

    /**
     * @default '{{0}} remaining'
     */
    '0rtrc': T;

    /**
     * @default 'to 0 of 0 Results'
     * @param {number} count - The number of occurrences.
     * - zero: to 0 of 0 Results
     * - singular: to {{0}} of 1 Result
     * - plural: to {{0}} of {{1}} Results
     */
    J9jXt: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Tier'
     */
    s6JNA: T;

    /**
     * @default 'Premium'
     */
    P2hvj: T;

    /**
     * @default 'Basic'
     */
    cJkhF: T;

    /**
     * @default 'Categories'
     */
    ElZ5Z: T;

    /**
     * @default 'Side'
     */
    VkANA: T;

    /**
     * @default 'Display'
     */
    snW4C: T;

    /**
     * @default 'Auto-fill'
     */
    '1ynSJ': T;

    /**
     * @default 'Labels'
     */
    tfH9B: T;

    /**
     * @default 'Recently Updated'
     */
    '9iN48': T;

    /**
     * @default 'A–Z'
     */
    g5aBA: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Quantity: {{0}} items at {{1}} each'
     */
    aKBZi: T;

    /**
     * @default 'Shipping: {{0}}'
     */
    uBISq: T;

    /**
     * @default 'A selection of cards showcasing each paper type, trim option, and card size'
     */
    BFyan: T;

    /**
     * @default 'Sample Pack'
     */
    nxZHn: T;

    /**
     * @default 'Payment Details — server pricing (admin only)'
     */
    XceWL: T;

    /**
     * @default 'Compare Paper Types'
     */
    mnFpN: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'the couple'
     */
    zzvM8: T;

    /**
     * @default 'Match front colors'
     */
    qpeNE: T;

    /**
     * @default 'You are editing an item in your cart. In order to submit changes, navigate to the final review screen and submit.'
     */
    SLfAf: T;

    /**
     * @default 'Sorry, we couldn't add that. Please try again.'
     */
    O2BuA: T;

    /**
     * @default 'Your item has been added to your cart.'
     */
    KJAJo: T;

    /**
     * @default 'Order paper copies of this card'
     */
    '2sMIP': T;

    /**
     * @default 'Get a copy of this card, digitally'
     */
    o5hpm: T;

    /**
     * @default 'This exact card, printed on Signature matte with envelopes included.'
     */
    QlEyj: T;

    /**
     * @default 'Send this exact card as a digital version — great for last-minute additions to your list.'
     */
    ATnMV: T;

    /**
     * @default 'From {{0}} each'
     */
    bre72: T;

    /**
     * @default 'You have paper and digital.'
     */
    UKUx9: T;

    /**
     * @default 'You can reach every guest in whichever way is most convenient for them.'
     */
    h0LJv: T;

    /**
     * @default 'Keep Shopping'
     */
    NKNa9: T;

    /**
     * @default 'Continue to Cart'
     */
    uyuSK: T;

    /**
     * @default 'Add Items From the {{0}} Suite'
     */
    '0F0eC': T;

    /**
     * @default 'Add an Enclosure Card'
     */
    c1SbA: T;

    /**
     * @default 'Most Loved'
     */
    ZcDCO: T;

    /**
     * @default 'View order #{{0}}'
     */
    uKODQ: T;

    /**
     * @default 'Congratulations!'
     */
    ANw98: T;

    /**
     * @default 'We've received your order.'
     */
    IDD6I: T;

    /**
     * @default 'Your order is being prepared for print. We'll get it to you soon, so you're ready to celebrate the big day.'
     */
    pPVWB: T;

    /**
     * @default 'We'll ship your cards to you. Guest addresses are printed for you to stamp and mail.'
     */
    rXKDD: T;

    /**
     * @default 'Order Confirmed'
     */
    byzAF: T;

    /**
     * @default 'We'll send an email confirmation for your order to'
     */
    gf0JN: T;

    /**
     * @default 'We're having trouble placing your order.'
     */
    '32Ek5': T;

    /**
     * @default 'Your design is still in draft, please revise and place your order or contact our support team via chat or email.'
     */
    o3Clb: T;

    /**
     * @default 'Got it'
     */
    D2I4z: T;

    /**
     * @default 'Removing...'
     */
    P1zse: T;

    /**
     * @default 'Remove Item'
     */
    '9IqxN': T;

    /**
     * @default 'Review Your Cart'
     */
    FZKox: T;

    /**
     * @default 'Check Out'
     */
    KUv3P: T;

    /**
     * @default 'Something went wrong'
     */
    X1dnv: T;

    /**
     * @default 'We couldn't load your cart. Please refresh the page or try again later.'
     */
    c8RjM: T;

    /**
     * @default 'Your cart is empty'
     */
    WJ2dL: T;

    /**
     * @default 'Browse our designs and add something you love'
     */
    mCuT7: T;

    /**
     * @default 'Explore Designs'
     */
    Wh0Py: T;

    /**
     * @default 'To: {{0}}'
     */
    XbvgA: T;

    /**
     * @default 'Failed to remove item. Please try again.'
     */
    uURY9: T;

    /**
     * @default 'Explore More'
     */
    OiwZP: T;

    /**
     * @default 'FOIL'
     */
    sb5KA: T;

    /**
     * @default 'We couldn't upgrade this card. Your change wasn't applied.'
     */
    yC7A6: T;

    /**
     * @default 'We couldn't undo that. This card is still Premium Digital.'
     */
    '4zoyV': T;

    /**
     * @default 'Heads up:'
     */
    w0fIY: T;

    /**
     * @default 'Carriers sometimes experience delays or show limited tracking updates during transit, especially during busy seasons. Your tracking link always reflects the most current information available.'
     */
    kbA8l: T;

    /**
     * @default 'This order has no server-computed pricing.'
     */
    wshwZ: T;

    /**
     * @default 'Digital {{0}}'
     */
    K0L6W: T;

    /**
     * @default 'Digital Card'
     */
    epjCf: T;

    /**
     * @default 'Price Details'
     */
    PvAxL: T;

    /**
     * @default 'Price Details — server pricing (admin only)'
     */
    wa4wN: T;

    /**
     * @default 'Billing Address'
     */
    tHIvo: T;

    /**
     * @default 'Print Recipient Addresses'
     */
    K8lPI: T;

    /**
     * @default 'Your order will be paused until we receive your list of recipient addresses. When you're ready, add your recipients by clicking the link below.'
     */
    nibVf: T;

    /**
     * @default 'Add/Edit Recipient addresses'
     */
    f0o7S: T;

    /**
     * @default 'Send to Print'
     */
    cJyXG: T;

    /**
     * @default 'Envelope Front'
     */
    DWGDD: T;

    /**
     * @default 'Envelope Back'
     */
    '9hn50': T;

    /**
     * @default 'Paused'
     */
    qo2mM: T;

    /**
     * @default 'In Progress'
     */
    '0ezfO': T;

    /**
     * @default 'Ready to Ship'
     */
    '6fgOk': T;

    /**
     * @default 'Shipped'
     */
    '1mzdC': T;

    /**
     * @default 'Canceled'
     */
    TqO5I: T;

    /**
     * @default '7x better open rate than email'
     */
    SyuOX: T;

    /**
     * @default 'We saved your draft!'
     */
    MSW0T: T;

    /**
     * @default 'You can always find it in the Drafts tab in the main navigation on the top and keep customizing your card.'
     */
    iaJxL: T;

    /**
     * @default 'View Drafts'
     */
    LSsxD: T;

    /**
     * @default 'Are you sure you want to exit editing mode?'
     */
    a9Ieu: T;

    /**
     * @default 'No changes will be made to the card in your original order.'
     */
    '1zMQT': T;

    /**
     * @default 'Go Back to Editing'
     */
    iqYCv: T;

    /**
     * @default 'Keep Original Card'
     */
    yJDp7: T;

    /**
     * @default 'Almost done'
     */
    cP4pK: T;

    /**
     * @default 'To save these changes to your cart, continue to the final review step and submit them.'
     */
    uJnH5: T;

    /**
     * @default 'Review Changes'
     */
    zinWH: T;

    /**
     * @default 'Leave and Discard Changes'
     */
    FHrey: T;

    /**
     * @default 'Exit Customization'
     */
    Xktye: T;

    /**
     * @default 'We couldn't save your draft. Please try again.'
     */
    gMSof: T;

    /**
     * @default 'Remove this item from your cart to change its format.'
     */
    '0v7KU': T;

    /**
     * @default 'Start a new Basic Digital card?'
     */
    C4IcC: T;

    /**
     * @default 'We’ll start a new Basic Digital draft from the original design. Your current card will be saved as a draft.'
     */
    p5pix: T;

    /**
     * @default 'Start New Draft'
     */
    DZcZz: T;

    /**
     * @default 'Keep Editing'
     */
    FgHPG: T;

    /**
     * @default 'We couldn't start your Basic Digital card. Please try again.'
     */
    e9PtB: T;

    /**
     * @default 'We couldn't change the format. Your card wasn't changed.'
     */
    dBDJX: T;

    /**
     * @default 'postcards'
     */
    NTvgT: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Selected'
     */
    '5gqDQ': T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Filter by:'
     */
    nmoMy: T;

    /**
     * @default 'Missing Addresses'
     */
    OBVd0: T;

    /**
     * @default 'Missing Address'
     */
    SRM6v: T;

    /**
     * @default 'Tax'
     */
    '9oYAA': T;

    /**
     * @default 'Paid with {{0}} {{1}}'
     */
    jKxtT: T;

    /**
     * @default 'Edit Back'
     */
    vaFHg: T;

    /**
     * @default 'Next: {{0}}'
     */
    tE1Is: T;

    /**
     * @default 'Edit Front'
     */
    TIVJ2: T;

    /**
     * @default 'Changing Quantity is not available in edit mode. Please contact customer support.'
     */
    VTgYL: T;

    /**
     * @default 'Add your text'
     */
    '1KFZd': T;

    /**
     * @default 'Your Guest Name'
     */
    inNq6: T;

    /**
     * @default 'Your Guest Address'
     */
    l8u1M: T;

    /**
     * @default 'Envelope Preview'
     */
    CJSZB: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default 'Previous envelope'
     */
    RFZsP: T;

    /**
     * @default 'Next envelope'
     */
    hIjCX: T;

    /**
     * @default 'Please confirm by ticking the checkbox.'
     */
    G2cnl: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Oops, you chose more recipients than cards with envelopes. Adjust cards quantity or selection.'
     */
    '8qhvB': T;

    /**
     * @default 'Preview All Envelopes'
     */
    S3ITI: T;

    /**
     * @default 'Preview All Postcards'
     */
    amC12: T;

    /**
     * @default 'As Ordered'
     */
    fHic8: T;

    /**
     * @default 'Revised'
     */
    aK9Jg: T;

    /**
     * @default 'Category navigation'
     */
    Oa377: T;

    /**
     * @default 'Ceremony & Reception'
     */
    nxXiY: T;

    /**
     * @default 'All Save the Dates'
     */
    ushWv: T;

    /**
     * @default 'All Invitations'
     */
    PlxnA: T;

    /**
     * @default 'All Thank You Cards'
     */
    VqAJM: T;

    /**
     * @default 'All Holiday Cards'
     */
    O3eP5: T;

    /**
     * @default 'Shop by Format'
     */
    u84HY: T;

    /**
     * @default 'Free Digital'
     */
    u9tRW: T;

    /**
     * @default 'Shop by Feature'
     */
    hsqsp: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Shop by Style'
     */
    WMIr6: T;

    /**
     * @default 'Botanical'
     */
    fvRhP: T;

    /**
     * @default 'Floral'
     */
    g0mAx: T;

    /**
     * @default 'Elegant & Classic'
     */
    QY6uD: T;

    /**
     * @default 'Destination'
     */
    Su78A: T;

    /**
     * @default 'Typographic'
     */
    OEt4f: T;

    /**
     * @default 'Rustic'
     */
    SUggT: T;

    /**
     * @default 'Minimal'
     */
    dpfGp: T;

    /**
     * @default 'Vintage'
     */
    UfyEn: T;

    /**
     * @default 'Whimsical'
     */
    '5AEBw': T;

    /**
     * @default 'Suite Inserts'
     */
    gppUg: T;

    /**
     * @default 'Enclosure Cards'
     */
    FmHhX: T;

    /**
     * @default 'Menus'
     */
    I23aG: T;

    /**
     * @default 'Services & Tools'
     */
    Nd2e4: T;

    /**
     * @default 'Free Sample Pack'
     */
    '7OTHT': T;

    /**
     * @default 'Design Concierge'
     */
    dEpyQ: T;

    /**
     * @default 'Wording & Etiquette'
     */
    '0FcGt': T;

    /**
     * @default 'Collect Addresses'
     */
    kS7jV: T;

    /**
     * @default 'Clear Photos'
     */
    ej7k0: T;

    /**
     * @default 'Clear Photo'
     */
    PP04z: T;

    /**
     * @default 'No results found.'
     */
    zB62V: T;

    /**
     * @default 'Look out for typos or try a different search.'
     */
    jimNe: T;

    /**
     * @default 'Size'
     */
    DwANA: T;

    /**
     * @default '5 × 7'
     */
    lfhVE: T;

    /**
     * @default 'Product'
     */
    dGAik: T;

    /**
     * @default 'In your cart'
     */
    iTB0T: T;

    /**
     * @default 'Guest Name'
     */
    BwmqA: T;

    /**
     * @default 'Guest Address'
     */
    aUzoh: T;

    /**
     * @default 'You don't have any drafts just yet!'
     */
    wpHDG: T;

    /**
     * @default 'Start with a design you love. Your paper and digital drafts will show up here.'
     */
    '6eb3w': T;

    /**
     * @default 'Show All'
     */
    E73y6: T;

    /**
     * @default 'Basic Digital Cards'
     */
    XF440: T;

    /**
     * @default 'No basic digital drafts yet.'
     */
    '7J20A': T;

    /**
     * @default 'Draft saved'
     */
    CjiA6: T;

    /**
     * @default 'Browse Designs'
     */
    vQAeM: T;

    /**
     * @default 'Your Orders'
     */
    mSB9C: T;

    /**
     * @default 'You don't have any orders just yet!'
     */
    fdQtN: T;

    /**
     * @default 'Once you're ready to place your order, you'll be able to find it here and track its progress.'
     */
    bOxPe: T;

    /**
     * @default 'Shop the '{{0}}' Save the Date Card | Joy'
     */
    '9r473': T;

    /**
     * @default 'Shop the '{{0}}' Invitation Card | Joy'
     */
    sxLwy: T;

    /**
     * @default 'Shop the '{{0}}' Thank You Card | Joy'
     */
    '2fXAn': T;

    /**
     * @default 'Shop the '{{0}}' Holiday Card | Joy'
     */
    XqM7m: T;

    /**
     * @default 'Shop the '{{0}}' Enclosure Card | Joy'
     */
    JYi4C: T;

    /**
     * @default 'Shop the '{{0}}' Card | Joy'
     */
    '5uR6a': T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Leave Basic Digital?'
     */
    SXyYM: T;

    /**
     * @default 'Your edits will move to the new format. You won’t be able to switch this draft back to Basic Digital.'
     */
    rrcct: T;

    /**
     * @default 'Switch Format'
     */
    NZ67j: T;

    /**
     * @default 'Stay in Basic'
     */
    wP877: T;

    /**
     * @default 'That is a premium feature'
     */
    NUp6q: T;

    /**
     * @default 'Premium also unlocks'
     */
    np2qx: T;

    /**
     * @default 'Background'
     */
    idoD3: T;

    /**
     * @default 'Colors, shapes'
     */
    kRCZi: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Styles, move, resize'
     */
    TZDZs: T;

    /**
     * @default 'Color, animation'
     */
    FbHSv: T;

    /**
     * @default 'Upgrade to Premium'
     */
    s35no: T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'Wallpaper Color'
     */
    Xmv4A: T;

    /**
     * @default 'Music'
     */
    XvUdG: T;

    /**
     * @default 'Party time! 🎉'
     */
    vDnOD: T;

    /**
     * @default 'Edit Envelope'
     */
    OzRDL: T;

    /**
     * @default 'Envelope Color'
     */
    r5rxC: T;

    /**
     * @default 'Next: Review'
     */
    NZGhm: T;

    /**
     * @default 'Reveal Animation'
     */
    tr6oI: T;

    /**
     * @default 'Bring joy to your guests when they open the card from you.'
     */
    FcbyA: T;

    /**
     * @default '1 person messaged'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person messaged
     * - plural: {{0}} people messaged
     */
    PSJcN: T;

    /**
     * @default '1 text'
     * @param {number} count - The number of occurrences.
     * - singular: 1 text
     * - plural: {{0}} texts
     */
    '6Y5Ig': T;

    /**
     * @default '1 email'
     * @param {number} count - The number of occurrences.
     * - singular: 1 email
     * - plural: {{0}} emails
     */
    q7Mgd: T;

    /**
     * @default '1 undeliverable'
     * @param {number} count - The number of occurrences.
     * - singular: 1 undeliverable
     * - plural: {{0}} undeliverable
     */
    j5nFN: T;

    /**
     * @default 'Congratulations! Your card has been sent.'
     */
    rHSca: T;

    /**
     * @default 'Recipients'
     */
    krwxH: T;

    /**
     * @default 'Post Checkout'
     */
    WV2Lx: T;

    /**
     * @default 'Take a look at our most commonly asked questions and answers. For additional support, chat with us.'
     */
    HFfe6: T;

    /**
     * @default 'Save the Date Frequently Asked Questions'
     */
    un4oR: T;

    /**
     * @default 'Frequently Asked Questions'
     */
    CMOWd: T;

    /**
     * @default 'Traditionally, the bride's name is listed first on Save the Dates and wedding invitations. This custom is rooted in traditional etiquette where the bride's family would be the primary hosts of the wedding. However, in modern times, many couples choose to list their names in the order that feels right to them. Whether you decide to list the bride's name first or the couple's names in alphabetical order, the most important aspect is that the Save the Date clearly communicates the essential information about your wedding.'
     */
    mo9l9: T;

    /**
     * @default 'The purpose of Save the Dates is to provide your guests with preliminary information about your wedding. The key details to include are your names, the wedding date, and the location (city or area). Since Save the Dates are less formal than the official wedding invitations, you don't need to include as much detail. It's also a good idea to mention that formal invitations will follow with more comprehensive information. Including your wedding website URL on the Save the Date can be very helpful. This allows guests to access additional information, such as travel details, accommodation options, and updates about your wedding.'
     */
    jsSNH: T;

    /**
     * @default 'Yes, sending digital Save the Dates is a perfectly acceptable and increasingly popular option. Digital Save the Dates are cost-effective, environmentally friendly, and convenient. They can also help streamline your wedding planning process by linking directly to your wedding website, where guests can RSVP and access further details. However, keep in mind that some guests, especially those who are less tech-savvy, might need a reminder to check their email. To ensure that everyone receives your Save the Date, consider sending a follow-up message or providing an alternate way for guests to confirm receipt.'
     */
    x4Yxg: T;

    /**
     * @default 'Joy's built-in Contact Collector makes it easy to gather all your guests' contact information in your guest list. Simply share your magic link with guests, they fill out a quick form, and your guest list grows automagically. Every Joy Save the Date includes free recipient and return address printing that integrates seamlessly with your contact list.'
     */
    VUaSa: T;

    /**
     * @default 'Joy wedding websites, planning tools, registry, and online RSVP are free! Paper wedding invitations come in a range of price and style options, and all include free back-of-card printing and free recipient and return address printing. On a tight budget? Mix and match Joy's digital and paper cards to save money on paper and postage. Hundreds of digital wedding invitation designs are available to send for free.'
     */
    N01u2: T;

    /**
     * @default 'When should we send Save the Dates for our wedding?'
     */
    '4TDJF': T;

    /**
     * @default 'Save the Dates are an important part of wedding planning, providing your guests with early notice of your wedding date so they can plan accordingly. For weddings where most of your guests are local, sending Save the Dates 4-6 months before your wedding is typically sufficient. This timing gives guests enough notice to mark their calendars and make any necessary arrangements. If you're hosting a destination wedding, it's best to send Save the Dates at least 9 months before the big day. This extra time allows your guests to arrange travel, accommodations, and time off from work if needed. Early notifications are especially crucial for guests who will need to book flights and hotels in advance.'
     */
    pEIGV: T;

    /**
     * @default 'Whose name goes first on Save the Date?'
     */
    '7y2NS': T;

    /**
     * @default 'wedding invitations'
     */
    u47mY: T;

    /**
     * @default 'What information should we include on Save the Dates?'
     */
    ymStW: T;

    /**
     * @default 'accommodation options'
     */
    IXKXy: T;

    /**
     * @default 'Is it okay to just send online Save the Dates?'
     */
    NUAgM: T;

    /**
     * @default 'where guests can RSVP'
     */
    tDDiZ: T;

    /**
     * @default 'Do we need to follow a specific design or style for Save the Dates?'
     */
    '9nrkM': T;

    /**
     * @default 'There is no strict rule regarding the design or style of Save the Dates. The design should reflect your personal taste and the theme of your wedding. Save the Dates can be formal, casual, whimsical, or traditional, depending on your preference. Many couples choose designs that align with their wedding theme or that give guests a sneak peek of the style and tone of the event. Whether you opt for a minimalist design, a vibrant photo, or a classic script, the goal is to convey the essential information while giving your guests a hint of what's to come.'
     */
    EYhhy: T;

    /**
     * @default 'Do I put my wedding website URL on Save the Dates?'
     */
    '00p20': T;

    /**
     * @default 'Though not required, it's certainly helpful. Because Save the Dates should be sent out 4 to 6 months before your wedding day, and are considered less formal than printed wedding invitations, it's best you complete your wedding website by that time. This way, you can add the URL to your Save the Dates and give your guests plenty of time to absorb all your wedding details.'
     */
    gvWEl: T;

    /**
     * @default 'Can we include photos on our Save the Dates?'
     */
    qUgkS: T;

    /**
     * @default 'Including a photo on your Save the Date can add a personal touch and make the announcement more memorable. Many couples choose to feature an engagement photo or a favorite picture that represents their relationship. Photos can make your Save the Date stand out and give guests a glimpse of the couple they're celebrating. If you decide to include a photo, ensure it complements the design and doesn't overwhelm the important details. A well-chosen photo can enhance the overall aesthetic and make your Save the Date more engaging.'
     */
    bw1Jo: T;

    /**
     * @default 'How do I word my Save the Date?'
     */
    xKhHH: T;

    /**
     * @default 'The wording of your Save the Date should be clear and concise, focusing on the essential information. A simple example of Save the Date wording might be, "Save the Date: [Your Names], [Wedding Date], [Location]. Formal invitation to follow." You can also add a personal touch by including a brief message or quote that reflects your personality. The key is to provide your guests with the crucial details while keeping the tone of the message in line with the style of your wedding.'
     */
    KSXpJ: T;

    /**
     * @default 'Do Save the Dates and invitations have to match?'
     */
    SaP9k: T;

    /**
     * @default 'While it's not necessary for Save the Dates and invitations to match exactly, having a cohesive look can be visually appealing. Many couples choose to align the design elements of their Save the Dates with their wedding invitations to create a consistent theme. However, it's perfectly fine to have different designs as long as they complement each other. The important thing is that both pieces of correspondence clearly convey the necessary information and reflect your wedding style.'
     */
    zmL7J: T;

    /**
     * @default 'What size should the Save the Date card be?'
     */
    HbV1p: T;

    /**
     * @default 'Save the Date cards typically come in standard sizes such as 5x7 inches, which is a common and practical size for mailing. However, you have the flexibility to choose a size that suits your design and budget. Smaller sizes like 4x6 inches or larger formats like 6x8 inches are also options depending on how you want to present your Save the Date. Make sure the size you choose aligns with your overall design and is easy for your guests to handle and store.'
     */
    '0IBz1': T;

    /**
     * @default 'How do I collect addresses for my Save the Dates?'
     */
    fk5E6: T;

    /**
     * @default 'guest list'
     */
    '4eKQC': T;

    /**
     * @default 'Are Save the Dates necessary?'
     */
    Ry8NL: T;

    /**
     * @default 'While it's ultimately your decision, we highly recommend that Save the Dates are a part of your suite of wedding announcements. This way, you'll ensure your guests have access to the who, what, where, and when of your wedding as soon as you've determined these details. Plus, by including your wedding website link on your Save the Dates, you'll enable your guests to learn more about the wedding and RSVP online.'
     */
    hvfa2: T;

    /**
     * @default 'Can you do Save the Dates and invitations together?'
     */
    '9JT1G': T;

    /**
     * @default 'Yes, coordinating your Save the Dates and invitations can create a unified look for your wedding announcements. Many couples choose to use matching or complementary designs for both Save the Dates and invitations to maintain consistency. This approach helps to set the tone for the wedding and provides a cohesive visual experience for your guests. You can work with the same designer or template provider to ensure that your Save the Dates and invitations align seamlessly.'
     */
    uTQAX: T;

    /**
     * @default 'Why choose Joy's Wedding Save the Dates'
     */
    anpBS: T;

    /**
     * @default 'Choosing the right Save the Date template is an essential step in your wedding planning process. It sets the stage for the rest of your wedding communications and provides your guests with the first glimpse of what's to come. Joy offers a wide range of Save the Date templates that cater to various styles and preferences. Whether you're envisioning a rustic countryside wedding, a glamorous city celebration, or a laid-back beach event, Joy has a template that fits your theme. Joy's Save the Date templates are designed with both style and functionality in mind. You can select from hundreds of beautifully crafted designs, each offering unique elements that can be customized to suit your wedding theme. From elegant calligraphy to playful illustrations, Joy provides options that cater to every taste. Additionally, Joy allows you to incorporate your favorite photos into the design, adding a personal touch that makes your Save the Date even more special.'
     */
    '2UCSs': T;

    /**
     * @default 'What does Joy cost?'
     */
    XdzGD: T;

    /**
     * @default 'registry'
     */
    zlalN: T;

    /**
     * @default 'online RSVP'
     */
    '4gkrg': T;

    /**
     * @default 'digital wedding invitation designs'
     */
    cZYvA: T;

    /**
     * @default 'Do you have a support team we can reach out to if we have questions?'
     */
    oJWCM: T;

    /**
     * @default 'Absolutely! Our amazing support team works hard around the clock, every day of the week, including weekends, to make sure that your questions are answered. You can send us an email at support@withjoy.com.'
     */
    mtFCe: T;

    /**
     * @default 'Are Save the Date magnets essential?'
     */
    '2T51B': T;

    /**
     * @default 'Save the Date magnets are not strictly necessary, and they can be more expensive than traditional paper cards. If you're on a tighter budget, it's perfectly fine to opt for paper Save the Dates instead. Most guests won't mind whether it's a magnet or paper; the key is ensuring the Save the Date reflects your style and provides the essential wedding details.'
     */
    jPt2u: T;

    /**
     * @default 'Do you send save-the-dates to everyone?'
     */
    '4yWLj': T;

    /**
     * @default 'You should only send save-the-dates to individuals you plan to invite to your wedding. Anyone who receives a save-the-date should also be sent a wedding invitation.'
     */
    Y1ZPs: T;

    /**
     * @default 'Related Links'
     */
    '6kMA4': T;

    /**
     * @default 'Wedding Website'
     */
    fh8jC: T;

    /**
     * @default 'Wedding Invitations'
     */
    '4fWdb': T;

    /**
     * @default 'Smart RSVP'
     */
    '8z7QR': T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Read Less'
     */
    DQaLg: T;

    /**
     * @default 'Read More'
     */
    jamLg: T;

    /**
     * @default 'Announce Your Wedding Date with a Save the Date Card'
     */
    lPFCS: T;

    /**
     * @default 'Whether you mail Save the Dates or send them digitally, we'll ensure a seamless stationery experience'
     */
    FYCDS: T;

    /**
     * @default 'A Save the Date card does more than just claim your wedding date. It frames a momentous occasion, announces an exciting first step towards the aisle, and should set the tone for your big day to come. Reflecting your personality and offering a glimpse of how your celebration will look and feel.'
     */
    RScBw: T;

    /**
     * @default 'We believe Save the Date cards are so much more than a formality. Which is why we've created a way for you to design yours easily, and quickly online. Whether you choose to craft from scratch, or tailor one of our expertly designed templates. Joy will help you build the anticipation for your wedding, and reflect your unique love story.'
     */
    EGXNt: T;

    /**
     * @default 'The Benefits of Save the Dates'
     */
    dH0PY: T;

    /**
     * @default 'Undecided on Save the Dates at this stage? We're not here to convince you, but we'd love to share a few benefits of sending out Save the Dates that we think you'll find useful.'
     */
    '0Ewvz': T;

    /**
     * @default 'Why Save the Dates Help Couples Save Money'
     */
    EeRTA: T;

    /**
     * @default 'Weddings are costly affairs, and unfortunately, not every desire can be fulfilled. But there's no need to skip on things like Save the Dates when they can be created and sent for free online!'
     */
    JarIU: T;

    /**
     * @default 'How Save the Dates Improve Wedding Planning'
     */
    '0DLOu': T;

    /**
     * @default 'Creating a realistic budget as early in the wedding planning process as possible is key to not overspending. Save the Dates play a pivotal role in gathering information, helping you to quickly understand the guest count you're working with.'
     */
    '0TEMu': T;

    /**
     * @default 'Our connected online RSVP allows you to effortlessly gather details from guests, whether it's an attendance yes/no or something more specific. All of which is then automatically stored in your private online guest list. An invaluable resource at every stage of the wedding planning journey.'
     */
    DX2xH: T;

    /**
     * @default 'Why Sending Save the Dates Increases Guest Attendance'
     */
    bL8j2: T;

    /**
     * @default 'This point is often easily overlooked, but if your wedding falls during a popular month for celebrations or vacations, you need guests to mark your date on their calendars ASAP. To avoid any clashes or disappointing no shows.'
     */
    mBNnp: T;

    /**
     * @default 'Guest availability is even more critical if you're planning a destination wedding, as guests will need more time to prepare for the travel and cost of attending your celebration.'
     */
    aInJN: T;

    /**
     * @default 'How Save the Dates Introduce Your Wedding Style'
     */
    YnNco: T;

    /**
     * @default 'Our couples like to think of Save the Dates as previews of their overall wedding theme. A little taster of what's to come on the big day, and a cohesive element in their wedding stationery suite.'
     */
    yzlPN: T;

    /**
     * @default 'When you choose a Joy save-the-date template, we don't just offer the card design—we gift you the entire package. You'll receive a wedding website, save-the-date, invitation, and printed materials, all designed with one coordinated theme. This ensures every detail of your wedding feels polished and cohesive, with a strong, consistent theme. Everything is crafted using high-quality designs to make your wedding experience even more memorable.'
     */
    '9jdhy': T;

    /**
     * @default 'Customize and Personalize Your Save the Date Cards'
     */
    ksMkH: T;

    /**
     * @default 'Joy makes it so easy to curate a wedding suite, complete with a stunning Save the Date that reflects your love story.'
     */
    h7K3F: T;

    /**
     * @default 'Start with Personality'
     */
    '6bgoW': T;

    /**
     * @default 'We make the art of Save the Date designing effortless and fun, by giving you the power to personalize as you wish. In just a couple of clicks you can transform one of our chic templates, or a blank page, into a unique Save the Date card that truly reflects your special day.'
     */
    dAMhq: T;

    /**
     * @default 'You are free to experiment with fonts, colors, and the design of our templates to build something that feels yours. While also excitedly hinting at the overall wedding theme.'
     */
    MFt6B: T;

    /**
     * @default 'Share Your Engagement Photos'
     */
    Cwqmg: T;

    /**
     * @default 'What better way to share your wonderful engagement photos than on your Save the Dates! You'll of course be featuring them on your wedding website, and perhaps on the big day itself. But Save the Dates offer the best opportunity to showcase your favorite image from the shoot, and really celebrate how amazing you guys look together!'
     */
    GrMN5: T;

    /**
     * @default 'You are free to upload your engagement photography to our Save the Date builder, and help give any of our templates a more unique, personal touch. Whether it's a candid snap taken in the moment, or something more professional. Placing your chosen picture within your Save the Dates will help to make the announcement feel even more significant.'
     */
    JAGqe: T;

    /**
     * @default 'Why Choose Save-the-Date Cards for Your Wedding'
     */
    OiNns: T;

    /**
     * @default 'WithJoy gives you the ability to create Save the Dates at your convenience, and then track them every step of the way.'
     */
    OWB9Z: T;

    /**
     * @default 'Seamless Save the Date Integration'
     */
    PYKRv: T;

    /**
     * @default 'Our Save the Date templates are not standalone pieces, they are designed as part of a wedding stationery suite. Meaning your wedding website, invitation (digital and physical) and your Save the Date card will all be coordinated.'
     */
    drxo9: T;

    /**
     * @default 'This coordination goes beyond aesthetics, as our Save the Date cards and invitations can be integrated within your wedding website. Giving you the ability to request RSVPs online, and additional details from your guests before even sending out the wedding invitations. This is incredibly useful if you don't have addresses for all of your guests, or require information that'll directly affect your wedding plans.'
     */
    P6B0a: T;

    /**
     * @default 'Having your Save the Date linked to your wedding website also allows you to share information about your wedding day along the way. Ensuring guests are always up-to-date with your event as it evolves.'
     */
    azInN: T;

    /**
     * @default 'Free Wedding Planning Tools'
     */
    '6VPg0': T;

    /**
     * @default 'We're committed to helping couples plan their best day, and we know how quickly wedding costs can add up. That's why Joy offers free wedding websites, planning tools, guest list management, and digital save the dates—so you can simplify planning without added expense. And when you're ready to elevate the experience, you can explore our premium digital invitations and printed stationery, designed to make a lasting impression.'
     */
    XUmM5: T;

    /**
     * @default 'Announce Your Wedding Date Today'
     */
    bmAdi: T;

    /**
     * @default 'Explore how Joy can help you create the perfect save-the-date card—and so much more—by browsing our free templates today. Whether you're drawn to minimalistic designs, like our modern minimalist save-the-date card, or something with a more intricate touch, you're sure to find a style that suits your theme and reflects your shared personality. And if not, we've made it easy to start with a blank page and turn it into something uniquely yours.'
     */
    wtpqK: T;

    /**
     * @default 'So whether you're selecting foil color, letterpress, or a matte finish monogram, you can create beautiful save-the-dates that effortlessly match your wedding day. After all, save-the-dates are not just a formality; they are the beginning of your story. Start telling yours with Joy today.'
     */
    '7ZBes': T;

    /**
     * @default 'Alex & Zack'
     */
    BaX4J: T;

    /**
     * @default 'Brooklyn, NY'
     */
    xlnEk: T;

    /**
     * @default 'Just wanted to follow up to thank the entire team for creating the most beautiful save the dates! We put them in the mail yesterday and they looked amazing. I don't have Reddit, but I've been telling all my friends how amazing things turned out and how great the customer service is.'
     */
    fkQQZ: T;

    /**
     * @default 'Sophia & Jimmy'
     */
    '6bLCV': T;

    /**
     * @default 'Pasadena, CA'
     */
    fl8TM: T;

    /**
     * @default 'The card team from Joy is incredible! When our initial Thank You card order was not what we expected, we communicated our concerns with the team. The team worked with us daily to reach a resolution that not only worked but exceeded our expectations. We are so grateful to have worked with the card team to put a beautiful bow of thanks on our wedding.'
     */
    ABUMI: T;

    /**
     * @default 'Guadalupe & Andy'
     */
    ErhLR: T;

    /**
     * @default 'Chicago, IL'
     */
    zCQUg: T;

    /**
     * @default 'We chose Joy for our destination wedding because it was super easy to use and offered all the features we needed. Planning a wedding away from home was a big task, but Joy made it a easy! Our favorite features were definitely the guest list and schedule options – they kept us on track and stress-free!'
     */
    '7UQJL': T;

    /**
     * @default 'I understand that by clicking Send to Print, I will no longer be able to edit my card or envelopes.'
     */
    '6L95T': T;

    /**
     * @default 'Oops, this photo is too large.'
     */
    '2koV9': T;

    /**
     * @default 'This image exceeds the recommended size. A smaller version will still look great. Please resize your photo to meet the following criteria.'
     */
    kWHb0: T;

    /**
     * @default 'Resolution'
     */
    WfjmS: T;

    /**
     * @default 'Current'
     */
    v8RNJ: T;

    /**
     * @default 'Maximum'
     */
    ktlsU: T;

    /**
     * @default 'Optimal'
     */
    KG6kb: T;

    /**
     * @default 'Upload Different Photo'
     */
    myVei: T;

    /**
     * @default 'Oops, this photo is low resolution.'
     */
    l1H7Q: T;

    /**
     * @default 'The uploaded image is low resolution and may affect the final quality. Please find a different photo that meets the following criteria.'
     */
    Wzkxk: T;

    /**
     * @default 'File size'
     */
    pXyNu: T;

    /**
     * @default 'Minimum'
     */
    I0fGp: T;

    /**
     * @default 'Please make sure you find the original photo. Upscaling or resizing the photo might get you past this warning, but will still affect the final quality.'
     */
    YZeql: T;

    /**
     * @default 'Keep This Photo'
     */
    LUxwQ: T;

    /**
     * @default 'This photo format isn't supported yet'
     */
    Optz3: T;

    /**
     * @default 'We detected this image as {{0}}, which isn't currently supported. Please upload a JPEG or PNG photo instead.'
     */
    '9IjaH': T;

    /**
     * @default 'Need help? Contact us at '
     */
    j5NjK: T;

    /**
     * @default 'Upload your design'
     */
    ohuch: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Use code:'
     */
    YtvvU: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Thank You'
     */
    TEKg2: T;

    /**
     * @default 'Holiday'
     */
    mOSz3: T;

    /**
     * @default 'Enclosure'
     */
    qJ0d5: T;

    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Sign'
     */
    FmANA: T;

    /**
     * @default 'Monogram'
     */
    ggmVN: T;

    /**
     * @default 'Home'
     */
    lgXLA: T;

    /**
     * @default 'Cards'
     */
    PVimF: T;

    /**
     * @default 'Wedding'
     */
    YtFsf: T;

    /**
     * @default 'Color'
     */
    fmnoF: T;

    /**
     * @default 'Foil template'
     */
    '60tWl': T;

    /**
     * @default 'Orientation'
     */
    ESFJe: T;

    /**
     * @default 'Shop Matching Designs'
     */
    UhY8i: T;

    /**
     * @default 'Back of the Card'
     */
    bhimN: T;

    /**
     * @default 'The Suite'
     */
    '1LPey': T;

    /**
     * @default 'Update Cart'
     */
    jnghw: T;

    /**
     * @default 'Submit Changes'
     */
    v9eid: T;

    /**
     * @default 'Next: Send'
     */
    Pa6go: T;

    /**
     * @default 'Add to Cart'
     */
    SQNQv: T;

    /**
     * @default 'Imported Address'
     */
    kxUp0: T;

    /**
     * @default 'We found this address in your guest’s details. It’s for reference only, please enter the formatted address below for printing.'
     */
    ZfLtT: T;

    /**
     * @default 'Move'
     */
    hVIMA: T;

    /**
     * @default 'A new line of text'
     */
    DHYfh: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Send guests to your website or RSVP'
     */
    QjriN: T;

    /**
     * @default 'QR Code'
     */
    uUGwg: T;

    /**
     * @default 'Guests scan it to open a link'
     */
    N4vLS: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Add to back'
     */
    p62Uv: T;

    /**
     * @default 'Add to front'
     */
    BUze6: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Delete layer'
     */
    AQcuH: T;

    /**
     * @default 'Delete this text layer?'
     */
    wUzHl: T;

    /**
     * @default 'Delete this link layer?'
     */
    hqSkw: T;

    /**
     * @default 'Delete this QR code layer?'
     */
    lyZud: T;

    /**
     * @default 'Delete this photo layer?'
     */
    vv0AR: T;

    /**
     * @default 'Delete this layer?'
     */
    DUxpp: T;

    /**
     * @default '“{{0}}” will be removed from the back of your card. This can’t be undone.'
     */
    VwxDT: T;

    /**
     * @default '“{{0}}” will be removed from the front of your card. This can’t be undone.'
     */
    RWjXL: T;

    /**
     * @default 'This layer will be removed from the back of your card. This can’t be undone.'
     */
    HlOH7: T;

    /**
     * @default 'This layer will be removed from the front of your card. This can’t be undone.'
     */
    hAPNZ: T;

    /**
     * @default 'Delete Layer'
     */
    u1NLF: T;

    /**
     * @default 'Weight: {{0}}'
     */
    '268GM': T;

    /**
     * @default 'Thickness: {{0}}'
     */
    mM0h7: T;

    /**
     * @default 'Ordered'
     */
    XvJlf: T;

    /**
     * @default 'We're excited to get your beautiful design printed and get them to you very soon to help you celebrate that amazing day.'
     */
    '1SvQD': T;

    /**
     * @default 'Your order will be paused until we receive your list of recipient addresses. When you're ready, add your recipients by clicking the button below.'
     */
    '7DMSt': T;

    /**
     * @default 'You can track your order status at any time.'
     */
    FoKgz: T;

    /**
     * @default 'View Order'
     */
    ltTsE: T;

    /**
     * @default 'Missing some info?'
     */
    PrYYQ: T;

    /**
     * @default 'Quickly get everyone’s address and info.'
     */
    uifrq: T;

    /**
     * @default 'Share your Contact Collector magic link with a friend, and let them fill in their details.'
     */
    '9iIcU': T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Use Contact Collector'
     */
    wcUhI: T;

    /**
     * @default 'Your design has been saved as a draft. Please revise and place your order again or contact our support team via chat or email.'
     */
    zoFdK: T;

    /**
     * @default '✨ Holiday shipping can get busy, but we’ve got you covered. Order soon for the most reliable delivery timing.'
     */
    '3r5HY': T;

    /**
     * @default 'The remaining envelope prints blank.'
     * @param {number} count - The number of occurrences.
     * - singular: The remaining envelope prints blank.
     * - plural: The remaining {{0}} envelopes print blank.
     */
    SOQd3: T;

    /**
     * @default 'The remaining envelope prints with your return address only.'
     * @param {number} count - The number of occurrences.
     * - singular: The remaining envelope prints with your return address only.
     * - plural: The remaining {{0}} envelopes print with your return address only.
     */
    WLVmb: T;

    /**
     * @default 'We couldn't load your recipients, so the addresses are not shown. Refresh the page to try again.'
     */
    LdQGh: T;

    /**
     * @default 'Hide Envelopes'
     */
    lH1Sb: T;

    /**
     * @default 'Preview All {{0}} Envelopes'
     */
    '2nfl1': T;

    /**
     * @default 'Check the preview and make sure every detail is correct.'
     */
    BHaOS: T;

    /**
     * @default 'Uh oh, we can't edit your order at this point.'
     */
    D6qZT: T;

    /**
     * @default 'Your order has already been sent to get printed, so we can't make changes at this point.'
     */
    PB5ZC: T;

    /**
     * @default 'If you still need help with your order, please contact printsupport@withjoy.com'
     */
    DK0t2: T;

    /**
     * @default 'Go to Orders'
     */
    AoM3A: T;

    /**
     * @default 'I have reviewed the envelope and recognize that the changes made will replace the existing envelope order.'
     */
    '2qk3z': T;

    /**
     * @default 'I have reviewed the card and recognize that the changes made will replace the existing card order.'
     */
    IpR7E: T;

    /**
     * @default 'Please add your shipping address.'
     */
    sIx3G: T;

    /**
     * @default 'Please confirm that you checked all the details by ticking the checkbox below.'
     */
    u9zq6: T;

    /**
     * @default 'I have checked all the details and the design and order look good to me.'
     */
    '8hWIK': T;

    /**
     * @default 'Your order includes:'
     */
    kEMgr: T;

    /**
     * @default 'Please double check all the details before we print.'
     */
    Tb80n: T;

    /**
     * @default 'Shipping Address'
     */
    UoPdP: T;

    /**
     * @default 'Add Shipping Address'
     */
    '3dTPi': T;

    /**
     * @default 'Review Your Design'
     */
    '3aYvF': T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Beach'
     */
    rYGiF: T;

    /**
     * @default 'Green'
     */
    Fo78F: T;

    /**
     * @default 'Search for'
     */
    ZuceU: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'Save the Date Cards'
     */
    TUy1R: T;

    /**
     * @default '{{0}} save the date cards'
     */
    FLdvj: T;

    /**
     * @default '{{0}} wedding invitations'
     */
    e6Oxc: T;

    /**
     * @default '{{0}} cards'
     */
    Pnnek: T;

    /**
     * @default 'Scroll styles left'
     */
    '26rg9': T;

    /**
     * @default 'Filter by style'
     */
    kha5H: T;

    /**
     * @default 'Filter by {{0}} style'
     */
    mC8si: T;

    /**
     * @default 'Scroll styles right'
     */
    bPvjR: T;

    /**
     * @default 'Get it as early as {{0}}'
     */
    AHelM: T;

    /**
     * @default 'Free Envelope Printing'
     */
    '5XcYZ': T;

    /**
     * @default 'Contact Collector!'
     */
    MGLPu: T;

    /**
     * @default 'Exclusive Designs'
     */
    zvmRu: T;

    /**
     * @default 'Digital printing on our luxurious signature card stock with a subtle velvety texture'
     */
    oWnmT: T;

    /**
     * @default 'Add rounded corners and customize your card the way you want'
     */
    oVYWR: T;

    /**
     * @default 'Full color back of card designs with a variety of pattern and photo layouts'
     */
    lOoLt: T;

    /**
     * @default 'Premium white envelopes with complimentary address printing'
     */
    OGMEr: T;

    /**
     * @default 'Personalized Touch:'
     */
    '1qTan': T;

    /**
     * @default 'Add a personalized touch to your cocktail bar or dinner table with custom napkins that showcase your unique style.'
     */
    RQhOH: T;

    /**
     * @default 'Showcase Your Style:'
     */
    '9JDEq': T;

    /**
     * @default 'Choose a classic monogram, add a fun photo of your pet, or upload your own custom design.'
     */
    sLlfs: T;

    /**
     * @default 'Multiple sizes:'
     */
    wuomv: T;

    /**
     * @default 'Available in Cocktail (4.75" square) and Luncheon (6.5" square) sizes.'
     */
    iXsfz: T;

    /**
     * @default 'Match your wedding aesthetic:'
     */
    gngmL: T;

    /**
     * @default 'Create a cohesive and elegant look with custom signs designed to match your wedding's aesthetic. From classic to modern, we'll bring your vision to life.'
     */
    Tc014: T;

    /**
     * @default 'Lightweight and durable:'
     */
    adNdI: T;

    /**
     * @default 'Made from lightweight and durable 3/16" paper-faced foam board.'
     */
    NWiA9: T;

    /**
     * @default 'Easel Display:'
     */
    A7Y8f: T;

    /**
     * @default 'Ideal for display on an easel or stand (not included).'
     */
    LtTvG: T;

    /**
     * @default 'Delight your guests with custom menus that beautifully present your carefully selected meal or cocktail offerings.'
     */
    IyEVZ: T;

    /**
     * @default 'Choose from whimsical illustrations, a classic monogram, or upload your own.'
     */
    '5Er3c': T;

    /**
     * @default 'Options Available:'
     */
    N7ODV: T;

    /**
     * @default 'Digital printing on your choice of luxurious card stock.'
     */
    DVQDe: T;

    /**
     * @default 'Weight:'
     */
    '8FaHg': T;

    /**
     * @default 'Each magnet weighs about 0.8 ounces (23 grams) in its envelope.'
     */
    vZsb6: T;

    /**
     * @default 'Card design video'
     */
    dBE2j: T;

    /**
     * @default 'Free Shipping to {{0}} Addresses'
     */
    Fy3fQ: T;

    /**
     * @default 'Matching Website Designs'
     */
    '5NJXG': T;

    /**
     * @default 'Contact Collector'
     */
    pHmSZ: T;

    /**
     * @default 'Easily Shareable'
     */
    EPAPA: T;

    /**
     * @default 'Digital Cards include:'
     */
    FUzUE: T;

    /**
     * @default 'Links'
     */
    jpgWG: T;

    /**
     * @default 'Link to your wedding website, RSVP, Add to Calendar, Registry, and more.'
     */
    bQkNO: T;

    /**
     * @default 'Tracking'
     */
    dFG59: T;

    /**
     * @default 'Easily track which guests have received and opened your digital card.'
     */
    YgAUg: T;

    /**
     * @default 'Premium Digital Cards additionally include:'
     */
    u4gzM: T;

    /**
     * @default 'Premium Customization'
     */
    w2vRg: T;

    /**
     * @default 'Change fonts, move text around, upload your own image, and more.'
     */
    go60m: T;

    /**
     * @default 'Card Back Design'
     */
    '3xEsO': T;

    /**
     * @default 'Choose from a variety of card back designs or upload your own. Color match the front of your card.'
     */
    IW7pC: T;

    /**
     * @default 'Premium Envelope'
     */
    PVOAs: T;

    /**
     * @default 'Choose envelope colors and animations. Color match the front of your card.'
     */
    l3S5r: T;

    /**
     * @default 'Options for purchase:'
     */
    WxXb1: T;

    /**
     * @default 'Text Message Delivery'
     */
    Ed9Ap: T;

    /**
     * @default 'Text messaging to USA and Canada with recipient tracking.'
     */
    oLW6o: T;

    /**
     * @default 'Matching Paper Cards'
     */
    SRebA: T;

    /**
     * @default 'Order printed cards for special guests or keepsakes.'
     */
    Hlg2o: T;

    /**
     * @default 'Front of the Card'
     */
    BgkF1: T;

    /**
     * @default 'Smart Tip'
     */
    MOPzc: T;

    /**
     * @default 'To have and to hold! Add Paper Cards'
     */
    BhTNX: T;

    /**
     * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them.'
     */
    bOOoY: T;

    /**
     * @default 'Create Matching Paper Card'
     */
    d2c4v: T;

    /**
     * @default 'Customize it your way:'
     */
    gN94E: T;

    /**
     * @default 'Reflect your personal style and love story.'
     */
    zdyMk: T;

    /**
     * @default 'Add QR Code on the Card Back:'
     */
    u4n4N: T;

    /**
     * @default 'Ensure your guests have easy access to your wedding details.'
     */
    '8Ae9A': T;

    /**
     * @default 'Address Envelopes Effortlessly:'
     */
    jiRsN: T;

    /**
     * @default 'Gather all the guest information and reach everyone.'
     */
    EcKSb: T;

    /**
     * @default 'Subject:'
     */
    sHXE7: T;

    /**
     * @default 'Edit Email Subject'
     */
    kvK2Y: T;

    /**
     * @default 'To: [Envelope or First Name(s)]'
     */
    LTl5P: T;

    /**
     * @default 'View The Card'
     */
    Q79tF: T;

    /**
     * @default '1 person selected'
     * @param {number} count - The number of occurrences.
     * - singular: 1 person selected
     * - plural: {{0}} people selected
     */
    TMdQT: T;

    /**
     * @default '{{0}} of {{1}} sent'
     */
    '6dsUG': T;

    /**
     * @default 'Sending this card to your guest list isn't available yet. Your purchase is saved, so you can come back and send it later.'
     */
    x2J5I: T;

    /**
     * @default 'Hang tight!'
     */
    bs36p: T;

    /**
     * @default 'Matches Your Site'
     */
    T3Rgi: T;

    /**
     * @default '{{0}} for every budget.'
     */
    zE0gs: T;

    /**
     * @default 'Concierge'
     */
    NvCRC: T;

    /**
     * @default '*Use code: {{0}}'
     */
    EmrBV: T;

    /**
     * @default 'Card'
     */
    M1iKA: T;

    /**
     * @default 'Edit Link'
     */
    aRnIg: T;

    /**
     * @default 'Font Size'
     */
    WGALC: T;

    /**
     * @default 'Line Height'
     */
    '54g9e': T;

    /**
     * @default 'Letter Spacing'
     */
    v1kyF: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'URL cannot be blank.'
     */
    J5Tmm: T;

    /**
     * @default 'URL must be less than 60 characters long.'
     */
    Rynku: T;

    /**
     * @default 'Only letters, numbers and '-' are allowed in your URL.'
     */
    W2Ipy: T;

    /**
     * @default 'Use at least {{0}} characters'
     */
    '7O76U': T;

    /**
     * @default 'Password cannot be blank.'
     */
    rOdcd: T;

    /**
     * @default 'Your password can only contain letters and numbers.'
     */
    I7Iqq: T;

    /**
     * @default 'Your Event Website has been updated.'
     */
    Bf3aG: T;

    /**
     * @default 'That URL is too short. Use at least {{0}} characters.'
     */
    rlsJx: T;

    /**
     * @default 'An error occurred while updating your Event Website. Please try again.'
     */
    QnDcv: T;

    /**
     * @default 'password input'
     */
    LuDfw: T;

    /**
     * @default 'Password: {{0}}'
     */
    LNP4W: T;

    /**
     * @default 'Couldn't load the event password.'
     */
    mJ2Dr: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Select a Page'
     */
    o3XtF: T;

    /**
     * @default 'Customize'
     */
    LkOTm: T;

    /**
     * @default 'Upgrade to Premium Digital to link to your own custom URL.'
     */
    '30NdA': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Previous slide'
     */
    oDNj3: T;

    /**
     * @default 'Next slide'
     */
    aNUYo: T;
  };
};

export type StationeryCrossSellTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Link copied'
     */
    IHIze: T;

    /**
     * @default 'Promo code copied'
     */
    OTNqP: T;

    /**
     * @default 'Your site is live! 🎉'
     */
    QBCES: T;

    /**
     * @default 'Copy your link and share it with guests:'
     */
    WjxBC: T;

    /**
     * @default 'Copy link'
     */
    Xn2zA: T;

    /**
     * @default 'Now make it match — up to {{0}}% off paper and digital invitations.'
     */
    z4Zex: T;

    /**
     * @default 'Copy promo code'
     */
    JVtyi: T;

    /**
     * @default 'Claim Discount'
     */
    l5Hi9: T;
  };
};

export type StationeryTemplateCategoryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  designsGalleryPdpBreadcrumbCategory: {
    /**
     * @default 'Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Invitations'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default 'All Cards'
     */
    default: T;
  };
  stationeryTemplateCategoryToTile: {
    /**
     * @default 'Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Invitation'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default 'Paper Card'
     */
    default: T;
  };
  stationeryTemplateCategoryToDigitalTile: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
  exitCustomizationWidgetBrowseDesignCta: {
    /**
     * @default 'Browse Invitations'
     */
    invitation: T;

    /**
     * @default 'Browse Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Browse Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Browse Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Browse Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Browse Designs'
     */
    default: T;
  };
  premiumDigitalCardCustomizerInitialEmailSubjectByType: {
    /**
     * @default 'Save the Date!'
     */
    saveTheDate: T;

    /**
     * @default 'You're Invited!'
     */
    invitation: T;

    /**
     * @default 'Thank You!'
     */
    thankYou: T;

    /**
     * @default 'Happy Holidays!'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Thank You!'
     */
    default: T;
  };
  dashboardCategoryNav: {
    /**
     * @default 'Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Invitations'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Day-of Stationery'
     */
    dayOf: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default ''
     */
    default: T;
  };
  dashboardOrderListDigitalOrderOrderType: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You Card'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Card'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Card'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
  premiumDigitalOrderTrackingCategory: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Card'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Card'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
};

export type StayAreasAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Explore'
     */
    FdNcu: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Couldn't add this neighborhood. Please try again.'
     */
    s7yk1: T;

    /**
     * @default 'Neighborhood added successfully.'
     */
    p0r8n: T;

    /**
     * @default 'Neighborhoods are now visible to your guests.'
     */
    UWCS6: T;

    /**
     * @default 'This neighborhood is already on your list.'
     */
    kQWXc: T;

    /**
     * @default 'An error occurred. Please try again.'
     */
    '9G3PF': T;

    /**
     * @default 'Neighborhood removed successfully.'
     */
    hkTFE: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'An error occurred while uploading your photo. Please try again.'
     */
    '6y3vI': T;

    /**
     * @default 'Failed to enable neighborhoods. Please try again.'
     */
    jua8Q: T;

    /**
     * @default 'Neighborhood updated successfully.'
     */
    Mt6pS: T;

    /**
     * @default 'An error occurred while saving. Please try again.'
     */
    Q3xiD: T;

    /**
     * @default 'Some guests prefer to book vacation rentals to stay together as a group, have more privacy or flexibility.'
     */
    Gnhig: T;

    /**
     * @default 'Vacation rentals availability changes very fast, so suggesting neighborhoods and letting your guests browse stays there is the most helpful.'
     */
    fMOOH: T;

    /**
     * @default 'We recommend suggesting 3-5 neighborhoods to stay near your venue.'
     */
    ih2xd: T;

    /**
     * @default 'Close Neighborhoods Tooltip'
     */
    WXDdS: T;

    /**
     * @default 'Why add Neighborhoods?'
     */
    '5NljV': T;

    /**
     * @default 'Turn On Neighborhoods'
     */
    '18vbz': T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Search Rentals on VRBO →'
     */
    tN9Ql: T;

    /**
     * @default 'Thumbnail'
     */
    '8G1W3': T;

    /**
     * @default 'Please enter a name'
     */
    '4dVtN': T;

    /**
     * @default 'Please select a neighborhood from the dropdown'
     */
    vzxdN: T;

    /**
     * @default 'Please choose a category'
     */
    muEy3: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'Zone Search'
     */
    OWihb: T;

    /**
     * @default 'Search a neighborhood…'
     */
    f5AbK: T;

    /**
     * @default 'Map'
     */
    '4pWAA': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Best for'
     */
    LVdsq: T;

    /**
     * @default 'Why It's Your Pick'
     */
    L38Lr: T;

    /**
     * @default 'Tell Guests Why'
     */
    GFwTU: T;

    /**
     * @default 'Write a note to guests about why you picked this area. Let them know any details you might want to share.'
     */
    XkVgX: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Remove Neighborhood'
     */
    '4NYtB': T;

    /**
     * @default 'It's too far from our venue'
     */
    B16sH: T;

    /**
     * @default 'Not the right vibe for us'
     */
    t4sLx: T;

    /**
     * @default 'The photos didn't win me over'
     */
    '6fAx0': T;

    /**
     * @default 'I was just exploring'
     */
    '8Zi0u': T;

    /**
     * @default 'I'd rather not show suggestions to my guests'
     */
    Njhi7: T;

    /**
     * @default 'Something else'
     */
    Jpifv: T;

    /**
     * @default 'Remove {{0}} from the list?'
     */
    gtmY0: T;

    /**
     * @default 'Remove this neighborhood from the list?'
     */
    GaJlS: T;

    /**
     * @default 'Mind sharing why? It helps us improve.'
     */
    kqpNx: T;

    /**
     * @default 'Remove it'
     */
    D6Jvl: T;

    /**
     * @default 'Actually, keep it!'
     */
    cdpll: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Thanks for your feedback!'
     */
    XLpso: T;

    /**
     * @default 'Neighborhoods map'
     */
    tOmSR: T;

    /**
     * @default 'Neighborhood Suggestions'
     */
    fUNhN: T;

    /**
     * @default 'Help your guests discover the best areas for vacation homes near your venue.'
     */
    HCwTU: T;

    /**
     * @default 'Suggest Neighborhoods'
     */
    XFQKv: T;

    /**
     * @default 'Ability to add and edit coming soon. Interested?'
     */
    HGmGT: T;

    /**
     * @default 'Not helpful'
     */
    XptR9: T;

    /**
     * @default 'Helpful'
     */
    aXRWd: T;

    /**
     * @default 'Finding curated neighborhoods near your venue...'
     */
    QuWT0: T;

    /**
     * @default 'We found a few curated neighborhood suggestions near your venue. Add, remove and tweak them the way you want.'
     */
    BjEFf: T;

    /**
     * @default 'Note to Guests'
     */
    oExcX: T;

    /**
     * @default 'You can share a note with your guests here!'
     */
    Opm2e: T;

    /**
     * @default 'Neighborhoods'
     */
    v2yGJ: T;

    /**
     * @default 'Suggest'
     */
    WmiYP: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Add Neighborhood'
     */
    zZ8UT: T;

    /**
     * @default 'Edit Neighborhood'
     */
    i01Un: T;
  };
};

export type StayAreasGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  vrboButton: {
    /**
     * @default 'Search rentals on <Vrbo/>'
     */
    searchRentalsOn: T;
  };
  quick: {
    /**
     * @default 'If you'd like to stay together as a group, have a more independent stay or turn the trip into a longer getaway, explore the best neighborhoods near our venue.'
     */
    JZos3: T;

    /**
     * @default 'Best for couples'
     */
    '8yghu': T;

    /**
     * @default 'Best for families'
     */
    '9zEPb': T;

    /**
     * @default 'Best for long stays'
     */
    VsvyH: T;

    /**
     * @default 'Best for short stays'
     */
    zzVFg: T;

    /**
     * @default 'Best for business travelers'
     */
    Jg0a9: T;

    /**
     * @default 'Best for digital nomads'
     */
    FU6is: T;

    /**
     * @default 'Best for first time visitors'
     */
    xlWs1: T;

    /**
     * @default 'Best for remote work'
     */
    skIYM: T;

    /**
     * @default 'Best for solo travelers'
     */
    YbkTL: T;

    /**
     * @default 'Best for weekend getaways'
     */
    nvRAn: T;

    /**
     * @default 'Best for art lovers'
     */
    VdtFH: T;

    /**
     * @default 'Best for walkable areas'
     */
    wEPoM: T;

    /**
     * @default 'Explore More Stays'
     */
    eIU7s: T;

    /**
     * @default 'Browse More Vacation Rentals.'
     */
    vtFVS: T;

    /**
     * @default 'Explore Vacation Rentals'
     */
    JCygg: T;

    /**
     * @default 'Search hotels'
     */
    z99rB: T;

    /**
     * @default 'Recommended Neighborhoods'
     */
    '6iwHd': T;

    /**
     * @default 'Search vacation rentals on Vrbo'
     */
    ALUQG: T;
  };
};

export type StayBookingAssistantTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Stay booking assistant updated successfully.'
   */
  'Stay booking assistant updated successfully.': T;

  /**
   * @default 'Stay booking assistant saved successfully.'
   */
  'Stay booking assistant saved successfully.': T;

  /**
   * @default 'Failed to save. Please try again.'
   */
  'Failed to save. Please try again.': T;

  /**
   * @default 'We support jpeg and PNG images.'
   */
  'We support jpeg and PNG images.': T;

  quick: {
    /**
     * @default 'What's Booking Assistant?'
     */
    '2pdvJ': T;

    /**
     * @default 'We find nearby hotel deals for your guests—no need to list or choose hotels yourself. Customize how the hotels appear on your page.'
     */
    jt4cq: T;

    /**
     * @default 'Are you sure you want to delete this stay booking assistant?'
     */
    qHcYj: T;

    /**
     * @default 'The contents of this section will be lost. This action can't be undone.'
     */
    Ddyiq: T;

    /**
     * @default 'Delete Stay Booking Assistant'
     */
    Fdjc8: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Stay booking assistant has been deleted.'
     */
    duGo0: T;

    /**
     * @default 'An error occurred while deleting this stay booking assistant. Please try again.'
     */
    ED47W: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Booking Assistant'
     */
    '9xYfI': T;

    /**
     * @default 'NEW'
     */
    KsWAA: T;

    /**
     * @default 'Simple Hotel List'
     */
    yWxpa: T;

    /**
     * @default 'Hotel Tiles Carousel'
     */
    veeU3: T;

    /**
     * @default '6.0 Pleasant'
     */
    CPA3q: T;

    /**
     * @default '7.0 Good'
     */
    cvgwK: T;

    /**
     * @default '8.0 Very Good'
     */
    fbLE3: T;

    /**
     * @default '9.0 Wonderful'
     */
    HFwWG: T;

    /**
     * @default '2 stars'
     */
    lljVq: T;

    /**
     * @default '3 stars'
     */
    GzyZu: T;

    /**
     * @default '4 stars'
     */
    nnqyJ: T;

    /**
     * @default '5 stars'
     */
    I152N: T;

    /**
     * @default 'Customize Hotel Display'
     */
    piEAk: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Show prices for suggested hotels'
     */
    '88P3C': T;

    /**
     * @default 'Show photo for each hotel'
     */
    lhd78: T;

    /**
     * @default 'Curate Hotel Selection'
     */
    cL6Tx: T;

    /**
     * @default 'Customize and display hotel options'
     */
    GbLZu: T;

    /**
     * @default 'Min Nightly Price'
     */
    y4pKI: T;

    /**
     * @default 'Max Nightly Price'
     */
    EwXLH: T;

    /**
     * @default 'Min Customer Rating'
     */
    D0CxE: T;

    /**
     * @default 'Min Hotel Star Rating'
     */
    Vx1XH: T;

    /**
     * @default 'No hotels match your selected filters.'
     */
    Ys0fO: T;

    /**
     * @default 'Recommended Hotels'
     */
    wbMfS: T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default 'Previous page'
     */
    ot9dK: T;

    /**
     * @default 'Next page'
     */
    '2Bgfo': T;

    /**
     * @default 'Simple Mode'
     */
    '1l5yN': T;

    /**
     * @default 'Display hotel search assistant'
     */
    SQG71: T;

    /**
     * @default 'Advanced Mode'
     */
    prMHR: T;

    /**
     * @default 'Navigation'
     */
    avBYb: T;

    /**
     * @default 'Search Hotels'
     */
    Vq7RA: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Nightly price from:'
     */
    kcLZz: T;

    /**
     * @default 'Choose Background Photo'
     */
    '3KIJJ': T;

    /**
     * @default 'Check-In Date'
     */
    YMM6E: T;

    /**
     * @default 'Add a date'
     */
    qrRii: T;

    /**
     * @default 'Check-Out Date'
     */
    jHfIJ: T;

    /**
     * @default 'Search near'
     */
    cahk3: T;

    /**
     * @default 'San Francisco, CA, USA'
     */
    zGqUZ: T;

    /**
     * @default 'Page Width'
     */
    zzCpp: T;

    /**
     * @default 'Screen Width'
     */
    wAcoa: T;

    /**
     * @default 'Photo Layout'
     */
    AgcDX: T;

    /**
     * @default 'Check-out date must be after check-in date'
     */
    TsSut: T;

    /**
     * @default 'Price must be positive'
     */
    q49tz: T;

    /**
     * @default 'Min price must be less than max price'
     */
    S6NEZ: T;
  };
};

export type StayDetailsGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Only {{0}} file can be added.'
     * @param {number} count - The number of occurrences.
     * - singular: Only {{0}} file can be added.
     * - plural: Only {{0}} files can be added.
     */
    XtNnT: T;

    /**
     * @default 'That file type isn't supported. Please add a photo, screenshot or PDF.'
     */
    HNizh: T;

    /**
     * @default 'That file is too large. Please add one under {{0}}MB.'
     */
    oi3rp: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Upload failed'
     */
    '6yP3V': T;

    /**
     * @default 'Where are you staying?'
     */
    KmGz7: T;

    /**
     * @default 'We couldn't open this link'
     */
    kOTaD: T;

    /**
     * @default 'Please open the link from your email again.'
     */
    K1bvU: T;

    /**
     * @default 'Something went wrong on our end. Please try again later.'
     */
    U8dej: T;

    /**
     * @default 'Add your booking details for {{0}}.'
     */
    '8cOYK': T;

    /**
     * @default 'Add your booking confirmation for {{0}} and we'll take care of the rest.'
     */
    '12mkI': T;

    /**
     * @default 'Don't have your confirmation handy?'
     */
    xLyh1: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Complete the required fields to submit.'
     */
    JNy4y: T;

    /**
     * @default 'Check the details above to submit.'
     */
    J7LHj: T;

    /**
     * @default '1 night · {{0}}'
     * @param {number} count - The number of occurrences.
     * - singular: 1 night · {{0}}
     * - plural: {{0}} nights · {{1}}
     */
    BhE5E: T;

    /**
     * @default 'Add where you're staying.'
     */
    '6ptwB': T;

    /**
     * @default 'Add a check-in date.'
     */
    '4qLZf': T;

    /**
     * @default 'Add a check-out date.'
     */
    dm8NC: T;

    /**
     * @default 'Keep the hotel name to {{0}} characters or fewer.'
     */
    KQlKo: T;

    /**
     * @default 'Keep the cost to {{0}} characters or fewer.'
     */
    WyOCT: T;

    /**
     * @default 'Remove the unsupported character.'
     */
    lVA7h: T;

    /**
     * @default 'Enter the cost as a number, like 420 or 420.50.'
     */
    bjWri: T;

    /**
     * @default 'Choose a valid date.'
     */
    q43tj: T;

    /**
     * @default 'Check-out must be after check-in.'
     */
    ZicG6: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Hotel name'
     */
    RqYES: T;

    /**
     * @default 'Check-in'
     */
    QJjjP: T;

    /**
     * @default 'Add date'
     */
    P6JvO: T;

    /**
     * @default 'Check-out'
     */
    Z515P: T;

    /**
     * @default 'Currency'
     */
    ZpluY: T;

    /**
     * @default 'What did it cost?'
     */
    grAAT: T;

    /**
     * @default 'Total or per night'
     */
    kTiqB: T;

    /**
     * @default 'Drag and drop your booking confirmation, or click to browse'
     */
    fyTlV: T;

    /**
     * @default 'A photo, a screenshot or a PDF · Max {{0}}MB'
     */
    cRfHI: T;

    /**
     * @default 'Add your booking confirmation. You've reached the file limit.'
     */
    tkPwN: T;

    /**
     * @default 'The quickest way. We'll fill in the hotel, dates and price for you.'
     */
    udO17: T;

    /**
     * @default 'Add your booking confirmation'
     */
    khoHi: T;

    /**
     * @default 'Ready to send'
     */
    '01UTk': T;

    /**
     * @default 'Uploading…'
     */
    vVZ8O: T;

    /**
     * @default 'Added'
     */
    AZ9cF: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Remove {{0}}'
     */
    '0zcyi': T;

    /**
     * @default 'You're all set'
     */
    AMUXy: T;

    /**
     * @default 'Thanks — we've got it.'
     */
    gOngz: T;

    /**
     * @default 'We're reading your confirmation now. You can close this page.'
     */
    Q1O10: T;

    /**
     * @default '{{0}} will see where you're staying.'
     */
    C3NYj: T;

    /**
     * @default 'Back to the event website'
     */
    GUp7a: T;

    /**
     * @default 'Found your confirmation? Upload it and we'll fill this in for you.'
     */
    VpspM: T;

    /**
     * @default 'Upload Instead'
     */
    PhSr9: T;
  };
};

export type StaysTranslations<T extends LeafNodeValue = TranslateFunction> = {
  datesOccupants: {
    /**
     * @default 'Find Hotel Rooms'
     */
    cta: T;

    /**
     * @default 'Rooms starting from'
     */
    roomsStartingFrom: T;

    /**
     * @default '{{price}} Nightly'
     */
    nightlyPrice: T;

    /**
     * @default 'Total: {{price}}'
     */
    totalPrice: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default 'Select Room'
     */
    selectRoom: T;

    /**
     * @default 'See Available Rooms'
     */
    seeAvailableRooms: T;

    /**
     * @default 'Configuring Rooms'
     */
    configureRooms: T;

    /**
     * @default 'Room {{number}}'
     */
    roomNumber: T;

    /**
     * @default 'Child {{number}}'
     */
    childNumber: T;

    /**
     * @default 'Adults'
     */
    adults: T;

    /**
     * @default 'Age 17 or under'
     */
    childrenAge: T;

    /**
     * @default 'Age 18 or above'
     */
    adultAge: T;

    /**
     * @default 'Select Dates'
     */
    selectDates: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Apply'
     */
    apply: T;

    /**
     * @default '{{startDate}} - {{endDate}}'
     */
    dateRange: T;

    numberOfAdults: {
      /**
       * @default '1 Adult'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Adult
       * - plural: {{count}} Adults
       */
      adults: T;
    };
    numberOfRooms: {
      /**
       * @default '1 Room'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Room
       * - plural: {{count}} Rooms
       */
      rooms: T;
    };

    /**
     * @default '{{children}} Children'
     */
    numberOfChildren: T;

    /**
     * @default 'Rooms'
     */
    rooms: T;

    /**
     * @default 'Children'
     */
    children: T;

    numberOfGuests: {
      /**
       * @default '1 Guest'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Guest
       * - plural: {{count}} Guests
       */
      guests: T;
    };

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'Add Room'
     */
    addRoom: T;

    /**
     * @default 'Remove Room'
     */
    removeRoom: T;

    /**
     * @default 'Occupancy'
     */
    occupancy: T;

    /**
     * @default 'Dates'
     */
    dates: T;

    /**
     * @default 'Check-In'
     */
    checkIn: T;

    /**
     * @default 'Check-Out'
     */
    checkOut: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Add Date'
     */
    addDate: T;

    /**
     * @default '{{percentage}} Special Wedding Discount'
     */
    discountBar: T;

    /**
     * @default 'Select Age'
     */
    selectAge: T;

    /**
     * @default 'Provide the age of child'
     */
    provideChildAge: T;

    validation: {
      /**
       * @default 'Age must be at least 0'
       */
      childAgeMin: T;

      /**
       * @default 'Age must be 17 or under'
       */
      childAgeMax: T;
    };
  };
  closedUserGroupNotVerified: {
    /**
     * @default 'Enjoy Exclusive Rates for All Joy Couples and Guests'
     */
    title: T;

    /**
     * @default 'Please note that the special rates are only available when you're participating in a Joy event as a host or a guest.'
     */
    description: T;

    redirectOptions: {
      findEvent: {
        /**
         * @default 'I'm a Joy event guest.'
         */
        title: T;

        /**
         * @default 'If you're attending an event hosted with Joy, you can find it here.'
         */
        description: T;
      };
      createEvent: {
        /**
         * @default 'I'd like to create a Joy event.'
         */
        title: T;

        /**
         * @default 'If you'd like to use Joy platform to create an event for you and your guests, click here.'
         */
        description: T;
      };
    };
    advancedAccess: {
      /**
       * @default 'Advanced'
       */
      title: T;

      /**
       * @default 'Get Access'
       */
      unlockRates: T;

      /**
       * @default 'Enter access code'
       */
      subTitle: T;

      /**
       * @default 'Invalid code. Please try again.'
       */
      errorMessage: T;
    };
    superAdmin: {
      /**
       * @default 'Looking for Joy Stays?'
       */
      title: T;

      /**
       * @default 'As a Joy team member, you can search and book hotels directly on our native platform.'
       */
      description: T;

      /**
       * @default 'Go to Joy Stays'
       */
      cta: T;
    };
  };
  currencySelectorModal: {
    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Choose a currency'
     */
    chooseACurrency: T;
  };
  quick: {
    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Rooms'
     */
    gIS1G: T;

    /**
     * @default 'Looking for Joy Stays?'
     */
    Zh2sF: T;

    /**
     * @default 'As a Joy team member, you can search and book hotels directly on our native platform.'
     */
    VAJle: T;

    /**
     * @default 'Go to Joy Stays'
     */
    dxVcB: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Offer expired animation'
     */
    ZXUjE: T;

    /**
     * @default 'Oops! Offer expired — let's find you a new one.'
     */
    Zo8nL: T;

    /**
     * @default 'We're sorry, the offer you selected is no longer available. We've taken you back to the product page where you can explore our latest offers and find a new one that's perfect for you!'
     */
    flDVI: T;

    /**
     * @default 'Sounds Good'
     */
    xAbHu: T;

    /**
     * @default 'Provide the age of child'
     */
    qnhUI: T;

    /**
     * @default 'Age must be at least 0'
     */
    XK89v: T;

    /**
     * @default 'Age must be 17 or under'
     */
    CLkze: T;

    /**
     * @default 'Select currency'
     */
    hjyj4: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Yes'
     */
    '1GaAA': T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default '1 Night'
     */
    Lm76N: T;

    /**
     * @default '{{0}} Nights'
     */
    NKh8H: T;

    /**
     * @default 'Winner'
     */
    '1NExf': T;

    /**
     * @default 'Published Price'
     */
    FV4xU: T;

    /**
     * @default '2nd'
     */
    YIPAA: T;

    /**
     * @default '2nd Published Price'
     */
    DqC0a: T;

    /**
     * @default 'Before markup'
     */
    Bljmz: T;

    /**
     * @default 'After markup'
     */
    AdJr7: T;

    /**
     * @default 'Provider'
     */
    r2z0s: T;

    /**
     * @default 'Nightly'
     */
    Fna6D: T;

    /**
     * @default 'Taxes & Fees'
     */
    '2ufzP': T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Raw Spread'
     */
    NGW4v: T;

    /**
     * @default 'Spread Cap'
     */
    pxBbO: T;

    /**
     * @default 'Final Spread'
     */
    dYbcL: T;

    /**
     * @default 'Total Markup'
     */
    qr21v: T;

    /**
     * @default 'Comparison total used'
     */
    eV9xJ: T;

    /**
     * @default 'Comparison total / night'
     */
    y56Mi: T;

    /**
     * @default 'Best published price'
     */
    tOCl7: T;

    /**
     * @default 'Best published price / night'
     */
    gptp5: T;

    /**
     * @default 'Published price provider'
     */
    GqlXJ: T;

    /**
     * @default 'Published price used'
     */
    '0OdnT': T;

    /**
     * @default 'Spread was capped'
     */
    rGeQe: T;

    /**
     * @default 'Cap percent used'
     */
    qYbOo: T;

    /**
     * @default 'Markup share of spread'
     */
    dHI3u: T;

    /**
     * @default 'Markup / night'
     */
    JavlF: T;

    /**
     * @default 'Synthesized by Joy'
     */
    lngEl: T;

    /**
     * @default 'Skip reason'
     */
    Z5IxM: T;

    /**
     * @default 'Anchor price'
     */
    OkWmu: T;

    /**
     * @default 'Synthesized strikeout'
     */
    ONUqt: T;

    /**
     * @default 'Implied discount'
     */
    N4M2z: T;

    /**
     * @default 'Configured discount'
     */
    PCZkQ: T;

    /**
     * @default 'Rounded to whole unit'
     */
    '7Uepx': T;

    /**
     * @default 'Surface'
     */
    DnHRQ: T;

    /**
     * @default 'Base'
     */
    HgZKA: T;

    /**
     * @default 'Markup'
     */
    '6vvpE': T;

    /**
     * @default 'Distribution mode'
     */
    VoMAf: T;

    /**
     * @default 'Synthetic strikeout'
     */
    jrY7P: T;

    /**
     * @default 'Comparison summary'
     */
    VqcJ6: T;

    /**
     * @default 'Spread walkthrough'
     */
    fQgkp: T;

    /**
     * @default 'Advanced details'
     */
    CNlCH: T;

    /**
     * @default 'Offer markup'
     */
    iQ23u: T;

    /**
     * @default 'Offer markup details'
     */
    y9AOe: T;

    /**
     * @default 'Additional details'
     */
    XuBIA: T;

    /**
     * @default 'OTA links'
     */
    Dzkrj: T;

    /**
     * @default 'Fee'
     */
    '4sUAA': T;

    /**
     * @default 'Tax'
     */
    '9oYAA': T;

    /**
     * @default 'Fees'
     */
    p5BLA: T;

    /**
     * @default 'Taxes'
     */
    DvK9G: T;

    /**
     * @default 'Taxes and Fees'
     */
    ll4cM: T;

    /**
     * @default 'Resort Fee'
     */
    nGBOi: T;

    /**
     * @default 'Resort Charge'
     */
    f9LDZ: T;

    /**
     * @default 'Resort Fee per Night'
     */
    AoqLH: T;

    /**
     * @default 'City Tax'
     */
    cl3RU: T;

    /**
     * @default 'City Fee'
     */
    XpzRU: T;

    /**
     * @default 'Local Fees'
     */
    '8TkxF': T;

    /**
     * @default 'Destination Fee'
     */
    '22Yfg': T;

    /**
     * @default 'Mandatory Fee'
     */
    '9hdMF': T;

    /**
     * @default 'Mandatory Tax'
     */
    EehMF: T;

    /**
     * @default 'Mandatory Charge'
     */
    TTXeK: T;

    /**
     * @default 'Occupancy Tax'
     */
    EfxTk: T;

    /**
     * @default 'State Tax'
     */
    Mh9UV: T;

    /**
     * @default 'County Tax'
     */
    '7mix8': T;

    /**
     * @default 'Tourism Tax'
     */
    KVSnf: T;

    /**
     * @default 'Tourism Fee'
     */
    FZOnf: T;

    /**
     * @default 'Convention/Tourism Fee'
     */
    '5kLTf': T;

    /**
     * @default 'Service Charge'
     */
    RdDXN: T;

    /**
     * @default 'Service Tax'
     */
    amwgf: T;

    /**
     * @default 'Property Service Charge'
     */
    Gh32X: T;

    /**
     * @default 'Hotel Fee'
     */
    ww1VJ: T;

    /**
     * @default 'Extra Person Charge'
     */
    TlnSl: T;

    /**
     * @default 'Amenity Fee'
     */
    tvQ3B: T;

    /**
     * @default 'Facility Fee'
     */
    fF0ka: T;

    /**
     * @default 'Accommodation Fee'
     */
    e8Up2: T;

    /**
     * @default 'Accommodation Tax'
     */
    j4Yp2: T;

    /**
     * @default 'Cleaning Fee'
     */
    tSqu9: T;

    /**
     * @default 'Convenience Fee'
     */
    '5oHjD': T;

    /**
     * @default 'Ecologic Fee'
     */
    laduQ: T;

    /**
     * @default 'Environment Fee'
     */
    '7rskf': T;

    /**
     * @default 'Environmental Fee'
     */
    A5VgL: T;

    /**
     * @default 'Heritage Fee'
     */
    jhUBr: T;

    /**
     * @default 'Hospitality Fee'
     */
    kjFJ2: T;

    /**
     * @default 'Municipality Fee'
     */
    IkK6z: T;

    /**
     * @default 'Other Taxes'
     */
    '5DdGh': T;

    /**
     * @default 'Residential Tax'
     */
    Z4Ep3: T;

    /**
     * @default 'VAT'
     */
    f6YAA: T;

    /**
     * @default 'Local Government Fee'
     */
    OVXsE: T;

    /**
     * @default 'Climate Resilience Tax'
     */
    ZbjK3: T;

    /**
     * @default 'Save up to an extra {{0}} · {{1}}'
     */
    i6FKz: T;

    /**
     * @default 'nothing more to pay'
     */
    vq1zK: T;

    /**
     * @default 'then just {{0}}'
     */
    '1uxJg': T;

    /**
     * @default 'Your fund covers {{0}}'
     */
    eM8bj: T;

    /**
     * @default 'Your honeymoon fund covers'
     */
    Yj0Dm: T;

    /**
     * @default 'Your honeymoon fund has {{0}} available.'
     */
    hTOOe: T;

    /**
     * @default 'Choose it at checkout, or pay by card instead.'
     */
    dzhkl: T;

    /**
     * @default 'How your honeymoon fund is applied'
     */
    nfSQj: T;

    /**
     * @default 'Nothing more to pay'
     */
    DMrKB: T;

    /**
     * @default 'Group code {{0}} applied, rates shown include the couple's group rate.'
     */
    d7eam: T;

    /**
     * @default 'Save more, travel further: {{0}} from Joy'
     */
    YmiN1: T;

    /**
     * @default 'Change your dates'
     */
    '4JmDm': T;

    /**
     * @default 'Check-in {{0}}'
     */
    wlbcf: T;

    /**
     * @default 'Check-out {{0}}'
     */
    NNMq3: T;

    /**
     * @default 'Check-in Instructions'
     */
    lzSmQ: T;

    /**
     * @default 'Pay when you confirm'
     */
    drYMy: T;

    /**
     * @default 'Lowest price. This booking cannot be changed or refunded after purchase.'
     */
    zpTwR: T;

    /**
     * @default 'This is a non-refundable booking. If you cancel or change your booking, you will not receive any refund.'
     */
    '8sKgN': T;

    /**
     * @default 'Cancel for a full refund until {{0}} GMT.'
     */
    '7wnSI': T;

    /**
     * @default 'Cancel for a full refund.'
     */
    zocal: T;

    /**
     * @default 'The estimated cancellation fee is {{0}} until {{1}} GMT.'
     */
    '9q3NO': T;

    /**
     * @default 'The estimated cancellation fee is {{0}}.'
     */
    qteks: T;

    /**
     * @default 'After that, the estimated cancellation fee is {{0}} until {{1}} GMT.'
     */
    IiARX: T;

    /**
     * @default 'After that, the estimated cancellation fee is {{0}}.'
     */
    JXrEp: T;

    /**
     * @default 'from'
     */
    W14PA: T;

    /**
     * @default '/night'
     */
    jhcjJ: T;

    /**
     * @default '{{0}}% Off'
     */
    SZqDF: T;

    /**
     * @default 'All Photos'
     */
    m8UFC: T;

    /**
     * @default 'Hotel Photos'
     */
    v3ExB: T;

    /**
     * @default '✨ Link Copied ✨'
     */
    WeiOM: T;

    /**
     * @default 'Photo Tour'
     */
    qTk69: T;

    /**
     * @default 'Share Link'
     */
    F4p3q: T;

    /**
     * @default 'See Available Rooms'
     */
    '8X2Z1': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'About'
     */
    t7tcF: T;

    /**
     * @default 'Event Note'
     */
    YYsan: T;

    /**
     * @default 'Only {{0}} room left'
     */
    WCyAz: T;

    /**
     * @default 'Only {{0}} rooms left'
     */
    zP8LT: T;

    /**
     * @default 'Cancellation policy'
     */
    rRDVP: T;

    /**
     * @default 'Cancellation fees are estimates and may vary slightly.'
     */
    L7PiZ: T;

    /**
     * @default 'General Instructions'
     */
    D42DM: T;

    /**
     * @default 'Special Instructions'
     */
    qianO: T;

    /**
     * @default 'All taxes and fees included in total'
     */
    rCQs7: T;

    /**
     * @default 'What you see is what you pay'
     */
    VmnON: T;

    /**
     * @default 'Price increase icon'
     */
    ywfZE: T;

    /**
     * @default 'Price might increase if you book later.'
     */
    XA3uT: T;

    /**
     * @default 'Check in'
     */
    '5cfjP': T;

    /**
     * @default 'Check out'
     */
    OY43P: T;

    /**
     * @default '1 Room'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Room
     * - plural: {{0}} Rooms
     */
    YfpCH: T;

    /**
     * @default '1 Night'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Night
     * - plural: {{0}} Nights
     */
    WvQK9: T;

    /**
     * @default 'Non-Refundable'
     */
    ocyBM: T;

    /**
     * @default 'Fully Refundable'
     */
    Wvj8m: T;

    /**
     * @default 'Average per night ({{0}})'
     */
    NMo5w: T;

    /**
     * @default 'View Policy'
     */
    vI7Wj: T;

    /**
     * @default 'The taxes are tax recovery charges paid to vendors (e.g., hotels) for details, please see our  Terms of Use . Service fees are retained as compensation in servicing your booking and may include fees charged by vendors.'
     */
    AYfYt: T;

    /**
     * @default 'Taxes and fees information'
     */
    zjl4G: T;

    /**
     * @default 'Due at property'
     */
    UiuET: T;

    /**
     * @default 'Promo code {{0}} applied'
     */
    JxqRS: T;

    /**
     * @default '-{{0}}'
     */
    '9QMWF': T;

    /**
     * @default 'Saved'
     */
    '5pL4G': T;

    /**
     * @default 'Property phone'
     */
    pfDfu: T;

    /**
     * @default 'Not provided by the property — contact Joy support'
     */
    yOAFH: T;

    /**
     * @default 'Property email'
     */
    BmAnt: T;

    /**
     * @default 'Property photo'
     */
    BjDfu: T;

    /**
     * @default 'Delicious Breakfast Included'
     */
    oMvOo: T;

    /**
     * @default 'Hide Room Facilities'
     */
    QWo4J: T;

    /**
     * @default 'View Room Facilities'
     */
    '5amBI': T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default 'Room'
     */
    FC3MA: T;

    /**
     * @default 'Change your selection'
     */
    lLfa8: T;

    /**
     * @default 'in {{0}} {{1}}'
     */
    YGP8t: T;

    /**
     * @default 'Total ({{0}})'
     */
    xMdRZ: T;

    /**
     * @default 'Fund or travel credit applied'
     */
    kDGEQ: T;

    /**
     * @default 'Honeymoon fund applied'
     */
    Q8ybs: T;

    /**
     * @default 'Net Charged'
     */
    TNn6v: T;

    /**
     * @default 'Paid from your fund or travel credit'
     */
    CBig7: T;

    /**
     * @default 'Pay today'
     */
    PU5ql: T;

    /**
     * @default 'Pay at property exchange conversion is an approximate price based on the current exchange rate and may change before your stay.'
     */
    vDVnR: T;

    /**
     * @default 'Exchange rate information'
     */
    PnXpC: T;

    /**
     * @default 'The hotel collects the {{0}} directly at check-in. Your honeymoon fund can't be used for it.'
     */
    J72U6: T;

    /**
     * @default 'Find Hotel Rooms'
     */
    B05SC: T;

    /**
     * @default 'Invalid dates'
     */
    eVfLe: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Check-In'
     */
    O2ijP: T;

    /**
     * @default 'Check-Out'
     */
    V1s5P: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Occupancy'
     */
    fz51z: T;

    /**
     * @default '{{0}} Rooms'
     */
    QCJKj: T;

    /**
     * @default '{{0}} Adults'
     */
    R2ELj: T;

    /**
     * @default '{{0}} Children'
     */
    tmItH: T;

    /**
     * @default '{{0}} Rooms x {{1}} Adults x {{2}} Children'
     */
    '1Ul7X': T;

    /**
     * @default '{{0}} Rooms x {{1}} Adults'
     */
    SWu9U: T;

    /**
     * @default 'Add Room'
     */
    SkfsO: T;

    /**
     * @default 'Remove Room'
     */
    J7AzN: T;

    /**
     * @default 'Adults'
     */
    '9woIj': T;

    /**
     * @default 'Children'
     */
    jbb2a: T;

    /**
     * @default 'Ages 0-17'
     */
    TdXgR: T;

    /**
     * @default 'Child {{0}}'
     */
    '2LJOz': T;

    /**
     * @default 'Age 17 or under'
     */
    '6FDhE': T;

    /**
     * @default 'Select Age'
     */
    njboI: T;

    /**
     * @default 'Under 1'
     */
    zCCFa: T;

    /**
     * @default 'Most popular amenities'
     */
    v7nIp: T;

    /**
     * @default 'All included amenities'
     */
    MU5pI: T;

    /**
     * @default 'Amenities'
     */
    Zz3IV: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'See on map'
     */
    Ov6ep: T;

    /**
     * @default 'We couldn't complete express checkout'
     */
    zPmr8: T;

    /**
     * @default 'Continue to standard checkout to finish your booking.'
     */
    bpMcQ: T;

    /**
     * @default 'Continue to checkout'
     */
    MLKKL: T;

    /**
     * @default 'Free cancellation before {{0}}, {{1}} GMT'
     */
    NrW7c: T;

    /**
     * @default 'Your honeymoon fund has {{0}} available — switch to {{1}} to use it on this stay.'
     */
    k0dAw: T;

    /**
     * @default 'Switch to {{0}}'
     */
    DdniK: T;

    /**
     * @default 'Non Refundable'
     */
    FzTNQ: T;

    /**
     * @default 'Lock Price for {{0}} hours for free'
     */
    nzXE8: T;

    /**
     * @default 'Lock Price'
     */
    '61zyR': T;

    /**
     * @default 'Note from {{0}}'
     */
    sPx35: T;

    /**
     * @default 'Less'
     */
    '3I6LA': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Terms Of Service'
     */
    LpQZs: T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Cookie Preferences'
     */
    '2dkkO': T;

    /**
     * @default 'Help Center'
     */
    '0H3Rt': T;

    /**
     * @default 'Manage My Bookings'
     */
    rmXUP: T;

    /**
     * @default '© Joy, {{0}}'
     */
    racYy: T;

    /**
     * @default 'Footer navigation'
     */
    VdDt2: T;

    /**
     * @default 'We found 1 additional room option from our booking partners.'
     * @param {number} count - The number of occurrences.
     * - singular: We found 1 additional room option from our booking partners.
     * - plural: We found {{0}} additional room options from our booking partners.
     */
    EHfYi: T;

    /**
     * @default 'No Available Rooms'
     */
    OMeW3: T;

    /**
     * @default 'Modify your search criteria and try again.'
     */
    git2M: T;

    /**
     * @default 'Modify your search criteria'
     */
    '6dM83': T;

    /**
     * @default 'Explore Other Options'
     */
    tWLyH: T;

    /**
     * @default 'See Available rooms'
     */
    OwG93: T;

    /**
     * @default 'Choose your room'
     */
    xcXpM: T;

    /**
     * @default 'Didn't find what you're looking for?'
     */
    NPFYI: T;

    /**
     * @default 'View More Options'
     */
    '8xkAt': T;

    /**
     * @default 'More Room Options'
     */
    QcLNw: T;

    /**
     * @default 'About the hotel'
     */
    ACved: T;

    /**
     * @default 'Hotel Overview'
     */
    L0kcQ: T;

    /**
     * @default 'Discover essential information about our hotel.'
     */
    MO0tX: T;

    /**
     * @default 'Read less'
     */
    LaPQg: T;

    /**
     * @default 'Read more'
     */
    rkbQg: T;

    /**
     * @default 'Map showing hotel and event venue'
     */
    PnowH: T;

    /**
     * @default 'Rooms starting from'
     */
    AqPhx: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default '{{0}}% Special Wedding Discount'
     */
    BKn5B: T;

    /**
     * @default 'Link Copied'
     */
    oxFZd: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Best Price'
     */
    XxPmg: T;

    /**
     * @default 'Biggest Discount'
     */
    e8m24: T;

    /**
     * @default 'Refundable'
     */
    '44cUc': T;

    /**
     * @default 'Non-refundable'
     */
    sYxgN: T;

    /**
     * @default 'Breakfast Included'
     */
    PaqdW: T;

    /**
     * @default 'Clear all'
     */
    YgozE: T;

    /**
     * @default 'No rooms match your criteria.'
     */
    s9ITb: T;

    /**
     * @default 'Clear filters'
     */
    '0Ev5m': T;

    /**
     * @default 'Default Hotel Offer Photo'
     */
    REFaz: T;

    /**
     * @default 'Review highlights'
     */
    JYxy7: T;

    /**
     * @default 'Read all reviews'
     */
    ya3mN: T;

    /**
     * @default 'What did guests like the most'
     */
    HhBqb: T;

    /**
     * @default 'Guest Reviews'
     */
    ROwNI: T;

    /**
     * @default 'Who stays at this property'
     */
    W52hY: T;

    /**
     * @default 'Something went wrong loading reviews.'
     */
    sVmi6: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Show More Reviews'
     */
    PprYT: T;

    /**
     * @default 'Showing {{0}} out of {{1}} reviews'
     */
    MzLSR: T;

    /**
     * @default 'Showing {{0}} reviews'
     */
    gcth9: T;

    /**
     * @default 'Turn the celebration into a mini-getaway. Add a night or two.'
     */
    mnlZh: T;

    /**
     * @default 'Room Policy'
     */
    fzx8H: T;

    /**
     * @default 'View room details'
     */
    G23rK: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Reviews'
     */
    VW5Jg: T;

    /**
     * @default 'Ticket emoji'
     */
    sWWC9: T;

    /**
     * @default 'Your checkout session expires in'
     */
    QI4s0: T;

    /**
     * @default 'Refunds on cash fund payments come back as travel credit, so it's ready for your next Joy stay. It never expires. Anything you paid by card goes back to your card.'
     */
    DDVRi: T;

    /**
     * @default 'Included in rate'
     */
    DAwhB: T;

    /**
     * @default 'Plans change. Pick the option that gives you the right amount of flexibility.'
     */
    Oodth: T;

    /**
     * @default 'Fully refundable'
     */
    arido: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Anonymous'
     */
    F6mAC: T;

    /**
     * @default 'Show Less'
     */
    yPlIB: T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default '{{0}} on'
     */
    '1UOTN': T;

    /**
     * @default 'Newest First'
     */
    '2kqF3': T;

    /**
     * @default 'Oldest First'
     */
    '7YmGE': T;

    /**
     * @default 'Highest Rated'
     */
    QiwmQ: T;

    /**
     * @default 'Lowest Rated'
     */
    Y7FvF: T;

    /**
     * @default '👩‍❤️‍👨 Couples'
     */
    '1lUv1': T;

    /**
     * @default '🧑‍ Families'
     */
    QxEnQ: T;

    /**
     * @default '🧍‍♂️ Solo'
     */
    Yx6VJ: T;

    /**
     * @default '🏄‍♀️ Large groups'
     */
    V9dhM: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Refundable option available'
     */
    chkf4: T;

    /**
     * @default 'No Meals Included'
     */
    BfPDr: T;

    /**
     * @default '{{0}}% Savings'
     */
    mRVxh: T;

    /**
     * @default '{{0}} total incl. taxes, fees & property charges'
     */
    QuizN: T;

    /**
     * @default '{{0}} total includes taxes & fees'
     */
    '5mdrU': T;

    /**
     * @default 'Room Information'
     */
    XmsjE: T;

    /**
     * @default 'Room Facilities'
     */
    I9Nxg: T;

    /**
     * @default 'Cancellation Policy'
     */
    N8A5N: T;

    /**
     * @default '{{0}} Rate'
     */
    ifawE: T;

    /**
     * @default 'Reserve'
     */
    IGc4f: T;

    /**
     * @default 'Offer Expired'
     */
    '3GwvB': T;

    /**
     * @default 'This offer is no longer available. Click here to see the latest offers.'
     */
    '8I8dt': T;

    /**
     * @default 'See Latest Offers'
     */
    tXsCp: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default '/ night'
     */
    bjrXI: T;

    /**
     * @default 'total'
     */
    m1ekJ: T;

    /**
     * @default '(+{{0}} taxes, fees & property charges)'
     */
    EGCxM: T;

    /**
     * @default '(+{{0}} taxes & fees)'
     */
    uwxPz: T;

    /**
     * @default 'Room Details'
     */
    lX7WV: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Choose room'
     */
    mqzoA: T;

    /**
     * @default 'View All'
     */
    MkQe0: T;
  };
};

export type StaysRedesignGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Honeymoon destination video'
     */
    HDLbc: T;

    /**
     * @default 'From “I do” to “I don’t want to leave”'
     */
    kLUj6: T;

    /**
     * @default '— your dream honeymoon starts now.'
     */
    nOeri: T;

    /**
     * @default 'Curated'
     */
    eNxKJ: T;

    /**
     * @default 'Itineraries with Lonely Planet'
     */
    Y7si9: T;

    /**
     * @default 'Hand-built routes from the writers who’ve been there first — from Tuscan hill towns to Kyoto back streets.'
     */
    faZ5s: T;

    /**
     * @default '$250 off for Joy couples'
     */
    stYXt: T;

    /**
     * @default 'Automatically applied to every itinerary.'
     */
    zOjxJ: T;

    /**
     * @default 'All-Inclusive'
     */
    enUBY: T;

    /**
     * @default 'Packages with JetBlue Vacations'
     */
    EHG8Y: T;

    /**
     * @default 'Flights, stays, and the small details handled together — so the only thing left to plan is what to order first.'
     */
    RFbKp: T;

    /**
     * @default 'Up to $300 in exclusive perks'
     */
    TsqmM: T;

    /**
     * @default 'Drinks for two on arrival'
     */
    igueJ: T;

    /**
     * @default 'Early boarding for two'
     */
    GxMcL: T;

    /**
     * @default 'Free airport transfers'
     */
    RnsLs: T;

    /**
     * @default 'Resort perks worth $125'
     */
    eZox7: T;

    /**
     * @default 'Your Way'
     */
    Q8GSg: T;

    /**
     * @default 'Book your own trip with Joy'
     */
    HGeBD: T;

    /**
     * @default 'Browse hotels and experiences the way you like to travel — with rates our members don’t find anywhere else.'
     */
    FGLBd: T;

    /**
     * @default 'Up to 40% off as a Joy couple'
     */
    '5l5nE': T;

    /**
     * @default 'Applied automatically at checkout.'
     */
    DRalf: T;
  };
};

export type SuggestionsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  eventSuggestions: {
    'reg-get-started': {
      /**
       * @default 'Get Started'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Start your everything wedding registry today with Joy.'
       */
      hed: T;
    };
    'reg-shop': {
      /**
       * @default 'Add Gifts'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Shop the best brands, gift cards, and experiences in one place.'
       */
      hed: T;
    };
    'reg-connect-registries': {
      /**
       * @default 'Learn How'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Add gifts from any store or an entire registry.'
       */
      hed: T;
    };
    'reg-browse-cash-funds': {
      /**
       * @default 'Explore Cash Funds'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Create a zero-fee cash fund and save for anything.'
       */
      hed: T;
    };
    'reg-discount': {
      /**
       * @default 'Add More Gifts'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Get 20% off after the big day with our newlywed discount.'
       */
      hed: T;
    };
    'onboarding-designs': {
      /**
       * @default 'Edit Design'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Style your registry and give guests one seamless place to shop.'
       */
      hed: T;
    };
    'new-update-designs-2020-01-14': {
      /**
       * @default 'Browse Designs'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Design your website with 70+ new designs.'
       */
      hed: T;
    };
    'onboarding-add-page-photos': {
      /**
       * @default 'Edit Your Photo'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Have you added photos?'
       */
      hed: T;
    };
    writersblock: {
      /**
       * @default 'Try it out'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Overcome Wedding Writer’s Block with AI.'
       */
      hed: T;
    };
  };
  adminFeed: {
    /**
     * @default 'You're all set!

Take a breath, you're doing great.'
*/
    zeroStateMessage: T;

    /**
     * @default 'View Past Suggestions'
     */
    zeroStateViewPast: T;
  };
  quick: {
    /**
     * @default 'Yep!'
     */
    Jn3NA: T;

    /**
     * @default 'Not yet'
     */
    v6grU: T;

    /**
     * @default 'Not interested'
     */
    Q4OCG: T;

    /**
     * @default 'Awesome, thanks!'
     */
    ZzvBM: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type SurveyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  buttons: {
    /**
     * @default 'OK'
     */
    nextLabel: T;

    /**
     * @default 'Back'
     */
    backLabel: T;

    /**
     * @default 'Submit'
     */
    submitLabel: T;

    /**
     * @default 'Skip'
     */
    skipLabel: T;
  };
  errors: {
    /**
     * @default 'Please complete the field above'
     */
    required: T;
  };
  quick: {
    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Enter a valid email address.'
     */
    DqvUM: T;

    /**
     * @default 'Enter a valid phone number. For a number from another country, start with + and the country code.'
     */
    Gh6CE: T;

    /**
     * @default 'Other:'
     */
    OFMdL: T;

    /**
     * @default 'optional'
     */
    uCHW7: T;

    /**
     * @default '(optional)'
     */
    jghot: T;
  };
};

export type TagsAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Add a label...'
     */
    sK113: T;

    /**
     * @default 'Remove {{0}}'
     */
    '0zcyi': T;

    /**
     * @default '"{{0}}" is already assigned. Tags ignore capitalization.'
     */
    lPPtQ: T;

    /**
     * @default '"{{0}}" already exists. Tags ignore capitalization. Select it below or enter a different name.'
     */
    RaifW: T;

    /**
     * @default 'Creating...'
     */
    Fbo9N: T;

    /**
     * @default '+ Create "{{0}}"'
     */
    Ho5hp: T;

    /**
     * @default 'Failed to create tag'
     */
    Gfgm6: T;
  };
};

export type TextBlastAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'By purchasing you are acquiring a license to access digital products and agree to Joy's <0>terms</0> and <1>privacy</1>.'
   */
  smsPaymentLegal: T;

  quick: {
    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;

    /**
     * @default 'Sender name must be {{0}} characters or fewer.'
     */
    gjs6q: T;

    /**
     * @default 'We have an important update to share with you regarding our upcoming celebration.'
     */
    S5KXr: T;

    /**
     * @default 'Untitled text blast - {{0}}'
     */
    JihzQ: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Pick a time at least {{0}} minutes from now.'
     */
    g2jG7: T;

    /**
     * @default 'Pick a date within the next year.'
     */
    '4ChIg': T;

    /**
     * @default 'Rescheduled for {{0}}'
     */
    TI5PA: T;

    /**
     * @default 'Scheduled for {{0}}'
     */
    IqZad: T;

    /**
     * @default 'This message is already being sent.'
     */
    MEZgA: T;

    /**
     * @default 'Sorry, something went wrong'
     */
    kkwz0: T;

    /**
     * @default 'Text Blast'
     */
    jYY9B: T;

    /**
     * @default 'We couldn't save your draft, so you're still in this editor. Check your connection and try again.'
     */
    fHTAC: T;

    /**
     * @default 'Switch to the new editor?'
     */
    kfeD4: T;

    /**
     * @default 'We'll save your current text message, and you'll find it in Drafts. The new editor uses a different format, so you'll start with a blank message and choose your recipients again.'
     */
    '0exHg': T;

    /**
     * @default 'Save & Switch'
     */
    dXmSz: T;

    /**
     * @default 'Try the new message editor'
     */
    ErYx5: T;

    /**
     * @default 'Write your text where you'll see it, with a live preview — and add an email to the same send. You can switch back anytime.'
     */
    nOixu: T;

    /**
     * @default 'Try the New Editor'
     */
    D7jRS: T;

    /**
     * @default 'SMS messaging activated! You can now send text messages to your guests.'
     */
    kQmmQ: T;

    /**
     * @default 'Payment was not completed. You can try again when you're ready.'
     */
    tlQsK: T;

    /**
     * @default 'Payment received, but activation is taking longer than expected. Please refresh the page.'
     */
    VHGYp: T;

    /**
     * @default 'Message from {{0}}'
     */
    ZASjR: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Your message to guests'
     */
    mkfzl: T;

    /**
     * @default 'Message sent successfully!'
     */
    d2F6T: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Send Now'
     */
    Ow0GV: T;

    /**
     * @default 'Confirm & Send'
     */
    KYpY4: T;

    /**
     * @default 'Review the details below and send your text blast to your guests.'
     */
    MC7Cx: T;

    /**
     * @default 'Something Went Wrong'
     */
    DhQjr: T;

    /**
     * @default 'We weren't able to send your messages. Please check your connection and try again.'
     */
    '9YSw9': T;

    /**
     * @default 'Review & Resend'
     */
    '5QGJr': T;

    /**
     * @default 'Back to Compose'
     */
    qYQEB: T;

    /**
     * @default '1 Person Selected…'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Person Selected…
     * - plural: {{0}} People Selected…
     */
    HsBfd: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Modify Recipients'
     */
    Yv9UB: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Compose Message'
     */
    lBM1t: T;

    /**
     * @default 'Send an SMS to your guests.'
     */
    Zjf5M: T;

    /**
     * @default 'How it works'
     */
    f7Woo: T;

    /**
     * @default 'Pick guests'
     */
    yMQrC: T;

    /**
     * @default 'Write message'
     */
    QYiDG: T;

    /**
     * @default 'Message sent'
     */
    B7JI3: T;

    /**
     * @default 'Review Scheduled Text Blast'
     */
    aeuj4: T;

    /**
     * @default 'This message is locked while it's scheduled. Use "Edit Message" to make changes.'
     */
    W23tA: T;

    /**
     * @default 'Reschedule send'
     */
    qm0u7: T;

    /**
     * @default 'Reschedule'
     */
    '82rNl': T;
  };
};

export type ThanksForRsvpTranslations<T extends LeafNodeValue = TranslateFunction> = {
  congratulationsCard: {
    /**
     * @default 'Back to Website'
     */
    backToWebsite: T;

    /**
     * @default 'the couple'
     */
    theCouple: T;

    /**
     * @default 'There was an error: {{msg}}. Please try again or contact support.'
     */
    error: T;

    /**
     * @default 'Your RSVP'
     */
    yourRSVP: T;

    /**
     * @default 'and card have'
     */
    andCardHave: T;

    /**
     * @default 'has'
     */
    has: T;

    /**
     * @default 'been sent{{coupleName}}’s event!'
     */
    beenSent: T;

    /**
     * @default 'Your RSVP has been sent.'
     */
    yourRSVPComplete: T;

    /**
     * @default 'Want to send a note of congrats?'
     */
    noteOfCongrats: T;

    /**
     * @default 'Congratulations Note'
     */
    noteTitle: T;

    /**
     * @default 'Your Note'
     */
    yourNoteTitle: T;

    /**
     * @default 'Add a note to the couple'
     */
    notePlaceholder: T;

    /**
     * @default 'Free'
     */
    free: T;

    /**
     * @default 'Congratulations eCard'
     */
    wrapTitle: T;

    /**
     * @default 'Wrap your note in a beautiful design.'
     */
    wrapDescription: T;

    /**
     * @default 'Back to Event Website'
     */
    backToEventWebsite: T;

    /**
     * @default 'Preview Your Note'
     */
    previewYourNote: T;

    /**
     * @default 'Send Message'
     */
    sendMessage: T;

    /**
     * @default 'Continue to Purchase'
     */
    continueToPurchase: T;

    /**
     * @default 'Your Email (Required for Replies)'
     */
    yourEmail: T;

    /**
     * @default 'Are you sure you want to continue without editing the congrats message?'
     */
    uneditedWarningMessage: T;

    /**
     * @default 'Next steps from Joy wedding experts'
     */
    whatNext: T;

    /**
     * @default 'Next steps from Joy wedding experts'
     */
    whatNextV2: T;

    emptyState: {
      /**
       * @default 'Event Details'
       */
      title: T;

      /**
       * @default 'Head back to the event website to find all the details.'
       */
      description: T;

      /**
       * @default 'Back to Website'
       */
      ctaText: T;
    };
    accommodations: {
      /**
       * @default 'We’ve secured discounted rates on a hotel near our venue.'
       */
      title: T;

      /**
       * @default 'Where To Stay'
       */
      titleNoRoomBlock: T;

      /**
       * @default 'Book soon while rooms are available.'
       */
      description: T;

      /**
       * @default 'We have listed our recommended hotel options for your convenience. Book soon while rooms are available.'
       */
      descriptionNoRoomBlock: T;

      /**
       * @default 'View Accommodations'
       */
      ctaText: T;
    };
    nearbyHotels: {
      withCityCopy: {
        /**
         * @default 'Book Your Stay'
         */
        heading: T;

        /**
         * @default 'Check out discounted rates in {{city}} for event guests.'
         */
        subHeading: T;

        /**
         * @default 'Browse Hotels'
         */
        ctaText: T;
      };
      genericCopy: {
        /**
         * @default 'Book Your Stay'
         */
        heading: T;

        /**
         * @default 'Check out discounted rates for event guests'
         */
        subHeading: T;

        /**
         * @default 'Browse Hotels'
         */
        ctaText: T;
      };
    };
    accommodationsV2: {
      /**
       * @default 'Where to Stay'
       */
      title: T;

      /**
       * @default 'We’ve reserved room blocks our special group'
       */
      descriptionRoomBlockOnly: T;

      /**
       * @default 'Here’s are a few places we’d love for everyone to stay.'
       */
      descriptionMultipleAccommodations: T;

      /**
       * @default 'Here’s where we recommend you stay near in the area.'
       */
      descriptionAccommodationPlaceOnly: T;

      /**
       * @default '{{miles}} miles from the venue'
       */
      distanceFromVenue: T;

      /**
       * @default 'Group Rate Ends {{date}}'
       */
      groupRateEnds: T;

      /**
       * @default 'View Room Block'
       */
      ctaRoomBlockOnly: T;

      /**
       * @default 'View Options'
       */
      ctaMultipleAccommodations: T;

      /**
       * @default 'View Stay'
       */
      ctaAccommodationPlaceOnly: T;
    };
    registry: {
      /**
       * @default 'View Registry'
       */
      ctaText: T;

      /**
       * @default 'Browse Registry'
       */
      heading: T;

      /**
       * @default 'Explore gifts {{eventName}} added to their registry.'
       */
      subHeadingWithName: T;
    };
  };
  accommodationsPushStep: {
    /**
     * @default 'Add Your Stay'
     */
    title: T;

    /**
     * @default 'Book your stay for the event and celebrate without a worry in the world.'
     */
    message: T;

    valueProps: {
      refundable: {
        /**
         * @default 'Stay Flexible'
         */
        title: T;

        /**
         * @default 'Pick fully refundable rates for peace of mind.'
         */
        description: T;
      };
      lowestRate: {
        /**
         * @default 'Lowest Rates'
         */
        title: T;

        /**
         * @default 'Exclusive rates for Joy events not available to the public.'
         */
        description: T;
      };
    };
    genericOfferingCard: {
      /**
       * @default 'Book Before Rooms Sell Out'
       */
      sellingFastBadge: T;

      /**
       * @default 'Hotels For Your Stay'
       */
      title: T;

      /**
       * @default 'Browse Hotels'
       */
      browseHotelsCta: T;
    };
    noAccomOrTravelCohort: {
      /**
       * @default 'Add Your Stay'
       */
      title: T;

      /**
       * @default 'Up to 20% off'
       */
      rateDisplayOverride: T;
    };
    hasOwnAccommodationsCohort: {
      /**
       * @default '{{eventDisplayName}}'s Preferred Hotels'
       */
      titleWithDisplayName: T;

      /**
       * @default 'Preferred Hotels'
       */
      genericTitle: T;

      /**
       * @default 'Stay near the venue, so you can spend more time with friends and family.'
       */
      message: T;

      /**
       * @default 'Select Hotel'
       */
      selectHotelCtaText: T;
    };
    offeringCard: {
      rateSection: {
        /**
         * @default 'Rate From'
         */
        title: T;

        rateType: {
          /**
           * @default 'Per Night'
           */
          daily: T;
        };
      };
      roomBlockRateSection: {
        /**
         * @default 'Book Before'
         */
        bookBefore: T;

        /**
         * @default 'Group Rate'
         */
        groupRate: T;

        /**
         * @default '{{price}} / Night'
         */
        pricePerNight: T;
      };
      distanceFromVenue: {
        /**
         * @default '{{distance}} miles from the venue'
         */
        mi: T;

        /**
         * @default '{{distance}} km from the venue'
         */
        km: T;
      };
    };
    footer: {
      /**
       * @default 'Not ready to book your stay?'
       */
      message: T;

      /**
       * @default 'Skip For Now'
       */
      ctaText: T;
    };
  };
  quick: {
    /**
     * @default 'Lodging Offering'
     */
    sa1fe: T;

    /**
     * @default 'Going fast'
     */
    c39EQ: T;

    /**
     * @default 'Less'
     */
    '3I6LA': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Select Hotel'
     */
    QWIB8: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default 'Your RSVP has been sent for {{0}}'s event!'
     */
    qcZVi: T;

    /**
     * @default 'Your RSVP has been sent!'
     */
    JbyOY: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Head back to the event website to find all the details.'
     */
    OuHcC: T;

    /**
     * @default 'Back to Website'
     */
    dNvtn: T;

    /**
     * @default 'Book Your Stay'
     */
    dtKQh: T;

    /**
     * @default 'Check out discounted rates in {{0}} for event guests.'
     */
    '6pwvu': T;

    /**
     * @default 'Check out discounted rates for event guests'
     */
    HcPaj: T;

    /**
     * @default 'Browse Hotels'
     */
    fDEDd: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'We've secured discounted rates on a hotel near our venue.'
     */
    fjK4Q: T;

    /**
     * @default 'Where To Stay'
     */
    xHHwM: T;

    /**
     * @default 'Book soon while rooms are available.'
     */
    u4LsD: T;

    /**
     * @default 'We have listed our recommended hotel options for your convenience. Book soon while rooms are available.'
     */
    bfNMI: T;

    /**
     * @default 'View Accommodations'
     */
    o4DHg: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'Explore gifts {{0}} added to their registry.'
     */
    '2vtJP': T;

    /**
     * @default 'Explore gifts the host added to their registry.'
     */
    '1Dl8P': T;

    /**
     * @default 'View Registry'
     */
    gIPTc: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Joy Home Page'
     */
    MAxNh: T;

    /**
     * @default 'About'
     */
    t7tcF: T;
  };
};

export type ThingsToDoCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Unable to fetch page info'
     */
    bbmol: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Please enter a valid URL'
     */
    evr6K: T;

    /**
     * @default 'Category is required'
     */
    B1r37: T;

    /**
     * @default 'Personal note is required'
     */
    dhTWY: T;

    /**
     * @default 'Couldn’t upload the photo. Your changes are still here — try again.'
     */
    RAnCG: T;

    /**
     * @default 'Things to Do'
     */
    XA7i5: T;

    /**
     * @default 'Edit Thing to Do'
     */
    QRkZG: T;

    /**
     * @default 'Add Thing to Do'
     */
    '3HMGB': T;

    /**
     * @default 'Category'
     */
    Ixu8Y: T;

    /**
     * @default 'Custom Category'
     */
    liMFl: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'thingtodo.com'
     */
    L1nEI: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Louvre Museum'
     */
    bz9OM: T;

    /**
     * @default 'Personal Note'
     */
    eIPUB: T;

    /**
     * @default 'Add some optional details about why you think your guests would enjoy it, things to know, etc.'
     */
    VZNll: T;

    /**
     * @default 'Delete Thing to Do'
     */
    '9Fw8F': T;

    /**
     * @default 'What's Thing to Do'
     */
    SEDpN: T;

    /**
     * @default 'Give guests ideas for their free time during the trip.'
     */
    d36kk: T;

    /**
     * @default 'Thing to Do'
     */
    CdK0S: T;
  };
};

export type TicketsAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Copy of {{0}}'
     */
    QIgEL: T;

    /**
     * @default 'Ticket Types'
     */
    bFkr7: T;

    /**
     * @default 'Add Ticket'
     */
    Fss8F: T;

    /**
     * @default 'Guests can register without tickets. Enable ticketing to add ticket options to registration form.'
     */
    kuGey: T;

    /**
     * @default 'Inactive Tickets'
     */
    sFgtN: T;

    /**
     * @default 'Ticket Sales'
     */
    UE8i7: T;

    /**
     * @default 'No email on file'
     */
    o5Fli: T;

    /**
     * @default '{{0}} is sold out'
     */
    mKbdD: T;

    /**
     * @default '{{0}} isn't on sale'
     */
    N55zu: T;

    /**
     * @default 'This ticket isn't available'
     */
    '64IVG': T;

    /**
     * @default 'This ticket is free now'
     */
    MXCPe: T;

    /**
     * @default 'You can resend in {{0}} min'
     */
    F5eUi: T;

    /**
     * @default '{{0}} has a newer registration'
     */
    lIRwM: T;

    /**
     * @default '{{0}} isn't attending'
     */
    r8w8T: T;

    /**
     * @default '{{0}} was removed from the guest list'
     */
    '07CQB': T;

    /**
     * @default 'A payment is already in progress'
     */
    dycKL: T;

    /**
     * @default 'Something went wrong. Try again.'
     */
    KNRCj: T;

    /**
     * @default 'Send Payment Link'
     */
    Yz10l: T;

    /**
     * @default 'Payment link sent to {{0}}'
     */
    ZePgt: T;

    /**
     * @default 'Payment link sent'
     */
    WWdhb: T;

    /**
     * @default 'A payment for this order is already in progress or complete. Check Stripe before trying again.'
     */
    FJ1vT: T;

    /**
     * @default 'We couldn't check this order's payment. Try again in a minute.'
     */
    tvF3K: T;

    /**
     * @default 'This registration just changed. Refresh and try again.'
     */
    IAQhG: T;

    /**
     * @default 'This order no longer exists. Refresh and try again.'
     */
    dWF2Q: T;

    /**
     * @default 'Awaiting Payment'
     */
    WeqgT: T;

    /**
     * @default 'Payment Expired'
     */
    pd0Wu: T;

    /**
     * @default 'Cancelled'
     */
    JVlxD: T;

    /**
     * @default 'Unpaid Registrations'
     */
    RJez3: T;

    /**
     * @default 'We couldn't load unpaid registrations.'
     */
    pqdqW: T;

    /**
     * @default '1 Unpaid Registration'
     */
    frDVI: T;

    /**
     * @default '{{0}} Unpaid Registrations'
     */
    RHNT7: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'This ticket'
     */
    mbTeF: T;

    /**
     * @default 'Link sent {{0}}'
     */
    '0i0DC': T;

    /**
     * @default 'Mark as Paid'
     */
    npgFV: T;

    /**
     * @default 'We couldn't load your registration settings. Refresh and try again.'
     */
    mHHKP: T;

    /**
     * @default 'Cancel Order'
     */
    WQT4k: T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default 'Guests & Ticket Sales will appear here.'
     */
    wIeR3: T;

    /**
     * @default 'Needs Review'
     */
    hUOct: T;

    /**
     * @default 'Completed'
     */
    NwyhL: T;

    /**
     * @default 'Expired'
     */
    '7Jwbu': T;

    /**
     * @default 'Refunded'
     */
    '3DziC': T;

    /**
     * @default 'We couldn't finish loading guests awaiting review.'
     */
    YH4WH: T;

    /**
     * @default '1 Guest'
     */
    Ju5ZN: T;

    /**
     * @default '{{0}} Guests'
     */
    JZhY0: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Ticket Type'
     */
    '68FUr': T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Approve'
     */
    xSOVc: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Show All'
     */
    E73y6: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Payment Methods'
     */
    '2qc4e': T;

    /**
     * @default 'Choose accepted payment methods for your events and memberships.'
     */
    FJ1Oo: T;

    /**
     * @default 'Cards'
     */
    PVimF: T;

    /**
     * @default 'Major credit and debit cards, Apple Pay and Google Pay are always accepted.'
     */
    glEJ3: T;

    /**
     * @default 'Manage on Stripe'
     */
    FmtSg: T;

    /**
     * @default '1 Purchase needs your review'
     */
    abaqc: T;

    /**
     * @default '{{0}} Purchases need your review'
     */
    '9XVpP': T;

    /**
     * @default 'Review All'
     */
    Z3Esz: T;

    /**
     * @default 'We couldn't load ticket sales.'
     */
    aOc7X: T;

    /**
     * @default 'a host'
     */
    '7KAZ0': T;

    /**
     * @default 'Ticket Purchase'
     */
    pJGWi: T;

    /**
     * @default 'Hide Details'
     */
    SlaeC: T;

    /**
     * @default 'Show Details'
     */
    xT55w: T;

    /**
     * @default 'Comped by {{0}} on {{1}} · {{2}}'
     */
    '05MN0': T;

    /**
     * @default 'Marked as paid outside Joy by {{0}} on {{1}} · {{2}}'
     */
    '5N68S': T;

    /**
     * @default 'Comped'
     */
    WbmSp: T;

    /**
     * @default 'Paid outside Joy'
     */
    vpKx7: T;

    /**
     * @default '{{0}} face value'
     */
    '8a5iR': T;

    /**
     * @default 'Stripe'
     */
    dTiFW: T;

    /**
     * @default 'We couldn't finish loading ticket sales.'
     */
    P1oah: T;

    /**
     * @default 'Showing {{0}} of {{1}}'
     */
    '1eVVT': T;

    /**
     * @default 'Stripe Account Under Review'
     */
    OBKSf: T;

    /**
     * @default 'Start Selling Tickets'
     */
    pnot6: T;

    /**
     * @default 'You've completed Stripe setup. Stripe is reviewing your account — this usually takes a few minutes.'
     */
    uOEbt: T;

    /**
     * @default 'Your Stripe account needs more information to be ready to use.'
     */
    mfcCN: T;

    /**
     * @default 'Create a Stripe account in minutes and start selling tickets for your event.'
     */
    '7vzxM': T;

    /**
     * @default 'Check Status'
     */
    '4VRiW': T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Stripe is a secure payment processor with low fees that handles all of Joy's sales.'
     */
    W2abs: T;

    /**
     * @default 'Enable promo codes'
     */
    iKZSS: T;

    /**
     * @default 'Allow Purchase of Available Tickets'
     */
    vGXLY: T;

    /**
     * @default 'They paid another way'
     */
    c58Wx: T;

    /**
     * @default 'Cash, Venmo, bank transfer'
     */
    PlcTo: T;

    /**
     * @default 'Payment note'
     */
    OblV3: T;

    /**
     * @default 'e.g. Paid by Venmo on Sep 17'
     */
    t1K34: T;

    /**
     * @default 'Add a payment note'
     */
    Gw41y: T;

    /**
     * @default 'I'm giving them this ticket for free'
     */
    OrXca: T;

    /**
     * @default 'No payment expected'
     */
    XDhLj: T;

    /**
     * @default 'Reason'
     */
    omLMS: T;

    /**
     * @default 'e.g. Speaker, volunteer or family'
     */
    Ate9F: T;

    /**
     * @default 'Add a reason'
     */
    cV4Eu: T;

    /**
     * @default 'Register for Free'
     */
    uunYC: T;

    /**
     * @default '{{0}} is registered, but we couldn't email them. Let them know directly.'
     */
    lIPUN: T;

    /**
     * @default '{{0}} is registered'
     */
    OU3zy: T;

    /**
     * @default '{{0}} is sold out. Raise its capacity, then try again.'
     */
    kDe3B: T;

    /**
     * @default '{{0}} is marked as not attending.'
     */
    '3JZDH': T;

    /**
     * @default '{{0}} was removed from the guest list.'
     */
    a1jhp: T;

    /**
     * @default '{{0}} already has a payment on another registration.'
     */
    gi4BK: T;

    /**
     * @default '{{0}} no longer exists.'
     */
    wXA01: T;

    /**
     * @default '{{0}} has already paid for this ticket.'
     */
    '1Ec4P': T;

    /**
     * @default 'This order was refunded.'
     */
    autf2: T;

    /**
     * @default '{{0}}'s payment is waiting for your approval. Approve it instead.'
     */
    '8qclj': T;

    /**
     * @default 'This ticket is free. Approve {{0}} instead.'
     */
    xLOlr: T;

    /**
     * @default '{{0}} has a newer registration. Refresh and try again.'
     */
    gfPP9: T;

    /**
     * @default '{{0}} has no registration to complete.'
     */
    SKKNK: T;

    /**
     * @default '{{0}} · {{1}}'
     */
    UsBX1: T;

    /**
     * @default 'This ticket wasn't paid through Joy. Registering issues the ticket and approves the registration. Joy won't charge {{0}}, and any open payment attempt is cancelled.'
     */
    u6zwA: T;

    /**
     * @default 'This ticket wasn't paid through Joy. Registering issues the ticket. Joy won't charge {{0}}, and any open payment attempt is cancelled.'
     */
    VJdqg: T;

    /**
     * @default 'Add a personal message (optional)'
     */
    i65nB: T;

    /**
     * @default 'Register without online payment?'
     */
    hZZXG: T;

    /**
     * @default 'Unpaid'
     */
    bBw3a: T;

    /**
     * @default 'How is this ticket being handled?'
     */
    '6KxyA': T;

    /**
     * @default 'Only hosts can see this'
     */
    QRVfF: T;

    /**
     * @default 'Email {{0}} their confirmation and approval'
     */
    DvEsj: T;

    /**
     * @default 'Email {{0}} their confirmation'
     */
    '3Fggs': T;

    /**
     * @default 'Register'
     */
    NGJQE: T;

    /**
     * @default 'Limited'
     */
    K7T7k: T;

    /**
     * @default 'Unlimited'
     */
    '9Boct': T;

    /**
     * @default 'Max Capacity'
     */
    ssKLN: T;

    /**
     * @default 'Auto-close registration when capacity is reached. Only approved guests count towards the cap.'
     */
    fquT9: T;

    /**
     * @default 'Ticket name is required'
     */
    COvu3: T;

    /**
     * @default 'Price must be greater than zero'
     */
    OTaPo: T;

    /**
     * @default 'Capacity must be at least 1'
     */
    vl8PC: T;

    /**
     * @default 'End date must be after start date'
     */
    X0ZOU: T;

    /**
     * @default 'Edit Ticket'
     */
    wJFTR: T;

    /**
     * @default 'Create Ticket'
     */
    kWkgl: T;

    /**
     * @default 'Ticket Name'
     */
    BEFTr: T;

    /**
     * @default 'e.g. VIP Ticket'
     */
    '1DhtV': T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Describe what's included with this ticket…'
     */
    HdEvF: T;

    /**
     * @default 'Require approval'
     */
    Qx1Ol: T;

    /**
     * @default 'Guests you've added to your guest list need your approval when they register with this ticket.'
     */
    fdn5t: T;

    /**
     * @default 'Guests you've added to your guest list are confirmed automatically when they register with this ticket.'
     */
    Fquzt: T;

    /**
     * @default 'Pricing & Access'
     */
    uVCx2: T;

    /**
     * @default 'Sales Period'
     */
    '5reEW': T;

    /**
     * @default 'Capacity'
     */
    MDYDO: T;

    /**
     * @default 'Paid'
     */
    kTgMA: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Currency'
     */
    ZpluY: T;

    /**
     * @default 'Price'
     */
    '7WvrG': T;

    /**
     * @default 'Auto Close'
     */
    bcHsB: T;

    /**
     * @default 'No Expiration'
     */
    QY2JR: T;

    /**
     * @default 'On Sale'
     */
    kRKfP: T;

    /**
     * @default 'Expires'
     */
    MKwbu: T;

    /**
     * @default 'Yes, delete this ticket'
     */
    w4rCB: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Reserved'
     */
    oGlsj: T;

    /**
     * @default 'Available'
     */
    d8nEm: T;

    /**
     * @default 'Sold Out'
     */
    C2XzR: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Duplicate'
     */
    djRAg: T;

    /**
     * @default 'Deactivate'
     */
    g1L73: T;

    /**
     * @default 'More options'
     */
    LeY4P: T;

    /**
     * @default 'Closed'
     */
    CcAEp: T;

    /**
     * @default 'Activate'
     */
    nPknl: T;
  };
};

export type TicketsGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} Day Left to Book'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} Day Left to Book
     * - plural: {{0}} Days Left to Book
     */
    '94pE7': T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Sold Out'
     */
    C2XzR: T;

    /**
     * @default 'Approval Required'
     */
    CUVVi: T;

    /**
     * @default 'Waitlist Enabled'
     */
    '6dZJM': T;

    /**
     * @default 'Sales ends today'
     */
    HWgVn: T;
  };
};

export type TimePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select time'
     */
    V1ZUG: T;

    /**
     * @default 'Clear time'
     */
    QtW3k: T;

    /**
     * @default 'Close time picker'
     */
    '91w6U': T;

    /**
     * @default 'Open time picker'
     */
    jYLit: T;

    /**
     * @default 'Time options'
     */
    rmNz2: T;

    /**
     * @default 'Time is outside the allowed range'
     */
    S6GLK: T;

    /**
     * @default 'Invalid time format'
     */
    lL8mj: T;

    /**
     * @default '{{0}}m'
     */
    NMOGt: T;

    /**
     * @default '{{0}}h'
     */
    IMOGt: T;

    /**
     * @default '{{0}}h {{1}}m'
     */
    '6sN6P': T;
  };
};

export type TimeZonePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type TimeZonePickerV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Popular Timezones'
     */
    P59EP: T;

    /**
     * @default 'All Timezones'
     */
    '74n09': T;

    /**
     * @default 'Select timezone...'
     */
    vhoje: T;

    /**
     * @default 'Search timezones...'
     */
    cbCmM: T;

    /**
     * @default 'No timezones found'
     */
    bongf: T;

    /**
     * @default 'Niue Time - Niue'
     */
    '83YaM': T;

    /**
     * @default 'Niue'
     */
    P9PMA: T;

    /**
     * @default 'Samoa Standard Time - Pago Pago'
     */
    EC5fM: T;

    /**
     * @default 'Pago Pago'
     */
    aWSN6: T;

    /**
     * @default 'Hawaii-Aleutian Standard Time - Adak'
     */
    bDZhm: T;

    /**
     * @default 'Adak'
     */
    r1QKA: T;

    /**
     * @default 'Hawaii-Aleutian Standard Time - Honolulu'
     */
    uU2lU: T;

    /**
     * @default 'Honolulu'
     */
    s1xGq: T;

    /**
     * @default 'Cook Islands Standard Time - Rarotonga'
     */
    y9lXm: T;

    /**
     * @default 'Rarotonga'
     */
    VWJ8s: T;

    /**
     * @default 'Tahiti Time - Tahiti'
     */
    SAwGs: T;

    /**
     * @default 'Tahiti'
     */
    '9BsLX': T;

    /**
     * @default 'Marquesas Time - Marquesas'
     */
    ubQfY: T;

    /**
     * @default 'Marquesas'
     */
    Qzqq1: T;

    /**
     * @default 'Alaska Standard Time - Anchorage'
     */
    OKkBg: T;

    /**
     * @default 'Anchorage'
     */
    '0C2Kl': T;

    /**
     * @default 'Gambier Time - Gambier'
     */
    Cgkjb: T;

    /**
     * @default 'Gambier'
     */
    F3EuO: T;

    /**
     * @default 'Alaska Standard Time - Juneau'
     */
    qid7c: T;

    /**
     * @default 'Juneau'
     */
    kCCU8: T;

    /**
     * @default 'Alaska Standard Time - Metlakatla'
     */
    u4hHT: T;

    /**
     * @default 'Metlakatla'
     */
    caGuh: T;

    /**
     * @default 'Alaska Standard Time - Nome'
     */
    ZsyOZ: T;

    /**
     * @default 'Nome'
     */
    XmRMA: T;

    /**
     * @default 'Alaska Standard Time - Sitka'
     */
    ayK73: T;

    /**
     * @default 'Sitka'
     */
    '86X5G': T;

    /**
     * @default 'Alaska Standard Time - Yakutat'
     */
    zjG1s: T;

    /**
     * @default 'Yakutat'
     */
    '1pyLz': T;

    /**
     * @default 'Pitcairn Time - Pitcairn'
     */
    GrqLL: T;

    /**
     * @default 'Pitcairn'
     */
    aoE6R: T;

    /**
     * @default 'Pacific Standard Time - Tijuana'
     */
    '2HQUI': T;

    /**
     * @default 'Tijuana'
     */
    iz6RJ: T;

    /**
     * @default 'Pacific Standard Time - Vancouver'
     */
    XFael: T;

    /**
     * @default 'Vancouver'
     */
    zNA4u: T;

    /**
     * @default 'Mountain Standard Time - Boise'
     */
    '8twpT': T;

    /**
     * @default 'Boise'
     */
    '8RojF': T;

    /**
     * @default 'Mountain Standard Time - Cambridge Bay'
     */
    '4Jjej': T;

    /**
     * @default 'Cambridge Bay'
     */
    u83PK: T;

    /**
     * @default 'Mountain Standard Time - Ciudad Juarez'
     */
    Vv3UC: T;

    /**
     * @default 'Ciudad Juarez'
     */
    LkOGn: T;

    /**
     * @default 'Yukon Time - Dawson'
     */
    '8DeS0': T;

    /**
     * @default 'Dawson'
     */
    Olq0q: T;

    /**
     * @default 'Mountain Standard Time - Dawson Creek'
     */
    GivY1: T;

    /**
     * @default 'Dawson Creek'
     */
    K2umT: T;

    /**
     * @default 'Mountain Standard Time - Denver'
     */
    '6X2ZK': T;

    /**
     * @default 'Denver'
     */
    CRPJr: T;

    /**
     * @default 'Mountain Standard Time - Edmonton'
     */
    AmIjA: T;

    /**
     * @default 'Edmonton'
     */
    cKfSR: T;

    /**
     * @default 'Mountain Standard Time - Fort Nelson'
     */
    GYbyn: T;

    /**
     * @default 'Fort Nelson'
     */
    wDaBC: T;

    /**
     * @default 'Mexican Pacific Standard Time - Hermosillo'
     */
    z6oaj: T;

    /**
     * @default 'Hermosillo'
     */
    K0Zbj: T;

    /**
     * @default 'Mountain Standard Time - Inuvik'
     */
    Q9uYY: T;

    /**
     * @default 'Inuvik'
     */
    W2HI5: T;

    /**
     * @default 'Mexican Pacific Standard Time - Mazatlan'
     */
    '7dEr4': T;

    /**
     * @default 'Mazatlan'
     */
    sYNFt: T;

    /**
     * @default 'Mountain Standard Time - Phoenix'
     */
    '1jH5p': T;

    /**
     * @default 'Phoenix'
     */
    PeCEK: T;

    /**
     * @default 'Yukon Time - Whitehorse'
     */
    '0sGev': T;

    /**
     * @default 'Whitehorse'
     */
    IvekA: T;

    /**
     * @default 'Central Standard Time - Bahia Banderas'
     */
    x9zNv: T;

    /**
     * @default 'Bahia Banderas'
     */
    DRJYn: T;

    /**
     * @default 'Central Standard Time - Belize'
     */
    PjIpT: T;

    /**
     * @default 'Belize'
     */
    XQd0l: T;

    /**
     * @default 'Central Standard Time - Beulah'
     */
    VVfqT: T;

    /**
     * @default 'Beulah'
     */
    dC01l: T;

    /**
     * @default 'Central Standard Time - Center'
     */
    tfE9A: T;

    /**
     * @default 'Center'
     */
    '3xBfo': T;

    /**
     * @default 'Central Standard Time - Chihuahua'
     */
    eImQG: T;

    /**
     * @default 'Chihuahua'
     */
    iLFsF: T;

    /**
     * @default 'Central Standard Time - Costa Rica'
     */
    Xgyag: T;

    /**
     * @default 'Costa Rica'
     */
    bdUrM: T;

    /**
     * @default 'Central Standard Time - El Salvador'
     */
    l5Yot: T;

    /**
     * @default 'El Salvador'
     */
    '9mFxT': T;

    /**
     * @default 'Galapagos Time - Galapagos'
     */
    C4aGJ: T;

    /**
     * @default 'Galapagos'
     */
    R7n5A: T;

    /**
     * @default 'Central Standard Time - Guatemala'
     */
    RTFNL: T;

    /**
     * @default 'Guatemala'
     */
    VWioK: T;

    /**
     * @default 'Central Standard Time - Knox'
     */
    EVRtu: T;

    /**
     * @default 'Knox'
     */
    STzLA: T;

    /**
     * @default 'Central Standard Time - Managua'
     */
    Wzo2X: T;

    /**
     * @default 'Managua'
     */
    YHm3T: T;

    /**
     * @default 'Central Standard Time - Matamoros'
     */
    D9EYT: T;

    /**
     * @default 'Matamoros'
     */
    JnKKo: T;

    /**
     * @default 'Central Standard Time - Menominee'
     */
    TmHsX: T;

    /**
     * @default 'Menominee'
     */
    ZQNes: T;

    /**
     * @default 'Central Standard Time - Merida'
     */
    Yyrdb: T;

    /**
     * @default 'Merida'
     */
    iGp9E: T;

    /**
     * @default 'Central Standard Time - Mexico City'
     */
    '4Uxuv': T;

    /**
     * @default 'Mexico City'
     */
    Qb1iA: T;

    /**
     * @default 'Central Standard Time - Monterrey'
     */
    xZRfT: T;

    /**
     * @default 'Monterrey'
     */
    '3DXRo': T;

    /**
     * @default 'Central Standard Time - New Salem'
     */
    c12jE: T;

    /**
     * @default 'New Salem'
     */
    if8VZ: T;

    /**
     * @default 'Central Standard Time - Ojinaga'
     */
    FJryO: T;

    /**
     * @default 'Ojinaga'
     */
    HbozK: T;

    /**
     * @default 'Central Standard Time - Rankin Inlet'
     */
    NelqU: T;

    /**
     * @default 'Rankin Inlet'
     */
    Rbn99: T;

    /**
     * @default 'Central Standard Time - Regina'
     */
    '2jFro': T;

    /**
     * @default 'Regina'
     */
    C2CNS: T;

    /**
     * @default 'Central Standard Time - Resolute'
     */
    xwQpW: T;

    /**
     * @default 'Resolute'
     */
    '38bfk': T;

    /**
     * @default 'Central Standard Time - Swift Current'
     */
    YXlvw: T;

    /**
     * @default 'Swift Current'
     */
    ObC4p: T;

    /**
     * @default 'Central Standard Time - Tegucigalpa'
     */
    '0Q6eh': T;

    /**
     * @default 'Tegucigalpa'
     */
    O8mnH: T;

    /**
     * @default 'Central Standard Time - Tell City'
     */
    '84Z0h': T;

    /**
     * @default 'Tell City'
     */
    Ejfm2: T;

    /**
     * @default 'Central Standard Time - Winnipeg'
     */
    '9jkgn': T;

    /**
     * @default 'Winnipeg'
     */
    FwvW1: T;

    /**
     * @default 'Colombia Standard Time - Bogota'
     */
    TIvQr: T;

    /**
     * @default 'Bogota'
     */
    '6Rfnm': T;

    /**
     * @default 'Eastern Standard Time - Cancun'
     */
    dZzGR: T;

    /**
     * @default 'Cancun'
     */
    sEDLo: T;

    /**
     * @default 'Eastern Standard Time - Detroit'
     */
    sLpyT: T;

    /**
     * @default 'Detroit'
     */
    hJzY2: T;

    /**
     * @default 'Easter Island Summer Time - Easter'
     */
    Muaav: T;

    /**
     * @default 'Easter'
     */
    CTSet: T;

    /**
     * @default 'Acre Standard Time - Eirunepe'
     */
    '56ICt': T;

    /**
     * @default 'Eirunepe'
     */
    jxxBg: T;

    /**
     * @default 'Eastern Standard Time - Grand Turk'
     */
    liAoH: T;

    /**
     * @default 'Grand Turk'
     */
    yYA2C: T;

    /**
     * @default 'Ecuador Time - Guayaquil'
     */
    D3dxV: T;

    /**
     * @default 'Guayaquil'
     */
    w1XkX: T;

    /**
     * @default 'Cuba Standard Time - Havana'
     */
    Pet2q: T;

    /**
     * @default 'Havana'
     */
    vuRb1: T;

    /**
     * @default 'Eastern Standard Time - Indianapolis'
     */
    Utena: T;

    /**
     * @default 'Indianapolis'
     */
    xZ9xl: T;

    /**
     * @default 'Eastern Standard Time - Iqaluit'
     */
    qLNEz: T;

    /**
     * @default 'Iqaluit'
     */
    diuTC: T;

    /**
     * @default 'Eastern Standard Time - Jamaica'
     */
    zxHrN: T;

    /**
     * @default 'Jamaica'
     */
    ovRRw: T;

    /**
     * @default 'Peru Standard Time - Lima'
     */
    gMbhu: T;

    /**
     * @default 'Lima'
     */
    pN7LA: T;

    /**
     * @default 'Eastern Standard Time - Louisville'
     */
    P6zyT: T;

    /**
     * @default 'Louisville'
     */
    eXcXk: T;

    /**
     * @default 'Eastern Standard Time - Marengo'
     */
    '2Dm8G': T;

    /**
     * @default 'Marengo'
     */
    paJOU: T;

    /**
     * @default 'Eastern Standard Time - Monticello'
     */
    HJ6Xj: T;

    /**
     * @default 'Monticello'
     */
    U95le: T;

    /**
     * @default 'Eastern Standard Time - Panama'
     */
    Fgghz: T;

    /**
     * @default 'Panama'
     */
    ULulM: T;

    /**
     * @default 'Eastern Standard Time - Petersburg'
     */
    QHedF: T;

    /**
     * @default 'Petersburg'
     */
    d7drA: T;

    /**
     * @default 'Eastern Standard Time - Port-au-Prince'
     */
    di7IB: T;

    /**
     * @default 'Port-au-Prince'
     */
    IDHNS: T;

    /**
     * @default 'Acre Standard Time - Rio Branco'
     */
    '9Fdy7': T;

    /**
     * @default 'Rio Branco'
     */
    tjeuP: T;

    /**
     * @default 'Eastern Standard Time - Vevay'
     */
    '6oiJy': T;

    /**
     * @default 'Vevay'
     */
    '5jsJH': T;

    /**
     * @default 'Eastern Standard Time - Vincennes'
     */
    UIJaN: T;

    /**
     * @default 'Vincennes'
     */
    tkTFM: T;

    /**
     * @default 'Eastern Standard Time - Winamac'
     */
    ldFgI: T;

    /**
     * @default 'Winamac'
     */
    abPGr: T;

    /**
     * @default 'Atlantic Standard Time - Barbados'
     */
    zQe8j: T;

    /**
     * @default 'Barbados'
     */
    OQQ0p: T;

    /**
     * @default 'Atlantic Standard Time - Bermuda'
     */
    F2T5Y: T;

    /**
     * @default 'Bermuda'
     */
    QACvY: T;

    /**
     * @default 'Amazon Standard Time - Boa Vista'
     */
    W7pf4: T;

    /**
     * @default 'Boa Vista'
     */
    hsAKI: T;

    /**
     * @default 'Amazon Standard Time - Campo Grande'
     */
    '2RAGP': T;

    /**
     * @default 'Campo Grande'
     */
    '5yjuP': T;

    /**
     * @default 'Venezuela Time - Caracas'
     */
    Lvpre: T;

    /**
     * @default 'Caracas'
     */
    qSiMS: T;

    /**
     * @default 'Amazon Standard Time - Cuiaba'
     */
    '2JVCJ': T;

    /**
     * @default 'Cuiaba'
     */
    R0xvp: T;

    /**
     * @default 'Atlantic Standard Time - Glace Bay'
     */
    Hnl34: T;

    /**
     * @default 'Glace Bay'
     */
    WH40V: T;

    /**
     * @default 'Atlantic Standard Time - Goose Bay'
     */
    S8DoJ: T;

    /**
     * @default 'Goose Bay'
     */
    jD955: T;

    /**
     * @default 'Guyana Time - Guyana'
     */
    '6A9BK': T;

    /**
     * @default 'Guyana'
     */
    xIDZ0: T;

    /**
     * @default 'Atlantic Standard Time - Halifax'
     */
    WmSPo: T;

    /**
     * @default 'Halifax'
     */
    fJYuS: T;

    /**
     * @default 'Bolivia Time - La Paz'
     */
    wLa1W: T;

    /**
     * @default 'La Paz'
     */
    mbEzB: T;

    /**
     * @default 'Amazon Standard Time - Manaus'
     */
    a1o5h: T;

    /**
     * @default 'Manaus'
     */
    zhHpE: T;

    /**
     * @default 'Atlantic Standard Time - Martinique'
     */
    mN48F: T;

    /**
     * @default 'Martinique'
     */
    Tcb1A: T;

    /**
     * @default 'Atlantic Standard Time - Moncton'
     */
    FjxdQ: T;

    /**
     * @default 'Moncton'
     */
    OG384: T;

    /**
     * @default 'Amazon Standard Time - Porto Velho'
     */
    '1Olr3': T;

    /**
     * @default 'Porto Velho'
     */
    uWI4N: T;

    /**
     * @default 'Atlantic Standard Time - Puerto Rico'
     */
    jnpsx: T;

    /**
     * @default 'Puerto Rico'
     */
    eD9Ea: T;

    /**
     * @default 'Atlantic Standard Time - Santo Domingo'
     */
    j60eE: T;

    /**
     * @default 'Santo Domingo'
     */
    egtmF: T;

    /**
     * @default 'Atlantic Standard Time - Thule'
     */
    '1LuVL': T;

    /**
     * @default 'Thule'
     */
    QZNAH: T;

    /**
     * @default 'Newfoundland Standard Time - St Johns'
     */
    '1RSgM': T;

    /**
     * @default 'St Johns'
     */
    vVT9W: T;

    /**
     * @default 'Brasilia Standard Time - Araguaina'
     */
    '7vyFM': T;

    /**
     * @default 'Araguaina'
     */
    h8QK9: T;

    /**
     * @default 'Paraguay Summer Time - Asuncion'
     */
    x9qag: T;

    /**
     * @default 'Asuncion'
     */
    qXftv: T;

    /**
     * @default 'Brasilia Standard Time - Bahia'
     */
    DFGXp: T;

    /**
     * @default 'Bahia'
     */
    NChhF: T;

    /**
     * @default 'Brasilia Standard Time - Belem'
     */
    '3jsXp': T;

    /**
     * @default 'Belem'
     */
    DhJiF: T;

    /**
     * @default 'Argentina Standard Time - Buenos Aires'
     */
    wbZDG: T;

    /**
     * @default 'Buenos Aires'
     */
    a9azN: T;

    /**
     * @default 'Argentina Standard Time - Catamarca'
     */
    Rh3jH: T;

    /**
     * @default 'Catamarca'
     */
    njrgZ: T;

    /**
     * @default 'French Guiana Time - Cayenne'
     */
    KUimd: T;

    /**
     * @default 'Cayenne'
     */
    ZfCwS: T;

    /**
     * @default 'Argentina Standard Time - Cordoba'
     */
    '2dpCh': T;

    /**
     * @default 'Cordoba'
     */
    yY8R3: T;

    /**
     * @default 'Brasilia Standard Time - Fortaleza'
     */
    g07TR: T;

    /**
     * @default 'Fortaleza'
     */
    EcxDt: T;

    /**
     * @default 'Argentina Standard Time - Jujuy'
     */
    Nibju: T;

    /**
     * @default 'Jujuy'
     */
    vwWOG: T;

    /**
     * @default 'Argentina Standard Time - La Rioja'
     */
    Mc7Fn: T;

    /**
     * @default 'La Rioja'
     */
    WInOj: T;

    /**
     * @default 'Brasilia Standard Time - Maceio'
     */
    qGbvj: T;

    /**
     * @default 'Maceio'
     */
    stdnE: T;

    /**
     * @default 'Argentina Standard Time - Mendoza'
     */
    kKnPI: T;

    /**
     * @default 'Mendoza'
     */
    gF6ee: T;

    /**
     * @default 'St. Pierre & Miquelon Standard Time - Miquelon'
     */
    T4a9k: T;

    /**
     * @default 'Miquelon'
     */
    '05aW5': T;

    /**
     * @default 'Uruguay Standard Time - Montevideo'
     */
    Lrfrm: T;

    /**
     * @default 'Montevideo'
     */
    '6KNiV': T;

    /**
     * @default 'GMT-03:00 - Palmer'
     */
    Muqjs: T;

    /**
     * @default 'Palmer'
     */
    '1yelM': T;

    /**
     * @default 'Suriname Time - Paramaribo'
     */
    SwZtB: T;

    /**
     * @default 'Paramaribo'
     */
    u4sOY: T;

    /**
     * @default 'GMT-03:00 - Punta Arenas'
     */
    PNfKK: T;

    /**
     * @default 'Punta Arenas'
     */
    '6uxmJ': T;

    /**
     * @default 'Brasilia Standard Time - Recife'
     */
    SwYUx: T;

    /**
     * @default 'Recife'
     */
    UZbMS: T;

    /**
     * @default 'Argentina Standard Time - Rio Gallegos'
     */
    MhvpY: T;

    /**
     * @default 'Rio Gallegos'
     */
    '2pZw1': T;

    /**
     * @default 'Rothera Time - Rothera'
     */
    ITPRN: T;

    /**
     * @default 'Rothera'
     */
    Z83d6: T;

    /**
     * @default 'Argentina Standard Time - Salta'
     */
    ptNPv: T;

    /**
     * @default 'Salta'
     */
    N8I4G: T;

    /**
     * @default 'Argentina Standard Time - San Juan'
     */
    SwFqW: T;

    /**
     * @default 'San Juan'
     */
    ccvyS: T;

    /**
     * @default 'Argentina Standard Time - San Luis'
     */
    '3hYqW': T;

    /**
     * @default 'San Luis'
     */
    DOEzS: T;

    /**
     * @default 'Brasilia Standard Time - Santarem'
     */
    X6729: T;

    /**
     * @default 'Santarem'
     */
    BrMmZ: T;

    /**
     * @default 'Chile Summer Time - Santiago'
     */
    ynjKB: T;

    /**
     * @default 'Santiago'
     */
    iqUnZ: T;

    /**
     * @default 'Falkland Islands Standard Time - Stanley'
     */
    Wrk3u: T;

    /**
     * @default 'Stanley'
     */
    w6jRM: T;

    /**
     * @default 'Argentina Standard Time - Tucuman'
     */
    jcWQS: T;

    /**
     * @default 'Tucuman'
     */
    fXpfo: T;

    /**
     * @default 'Argentina Standard Time - Ushuaia'
     */
    GGBbR: T;

    /**
     * @default 'Ushuaia'
     */
    CBUqn: T;

    /**
     * @default 'Fernando de Noronha Standard Time - Noronha'
     */
    '1c4sR': T;

    /**
     * @default 'Noronha'
     */
    BYbtU: T;

    /**
     * @default 'Greenland Standard Time - Nuuk'
     */
    sS6Y7: T;

    /**
     * @default 'Nuuk'
     */
    HYTMA: T;

    /**
     * @default 'Greenland Standard Time - Scoresbysund'
     */
    PP0AE: T;

    /**
     * @default 'Scoresbysund'
     */
    gYHfV: T;

    /**
     * @default 'South Georgia Time - South Georgia'
     */
    eivHM: T;

    /**
     * @default 'South Georgia'
     */
    '5MMG1': T;

    /**
     * @default 'Azores Standard Time - Azores'
     */
    VsAtQ: T;

    /**
     * @default 'Azores'
     */
    ShP3k: T;

    /**
     * @default 'Cape Verde Standard Time - Cape Verde'
     */
    NxCRg: T;

    /**
     * @default 'Cape Verde'
     */
    dbK0I: T;

    /**
     * @default 'Greenwich Mean Time - Abidjan'
     */
    k1YTC: T;

    /**
     * @default 'Abidjan'
     */
    nL89L: T;

    /**
     * @default 'Greenwich Mean Time - Bissau'
     */
    Yujds: T;

    /**
     * @default 'Bissau'
     */
    ZXdLm: T;

    /**
     * @default 'Western European Standard Time - Canary'
     */
    gN1rn: T;

    /**
     * @default 'Canary'
     */
    KeCLo: T;

    /**
     * @default 'Greenwich Mean Time - Danmarkshavn'
     */
    xhiWV: T;

    /**
     * @default 'Danmarkshavn'
     */
    A5epy: T;

    /**
     * @default 'Irish Standard Time - Dublin'
     */
    SgwXH: T;

    /**
     * @default 'Dublin'
     */
    CeAZs: T;

    /**
     * @default 'Western European Standard Time - Faroe'
     */
    rTNBv: T;

    /**
     * @default 'Faroe'
     */
    J8d1F: T;

    /**
     * @default 'Western European Standard Time - Lisbon'
     */
    pbSMC: T;

    /**
     * @default 'Lisbon'
     */
    TsdpC: T;

    /**
     * @default 'Western European Standard Time - Madeira'
     */
    Hsu4O: T;

    /**
     * @default 'Madeira'
     */
    '15cGT': T;

    /**
     * @default 'Greenwich Mean Time - Monrovia'
     */
    E65Qj: T;

    /**
     * @default 'Monrovia'
     */
    JDwlN: T;

    /**
     * @default 'Greenwich Mean Time - Sao Tome'
     */
    hImJr: T;

    /**
     * @default 'Sao Tome'
     */
    mPceV: T;

    /**
     * @default 'Greenwich Mean Time - Troll'
     */
    GaPHf: T;

    /**
     * @default 'Troll'
     */
    RMrBH: T;

    /**
     * @default 'Central European Standard Time - Algiers'
     */
    YOUUP: T;

    /**
     * @default 'Algiers'
     */
    rENAR: T;

    /**
     * @default 'Central European Standard Time - Andorra'
     */
    '8QwYU': T;

    /**
     * @default 'Andorra'
     */
    RHpEW: T;

    /**
     * @default 'Central European Standard Time - Belgrade'
     */
    xldCe: T;

    /**
     * @default 'Belgrade'
     */
    '4bpUX': T;

    /**
     * @default 'Central European Standard Time - Berlin'
     */
    '7n9wP': T;

    /**
     * @default 'Berlin'
     */
    '6DY1l': T;

    /**
     * @default 'Central European Standard Time - Brussels'
     */
    EQhYc: T;

    /**
     * @default 'Brussels'
     */
    LGtqV: T;

    /**
     * @default 'Central European Standard Time - Budapest'
     */
    jh7wk: T;

    /**
     * @default 'Budapest'
     */
    owguI: T;

    /**
     * @default 'GMT+01:00 - Casablanca'
     */
    EoceE: T;

    /**
     * @default 'Casablanca'
     */
    hkGN7: T;

    /**
     * @default 'Central European Standard Time - Ceuta'
     */
    hFAYf: T;

    /**
     * @default 'Ceuta'
     */
    qsKnF: T;

    /**
     * @default 'GMT+01:00 - El Aaiun'
     */
    wnIBK: T;

    /**
     * @default 'El Aaiun'
     */
    TKo0K: T;

    /**
     * @default 'Central European Standard Time - Gibraltar'
     */
    '5qQZL': T;

    /**
     * @default 'Gibraltar'
     */
    OpdvI: T;

    /**
     * @default 'West Africa Standard Time - Lagos'
     */
    aFpNY: T;

    /**
     * @default 'Lagos'
     */
    s5RVG: T;

    /**
     * @default 'Central European Standard Time - Malta'
     */
    gQHLg: T;

    /**
     * @default 'Malta'
     */
    p3RaG: T;

    /**
     * @default 'West Africa Standard Time - Ndjamena'
     */
    Wx8Eb: T;

    /**
     * @default 'Ndjamena'
     */
    QzVyN: T;

    /**
     * @default 'Central European Standard Time - Prague'
     */
    vrA21: T;

    /**
     * @default 'Prague'
     */
    uHZ6N: T;

    /**
     * @default 'Central European Standard Time - Rome'
     */
    OlvBt: T;

    /**
     * @default 'Rome'
     */
    '3A3MA': T;

    /**
     * @default 'Central European Standard Time - Tirane'
     */
    k2kwB: T;

    /**
     * @default 'Tirane'
     */
    jS90X: T;

    /**
     * @default 'Central European Standard Time - Tunis'
     */
    '8S8wg': T;

    /**
     * @default 'Tunis'
     */
    H6ICH: T;

    /**
     * @default 'Central European Standard Time - Vienna'
     */
    szGDH: T;

    /**
     * @default 'Vienna'
     */
    rPfHd: T;

    /**
     * @default 'Central European Standard Time - Warsaw'
     */
    GeeFJ: T;

    /**
     * @default 'Warsaw'
     */
    F42Jf: T;

    /**
     * @default 'Central European Standard Time - Zurich'
     */
    emknS: T;

    /**
     * @default 'Zurich'
     */
    dC9ro: T;

    /**
     * @default 'Eastern European Standard Time - Athens'
     */
    JyhP1: T;

    /**
     * @default 'Athens'
     */
    xZRYk: T;

    /**
     * @default 'Eastern European Standard Time - Beirut'
     */
    fHUr2: T;

    /**
     * @default 'Beirut'
     */
    JtD0l: T;

    /**
     * @default 'Eastern European Standard Time - Bucharest'
     */
    bWESv: T;

    /**
     * @default 'Bucharest'
     */
    FspYL: T;

    /**
     * @default 'Eastern European Standard Time - Cairo'
     */
    CpHyb: T;

    /**
     * @default 'Cairo'
     */
    i4fmF: T;

    /**
     * @default 'Eastern European Standard Time - Chisinau'
     */
    GIfGN: T;

    /**
     * @default 'Chisinau'
     */
    ulAcb: T;

    /**
     * @default 'GMT+02:00 - Famagusta'
     */
    v9UeC: T;

    /**
     * @default 'Famagusta'
     */
    LnrYR: T;

    /**
     * @default 'Eastern European Standard Time - Gaza'
     */
    RMqih: T;

    /**
     * @default 'Gaza'
     */
    '5TKLA': T;

    /**
     * @default 'Eastern European Standard Time - Hebron'
     */
    '4CgjI': T;

    /**
     * @default 'Hebron'
     */
    ioPs1: T;

    /**
     * @default 'Eastern European Standard Time - Helsinki'
     */
    XBWvU: T;

    /**
     * @default 'Helsinki'
     */
    Bf1Gj: T;

    /**
     * @default 'Israel Standard Time - Jerusalem'
     */
    bPyIB: T;

    /**
     * @default 'Jerusalem'
     */
    izRpN: T;

    /**
     * @default 'South Africa Standard Time - Johannesburg'
     */
    YgVmn: T;

    /**
     * @default 'Johannesburg'
     */
    cBfIZ: T;

    /**
     * @default 'Central Africa Time - Juba'
     */
    v7dsg: T;

    /**
     * @default 'Juba'
     */
    UzrLA: T;

    /**
     * @default 'Eastern European Standard Time - Kaliningrad'
     */
    OIzp2: T;

    /**
     * @default 'Kaliningrad'
     */
    ePzb9: T;

    /**
     * @default 'Central Africa Time - Khartoum'
     */
    SY5mS: T;

    /**
     * @default 'Khartoum'
     */
    R7yh3: T;

    /**
     * @default 'Eastern European Standard Time - Kyiv'
     */
    nPYjh: T;

    /**
     * @default 'Kyiv'
     */
    RX2LA: T;

    /**
     * @default 'Central Africa Time - Maputo'
     */
    JUGNd: T;

    /**
     * @default 'Maputo'
     */
    w3fpE: T;

    /**
     * @default 'Eastern European Standard Time - Nicosia'
     */
    eRyoo: T;

    /**
     * @default 'Nicosia'
     */
    '4rjnD': T;

    /**
     * @default 'Eastern European Standard Time - Riga'
     */
    lIXkh: T;

    /**
     * @default 'Riga'
     */
    PQ1MA: T;

    /**
     * @default 'Eastern European Standard Time - Sofia'
     */
    QyzHd: T;

    /**
     * @default 'Sofia'
     */
    wDO6G: T;

    /**
     * @default 'Eastern European Standard Time - Tallinn'
     */
    kUJQZ: T;

    /**
     * @default 'Tallinn'
     */
    Av4Oy: T;

    /**
     * @default 'Eastern European Standard Time - Tripoli'
     */
    VOYDI: T;

    /**
     * @default 'Tripoli'
     */
    voJCh: T;

    /**
     * @default 'Eastern European Standard Time - Vilnius'
     */
    yVO5N: T;

    /**
     * @default 'Vilnius'
     */
    Ow93m: T;

    /**
     * @default 'Central Africa Time - Windhoek'
     */
    Yc7nP: T;

    /**
     * @default 'Windhoek'
     */
    XB1i0: T;

    /**
     * @default 'GMT+03:00 - Amman'
     */
    '7APmK': T;

    /**
     * @default 'Amman'
     */
    wDYeF: T;

    /**
     * @default 'Arabian Standard Time - Baghdad'
     */
    OYkPW: T;

    /**
     * @default 'Baghdad'
     */
    jKnQN: T;

    /**
     * @default 'GMT+03:00 - Damascus'
     */
    qOaVW: T;

    /**
     * @default 'Damascus'
     */
    Nw7DF: T;

    /**
     * @default 'GMT+03:00 - Kirov'
     */
    aRaZL: T;

    /**
     * @default 'Kirov'
     */
    PUjRG: T;

    /**
     * @default 'Moscow Standard Time - Minsk'
     */
    tNTFL: T;

    /**
     * @default 'Minsk'
     */
    cPfbG: T;

    /**
     * @default 'Moscow Standard Time - Moscow'
     */
    JGy9Y: T;

    /**
     * @default 'Moscow'
     */
    k8hxF: T;

    /**
     * @default 'East Africa Time - Nairobi'
     */
    lnXu3: T;

    /**
     * @default 'Nairobi'
     */
    WZM6s: T;

    /**
     * @default 'Arabian Standard Time - Qatar'
     */
    oWqyO: T;

    /**
     * @default 'Qatar'
     */
    XDOuG: T;

    /**
     * @default 'Arabian Standard Time - Riyadh'
     */
    uLB8Q: T;

    /**
     * @default 'Riyadh'
     */
    p0mjS: T;

    /**
     * @default 'Moscow Standard Time - Simferopol'
     */
    VgUwM: T;

    /**
     * @default 'Simferopol'
     */
    Mc9pa: T;

    /**
     * @default 'Volgograd Standard Time - Volgograd'
     */
    '15XFs': T;

    /**
     * @default 'Volgograd'
     */
    XPhzE: T;

    /**
     * @default 'Iran Standard Time - Tehran'
     */
    TbHG9: T;

    /**
     * @default 'Tehran'
     */
    EdofX: T;

    /**
     * @default 'GMT+04:00 - Astrakhan'
     */
    LgeZk: T;

    /**
     * @default 'Astrakhan'
     */
    NCv5s: T;

    /**
     * @default 'Azerbaijan Standard Time - Baku'
     */
    jAHNB: T;

    /**
     * @default 'Baku'
     */
    HcZKA: T;

    /**
     * @default 'Mauritius Standard Time - Mauritius'
     */
    '3IptJ': T;

    /**
     * @default 'Mauritius'
     */
    JZv6a: T;

    /**
     * @default 'Samara Standard Time - Samara'
     */
    PQUjn: T;

    /**
     * @default 'Samara'
     */
    ZkNiU: T;

    /**
     * @default 'GMT+04:00 - Saratov'
     */
    M7QNd: T;

    /**
     * @default 'Saratov'
     */
    A44mu: T;

    /**
     * @default 'Georgia Standard Time - Tbilisi'
     */
    NLXVH: T;

    /**
     * @default 'Tbilisi'
     */
    UKMo0: T;

    /**
     * @default 'GMT+04:00 - Ulyanovsk'
     */
    '2egOi': T;

    /**
     * @default 'Ulyanovsk'
     */
    '4Axuq': T;

    /**
     * @default 'Armenia Standard Time - Yerevan'
     */
    CL649: T;

    /**
     * @default 'Yerevan'
     */
    M1ETA: T;

    /**
     * @default 'Afghanistan Time - Kabul'
     */
    l70aC: T;

    /**
     * @default 'Kabul'
     */
    NDSQG: T;

    /**
     * @default 'Kazakhstan Time - Almaty'
     */
    MevHK: T;

    /**
     * @default 'Almaty'
     */
    '48Mvj': T;

    /**
     * @default 'Kazakhstan Time - Aqtau'
     */
    SFu9V: T;

    /**
     * @default 'Aqtau'
     */
    WbBfF: T;

    /**
     * @default 'Kazakhstan Time - Aqtobe'
     */
    YSvhK: T;

    /**
     * @default 'Aqtobe'
     */
    GxMLk: T;

    /**
     * @default 'Turkmenistan Standard Time - Ashgabat'
     */
    dmdpP: T;

    /**
     * @default 'Ashgabat'
     */
    lPntM: T;

    /**
     * @default 'Kazakhstan Time - Atyrau'
     */
    OacxK: T;

    /**
     * @default 'Atyrau'
     */
    '643ak': T;

    /**
     * @default 'Tajikistan Time - Dushanbe'
     */
    c8P5O: T;

    /**
     * @default 'Dushanbe'
     */
    Y9nKE: T;

    /**
     * @default 'Pakistan Standard Time - Karachi'
     */
    HchtR: T;

    /**
     * @default 'Karachi'
     */
    XeAFM: T;

    /**
     * @default 'Maldives Time - Maldives'
     */
    yKOGQ: T;

    /**
     * @default 'Maldives'
     */
    rTmNI: T;

    /**
     * @default 'Mawson Time - Mawson'
     */
    ohulp: T;

    /**
     * @default 'Mawson'
     */
    XtiqE: T;

    /**
     * @default 'Kazakhstan Time - Oral'
     */
    kzfa3: T;

    /**
     * @default 'Oral'
     */
    asbMA: T;

    /**
     * @default 'Kazakhstan Time - Qostanay'
     */
    kc8Wv: T;

    /**
     * @default 'Qostanay'
     */
    OLYT9: T;

    /**
     * @default 'Kazakhstan Time - Qyzylorda'
     */
    ryFqN: T;

    /**
     * @default 'Qyzylorda'
     */
    '3w4vl': T;

    /**
     * @default 'Uzbekistan Standard Time - Samarkand'
     */
    '1RJ3C': T;

    /**
     * @default 'Samarkand'
     */
    eUP8O: T;

    /**
     * @default 'Uzbekistan Standard Time - Tashkent'
     */
    fyVAS: T;

    /**
     * @default 'Tashkent'
     */
    w3KfP: T;

    /**
     * @default 'Vostok Time - Vostok'
     */
    kWkOF: T;

    /**
     * @default 'Vostok'
     */
    I5end: T;

    /**
     * @default 'Yekaterinburg Standard Time - Yekaterinburg'
     */
    Jsr99: T;

    /**
     * @default 'Yekaterinburg'
     */
    KHKvD: T;

    /**
     * @default 'India Standard Time - Colombo'
     */
    r15HF: T;

    /**
     * @default 'Colombo'
     */
    Rlvz2: T;

    /**
     * @default 'Nepal Time - Kathmandu'
     */
    '1Kslm': T;

    /**
     * @default 'Kathmandu'
     */
    Vi5dB: T;

    /**
     * @default 'Kyrgyzstan Time - Bishkek'
     */
    baRzL: T;

    /**
     * @default 'Bishkek'
     */
    '9iCaj': T;

    /**
     * @default 'Indian Ocean Time - Chagos'
     */
    ukzvL: T;

    /**
     * @default 'Chagos'
     */
    '9M6ro': T;

    /**
     * @default 'Bangladesh Standard Time - Dhaka'
     */
    l7udH: T;

    /**
     * @default 'Dhaka'
     */
    PhfsF: T;

    /**
     * @default 'Omsk Standard Time - Omsk'
     */
    '7DRjM': T;

    /**
     * @default 'Omsk'
     */
    KcaMA: T;

    /**
     * @default 'Bhutan Time - Thimphu'
     */
    LroBN: T;

    /**
     * @default 'Thimphu'
     */
    VzmhG: T;

    /**
     * @default 'GMT+06:00 - Urumqi'
     */
    HwNHq: T;

    /**
     * @default 'Urumqi'
     */
    tReOb: T;

    /**
     * @default 'Myanmar Time - Yangon'
     */
    '92hVB': T;

    /**
     * @default 'Yangon'
     */
    ICobk: T;

    /**
     * @default 'Indochina Time - Bangkok'
     */
    qSeVT: T;

    /**
     * @default 'Bangkok'
     */
    vfVzN: T;

    /**
     * @default 'GMT+07:00 - Barnaul'
     */
    op8O1: T;

    /**
     * @default 'Barnaul'
     */
    vNQKO: T;

    /**
     * @default 'Davis Time - Davis'
     */
    mAF2i: T;

    /**
     * @default 'Davis'
     */
    '5BirF': T;

    /**
     * @default 'Indochina Time - Ho Chi Minh'
     */
    co1it: T;

    /**
     * @default 'Ho Chi Minh'
     */
    '1zCE0': T;

    /**
     * @default 'Hovd Standard Time - Hovd'
     */
    '7a0zv': T;

    /**
     * @default 'Hovd'
     */
    XlXLA: T;

    /**
     * @default 'Western Indonesia Time - Jakarta'
     */
    KTgHL: T;

    /**
     * @default 'Jakarta'
     */
    QbXHw: T;

    /**
     * @default 'Krasnoyarsk Standard Time - Krasnoyarsk'
     */
    fjHH2: T;

    /**
     * @default 'Krasnoyarsk'
     */
    qD50N: T;

    /**
     * @default 'Krasnoyarsk Standard Time - Novokuznetsk'
     */
    g1CPA: T;

    /**
     * @default 'Novokuznetsk'
     */
    N6Q70: T;

    /**
     * @default 'Novosibirsk Standard Time - Novosibirsk'
     */
    Np58E: T;

    /**
     * @default 'Novosibirsk'
     */
    xynGY: T;

    /**
     * @default 'Western Indonesia Time - Pontianak'
     */
    r27Tz: T;

    /**
     * @default 'Pontianak'
     */
    HDHVB: T;

    /**
     * @default 'GMT+07:00 - Tomsk'
     */
    PscxF: T;

    /**
     * @default 'Tomsk'
     */
    '8nOBH': T;

    /**
     * @default 'Australian Western Standard Time - Casey'
     */
    meZEJ: T;

    /**
     * @default 'Casey'
     */
    bnimF: T;

    /**
     * @default 'Hong Kong Standard Time - Hong Kong'
     */
    '5tz3H': T;

    /**
     * @default 'Hong Kong'
     */
    J1DkD: T;

    /**
     * @default 'Irkutsk Standard Time - Irkutsk'
     */
    tDMaA: T;

    /**
     * @default 'Irkutsk'
     */
    VgExF: T;

    /**
     * @default 'Malaysia Time - Kuching'
     */
    I7PZp: T;

    /**
     * @default 'Kuching'
     */
    Pd9gq: T;

    /**
     * @default 'China Standard Time - Macau'
     */
    rY5Hh: T;

    /**
     * @default 'Macau'
     */
    xLPaG: T;

    /**
     * @default 'Central Indonesia Time - Makassar'
     */
    agCCG: T;

    /**
     * @default 'Makassar'
     */
    '1d8VF': T;

    /**
     * @default 'Philippine Standard Time - Manila'
     */
    BKnbE: T;

    /**
     * @default 'Manila'
     */
    QtJpE: T;

    /**
     * @default 'Australian Western Standard Time - Perth'
     */
    IYrHK: T;

    /**
     * @default 'Perth'
     */
    '7g0pG': T;

    /**
     * @default 'China Standard Time - Shanghai'
     */
    BjghI: T;

    /**
     * @default 'Shanghai'
     */
    xZFMV: T;

    /**
     * @default 'Taipei Standard Time - Taipei'
     */
    Hx0Ow: T;

    /**
     * @default 'Taipei'
     */
    kO3LX: T;

    /**
     * @default 'Ulaanbaatar Standard Time - Ulaanbaatar'
     */
    h83E0: T;

    /**
     * @default 'Ulaanbaatar'
     */
    U0OVo: T;

    /**
     * @default 'Australian Central Western Standard Time - Eucla'
     */
    US1Ru: T;

    /**
     * @default 'Eucla'
     */
    '0JczF': T;

    /**
     * @default 'Yakutsk Standard Time - Chita'
     */
    '0b9mE': T;

    /**
     * @default 'Chita'
     */
    xWjnF: T;

    /**
     * @default 'East Timor Time - Dili'
     */
    CcV1q: T;

    /**
     * @default 'Dili'
     */
    OauKA: T;

    /**
     * @default 'Eastern Indonesia Time - Jayapura'
     */
    h8lxb: T;

    /**
     * @default 'Jayapura'
     */
    TVPVa: T;

    /**
     * @default 'Yakutsk Standard Time - Khandyga'
     */
    iz9wf: T;

    /**
     * @default 'Khandyga'
     */
    LCiL3: T;

    /**
     * @default 'Palau Time - Palau'
     */
    KQWkw: T;

    /**
     * @default 'Palau'
     */
    JRNpG: T;

    /**
     * @default 'Korean Standard Time - Pyongyang'
     */
    FYtCR: T;

    /**
     * @default 'Pyongyang'
     */
    '44fPP': T;

    /**
     * @default 'Korean Standard Time - Seoul'
     */
    lqrTL: T;

    /**
     * @default 'Seoul'
     */
    IOv4G: T;

    /**
     * @default 'Yakutsk Standard Time - Yakutsk'
     */
    PhaA1: T;

    /**
     * @default 'Yakutsk'
     */
    SzyLz: T;

    /**
     * @default 'Australian Central Standard Time - Darwin'
     */
    by0n6: T;

    /**
     * @default 'Darwin'
     */
    J66zq: T;

    /**
     * @default 'Australian Eastern Standard Time - Brisbane'
     */
    br9qZ: T;

    /**
     * @default 'Brisbane'
     */
    '2Mo1z': T;

    /**
     * @default 'Chamorro Standard Time - Guam'
     */
    MtYqr: T;

    /**
     * @default 'Guam'
     */
    GwPLA: T;

    /**
     * @default 'Australian Eastern Standard Time - Lindeman'
     */
    pNXSs: T;

    /**
     * @default 'Lindeman'
     */
    GtBdI: T;

    /**
     * @default 'Papua New Guinea Time - Port Moresby'
     */
    '4Skz5': T;

    /**
     * @default 'Port Moresby'
     */
    icBFC: T;

    /**
     * @default 'Vladivostok Standard Time - Ust-Nera'
     */
    IdFE5: T;

    /**
     * @default 'Ust-Nera'
     */
    xhYeb: T;

    /**
     * @default 'Vladivostok Standard Time - Vladivostok'
     */
    hQGuN: T;

    /**
     * @default 'Vladivostok'
     */
    wNWTg: T;

    /**
     * @default 'Australian Central Daylight Time - Adelaide'
     */
    '4wows': T;

    /**
     * @default 'Adelaide'
     */
    '7PfKC': T;

    /**
     * @default 'Australian Central Daylight Time - Broken Hill'
     */
    '7lOuu': T;

    /**
     * @default 'Broken Hill'
     */
    wLy3e: T;

    /**
     * @default 'GMT+11:00 - Bougainville'
     */
    H3v3U: T;

    /**
     * @default 'Bougainville'
     */
    '5A4hV': T;

    /**
     * @default 'Vanuatu Standard Time - Efate'
     */
    '6Wuqa': T;

    /**
     * @default 'Efate'
     */
    laLxF: T;

    /**
     * @default 'Solomon Islands Time - Guadalcanal'
     */
    icNgS: T;

    /**
     * @default 'Guadalcanal'
     */
    vh6jD: T;

    /**
     * @default 'Australian Eastern Daylight Time - Hobart'
     */
    cYLKp: T;

    /**
     * @default 'Hobart'
     */
    O95f2: T;

    /**
     * @default 'Kosrae Time - Kosrae'
     */
    YvVHB: T;

    /**
     * @default 'Kosrae'
     */
    RSMfA: T;

    /**
     * @default 'Lord Howe Daylight Time - Lord Howe'
     */
    iQUv6: T;

    /**
     * @default 'Lord Howe'
     */
    CnGRC: T;

    /**
     * @default 'Australian Eastern Daylight Time - Macquarie'
     */
    QgyZE: T;

    /**
     * @default 'Macquarie'
     */
    gWpoy: T;

    /**
     * @default 'Magadan Standard Time - Magadan'
     */
    '3ufR5': T;

    /**
     * @default 'Magadan'
     */
    '7fvUT': T;

    /**
     * @default 'Australian Eastern Daylight Time - Melbourne'
     */
    Dp61R: T;

    /**
     * @default 'Melbourne'
     */
    R4Kwq: T;

    /**
     * @default 'New Caledonia Standard Time - Noumea'
     */
    '44HzJ': T;

    /**
     * @default 'Noumea'
     */
    zTGcI: T;

    /**
     * @default 'Sakhalin Standard Time - Sakhalin'
     */
    TIuz4: T;

    /**
     * @default 'Sakhalin'
     */
    nK0rQ: T;

    /**
     * @default 'GMT+11:00 - Srednekolymsk'
     */
    ZRuLb: T;

    /**
     * @default 'Srednekolymsk'
     */
    jEW37: T;

    /**
     * @default 'Australian Eastern Daylight Time - Sydney'
     */
    '8skGJ': T;

    /**
     * @default 'Sydney'
     */
    uTVcW: T;

    /**
     * @default 'Anadyr Standard Time - Anadyr'
     */
    fWEbo: T;

    /**
     * @default 'Anadyr'
     */
    HsW3j: T;

    /**
     * @default 'Fiji Standard Time - Fiji'
     */
    j5cQL: T;

    /**
     * @default 'Fiji'
     */
    aGDLA: T;

    /**
     * @default 'Petropavlovsk-Kamchatski Standard Time - Kamchatka'
     */
    RtkZG: T;

    /**
     * @default 'Kamchatka'
     */
    rfEro: T;

    /**
     * @default 'Marshall Islands Time - Kwajalein'
     */
    Ieum4: T;

    /**
     * @default 'Kwajalein'
     */
    Q5UDg: T;

    /**
     * @default 'Nauru Time - Nauru'
     */
    AdPyW: T;

    /**
     * @default 'Nauru'
     */
    v6SfG: T;

    /**
     * @default 'Norfolk Island Daylight Time - Norfolk'
     */
    lPXW5: T;

    /**
     * @default 'Norfolk'
     */
    NjFsU: T;

    /**
     * @default 'Gilbert Islands Time - Tarawa'
     */
    bubdV: T;

    /**
     * @default 'Tarawa'
     */
    ORLNX: T;

    /**
     * @default 'Apia Standard Time - Apia'
     */
    b0afM: T;

    /**
     * @default 'Apia'
     */
    jUUKA: T;

    /**
     * @default 'New Zealand Daylight Time - Auckland'
     */
    opaUc: T;

    /**
     * @default 'Auckland'
     */
    ldQTd: T;

    /**
     * @default 'Tokelau Time - Fakaofo'
     */
    UqkFw: T;

    /**
     * @default 'Fakaofo'
     */
    TAvfK: T;

    /**
     * @default 'Phoenix Islands Time - Kanton'
     */
    '0cTT4': T;

    /**
     * @default 'Kanton'
     */
    PExW9: T;

    /**
     * @default 'Tonga Standard Time - Tongatapu'
     */
    pgOdA: T;

    /**
     * @default 'Tongatapu'
     */
    nQ5V7: T;

    /**
     * @default 'Chatham Daylight Time - Chatham'
     */
    chJUY: T;

    /**
     * @default 'Chatham'
     */
    k7Saj: T;

    /**
     * @default 'Line Islands Time - Kiritimati'
     */
    p2zqF: T;

    /**
     * @default 'Kiritimati'
     */
    '3MAvh': T;

    /**
     * @default 'Pacific Standard Time - Los Angeles'
     */
    bbJMa: T;

    /**
     * @default 'Los Angeles'
     */
    '7NJlT': T;

    /**
     * @default 'Central Standard Time - Chicago'
     */
    M4iAo: T;

    /**
     * @default 'Chicago'
     */
    OMgBk: T;

    /**
     * @default 'Eastern Standard Time - Toronto'
     */
    '2BAO1': T;

    /**
     * @default 'Toronto'
     */
    r9JyZ: T;

    /**
     * @default 'Eastern Standard Time - New York'
     */
    KUjcG: T;

    /**
     * @default 'New York'
     */
    F9fXG: T;

    /**
     * @default 'Brasilia Standard Time - Sao Paulo'
     */
    QwYxb: T;

    /**
     * @default 'Sao Paulo'
     */
    '0801O': T;

    /**
     * @default 'Greenwich Mean Time - London'
     */
    z8qaJ: T;

    /**
     * @default 'London'
     */
    '0lkID': T;

    /**
     * @default 'Central European Standard Time - Madrid'
     */
    gVSjs: T;

    /**
     * @default 'Madrid'
     */
    fvqnE: T;

    /**
     * @default 'Central European Standard Time - Paris'
     */
    mZEag: T;

    /**
     * @default 'Paris'
     */
    vCPpG: T;

    /**
     * @default 'Gulf Standard Time - Dubai'
     */
    IAILZ: T;

    /**
     * @default 'Dubai'
     */
    xQduF: T;

    /**
     * @default 'India Standard Time - Kolkata'
     */
    '3Vt98': T;

    /**
     * @default 'Kolkata'
     */
    be6Wb: T;

    /**
     * @default 'Singapore Standard Time - Singapore'
     */
    ztHpv: T;

    /**
     * @default 'Singapore'
     */
    wMIk9: T;

    /**
     * @default 'Japan Standard Time - Tokyo'
     */
    hIjYD: T;

    /**
     * @default 'Tokyo'
     */
    GIOBH: T;

    /**
     * @default 'Choose Timezone'
     */
    IgzFk: T;
  };
};

export type TourTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Close tour'
     */
    Yingr: T;

    /**
     * @default 'Why it’s our pick?'
     */
    JwBwB: T;

    /**
     * @default 'Previous'
     */
    RGyWS: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;
  };
};

export type TransferToBankDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Transferring your funds'
     */
    Wjx0n: T;

    /**
     * @default 'Start your financial life together with Ally Bank.'
     */
    WN6h0: T;

    /**
     * @default 'Combining your finances is a big step. We make it an easy one. Our Spending and Savings Accounts work better together, just like you two.'
     */
    STp2n: T;

    /**
     * @default 'Smart savings tools'
     */
    JLoQI: T;

    /**
     * @default 'Early direct deposit'
     */
    ufcc7: T;

    /**
     * @default 'No hidden fees or minimums'
     */
    udgHu: T;

    /**
     * @default 'Your registry funds help celebrate today. Let Ally help you plan for tomorrow.'
     */
    XFQir: T;

    /**
     * @default 'Open Account'
     */
    pbt5e: T;

    /**
     * @default 'Continue anyway'
     */
    oJENm: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Continue With Transfer'
     */
    myZcU: T;

    /**
     * @default 'Ally Bank, Member FDIC'
     */
    '2tL6j': T;

    /**
     * @default 'Up to'
     */
    erAGH: T;

    /**
     * @default 'Your wedding gifts, earning up to {{0}} APY¹ — paid monthly, access anytime.'
     */
    Boq8f: T;

    /**
     * @default 'Annual Percentage Yield (APY)¹ (variable) on your cash gifts.'
     */
    '568up': T;

    /**
     * @default 'Cash Gifts Received'
     */
    hBJ6f: T;

    /**
     * @default 'Open {{0}} Account'
     */
    Lqwzi: T;

    /**
     * @default 'Transfer to another account'
     */
    IJ231: T;

    /**
     * @default 'Additional Terms and Disclosures.'
     */
    lu9PD: T;

    /**
     * @default '¹The Annual Percentage Yield (APY) is a variable rate and may change at any time. These APYs are accurate as of 9/1/2026 and apply only to plan users in good standing. Plan fees apply and cancellation fees may apply for Premium and Metal plans. Terms & Conditions apply. No min. balance to open; $0.01 min. to earn APY. 4.00% APY for Metal plan users, 3.75% APY for Premium plan users, and 3.50% APY for Standard plan users with balances held in a Max Rate Savings Account. For balances in other Savings Accounts, the rate is 3.10% APY Metal, 3.00% for Premium, and 2.90% for Standard. Only 1 Max Rate Savings Account is permitted and is limited to $10,000 USD in user-initiated deposits. The max combined balance of all Savings Accounts is $250,000 per user. Savings Account services provided by Cross River Bank, Member FDIC, insured up to $250,000.'
     */
    iet7j: T;

    /**
     * @default 'Your Transfer is Being Proccessed'
     */
    c4lcQ: T;

    /**
     * @default 'Oops! Something Went Wrong.'
     */
    nv0kd: T;

    /**
     * @default 'Woo-hoo! We're working on moving your cash fund balance to your bank account now. Please note that transferred funds typically arrive within 5 to 7 business days.'
     */
    H9X14: T;

    /**
     * @default 'We're unable to complete this transfer. Please ensure the destination account is valid and try again. If this error persists, contact Joy Customer Support.'
     */
    xED4I: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Transferrable Balance'
     */
    rr7kp: T;

    /**
     * @default 'Transfer Fee'
     */
    VObkV: T;

    /**
     * @default 'Transfer fee amount'
     */
    xEu9T: T;

    /**
     * @default 'Total Transfer'
     */
    DRExO: T;

    /**
     * @default 'Transfer Your Funds'
     */
    y7olu: T;

    /**
     * @default 'You are about to transfer your cash balance to the account or card ending in {{0}}. This transfer cannot be reversed.'
     */
    juaJK: T;

    /**
     * @default 'You are about to transfer your cash balance to your connected account or card. This transfer cannot be reversed.'
     */
    azofU: T;

    /**
     * @default 'Sorry! A minimum balance of $2 is needed to process a balance transfer.'
     */
    HOcMl: T;

    /**
     * @default 'Yes, Transfer Balance'
     */
    Qwcxd: T;

    /**
     * @default 'Nevermind'
     */
    Gt32n: T;

    /**
     * @default 'Connect Bank Account'
     */
    lXrYh: T;
  };
};

export type TranslationTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type TravelAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Why this hotel is a great pick'
     */
    BD018: T;

    /**
     * @default 'Proposed note from host to guest'
     */
    HIOEh: T;
  };
};

export type TravelEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  delete: {
    /**
     * @default 'Are you sure you want to delete this item?'
     */
    title: T;

    /**
     * @default 'Are you sure you want to delete “{{travelItemTitle}}”? This cannot be undone.'
     */
    message: T;

    /**
     * @default 'Delete Travel Tip'
     */
    deleteCta: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'An error occurred while deleting your travel Item. Please try again.'
     */
    deleteError: T;

    /**
     * @default 'Success! Travel item have been deleted.'
     */
    deleteSuccess: T;
  };
  sort: {
    /**
     * @default 'An error occurred while sorting your travel Item. Please try again.'
     */
    sortError: T;

    /**
     * @default 'Success! Your Travel item order has been updated.'
     */
    sortSuccess: T;
  };
  addTravelTip: {
    /**
     * @default 'Add Travel Tip'
     */
    title: T;

    /**
     * @default 'Share travel plans with guests, including transportation options and general tips.'
     */
    subtitle: T;

    /**
     * @default 'General'
     */
    groupGeneral: T;

    /**
     * @default 'Transportation'
     */
    groupTransportation: T;

    /**
     * @default 'Accommodations'
     */
    groupAccommodations: T;

    /**
     * @default 'Share places to stay on the new Where to Stay page. 🎉'
     */
    groupAccommodationsSubtitle: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    booking: {
      /**
       * @default 'Booking Assistant'
       */
      title: T;
    };
    ferry: {
      /**
       * @default 'Ferry'
       */
      title: T;
    };
    flight: {
      /**
       * @default 'Flight / Airport'
       */
      title: T;
    };
    hotel: {
      /**
       * @default 'Hotel'
       */
      title: T;
    };
    list: {
      /**
       * @default 'Travel List'
       */
      title: T;
    };
    note: {
      /**
       * @default 'Travel Note'
       */
      title: T;
    };
    rentalCar: {
      /**
       * @default 'Rental Car'
       */
      title: T;
    };
    rentalHome: {
      /**
       * @default 'House / Rental'
       */
      title: T;
    };
    shuttle: {
      /**
       * @default 'Shuttle Schedule'
       */
      title: T;
    };
    taxi: {
      /**
       * @default 'Taxi Service'
       */
      title: T;
    };
    tent: {
      /**
       * @default 'Tents / Campsite'
       */
      title: T;
    };
    train: {
      /**
       * @default 'Train'
       */
      title: T;
    };
  };
  addTravelItem: {
    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Title'
     */
    title: T;

    /**
     * @default 'List Title'
     */
    listTitle: T;

    /**
     * @default 'Link'
     */
    link: T;

    /**
     * @default 'website.com'
     */
    linkFieldPlaceholder: T;

    /**
     * @default 'Update Url'
     */
    updateLink: T;

    /**
     * @default 'Note for Guests'
     */
    noteForGuests: T;

    /**
     * @default 'Venue Location'
     */
    venueLocation: T;

    /**
     * @default 'Address'
     */
    address: T;

    /**
     * @default 'Check In'
     */
    checkIn: T;

    /**
     * @default 'Check Out'
     */
    checkOut: T;

    /**
     * @default 'Item Description'
     */
    itemDescription: T;

    /**
     * @default 'Item Link'
     */
    itemLink: T;

    /**
     * @default 'website.com'
     */
    itemLinkPlaceholder: T;

    /**
     * @default 'Discount Code'
     */
    discountCode: T;

    /**
     * @default 'Remove Item'
     */
    removeItem: T;

    /**
     * @default 'Add Item'
     */
    addItem: T;

    /**
     * @default '01/01/2024'
     */
    datePlaceholder: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Phone'
     */
    phone: T;

    /**
     * @default '+1-555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Pick-Up Date'
     */
    pickUpDate: T;

    /**
     * @default 'Start Time'
     */
    startTime: T;

    /**
     * @default 'End Time'
     */
    endTime: T;

    /**
     * @default '12:00pm'
     */
    timePlaceholder: T;

    /**
     * @default 'Shuttle Description'
     */
    shuttleDescription: T;

    /**
     * @default 'Pick Up Description'
     */
    shuttleDescriptionPlaceholder: T;

    /**
     * @default 'Please add a title'
     */
    titleError: T;

    /**
     * @default 'Please search for venue location'
     */
    addressError: T;

    /**
     * @default 'Please add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Please add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Your url is invalid.'
     */
    invalidURL: T;

    /**
     * @default 'The description has to be less than 5000 characters long.'
     */
    descriptionError: T;

    /**
     * @default 'Please add a note for guests'
     */
    guestNoteError: T;

    /**
     * @default 'Please add a location'
     */
    locationError: T;

    /**
     * @default 'Please add a pick-up date'
     */
    pickUpDateError: T;

    /**
     * @default 'Please add a start time'
     */
    startTimeError: T;

    /**
     * @default 'Please add an end time'
     */
    endTimeError: T;

    /**
     * @default 'An error occurred while addding your travel item. Please try again.'
     */
    addTravelItemError: T;

    /**
     * @default 'An error occurred while updating your travel item. Please try again.'
     */
    updateTravelItemError: T;

    /**
     * @default 'Success! Your changes have been saved.'
     */
    addTravelItemSuccess: T;

    /**
     * @default 'Delete Travel Tip'
     */
    deleteTravelTip: T;

    /**
     * @default 'Discounted Rates on Rental Cars'
     */
    hertzTitleDefaultText: T;

    /**
     * @default 'All of our guests receive up to 25% off car rentals. Extend your visit and enjoy your trip before and/or after our big day!'
     */
    hertzDescriptionDefaultText: T;

    booking: {
      title: {
        /**
         * @default 'Add Booking Assistant'
         */
        add: T;

        /**
         * @default 'Booking Assistant'
         */
        edit: T;
      };

      /**
       * @default 'Help your guests find and book hotels and rental cars near your venue.'
       */
      subtitle: T;
    };
    ferry: {
      title: {
        /**
         * @default 'Add Ferry'
         */
        add: T;

        /**
         * @default 'Ferry'
         */
        edit: T;
      };

      /**
       * @default 'Share ferry ports, a link to the schedule, and any other valuable info.'
       */
      subtitle: T;
    };
    flight: {
      title: {
        /**
         * @default 'Add Flight / Airport'
         */
        add: T;

        /**
         * @default 'Flight / Airport'
         */
        edit: T;
      };

      /**
       * @default 'Share flight, airport suggestions, or other instructions and details.'
       */
      subtitle: T;
    };
    hotel: {
      title: {
        /**
         * @default 'Add Hotel'
         */
        add: T;

        /**
         * @default 'Hotel'
         */
        edit: T;
      };

      /**
       * @default 'Share a hotel recommendation.'
       */
      subtitle: T;
    };
    list: {
      title: {
        /**
         * @default 'Add Travel List'
         */
        add: T;

        /**
         * @default 'Travel List'
         */
        edit: T;
      };

      /**
       * @default 'Create a list of things to do, what to bring, helpful links—anything!'
       */
      subtitle: T;
    };
    note: {
      title: {
        /**
         * @default 'Add Travel Note'
         */
        add: T;

        /**
         * @default 'Travel Note'
         */
        edit: T;
      };

      /**
       * @default 'This flexible travel tip allows you to write anything you want.'
       */
      subtitle: T;
    };
    rentalCar: {
      title: {
        /**
         * @default 'Add Rental Car'
         */
        add: T;

        /**
         * @default 'Rental Car'
         */
        edit: T;
      };

      /**
       * @default 'Share a rental car recommendation, location, and any other valuable info.'
       */
      subtitle: T;
    };
    rentalHome: {
      title: {
        /**
         * @default 'Add House / Rental'
         */
        add: T;

        /**
         * @default 'House / Rental'
         */
        edit: T;
      };

      /**
       * @default 'Share info about rentals or non-hotel accommodation options.'
       */
      subtitle: T;
    };
    shuttle: {
      title: {
        /**
         * @default 'Add Shuttle Schedule'
         */
        add: T;

        /**
         * @default 'Shuttle Schedule'
         */
        edit: T;
      };

      /**
       * @default 'Share details about your shuttle, the schedule, and any other valuable info.'
       */
      subtitle: T;
    };
    taxi: {
      title: {
        /**
         * @default 'Add Taxi Service'
         */
        add: T;

        /**
         * @default 'Taxi Service'
         */
        edit: T;
      };

      /**
       * @default 'Share a ride share or taxi service recommendation and any valuable info.'
       */
      subtitle: T;
    };
    tent: {
      title: {
        /**
         * @default 'Add Tents / Campsite'
         */
        add: T;

        /**
         * @default 'Tents / Campsite'
         */
        edit: T;
      };

      /**
       * @default 'Share info about camping.'
       */
      subtitle: T;
    };
    train: {
      title: {
        /**
         * @default 'Add Train'
         */
        add: T;

        /**
         * @default 'Train'
         */
        edit: T;
      };

      /**
       * @default 'Share train lines, stations, instructions, and any other valuable info.'
       */
      subtitle: T;
    };
  };
  hertz: {
    /**
     * @default 'Give guests up to 25% off rental cars from Hertz, Dollar and Thrifty.  ✨'
     */
    bannerTitle: T;

    /**
     * @default 'Remove Offer'
     */
    bannerCTA: T;

    /**
     * @default 'Are you sure you want to remove this exclusive deal for your guests?'
     */
    dialogTitleRemove: T;

    /**
     * @default 'Are you sure you want to delete this exclusive deal for your guests?'
     */
    dialogTitleDelete: T;

    /**
     * @default 'Car rentals are the second largest travel expense for your guests after they arrive. Joy has partnered with Hertz, Dollar, and Thrifty to provide your guests up to 25% off their rentals.'
     */
    dialogBody: T;

    /**
     * @default 'Keep discount for my guests'
     */
    dialogCTA1: T;

    /**
     * @default 'Remove this discount'
     */
    dialogCTA2Remove: T;

    /**
     * @default 'Delete this discount'
     */
    dialogCTA2Delete: T;
  };
  quick: {
    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Choose an airport from the list.'
     */
    seY8C: T;

    /**
     * @default 'Arrival airport'
     */
    ScUzc: T;

    /**
     * @default 'We couldn’t save the airport. Your changes are still here.'
     */
    thdZL: T;

    /**
     * @default 'Introducing Where to Stay'
     */
    '7DQgZ': T;

    /**
     * @default 'We’ve added a Where to Stay page to help you find and recommend the best accommodations for your guests. This page showcases your top picks and lets you see where guests are staying, making planning easier.'
     */
    BuTFu: T;

    /**
     * @default 'Edit Page'
     */
    lVMJg: T;

    /**
     * @default 'Maybe Later'
     */
    Eb0Nh: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Give guests up to 25% off rental cars from Hertz, Dollar and Thrifty. ✨'
     */
    Gu4d4: T;

    /**
     * @default 'Remove Offer'
     */
    yDlOf: T;

    /**
     * @default 'Something went wrong while updating rental car search. Please try again.'
     */
    lClAg: T;

    /**
     * @default 'Added for you'
     */
    eOBg9: T;

    /**
     * @default 'Rental car search'
     */
    auX3r: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Group rates for your wedding dates'
     */
    '3FeIJ': T;

    /**
     * @default 'Shown after your travel items.'
     */
    MVNNu: T;

    /**
     * @default 'Suggested from your venue. Save to show it to guests.'
     */
    '5lXYl': T;

    /**
     * @default '{{0}} Listed Items'
     */
    BVy5H: T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default 'Deleted {{0}} of {{1}} travel tips. Please retry the rest.'
     */
    ghmYp: T;

    /**
     * @default 'Delete travel tip'
     * @param {number} count - The number of occurrences.
     * - singular: Delete travel tip
     * - plural: Delete {{0}} travel tips
     */
    DeURK: T;

    /**
     * @default 'Are you sure you want to delete this travel tip? This can't be undone.'
     * @param {number} count - The number of occurrences.
     * - singular: Are you sure you want to delete this travel tip? This can't be undone.
     * - plural: Are you sure you want to delete {{0}} travel tips? This can't be undone.
     */
    nShcI: T;

    /**
     * @default 'Delete travel tip?'
     * @param {number} count - The number of occurrences.
     * - singular: Delete travel tip?
     * - plural: Delete travel tips?
     */
    jJHSX: T;
  };
};

export type TravelMapTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'Failed to save accommodation. Please try again.'
     */
    u2YRT: T;

    /**
     * @default 'Accommodation saved successfully.'
     */
    OjTEV: T;

    /**
     * @default 'Close Auto Populated More Hotels Tooltip'
     */
    '2Y1ik': T;

    /**
     * @default 'We added more hotel suggestions near your new venue.'
     */
    UwFUQ: T;

    /**
     * @default 'Share guest stays, up to 40% with Joy.'
     */
    AI8XK: T;

    /**
     * @default 'Curate your list the way you want.'
     */
    QtQc7: T;

    /**
     * @default 'Show Hotel Picks'
     */
    FhpIL: T;

    /**
     * @default 'Why it’s our pick?'
     */
    JwBwB: T;

    /**
     * @default 'Why is {{0}} our pick?'
     */
    iJ86Q: T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Handpicked hotels for you. Manage them in Joy'
     */
    e7N8l: T;

    /**
     * @default 'View Hotel Picks'
     */
    '5UwWB': T;

    /**
     * @default 'Get a curated mix of top-rated hotels near your venue.'
     */
    '5C5DR': T;

    /**
     * @default 'Add Your Venue'
     */
    tFsbg: T;

    /**
     * @default 'Explore hotels and pick the ones that suit you best.'
     */
    DFfj3: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Hotel picks work alongside your room block. No extra contract.'
     */
    lwbiK: T;

    /**
     * @default 'No room block or contracts required.'
     */
    Yp4ge: T;

    /**
     * @default 'No commitments or penalties for hotel picks'
     */
    qNAWV: T;

    /**
     * @default 'No commitments or penalties'
     */
    PiSkS: T;

    /**
     * @default 'Add hotels near your venue.'
     */
    KuIqE: T;

    /**
     * @default 'Joy helps your guests save up to 40% on their stays.'
     */
    JfKY8: T;

    /**
     * @default 'Guests choose the room and dates that work for them.'
     */
    RYdSD: T;

    /**
     * @default 'Help guests save up to 40% on stays'
     */
    V23cp: T;

    /**
     * @default 'More flexibility in room choice and dates'
     */
    Z5fvf: T;

    /**
     * @default 'Close Room Block Rates Dialog'
     */
    Z4hc2: T;

    /**
     * @default 'Room Block Rates Dialog'
     */
    D4n5x: T;

    /**
     * @default 'Welcome to Your 'Where to Stay' Guide'
     */
    '92ID8': T;

    /**
     * @default 'Pick your favorite hotels. We'll help your guests save.'
     */
    YP5yH: T;

    /**
     * @default 'Big savings, zero commitments'
     */
    DLRbN: T;

    /**
     * @default 'Help your guests find the perfect place to stay'
     */
    lxZi7: T;

    /**
     * @default 'Exclusive hotel rates for Joy hosts and guests.'
     */
    LFop6: T;

    /**
     * @default 'Start accommodations tour'
     */
    NcLdz: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'Martoca Beach Garden, Mexico'
     */
    mDNJp: T;

    /**
     * @default 'Bathers Pavilion, Balmoral Beach, Sydney'
     */
    EmVwH: T;

    /**
     * @default 'Heritage Hall, Vancouver, Canada'
     */
    FLFQv: T;

    /**
     * @default 'Amadeus, Maida Vale, London'
     */
    qQhJQ: T;

    /**
     * @default 'Garfield Park Conservatory, Chicago'
     */
    '7DsAT': T;

    /**
     * @default 'The Grove, Houston'
     */
    s6C2f: T;

    /**
     * @default 'The Plaza Hotel, New York City'
     */
    D7pDb: T;

    /**
     * @default 'Update your venue'
     */
    nT5yS: T;

    /**
     * @default 'Changing your venue location will update wherever it’s used. I.e. if you’ve already added hotels, distance and driving directions will be updated to this new location.'
     */
    ZCAYb: T;

    /**
     * @default 'Update Venue'
     */
    oJ6DQ: T;

    /**
     * @default 'Please enter event venue.'
     */
    PuszU: T;

    /**
     * @default 'Add your venue'
     */
    Da5fk: T;

    /**
     * @default 'We’ll use this to personalize your guest website experience with maps, directions, things-to-do, nearby hotel picks and more.'
     */
    I2nTW: T;

    /**
     * @default 'Save Venue'
     */
    U5GvJ: T;

    /**
     * @default 'Event Venue or Destination'
     */
    GnCfE: T;

    /**
     * @default 'Are you sure you want to remove the venue?'
     */
    '19J67': T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'Remove Venue'
     */
    TrTxf: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Failed to update event location'
     */
    ygdIS: T;

    /**
     * @default 'Please select a venue from the suggestions'
     */
    kpRDP: T;

    /**
     * @default 'I don’t have a venue yet'
     */
    TjZQ0: T;

    /**
     * @default 'Super Admins Only'
     */
    rBTfL: T;

    /**
     * @default 'Also update my event location to {{0}}'
     */
    QznY7: T;

    /**
     * @default 'Also update my event location to match the venue'
     */
    XOTON: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default 'Booked on {{0}}'
     */
    tesEN: T;

    /**
     * @default 'Explore This Property →'
     */
    '8Zn7K': T;

    /**
     * @default 'Please search for a hotel'
     */
    sWJYp: T;

    /**
     * @default 'Please add an address'
     */
    WTsxe: T;

    /**
     * @default 'This is over the character limit.'
     */
    tBMiA: T;

    /**
     * @default 'An error occurred while selecting the hotel. Please try again.'
     */
    Bqt1y: T;

    /**
     * @default 'We're sorry, we're having trouble generating a prompt. Try again'
     */
    B602e: T;

    /**
     * @default 'Why It's Your Pick'
     */
    L38Lr: T;

    /**
     * @default 'Tell Guests Why'
     */
    GFwTU: T;

    /**
     * @default 'Write a note to guests about why you picked this hotel. Let them know any details you might want to share.'
     */
    k3yTL: T;

    /**
     * @default 'Suggest'
     */
    WmiYP: T;

    /**
     * @default 'Our Pick'
     */
    Fg6wn: T;

    /**
     * @default 'Choose one hotel to appear at the top of the list.'
     */
    kKNyj: T;

    /**
     * @default 'This hotel will be displayed at the top of your list.'
     */
    LhSrN: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;

    /**
     * @default 'Let your guests know where you're staying.'
     */
    ZmHlr: T;

    /**
     * @default 'Where You're Staying'
     */
    '5UfVd': T;

    /**
     * @default 'Let guests know where you'll be staying. We'll put this hotel first on your page and highlight it letting guests know with a label.'
     */
    j03cP: T;

    /**
     * @default 'Pick one hotel that will be displayed at the top of the list.'
     */
    hUNGC: T;

    /**
     * @default 'Hotel Room Block'
     */
    mLHNM: T;

    /**
     * @default 'Room Block'
     */
    uV3Vh: T;

    /**
     * @default 'Let guests know this is a group room block. You'll be able to set the booking deadline and discount price.'
     */
    YvYep: T;

    /**
     * @default 'Remove Stay from Page'
     */
    '4swaB': T;

    /**
     * @default 'Cancel Room Block'
     */
    Oabtb: T;

    /**
     * @default 'Rates from'
     */
    F7VK6: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default 'Compared to'
     */
    SWS2n: T;

    /**
     * @default 'Room Block Details'
     */
    q2A2S: T;

    /**
     * @default 'Booking Link'
     */
    PuVic: T;

    /**
     * @default 'Room block booking link where guests will go to reserve your room block. It usually includes your special discount code applied.'
     */
    f6KtC: T;

    /**
     * @default 'www.examplehotel.com/myEvent'
     */
    xv1f3: T;

    /**
     * @default 'We do not have a room block link'
     */
    pZJif: T;

    /**
     * @default 'Check in'
     */
    '5cfjP': T;

    /**
     * @default 'Add a date'
     */
    qrRii: T;

    /**
     * @default 'Check out'
     */
    OY43P: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Dates covered by your hotel room block and the nights you recommend guests book'
     */
    dGHBU: T;

    /**
     * @default 'Check-In'
     */
    O2ijP: T;

    /**
     * @default 'Check-Out'
     */
    V1s5P: T;

    /**
     * @default 'Book By Date'
     */
    Ct55u: T;

    /**
     * @default 'Enter the deadline for guests to book before your room block or special rate expires.'
     */
    jE6DK: T;

    /**
     * @default 'When does this deal expire?'
     */
    DEbsF: T;

    /**
     * @default 'Rooms Reserved'
     */
    '6jDa2': T;

    /**
     * @default 'Number of rooms included in your room block at this hotel.'
     */
    '9TH3a': T;

    /**
     * @default 'Group Price / Night'
     */
    Fi2cL: T;

    /**
     * @default 'The discounted nightly rate negotiated for your group so guests can see the special price.'
     */
    c2B0A: T;

    /**
     * @default 'Standard Price / Night'
     */
    BCeLf: T;

    /**
     * @default 'The regular nightly rate before the group discount is applied.'
     */
    '7r9Vc': T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Standard price per night before group discount'
     */
    wLHvH: T;

    /**
     * @default 'Joy Hotel Room Block'
     */
    '2OD2k': T;

    /**
     * @default 'Please check this only if this is a room block that was secured by the Joy room block service.'
     */
    '2aCSW': T;

    /**
     * @default 'Please add a hotel booking link.'
     */
    XB2jT: T;

    /**
     * @default 'Please enter a valid URL.'
     */
    oFDkI: T;

    /**
     * @default 'Please add a check in date.'
     */
    l6DNB: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    gHC0Z: T;

    /**
     * @default 'Please add a check out date.'
     */
    Cg5uL: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    Z8CWJ: T;

    /**
     * @default 'Please add cutoff date.'
     */
    '0L83g': T;

    /**
     * @default 'Please enter the number of rooms reserved.'
     */
    Hv9VA: T;

    /**
     * @default 'Please enter a valid number of rooms reserved.'
     */
    '7RhLK': T;

    /**
     * @default 'Please add price per night.'
     */
    v1UsT: T;

    /**
     * @default 'Please enter the valid Joy price for the hotel.'
     */
    '2dPVz': T;

    /**
     * @default 'Please enter the valid Initial price for the hotel.'
     */
    '84dTt': T;

    /**
     * @default 'Simple & Budget-Friendly'
     */
    JmIrn: T;

    /**
     * @default 'For travelers who value savings and just need the essentials—clean, no-frills stays close to where you need to be.'
     */
    '0w7nY': T;

    /**
     * @default 'Comfort Meets Affordability'
     */
    K3v0E: T;

    /**
     * @default 'Reliable comfort with helpful amenities like free Wi‑Fi or breakfast. Great for quick getaways or overnight stays.'
     */
    ZFpCW: T;

    /**
     * @default 'Well‑Rounded & Convenient'
     */
    '33d3t': T;

    /**
     * @default 'A balanced stay with thoughtful service, comfortable rooms, and extra perks like on‑site dining or a fitness center.'
     */
    tJU9k: T;

    /**
     * @default 'Stylish & Full‑Service'
     */
    fUFEE: T;

    /**
     * @default 'Upscale comfort with modern design, excellent service, and amenities like spas, restaurants, or concierge support.'
     */
    mXvVg: T;

    /**
     * @default 'Luxury Without Limits'
     */
    LAzva: T;

    /**
     * @default 'World‑class hospitality, stunning interiors, and every detail considered—from gourmet dining to personalized experiences.'
     */
    TW8Qn: T;

    /**
     * @default 'Add Venue'
     */
    oK4pK: T;

    /**
     * @default 'Please select an address from the dropdown'
     */
    ZmjX1: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'House / Rental'
     */
    DHr3V: T;

    /**
     * @default 'Tent / Campsite'
     */
    AEInG: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default '{{0}}/{{1}}'
     */
    yVyMQ: T;

    /**
     * @default 'Note for Guests'
     */
    ijXsE: T;

    /**
     * @default 'A note to share with your guests about this hotel.'
     */
    wYK19: T;

    /**
     * @default 'Use Joy Travel'
     */
    dmr0V: T;

    /**
     * @default 'Use My Own Link'
     */
    JKaRO: T;

    /**
     * @default 'View hotel on Joy'
     */
    iqopQ: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Let guest know where you'll be staying. We'll put this hotel first on your page and highlight it letting guest know with a label.'
     */
    xcqoE: T;
  };
};

export type TravelNativeCheckoutTranslations<T extends LeafNodeValue = TranslateFunction> = {
  errorScreen500: {
    /**
     * @default 'Return to event site'
     */
    returnToSite: T;

    /**
     * @default 'Choose another room'
     */
    returnToHotelPage: T;

    /**
     * @default 'That link doesn't seem to exist or may have expired.'
     */
    body: T;

    /**
     * @default 'Let's get this cleaned up.'
     */
    subtitle: T;

    /**
     * @default 'Error'
     */
    title: T;
  };

  /**
   * @default 'or'
   */
  expressPaymentDivide: T;

  formActions: {
    /**
     * @default 'Book Now'
     */
    confirmReservation: T;
  };

  /**
   * @default 'We couldn't process your reservation at this time. Please try again later or contact support at <link/>.'
   */
  formErrorFailedReservationLine1: T;

  formErrors: {
    /**
     * @default 'Select new offer'
     */
    invalidOfferExpiredAction: T;

    /**
     * @default 'Sorry, we couldn't load your payment options at this time. Please try again.'
     */
    failedLoadingPaymentMethods: T;

    /**
     * @default 'Try Again'
     */
    failedLoadingPaymentMethodsAction: T;

    /**
     * @default 'If you have any questions, please reach out to our support team.'
     */
    failedReservationLine2: T;

    /**
     * @default 'We couldn't process your credit card information, but don't worry, your card hasn't been charged. Please double-check your details and try again.'
     */
    submissionFailed: T;

    /**
     * @default 'Try again'
     */
    submissionFailedAction: T;
  };
  formFields: {
    /**
     * @default 'Street Address'
     */
    addressLine1: T;

    /**
     * @default 'Street Address is required'
     */
    addressLine1Required: T;

    /**
     * @default 'Apartment, Suite, etc. (optional)'
     */
    addressLine2: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'City is required'
     */
    cityRequired: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default 'Country is required'
     */
    countryRequired: T;

    /**
     * @default 'Please select a valid country'
     */
    countryValid: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'Please enter a valid email address'
     */
    emailInvalid: T;

    /**
     * @default 'Email address is required'
     */
    emailRequired: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'First Name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Last Name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Title'
     */
    personTitle: T;

    /**
     * @default 'Title is required'
     */
    personTitleRequired: T;

    personTitles: {
      /**
       * @default 'Dr.'
       */
      dr: T;

      /**
       * @default 'Mr.'
       */
      mr: T;

      /**
       * @default 'Mrs.'
       */
      mrs: T;

      /**
       * @default 'Ms.'
       */
      ms: T;
    };

    /**
     * @default 'Phone Number'
     */
    phone: T;

    /**
     * @default 'Please enter a valid phone number'
     */
    phoneInvalid: T;

    /**
     * @default 'Phone number is required'
     */
    phoneRequired: T;

    /**
     * @default 'ZIP/Postal Code'
     */
    postalCode: T;

    /**
     * @default 'ZIP/Postal Code is required'
     */
    postalCodeRequired: T;

    /**
     * @default 'State/Province/Region'
     */
    state: T;

    /**
     * @default 'State/Province/Region is required'
     */
    stateRequired: T;
  };

  /**
   * @default 'Room {{roomNumber}}'
   */
  formTitleRoom: T;

  /**
   * @default 'Adult {{adultNumber}}'
   */
  formTitleRoomContact: T;

  formTitles: {
    /**
     * @default 'Billing Address'
     */
    billing: T;

    /**
     * @default 'Payment'
     */
    payment: T;
  };
  securityFeatures: {
    /**
     * @default '✓'
     */
    checkMark: T;

    /**
     * @default 'We use secure transmission'
     */
    primaryCta: T;

    /**
     * @default 'We protect your personal information'
     */
    secondaryCta: T;
  };
  paymentErrorOutcome: {
    /**
     * @default 'Your payment was canceled. Please try again.'
     */
    canceled: T;

    /**
     * @default 'We couldn't retrieve your payment. Please try again.'
     */
    failed_to_retrieve: T;

    /**
     * @default 'A valid payment method is required. Please update your payment details.'
     */
    requires_payment_method: T;

    /**
     * @default 'Your payment requires confirmation. Please follow the instructions to complete your payment.'
     */
    requires_confirmation: T;
  };

  /**
   * @default 'Complete Secure Booking'
   */
  checkoutHeader: T;

  /**
   * @default 'Who's checking in?'
   */
  checkingInCta: T;

  /**
   * @default 'This payment will be processed in the US and credit card provided will be charged immediately for the full amount of the reservation.'
   */
  paymentProcessing: T;

  /**
   * @default 'Great pick! Book your room before rates change.'
   */
  promotionalBanner: T;

  /**
   * @default '✨'
   */
  promotionalBannerFlair: T;

  /**
   * @default 'Great pick!'
   */
  promotionalBannerFlairAriaLabel: T;

  /**
     * @default 'Hello,

I have a question about my booking attempt for {{hotelName}} from {{bookingStartDate}} to {{bookingEndDate}} under the name {{guestName}}.

Details:
- Hotel: {{hotelName}}
- Dates: {{bookingStartDate}} to {{bookingEndDate}}
- Guest: {{guestName}}
- Reservation ID: {{reservationId}}
Thank you!'
*/
  checkoutErrorSupportEmailBody: T;

  /**
   * @default 'Booking Inquiry for {{hotelName}}'
   */
  checkoutErrorSupportEmailSubject: T;

  reservationStatus: {
    supportSection: {
      /**
       * @default 'Contact {{supportName}} at <0>{{travelSupportEmail}}</0> for booking related questions.'
       */
      message: T;
    };
    cancellationDialog: {
      /**
       * @default 'Your booking has been successfully cancelled. If this was a mistake, please contact customer support at <0>{{travelSupportEmail}}</0>.'
       */
      bookingCancelledRefresh: T;

      /**
       * @default 'We’re sorry, but we couldn’t process your cancellation request. Please contact our support team at <0>{{travelSupportEmail}}</0> with your booking ID for assistance.'
       */
      contactCustomerSupport: T;
    };
  };
  quick: {
    /**
     * @default 'Help us improve - what was the reason for your cancellation?'
     */
    SuTxl: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Found a better price elsewhere'
     */
    mGYy7: T;

    /**
     * @default 'I am changing my trip dates'
     */
    ahhwN: T;

    /**
     * @default 'No longer attending event'
     */
    O7Vjz: T;

    /**
     * @default 'We want to rebook a different car'
     */
    vbgeA: T;

    /**
     * @default 'This is a duplicate booking'
     */
    BoOGQ: T;

    /**
     * @default 'Please provide more details'
     */
    '88K6n': T;

    /**
     * @default 'Your feedback helps us improve our service.'
     */
    jglhk: T;

    /**
     * @default 'Confirm Cancellation'
     */
    pB7Pi: T;

    /**
     * @default 'We couldn't submit your feedback. Please try again.'
     */
    rbdkt: T;

    /**
     * @default 'Booking Id'
     */
    '8FX9r': T;

    /**
     * @default 'Confirmation Id'
     */
    O2BAF: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Phone'
     */
    '4pRqG': T;

    /**
     * @default 'Driver Details'
     */
    '2OEVJ': T;

    /**
     * @default 'Reservation Details'
     */
    AKNtW: T;

    /**
     * @default 'Manage Booking'
     */
    qYwPL: T;

    /**
     * @default 'You can cancel this booking. Please review our cancellation policy for full details on refunds.'
     */
    nr5of: T;

    /**
     * @default 'This rental has already ended and can't be canceled.'
     */
    AgkoZ: T;

    /**
     * @default 'Cancel Booking'
     */
    DCOpm: T;

    /**
     * @default 'Help Center'
     */
    '0H3Rt': T;

    /**
     * @default 'Car Reservation'
     */
    CfFew: T;

    /**
     * @default 'page not found'
     */
    '2IZmB': T;

    /**
     * @default 'Matches your current booking'
     */
    kkLvB: T;

    /**
     * @default 'Lowest price'
     */
    jH3MI: T;

    /**
     * @default 'Fully refundable'
     */
    arido: T;

    /**
     * @default 'Non-refundable'
     */
    sYxgN: T;

    /**
     * @default 'This stay has ended'
     */
    luJDW: T;

    /**
     * @default 'Nights can no longer be added to this reservation. Search for a new stay to book again.'
     */
    '4SQpx': T;

    /**
     * @default 'Extend Your Stay'
     */
    '2LAFW': T;

    /**
     * @default 'Add nights before or after your current booking. This will create a new reservation. We recommend confirming with the hotel to keep the same room.'
     */
    NYlXh: T;

    /**
     * @default 'Your Current Booking'
     */
    zQsD3: T;

    /**
     * @default 'Add Extra Nights'
     */
    GUBvH: T;

    /**
     * @default 'Before check-in'
     */
    vrLqG: T;

    /**
     * @default 'After check-out'
     */
    jry0S: T;

    /**
     * @default 'Number of extra nights'
     */
    JRisS: T;

    /**
     * @default 'Decrease nights'
     */
    Jq9KX: T;

    /**
     * @default 'Increase nights'
     */
    pnPQo: T;

    /**
     * @default 'New check-in'
     */
    KJTDQ: T;

    /**
     * @default 'New check-out'
     */
    N2Vvf: T;

    /**
     * @default 'Checking availability...'
     */
    T3bAD: T;

    /**
     * @default 'Unable to check availability for these dates. Please try different dates.'
     */
    dQ7hc: T;

    /**
     * @default 'No rooms available for these dates. Try adjusting the number of nights.'
     */
    net07: T;

    /**
     * @default 'We couldn't load this hotel's details, so extra nights can't be added online. Please contact the hotel directly to extend your stay.'
     */
    Eap0O: T;

    /**
     * @default 'Extension Pricing'
     */
    L1qI8: T;

    /**
     * @default 'Updating…'
     */
    sLXcH: T;

    /**
     * @default 'Choose a rate for your extra nights'
     */
    RqWiJ: T;

    /**
     * @default 'Only non-refundable rates are available for these dates. Your current booking is refundable, but these extra nights would not be.'
     */
    ABTih: T;

    /**
     * @default 'Book Extension'
     */
    U4vdn: T;

    /**
     * @default 'This will be a new, separate booking. We recommend confirming with the hotel at check-in to keep the same room.'
     */
    k7aya: T;

    /**
     * @default 'Something Went Wrong'
     */
    DhQjr: T;

    /**
     * @default 'We couldn't confirm this offer just now. Your booking was not changed — please try again.'
     */
    zjQJR: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Offer Expired'
     */
    '3GwvB': T;

    /**
     * @default 'This offer is no longer available. Let's check the latest prices for these dates.'
     */
    '3tXa8': T;

    /**
     * @default 'See Latest Prices'
     */
    qxEps: T;

    /**
     * @default 'Staying with friends/family'
     */
    '99TLW': T;

    /**
     * @default 'I accidentally made a second booking'
     */
    lrZeb: T;

    /**
     * @default 'Thank you for your feedback!'
     */
    BbTNk: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Back to Booking Confirmation'
     */
    SId4R: T;

    /**
     * @default 'Cancellation unsuccessful'
     */
    '02GWU': T;

    /**
     * @default 'Cancellation Unsuccessful'
     */
    '6jnyv': T;

    /**
     * @default 'travelsupport@withjoy.com'
     */
    gxukB: T;

    /**
     * @default 'Your booking has been canceled.'
     */
    '7w27p': T;

    /**
     * @default 'Are you sure you want to cancel this booking?'
     */
    cManU: T;

    /**
     * @default '{{0}} is now travel credit, ready to use on your next stay on Joy.'
     */
    Tg6BQ: T;

    /**
     * @default '{{0}} returned to your card, in 5–10 business days.'
     */
    CJLM7: T;

    /**
     * @default 'Your refund is now travel credit to use on your next stay on Joy.'
     */
    RM9vl: T;

    /**
     * @default 'Total Cancellation Cost {{0}}'
     */
    UPTdP: T;

    /**
     * @default 'Cancelling...'
     */
    MtSCT: T;

    /**
     * @default 'Continue to Cancel'
     */
    '26txc': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Keep My Booking'
     */
    '2JwMb': T;

    /**
     * @default 'The part you paid from your fund comes back as travel credit'
     */
    I0Cqp: T;

    /**
     * @default 'Your refund will be added as travel credit'
     */
    '1uWAh': T;

    /**
     * @default 'Use it anytime to book a stay on Joy. It never expires.'
     */
    bRg8C: T;

    /**
     * @default 'Rate will be lost'
     */
    bBF6z: T;

    /**
     * @default 'If you cancel, you'll lose this rate and a similar one may not be available later.'
     */
    OEQnX: T;

    /**
     * @default 'Exclusive rates on Joy'
     */
    ctXbC: T;

    /**
     * @default 'Joy offers special rates available only to our couples and guests.'
     */
    q8SIx: T;

    /**
     * @default 'This booking is fully refundable'
     */
    bLjI5: T;

    /**
     * @default 'You will be refunded entire amount.'
     */
    YXcjj: T;

    /**
     * @default 'This booking is non-refundable'
     */
    zbqfy: T;

    /**
     * @default 'You will not be refunded any amount.'
     */
    sk2Nl: T;

    /**
     * @default 'Cancellation details are unavailable'
     */
    '7Oo2S': T;

    /**
     * @default 'We can't confirm the cancellation cost for this booking right now.'
     */
    '6eqIG': T;

    /**
     * @default 'Rate Will Be Lost'
     */
    BacID: T;

    /**
     * @default 'If you cancel, you will lose this rate and might not get the similar one.'
     */
    bBaZH: T;

    /**
     * @default 'Exclusive Discounted Rates on Joy'
     */
    wWXHl: T;

    /**
     * @default 'On Joy, you get rates available only for our couples and guests.'
     */
    Mbe6H: T;

    /**
     * @default 'This booking is partially refundable'
     */
    bW2Gt: T;

    /**
     * @default 'You will pay around {{0}}% of booking.'
     */
    t6uF3: T;

    /**
     * @default 'Cancellation fee'
     */
    ZqovZ: T;

    /**
     * @default 'Refund'
     */
    O56MS: T;

    /**
     * @default 'Refund to your card'
     */
    oq1Bn: T;

    /**
     * @default 'Refunded as travel credit'
     */
    WSOss: T;

    /**
     * @default 'Travel credit can be used for stays on Joy.'
     */
    Te58L: T;

    /**
     * @default 'Back as a new code'
     */
    BPAV7: T;

    /**
     * @default 'You'll get a new {{0}} code.'
     */
    mp7ob: T;

    /**
     * @default 'includes {{0}} of your code'
     */
    wp4hY: T;

    /**
     * @default '{{0}} ending in {{1}}'
     */
    lalRB: T;

    /**
     * @default '{{0}} is now travel credit to use on your next stay on Joy.'
     */
    wPC3L: T;

    /**
     * @default 'Hotel Confirmation Number'
     */
    '4JIvG': T;

    /**
     * @default 'Awaiting confirmation code'
     */
    oGdR7: T;

    /**
     * @default 'Who's checking in?'
     */
    '6As8v': T;

    /**
     * @default 'Booking Details'
     */
    '1RdR1': T;

    /**
     * @default 'Paid from your fund or travel credit'
     */
    CBig7: T;

    /**
     * @default 'Paid with {{0}} ending in {{1}}'
     */
    Xgcmd: T;

    /**
     * @default 'Paid with {{0}}'
     */
    '8Jw0l': T;

    /**
     * @default 'On your statement this charge will appear as "{{0}}".'
     */
    cTVeW: T;

    /**
     * @default 'Cancellation Policy'
     */
    N8A5N: T;

    /**
     * @default 'View Policy'
     */
    vI7Wj: T;

    /**
     * @default 'Need help? Take a look at our'
     */
    ecbtY: T;

    /**
     * @default 'frequently asked questions'
     */
    '0VauK': T;

    /**
     * @default 'Need more time? Add extra nights before or after your current stay.'
     */
    cFpBj: T;

    /**
     * @default 'This stay has already ended and can't be canceled.'
     */
    voplO: T;

    /**
     * @default 'Cancellation is not available while your booking is being finalized.'
     */
    '9Kwr6': T;

    /**
     * @default 'Cancellation details are currently unavailable.'
     */
    FuHc6: T;

    /**
     * @default 'You can cancel this booking for free.'
     */
    hEdmL: T;

    /**
     * @default 'A cancellation fee will apply. You'll see the amount before you confirm.'
     */
    GftRH: T;

    /**
     * @default 'Cancelling costs the full amount of this booking, so no money will be returned.'
     */
    LOJIF: T;

    /**
     * @default 'This booking was made through our partner website, where you can view or manage your reservation.'
     */
    '1ftPQ': T;

    /**
     * @default 'Manage your reservation'
     */
    ecJqb: T;

    /**
     * @default 'Please enter at least one email address.'
     */
    C11N6: T;

    /**
     * @default 'Invalid email: {{0}}'
     */
    DTBRj: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Too many attempts. Please try again later.'
     */
    '45cqE': T;

    /**
     * @default 'Failed to send. Please try again.'
     */
    dL6V8: T;

    /**
     * @default 'Confirmation sent'
     */
    HQPUG: T;

    /**
     * @default 'Sent to {{0}}. It can take a few minutes to arrive.'
     */
    '1U71X': T;

    /**
     * @default 'We couldn't send it to {{0}}.'
     */
    OJGGJ: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Resend confirmation'
     */
    iYSQ5: T;

    /**
     * @default 'Send the booking confirmation to one or more email addresses.'
     */
    KcOeD: T;

    /**
     * @default 'Send to'
     */
    Dv434: T;

    /**
     * @default 'name@example.com'
     */
    '8L5Kg': T;

    /**
     * @default 'Recipient email {{0}}'
     */
    vg3WF: T;

    /**
     * @default 'Remove email {{0}}'
     */
    '8t3jh': T;

    /**
     * @default '+ Add another email'
     */
    vpupe: T;

    /**
     * @default 'Send Confirmation'
     */
    FZg8o: T;

    /**
     * @default 'Resend Confirmation'
     */
    oFzsW: T;

    /**
     * @default 'Send the booking confirmation to a different email address.'
     */
    ClJjX: T;

    /**
     * @default 'Booking ID is required'
     */
    bKd7J: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'No reservations found with the provided details. Please check your booking ID and email address.'
     */
    SjLQY: T;

    /**
     * @default 'Unable to search for reservations. Please try again.'
     */
    Jabc1: T;

    /**
     * @default 'Find Your Reservation'
     */
    '6iLoS': T;

    /**
     * @default 'Enter both your booking ID and email address to view your reservation status'
     */
    KFbxd: T;

    /**
     * @default 'Booking ID'
     */
    cFX9r: T;

    /**
     * @default 'Get Details'
     */
    '8hjQY': T;

    /**
     * @default 'We found multiple reservations for your booking. Choose one to view:'
     */
    BurmP: T;

    /**
     * @default 'View hotel reservation'
     */
    tO8Vd: T;

    /**
     * @default 'View car reservation'
     */
    nmKqZ: T;

    /**
     * @default 'Contact us and we'll help.'
     */
    VsX2N: T;

    /**
     * @default 'You will be refunded the entire amount.'
     */
    XmUbB: T;

    /**
     * @default 'You will pay around {{0}}% of the booking total.'
     */
    '4PVYt': T;

    /**
     * @default 'If you cancel, you will lose this rate and might not get a similar one.'
     */
    zJWMJ: T;

    /**
     * @default 'We're sorry, we couldn't process your cancellation right now. Please contact {{0}} with your booking ID for assistance.'
     */
    UZf7W: T;

    /**
     * @default 'Your booking has been successfully cancelled.'
     */
    yjyhf: T;

    /**
     * @default 'Your booking has been cancelled.'
     */
    Hg4Oa: T;

    /**
     * @default 'This reservation is no longer available, but don't worry!'
     */
    QtTmx: T;

    /**
     * @default 'Car prices and availability change fast. Try again before this deal is gone.'
     */
    '5FQ8Z': T;

    /**
     * @default 'View This Car'
     */
    dOa4W: T;

    /**
     * @default 'Browse All Cars'
     */
    ooFNx: T;

    /**
     * @default '{{0}} will charge this card once your booking is confirmed. You'll pay the rest when you pick up the car.'
     */
    HAAuM: T;

    /**
     * @default 'This card will be charged once your booking is confirmed. You'll pay the rest when you pick up the car.'
     */
    wlDOm: T;

    /**
     * @default 'Your card just holds the reservation — you'll pay {{0}} {{1}} when you pick up the car.'
     */
    '7EX9B': T;

    /**
     * @default 'Your card just holds the reservation — you'll pay {{0}} when you pick up the car.'
     */
    M7217: T;

    /**
     * @default 'Your card just holds the reservation — you'll pay at the counter when you pick up the car.'
     */
    '6l5vV': T;

    /**
     * @default 'You pay today'
     */
    '65aHL': T;

    /**
     * @default 'Car Checkout'
     */
    KzKsM: T;

    /**
     * @default 'Great pick! Book your car rental before rates change.'
     */
    dhxFs: T;

    /**
     * @default 'Car rental booking inquiry for {{0}}'
     */
    '77c3w': T;

    /**
     * @default 'Hello,

I have a question about my car rental booking attempt.

Details:
- Car: {{0}}
- Pick-up: {{1}}
- Drop-off: {{2}}
- Driver: {{3}}
- Reservation ID: {{4}}

Thank you!'
*/
    '3Ea7u': T;

    /**
     * @default 'We couldn't complete your booking just now. Your card details are saved, so you can press Book Now to try again.'
     */
    Em6FN: T;

    /**
     * @default 'We couldn't complete your booking just now. Please check your card details, then press Book Now to try again.'
     */
    NfBca: T;

    /**
     * @default 'We couldn't complete your booking just now. Press Book Now to try again.'
     */
    HtFo7: T;

    /**
     * @default 'Still not working? Email us at'
     */
    gH7gI: T;

    /**
     * @default 'Payment'
     */
    SKIqN: T;

    /**
     * @default 'Card'
     */
    M1iKA: T;

    /**
     * @default 'Credit card details'
     */
    '74wEV': T;

    /**
     * @default 'We couldn't load the card form. Please try again.'
     */
    kIjKB: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Locking this rate? Fill in your details and card below, then press Lock Price. Nothing is charged until you confirm.'
     */
    je3zr: T;

    /**
     * @default 'If you lock the price, we keep your card on file so the hotel can hold the room. It's charged only if you confirm your booking before the hold ends. If you don't, nothing is charged.'
     */
    ploCC: T;

    /**
     * @default 'Part of your honeymoon fund is being held for this booking, so this way of paying isn't available yet. Put it back to carry on — nothing has been taken.'
     */
    qotmF: T;

    /**
     * @default 'Put my honeymoon fund back'
     */
    t2MhP: T;

    /**
     * @default 'We couldn't check your honeymoon fund just now. Change the amount to try again, or reload the page.'
     */
    '9pt5f': T;

    /**
     * @default 'Pay with Honeymoon Fund'
     */
    DsZo0: T;

    /**
     * @default 'Pay with Card'
     */
    uX06S: T;

    /**
     * @default 'Please enter a valid credit card number'
     */
    NDKl4: T;

    /**
     * @default 'Change Guests'
     */
    BuDgb: T;

    /**
     * @default 'Change Dates'
     */
    D8Rfc: T;

    /**
     * @default 'Add or remove guests in the rooms you booked. You'll see the new price before anything changes.'
     */
    b7ycA: T;

    /**
     * @default 'Pick new check-in and check-out dates. You'll see the new price before anything changes.'
     */
    Lwa34: T;

    /**
     * @default 'Guests can be changed once your payment has gone through, usually within a day of booking.'
     */
    '5X7br': T;

    /**
     * @default 'Dates can be changed once your payment has gone through, usually within a day of booking.'
     */
    t6jgi: T;

    /**
     * @default 'The number of guests can't be changed online for this booking.'
     */
    '7mhsa': T;

    /**
     * @default 'Dates can't be changed online for this booking.'
     */
    e0RCc: T;

    /**
     * @default 'Same price'
     */
    fDESG: T;

    /**
     * @default '+{{0}} to pay'
     */
    ImZtm: T;

    /**
     * @default '{{0}} back'
     */
    p6zyE: T;

    /**
     * @default '1 night'
     */
    bAMgQ: T;

    /**
     * @default '{{0}} nights'
     */
    rdjYJ: T;

    /**
     * @default '1 adult'
     */
    dlycP: T;

    /**
     * @default '{{0}} adults'
     */
    vLHlk: T;

    /**
     * @default '1 adult, 1 child'
     */
    yRviR: T;

    /**
     * @default '{{0}} adults, 1 child'
     */
    iMlYL: T;

    /**
     * @default '1 adult, {{0}} children'
     */
    oK9DT: T;

    /**
     * @default '{{0}} adults, {{1}} children'
     */
    hD2cx: T;

    /**
     * @default 'Room {{0}}: 1 adult'
     */
    krnnD: T;

    /**
     * @default 'Room {{0}}: {{1}} adults'
     */
    '9qlV5': T;

    /**
     * @default 'Room {{0}}: 1 adult, 1 child'
     */
    L840H: T;

    /**
     * @default 'Room {{0}}: {{1}} adults, 1 child'
     */
    qA3CT: T;

    /**
     * @default 'Room {{0}}: 1 adult, {{1}} children'
     */
    cacmH: T;

    /**
     * @default 'Room {{0}}: {{1}} adults, {{2}} children'
     */
    kqpDE: T;

    /**
     * @default 'Free cancellation'
     */
    TQbyK: T;

    /**
     * @default 'Free cancellation until {{0}}'
     */
    LyR4f: T;

    /**
     * @default 'Step {{0}} of {{1}}'
     */
    sXRsT: T;

    /**
     * @default 'We're checking your change'
     */
    f4fyp: T;

    /**
     * @default 'Questions in the meantime? Contact us.'
     */
    CHkyO: T;

    /**
     * @default 'Your change is with the hotel'
     */
    IzYBd: T;

    /**
     * @default 'Your booking is updated'
     */
    xPQ9N: T;

    /**
     * @default 'We're refunding {{0}} to the card you booked with. It can take 5–10 business days to appear on your statement.'
     */
    uWW8G: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Room'
     */
    FC3MA: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Paid today'
     */
    FTYG5: T;

    /**
     * @default 'Updating your booking'
     */
    IQNHB: T;

    /**
     * @default 'This usually takes a few seconds.'
     */
    lDk2Y: T;

    /**
     * @default 'Pay the difference'
     */
    ILLJ6: T;

    /**
     * @default 'You'll pay {{0}} more'
     */
    nrEFQ: T;

    /**
     * @default 'You'll get {{0}} back'
     */
    rT2eM: T;

    /**
     * @default 'No change in price'
     */
    DJPqz: T;

    /**
     * @default 'Nothing to pay or refund.'
     */
    vGLVR: T;

    /**
     * @default 'Review your change'
     */
    JBgiN: T;

    /**
     * @default 'Current'
     */
    v8RNJ: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Nights'
     */
    '5EH6H': T;

    /**
     * @default 'Meal plan'
     */
    mILz4: T;

    /**
     * @default 'Cancellation'
     */
    huYTg: T;

    /**
     * @default 'Continue to Payment'
     */
    wtQ60: T;

    /**
     * @default 'Confirm Change'
     */
    Y0HBP: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Choose a room'
     */
    B1MhW: T;

    /**
     * @default 'Prices include taxes and fees. Each option shows the new total for the stay and what that means against your current total of {{0}}.'
     */
    hmS7r: T;

    /**
     * @default 'Prices include taxes and fees.'
     */
    T041T: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Room options'
     */
    TVmHe: T;

    /**
     * @default 'New room'
     */
    PqRbG: T;

    /**
     * @default 'Breakfast added'
     */
    fXpIv: T;

    /**
     * @default 'New meal plan'
     */
    aFpoK: T;

    /**
     * @default 'New cancellation terms'
     */
    '8t4iF': T;

    /**
     * @default 'Review Change'
     */
    '4SFe4': T;

    /**
     * @default 'Add each child's age at check-in to see the hotel's options.'
     */
    xOWun: T;

    /**
     * @default 'See Options'
     */
    nbk9l: T;

    /**
     * @default 'Check in'
     */
    '5cfjP': T;

    /**
     * @default 'Check out'
     */
    OY43P: T;

    /**
     * @default 'Add date'
     */
    P6JvO: T;

    /**
     * @default 'Check-out must be after check-in.'
     */
    ZicG6: T;

    /**
     * @default 'New total'
     */
    ugUCc: T;

    /**
     * @default 'Loading payment form…'
     */
    '0xfNv': T;

    /**
     * @default 'Your card was declined. Try a different card.'
     */
    XP6bh: T;

    /**
     * @default 'Amount due today'
     */
    ryVhE: T;

    /**
     * @default 'Pay {{0}} and Confirm'
     */
    '3A1at': T;

    /**
     * @default 'Under 1'
     */
    zCCFa: T;

    /**
     * @default '1 year old'
     */
    vbqyV: T;

    /**
     * @default '{{0}} years old'
     */
    RFLqi: T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default 'Adults'
     */
    '9woIj': T;

    /**
     * @default 'Age 18+'
     */
    xy7ZD: T;

    /**
     * @default 'Remove an adult from room {{0}}'
     */
    ECoLm: T;

    /**
     * @default 'Remove an adult'
     */
    hXvFH: T;

    /**
     * @default 'Add an adult to room {{0}}'
     */
    u454B: T;

    /**
     * @default 'Add an adult'
     */
    o3cjW: T;

    /**
     * @default 'Children'
     */
    jbb2a: T;

    /**
     * @default 'Ages 0–17'
     */
    J3qHS: T;

    /**
     * @default 'Remove a child from room {{0}}'
     */
    AcVvS: T;

    /**
     * @default 'Remove a child'
     */
    dDPKZ: T;

    /**
     * @default 'Add a child to room {{0}}'
     */
    Efuw1: T;

    /**
     * @default 'Add a child'
     */
    clXMK: T;

    /**
     * @default 'Child {{0}} age'
     */
    hGPq5: T;

    /**
     * @default 'Select age'
     */
    rnkoI: T;

    /**
     * @default 'Hotels use children's ages at check-in to price the room.'
     */
    MMhEy: T;

    /**
     * @default 'Change dates'
     */
    TWgEf: T;

    /**
     * @default 'Change guests'
     */
    fDG6c: T;

    /**
     * @default 'Pick new check-in and check-out dates. Nothing changes until you confirm.'
     */
    z1lcs: T;

    /**
     * @default 'Update who's staying. Nothing changes until you confirm.'
     */
    zdh4t: T;

    /**
     * @default 'Edit Dates'
     */
    Hg061: T;

    /**
     * @default 'Edit Guests'
     */
    Zoa0t: T;

    /**
     * @default 'Finding options for your new dates…'
     */
    '0tAvI': T;

    /**
     * @default 'Finding options for your guests…'
     */
    '4t5ej': T;

    /**
     * @default 'We couldn't load options for these dates. Try again in a few minutes, or contact us and we'll help.'
     */
    dpc8z: T;

    /**
     * @default 'We couldn't load options for these guests. Try again in a few minutes, or contact us and we'll help.'
     */
    vzR9j: T;

    /**
     * @default 'The hotel has no rooms for these dates. Try different dates, or contact us and we'll help.'
     */
    MpM7W: T;

    /**
     * @default 'The hotel has no rooms that fit these guests. Try a different number of guests, or contact us and we'll help.'
     */
    OGaTI: T;

    /**
     * @default 'You'll pay the difference on the next step.'
     */
    VCOs3: T;

    /**
     * @default 'We'll refund the difference to your {{0}}.'
     */
    nEdH7: T;

    /**
     * @default 'We'll refund the difference to the card you booked with.'
     */
    Mgyau: T;

    /**
     * @default 'We couldn't confirm your change went through. Refresh this page to see your current dates before trying again.'
     */
    '1ElEb': T;

    /**
     * @default 'We couldn't confirm your change went through. Refresh this page to see your current guests before trying again.'
     */
    t7fPQ: T;

    /**
     * @default 'We couldn't complete your change. Refresh this page to check your current dates before trying again, or contact us and we'll help.'
     */
    qsLNU: T;

    /**
     * @default 'We couldn't complete your change. Refresh this page to check your current guests before trying again, or contact us and we'll help.'
     */
    '6RCKd': T;

    /**
     * @default 'We couldn't take your payment. Your dates haven't changed. Try again, or contact us and we'll help.'
     */
    iQHNR: T;

    /**
     * @default 'We couldn't take your payment. Your guests haven't changed. Try again, or contact us and we'll help.'
     */
    '86q8E': T;

    /**
     * @default 'We couldn't load the payment form. Your dates haven't changed. Try again in a few minutes, or contact us and we'll help.'
     */
    W4yHZ: T;

    /**
     * @default 'We couldn't load the payment form. Your guests haven't changed. Try again in a few minutes, or contact us and we'll help.'
     */
    qVujt: T;

    /**
     * @default 'We're still confirming your new dates'
     */
    '2lrc2': T;

    /**
     * @default 'We're still confirming your guest change'
     */
    zON61: T;

    /**
     * @default 'Your payment is authorised and we're waiting for the hotel to confirm. Your new dates will show on this page once they do. If the hotel can't make the change, we'll release the hold on your card.'
     */
    DmFMl: T;

    /**
     * @default 'We're waiting for the hotel to confirm. Your new dates will show on this page once they do.'
     */
    hMbkH: T;

    /**
     * @default 'Your payment is authorised and we're waiting for the hotel to confirm. Your new guests will show on this page once they do. If the hotel can't make the change, we'll release the hold on your card.'
     */
    lY6FH: T;

    /**
     * @default 'We're waiting for the hotel to confirm. Your new guests will show on this page once they do.'
     */
    bCY1Y: T;

    /**
     * @default 'Your dates weren't changed'
     */
    q2kDP: T;

    /**
     * @default 'Your guests weren't changed'
     */
    QYgkR: T;

    /**
     * @default 'The hotel couldn't move your booking, so it keeps its current dates. We've released the hold on your card, so you haven't been charged for the difference.'
     */
    jeHgr: T;

    /**
     * @default 'The hotel couldn't move your booking, so it keeps its current dates.'
     */
    LZkZa: T;

    /**
     * @default 'The hotel couldn't change your booking, so it keeps its current guests. We've released the hold on your card, so you haven't been charged for the difference.'
     */
    gGwjD: T;

    /**
     * @default 'The hotel couldn't change your booking, so it keeps its current guests.'
     */
    wfOYL: T;

    /**
     * @default 'You can try other dates, or contact us and we'll help.'
     */
    HOjSW: T;

    /**
     * @default 'You can try a different number of guests, or contact us and we'll help.'
     */
    RwjnS: T;

    /**
     * @default 'Choose Other Dates'
     */
    SlPsB: T;

    /**
     * @default 'We couldn't confirm with the hotel whether your dates changed. Our support team is checking your booking and will contact you. You don't need to do anything for now.'
     */
    '8M8om': T;

    /**
     * @default 'We couldn't confirm with the hotel whether your guests changed. Our support team is checking your booking and will contact you. You don't need to do anything for now.'
     */
    y62tD: T;

    /**
     * @default 'The hotel will make this change by hand. Your booking keeps its current dates until then, and our support team will follow up with you. We've released the hold on your card in the meantime.'
     */
    '7Y8gk': T;

    /**
     * @default 'The hotel will make this change by hand. Your booking keeps its current dates until then, and our support team will follow up with you.'
     */
    yTqII: T;

    /**
     * @default 'The hotel will make this change by hand. Your booking keeps its current guests until then, and our support team will follow up with you. We've released the hold on your card in the meantime.'
     */
    lgUQD: T;

    /**
     * @default 'The hotel will make this change by hand. Your booking keeps its current guests until then, and our support team will follow up with you.'
     */
    odcIC: T;

    /**
     * @default 'First name'
     */
    heZ8G: T;

    /**
     * @default 'Last name'
     */
    hAZ8J: T;

    /**
     * @default 'Enter a first name.'
     */
    a2wbo: T;

    /**
     * @default 'Enter a last name.'
     */
    mYfA9: T;

    /**
     * @default 'Enter an email address.'
     */
    NqIuK: T;

    /**
     * @default 'Enter a phone number.'
     */
    QIabw: T;

    /**
     * @default 'Use {{0}} characters or fewer.'
     */
    rFnFA: T;

    /**
     * @default 'Enter a valid email address, like name@example.com.'
     */
    yiA91: T;

    /**
     * @default 'Details updated'
     */
    Z0V5L: T;

    /**
     * @default 'The hotel has your new details. We'll email an updated confirmation to {{0}}.'
     */
    '1oFK5': T;

    /**
     * @default 'Review your changes'
     */
    oHuDi: T;

    /**
     * @default 'We'll send these to the hotel and email an updated confirmation to {{0}}.'
     */
    X9Xgv: T;

    /**
     * @default 'We couldn't confirm your changes were sent. Check your connection, then refresh this page to see your current details before trying again.'
     */
    RFY3X: T;

    /**
     * @default 'We couldn't send your changes to the hotel. Try again in a few minutes, or contact us and we'll help.'
     */
    ulBF4: T;

    /**
     * @default 'Send to Hotel'
     */
    xCltF: T;

    /**
     * @default 'Edit guest details'
     */
    yjQvC: T;

    /**
     * @default 'Update the name and contact details the hotel has for this booking. You'll review your changes before we send them.'
     */
    '8qfQK': T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'Currently'
     */
    wwAJc: T;

    /**
     * @default 'Edit Guest Details'
     */
    '2JUaL': T;

    /**
     * @default 'Update the name, email, or phone number the hotel has.'
     */
    '2tVcg': T;

    /**
     * @default 'Changing booking details online isn't available right now. Try again later.'
     */
    WC9HZ: T;

    /**
     * @default 'It's too close to check-in to change booking details online.'
     */
    HYw9o: T;

    /**
     * @default 'Booking details can't be changed online once cancellation fees apply.'
     */
    '9R6DL': T;

    /**
     * @default 'This booking can't be changed right now.'
     */
    XaxxQ: T;

    /**
     * @default 'Your booking can be changed once your payment has gone through, usually within a day of booking.'
     */
    yRbof: T;

    /**
     * @default 'The details on this booking can't be changed online.'
     */
    ofrqf: T;

    /**
     * @default 'Can't be changed right now. Try again later.'
     */
    xfy7G: T;

    /**
     * @default 'Too close to check-in to change online.'
     */
    zzBlE: T;

    /**
     * @default 'Can't be changed online once cancellation fees apply.'
     */
    '4C8xp': T;

    /**
     * @default 'Can't be changed on this booking right now.'
     */
    CzGni: T;

    /**
     * @default 'Can be changed once your payment has gone through.'
     */
    Xvm3r: T;

    /**
     * @default 'Can't be changed online for this booking.'
     */
    jRu2N: T;

    /**
     * @default 'card'
     */
    UBYPA: T;

    /**
     * @default '{{0}} is on its way back to your {{1}}, and {{2}} is now travel credit.'
     */
    qkPR7: T;

    /**
     * @default 'Your {{0}} is on its way back to your {{1}}.'
     */
    '3SauT': T;

    /**
     * @default 'Your {{0}} has been returned as Joy travel credit.'
     */
    FrNh7: T;

    /**
     * @default '{{0}} is on its way back to your {{1}}, and {{2}} has been returned as Joy travel credit.'
     */
    JtDss: T;

    /**
     * @default 'Find Your Next Stay in {{0}}'
     */
    hNYWJ: T;

    /**
     * @default 'Find Your Next Stay'
     */
    EqSR8: T;

    /**
     * @default 'Joy travel credit'
     */
    BnwXw: T;

    /**
     * @default 'to spend on your next stay'
     */
    '7Tp87': T;

    /**
     * @default 'Copied'
     */
    SfCTp: T;

    /**
     * @default 'Copy Code'
     */
    i6stA: T;

    /**
     * @default 'Enter this code at checkout on any hotel booked with Joy. One use, no expiry date. We also sent it to {{0}}.'
     */
    xKuIh: T;

    /**
     * @default 'Enter this code at checkout on any hotel booked with Joy. One use, no expiry date.'
     */
    qCHIT: T;

    /**
     * @default 'back to {{0}}'
     */
    irKyD: T;

    /**
     * @default 'back to your card'
     */
    DNpA5: T;

    /**
     * @default 'Card refunds usually show up in 5–10 business days, depending on your bank. The {{0}} you paid from your fund is now travel credit.'
     */
    qMXzv: T;

    /**
     * @default 'Card refunds usually show up in 5–10 business days, depending on your bank.'
     */
    jGxz7: T;

    /**
     * @default 'Fund or travel credit'
     */
    prLRU: T;

    /**
     * @default 'Promo code {{0}}'
     */
    anx3J: T;

    /**
     * @default 'Promo code'
     */
    SJmGu: T;

    /**
     * @default 'Bonus from Joy'
     */
    LhxiB: T;

    /**
     * @default '{{0}}% of {{1}} paid by card'
     */
    yqeHJ: T;

    /**
     * @default 'Refunded to {{0}}'
     */
    s4BmE: T;

    /**
     * @default 'Refunded to your card'
     */
    '1sXOv': T;

    /**
     * @default 'Usually shows up in 5–10 business days'
     */
    lQIOF: T;

    /**
     * @default 'Returned as Joy travel credit'
     */
    '40Ebv': T;

    /**
     * @default 'Code {{0}}'
     */
    tb9eO: T;

    /**
     * @default 'Returned as travel credit'
     */
    G6bnQ: T;

    /**
     * @default 'Travel credit balance {{0}}'
     */
    Zfhw5: T;

    /**
     * @default 'How you paid'
     */
    zNccs: T;

    /**
     * @default 'Where it went'
     */
    qARh3: T;

    /**
     * @default 'Cancel within {{0}} hour for a full refund.'
     * @param {number} count - The number of occurrences.
     * - singular: Cancel within {{0}} hour for a full refund.
     * - plural: Cancel within {{0}} hours for a full refund.
     */
    tbNKi: T;

    /**
     * @default 'Cancel within the hour for a full refund.'
     */
    R0tDE: T;

    /**
     * @default 'Full policy'
     */
    NfffZ: T;

    /**
     * @default 'Customer Support'
     */
    '30ahK': T;

    /**
     * @default 'Failure'
     */
    UmeXK: T;

    /**
     * @default 'We were unable to complete your booking.'
     */
    EGQgz: T;

    /**
     * @default 'Booking Status'
     */
    FQKOj: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Unfortunately, we were unable to complete your booking. Your payment will be refunded within 24 hours.'
     */
    dUg62: T;

    /**
     * @default 'Almost there! We're locking your rate.'
     */
    '76Brs': T;

    /**
     * @default 'Yay! You're one step away from your trip.'
     */
    fcApB: T;

    /**
     * @default 'We're holding your room with the hotel. Nothing is charged now, and it might take a couple of moments.'
     */
    uZvHl: T;

    /**
     * @default 'We're currently processing your payment, it might take a couple of moments.'
     */
    AN55g: T;

    /**
     * @default 'In Progress'
     */
    '0ezfO': T;

    /**
     * @default 'Back to event website'
     */
    zb3eG: T;

    /**
     * @default 'Ready for your next stay'
     */
    xXyGJ: T;

    /**
     * @default 'Travel credit'
     */
    V45g8: T;

    /**
     * @default 'New · from this refund'
     */
    '9chhf': T;

    /**
     * @default 'Cash fund'
     */
    kU4eM: T;

    /**
     * @default 'Already yours · not part of this refund'
     */
    cIWsF: T;

    /**
     * @default 'Total you can spend on stays'
     */
    '0phjJ': T;

    /**
     * @default 'Book Another Stay'
     */
    J0BzZ: T;

    /**
     * @default 'Success'
     */
    xKDEP: T;

    /**
     * @default 'Your payment has been processed successfully!'
     */
    JOrdu: T;

    /**
     * @default 'Pending'
     */
    XhQCC: T;

    /**
     * @default 'This is not a confirmed booking — at least not yet. You'll get a confirmation email within one hour'
     */
    u6G5H: T;

    /**
     * @default 'It is now safe to close this window.'
     */
    dHjvG: T;

    /**
     * @default 'Includes a {{0}} bonus'
     */
    '1h9Fs': T;

    /**
     * @default 'Includes the {{0}} you paid with a code.'
     */
    tEB0P: T;

    /**
     * @default 'Plus a new {{0}} code for the part you paid with a code.'
     */
    KsOYA: T;

    /**
     * @default 'All as travel credit'
     */
    E594L: T;

    /**
     * @default 'We move your card refund into travel credit and add {{0}}% on top. The fund portion comes back as travel credit too.'
     */
    wISvD: T;

    /**
     * @default 'We move your card refund into travel credit. The fund portion comes back as travel credit too.'
     */
    RpgiK: T;

    /**
     * @default 'Refund how you paid'
     */
    '9i90w': T;

    /**
     * @default 'your card'
     */
    z5KAE: T;

    /**
     * @default 'Use it on any hotel you book with Joy. No expiry date, and anything you don't spend stays yours.'
     */
    JN94e: T;

    /**
     * @default 'Refund to card'
     */
    b52I8: T;

    /**
     * @default 'Back to {{0}} in 5–10 business days.'
     */
    ZDpTk: T;

    /**
     * @default 'Back to your card in 5–10 business days.'
     */
    mParB: T;

    /**
     * @default 'Cancel and refund {{0}}'
     */
    '14iAD': T;

    /**
     * @default 'Cancel and get {{0}} travel credit'
     */
    MJMhg: T;

    /**
     * @default 'Cancel and get {{0}} credit'
     */
    KNR2t: T;

    /**
     * @default 'How would you like your money back?'
     */
    UJgq7: T;

    /**
     * @default 'Travel credit works on any stay you book on Joy and never expires.'
     */
    j3Gmc: T;

    /**
     * @default 'Joy travel credit works with the email on this booking, on any hotel booked with Joy, and never expires. If your next stay costs less, we'll send a new code for what's left.'
     */
    kfSL0: T;

    /**
     * @default 'Your refund'
     */
    N1WTL: T;

    /**
     * @default 'returned as travel credit'
     */
    GYeFU: T;

    /**
     * @default 'Use it on any stay you book on Joy.'
     */
    xMLsT: T;

    /**
     * @default 'Thank you, {{0}}, we are finalizing your booking'
     */
    E9s55: T;

    /**
     * @default 'Thank you, {{0}},
your booking is confirmed.'
*/
    uKnTz: T;

    /**
     * @default 'We'll send an email confirmation for your booking to {{0}}'
     */
    f8A4Q: T;

    /**
     * @default 'Canceled'
     */
    TqO5I: T;

    /**
     * @default 'Your booking was successfully canceled.'
     */
    nBSHz: T;

    /**
     * @default 'Your fund or travel credit was not charged.'
     */
    QdwZh: T;

    /**
     * @default 'Your credit card will not be charged.'
     */
    oMcEF: T;

    /**
     * @default 'Back to hotel page'
     */
    '1Y2Wg': T;

    /**
     * @default 'Looks like you already have a booking here'
     */
    mWT1Y: T;

    /**
     * @default 'We found a recent booking with the same details. Do you want to continue with your booking or cancel the one you just made?'
     */
    lvTsR: T;

    /**
     * @default 'You have {{0}} to change your mind before we proceed with the booking.'
     */
    AZKcT: T;

    /**
     * @default 'Continue with booking'
     */
    oLIPt: T;

    /**
     * @default 'Cancel new booking'
     */
    lstz5: T;

    /**
     * @default 'Booking Details Updated'
     */
    ykzY0: T;

    /**
     * @default 'Booking Updated'
     */
    '0WGSe': T;

    /**
     * @default 'Price Updated'
     */
    QbQIK: T;

    /**
     * @default 'Good News!'
     */
    HGJNH: T;

    /**
     * @default 'The cancellation policy or meal plan for your selected room has changed since you started checkout.'
     */
    Ltxut: T;

    /**
     * @default 'The price and booking details for your selected room have changed since you started checkout.'
     */
    UBCem: T;

    /**
     * @default 'The price for your selected room has increased since you started checkout.'
     */
    Egmnc: T;

    /**
     * @default 'The price for your selected room has decreased since you started checkout.'
     */
    Ap8VQ: T;

    /**
     * @default 'Original Price'
     */
    wytZx: T;

    /**
     * @default 'New Price'
     */
    FClJZ: T;

    /**
     * @default 'See Other Offers'
     */
    EGD4y: T;

    /**
     * @default 'Scroll to confirm reservation'
     */
    eQz7k: T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'Invalid promo code. Please check and try again.'
     */
    '1kGwx': T;

    /**
     * @default 'This promo code has expired.'
     */
    hfW6H: T;

    /**
     * @default 'This promo code isn't available for this booking.'
     */
    SXGSb: T;

    /**
     * @default 'This promo code requires your email address. Please enter it above.'
     */
    reNDm: T;

    /**
     * @default 'This promo code is not applicable for your account.'
     */
    N5cef: T;

    /**
     * @default 'This promo code can't be applied to this booking.'
     */
    ZIFFb: T;

    /**
     * @default 'This promo code isn't eligible for this booking.'
     */
    UoBGw: T;

    /**
     * @default 'This promo code isn't valid for this email address.'
     */
    Ukf1P: T;

    /**
     * @default 'Spend a little more to use this promo code.'
     */
    qyVs2: T;

    /**
     * @default 'This promo code is no longer available.'
     */
    LoTVz: T;

    /**
     * @default 'We couldn't apply this promo code. Please try again.'
     */
    TYFAK: T;

    /**
     * @default 'Unable to apply this code right now. Please try again.'
     */
    iaPYn: T;

    /**
     * @default 'This promo code can't be used with this way of paying.'
     */
    JE7hF: T;

    /**
     * @default 'Have a promo code?'
     */
    '4O0Q4': T;

    /**
     * @default 'Enter promo code'
     */
    ysD8I: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Code applied — save {{0}}'
     */
    n7Bpn: T;

    /**
     * @default 'We removed {{0}} because your fund amount changed. Apply it again to save on the new amount.'
     */
    zlDbj: T;

    /**
     * @default '{{0}} doesn't work with how you're paying now. Use {{1}} instead to save {{2}}.'
     */
    '0FHdc': T;

    /**
     * @default 'We removed {{0}} — it doesn't work with how you're paying now.'
     */
    Zw3iK: T;

    /**
     * @default 'Pay Remaining Balance with Card ({{0}})'
     */
    b9MEq: T;

    /**
     * @default 'Book Now'
     */
    '72qZh': T;

    /**
     * @default 'Your honeymoon fund has {{0}} available — switch to {{1}} to use it on this stay.'
     */
    k0dAw: T;

    /**
     * @default 'Switch to {{0}}'
     */
    DdniK: T;

    /**
     * @default 'SUV'
     */
    eQYAA: T;

    /**
     * @default 'Nissan Rogue'
     */
    '6gXxw': T;

    /**
     * @default '5'
     */
    '1AAAA': T;

    /**
     * @default 'Automatic'
     */
    r6YaO: T;

    /**
     * @default 'Unlimited mileage'
     */
    '9zAlx': T;

    /**
     * @default 'Car Image'
     */
    bXRXc: T;

    /**
     * @default 'Free Cancellation'
     */
    Z77Qm: T;

    /**
     * @default 'Very Good'
     */
    Pif9F: T;

    /**
     * @default 'Need a car while you're in {{0}}?'
     */
    Vi9P5: T;

    /**
     * @default 'Need a car for your trip?'
     */
    xXD7T: T;

    /**
     * @default 'Make getting around easy with a comfortable car for your trip, ready whenever you need it.'
     */
    MdAVa: T;

    /**
     * @default 'Browse Car Rentals'
     */
    '31FmL': T;

    /**
     * @default 'Booking'
     */
    hez9y: T;

    /**
     * @default 'Booking change'
     */
    LuunO: T;

    /**
     * @default 'Refund for booking change'
     */
    aomfx: T;

    /**
     * @default 'Cancellation refund'
     */
    pW1yT: T;

    /**
     * @default 'Authorized, not yet charged'
     */
    uTT3c: T;

    /**
     * @default 'On its way'
     */
    sHSfT: T;

    /**
     * @default 'Payments'
     */
    b9CHm: T;

    /**
     * @default '−{{0}}'
     */
    y0EpC: T;

    /**
     * @default 'your room'
     */
    sGfCE: T;

    /**
     * @default 'Plans changed?'
     */
    X0gnT: T;

    /**
     * @default 'Release This Hold'
     */
    uXA2l: T;

    /**
     * @default 'Confirm Your Booking'
     */
    wFefS: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'How to pay'
     */
    BBTcz: T;

    /**
     * @default '{{0}} ending {{1}}'
     */
    wpWoe: T;

    /**
     * @default 'Card used to lock this rate'
     */
    zmZcv: T;

    /**
     * @default 'Your card is charged {{0}} when you confirm. {{1}} is due at the property.'
     */
    WCq78: T;

    /**
     * @default 'Your card is charged {{0}} when you confirm.'
     */
    w5skn: T;

    /**
     * @default 'Confirm Booking · {{0}}'
     */
    gBSBL: T;

    /**
     * @default 'Your rate is locked. Book it from your email.'
     */
    CtO1e: T;

    /**
     * @default 'We're holding {{0}} at {{1}}. The room isn't yours until you confirm the booking.'
     */
    bY53O: T;

    /**
     * @default 'Book by'
     */
    Ose9y: T;

    /**
     * @default 'If you don't book, you lose the room.'
     */
    RXYX1: T;

    /**
     * @default 'After {{0}} it goes back to the hotel. Nothing is charged.'
     */
    lLddn: T;

    /**
     * @default 'When your lock ends it goes back to the hotel. Nothing is charged.'
     */
    fNcdi: T;

    /**
     * @default 'Confirm Booking Now · {{0}}'
     */
    Iv4to: T;

    /**
     * @default 'Rate locked until'
     */
    wHYBT: T;

    /**
     * @default '{{0}}h left'
     */
    P6MfO: T;

    /**
     * @default '{{0}} min left'
     */
    '1n0xg': T;

    /**
     * @default 'Charge'
     */
    sP9ro: T;

    /**
     * @default 'Still going to the wedding?'
     */
    Pp3xx: T;

    /**
     * @default 'Book Your Stay'
     */
    dtKQh: T;

    /**
     * @default 'Your hold has expired'
     */
    Lk4Im: T;

    /**
     * @default 'The time to confirm ran out, so your hold at {{0}} has ended. Nothing was charged, and the hold on your {{1}} ending {{2}} has been removed.'
     */
    eECkf: T;

    /**
     * @default 'The time to confirm ran out, so your hold at {{0}} has ended. Nothing was charged, and the hold on your card has been removed.'
     */
    '2xRFC': T;

    /**
     * @default 'Expired'
     */
    '7Jwbu': T;

    /**
     * @default 'We couldn't load your reservation.'
     */
    Ts6Hc: T;

    /**
     * @default 'Your rate is locked. Book by {{0}}, {{1}} to keep it'
     */
    p79pb: T;

    /**
     * @default 'Your rate is locked'
     */
    Ji1MR: T;

    /**
     * @default 'What to do next'
     */
    xQm2F: T;

    /**
     * @default 'Step 1 · Done'
     */
    EVOJw: T;

    /**
     * @default 'Rate locked'
     */
    '4xofw': T;

    /**
     * @default 'Your price is held. Nothing has been charged.'
     */
    cPxs5: T;

    /**
     * @default 'Step 2 · Now'
     */
    PLsgP: T;

    /**
     * @default 'Open the Rate Lock email we sent you'
     */
    dbTMF: T;

    /**
     * @default 'Sent to {{0}}. Check spam or promotions if you don't see it.'
     */
    BK4XX: T;

    /**
     * @default 'From Joy'
     */
    eaXw8: T;

    /**
     * @default 'Step 3 · By {{0}}'
     */
    Ljjs1: T;

    /**
     * @default 'Step 3 · Before your lock ends'
     */
    rmRlo: T;

    /**
     * @default 'Confirm your booking in the email'
     */
    '0F7yS': T;

    /**
     * @default 'Tap Confirm Booking in the email, which will bring you back to this page, and press Confirm Booking.'
     */
    '8qv1W': T;

    /**
     * @default 'Tap Confirm Booking in the email, which will bring you back to this page to confirm your booking.'
     */
    mUDPL: T;

    /**
     * @default 'We couldn't lock this rate'
     */
    D1cES: T;

    /**
     * @default 'Nothing was charged and no hold was placed on your card. Your room isn't reserved yet.'
     */
    ImXvS: T;

    /**
     * @default 'The hotel couldn't hold this room'
     */
    znLnK: T;

    /**
     * @default 'This sometimes happens when a rate is in high demand. Try again, or book it without locking.'
     */
    jAs2C: T;

    /**
     * @default 'Book Without Locking'
     */
    i8TOO: T;

    /**
     * @default 'Locked rate'
     */
    c17KB: T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default 'Hold ends'
     */
    tyOOc: T;

    /**
     * @default 'Release this hold?'
     */
    jMbJd: T;

    /**
     * @default 'We'll give your room back to the hotel and you'll lose your {{0}}/night rate. If you book again later, the price may be higher, or the room may be gone. You don't need to release to avoid a charge. The hold expires on its own.'
     */
    sxKPM: T;

    /**
     * @default 'We'll give your room back to the hotel and you'll lose your locked rate. If you book again later, the price may be higher, or the room may be gone. You don't need to release to avoid a charge. The hold expires on its own.'
     */
    Pyg3T: T;

    /**
     * @default 'Keep My Room'
     */
    yd8cc: T;

    /**
     * @default 'Release Hold'
     */
    IcYTR: T;

    /**
     * @default 'Your hold has been released'
     */
    h2VdL: T;

    /**
     * @default 'You released your hold at {{0}}. Nothing was charged, and the hold on your {{1}} ending {{2}} has been removed.'
     */
    '0s6VF': T;

    /**
     * @default 'You released your hold at {{0}}. Nothing was charged, and the hold on your card has been removed.'
     */
    chpSQ: T;

    /**
     * @default 'Released'
     */
    JAjIR: T;

    /**
     * @default 'We couldn't confirm your booking from this page. Please use the link in your most recent Joy email.'
     */
    '5A0vx': T;

    /**
     * @default 'This confirmation link is no longer valid. Please use the link in your most recent Joy email.'
     */
    '1Eyyt': T;

    /**
     * @default 'This hold is no longer active.'
     */
    vz6tQ: T;

    /**
     * @default 'We're reviewing this booking, which can take a little while. Please try again later, or contact Customer Support.'
     */
    '6Wk21': T;

    /**
     * @default 'We couldn't release this room with the hotel. Our support team has been notified and will follow up with you.'
     */
    Zuw9l: T;

    /**
     * @default 'We couldn't find this hold. Please contact Customer Support.'
     */
    Pfbod: T;

    /**
     * @default 'We couldn't confirm your booking. Please try again.'
     */
    xJqqG: T;

    /**
     * @default 'We couldn't release your hold. Please try again.'
     */
    eRVBK: T;

    /**
     * @default 'We're still applying your honeymoon fund'
     */
    YDh5z: T;

    /**
     * @default 'This can take a few minutes. We'll email you as soon as it's done — please don't pay again.'
     */
    bcGc9: T;

    /**
     * @default 'Your honeymoon fund no longer covers this stay. You can pay with a card instead.'
     */
    '1hQrW': T;

    /**
     * @default 'Your promo code can't be used with your honeymoon fund. You can pay with a card instead.'
     */
    yxfDR: T;

    /**
     * @default 'We couldn't use your honeymoon fund right now. You can pay with a card instead.'
     */
    '3s4TO': T;

    /**
     * @default 'We're finishing your booking'
     */
    lqGTA: T;

    /**
     * @default 'This can take a few minutes. We'll email your confirmation as soon as it's done — please don't pay again.'
     */
    M366B: T;

    /**
     * @default 'Check again'
     */
    mwq6q: T;

    /**
     * @default 'Use your honeymoon fund'
     */
    rxPII: T;

    /**
     * @default 'Available balance'
     */
    rs5MJ: T;

    /**
     * @default 'Applied to this stay'
     */
    '1d4AC': T;

    /**
     * @default 'Remaining to pay'
     */
    TgNQS: T;

    /**
     * @default 'No other payment needed — your honeymoon fund covers this stay.'
     */
    '1VnGf': T;

    /**
     * @default 'It’s your money. Spend it here, or keep it in your cash fund.'
     */
    '42x9R': T;

    /**
     * @default 'Use Your Honeymoon Balance'
     */
    CWqIq: T;

    /**
     * @default '{{0}} available. Applies automatically — choose how much below.'
     */
    '9ubkm': T;

    /**
     * @default 'How much of your Honeymoon Balance would you like to use?'
     */
    xAv4Z: T;

    /**
     * @default 'You have {{0}} in your Honeymoon Balance.'
     */
    R3fNS: T;

    /**
     * @default 'Applying {{0}} from your fund.'
     */
    iORFE: T;

    /**
     * @default 'Only {{0}} is due now, so we applied {{1}}.'
     */
    iVgmq: T;

    /**
     * @default 'At least {{0}} must be paid by card.'
     */
    lj4g4: T;

    /**
     * @default 'Your honeymoon fund has less available than that. We've updated the amount — press Continue to keep going.'
     */
    M6sN6: T;

    /**
     * @default 'We couldn't apply your honeymoon fund to this stay. Nothing was taken from it, and you can still pay by card.'
     */
    x2igi: T;

    /**
     * @default 'We couldn't accept that card. Please check your card and billing details, or enter a different card, then try again.'
     */
    JyGnq: T;

    /**
     * @default 'That promo code can't be used with the way you've chosen to pay. Remove the code, or change your honeymoon fund amount, then press Continue. You haven't been charged.'
     */
    El8if: T;

    /**
     * @default 'Uh oh! Seems like this offer is no longer available'
     */
    '4LomP': T;

    /**
     * @default 'Don’t worry we have other great offers at this hotel for you to select from.'
     */
    H7P2W: T;

    /**
     * @default 'Pick New Offer'
     */
    '5NjfN': T;

    /**
     * @default 'Offer expired animation'
     */
    ZXUjE: T;

    /**
     * @default 'This room's price or terms just changed'
     */
    OCBeQ: T;

    /**
     * @default 'We didn't charge you. The hotel updated this room while you were checking out, so we've brought you back to review the latest offers.'
     */
    m1CvQ: T;

    /**
     * @default 'Review Offers'
     */
    ryswE: T;

    /**
     * @default 'Offer changed animation'
     */
    '0Y41U': T;

    /**
     * @default 'The price for this room just changed, so we couldn't hold it. Nothing was charged, and nothing is on hold.'
     */
    MM5rr: T;

    /**
     * @default 'This rate can't be held right now. Nothing was charged, and nothing is on hold. You can still book it.'
     */
    uGvR6: T;

    /**
     * @default 'This room is already being held for you. Use the link in your most recent Joy email to confirm or release it.'
     */
    jLSKU: T;

    /**
     * @default 'Please fill out the missing details above.'
     */
    h4r73: T;

    /**
     * @default 'Please select a payment method.'
     */
    '6FspP': T;

    /**
     * @default 'Check your payment details above, then press Lock Price again.'
     */
    MO6n1: T;

    /**
     * @default 'Not ready to book?'
     */
    fUpFC: T;

    /**
     * @default 'FREE'
     */
    KQ6KA: T;

    /**
     * @default 'Hold this price for {{0}} hours for free.'
     */
    HhHIQ: T;

    /**
     * @default 'Nothing is charged now. Your rate is held until {{0}}.'
     */
    ZKdhG: T;

    /**
     * @default 'Nothing is charged now.'
     */
    zUsh7: T;

    /**
     * @default 'Lock Price'
     */
    '61zyR': T;
  };
};

export type UnifiedWebsiteEditorAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Add New Page'
     */
    wsKWg: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Link copied'
     */
    IHIze: T;

    /**
     * @default 'Your site is live'
     */
    ahOO7: T;

    /**
     * @default 'Copy link'
     */
    Xn2zA: T;

    /**
     * @default 'Still on your list'
     */
    g2hJa: T;

    /**
     * @default 'You’re ready to share your site with guests!'
     */
    oYl5Z: T;

    /**
     * @default 'Print a QR code on your cards, send email, text or share any way that works best.'
     */
    '61lQU': T;

    /**
     * @default 'Explore Cards'
     */
    '0EYOV': T;

    /**
     * @default 'Share with email'
     */
    Bzxzt: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Publish Now'
     */
    RbCnC: T;

    /**
     * @default 'Go live checks'
     */
    VDI5l: T;

    /**
     * @default 'Here's how guests will see your site'
     */
    oUOTQ: T;

    /**
     * @default 'This is what pops up when you share your link in a text or group chat. Check each detail before you send it.'
     */
    E7wS7: T;

    /**
     * @default 'Update {{0}}'
     */
    LSFFT: T;

    /**
     * @default 'Check My Site'
     */
    jJQxf: T;

    /**
     * @default 'Resend in {{0}}s'
     */
    hBDGL: T;

    /**
     * @default 'Resend Link'
     */
    FrUAn: T;

    /**
     * @default 'I've Verified'
     */
    Hbc1G: T;

    /**
     * @default 'Verify Email'
     */
    Z6YfL: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Step {{0}} of {{1}}'
     */
    sXRsT: T;

    /**
     * @default 'Save and Publish'
     */
    JevWG: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'Save and Continue'
     */
    nc0hJ: T;

    /**
     * @default 'Add Page'
     */
    u0IsO: T;

    /**
     * @default 'Manage Plans'
     */
    fwYlt: T;

    /**
     * @default 'Website Page Photos'
     */
    rNZVs: T;

    /**
     * @default 'Event Photos'
     */
    B1A1J: T;

    /**
     * @default 'Albums'
     */
    cuntj: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Uploads'
     */
    '2NrCg': T;

    /**
     * @default 'Media Library'
     */
    XlwVF: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Resize panel'
     */
    Wm6Ky: T;

    /**
     * @default 'Website editor panel'
     */
    glbVF: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'We found our placeholder copy on one page. Guests will see it word for word.'
     * @param {number} count - The number of occurrences.
     * - singular: We found our placeholder copy on one page. Guests will see it word for word.
     * - plural: We found our placeholder copy on {{0}} pages. Guests will see it word for word.
     */
    '5GB0A': T;

    /**
     * @default 'A few pages still have our starter text'
     */
    Hcap3: T;

    /**
     * @default 'Ticked pages go on your list, so you can come back to them after you publish.'
     */
    pO5BL: T;

    /**
     * @default 'Replaced'
     */
    epJSc: T;

    /**
     * @default 'Saved when you continue'
     */
    Jx27S: T;

    /**
     * @default 'Replace {{0}}'
     */
    '6VXQR': T;

    /**
     * @default 'Replace'
     */
    iBfqf: T;

    /**
     * @default 'Welcome page header'
     */
    '8N0IC': T;

    /**
     * @default 'Photo {{0}}'
     */
    eecBY: T;

    /**
     * @default 'App photo'
     */
    rAW5D: T;

    /**
     * @default 'Joy app & invites'
     */
    bwaBc: T;

    /**
     * @default 'Some photos are still from the template'
     */
    I1Ljv: T;

    /**
     * @default 'Yours will look better. Promise.'
     */
    sOORV: T;

    /**
     * @default 'Checking'
     */
    qL0jP: T;

    /**
     * @default 'Couldn't check'
     */
    IPXZw: T;

    /**
     * @default 'Not verified yet'
     */
    RomD5: T;

    /**
     * @default 'Couldn't send'
     */
    mQTfL: T;

    /**
     * @default 'Waiting'
     */
    LQiiV: T;

    /**
     * @default 'Not verified'
     */
    NxxmM: T;

    /**
     * @default 'We sent a new link to {{0}}.'
     */
    Sfxno: T;

    /**
     * @default 'We sent you a new link.'
     */
    aUsnB: T;

    /**
     * @default 'We sent a link to {{0}}.'
     */
    aaix3: T;

    /**
     * @default 'We sent you a link.'
     */
    Ymzbx: T;

    /**
     * @default 'We'll send a link to {{0}}.'
     */
    RuMi3: T;

    /**
     * @default 'We'll send you a link.'
     */
    '9NLWS': T;

    /**
     * @default 'Required to publish'
     */
    hVNqY: T;

    /**
     * @default 'Verify your email to publish'
     */
    EZHTx: T;

    /**
     * @default 'Joy needs a verified email before your site can go live.'
     */
    zNF5l: T;

    /**
     * @default 'No email on your account'
     */
    '26H2B': T;

    /**
     * @default 'We couldn't send the verification email. Please try again.'
     */
    BdQUQ: T;

    /**
     * @default 'We couldn't check your email just now. Please try again.'
     */
    AyrLT: T;

    /**
     * @default 'Publishing stays unavailable until this is done.'
     */
    zBA2s: T;

    /**
     * @default 'Your banner will be switched off when you continue.'
     */
    sQS7Y: T;

    /**
     * @default 'Your banner is switched off.'
     */
    '33FL8': T;

    /**
     * @default 'Your banner will be switched back on when you continue.'
     */
    XqbAk: T;

    /**
     * @default 'Your announcement banner is on'
     */
    pcisZ: T;

    /**
     * @default 'Your announcement banner is off'
     */
    DOOD8: T;

    /**
     * @default 'This pops up the second guests land on your site. Check it says what you want, or switch it off until you need it.'
     */
    '2Q9vC': T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Your banner needs a title and a message.'
     */
    '8ZrPG': T;

    /**
     * @default 'We couldn't save your banner. Please try again.'
     */
    TbCEk: T;

    /**
     * @default 'Keep the banner on'
     */
    '3TC4K': T;

    /**
     * @default 'Turn the banner back on'
     */
    q8v8O: T;

    /**
     * @default 'Turn the banner off instead'
     */
    tH5CR: T;

    /**
     * @default 'Live preview'
     */
    EBMqh: T;

    /**
     * @default 'We couldn't save your photo. Please try again.'
     */
    fj8I7: T;

    /**
     * @default 'Display name'
     */
    XavHB: T;

    /**
     * @default 'Your event needs a display name.'
     */
    OmtI9: T;

    /**
     * @default 'We couldn't save your display name. Please try again.'
     */
    UJHTC: T;

    /**
     * @default 'Pick something guests will remember.'
     */
    xoFcd: T;

    /**
     * @default 'Your {{0}} page is password protected. Pick something guests will remember.'
     */
    aL5Oy: T;

    /**
     * @default 'Your {{0}} and {{1}} pages are password protected. Pick something guests will remember.'
     */
    df1bw: T;

    /**
     * @default 'Your {{0}}, and {{1}} pages are password protected. Pick something guests will remember.'
     */
    pd81p: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'We couldn't save your password. Please try again.'
     */
    U1Ml9: T;

    /**
     * @default 'Couldn't load the current password. Enter it again to continue.'
     */
    yMpFM: T;

    /**
     * @default 'These pages don't have a password yet, so guests can't get in. Set one to continue.'
     */
    wZUIQ: T;

    /**
     * @default 'At least 3 characters. Letters, numbers and ! & + only. Not case sensitive.'
     */
    i95tE: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'This is also what's printed on your cards. Change it now — once it's shared, the old link stops working.'
     */
    gVC4z: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Change who can see {{0}}. Currently {{1}}.'
     */
    OnUxI: T;

    /**
     * @default 'Hotels, room blocks, and travel details in one place. It's the first thing out-of-town guests hunt for.'
     */
    luLhm: T;

    /**
     * @default 'Currently hidden.'
     */
    wD2WD: T;

    /**
     * @default 'Currently hidden, so guests can't respond from your site.'
     */
    nsfAs: T;

    /**
     * @default 'Guests can't respond from your site without it.'
     */
    QPegj: T;

    /**
     * @default 'Turn on the pages guests ask about most'
     */
    '5xM1L': T;

    /**
     * @default 'Anything you turn on with nothing behind it goes on your list for later.'
     */
    Ybmbs: T;

    /**
     * @default 'We couldn't save these pages. Please try again.'
     */
    Fmg8n: T;

    /**
     * @default 'Allow guests to search for my event on Joy'
     */
    '94D1e': T;

    /**
     * @default 'Help guests find your website and registry if they’ve lost the link. Search results are not guaranteed.'
     */
    '8BXtg': T;

    /**
     * @default 'Allow my event to be found on Google etc.'
     */
    TrjPC: T;

    /**
     * @default 'Search engine changes may take anywhere from a few days to weeks to take effect. Search results are not guaranteed.'
     */
    oCRBo: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Who should be able to find your site?'
     */
    '5J6WK': T;

    /**
     * @default 'We couldn't save these settings. Please try again.'
     */
    CAgNJ: T;

    /**
     * @default 'We couldn't replace that photo. Please try again.'
     */
    Yi5QT: T;
  };
};

export type UniversalRecommendationsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  productTile: {
    /**
     * @default 'While copying your gifts we may have found something better.'
     */
    title: T;

    /**
     * @default 'Added to your registry!'
     */
    postAddTitle: T;

    /**
     * @default 'You might also like this:'
     */
    postAddSubtitle: T;

    /**
     * @default 'Tell Me More'
     */
    TellMeMoreBtn: T;

    /**
     * @default 'Skip'
     */
    SkipBtn: T;

    /**
     * @default 'Swap Gift'
     */
    SwapGiftBtn: T;

    /**
     * @default 'Remind Me Later'
     */
    RemindMeLater: T;
  };
  notifiers: {
    /**
     * @default 'You’ve got recomendations'
     */
    notification: T;

    /**
     * @default 'All your registries have been transferred'
     */
    bannerTitle: T;

    /**
     * @default 'We found some recommendations that you may like!'
     */
    bannerSubtitle: T;

    /**
     * @default 'View Recommendations'
     */
    bannerBtn: T;

    /**
     * @default 'Registry {{currentIndex}} of {{totalItems}}'
     */
    registryCount: T;
  };
};

export type UnpublishedWebsiteTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'This site is still in the works.'
     */
    PNQZA: T;

    /**
     * @default 'Exciting things are happening behind the scenes. The site is currently under construction and will be unveiled here shortly. Please check back soon for all the details.'
     */
    VwvLV: T;

    /**
     * @default 'Planning your own event?'
     */
    n643y: T;

    /**
     * @default 'Create your own event website, invite guests and share all the details with Joy.'
     */
    kypCp: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;
  };
};

export type UpdateScheduleDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Want to check your Schedule for the new date?'
     */
    olyKh: T;

    /**
     * @default 'Make sure all the events in your Schedule are up to date.'
     */
    HsdbQ: T;

    /**
     * @default 'Take Me to Schedule'
     */
    rAtB3: T;
  };
};

export type ValidateGuestIdentityAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Validate website visitor identity'
     */
    Hwa7i: T;

    /**
     * @default 'Passwords can be shared, so we created something with higher security. We'll email guests a one-time code and a sign-in link to confirm who they are. Only people on your guestlist get in to your website. This setting replaces password protection.'
     */
    vIhlQ: T;

    /**
     * @default 'All pages must be password protected to enable this feature'
     */
    IgPc8: T;

    /**
     * @default 'Disabled — identity validation is on'
     */
    WQTbb: T;

    /**
     * @default 'Disabled while identity validation is on.'
     */
    vJaRH: T;
  };
};

export type VerifyEmailTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Let’s verify your email address'
   */
  headerText: T;

  /**
   * @default 'We just sent an email to <Email/>, with the subject “Please verify your email”. Click the link in that email and you’ll be all set to go.'
   */
  emailSentExplanation: T;

  /**
   * @default 'Your verification email has been re-sent.'
   */
  emailReSentCopy: T;

  /**
   * @default 'Sending...'
   */
  emailSendingCopy: T;

  /**
   * @default 'Can't find the email?'
   */
  emailNotFoundCopy: T;

  /**
   * @default 'Resend verification email'
   */
  reSendEmailAction: T;
};

export type VideoBackgroundTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Video Background Thumbnail'
     */
    JDUZb: T;

    /**
     * @default 'We couldn't load your video background.'
     */
    e7yCx: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Video Background'
     */
    FJLTh: T;

    /**
     * @default 'Play Video'
     */
    bbATk: T;

    /**
     * @default 'Video thumbnail'
     */
    X2WHP: T;

    /**
     * @default 'Change Video'
     */
    nb97d: T;

    /**
     * @default 'Remove Video'
     */
    zH2xf: T;

    /**
     * @default 'You reached a maximum number of videos in this header.'
     */
    SozJ7: T;

    /**
     * @default 'Add Video'
     */
    KlcqK: T;

    /**
     * @default 'Only show on welcome page'
     */
    JyHzi: T;

    /**
     * @default 'The top section of the video will be shown behind the navigation menu on pages other than the welcome page if turned off.'
     */
    uuyTS: T;

    /**
     * @default 'Only show on welcome page details'
     */
    P0MXf: T;

    /**
     * @default 'Event Title'
     */
    oQlBP: T;

    /**
     * @default 'Title Position'
     */
    '76UUw': T;

    /**
     * @default 'Title Style'
     */
    v8TWQ: T;

    /**
     * @default 'Navigation'
     */
    avBYb: T;

    /**
     * @default 'Choose Video Background'
     */
    GvMQU: T;

    /**
     * @default 'Save Video'
     */
    '0VpvJ': T;

    /**
     * @default 'Video Library'
     */
    MqtWb: T;

    /**
     * @default 'Add Your Own'
     */
    gawmR: T;

    /**
     * @default 'We couldn't load the video library. Please try again.'
     */
    e6VsM: T;

    /**
     * @default 'Loading…'
     */
    O5ScA: T;
  };
};

export type VideoHelperTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Read our video guide'
     */
    dBBbr: T;

    /**
     * @default 'How it works:'
     */
    JTmeh: T;

    /**
     * @default 'Prepare your video in 16:9 for desktop and 4:3 for mobile to avoid cropping or distortion.'
     */
    yvlBh: T;

    /**
     * @default 'Upload your video to Youtube or Vimeo. We recommend Vimeo for best quality.'
     */
    WVaHp: T;

    /**
     * @default 'Once that's complete, copy the website address of that video and paste it here.'
     */
    orVsO: T;

    /**
     * @default 'Vimeo Logo'
     */
    pyV1i: T;

    /**
     * @default 'Upload to Vimeo'
     */
    '63ppO': T;

    /**
     * @default 'Youtube Logo'
     */
    '2Gd8m': T;

    /**
     * @default 'Upload to Youtube'
     */
    hMXMB: T;

    /**
     * @default 'For best results, remove audio from your video. Videos with audio may not autoplay on mobile devices.'
     */
    I21iy: T;
  };
};

export type VipCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'VIPs'
     */
    uYTNA: T;

    /**
     * @default 'Failed to delete VIP'
     */
    mOSLL: T;

    /**
     * @default 'What's Wedding Party'
     */
    iN0Nn: T;

    /**
     * @default 'What's VIPs?'
     */
    dZnnE: T;

    /**
     * @default 'Highlight your wedding party with names, roles, and photos so guests can get to know them before the big day.'
     */
    PidN5: T;

    /**
     * @default 'Showcase important people or speakers by highlighting them on your event website.'
     */
    jbIaj: T;

    /**
     * @default 'Edit Member'
     */
    ysLd8: T;

    /**
     * @default 'Create New Member'
     */
    snszO: T;

    /**
     * @default 'We couldn’t load this member. Go back and try again.'
     */
    fKUXx: T;

    /**
     * @default 'Error deleting VIP'
     */
    NcsWv: T;

    /**
     * @default 'close dialog'
     */
    '4VEdN': T;

    /**
     * @default 'Delete VIP?'
     */
    '7ZsB1': T;

    /**
     * @default 'Are you sure you want to delete this VIP? This action cannot be undone.'
     */
    '6cxpA': T;

    /**
     * @default 'Delete VIP'
     */
    IZHot: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Your VIP list is empty'
     */
    Ni3yH: T;

    /**
     * @default 'Start adding the faces behind your event.'
     */
    T3Vrg: T;

    /**
     * @default 'Add Your First VIP'
     */
    '9HaJy': T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default 'Members'
     */
    '38lZe': T;

    /**
     * @default 'confirm'
     */
    wNSec: T;

    /**
     * @default 'cancel'
     */
    q0r5A: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Add {{0}} Members'
     */
    ONMcz: T;

    /**
     * @default 'All Members'
     */
    Czuem: T;

    /**
     * @default 'Choose from your saved members to display on this page.'
     */
    zAoXG: T;

    /**
     * @default 'No members in your list.'
     */
    c6OjT: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default '{{0}} Selected'
     */
    FsX46: T;

    /**
     * @default 'Select {{0}}'
     */
    ImZIC: T;

    /**
     * @default 'Delete {{0}}'
     */
    dhqAJ: T;

    /**
     * @default 'Remove this wedding party member?'
     */
    FzGTP: T;

    /**
     * @default 'This will permanently remove them from your saved wedding party members. To hide them from this page only, return to “Select mode” for this list.'
     */
    AmRMT: T;

    /**
     * @default 'Remove Member'
     */
    OCBFI: T;

    /**
     * @default 'Couldn’t save. Your changes are still here.'
     */
    '7JCbj': T;

    /**
     * @default 'Retry'
     */
    yGyzG: T;

    /**
     * @default 'Move up'
     */
    WJmm5: T;

    /**
     * @default 'Move down'
     */
    XsO1y: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Select...'
     */
    S8Eo2: T;

    /**
     * @default 'Loading VIP members'
     */
    uB1HJ: T;

    /**
     * @default 'We hold the rooms. You pay nothing.'
     */
    wBoy1: T;

    /**
     * @default 'Everyone gets their own booking link.'
     */
    pwZD6: T;

    /**
     * @default 'You'll be able to see who booked a room.'
     */
    BUXIN: T;

    /**
     * @default 'I'm interested in group rates'
     */
    FBlKp: T;

    /**
     * @default 'Maybe later'
     */
    UzExj: T;

    /**
     * @default 'You're on the list'
     */
    bBRFc: T;

    /**
     * @default 'We'll email you when your party can book. Nothing has been booked or charged.'
     */
    kpG22: T;

    /**
     * @default 'Meanwhile, they can book today'
     */
    Q3lLK: T;

    /**
     * @default 'Hotels near {{0}}'
     */
    RCeO8: T;

    /**
     * @default 'Hotels near your venue'
     */
    N3cH3: T;

    /**
     * @default 'Back to my wedding party'
     */
    AMFm8: T;

    /**
     * @default 'Add your wedding party. We'll handle their rooms.'
     */
    LjvJ4: T;

    /**
     * @default 'Everyone you add gets a room near {{0}} at a group rate, so the biggest thing you're asking of them costs them less.'
     */
    dqOCl: T;

    /**
     * @default 'Everyone you add gets a room near your venue at a group rate, so the biggest thing you're asking of them costs them less.'
     */
    lpmzO: T;

    /**
     * @default 'We'll hold rooms near {{0}} at a group rate: cheaper for them, and nothing for you.'
     */
    yIHFO: T;

    /**
     * @default 'We'll hold rooms near your venue at a group rate: cheaper for them, and nothing for you.'
     */
    eXohG: T;

    /**
     * @default 'Your wedding party is standing up for you - and paying their own way to do it.'
     */
    '4eDQy': T;

    /**
     * @default '{{0}} and {{1}} more are standing up for you - and paying their own way to do it.'
     */
    O6WTZ: T;

    /**
     * @default '{{0}} is standing up for you - and paying their own way to do it.'
     */
    '1vw0N': T;

    /**
     * @default '{{0}} and {{1}} are standing up for you - and paying their own way to do it.'
     */
    fWtgD: T;

    /**
     * @default 'Your people are coming together'
     */
    fSoIJ: T;

    /**
     * @default 'Plan Their Stay →'
     */
    '0RCIG': T;

    /**
     * @default 'Add your wedding party'
     */
    GCa4A: T;

    /**
     * @default 'Secure discounted hotel rooms near your venue - instantly, at no cost to you.'
     */
    '5iokM': T;

    /**
     * @default 'Your people, together'
     */
    M3rLV: T;

    /**
     * @default 'You've added {{0}} people to your wedding party. Want to do something special for them?'
     */
    dJOz7: T;

    /**
     * @default 'Wedding party member {{0}}'
     */
    Wsj6X: T;
  };
};

export type VipFormTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Choose Photo'
     */
    j4Q9S: T;

    /**
     * @default 'Swap Photo'
     */
    LnQfM: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Remove Photo'
     */
    '064Tf': T;
  };
};

export type WeatherReportGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Low'
     */
    '4fWAA': T;

    /**
     * @default 'Moderate'
     */
    FiWFw: T;

    /**
     * @default 'High'
     */
    EwVLA: T;

    /**
     * @default 'Very High'
     */
    SIn9F: T;

    /**
     * @default 'Extreme'
     */
    kt8wu: T;

    /**
     * @default 'UV: {{0}} · {{1}}'
     */
    VwUbt: T;

    /**
     * @default 'Calm'
     */
    JyiKA: T;

    /**
     * @default 'Breezy'
     */
    '3VF2m': T;

    /**
     * @default 'Windy'
     */
    RPQPH: T;

    /**
     * @default 'Strong'
     */
    z9jFW: T;

    /**
     * @default 'Wind: {{0}} km/h · {{1}}'
     */
    t5ctH: T;

    /**
     * @default 'Precip'
     */
    xR96N: T;

    /**
     * @default 'Humidity'
     */
    tQMCs: T;

    /**
     * @default 'City {{0}}'
     */
    v3W8c: T;

    /**
     * @default '{{0}}-Day Forecast'
     */
    WkrL2: T;

    /**
     * @default 'Today'
     */
    h6LBH: T;
  };
};

export type WebsiteCreateTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Romantic'
     */
    HRwfV: T;

    /**
     * @default 'Modern'
     */
    tUSvF: T;

    /**
     * @default 'Rustic'
     */
    SUggT: T;

    /**
     * @default 'Playful'
     */
    '7tLkT': T;

    /**
     * @default 'Classic'
     */
    UZCBu: T;

    /**
     * @default 'Moody'
     */
    CfZcG: T;

    /**
     * @default 'Beachy'
     */
    yjwyl: T;

    /**
     * @default 'Garden'
     */
    VOewy: T;

    /**
     * @default 'Minimal'
     */
    dpfGp: T;

    /**
     * @default 'Bold'
     */
    RadKA: T;

    /**
     * @default 'What's the vibe?'
     */
    '2pgYD': T;

    /**
     * @default 'Your colors'
     */
    T12Yi: T;

    /**
     * @default 'Other…'
     */
    CNOdL: T;

    /**
     * @default 'Tell us about you two'
     */
    vQ3Ag: T;

    /**
     * @default 'What's the occasion?'
     */
    HbVVk: T;

    /**
     * @default 'e.g. We met at a climbing gym. Garden party, not formal — think long tables, string lights, and our dog as ring bearer.'
     */
    OPPQP: T;

    /**
     * @default 'e.g. A dinner for our leadership team. Relaxed but polished — think candlelight, long tables, and a short welcome toast.'
     */
    '3bOjK': T;

    /**
     * @default 'Anything to avoid?'
     */
    x9elz: T;

    /**
     * @default 'e.g. No florals, nothing pink, no script fonts.'
     */
    TU22R: T;

    /**
     * @default 'Review brief'
     */
    IBJKK: T;

    /**
     * @default 'Your selections compose the brief here — or write your own.'
     */
    o4vLo: T;

    /**
     * @default 'Reset to selections'
     */
    rOqfs: T;

    /**
     * @default 'Starting to look like you.'
     */
    oIveD: T;

    /**
     * @default 'Tap a vibe or a color to see it take shape.'
     */
    EZzCi: T;

    /**
     * @default 'Save the date'
     */
    '6wNuv': T;

    /**
     * @default 'The celebration'
     */
    npTdn: T;

    /**
     * @default 'A garden wedding'
     */
    abowD: T;

    /**
     * @default 'Our wedding day'
     */
    SmWj5: T;

    /**
     * @default 'Reading your story…'
     */
    '23iW5': T;

    /**
     * @default 'Choosing your look…'
     */
    ipvla: T;

    /**
     * @default 'Laying out your site…'
     */
    WinT1: T;

    /**
     * @default 'Creating your imagery…'
     */
    Ik2lO: T;

    /**
     * @default 'Designing your website…'
     */
    OH2RR: T;

    /**
     * @default 'Looking everything over…'
     */
    MF49a: T;

    /**
     * @default 'Putting it all together…'
     */
    laohO: T;

    /**
     * @default 'Setting up your site…'
     */
    '9EeST': T;

    /**
     * @default 'Getting started…'
     */
    JtuBh: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Continue in the background'
     */
    XFWzD: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Let's make your website'
     */
    Jvrno: T;

    /**
     * @default 'Start from a design we love, or tell us about you and we'll design one just for your special day.'
     */
    '0wbg0': T;

    /**
     * @default 'Pick a design you love.'
     */
    '5dRoc': T;

    /**
     * @default 'Design something just for us'
     */
    FYcr9: T;

    /**
     * @default 'Tell us about your day, and we'll build the perfect site for you.'
     */
    qXeRn: T;

    /**
     * @default 'Or start from a design'
     */
    EDyL5: T;

    /**
     * @default 'A designer template'
     */
    A9Uxy: T;

    /**
     * @default 'Tell us about your day'
     */
    '37Ugt': T;

    /**
     * @default 'Tell us about your event'
     */
    JWCsO: T;

    /**
     * @default 'All fields are optional, but help add personality to your site.'
     */
    QbHsd: T;

    /**
     * @default 'Design My Website'
     */
    nEtmH: T;

    /**
     * @default 'That didn't work.'
     */
    '0mXfB': T;

    /**
     * @default 'Something went wrong while designing your website.'
     */
    GcfWu: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Your website is ready.'
     */
    tAlCR: T;

    /**
     * @default 'Open Your Website'
     */
    cEezu: T;

    /**
     * @default 'Designing from your brief:'
     */
    l6T2T: T;
  };
};

export type WebsiteDesignerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Design'
   */
  titleDesign: T;

  /**
   * @default 'Select a Design Template'
   */
  selectTemplateTitle: T;

  /**
   * @default 'Select a Template'
   */
  selectTemplateTitleV2: T;

  /**
   * @default 'Save and Open'
   */
  saveAndOpen: T;

  /**
   * @default 'Add your custom CSS here'
   */
  cssCodePlaceholder: T;

  /**
   * @default 'Custom CSS is an experimental feature. We can't guarantee your custom CSS will work indefinitely.'
   */
  cssWarning: T;

  /**
   * @default 'Using CSS requires a separate preview.'
   */
  cssPreviewTitle: T;

  /**
   * @default 'To see your changes, publish your design and open your live website.'
   */
  cssPreviewContent: T;

  /**
   * @default 'Edit Design'
   */
  editDesign: T;

  /**
   * @default 'Preview'
   */
  preview: T;

  /**
   * @default 'View Site'
   */
  previewSite: T;

  /**
   * @default 'Publish'
   */
  ctaPublish: T;

  /**
   * @default 'Apply Template'
   */
  ctaApplyTemplate: T;

  /**
   * @default 'Back'
   */
  ctaBack: T;

  /**
   * @default 'Design'
   */
  design: T;

  /**
   * @default 'Back to Dashboard'
   */
  back: T;

  /**
   * @default 'Preview site with this theme'
   */
  previewSiteWithThisTheme: T;

  /**
   * @default 'Publish'
   */
  publish: T;

  /**
   * @default 'Publish Changes'
   */
  publishChanges: T;

  /**
   * @default 'Publishing...'
   */
  publishing: T;

  /**
   * @default 'Saving...'
   */
  saving: T;

  /**
   * @default 'Nice work! Now, check out your site.'
   */
  niceWork: T;

  /**
   * @default 'View current site without your changes.'
   */
  viewCurrentSite: T;

  /**
   * @default 'Not seeing your changes on your website? Make sure to apply changes.'
   */
  notSeeingChangesMessage: T;

  /**
   * @default 'View Site'
   */
  viewSite: T;

  /**
   * @default 'Updates have been published'
   */
  changesPublishedSuccessfully: T;

  /**
   * @default 'Preview Website'
   */
  'titlePreview.desktop': T;

  /**
   * @default 'Preview Mobile'
   */
  'titlePreview.mobile': T;

  /**
   * @default 'Preview Stationery'
   */
  'titlePreview.stationery': T;

  /**
   * @default 'Sorry but your theme is no longer available to preview.'
   */
  themeNotSupportedText: T;

  /**
   * @default 'Learn Why'
   */
  themeNotSupportedButton: T;

  /**
   * @default 'Explore Matching Prints'
   */
  stationeryExplorePrints: T;

  /**
   * @default 'Select unique print stationery from'
   */
  stationerySelectUnique: T;

  /**
   * @default 'Or pair your theme with free matching digital stationery'
   */
  stationaryDigitalOption: T;

  /**
   * @default 'Pair your theme with free matching digital stationery'
   */
  stationaryDigitalOptionPair: T;

  /**
   * @default 'Create Save the Date'
   */
  stationarySaveTheDate: T;

  /**
   * @default 'Create Invitation'
   */
  stationaryInvitation: T;

  /**
   * @default 'Save the Date'
   */
  saveTheDate: T;

  /**
   * @default 'Invitation'
   */
  invitation: T;

  /**
   * @default 'Current'
   */
  current: T;

  /**
   * @default 'Headers'
   */
  headers: T;

  /**
   * @default 'Filter'
   */
  filter: T;

  /**
   * @default 'Filters'
   */
  filters: T;

  /**
   * @default 'Clear'
   */
  clear: T;

  /**
   * @default 'reset'
   */
  reset: T;

  /**
   * @default 'Graphic Accent'
   */
  graphicAccent: T;

  /**
   * @default 'Layout'
   */
  layout: T;

  /**
   * @default 'Choose between single and multi-page layout.'
   */
  layoutDescription: T;

  /**
   * @default 'Site Layout'
   */
  siteLayout: T;

  /**
   * @default 'Accent Color'
   */
  accentColor: T;

  /**
   * @default ' is used for links and buttons. It can also be used as a background color for some themes using the single page layout.'
   */
  accentColorTooltip: T;

  /**
   * @default 'Font'
   */
  font: T;

  /**
   * @default 'Art background'
   */
  artBackground: T;

  /**
   * @default 'Art font'
   */
  artFont: T;

  /**
   * @default 'Page background'
   */
  pageBackground: T;

  /**
   * @default 'Page font'
   */
  pageFont: T;

  /**
   * @default 'Link & button'
   */
  linkAndButton: T;

  /**
   * @default 'Colors'
   */
  colors: T;

  /**
   * @default 'Photo Palette'
   */
  photoPalette: T;

  /**
   * @default 'Art'
   */
  art: T;

  /**
   * @default 'Border'
   */
  border: T;

  /**
   * @default 'Transparency'
   */
  transparency: T;

  /**
   * @default 'Page Transparency'
   */
  pageTransparency: T;

  /**
   * @default 'Page Shadow'
   */
  pageShadow: T;

  /**
   * @default 'Sorry, there&apos;s been an error. Refresh the page.'
   */
  dataLoadError: T;

  /**
   * @default 'Multi-Page'
   */
  multiPage: T;

  /**
   * @default 'Simple Scroll'
   */
  simpleScroll: T;

  /**
   * @default 'Split View'
   */
  splitView: T;

  /**
   * @default 'Classic Navigation'
   */
  classicNavigation: T;

  /**
   * @default 'Collection'
   */
  collection: T;

  /**
   * @default 'Single Page'
   */
  singlePage: T;

  /**
   * @default 'No Exact Matches'
   */
  noMatches: T;

  /**
   * @default 'Clear All Filters'
   */
  clearAllFilters: T;

  /**
   * @default 'Reset All Filters'
   */
  resetAllFilters: T;

  /**
   * @default 'Show Results'
   */
  showResults: T;

  /**
   * @default 'Show All'
   */
  showAllButton: T;

  /**
   * @default 'Show All Templates'
   */
  showAllButton_template: T;

  /**
   * @default 'Show All Fonts'
   */
  showAllButton_font: T;

  /**
   * @default 'Show All Themes'
   */
  showAllButton_theme: T;

  /**
   * @default 'Show it'
   */
  showOneButton: T;

  /**
   * @default 'Show 1 Template'
   */
  showOneButton_template: T;

  /**
   * @default 'Show 1 Font'
   */
  showOneButton_font: T;

  /**
   * @default 'Show 1 Theme'
   */
  showOneButton_theme: T;

  /**
   * @default 'Show them'
   */
  showManyButton: T;

  /**
   * @default 'Show {{count}} Templates'
   */
  showManyButton_template: T;

  /**
   * @default 'Show {{count}} Fonts'
   */
  showManyButton_font: T;

  /**
   * @default 'Show {{count}} Themes'
   */
  showManyButton_theme: T;

  /**
   * @default 'Filter Options'
   */
  filterBaseTitle: T;

  /**
   * @default 'Filter Templates'
   */
  filterBaseTitle_template: T;

  /**
   * @default 'Filter Fonts'
   */
  filterBaseTitle_font: T;

  /**
   * @default 'Filter Themes'
   */
  filterBaseTitle_theme: T;

  /**
   * @default 'Designs Gallery'
   */
  designsGallery: T;

  /**
   * @default 'Color'
   */
  color: T;

  /**
   * @default 'Guide to Customizing Colors'
   */
  guideToCustomizingColors: T;

  /**
   * @default 'Customize'
   */
  customizeThisDesign: T;

  /**
   * @default 'Change Design'
   */
  changeDesign: T;

  /**
   * @default 'View with Your Photo'
   */
  viewWithYourPhoto: T;

  /**
   * @default 'You must select one photo.'
   */
  youMustSelectOnePhoto: T;

  /**
   * @default 'Clear Photo'
   */
  clearPhoto: T;

  customCssError: {
    /**
     * @default 'Custom CSS Error'
     */
    title: T;

    /**
     * @default 'Your custom CSS is invalid. Please review and make any necessary adjustments.'
     */
    message: T;

    /**
     * @default 'Review'
     */
    action: T;
  };
  customErrorDefault: {
    /**
     * @default 'Error'
     */
    title: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    message: T;

    /**
     * @default 'Try Again'
     */
    action: T;
  };

  /**
   * @default 'Templates'
   */
  templates: T;

  /**
   * @default 'Details'
   */
  details: T;

  /**
   * @default 'CSS'
   */
  css: T;

  smartTip: {
    /**
     * @default 'SMART TIP'
     */
    label: T;

    /**
     * @default 'Easily link to your website with a QR code on your cards.'
     */
    browse: T;

    /**
     * @default 'Link to your website with a QR code on matching cards.'
     */
    matching: T;

    /**
     * @default 'Browse Cards'
     */
    browseButton: T;

    /**
     * @default 'Add QR Code'
     */
    matchingButton: T;
  };
  stationeryTabV2: {
    externalProviderBlock: {
      /**
       * @default 'Beautiful Matching Paper Cards from {{providerName}}'
       */
      title: T;

      /**
       * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
       */
      description: T;

      /**
       * @default 'Customize on {{providerName}}'
       */
      primaryCta: T;
    };
    joyProviderBlock: {
      /**
       * @default 'Beautiful Paper & Digital Cards to Match Your Wedding Website'
       */
      defaultTitle: T;

      /**
       * @default 'Digital Cards to Match Your Wedding Website'
       */
      externalProviderTitle: T;

      /**
       * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
       */
      description: T;

      /**
       * @default 'Explore Print Designs'
       */
      primaryCta: T;

      /**
       * @default 'Explore Digital Designs'
       */
      secondaryCta: T;

      /**
       * @default 'Save the Date'
       */
      saveTheDateAlt: T;

      /**
       * @default 'Invitation'
       */
      invitationAlt: T;

      /**
       * @default 'test'
       */
      testAlt: T;
    };
  };

  /**
   * @default 'Favorites'
   */
  favorites: T;

  emptyResults: {
    /**
     * @default 'Clear Filters'
     */
    clearFilters: T;

    /**
     * @default 'Clear Search'
     */
    clearSearch: T;

    /**
     * @default 'Once you favorite fonts, you’ll see them here.'
     */
    fontsFavoritesSubTitle: T;

    state: {
      filters: {
        /**
         * @default 'No results for those filters.'
         */
        title: T;

        /**
         * @default 'Try changing them or using fewer filters.'
         */
        subTitle: T;
      };
      search: {
        /**
         * @default 'No results found.'
         */
        title: T;

        /**
         * @default 'Look out for typos or try a different search.'
         */
        subTitle: T;
      };
      favorite: {
        /**
         * @default 'Press the heart button on anything you love to favorite it.'
         */
        title: T;

        /**
         * @default 'Your favorite designs will be collected here.'
         */
        subTitle: T;
      };
    };

    /**
     * @default 'Looking for something we don't have yet?'
     */
    notFoundMessage: T;

    /**
     * @default 'Let us know!'
     */
    letUsKnow: T;
  };
  search: {
    /**
     * @default 'Search for {{tab}}'
     */
    placeholder: T;
  };
  tabs: {
    /**
     * @default 'Templates'
     */
    templates: T;
  };
  localStorageError: {
    /**
     * @default 'LocalStorage Not Available'
     */
    title: T;

    /**
     * @default 'Close'
     */
    closeCta: T;

    /**
     * @default 'It looks like LocalStorage is not available in your browser. LocalStorage is required for favorite application to function correctly.'
     */
    applicationMessage: T;

    /**
     * @default 'Please ensure that LocalStorage is enabled in your browser settings. You can usually find these settings under privacy or site-specific settings.'
     */
    privacyMessage: T;

    /**
     * @default 'If you are using incognito mode or a privacy-focused browser, try switching to a normal browsing window or adjusting your privacy settings.'
     */
    incognitoMessage: T;
  };
  matchingPrintModal: {
    /**
     * @default 'Complement your website with matching cards.'
     */
    title: T;

    /**
     * @default 'Share your style your way with paper and digital Save the Dates and invitations.'
     */
    subtitle: T;

    /**
     * @default 'Browse Card Designs'
     */
    browseButton: T;
  };
  unsupportedThemeLayout: {
    /**
     * @default 'This theme is not available in your current layout.'
     */
    title: T;

    /**
     * @default 'Switch Layout'
     */
    switchButton: T;
  };
  altText: {
    /**
     * @default 'Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Invitation'
     */
    invitation: T;

    /**
     * @default 'test'
     */
    test: T;
  };
  badges: {
    /**
     * @default 'Matching Paper'
     */
    matchingPaper: T;

    /**
     * @default 'New'
     */
    new: T;
  };
  fontPacks: {
    /**
     * @default 'Customize Fonts'
     */
    customizeFonts: T;

    /**
     * @default 'Font Sets'
     */
    fontSets: T;

    categories: {
      /**
       * @default 'Buttons'
       */
      BUTTONS: T;

      /**
       * @default 'Event Date'
       */
      DATE: T;

      /**
       * @default 'Event Name'
       */
      EVENT_TITLE: T;

      /**
       * @default 'Heading'
       */
      HEADING: T;

      /**
       * @default 'Event Location'
       */
      LOCATION: T;

      /**
       * @default 'Navigation'
       */
      NAVIGATION: T;

      /**
       * @default 'Paragraph'
       */
      PARAGRAPH: T;

      /**
       * @default 'Subhead'
       */
      SUB_HEADING: T;

      /**
       * @default 'Caption'
       */
      CAPTION: T;

      /**
       * @default 'Page Title'
       */
      PAGE_TITLE: T;
    };

    /**
     * @default 'Reset All Fonts'
     */
    resetAllFonts: T;

    /**
     * @default 'All Styles'
     */
    allStyles: T;

    /**
     * @default '{{category}} Style'
     */
    fontCategoryTitle: T;

    /**
     * @default '{{category}} Size'
     */
    fontCategorySize: T;

    /**
     * @default '{{category}} style updated.'
     */
    fontConfigEditSuccess: T;

    /**
     * @default 'Error updating font configuration. Please try again later.'
     */
    fontConfigEditError: T;

    /**
     * @default 'A'
     */
    a: T;

    /**
     * @default 'Search by name, style, or vibes'
     */
    fontPackSearchPlaceholder: T;

    /**
     * @default 'Select a font pack for customization'
     */
    selectAFontPackForCustomization: T;

    sampleFontText: {
      /**
       * @default 'The Ceremony'
       */
      heading: T;

      /**
       * @default 'Rehearsal Dinner'
       */
      subHeading: T;

      /**
     * @default 'Please see our Schedule 
 for the dress code.'
*/
      paragraph: T;

      /**
       * @default 'Don't forget to RSVP'
       */
      buttons: T;

      /**
       * @default 'Schedule    Travel    Registry'
       */
      navigation: T;

      /**
       * @default '10:00 AM'
       */
      caption: T;

      /**
       * @default 'Schedule'
       */
      pageTitle: T;
    };
    discardDialog: {
      /**
       * @default 'Do you want to discard font customizations?'
       */
      title: T;

      /**
       * @default 'You will lose the custom page fonts you have selected if you switch to this font set.'
       */
      subtitle: T;

      /**
       * @default 'Keep Custom Fonts'
       */
      CTA1: T;

      /**
       * @default 'Discard Custom Fonts'
       */
      CTA2: T;
    };
  };
  header: {
    photo: {
      /**
       * @default 'Header Layout'
       */
      headerLayout: T;

      /**
       * @default 'Choose the layout for the header photo.'
       */
      headerLayoutDescription: T;

      /**
       * @default 'Choose Photos ({{countRange}} required)'
       */
      photoSelectionCount: T;

      photoPresentationLayouts: {
        /**
         * @default 'Screen Width Photo'
         */
        fullWidth: T;

        /**
         * @default 'Page Width Photo'
         */
        pageWidth: T;

        /**
         * @default 'Photo'
         */
        center: T;

        /**
         * @default 'Photo Slider'
         */
        photoSlider: T;

        /**
         * @default 'Photo Marquee'
         */
        photoMarquee: T;

        /**
         * @default 'Photo Trio'
         */
        photoTrio: T;

        /**
         * @default 'Page Width Photo Trio'
         */
        photoTrioPageWidth: T;

        /**
         * @default 'Photo Duo Left'
         */
        photoDuoLeft: T;

        /**
         * @default 'Photo Duo Right'
         */
        photoDuoRight: T;

        /**
         * @default 'Photo Arch'
         */
        photoArch: T;

        /**
         * @default 'No Photo'
         */
        noPhoto: T;

        /**
         * @default 'Monogram'
         */
        monogram: T;

        /**
         * @default 'Photo Background'
         */
        photoBackground: T;

        /**
         * @default 'Video Background'
         */
        videoBackground: T;

        /**
         * @default 'Video Arch'
         */
        videoArch: T;
      };
    };
    text: {
      /**
       * @default 'Text Alignment'
       */
      textAlignment: T;

      /**
       * @default 'Colors'
       */
      colors: T;
    };
    eventDisplayName: {
      /**
       * @default 'Your Event Display Name'
       */
      displayNameLabel: T;

      /**
       * @default 'Enter your event display name'
       */
      displayNamePlaceholder: T;

      /**
       * @default 'Event Display Name is required.'
       */
      displayNameRequired: T;

      /**
       * @default 'Event Display Name saved successfully.'
       */
      saveDisplayNameSuccess: T;

      /**
       * @default 'Error saving Event Display Name. Please try again later.'
       */
      saveDisplayNameError: T;
    };
    eventGreetingMessage: {
      /**
       * @default 'Greeting Message'
       */
      greetingMessageLabel: T;

      /**
       * @default 'Enter your greeting message'
       */
      greetingMessagePlaceholder: T;

      /**
       * @default 'Greeting Message is required.'
       */
      greetingMessageRequired: T;

      /**
       * @default 'Greeting Message saved successfully.'
       */
      saveGreetingMessageSuccess: T;

      /**
       * @default 'Error saving Greeting Message. Please try again later.'
       */
      saveGreetingMessageError: T;
    };
  };
  monogramEditorDialog: {
    /**
     * @default 'Select Layout and Edit'
     */
    selectLayoutAndEdit: T;

    /**
     * @default 'Edit Monogram'
     */
    editMonogram: T;

    /**
     * @default 'Customize Monogram'
     */
    title: T;

    layoutTab: {
      /**
       * @default 'Layouts'
       */
      title: T;

      /**
       * @default 'Thumbnail of Monogram'
       */
      monogramAlt: T;

      /**
       * @default 'Select and Customize'
       */
      cta: T;
    };
    editorTab: {
      /**
       * @default 'Editor'
       */
      title: T;

      /**
       * @default 'Save'
       */
      cta: T;

      /**
       * @default 'Failed to save Monogram'
       */
      saveError: T;
    };
  };
  websitePreviewPhoto: {
    /**
     * @default 'Event Photo'
     */
    title: T;

    /**
     * @default 'Select a photo to use as the website preview photo.'
     */
    description: T;

    /**
     * @default 'Shown when sharing the link with guests.'
     */
    descriptionInfo: T;

    /**
     * @default 'Add Photo'
     */
    addPhoto: T;
  };

  /**
   * @default 'Not available for this design'
   */
  notAvailableForThisDesign: T;

  designTile: {
    /**
     * @default 'Selected'
     */
    selected: T;

    /**
     * @default 'Animated'
     */
    animated: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Customize'
     */
    customize: T;
  };
  editorV3Tabs: {
    /**
     * @default 'Templates'
     */
    templates: T;

    /**
     * @default 'Layout'
     */
    layout: T;

    /**
     * @default 'Color'
     */
    color: T;

    /**
     * @default 'Details'
     */
    details: T;

    /**
     * @default 'Art'
     */
    art: T;

    /**
     * @default 'Font'
     */
    font: T;

    /**
     * @default 'Event Photo'
     */
    eventPhoto: T;

    /**
     * @default 'Custom CSS'
     */
    css: T;
  };
  quick: {
    /**
     * @default 'Go back'
     */
    Pyxnt: T;

    /**
     * @default 'Check My Site'
     */
    jJQxf: T;

    /**
     * @default 'Publish Without Checking'
     */
    '5DvRm': T;

    /**
     * @default 'Want a quick check before you publish?'
     */
    k4oLC: T;

    /**
     * @default 'We'll walk you through a few quick steps to make sure your site is ready for guests.'
     */
    Ms6Cv: T;

    /**
     * @default 'Default Photos'
     */
    yw6tD: T;

    /**
     * @default 'Make sure all the default photos have been updated with your own.'
     */
    r448J: T;

    /**
     * @default 'Starter Text'
     */
    '4b8Xz': T;

    /**
     * @default 'Replace the placeholder text on your pages.'
     */
    jKqrB: T;

    /**
     * @default 'Announcement Banner'
     */
    '56Np9': T;

    /**
     * @default 'The first thing guests see when they open your site.'
     */
    F7FbU: T;

    /**
     * @default 'Your Event URL'
     */
    gqkdP: T;

    /**
     * @default 'The link guests type or tap to reach your site.'
     */
    CqVJD: T;

    /**
     * @default 'Your Link Preview'
     */
    fgehZ: T;

    /**
     * @default 'The name and photo guests see when you share your link.'
     */
    WTFok: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'What guests enter to open your protected pages.'
     */
    zrZvD: T;

    /**
     * @default 'Hidden Pages'
     */
    '2ReYr': T;

    /**
     * @default 'Turn on the pages guests look for most.'
     */
    FNf7h: T;

    /**
     * @default 'Search & Privacy'
     */
    ANduF: T;

    /**
     * @default 'Who can see and search for your site.'
     */
    XEaJt: T;

    /**
     * @default 'What guests type, tap, and see when you share your site.'
     */
    QbWKB: T;

    /**
     * @default 'Password & Privacy Settings'
     */
    iVub5: T;

    /**
     * @default 'Photos & Default Content'
     */
    vcZ7U: T;

    /**
     * @default 'You don't have a website yet.'
     */
    VI5nm: T;

    /**
     * @default 'Guests won't see any event details when they visit your link. Create your website first, then publish it.'
     */
    CTBDj: T;

    /**
     * @default 'Your website is still being designed.'
     */
    S3e8O: T;

    /**
     * @default 'Guests can't see it yet. Once it's ready, publish it from the website editor.'
     */
    CTbl7: T;

    /**
     * @default 'We couldn't finish your website.'
     */
    '7p731': T;

    /**
     * @default 'Guests can't see it yet. Open the website editor to try again.'
     */
    nE0Mb: T;

    /**
     * @default 'Open Website Editor'
     */
    YQFoq: T;

    /**
     * @default 'Publish Website'
     */
    C04Ki: T;

    /**
     * @default 'Edit Website'
     */
    nH6Xt: T;

    /**
     * @default 'Not Now'
     */
    '10UrU': T;

    /**
     * @default 'Keep the Site Hidden'
     */
    RRW4O: T;

    /**
     * @default 'Publish your site before sharing.'
     */
    Aqnsm: T;

    /**
     * @default 'Your website is hidden from guests right now. Publish it so they can view the event details when they receive your message.'
     */
    A46Hn: T;

    /**
     * @default 'We couldn't confirm your Joy AI Website purchase. Try publishing again in a moment.'
     */
    r8uey: T;

    /**
     * @default '😬 Failed to publish website. Please try again.'
     */
    QWLqh: T;

    /**
     * @default '🥳 Your site has been published.'
     */
    xmHdM: T;

    /**
     * @default 'View Your Site →'
     */
    V6unB: T;

    /**
     * @default 'We couldn't personalize this monogram.'
     */
    ADn5o: T;

    /**
     * @default 'Clear All Photos'
     */
    jX4VB: T;

    /**
     * @default 'Select up to {{0}} photos.'
     */
    '3a8gi': T;

    /**
     * @default 'Select This Design →'
     */
    eRoXw: T;

    /**
     * @default 'Continue Editing →'
     */
    v6o2J: T;

    /**
     * @default 'Connection trouble.'
     */
    tB6VH: T;

    /**
     * @default 'Refresh'
     */
    jQp3e: T;

    /**
     * @default 'Apologies, we weren't able to {{0}} your changes. Please click "{{1}}" to reconnect.'
     */
    RTqJ6: T;

    /**
     * @default 'Apologies, we weren't able to process your changes. Please click "{{0}}" to reconnect.'
     */
    '31L0V': T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default 'Show less'
     */
    '6ZaNB': T;

    /**
     * @default 'Show more'
     */
    ckmNB: T;

    /**
     * @default 'Adjust colors, fonts, and layouts'
     */
    vUXEA: T;

    /**
     * @default 'Swap in different headers and sections'
     */
    OzC6w: T;

    /**
     * @default 'Upload your own custom theme'
     */
    CSMVJ: T;

    /**
     * @default 'Didn't find the exact template?'
     */
    c0EFR: T;

    /**
     * @default 'No worries — our templates are just a starting point.'
     */
    unleg: T;

    /**
     * @default 'Learn more'
     */
    tks4L: T;

    /**
     * @default 'Results for'
     */
    R0Od0: T;

    /**
     * @default 'or'
     */
    '58AAA': T;

    /**
     * @default 'Most Popular Designs'
     */
    ze3mF: T;

    /**
     * @default 'Looking for something we don't have yet?'
     */
    BgFSj: T;

    /**
     * @default 'Let us know'
     */
    s8OuH: T;

    /**
     * @default 'Thousands of Stunning Designs'
     */
    fbmuQ: T;

    /**
     * @default 'Endless design combinations adored by millions of couples.'
     */
    XL9Xu: T;

    /**
     * @default 'Customise to your heart's delight'
     */
    '7zYZT': T;

    /**
     * @default 'Apply custom colors, photo, video or monogram header styles, fonts and art.'
     */
    ShmyE: T;

    /**
     * @default 'Personalized Schedules'
     */
    wajl3: T;

    /**
     * @default 'From the rehearsal dinner to the post-wedding brunch, choose who can see and RSVP to each event.'
     */
    '7cEuR': T;

    /**
     * @default 'Smart RSVP with Tracking'
     */
    PHsQ9: T;

    /**
     * @default 'Keep tabs on who's coming to each event, their meal choices, and more.'
     */
    yv4Tj: T;

    /**
     * @default '{{0}} Wedding Website Template'
     */
    xckLe: T;

    /**
     * @default 'Select This Design'
     */
    yoiPS: T;

    /**
     * @default 'Let us know!'
     */
    dWnm7: T;

    /**
     * @default '🥳 Your site looks awesome! All changes saved!'
     */
    fR0FP: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'More info about {{0}}'
     */
    WaisF: T;

    /**
     * @default 'Site Artwork'
     */
    TiIOC: T;

    /**
     * @default 'Edit {{0}} color'
     */
    tsIGY: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Maps'
     */
    pUEMA: T;

    /**
     * @default 'Effects'
     */
    UQl77: T;

    /**
     * @default 'Guide to Customizing Colors'
     */
    lp17V: T;

    /**
     * @default 'Page Background'
     */
    '52mzX': T;

    /**
     * @default 'The background color for page content. The center panel on desktop, full screen on mobile.'
     */
    soZHt: T;

    /**
     * @default 'The background color for page content.'
     */
    lQKQI: T;

    /**
     * @default 'Page Text'
     */
    KA0tf: T;

    /**
     * @default 'The text color for page content.'
     */
    '6yN5R': T;

    /**
     * @default 'Buttons & Links'
     */
    IjlEQ: T;

    /**
     * @default 'The color for buttons and link text.'
     */
    '4bELV': T;

    /**
     * @default 'Background Behind Art'
     */
    '7TxDJ': T;

    /**
     * @default 'The color behind the website's art section.'
     */
    KWVIt: T;

    /**
     * @default 'The color behind the welcome page.'
     */
    mKYmO: T;

    /**
     * @default 'Text on Art'
     */
    F851y: T;

    /**
     * @default 'The text color in the website's art section. Only visible on phones and smaller screens.'
     */
    m2GAC: T;

    /**
     * @default 'The text color on the welcome page.'
     */
    eqosp: T;

    /**
     * @default 'Photo Palette'
     */
    XVXYp: T;

    /**
     * @default 'Art Palette'
     */
    iCKoF: T;

    /**
     * @default 'Template Colors'
     */
    OUiQA: T;

    /**
     * @default 'Link Preview Image'
     */
    '3o7AO': T;

    /**
     * @default 'Choose the photo that appears when you share your website link in text messages, social posts, or chats.'
     */
    dICDM: T;

    /**
     * @default 'Change Photo'
     */
    oQCed: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Suggested 1200 x 630 pixels'
     */
    mXNDK: T;

    /**
     * @default 'Error uploading photo. Please try again later.'
     */
    yLC80: T;

    /**
     * @default 'Photo uploaded successfully.'
     */
    rCjjD: T;

    /**
     * @default 'This is an experimental feature. Your custom code may not always work as we update the platform.'
     */
    DSNmU: T;

    /**
     * @default 'Add Custom CSS'
     */
    ZIN62: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Single Page Scroll'
     */
    wfBHR: T;

    /**
     * @default 'Split View'
     */
    j6uMY: T;

    /**
     * @default 'Classic Navigation'
     */
    c96Le: T;

    /**
     * @default 'Categories'
     */
    ElZ5Z: T;

    /**
     * @default 'Bold'
     */
    RadKA: T;

    /**
     * @default 'Classic'
     */
    UZCBu: T;

    /**
     * @default 'Cultural'
     */
    '27tDJ': T;

    /**
     * @default 'Destination'
     */
    Su78A: T;

    /**
     * @default 'Floral & Botanical'
     */
    tbZR0: T;

    /**
     * @default 'Metallic'
     */
    rsWwE: T;

    /**
     * @default 'Modern'
     */
    tUSvF: T;

    /**
     * @default 'Monogram'
     */
    ggmVN: T;

    /**
     * @default 'Rustic'
     */
    SUggT: T;

    /**
     * @default 'Seasonal'
     */
    gN0Ey: T;

    /**
     * @default 'Textured'
     */
    jHGVF: T;

    /**
     * @default 'Colors'
     */
    U5cSp: T;

    /**
     * @default 'Red'
     */
    pHYAA: T;

    /**
     * @default 'Orange'
     */
    OFOSL: T;

    /**
     * @default 'Yellow'
     */
    '2xQvk': T;

    /**
     * @default 'Green'
     */
    Fo78F: T;

    /**
     * @default 'Blue'
     */
    YocKA: T;

    /**
     * @default 'Brown'
     */
    gEIkF: T;

    /**
     * @default 'Purple'
     */
    AE6NO: T;

    /**
     * @default 'Pink'
     */
    '2miMA': T;

    /**
     * @default 'Beige'
     */
    SrIiF: T;

    /**
     * @default 'Gray'
     */
    l5OLA: T;

    /**
     * @default 'Black'
     */
    J0JjF: T;

    /**
     * @default 'White'
     */
    BmFPH: T;

    /**
     * @default 'Gold'
     */
    aKOLA: T;

    /**
     * @default 'Rose Gold'
     */
    F912N: T;

    /**
     * @default 'Silver'
     */
    DL8LV: T;

    /**
     * @default 'Photo/Art Style'
     */
    hoSXH: T;

    /**
     * @default 'Art & Typography'
     */
    '4Oo5f': T;

    /**
     * @default 'Single Photo'
     */
    k2lkI: T;

    /**
     * @default 'Multi-photo'
     */
    IJBtx: T;

    /**
     * @default 'Animation'
     */
    i5SX2: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Photo Slider'
     */
    nnLbq: T;

    /**
     * @default 'Photo Marquee'
     */
    gfqWI: T;

    /**
     * @default 'No Animation'
     */
    jp3gB: T;

    /**
     * @default 'Alex & Jordan'
     */
    cbAFR: T;

    /**
     * @default 'Could not update Art Masthead'
     */
    DLRLe: T;

    /**
     * @default 'Load more'
     */
    '5lJ2f': T;

    /**
     * @default 'Start with the photo. We'll design your wedding website around it.'
     */
    MOOTS: T;

    /**
     * @default 'Its colors, its mood, its style — all shape the design. Custom, free, yours in under a minute.'
     */
    m0mnz: T;

    /**
     * @default 'Add Your Photo'
     */
    QVT8f: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Not now'
     */
    '54drU': T;

    /**
     * @default 'Color'
     */
    fmnoF: T;

    /**
     * @default 'Font'
     */
    H0ELA: T;

    /**
     * @default 'Art'
     */
    PaTAA: T;

    /**
     * @default 'Link Preview'
     */
    '4EyVc': T;

    /**
     * @default 'Custom CSS'
     */
    YSgYn: T;

    /**
     * @default 'Templates'
     */
    PwUcN: T;

    /**
     * @default 'Loading CSS editor...'
     */
    '4e1pL': T;

    /**
     * @default 'Your Current Template'
     */
    qAn5v: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Made for You'
     */
    pZnzK: T;

    /**
     * @default 'Animated'
     */
    nET1O: T;

    /**
     * @default 'Select →'
     */
    MJsDQ: T;

    /**
     * @default 'Sorry but your theme is no longer available to preview.'
     */
    U87JE: T;

    /**
     * @default 'Learn Why'
     */
    CwSgI: T;

    /**
     * @default 'Nerd face'
     */
    Ii7B3: T;

    /**
     * @default 'Sparkle'
     */
    EfVrB: T;

    /**
     * @default 'Design controls'
     */
    '2i3i9': T;

    /**
     * @default 'Resize design controls'
     */
    '6Rg3A': T;

    /**
     * @default 'Back to design menu'
     */
    PC4h0: T;

    /**
     * @default 'Expand design controls'
     */
    u2XSM: T;

    /**
     * @default 'Collapse design controls'
     */
    VKo8Y: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Browse Templates'
     */
    Z8sEd: T;

    /**
     * @default 'Change Design'
     */
    Aw2TS: T;

    /**
     * @default 'Gallery View'
     */
    '5fIqQ': T;

    /**
     * @default '2 in a row'
     */
    '2Ebzq': T;

    /**
     * @default '1 in a row'
     */
    R06Om: T;

    /**
     * @default 'Favorites'
     */
    rOPR1: T;

    /**
     * @default 'Reset All Filters'
     */
    bnE3D: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;

    /**
     * @default 'Preview desktop layout'
     */
    '4tDk3': T;

    /**
     * @default 'Preview mobile layout'
     */
    Yokah: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Saving...'
     */
    '60ObM': T;

    /**
     * @default 'Filters, {{0}} active'
     */
    fvSbl: T;

    /**
     * @default 'floral, mocha, whimsical'
     */
    lKaZd: T;

    /**
     * @default 'modern, rustic, elegant'
     */
    v2J2e: T;

    /**
     * @default 'vintage, bold, romantic'
     */
    ul6Ne: T;

    /**
     * @default 'minimalist, classic, boho'
     */
    Lxup2: T;

    /**
     * @default 'Type anything'
     */
    s8065: T;

    /**
     * @default 'Search templates'
     */
    lQS1e: T;

    /**
     * @default 'Clear search'
     */
    Pfjq9: T;

    /**
     * @default 'Popular searches'
     */
    '7VUWQ': T;

    /**
     * @default 'Suggestions'
     */
    JzeyJ: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'Publish Changes'
     */
    Cd49l: T;

    /**
     * @default 'Publishing...'
     */
    X4Uld: T;

    /**
     * @default 'Not seeing your changes on your website? Make sure to apply changes.'
     */
    '5X7D2': T;

    /**
     * @default 'Unpublished'
     */
    F7vbD: T;

    /**
     * @default 'Site Unpublished'
     */
    C5i4q: T;

    /**
     * @default 'View website in a new tab.'
     */
    blTVK: T;

    /**
     * @default 'View current site without your changes.'
     */
    FY2GA: T;

    /**
     * @default 'Nice work! Now, check out your site.'
     */
    hX0Rr: T;

    /**
     * @default 'View Site'
     */
    G17zU: T;

    /**
     * @default 'Map style'
     */
    '3Mq3Q': T;

    /**
     * @default 'Edit map style, currently {{0}}'
     */
    '1Yntv': T;

    /**
     * @default 'Applies to the maps on your schedule and travel pages.'
     */
    fIRrw: T;

    /**
     * @default 'High Contrast'
     */
    QtUpB: T;

    /**
     * @default 'Inverted'
     */
    '105qO': T;

    /**
     * @default 'Blueprint'
     */
    '5sHnj': T;

    /**
     * @default 'Black on White'
     */
    '5Vl1K': T;

    /**
     * @default 'White on Black'
     */
    '9jfZt': T;

    /**
     * @default 'Parchment'
     */
    ueoWm: T;

    /**
     * @default 'Midnight'
     */
    YgdXW: T;

    /**
     * @default 'Sage'
     */
    aV8MA: T;

    /**
     * @default 'Blush'
     */
    '4nPjF': T;

    /**
     * @default 'Standard I'
     */
    UJqEl: T;

    /**
     * @default 'Standard II'
     */
    jMcz8: T;

    /**
     * @default 'Website Colors'
     */
    '35w6D': T;

    /**
     * @default 'Classic Colors'
     */
    '2PZjx': T;

    /**
     * @default 'Failed to copy color to clipboard.'
     */
    N56MU: T;

    /**
     * @default 'Color {{0}} copied to clipboard.'
     */
    QsH4u: T;

    /**
     * @default 'We’ve created a color palette that matches your photo and applied them to your site. You can adjust each element individually.'
     */
    cUaqu: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Current Selection'
     */
    Rmj9W: T;

    /**
     * @default 'Upload Your Own'
     */
    O9lGl: T;

    /**
     * @default 'Graphic Accent'
     */
    uJOr5: T;

    /**
     * @default 'Sorry, there's been an error. Refresh the page.'
     */
    Rq7WI: T;

    /**
     * @default 'Page Layout'
     */
    xN7Hl: T;

    /**
     * @default 'Event Display Name is required.'
     */
    OvJID: T;

    /**
     * @default 'Error saving Event Display Name. Please try again later.'
     */
    MWKAt: T;

    /**
     * @default 'Event Display Name saved successfully.'
     */
    b2sOT: T;

    /**
     * @default 'Event Display Name'
     */
    rZqZK: T;

    /**
     * @default 'Enter your event display name'
     */
    mSBCX: T;

    /**
     * @default 'Error updating your event name. Please try again later.'
     */
    rBFHA: T;

    /**
     * @default 'Event name updated everywhere.'
     */
    '8bysP': T;

    /**
     * @default 'Update your event name everywhere?'
     */
    '05wBI': T;

    /**
     * @default 'Your website header is using your new event name. The rest of your website, guest messages, and link previews are still using: {{0}}.'
     */
    '75mN9': T;

    /**
     * @default 'Replace it with:'
     */
    '19tCj': T;

    /**
     * @default 'Update Everywhere'
     */
    tecf2: T;

    /**
     * @default 'Keep Previous Name'
     */
    V9aGx: T;

    /**
     * @default 'Font Family'
     */
    L3Dyg: T;

    /**
     * @default 'Font Size'
     */
    WGALC: T;

    /**
     * @default 'Could not update header layout. Please try again.'
     */
    BfdYH: T;

    /**
     * @default 'Show Art Masthead'
     */
    xdkxn: T;

    /**
     * @default 'Change Art Masthead'
     */
    kezU4: T;

    /**
     * @default 'Art Masthead'
     */
    UJTWF: T;

    /**
     * @default 'Select Art Masthead'
     */
    EBjGN: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Boardwalk'
     */
    '7egz7': T;

    /**
     * @default 'Bonsoir'
     */
    saF6y: T;

    /**
     * @default 'Charlotte'
     */
    '4Vs76': T;

    /**
     * @default 'Lorange'
     */
    scNO1: T;

    /**
     * @default 'Mirrorball'
     */
    SmIAH: T;

    /**
     * @default 'Regal Garden'
     */
    KzWmH: T;

    /**
     * @default 'Fiore'
     */
    F6p2F: T;

    /**
     * @default 'Maison'
     */
    j0boE: T;

    /**
     * @default 'Top'
     */
    TwYAA: T;

    /**
     * @default 'Center'
     */
    '3xBfo': T;

    /**
     * @default 'Background'
     */
    idoD3: T;

    /**
     * @default 'Apricot'
     */
    Ytvdc: T;

    /**
     * @default 'Lilac'
     */
    '1AgWG': T;

    /**
     * @default 'Moss'
     */
    KUIMA: T;

    /**
     * @default 'Neon'
     */
    '6xOMA': T;

    /**
     * @default 'Rouge'
     */
    ewT1G: T;

    /**
     * @default 'Saffron'
     */
    x56pt: T;

    /**
     * @default 'Sky'
     */
    vcYAA: T;

    /**
     * @default 'Test Tube'
     */
    Uqu9W: T;

    /**
     * @default 'Custom CSS is an experimental feature. We can't guarantee your custom CSS will work indefinitely.'
     */
    QQPCM: T;

    /**
     * @default 'Crafting your templates'
     */
    Y6SuF: T;

    /**
     * @default 'Composing palette'
     */
    UDsoA: T;

    /**
     * @default 'Refining layout'
     */
    yLjPY: T;

    /**
     * @default 'Almost ready'
     */
    xqEFM: T;

    /**
     * @default 'We're getting married!'
     */
    ZC11n: T;

    /**
     * @default 'Seattle, Washington'
     */
    kWYXE: T;

    /**
     * @default 'Saturday, January 1, 2028'
     */
    iLaXw: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Welcome to our function'
     */
    FDZ38: T;

    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'Story'
     */
    LbB7G: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'Start with the photo you love'
     */
    IgU87: T;

    /**
     * @default 'Start with the photo. We'll design
your wedding website around it.'
*/
    '2SozS': T;

    /**
     * @default 'Every design is fully customizable in the Colors tab.'
     */
    SQ7Wu: T;

    /**
     * @default 'We're crafting custom designs that match your photo.'
     */
    z3MwS: T;

    /**
     * @default 'They'll be ready in a moment. You can change or add photos here.'
     */
    PRJXC: T;

    /**
     * @default 'Custom Templates from Your Photo.'
     */
    nhIqt: T;

    /**
     * @default 'The first three designs are crafted for you to match your photo! You can change or add photos.'
     */
    '1VX87': T;

    /**
     * @default 'See Designs'
     */
    i6FrC: T;

    /**
     * @default 'Upload your favorite photo(s) and we'll find templates that feel like they were made for it.'
     */
    kSi4s: T;

    /**
     * @default 'Promotional content'
     */
    zmeK4: T;

    /**
     * @default 'Promotional video'
     */
    DoyuQ: T;

    /**
     * @default 'Split view'
     */
    rGkRY: T;

    /**
     * @default '3 in a row'
     */
    dT5Zv: T;

    /**
     * @default '4 in a row'
     */
    EiZA0: T;

    /**
     * @default 'Could not save changes. Please try again.'
     */
    PxyO2: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Screen Width Photo'
     */
    oncaR: T;

    /**
     * @default 'Page Width Photo'
     */
    DAxkW: T;

    /**
     * @default 'Page Width Photo Slider'
     */
    Ih35H: T;

    /**
     * @default 'Page Width Photo Marquee'
     */
    tLuBV: T;

    /**
     * @default 'Photo Trio'
     */
    '6Dl69': T;

    /**
     * @default 'Page Width Photo Trio'
     */
    pIRnk: T;

    /**
     * @default 'Photo Duo Left'
     */
    LXm91: T;

    /**
     * @default 'Photo Duo Right'
     */
    k0ZSm: T;

    /**
     * @default 'Photo Arch'
     */
    qXt39: T;

    /**
     * @default 'No Photo'
     */
    xXFMz: T;

    /**
     * @default 'Photo Background'
     */
    '8RCjy': T;

    /**
     * @default 'Photo Monogram'
     */
    '0nRQ6': T;

    /**
     * @default 'Video Background'
     */
    FJLTh: T;

    /**
     * @default 'Video Arch'
     */
    '3nVPd': T;

    /**
     * @default 'Video Monogram'
     */
    bw19P: T;

    /**
     * @default 'Show every matching design'
     */
    R6PtU: T;

    /**
     * @default 'Show designs matching {{0}}'
     */
    DDjwx: T;

    /**
     * @default 'Change photo'
     */
    '4oQDg': T;

    /**
     * @default 'Add a photo to find matching designs'
     */
    IqHeP: T;

    /**
     * @default 'No designs match this photo's colors'
     */
    NoaE6: T;

    /**
     * @default 'Show matching designs'
     */
    RaZ9S: T;

    /**
     * @default 'Close graphic accent picker'
     */
    uniRG: T;

    /**
     * @default 'Select a font pack for customization'
     */
    FplAz: T;

    /**
     * @default 'Customize Fonts'
     */
    zfALJ: T;

    /**
     * @default 'Select Font Pack '
     */
    '8DStQ': T;

    /**
     * @default 'Choose from designer-curated font pairings that work beautifully together.'
     */
    r92IH: T;

    /**
     * @default 'Search Fonts'
     */
    SRImk: T;

    /**
     * @default 'Hero Display'
     */
    qvOMu: T;

    /**
     * @default 'Customize Monogram'
     */
    Njpjp: T;

    /**
     * @default 'Layouts'
     */
    rXRuQ: T;

    /**
     * @default 'Editor'
     */
    Vbsrt: T;

    /**
     * @default 'Add {{0}} photos'
     */
    '4ZWJ9': T;

    /**
     * @default 'Add 1 photo'
     */
    en1SJ: T;

    /**
     * @default 'Add {{0}} - {{1}} photos'
     */
    GVWMS: T;

    /**
     * @default 'You must select one photo.'
     */
    aVU2n: T;

    /**
     * @default 'You must select {{0}} photos for the {{1}}.'
     */
    Ex8fI: T;

    /**
     * @default 'You must select 1 photo for the {{0}}.'
     */
    Tuq7j: T;

    /**
     * @default 'You must select {{0}} - {{1}} photos for the {{2}}.'
     */
    pK1Wj: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Recommended Fonts'
     */
    LrkBR: T;

    /**
     * @default 'View All Fonts'
     */
    aUHSa: T;

    /**
     * @default 'More Fonts'
     */
    '7bi6g': T;

    /**
     * @default 'Event Title'
     */
    oQlBP: T;

    /**
     * @default 'Title Position'
     */
    '76UUw': T;

    /**
     * @default 'Title Style'
     */
    v8TWQ: T;

    /**
     * @default 'Navigation'
     */
    avBYb: T;

    /**
     * @default 'Please enter a valid Vimeo or YouTube URL'
     */
    sh6fB: T;

    /**
     * @default 'Please select a placeholder photo'
     */
    UIvJB: T;

    /**
     * @default 'Vimeo or Youtube Link - Desktop View'
     */
    u2LcN: T;

    /**
     * @default 'Vimeo or Youtube Link - Mobile View'
     */
    Gt0WB: T;

    /**
     * @default 'Optional'
     */
    KozAy: T;

    /**
     * @default 'Placeholder Photo'
     */
    Ruqaq: T;

    /**
     * @default 'Video placeholder'
     */
    '0Dn4B': T;

    /**
     * @default 'Change Placeholder'
     */
    nHAUN: T;

    /**
     * @default 'Remove Placeholder'
     */
    XdZgx: T;

    /**
     * @default 'Placeholder photo already selected.'
     */
    iaoZO: T;

    /**
     * @default 'Add Placeholder'
     */
    '2TVFJ': T;

    /**
     * @default 'Save Video'
     */
    '0VpvJ': T;

    /**
     * @default 'Read our video guide'
     */
    dBBbr: T;

    /**
     * @default 'Select a thumbnail photo for your video'
     */
    '21Y8L': T;

    /**
     * @default 'This video may not autoplay on mobile devices. For best results, upload a version without an audio track.'
     */
    vOQKv: T;

    /**
     * @default 'This video could not be loaded for preview. It may not play on your website. Check that embedding is enabled in your Vimeo video settings.'
     */
    TmkGU: T;

    /**
     * @default 'This YouTube video could not be verified. Make sure the video is public and embedding is allowed.'
     */
    RxXe8: T;

    /**
     * @default 'Beautiful Matching Paper Cards from {{0}}'
     */
    P5sPl: T;

    /**
     * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
     */
    Ot4Bq: T;

    /**
     * @default 'Customize on {{0}}'
     */
    eb4vD: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Default stationary banner'
     */
    HFxDO: T;

    /**
     * @default 'Digital Cards to Match Your Wedding Website'
     */
    ZhyQE: T;

    /**
     * @default 'Beautiful Paper & Digital Cards to Match Your Wedding Website'
     */
    w9MBw: T;

    /**
     * @default 'Explore Paper Designs'
     */
    ytXUz: T;

    /**
     * @default 'Explore Digital Designs'
     */
    meqv3: T;

    /**
     * @default 'Event Title is required.'
     */
    Bd6KH: T;

    /**
     * @default 'Enter your event title'
     */
    bJ8Hv: T;

    /**
     * @default 'Text Color'
     */
    QC2EC: T;

    /**
     * @default 'Mobile Text Color'
     */
    k0YSJ: T;

    /**
     * @default 'Show Event Display Name'
     */
    q0yA1: T;

    /**
     * @default 'Event Display Name Color'
     */
    '8odPr': T;

    /**
     * @default 'Monogram Color'
     */
    VFj95: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Glass'
     */
    khC8F: T;

    /**
     * @default 'Glass Effect Background'
     */
    Dgvtp: T;

    /**
     * @default 'Transparent'
     */
    OWUKl: T;

    /**
     * @default 'Transparent Background'
     */
    m8tCk: T;

    /**
     * @default 'Solid'
     */
    NvP6G: T;

    /**
     * @default 'Solid Background'
     */
    XOoWV: T;

    /**
     * @default 'Nav Bar Style'
     */
    FNWro: T;

    /**
     * @default 'Title Background Color'
     */
    fjecn: T;

    /**
     * @default 'Nav Bar Background Color'
     */
    vD8AS: T;

    /**
     * @default 'Adjust text color here if you'd like.'
     */
    hoRpV: T;

    /**
     * @default 'Title Text Color'
     */
    '6uMXD': T;

    /**
     * @default 'Nav Bar Text Color'
     */
    '456sN': T;
  };
};

export type WebsiteEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  topBar: {
    /**
     * @default 'Home'
     */
    home: T;

    /**
     * @default 'Page Settings'
     */
    pageSettings: T;

    /**
     * @default 'New'
     */
    new: T;

    /**
     * @default 'Publish'
     */
    publish: T;

    /**
     * @default 'Publish Changes'
     */
    publishChanges: T;

    /**
     * @default 'Publishing...'
     */
    publishing: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;

    /**
     * @default 'Saving...'
     */
    saving: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Not seeing your changes on your website? Make sure to apply changes.'
     */
    notSeeingChangesMessage: T;

    /**
     * @default 'Nice work! Now, check out your page.'
     */
    niceWork: T;

    /**
     * @default 'View current page without your changes.'
     */
    viewCurrentPage: T;

    /**
     * @default 'View Page'
     */
    viewPage: T;

    visibility: {
      /**
       * @default 'Hidden'
       */
      hidden: T;

      /**
       * @default 'Password Protected'
       */
      protected: T;

      /**
       * @default 'Public'
       */
      visible: T;
    };

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'An error occurred while updating your page. Please try again.'
     */
    updatePageError: T;
  };
  panel: {
    /**
     * @default 'Page Photo'
     */
    pagePhoto: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Add Label'
     */
    addLabel: T;

    /**
     * @default 'View Page'
     */
    viewPage: T;

    /**
     * @default 'Edit Page'
     */
    editPage: T;

    /**
     * @default 'Add Content'
     */
    addContent: T;

    /**
     * @default 'Skip'
     */
    skip: T;
  };
  customPage: {
    /**
     * @default 'An error occurred while creating page container. Please try again.'
     */
    createPageContainerError: T;

    /**
     * @default 'An error occurred while updating page container. Please try again.'
     */
    updatePageContainerError: T;

    /**
     * @default 'An error occurred while creating travelMap component. Please try again.'
     */
    travelMapComponentError: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'An error occurred while updating hotel order. Please try again.'
     */
    changeBlockOrderFailed: T;

    /**
     * @default 'Your Hotel order has been updated.'
     */
    changeBlockOrderSuccess: T;

    /**
     * @default 'An error occurred while updating component order. Please try again.'
     */
    changeComponentOrderFailed: T;

    /**
     * @default 'Your component order has been updated.'
     */
    changeComponentOrderSuccess: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    matchedHotelDialog: {
      /**
       * @default 'High five! Joy already has special group rates at this hotel—save your guests money and skip the manual setup.'
       */
      description: T;

      /**
       * @default 'Save money with Joy's rates'
       */
      saveWithJoy: T;

      /**
       * @default 'No thanks, I'll use my own booking link'
       */
      haveBookingLink: T;

      /**
       * @default 'Starting at'
       */
      startingAt: T;

      /**
       * @default 'An error occurred while saving your hotel. Please try again.'
       */
      submitError: T;

      /**
       * @default 'Success! Hotel details have been saved.'
       */
      savedHotelSuccess: T;
    };
    emptyState: {
      /**
       * @default 'Add hotel recommendations to save guests time and money'
       */
      title: T;

      /**
       * @default 'Give your guests the best rates on hotels close to your venue, available exclusively to the millions of people using Joy.'
       */
      content: T;

      /**
       * @default 'Explore Hotels'
       */
      buttonLabel: T;
    };
    customPageEmptyState: {
      /**
       * @default 'Dive in and start creating.'
       */
      title: T;

      /**
       * @default 'Add your first content block to start crafting your perfect page.'
       */
      content: T;
    };
    addNewPage: {
      /**
       * @default 'Add New Page'
       */
      title: T;

      /**
       * @default 'Name'
       */
      name: T;

      /**
       * @default 'A Memorable Name'
       */
      placeholder: T;

      /**
       * @default 'Create Page'
       */
      createPage: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'An error occurred while creating page. Please try again.'
       */
      addPageError: T;

      /**
       * @default 'Page path unavailable for the entered title. Please choose a different one.'
       */
      pagePathNotAvailable: T;
    };
    deletePage: {
      /**
       * @default 'Are you sure you want to delete this custom page?'
       */
      title: T;

      /**
       * @default 'The contents of this page will be lost. This action can’t be undone.'
       */
      subTitle: T;

      /**
       * @default 'Delete Custom Page'
       */
      deleteCustomPageCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Success! Page has been deleted.'
       */
      deletePageSuccess: T;

      /**
       * @default 'An error occurred while deleting your page. Please try again.'
       */
      deletePageError: T;
    };
    addCustomComponent: {
      /**
       * @default 'Start Creating'
       */
      title: T;

      /**
       * @default 'Add a content block and continue crafting your page.'
       */
      subTitle: T;

      /**
       * @default 'Add your first content block to craft your perfect page.'
       */
      subTitleFirst: T;

      supportedCustomComponents: {
        text: {
          /**
           * @default 'Text'
           */
          title: T;

          /**
           * @default 'Tell your guests what to expect here—make it fun, exciting, and uniquely you.'
           */
          subTitle: T;
        };
        photo: {
          /**
           * @default 'Photo'
           */
          title: T;
        };
        travel: {
          /**
           * @default 'Travel'
           */
          title: T;
        };
        eventCountdown: {
          /**
           * @default 'Event Countdown'
           */
          title: T;
        };
        video: {
          /**
           * @default 'Video'
           */
          title: T;
        };
        graphicAccent: {
          /**
           * @default 'Graphic Accent'
           */
          title: T;
        };
        photoGallery: {
          /**
           * @default 'Photo Gallery'
           */
          title: T;
        };
        eventDetails: {
          /**
           * @default 'Event Details'
           */
          title: T;
        };
        photoBlock: {
          /**
           * @default 'Photo Block'
           */
          title: T;
        };

        /**
         * @default 'Accommodations'
         */
        accommodations: T;
      };
    };
    eventDetails: {
      /**
       * @default 'Event Details'
       */
      title: T;

      /**
       * @default '{{date}}, {{location}}'
       */
      subTitle: T;

      /**
       * @default 'Are you sure you want to delete this event details block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event details have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event details. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Event Details Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event details have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event details. Please try again.'
       */
      saveComponentError: T;

      form: {
        /**
         * @default 'Date'
         */
        dateLabel: T;

        /**
         * @default 'MM/DD/YYYY'
         */
        datePlaceholder: T;

        /**
         * @default 'Please re-enter the date in MM/DD/YYYY format'
         */
        dateError: T;

        /**
         * @default 'Location'
         */
        locationLabel: T;

        /**
         * @default 'San Francisco, CA'
         */
        locationPlaceholder: T;

        /**
         * @default 'Pick a place, any place. You can always change it.'
         */
        locationError: T;
      };
    };
    graphicAccent: {
      /**
       * @default 'Graphic Accent'
       */
      title: T;

      /**
       * @default 'Are you sure you want to delete this graphic accent block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Graphic accent have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your graphic accent. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Graphic Accent Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Graphic accent have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your graphic accent. Please try again.'
       */
      saveComponentError: T;
    };
    eventDisplayName: {
      /**
       * @default 'Event Display Name'
       */
      title: T;

      /**
       * @default 'Are you sure you want to delete this event details block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event details have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event details. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Event Details Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event details have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event details. Please try again.'
       */
      saveComponentError: T;

      form: {
        /**
         * @default 'Your Event Display Name'
         */
        displayNameLabel: T;

        /**
         * @default 'Enter your event display name'
         */
        displayNamePlaceholder: T;

        /**
         * @default 'Event Display Name is required.'
         */
        displayNameRequired: T;
      };
    };
    jsonBlobComponent: {
      form: {
        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Delete Section'
         */
        deleteCta: T;

        /**
         * @default 'Are you sure you want to delete this section?'
         */
        deleteTitle: T;

        /**
         * @default 'The contents of this section will be lost. This action can’t be undone.'
         */
        deleteSubtitle: T;

        /**
         * @default 'Success! Section has been deleted.'
         */
        deleteComponentSuccess: T;

        /**
         * @default 'An error occurred while deleting this section. Please try again.'
         */
        deleteComponentError: T;
      };
    };
    richText: {
      form: {
        /**
         * @default 'Please enter a text.'
         */
        textRequiredError: T;

        /**
         * @default 'Share a great story with your guests'
         */
        placeholder: T;

        /**
         * @default 'Save'
         */
        saveCta: T;

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Success! Text has been saved.'
         */
        saveComponentSuccess: T;

        /**
         * @default 'An error occurred while saving your text. Please try again.'
         */
        saveComponentError: T;

        /**
         * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
         */
        saveComponentLimitError: T;

        /**
         * @default 'Delete Text Block'
         */
        deleteCta: T;

        /**
         * @default 'Are you sure you want to delete this text block?'
         */
        deleteTitle: T;

        /**
         * @default 'The contents of this section will be lost. This action can’t be undone.'
         */
        deleteSubtitle: T;

        /**
         * @default 'Success! Text has been deleted.'
         */
        deleteComponentSuccess: T;

        /**
         * @default 'An error occurred while deleting your text. Please try again.'
         */
        deleteComponentError: T;

        /**
         * @default 'Insert'
         */
        insert: T;

        /**
         * @default 'Update'
         */
        update: T;

        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'Text'
         */
        text: T;

        /**
         * @default 'https://'
         */
        linkPlaceholder: T;

        /**
         * @default 'Unlink'
         */
        unlink: T;

        /**
         * @default 'Inserting...'
         */
        inserting: T;

        /**
         * @default 'Updating...'
         */
        updating: T;
      };
    };
    photo: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Add Your Photo'
       */
      addTitle: T;

      /**
       * @default 'We support jpeg and PNG images.'
       */
      addSubtitle: T;

      /**
       * @default 'Upload Photo'
       */
      addCta: T;

      /**
       * @default 'Replace Photo'
       */
      replaceCta: T;

      /**
       * @default 'Delete Photo Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Photo have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your photo. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this photo block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo has been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Photo'
       */
      photoCardHeader: T;
    };
    eventCountdown: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Event Countdown'
       */
      title: T;

      /**
       * @default 'Add Your Event Countdown'
       */
      addTitle: T;

      /**
       * @default 'Delete Event Countdown Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event Countdown have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event countdown. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this event countdown block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event Countdown have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event countdown. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Display event countdown'
       */
      displayEventCountdown: T;

      /**
       * @default 'Countdown to your {{eventName}} for {{date}}. You can edit event times in your'
       */
      displayCountdownNoteWithEvent: T;

      /**
       * @default 'Countdown to {{date}}.'
       */
      displayCountdownNoteWithoutEvent: T;

      /**
       * @default 'Schedule.'
       */
      schedule: T;

      /**
       * @default 'Schedule Event'
       */
      scheduleEvent: T;

      /**
       * @default 'Add an event to your schedule to customize'
       */
      scheduleEmptyPlaceholder: T;

      /**
       * @default 'Select...'
       */
      scheduleNotSelectedPlaceholder: T;
    };
    video: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Video URL'
       */
      videoUrlLabel: T;

      /**
       * @default 'Video Caption'
       */
      captionLabel: T;

      /**
       * @default 'Delete Video Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Video has been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your video. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this video block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Video has been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your video. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Please enter a valid video URL.'
       */
      formInvalidError: T;

      helpDialog: {
        /**
         * @default 'Adding a Video'
         */
        title: T;

        /**
         * @default 'Add a video to your website using a share link (URL) from Youtube or Vimeo. For the best quality, use Vimeo.'
         */
        description: T;

        /**
         * @default 'Got It'
         */
        cta: T;
      };

      /**
       * @default 'Video'
       */
      videoCardHeader: T;
    };
    photoGallery: {
      /**
       * @default 'Create Album'
       */
      createAlbum: T;

      /**
       * @default 'Select Album'
       */
      selectAlbum: T;

      /**
       * @default 'All your albums will appear here.'
       */
      selectAlbumSubText: T;

      /**
       * @default 'Photo'
       */
      photo: T;

      /**
       * @default 'Photos'
       */
      photos: T;

      /**
       * @default 'Success! Photo Gallery have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your photo gallery. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this photo gallery block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo Gallery have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo gallery. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Delete Photo Gallery Block'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Public'
       */
      public: T;

      /**
       * @default 'Hidden'
       */
      hidden: T;

      /**
       * @default 'Edit Album'
       */
      editAlbum: T;

      /**
       * @default 'Photo Gallery'
       */
      photoGalleryCardHeader: T;
    };
    photoBlock: {
      /**
       * @default 'Photo Block'
       */
      photoBlock: T;

      /**
       * @default 'Header Layout'
       */
      headerLayout: T;

      /**
       * @default 'Create Album'
       */
      createAlbum: T;

      /**
       * @default 'Select Album'
       */
      selectAlbum: T;

      /**
       * @default 'All your albums will appear here.'
       */
      selectAlbumSubText: T;

      /**
       * @default 'Add Photos'
       */
      addPhotos: T;

      /**
       * @default 'Photo Selection ({{countRange}} required)'
       */
      photoSelectionCount: T;

      /**
       * @default 'You must select {{countRange}} for the {{layout}}.'
       */
      photoSelectionHelperText: T;

      /**
       * @default 'You must select one photo.'
       */
      singlePhotoSelectionHelperText: T;

      /**
       * @default 'Remove Photo'
       */
      removePhoto: T;

      /**
       * @default 'Swap Photo'
       */
      swapPhoto: T;

      /**
       * @default 'Are you sure you want to delete this photo block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo Block have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo block. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Delete Photo Block'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Animated'
       */
      animated: T;

      /**
       * @default 'Continue'
       */
      continue: T;

      /**
       * @default 'Header - {{layout}}'
       */
      photoBlockCardHeader: T;

      photoPresentationLayouts: {
        /**
         * @default 'Screen Width Photo'
         */
        fullWidth: T;

        /**
         * @default 'Page Width Photo'
         */
        pageWidth: T;

        /**
         * @default 'Photo'
         */
        center: T;

        /**
         * @default 'Photo Slider'
         */
        photoSlider: T;

        /**
         * @default 'Photo Marquee'
         */
        photoMarquee: T;

        /**
         * @default 'Photo Trio'
         */
        photoTrio: T;

        /**
         * @default 'Page Width Photo Trio'
         */
        photoTrioPageWidth: T;

        /**
         * @default 'Photo Duo Left'
         */
        photoDuoLeft: T;

        /**
         * @default 'Photo Duo Right'
         */
        photoDuoRight: T;

        /**
         * @default 'Photo Arch'
         */
        photoArch: T;

        /**
         * @default 'No Photo'
         */
        noPhoto: T;

        /**
         * @default 'Monogram'
         */
        monogram: T;

        /**
         * @default 'Photo Background'
         */
        photoBackground: T;

        /**
         * @default 'Video Background'
         */
        videoBackground: T;
      };
    };
    greetingMessage: {
      /**
       * @default 'Greeting Message'
       */
      title: T;

      form: {
        /**
         * @default 'We can't wait to share our special day with you. Help us capture our wedding with Joy.'
         */
        greetingMessagePlaceholder: T;
      };
    };
    itemTypes: {
      travelMapVenue: {
        title: {
          /**
           * @default 'Add Venue'
           */
          add: T;

          /**
           * @default 'Venue'
           */
          edit: T;
        };

        /**
         * @default 'Your event location.'
         */
        subTitle: T;
      };
      travelMapHotels: {
        title: {
          /**
           * @default 'Add Hotel Room Block'
           */
          add: T;

          /**
           * @default 'Hotel Room Block'
           */
          edit: T;

          /**
           * @default 'Delete Hotel Room Block'
           */
          deleteCta: T;

          /**
           * @default 'Cancel Room Block'
           */
          cancelCta: T;
        };

        /**
         * @default 'Your reserved room block.'
         */
        subTitle: T;
      };
      travelMapAccommodationsCustom: {
        title: {
          /**
           * @default 'Add Custom Property'
           */
          add: T;

          /**
           * @default 'Add your own stay'
           */
          addV2: T;

          /**
           * @default 'Edit Hotel Link'
           */
          editV2: T;

          /**
           * @default 'Custom Property'
           */
          edit: T;

          /**
           * @default 'Delete Custom Property'
           */
          deleteCta: T;
        };
        list: {
          /**
           * @default 'Custom Property'
           */
          title: T;

          /**
           * @default 'Existing Room Blocks, homes, and other unique stays.'
           */
          subtitle: T;
        };
        listV2: {
          /**
           * @default 'Other'
           */
          title: T;

          /**
           * @default 'Add custom link. From a rental home to a campsite to an existing room block.'
           */
          subtitle: T;
        };

        /**
         * @default 'Share an existing room block, homes or other unique stays.'
         */
        subTitle: T;

        /**
         * @default 'Add an existing room block, homes or other unique stays link to your page.'
         */
        subTitleV2: T;
      };
      travelMapAccommodationsGetRoomBlock: {
        listV2: {
          /**
           * @default 'Get Hotel Room Blocks'
           */
          title: T;

          /**
           * @default 'Work with your Joy concierge to get the best room block rates for you and your guests.'
           */
          subtitle: T;
        };
      };
      travelMapAccommodationsHotel: {
        title: {
          /**
           * @default 'Add Hotel'
           */
          add: T;

          /**
           * @default 'Hotel'
           */
          edit: T;

          /**
           * @default 'Edit Hotel'
           */
          editHotel: T;

          /**
           * @default 'Delete Hotel'
           */
          deleteCta: T;
        };
        list: {
          /**
           * @default 'Hotel'
           */
          title: T;

          /**
           * @default 'Share a hotel with your guests.'
           */
          subtitle: T;
        };
        listV2: {
          /**
           * @default 'Add Hotel'
           */
          title: T;

          /**
           * @default 'Add hotels to your page. Need more options? Explore nearby hotels with top discounts.'
           */
          subtitle: T;
        };

        /**
         * @default 'Share a hotel with your guests.'
         */
        subTitle: T;

        starRatingTooltip: {
          /**
           * @default 'Star ratings show hotel quality, not reviews. '
           */
          title: T;

          /**
           * @default 'More stars = fancier place with better service and amenities.'
           */
          content: T;
        };

        /**
         * @default '{{miles}} mi from venue'
         */
        milesFromVenue: T;

        editHotelTooltip: {
          /**
           * @default 'How Guest See It'
           */
          title: T;

          /**
           * @default 'Edit how this hotel is shown to guests on your website. Choose the cover photo, let guests know where you’re staying and write a personal note why you’re recommending it.'
           */
          content: T;
        };
      };
      travelMapAccommodationsRoomblock: {
        title: {
          /**
           * @default 'Add Hotel Room Block'
           */
          add: T;

          /**
           * @default 'Hotel Room Block'
           */
          edit: T;

          /**
           * @default 'Delete Hotel Room Block'
           */
          deleteCta: T;

          /**
           * @default 'Cancel Room Block'
           */
          cancelCta: T;
        };

        /**
         * @default 'Your reserved room block.'
         */
        subTitle: T;
      };
    };
    travelMap: {
      feedback: {
        /**
         * @default 'How'd we do with our recommendations?'
         */
        howDidWeDo: T;

        /**
         * @default 'What could we do better?'
         */
        whatCouldWeDoBetter: T;

        /**
         * @default 'Send Feedback'
         */
        sendFeedback: T;

        /**
         * @default 'Start typing...'
         */
        startTyping: T;
      };

      /**
       * @default 'Your Venue Details'
       */
      yourVenueDetails: T;

      venue: {
        /**
         * @default 'Your Venue'
         */
        title: T;

        /**
         * @default 'Add Venue'
         */
        addVenue: T;

        addEditForm: {
          /**
           * @default 'Success! Venue details have been saved.'
           */
          submitSuccess: T;

          /**
           * @default 'An error occurred while saving your venue. Please try again.'
           */
          submitError: T;

          /**
           * @default 'An error occurred while deleting your venue. Please try again.'
           */
          deleteError: T;

          form: {
            /**
             * @default 'Venue'
             */
            venue: T;

            /**
             * @default 'Latitude'
             */
            latitude: T;

            /**
             * @default 'Longitude'
             */
            longitude: T;

            /**
             * @default '-34.5628781'
             */
            latitudePlaceholder: T;

            /**
             * @default '-58.4600246'
             */
            longitudePlaceholder: T;

            /**
             * @default 'Please enter a venue.'
             */
            venueError: T;

            /**
             * @default 'Please enter a valid latitude.'
             */
            latitudeError: T;

            /**
             * @default 'Please enter a valid longitude.'
             */
            longitudeError: T;

            /**
             * @default 'Please enter a valid latitude.'
             */
            latitudeTypeError: T;

            /**
             * @default 'Please enter a valid longitude.'
             */
            longitudeTypeError: T;
          };
        };
        eventVenueDialog: {
          searchPlaceholders: [
            /**
             * @default 'San Francisco City Hall'
             */
            T,
            /**
             * @default 'Martoca Beach Garden, Mexico'
             */
            T,
            /**
             * @default 'Bathers Pavilion, Balmoral Beach, Sydney'
             */
            T,
            /**
             * @default 'Heritage Hall, Vancouver, Canada'
             */
            T,
            /**
             * @default 'Amadeus, Maida Vale, London'
             */
            T,
            /**
             * @default 'Garfield Park Conservatory, Chicago'
             */
            T,
            /**
             * @default 'The Grove, Houston'
             */
            T,
            /**
             * @default 'The Plaza Hotel, New York City'
             */
            T,
          ];
          createVenue: {
            /**
             * @default 'Add your venue'
             */
            title: T;

            /**
             * @default 'We’ll use this to personalize your guest website experience with maps, directions, things-to-do, nearby hotel picks and more.'
             */
            message: T;

            /**
             * @default 'Save Venue'
             */
            cta: T;

            /**
             * @default 'Event Venue or Destination'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          updateVenue: {
            /**
             * @default 'Update your venue'
             */
            title: T;

            /**
             * @default 'Changing your venue location will update wherever it’s used. I.e. if you’ve already added hotels, distance and driving directions will be updated to this new location. '
             */
            message: T;

            /**
             * @default 'Update Venue'
             */
            cta: T;

            /**
             * @default 'Event Venue'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          confirmVenue: {
            /**
             * @default 'Confirm your venue'
             */
            title: T;

            /**
             * @default 'Let’s make sure your venue is up-to-date. Easily include venue details on your website. Get personalized guest travel itineraries near your event that you can customize.'
             */
            message: T;

            /**
             * @default 'Looks Good'
             */
            cta: T;

            /**
             * @default 'Event Venue'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          createdVenue: {
            /**
             * @default 'Do you think your guests might need a hotel nearby?'
             */
            title: T;

            /**
             * @default 'Whether your guests are travelling from out of town, or just want a quick walk home after the night of fun.'
             */
            message: T;

            /**
             * @default 'Yes, they might'
             */
            cta: T;

            /**
             * @default 'Probably not'
             */
            cta2: T;
          };
          filters: {
            /**
             * @default 'Select your preferences to get personalized recommendations'
             */
            title: T;

            /**
             * @default 'Show Recommended Hotels'
             */
            cta: T;
          };
          results: {
            /**
             * @default 'We curated the best of 5,000 Joy hotels, chosen for your guests.'
             */
            title: T;

            /**
             * @default 'Preview Page'
             */
            previewPage: T;

            /**
             * @default 'Browse 5,000 More Stays'
             */
            browseMoreStays: T;

            hotelCard: {
              /**
               * @default '{{price}} / night'
               */
              price: T;

              /**
               * @default '{{percentage}}% off'
               */
              percentageOff: T;

              /**
               * @default '{{min}} min'
               */
              travelTime: T;

              /**
               * @default '{{miles}} mi'
               */
              distance: T;

              /**
               * @default 'Highest discount'
               */
              highestDiscount: T;

              /**
               * @default 'Picked by {{count}}+ Joy couples'
               */
              pickedBy: T;

              /**
               * @default '{{miles}} mi to your venue'
               */
              toVenue: T;

              /**
               * @default 'Added'
               */
              added: T;
            };
          };
        };
        venueAutoPopulateLoadingState: {
          /**
           * @default 'We’ve found {{populatedHotels}} hotels offering special rates near your venue!  🎉'
           */
          title: T;

          /**
           * @default 'We searched thousands of places to stay near your venue. Based on the last 10 years of weddings in your area, we’ve optimized for distance, price, and rating. Add and remove hotels to make it your own.'
           */
          message: T;

          /**
           * @default 'Reveal Hotel Picks'
           */
          cta: T;

          messages: [
            /**
             * @default 'Finding the best deals for your guests. 🙏'
             */
            T,
            /**
             * @default 'Making sure the rooms are nice. 💅'
             */
            T,
            /**
             * @default 'Calculating walking time and driving distance… 🏃‍♀️'
             */
            T,
            /**
             * @default 'Because who doesn’t love a lil’ stroll after the party?'
             */
            T,
          ];
        };
        venueAutoPopulateLoadingEmptyState: {
          /**
           * @default 'We are having trouble finding hotel rates near your venue.'
           */
          title: T;

          /**
           * @default 'You’re welcome to add any place you want, manually.'
           */
          message: T;

          /**
           * @default 'Add a Place to Stay'
           */
          cta: T;
        };
      };
      guestHotelBookings: {
        /**
         * @default 'Booked on {{month}} {{day}}, {{year}} at {{time}}'
         */
        bookedOn: T;

        /**
         * @default '{{checkInMonth}} {{checkInDay}} — {{checkOutMonth}} {{checkOutDay}}'
         */
        dateRange: T;

        /**
         * @default '{{value}}'
         */
        translateValue: T;

        featureDialog: {
          /**
           * @default 'Track Guest Hotel Bookings'
           */
          title: T;

          /**
           * @default ' When you use Joy Hotels, your guests get access to exclusive closed user group rates and you get to see where everyone’s staying. We’ll notify you when a guest books, and you can view all bookings here to help with planning.'
           */
          message: T;

          /**
           * @default 'Got it'
           */
          gotIt: T;

          /**
           * @default 'New'
           */
          new: T;
        };

        /**
         * @default '{{firstName}} {{lastName}}'
         */
        guestName: T;

        /**
         * @default '{{distance}} from venue'
         */
        distanceFromVenue: T;
      };
      hotel: {
        /**
         * @default 'Solid'
         */
        solid: T;

        /**
         * @default 'Luxe'
         */
        luxe: T;

        /**
         * @default '{{rooms}} rooms'
         */
        rooms: T;

        /**
         * @default '{{groupDiscount}}% Group Discount'
         */
        groupDiscount: T;

        /**
         * @default 'and more'
         */
        andMore: T;

        /**
         * @default 'Group Rate ({{noOfRooms}} Rooms)'
         */
        groupRateRooms: T;

        /**
         * @default 'Rooms starting from'
         */
        roomsStartingFrom: T;

        /**
         * @default 'Standard Price'
         */
        standardPrice: T;

        /**
         * @default 'Edit'
         */
        editStay: T;

        /**
         * @default 'Remove'
         */
        remove: T;

        /**
         * @default 'Hotels'
         */
        hotels: T;

        /**
         * @default 'Places to Stay'
         */
        placesToStay: T;

        /**
         * @default 'Accommodations'
         */
        accommodations: T;

        /**
         * @default 'Share the perfect stay with your guests.'
         */
        noHotelsAdded: T;

        /**
         * @default 'Deal ends:'
         */
        dealends: T;

        /**
         * @default 'Group Rate ({noOfRooms})'
         */
        groupRate: T;

        /**
         * @default 'Add Hotel'
         */
        addHotelCta: T;

        /**
         * @default 'Add Stay'
         */
        addStayCta: T;

        /**
         * @default 'Add Place to Stay'
         */
        addPlaceToStay: T;

        /**
         * @default 'Search and add more hotels at any time.'
         */
        fabTooltip: T;

        /**
         * @default 'Add hotels, room blocks or custom links'
         */
        addStaySubtitle: T;

        /**
         * @default 'SUPER ADMIN ONLY'
         */
        superAdminOnly: T;

        /**
         * @default 'Room Block'
         */
        labelRoomblock: T;

        /**
         * @default '{{percentage}}% off'
         */
        percentageOff: T;

        /**
         * @default 'Favorite'
         */
        labelFavorite: T;

        /**
         * @default 'Manage Your Hotels'
         */
        manageYourHotels: T;

        /**
     * @default 'You can’t drag an item 
 above your preferred hotel.'
*/
        changeOrderInfo: T;

        /**
         * @default 'Book by'
         */
        bookBy: T;

        /**
         * @default 'Explore'
         */
        explore: T;

        /**
         * @default 'By'
         */
        by: T;

        addEditForm: {
          /**
           * @default 'Use My Own Booking Link'
           */
          updateLink: T;

          /**
           * @default 'ZentrumHub ID'
           */
          zhId: T;

          /**
           * @default 'ZentrumHub ID (Super Admin Only)'
           */
          zhIdLabel: T;

          /**
           * @default '+1-555-555-5555'
           */
          phonePlaceholder: T;

          /**
           * @default 'Phone'
           */
          phone: T;

          /**
           * @default 'Add Hotel'
           */
          addHotel: T;

          /**
           * @default 'Hotel Photo'
           */
          hotelPhoto: T;

          /**
           * @default 'Add Hotel Photo'
           */
          addHotelPhoto: T;

          /**
           * @default 'Add Photo'
           */
          addPhoto: T;

          /**
           * @default 'Edit Photo'
           */
          editPhoto: T;

          /**
           * @default 'Edit Hotel'
           */
          editHotel: T;

          /**
           * @default 'Delete Hotel'
           */
          deleteCta: T;

          /**
           * @default 'Mark as favorite hotel'
           */
          markAsFavoriteHotel: T;

          /**
           * @default 'We're sorry, we're having trouble generating a prompt. Try again'
           */
          promptError: T;

          /**
           * @default 'Latitude'
           */
          latitude: T;

          /**
           * @default 'Longitude'
           */
          longitude: T;

          /**
           * @default 'Star Rating'
           */
          starRating: T;

          /**
           * @default 'Check in'
           */
          checkIn: T;

          /**
           * @default 'Check out'
           */
          checkOut: T;

          /**
           * @default 'Cutoff Date'
           */
          cutoffDate: T;

          /**
           * @default 'Initial Price'
           */
          initialPrice: T;

          /**
           * @default 'Joy Price'
           */
          joyPrice: T;

          /**
           * @default 'Hotel Note'
           */
          hotelNote: T;

          /**
           * @default 'Save'
           */
          saveCta: T;

          /**
           * @default 'Cancel'
           */
          cancelCta: T;

          /**
           * @default 'Search for hotels'
           */
          namePlaceholder: T;

          /**
           * @default '-34.5628781'
           */
          latitudePlaceholder: T;

          /**
           * @default '-58.4600246'
           */
          longitudePlaceholder: T;

          /**
           * @default 'www.hotel.com/mywedding'
           */
          bookingLinkPlaceholder: T;

          /**
           * @default '4.5'
           */
          starRatingPlaceholder: T;

          /**
           * @default '20'
           */
          numberOfRoomsPlaceholder: T;

          /**
           * @default '400'
           */
          initialPricePlaceholder: T;

          /**
           * @default '200'
           */
          joyPricePlaceholder: T;

          /**
           * @default 'Please add a hotel photo.'
           */
          photoError: T;

          /**
           * @default 'Please add a hotel booking link.'
           */
          bookingLinkError: T;

          /**
           * @default 'Please add a check in date.'
           */
          checkInDateError: T;

          /**
           * @default 'Please add a check out date.'
           */
          checkOutDateError: T;

          /**
           * @default 'Check in date must be before check out date'
           */
          checkInDateRangeError: T;

          /**
           * @default 'Check out date must be after check in date'
           */
          checkOutDateRangeError: T;

          /**
           * @default 'Please add cutoff date.'
           */
          cutoffDateError: T;

          /**
           * @default 'Please add the Initial price for the hotel.'
           */
          initialPriceError: T;

          /**
           * @default 'Please enter the valid Initial price for the hotel.'
           */
          initialPriceTypeError: T;

          /**
           * @default 'Please add price per night.'
           */
          joyPriceError: T;

          /**
           * @default 'Please enter the valid Joy price for the hotel.'
           */
          joyPriceTypeError: T;

          /**
           * @default 'Please enter a valid latitude.'
           */
          latitudeTypeError: T;

          /**
           * @default 'Please enter a valid longitude.'
           */
          longitudeTypeError: T;

          /**
           * @default 'Please enter a valid star rating.'
           */
          starRatingTypeError: T;

          /**
           * @default 'An error occurred while saving your hotel. Please try again.'
           */
          submitError: T;

          /**
           * @default 'An error occurred while deleting your hotel. Please try again.'
           */
          deleteError: T;

          /**
           * @default 'User not submitted hotel room blocks request.'
           */
          hotelRoomBlocksError: T;

          /**
           * @default 'Success! Hotel details have been saved.'
           */
          savedHotelSuccess: T;

          /**
           * @default 'Please enter the number of rooms reserved.'
           */
          numberOfRoomsReservedError: T;

          /**
           * @default 'Please enter a valid number of rooms reserved.'
           */
          numberOfRoomsReservedTypeError: T;

          /**
           * @default 'An error occurred while saving your photo. Please try again.'
           */
          photoSaveError: T;

          thumbnail: {
            /**
             * @default 'Thumbnail'
             */
            title: T;

            tooltip: {
              /**
               * @default 'Thumbnail'
               */
              title: T;

              /**
               * @default 'This is a preview of how this hotel will be displayed on your website. Guests click on this to view more details and book from your website.'
               */
              content: T;
            };
          };
          spotlight: {
            /**
             * @default 'Spotlight'
             */
            title: T;

            /**
             * @default 'Pick one hotel that will be displayed at the top of the list.'
             */
            sideNote: T;

            tooltip: {
              /**
               * @default 'Mark as Spotlight'
               */
              title: T;

              /**
               * @default 'Marking a hotel as a favorite lets guests know you prefer them to book here. Your hotel will show a “favorites” badge on the link.'
               */
              content: T;
            };
          };
          isJoyManagedRoomBlock: {
            /**
             * @default 'Joy Hotel Room Block'
             */
            title: T;

            tooltip: {
              /**
               * @default 'Joy Hotel Room Block'
               */
              title: T;

              /**
               * @default 'Please check this only if this is a Joy room block that the host got through Joy.'
               */
              content: T;
            };
          };
          coupleNote: {
            /**
             * @default 'Why It’s Your Pick'
             */
            title: T;

            /**
             * @default 'Suggest'
             */
            suggest: T;

            tooltip: {
              /**
               * @default 'Tell Guests Why'
               */
              title: T;

              /**
               * @default 'Write a note to guest why you picked this hotel. Let me know any details you might want to share.'
               */
              content: T;
            };
          };

          /**
           * @default 'About this property'
           */
          aboutThisProperty: T;
        };
      };
      leadState: {
        comingSoon: {
          /**
           * @default 'Coming Soon'
           */
          eyebrowTitle: T;

          /**
           * @default 'Joy's Free Hotel Concierge Service'
           */
          title: T;

          /**
           * @default 'Add courtesy blocks at discounted rates and zero deposit requirements with our free hotel concierge service.'
           */
          message: T;

          /**
           * @default 'I'm Interested'
           */
          cta: T;

          /**
           * @default 'Interest Confirmed!'
           */
          toastMessage: T;
        };
        pitch: {
          /**
           * @default 'Introducing Joy Room Blocks'
           */
          eyebrowTitle: T;

          /**
           * @default 'Get discounted rates for you and your guests.'
           */
          title: T;

          /**
           * @default 'Let our concierge team call hotels on your behalf and unlock all the benefits below so that you can focus on what matters most.'
           */
          message: T;

          /**
           * @default 'Get Started'
           */
          cta: T;

          /**
           * @default 'Save up to 30% off room rates'
           */
          valuePropOneTitle: T;

          /**
           * @default 'Enjoy exclusive group rate discounts with your favorite hotels and resorts.'
           */
          valuePropOneDescription: T;

          /**
           * @default 'No Financial Commitments'
           */
          valuePropTwoTitle: T;

          /**
           * @default 'We’ll take on the risk—that means no cancelation fees if your hotel room blocks aren’t fully booked.'
           */
          valuePropTwoDescription: T;

          /**
           * @default 'Perks'
           */
          valuePropThreeTitle: T;

          /**
           * @default 'From bridal suite upgrades and spa experiences, to in‑room amenities for you and your guests.'
           */
          valuePropThreeDescription: T;

          /**
           * @default 'Dedicated Concierge Team'
           */
          valuePropFourTitle: T;

          /**
           * @default 'Your personal hotel consultant can help  book rooms, and answer all your questions before your event.'
           */
          valuePropFourDescription: T;
        };
        inProgress: {
          /**
           * @default 'Your room blocks request is being processed.'
           */
          title: T;

          /**
           * @default 'The typical request takes 6 days. We'll send you an email when your rates are ready.'
           */
          text: T;

          /**
           * @default 'Once you receive your booking link, we'll populate this page with your hotels and help you share your room block with guests.'
           */
          subText: T;

          /**
           * @default 'View Hotel Request'
           */
          cta: T;
        };
        getAccommodations: {
          /**
           * @default 'Your hotels will soon be visible in your accommodations page.'
           */
          title: T;

          /**
           * @default 'If you have questions please contact our concierge team.'
           */
          subtext: T;

          /**
           * @default 'Manage Hotel Request'
           */
          cta: T;
        };
        adminAccommodations: {
          /**
           * @default 'To update your hotels and venue content, please contact our concierge team.'
           */
          message: T;

          /**
           * @default 'Contact Concierge'
           */
          contactCta: T;

          /**
           * @default 'Manage Room Blocks'
           */
          manageCta: T;
        };
      };
      leadStateV2: {
        getAccommodations: {
          /**
           * @default 'Unlock exclusive group rates with our free hotel concierge service.'
           */
          title: T;

          /**
           * @default 'We’ll show you which hotels couples and guests consistently choose and negotiate exclusive rates on your behalf.'
           */
          subText: T;

          /**
           * @default 'Get Started'
           */
          cta: T;
        };
        inProgress: {
          /**
           * @default 'Your room blocks request is being processed.'
           */
          title: T;

          /**
           * @default 'The typical request takes 6 days. We'll send you an email when your rates are ready.'
           */
          subText: T;

          /**
           * @default 'View Hotel Request'
           */
          cta: T;
        };
      };
      updateRoomBlockMessage: {
        /**
         * @default 'To update your hotels and venue content, please contact our concierge team.'
         */
        message: T;

        /**
         * @default 'Contact Concierge'
         */
        contactCta: T;

        /**
         * @default 'Manage Room Blocks'
         */
        manageCta: T;
      };
      updateExploreCTA: {
        /**
         * @default 'Explore Other Options'
         */
        label: T;

        /**
         * @default 'Success! 'Explore Other Options' has been updated.'
         */
        successMessage: T;

        /**
         * @default 'An error occurred while updating. Please try again.'
         */
        failedMessage: T;
      };
      ourPicks: {
        /**
         * @default 'How did we pick these hotels?'
         */
        title: T;

        picks: [
          {
            /**
             * @default 'Amazing Exclusive Rates'
             */
            title: T;

            /**
             * @default 'We help MILLIONS of guests each year, giving you access to cheaper group rates than Expedia—up to 40% off per night!'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Something for Everyone'
             */
            title: T;

            /**
             * @default 'A range of price points that include hotels with the best event-friendly amenities.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Close to Your Venue'
             */
            title: T;

            /**
             * @default 'Balancing travel time and distance, we’ve picked the most popular and conveniently located hotels near your event.'
             */
            subTitle: T;
          },
        ];
      };
    };
    delete: {
      /**
       * @default 'Are you sure you want to delete this item?'
       */
      title: T;

      /**
       * @default 'This cannot be undone.'
       */
      message: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      travelMapVenue: {
        /**
         * @default 'Delete Venue'
         */
        deleteCta: T;
      };
      travelMapHotels: {
        /**
         * @default 'Delete Hotel'
         */
        deleteCta: T;
      };
      travelMapAccommodationsHotel: {
        /**
         * @default 'Delete Accommodation'
         */
        deleteCta: T;
      };
      travelMapAccommodationsCustom: {
        /**
         * @default 'Delete Custom Property'
         */
        deleteCta: T;
      };
      travelMapAccommodationsRoomblock: {
        /**
         * @default 'Remove Stay from Page'
         */
        deleteCta: T;
      };
    };
    cancelRoomBlock: {
      /**
       * @default 'Request to Cancel Your Room Block'
       */
      title: T;

      /**
       * @default 'Let us know if you need to cancel your room block, and we’ll follow up via email within 3 business days.'
       */
      message: T;

      /**
       * @default 'Reason for cancelling'
       */
      label: T;

      /**
       * @default 'Please enter a reason for canceling the room block.'
       */
      inputError: T;

      /**
       * @default 'An error occurred while canceling your room block. Please try again.'
       */
      submitError: T;

      /**
       * @default 'Your room block cancellation request has been sent.'
       */
      successMessage: T;

      /**
       * @default 'Request Cancellation'
       */
      cancelRoomBlockCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Cancel Room Block'
       */
      cancelOption: T;
    };
    registryLinks: {
      /**
       * @default 'Welcome Note'
       */
      welcomeNoteLabel: T;

      /**
       * @default 'Manage Registry'
       */
      manageRegistryCta: T;

      welcomeWidget: {
        /**
         * @default 'Welcome to your registry.'
         */
        title: T;

        /**
         * @default 'With Joy, your website IS your registry, so you’ll never share an awkward link or worry about people finding it. Guests can access your gifts, cash funds, and more all in one place.'
         */
        description: T;
      };
      registryActions: {
        /**
         * @default 'Guests will give you gifts no matter what—why not pick things you’ll actually love?'
         */
        title: T;
      };

      /**
       * @default 'Build Your Registry'
       */
      buildRegistry: T;

      /**
       * @default 'The registry trusted by millions.'
       */
      heroTitle: T;

      /**
       * @default 'Add Gifts'
       */
      addGifts: T;

      /**
       * @default 'Track Gifts'
       */
      trackGifts: T;

      /**
       * @default 'Background video'
       */
      backgroundVideo: T;

      /**
       * @default 'Emoji'
       */
      emoji: T;
    };
    thingsToDo: {
      /**
       * @default 'Thing to Do'
       */
      title: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Edit'
       */
      edit: T;

      /**
       * @default 'Delete Thing to Do'
       */
      delete: T;

      /**
       * @default 'Category'
       */
      category: T;

      /**
       * @default 'Website'
       */
      website: T;

      /**
       * @default 'thingtodo.com'
       */
      websitePlaceholder: T;

      /**
       * @default 'Name'
       */
      name: T;

      /**
       * @default 'Louvre Museum'
       */
      namePlaceholder: T;

      /**
       * @default 'Personal Note'
       */
      personalNote: T;

      /**
       * @default 'Add some optional details about why you think your guests would enjoy it, things to know, etc.'
       */
      personalNotePlaceholder: T;

      /**
       * @default 'Name is required'
       */
      titleRequired: T;

      /**
       * @default 'Please enter a valid URL'
       */
      urlInvalid: T;

      /**
       * @default 'Category is required'
       */
      categoryRequired: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Save'
       */
      save: T;

      /**
       * @default 'Custom Category'
       */
      customCategory: T;

      /**
       * @default 'Custom Category'
       */
      customCategoryPlaceholder: T;

      /**
       * @default 'Recommended Things to Do'
       */
      recommendedThingsToDo: T;

      /**
       * @default 'Failed to update. Please try again.'
       */
      failedUpdate: T;

      /**
       * @default 'Failed to create. Please try again.'
       */
      failedCreate: T;
    };
    weatherReport: {
      /**
       * @default 'Weather Report'
       */
      title: T;

      /**
       * @default 'Keep details crisp and clear for guests.'
       */
      subtitle: T;

      location: {
        /**
         * @default 'Location'
         */
        title: T;

        /**
         * @default 'Search location'
         */
        search: T;

        /**
         * @default 'Display name'
         */
        displayName: T;

        /**
         * @default 'e.g., Napa Valley'
         */
        displayNamePlaceholder: T;

        /**
         * @default 'City'
         */
        city: T;

        /**
         * @default 'Country'
         */
        country: T;
      };
      dates: {
        /**
         * @default 'Dates'
         */
        title: T;

        /**
         * @default 'Date range'
         */
        range: T;
      };
      daily: {
        /**
         * @default 'Daily forecast'
         */
        title: T;

        /**
         * @default 'Populate from date range'
         */
        populateFromRange: T;

        /**
         * @default 'Date'
         */
        date: T;

        /**
         * @default 'Remove'
         */
        remove: T;

        /**
         * @default 'Summary'
         */
        summary: T;

        /**
         * @default 'Sunny, showers, cloudy...'
         */
        summaryPlaceholder: T;

        /**
         * @default 'High °C'
         */
        highC: T;

        /**
         * @default 'Low °C'
         */
        lowC: T;

        /**
         * @default 'Precip (0–1)'
         */
        precip01: T;

        /**
         * @default 'Humidity %'
         */
        humidityPct: T;

        /**
         * @default 'Wind kph'
         */
        windKph: T;

        /**
         * @default 'UV Index'
         */
        uvIndex: T;

        /**
         * @default 'Add day'
         */
        addDay: T;
      };
      cities: {
        /**
         * @default 'Cities'
         */
        title: T;

        /**
         * @default '+ Add city'
         */
        add: T;

        /**
         * @default 'Remove city'
         */
        remove: T;

        /**
         * @default 'City {{index}}'
         */
        fallback: T;
      };
      cityHighlights: {
        /**
         * @default 'City guest highlights'
         */
        label: T;

        /**
         * @default 'Helpful notes specific to this city...'
         */
        placeholder: T;
      };
      guestHighlights: {
        /**
         * @default 'Guest highlights'
         */
        label: T;

        /**
         * @default 'Helpful notes for your guests...'
         */
        placeholder: T;
      };

      /**
       * @default 'Save'
       */
      saveCta: T;

      toast: {
        /**
         * @default 'Weather report saved'
         */
        saved: T;

        /**
         * @default 'We couldn't save your weather report. Please try again.'
         */
        failed: T;
      };
      guest: {
        /**
         * @default 'Today'
         */
        today: T;

        /**
         * @default '{{count}}-Day Forecast'
         */
        nDayForecast: T;

        /**
         * @default 'Host planning notes'
         */
        hostPlanningNotes: T;
      };
      metrics: {
        labels: {
          /**
           * @default 'Precip'
           */
          precip: T;

          /**
           * @default 'Humidity'
           */
          humidity: T;

          /**
           * @default 'Wind'
           */
          wind: T;

          /**
           * @default 'UV'
           */
          uv: T;
        };

        /**
         * @default 'UV: {{uv}} · {{category}}'
         */
        uvLabel: T;

        uvCategory: {
          /**
           * @default 'Low'
           */
          low: T;

          /**
           * @default 'Moderate'
           */
          moderate: T;

          /**
           * @default 'High'
           */
          high: T;

          /**
           * @default 'Very High'
           */
          veryHigh: T;

          /**
           * @default 'Extreme'
           */
          extreme: T;
        };

        /**
         * @default 'Wind: {{kph}} km/h · {{label}}'
         */
        windLabel: T;

        windCategory: {
          /**
           * @default 'Calm'
           */
          calm: T;

          /**
           * @default 'Breezy'
           */
          breezy: T;

          /**
           * @default 'Windy'
           */
          windy: T;

          /**
           * @default 'Strong'
           */
          strong: T;
        };
      };
    };
  };

  /**
   * @default 'Compared to <ExpediaCompareTo/>'
   */
  expediaCompareTo: T;

  venueError: {
    /**
     * @default 'Oops! Something Went Wrong.'
     */
    title: T;

    /**
     * @default 'We’re unable to store event venue.'
     */
    message: T;

    /**
     * @default 'Please try again'
     */
    cta: T;
  };
  quick: {
    /**
     * @default 'Universal'
     */
    rPhtt: T;

    /**
     * @default 'Plan Your Trip'
     */
    TL13G: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Your website has reached the maximum number of pages. Delete a page you no longer need, then try again.'
     */
    r4wuN: T;

    /**
     * @default 'We couldn't save who can see this page. Please try again.'
     */
    Wq0IO: T;

    /**
     * @default 'This video can't be embedded on your website. In your Vimeo video settings, go to Privacy and make sure embedding is allowed — either set it to "Anywhere" or add withjoy.com as an allowed domain.'
     */
    OHBhI: T;

    /**
     * @default 'This YouTube video could not be verified. Make sure the video is public and embedding is allowed.'
     */
    RxXe8: T;

    /**
     * @default 'Weather Report'
     */
    '0W1ym': T;

    /**
     * @default 'What's Weather Report'
     */
    OWmyR: T;

    /**
     * @default 'Share the local weather forecast for your event dates, helping guests pack and plan appropriately.'
     */
    oakgL: T;

    /**
     * @default 'Are you sure you want to delete this section?'
     */
    HVyJJ: T;

    /**
     * @default 'The contents of this section will be lost. This action can’t be undone.'
     */
    T0G41: T;

    /**
     * @default 'Delete Section'
     */
    '48cfN': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Section has been deleted.'
     */
    QTO9P: T;

    /**
     * @default 'An error occurred while deleting this section. Please try again.'
     */
    tdBWp: T;

    /**
     * @default 'Your component order has been updated.'
     */
    '9qKbj': T;

    /**
     * @default 'An error occurred while updating component order. Please try again.'
     */
    X1JHd: T;

    /**
     * @default 'Photo / Video / Gallery'
     */
    '5JURA': T;

    /**
     * @default 'Show 'Add to Calendar' button'
     */
    '54chm': T;

    /**
     * @default 'By clicking Save, you are overriding any individual event 'Show Add to Calendar' settings.'
     */
    ZN6j2: T;

    /**
     * @default 'Show 'Get Directions' link'
     */
    '3Py03': T;

    /**
     * @default 'By clicking Save, you are overriding any individual event 'Show Directions' settings.'
     */
    DB78x: T;

    /**
     * @default 'Show 'Where to Stay' link'
     */
    y3u2F: T;

    /**
     * @default 'By clicking Save, you are overriding any individual event 'Where to Stay' settings on your Schedule page.'
     */
    bd3m1: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Specific Guests'
     */
    '3Tybq': T;

    /**
     * @default 'Weather report saved'
     */
    lDw04: T;

    /**
     * @default 'We couldn't save your weather report. Please try again.'
     */
    tVem3: T;

    /**
     * @default 'City {{0}}'
     */
    v3W8c: T;

    /**
     * @default 'Keep details crisp and clear for guests.'
     */
    yeOtR: T;

    /**
     * @default 'Cities'
     */
    fzwzo: T;

    /**
     * @default '+ Add city'
     */
    JqwDB: T;

    /**
     * @default 'Remove city'
     */
    TOi1N: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Search location'
     */
    DolLE: T;

    /**
     * @default 'Display name'
     */
    XavHB: T;

    /**
     * @default 'e.g., Napa Valley'
     */
    zrXBd: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'Country'
     */
    G9ai3: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Date range'
     */
    z4uUJ: T;

    /**
     * @default 'Daily forecast'
     */
    kPjh6: T;

    /**
     * @default 'Populate from date range'
     */
    '7v36U': T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Summary'
     */
    '8nS3P': T;

    /**
     * @default 'Sunny, showers, cloudy...'
     */
    GKovY: T;

    /**
     * @default 'High °C'
     */
    '3Ssgn': T;

    /**
     * @default 'Low °C'
     */
    BCoJD: T;

    /**
     * @default 'Precip (0–1)'
     */
    '6Tli9': T;

    /**
     * @default 'Humidity %'
     */
    airKQ: T;

    /**
     * @default 'Wind kph'
     */
    n18X0: T;

    /**
     * @default 'UV Index'
     */
    '1dsBi': T;

    /**
     * @default '+ Add day'
     */
    EHt5X: T;

    /**
     * @default 'City guest highlights'
     */
    MwwYs: T;

    /**
     * @default 'Helpful notes specific to this city...'
     */
    '1SHsN': T;

    /**
     * @default 'Guest highlights'
     */
    jEAps: T;

    /**
     * @default 'Helpful notes for your guests...'
     */
    yNBNE: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Edit {{0}}'
     */
    srIa6: T;

    /**
     * @default 'You will be taken to {{0}} page editor. Your current changes are saved'
     */
    MVK09: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Container for Page Components'
     */
    LBflH: T;

    /**
     * @default 'Page Photo'
     */
    NBHGp: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Photo Gallery'
     */
    '6Kpcr': T;

    /**
     * @default 'Something went wrong'
     */
    X1dnv: T;

    /**
     * @default 'Unable to load the component list. Please try again.'
     */
    jIjeR: T;

    /**
     * @default 'Retry'
     */
    yGyzG: T;

    /**
     * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
     */
    '983Rd': T;

    /**
     * @default 'The contents of this section will be lost. This action can't be undone.'
     */
    Ddyiq: T;

    /**
     * @default 'Delete 1 item?'
     */
    '28H54': T;

    /**
     * @default 'Delete {{0}} items?'
     */
    ihT5v: T;

    /**
     * @default 'The contents of these sections will be lost. This action can't be undone.'
     */
    NGnNe: T;

    /**
     * @default 'Delete 1 Item'
     */
    '3UJIg': T;

    /**
     * @default 'Delete {{0}} Items'
     */
    '5iS5q': T;

    /**
     * @default 'Success! 1 section has been deleted.'
     */
    '9tiiG': T;

    /**
     * @default 'Success! {{0}} sections have been deleted.'
     */
    '1G9rG': T;

    /**
     * @default 'Deleted 1 item. {{0}} failed.'
     */
    SR49h: T;

    /**
     * @default 'Deleted {{0}} items. {{1}} failed.'
     */
    P6IGF: T;

    /**
     * @default 'Failed to delete items. Please try again.'
     */
    '4ns9a': T;

    /**
     * @default 'Component'
     */
    tRCyL: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Gallery'
     */
    Y0kqO: T;

    /**
     * @default '1 item'
     */
    GDylI: T;

    /**
     * @default '{{0}} items'
     */
    MtSBl: T;

    /**
     * @default 'Accommodations'
     */
    '5mXFH': T;

    /**
     * @default 'FAQ'
     */
    aZUAA: T;

    /**
     * @default 'VIP'
     */
    rAZAA: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Form'
     */
    I2ELA: T;

    /**
     * @default 'Stay Booking'
     */
    '2sRPc': T;

    /**
     * @default 'Place to Stay'
     */
    DpU5D: T;

    /**
     * @default 'Things to Do'
     */
    XA7i5: T;

    /**
     * @default 'Weather'
     */
    Aajff: T;

    /**
     * @default 'Countdown'
     */
    n91ap: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Graphic Accent'
     */
    uJOr5: T;

    /**
     * @default 'Page Settings'
     */
    qiWuC: T;

    /**
     * @default 'Nice work! Now, check out your page.'
     */
    '3WoBr': T;

    /**
     * @default 'Edit Page'
     */
    lVMJg: T;

    /**
     * @default 'Delete Custom Property'
     */
    Zl7ta: T;

    /**
     * @default 'Delete Accommodation'
     */
    VQJHt: T;

    /**
     * @default 'Remove Stay from Page'
     */
    '4swaB': T;

    /**
     * @default 'Delete Venue'
     */
    '6Yh9F': T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Are you sure you want to delete this item?'
     */
    PsQI1: T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'An error occurred while deleting the venue. Please try again.'
     */
    mcqrt: T;

    /**
     * @default 'An error occurred while deleting the hotel. Please try again.'
     */
    '13oks': T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'An error occurred while creating the page container. Please try again.'
     */
    G71vk: T;

    /**
     * @default 'An error occurred while creating the travel map component. Please try again.'
     */
    '1HdGK': T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    ZTnCp: T;

    /**
     * @default 'An error occurred while updating your Event Password. Please try again.'
     */
    klFYf: T;

    /**
     * @default 'Your {{0}} Page is now only visible to Specific Guests.'
     */
    clbaN: T;

    /**
     * @default 'Your {{0}} Page is now {{1}}.'
     */
    '3ohKV': T;

    /**
     * @default 'Your {{0}} Page visibility has been updated.'
     */
    '5P94D': T;

    /**
     * @default 'An error occurred while updating your {{0}} Page Visibility. Please try again.'
     */
    S01Ux: T;

    /**
     * @default 'An error occurred while updating page container. Please try again.'
     */
    CC7UR: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Back to website overview'
     */
    YxGmo: T;

    /**
     * @default 'Edit your page photo, title and visibility settings'
     */
    QnNmP: T;

    /**
     * @default 'View current page without your changes.'
     */
    jBnPS: T;

    /**
     * @default 'View Page'
     */
    wadzU: T;

    /**
     * @default 'Close tour'
     */
    Yingr: T;

    /**
     * @default 'Guests badge tour step'
     */
    q3sfE: T;

    /**
     * @default 'See where your guests are staying when booked with Joy.'
     */
    '511rl': T;

    /**
     * @default 'If you’d like, we can notify you when a guest books, and you can view all bookings here to help with planning.'
     */
    eSXWE: T;

    /**
     * @default 'Explore More Hotels'
     */
    BmXGM: T;

    /**
     * @default 'Hotel map preview'
     */
    '6jKeh': T;

    /**
     * @default 'Your hotel map just got an upgrade.'
     */
    iuUpv: T;

    /**
     * @default 'Guests love using the map to find a place to stay, so we’ve made it bigger and better. Now it's easier to see where everything is in relation to your venue.'
     */
    lECOR: T;

    /**
     * @default 'Try the New Map'
     */
    OTqhS: T;

    /**
     * @default 'Please enter a reason for canceling the room block.'
     */
    FXt12: T;

    /**
     * @default 'Request to Cancel Your Room Block'
     */
    Df90H: T;

    /**
     * @default 'Let us know if you need to cancel your room block, and we'll follow up via email within 3 business days.'
     */
    jye1b: T;

    /**
     * @default 'Reason for cancelling'
     */
    '74N6D': T;

    /**
     * @default 'Request Cancellation'
     */
    QRMxm: T;

    /**
     * @default 'More info'
     */
    '17u51': T;

    /**
     * @default 'Are you sure you want to delete this photo block?'
     */
    '1oWWy': T;

    /**
     * @default 'The contents of this section will be lost. This can’t be undone.'
     */
    BKEBe: T;

    /**
     * @default 'Delete Photo Block'
     */
    Q4E3b: T;

    /**
     * @default 'Success! Photo has been deleted.'
     */
    trYPA: T;

    /**
     * @default 'An error occurred while deleting your photo. Please try again.'
     */
    HqKXy: T;

    /**
     * @default 'Replace Photo'
     */
    '6czvN': T;

    /**
     * @default 'Add Your Photo'
     */
    QVT8f: T;

    /**
     * @default 'We support jpeg and PNG images.'
     */
    ppvro: T;

    /**
     * @default 'Upload Photo'
     */
    '5p4bA': T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Create Album'
     */
    Zy6Dw: T;

    /**
     * @default 'Select Album'
     */
    bvvb7: T;

    /**
     * @default 'All your albums will appear here.'
     */
    vO9z6: T;

    /**
     * @default 'Are you sure you want to delete this text block?'
     */
    Yg4ea: T;

    /**
     * @default 'Delete Text Block'
     */
    FHdDL: T;

    /**
     * @default 'Success! Text has been deleted.'
     */
    I1TIT: T;

    /**
     * @default 'An error occurred while deleting your text. Please try again.'
     */
    kLC95: T;

    /**
     * @default 'Tell your guests what to expect here—make it fun, exciting, and uniquely you.'
     */
    wQjhB: T;

    /**
     * @default 'Please enter a valid video URL.'
     */
    X7AwG: T;

    /**
     * @default 'Are you sure you want to delete this video block?'
     */
    Gs5hl: T;

    /**
     * @default 'Delete Video Block'
     */
    bTaDz: T;

    /**
     * @default 'Success! Video has been deleted.'
     */
    erhG5: T;

    /**
     * @default 'An error occurred while deleting your video. Please try again.'
     */
    sw1Ul: T;

    /**
     * @default 'Video URL'
     */
    Sep8P: T;

    /**
     * @default 'Example:'
     */
    kvMYz: T;

    /**
     * @default 'Video Caption'
     */
    DNXWJ: T;

    /**
     * @default 'Back to pages'
     */
    aFJsZ: T;

    /**
     * @default 'emoji'
     */
    '4IhXI': T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Start Creating'
     */
    zgURS: T;

    /**
     * @default 'Add your first content block to craft your perfect page.'
     */
    a1hdj: T;

    /**
     * @default 'Add a content block and continue crafting your page.'
     */
    MoNeF: T;

    /**
     * @default 'Dive in and start creating.'
     */
    ZFLci: T;

    /**
     * @default 'Add your first content block to start crafting your perfect page.'
     */
    EAjB4: T;

    /**
     * @default 'Add Content'
     */
    OxQnv: T;
  };
};

export type WebsiteHeaderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Photo'
     */
    QtRqG: T;
  };
};

export type WebsiteOverviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Support'
     */
    support: T;

    /**
     * @default 'Settings'
     */
    settings: T;
  };
  overview: {
    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default '{{completedCount}} / {{totalCount}} Done'
     */
    completedCount: T;

    /**
     * @default 'Edit Design'
     */
    editDesign: T;

    /**
     * @default 'Share Website'
     */
    shareWebsite: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Event URL copied.'
     */
    eventUrlCopiedToast: T;

    /**
     * @default 'RSVP is On'
     */
    rsvpOnText: T;

    /**
     * @default 'RSVP is Off'
     */
    rsvpOffText: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;
  };
  photos: {
    /**
     * @default 'Albums'
     */
    albums: T;

    /**
     * @default 'New Album'
     */
    newAlbum: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'View'
     */
    view: T;

    /**
     * @default 'Manage Album'
     */
    manageAlbum: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Delete'
     */
    Delete: T;

    /**
     * @default 'Item'
     */
    item: T;

    /**
     * @default 'Items'
     */
    items: T;

    /**
     * @default 'Photos'
     */
    photos: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    photoLabel: T;

    /**
     * @default 'Upload Photo'
     */
    uploadPhoto: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    /**
     * @default 'Manage Photos'
     */
    managePhotos: T;

    /**
     * @default 'Add Album'
     */
    addAlbum: T;

    /**
     * @default 'Edit Album'
     */
    editAlbum: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Allow Uploads'
     */
    allowUploads: T;

    /**
     * @default 'Link'
     */
    link: T;

    /**
     * @default 'Magic Link'
     */
    magicLink: T;

    /**
     * @default 'Generating...'
     */
    magicLinkPlaceholder: T;

    /**
     * @default 'Share Link'
     */
    shareLink: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Copy Upload Link'
     */
    copyUploadLink: T;

    /**
     * @default 'Share Link copied.'
     */
    shareLinkCopied: T;

    /**
     * @default 'Send this link to your guests. They'll be able to upload all their photos straight into your collection. Please note this link will also allow anyone to see photos uploaded to this album.'
     */
    uploadLinkInfo: T;

    noCollections: {
      /**
       * @default 'Introducing Shared Photo Albums'
       */
      eyebrow: T;

      /**
       * @default 'Collect and share memories from friends and family before and after the big day.'
       */
      title: T;

      /**
       * @default 'From your childhood photos and early days together to the ceremony and after party, friends and family can now upload photos and notes before and after your big day.'
       */
      description: T;
    };

    /**
     * @default 'Create Album'
     */
    createAlbum: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    savePhotoError: T;

    /**
     * @default 'Upload'
     */
    upload: T;

    /**
     * @default 'Looking for Moments?'
     */
    lookingForMoments: T;

    /**
     * @default ' View your Moments'
     */
    viewYourMoments: T;

    /**
     * @default 'Looking to set your website page photos?'
     */
    lookingForPagePhotos: T;

    /**
     * @default 'Set page photos'
     */
    setPagePhotos: T;

    faqs: {
      questions: [
        {
          /**
           * @default 'What is Joy Collections?'
           */
          Q: T;

          /**
           * @default 'Joy Collections is your dedicated service for organizing, collecting, and sharing all your wedding photos and videos in one beautifully designed platform. Guests can easily upload their moments, and you can relive every magical memory with ease.'
           */
          A: T;
        },
        {
          /**
           * @default 'How do I invite guests to share their photos?'
           */
          Q: T;

          /**
           * @default 'You can invite guests to upload their photos through your wedding website on Joy. Simply share your unique link via email, text, or on your event website. Guests can upload directly without needing to create an account.'
           */
          A: T;
        },
        {
          /**
           * @default 'Is there a limit to the number of photos or videos we can collect?'
           */
          Q: T;

          /**
           * @default 'Nope! Joy Collections offers unlimited uploads, so you won’t miss a single shot of your big day.'
           */
          A: T;
        },
        {
          /**
           * @default 'Can we organize the photos into albums?'
           */
          Q: T;

          /**
           * @default 'Yes! You can create albums for different events (e.g., rehearsal dinner, ceremony, reception) or themes (e.g., candid moments, dance floor fun).'
           */
          A: T;
        },
      ];
    };

    /**
     * @default 'Album Options'
     */
    albumOptions: T;

    /**
     * @default 'Options'
     */
    options: T;

    /**
     * @default 'Album name is required'
     */
    albumNameRequired: T;

    /**
     * @default 'Name should be 30 characters or less.'
     */
    maxCharacters: T;

    /**
     * @default 'This album has no images.'
     */
    noImages: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    mediaSettingsError: T;

    /**
     * @default 'All Photos'
     */
    allPhotos: T;

    photoPickerDialog: {
      /**
       * @default 'Select All'
       */
      selectAll: T;

      /**
       * @default 'Deselect All'
       */
      deselectAll: T;

      /**
       * @default 'Add to Album'
       */
      addToAlbum: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Upload Photos'
       */
      uploadPhotos: T;

      /**
       * @default 'Add Photos'
       */
      addPhotos: T;

      /**
       * @default 'Select {{count}} Photos'
       */
      selectPhotosCount: T;

      /**
       * @default 'Select {{count}} Photo'
       */
      selectPhotoCount: T;

      /**
       * @default 'Select Photos'
       */
      selectPhotos: T;
    };

    /**
     * @default 'Photos added to album.'
     */
    addMediaToCollectionSuccess: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    addMediaToCollectionPartialSuccess: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    addMediaToCollectionError: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    toggleTooltipText: T;

    /**
     * @default 'Select Photos…'
     */
    selectPhotosCTALabel: T;

    /**
     * @default 'Select…'
     */
    selectCTALabel: T;

    /**
     * @default 'Select photos'
     */
    selectPhotos: T;

    /**
     * @default 'Add to Album…'
     */
    addToAlbumCTALabel: T;

    /**
     * @default '{{count}} Photos Selected'
     */
    selectedPhotosCount: T;

    /**
     * @default '{{count}} Photo Selected'
     */
    selectedPhotoCount: T;

    /**
     * @default 'Add to Album'
     */
    addToAlbum: T;

    /**
     * @default 'Remove from album'
     */
    removeFromAlbum: T;

    /**
     * @default 'Happy face 1'
     */
    happyFace1: T;

    /**
     * @default 'Happy face 2'
     */
    happyFace2: T;
  };
  quick: {
    /**
     * @default 'Domain'
     */
    MIv6r: T;

    /**
     * @default 'Event Admins'
     */
    uanxf: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default '1 item'
     */
    GDylI: T;

    /**
     * @default '{{0}} items'
     */
    MtSBl: T;

    /**
     * @default 'Manage Album'
     */
    UbvYs: T;

    /**
     * @default 'Upload photos'
     */
    Q3G7w: T;

    /**
     * @default 'Live'
     */
    gS7LA: T;

    /**
     * @default '1 photo'
     */
    JDCqQ: T;

    /**
     * @default '{{0}} photos'
     */
    H5QnO: T;

    /**
     * @default 'A download link was sent recently. Check your inbox.'
     */
    JFb2C: T;

    /**
     * @default 'This album has no photos to download.'
     */
    EEj6l: T;

    /**
     * @default 'Albums over {{0}} photos can't be downloaded at once.'
     */
    sRkiH: T;

    /**
     * @default 'This album is too large to download at once.'
     */
    '71jDC': T;

    /**
     * @default 'Downloads are off because photo storage has expired.'
     */
    YuF65: T;

    /**
     * @default 'Full-resolution downloads need a Gold or Platinum photos plan.'
     */
    vUHYA: T;

    /**
     * @default 'Downloads are unavailable right now. Please try again later.'
     */
    QrHoh: T;

    /**
     * @default 'Something went wrong with your download. Please try again.'
     */
    fhjZN: T;

    /**
     * @default 'We're preparing your photos and will email a link to {{0}} in a few minutes.'
     */
    qnJU2: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Edit Pages'
     */
    '28e42': T;

    /**
     * @default 'Website navigation'
     */
    dDDAC: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Your request has been sent to the event hosts.'
     */
    PlQlJ: T;

    /**
     * @default 'An error occurred while sending your request. Please try again.'
     */
    w5UWo: T;

    /**
     * @default 'This album has expired'
     */
    qwzEo: T;

    /**
     * @default 'These photos are no longer available to view. Add storage to restore the album for you and your guests.'
     */
    Lvkb8: T;

    /**
     * @default 'These photos are no longer available to view. Reach out to the event hosts if you'd like to see them restored.'
     */
    j3BXZ: T;

    /**
     * @default 'Request sent!'
     */
    Q8BrI: T;

    /**
     * @default 'Upgrade now'
     */
    GlWFF: T;

    /**
     * @default 'Contact the event hosts'
     */
    EYLMK: T;

    /**
     * @default 'Photos uploaded! The host may need to approve before they appear in the album.'
     */
    P6ijE: T;

    /**
     * @default 'All photos successfully uploaded'
     */
    P3gVJ: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'The photo upload period for this event has ended.'
     */
    aUdnP: T;

    /**
     * @default 'All Photos'
     */
    m8UFC: T;

    /**
     * @default 'Add photos'
     */
    sTaFS: T;

    /**
     * @default 'Upload from this device'
     */
    NiQZG: T;

    /**
     * @default 'Upload from your device, a link, and more'
     */
    j1TUi: T;

    /**
     * @default 'Upload from your device, phone, a link, and more'
     */
    xxtpL: T;

    /**
     * @default 'Add photos from this device'
     */
    me8FR: T;

    /**
     * @default 'Upload from phone'
     */
    Zxn2R: T;

    /**
     * @default 'Scan QR to send from your camera roll'
     */
    CWTVk: T;

    /**
     * @default 'Guest uploads are closed'
     */
    '4XINF': T;

    /**
     * @default 'This album isn't accepting photo uploads.'
     */
    '6fKp1': T;

    /**
     * @default 'This album is no longer accepting new photos.'
     */
    IghS5: T;

    /**
     * @default 'Photos uploaded'
     */
    BxnGS: T;

    /**
     * @default 'Upload photos to the event'
     */
    US6ER: T;

    /**
     * @default 'Awaiting approval from host.'
     */
    J40Ke: T;

    /**
     * @default 'Share your photos with the couple.'
     */
    cjx3D: T;

    /**
     * @default 'Upload More Photos'
     */
    F0Udr: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Joy Home Page'
     */
    MAxNh: T;

    /**
     * @default 'Uploading photos...'
     */
    '6EiQZ': T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Upload Photo'
     */
    '5p4bA': T;

    /**
     * @default 'Download All'
     */
    flldB: T;

    /**
     * @default 'Albums'
     */
    cuntj: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    '32yZ1': T;

    /**
     * @default 'This album has no images.'
     */
    '0zSUX': T;

    /**
     * @default 'Pick up where you left off'
     */
    SEcYl: T;

    /**
     * @default 'Finish your drafts, or start a new card in a design that matches your website.'
     */
    gszz9: T;

    /**
     * @default 'Browse All'
     */
    rCl09: T;

    /**
     * @default 'Previous Designs'
     */
    OotJU: T;

    /**
     * @default 'Next Designs'
     */
    '8yxio': T;

    /**
     * @default 'Your stationery'
     */
    JuFA2: T;

    /**
     * @default '{{0}} · edited {{1}}'
     */
    '1tHiC': T;

    /**
     * @default 'Draft'
     */
    L9AuF: T;

    /**
     * @default 'Matching stationery'
     */
    jxXiN: T;

    /**
     * @default 'Your website, invitations, and save the dates, all in one design.'
     */
    AsJSz: T;

    /**
     * @default 'Your names and date are already on them. Send on paper, digitally, or both.'
     */
    dePil: T;

    /**
     * @default 'Browse Stationery'
     */
    wmg6L: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default '{{0}} / {{1}} Done'
     */
    c7CJl: T;

    /**
     * @default 'Get Started checklist'
     */
    rbr6G: T;

    /**
     * @default 'Resize the Get Started checklist'
     */
    '0w6JT': T;

    /**
     * @default '🥳 Your website has been successfully published!'
     */
    rQbtw: T;

    /**
     * @default '🥳 Your website has been successfully unpublished!'
     */
    '2OqIt': T;

    /**
     * @default '😬 Failed to update website visibility. Please try again.'
     */
    '2rtoX': T;

    /**
     * @default 'Website Visibility:'
     */
    DNxDm: T;

    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Unpublished'
     */
    F7vbD: T;

    /**
     * @default 'Toggle website visibility'
     */
    PbFMt: T;

    /**
     * @default 'Finish setting up'
     */
    Q6QjI: T;

    /**
     * @default '1 step left'
     */
    YEYJd: T;

    /**
     * @default '{{0}} steps left'
     */
    GCaWY: T;

    /**
     * @default 'Let’s get your website ready'
     */
    g2pct: T;

    /**
     * @default 'Pick any step. They tick off as you go, and you can publish whenever you like.'
     */
    HXO9B: T;

    /**
     * @default 'Get started'
     */
    zUfsR: T;

    /**
     * @default '{{0}}/{{1}}'
     */
    yVyMQ: T;

    /**
     * @default 'Get started progress'
     */
    wQFBF: T;

    /**
     * @default 'Couldn't copy the link. Try again.'
     */
    r3O2I: T;

    /**
     * @default 'Event URL copied.'
     */
    lPIkx: T;

    /**
     * @default 'Couldn't copy the password. Try again.'
     */
    UNO92: T;

    /**
     * @default 'Password copied.'
     */
    xqQJ0: T;

    /**
     * @default 'Couldn't load the password. Try again.'
     */
    XGBs8: T;

    /**
     * @default 'Your website is live'
     */
    aq6e3: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Visit Site'
     */
    Iia33: T;

    /**
     * @default '{{0}} of {{1}} pages protected'
     */
    oKlfS: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'Copy Password'
     */
    EDeJ0: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Couldn't update your website. Try again.'
     */
    yLpOT: T;

    /**
     * @default 'Website published.'
     */
    tG4mJ: T;

    /**
     * @default 'Website unpublished.'
     */
    Uejyp: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'Unpublish'
     */
    GWCTL: T;

    /**
     * @default 'Publish website?'
     */
    b5Kz5: T;

    /**
     * @default 'Unpublish website?'
     */
    AcjRa: T;

    /**
     * @default 'Guests with your link will be able to see your website.'
     */
    tZttT: T;

    /**
     * @default 'Guests won't be able to see your website until you publish it again. Nothing you've made is lost.'
     */
    X6OkN: T;

    /**
     * @default 'Download PNG'
     */
    ZkpdB: T;

    /**
     * @default 'Share with a QR code'
     */
    '6awFh': T;

    /**
     * @default 'Guests scan it to open your website.'
     */
    kjJOV: T;

    /**
     * @default 'Send Reminder'
     */
    '2juHR': T;

    /**
     * @default 'Add Hotels'
     */
    cOmsk: T;

    /**
     * @default 'Remind your guests'
     */
    '5eLUS': T;

    /**
     * @default 'Remind guests to RSVP'
     */
    '6RSXw': T;

    /**
     * @default 'Send a reminder to guests who haven't replied yet.'
     */
    '7oVIS': T;

    /**
     * @default 'Remind guests to book where to stay'
     */
    DElTl: T;

    /**
     * @default 'Send your hotels and book-by date.'
     */
    KmBdG: T;

    /**
     * @default 'Share your website'
     */
    f9KfA: T;

    /**
     * @default 'Share with a card'
     */
    '2Q1y1': T;

    /**
     * @default 'Paper or digital'
     */
    XGVHd: T;

    /**
     * @default 'Share with a message'
     */
    RayqE: T;

    /**
     * @default 'Text or email'
     */
    oBiaZ: T;

    /**
     * @default 'For signs, menus, and printed cards'
     */
    lEF6E: T;

    /**
     * @default 'Desktop'
     */
    UpyS2: T;

    /**
     * @default 'Phone'
     */
    '4pRqG': T;

    /**
     * @default 'Your website'
     */
    ADcpg: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Edit Design'
     */
    YqPok: T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default 'Manage Photos'
     */
    mAenA: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    dVCSs: T;

    /**
     * @default 'Share Link copied.'
     */
    Z1zfQ: T;

    /**
     * @default 'Remove from album'
     */
    vwTJs: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    JG58J: T;

    /**
     * @default 'Allow Uploads'
     */
    fkQif: T;

    /**
     * @default 'Album Options'
     */
    '3vXJp': T;

    /**
     * @default 'Options'
     */
    Uw6kb: T;

    /**
     * @default 'Failed to delete photo.'
     */
    VTRSR: T;

    /**
     * @default 'Please enter a valid email'
     */
    '3hdNF': T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'Email must be {{0}} characters or fewer'
     */
    uMhvz: T;

    /**
     * @default 'Download all photos'
     */
    WEY0y: T;

    /**
     * @default 'We'll email you a link to download the photos in this album.'
     */
    wvTJu: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    zPEWs: T;

    /**
     * @default 'Send link'
     */
    '0QpEO': T;
  };
};

export type WebsitePagesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  seo: {
    pageTitle: {
      /**
       * @default '{{eventName}} | Joy'
       */
      withEventName: T;

      /**
       * @default 'Joy'
       */
      default: T;

      /**
       * @default '{{eventName}} | Baby Registry | Joy'
       */
      babyRegistry: T;

      /**
       * @default 'Baby Registry | Joy'
       */
      babyRegistryDefault: T;

      /**
       * @default '{{partnerOne}} & {{partnerTwo}} | Joy'
       */
      withPartnerNames: T;
    };
    pageDescription: {
      /**
       * @default 'Welcome to {{eventName}}! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeWithEvent: T;

      /**
       * @default 'Welcome! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeDefault: T;

      /**
       * @default 'Welcome to the website for {{eventName}}! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeWithNames: T;

      /**
       * @default 'Welcome to {{eventName}}! Explore photos, baby registry information, and more on Joy.'
       */
      babyRegistryWithEvent: T;

      /**
       * @default 'Welcome! Explore photos, baby registry information, and more on Joy.'
       */
      babyRegistryDefault: T;

      /**
       * @default 'Welcome to the website for {{partnerOne}} and {{partnerTwo}}! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeWithPartnerNames: T;
    };

    /**
     * @default 'accommodations'
     */
    accommodations: T;

    /**
     * @default 'travel details'
     */
    travelDetails: T;

    /**
     * @default 'registry information'
     */
    registryInformation: T;

    /**
     * @default 'event information'
     */
    eventInformation: T;
  };
  quick: {
    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Specific Guests'
     */
    '3Tybq': T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Story & Tidbits'
     */
    MZCpe: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Guest Q&A'
     */
    gMg7F: T;

    /**
     * @default 'Wedding Party'
     */
    QfgiL: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Add New Page'
     */
    wsKWg: T;

    /**
     * @default 'Manage Pages'
     */
    Ljvjt: T;

    /**
     * @default 'Cash Fund'
     */
    cKFaM: T;

    /**
     * @default 'Add your cash fund to any page so guests can contribute directly.'
     */
    sigqF: T;
  };
};

export type WebsitePhotosAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Your event date changed, but your photo storage and guest upload dates didn't. Contact support to have them updated.'
     */
    egpjC: T;

    /**
     * @default 'I changed my event date. Please update my photo storage and guest upload expiry dates.'
     */
    '14jrP': T;

    /**
     * @default 'Contact support'
     */
    t4jQY: T;

    /**
     * @default 'Photo uploaded successfully.'
     */
    rCjjD: T;

    /**
     * @default 'Error uploading photo. Please try again later.'
     */
    yLC80: T;

    /**
     * @default 'Delete this photo from your event?'
     */
    zd0QJ: T;

    /**
     * @default 'This photo will be permanently removed from all albums, headers, and website pages. This action cannot be undone.'
     */
    '4jUuz': T;

    /**
     * @default 'Delete Photo'
     */
    doIgF: T;

    /**
     * @default 'An error occurred while adding the photo to your album. Please try again.'
     */
    vCMJu: T;

    /**
     * @default 'Photo has been successfully added to the album.'
     */
    GO8mv: T;

    /**
     * @default 'Add to Album'
     */
    douf3: T;

    /**
     * @default 'An error occurred while applying the photo. Please try again.'
     */
    JsdTS: T;

    /**
     * @default 'Photo has been successfully applied to "{{0}}" page.'
     */
    SGuDx: T;

    /**
     * @default 'Assign to Page'
     */
    PBsDA: T;

    /**
     * @default 'Billing Address'
     */
    tHIvo: T;

    /**
     * @default 'Payment was not completed. You can try again when you're ready.'
     */
    tlQsK: T;

    /**
     * @default 'Basic'
     */
    cJkhF: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Share your favorite moments on your Joy website.'
     */
    '4IjOK': T;

    /**
     * @default 'Add photos'
     */
    sTaFS: T;

    /**
     * @default 'Why choose Basic?'
     */
    yQEt0: T;

    /**
     * @default 'Includes:'
     */
    l0PnF: T;

    /**
     * @default 'Up to '
     */
    ciu1a: T;

    /**
     * @default '100 photos'
     */
    '6U3wY': T;

    /**
     * @default ', added by hosts'
     */
    ozyaR: T;

    /**
     * @default 'Guests view from your Joy wedding website'
     */
    qrfoz: T;

    /**
     * @default 'Share by QR code, link, or Joy guest messaging'
     */
    '91MJ7': T;

    /**
     * @default 'Opens instantly in any browser'
     */
    k3mKV: T;

    /**
     * @default 'Gallery matches your wedding website design'
     */
    RrSgf: T;

    /**
     * @default 'Organize memories by wedding event'
     */
    lvI9G: T;

    /**
     * @default 'Likes & comments, turn on or off anytime'
     */
    pkkDz: T;

    /**
     * @default 'Photos stored in full quality for {{0}} after your event'
     */
    HkB3M: T;

    /**
     * @default '3 months'
     */
    SRpJA: T;

    /**
     * @default 'Guest uploads'
     */
    Ozemr: T;

    /**
     * @default 'Full resolution originals'
     */
    ZlA8u: T;

    /**
     * @default 'Live slideshow'
     */
    MJm2k: T;

    /**
     * @default 'Plus'
     */
    ahjMA: T;

    /**
     * @default 'Most Popular'
     */
    S2MqS: T;

    /**
     * @default 'Collect every guest's POV, no app required.'
     */
    BqXHL: T;

    /**
     * @default 'Get Plus'
     */
    '6Di9J': T;

    /**
     * @default 'Why choose Plus?'
     */
    I0Hoa: T;

    /**
     * @default 'Everything in Basic, plus:'
     */
    StgAr: T;

    /**
     * @default 'Easy guest uploads (no app or login needed)'
     */
    '2RZ3a': T;

    /**
     * @default 'Best-in-class privacy controls'
     */
    rC8mU: T;

    /**
     * @default '1,000 photos'
     */
    gf8xq: T;

    /**
     * @default 'Download everything in full resolution'
     */
    boizM: T;

    /**
     * @default 'Guests can add photos for {{0}} after your event'
     */
    jLiRj: T;

    /**
     * @default '1 month'
     */
    lpJcQ: T;

    /**
     * @default '6 months'
     */
    Ft1OQ: T;

    /**
     * @default 'Premium'
     */
    P2hvj: T;

    /**
     * @default 'Recommended'
     */
    '1pIEc': T;

    /**
     * @default 'Turn every moment into a live slideshow.'
     */
    viP9J: T;

    /**
     * @default 'Get Premium'
     */
    L22pF: T;

    /**
     * @default 'Why choose Premium?'
     */
    RP3dH: T;

    /**
     * @default 'Everything in Plus, and more:'
     */
    kUqNv: T;

    /**
     * @default 'Live slideshow on any TV or projector'
     */
    yqxbS: T;

    /**
     * @default 'Real time upload and moderation during the event'
     */
    loLDK: T;

    /**
     * @default '2,000 photos'
     */
    R9PDP: T;

    /**
     * @default ' (contact us if you need more)'
     */
    O1R7J: T;

    /**
     * @default '12 months'
     */
    AsJUZ: T;

    /**
     * @default 'Event Photos upgraded!'
     */
    OtOmj: T;

    /**
     * @default 'Something went wrong. Please refresh the page.'
     */
    '6NT01': T;

    /**
     * @default 'This photo is already in the selected album.'
     */
    k0xmj: T;

    /**
     * @default 'An error occurred while moving the photo. Please try again.'
     */
    bdoFy: T;

    /**
     * @default 'Photo has been successfully moved to the album.'
     */
    FV6wC: T;

    /**
     * @default 'Photo has been added to the album but could not be removed from the current one.'
     */
    DAgxg: T;

    /**
     * @default 'Move to Album'
     */
    lhQhL: T;

    /**
     * @default 'Storage extended successfully!'
     */
    CPYFr: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Add storage'
     */
    Mtjip: T;

    /**
     * @default 'Your included photo storage ends {{0}}. Add a year of storage to keep your gallery live and downloadable — adding storage resets the countdown and all reminders.'
     */
    AWWVr: T;

    /**
     * @default '+1 year of storage'
     */
    h5WiY: T;

    /**
     * @default 'through {{0}}'
     */
    jpcux: T;

    /**
     * @default 'Add storage · {{0}}'
     */
    '7H077': T;

    /**
     * @default 'Or download everything for free to keep your own copy.'
     */
    '1nf5I': T;

    /**
     * @default 'Album name is required.'
     */
    Vkc4Y: T;

    /**
     * @default 'Name should be {{0}} characters or less.'
     */
    Xnl4G: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Upload from this device'
     */
    NiQZG: T;

    /**
     * @default 'Upload from phone'
     */
    Zxn2R: T;

    /**
     * @default 'Start with the photos you already have'
     */
    hhRdT: T;

    /**
     * @default 'Up to {{0}} photos on your website, free — no plan needed.'
     */
    '5Qkxe': T;

    /**
     * @default 'Up to {{0}} photos on your website.'
     */
    O6iYn: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default 'Approved'
     */
    fb2SB: T;

    /**
     * @default 'Rejected'
     */
    '6Kc0L': T;

    /**
     * @default 'Reject'
     */
    HrdNS: T;

    /**
     * @default 'Approve'
     */
    xSOVc: T;

    /**
     * @default 'Create Album - {{0}} photo'
     * @param {number} count - The number of occurrences.
     * - singular: Create Album - {{0}} photo
     * - plural: Create Album - {{0}} photos
     */
    JnUoS: T;

    /**
     * @default 'Create Album'
     */
    Zy6Dw: T;

    /**
     * @default 'New Album'
     */
    raB6X: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Share on your website'
     */
    um0Kj: T;

    /**
     * @default 'Add a beautiful photo gallery page to your wedding website with one click.'
     */
    '1xw3K': T;

    /**
     * @default 'Password protect or keep open'
     */
    eHXse: T;

    /**
     * @default 'Control who sees your photos. Set a password or share openly with all your guests.'
     */
    vzy2n: T;

    /**
     * @default 'Upload from any device'
     */
    '9qcvl': T;

    /**
     * @default 'Drag and drop from your computer or scan a QR code to upload directly from your phone.'
     */
    ONNBb: T;

    /**
     * @default 'Engagement gallery example'
     */
    vO71C: T;

    /**
     * @default 'Your engagement, beautifully shared.'
     */
    r9o2Y: T;

    /**
     * @default 'Upload your photos'
     */
    JsmdD: T;

    /**
     * @default 'Moderation'
     */
    WiIIG: T;

    /**
     * @default 'Likes'
     */
    qvfWG: T;

    /**
     * @default 'Event Photos'
     */
    B1A1J: T;

    /**
     * @default 'Everyone's photos, one shared album.'
     */
    mzWm2: T;

    /**
     * @default 'Every guest captures a different part of the day, brought together in one shared album.'
     */
    jHyFg: T;

    /**
     * @default 'Watch how it works'
     */
    eVLnP: T;

    /**
     * @default 'Every guest captures a different part of the day. Joy brings those photos together in one shared album, so it's easy to collect the moments you'd otherwise miss. Moderate what appears, then let everyone like and relive it together.'
     */
    '1fKGh': T;

    /**
     * @default 'See photo plans'
     */
    '90GlU': T;

    /**
     * @default 'Event Photos preview'
     */
    JwcXW: T;

    /**
     * @default 'Full resolution downloads'
     */
    CgqFv: T;

    /**
     * @default 'Up to 1,000 photos'
     */
    cr3iU: T;

    /**
     * @default 'Real time upload and moderation'
     */
    RgxHM: T;

    /**
     * @default 'Up to 2,000 photos'
     */
    PwxIO: T;

    /**
     * @default 'Get more from your event'
     */
    '4G7G9': T;

    /**
     * @default 'Upgrade anytime. Your photos and settings carry over.'
     */
    g657l: T;

    /**
     * @default 'Everyone's photos, all in one shared album.'
     */
    EuAkb: T;

    /**
     * @default 'Every guest captures a unique moment — Joy brings them all together in one shared album.'
     */
    '5maiC': T;

    /**
     * @default 'Plus plan. View photo plans'
     */
    ez6Wt: T;

    /**
     * @default 'Premium plan. View photo plans'
     */
    fs9Sj: T;

    /**
     * @default 'Free plan. View photo plans'
     */
    K4NmA: T;

    /**
     * @default 'View photo plans'
     */
    pzWV9: T;

    /**
     * @default 'You're all set on Premium.'
     */
    i4IlQ: T;

    /**
     * @default 'Every feature is unlocked. Photos are stored in full quality for 12 months after your event.'
     */
    T8yet: T;

    /**
     * @default 'Unlock more features'
     */
    '4leZK': T;

    /**
     * @default 'Add a live slideshow and real-time moderation to show every moment live on the big day.'
     */
    AQL0T: T;

    /**
     * @default 'Upgrade to Premium'
     */
    s35no: T;

    /**
     * @default 'You're on the Free plan. Upgrade for guest uploads, full-resolution downloads, and more.'
     */
    '4XDFO': T;

    /**
     * @default 'Upgrade to Plus'
     */
    H2pkt: T;

    /**
     * @default 'How Event Photos works'
     */
    Te7Gr: T;

    /**
     * @default 'See how guests add photos and everything lands in one shared album, in real time.'
     */
    '1BOwL': T;

    /**
     * @default '{{0}} Selected'
     */
    FsX46: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Drag photos to reorder'
     */
    Hzcco: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Please enter a year between {{0}} and {{1}}.'
     */
    '4xYse': T;

    /**
     * @default 'Event date saved.'
     */
    '14VlR': T;

    /**
     * @default 'We couldn't save your event date. Please try again.'
     */
    JLb2O: T;

    /**
     * @default 'When's the big day?'
     */
    IKIp1: T;

    /**
     * @default 'We use your event date to set how long guests can add photos and how long your photos are stored.'
     */
    qnS3u: T;

    /**
     * @default 'Save event date'
     */
    VLyXc: T;

    /**
     * @default 'You can change this anytime in Settings.'
     */
    CYyCr: T;

    /**
     * @default 'I'd like to extend the upload window for my event album.'
     */
    GB1FE: T;

    /**
     * @default 'Uploads open · {{0}} day left'
     * @param {number} count - The number of occurrences.
     * - singular: Uploads open · {{0}} day left
     * - plural: Uploads open · {{0}} days left
     */
    PyRZg: T;

    /**
     * @default '{{0}} day until your photos expire'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} day until your photos expire
     * - plural: {{0}} days until your photos expire
     */
    '3PyjJ': T;

    /**
     * @default 'Contact our team'
     */
    dM5sc: T;

    /**
     * @default 'Guest uploads close {{0}}. Need a longer upload window? Our team can extend it for you.'
     */
    iid1W: T;

    /**
     * @default 'Uploads close today'
     */
    '78nCI': T;

    /**
     * @default 'Uploads close tonight ({{0}}). Need more time? Our team can extend your upload window.'
     */
    Iy9Mu: T;

    /**
     * @default 'Uploads closed'
     */
    Uz5Sb: T;

    /**
     * @default 'This album is view-only. Guests can still view and download photos, but can't add new ones.'
     */
    HMgub: T;

    /**
     * @default 'No event date'
     */
    Z8hvB: T;

    /**
     * @default 'Your event date sets how long guests can add photos and how long they're stored. Without one, storage expires a year after purchase.'
     */
    h9pcI: T;

    /**
     * @default 'Add event date'
     */
    bdQ1P: T;

    /**
     * @default 'After {{0}}, downloads turn off and the gallery locks. Download now or extend storage to keep access.'
     */
    HHBW0: T;

    /**
     * @default 'Extend storage'
     */
    pMja5: T;

    /**
     * @default 'Last day — photos expire tonight'
     */
    Ro3sd: T;

    /**
     * @default 'Download your album or extend storage before {{0}} to keep access to your album.'
     */
    qZjqY: T;

    /**
     * @default 'Photo storage expired {{0}}'
     */
    '0KSzU': T;

    /**
     * @default 'Your photos are safe. Viewing and downloads stay paused until you add storage.'
     */
    iztKa: T;

    /**
     * @default 'Storage included until {{0}}'
     */
    '9YzMp': T;

    /**
     * @default 'Your photo storage has expired'
     */
    fiQe7: T;

    /**
     * @default 'Your included photo storage expired on {{0}}. Your album is still here, but access and downloads are paused.'
     */
    po8YO: T;

    /**
     * @default 'Upgrade now'
     */
    GlWFF: T;

    /**
     * @default 'Downloads are disabled while storage is expired.'
     */
    '0UKyE': T;

    /**
     * @default '{{0}} of {{1}} photos used'
     */
    '4uygC': T;

    /**
     * @default 'Reject {{0}} photos?'
     */
    XbaGA: T;

    /**
     * @default 'Reject this photo?'
     */
    qUNxf: T;

    /**
     * @default 'These photos will be marked as rejected and won't appear in the slideshow.'
     */
    yoZGG: T;

    /**
     * @default 'This photo will be marked as rejected and won't appear in the slideshow.'
     */
    '4lL9P': T;

    /**
     * @default 'Reject {{0}} Photos'
     */
    EXvVZ: T;

    /**
     * @default 'Reject Photo'
     */
    LwlNR: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Failed to create album. Please try again.'
     */
    '8xuOw': T;

    /**
     * @default 'Browse Albums'
     */
    WcCOK: T;

    /**
     * @default 'Select {{0}}'
     */
    ImZIC: T;

    /**
     * @default 'Create Your First Album'
     */
    gk7Bk: T;

    /**
     * @default 'Add albums with your photos so you can easily use them in your website.'
     */
    nCxjs: T;

    /**
     * @default 'Apply to Page'
     */
    mQoQg: T;

    /**
     * @default 'No custom pages available.'
     */
    '7iMkp': T;

    /**
     * @default 'Slideshow Settings'
     */
    xx9cy: T;

    /**
     * @default 'Transition Duration (seconds)'
     */
    '9Al00': T;

    /**
     * @default 'Show QR Code'
     */
    fGxVb: T;

    /**
     * @default 'Guest uploads are disabled. Enable uploads in album settings to show the QR code.'
     */
    ved2t: T;

    /**
     * @default 'Start Slideshow'
     */
    U4h5M: T;

    /**
     * @default 'Exit Slideshow'
     */
    YsVNo: T;

    /**
     * @default 'Scan to share photos'
     */
    QsW1N: T;

    /**
     * @default 'Photos will appear here as guests upload and the host approves them.'
     */
    IMLRT: T;

    /**
     * @default 'Waiting for photos'
     */
    XIUke: T;

    /**
     * @default 'Upload photos to this album and the host can approve them to start the slideshow.'
     */
    bOEmh: T;

    /**
     * @default 'Share Link copied.'
     */
    Z1zfQ: T;

    /**
     * @default 'Edit Album'
     */
    B1et1: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Allow Uploads'
     */
    fkQif: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Generating...'
     */
    qOw0Q: T;

    /**
     * @default 'Share Link'
     */
    F4p3q: T;

    /**
     * @default 'Send this link to your guests. They'll be able to upload all their photos straight into your collection. Please note this link will also allow anyone to see photos uploaded to this album.'
     */
    PVAPM: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Album has been deleted'
     */
    mi3CD: T;

    /**
     * @default 'Failed to delete album.'
     */
    chG1n: T;

    /**
     * @default 'Are you sure you want to delete this album?'
     */
    jRK4I: T;

    /**
     * @default 'The album will be deleted, but its photos will remain in All Photos. This can't be undone. This album has a shared link or QR code — anyone with it will lose access, and printed QR codes can't be updated.'
     */
    '99gzG': T;

    /**
     * @default 'The album will be deleted, but its photos will remain in All Photos. This can't be undone.'
     */
    WMSFE: T;

    /**
     * @default 'Delete Album'
     */
    wqCUE: T;

    /**
     * @default 'I understand the shared link and any printed QR codes for this album will stop working.'
     */
    '0d3o1': T;

    /**
     * @default 'Website Page Photos'
     */
    rNZVs: T;

    /**
     * @default 'All Photos'
     */
    m8UFC: T;

    /**
     * @default 'Event Photos unlocked!'
     */
    z1rqL: T;

    /**
     * @default 'Current plan'
     */
    QnlvV: T;

    /**
     * @default 'Included'
     */
    uXyQw: T;

    /**
     * @default 'Manage Plans'
     */
    fwYlt: T;

    /**
     * @default 'Albums'
     */
    cuntj: T;

    /**
     * @default 'Are you still there?'
     */
    OzDeN: T;

    /**
     * @default 'Photo updates have been paused.'
     */
    MpjtH: T;

    /**
     * @default 'Continue Slideshow'
     */
    '7kjfT': T;

    /**
     * @default 'Share a photo'
     */
    '4X5YB': T;

    /**
     * @default 'This album is no longer available.'
     */
    YCjHl: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    dVCSs: T;

    /**
     * @default 'An error occurred while updating who can see this album. Please try again.'
     */
    q9Kna: T;

    /**
     * @default 'An error occurred while updating guest uploads. Please try again.'
     */
    aAIu5: T;

    /**
     * @default 'Photo removed from album.'
     */
    Fxj0g: T;

    /**
     * @default 'Failed to remove photo.'
     */
    YfPx6: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Preparing your download…'
     */
    '1Ch6p': T;

    /**
     * @default 'An error occurred while downloading your photos. Please try again.'
     */
    '0W6Qz': T;

    /**
     * @default '1 photo couldn't be downloaded and is missing from the zip.'
     */
    uGiFU: T;

    /**
     * @default '{{0}} photos couldn't be downloaded and are missing from the zip.'
     */
    Sjrv4: T;

    /**
     * @default 'Failed to load reorder tools. Please try again.'
     */
    '92yVD': T;

    /**
     * @default 'Failed to switch to custom order. Please try again.'
     */
    jZMFD: T;

    /**
     * @default 'An error occurred while loading photos. Please try again.'
     */
    lOWxK: T;

    /**
     * @default 'Upload Your Photos'
     */
    heJjO: T;

    /**
     * @default 'Add as many as you'd like to easily access them and add to your site.'
     */
    '2G9cX': T;

    /**
     * @default 'Remove from album'
     */
    vwTJs: T;

    /**
     * @default 'Quick actions'
     */
    kbGPU: T;

    /**
     * @default 'Slideshow'
     */
    muiCH: T;

    /**
     * @default 'Create gallery page'
     */
    h8KWi: T;

    /**
     * @default 'Manage Album'
     */
    UbvYs: T;

    /**
     * @default 'Photo has been deleted'
     */
    XG519: T;

    /**
     * @default 'Failed to delete photo.'
     */
    VTRSR: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    h4DHM: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    bJz4t: T;

    /**
     * @default 'Photos added to album.'
     */
    fVd3i: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Add Page'
     */
    u0IsO: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Global'
     */
    fNvoz: T;

    /**
     * @default 'App Photo'
     */
    bmHWB: T;

    /**
     * @default 'Photo background for iOS and Android mobile apps'
     */
    a5j3o: T;

    /**
     * @default 'Event Share Link'
     */
    p3CKJ: T;

    /**
     * @default 'Link preview image when sharing on messaging apps'
     */
    '29Jqn': T;

    /**
     * @default 'Edit your Welcome photo'
     */
    vwR18: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Your Welcome page photo is part of your Website Header. We'll take you to the Website Layout editor to update it there.'
     */
    lQa5u: T;

    /**
     * @default 'Everyone's photos, one shared album'
     */
    krDSp: T;

    /**
     * @default 'Every guest captures a different part of the day. Collect the moments you'd otherwise miss, no app required.'
     */
    CzuXL: T;

    /**
     * @default 'Create live album'
     */
    J89IN: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Show photos full screen on any TV or projector. New ones appear as you approve them.'
     */
    zxg5e: T;

    /**
     * @default 'Guest uploads via QR code'
     */
    EtVYO: T;

    /**
     * @default 'Guests scan and upload from their phones — no app or login needed.'
     */
    mL9eI: T;

    /**
     * @default 'You approve every photo'
     */
    ljOvn: T;

    /**
     * @default 'Review and approve in seconds — nothing appears without you.'
     */
    '6e6DR': T;

    /**
     * @default 'Go live at your event'
     */
    yfc5r: T;

    /**
     * @default 'Turn your album into a real-time slideshow guests contribute to — with full control over what's shown.'
     */
    uWbyW: T;

    /**
     * @default 'Pricing is unavailable.'
     */
    Ou0TV: T;

    /**
     * @default 'Please try again later.'
     */
    Fn2ol: T;

    /**
     * @default 'One-time purchase per album. Your existing albums are always free.'
     */
    emZKd: T;

    /**
     * @default 'Collect guest photos as they happen.'
     */
    LybKo: T;

    /**
     * @default 'One private album for your event, shared on your website and in the Joy app. Bring it to the big screen with a live slideshow.'
     */
    ecU8J: T;

    /**
     * @default 'Start Live Album'
     */
    TO87q: T;

    /**
     * @default 'Album was activated but we couldn't set it up. Please refresh and try again.'
     */
    ZCuod: T;

    /**
     * @default 'Live Album activated!'
     */
    L4RBs: T;

    /**
     * @default 'Something went wrong with checkout. Please try again.'
     */
    MYTVo: T;

    /**
     * @default 'Reorder Photos'
     */
    syK8I: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Download All'
     */
    flldB: T;

    /**
     * @default 'Reorder'
     */
    hdbmf: T;

    /**
     * @default 'Album'
     */
    jvLeF: T;

    /**
     * @default 'An error occurred while updating likes. Please try again.'
     */
    uYdcI: T;

    /**
     * @default 'An error occurred while updating comments. Please try again.'
     */
    KrJf0: T;

    /**
     * @default 'Album Visibility:'
     */
    T6tCX: T;

    /**
     * @default 'Guest Uploads:'
     */
    EJyeJ: T;

    /**
     * @default 'Likes:'
     */
    QxRoC: T;

    /**
     * @default 'Comments:'
     */
    StsDD: T;

    /**
     * @default 'Sort:'
     */
    whR6G: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    JG58J: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Anyone who can open your wedding website can see this album.'
     */
    kju8j: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Only people with the direct album link can see it.'
     */
    '6zbtQ': T;

    /**
     * @default 'Allowed'
     */
    QsEaR: T;

    /**
     * @default 'Guests can add photos from their phone or by scanning the QR code.'
     */
    zkTgk: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Only you can add photos to this album.'
     */
    l6ECE: T;

    /**
     * @default 'Gallery page created and added to your website.'
     */
    r5HBp: T;

    /**
     * @default 'An error occurred while making the album public. Please try again.'
     */
    MXkdE: T;

    /**
     * @default 'Page creation failed. The album was made public but could not be reverted — check your album settings.'
     */
    EqRcR: T;

    /**
     * @default 'Your website has reached the maximum number of pages. Delete a page you no longer need, then try again.'
     */
    r4wuN: T;

    /**
     * @default 'An error occurred while creating the gallery page. Please try again.'
     */
    FGanv: T;

    /**
     * @default 'On'
     */
    zrAAA: T;

    /**
     * @default 'Guests can leave comments. You can remove any comment.'
     */
    KX66Q: T;

    /**
     * @default 'Off'
     */
    hRXAA: T;

    /**
     * @default 'Comments are hidden and no new ones can be added.'
     */
    aavo3: T;

    /**
     * @default 'Guests can like photos, and like counts are visible to everyone.'
     */
    FdGeG: T;

    /**
     * @default 'Photos are shown without likes.'
     */
    kXaUc: T;

    /**
     * @default 'Failed to save photo order. Please try again.'
     */
    s5kpT: T;

    /**
     * @default 'Newest uploaded'
     */
    UaXXa: T;

    /**
     * @default 'Oldest uploaded'
     */
    lknux: T;

    /**
     * @default 'Newest photo date'
     */
    AvhbR: T;

    /**
     * @default 'Oldest photo date'
     */
    '5zYIS': T;

    /**
     * @default 'Approval Status'
     */
    '50UPc': T;

    /**
     * @default 'Custom'
     */
    ZzYxp: T;

    /**
     * @default 'approved'
     */
    F0JoK: T;

    /**
     * @default 'rejected'
     */
    gjtLV: T;

    /**
     * @default '{{0}} of {{1}} photos {{2}}. Some photos were skipped.'
     */
    t4gVh: T;

    /**
     * @default 'Photo {{0}}.'
     */
    iPDHE: T;

    /**
     * @default '{{0}} photos {{1}}.'
     */
    OP3Wz: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Unlock with an upgrade'
     */
    x5YKN: T;

    /**
     * @default 'An error occurred while copying the link. Please try again.'
     */
    ULI7s: T;

    /**
     * @default 'Upload from your computer or phone'
     */
    qgw1R: T;

    /**
     * @default 'Link & QR Code'
     */
    qAWuq: T;

    /**
     * @default 'Copy link'
     */
    Xn2zA: T;

    /**
     * @default 'Download QR'
     */
    lZYNp: T;

    /**
     * @default 'QR code downloaded.'
     */
    '7vyR5': T;

    /**
     * @default 'An error occurred while downloading the QR code. Please try again.'
     */
    dHVKc: T;

    /**
     * @default 'Scan the QR code or share the link so guests can view this album.'
     */
    e3MNv: T;

    /**
     * @default 'QR code to view this album'
     */
    Dz8R6: T;

    /**
     * @default 'Copy a link or download a QR code'
     */
    '8l8aH': T;

    /**
     * @default 'Rename album'
     */
    pA6XH: T;

    /**
     * @default 'Album renamed.'
     */
    '7qTdf': T;

    /**
     * @default 'Change the name guests see'
     */
    wK75O: T;

    /**
     * @default 'Album visibility updated.'
     */
    '01njW': T;

    /**
     * @default 'Album visibility'
     */
    t470B: T;

    /**
     * @default 'Control who can see this album'
     */
    TGYeB: T;

    /**
     * @default 'Guest uploads updated.'
     */
    l2x9g: T;

    /**
     * @default 'Let guests add their own photos'
     */
    M3KEN: T;

    /**
     * @default 'Likes updated.'
     */
    HRSK3: T;

    /**
     * @default 'Allow guests to “like” photos'
     */
    waFzI: T;

    /**
     * @default 'Comments updated.'
     */
    Zh12C: T;

    /**
     * @default 'Comments'
     */
    aO8BG: T;

    /**
     * @default 'Allow guests to comment on photos'
     */
    G8z2g: T;

    /**
     * @default 'Download all'
     */
    jpudB: T;

    /**
     * @default 'Full-resolution originals'
     */
    UM2nS: T;

    /**
     * @default 'Web-sized copies, not the originals'
     */
    R72iH: T;

    /**
     * @default 'Add album as gallery page'
     */
    VX1EO: T;

    /**
     * @default 'Create page'
     */
    li4eS: T;

    /**
     * @default 'Make public & create page'
     */
    mx6xV: T;

    /**
     * @default 'Please use letters or numbers in the page name.'
     */
    vQxPJ: T;

    /**
     * @default 'Show this album on your website'
     */
    BUC78: T;

    /**
     * @default 'Start slideshow'
     */
    axike: T;

    /**
     * @default 'Show photos live on any TV or projector'
     */
    UhlQB: T;

    /**
     * @default 'Create a new custom page with this album's photos as a gallery.'
     */
    ykju8: T;

    /**
     * @default 'Page Name'
     */
    Cq4sf: T;

    /**
     * @default 'This will appear in your website navigation'
     */
    sbxpq: T;

    /**
     * @default 'This album is private. Gallery pages require public albums. Creating this page will make the album public.'
     */
    DIu5X: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Couldn't download the QR code. Please try again.'
     */
    skQPE: T;

    /**
     * @default 'Share album'
     */
    Cn2p6: T;

    /**
     * @default 'Download QR code'
     */
    eCTQl: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Album name'
     */
    MpstX: T;

    /**
     * @default 'Guests see this above the album's photos.'
     */
    CX21F: T;

    /**
     * @default 'Transition duration (seconds)'
     */
    ndpoE: T;

    /**
     * @default 'Show QR code'
     */
    nQmab: T;

    /**
     * @default 'Guests can scan it to add their own photos'
     */
    a52DA: T;
  };
};

export type WebsitePreviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  websitePreview: {
    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Save and Open'
     */
    saveAndOpen: T;

    /**
     * @default 'Sorry but your theme is no longer available to preview.'
     */
    themeNotSupportedText: T;

    /**
     * @default 'Learn Why'
     */
    themeNotSupportedButton: T;

    titlePreview: {
      /**
       * @default 'Preview Website'
       */
      desktop: T;

      /**
       * @default 'Preview Mobile'
       */
      mobile: T;

      /**
       * @default 'Preview Stationery'
       */
      stationery: T;
    };
    stationery: {
      /**
       * @default 'Explore Matching Prints'
       */
      explorePrints: T;

      /**
       * @default 'Select unique print stationery from'
       */
      selectUnique: T;

      /**
       * @default 'Or pair your theme with free matching digital stationery'
       */
      digitalOption: T;

      /**
       * @default 'Pair your theme with free matching digital stationery'
       */
      digitalOptionPair: T;

      /**
       * @default 'Create Save the Date'
       */
      saveTheDate: T;

      /**
       * @default 'Create Invitation'
       */
      invitation: T;
    };
  };
};

export type WebsiteV2AdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Website Editor'
     */
    '4bCWI': T;

    /**
     * @default 'Untitled website'
     */
    GfRY7: T;

    /**
     * @default 'Switch website'
     */
    '9CH0N': T;

    /**
     * @default 'Live'
     */
    gS7LA: T;

    /**
     * @default 'New Website'
     */
    hOc3E: T;

    /**
     * @default 'Copying V2 styles back to V1 isn't built yet.'
     */
    '3tkjR': T;

    /**
     * @default 'Copies the live V1 colors, fonts, art and header onto your V2 site, overwriting its current styles.'
     */
    v8ctp: T;

    /**
     * @default 'Your current V2 site was AI-generated and can't take V1 styles. This creates a new Brannan site with your live V1 colors, fonts, art and header, then switches.'
     */
    TTJrX: T;

    /**
     * @default 'No V2 site exists yet. This creates one from the Brannan template with your live V1 colors, fonts, art and header, then switches.'
     */
    '8qEYm': T;

    /**
     * @default 'Switch back to Website V1'
     */
    irhia: T;

    /**
     * @default 'Switch to Website V2'
     */
    kQZTM: T;

    /**
     * @default 'Flips the useWebsiteV2 event flag. Guests follow immediately (up to a few minutes of CDN lag), and you can switch back any time.'
     */
    GHmhU: T;

    /**
     * @default 'Shared either way, nothing to migrate'
     */
    anNFK: T;

    /**
     * @default 'Schedule, wedding party, FAQ, accommodations, event details, registry, RSVP.'
     */
    eMhmJ: T;

    /**
     * @default 'Stays with the site you leave'
     */
    CZ04L: T;

    /**
     * @default 'Styles, V2 welcome / story / travel / gallery text and custom sections, V1 custom pages, custom CSS and art.'
     */
    FEHvE: T;

    /**
     * @default 'We couldn't load your website. Close this dialog and try again.'
     */
    KIyT4: T;

    /**
     * @default 'We couldn't load your design details. You can still switch without copying styles.'
     */
    dS0to: T;

    /**
     * @default 'Parts of your V1 design that V2 can't carry yet'
     */
    s0Jg2: T;

    /**
     * @default '{{0}} · not carried'
     */
    CCVG4: T;

    /**
     * @default '{{0}} · carried with changes'
     */
    '2ebk0': T;

    /**
     * @default 'Just switch'
     */
    '6RgQQ': T;

    /**
     * @default 'Create site & switch'
     */
    RsAf8: T;

    /**
     * @default 'Copy styles & switch'
     */
    V5Lnk: T;

    /**
     * @default 'Styles copied with {{0}} warning(s) — some V1 design fields had no V2 home.'
     */
    '1Xo26': T;

    /**
     * @default 'Couldn't copy your V1 styles onto the V2 site. Nothing was switched.'
     */
    aJrjF: T;

    /**
     * @default 'The Brannan template isn't available in this environment, so no site was created. Nothing was switched.'
     */
    n8PFA: T;

    /**
     * @default 'Couldn't create a V2 site from your V1 design. Nothing was switched.'
     */
    XcEw2: T;

    /**
     * @default 'Couldn't switch this event to Website V2.'
     */
    UEd1w: T;

    /**
     * @default 'Couldn't switch this event back to Website V1.'
     */
    '0G8Ks': T;

    /**
     * @default 'Switched back to Website V1.'
     */
    tbCxw: T;

    /**
     * @default 'Your new website is ready.'
     */
    nszyQ: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'We're designing your website…'
     */
    mYt8b: T;

    /**
     * @default 'Your pages are being laid out and styled right now. This usually takes a few minutes. Feel free to explore the rest of Joy while we get ready for you.'
     */
    PjtkL: T;

    /**
     * @default 'We couldn't finish this website.'
     */
    y8TwR: T;

    /**
     * @default 'Something went wrong while it was being generated. You can start a new one.'
     */
    UQiX3: T;

    /**
     * @default 'Create Website'
     */
    hTJjk: T;

    /**
     * @default 'This event doesn't have a website yet.'
     */
    Y1AL1: T;

    /**
     * @default 'Your Wedding'
     */
    fDMR7: T;

    /**
     * @default 'Your Event'
     */
    '716jP': T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Close {{0}}'
     */
    QRw7E: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Fit to window'
     */
    '4hQny': T;

    /**
     * @default 'Desktop preview'
     */
    kownU: T;

    /**
     * @default 'Mobile preview'
     */
    cfTQh: T;

    /**
     * @default 'Preview size'
     */
    JOwak: T;

    /**
     * @default 'Assistant isn't available for this website'
     */
    cxKCG: T;

    /**
     * @default 'Close assistant'
     */
    Y271a: T;

    /**
     * @default 'Open assistant'
     */
    oErQM: T;

    /**
     * @default 'Assistant'
     */
    '6KheS': T;

    /**
     * @default 'Rename Website'
     */
    BLoiz: T;

    /**
     * @default 'Website Name'
     */
    a34Xk: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Website link copied.'
     */
    n8Djy: T;

    /**
     * @default 'Your website is no longer live.'
     */
    ShCj6: T;

    /**
     * @default 'Rename'
     */
    cCEOS: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'View Site'
     */
    G17zU: T;

    /**
     * @default 'Unpublish website'
     */
    ZG2zs: T;

    /**
     * @default 'Publish website'
     */
    cj1qH: T;

    /**
     * @default 'Unpublish'
     */
    GWCTL: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'More website actions'
     */
    Z3nem: T;

    /**
     * @default 'Unpublish Website?'
     */
    aDS6Q: T;

    /**
     * @default 'Guests won't be able to see your website until you publish it again. Nothing you've made is lost.'
     */
    X6OkN: T;

    /**
     * @default 'Show welcome'
     */
    zpZbA: T;

    /**
     * @default 'Edit right on your website. Change your text, photos, and layout without stepping away from the page.'
     */
    '9kbeP': T;

    /**
     * @default 'Shape your design with AI. Customize your theme, create images, or explore a whole new layout.'
     */
    '1rNl8': T;

    /**
     * @default 'Help us shape what comes next. This early preview is for couples who like trying new things and sharing what could be better.'
     */
    Vxshe: T;

    /**
     * @default 'Welcome to Websites 2'
     */
    vkYmx: T;

    /**
     * @default 'Start editing'
     */
    a2FGu: T;

    /**
     * @default 'Early preview'
     */
    '51gMt': T;

    /**
     * @default 'Play layout animation'
     */
    uRQJn: T;

    /**
     * @default 'Pause layout animation'
     */
    SlXdW: T;

    /**
     * @default 'Payment received. Publishing your website…'
     */
    ihGRC: T;

    /**
     * @default 'Your payment went through, but we're still confirming it. Try publishing again in a minute.'
     */
    QyRtM: T;

    /**
     * @default 'We haven't received your payment yet. If you completed it, it can take a few minutes to confirm, so try again in a minute.'
     */
    HXWiG: T;

    /**
     * @default 'Your payment went through, but we couldn't publish your website.'
     */
    chRDm: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Back to Payment'
     */
    Qx1eA: T;

    /**
     * @default 'Share with Guests'
     */
    otZHN: T;

    /**
     * @default 'Publish now. Republishing is free.'
     */
    hUEb8: T;

    /**
     * @default 'Keep Editing with AI'
     */
    VrUaV: T;

    /**
     * @default 'Ask for changes in your own words.'
     */
    Qtybp: T;

    /**
     * @default 'Every Website for This Event'
     */
    boVmn: T;

    /**
     * @default 'One purchase covers them all.'
     */
    KzsAn: T;

    /**
     * @default 'Publish with Joy AI Website'
     */
    aOxsw: T;

    /**
     * @default 'You kept editing with AI after your free AI edits, so publishing needs a one-time purchase for your event.'
     */
    '9hoTt': T;

    /**
     * @default 'Joy AI Website isn't available right now. Please try again later.'
     */
    QeYK9: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Unlock & Publish'
     */
    f9VQR: T;

    /**
     * @default 'Your website is live.'
     */
    MavdZ: T;

    /**
     * @default 'Your website is live, but another website could not be unpublished. Open it from the website menu and unpublish it.'
     */
    VcCh9: T;

    /**
     * @default 'We couldn't confirm your Joy AI Website purchase. Try publishing again in a moment.'
     */
    r8uey: T;

    /**
     * @default 'Something went wrong publishing your website. Please try again.'
     */
    tO3bt: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Where to Stay didn't load.'
     */
    ZnHml: T;

    /**
     * @default 'Your Website'
     */
    kTfJ7: T;

    /**
     * @default 'Open in editor'
     */
    WjiRU: T;

    /**
     * @default 'Sections'
     */
    I0Ub3: T;

    /**
     * @default 'Drag to reorder. Choose what appears on your website and in its menu.'
     */
    FzYYG: T;

    /**
     * @default 'Shown'
     */
    HSN5G: T;

    /**
     * @default 'Not in menu'
     */
    XrNFV: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Empty — nothing to show yet.'
     */
    ET618: T;
  };
};

export type WebsiteV2GuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'This website is temporarily unavailable. Please try again in a moment.'
     */
    kuG0Y: T;
  };
};

export type WeddingPartyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  titles: {
    /**
     * @default 'Bride'
     */
    Bride: T;

    /**
     * @default 'Groom'
     */
    Groom: T;

    /**
     * @default 'Bridesmaid'
     */
    Bridesmaid: T;

    /**
     * @default 'Groomsman'
     */
    Groomsman: T;

    /**
     * @default 'Mother In Law'
     */
    motherInLaw: T;

    /**
     * @default 'Matron of Honor'
     */
    'Matron of Honor': T;

    array: [
      {
        /**
         * @default 'Howdy!'
         */
        greeting: T;

        /**
         * @default '/groom.jpg'
         */
        _url: string;
      },
    ];
  };

  /**
   * @default 'Learn more about {{name}}'
   */
  learnAbout: T;
};

export type YourRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  registrySection: {
    /**
     * @default 'Connected Registries'
     */
    title: T;

    /**
     * @default 'For tracking gifts on your linked registries, visit those registries directly.'
     */
    subtitle: T;

    /**
     * @default 'Drag and drop to reorder your list.'
     */
    dndLabel: T;

    /**
     * @default 'Modify'
     */
    modify: T;

    /**
     * @default 'Reorder List'
     */
    reorder: T;

    /**
     * @default 'Finish'
     */
    finish: T;

    /**
     * @default 'Looks like you haven’t added any registries yet.'
     */
    emptyRegistries: T;

    /**
     * @default 'No worries. Go ahead and <CreateOneLink/>.'
     */
    goAheadAnd: T;

    /**
     * @default 'create one'
     */
    createOne: T;

    /**
     * @default 'Syncing'
     */
    registrySyncing: T;

    /**
     * @default 'Synced'
     */
    registrySynced: T;

    /**
     * @default 'Transferred'
     */
    registryTransferred: T;

    /**
     * @default 'Transferring'
     */
    registryTransferInProgress: T;

    /**
     * @default 'Linked'
     */
    registryLinked: T;

    /**
     * @default 'Update'
     */
    registryUpdate: T;

    /**
     * @default 'Edit'
     */
    actionEdit: T;

    /**
     * @default 'View'
     */
    actionView: T;

    /**
     * @default 'Waiting on updates?'
     */
    registryToolTipText: T;

    /**
     * @default 'Connected registries sync daily.'
     */
    syncDaily: T;

    /**
     * @default '{{count}} External Registries'
     */
    subTitleManageRegistry: T;

    /**
     * @default 'We will display any external registries that you add here on your Joy registry. We also support item syncing for retailers like Amazon and Target and we are continuously adding more stores.'
     */
    helpText: T;

    /**
     * @default 'link an existing registry'
     */
    linkExistingRegistry: T;

    /**
     * @default 'Add Registry'
     */
    addRegistry: T;
  };
  validation: {
    /**
     * @default 'Invalid URL'
     */
    invalidDomain: T;

    /**
     * @default 'Required'
     */
    required: T;
  };
  errorDialog: {
    /**
     * @default 'Connection trouble.'
     */
    titleText: T;

    /**
     * @default 'Apologies, we weren’t able to '
     */
    messageTextStart: T;

    /**
     * @default 'your changes. Please click 'Refresh' to reconnect.'
     */
    messageTextEnd: T;

    /**
     * @default 'Refresh'
     */
    actionText: T;
  };

  /**
   * @default 'Learn More'
   */
  learnMore: T;

  /**
   * @default 'Registry URL'
   */
  registryUrl: T;

  publishPage: {
    /**
     * @default 'Make Registry Visible'
     */
    newTitle: T;

    /**
     * @default 'Allow guests to see your registry'
     */
    info: T;

    /**
     * @default 'On'
     */
    labelOn: T;

    /**
     * @default 'Off'
     */
    labelOff: T;

    /**
     * @default 'Info'
     */
    allyLabel: T;

    /**
     * @default 'Manage Visibility and Sharing'
     */
    newDialogTitle: T;

    /**
     * @default 'Turning this on makes your registry available to gift givers.'
     */
    newToggleDescription: T;

    /**
     * @default 'Registry URL'
     */
    registryUrlLabel: T;

    /**
     * @default 'Add'
     */
    addLink: T;

    /**
     * @default 'Edit'
     */
    editLink: T;

    /**
     * @default 'Save'
     */
    actionButton: T;

    /**
     * @default 'Cancel'
     */
    secondaryButton: T;

    /**
     * @default 'Your registry is visible'
     */
    registryVisibleText: T;

    /**
     * @default 'Your registry is hidden'
     */
    registryHiddenText: T;

    /**
     * @default 'Modify registry visibility'
     */
    registryHoverText: T;

    /**
     * @default '✨ Link Copied ✨'
     */
    linkCopied: T;

    /**
     * @default 'Share it with gift givers so they can shop in one place!'
     */
    linkCopiedDescription: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddressLabel: T;

    /**
     * @default 'Your shipping address is missing. Let gift givers know where to send your gifts.'
     */
    shippingAddressWarning: T;

    /**
     * @default 'Let gift givers know where to send your gifts.'
     */
    emptyShippingAddressMsg: T;
  };
  visibilityDialog: {
    /**
     * @default '{{resource}} Visibility'
     */
    title: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Password Protected'
     */
    passwordProtected: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Please Note:'
     */
    passwordNoteTitle: T;

    /**
     * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordNoteMessage: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'Your password can only contain letters and numbers.'
     */
    passwordError: T;

    /**
     * @default 'Registry'
     */
    registry: T;
  };
  inviteAdminDialog: {
    /**
     * @default 'Registry Admins'
     */
    registryInviteAdminDialogTitle: T;

    /**
     * @default 'Invite Collaborator'
     */
    addAdminTitle: T;

    /**
     * @default 'Revoke Collaborator Invitation'
     */
    revokeAdminInvitationTitle: T;

    /**
     * @default 'Are you sure you want to revoke <fullname/> admin privileges?'
     */
    revokeAdminMessage: T;

    /**
     * @default 'Transfer Ownership'
     */
    transferOwnershipTitle: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to <fullname/>?'
     */
    transferOwnershipMessage: T;

    /**
     * @default '<fullname/> will become the primary account owner for this event and your current account will be downgraded to an admin account.'
     */
    transferOwnershipConfirmation: T;

    /**
     * @default 'Type “{{confirmationWord}}” in the input below to confirm this change'
     */
    transferOwnershipInputLabel: T;

    /**
     * @default 'Owner'
     */
    owner: T;

    /**
     * @default 'Collaborators'
     */
    collaborators: T;

    /**
     * @default 'Transfer'
     */
    transfer: T;

    /**
     * @default 'Revoke'
     */
    revoke: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Done'
     */
    done: T;

    /**
     * @default 'Invite Collaborator'
     */
    inviteNewAdmin: T;

    /**
     * @default 'Add {{page}} Admin'
     */
    addAdmin: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'An email invitation has been sent'
     */
    sentInvitation: T;

    /**
     * @default 'Resend'
     */
    resend: T;

    /**
     * @default 'Pending Invitations'
     */
    pendingInvitations: T;

    /**
     * @default 'Send Invitation'
     */
    sendInvitation: T;

    /**
     * @default 'Confirm Transfer'
     */
    confirmTransfer: T;

    /**
     * @default 'Verify your email address to invite collaborators'
     */
    verifyYourEmail: T;

    /**
     * @default 'First name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Email is required'
     */
    emailRequired: T;

    /**
     * @default 'Invalid email format'
     */
    invalidEmail: T;

    /**
     * @default 'First name'
     */
    firstNameAriaLabel: T;

    /**
     * @default 'First name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last name'
     */
    lastNameAriaLabel: T;

    /**
     * @default 'Last name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailAriaLabel: T;

    /**
     * @default 'email@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'An email invitation has been sent'
     */
    invitationHasBeenSent: T;

    /**
     * @default 'An error occurred while send your invitation'
     */
    errorSendingInvitation: T;

    /**
     * @default 'We resent your invitation'
     */
    weResentYourInvitation: T;

    /**
     * @default 'Please wait a short time to resend this invitation'
     */
    errorResendingYourInvitation: T;

    /**
     * @default 'You have transferred ownership of this Joy event'
     */
    transferredOwnership: T;

    /**
     * @default 'Error transfering ownership'
     */
    errorTransferingOwnership: T;

    /**
     * @default 'This invitation has been cancelled'
     */
    invitationCancelled: T;

    /**
     * @default 'Error cancelling invitation'
     */
    errorCancellingInvitation: T;

    /**
     * @default 'Admin removed'
     */
    adminRemoved: T;

    /**
     * @default 'Error removing admin'
     */
    errorRemovingAdmin: T;
  };
  registryProductRow: {
    /**
     * @default 'Gift Purchased'
     */
    giftPurchased: T;

    /**
     * @default '{{amount}} Reserved'
     */
    giftsPurchased: T;

    /**
     * @default '{{amount}} Requested'
     */
    giftsRequested: T;

    /**
     * @default 'Favorite'
     */
    favorite: T;

    /**
     * @default '{{amount}} Still Needed'
     */
    giftStillNeeded: T;

    rewardPhrasesCompleted: [
      /**
       * @default 'Hooray! 🎉'
       */
      T,
      /**
       * @default 'A fabulous choice! 😍'
       */
      T,
      /**
       * @default 'Purchased with love! 💕'
       */
      T,
      /**
       * @default 'Someone got you this! 🎁'
       */
      T,
      /**
       * @default 'Gift purchased! 💃'
       */
      T,
      /**
       * @default 'Congratulations! 🎊'
       */
      T,
      /**
       * @default 'Oh, the generosity! 🫶'
       */
      T,
      /**
       * @default 'Consider it gifted! 🥳'
       */
      T,
    ];

    /**
     * @default 'Item Still Needed'
     */
    itemStillNeeded: T;

    /**
     * @default 'Items Still Needed'
     */
    itemsStillNeeded: T;

    /**
     * @default 'Reorder Gifts'
     */
    reorderGifts: T;

    /**
     * @default 'Done'
     */
    doneReordering: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved by You'
     */
    reservedByYou: T;

    /**
     * @default 'Purchased by You'
     */
    purchasedByYou: T;

    /**
     * @default 'Reserved by'
     */
    reservedByColumnHeader: T;

    /**
     * @default 'Purchased by'
     */
    purchasedByColumnHeader: T;

    /**
     * @default '{{initialEntry}} & {{remaining}} others...'
     */
    purchasedByOverflow: T;

    /**
     * @default 'Removing gift...'
     */
    removingGift: T;

    /**
     * @default 'Cash Fund'
     */
    categoryCashFundText: T;

    /**
     * @default 'Charity Fund'
     */
    categoryCharityFundText: T;

    /**
     * @default 'Drag to reorder items'
     */
    reorderMessage: T;

    /**
     * @default 'gifted so far'
     */
    giftedSoFarText: T;

    /**
     * @default 'Reorder'
     */
    reorder: T;

    /**
     * @default 'Gift Reserved'
     */
    giftReserved: T;

    /**
     * @default '{{action}} from'
     */
    storeAction: T;

    /**
     * @default '{{store}} Registry'
     */
    storeName: T;

    /**
     * @default 'Remove filters to reorder your items.'
     */
    disabledReorderText: T;

    /**
     * @default ' Hidden Gifts ({{count}}) '
     */
    hideItemText: T;

    /**
     * @default 'New'
     */
    newItem: T;

    /**
     * @default 'Funded'
     */
    funded: T;

    /**
     * @default 'Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Marked as Most Wanted'
     */
    markedAsMostWanted: T;

    /**
     * @default 'Removed as Most Wanted'
     */
    removedAsMostWanted: T;

    /**
     * @default 'Our Most Wanted'
     */
    ourMostWanted: T;
  };
  registryStats: {
    /**
     * @default 'Gifts Added'
     */
    giftsAdded: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Still Needed'
     */
    stillNeeded: T;
  };
  amazonRegistry: {
    /**
     * @default 'Amazon Registry'
     */
    heading: T;

    /**
     * @default 'Last Synced'
     */
    lastSync: T;

    /**
     * @default 'Manage Registry'
     */
    manageReg: T;

    /**
     * @default 'We are grabbing your gifts right now. They’ll be ready to view soon.'
     */
    inProgressSync: T;

    /**
     * @default 'Syncing...'
     */
    syncing: T;
  };
  registry: {
    /**
     * @default ''s Registry'
     */
    heading: T;
  };
  emptyFilter: {
    /**
     * @default 'Cleaned out the aisles'
     */
    stillNeededTitle: T;

    /**
     * @default 'Looks like your guests purchased everything currently on your registry. If you find anything new that suits your fancy, add  them your registry so there are items for all your guests to buy.'
     */
    stillNeededSubtitle: T;

    /**
     * @default 'Nothing gifted yet'
     */
    purchasedTitle: T;

    /**
     * @default 'Once your guests purchase items on your registry,  you'll see the items here.'
     */
    purchasedSubtitle: T;

    /**
     * @default 'Looks like you don’t have any favorites yet'
     */
    favoriteTitle: T;

    /**
     * @default 'That’s totally cool, but if you did they’d show up here to help your guests purchase what you really want.'
     */
    favoriteSubtitle: T;

    /**
     * @default 'Looks like you don’t have any items on your registry'
     */
    defaultTitle: T;

    /**
     * @default 'Please add items to your registry'
     */
    defaultSubTitle: T;

    /**
     * @default 'No gifts added yet'
     */
    noSyncableRegistryTitle: T;

    /**
     * @default 'Once you add gifts or sync a registry, they will appear here.'
     */
    noSyncableRegistrySubtitle: T;
  };
  publishRegistryItems: {
    /**
     * @default 'Display Gifts In Registry'
     */
    title: T;

    /**
     * @default 'Show or hide products synced from this registry. If products are not displayed, guests can still shop for them using the external registry link.'
     */
    info: T;

    /**
     * @default 'Show'
     */
    labelOn: T;

    /**
     * @default 'Hide'
     */
    labelOff: T;
  };
  filterSectionRegistry: {
    /**
     * @default 'Everything'
     */
    everything: T;

    /**
     * @default 'Gifts Available'
     */
    stillNeeded: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Reserved & Purchased'
     */
    reservedAndPurchased: T;
  };
  productDialog: {
    /**
     * @default 'Gift added from {{storeName}}'
     */
    giftAddedFrom: T;

    /**
     * @default 'To edit or remove this gift you’ll need to do it on your'
     */
    alertEditRegistry: T;

    /**
     * @default 'linked registry'
     */
    linkRegistry: T;

    /**
     * @default 'Remove from Registry'
     */
    removedCustomItem: T;

    /**
     * @default 'was removed from your registry.'
     */
    giftRemoved: T;

    /**
     * @default 'Edit Gift'
     */
    giftEditDetails: T;
  };
  productListHeaderButtons: {
    /**
     * @default 'Add Gift'
     */
    addGift: T;

    /**
     * @default 'Add Gifts'
     */
    addGiftV2: T;

    /**
     * @default 'Filter By'
     */
    filterBy: T;

    /**
     * @default 'Manage Gifts'
     */
    title: T;

    /**
     * @default 'New Gift'
     */
    newGift: T;
  };
  notification: {
    /**
     * @default 'Notifications'
     */
    title: T;

    bankAccount: {
      /**
       * @default 'Connect your bank account to allow guests to give by credit card.'
       */
      primaryText: T;

      /**
       * @default 'Guests prefer the flexibility of giving to cash funds by card, and right now they can't.'
       */
      secondaryText: T;
    };
  };
  giftTypeOptionsButtons: {
    /**
     * @default 'Product'
     */
    product: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default 'Charity'
     */
    charity: T;
  };
  addGiftFromUrl: {
    /**
     * @default 'Save time and <browserButtonCta/> or <appCta/>
'
*/
    saveTime: T;

    /**
     * @default 'install the browser button
'
*/
    browserButtonCta: T;

    /**
     * @default 'get the app'
     */
    appCta: T;

    /**
     * @default 'Continue adding from
'
*/
    continueAdding: T;
  };
  addressDialog: {
    /**
     * @default 'Edit shipping address'
     */
    editShippingAddressButton: T;

    /**
     * @default 'Your shipping address'
     */
    yourShippingAddressButton: T;

    /**
     * @default 'Shipping Settings'
     */
    shippingSettingsTitle: T;

    /**
     * @default 'With Joy, you choose when your gifts ship.'
     */
    shippingControlMessageTitle: T;

    /**
     * @default 'You’re in control with gifts fulfilled by Joy. We’ll hold them until you’re ready to ship.'
     */
    shippingControlMessageDescription: T;

    /**
     * @default ' Learn More'
     */
    learnMore: T;

    /**
     * @default 'Let gift givers know where to send their gifts.'
     */
    note: T;

    /**
     * @default 'Items sold by Joy are only shippable within the contiguous U.S. (excludes Alaska/Hawaii).'
     */
    shippingPolicyExceptions: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Phone'
     */
    phone: T;

    /**
     * @default 'Only one recipient name is recommended'
     */
    nameCaption: T;

    /**
     * @default 'Address Line 1'
     */
    address1: T;

    /**
     * @default 'We cannot ship to P.O. boxes'
     */
    poBoxWarningCaption: T;

    /**
     * @default 'Address Line 2'
     */
    address2: T;

    /**
     * @default 'City/Town'
     */
    city: T;

    /**
     * @default 'State/Province/County'
     */
    state: T;

    /**
     * @default 'Postal/Zip code'
     */
    postalCode: T;

    /**
     * @default 'Country/Region'
     */
    country: T;

    /**
     * @default 'Country Code'
     */
    countryCode: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Clear Address'
     */
    resetButton: T;

    /**
     * @default '*Required fields'
     */
    requiredFields: T;

    /**
     * @default 'Other'
     */
    countryOtherByCode: T;

    /**
     * @default 'Confirm Shipping Address'
     */
    addressConfirmationTitle: T;

    /**
     * @default 'To ensure accurate delivery, we suggest the slightly modified address below. Please select the address you’d like to use.'
     */
    addressConfirmationNote: T;

    /**
     * @default 'Original Address'
     */
    originalAddressText: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddressText: T;

    /**
     * @default 'Back'
     */
    backButton: T;

    /**
     * @default 'Confirm Address'
     */
    confirmButton: T;

    /**
     * @default 'Full name'
     */
    fullName: T;

    /**
     * @default '555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Address'
     */
    address: T;

    /**
     * @default 'Apartment, suite, etc. (optional)'
     */
    addressPlaceholder2: T;
  };
  delayShipping: {
    /**
     * @default 'You decide when you want your gifts to ship. Exclusively for gifts sold by Joy.'
     */
    delayShippingDescription: T;

    /**
     * @default 'Note: Previously delayed gifts will need your review before they can be shipped.'
     */
    widgetCounterNoteMessage: T;

    /**
     * @default 'Gifts to Review'
     */
    counterLabel: T;

    /**
     * @default 'Review and Ship'
     */
    reviewAndShip: T;

    /**
     * @default 'Activate Delay Shipping'
     */
    activateDelayShippingTitle: T;

    /**
     * @default 'Deactivate Delay Shipping'
     */
    deactivateDelayShippingTitle: T;

    /**
     * @default 'By enabling Delay Shipping, any new orders you receive will not be shipped until you give us the go-ahead. You can easily turn off Delay Shipping from the Track page at any time. Are you sure you want to confirm this action?'
     */
    activateDelayShippingDescription: T;

    /**
     * @default 'You are about to disable Delay Shipping. Newly placed orders will ship automatically as soon as they’re received. Previously delayed orders must still be shipped from the Gift Tracker.'
     */
    deactivateDelayShippingDescription: T;

    /**
     * @default 'Got it'
     */
    confirmButton: T;

    /**
     * @default ' Newly received gifts will ship automatically unless Delay Shipping is on. Please note: toggling delay shipping only impacts new orders. Existing delayed orders will still require action.'
     */
    tooltipDescription: T;

    /**
     * @default 'Delay Shipping is '
     */
    toggleLabel: T;

    /**
     * @default 'Confirm Shipping'
     */
    confirmShipping: T;

    /**
     * @default 'Ship Order Now'
     */
    shipOrderNow: T;

    /**
     * @default 'Ship {{count}} Orders'
     */
    shipOrdersNow: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Review Orders'
     */
    reviewOrders: T;

    /**
     * @default 'Your order is being processed.'
     */
    inProcessSingular: T;

    /**
     * @default 'Your orders are being processed.'
     */
    inProcessPlural: T;

    /**
     * @default 'Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was processed. We’ll send you an email once it ships!'
     */
    inProcessDescription: T;

    /**
     * @default 'Show Details'
     */
    showDetailsText: T;

    /**
     * @default 'Hide Details'
     */
    hideDetailsText: T;

    /**
     * @default 'You have {{count}} Orders Pending Shipment'
     */
    countMessage: T;

    /**
     * @default 'Shipping to:'
     */
    shipTo: T;

    /**
     * @default 'One or more orders was placed with an old shipping address. Which address would like to use?'
     */
    shippingConflict: T;

    /**
     * @default 'Please select if you’d prefer this address:'
     */
    newAddressOnFile: T;

    /**
     * @default 'Mmm... Something went wrong. Please try again or contact support'
     */
    mutationGenericError: T;

    /**
     * @default 'Shipping is limited to the continental USA; PO boxes are not eligible.'
     */
    invalidShippingAddress: T;

    /**
     * @default 'When we receive your order, we will begin to process shipping for your available items.'
     */
    shipWhatWeCanNotice: T;
  };
  delayShippingV2: {
    /**
     * @default 'You have gifts ready to ship.'
     */
    enabledDelayShippingTitle: T;

    /**
     * @default 'You decide when gifts ship.'
     */
    disabledDelayShippingTitle: T;

    /**
     * @default 'You’re in control with gifts sold by Joy. We’ll hold them until you’re ready to ship.'
     */
    delayShippingDescription: T;

    /**
     * @default 'Gifts Ready to Ship'
     */
    enabledCounterLabel: T;

    /**
     * @default 'No gifts are ready to ship.'
     */
    disabledCounterLabel: T;

    /**
     * @default 'Review and Ship'
     */
    reviewAndShip: T;
  };
  giftProgressTracker: {
    progressBarStateStart: [
      /**
       * @default 'Let's get it started!'
       */
      T,
      /**
       * @default 'Start your engines!'
       */
      T,
      /**
       * @default 'It's good to have goals!'
       */
      T,
      /**
       * @default 'There is so much potential here!'
       */
      T,
    ];

    progressBarStateComplete: [
      /**
       * @default 'We did it! 🎉'
       */
      T,
      /**
       * @default 'Cash fund complete! ✅'
       */
      T,
      /**
       * @default 'Mission accomplished! 🏆'
       */
      T,
      /**
       * @default 'Goal crushed! ⭐️'
       */
      T,
      /**
       * @default 'Time to celebrate! 🎊'
       */
      T,
    ];

    /**
     * @default '{{goal}} Goal'
     */
    cashGiftLabel: T;

    /**
     * @default '{{goal}} Goal Reached!'
     */
    cashGiftLabelComplete: T;

    /**
     * @default '{{amount}} Received'
     */
    cashGiftProgress: T;

    /**
     * @default '{{amount}}'
     */
    cashGiftProgressV2: T;

    /**
     * @default '{{amount}} Gifted'
     */
    groupGiftProgress: T;

    /**
     * @default '{{requested}} Requested'
     */
    physicalGiftLabel: T;

    /**
     * @default '{{requested}} Received!'
     */
    physicalGiftLabelComplete: T;

    /**
     * @default '{{purchased}} of {{requested}} reserved/purchased'
     */
    physicalGiftProgress: T;

    /**
     * @default '{{amount}} still needed'
     */
    remainingText: T;

    /**
     * @default '{{amount}} Goal'
     */
    remainingTextV2: T;

    /**
     * @default '{{amount}} Contribution'
     */
    contributionText: T;

    /**
     * @default '{{amount}} Contributed'
     */
    contributedText: T;

    /**
     * @default 'Contribute what you wish'
     */
    contributionAnyAmountText: T;

    /**
     * @default 'Group Gift'
     */
    groupGifting: T;
  };
  customItemDetailsDialog: {
    /**
     * @default 'Payment via {{provider}} @{{handle}}'
     */
    paymentSource: T;

    /**
     * @default 'Fulfilled by {{retailer}}'
     */
    fulfillmentSource: T;

    /**
     * @default 'No one has purchased this (yet).'
     */
    zeroStateMsgHeader: T;

    /**
     * @default 'After someone has purchased this gift, you'll be able to see it here.'
     */
    zeroStateMsgBody: T;

    /**
     * @default 'Edit Gift'
     */
    editGiftButton: T;

    /**
     * @default 'Remove from Registry'
     */
    removeGiftButton: T;

    /**
     * @default 'Remove registry gift?'
     */
    removeGiftDialogHeader: T;

    /**
     * @default 'This item will be permanently deleted from your registry.'
     */
    removeGiftDialogBody: T;

    /**
     * @default 'Nevermind'
     */
    cancelRemoveGiftButton: T;

    /**
     * @default 'Are you sure you want to remove this gift?'
     */
    removeGiftDialogHeaderHasPurchases: T;

    /**
     * @default 'Someone has already reserved it, and they (or your future self) may be confused if you delete it from your registry.'
     */
    removeGiftDialogBodyHasPurchases: T;

    /**
     * @default 'gifted so far'
     */
    giftedSoFarText: T;

    /**
     * @default 'View Item on {{storeName}}'
     */
    viewOnWebsite: T;

    /**
     * @default 'View Contribution link'
     */
    contributionLink: T;

    /**
     * @default 'cash'
     */
    cash: T;

    /**
     * @default 'Gift Message'
     */
    noteLabel: T;

    /**
     * @default 'and Cash/Check'
     */
    cashOrCheckFulfillmentText: T;

    /**
     * @default 'Credit card'
     */
    creditCardFullfillmentText: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteToFamilyTitle: T;

    /**
     * @default 'Tracking Unavailable on Joy'
     */
    noTrackingTitle: T;

    /**
     * @default 'This item was purchased on an external registry prior to being transferred to Joy.'
     */
    noTrackingSubtitle: T;

    /**
     * @default 'To track this gift, please refer to your'
     */
    noTrackingPreText: T;

    /**
     * @default 'external'
     */
    noTrackingExternalText: T;

    /**
     * @default 'registry.'
     */
    noTrackingPostText: T;

    /**
     * @default 'This gift cannot be removed from your registry because it has been reserved or purchased.'
     */
    cannotRemoveExplanation: T;

    /**
     * @default 'Hide Gift'
     */
    hideButton: T;

    /**
     * @default 'Show on Registry'
     */
    showButton: T;

    /**
     * @default '🙈 {{title}} has been hidden from your registry.'
     */
    hideTostText: T;

    /**
     * @default '{{title}} is now being shown on your registry.'
     */
    showTostText: T;
  };
  cancelReservationDialog: {
    /**
     * @default 'Are you sure you want to cancel this reservation?'
     */
    cancelReservationHeader: T;

    /**
     * @default 'This will make the gift available for reservation on your registry again.'
     */
    cancelReservationBody: T;

    /**
     * @default 'Nevermind'
     */
    cancelReservationCancelButton: T;

    /**
     * @default 'Confirm Cancellation'
     */
    cancelReservationConfirmButton: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservationButtonText: T;
  };
  cashFundPreviewSendEmailReminderDialog: {
    /**
     * @default 'Missing your cash gift?'
     */
    header: T;

    /**
     * @default 'Joy can send a friendly reminder to {{guestName}}.'
     */
    body: T;

    /**
     * @default 'EMAIL PREVIEW'
     */
    emailPreview: T;

    /**
     * @default 'From:'
     */
    from: T;

    /**
     * @default ' Joy'
     */
    joy: T;

    /**
     * @default 'To:'
     */
    to: T;

    /**
     * @default '{{guestName}}'
     */
    toText: T;

    /**
     * @default 'Subject:'
     */
    subject: T;

    /**
     * @default ' Following up on your gift for {{eventName}}'
     */
    subjectText: T;

    /**
     * @default 'Reminder Sent'
     */
    successText: T;

    /**
     * @default 'Haven't received this gift?'
     */
    haventReceivedTitle: T;

    /**
     * @default 'Joy can send a reminder email to your guest for you. You'll see a preview first.'
     */
    haventReceivedDescription: T;

    /**
     * @default 'Still have questions?'
     */
    stillHaveQuestions: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Send Reminder from Joy'
     */
    confirmButton: T;

    /**
     * @default 'Sample Email:'
     */
    sampleText: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;
  };
  previewSendEmailReminderDialog: {
    /**
     * @default 'Need tracking info for your gift? We’ve got you.'
     */
    header: T;

    /**
     * @default 'We’ll send a one-time email to your guest to request the Order ID, Tracking Number and Shipping Carrier for this gift. Once provided, the information will appear in your gift tracker.'
     */
    body: T;

    /**
     * @default 'Your guest may have forgotten to complete the gift reservation process. If you’d like, we’ll send them a friendly nudge. The email will come right from Joy, they won’t ever know you asked us to remind them.'
     */
    bodyCashFundOrCharity: T;

    /**
     * @default 'Sample Email:'
     */
    sampleText: T;

    /**
     * @default 'unknown'
     */
    unknown: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Send Request'
     */
    confirmButton: T;

    /**
     * @default 'Haven’t received your gift yet? We can send a reminder email to your guest for you.'
     */
    prompt: T;

    /**
     * @default 'Preview and Send Reminder'
     */
    buttonText: T;

    /**
     * @default 'Reminder Sent'
     */
    successText: T;

    /**
     * @default 'Haven't received this gift?'
     */
    haventReceivedTitle: T;

    /**
     * @default 'Joy can send a reminder email to your guest for you. You'll see a preview first.'
     */
    haventReceivedDescription: T;

    /**
     * @default 'Still have questions?'
     */
    stillHaveQuestions: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;
  };
  reminderSentConfirmationDialog: {
    /**
     * @default 'Reminder Sent to {{guestName}}'
     */
    title: T;

    /**
     * @default 'You can remind guests as many times as needed.'
     */
    subtitle: T;

    /**
     * @default 'Joy does not perform {{paymentMethod}} transactions for your guests. Guests have to leave your registry and go to the payment app to send you money.'
     */
    paymentMethodInfo: T;

    /**
     * @default 'What might have happened?'
     */
    whatMightHaveHappenedTitle: T;

    /**
     * @default 'Most of the time this happens because guests are unfamiliar with payment apps, or they simply forgot to complete their payment or mark it as given.'
     */
    whatMightHaveHappenedBody: T;

    /**
     * @default 'How can I avoid this problem?'
     */
    howToAvoidTitle: T;

    /**
     * @default 'Securely connect your bank account to allow your guests to pay by credit and debit card. These transactions are simpler, automatically tracked by Joy, and are more flexible for guests.'
     */
    howToAvoidBody: T;

    /**
     * @default 'Connect Your Bank Account'
     */
    connectBankAccountButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;
  };
  downloadDialog: {
    /**
     * @default 'Add Gifts on the Go'
     */
    downloadDialogEyebrowText: T;

    /**
     * @default 'Use the app to add items wherever, whenever'
     */
    downloadDialogHeaderText: T;

    /**
     * @default 'You can download the app on both Android and iOS.'
     */
    downloadDialogBodyText: T;
  };
  addGiftDialog: {
    /**
     * @default 'Add your own gift'
     */
    title: T;
  };
  giftTypeSection: {
    /**
     * @default 'Get Gift Ideas'
     */
    getGiftIdeas: T;

    /**
     * @default 'Add Gift Manually'
     */
    addGiftManually: T;

    /**
     * @default 'Add Item'
     */
    addProduct: T;

    /**
     * @default 'Add Cash Fund'
     */
    addCashFund: T;

    /**
     * @default 'Add Charity'
     */
    addCharity: T;

    /**
     * @default 'Browse Products'
     */
    browseProducts: T;

    /**
     * @default 'Explore Cash Funds'
     */
    exploreCashFunds: T;

    /**
     * @default 'See Top Picks For You'
     */
    topPicks: T;

    /**
     * @default 'Start Your Checklist'
     */
    checklist: T;

    /**
     * @default 'Install the Joy Quick Add Button'
     */
    quickAddSectionTitle: T;

    /**
     * @default 'Joy Mobile App'
     */
    quickAddSectionTitleMobile: T;

    /**
     * @default 'Add anything as you browse the web.'
     */
    quickAddSectionSubtitle: T;

    /**
     * @default 'Add anything as you browse the web on your phone.'
     */
    quickAddSectionSubtitleMobile: T;

    /**
     * @default 'Get the button'
     */
    quickAddSectionBtn: T;

    /**
     * @default 'Get the app'
     */
    quickAddSectionBtnMobile: T;

    /**
     * @default 'Joy Quick Add'
     */
    quickAddSectionImgAlt: T;

    /**
     * @default 'Shop from Any Store'
     */
    shopFromAnyStore: T;

    /**
     * @default 'Add Gift from Anywhere'
     */
    addGiftFromAnywhere: T;
  };
  transferRegistry: {
    /**
     * @default 'Transfer Your {{retailer}} Registry to Joy'
     */
    title: T;

    /**
     * @default 'Make a one-time registry transfer. All your items will be hosted and managed through Joy so you don’t have to worry about juggling multiple registries.'
     */
    subtitle: T;

    /**
     * @default 'Start Transfer'
     */
    button: T;

    /**
     * @default 'I’d rather manage my gifts through {{retailer}}'
     */
    secondaryButton: T;

    /**
     * @default 'Add, update, and track gifts in one place'
     */
    ctaOne: T;

    /**
     * @default 'Guests look for available gifts on Joy'
     */
    ctaThree: T;

    /**
     * @default 'Shop anywhere with the Joy Browser Button'
     */
    ctaTwo: T;

    /**
     * @default 'Hang Tight! We’re Transferring Your Registry…'
     */
    loadingTitle: T;

    /**
     * @default 'In a moment your {{retailer}} items will appear in your Joy registry.'
     */
    loadingSubtitle: T;

    /**
     * @default 'Your gifts are now in Joy!'
     */
    completeTitle: T;

    /**
     * @default 'Next let’s hide your old registry.'
     */
    completeTitleLineTwo: T;

    /**
     * @default 'By making your {{retailer}} registry private, your guests won’t accidentally purchase the same Mickey Mouse Waffle Maker twice. 😉'
     */
    completeSubtitle: T;

    /**
     * @default 'Sit tight, your transfer is still in progress.'
     */
    stillTransferingTitle: T;

    /**
     * @default 'Refresh the page in a few minutes and it should be complete.'
     */
    stillTransferingSubtitle: T;

    /**
     * @default 'Thousands of unique gifts and brands you love are waiting for you. Shop with Joy!'
     */
    shopPromoTitle: T;

    /**
     * @default 'Shop Now'
     */
    shopPromoButton: T;

    /**
     * @default 'Next'
     */
    nextButton: T;

    /**
     * @default 'Add gifts from {{retailer}} or any store easily with the Joy Browser Button'
     */
    joyButtonTitle: T;

    /**
     * @default 'Drag the button below to your browser’s Bookmark bar to save it.'
     */
    joyButtonSubtitle: T;

    /**
     * @default 'Add gifts easily'
     */
    joyAppTitle: T;

    /**
     * @default 'Download the Joy app & add new items from {{retailer}} or any store.'
     */
    joyAppSubtitle: T;

    /**
     * @default 'Need help?'
     */
    needHelp: T;

    /**
     * @default 'Read our step-by-step guide.'
     */
    readOurGuide: T;

    /**
     * @default 'Edit Old Registry Settings'
     */
    editOldButton: T;

    /**
     * @default 'Want to add more gifts to your registry? Get the '
     */
    tryBrowserButton: T;

    /**
     * @default 'Joy Browser Button!'
     */
    joyBrowserButton: T;

    /**
     * @default 'Delete Registry and Gifts'
     */
    deleteRegistry: T;

    /**
     * @default 'As of {{date}} your registry is still set to Public.'
     */
    asOfPublic: T;

    /**
     * @default 'Set your {{storeName}} registry to private to avoid confusion and duplicate gifts.'
     */
    turnToPrivate: T;

    /**
     * @default 'Fix Registry Privacy'
     */
    fixRegPrivacy: T;

    /**
     * @default 'Please note: if you already have purchased gifts on your other registry, your gift tracking and purchase data will NOT be transferred to Joy.'
     */
    transferWarning: T;

    /**
     * @default 'Edit Registry'
     */
    viewRegistry: T;

    /**
     * @default 'How does this work?'
     */
    howTo: T;

    /**
     * @default 'Want to add more gifts from {{storeName}}?'
     */
    browserButtonCTATitle: T;

    /**
     * @default 'Get the Joy Browser Button'
     */
    browserButtonCTASubtitle: T;

    /**
     * @default 'Please hide your {{storeName}} registry'
     */
    hideRegistryTitle: T;

    /**
     * @default 'Transferring'
     */
    registryTransferInProgress: T;

    /**
     * @default 'We only check this once a day, so if it doesn't seem accurate please check back tomorrow.'
     */
    bannerTooltip: T;

    giftCounts: {
      /**
       * @default '{{count}} gift transferred'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} gift transferred
       * - plural: {{count}} gifts transferred
       */
      transferredGiftCount: T;
    };
  };
  addGiftsPostTransfer: {
    /**
     * @default 'New gifts found on your {{storeName}} registry'
     */
    bannerTitle: T;

    /**
     * @default 'New gifts found on your {{storeNames}} registries'
     */
    bannerTitlePlural: T;

    /**
     * @default 'New gifts found.'
     */
    bannerTitleMobile: T;

    /**
     * @default 'Bring them into your Joy registry.'
     */
    bannerSubTitle: T;

    /**
     * @default 'Transferred Registry'
     */
    tooltipHeader: T;

    /**
     * @default 'If you’ve added new gifts after transferring your registry, Joy will let you bring those gifts in to keep everything in sync. Just click on the Transfer All button to make it happen.'
     */
    tooltipText: T;

    /**
     * @default 'Transfer All'
     */
    bannerButtonCTA: T;

    /**
     * @default '{{giftCount}} New Gifts Found'
     */
    newGiftsTitle: T;

    /**
     * @default 'New gifts found on your {{storeName}} registry. Would you like to add them to Joy?'
     */
    newGiftsSubtitle: T;

    /**
     * @default 'New gifts found in your {{storeNames}} registries. Would you like to add them to Joy?'
     */
    newGiftsSubtitlePlural: T;

    /**
     * @default 'Price (ea)'
     */
    priceTitle: T;

    /**
     * @default 'Quantity'
     */
    quantityTitle: T;

    /**
     * @default 'Maybe Later'
     */
    secondaryCTA: T;

    /**
     * @default 'Add Gifts to Joy'
     */
    newGiftsPrimaryCTA: T;

    /**
     * @default 'Your new gifts have been copied to your Joy registry.'
     */
    giftsAddedConfirmation: T;

    /**
     * @default 'Tired of updating your gifts?
There’s a better way!'
*/
    getButtonTitle: T;

    /**
     * @default 'The Joy Quick Add Button makes it easy to add new items from any store directly into your Joy registry.'
     */
    getButtonSubtitle: T;

    /**
     * @default 'Get the Button'
     */
    getButtonPrimaryCTA: T;
  };
  giftTracker: {
    /**
     * @default 'Qty {{qty}}'
     */
    quantityTitle: T;

    /**
     * @default 'Order #{{orderNumber}}'
     */
    orderTitle: T;

    /**
     * @default 'Order number or tracking not available'
     */
    orderNotAvailableInfo: T;

    /**
     * @default 'Add Order & Tracking Info'
     */
    addOrderInfo: T;

    /**
     * @default 'Re: Gift tracking from Joy'
     */
    mailSubject: T;

    /**
     * @default 'Track Shipment'
     */
    trackShipmentLinkText: T;

    /**
     * @default 'Where's my gift?'
     */
    mailLinkText: T;

    /**
     * @default 'To be sent via <storeLink/>'
     */
    toBeSent: T;

    /**
     * @default 'Sent via <storeLink/>'
     */
    sentBy: T;

    /**
     * @default 'Gift Giver'
     */
    tableName: T;

    /**
     * @default 'Thank You Manager'
     */
    tableGift: T;

    /**
     * @default 'Track Gifts & Send Thanks'
     */
    trackingGiftTitle: T;

    /**
     * @default 'Tracking'
     */
    trackGiftNavOption: T;

    /**
     * @default 'Gifts & Registries'
     */
    giftsAndRegistriesNavOption: T;

    /**
     * @default '{{guestName}} marked this as purchased.'
     */
    tooltipPurchased: T;

    /**
     * @default '{{guestName}} marked this as given.'
     */
    tooltipGiven: T;

    /**
     * @default '{{guestName}} intends to get you this gift, but they have not marked it as purchased yet.'
     */
    tooltipReserved: T;

    /**
     * @default 'These gifts have been marked as purchased by your guests.'
     */
    tooltipReservedPurchased: T;

    /**
     * @default 'Your guests intend to get you these gifts, but they have not yet marked them as purchased.'
     */
    tooltipReservedRequested: T;

    /**
     * @default 'This gift has not been shipped yet'
     */
    statusTooltipNotShipped: T;

    /**
     * @default 'We will provide tracking information as soon as it is available.'
     */
    statusTooltipTracking: T;

    /**
     * @default 'This gift has been shipped.'
     */
    statusTooltipShipped: T;

    /**
     * @default 'Request Refund'
     */
    requestRefund: T;

    /**
     * @default 'Mark as not purchased'
     */
    markAsNotPurchased: T;

    /**
     * @default 'Contact Support'
     */
    contact: T;

    /**
     * @default 'Return Policy'
     */
    returnPolicy: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Mark as not given'
     */
    markAsNotGiven: T;

    /**
     * @default 'The order was cancelled'
     */
    orderCancelledText: T;

    /**
     * @default 'Cancelling reservation...'
     */
    cancellingReservation: T;

    /**
     * @default 'order has not selected'
     */
    errorOrderNotSelected: T;

    /**
     * @default 'Hidden from registry'
     */
    hideGiftText: T;

    /**
     * @default 'More Options...'
     */
    moreOptions: T;

    /**
     * @default 'This gift has an issue with the delivery address'
     */
    noticeTitleText: T;

    /**
     * @default 'Instructions for how to fix...'
     */
    noticeInstructionsText: T;

    /**
     * @default 'Write Thank You'
     */
    thankYouLabelLong: T;

    /**
     * @default 'Thank'
     */
    thankYouLabelShort: T;

    /**
     * @default 'Thank You Sent'
     */
    thankedLabelLong: T;

    /**
     * @default 'Thanked'
     */
    thankedLabelShort: T;

    /**
     * @default 'Gift'
     */
    giftLabelSingular: T;

    /**
     * @default 'Gifts'
     */
    giftLabelPlural: T;

    /**
     * @default 'Tracking Info requested from guest'
     */
    trackingInfoRequested: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Partially Shipped'
     */
    partiallyFulfilled: T;

    /**
     * @default 'Partially Delivered'
     */
    partiallyDelivered: T;

    /**
     * @default 'Credit Issued'
     */
    creditIssued: T;

    /**
     * @default 'Unavailable: Credit Issued'
     */
    unavailableCreditIssued: T;

    /**
     * @default 'Copy Promo Code'
     */
    copyPromoCode: T;

    /**
     * @default '✨  Copied!  ✨'
     */
    copyPromoCodeTooltip: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Tracking'
     */
    tracking: T;

    /**
     * @default 'Given'
     */
    given: T;

    /**
     * @default 'Processing'
     */
    draft: T;

    /**
     * @default 'Shipped'
     */
    shipping: T;

    /**
     * @default 'Ready to Ship'
     */
    readyToFulfill: T;

    /**
     * @default 'Processing'
     */
    fulFillmentStarted: T;

    /**
     * @default 'Needs Action'
     */
    failed: T;

    /**
     * @default 'Delivered'
     */
    delivered: T;

    /**
     * @default 'Processing'
     */
    processing: T;

    /**
     * @default 'Needs Action'
     */
    pendingRefundAction: T;

    /**
     * @default 'Shipped'
     */
    pendingWithdrawalAction: T;

    /**
     * @default 'Ship Now'
     */
    shipNow: T;

    /**
     * @default 'Status'
     */
    statusColumn: T;

    /**
     * @default 'Cash Received'
     */
    cashReceived: T;

    /**
     * @default 'Resolve Issue'
     */
    resolveIssue: T;

    /**
     * @default 'Manage {{count}} unresolved issues.'
     */
    manageUnresolvedIssues: T;

    /**
     * @default 'Swapped for cash'
     */
    swappedForCash: T;

    /**
     * @default 'Refunded Guest'
     */
    guestRefunded: T;

    /**
     * @default 'Exchanged for cash'
     */
    swappedForCashOrderLabel: T;

    /**
     * @default 'Guest Refund Issued'
     */
    guestRefundedOrderLabel: T;

    /**
     * @default 'Out For Delivery'
     */
    outForDelivery: T;

    /**
     * @default 'Canceled'
     */
    canceled: T;

    /**
     * @default 'Processing'
     */
    notReady: T;

    /**
     * @default 'Given by'
     */
    givenBy: T;

    /**
     * @default 'Total'
     */
    total: T;
  };
  joyCreditWidget: {
    /**
     * @default 'Learn more about Joy Credit'
     */
    learnMore: T;

    /**
     * @default 'Joy Credit'
     */
    title: T;

    /**
     * @default 'Available for Purchases'
     */
    subtitle: T;

    /**
     * @default 'Copy Promo Code'
     */
    copyPromoCode: T;

    /**
     * @default '✨  Copied!  ✨'
     */
    copyPromoCodeTooltip: T;

    /**
     * @default 'Promo Code'
     */
    promoCode: T;
  };
  refundDialog: {
    /**
     * @default 'Action needed'
     */
    header: T;

    /**
     * @default 'We’re unable to fulfill your order.'
     */
    title: T;

    /**
     * @default 'We can give you cash or refund your guest.'
     */
    subTitle: T;

    /**
     * @default 'Convert {{amount}} to Cash'
     */
    swapAmountForCash: T;

    /**
     * @default 'We won’t tell your guests you swapped the physical gift for cash. A Stripe account is required for this option.'
     */
    swapForCashDesc: T;

    /**
     * @default 'Refund {{amount}} to Guest'
     */
    refundAmount: T;

    /**
     * @default 'Your gift’s status will be reverted back to “Available” and your guest will receive an email notifying them of the refund. Refunds usually takes 3-5 business days.'
     */
    refundDesc: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Use Stripe to enable credit card payments and transfer cash to your bank account or debit card.'
     */
    stripeInfo: T;

    /**
     * @default 'Stripe needs more information.'
     */
    stripeInfoError: T;

    /**
     * @default 'Credit card payment enabled.'
     */
    stripeInfoReady: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Confirm'
     */
    confirmCta: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default '{{amount}} will be refunded to your guest.'
     */
    refundHandledTitle: T;

    /**
     * @default 'Your guest will receive an email notifying them of the refund. Refunds usually takes 3-5 business days. Your gift’s status will be reverted back to Available.'
     */
    refundHandledSubtitle: T;

    /**
     * @default '{{amount}} has been added to your Joy Wallet.'
     */
    sg4cHandledTitle: T;

    /**
     * @default 'You’ve chosen to swap the gift for cash. Your gift’s status will be reverted back to Available.'
     */
    sg4cHandledSubtitle: T;
  };
  giftTrackerDialog: {
    /**
     * @default 'Returning a gift?'
     */
    returnDialogTitle: T;

    /**
     * @default 'customer support'
     */
    dialogEdeliveryLine2Contact: T;

    /**
     * @default 'Returns for this product are handled directly by the store it was purchased from.'
     */
    returnDialogLine1: T;

    /**
     * @default 'This gift was given by {{guestName}} and purchased at {{retailer}}.'
     */
    returnDialogLine2: T;

    /**
     * @default 'Got It'
     */
    buttonText: T;

    /**
     * @default 'Quantity {{qty}}'
     */
    quantityTitle: T;

    /**
     * @default 'If unredeemed, this experience can be returned for a merchandise credit.'
     */
    spurText: T;

    /**
     * @default 'Request a refund for this gift or exchange within 90 days of purchase or event date.'
     */
    dropshipText: T;

    /**
     * @default 'Gift cards and eGift cards are non-refundable.'
     */
    eDeliveryText: T;

    /**
     * @default 'See Details'
     */
    linkText: T;

    /**
     * @default 'Credit Card for Cash and Get Cash Equivalent purchases are non-refundable.'
     */
    gceText: T;
  };
  giftTrackerEDeliveryDialog: {
    /**
     * @default 'Where is my gift?'
     */
    dialogTitle: T;

    /**
     * @default 'This item is scheduled for eDelivery to your email.'
     */
    dialogEdeliveryLine1: T;

    /**
     * @default 'If you have not received your gift via email after 1 -2 days Please contact <customerLink/>'
     */
    dialogEdeliveryLine2: T;

    /**
     * @default 'customer support'
     */
    dialogEdeliveryLine2Contact: T;

    /**
     * @default 'Ok'
     */
    buttonText: T;
  };
  giftTrackerZeroState: {
    /**
     * @default 'Gifts you’ve received and thank you notes sent will appear here.'
     */
    title: T;
  };
  hideShowDialog: {
    /**
     * @default 'Are you sure you want to {{status}} this gift?'
     */
    title: T;

    /**
     * @default 'This will allow guests to see it in your registry.'
     */
    showTitle: T;

    /**
     * @default 'This will prevent anyone from seeing this gift on your registry. You can still view any reservations for this gift in the Tracking tab.'
     */
    hideTitle: T;

    /**
     * @default 'Please note that you may still receive the gift if a guest has already purchased it.'
     */
    hideSubtitle: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Yes, Show on Registry'
     */
    showButton: T;

    /**
     * @default 'Hide Gift'
     */
    hideButton: T;
  };
  quickAdd: {
    /**
     * @default 'Use the Joy Quick Add Button to add items from any store.'
     */
    title: T;

    /**
     * @default 'Just drag the button below to your<lineBreak/>Bookmarks Bar to get started.'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    addButton: T;

    /**
     * @default 'Verify your Bookmarks Bar is visible.'
     */
    step1: T;

    /**
     * @default 'View'
     */
    viewChrome: T;

    /**
     * @default 'View > Toolbars > Bookmarks Toolbar'
     */
    viewFirefox: T;

    /**
     * @default 'Always Show Bookmarks Bar'
     */
    bookmarksChrome: T;

    /**
     * @default 'Always Show'
     */
    bookmarksFirefox: T;

    /**
     * @default 'In <browser/>’s menu, go to <view/> and make sure there’s a checkmark next to <bookmarks/>.'
     */
    step1Description: T;

    /**
     * @default 'Click and drag the Joy Quick Add Button to your Bookmarks Bar, found above this page.'
     */
    step2: T;

    /**
     * @default 'Now try it out! Visit any store you love, find a gift you want, and then click the Joy Quick Add Button.'
     */
    step3: T;

    /**
     * @default 'We’re still working on the Joy Quick Add Button for Safari, but in the meantime, you can add the button in <chromeLink/> or <firefoxLink/> instead.'
     */
    stepSafari: T;

    /**
     * @default 'You can also get the “Add to Joy” Button for <link/>.'
     */
    footer: T;

    emptyCatalogState: {
      /**
       * @default 'Add Gifts from Anywhere!'
       */
      title: T;

      /**
       * @default 'Just drag the this Joy Quick Add button to your browser bookmark bar in the header and add gifts from anywhere.'
       */
      subtitle: T;

      /**
       * @default 'Add to Joy'
       */
      addButton: T;

      /**
       * @default 'Show me how it works'
       */
      showMeLink: T;
    };
  };
  transferRegistryDialog: {
    screens: {
      selectRegistry: {
        /**
         * @default 'Welcome to Your Universal Registry'
         */
        subTitle: T;

        /**
         * @default 'Select the registry you’d like to connect'
         */
        title: T;

        ukCambium: {
          /**
           * @default 'We've partnered with the best gift lists in the United Kingdom.'
           */
          title: T;

          /**
           * @default 'Where would you like to start?'
           */
          subTitle: T;
        };

        /**
         * @default 'Other Registries'
         */
        allStoresHeader: T;

        /**
         * @default 'Connect a different registry…'
         */
        showAllStores: T;
      };
      createExternalRegistryLink: {
        /**
         * @default 'Let’s get your gift list started'
         */
        title: T;

        /**
         * @default 'You can start a new list or connect an existing list.'
         */
        subTitle: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Create New Gift List'
         */
        createNewButton: T;

        /**
         * @default 'Connect Existing Gift List'
         */
        transferExistingButton: T;
      };
      enterLink: {
        title: {
          /**
           * @default 'Let’s connect to {{registry}}'
           */
          transfer: T;

          /**
           * @default 'Let’s connect to {{registry}}'
           */
          sync: T;

          /**
           * @default 'Let’s connect to {{registry}}'
           */
          linkToStore: T;

          /**
           * @default 'Let’s connect your registries in one place'
           */
          link: T;
        };
        subTitle: {
          /**
           * @default 'Add your registry link below. After we’ve found your registry, you’ll choose whether to make a one-time copy of your gifts into Joy or sync daily.'
           */
          transfer: T;

          /**
           * @default 'Add your registry link below and we’ll get started.'
           */
          sync: T;

          /**
           * @default 'Add your registry link below and we’ll get started.'
           */
          link: T;
        };
        errors: {
          /**
           * @default 'Please enter a valid registry link.'
           */
          invalidDomain: T;

          /**
           * @default '{{brandName}} registry link should include {{hostname}}.'
           */
          invalidBrandUrl: T;

          /**
           * @default 'Please enter a registry link.'
           */
          required: T;

          /**
           * @default 'This registry can be synced or transferred. Please choose your registry accordingly.'
           */
          canSyncOrTransfer: T;

          /**
           * @default 'Hmm... we can’t find your registry. Check your URL or make sure your registry is set to “Public.”'
           */
          genericError: T;
        };

        /**
         * @default 'Learn More'
         */
        learnButton: T;

        /**
         * @default 'Get Started'
         */
        startButton: T;

        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Connect Registry'
         */
        connectButton: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Make sure the registry you’re connecting is set to "Public".'
         */
        makeSureRegistryIsPublic: T;
      };
      linkAdded: {
        /**
         * @default 'Awesome. We’ve added a link on your Joy registry so gift givers will easily find it.'
         */
        title: T;

        /**
         * @default 'Add Another Registry'
         */
        addButton: T;

        /**
         * @default 'View My Registry'
         */
        viewRegistry: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnPhrase: T;
      };
      registryFound: {
        /**
         * @default 'Registry Found'
         */
        title: T;

        /**
         * @default '{{coupleName}}'s Registry'
         */
        coupleSubtitle: T;

        /**
         * @default 'Now let’s import and supercharge it with Joy.'
         */
        newTitle: T;

        /**
         * @default 'We found your registry at {{brandName}}'
         */
        subtitle: T;

        /**
         * @default 'Move Registry to Joy'
         */
        moveButton: T;

        /**
         * @default 'No thanks, I’d like to continue adding gifts through {{brandName}}'
         */
        syncInsteadButton: T;

        /**
         * @default 'No thanks, just display a link to {{brandName}}.'
         */
        linkInsteadButton: T;

        /**
         * @default 'How does this work?'
         */
        howButton: T;

        /**
         * @default 'Sync Registry'
         */
        syncButton: T;

        /**
         * @default 'Learn more about syncing'
         */
        learnAboutSyncButton: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Add gifts from ANY store, not just {{brandName}}.'
         */
        addGiftsFromAnyStore: T;

        /**
         * @default 'We’ll hold your packages during your honeymoon!'
         */
        holdPackagesDuringHoneymoon: T;

        /**
         * @default 'Shop right on your website (no annoying link-outs).'
         */
        shopOnWebsite: T;

        /**
         * @default 'Zero-fee cash funds help you reach your goals faster.'
         */
        zeroFeeCashFunds: T;

        /**
         * @default 'Price match promise guarantees you and your guests get the best price.'
         */
        priceMatchPromise: T;

        /**
         * @default 'It’s easy to be grateful with automagic thank you cards.'
         */
        automagicThankYouCards: T;
      };
      gettingGifts: {
        /**
         * @default 'We’re getting your gifts from {{registry}}'
         */
        title: T;

        /**
         * @default 'In the meantime, feel free to explore Registry. Refresh your Manage Gifts page shortly to see your gifts.'
         */
        subTitle: T;

        /**
         * @default 'You’ll begin seeing your gifts in the next few minutes, and we’ll update changes, pricing, and availability once daily.'
         */
        subTitleVariant: T;

        /**
         * @default 'Connect Another Registry'
         */
        addAnotherButton: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnAboutButton: T;

        /**
         * @default 'Done'
         */
        done: T;
      };
      linkInstead: {
        /**
         * @default 'Great! Before we link your registry, some things to keep in mind:'
         */
        title: T;

        /**
         * @default 'Guests will have to leave your website to purchase gifts.'
         */
        listItem1: T;

        /**
         * @default 'You won’t have control over when your packages arrive on your doorstep.'
         */
        listItem2: T;

        /**
         * @default 'Gifts outside of Joy aren’t eligible for Joy’s AI-assisted thank you cards.'
         */
        listItem3: T;

        /**
         * @default 'I understand and I still want to link this Registry.'
         */
        checkboxLabel: T;

        /**
         * @default 'Nevermind, transfer gifts to Joy'
         */
        transferButton: T;

        /**
         * @default 'Continue Without Transferring'
         */
        linkButton: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnAboutButton: T;
      };
      reminderShippingAddressForTransfer: {
        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Now let’s add your shipping address'
         */
        title: T;

        /**
         * @default 'Avoid missing packages and awkward texts! We’ll make sure gift givers know where to send your gifts.'
         */
        body: T;

        /**
         * @default 'Add Shipping Address'
         */
        addButton: T;

        /**
         * @default 'I’ll Do It Later'
         */
        laterButton: T;
      };
      syncInstead: {
        /**
         * @default 'Sync this registry instead'
         */
        title: T;

        /**
         * @default 'While we recommend moving your registry to Joy so you can <strong>do everything in one place</strong>, syncing is another option if you want to continue using your {{retailer}} registry.'
         */
        subTitle: T;

        /**
         * @default 'Move to Joy'
         */
        moveToJoy: T;

        /**
         * @default 'Syncing'
         */
        syncing: T;

        /**
         * @default 'Adding Gifts'
         */
        addingGifts: T;

        /**
         * @default 'Tracking Gifts'
         */
        trackingGifts: T;

        /**
         * @default 'Buying Gifts'
         */
        buyingGifts: T;

        /**
         * @default 'Completion Discount'
         */
        completionDiscount: T;

        /**
         * @default 'Add and update items in Joy, not {{retailer}}, changes reflect instantly'
         */
        addingTransfer: T;

        /**
         * @default 'Add and update items in {{retailer}}, they’ll sync daily'
         */
        addingSyncing: T;

        /**
         * @default 'Manage and track your gifts, across all stores, in Joy'
         */
        trackingTransfer: T;

        /**
         * @default 'Manage and track registries one-by-one on each site'
         */
        trackingSyncing: T;

        /**
         * @default 'Guests can buy their gifts on {{retailer}} or Joy'
         */
        buyingTransfer: T;

        /**
         * @default 'Guests are taken to your {{retailer}} registry to purchase'
         */
        buyingSyncing: T;

        /**
         * @default 'Get access to Joy’s completion discount on Joy gifts in addition to a completion discount from {{retailer}}'
         */
        completionDiscountTransfer: T;

        /**
     * @default 'Get access to Joy's completion discount on Joy gifts.

Note: With guests purchasing gifts off of your Joy registry instead of your {{retailer}} registry, you are not likely to qualify for {{retailer}}'s completion discount, which requires $500 to be bought off of the original {{retailer}} registry.'
*/
        noCompletionDiscountTransfer: T;

        /**
         * @default 'Receive a completion discount from {{retailer}}'
         */
        completionDiscountSyncing: T;

        /**
         * @default 'Go Back'
         */
        backButton: T;

        /**
         * @default 'Sync Registry'
         */
        syncRegistryButton: T;
      };
      seamlessCheckout: {
        /**
         * @default 'Seamless Checkout'
         */
        title: T;

        /**
         * @default 'Simplify your guests checkout experience for eligible gifts.'
         */
        subTitle: T;

        /**
         * @default 'Seamless Checkout is On'
         */
        seamlessCheckoutOn: T;

        /**
         * @default 'Seamless Checkout is Off'
         */
        seamlessCheckoutOff: T;

        /**
         * @default 'Go Back'
         */
        backButton: T;

        /**
         * @default 'Next'
         */
        nextButton: T;

        /**
         * @default 'With Seamless Checkout:'
         */
        withSeamelessCheckout: T;

        /**
         * @default 'Without Seamless Checkout:'
         */
        withoutSeamlessCheckout: T;

        /**
         * @default 'Still have questions?'
         */
        stillHaveQuestions: T;

        /**
         * @default 'Learn more'
         */
        learnMore: T;

        seamlessCheckoutValueProps: {
          /**
           * @default 'Your guests will check out easily without leaving your website.'
           */
          guestsCheckoutEasily: T;

          /**
           * @default 'Guests won’t need to know your address, confirm purchase, or give you their purchase details.'
           */
          guestsNoAddressNeeded: T;

          /**
           * @default 'Gifts are tracked on Joy.'
           */
          giftsTrackedOnJoy: T;

          /**
           * @default 'Hassle-free returns with Joy.'
           */
          hassleFreeReturns: T;

          /**
           * @default '24/7 order support from Joy.'
           */
          orderSupport24_7: T;
        };
        risks: {
          /**
           * @default 'Your guests will leave your Joy website to complete purchase.'
           */
          guestsLeaveSite: T;

          /**
           * @default 'Guests will have to come back to your Joy website to add their purchase details.'
           */
          guestsReturnToAddDetails: T;

          /**
           * @default 'You are more likely to receive duplicate gifts.'
           */
          moreDuplicateGifts: T;

          /**
           * @default 'You’ll work with your retailer for customer support and returns.'
           */
          retailerSupportAndReturns: T;
        };

        /**
         * @default 'Don’t Optimize Checkout'
         */
        dontOptimize: T;

        /**
         * @default 'Enable Seamless Checkout'
         */
        enableSeamless: T;
      };
      quickAdd: {
        /**
         * @default 'Back'
         */
        backButton: T;

        step1: {
          /**
           * @default 'Shop on {{retailer}} and any other store with the Joy Quick Add Button'
           */
          title: T;

          /**
           * @default 'Add items from anywhere with the Joy Quick Add Button'
           */
          linkedTitle: T;

          /**
           * @default 'Install it today to keep shopping with a simple click.'
           */
          subTitle: T;

          /**
           * @default 'Learn More'
           */
          learnMoreLink: T;

          /**
           * @default 'I’ll Do It Later'
           */
          laterButton: T;

          /**
           * @default 'Get the Button'
           */
          getButton: T;
        };
        step2: {
          /**
           * @default 'Install the Joy Quick Add Button in Chrome/Firefox'
           */
          title: T;

          /**
           * @default 'Just drag the button below to your browser’s bookmark bar.'
           */
          subTitle: T;

          /**
           * @default 'Add to Joy'
           */
          browserButton: T;

          /**
           * @default 'I’ve Installed It'
           */
          doneButton: T;

          /**
           * @default 'Need Help? Read our'
           */
          help: T;

          /**
           * @default 'step-by-step guide'
           */
          helpLink: T;
        };
      };
      joyApp: {
        /**
         * @default 'Add & track gifts on the go'
         */
        title: T;

        /**
         * @default 'Download the Joy App to shop, edit, and manage your registry all from your phone.'
         */
        subTitle: T;

        /**
         * @default 'Get the App'
         */
        downloadButton: T;

        /**
         * @default 'View My Registry'
         */
        viewRegistryButton: T;

        /**
         * @default 'Download the Joy Mobile App'
         */
        qrCodeAltText: T;

        /**
         * @default 'Add Gifts'
         */
        addGiftsAltText: T;

        /**
         * @default 'Back'
         */
        backButton: T;
      };
    };
  };
  confirmRegistryNotification: {
    /**
     * @default 'No, Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Yes'
     */
    yes: T;

    /**
     * @default 'Do your gifts from {{storeName}} look correct?'
     */
    looksCorrect: T;

    /**
     * @default 'We’ve copied your gifts from {{storeName}}. Make sure everything looks good.'
     */
    confirmRegistry: T;

    /**
     * @default 'Review Gifts'
     */
    reviewGifts: T;

    /**
     * @default 'Maybe Later'
     */
    maybeLater: T;
  };
  sidebar: {
    greeting: {
      /**
       * @default 'Happy {{dayOfWeek}}!'
       */
      dailyMessage: T;

      /**
       * @default '{{count}} day to go 🎉'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} day to go 🎉
       * - plural: {{count}} days to go 🎉
       */
      countdownToWedding: T;

      /**
       * @default '{{count}} days ago ️💘'
       */
      countdownPostWedding: T;

      /**
       * @default 'Today’s the big day! 🥂'
       */
      weddingDay: T;
    };
    counters: {
      /**
       * @default 'Gifts Available'
       */
      giftsAddedLabel: T;

      /**
       * @default 'Reserved & Purchased'
       */
      reservedLabel: T;
    };
    quickActions: {
      /**
       * @default 'Close'
       */
      mobileToggleButtonOn: T;

      /**
       * @default 'Quick Actions'
       */
      mobileToggleButtonOff: T;

      /**
       * @default 'Your registry is hidden'
       */
      visibilityPrivate: T;

      /**
       * @default 'Your registry is visible'
       */
      visibilityPublic: T;

      /**
       * @default 'Registry is hidden'
       */
      visibilityOptionHidden: T;

      /**
       * @default 'Registry is visible'
       */
      visibilityOptionPublic: T;

      /**
       * @default 'Registry is password protected'
       */
      visibilityOptionPasswordProtected: T;

      /**
       * @default 'Change Privacy'
       */
      changeVisibility: T;

      /**
       * @default 'Add Shipping Address'
       */
      addShippingAddress: T;

      /**
       * @default 'Edit Shipping Address'
       */
      editShippingAddress: T;

      /**
       * @default 'Set Currency'
       */
      setCurrency: T;

      /**
       * @default 'View as Guest'
       */
      viewAsGuest: T;

      /**
       * @default 'Preview Registry'
       */
      previewRegistry: T;

      /**
       * @default 'Copy Registry Link'
       */
      copyGuestsiteUrl: T;

      /**
       * @default 'Get the Quick Add Button'
       */
      getBrowserButton: T;

      /**
       * @default 'Connect a Registry'
       */
      linkAnotherRegistry: T;

      /**
       * @default 'Download the App'
       */
      downloadApp: T;

      /**
       * @default 'Registry Completion Discount'
       */
      postWeddingDiscount: T;

      /**
       * @default '✨ Link Copied ✨'
       */
      linkCopied: T;

      /**
       * @default 'Share it with gift givers so they can shop in one place!'
       */
      linkCopiedMessage: T;

      /**
       * @default 'Edit Welcome Note'
       */
      editNote: T;

      /**
       * @default 'External Registries'
       */
      externalRegistries: T;

      /**
       * @default 'Registry Settings'
       */
      registrySettings: T;

      /**
       * @default 'Registry URL'
       */
      registrySettingsNonStandalone: T;

      /**
       * @default 'Invite a Collaborator'
       */
      inviteCollaborator: T;
    };
  };
  shippingAddressWarningBanner: {
    /**
     * @default 'Your shipping address is missing'
     */
    emptyAddressMessage: T;

    /**
     * @default 'It looks like your shipping address is invalid.'
     */
    noValidatedAddressMessage: T;

    /**
     * @default 'Update it so guests can send you your gifts'
     */
    noValidatedAddressSubTextMessage: T;

    /**
     * @default 'Add it so guests can send you your gifts!'
     */
    addressSubTextMessage: T;

    /**
     * @default 'Add Address'
     */
    buttonText: T;
  };
  completionDiscountBanner: {
    /**
     * @default 'Registry Completion Discount'
     */
    title: T;

    /**
     * @default 'Get 20% off on all the gifts your guests didn't buy.'
     */
    subTitle: T;

    /**
     * @default 'View Discount'
     */
    button: T;
  };
  completionDiscountCountdown: {
    /**
     * @default 'Register now, save later.'
     */
    registerMessage: T;

    /**
     * @default 'Now Available'
     */
    nowAvailableMessage: T;

    /**
     * @default 'Registry Completion Discount'
     */
    discountMessage: T;

    /**
     * @default 'Available in {{days}} days'
     */
    availableMessage: T;

    /**
     * @default 'Save 20% on all remaining items on your registry.'
     */
    saveMessage: T;

    /**
     * @default 'Shop Now'
     */
    shopButton: T;

    /**
     * @default 'Add More Gifts'
     */
    addMoreButton: T;

    /**
     * @default 'Discounts available for gifts added before your event date. 
Gifts added after won’t qualify. U.S Shipping Only. 
<learnMoreLink/>'
*/
    learnMoreMessage: T;

    /**
     * @default 'Learn more'
     */
    learnMoreCta: T;

    congratulationsMessage: {
      /**
       * @default 'Congratulations on your wedding! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      wedding: T;

      /**
       * @default 'Congratulations on your wedding! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      babyRegistry: T;

      /**
       * @default 'Congratulations! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      general: T;
    };

    /**
     * @default 'Expires in {{days}} days'
     */
    expiresInMessage: T;

    /**
     * @default 'Discounts available for gifts added before your event date. Gifts added after won’t qualify. U.S Shipping Only. Offer valid only until {{timestamp}}. <learnMoreLink/>'
     */
    availabilityMessage: T;
  };
  discountGiftList: {
    /**
     * @default 'Total Savings {{total}}'
     */
    totalSavings: T;

    /**
     * @default 'Sorry, it looks like none of your gifts currently qualify for the discount! <learnMoreLink/>'
     */
    emptyStateMessage: T;

    /**
     * @default 'Learn more'
     */
    learnMoreCta: T;
  };
  discountGift: {
    /**
     * @default 'Save {{discount}}'
     */
    save: T;

    /**
     * @default 'Buy Now'
     */
    buyNowCta: T;
  };
  externalRegistries: {
    /**
     * @default 'Already registered somewhere else? Connect it to Joy to make your registry a success.'
     */
    emptyListMessage: T;

    /**
     * @default 'Learn More'
     */
    emptyListLink: T;

    /**
     * @default 'New Gifts'
     */
    newGifts: T;

    /**
     * @default 'Update All'
     */
    updateAll: T;

    /**
     * @default 'Connect Registry'
     */
    connectRegistry: T;

    /**
     * @default 'and {{count}} More...'
     */
    andMore: T;

    /**
     * @default 'External Registries'
     */
    externalRegistries: T;
  };
  externalRegistriesManage: {
    /**
     * @default 'Connect Registry'
     */
    connectRegistry: T;

    /**
     * @default 'and {{count}} More...'
     */
    andMore: T;

    /**
     * @default 'External Registries'
     */
    externalRegistries: T;

    /**
     * @default 'Manage'
     */
    manage: T;
  };
  eventPreview: {
    /**
     * @default 'Edit Photo & Note'
     */
    showMore: T;
  };
  paidAds: {
    /**
     * @default 'Shop Top Brands'
     */
    brandCarouselTitle: T;

    /**
     * @default 'Shop All Brands'
     */
    brandCarouselLink: T;

    /**
     * @default 'Sponsored'
     */
    sponsored: T;

    /**
     * @default 'Shop Now'
     */
    shopNow: T;
  };
  paperThankYouBanner: {
    /**
     * @default 'Show your gratitude with paper thank you cards.'
     */
    title: T;

    /**
     * @default 'Choose from a variety of customizable art and photo cards, or upload your own design, to share your heartfelt thanks.'
     */
    subTitle: T;

    /**
     * @default 'Browse Thank Yous'
     */
    button: T;
  };
  deleteConfirmationModal: {
    /**
     * @default 'Are you sure you want to delete this gift?'
     */
    title: T;

    /**
     * @default 'This item will be permanently deleted from your registry.'
     */
    description: T;

    /**
     * @default 'Remove from Registry'
     */
    primaryButtonText: T;

    /**
     * @default 'Don’t Remove'
     */
    secondaryButtonText: T;
  };
  departmentFooter: {
    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Returns'
     */
    returns: T;

    /**
     * @default 'Terms & Privacy'
     */
    termsAndPrivacy: T;

    /**
     * @default 'Support'
     */
    support: T;
  };
  quick: {
    /**
     * @default 'Your currency is set to {{0}} because a Stripe account is connected to your event. To change currencies, the existing Stripe account must be disconnected first.'
     */
    m3nkl: T;

    /**
     * @default 'We're having trouble syncing your items from {{0}}.'
     */
    uMzCp: T;

    /**
     * @default 'We're having trouble syncing your items from {{0}} and {{1}}.'
     */
    O6Bfx: T;

    /**
     * @default 'We're having trouble syncing your items from {{0}}, and {{1}}.'
     */
    G6MQc: T;

    /**
     * @default 'We've linked them for now as a backup and will continue trying to sync your gifts. In the meantime, add gifts from Joy's catalog so guests can shop right here.'
     */
    m65t5: T;

    /**
     * @default 'We've linked it for now as a backup and will continue trying to sync your gifts. In the meantime, add gifts from Joy's catalog so guests can shop right here.'
     */
    xgHEY: T;

    /**
     * @default 'We're having trouble syncing your items from {{0}}. We've linked it for now as a backup and will continue trying to sync your gifts.'
     */
    JORim: T;

    /**
     * @default 'Couldn't sync'
     */
    '35YfL': T;

    /**
     * @default 'Shop on Joy'
     */
    jfTh6: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default 'You have {{0}} to spend on stays'
     */
    dxXly: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Only on Joy'
     */
    TVSgs: T;

    /**
     * @default 'It’s your money. Spend it here, or keep it in your cash fund.'
     */
    '42x9R': T;

    /**
     * @default 'Book a stay with your {{0}}'
     */
    EgXFy: T;

    /**
     * @default 'Maybe later'
     */
    UzExj: T;

    /**
     * @default 'Discount varies by stay and dates, applied at checkout on Joy.'
     */
    Ehz7J: T;

    /**
     * @default 'Terms of Service'
     */
    PlP4t: T;

    /**
     * @default 'Travel credit'
     */
    V45g8: T;

    /**
     * @default 'From your canceled stay. For stays on Joy only.'
     */
    tJeT6: T;

    /**
     * @default 'Cash fund'
     */
    kU4eM: T;

    /**
     * @default 'It’s your money. Spend it here, or transfer it anytime.'
     */
    BgBls: T;

    /**
     * @default 'Travel credit is used first at checkout.'
     */
    '5xE05': T;

    /**
     * @default '{{0}} total'
     */
    WvV3l: T;

    /**
     * @default 'From your canceled stay. Use it on any stay booked on Joy.'
     */
    Yjyb0: T;

    /**
     * @default 'Use your cash fund to book stays'
     */
    WaUle: T;

    /**
     * @default '{{0}} travel credit + {{1}} cash fund'
     */
    tKaud: T;

    /**
     * @default 'Book a honeymoon or getaway with your cash fund, on rates only for Joy couples.'
     */
    Wab4t: T;

    /**
     * @default 'Explore stays'
     */
    voBIZ: T;

    /**
     * @default 'Selecting {{0}} will set your registry currency to {{1}}. Existing cash fund goals and gift prices keep their numbers and are not converted, so check them after saving. Cash funds that already have contributions stay in their current currency and stop taking card payments. Joy catalog items are not affected. Your currency will be locked once saved.'
     */
    IetsK: T;

    /**
     * @default 'Travel credit isn't part of your cash fund balance.'
     */
    ZMGe6: T;

    /**
     * @default 'Stay canceled · {{0}} returned as travel credit'
     */
    '5SQPx': T;

    /**
     * @default '{{0}} stays canceled · {{1}} returned as travel credit'
     */
    twj34: T;

    /**
     * @default 'Put it toward a honeymoon or getaway, on rates only for Joy couples.'
     */
    lrt69: T;

    /**
     * @default 'Use it for a honeymoon or getaway. Save up to an extra {{0}} ({{1}}) on rates only for Joy couples.'
     */
    R5NfZ: T;

    /**
     * @default 'Use it for a honeymoon or getaway. Save up to an extra {{0}} on rates only for Joy couples.'
     */
    nvUAA: T;

    /**
     * @default 'Put your {{0}} toward a honeymoon or getaway, on rates only for Joy couples.'
     */
    Bo3FN: T;

    /**
     * @default 'Use your {{0}} for a honeymoon or getaway. Save up to an extra {{1}} ({{2}}) on rates only for Joy couples.'
     */
    '7q0RR': T;

    /**
     * @default 'Use your {{0}} for a honeymoon or getaway. Save up to an extra {{1}} on rates only for Joy couples.'
     */
    '02jDN': T;

    /**
     * @default 'Honeymoon'
     */
    mfnfF: T;

    /**
     * @default 'Your trips'
     */
    XrOVT: T;

    /**
     * @default 'Explore'
     */
    FdNcu: T;

    /**
     * @default 'Find your honeymoon stay'
     */
    v7bZ3: T;

    /**
     * @default 'Explore hotel rates only for Joy couples.'
     */
    cBLnf: T;

    /**
     * @default 'Search hotels'
     */
    z99rB: T;

    /**
     * @default 'Use code {{0}} when you book.'
     */
    mxJ1t: T;

    /**
     * @default 'Your discount depends on the stay and how much of your cash fund you use.'
     */
    AaLv9: T;

    /**
     * @default 'Where to?'
     */
    tuRBB: T;

    /**
     * @default 'Where are you headed?'
     */
    KOzc7: T;

    /**
     * @default 'Stays in {{0}}'
     */
    JtBjD: T;

    /**
     * @default 'Cars in {{0}}'
     */
    qxoTz: T;

    /**
     * @default 'What to find in {{0}}'
     */
    zgdN7: T;

    /**
     * @default '1 room'
     * @param {number} count - The number of occurrences.
     * - singular: 1 room
     * - plural: {{0}} rooms
     */
    UzoYX: T;

    /**
     * @default '1 guest'
     * @param {number} count - The number of occurrences.
     * - singular: 1 guest
     * - plural: {{0}} guests
     */
    kOBri: T;

    /**
     * @default '{{0}}, {{1}}'
     */
    v3VHr: T;

    /**
     * @default 'Rooms'
     */
    gIS1G: T;

    /**
     * @default 'Fewer rooms'
     */
    TJmeG: T;

    /**
     * @default 'More rooms'
     */
    JNfdk: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Fewer guests'
     */
    '6tvRo': T;

    /**
     * @default 'More guests'
     */
    YlsWM: T;

    /**
     * @default 'Where to honeymoon in {{0}}'
     */
    FkN8S: T;

    /**
     * @default 'Explore our picks by month.'
     */
    wTrp9: T;

    /**
     * @default 'Not sure? Take the quiz'
     */
    k1TdQ: T;

    /**
     * @default 'Choose a month'
     */
    '8GI7b': T;

    /**
     * @default 'Put your {{0}} cash fund toward your stay.'
     */
    LceVI: T;

    /**
     * @default 'Your {{0}} cash fund, plus up to {{1}} ({{2}}) off.'
     */
    '8G6Fq': T;

    /**
     * @default 'Your {{0}} cash fund, plus up to {{1}} off.'
     */
    XtanH: T;

    /**
     * @default 'Your cash fund offer'
     */
    '7rEvH': T;

    /**
     * @default 'Code {{0}}'
     */
    tb9eO: T;

    /**
     * @default 'What to search'
     */
    VynoU: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Cars'
     */
    b1iKA: T;

    /**
     * @default 'Search any pick-up city'
     */
    '2dDBT': T;

    /**
     * @default 'Search any destination or hotel'
     */
    toEkT: T;

    /**
     * @default 'Search cars'
     */
    Vl1i3: T;

    /**
     * @default 'Search stays'
     */
    '2auOo': T;

    /**
     * @default 'Search Cars'
     */
    NbCe3: T;

    /**
     * @default 'Search Stays'
     */
    mCgpl: T;

    /**
     * @default 'Honeymoon sections'
     */
    GrzRx: T;

    /**
     * @default 'Start another trip'
     */
    UNvDk: T;

    /**
     * @default 'Where are you starting your next adventure?'
     */
    NrsIx: T;

    /**
     * @default 'Tell us where you two are with it, and we’ll take it from there.'
     */
    Uc2ac: T;

    /**
     * @default 'We have a place in mind'
     */
    '7BnSy': T;

    /**
     * @default 'Go to your destination'
     */
    YPQOO: T;

    /**
     * @default 'When to go, where to stay, and private Joy rates for two.'
     */
    '4kEcv': T;

    /**
     * @default 'We need help finding one'
     */
    YJ9hd: T;

    /**
     * @default 'Browse and build a trip'
     */
    JYF9d: T;

    /**
     * @default 'Look through 20 destinations and save the ones you love. {{0}} sees them too.'
     */
    SzIVy: T;

    /**
     * @default 'Look through 20 destinations and save the ones you love. Your partner sees them too.'
     */
    ZvzHS: T;

    /**
     * @default 'Browse Destinations'
     */
    J7V8C: T;

    /**
     * @default 'We want to explore by theme'
     */
    yMFr3: T;

    /**
     * @default 'Take the honeymoon quiz'
     */
    rQwS5: T;

    /**
     * @default 'Nine quick questions. We’ll suggest three destinations that fit you both.'
     */
    ixOag: T;

    /**
     * @default 'Take the Quiz'
     */
    LOo0I: T;

    /**
     * @default 'Both love'
     */
    NvHzb: T;

    /**
     * @default '“Overwater villa is non-negotiable.”'
     */
    cCX9C: T;

    /**
     * @default 'Trusted by a million couples'
     */
    WOzEJ: T;

    /**
     * @default 'Planning weddings with Joy for over a decade.'
     */
    '4VLJf': T;

    /**
     * @default 'Why book with Joy'
     */
    NYzng: T;

    /**
     * @default 'Go for the nicer room.'
     */
    qyPX1: T;

    /**
     * @default 'Find a stay you both love at a private Joy rate, and let us take care of the rest.'
     */
    ksl8A: T;

    /**
     * @default 'Pay over time'
     */
    '3DRCB': T;

    /**
     * @default 'Secure an eligible stay with scheduled payments, at the same total price.'
     */
    r6i80: T;

    /**
     * @default 'Up to {{0}} off'
     */
    '3iYwt': T;

    /**
     * @default 'Save extra at checkout'
     */
    s9ncN: T;

    /**
     * @default 'Comes off at checkout on honeymoon stays you book with Joy.'
     */
    c11jk: T;

    /**
     * @default 'Find a Stay'
     */
    '9HHfP': T;

    /**
     * @default 'Scheduled payments at the same total price.'
     */
    trZx7: T;

    /**
     * @default 'Jan'
     */
    LzVAA: T;

    /**
     * @default 'January'
     */
    '0HPZw': T;

    /**
     * @default 'Dry season, flat water, and the clearest skies of the year.'
     */
    XnhLU: T;

    /**
     * @default 'Warm days without the summer humidity.'
     */
    jhaxl: T;

    /**
     * @default 'Dry season in full swing on the Pacific side.'
     */
    OoJvK: T;

    /**
     * @default 'Whale season off the west shore, and the beaches stay quiet.'
     */
    '0ciFY': T;

    /**
     * @default 'Feb'
     */
    '1sUAA': T;

    /**
     * @default 'February'
     */
    cmKZ1: T;

    /**
     * @default 'Still dry, still quiet, before the March rush.'
     */
    '89pju': T;

    /**
     * @default 'The green season is over and the Pacific coast is at its best.'
     */
    hoHuZ: T;

    /**
     * @default 'Cool nights, warm sea, and the clearest reef water of the year.'
     */
    xLIXq: T;

    /**
     * @default 'Peak whale watching, and the rain stays on the north shore.'
     */
    fJEmz: T;

    /**
     * @default 'Mar'
     */
    '6pWAA': T;

    /**
     * @default 'March'
     */
    HcTaG: T;

    /**
     * @default 'Late March is blossom, and the gardens stay open into the evening.'
     */
    GXSZc: T;

    /**
     * @default 'Warm sea, long days, before the summer heat.'
     */
    I73jn: T;

    /**
     * @default 'The last dry weeks before the rains come back.'
     */
    '51sbB': T;

    /**
     * @default 'Warm and dry, with the trades keeping the afternoons cool.'
     */
    juRF4: T;

    /**
     * @default 'Apr'
     */
    JZTAA: T;

    /**
     * @default 'April'
     */
    sk1eF: T;

    /**
     * @default 'Blossom in the north of the city, and nothing else on the agenda.'
     */
    GDz2c: T;

    /**
     * @default 'The rains stop and the rice terraces are at their greenest.'
     */
    AWXfl: T;

    /**
     * @default 'Shoulder season — warm shore, half-empty sand.'
     */
    '8JCKP': T;

    /**
     * @default 'Cloud forest mornings before the afternoon showers arrive.'
     */
    BMgIJ: T;

    /**
     * @default 'May'
     */
    DqWAA: T;

    /**
     * @default 'Warm sea, long evenings, before the crowds arrive.'
     */
    S9tNz: T;

    /**
     * @default 'Everything is open and nothing is full.'
     */
    UfDHX: T;

    /**
     * @default 'Dry, clear, and far quieter than July.'
     */
    SUDwC: T;

    /**
     * @default 'Calm water on the south shore and light until late.'
     */
    vXbaM: T;

    /**
     * @default 'Jun'
     */
    z9VAA: T;

    /**
     * @default 'June'
     */
    w5rLA: T;

    /**
     * @default 'Long light, warm water, and the caldera at its best.'
     */
    bk0HP: T;

    /**
     * @default 'Dry, calm and warm on the south and west shores.'
     */
    '3CK4X': T;

    /**
     * @default 'The sea has warmed up and the lemon groves are in full flush.'
     */
    oPKIY: T;

    /**
     * @default 'Dry season opens, and the mornings are clear.'
     */
    n2z8H: T;

    /**
     * @default 'Jul'
     */
    x9VAA: T;

    /**
     * @default 'July'
     */
    C5rLA: T;

    /**
     * @default 'Warm sea, long evenings, before the August crowds arrive.'
     */
    xa8SB: T;

    /**
     * @default 'Dry season. Clear mornings and cool nights inland.'
     */
    bkie6: T;

    /**
     * @default 'Hot days, but the meltemi keeps the evenings easy.'
     */
    '7J2r5': T;

    /**
     * @default 'Warm summer days and generally drier weather.'
     */
    T8iRX: T;

    /**
     * @default 'Aug'
     */
    nbTAA: T;

    /**
     * @default 'August'
     */
    nJLdk: T;

    /**
     * @default 'The driest month, and the surf on the west coast is at its best.'
     */
    uasmT: T;

    /**
     * @default 'Warm summer days, with generally gentler surf.'
     */
    pJHLR: T;

    /**
     * @default 'Dry-season island stays, with cooler evenings.'
     */
    '77oTU': T;

    /**
     * @default 'A drier time for lagoon trips and island walks.'
     */
    Xvz5G: T;

    /**
     * @default 'Sep'
     */
    aZYAA: T;

    /**
     * @default 'September'
     */
    Zx6HI: T;

    /**
     * @default 'The sea is still warm and the coast has emptied out.'
     */
    '3x6cD': T;

    /**
     * @default 'Shoulder season, and the quietest beaches of the year.'
     */
    FlMd0: T;

    /**
     * @default 'September light, warm sea, and dinner outside every night.'
     */
    '6Ms1g': T;

    /**
     * @default 'Dry-season weather for beaches and time outdoors.'
     */
    qgdbF: T;

    /**
     * @default 'Oct'
     */
    KQXAA: T;

    /**
     * @default 'October'
     */
    uWFL3: T;

    /**
     * @default 'Warm sea, soft light, and the last of the season.'
     */
    FEP3B: T;

    /**
     * @default 'Warm days near the end of the dry season.'
     */
    CmRN1: T;

    /**
     * @default 'Warm coastal days before the wetter winter months.'
     */
    u6RyN: T;

    /**
     * @default 'Milder days for temple visits and walks around the city.'
     */
    kKBuK: T;

    /**
     * @default 'Nov'
     */
    BFXAA: T;

    /**
     * @default 'November'
     */
    '6KiUL': T;

    /**
     * @default 'The maples turn, and the temple gardens open late.'
     */
    JasbZ: T;

    /**
     * @default 'Warm island stays, with rain still possible before the drier months.'
     */
    WwhNG: T;

    /**
     * @default 'Warm beach days; hurricane season continues through November.'
     */
    ZWqaE: T;

    /**
     * @default 'Warm coastal stays, with more rain as winter begins.'
     */
    CAeiG: T;

    /**
     * @default 'Dec'
     */
    uJUAA: T;

    /**
     * @default 'December'
     */
    PudeQ: T;

    /**
     * @default 'Dry, warm and completely still — the best water of the year.'
     */
    KwrkT: T;

    /**
     * @default 'The Pacific coast moves into its dry season around mid-month.'
     */
    yC5Jj: T;

    /**
     * @default 'Warm sea and clear skies, ahead of the holiday rush.'
     */
    AWDbz: T;

    /**
     * @default 'Green mountains, warm ocean, and the whales returning.'
     */
    YyleZ: T;

    /**
     * @default 'On {{0}}'
     */
    NAkMc: T;

    /**
     * @default 'Add a flight'
     */
    MaY2O: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'JFK or New York'
     */
    '9NSy3': T;

    /**
     * @default 'To'
     */
    fuAAA: T;

    /**
     * @default 'MLE or Maldives'
     */
    YOiuo: T;

    /**
     * @default 'Departure'
     */
    QaGnJ: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Add Flight'
     */
    PkmJf: T;

    /**
     * @default 'You both love this'
     */
    S3Tdz: T;

    /**
     * @default 'Your note'
     */
    n12Ww: T;

    /**
     * @default 'Why this one?'
     */
    f3A8W: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Edit your note: {{0}}'
     */
    bnsLY: T;

    /**
     * @default 'Add Note'
     */
    TO4rO: T;

    /**
     * @default '{{0}} saved'
     */
    '57Qwl': T;

    /**
     * @default '“{{0}}”'
     */
    vd37o: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'All ideas'
     */
    ZjPuM: T;

    /**
     * @default 'Stays'
     */
    '4g76G': T;

    /**
     * @default 'Flights'
     */
    RiVKS: T;

    /**
     * @default 'Places'
     */
    owgcN: T;

    /**
     * @default 'Filters · {{0}}'
     */
    yPbiI: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Filter ideas'
     */
    wEdYx: T;

    /**
     * @default 'Clear'
     */
    NdJoF: T;

    /**
     * @default 'Destinations'
     */
    bpxbg: T;

    /**
     * @default 'Add Another Flight'
     */
    GTC60: T;

    /**
     * @default 'Add Flights'
     */
    mILxK: T;

    /**
     * @default 'Save flights you’re considering'
     */
    yad6y: T;

    /**
     * @default '1 stop'
     * @param {number} count - The number of occurrences.
     * - singular: 1 stop
     * - plural: {{0}} stops
     */
    yN2i1: T;

    /**
     * @default '1 night'
     * @param {number} count - The number of occurrences.
     * - singular: 1 night
     * - plural: {{0}} nights
     */
    MwVDX: T;

    /**
     * @default 'Nothing saved yet'
     * @param {number} count - The number of occurrences.
     * - zero: Nothing saved yet
     * - singular: 1 idea saved
     * - plural: {{0}} ideas saved
     */
    cJo3R: T;

    /**
     * @default 'Your saved ideas, all in one place. Turn them into an itinerary when you’re ready.'
     */
    MbJPF: T;

    /**
     * @default 'New Trip'
     */
    '5AwWG': T;

    /**
     * @default 'Create'
     */
    IERgp: T;

    /**
     * @default 'Itinerary'
     */
    LmQ5u: T;

    /**
     * @default 'Itinerary not started'
     */
    TEJKM: T;

    /**
     * @default 'No dates yet'
     */
    Q8E1c: T;

    /**
     * @default 'Open {{0}}'
     */
    '64MBg': T;

    /**
     * @default 'Planning together'
     */
    xEcqD: T;

    /**
     * @default 'Just you so far'
     */
    UR5Lw: T;

    /**
     * @default 'Start saving ideas'
     */
    a59Mc: T;

    /**
     * @default 'Build Itinerary'
     */
    '7M7Lp': T;

    /**
     * @default 'Open Ideas'
     */
    aDL7b: T;

    /**
     * @default 'Open Board'
     */
    kT9Zb: T;

    /**
     * @default 'Zoom in'
     */
    UESne: T;

    /**
     * @default 'Zoom out'
     */
    bf44O: T;

    /**
     * @default 'Hide Map'
     */
    kQliJ: T;

    /**
     * @default 'Board options'
     */
    W58oQ: T;

    /**
     * @default 'Rename'
     */
    cCEOS: T;

    /**
     * @default 'Delete Board'
     */
    H6cZE: T;

    /**
     * @default 'Rename board'
     */
    AQWdH: T;

    /**
     * @default 'Delete “{{0}}”?'
     */
    vgD2e: T;

    /**
     * @default 'Everything saved on this board goes with it, for both of you. This can’t be undone.'
     */
    zXTmH: T;

    /**
     * @default 'e.g. Italy ideas'
     */
    LnDfK: T;

    /**
     * @default 'Board name'
     */
    rlMJQ: T;

    /**
     * @default 'Place'
     */
    pAzqG: T;

    /**
     * @default 'Search any destination'
     */
    yz3rt: T;

    /**
     * @default 'Stay'
     */
    RqDNA: T;

    /**
     * @default 'Find hotels and accommodations'
     */
    eBeYy: T;

    /**
     * @default 'Car'
     */
    S0TAA: T;

    /**
     * @default 'Find rental cars'
     */
    c0jyo: T;

    /**
     * @default 'Flight'
     */
    Yrp9w: T;

    /**
     * @default 'Add your flights'
     */
    fZ7Sm: T;

    /**
     * @default 'Nine questions, three places that fit you both'
     */
    FDClD: T;

    /**
     * @default 'Add a Place'
     */
    R5YqI: T;

    /**
     * @default 'Add Somewhere to Stay'
     */
    EmLnR: T;

    /**
     * @default 'Add a Car Rental'
     */
    w5yeL: T;

    /**
     * @default 'Add a Flight'
     */
    sGWcN: T;

    /**
     * @default 'Want Inspiration? Take the Quiz'
     */
    '4GDep': T;

    /**
     * @default 'Add Ideas'
     */
    pbBnJ: T;

    /**
     * @default 'Add to board'
     */
    ESZK6: T;

    /**
     * @default 'Choose what you’d like to find.'
     */
    AbLC6: T;

    /**
     * @default 'All Boards'
     */
    '4WIhb': T;

    /**
     * @default 'Ideas'
     */
    uuxGG: T;

    /**
     * @default 'Board view'
     */
    RlbKQ: T;

    /**
     * @default 'for 1 night'
     * @param {number} count - The number of occurrences.
     * - singular: for 1 night
     * - plural: for {{0}} nights
     */
    CQTpC: T;

    /**
     * @default 'for 1 day'
     * @param {number} count - The number of occurrences.
     * - singular: for 1 day
     * - plural: for {{0}} days
     */
    g183M: T;

    /**
     * @default '1 flight'
     * @param {number} count - The number of occurrences.
     * - singular: 1 flight
     * - plural: {{0}} flights
     */
    '4O1A1': T;

    /**
     * @default '1 stay'
     * @param {number} count - The number of occurrences.
     * - singular: 1 stay
     * - plural: {{0}} stays
     */
    Uxn5G: T;

    /**
     * @default '1 car'
     * @param {number} count - The number of occurrences.
     * - singular: 1 car
     * - plural: {{0}} cars
     */
    '0Gu4n': T;

    /**
     * @default '1 place'
     * @param {number} count - The number of occurrences.
     * - singular: 1 place
     * - plural: {{0}} places
     */
    YxkZh: T;

    /**
     * @default '1 flight saved'
     * @param {number} count - The number of occurrences.
     * - singular: 1 flight saved
     * - plural: {{0}} flights saved
     */
    mc8pJ: T;

    /**
     * @default 'That didn’t save. Please try again.'
     */
    jbpQV: T;

    /**
     * @default 'Saved cars'
     */
    erjLo: T;

    /**
     * @default 'Saved stays'
     */
    N1xeT: T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default 'Save {{0}}% with Joy'
     */
    '0lO8o': T;

    /**
     * @default '{{0}} / day'
     */
    hUBKg: T;

    /**
     * @default 'We couldn’t load your board.'
     */
    Bh1id: T;

    /**
     * @default 'Your saves are safe. Check your connection and try again.'
     */
    X0F0j: T;

    /**
     * @default 'Try Again'
     */
    p77Mk: T;

    /**
     * @default 'Our honeymoon {{0}}'
     */
    ieRJp: T;

    /**
     * @default 'Our honeymoon'
     */
    OCQ7O: T;

    /**
     * @default 'Removed from your board'
     */
    BIZLe: T;

    /**
     * @default 'Undo'
     */
    krUNA: T;

    /**
     * @default 'Plan {{0}}'
     */
    zWZOh: T;

    /**
     * @default 'To {{0}}'
     */
    VjZgD: T;

    /**
     * @default 'In {{0}}'
     */
    prxWR: T;

    /**
     * @default 'Add to Trip'
     */
    t50Sv: T;

    /**
     * @default 'Rental car'
     */
    qvqTS: T;

    /**
     * @default 'Saved stay'
     */
    UgEOo: T;

    /**
     * @default 'Best {{0}}'
     */
    qCUFk: T;

    /**
     * @default 'Unavailable {{0}}'
     */
    ahXkZ: T;

    /**
     * @default 'Nowhere yet. Save a place to start.'
     */
    AExUt: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Clear Dates'
     */
    o6F6y: T;

    /**
     * @default 'Show Prices'
     */
    LQ1Vb: T;

    /**
     * @default 'Add dates'
     */
    '0f9wL': T;

    /**
     * @default '2 guests'
     */
    '9osIH': T;

    /**
     * @default 'Nothing saved here yet.'
     */
    QjDHv: T;

    /**
     * @default 'Notes'
     */
    DbZhG: T;

    /**
     * @default 'Show Map'
     */
    DQ7y6: T;

    /**
     * @default '{{0}} added'
     */
    ArEVk: T;

    /**
     * @default '1 destination'
     * @param {number} count - The number of occurrences.
     * - singular: 1 destination
     * - plural: {{0}} destinations
     */
    aF2Ao: T;

    /**
     * @default '1 idea'
     * @param {number} count - The number of occurrences.
     * - singular: 1 idea
     * - plural: {{0}} ideas
     */
    Mbv5Y: T;

    /**
     * @default '1 stay saved'
     * @param {number} count - The number of occurrences.
     * - singular: 1 stay saved
     * - plural: {{0}} stays saved
     */
    YUzAd: T;

    /**
     * @default 'Turn your ideas into a real trip'
     */
    a1BB9: T;

    /**
     * @default 'Pick where you’ll go and for how long. We’ll lay out your dates from {{0}} and match the stays you saved.'
     */
    CojOr: T;

    /**
     * @default 'Pick where you’ll go and for how long. We’ll lay out the days and match the stays you saved.'
     */
    yFr5t: T;

    /**
     * @default 'Nights in {{0}}'
     */
    '04gYQ': T;

    /**
     * @default 'Fewer nights'
     */
    Afv15: T;

    /**
     * @default 'More nights'
     */
    cWs6d: T;

    /**
     * @default 'Its destinations, dates and stays go with it, for both of you. Your saved ideas stay on the board. This can’t be undone.'
     */
    SCt1d: T;

    /**
     * @default 'Delete Plan'
     */
    uY8A1: T;

    /**
     * @default 'Add a Stay'
     */
    '59xfi': T;

    /**
     * @default 'Add to {{0}}'
     */
    KfYM8: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'From your ideas or search new'
     */
    eIbOe: T;

    /**
     * @default 'Rental car from {{0}}'
     */
    Q2ZvS: T;

    /**
     * @default 'Flight to {{0}}'
     */
    fr6GC: T;

    /**
     * @default 'Stays you saved'
     */
    qBvU6: T;

    /**
     * @default 'Cars you saved'
     */
    VOaJY: T;

    /**
     * @default 'Pick one for {{0}}, or search for more.'
     */
    Lavf2: T;

    /**
     * @default 'Search for a new stay'
     */
    TpOQX: T;

    /**
     * @default 'Search for a new car'
     */
    ycJON: T;

    /**
     * @default 'Add Another Destination'
     */
    QKuF1: T;

    /**
     * @default 'Where next? It goes on the end, for a few nights.'
     */
    '6MQFT': T;

    /**
     * @default '1 flight added'
     * @param {number} count - The number of occurrences.
     * - singular: 1 flight added
     * - plural: {{0}} flights added
     */
    gQD7Z: T;

    /**
     * @default '1 stop not priced yet'
     * @param {number} count - The number of occurrences.
     * - singular: 1 stop not priced yet
     * - plural: {{0}} stops not priced yet
     */
    kUiU6: T;

    /**
     * @default '1 thing to sort out before booking'
     * @param {number} count - The number of occurrences.
     * - singular: 1 thing to sort out before booking
     * - plural: {{0}} things to sort out before booking
     */
    wlIEJ: T;

    /**
     * @default 'Destination'
     */
    Su78A: T;

    /**
     * @default '{{0}} for {{1}}'
     */
    KzbZU: T;

    /**
     * @default 'Your trip itinerary'
     */
    lAidG: T;

    /**
     * @default 'Expand itinerary and map'
     */
    EmWzR: T;

    /**
     * @default 'Expand'
     */
    atMUv: T;

    /**
     * @default 'Plans'
     */
    uGzqG: T;

    /**
     * @default 'Plan name'
     */
    YgnTL: T;

    /**
     * @default 'Save name'
     */
    Wtjl5: T;

    /**
     * @default 'Cancel rename'
     */
    IntoB: T;

    /**
     * @default 'Double-click to rename'
     */
    XvUa7: T;

    /**
     * @default 'Plan options'
     */
    '5Tpse': T;

    /**
     * @default 'Rename Plan'
     */
    rwg7Z: T;

    /**
     * @default 'Duplicate Plan'
     */
    qSYuD: T;

    /**
     * @default 'Try Another Plan'
     */
    pLIlb: T;

    /**
     * @default 'Trip total'
     */
    '91ICe': T;

    /**
     * @default 'Priced so far'
     */
    mmANc: T;

    /**
     * @default 'Updating prices'
     */
    uIfVR: T;

    /**
     * @default 'Compare Plans'
     */
    Vuh7W: T;

    /**
     * @default 'Stays {{0}}'
     */
    QMp3T: T;

    /**
     * @default 'Cars {{0}}'
     */
    zH18b: T;

    /**
     * @default 'Nothing priced yet'
     */
    aRGag: T;

    /**
     * @default '{{0}}: No stay yet for {{1}}.'
     */
    eHqTM: T;

    /**
     * @default '{{0}}: No stay yet.'
     */
    MekZk: T;

    /**
     * @default 'Add flight to {{0}}'
     */
    iEgCA: T;

    /**
     * @default 'Reorder {{0}}: drag, or use the up and down arrow keys'
     */
    pa4fS: T;

    /**
     * @default 'Drag, or use the arrow keys, to reorder'
     */
    '2aweh': T;

    /**
     * @default 'Updating price'
     */
    rIHDN: T;

    /**
     * @default 'Remove {{0}}'
     */
    '0zcyi': T;

    /**
     * @default 'No stay yet for {{0}} ·'
     */
    w7pk1: T;

    /**
     * @default 'No stay yet ·'
     */
    z2E43: T;

    /**
     * @default 'Add Flight Home'
     */
    aBMLU: T;

    /**
     * @default 'Book Trip'
     */
    iipri: T;

    /**
     * @default 'View Itinerary & Map'
     */
    YrNsU: T;

    /**
     * @default 'Start with something you’ve saved'
     */
    qht2H: T;

    /**
     * @default 'Drag a place, stay, or car here — or tap'
     */
    k7Ppj: T;

    /**
     * @default 'on any idea. We’ll line up the dates and keep a running total.'
     */
    sXcOU: T;

    /**
     * @default '{{0}} is missing a stay or a price, so we can’t say which costs less yet.'
     */
    '1gpIW': T;

    /**
     * @default '{{0}} are missing a stay or a price, so we can’t say which costs less yet.'
     */
    nFEbG: T;

    /**
     * @default '{{0}} costs {{1}} less.'
     */
    ySdE9: T;

    /**
     * @default 'Your plans cost the same.'
     */
    Z1zKZ: T;

    /**
     * @default 'Add another plan to compare against.'
     */
    I4rkS: T;

    /**
     * @default 'Compare your plans'
     */
    EEMT0: T;

    /**
     * @default 'Full-trip totals for 2 with Joy rates applied'
     */
    Dy9B3: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'so far'
     */
    HeU4W: T;

    /**
     * @default 'Viewing'
     */
    pQgWm: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Adds a stay at {{0}}'
     */
    ve84L: T;

    /**
     * @default 'Drops the stay at {{0}}'
     */
    nkWPa: T;

    /**
     * @default 'Adds {{0}}'
     */
    MMWuC: T;

    /**
     * @default 'Drops {{0}}'
     */
    '2bgHA': T;

    /**
     * @default '{{0}}: {{1}} instead of {{2}}'
     */
    sJQQO: T;

    /**
     * @default '{{0}} vs. {{1}}'
     */
    Cbhlb: T;

    /**
     * @default 'The same places, nights and stays'
     */
    x3dbw: T;

    /**
     * @default 'View your trip'
     */
    '7tIXU': T;

    /**
     * @default 'Build Your Itinerary'
     */
    UZfr1: T;

    /**
     * @default 'Lay your ideas out over the days.'
     */
    '7IRoa': T;

    /**
     * @default 'Drop to add here'
     */
    '108pH': T;

    /**
     * @default 'Drop here'
     */
    P9LlQ: T;

    /**
     * @default 'Drag to reorder'
     */
    UEgfY: T;

    /**
     * @default 'Updating prices for your dates…'
     */
    h9MZE: T;

    /**
     * @default '1 day'
     * @param {number} count - The number of occurrences.
     * - singular: 1 day
     * - plural: {{0}} days
     */
    ehHVF: T;

    /**
     * @default 'Loading your itinerary…'
     */
    oDeCO: T;

    /**
     * @default 'We couldn’t load your itinerary.'
     */
    QNhZH: T;

    /**
     * @default 'Save a place or a stay first. Your itinerary is built from the destinations on your board.'
     */
    qNFDF: T;

    /**
     * @default '1 room · {{0}} guests'
     */
    '08ZkO': T;

    /**
     * @default 'Pick up in {{0}}'
     */
    x7UNW: T;

    /**
     * @default '{{0}} guests'
     */
    nsjy1: T;

    /**
     * @default 'On your board'
     */
    GvlX3: T;

    /**
     * @default '{{0}} options'
     */
    '27DuN': T;

    /**
     * @default 'Move Earlier'
     */
    '7yx0S': T;

    /**
     * @default 'Move Later'
     */
    xlsDb: T;

    /**
     * @default 'Remove Destination'
     */
    suSVE: T;

    /**
     * @default 'Add a stay for {{0}}'
     */
    Efd3D: T;

    /**
     * @default 'Arrival'
     */
    jxQwh: T;

    /**
     * @default 'Travel to {{0}}'
     */
    RGj8G: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Flight home'
     */
    rg99l: T;

    /**
     * @default 'Add transfer details'
     */
    '4KavC': T;

    /**
     * @default 'Add flight details'
     */
    RozSZ: T;

    /**
     * @default 'Flight details coming soon'
     */
    '8g5gE': T;

    /**
     * @default 'Choose a stay in {{0}} to see your full total.'
     */
    k1Nss: T;

    /**
     * @default 'You save {{0}} with Joy rates'
     */
    FYNiU: T;

    /**
     * @default 'Prices appear once your stays are priced for these dates.'
     */
    hu44F: T;

    /**
     * @default 'Honeymoon itinerary'
     */
    JZTMz: T;

    /**
     * @default 'Your honeymoon team'
     */
    '6kscr': T;

    /**
     * @default '{{0}} · Best {{1}}'
     */
    IPbWe: T;

    /**
     * @default 'From beach days to city adventures, explore places that fit your plans.'
     */
    lb2SL: T;

    /**
     * @default 'Adding to {{0}}'
     */
    oZ7tB: T;

    /**
     * @default 'Saved items will go to this board.'
     */
    utAEA: T;

    /**
     * @default 'View Board'
     */
    '1RKpD': T;

    /**
     * @default 'Stop adding to this board'
     */
    I0arU: T;

    /**
     * @default 'Find a rental car'
     */
    io1Ry: T;

    /**
     * @default 'Find a place to stay'
     */
    Haox2: T;

    /**
     * @default 'Where to for your honeymoon?'
     */
    L6oL9: T;

    /**
     * @default 'Start with a place from {{0}}, or search anywhere.'
     */
    '2RByd': T;

    /**
     * @default 'Search anywhere in the world, or start with a few places we love.'
     */
    Deb7R: T;

    /**
     * @default 'Places from your board'
     */
    '7aV3S': T;

    /**
     * @default 'Need ideas? Take the quiz'
     */
    Mc323: T;

    /**
     * @default 'Popular stays in {{0}}'
     */
    kLKJ2: T;

    /**
     * @default 'Handpicked stays for your board.'
     */
    Jh33o: T;

    /**
     * @default 'See all in {{0}}'
     */
    nZeAQ: T;

    /**
     * @default 'Where to go in {{0}}'
     */
    zW3JD: T;

    /**
     * @default 'Discover destinations for your honeymoon month.'
     */
    IPa9F: T;

    /**
     * @default 'Pick a month'
     */
    IxSIQ: T;

    /**
     * @default 'Best in {{0}}'
     */
    XhO1w: T;

    /**
     * @default 'Find your kind of honeymoon'
     */
    BnFiz: T;

    /**
     * @default 'Pick a kind of trip'
     */
    OEpxk: T;

    /**
     * @default 'All'
     */
    '5WTAA': T;

    /**
     * @default 'All destinations'
     */
    '2IcJm': T;

    /**
     * @default 'By location'
     */
    qfYPi: T;

    /**
     * @default 'Pick a region'
     */
    G5kL6: T;

    /**
     * @default 'Everywhere'
     */
    Ivvo4: T;

    /**
     * @default 'Stays couples love'
     */
    Dz8hG: T;

    /**
     * @default 'Hotels in these destinations, with private Joy rates for two.'
     */
    B3PXA: T;

    /**
     * @default 'Popular rental cars in {{0}}'
     */
    '357Vo': T;

    /**
     * @default 'Airport and city pick-ups near {{0}}.'
     */
    '5iaIr': T;

    /**
     * @default 'Rental cars in {{0}}'
     */
    SkpLH: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default '/ day'
     */
    xaK1D: T;

    /**
     * @default 'Pick up at {{0}}'
     */
    f1fmU: T;

    /**
     * @default 'Previous: {{0}}'
     */
    FFL6u: T;

    /**
     * @default 'Next: {{0}}'
     */
    tE1Is: T;

    /**
     * @default 'Finding stays…'
     */
    r7nzo: T;

    /**
     * @default 'a night'
     */
    FZacS: T;

    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default 'French Polynesia'
     */
    kV6Fb: T;

    /**
     * @default 'Indian Ocean'
     */
    '5ICTI': T;

    /**
     * @default 'Greece'
     */
    ZpHH0: T;

    /**
     * @default 'Hawaii, USA'
     */
    AuVOK: T;

    /**
     * @default 'Sicily, Italy'
     */
    OJKP1: T;

    /**
     * @default 'Morocco'
     */
    '0ZgU5': T;

    /**
     * @default 'Indonesia'
     */
    sBIam: T;

    /**
     * @default 'Japan'
     */
    uUXLG: T;

    /**
     * @default 'Italy'
     */
    fSMJG: T;

    /**
     * @default 'France'
     */
    '74Vcx': T;

    /**
     * @default 'Mexico'
     */
    BMjAF: T;

    /**
     * @default 'Iceland'
     */
    a5Q3w: T;

    /**
     * @default 'Switzerland'
     */
    HSz7Y: T;

    /**
     * @default 'Portugal'
     */
    sT8HT: T;

    /**
     * @default 'Central America'
     */
    '532RQ': T;

    /**
     * @default 'South Africa'
     */
    '9OqGO': T;

    /**
     * @default 'New York, USA'
     */
    '4mWO5': T;

    /**
     * @default 'Caribbean'
     */
    zwlWQ: T;

    /**
     * @default 'Beach and sun'
     */
    SFbr8: T;

    /**
     * @default 'Adventure'
     */
    '6eImY': T;

    /**
     * @default 'Cities'
     */
    fzwzo: T;

    /**
     * @default 'Slow and quiet'
     */
    '8qOCL': T;

    /**
     * @default 'Food and wine'
     */
    objy4: T;

    /**
     * @default 'Off the beaten path'
     */
    U4l61: T;

    /**
     * @default 'Europe'
     */
    Y2nFv: T;

    /**
     * @default 'Islands and the Pacific'
     */
    poSqi: T;

    /**
     * @default 'Asia'
     */
    QLVKA: T;

    /**
     * @default 'The Americas'
     */
    o3fOg: T;

    /**
     * @default 'Africa'
     */
    kvISj: T;

    /**
     * @default 'On the water'
     */
    NkzSu: T;

    /**
     * @default 'Above the Mediterranean and beyond'
     */
    '5ccSW': T;

    /**
     * @default 'Slow, quiet hideaways'
     */
    wmbvC: T;

    /**
     * @default 'City stays'
     */
    pMtTc: T;

    /**
     * @default 'your partner'
     */
    DQSab: T;

    /**
     * @default 'Your partner'
     */
    J7y22: T;

    /**
     * @default 'Dreamy.'
     */
    '4OrPE': T;

    /**
     * @default 'Good call.'
     */
    xR92I: T;

    /**
     * @default 'Delicious.'
     */
    '70vE8': T;

    /**
     * @default 'Honest.'
     */
    '9Ps83': T;

    /**
     * @default 'Noted.'
     */
    Uq4bI: T;

    /**
     * @default 'Worth it.'
     */
    Xqd1z: T;

    /**
     * @default 'Bon voyage.'
     */
    OJTwJ: T;

    /**
     * @default 'Love that.'
     */
    FCPrZ: T;

    /**
     * @default 'Perfect.'
     */
    vA66P: T;

    /**
     * @default 'sun and salt water'
     */
    Q0kT2: T;

    /**
     * @default 'a bit of wild'
     */
    XhWBK: T;

    /**
     * @default 'city streets'
     */
    N1A2B: T;

    /**
     * @default 'slow, quiet mornings'
     */
    kZluv: T;

    /**
     * @default 'long, good meals'
     */
    X6rNz: T;

    /**
     * @default 'going off the map'
     */
    obRBc: T;

    /**
     * @default 'the classics'
     */
    '4XFtQ': T;

    /**
     * @default 'Start Over'
     */
    '41lFJ': T;

    /**
     * @default 'Honeymoon quiz'
     */
    tyvwS: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default 'Honeymoon quiz · {{0}}'
     */
    gWeKK: T;

    /**
     * @default 'You meet in the middle in {{0}}'
     */
    ApOW5: T;

    /**
     * @default 'Greetings from {{0}}'
     */
    ibehg: T;

    /**
     * @default 'Blending your answers with {{0}}’s…'
     */
    FFGYT: T;

    /**
     * @default 'Finding your honeymoon…'
     */
    G9n5X: T;

    /**
     * @default 'What gave you away: {{0}} and {{1}}.'
     */
    QxfNo: T;

    /**
     * @default 'Your three matches'
     */
    '6RVqt': T;

    /**
     * @default 'Best match'
     */
    '5zC4i': T;

    /**
     * @default '2nd'
     */
    YIPAA: T;

    /**
     * @default '3rd'
     */
    FcPAA: T;

    /**
     * @default 'Sun and sea'
     */
    CmB3s: T;

    /**
     * @default 'Wild places'
     */
    QuPVY: T;

    /**
     * @default 'City streets'
     */
    TihUd: T;

    /**
     * @default 'Quiet time'
     */
    '5ZeXp': T;

    /**
     * @default 'Good food'
     */
    jbR0M: T;

    /**
     * @default 'Off the map'
     */
    iSvGT: T;

    /**
     * @default 'Basically the same honeymoon.'
     */
    hYZkJ: T;

    /**
     * @default 'Very close. A few friendly debates.'
     */
    m5pLN: T;

    /**
     * @default 'Some negotiating ahead.'
     */
    UtLp9: T;

    /**
     * @default 'Opposites. It’ll make a great story.'
     */
    Zrazb: T;

    /**
     * @default 'You’re in sync on sun and sea.'
     */
    MTALa: T;

    /**
     * @default 'You’re in sync on wild places.'
     */
    QCWgB: T;

    /**
     * @default 'You’re in sync on city streets.'
     */
    FV1sk: T;

    /**
     * @default 'You’re in sync on quiet time.'
     */
    xfyNh: T;

    /**
     * @default 'You’re in sync on good food.'
     */
    jtpWE: T;

    /**
     * @default 'You’re in sync on going off the map.'
     */
    c9EzU: T;

    /**
     * @default 'You’ll want to talk about sun and sea.'
     */
    ekLWp: T;

    /**
     * @default 'You’ll want to talk about wild places.'
     */
    iThrQ: T;

    /**
     * @default 'You’ll want to talk about city streets.'
     */
    Fxoqd: T;

    /**
     * @default 'You’ll want to talk about quiet time.'
     */
    '997vw': T;

    /**
     * @default 'You’ll want to talk about good food.'
     */
    xiREo: T;

    /**
     * @default 'You’ll want to talk about going off the map.'
     */
    mIKG0: T;

    /**
     * @default 'No real arguments on the horizon.'
     */
    qBfVh: T;

    /**
     * @default '{{0}}’s pick'
     */
    PEDmF: T;

    /**
     * @default 'Your pick'
     */
    isJXw: T;

    /**
     * @default '{{0}} · where you meet'
     */
    mG4w0: T;

    /**
     * @default '{{0}} · {{1}}’s pick'
     */
    PkLtE: T;

    /**
     * @default '{{0}} · your pick'
     */
    haAs4: T;

    /**
     * @default '{{0}}%'
     */
    DLOGt: T;

    /**
     * @default 'Where you agree, and where you don’t'
     */
    DZ2l2: T;

    /**
     * @default '{{0}}: {{1}} {{2}} of 10, you {{3}} of 10'
     */
    JmWoW: T;

    /**
     * @default 'You picked the same place. Romance, or a coincidence.'
     */
    '8QsEX': T;

    /**
     * @default 'Somewhere you’d both be happy'
     */
    lXmSw: T;

    /**
     * @default 'You both land in {{0}}'
     */
    kWiuV: T;

    /**
     * @default 'Meet in the middle in {{0}}'
     */
    jBYDC: T;

    /**
     * @default '{{0}} finished · {{1}} of {{2}}'
     */
    NwzI0: T;

    /**
     * @default '{{0}} took the honeymoon quiz.'
     */
    DnJjJ: T;

    /**
     * @default 'Where should you two honeymoon?'
     */
    '8MGOj': T;

    /**
     * @default 'Your turn. Answer without peeking, then see how close your honeymoons are, and where you’d meet in the middle.'
     */
    '3OiQB': T;

    /**
     * @default 'Find your honeymoon type, then send it to {{0}} and see how close you are.'
     */
    Wiw9E: T;

    /**
     * @default 'Find your honeymoon type. We’ll suggest three destinations that fit you both.'
     */
    '21aWS': T;

    /**
     * @default 'Start the Quiz'
     */
    IKJON: T;

    /**
     * @default '{{0}} questions · about a minute'
     */
    mbIw2: T;

    /**
     * @default '{{0}}, {{1}} & {{2}}'
     */
    paKLt: T;

    /**
     * @default 'Saved to your board “{{0}}”.'
     */
    kqtaM: T;

    /**
     * @default 'Add to a Board'
     */
    r7K92: T;

    /**
     * @default 'Save as a Board'
     */
    Uwkrg: T;

    /**
     * @default 'Our honeymoon quiz'
     */
    D6hl3: T;

    /**
     * @default 'I took our honeymoon quiz. Your turn.'
     */
    vpmMc: T;

    /**
     * @default 'Sent to {{0}}'
     */
    NEqQV: T;

    /**
     * @default 'Link copied for {{0}}'
     */
    zlQUG: T;

    /**
     * @default 'Open the quiz again after {{0}} takes it to see how close you are.'
     */
    QNhiA: T;

    /**
     * @default 'Now send it to {{0}}.'
     */
    kIC87: T;

    /**
     * @default '{{0}} takes the quiz, then you both see how close your honeymoons are, and where you’d meet in the middle.'
     */
    iWrio: T;

    /**
     * @default 'The quiz lives on your event, so {{0}} needs to be invited to it first. The link works once they’ve accepted.'
     */
    Cuh6X: T;

    /**
     * @default 'Invite {{0}}'
     */
    RB8ms: T;

    /**
     * @default 'Send to {{0}}'
     */
    pS20J: T;

    /**
     * @default 'Copy link for {{0}}'
     */
    '8kfIG': T;

    /**
     * @default 'Link copied'
     */
    IHIze: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Your browser blocked copying. Here’s the link: {{0}}'
     */
    Z9IVL: T;

    /**
     * @default 'Where you’d stay in {{0}}'
     */
    xCK75: T;

    /**
     * @default 'Pick a place'
     */
    FcsWQ: T;

    /**
     * @default '{{0}} · your match'
     */
    bC9fO: T;

    /**
     * @default 'Why book with Joy.'
     */
    bs917: T;

    /**
     * @default 'Private honeymoon rates at hotels like these, often better than booking on your own, plus upgrades when a hotel offers them. You can put your honeymoon fund toward it.'
     */
    v1hh5: T;

    /**
     * @default 'Prices for your dates, {{0}}'
     */
    Fwhct: T;

    /**
     * @default 'Sample prices for {{0}}. Add dates to a board to see yours.'
     */
    B1nOB: T;

    /**
     * @default 'We couldn’t load stays just now.'
     */
    '0XhYC': T;

    /**
     * @default 'No Joy rates in {{0}} for these dates yet. Try another match, or different dates on the board.'
     */
    KRzv8: T;

    /**
     * @default '{{0}}% off · Joy rate'
     */
    peqCN: T;

    /**
     * @default 'You save {{0}} a night'
     */
    VVhlA: T;

    /**
     * @default 'See Rooms'
     */
    '5asXv': T;

    /**
     * @default 'Question 3 of {{0}}'
     */
    YEuh2: T;

    /**
     * @default 'Wake up to a view of…'
     */
    hfZ63: T;

    /**
     * @default 'The ocean, from bed'
     */
    IrCzZ: T;

    /**
     * @default 'Mountains in the mist'
     */
    zUYDs: T;

    /**
     * @default 'It’s a match'
     */
    '1rOyH': T;

    /**
     * @default 'One island, one villa, very little to decide.'
     */
    Su5xS: T;

    /**
     * @default 'Whitewashed cliffs, caldera sunsets, long dinners.'
     */
    '0ZxLt': T;

    /**
     * @default 'Lemon groves, cliffside dinners, a boat for the afternoon.'
     */
    a4hGJ: T;

    /**
     * @default 'Temples at dawn, tea houses, a dinner you’ll talk about for years.'
     */
    Roe9S: T;

    /**
     * @default 'Rice terraces, jungle villas, and a spa around every corner.'
     */
    xXzHD: T;

    /**
     * @default 'Sunrise from the volcano, snorkeling, slow beach days.'
     */
    RnYpg: T;

    /**
     * @default 'Jungle, cenotes, and barefoot dinners by the sea.'
     */
    xAS8D: T;

    /**
     * @default 'Volcano views, hot springs, and monkeys in the trees.'
     */
    '7O9dY': T;

    /**
     * @default 'An overwater bungalow and a lagoon that looks edited.'
     */
    ppYSB: T;

    /**
     * @default 'Soft sand, warm water, and an island to yourselves.'
     */
    '1ZmzW': T;

    /**
     * @default 'A hill town above the sea, with Etna just beyond the terrace.'
     */
    '9YsJj': T;

    /**
     * @default 'Riads, rooftop sunsets, and a market for every mood.'
     */
    '8oxKt': T;

    /**
     * @default 'Hill towns, olive oil, and a table that lasts all evening.'
     */
    uKxjI: T;

    /**
     * @default 'The classic for a reason: cafés, museums, late walks.'
     */
    upbPG: T;

    /**
     * @default 'Northern lights, hot springs, and a lot of sky.'
     */
    x0o7v: T;

    /**
     * @default 'The Matterhorn out the window and fondue by the fire.'
     */
    '4RBYY': T;

    /**
     * @default 'Tiled hillsides, custard tarts, fado in a tiny bar.'
     */
    uxXwe: T;

    /**
     * @default 'Granite boulders, powdery beaches, almost nobody around.'
     */
    N60yt: T;

    /**
     * @default 'Safari at sunrise, Table Mountain and winelands after.'
     */
    txK5C: T;

    /**
     * @default 'Broadway, rooftop bars, and dinner at midnight.'
     */
    gM1sP: T;

    /**
     * @default 'The Pitons, warm water, and suites open to the view.'
     */
    RJ6dM: T;

    /**
     * @default 'First morning as a married couple. Where are you waking up?'
     */
    '6Ogns': T;

    /**
     * @default 'A bungalow over turquoise water'
     */
    MQTto: T;

    /**
     * @default 'A stone villa, shutters open to a hillside'
     */
    KRXiA: T;

    /**
     * @default 'A loft in a city that never asked you to sleep'
     */
    hefXZ: T;

    /**
     * @default 'A lodge where the view is mostly mountains'
     */
    '1qD5m': T;

    /**
     * @default 'It’s 10am. What are you doing?'
     */
    Jts6r: T;

    /**
     * @default 'Absolutely nothing, on purpose'
     */
    iKROp: T;

    /**
     * @default 'Already on a trail'
     */
    qbYxn: T;

    /**
     * @default 'In line at a bakery someone recommended'
     */
    '65vzU': T;

    /**
     * @default 'On a boat with a drink we didn’t order'
     */
    '7jg5x': T;

    /**
     * @default 'Pick the dinner.'
     */
    W8oBg: T;

    /**
     * @default 'A tasting menu that takes three hours'
     */
    cb1Lg: T;

    /**
     * @default 'Grilled fish, bare feet, plastic chairs'
     */
    '7lTqA': T;

    /**
     * @default 'A picnic we put together from a market'
     */
    lzK0A: T;

    /**
     * @default 'Room service, in robes, no notes'
     */
    sXA8a: T;

    /**
     * @default 'How do you two travel, honestly?'
     */
    f4QBi: T;

    /**
     * @default 'We have a spreadsheet. It has tabs.'
     */
    '4o2l4': T;

    /**
     * @default 'We book the flights and figure out the rest'
     */
    Vo0wx: T;

    /**
     * @default 'One of us has a folder of saved reels'
     */
    jkoM8: T;

    /**
     * @default 'We’d love someone else to plan all of it'
     */
    '7eKmB': T;

    /**
     * @default 'The weather, ideally?'
     */
    urC6P: T;

    /**
     * @default 'Hot. Sunscreen-on-the-pillow hot.'
     */
    ImwF5: T;

    /**
     * @default 'Warm enough for linen'
     */
    a42ft: T;

    /**
     * @default 'Cool and crisp, a sweater by the fire'
     */
    NDp0o: T;

    /**
     * @default 'Weather? We’ll be inside.'
     */
    Xpc7F: T;

    /**
     * @default 'You get to splurge on one thing.'
     */
    z9Iii: T;

    /**
     * @default 'The room. A view worth the bill.'
     */
    SgDy4: T;

    /**
     * @default 'The food. Every meal.'
     */
    xjpku: T;

    /**
     * @default 'An experience we’ll talk about for years'
     */
    MBJfe: T;

    /**
     * @default 'All of it, no choosing'
     */
    cRH52: T;

    /**
     * @default 'How far are you willing to fly?'
     */
    ZLlHk: T;

    /**
     * @default 'As far as it takes'
     */
    WqpgB: T;

    /**
     * @default 'One good movie and a nap'
     */
    qUjKG: T;

    /**
     * @default 'Just far enough to feel like we left'
     */
    KdCp0: T;

    /**
     * @default 'We’d honestly take a train'
     */
    VFG64: T;

    /**
     * @default 'You want to come home with…'
     */
    l6CId: T;

    /**
     * @default 'A tan and zero emails read'
     */
    QNU3Q: T;

    /**
     * @default 'A story that starts “so there was this goat”'
     */
    n5MkR: T;

    /**
     * @default 'A suitcase of things we can’t find at home'
     */
    '0pT4R': T;

    /**
     * @default 'Sore legs and a camera roll full of sky'
     */
    PLqvZ: T;

    /**
     * @default 'The soundtrack to the trip is…'
     */
    UKnvY: T;

    /**
     * @default 'Waves, and then more waves'
     */
    pyyMK: T;

    /**
     * @default 'A street band we’ll never find again'
     */
    F9S5F: T;

    /**
     * @default 'Wind, and nothing else'
     */
    dY7PZ: T;

    /**
     * @default 'Clinking glasses'
     */
    LPPpO: T;

    /**
     * @default 'Link copied. Send it to {{0}}.'
     */
    w4IH0: T;

    /**
     * @default 'Link copied.'
     */
    yNkNV: T;

    /**
     * @default 'Share Your Board'
     */
    kx41N: T;

    /**
     * @default 'Invite Your Partner'
     */
    IFnWT: T;

    /**
     * @default 'Copy link to our board'
     */
    YL8xC: T;

    /**
     * @default 'Anyone on your event can open it.'
     */
    n82sm: T;

    /**
     * @default 'Only people on your event can open it.'
     */
    c2BYJ: T;

    /**
     * @default 'Manage Who Can Plan'
     */
    UMEfO: T;

    /**
     * @default 'Who can open this board and plan with you.'
     */
    XIKRZ: T;

    /**
     * @default 'Add them to your event so you can plan together.'
     */
    '1B1C6': T;

    /**
     * @default 'Try {{0}}'
     */
    b6W4o: T;

    /**
     * @default 'Where are you going?'
     */
    FvpLN: T;

    /**
     * @default 'Try Maldives, Amalfi Coast or Bali'
     */
    Zq6Km: T;

    /**
     * @default 'When?'
     */
    '7ZEPH': T;

    /**
     * @default 'Spending & Savings Buckets'
     */
    q0mqE: T;

    /**
     * @default 'Spend on the dance. Save for France.'
     */
    saxD3: T;

    /**
     * @default 'Automatically save while you spend.'
     */
    gbdr2: T;

    /**
     * @default 'Ally Bank, Member FDIC.'
     */
    OoQTX: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Your bank declined the transfer. Contact your bank before trying again.'
     */
    YKGgp: T;

    /**
     * @default 'Your bank account is closed. Add a different bank account.'
     */
    Czi0r: T;

    /**
     * @default 'Your bank account details don't match your bank's records. Edit your bank account.'
     */
    '4cSiS': T;

    /**
     * @default 'Your bank account can't receive this currency.'
     */
    X1Hk1: T;

    /**
     * @default 'The transfer exceeded the amount your card can receive. Add a bank account or transfer a smaller amount.'
     */
    U3xeP: T;

    /**
     * @default 'We couldn't complete your transfer.'
     */
    fC19P: T;

    /**
     * @default 'Hi, my Cash Fund transfer failed. Can you help me with the next step?'
     */
    gixXo: T;

    /**
     * @default 'Your payout method has been updated.'
     */
    DXcnd: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'Available to transfer'
     */
    fVhYn: T;

    /**
     * @default 'Money you can transfer to your bank now.'
     */
    CFXzD: T;

    /**
     * @default 'Stripe needs a bit more information before you can transfer.'
     */
    EQ0yv: T;

    /**
     * @default 'Verify your account to transfer'
     */
    '1Ggcb': T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Transfer processing...'
     */
    CHg1I: T;

    /**
     * @default 'Contact Joy'
     */
    EXmwr: T;

    /**
     * @default 'Transfer to Bank'
     */
    WRWhY: T;

    /**
     * @default 'You don't have any funds available to transfer yet.'
     */
    a41yU: T;

    /**
     * @default 'Used on Joy stays'
     */
    qz0qX: T;

    /**
     * @default 'Applied toward hotel bookings made on Joy.'
     */
    M0qiE: T;

    /**
     * @default 'Lifetime total received'
     */
    Q9zfd: T;

    /**
     * @default 'Total cash contributions collected from registry funds and private funds via Stripe.'
     */
    ti5nP: T;

    /**
     * @default 'Processing'
     */
    '7B9SY': T;

    /**
     * @default 'Guest contributions are under review and usually become available within a few days.'
     */
    w7Z9b: T;

    /**
     * @default 'Available'
     */
    d8nEm: T;

    /**
     * @default 'Ready to transfer to your bank.'
     */
    nvKra: T;

    /**
     * @default 'Transfer in progress'
     */
    pK5Th: T;

    /**
     * @default 'On the way to your bank.'
     */
    bWVHG: T;

    /**
     * @default 'Transferred'
     */
    Y8MAL: T;

    /**
     * @default 'Successfully received by your bank.'
     */
    qDfCF: T;

    /**
     * @default 'Get cash equivalent'
     */
    '7PgmF': T;

    /**
     * @default 'Registry Currency'
     */
    '27F8l': T;

    /**
     * @default 'Select the currency displayed on your registry.'
     */
    '2cuXa': T;

    /**
     * @default 'We will use this currency symbol for any gift that isn't added from the Joy Shop or synced from an external registry.'
     */
    W3GAN: T;

    /**
     * @default 'If you have an existing cash fund with contributions, the currency for that gift will not be changed.'
     */
    '3ooIO': T;

    /**
     * @default 'We couldn't check your payout account, so the currency can't be changed right now.'
     */
    CrXPI: T;

    /**
     * @default 'First name is required'
     */
    '8niW2': T;

    /**
     * @default 'Last name is required'
     */
    cLL4a: T;

    /**
     * @default 'Country is required'
     */
    '94Fcd': T;

    /**
     * @default 'First, a little paperwork.'
     */
    y95K8: T;

    /**
     * @default 'Enter the name on a valid government ID. It must match your bank account exactly.'
     */
    TVict: T;

    /**
     * @default 'Legal First Name'
     */
    iEzPE: T;

    /**
     * @default 'Legal Last Name'
     */
    '0bdvm': T;

    /**
     * @default 'Country'
     */
    G9ai3: T;

    /**
     * @default 'Set by your country. Can't be changed after saving'
     */
    eJtMr: T;

    /**
     * @default 'Set this up later'
     */
    '9eOFD': T;

    /**
     * @default 'From {{0}}'
     */
    SXEqF: T;

    /**
     * @default 'Book a stay'
     */
    BmaG4: T;

    /**
     * @default 'Honeymoon Rate — book a stay with your honeymoon fund'
     */
    H5aUW: T;

    /**
     * @default 'Honeymoon Rate'
     */
    caAsS: T;

    /**
     * @default 'Price unavailable'
     */
    PCrkG: T;

    /**
     * @default 'Available once gifts sync from this registry.'
     */
    PoFSP: T;

    /**
     * @default 'This registry couldn't sync'
     */
    G00eB: T;

    /**
     * @default 'Guests will see gifts from your last sync. To try again, delete this registry and connect it again. You can also add gifts from Joy's catalog so guests can shop right here.'
     */
    VyAyy: T;

    /**
     * @default 'Guests will only see a link to {{0}}. To try again, delete this registry and connect it again. You can also add gifts from Joy's catalog so guests can shop right here.'
     */
    mROny: T;

    /**
     * @default 'Buy Now'
     */
    kOZfF: T;

    /**
     * @default 'Extra {{0}} off on Joy'
     */
    chrxF: T;

    /**
     * @default 'Ready to plan the honeymoon?'
     */
    NrUP5: T;

    /**
     * @default 'Put your gifts toward a stay and save on rates you won't find elsewhere.'
     */
    rvekL: T;

    /**
     * @default 'See Honeymoon Stays'
     */
    ffhfq: T;

    /**
     * @default 'Let your guests in {{0}} give by card or Apple Pay'
     */
    t3JY8: T;

    /**
     * @default 'Let your guests give by card or Apple Pay'
     */
    gKEAH: T;

    /**
     * @default 'We now support {{0}} cash funds via Stripe. Guests pay a small card processing fee.'
     */
    '1oMmQ': T;

    /**
     * @default 'We now support secure cash fund contributions via Stripe. Guests pay a small card processing fee.'
     */
    C5p18: T;

    /**
     * @default 'Enable card payments'
     */
    YN5yo: T;

    /**
     * @default 'Let loved ones chip in for your honeymoon, first home, or whatever comes next.'
     */
    XVMnx: T;

    /**
     * @default 'Show guests how they can contribute to a cause close to your hearts.'
     */
    f8er4: T;

    /**
     * @default 'Spotted something perfect on another site? Add it with a link.'
     */
    pT62c: T;

    /**
     * @default 'Let loved ones chip in for… your sweet honeymoon'
     */
    Vzcc3: T;

    /**
     * @default 'Let loved ones chip in for… your future home'
     */
    vyHFt: T;

    /**
     * @default 'Let loved ones chip in for… the wedding of your dreams'
     */
    HI2Yp: T;

    /**
     * @default 'Flexible Cash Funds'
     */
    Q3YfS: T;

    /**
     * @default 'Support Charities'
     */
    XLqs1: T;

    /**
     * @default 'Gifts from Anywhere'
     */
    su1KE: T;

    /**
     * @default 'Add a Gift'
     */
    ut6di: T;

    /**
     * @default 'Manage your gifts with ease'
     */
    zsnTB: T;

    /**
     * @default 'Start with the things that matter most — and show your loved ones how they can help.'
     */
    YEASR: T;

    /**
     * @default 'Add more gifts'
     */
    xWH7L: T;

    /**
     * @default 'Add anything from anywhere. Like, literally.'
     */
    tsRNh: T;

    /**
     * @default 'Install Quick Add Button'
     */
    '1YzpB': T;

    /**
     * @default 'We’re unable to delete all the transferred items from this registry because some gifts have already been purchased by guests.'
     */
    Ggyv5: T;

    /**
     * @default 'Dismiss'
     */
    m333C: T;

    /**
     * @default 'Guests can give in seconds with'
     */
    G0v2P: T;

    /**
     * @default 'Who fulfills this gift'
     */
    dQVqH: T;

    /**
     * @default 'Fulfilled by Joy'
     */
    Svqb8: T;

    /**
     * @default 'Joy fulfills this gift and handles support for it.'
     */
    qmc9B: T;

    /**
     * @default 'Fulfilled by {{0}}'
     */
    mmiSQ: T;

    /**
     * @default '{{0}} marked this as purchased. {{1}} handles shipping and returns, so Joy can't track it.'
     */
    q82FS: T;

    /**
     * @default '{{0}} handles shipping and returns, so Joy can't track it.'
     */
    '8008h': T;
  };
};

export type TranslationsByNamespace<T extends LeafNodeValue = TranslateFunction> = {
  accommodationsAdmin: AccommodationsAdminTranslations<T>;
  accommodationsConsole: AccommodationsConsoleTranslations<T>;
  accommodationsGuest: AccommodationsGuestTranslations<T>;
  accommodationsShared: AccommodationsSharedTranslations<T>;
  account: AccountTranslations<T>;
  actionBar: ActionBarTranslations<T>;
  addFromFriendsRegistry: AddFromFriendsRegistryTranslations<T>;
  addressDialog: AddressDialogTranslations<T>;
  addToCalendar: AddToCalendarTranslations<T>;
  adminDashboardV2: AdminDashboardV2Translations<T>;
  adminDashboardV3: AdminDashboardV3Translations<T>;
  adminHeaderBar: AdminHeaderBarTranslations<T>;
  aiReviewTextarea: AiReviewTextareaTranslations<T>;
  allyPartnershipAdmin: AllyPartnershipAdminTranslations<T>;
  artUpload: ArtUploadTranslations<T>;
  autoPopulation: AutoPopulationTranslations<T>;
  bookmarklet: BookmarkletTranslations<T>;
  budget: BudgetTranslations<T>;
  cardGuest: CardGuestTranslations<T>;
  carousel: CarouselTranslations<T>;
  carRentalConsole: CarRentalConsoleTranslations<T>;
  cashFundsAdmin: CashFundsAdminTranslations<T>;
  cashFundsGuest: CashFundsGuestTranslations<T>;
  cashFundsShared: CashFundsSharedTranslations<T>;
  cashFundsTransfer: CashFundsTransferTranslations<T>;
  catalogRegistry: CatalogRegistryTranslations<T>;
  checkInAdmin: CheckInAdminTranslations<T>;
  checklist: ChecklistTranslations<T>;
  collaboration: CollaborationTranslations<T>;
  colors: ColorsTranslations<T>;
  combobox: ComboboxTranslations<T>;
  commandPaletteAdmin: CommandPaletteAdminTranslations<T>;
  companyPolicies: CompanyPoliciesTranslations<T>;
  contactCollector: ContactCollectorTranslations<T>;
  countries: CountriesTranslations<T>;
  createBabyRegistry: CreateBabyRegistryTranslations<T>;
  createEvent: CreateEventTranslations<T>;
  createGeneral: CreateGeneralTranslations<T>;
  createRegistry: CreateRegistryTranslations<T>;
  createWedding: CreateWeddingTranslations<T>;
  curationsRegistry: CurationsRegistryTranslations<T>;
  currencies: CurrenciesTranslations<T>;
  currencySelectorV2: CurrencySelectorV2Translations<T>;
  customBlockConfig: CustomBlockConfigTranslations<T>;
  customDomain: CustomDomainTranslations<T>;
  customPage: CustomPageTranslations<T>;
  customPhotoPreviewButton: CustomPhotoPreviewButtonTranslations<T>;
  dates: DatesTranslations<T>;
  discountedRates: DiscountedRatesTranslations<T>;
  emailPreferences: EmailPreferencesTranslations<T>;
  emailsAndEcards: EmailsAndEcardsTranslations<T>;
  emailTemplatesAdmin: EmailTemplatesAdminTranslations<T>;
  emailVerification: EmailVerificationTranslations<T>;
  errors: ErrorsTranslations<T>;
  eventCountdown: EventCountdownTranslations<T>;
  eventCountdownCustomComponent: EventCountdownCustomComponentTranslations<T>;
  eventDetailsCustomComponent: EventDetailsCustomComponentTranslations<T>;
  eventDisplayNameCustomComponent: EventDisplayNameCustomComponentTranslations<T>;
  eventFormDisplay: EventFormDisplayTranslations<T>;
  eventMenu: EventMenuTranslations<T>;
  eventPersonGuest: EventPersonGuestTranslations<T>;
  eventPhotoPicker: EventPhotoPickerTranslations<T>;
  eventRedirect: EventRedirectTranslations<T>;
  eventServiceCenter: EventServiceCenterTranslations<T>;
  eventSite: EventSiteTranslations<T>;
  eventSiteApps: EventSiteAppsTranslations<T>;
  eventWorkspace: EventWorkspaceTranslations<T>;
  faqCustomComponent: FaqCustomComponentTranslations<T>;
  focusPoint: FocusPointTranslations<T>;
  form: FormTranslations<T>;
  formCustomComponent: FormCustomComponentTranslations<T>;
  generalEventSchedule: GeneralEventScheduleTranslations<T>;
  generalEventScheduleEditor: GeneralEventScheduleEditorTranslations<T>;
  generalFormValidation: GeneralFormValidationTranslations<T>;
  getStartedOnboarding: GetStartedOnboardingTranslations<T>;
  giftNoteGuest: GiftNoteGuestTranslations<T>;
  graphError: GraphErrorTranslations<T>;
  graphicAccentCustomComponent: GraphicAccentCustomComponentTranslations<T>;
  greetingMessageComponent: GreetingMessageComponentTranslations<T>;
  groupMessaging: GroupMessagingTranslations<T>;
  guestGuide: GuestGuideTranslations<T>;
  guestInAppBrowserBanner: GuestInAppBrowserBannerTranslations<T>;
  guestKit: GuestKitTranslations<T>;
  guestList: GuestListTranslations<T>;
  guestRegistry: GuestRegistryTranslations<T>;
  guestSiteCustom: GuestSiteCustomTranslations<T>;
  guestSiteTravel: GuestSiteTravelTranslations<T>;
  guestSiteWelcome: GuestSiteWelcomeTranslations<T>;
  guestUnlock: GuestUnlockTranslations<T>;
  headerHelpMenu: HeaderHelpMenuTranslations<T>;
  headerLayoutUpgrade: HeaderLayoutUpgradeTranslations<T>;
  hotelBlock: HotelBlockTranslations<T>;
  hotelReminder: HotelReminderTranslations<T>;
  hotelSearchGuest: HotelSearchGuestTranslations<T>;
  hotelSuggestionDialog: HotelSuggestionDialogTranslations<T>;
  hotelTile: HotelTileTranslations<T>;
  imageFilePicker: ImageFilePickerTranslations<T>;
  imagineYourCard: ImagineYourCardTranslations<T>;
  impermissible: ImpermissibleTranslations<T>;
  inlineEditor: InlineEditorTranslations<T>;
  instantRoomBlocksAdmin: InstantRoomBlocksAdminTranslations<T>;
  instantRoomBlocksGuest: InstantRoomBlocksGuestTranslations<T>;
  joykit: JoykitTranslations<T>;
  languagePickerV2: LanguagePickerV2Translations<T>;
  layoutEngine: LayoutEngineTranslations<T>;
  locationDatesOccupants: LocationDatesOccupantsTranslations<T>;
  locationVenueSyncDialog: LocationVenueSyncDialogTranslations<T>;
  marcom: MarcomTranslations<T>;
  message: MessageTranslations<T>;
  messagesV2ServiceCenter: MessagesV2ServiceCenterTranslations<T>;
  messaging: MessagingTranslations<T>;
  mothersDayDialog: MothersDayDialogTranslations<T>;
  multiPhotoSelector: MultiPhotoSelectorTranslations<T>;
  pageNotFound: PageNotFoundTranslations<T>;
  pageSettingsDialog: PageSettingsDialogTranslations<T>;
  peoplePicker: PeoplePickerTranslations<T>;
  peoplePickerButton: PeoplePickerButtonTranslations<T>;
  photoDownloadGuest: PhotoDownloadGuestTranslations<T>;
  photoGalleryLayout: PhotoGalleryLayoutTranslations<T>;
  photoPickerDialog: PhotoPickerDialogTranslations<T>;
  photoUploader: PhotoUploaderTranslations<T>;
  pkpassGuest: PkpassGuestTranslations<T>;
  placeToStayComponent: PlaceToStayComponentTranslations<T>;
  placeToStayGuest: PlaceToStayGuestTranslations<T>;
  planningAccommodations: PlanningAccommodationsTranslations<T>;
  postcardRecipientsCustomizer: PostcardRecipientsCustomizerTranslations<T>;
  postOffice: PostOfficeTranslations<T>;
  productSelectionDialog: ProductSelectionDialogTranslations<T>;
  promoCodeAdmin: PromoCodeAdminTranslations<T>;
  promoCodeGuest: PromoCodeGuestTranslations<T>;
  publishReminder: PublishReminderTranslations<T>;
  qrCode: QrCodeTranslations<T>;
  registration: RegistrationTranslations<T>;
  registrationFormGuest: RegistrationFormGuestTranslations<T>;
  registrationPostRsvp: RegistrationPostRsvpTranslations<T>;
  registrationResumeGuest: RegistrationResumeGuestTranslations<T>;
  registryChecklist: RegistryChecklistTranslations<T>;
  registryOnboardingSurvey: RegistryOnboardingSurveyTranslations<T>;
  registryOnboardingSurveyV2: RegistryOnboardingSurveyV2Translations<T>;
  registryOnboardingV3Admin: RegistryOnboardingV3AdminTranslations<T>;
  registryOverview: RegistryOverviewTranslations<T>;
  replaceDefaultPhotos: ReplaceDefaultPhotosTranslations<T>;
  richTextEditor: RichTextEditorTranslations<T>;
  rsvpAdmin: RsvpAdminTranslations<T>;
  rsvpCustomComponent: RsvpCustomComponentTranslations<T>;
  rsvpDeadlineStatus: RsvpDeadlineStatusTranslations<T>;
  rsvpReminder: RsvpReminderTranslations<T>;
  rsvpSettings: RsvpSettingsTranslations<T>;
  saveStateAdmin: SaveStateAdminTranslations<T>;
  scheduleEditor: ScheduleEditorTranslations<T>;
  seatingChart: SeatingChartTranslations<T>;
  serviceCenter: ServiceCenterTranslations<T>;
  settings: SettingsTranslations<T>;
  shareAccommodationsHost: ShareAccommodationsHostTranslations<T>;
  sharedComponents: SharedComponentsTranslations<T>;
  shareDialog: ShareDialogTranslations<T>;
  sharedRegistry: SharedRegistryTranslations<T>;
  shareEditor: ShareEditorTranslations<T>;
  shareRoomBlockHost: ShareRoomBlockHostTranslations<T>;
  shareWebsiteDialog: ShareWebsiteDialogTranslations<T>;
  shareYourStayGuest: ShareYourStayGuestTranslations<T>;
  siteStatusIndicatorAdmin: SiteStatusIndicatorAdminTranslations<T>;
  slapAdsRegistry: SlapAdsRegistryTranslations<T>;
  ssrServer: SsrServerTranslations<T>;
  stationery: StationeryTranslations<T>;
  stationeryCrossSell: StationeryCrossSellTranslations<T>;
  stationeryTemplateCategory: StationeryTemplateCategoryTranslations<T>;
  stayAreasAdmin: StayAreasAdminTranslations<T>;
  stayAreasGuest: StayAreasGuestTranslations<T>;
  stayBookingAssistant: StayBookingAssistantTranslations<T>;
  stayDetailsGuest: StayDetailsGuestTranslations<T>;
  stays: StaysTranslations<T>;
  staysRedesignGuest: StaysRedesignGuestTranslations<T>;
  suggestions: SuggestionsTranslations<T>;
  survey: SurveyTranslations<T>;
  tagsAdmin: TagsAdminTranslations<T>;
  textBlastAdmin: TextBlastAdminTranslations<T>;
  thanksForRSVP: ThanksForRsvpTranslations<T>;
  thingsToDoCustomComponent: ThingsToDoCustomComponentTranslations<T>;
  ticketsAdmin: TicketsAdminTranslations<T>;
  ticketsGuest: TicketsGuestTranslations<T>;
  timePicker: TimePickerTranslations<T>;
  timeZonePicker: TimeZonePickerTranslations<T>;
  timeZonePickerV2: TimeZonePickerV2Translations<T>;
  tour: TourTranslations<T>;
  transferToBankDialog: TransferToBankDialogTranslations<T>;
  translation: TranslationTranslations<T>;
  travelAdmin: TravelAdminTranslations<T>;
  travelEditor: TravelEditorTranslations<T>;
  travelMap: TravelMapTranslations<T>;
  travelNativeCheckout: TravelNativeCheckoutTranslations<T>;
  unifiedWebsiteEditorAdmin: UnifiedWebsiteEditorAdminTranslations<T>;
  universalRecommendations: UniversalRecommendationsTranslations<T>;
  unpublishedWebsite: UnpublishedWebsiteTranslations<T>;
  updateScheduleDialog: UpdateScheduleDialogTranslations<T>;
  validateGuestIdentityAdmin: ValidateGuestIdentityAdminTranslations<T>;
  verifyEmail: VerifyEmailTranslations<T>;
  videoBackground: VideoBackgroundTranslations<T>;
  videoHelper: VideoHelperTranslations<T>;
  VIPCustomComponent: VipCustomComponentTranslations<T>;
  VIPForm: VipFormTranslations<T>;
  weatherReportGuest: WeatherReportGuestTranslations<T>;
  websiteCreate: WebsiteCreateTranslations<T>;
  websiteDesigner: WebsiteDesignerTranslations<T>;
  websiteEditor: WebsiteEditorTranslations<T>;
  websiteHeader: WebsiteHeaderTranslations<T>;
  websiteOverview: WebsiteOverviewTranslations<T>;
  websitePages: WebsitePagesTranslations<T>;
  websitePhotosAdmin: WebsitePhotosAdminTranslations<T>;
  websitePreview: WebsitePreviewTranslations<T>;
  websiteV2Admin: WebsiteV2AdminTranslations<T>;
  websiteV2Guest: WebsiteV2GuestTranslations<T>;
  weddingParty: WeddingPartyTranslations<T>;
  yourRegistry: YourRegistryTranslations<T>;
};

export type TranslationNamespaces = keyof TranslationsByNamespace;

export const manifest = {
  'de-DE': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/de-DE/accommodationsAdmin.7f1bd738.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/de-DE/accommodationsConsole.976a820a.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/de-DE/accommodationsGuest.6f033f0f.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/de-DE/accommodationsShared.5dfb2049.json',
    account: '/bliss-apps/joy-web/static/locales/de-DE/account.39aff8c6.json',
    actionBar: '/bliss-apps/joy-web/static/locales/de-DE/actionBar.6713393e.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/de-DE/addFromFriendsRegistry.5ec48fcc.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/de-DE/addressDialog.9426173f.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/de-DE/addToCalendar.10dab788.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/de-DE/adminDashboardV2.cf46d4d1.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/de-DE/adminDashboardV3.1c7ef1d1.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/de-DE/adminHeaderBar.f8e30536.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/de-DE/aiReviewTextarea.ec9e639c.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/de-DE/allyPartnershipAdmin.c0b29b22.json',
    artUpload: '/bliss-apps/joy-web/static/locales/de-DE/artUpload.9b788515.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/de-DE/autoPopulation.a5d97b3e.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/de-DE/bookmarklet.d21ee578.json',
    budget: '/bliss-apps/joy-web/static/locales/de-DE/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/de-DE/cardGuest.da421283.json',
    carousel: '/bliss-apps/joy-web/static/locales/de-DE/carousel.60cc65c0.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/de-DE/carRentalConsole.815cf252.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/de-DE/cashFundsAdmin.fe94ac1b.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/de-DE/cashFundsGuest.63acfc53.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/de-DE/cashFundsShared.a7ef1955.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/de-DE/cashFundsTransfer.336563fc.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/de-DE/catalogRegistry.912492b7.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/de-DE/checkInAdmin.bad52678.json',
    checklist: '/bliss-apps/joy-web/static/locales/de-DE/checklist.92781ec6.json',
    collaboration: '/bliss-apps/joy-web/static/locales/de-DE/collaboration.c3f86394.json',
    colors: '/bliss-apps/joy-web/static/locales/de-DE/colors.8489878b.json',
    combobox: '/bliss-apps/joy-web/static/locales/de-DE/combobox.5d8bb256.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/de-DE/commandPaletteAdmin.ee543e12.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/de-DE/companyPolicies.e7f5716a.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/de-DE/contactCollector.803676f9.json',
    countries: '/bliss-apps/joy-web/static/locales/de-DE/countries.d7c8b2de.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/de-DE/createBabyRegistry.c8a93a3d.json',
    createEvent: '/bliss-apps/joy-web/static/locales/de-DE/createEvent.cced60e5.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/de-DE/createGeneral.fbde0251.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/de-DE/createRegistry.9f665a5b.json',
    createWedding: '/bliss-apps/joy-web/static/locales/de-DE/createWedding.5080cec3.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/de-DE/curationsRegistry.9e0de4ae.json',
    currencies: '/bliss-apps/joy-web/static/locales/de-DE/currencies.1aaa611a.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/de-DE/currencySelectorV2.eeb5367b.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/de-DE/customBlockConfig.084dc7bd.json',
    customDomain: '/bliss-apps/joy-web/static/locales/de-DE/customDomain.44ce52af.json',
    customPage: '/bliss-apps/joy-web/static/locales/de-DE/customPage.8d40b629.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/de-DE/customPhotoPreviewButton.63154996.json',
    dates: '/bliss-apps/joy-web/static/locales/de-DE/dates.d786c64a.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/de-DE/discountedRates.da474bfc.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/de-DE/emailPreferences.9c60a63a.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/de-DE/emailsAndEcards.90de8d83.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/de-DE/emailTemplatesAdmin.80beba8e.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/de-DE/emailVerification.a7da1cfd.json',
    errors: '/bliss-apps/joy-web/static/locales/de-DE/errors.aed2cd05.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/de-DE/eventCountdown.e8a64d3f.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/eventCountdownCustomComponent.478d0d02.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/eventDetailsCustomComponent.194d9ba5.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/eventDisplayNameCustomComponent.f95b1ae2.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/de-DE/eventFormDisplay.cade8bc2.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/de-DE/eventMenu.0710ed2e.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/de-DE/eventPersonGuest.eee117d2.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/de-DE/eventPhotoPicker.d1653f9e.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/de-DE/eventRedirect.beccd276.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/de-DE/eventServiceCenter.80deb878.json',
    eventSite: '/bliss-apps/joy-web/static/locales/de-DE/eventSite.55d4409d.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/de-DE/eventSiteApps.ede13d86.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/de-DE/eventWorkspace.fe393bb0.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/faqCustomComponent.15046ea2.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/de-DE/focusPoint.6609247d.json',
    form: '/bliss-apps/joy-web/static/locales/de-DE/form.24c0ad53.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/formCustomComponent.03ff11df.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/de-DE/generalEventSchedule.437e5adc.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/de-DE/generalEventScheduleEditor.c958b07a.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/de-DE/generalFormValidation.f9bc211c.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/de-DE/getStartedOnboarding.9fce15b5.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/de-DE/giftNoteGuest.2ecd2d81.json',
    graphError: '/bliss-apps/joy-web/static/locales/de-DE/graphError.62950f80.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/graphicAccentCustomComponent.61566abe.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/de-DE/greetingMessageComponent.21554208.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/de-DE/groupMessaging.4b41087f.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/de-DE/guestGuide.0c22b3c8.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/de-DE/guestInAppBrowserBanner.2035b429.json',
    guestKit: '/bliss-apps/joy-web/static/locales/de-DE/guestKit.df8ad934.json',
    guestList: '/bliss-apps/joy-web/static/locales/de-DE/guestList.10aaa834.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/de-DE/guestRegistry.4dd067aa.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/de-DE/guestSiteCustom.21ea57c1.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/de-DE/guestSiteTravel.b252c331.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/de-DE/guestSiteWelcome.591af0f6.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/de-DE/guestUnlock.acf4db09.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/de-DE/headerHelpMenu.92b95591.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/de-DE/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/de-DE/hotelBlock.ed7b482d.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/de-DE/hotelReminder.10a4b149.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/de-DE/hotelSearchGuest.40b66131.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/de-DE/hotelSuggestionDialog.c181b305.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/de-DE/hotelTile.e4a405a1.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/de-DE/imageFilePicker.3b1a6112.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/de-DE/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/de-DE/impermissible.f25dc585.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/de-DE/inlineEditor.007f419d.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/de-DE/instantRoomBlocksAdmin.634e1f49.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/de-DE/instantRoomBlocksGuest.260260af.json',
    joykit: '/bliss-apps/joy-web/static/locales/de-DE/joykit.b90161e7.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/de-DE/languagePickerV2.fded4a00.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/de-DE/layoutEngine.8c3860e7.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/de-DE/locationDatesOccupants.43ece541.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/de-DE/locationVenueSyncDialog.5f5c0140.json',
    marcom: '/bliss-apps/joy-web/static/locales/de-DE/marcom.a422b79d.json',
    message: '/bliss-apps/joy-web/static/locales/de-DE/message.1a9e969a.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/de-DE/messagesV2ServiceCenter.23938715.json',
    messaging: '/bliss-apps/joy-web/static/locales/de-DE/messaging.34904e12.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/de-DE/mothersDayDialog.61cf17e2.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/de-DE/multiPhotoSelector.dc880089.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/de-DE/pageNotFound.e80516e1.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/de-DE/pageSettingsDialog.00cb67a6.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/de-DE/peoplePicker.cae6eb91.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/de-DE/peoplePickerButton.1622d5a5.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/de-DE/photoDownloadGuest.ffa1285d.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/de-DE/photoGalleryLayout.b5ca927a.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/de-DE/photoPickerDialog.235b6d07.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/de-DE/photoUploader.54c8b7fe.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/de-DE/pkpassGuest.00a33281.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/de-DE/placeToStayComponent.0c3a2693.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/de-DE/placeToStayGuest.72e3ea70.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/de-DE/planningAccommodations.3f4a6cbb.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/de-DE/postcardRecipientsCustomizer.12d6e5ae.json',
    postOffice: '/bliss-apps/joy-web/static/locales/de-DE/postOffice.f1a0db0a.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/de-DE/productSelectionDialog.70f41da6.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/de-DE/promoCodeAdmin.2c9bad8f.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/de-DE/promoCodeGuest.3b51ed0d.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/de-DE/publishReminder.775aa411.json',
    qrCode: '/bliss-apps/joy-web/static/locales/de-DE/qrCode.4b7df91d.json',
    registration: '/bliss-apps/joy-web/static/locales/de-DE/registration.bd17028d.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/de-DE/registrationFormGuest.95b6efab.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/de-DE/registrationPostRsvp.d0a9c789.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/de-DE/registrationResumeGuest.af35de1a.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/de-DE/registryChecklist.416d8f0b.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/de-DE/registryOnboardingSurvey.8d9b1a23.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/de-DE/registryOnboardingSurveyV2.f0aa8390.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/de-DE/registryOnboardingV3Admin.48d76f78.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/de-DE/registryOverview.faaef821.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/de-DE/replaceDefaultPhotos.c79a602d.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/de-DE/richTextEditor.cee2ba0d.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/de-DE/rsvpAdmin.60baf1ed.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/rsvpCustomComponent.19414ee8.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/de-DE/rsvpDeadlineStatus.db30bf2e.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/de-DE/rsvpReminder.6edeb3e3.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/de-DE/rsvpSettings.35882fe9.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/de-DE/saveStateAdmin.5f81f3e6.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/de-DE/scheduleEditor.4ada31e9.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/de-DE/seatingChart.b172b7b4.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/de-DE/serviceCenter.ed0caba8.json',
    settings: '/bliss-apps/joy-web/static/locales/de-DE/settings.4fd33cc3.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/de-DE/shareAccommodationsHost.4b8b3986.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/de-DE/sharedComponents.a7071be8.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/de-DE/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/de-DE/sharedRegistry.00458e16.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/de-DE/shareEditor.7b66dec0.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/de-DE/shareRoomBlockHost.13daffa0.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/de-DE/shareWebsiteDialog.65e6e61f.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/de-DE/shareYourStayGuest.13f0e72c.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/de-DE/siteStatusIndicatorAdmin.b3b7568c.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/de-DE/slapAdsRegistry.3be3f56a.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/de-DE/ssrServer.c74c8d3b.json',
    stationery: '/bliss-apps/joy-web/static/locales/de-DE/stationery.8cbb3fb8.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/de-DE/stationeryCrossSell.dfd60e7f.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/de-DE/stationeryTemplateCategory.08e3fb15.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/de-DE/stayAreasAdmin.48eff68f.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/de-DE/stayAreasGuest.e0f654df.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/de-DE/stayBookingAssistant.f4555931.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/de-DE/stayDetailsGuest.33ab5bb4.json',
    stays: '/bliss-apps/joy-web/static/locales/de-DE/stays.14d6b9cb.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/de-DE/staysRedesignGuest.373b4cdd.json',
    suggestions: '/bliss-apps/joy-web/static/locales/de-DE/suggestions.241fc7ae.json',
    survey: '/bliss-apps/joy-web/static/locales/de-DE/survey.04bede5f.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/de-DE/tagsAdmin.c0e8abf5.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/de-DE/textBlastAdmin.c801b4b0.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/de-DE/thanksForRSVP.e483721f.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/thingsToDoCustomComponent.e6dbe528.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/de-DE/ticketsAdmin.25b647cf.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/de-DE/ticketsGuest.8296c6e4.json',
    timePicker: '/bliss-apps/joy-web/static/locales/de-DE/timePicker.c050ca13.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/de-DE/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/de-DE/timeZonePickerV2.fa1417ff.json',
    tour: '/bliss-apps/joy-web/static/locales/de-DE/tour.d5940c7f.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/de-DE/transferToBankDialog.aba7c7f7.json',
    translation: '/bliss-apps/joy-web/static/locales/de-DE/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/de-DE/travelAdmin.2efc65dd.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/de-DE/travelEditor.74925c69.json',
    travelMap: '/bliss-apps/joy-web/static/locales/de-DE/travelMap.69c57735.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/de-DE/travelNativeCheckout.b5a8e69a.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/de-DE/unifiedWebsiteEditorAdmin.716f3e49.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/de-DE/universalRecommendations.a15d25cc.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/de-DE/unpublishedWebsite.2e2b81a4.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/de-DE/updateScheduleDialog.a29672d0.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/de-DE/validateGuestIdentityAdmin.3738ac13.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/de-DE/verifyEmail.e41d5c41.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/de-DE/videoBackground.17002a27.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/de-DE/videoHelper.6ec2264d.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/de-DE/VIPCustomComponent.31c9a748.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/de-DE/VIPForm.db9a1867.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/de-DE/weatherReportGuest.8f9a852f.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/de-DE/websiteCreate.ae22cce7.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/de-DE/websiteDesigner.a5bb837f.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/de-DE/websiteEditor.bdd49f11.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/de-DE/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/de-DE/websiteOverview.559a3a4c.json',
    websitePages: '/bliss-apps/joy-web/static/locales/de-DE/websitePages.9c914e4b.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/de-DE/websitePhotosAdmin.bd82d6b7.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/de-DE/websitePreview.3f348e58.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/de-DE/websiteV2Admin.c2dcd644.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/de-DE/websiteV2Guest.146363fa.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/de-DE/weddingParty.a9e63f90.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/de-DE/yourRegistry.9220341e.json',
  },
  'en-AU': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsAdmin.56b8d4de.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsConsole.36e1e2b2.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsGuest.1c51b33e.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsShared.78825e3b.json',
    account: '/bliss-apps/joy-web/static/locales/en-AU/account.7956b78a.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-AU/actionBar.b83fb941.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/addFromFriendsRegistry.e5358ec7.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/en-AU/addressDialog.375300d1.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-AU/addToCalendar.8b347153.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-AU/adminDashboardV2.5e2775a5.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-AU/adminDashboardV3.caa22bff.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/en-AU/adminHeaderBar.145443ef.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-AU/aiReviewTextarea.859d583e.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/en-AU/allyPartnershipAdmin.e6d46984.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-AU/artUpload.d4f85cda.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-AU/autoPopulation.4666cd88.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-AU/bookmarklet.ce663a2c.json',
    budget: '/bliss-apps/joy-web/static/locales/en-AU/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/en-AU/cardGuest.8c924b27.json',
    carousel: '/bliss-apps/joy-web/static/locales/en-AU/carousel.a34fb581.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/en-AU/carRentalConsole.1a1b1b62.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/en-AU/cashFundsAdmin.bc887d47.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/en-AU/cashFundsGuest.68cd8db4.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/en-AU/cashFundsShared.3a26f58e.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/en-AU/cashFundsTransfer.6609d28f.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-AU/catalogRegistry.78bc2f6c.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/en-AU/checkInAdmin.442a9d29.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-AU/checklist.35bd2767.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-AU/collaboration.0a2ff50c.json',
    colors: '/bliss-apps/joy-web/static/locales/en-AU/colors.a0a32295.json',
    combobox: '/bliss-apps/joy-web/static/locales/en-AU/combobox.983ac2bb.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/en-AU/commandPaletteAdmin.b7e012df.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-AU/companyPolicies.c31b5022.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-AU/contactCollector.4f60ac1f.json',
    countries: '/bliss-apps/joy-web/static/locales/en-AU/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-AU/createBabyRegistry.d3395c2c.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-AU/createEvent.a17e76c6.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-AU/createGeneral.1ca0940f.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-AU/createRegistry.cbfff3b3.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-AU/createWedding.3e2b3c5d.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/curationsRegistry.87f31cd1.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-AU/currencies.75d9f61c.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/en-AU/currencySelectorV2.54de488c.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/en-AU/customBlockConfig.3721f97d.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-AU/customDomain.77156ed3.json',
    customPage: '/bliss-apps/joy-web/static/locales/en-AU/customPage.aaf96c9f.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/en-AU/customPhotoPreviewButton.916a63c0.json',
    dates: '/bliss-apps/joy-web/static/locales/en-AU/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-AU/discountedRates.5d944820.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-AU/emailPreferences.9aaf4e53.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-AU/emailsAndEcards.d1ff2fca.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/en-AU/emailTemplatesAdmin.3202f2cb.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/en-AU/emailVerification.0bb1a56f.json',
    errors: '/bliss-apps/joy-web/static/locales/en-AU/errors.d34d33e5.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-AU/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/eventCountdownCustomComponent.66f4ce5f.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/eventDetailsCustomComponent.cd594877.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/eventDisplayNameCustomComponent.4fe30e85.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-AU/eventFormDisplay.bbb1d101.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-AU/eventMenu.66e5dcfa.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/en-AU/eventPersonGuest.98cc298b.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-AU/eventPhotoPicker.2be5bb9e.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-AU/eventRedirect.2d9d2da9.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-AU/eventServiceCenter.10cdf04f.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-AU/eventSite.2c207aaf.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-AU/eventSiteApps.8af2c5ca.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-AU/eventWorkspace.af0b1323.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/faqCustomComponent.f78b1e2a.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-AU/focusPoint.eac4ae34.json',
    form: '/bliss-apps/joy-web/static/locales/en-AU/form.37df686d.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/formCustomComponent.4cf25ea8.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-AU/generalEventSchedule.650db189.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-AU/generalEventScheduleEditor.56d528d7.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-AU/generalFormValidation.683575c9.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/en-AU/getStartedOnboarding.9d73f915.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/en-AU/giftNoteGuest.8190629c.json',
    graphError: '/bliss-apps/joy-web/static/locales/en-AU/graphError.8ac340e4.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/graphicAccentCustomComponent.09ec1e03.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/en-AU/greetingMessageComponent.43dd357d.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/en-AU/groupMessaging.5a6d84a6.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-AU/guestGuide.ee335316.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/en-AU/guestInAppBrowserBanner.9828cb86.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-AU/guestKit.faf84c4b.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-AU/guestList.e331a952.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-AU/guestRegistry.f8e0ed08.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteCustom.dd7dbe5a.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteTravel.4bfeab44.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteWelcome.f185e3c2.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-AU/guestUnlock.3358164a.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-AU/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-AU/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-AU/hotelBlock.6aedf7a4.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-AU/hotelReminder.e9df8c26.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/en-AU/hotelSearchGuest.9f91a7c0.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/en-AU/hotelSuggestionDialog.231bcaa5.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-AU/hotelTile.490af09b.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-AU/imageFilePicker.93c64dd8.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/en-AU/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-AU/impermissible.4cb89332.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/en-AU/inlineEditor.9d41c1fe.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/en-AU/instantRoomBlocksAdmin.618daa95.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/en-AU/instantRoomBlocksGuest.f82176fb.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-AU/joykit.ba46ce28.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/en-AU/languagePickerV2.50cf5ae6.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-AU/layoutEngine.f55baf11.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-AU/locationDatesOccupants.8d89968d.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-AU/locationVenueSyncDialog.83a5cdda.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-AU/marcom.f6febe0d.json',
    message: '/bliss-apps/joy-web/static/locales/en-AU/message.0dfd8264.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/en-AU/messagesV2ServiceCenter.b5bb9a2d.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-AU/messaging.746b0cb7.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/en-AU/mothersDayDialog.ed973310.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-AU/multiPhotoSelector.f46b5993.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-AU/pageNotFound.bf70c17f.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-AU/pageSettingsDialog.c3302276.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/en-AU/peoplePicker.dbe84f62.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/en-AU/peoplePickerButton.e2f43760.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/en-AU/photoDownloadGuest.b906e05d.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/en-AU/photoGalleryLayout.c9e492f0.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-AU/photoPickerDialog.1e3d86fb.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-AU/photoUploader.26951819.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/en-AU/pkpassGuest.dc96320b.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-AU/placeToStayComponent.86091e38.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-AU/placeToStayGuest.b2dba3bd.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-AU/planningAccommodations.c3330c3b.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/en-AU/postcardRecipientsCustomizer.d424ffc8.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-AU/postOffice.81f94ed2.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-AU/productSelectionDialog.29697983.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/en-AU/promoCodeAdmin.a4a43588.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/en-AU/promoCodeGuest.0f88ffad.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-AU/publishReminder.dc2221a3.json',
    qrCode: '/bliss-apps/joy-web/static/locales/en-AU/qrCode.0fed007b.json',
    registration: '/bliss-apps/joy-web/static/locales/en-AU/registration.2e259de6.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/en-AU/registrationFormGuest.c0be805a.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/en-AU/registrationPostRsvp.c532ac73.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/en-AU/registrationResumeGuest.df40432b.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-AU/registryChecklist.2a055ba0.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-AU/registryOnboardingSurvey.91064ca7.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-AU/registryOnboardingSurveyV2.a772bf00.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/en-AU/registryOnboardingV3Admin.1ec7e78f.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-AU/registryOverview.65cb8a56.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/en-AU/replaceDefaultPhotos.88323d6f.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-AU/richTextEditor.d136c3e1.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-AU/rsvpAdmin.9bda95bd.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/rsvpCustomComponent.8e6d0e24.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/en-AU/rsvpDeadlineStatus.d4e9537a.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-AU/rsvpReminder.c01676aa.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/en-AU/rsvpSettings.b964ab63.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/en-AU/saveStateAdmin.8a536f99.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-AU/scheduleEditor.47242b88.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/en-AU/seatingChart.3dbbadc7.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/en-AU/serviceCenter.12fe3eed.json',
    settings: '/bliss-apps/joy-web/static/locales/en-AU/settings.057bb16a.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/en-AU/shareAccommodationsHost.1b5f80b5.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-AU/sharedComponents.0ebd018d.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-AU/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-AU/sharedRegistry.edf552a0.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/en-AU/shareEditor.8bcceb28.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/en-AU/shareRoomBlockHost.ce590617.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/en-AU/shareWebsiteDialog.42568594.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/en-AU/shareYourStayGuest.8d1de0a5.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/en-AU/siteStatusIndicatorAdmin.d25eaf73.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/slapAdsRegistry.17936cb1.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-AU/ssrServer.82b36cdc.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-AU/stationery.66cc0556.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/en-AU/stationeryCrossSell.e6e7023a.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-AU/stationeryTemplateCategory.5b0114fc.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/en-AU/stayAreasAdmin.f6b32deb.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/en-AU/stayAreasGuest.ca4dba1c.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-AU/stayBookingAssistant.aefc800e.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/en-AU/stayDetailsGuest.1de95043.json',
    stays: '/bliss-apps/joy-web/static/locales/en-AU/stays.3e65017b.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/en-AU/staysRedesignGuest.e31059d1.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-AU/suggestions.ce3bcf27.json',
    survey: '/bliss-apps/joy-web/static/locales/en-AU/survey.f492329b.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/en-AU/tagsAdmin.5a47fb64.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/en-AU/textBlastAdmin.e1fe590b.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-AU/thanksForRSVP.e6217c85.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/thingsToDoCustomComponent.b7fea80a.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/en-AU/ticketsAdmin.17fe5bc9.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/en-AU/ticketsGuest.7e5f34d5.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-AU/timePicker.3d0fbcd4.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/en-AU/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/en-AU/timeZonePickerV2.eb32be18.json',
    tour: '/bliss-apps/joy-web/static/locales/en-AU/tour.f4e595ca.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/en-AU/transferToBankDialog.3ea75972.json',
    translation: '/bliss-apps/joy-web/static/locales/en-AU/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-AU/travelAdmin.9e71b1a3.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-AU/travelEditor.455b6af4.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-AU/travelMap.756dc66f.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-AU/travelNativeCheckout.e6fa89f6.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/en-AU/unifiedWebsiteEditorAdmin.7bc47d85.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-AU/universalRecommendations.cdfcc1ac.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-AU/unpublishedWebsite.39f0124b.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-AU/updateScheduleDialog.eebc0959.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/en-AU/validateGuestIdentityAdmin.42fe087d.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-AU/verifyEmail.fe978e71.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-AU/videoBackground.7f3324bc.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/en-AU/videoHelper.abd08d8b.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/VIPCustomComponent.2fbd223b.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-AU/VIPForm.d5a152f2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-AU/weatherReportGuest.0f9c262e.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/en-AU/websiteCreate.3afe676c.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-AU/websiteDesigner.49badf36.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-AU/websiteEditor.24ecbf32.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-AU/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-AU/websiteOverview.6a95ef71.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-AU/websitePages.d2edb47f.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/en-AU/websitePhotosAdmin.e148c631.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-AU/websitePreview.9bd55a76.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/en-AU/websiteV2Admin.b97cb54d.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/en-AU/websiteV2Guest.e49ccc1f.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-AU/weddingParty.e5a1f434.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-AU/yourRegistry.a36a57b8.json',
  },
  'en-CA': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-CA/accommodationsAdmin.c22d7a55.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-CA/accommodationsConsole.62af8ade.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-CA/accommodationsGuest.b5f38a8c.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/en-CA/accommodationsShared.13743e4c.json',
    account: '/bliss-apps/joy-web/static/locales/en-CA/account.e426654d.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-CA/actionBar.fe494f43.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-CA/addFromFriendsRegistry.9e0c841f.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/en-CA/addressDialog.8123bef7.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-CA/addToCalendar.8b347153.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-CA/adminDashboardV2.38864fd0.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-CA/adminDashboardV3.f72b4cfe.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/en-CA/adminHeaderBar.62153dfe.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-CA/aiReviewTextarea.b67e5b26.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/en-CA/allyPartnershipAdmin.0a2c5327.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-CA/artUpload.94217fff.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-CA/autoPopulation.12eebb48.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-CA/bookmarklet.5847de29.json',
    budget: '/bliss-apps/joy-web/static/locales/en-CA/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/en-CA/cardGuest.54e5c4b2.json',
    carousel: '/bliss-apps/joy-web/static/locales/en-CA/carousel.a34fb581.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/en-CA/carRentalConsole.27ef5dfd.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/en-CA/cashFundsAdmin.f88b2862.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/en-CA/cashFundsGuest.da0ea753.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/en-CA/cashFundsShared.b8077877.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/en-CA/cashFundsTransfer.d7cf1b0d.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-CA/catalogRegistry.79fce64d.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/en-CA/checkInAdmin.6eda64cb.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-CA/checklist.49d1f919.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-CA/collaboration.94611370.json',
    colors: '/bliss-apps/joy-web/static/locales/en-CA/colors.3cb09525.json',
    combobox: '/bliss-apps/joy-web/static/locales/en-CA/combobox.2d802093.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/en-CA/commandPaletteAdmin.def7938a.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-CA/companyPolicies.dad1714d.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-CA/contactCollector.28050610.json',
    countries: '/bliss-apps/joy-web/static/locales/en-CA/countries.876171ba.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-CA/createBabyRegistry.013bb38b.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-CA/createEvent.9bfb2d59.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-CA/createGeneral.bce0b2ae.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-CA/createRegistry.c78af20d.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-CA/createWedding.d842617c.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-CA/curationsRegistry.c0aa8170.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-CA/currencies.f57b431f.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/en-CA/currencySelectorV2.eba426d8.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/en-CA/customBlockConfig.3721f97d.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-CA/customDomain.6b4556f3.json',
    customPage: '/bliss-apps/joy-web/static/locales/en-CA/customPage.26490df9.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/en-CA/customPhotoPreviewButton.916a63c0.json',
    dates: '/bliss-apps/joy-web/static/locales/en-CA/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-CA/discountedRates.dd5adb52.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-CA/emailPreferences.c27d1d9d.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-CA/emailsAndEcards.24e9aee5.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/en-CA/emailTemplatesAdmin.2833b004.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/en-CA/emailVerification.a173a8fb.json',
    errors: '/bliss-apps/joy-web/static/locales/en-CA/errors.1d942080.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-CA/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/eventCountdownCustomComponent.79de5f6e.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/eventDetailsCustomComponent.6827b6a4.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/eventDisplayNameCustomComponent.4fe30e85.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-CA/eventFormDisplay.fe50a9db.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-CA/eventMenu.c7b0bfed.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/en-CA/eventPersonGuest.1f842fdb.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-CA/eventPhotoPicker.f52d0813.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-CA/eventRedirect.10573672.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-CA/eventServiceCenter.28208595.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-CA/eventSite.ba4afcd2.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-CA/eventSiteApps.89061e52.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-CA/eventWorkspace.fc936925.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/faqCustomComponent.d435f54e.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-CA/focusPoint.eac4ae34.json',
    form: '/bliss-apps/joy-web/static/locales/en-CA/form.2b677c02.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/formCustomComponent.c2cf70ea.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-CA/generalEventSchedule.53dc1aa5.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-CA/generalEventScheduleEditor.b953e9fd.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-CA/generalFormValidation.78d35b99.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/en-CA/getStartedOnboarding.5bf2b94e.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/en-CA/giftNoteGuest.14ce3431.json',
    graphError: '/bliss-apps/joy-web/static/locales/en-CA/graphError.b10b56a5.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/graphicAccentCustomComponent.c04fd46c.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/en-CA/greetingMessageComponent.43dd357d.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/en-CA/groupMessaging.4dff8a4f.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-CA/guestGuide.e82debd8.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/en-CA/guestInAppBrowserBanner.82ce8938.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-CA/guestKit.4c597439.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-CA/guestList.60933a4f.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-CA/guestRegistry.c1996cb4.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-CA/guestSiteCustom.104aa2dc.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-CA/guestSiteTravel.6e7796e0.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-CA/guestSiteWelcome.76efcea1.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-CA/guestUnlock.d2678ccb.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-CA/headerHelpMenu.3cc1d683.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-CA/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-CA/hotelBlock.e6384b1f.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-CA/hotelReminder.444b4b78.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/en-CA/hotelSearchGuest.e10e3dca.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/en-CA/hotelSuggestionDialog.cf351c33.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-CA/hotelTile.2d06347a.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-CA/imageFilePicker.6848ef78.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/en-CA/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-CA/impermissible.8d94cbc7.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/en-CA/inlineEditor.9d41c1fe.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/en-CA/instantRoomBlocksAdmin.24fa7bf3.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/en-CA/instantRoomBlocksGuest.5a28c21b.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-CA/joykit.2dafe046.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/en-CA/languagePickerV2.03343089.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-CA/layoutEngine.ae80dee6.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-CA/locationDatesOccupants.7525a677.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-CA/locationVenueSyncDialog.c5e33adb.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-CA/marcom.a6d82934.json',
    message: '/bliss-apps/joy-web/static/locales/en-CA/message.b4ea8621.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/en-CA/messagesV2ServiceCenter.9b5ddca4.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-CA/messaging.f88e8388.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/en-CA/mothersDayDialog.4237c7de.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-CA/multiPhotoSelector.f0c9872b.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-CA/pageNotFound.9b0a3f17.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-CA/pageSettingsDialog.dc9f60d1.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/en-CA/peoplePicker.48c76960.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/en-CA/peoplePickerButton.0df9c470.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/en-CA/photoDownloadGuest.bdbd317c.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/en-CA/photoGalleryLayout.c9e492f0.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-CA/photoPickerDialog.6946d765.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-CA/photoUploader.783be944.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/en-CA/pkpassGuest.57f05c05.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-CA/placeToStayComponent.614a6ffb.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-CA/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-CA/planningAccommodations.0bebdf31.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/en-CA/postcardRecipientsCustomizer.39ae795b.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-CA/postOffice.d7f8b32b.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-CA/productSelectionDialog.fbe2ea73.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/en-CA/promoCodeAdmin.2acfd736.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/en-CA/promoCodeGuest.4d594dd9.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-CA/publishReminder.ec48b873.json',
    qrCode: '/bliss-apps/joy-web/static/locales/en-CA/qrCode.0fed007b.json',
    registration: '/bliss-apps/joy-web/static/locales/en-CA/registration.e7668cb6.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/en-CA/registrationFormGuest.96104942.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/en-CA/registrationPostRsvp.0b2b3aa4.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/en-CA/registrationResumeGuest.9378782e.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-CA/registryChecklist.e96c81f1.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-CA/registryOnboardingSurvey.8b3c0174.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-CA/registryOnboardingSurveyV2.f60ee805.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/en-CA/registryOnboardingV3Admin.ca10d904.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-CA/registryOverview.016dc7c3.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/en-CA/replaceDefaultPhotos.da78f5a5.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-CA/richTextEditor.e958f0cd.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-CA/rsvpAdmin.f9c04a42.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/rsvpCustomComponent.914936d5.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/en-CA/rsvpDeadlineStatus.aa078703.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-CA/rsvpReminder.317678fa.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/en-CA/rsvpSettings.9e725ab5.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/en-CA/saveStateAdmin.77206581.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-CA/scheduleEditor.94c244d1.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/en-CA/seatingChart.b21d90f8.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/en-CA/serviceCenter.8fa7dc83.json',
    settings: '/bliss-apps/joy-web/static/locales/en-CA/settings.df4402dc.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/en-CA/shareAccommodationsHost.ccf6aa94.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-CA/sharedComponents.f9d3aa98.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-CA/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-CA/sharedRegistry.1521f4ec.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/en-CA/shareEditor.8bcceb28.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/en-CA/shareRoomBlockHost.a7b736bf.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/en-CA/shareWebsiteDialog.21724cf7.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/en-CA/shareYourStayGuest.6f07463d.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/en-CA/siteStatusIndicatorAdmin.d25eaf73.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-CA/slapAdsRegistry.7cce8b24.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-CA/ssrServer.82b36cdc.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-CA/stationery.7b053ca3.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/en-CA/stationeryCrossSell.f705581a.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-CA/stationeryTemplateCategory.bee5d5b9.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/en-CA/stayAreasAdmin.44bf8518.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/en-CA/stayAreasGuest.386c8b02.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-CA/stayBookingAssistant.d58a39bd.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/en-CA/stayDetailsGuest.da99b6ec.json',
    stays: '/bliss-apps/joy-web/static/locales/en-CA/stays.5d13f934.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/en-CA/staysRedesignGuest.fd12f19a.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-CA/suggestions.535cfc94.json',
    survey: '/bliss-apps/joy-web/static/locales/en-CA/survey.501ad929.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/en-CA/tagsAdmin.f0c6dbc5.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/en-CA/textBlastAdmin.6d80e34e.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-CA/thanksForRSVP.586b5986.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/thingsToDoCustomComponent.c67a63e7.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/en-CA/ticketsAdmin.15cbd6ca.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/en-CA/ticketsGuest.7e5f34d5.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-CA/timePicker.a9875105.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/en-CA/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/en-CA/timeZonePickerV2.0a323bde.json',
    tour: '/bliss-apps/joy-web/static/locales/en-CA/tour.a722765b.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/en-CA/transferToBankDialog.81e57a58.json',
    translation: '/bliss-apps/joy-web/static/locales/en-CA/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-CA/travelAdmin.baddbbc1.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-CA/travelEditor.8c4e243e.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-CA/travelMap.ff589663.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-CA/travelNativeCheckout.8cddd750.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/en-CA/unifiedWebsiteEditorAdmin.bba18018.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-CA/universalRecommendations.bfcf3371.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-CA/unpublishedWebsite.406c24e0.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-CA/updateScheduleDialog.865e0fd0.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/en-CA/validateGuestIdentityAdmin.f266dc66.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-CA/verifyEmail.d1638a76.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-CA/videoBackground.bbfb20bb.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/en-CA/videoHelper.3d70ca18.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-CA/VIPCustomComponent.1099877b.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-CA/VIPForm.d5a152f2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-CA/weatherReportGuest.fa03cb4e.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/en-CA/websiteCreate.5b932d11.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-CA/websiteDesigner.e980fca1.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-CA/websiteEditor.3c0e1b7e.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-CA/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-CA/websiteOverview.f3bf0bc8.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-CA/websitePages.2ffb7d2c.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/en-CA/websitePhotosAdmin.9df3f6ee.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-CA/websitePreview.4ac71aaa.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/en-CA/websiteV2Admin.82595174.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/en-CA/websiteV2Guest.ed5f8756.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-CA/weddingParty.f6576776.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-CA/yourRegistry.953774ef.json',
  },
  'en-GB': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsAdmin.ee9d7c5d.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsConsole.14993039.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsGuest.e58b2ce7.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsShared.9222d457.json',
    account: '/bliss-apps/joy-web/static/locales/en-GB/account.5c5cdcda.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-GB/actionBar.fe494f43.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/addFromFriendsRegistry.aa0da612.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/en-GB/addressDialog.110898f2.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-GB/addToCalendar.8b347153.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-GB/adminDashboardV2.4dd2a203.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-GB/adminDashboardV3.1b19ed38.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/en-GB/adminHeaderBar.145443ef.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-GB/aiReviewTextarea.fde07661.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/en-GB/allyPartnershipAdmin.9f00fca2.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-GB/artUpload.7194db63.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-GB/autoPopulation.1cc84def.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-GB/bookmarklet.a2d19795.json',
    budget: '/bliss-apps/joy-web/static/locales/en-GB/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/en-GB/cardGuest.5efabc0c.json',
    carousel: '/bliss-apps/joy-web/static/locales/en-GB/carousel.a34fb581.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/en-GB/carRentalConsole.29c1668a.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/en-GB/cashFundsAdmin.ba7a5210.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/en-GB/cashFundsGuest.832663a5.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/en-GB/cashFundsShared.3a26f58e.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/en-GB/cashFundsTransfer.97407aeb.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-GB/catalogRegistry.68055d3e.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/en-GB/checkInAdmin.5519a21a.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-GB/checklist.984b7e54.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-GB/collaboration.455f5a01.json',
    colors: '/bliss-apps/joy-web/static/locales/en-GB/colors.a0a32295.json',
    combobox: '/bliss-apps/joy-web/static/locales/en-GB/combobox.983ac2bb.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/en-GB/commandPaletteAdmin.d7804820.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-GB/companyPolicies.2a6fd7df.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-GB/contactCollector.d3636d11.json',
    countries: '/bliss-apps/joy-web/static/locales/en-GB/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-GB/createBabyRegistry.b119c9b0.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-GB/createEvent.353e8ad4.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-GB/createGeneral.8db23bc0.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-GB/createRegistry.b04c588e.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-GB/createWedding.4df1c5ed.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/curationsRegistry.87f31cd1.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-GB/currencies.69f42833.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/en-GB/currencySelectorV2.f27c0b9e.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/en-GB/customBlockConfig.3721f97d.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-GB/customDomain.6c5b825d.json',
    customPage: '/bliss-apps/joy-web/static/locales/en-GB/customPage.d03c8b37.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/en-GB/customPhotoPreviewButton.afeab8b4.json',
    dates: '/bliss-apps/joy-web/static/locales/en-GB/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-GB/discountedRates.a8d06c20.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-GB/emailPreferences.85ba8363.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-GB/emailsAndEcards.b6a094d9.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/en-GB/emailTemplatesAdmin.62b6bac6.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/en-GB/emailVerification.5a67c126.json',
    errors: '/bliss-apps/joy-web/static/locales/en-GB/errors.a893ee8d.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-GB/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/eventCountdownCustomComponent.13685127.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/eventDetailsCustomComponent.b0a5ce98.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/eventDisplayNameCustomComponent.2c434c13.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-GB/eventFormDisplay.20bf1dfc.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-GB/eventMenu.9c239932.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/en-GB/eventPersonGuest.98cc298b.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-GB/eventPhotoPicker.55399b93.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-GB/eventRedirect.ed823f22.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-GB/eventServiceCenter.ac666539.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-GB/eventSite.a1d4b8ef.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-GB/eventSiteApps.890d04fa.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-GB/eventWorkspace.31a82ad4.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/faqCustomComponent.8d597b1f.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-GB/focusPoint.eac4ae34.json',
    form: '/bliss-apps/joy-web/static/locales/en-GB/form.3b22b2f2.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/formCustomComponent.dbf0c62a.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-GB/generalEventSchedule.866c37df.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-GB/generalEventScheduleEditor.ecad4216.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-GB/generalFormValidation.56c472d7.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/en-GB/getStartedOnboarding.542891f2.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/en-GB/giftNoteGuest.dad0ad35.json',
    graphError: '/bliss-apps/joy-web/static/locales/en-GB/graphError.30168852.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/graphicAccentCustomComponent.78e4fb26.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/en-GB/greetingMessageComponent.43dd357d.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/en-GB/groupMessaging.a85df38c.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-GB/guestGuide.85f26472.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/en-GB/guestInAppBrowserBanner.9828cb86.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-GB/guestKit.0eedf66b.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-GB/guestList.119feea6.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-GB/guestRegistry.7757512f.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteCustom.d04153e7.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteTravel.32ccacb7.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteWelcome.0dbaa68f.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-GB/guestUnlock.a37b36c9.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-GB/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-GB/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-GB/hotelBlock.76f5763c.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-GB/hotelReminder.2c734795.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/en-GB/hotelSearchGuest.9f91a7c0.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/en-GB/hotelSuggestionDialog.8006c58c.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-GB/hotelTile.96702ede.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-GB/imageFilePicker.2f64dd70.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/en-GB/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-GB/impermissible.b94bb60f.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/en-GB/inlineEditor.9d41c1fe.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/en-GB/instantRoomBlocksAdmin.a6a55c07.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/en-GB/instantRoomBlocksGuest.d3c2e455.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-GB/joykit.d025b565.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/en-GB/languagePickerV2.6220adc1.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-GB/layoutEngine.b8628dba.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-GB/locationDatesOccupants.66ffb689.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-GB/locationVenueSyncDialog.5dbbf854.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-GB/marcom.7b292db9.json',
    message: '/bliss-apps/joy-web/static/locales/en-GB/message.8b47dd9f.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/en-GB/messagesV2ServiceCenter.abbed87f.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-GB/messaging.2ee9eb68.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/en-GB/mothersDayDialog.55b5fce8.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-GB/multiPhotoSelector.e4c4891d.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-GB/pageNotFound.33eb49b3.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-GB/pageSettingsDialog.695eb309.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/en-GB/peoplePicker.e11ea823.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/en-GB/peoplePickerButton.d38ab9ea.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/en-GB/photoDownloadGuest.41359eaa.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/en-GB/photoGalleryLayout.470954c7.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-GB/photoPickerDialog.c83f45f7.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-GB/photoUploader.40e25c67.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/en-GB/pkpassGuest.f3f55d3c.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-GB/placeToStayComponent.3ee4c645.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-GB/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-GB/planningAccommodations.fd44cf9b.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/en-GB/postcardRecipientsCustomizer.bf7893f6.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-GB/postOffice.85e2d889.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-GB/productSelectionDialog.83195730.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/en-GB/promoCodeAdmin.dab3ff7b.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/en-GB/promoCodeGuest.485a185d.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-GB/publishReminder.e12b4a87.json',
    qrCode: '/bliss-apps/joy-web/static/locales/en-GB/qrCode.0fed007b.json',
    registration: '/bliss-apps/joy-web/static/locales/en-GB/registration.fe247539.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/en-GB/registrationFormGuest.1970b303.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/en-GB/registrationPostRsvp.e4dfb402.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/en-GB/registrationResumeGuest.5f5476bb.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-GB/registryChecklist.c7ff3723.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-GB/registryOnboardingSurvey.d9619ec3.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-GB/registryOnboardingSurveyV2.dd143cbf.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/en-GB/registryOnboardingV3Admin.d323af02.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-GB/registryOverview.acba3d0e.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/en-GB/replaceDefaultPhotos.ba67563b.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-GB/richTextEditor.e6bfeb1d.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-GB/rsvpAdmin.9ee7643b.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/rsvpCustomComponent.acf5eeb0.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/en-GB/rsvpDeadlineStatus.c062a1b2.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-GB/rsvpReminder.037bda23.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/en-GB/rsvpSettings.27182d49.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/en-GB/saveStateAdmin.bc13d10c.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-GB/scheduleEditor.28b2f703.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/en-GB/seatingChart.3dbbadc7.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/en-GB/serviceCenter.6440d210.json',
    settings: '/bliss-apps/joy-web/static/locales/en-GB/settings.e5ea8243.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/en-GB/shareAccommodationsHost.1b5f80b5.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-GB/sharedComponents.1ddfd134.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-GB/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-GB/sharedRegistry.e9819725.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/en-GB/shareEditor.8bcceb28.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/en-GB/shareRoomBlockHost.2378c998.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/en-GB/shareWebsiteDialog.6b6a0774.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/en-GB/shareYourStayGuest.90d27943.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/en-GB/siteStatusIndicatorAdmin.d25eaf73.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/slapAdsRegistry.85246404.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-GB/ssrServer.82b36cdc.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-GB/stationery.e8d82431.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/en-GB/stationeryCrossSell.450def01.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-GB/stationeryTemplateCategory.826e03ec.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/en-GB/stayAreasAdmin.edab956e.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/en-GB/stayAreasGuest.b9c58485.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-GB/stayBookingAssistant.ffb06818.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/en-GB/stayDetailsGuest.5ac0f6bf.json',
    stays: '/bliss-apps/joy-web/static/locales/en-GB/stays.1a46d314.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/en-GB/staysRedesignGuest.f37fbeb1.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-GB/suggestions.3daf4684.json',
    survey: '/bliss-apps/joy-web/static/locales/en-GB/survey.a9cc71a8.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/en-GB/tagsAdmin.8e78dc89.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/en-GB/textBlastAdmin.1b3f375a.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-GB/thanksForRSVP.e0f2a890.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/thingsToDoCustomComponent.7b1d85ac.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/en-GB/ticketsAdmin.75623880.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/en-GB/ticketsGuest.a553e3ce.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-GB/timePicker.1035b5ec.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/en-GB/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/en-GB/timeZonePickerV2.eeddc46d.json',
    tour: '/bliss-apps/joy-web/static/locales/en-GB/tour.ed0c5794.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/en-GB/transferToBankDialog.afe9e5d3.json',
    translation: '/bliss-apps/joy-web/static/locales/en-GB/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-GB/travelAdmin.07712c83.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-GB/travelEditor.e35e7539.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-GB/travelMap.91e8a6de.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-GB/travelNativeCheckout.9bbc75a9.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/en-GB/unifiedWebsiteEditorAdmin.0ff062a7.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-GB/universalRecommendations.baae19df.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-GB/unpublishedWebsite.a4bda309.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-GB/updateScheduleDialog.39447921.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/en-GB/validateGuestIdentityAdmin.9cc1e4d4.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-GB/verifyEmail.60a204df.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-GB/videoBackground.9f270c68.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/en-GB/videoHelper.18b1ee37.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/VIPCustomComponent.09e42052.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-GB/VIPForm.d5a152f2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-GB/weatherReportGuest.0f9c262e.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/en-GB/websiteCreate.e7a0f17f.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-GB/websiteDesigner.133767e4.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-GB/websiteEditor.10b7e312.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-GB/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-GB/websiteOverview.0dada388.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-GB/websitePages.373dbd61.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/en-GB/websitePhotosAdmin.7c341555.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-GB/websitePreview.48691ab8.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/en-GB/websiteV2Admin.1c28ea39.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/en-GB/websiteV2Guest.4cf84396.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-GB/weddingParty.83479da2.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-GB/yourRegistry.c385a69e.json',
  },
  'en-SG': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-SG/accommodationsAdmin.456d8b13.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-SG/accommodationsConsole.72e9876b.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-SG/accommodationsGuest.dad059f7.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/en-SG/accommodationsShared.13743e4c.json',
    account: '/bliss-apps/joy-web/static/locales/en-SG/account.fec0fd09.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-SG/actionBar.345c96a8.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-SG/addFromFriendsRegistry.ffa85e17.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/en-SG/addressDialog.d06d1511.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-SG/addToCalendar.8b347153.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-SG/adminDashboardV2.dae8a9d7.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-SG/adminDashboardV3.af73c564.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/en-SG/adminHeaderBar.62153dfe.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-SG/aiReviewTextarea.1d61865e.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/en-SG/allyPartnershipAdmin.9a26599f.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-SG/artUpload.b560a765.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-SG/autoPopulation.26e5620b.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-SG/bookmarklet.b2d13a6f.json',
    budget: '/bliss-apps/joy-web/static/locales/en-SG/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/en-SG/cardGuest.22a5fac3.json',
    carousel: '/bliss-apps/joy-web/static/locales/en-SG/carousel.a34fb581.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/en-SG/carRentalConsole.8f7e860a.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/en-SG/cashFundsAdmin.bdf06e61.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/en-SG/cashFundsGuest.9c65a11c.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/en-SG/cashFundsShared.9f81507e.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/en-SG/cashFundsTransfer.9a043bdb.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-SG/catalogRegistry.3661f435.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/en-SG/checkInAdmin.af33486f.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-SG/checklist.f8a27b51.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-SG/collaboration.0b770c14.json',
    colors: '/bliss-apps/joy-web/static/locales/en-SG/colors.955b0a62.json',
    combobox: '/bliss-apps/joy-web/static/locales/en-SG/combobox.983ac2bb.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/en-SG/commandPaletteAdmin.dbc9a574.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-SG/companyPolicies.b3065767.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-SG/contactCollector.e5378ae3.json',
    countries: '/bliss-apps/joy-web/static/locales/en-SG/countries.29294752.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-SG/createBabyRegistry.647beb50.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-SG/createEvent.1ef2ba3f.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-SG/createGeneral.f4484ede.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-SG/createRegistry.fc6658d8.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-SG/createWedding.e49a8a52.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-SG/curationsRegistry.c0aa8170.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-SG/currencies.b15fea22.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/en-SG/currencySelectorV2.7472ba62.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/en-SG/customBlockConfig.3721f97d.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-SG/customDomain.40e72990.json',
    customPage: '/bliss-apps/joy-web/static/locales/en-SG/customPage.26490df9.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/en-SG/customPhotoPreviewButton.82a5dfcd.json',
    dates: '/bliss-apps/joy-web/static/locales/en-SG/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-SG/discountedRates.0dd5bb7e.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-SG/emailPreferences.899dfff3.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-SG/emailsAndEcards.b2c67e0c.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/en-SG/emailTemplatesAdmin.471c16f0.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/en-SG/emailVerification.5a7b74c2.json',
    errors: '/bliss-apps/joy-web/static/locales/en-SG/errors.e6bfad7f.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-SG/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/eventCountdownCustomComponent.9b2c0703.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/eventDetailsCustomComponent.eb8b5129.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/eventDisplayNameCustomComponent.4fe30e85.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-SG/eventFormDisplay.8f4fe466.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-SG/eventMenu.5b36f289.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/en-SG/eventPersonGuest.d125198f.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-SG/eventPhotoPicker.0ea23ee1.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-SG/eventRedirect.eca05bb5.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-SG/eventServiceCenter.b2908bb9.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-SG/eventSite.eb670c86.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-SG/eventSiteApps.9fa560f3.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-SG/eventWorkspace.88e167bd.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/faqCustomComponent.27155bb7.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-SG/focusPoint.eac4ae34.json',
    form: '/bliss-apps/joy-web/static/locales/en-SG/form.686d7674.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/formCustomComponent.b4fbbda0.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-SG/generalEventSchedule.866c37df.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-SG/generalEventScheduleEditor.76ca6512.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-SG/generalFormValidation.b70bbd23.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/en-SG/getStartedOnboarding.92db5499.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/en-SG/giftNoteGuest.87c624d2.json',
    graphError: '/bliss-apps/joy-web/static/locales/en-SG/graphError.9320c730.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/graphicAccentCustomComponent.c04fd46c.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/en-SG/greetingMessageComponent.43dd357d.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/en-SG/groupMessaging.b6ab6084.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-SG/guestGuide.4608be55.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/en-SG/guestInAppBrowserBanner.b60fa818.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-SG/guestKit.b52584ab.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-SG/guestList.a156e8cd.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-SG/guestRegistry.82664c65.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-SG/guestSiteCustom.3c631fb2.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-SG/guestSiteTravel.4a7556d1.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-SG/guestSiteWelcome.76efcea1.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-SG/guestUnlock.ad88be75.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-SG/headerHelpMenu.770d30b1.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-SG/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-SG/hotelBlock.c3b0da5e.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-SG/hotelReminder.500da24a.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/en-SG/hotelSearchGuest.e4f733f9.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/en-SG/hotelSuggestionDialog.5dd4a510.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-SG/hotelTile.b14bdee1.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-SG/imageFilePicker.8c4ac817.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/en-SG/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-SG/impermissible.bfe7f67d.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/en-SG/inlineEditor.2b1ea015.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/en-SG/instantRoomBlocksAdmin.a1bb1e0b.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/en-SG/instantRoomBlocksGuest.b9c93114.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-SG/joykit.e9007aed.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/en-SG/languagePickerV2.4fca8499.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-SG/layoutEngine.178f59f8.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-SG/locationDatesOccupants.6da28758.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-SG/locationVenueSyncDialog.064fd22c.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-SG/marcom.94eebffc.json',
    message: '/bliss-apps/joy-web/static/locales/en-SG/message.1dc6f356.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/en-SG/messagesV2ServiceCenter.c0368cd6.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-SG/messaging.ac7bc724.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/en-SG/mothersDayDialog.38430907.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-SG/multiPhotoSelector.c7a6bfdc.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-SG/pageNotFound.f2b87159.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-SG/pageSettingsDialog.ec85b4c8.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/en-SG/peoplePicker.ba60bc62.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/en-SG/peoplePickerButton.a28faf08.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/en-SG/photoDownloadGuest.0d8a5229.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/en-SG/photoGalleryLayout.c9e492f0.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-SG/photoPickerDialog.28b40b2a.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-SG/photoUploader.2532ae82.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/en-SG/pkpassGuest.66e17d12.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-SG/placeToStayComponent.190c4ab0.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-SG/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-SG/planningAccommodations.45b1cb6d.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/en-SG/postcardRecipientsCustomizer.3cb24fb5.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-SG/postOffice.b66f5272.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-SG/productSelectionDialog.9bcdb8f7.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/en-SG/promoCodeAdmin.54668eb2.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/en-SG/promoCodeGuest.5c35f4ae.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-SG/publishReminder.a58f7caa.json',
    qrCode: '/bliss-apps/joy-web/static/locales/en-SG/qrCode.72cf2742.json',
    registration: '/bliss-apps/joy-web/static/locales/en-SG/registration.b2e1ccc4.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/en-SG/registrationFormGuest.b070ceb4.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/en-SG/registrationPostRsvp.74d5bfa8.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/en-SG/registrationResumeGuest.ca7c9568.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-SG/registryChecklist.e96c81f1.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-SG/registryOnboardingSurvey.4a1653e7.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-SG/registryOnboardingSurveyV2.28d40852.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/en-SG/registryOnboardingV3Admin.3d82d730.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-SG/registryOverview.4c27736d.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/en-SG/replaceDefaultPhotos.46ea186b.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-SG/richTextEditor.2a8e39d6.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-SG/rsvpAdmin.10dd1439.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/rsvpCustomComponent.914936d5.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/en-SG/rsvpDeadlineStatus.baf58811.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-SG/rsvpReminder.6dc902aa.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/en-SG/rsvpSettings.82888c83.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/en-SG/saveStateAdmin.37db451e.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-SG/scheduleEditor.69d40865.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/en-SG/seatingChart.3dbbadc7.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/en-SG/serviceCenter.9c544f2f.json',
    settings: '/bliss-apps/joy-web/static/locales/en-SG/settings.8a4711de.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/en-SG/shareAccommodationsHost.c9a20ca1.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-SG/sharedComponents.1109e37c.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-SG/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-SG/sharedRegistry.5defda4d.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/en-SG/shareEditor.8bcceb28.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/en-SG/shareRoomBlockHost.ba94db95.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/en-SG/shareWebsiteDialog.3e44edad.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/en-SG/shareYourStayGuest.9938962e.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/en-SG/siteStatusIndicatorAdmin.582b5b5c.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-SG/slapAdsRegistry.14af5bec.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-SG/ssrServer.c0aa0f96.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-SG/stationery.597a4cb8.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/en-SG/stationeryCrossSell.d4ed2af0.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-SG/stationeryTemplateCategory.bee5d5b9.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/en-SG/stayAreasAdmin.f63f770a.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/en-SG/stayAreasGuest.c2b40f89.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-SG/stayBookingAssistant.e7eeea50.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/en-SG/stayDetailsGuest.ccfe2680.json',
    stays: '/bliss-apps/joy-web/static/locales/en-SG/stays.bc5eca3d.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/en-SG/staysRedesignGuest.32897d62.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-SG/suggestions.9833b070.json',
    survey: '/bliss-apps/joy-web/static/locales/en-SG/survey.c5c87ba8.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/en-SG/tagsAdmin.f0c6dbc5.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/en-SG/textBlastAdmin.c1abd035.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-SG/thanksForRSVP.698d3a7e.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/thingsToDoCustomComponent.d7e13163.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/en-SG/ticketsAdmin.c899de80.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/en-SG/ticketsGuest.7e5f34d5.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-SG/timePicker.b7020cc2.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/en-SG/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/en-SG/timeZonePickerV2.90054a50.json',
    tour: '/bliss-apps/joy-web/static/locales/en-SG/tour.a722765b.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/en-SG/transferToBankDialog.ccc372f8.json',
    translation: '/bliss-apps/joy-web/static/locales/en-SG/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-SG/travelAdmin.7882cc04.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-SG/travelEditor.4e4499de.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-SG/travelMap.b4d7a870.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-SG/travelNativeCheckout.2bbe14c6.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/en-SG/unifiedWebsiteEditorAdmin.bb15d600.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-SG/universalRecommendations.9c0c6014.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-SG/unpublishedWebsite.ea96bc1d.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-SG/updateScheduleDialog.b8668799.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/en-SG/validateGuestIdentityAdmin.314def78.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-SG/verifyEmail.1c0b3af7.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-SG/videoBackground.3204a5a5.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/en-SG/videoHelper.e61fd0a6.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-SG/VIPCustomComponent.de03666b.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-SG/VIPForm.d5a152f2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-SG/weatherReportGuest.897ea35d.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/en-SG/websiteCreate.6266284d.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-SG/websiteDesigner.02ff2ba6.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-SG/websiteEditor.49686cd8.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-SG/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-SG/websiteOverview.8c6126b8.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-SG/websitePages.b697031a.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/en-SG/websitePhotosAdmin.b35ee2f5.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-SG/websitePreview.912ecece.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/en-SG/websiteV2Admin.20bd2cfc.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/en-SG/websiteV2Guest.4cf84396.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-SG/weddingParty.84b9512d.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-SG/yourRegistry.87455816.json',
  },
  'en-US': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-US/accommodationsAdmin.b7c4b069.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-US/accommodationsConsole.a0164af2.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-US/accommodationsGuest.a99ea785.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/en-US/accommodationsShared.13743e4c.json',
    account: '/bliss-apps/joy-web/static/locales/en-US/account.50d9e432.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-US/actionBar.fe494f43.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-US/addFromFriendsRegistry.9e68360b.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/en-US/addressDialog.7662c0a1.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-US/addToCalendar.8b347153.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-US/adminDashboardV2.b4350e57.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-US/adminDashboardV3.f7145f14.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/en-US/adminHeaderBar.145443ef.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-US/aiReviewTextarea.7ee6135e.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/en-US/allyPartnershipAdmin.03e1f584.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-US/artUpload.a21e245c.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-US/autoPopulation.c6c2c641.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-US/bookmarklet.cd09a701.json',
    budget: '/bliss-apps/joy-web/static/locales/en-US/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/en-US/cardGuest.82d66ed4.json',
    carousel: '/bliss-apps/joy-web/static/locales/en-US/carousel.a34fb581.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/en-US/carRentalConsole.131445f1.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/en-US/cashFundsAdmin.78c54ffd.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/en-US/cashFundsGuest.da0ea753.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/en-US/cashFundsShared.3a26f58e.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/en-US/cashFundsTransfer.29eaee16.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-US/catalogRegistry.63e29042.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/en-US/checkInAdmin.fd2eefac.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-US/checklist.d09063a2.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-US/collaboration.e29fc42e.json',
    colors: '/bliss-apps/joy-web/static/locales/en-US/colors.4eea2c1a.json',
    combobox: '/bliss-apps/joy-web/static/locales/en-US/combobox.983ac2bb.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/en-US/commandPaletteAdmin.09d771f2.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-US/companyPolicies.28fb77c4.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-US/contactCollector.1943e05d.json',
    countries: '/bliss-apps/joy-web/static/locales/en-US/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-US/createBabyRegistry.682c96ea.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-US/createEvent.7b74cba4.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-US/createGeneral.cd491b97.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-US/createRegistry.ba50bb20.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-US/createWedding.3991ff04.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-US/curationsRegistry.c0aa8170.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-US/currencies.479c7906.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/en-US/currencySelectorV2.eba426d8.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/en-US/customBlockConfig.3721f97d.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-US/customDomain.a3359f5b.json',
    customPage: '/bliss-apps/joy-web/static/locales/en-US/customPage.26490df9.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/en-US/customPhotoPreviewButton.afeab8b4.json',
    dates: '/bliss-apps/joy-web/static/locales/en-US/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-US/discountedRates.3182c358.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-US/emailPreferences.2d6eac91.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-US/emailsAndEcards.b82320d7.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/en-US/emailTemplatesAdmin.2fd00c80.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/en-US/emailVerification.4a582100.json',
    errors: '/bliss-apps/joy-web/static/locales/en-US/errors.1e5d30f8.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-US/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/eventCountdownCustomComponent.6a986748.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/eventDetailsCustomComponent.27f2021b.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/eventDisplayNameCustomComponent.4fe30e85.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-US/eventFormDisplay.90ea1556.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-US/eventMenu.5b36f289.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/en-US/eventPersonGuest.5e559a56.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-US/eventPhotoPicker.f52d0813.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-US/eventRedirect.7530e171.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-US/eventServiceCenter.309d6026.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-US/eventSite.1e1fc32f.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-US/eventSiteApps.8af2c5ca.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-US/eventWorkspace.fc477c5f.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/faqCustomComponent.27155bb7.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-US/focusPoint.eac4ae34.json',
    form: '/bliss-apps/joy-web/static/locales/en-US/form.b28949b3.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/formCustomComponent.65254259.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-US/generalEventSchedule.866c37df.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-US/generalEventScheduleEditor.14f9fa05.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-US/generalFormValidation.78d35b99.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/en-US/getStartedOnboarding.981693f2.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/en-US/giftNoteGuest.fe23beb0.json',
    graphError: '/bliss-apps/joy-web/static/locales/en-US/graphError.c6184d51.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/graphicAccentCustomComponent.c04fd46c.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/en-US/greetingMessageComponent.43dd357d.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/en-US/groupMessaging.60cd0aa8.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-US/guestGuide.885e99d3.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/en-US/guestInAppBrowserBanner.9828cb86.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-US/guestKit.82ba44b2.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-US/guestList.41008ade.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-US/guestRegistry.5b41428c.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-US/guestSiteCustom.66504c16.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-US/guestSiteTravel.20142407.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-US/guestSiteWelcome.c22d679a.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-US/guestUnlock.5bb5de12.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-US/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-US/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-US/hotelBlock.5743da69.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-US/hotelReminder.b15f7164.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/en-US/hotelSearchGuest.9f91a7c0.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/en-US/hotelSuggestionDialog.40787892.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-US/hotelTile.3df86aff.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-US/imageFilePicker.18aa8ddc.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/en-US/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-US/impermissible.81146127.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/en-US/inlineEditor.0e13f775.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/en-US/instantRoomBlocksAdmin.a7b12233.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/en-US/instantRoomBlocksGuest.a4136d62.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-US/joykit.91aab355.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/en-US/languagePickerV2.578b8050.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-US/layoutEngine.ae80dee6.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-US/locationDatesOccupants.700b79ca.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-US/locationVenueSyncDialog.90f3ddd4.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-US/marcom.a6d82934.json',
    message: '/bliss-apps/joy-web/static/locales/en-US/message.0babf542.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/en-US/messagesV2ServiceCenter.a07e28f9.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-US/messaging.500f07d4.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/en-US/mothersDayDialog.dfeb0c14.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-US/multiPhotoSelector.6e334cd8.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-US/pageNotFound.aad2bb88.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-US/pageSettingsDialog.996dc5f4.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/en-US/peoplePicker.2a087c96.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/en-US/peoplePickerButton.654623e1.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/en-US/photoDownloadGuest.0e675dec.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/en-US/photoGalleryLayout.e654fc46.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-US/photoPickerDialog.65c53205.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-US/photoUploader.90734996.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/en-US/pkpassGuest.62d2c50c.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-US/placeToStayComponent.63a00207.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-US/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-US/planningAccommodations.fde99432.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/en-US/postcardRecipientsCustomizer.c8878635.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-US/postOffice.4c801ae7.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-US/productSelectionDialog.fbe2ea73.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/en-US/promoCodeAdmin.96242d78.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/en-US/promoCodeGuest.eb5f5c6f.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-US/publishReminder.548cb7f9.json',
    qrCode: '/bliss-apps/joy-web/static/locales/en-US/qrCode.eeb63f4e.json',
    registration: '/bliss-apps/joy-web/static/locales/en-US/registration.d88b282d.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/en-US/registrationFormGuest.ced51c73.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/en-US/registrationPostRsvp.34e35cfc.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/en-US/registrationResumeGuest.5cca71b9.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-US/registryChecklist.e96c81f1.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-US/registryOnboardingSurvey.07b31907.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-US/registryOnboardingSurveyV2.7a7a36ac.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/en-US/registryOnboardingV3Admin.9b02aa2c.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-US/registryOverview.6b6cf837.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/en-US/replaceDefaultPhotos.31e6c100.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-US/richTextEditor.94eb1fbe.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-US/rsvpAdmin.b86da64d.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/rsvpCustomComponent.914936d5.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/en-US/rsvpDeadlineStatus.aa078703.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-US/rsvpReminder.6447c712.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/en-US/rsvpSettings.1ac8cbae.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/en-US/saveStateAdmin.625307fe.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-US/scheduleEditor.2cfe4277.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/en-US/seatingChart.b21d90f8.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/en-US/serviceCenter.1c4ace81.json',
    settings: '/bliss-apps/joy-web/static/locales/en-US/settings.35198490.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/en-US/shareAccommodationsHost.33a1e7b7.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-US/sharedComponents.9df1e023.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-US/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-US/sharedRegistry.e32bdea2.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/en-US/shareEditor.8bcceb28.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/en-US/shareRoomBlockHost.3cca07a3.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/en-US/shareWebsiteDialog.9206769d.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/en-US/shareYourStayGuest.4b43f634.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/en-US/siteStatusIndicatorAdmin.d25eaf73.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-US/slapAdsRegistry.3e78dffc.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-US/ssrServer.24259b78.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-US/stationery.a35a368f.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/en-US/stationeryCrossSell.f705581a.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-US/stationeryTemplateCategory.bee5d5b9.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/en-US/stayAreasAdmin.8c985d14.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/en-US/stayAreasGuest.740733e9.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-US/stayBookingAssistant.8d798f02.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/en-US/stayDetailsGuest.7b4088d5.json',
    stays: '/bliss-apps/joy-web/static/locales/en-US/stays.d78a5f02.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/en-US/staysRedesignGuest.3ccc55d3.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-US/suggestions.7715ee59.json',
    survey: '/bliss-apps/joy-web/static/locales/en-US/survey.501ad929.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/en-US/tagsAdmin.f0c6dbc5.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/en-US/textBlastAdmin.e71ad9eb.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-US/thanksForRSVP.33cf2ed3.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/thingsToDoCustomComponent.af0c0a51.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/en-US/ticketsAdmin.ca29f164.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/en-US/ticketsGuest.a553e3ce.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-US/timePicker.a9875105.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/en-US/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/en-US/timeZonePickerV2.e1b5b576.json',
    tour: '/bliss-apps/joy-web/static/locales/en-US/tour.f4e03f08.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/en-US/transferToBankDialog.0c2bbabf.json',
    translation: '/bliss-apps/joy-web/static/locales/en-US/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-US/travelAdmin.f1bcffc9.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-US/travelEditor.72f8e88f.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-US/travelMap.a05953a8.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-US/travelNativeCheckout.b7677e38.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/en-US/unifiedWebsiteEditorAdmin.05f1b17b.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-US/universalRecommendations.309737e0.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-US/unpublishedWebsite.ea96bc1d.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-US/updateScheduleDialog.8cfa387e.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/en-US/validateGuestIdentityAdmin.bce1ca18.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-US/verifyEmail.6ce1b9a3.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-US/videoBackground.1838439c.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/en-US/videoHelper.6eadae0c.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-US/VIPCustomComponent.9066f9a4.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-US/VIPForm.d5a152f2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-US/weatherReportGuest.0f9c262e.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/en-US/websiteCreate.5f7366bb.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-US/websiteDesigner.3f3b000a.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-US/websiteEditor.6c3897b6.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-US/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-US/websiteOverview.9ab4c9ce.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-US/websitePages.2f184a44.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/en-US/websitePhotosAdmin.f7fba0a3.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-US/websitePreview.9bd55a76.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/en-US/websiteV2Admin.cea01bd9.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/en-US/websiteV2Guest.4cf84396.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-US/weddingParty.9b78bbd3.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-US/yourRegistry.6b5addd5.json',
  },
  'es-ES': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/es-ES/accommodationsAdmin.60e35e2d.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/es-ES/accommodationsConsole.e7892e70.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/es-ES/accommodationsGuest.48809245.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/es-ES/accommodationsShared.8bd31db6.json',
    account: '/bliss-apps/joy-web/static/locales/es-ES/account.81cc9a73.json',
    actionBar: '/bliss-apps/joy-web/static/locales/es-ES/actionBar.969a37e1.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/es-ES/addFromFriendsRegistry.b8a1d367.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/es-ES/addressDialog.cc6d5ecf.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/es-ES/addToCalendar.731dba60.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/es-ES/adminDashboardV2.6bcb7dc3.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/es-ES/adminDashboardV3.2ae8b1d2.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/es-ES/adminHeaderBar.f477eac5.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/es-ES/aiReviewTextarea.10f26c11.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/es-ES/allyPartnershipAdmin.94db1479.json',
    artUpload: '/bliss-apps/joy-web/static/locales/es-ES/artUpload.5c7ee918.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/es-ES/autoPopulation.afc8a0e9.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/es-ES/bookmarklet.87740cc9.json',
    budget: '/bliss-apps/joy-web/static/locales/es-ES/budget.c045aaae.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/es-ES/cardGuest.986c16ed.json',
    carousel: '/bliss-apps/joy-web/static/locales/es-ES/carousel.e6e05328.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/es-ES/carRentalConsole.ae3699ae.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/es-ES/cashFundsAdmin.c2500210.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/es-ES/cashFundsGuest.a128da79.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/es-ES/cashFundsShared.cba01744.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/es-ES/cashFundsTransfer.ce9c4076.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/es-ES/catalogRegistry.47c03359.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/es-ES/checkInAdmin.83848901.json',
    checklist: '/bliss-apps/joy-web/static/locales/es-ES/checklist.bb1b6645.json',
    collaboration: '/bliss-apps/joy-web/static/locales/es-ES/collaboration.186e225a.json',
    colors: '/bliss-apps/joy-web/static/locales/es-ES/colors.cacc8e91.json',
    combobox: '/bliss-apps/joy-web/static/locales/es-ES/combobox.87cb92dc.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/es-ES/commandPaletteAdmin.085e99e6.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/es-ES/companyPolicies.936e8e47.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/es-ES/contactCollector.8a6c0897.json',
    countries: '/bliss-apps/joy-web/static/locales/es-ES/countries.282359ed.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/es-ES/createBabyRegistry.8422f01a.json',
    createEvent: '/bliss-apps/joy-web/static/locales/es-ES/createEvent.14ad2efe.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/es-ES/createGeneral.e21b83a7.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/es-ES/createRegistry.6c75b323.json',
    createWedding: '/bliss-apps/joy-web/static/locales/es-ES/createWedding.f5b40c8d.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/es-ES/curationsRegistry.478e0941.json',
    currencies: '/bliss-apps/joy-web/static/locales/es-ES/currencies.848ecdfa.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/es-ES/currencySelectorV2.547635b1.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/es-ES/customBlockConfig.c8997979.json',
    customDomain: '/bliss-apps/joy-web/static/locales/es-ES/customDomain.3e8c543d.json',
    customPage: '/bliss-apps/joy-web/static/locales/es-ES/customPage.0089701c.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/es-ES/customPhotoPreviewButton.a2afdb9e.json',
    dates: '/bliss-apps/joy-web/static/locales/es-ES/dates.ab12382b.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/es-ES/discountedRates.ea162d81.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/es-ES/emailPreferences.6437bfb3.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/es-ES/emailsAndEcards.178fe4d9.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/es-ES/emailTemplatesAdmin.074e88f9.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/es-ES/emailVerification.915e5f30.json',
    errors: '/bliss-apps/joy-web/static/locales/es-ES/errors.3785903d.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/es-ES/eventCountdown.9633219c.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/eventCountdownCustomComponent.6dcad2ba.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/eventDetailsCustomComponent.d384c989.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/eventDisplayNameCustomComponent.41370475.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/es-ES/eventFormDisplay.dcb72bc1.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/es-ES/eventMenu.b3b2edb5.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/es-ES/eventPersonGuest.75ecb718.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/es-ES/eventPhotoPicker.9d871fb6.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/es-ES/eventRedirect.9ea1f29c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/es-ES/eventServiceCenter.4bcd16ea.json',
    eventSite: '/bliss-apps/joy-web/static/locales/es-ES/eventSite.1c5fd3a8.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/es-ES/eventSiteApps.efa3e804.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/es-ES/eventWorkspace.039426a4.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/faqCustomComponent.ddc70a92.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/es-ES/focusPoint.7b819913.json',
    form: '/bliss-apps/joy-web/static/locales/es-ES/form.71f78d87.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/formCustomComponent.b06c0023.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/es-ES/generalEventSchedule.283f21cb.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/es-ES/generalEventScheduleEditor.8ebf8e3e.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/es-ES/generalFormValidation.cc740266.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/es-ES/getStartedOnboarding.9f4e35af.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/es-ES/giftNoteGuest.a98737b4.json',
    graphError: '/bliss-apps/joy-web/static/locales/es-ES/graphError.15ab9bc7.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/graphicAccentCustomComponent.b9e4cc48.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/es-ES/greetingMessageComponent.557ea40e.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/es-ES/groupMessaging.44367af4.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/es-ES/guestGuide.3c37102a.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/es-ES/guestInAppBrowserBanner.5c89c634.json',
    guestKit: '/bliss-apps/joy-web/static/locales/es-ES/guestKit.b2798f03.json',
    guestList: '/bliss-apps/joy-web/static/locales/es-ES/guestList.e55256c2.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/es-ES/guestRegistry.9ae59d90.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/es-ES/guestSiteCustom.c64f6123.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/es-ES/guestSiteTravel.99c3464a.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/es-ES/guestSiteWelcome.28498519.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/es-ES/guestUnlock.14fc0b03.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/es-ES/headerHelpMenu.af32fe66.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/es-ES/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/es-ES/hotelBlock.d5780145.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/es-ES/hotelReminder.114fa71b.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/es-ES/hotelSearchGuest.97da8c66.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/es-ES/hotelSuggestionDialog.1a36c7fd.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/es-ES/hotelTile.ff8cf28e.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/es-ES/imageFilePicker.fba72e03.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/es-ES/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/es-ES/impermissible.9d0f218e.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/es-ES/inlineEditor.4116a6c0.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/es-ES/instantRoomBlocksAdmin.f00f3465.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/es-ES/instantRoomBlocksGuest.8024e2d5.json',
    joykit: '/bliss-apps/joy-web/static/locales/es-ES/joykit.f0f16f89.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/es-ES/languagePickerV2.ed6e92b8.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/es-ES/layoutEngine.f320475d.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/es-ES/locationDatesOccupants.9d7265d0.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/es-ES/locationVenueSyncDialog.c36458cf.json',
    marcom: '/bliss-apps/joy-web/static/locales/es-ES/marcom.8e3f036b.json',
    message: '/bliss-apps/joy-web/static/locales/es-ES/message.6b2aa306.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/es-ES/messagesV2ServiceCenter.69d01371.json',
    messaging: '/bliss-apps/joy-web/static/locales/es-ES/messaging.2cca2aed.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/es-ES/mothersDayDialog.3cd37334.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/es-ES/multiPhotoSelector.a2a7d2ef.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/es-ES/pageNotFound.04b664ec.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/es-ES/pageSettingsDialog.0ed92fe0.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/es-ES/peoplePicker.809fa4e9.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/es-ES/peoplePickerButton.342917fa.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/es-ES/photoDownloadGuest.91a04d45.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/es-ES/photoGalleryLayout.97f4c03b.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/es-ES/photoPickerDialog.1ff1aa1b.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/es-ES/photoUploader.eaf5c327.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/es-ES/pkpassGuest.0b388a37.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/es-ES/placeToStayComponent.00ff63fb.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/es-ES/placeToStayGuest.45999e0b.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/es-ES/planningAccommodations.a9f2a6dc.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/es-ES/postcardRecipientsCustomizer.5c0cafdc.json',
    postOffice: '/bliss-apps/joy-web/static/locales/es-ES/postOffice.5c0116ee.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/es-ES/productSelectionDialog.b706feab.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/es-ES/promoCodeAdmin.94b32941.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/es-ES/promoCodeGuest.8e981725.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/es-ES/publishReminder.45e17b5f.json',
    qrCode: '/bliss-apps/joy-web/static/locales/es-ES/qrCode.eec7a28f.json',
    registration: '/bliss-apps/joy-web/static/locales/es-ES/registration.e76d8bf0.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/es-ES/registrationFormGuest.1eda0880.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/es-ES/registrationPostRsvp.0ddeb52c.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/es-ES/registrationResumeGuest.856b0022.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/es-ES/registryChecklist.1830232d.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/es-ES/registryOnboardingSurvey.5760bb3d.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/es-ES/registryOnboardingSurveyV2.50cb70ca.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/es-ES/registryOnboardingV3Admin.fdb3c36a.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/es-ES/registryOverview.d78081ac.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/es-ES/replaceDefaultPhotos.17546845.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/es-ES/richTextEditor.9fc8ba87.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/es-ES/rsvpAdmin.f9f3a06e.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/rsvpCustomComponent.c9a1ab43.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/es-ES/rsvpDeadlineStatus.d5954de6.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/es-ES/rsvpReminder.8206251b.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/es-ES/rsvpSettings.03951bb7.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/es-ES/saveStateAdmin.5f5deccf.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/es-ES/scheduleEditor.7e28b035.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/es-ES/seatingChart.724ac4c7.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/es-ES/serviceCenter.b3e46bbc.json',
    settings: '/bliss-apps/joy-web/static/locales/es-ES/settings.5c304de9.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/es-ES/shareAccommodationsHost.b08e5ed9.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/es-ES/sharedComponents.a31e3a6b.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/es-ES/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/es-ES/sharedRegistry.6cf80b84.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/es-ES/shareEditor.31462f0a.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/es-ES/shareRoomBlockHost.0a0b483a.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/es-ES/shareWebsiteDialog.93b2196c.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/es-ES/shareYourStayGuest.7324b270.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/es-ES/siteStatusIndicatorAdmin.58fccbb1.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/es-ES/slapAdsRegistry.b2c00316.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/es-ES/ssrServer.23e14d21.json',
    stationery: '/bliss-apps/joy-web/static/locales/es-ES/stationery.19a78e1c.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/es-ES/stationeryCrossSell.01112e64.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/es-ES/stationeryTemplateCategory.7f37cf7d.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/es-ES/stayAreasAdmin.28637662.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/es-ES/stayAreasGuest.4e6069ac.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/es-ES/stayBookingAssistant.3a591e02.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/es-ES/stayDetailsGuest.15b69243.json',
    stays: '/bliss-apps/joy-web/static/locales/es-ES/stays.be6f8b40.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/es-ES/staysRedesignGuest.2409d556.json',
    suggestions: '/bliss-apps/joy-web/static/locales/es-ES/suggestions.1fdbca20.json',
    survey: '/bliss-apps/joy-web/static/locales/es-ES/survey.c54f060b.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/es-ES/tagsAdmin.89c4c758.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/es-ES/textBlastAdmin.b3c29516.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/es-ES/thanksForRSVP.c3f9124f.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/thingsToDoCustomComponent.1b36865e.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/es-ES/ticketsAdmin.38adfafd.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/es-ES/ticketsGuest.3ec322e8.json',
    timePicker: '/bliss-apps/joy-web/static/locales/es-ES/timePicker.b1646d85.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/es-ES/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/es-ES/timeZonePickerV2.ec894c07.json',
    tour: '/bliss-apps/joy-web/static/locales/es-ES/tour.d00cae03.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/es-ES/transferToBankDialog.56b6746e.json',
    translation: '/bliss-apps/joy-web/static/locales/es-ES/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/es-ES/travelAdmin.70dfe250.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/es-ES/travelEditor.793189a6.json',
    travelMap: '/bliss-apps/joy-web/static/locales/es-ES/travelMap.5da1a594.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/es-ES/travelNativeCheckout.ce3e36bd.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/es-ES/unifiedWebsiteEditorAdmin.daca253e.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/es-ES/universalRecommendations.5d01762f.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/es-ES/unpublishedWebsite.49ddd7ff.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/es-ES/updateScheduleDialog.c62079e3.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/es-ES/validateGuestIdentityAdmin.c2d3221b.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/es-ES/verifyEmail.91f1dd03.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/es-ES/videoBackground.cdbce0f6.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/es-ES/videoHelper.af521ef6.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/es-ES/VIPCustomComponent.a1a8edb5.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/es-ES/VIPForm.d35dbdd8.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/es-ES/weatherReportGuest.f607ad1a.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/es-ES/websiteCreate.02e5abf7.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/es-ES/websiteDesigner.0fb201c5.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/es-ES/websiteEditor.6a961165.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/es-ES/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/es-ES/websiteOverview.b5b361e7.json',
    websitePages: '/bliss-apps/joy-web/static/locales/es-ES/websitePages.4c9c70d1.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/es-ES/websitePhotosAdmin.b3d8fed4.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/es-ES/websitePreview.4ea9dc11.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/es-ES/websiteV2Admin.c075aad9.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/es-ES/websiteV2Guest.1e222683.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/es-ES/weddingParty.707527e0.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/es-ES/yourRegistry.b8115080.json',
  },
  'es-US': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/es-US/accommodationsAdmin.a2e54562.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/es-US/accommodationsConsole.76d151e1.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/es-US/accommodationsGuest.e37c56d1.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/es-US/accommodationsShared.174955bc.json',
    account: '/bliss-apps/joy-web/static/locales/es-US/account.e38c18fa.json',
    actionBar: '/bliss-apps/joy-web/static/locales/es-US/actionBar.8d1a609b.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/es-US/addFromFriendsRegistry.8c87033d.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/es-US/addressDialog.218f236c.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/es-US/addToCalendar.731dba60.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/es-US/adminDashboardV2.d28ac1e5.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/es-US/adminDashboardV3.61c22dc5.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/es-US/adminHeaderBar.25899fb3.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/es-US/aiReviewTextarea.a3815671.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/es-US/allyPartnershipAdmin.35689204.json',
    artUpload: '/bliss-apps/joy-web/static/locales/es-US/artUpload.3511434c.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/es-US/autoPopulation.870539e2.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/es-US/bookmarklet.7656542d.json',
    budget: '/bliss-apps/joy-web/static/locales/es-US/budget.c045aaae.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/es-US/cardGuest.f886ebb1.json',
    carousel: '/bliss-apps/joy-web/static/locales/es-US/carousel.e6e05328.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/es-US/carRentalConsole.79e4aa9b.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/es-US/cashFundsAdmin.19aba75c.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/es-US/cashFundsGuest.db30b46f.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/es-US/cashFundsShared.cba01744.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/es-US/cashFundsTransfer.7d0e53f9.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/es-US/catalogRegistry.23fad2cf.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/es-US/checkInAdmin.f1fe2dc8.json',
    checklist: '/bliss-apps/joy-web/static/locales/es-US/checklist.e61702cd.json',
    collaboration: '/bliss-apps/joy-web/static/locales/es-US/collaboration.4f5bd5d8.json',
    colors: '/bliss-apps/joy-web/static/locales/es-US/colors.d591dd44.json',
    combobox: '/bliss-apps/joy-web/static/locales/es-US/combobox.4a5bdf6c.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/es-US/commandPaletteAdmin.6eacd48a.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/es-US/companyPolicies.7b98aff6.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/es-US/contactCollector.8c87c521.json',
    countries: '/bliss-apps/joy-web/static/locales/es-US/countries.66764885.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/es-US/createBabyRegistry.7dcaaebf.json',
    createEvent: '/bliss-apps/joy-web/static/locales/es-US/createEvent.dd5d8e6e.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/es-US/createGeneral.c7ecc3f7.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/es-US/createRegistry.8b571c7f.json',
    createWedding: '/bliss-apps/joy-web/static/locales/es-US/createWedding.669ed096.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/es-US/curationsRegistry.febb3f5b.json',
    currencies: '/bliss-apps/joy-web/static/locales/es-US/currencies.c552906f.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/es-US/currencySelectorV2.85947bbf.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/es-US/customBlockConfig.24d9fc20.json',
    customDomain: '/bliss-apps/joy-web/static/locales/es-US/customDomain.fa222d76.json',
    customPage: '/bliss-apps/joy-web/static/locales/es-US/customPage.684e97f2.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/es-US/customPhotoPreviewButton.a2afdb9e.json',
    dates: '/bliss-apps/joy-web/static/locales/es-US/dates.cfeb4cc0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/es-US/discountedRates.39fae5de.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/es-US/emailPreferences.020df0ef.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/es-US/emailsAndEcards.1bbdb298.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/es-US/emailTemplatesAdmin.9af2d1b6.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/es-US/emailVerification.5715a256.json',
    errors: '/bliss-apps/joy-web/static/locales/es-US/errors.4cc37e68.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/es-US/eventCountdown.9633219c.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/eventCountdownCustomComponent.f0bd329f.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/eventDetailsCustomComponent.8f2f6cac.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/eventDisplayNameCustomComponent.457460bc.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/es-US/eventFormDisplay.49934af2.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/es-US/eventMenu.1c08a0ff.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/es-US/eventPersonGuest.75ecb718.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/es-US/eventPhotoPicker.c260f625.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/es-US/eventRedirect.9ea1f29c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/es-US/eventServiceCenter.c1d5b5d1.json',
    eventSite: '/bliss-apps/joy-web/static/locales/es-US/eventSite.4eb19522.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/es-US/eventSiteApps.76b58a98.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/es-US/eventWorkspace.37a10793.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/faqCustomComponent.2e1e0887.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/es-US/focusPoint.7b819913.json',
    form: '/bliss-apps/joy-web/static/locales/es-US/form.58d1202f.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/formCustomComponent.40467e48.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/es-US/generalEventSchedule.78a7891a.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/es-US/generalEventScheduleEditor.07333d5b.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/es-US/generalFormValidation.09be71e8.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/es-US/getStartedOnboarding.280775a4.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/es-US/giftNoteGuest.16d3bfef.json',
    graphError: '/bliss-apps/joy-web/static/locales/es-US/graphError.1bdd0070.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/graphicAccentCustomComponent.e62746e1.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/es-US/greetingMessageComponent.557ea40e.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/es-US/groupMessaging.b81dfabe.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/es-US/guestGuide.655f9d8e.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/es-US/guestInAppBrowserBanner.5c89c634.json',
    guestKit: '/bliss-apps/joy-web/static/locales/es-US/guestKit.e5455736.json',
    guestList: '/bliss-apps/joy-web/static/locales/es-US/guestList.24b65737.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/es-US/guestRegistry.56547309.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/es-US/guestSiteCustom.44aae31c.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/es-US/guestSiteTravel.1fd43a73.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/es-US/guestSiteWelcome.28498519.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/es-US/guestUnlock.b5969b25.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/es-US/headerHelpMenu.af32fe66.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/es-US/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/es-US/hotelBlock.13145d49.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/es-US/hotelReminder.db7f46d4.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/es-US/hotelSearchGuest.7eaedee2.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/es-US/hotelSuggestionDialog.0cdd24c1.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/es-US/hotelTile.b0a9a17d.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/es-US/imageFilePicker.fb7cee31.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/es-US/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/es-US/impermissible.e38335a1.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/es-US/inlineEditor.e7af628b.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/es-US/instantRoomBlocksAdmin.adbcf970.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/es-US/instantRoomBlocksGuest.f775a8c4.json',
    joykit: '/bliss-apps/joy-web/static/locales/es-US/joykit.6f593dfc.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/es-US/languagePickerV2.9b2e26ae.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/es-US/layoutEngine.82b6c92f.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/es-US/locationDatesOccupants.0401450e.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/es-US/locationVenueSyncDialog.507caeb5.json',
    marcom: '/bliss-apps/joy-web/static/locales/es-US/marcom.c0945504.json',
    message: '/bliss-apps/joy-web/static/locales/es-US/message.4915dde4.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/es-US/messagesV2ServiceCenter.8a3c8609.json',
    messaging: '/bliss-apps/joy-web/static/locales/es-US/messaging.819149f9.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/es-US/mothersDayDialog.37d73dd6.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/es-US/multiPhotoSelector.42be1eec.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/es-US/pageNotFound.baf678b3.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/es-US/pageSettingsDialog.3f25fb35.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/es-US/peoplePicker.2bd84123.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/es-US/peoplePickerButton.4d57230f.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/es-US/photoDownloadGuest.3669364b.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/es-US/photoGalleryLayout.c9677ad1.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/es-US/photoPickerDialog.6d96653c.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/es-US/photoUploader.c57254ae.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/es-US/pkpassGuest.05e1884f.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/es-US/placeToStayComponent.bcee07ee.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/es-US/placeToStayGuest.45999e0b.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/es-US/planningAccommodations.100dd917.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/es-US/postcardRecipientsCustomizer.08a58c9b.json',
    postOffice: '/bliss-apps/joy-web/static/locales/es-US/postOffice.85fcca35.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/es-US/productSelectionDialog.98e881d3.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/es-US/promoCodeAdmin.37bab4dd.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/es-US/promoCodeGuest.51e32b62.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/es-US/publishReminder.d83a6c8e.json',
    qrCode: '/bliss-apps/joy-web/static/locales/es-US/qrCode.eec7a28f.json',
    registration: '/bliss-apps/joy-web/static/locales/es-US/registration.0db8cb0c.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/es-US/registrationFormGuest.28419b2a.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/es-US/registrationPostRsvp.a7955d11.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/es-US/registrationResumeGuest.b98bf9bc.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/es-US/registryChecklist.47a72caa.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/es-US/registryOnboardingSurvey.3a7de043.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/es-US/registryOnboardingSurveyV2.48385399.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/es-US/registryOnboardingV3Admin.bbdf7e52.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/es-US/registryOverview.ed8d2b49.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/es-US/replaceDefaultPhotos.de9499ae.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/es-US/richTextEditor.c5107478.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/es-US/rsvpAdmin.f8e951ee.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/rsvpCustomComponent.82472a48.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/es-US/rsvpDeadlineStatus.2d91e5fb.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/es-US/rsvpReminder.1e626b7a.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/es-US/rsvpSettings.2449e851.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/es-US/saveStateAdmin.893b6dc5.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/es-US/scheduleEditor.2c917c8f.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/es-US/seatingChart.7877db61.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/es-US/serviceCenter.65f0f040.json',
    settings: '/bliss-apps/joy-web/static/locales/es-US/settings.265845d1.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/es-US/shareAccommodationsHost.14dfd1f1.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/es-US/sharedComponents.5adaf5d3.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/es-US/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/es-US/sharedRegistry.73bf5558.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/es-US/shareEditor.0bbd415d.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/es-US/shareRoomBlockHost.da790843.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/es-US/shareWebsiteDialog.083f1f28.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/es-US/shareYourStayGuest.a444db55.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/es-US/siteStatusIndicatorAdmin.8d0df335.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/es-US/slapAdsRegistry.d47a3a48.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/es-US/ssrServer.55c0ce66.json',
    stationery: '/bliss-apps/joy-web/static/locales/es-US/stationery.0659d67c.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/es-US/stationeryCrossSell.e5142145.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/es-US/stationeryTemplateCategory.c58884cf.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/es-US/stayAreasAdmin.5b0e211a.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/es-US/stayAreasGuest.d23bf760.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/es-US/stayBookingAssistant.097dc108.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/es-US/stayDetailsGuest.34a2ebeb.json',
    stays: '/bliss-apps/joy-web/static/locales/es-US/stays.c505f1a8.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/es-US/staysRedesignGuest.2d937c3e.json',
    suggestions: '/bliss-apps/joy-web/static/locales/es-US/suggestions.c4570541.json',
    survey: '/bliss-apps/joy-web/static/locales/es-US/survey.3f4758f2.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/es-US/tagsAdmin.927c2fa1.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/es-US/textBlastAdmin.8e5f40a8.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/es-US/thanksForRSVP.edb48235.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/thingsToDoCustomComponent.06bce9bb.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/es-US/ticketsAdmin.b3baf611.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/es-US/ticketsGuest.3ec322e8.json',
    timePicker: '/bliss-apps/joy-web/static/locales/es-US/timePicker.9ec9c9ac.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/es-US/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/es-US/timeZonePickerV2.c347fa08.json',
    tour: '/bliss-apps/joy-web/static/locales/es-US/tour.d00cae03.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/es-US/transferToBankDialog.7cb80eff.json',
    translation: '/bliss-apps/joy-web/static/locales/es-US/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/es-US/travelAdmin.6d44400f.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/es-US/travelEditor.b1f59371.json',
    travelMap: '/bliss-apps/joy-web/static/locales/es-US/travelMap.762a3a59.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/es-US/travelNativeCheckout.06e68d02.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/es-US/unifiedWebsiteEditorAdmin.470255d4.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/es-US/universalRecommendations.0f71bc66.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/es-US/unpublishedWebsite.24bd87de.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/es-US/updateScheduleDialog.93a01300.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/es-US/validateGuestIdentityAdmin.5a6f7df7.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/es-US/verifyEmail.3ec74fed.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/es-US/videoBackground.6c062a41.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/es-US/videoHelper.ac545097.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/es-US/VIPCustomComponent.9307c6fa.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/es-US/VIPForm.4185b9ae.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/es-US/weatherReportGuest.2b4ae351.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/es-US/websiteCreate.186f508f.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/es-US/websiteDesigner.7ab503ce.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/es-US/websiteEditor.4c579c42.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/es-US/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/es-US/websiteOverview.1f556f20.json',
    websitePages: '/bliss-apps/joy-web/static/locales/es-US/websitePages.56b2d330.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/es-US/websitePhotosAdmin.2790bf07.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/es-US/websitePreview.9e09bc56.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/es-US/websiteV2Admin.6a1255d0.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/es-US/websiteV2Guest.73334023.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/es-US/weddingParty.e422a488.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/es-US/yourRegistry.e0513830.json',
  },
  'fr-CA': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/accommodationsAdmin.a0bcbc94.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/fr-CA/accommodationsConsole.249a5c49.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/fr-CA/accommodationsGuest.fc5c695e.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/fr-CA/accommodationsShared.4544b235.json',
    account: '/bliss-apps/joy-web/static/locales/fr-CA/account.2cdbeab9.json',
    actionBar: '/bliss-apps/joy-web/static/locales/fr-CA/actionBar.2dca6a83.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/addFromFriendsRegistry.a1b946e4.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/fr-CA/addressDialog.3dfa4e5b.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/fr-CA/addToCalendar.7ed0cf9f.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/fr-CA/adminDashboardV2.6a9a0820.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/fr-CA/adminDashboardV3.760e5c13.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/fr-CA/adminHeaderBar.9335e197.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/fr-CA/aiReviewTextarea.5e4a912c.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/allyPartnershipAdmin.c17e52ab.json',
    artUpload: '/bliss-apps/joy-web/static/locales/fr-CA/artUpload.d88ba9bf.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/fr-CA/autoPopulation.1379c10c.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/fr-CA/bookmarklet.8f34e3df.json',
    budget: '/bliss-apps/joy-web/static/locales/fr-CA/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/fr-CA/cardGuest.324a2d3c.json',
    carousel: '/bliss-apps/joy-web/static/locales/fr-CA/carousel.8e874448.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/fr-CA/carRentalConsole.4d2308a0.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/cashFundsAdmin.dd7b11ca.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/fr-CA/cashFundsGuest.180d989b.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/fr-CA/cashFundsShared.24e2bf6f.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/fr-CA/cashFundsTransfer.d9fc162a.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/catalogRegistry.99942d9b.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/checkInAdmin.c1fd13ad.json',
    checklist: '/bliss-apps/joy-web/static/locales/fr-CA/checklist.b465b491.json',
    collaboration: '/bliss-apps/joy-web/static/locales/fr-CA/collaboration.8bf58a84.json',
    colors: '/bliss-apps/joy-web/static/locales/fr-CA/colors.2fbe885d.json',
    combobox: '/bliss-apps/joy-web/static/locales/fr-CA/combobox.68dba582.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/commandPaletteAdmin.f263abbe.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/fr-CA/companyPolicies.c3b98f4d.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/fr-CA/contactCollector.b30c983a.json',
    countries: '/bliss-apps/joy-web/static/locales/fr-CA/countries.b0f13c56.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/createBabyRegistry.e689a035.json',
    createEvent: '/bliss-apps/joy-web/static/locales/fr-CA/createEvent.d4513ea4.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/fr-CA/createGeneral.7644f33c.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/createRegistry.b3474dc5.json',
    createWedding: '/bliss-apps/joy-web/static/locales/fr-CA/createWedding.dc06933e.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/curationsRegistry.fe49705a.json',
    currencies: '/bliss-apps/joy-web/static/locales/fr-CA/currencies.46396a75.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/fr-CA/currencySelectorV2.2cf7d872.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/fr-CA/customBlockConfig.ad361912.json',
    customDomain: '/bliss-apps/joy-web/static/locales/fr-CA/customDomain.e1237c3a.json',
    customPage: '/bliss-apps/joy-web/static/locales/fr-CA/customPage.273ccadb.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/fr-CA/customPhotoPreviewButton.4dc6a582.json',
    dates: '/bliss-apps/joy-web/static/locales/fr-CA/dates.510dad32.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/fr-CA/discountedRates.af3c38f9.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/fr-CA/emailPreferences.544be463.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/fr-CA/emailsAndEcards.05bb2748.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/emailTemplatesAdmin.f78f039a.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/fr-CA/emailVerification.94745986.json',
    errors: '/bliss-apps/joy-web/static/locales/fr-CA/errors.3b25215e.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/fr-CA/eventCountdown.04bdd6e4.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/eventCountdownCustomComponent.a60b47f4.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/eventDetailsCustomComponent.07bb576f.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/eventDisplayNameCustomComponent.16570229.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/fr-CA/eventFormDisplay.b0ccddfa.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/fr-CA/eventMenu.35c9f84b.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/fr-CA/eventPersonGuest.611eab59.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/fr-CA/eventPhotoPicker.7104fde7.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/fr-CA/eventRedirect.debdbf9c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/fr-CA/eventServiceCenter.f0e4d2b6.json',
    eventSite: '/bliss-apps/joy-web/static/locales/fr-CA/eventSite.e0d048ed.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/fr-CA/eventSiteApps.59bb7a60.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/fr-CA/eventWorkspace.6c52cfe2.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/faqCustomComponent.2c52ac08.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/fr-CA/focusPoint.17281786.json',
    form: '/bliss-apps/joy-web/static/locales/fr-CA/form.4780fe7d.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/formCustomComponent.55ff1ef0.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/fr-CA/generalEventSchedule.cfad19df.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/fr-CA/generalEventScheduleEditor.b1e1d141.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/fr-CA/generalFormValidation.a18f9b27.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/fr-CA/getStartedOnboarding.8d6426a5.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/fr-CA/giftNoteGuest.8eed4b2c.json',
    graphError: '/bliss-apps/joy-web/static/locales/fr-CA/graphError.e4292486.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/graphicAccentCustomComponent.c75d911c.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/fr-CA/greetingMessageComponent.76ebedeb.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/fr-CA/groupMessaging.32d593c8.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/fr-CA/guestGuide.97fb21a0.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/fr-CA/guestInAppBrowserBanner.36f394cc.json',
    guestKit: '/bliss-apps/joy-web/static/locales/fr-CA/guestKit.8f7fadb5.json',
    guestList: '/bliss-apps/joy-web/static/locales/fr-CA/guestList.5aab55e5.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/guestRegistry.3b3388b9.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/fr-CA/guestSiteCustom.36a72db8.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/fr-CA/guestSiteTravel.e9b2eb84.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/fr-CA/guestSiteWelcome.df5b5af4.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/fr-CA/guestUnlock.f36818c5.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/fr-CA/headerHelpMenu.eeed9959.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/fr-CA/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/fr-CA/hotelBlock.7601df14.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/fr-CA/hotelReminder.ce84c1b8.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/fr-CA/hotelSearchGuest.54032fc4.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/fr-CA/hotelSuggestionDialog.f1e8b003.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/fr-CA/hotelTile.72494340.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/fr-CA/imageFilePicker.152aac68.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/fr-CA/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/fr-CA/impermissible.e2cfea56.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/fr-CA/inlineEditor.4f766ba9.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/instantRoomBlocksAdmin.ef57cf0d.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/fr-CA/instantRoomBlocksGuest.4e7b088a.json',
    joykit: '/bliss-apps/joy-web/static/locales/fr-CA/joykit.9cf7f25e.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/fr-CA/languagePickerV2.f7ff70b2.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/fr-CA/layoutEngine.212cc640.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/fr-CA/locationDatesOccupants.8ee923dd.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/fr-CA/locationVenueSyncDialog.5f725700.json',
    marcom: '/bliss-apps/joy-web/static/locales/fr-CA/marcom.552f5e26.json',
    message: '/bliss-apps/joy-web/static/locales/fr-CA/message.56d9b56e.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/fr-CA/messagesV2ServiceCenter.a4488095.json',
    messaging: '/bliss-apps/joy-web/static/locales/fr-CA/messaging.91bc0f9a.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/fr-CA/mothersDayDialog.fe212637.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/fr-CA/multiPhotoSelector.3c65ac98.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/fr-CA/pageNotFound.4c214cec.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/fr-CA/pageSettingsDialog.196aae12.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/fr-CA/peoplePicker.d02cd313.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/fr-CA/peoplePickerButton.bd06124d.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/fr-CA/photoDownloadGuest.267fbb35.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/fr-CA/photoGalleryLayout.097eadd6.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/fr-CA/photoPickerDialog.f7b1583f.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/fr-CA/photoUploader.f2e9de3f.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/fr-CA/pkpassGuest.295f2a23.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/fr-CA/placeToStayComponent.0a0e1d2d.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/fr-CA/placeToStayGuest.08161b91.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/fr-CA/planningAccommodations.3ea1bf8b.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/fr-CA/postcardRecipientsCustomizer.0b423269.json',
    postOffice: '/bliss-apps/joy-web/static/locales/fr-CA/postOffice.2d4df738.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/fr-CA/productSelectionDialog.4c84192c.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/promoCodeAdmin.20def637.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/fr-CA/promoCodeGuest.f005eb2e.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/fr-CA/publishReminder.dc17d161.json',
    qrCode: '/bliss-apps/joy-web/static/locales/fr-CA/qrCode.e683c0b0.json',
    registration: '/bliss-apps/joy-web/static/locales/fr-CA/registration.739a0525.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/fr-CA/registrationFormGuest.2ba2d301.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/fr-CA/registrationPostRsvp.55127690.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/fr-CA/registrationResumeGuest.edb122c6.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/fr-CA/registryChecklist.17ca9540.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/fr-CA/registryOnboardingSurvey.07a2502c.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/fr-CA/registryOnboardingSurveyV2.36dca48f.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/fr-CA/registryOnboardingV3Admin.04a04f4c.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/fr-CA/registryOverview.9330e5fd.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/fr-CA/replaceDefaultPhotos.6e14a986.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/fr-CA/richTextEditor.91bdf0c8.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/rsvpAdmin.3853f1fb.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/rsvpCustomComponent.ff5017b4.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/fr-CA/rsvpDeadlineStatus.f4a54fd6.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/fr-CA/rsvpReminder.8265e1be.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/fr-CA/rsvpSettings.f6748cbc.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/saveStateAdmin.688043f1.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/fr-CA/scheduleEditor.cf1867ce.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/fr-CA/seatingChart.88ee4516.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/fr-CA/serviceCenter.f3e2c330.json',
    settings: '/bliss-apps/joy-web/static/locales/fr-CA/settings.5ba14542.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/fr-CA/shareAccommodationsHost.62b248e5.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/fr-CA/sharedComponents.9b1369d0.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/fr-CA/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/sharedRegistry.a39981db.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/fr-CA/shareEditor.048ba998.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/fr-CA/shareRoomBlockHost.68559300.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/fr-CA/shareWebsiteDialog.4bc4eddf.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/fr-CA/shareYourStayGuest.f67dd341.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/siteStatusIndicatorAdmin.edf23791.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/slapAdsRegistry.7bbf1519.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/fr-CA/ssrServer.f6bf523b.json',
    stationery: '/bliss-apps/joy-web/static/locales/fr-CA/stationery.c390ad8a.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/fr-CA/stationeryCrossSell.4cbd5421.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/fr-CA/stationeryTemplateCategory.d7ea9d59.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/stayAreasAdmin.9e2f0cd6.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/fr-CA/stayAreasGuest.5ac0da46.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/fr-CA/stayBookingAssistant.1a1d23ad.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/fr-CA/stayDetailsGuest.f36ff481.json',
    stays: '/bliss-apps/joy-web/static/locales/fr-CA/stays.1c654002.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/fr-CA/staysRedesignGuest.4d2eb849.json',
    suggestions: '/bliss-apps/joy-web/static/locales/fr-CA/suggestions.f54a7ab2.json',
    survey: '/bliss-apps/joy-web/static/locales/fr-CA/survey.6eec271c.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/tagsAdmin.c9bfbe4f.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/textBlastAdmin.e8607ea6.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/fr-CA/thanksForRSVP.cd6a37bb.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/thingsToDoCustomComponent.68446375.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/ticketsAdmin.80029774.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/fr-CA/ticketsGuest.f327f72b.json',
    timePicker: '/bliss-apps/joy-web/static/locales/fr-CA/timePicker.c14dc879.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/fr-CA/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/fr-CA/timeZonePickerV2.b94291cb.json',
    tour: '/bliss-apps/joy-web/static/locales/fr-CA/tour.439253da.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/fr-CA/transferToBankDialog.a5530531.json',
    translation: '/bliss-apps/joy-web/static/locales/fr-CA/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/travelAdmin.67099576.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/fr-CA/travelEditor.ea3ecd09.json',
    travelMap: '/bliss-apps/joy-web/static/locales/fr-CA/travelMap.22be4b04.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/fr-CA/travelNativeCheckout.3aa05e9d.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/unifiedWebsiteEditorAdmin.d080ea3f.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/fr-CA/universalRecommendations.42fbc7db.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/fr-CA/unpublishedWebsite.409e2c85.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/fr-CA/updateScheduleDialog.18a39a39.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/validateGuestIdentityAdmin.96eccde3.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/fr-CA/verifyEmail.c59084e9.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/fr-CA/videoBackground.228ffe5c.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/fr-CA/videoHelper.2e27b4a1.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/fr-CA/VIPCustomComponent.43fe3fb1.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/fr-CA/VIPForm.f048ba82.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/fr-CA/weatherReportGuest.d0e5aecd.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/fr-CA/websiteCreate.f9b11ac6.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/fr-CA/websiteDesigner.c1ba7ca6.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/fr-CA/websiteEditor.8899c024.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/fr-CA/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/fr-CA/websiteOverview.9671405b.json',
    websitePages: '/bliss-apps/joy-web/static/locales/fr-CA/websitePages.38f59dbb.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/fr-CA/websitePhotosAdmin.606c477f.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/fr-CA/websitePreview.deb4d687.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/fr-CA/websiteV2Admin.8b1da955.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/fr-CA/websiteV2Guest.9451a99c.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/fr-CA/weddingParty.ea6fb333.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/fr-CA/yourRegistry.9b574b2f.json',
  },
  'fr-FR': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/accommodationsAdmin.9d3494ab.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/fr-FR/accommodationsConsole.d7c292bc.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/fr-FR/accommodationsGuest.e9e4fcb6.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/fr-FR/accommodationsShared.dafc7723.json',
    account: '/bliss-apps/joy-web/static/locales/fr-FR/account.33eef4e6.json',
    actionBar: '/bliss-apps/joy-web/static/locales/fr-FR/actionBar.31a89fb8.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/addFromFriendsRegistry.9adb7769.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/fr-FR/addressDialog.49b1531a.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/fr-FR/addToCalendar.7ed0cf9f.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/fr-FR/adminDashboardV2.7975d5c2.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/fr-FR/adminDashboardV3.f1e561ac.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/fr-FR/adminHeaderBar.cebf4c21.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/fr-FR/aiReviewTextarea.ba38ba94.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/allyPartnershipAdmin.c7fd755c.json',
    artUpload: '/bliss-apps/joy-web/static/locales/fr-FR/artUpload.d474ef92.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/fr-FR/autoPopulation.df34f13d.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/fr-FR/bookmarklet.1a60ad8a.json',
    budget: '/bliss-apps/joy-web/static/locales/fr-FR/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/fr-FR/cardGuest.7c82a6c4.json',
    carousel: '/bliss-apps/joy-web/static/locales/fr-FR/carousel.8e874448.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/fr-FR/carRentalConsole.00296068.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/cashFundsAdmin.20e250b2.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/fr-FR/cashFundsGuest.a425da19.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/fr-FR/cashFundsShared.24e2bf6f.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/fr-FR/cashFundsTransfer.1d821844.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/catalogRegistry.0c343727.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/checkInAdmin.df33491d.json',
    checklist: '/bliss-apps/joy-web/static/locales/fr-FR/checklist.4b444438.json',
    collaboration: '/bliss-apps/joy-web/static/locales/fr-FR/collaboration.717f3ca0.json',
    colors: '/bliss-apps/joy-web/static/locales/fr-FR/colors.90f25ff0.json',
    combobox: '/bliss-apps/joy-web/static/locales/fr-FR/combobox.f037afb8.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/commandPaletteAdmin.57a91de7.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/fr-FR/companyPolicies.41aa0462.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/fr-FR/contactCollector.2e838087.json',
    countries: '/bliss-apps/joy-web/static/locales/fr-FR/countries.bfc37f4b.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/createBabyRegistry.7beb5146.json',
    createEvent: '/bliss-apps/joy-web/static/locales/fr-FR/createEvent.74de480e.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/fr-FR/createGeneral.f2259d1d.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/createRegistry.7f9845a4.json',
    createWedding: '/bliss-apps/joy-web/static/locales/fr-FR/createWedding.a947f8ff.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/curationsRegistry.cbea32b4.json',
    currencies: '/bliss-apps/joy-web/static/locales/fr-FR/currencies.ad1b6b4c.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/fr-FR/currencySelectorV2.5e09f715.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/fr-FR/customBlockConfig.ad361912.json',
    customDomain: '/bliss-apps/joy-web/static/locales/fr-FR/customDomain.7c5308d0.json',
    customPage: '/bliss-apps/joy-web/static/locales/fr-FR/customPage.273ccadb.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/fr-FR/customPhotoPreviewButton.4dc6a582.json',
    dates: '/bliss-apps/joy-web/static/locales/fr-FR/dates.f9db5608.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/fr-FR/discountedRates.40143acb.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/fr-FR/emailPreferences.5bfc7a77.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/fr-FR/emailsAndEcards.826ab45d.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/emailTemplatesAdmin.79ba9720.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/fr-FR/emailVerification.9adb3bb2.json',
    errors: '/bliss-apps/joy-web/static/locales/fr-FR/errors.d1a13b7c.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/fr-FR/eventCountdown.04bdd6e4.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/eventCountdownCustomComponent.f2fddaee.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/eventDetailsCustomComponent.345a1bc7.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/eventDisplayNameCustomComponent.16570229.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/fr-FR/eventFormDisplay.2a8a162c.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/fr-FR/eventMenu.6d6221a3.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/fr-FR/eventPersonGuest.978e5ee8.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/fr-FR/eventPhotoPicker.7104fde7.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/fr-FR/eventRedirect.debdbf9c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/fr-FR/eventServiceCenter.6db30fb0.json',
    eventSite: '/bliss-apps/joy-web/static/locales/fr-FR/eventSite.015b30c5.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/fr-FR/eventSiteApps.d9631706.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/fr-FR/eventWorkspace.345d90de.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/faqCustomComponent.2a120019.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/fr-FR/focusPoint.17281786.json',
    form: '/bliss-apps/joy-web/static/locales/fr-FR/form.3cdae65e.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/formCustomComponent.e227655d.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/fr-FR/generalEventSchedule.5fd7dc60.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/fr-FR/generalEventScheduleEditor.9eb8b1eb.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/fr-FR/generalFormValidation.a18f9b27.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/fr-FR/getStartedOnboarding.7a6fcbda.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/fr-FR/giftNoteGuest.203515c4.json',
    graphError: '/bliss-apps/joy-web/static/locales/fr-FR/graphError.48fd3043.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/graphicAccentCustomComponent.2991ebc6.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/fr-FR/greetingMessageComponent.76ebedeb.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/fr-FR/groupMessaging.a6323ee0.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/fr-FR/guestGuide.778915ca.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/fr-FR/guestInAppBrowserBanner.36f394cc.json',
    guestKit: '/bliss-apps/joy-web/static/locales/fr-FR/guestKit.0054c519.json',
    guestList: '/bliss-apps/joy-web/static/locales/fr-FR/guestList.a9312ae1.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/guestRegistry.33e3040a.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/fr-FR/guestSiteCustom.77984bcb.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/fr-FR/guestSiteTravel.3587201a.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/fr-FR/guestSiteWelcome.df5b5af4.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/fr-FR/guestUnlock.eb6d4d31.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/fr-FR/headerHelpMenu.d2bb1dbc.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/fr-FR/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/fr-FR/hotelBlock.bc0d1704.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/fr-FR/hotelReminder.650a30c5.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/fr-FR/hotelSearchGuest.0ff12e5a.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/fr-FR/hotelSuggestionDialog.f7dc4727.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/fr-FR/hotelTile.fc2ef0ac.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/fr-FR/imageFilePicker.50c3eb9a.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/fr-FR/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/fr-FR/impermissible.68541b1e.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/fr-FR/inlineEditor.1c011642.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/instantRoomBlocksAdmin.fe833fc3.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/fr-FR/instantRoomBlocksGuest.41d15f93.json',
    joykit: '/bliss-apps/joy-web/static/locales/fr-FR/joykit.6c08cda9.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/fr-FR/languagePickerV2.6efa78dc.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/fr-FR/layoutEngine.4a73e512.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/fr-FR/locationDatesOccupants.5dbbde5b.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/fr-FR/locationVenueSyncDialog.7e0eb738.json',
    marcom: '/bliss-apps/joy-web/static/locales/fr-FR/marcom.3fffc180.json',
    message: '/bliss-apps/joy-web/static/locales/fr-FR/message.3dd7e28d.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/fr-FR/messagesV2ServiceCenter.b8af01d1.json',
    messaging: '/bliss-apps/joy-web/static/locales/fr-FR/messaging.f13a02ec.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/fr-FR/mothersDayDialog.8cb9e795.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/fr-FR/multiPhotoSelector.5bed2c06.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/fr-FR/pageNotFound.98544671.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/fr-FR/pageSettingsDialog.61a7be18.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/fr-FR/peoplePicker.ae5444f5.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/fr-FR/peoplePickerButton.131128dd.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/fr-FR/photoDownloadGuest.aa55e055.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/fr-FR/photoGalleryLayout.17d7d9ad.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/fr-FR/photoPickerDialog.36c2eb21.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/fr-FR/photoUploader.81bc9abf.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/fr-FR/pkpassGuest.136f3f50.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/fr-FR/placeToStayComponent.82ca960d.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/fr-FR/placeToStayGuest.08161b91.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/fr-FR/planningAccommodations.4362ea35.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/fr-FR/postcardRecipientsCustomizer.ec85fcd7.json',
    postOffice: '/bliss-apps/joy-web/static/locales/fr-FR/postOffice.638d3326.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/fr-FR/productSelectionDialog.ca14a09b.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/promoCodeAdmin.60f4ebec.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/fr-FR/promoCodeGuest.be073553.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/fr-FR/publishReminder.b2a28c14.json',
    qrCode: '/bliss-apps/joy-web/static/locales/fr-FR/qrCode.47a8487b.json',
    registration: '/bliss-apps/joy-web/static/locales/fr-FR/registration.b9177f4d.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/fr-FR/registrationFormGuest.91b8f826.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/fr-FR/registrationPostRsvp.be80507f.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/fr-FR/registrationResumeGuest.edb122c6.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/fr-FR/registryChecklist.f464cbd1.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/fr-FR/registryOnboardingSurvey.f8bddd6c.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/fr-FR/registryOnboardingSurveyV2.498aaa68.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/fr-FR/registryOnboardingV3Admin.166c61b5.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/fr-FR/registryOverview.8cffd0f3.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/fr-FR/replaceDefaultPhotos.9a2294ce.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/fr-FR/richTextEditor.7cf1937a.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/rsvpAdmin.5d19a204.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/rsvpCustomComponent.08193006.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/fr-FR/rsvpDeadlineStatus.ab499fb4.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/fr-FR/rsvpReminder.cbae6fe2.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/fr-FR/rsvpSettings.56796659.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/saveStateAdmin.7f8b7a3c.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/fr-FR/scheduleEditor.e41c897d.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/fr-FR/seatingChart.88ee4516.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/fr-FR/serviceCenter.77b99aa0.json',
    settings: '/bliss-apps/joy-web/static/locales/fr-FR/settings.16797e87.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/fr-FR/shareAccommodationsHost.b41aa1f7.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/fr-FR/sharedComponents.50c5fa08.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/fr-FR/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/sharedRegistry.fd634c5f.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/fr-FR/shareEditor.048ba998.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/fr-FR/shareRoomBlockHost.690174f9.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/fr-FR/shareWebsiteDialog.d97b5e45.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/fr-FR/shareYourStayGuest.ebb0a12c.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/siteStatusIndicatorAdmin.edf23791.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/slapAdsRegistry.08cc4724.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/fr-FR/ssrServer.4eb33790.json',
    stationery: '/bliss-apps/joy-web/static/locales/fr-FR/stationery.52c5a583.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/fr-FR/stationeryCrossSell.c5ef9490.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/fr-FR/stationeryTemplateCategory.2d0abecf.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/stayAreasAdmin.2b5ee852.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/fr-FR/stayAreasGuest.3387d3b0.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/fr-FR/stayBookingAssistant.d3687a38.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/fr-FR/stayDetailsGuest.5594c4ed.json',
    stays: '/bliss-apps/joy-web/static/locales/fr-FR/stays.b3a21956.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/fr-FR/staysRedesignGuest.8319b7d5.json',
    suggestions: '/bliss-apps/joy-web/static/locales/fr-FR/suggestions.b9e94df2.json',
    survey: '/bliss-apps/joy-web/static/locales/fr-FR/survey.9c5fe0ed.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/tagsAdmin.1adcee23.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/textBlastAdmin.ddb1cfbb.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/fr-FR/thanksForRSVP.9c480842.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/thingsToDoCustomComponent.bb1d3029.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/ticketsAdmin.a202de40.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/fr-FR/ticketsGuest.cc54d059.json',
    timePicker: '/bliss-apps/joy-web/static/locales/fr-FR/timePicker.75c2e41c.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/fr-FR/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/fr-FR/timeZonePickerV2.59aa9afa.json',
    tour: '/bliss-apps/joy-web/static/locales/fr-FR/tour.36f26aba.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/fr-FR/transferToBankDialog.38c168e3.json',
    translation: '/bliss-apps/joy-web/static/locales/fr-FR/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/travelAdmin.9a536827.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/fr-FR/travelEditor.7b80d6d6.json',
    travelMap: '/bliss-apps/joy-web/static/locales/fr-FR/travelMap.d684ee4c.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/fr-FR/travelNativeCheckout.0a0874fe.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/unifiedWebsiteEditorAdmin.d26b1126.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/fr-FR/universalRecommendations.c66b85fe.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/fr-FR/unpublishedWebsite.80cd8846.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/fr-FR/updateScheduleDialog.4c38cb15.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/validateGuestIdentityAdmin.ee542aea.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/fr-FR/verifyEmail.aa1c6a2e.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/fr-FR/videoBackground.d00e37a1.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/fr-FR/videoHelper.3495f2dd.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/fr-FR/VIPCustomComponent.ef842cfd.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/fr-FR/VIPForm.6ba6e58b.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/fr-FR/weatherReportGuest.9ca4add7.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/fr-FR/websiteCreate.e6945df4.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/fr-FR/websiteDesigner.fba698a7.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/fr-FR/websiteEditor.d772e0c4.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/fr-FR/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/fr-FR/websiteOverview.7c92be34.json',
    websitePages: '/bliss-apps/joy-web/static/locales/fr-FR/websitePages.9373323a.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/fr-FR/websitePhotosAdmin.2aacc630.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/fr-FR/websitePreview.633b5483.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/fr-FR/websiteV2Admin.6bd65de7.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/fr-FR/websiteV2Guest.9451a99c.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/fr-FR/weddingParty.26750c57.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/fr-FR/yourRegistry.3c67021b.json',
  },
  'it-IT': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/it-IT/accommodationsAdmin.ef72cdfe.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/it-IT/accommodationsConsole.32d305f9.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/it-IT/accommodationsGuest.e74eea41.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/it-IT/accommodationsShared.e3ba6386.json',
    account: '/bliss-apps/joy-web/static/locales/it-IT/account.d9c8ae8b.json',
    actionBar: '/bliss-apps/joy-web/static/locales/it-IT/actionBar.40ff99d1.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/it-IT/addFromFriendsRegistry.75443368.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/it-IT/addressDialog.5ab01125.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/it-IT/addToCalendar.a37cd626.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/it-IT/adminDashboardV2.527870c2.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/it-IT/adminDashboardV3.14df0c41.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/it-IT/adminHeaderBar.a2f2f62c.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/it-IT/aiReviewTextarea.d0695c2f.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/it-IT/allyPartnershipAdmin.b6050d54.json',
    artUpload: '/bliss-apps/joy-web/static/locales/it-IT/artUpload.24a61d74.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/it-IT/autoPopulation.e1d1ad62.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/it-IT/bookmarklet.5ce1d889.json',
    budget: '/bliss-apps/joy-web/static/locales/it-IT/budget.563b1538.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/it-IT/cardGuest.55cfee41.json',
    carousel: '/bliss-apps/joy-web/static/locales/it-IT/carousel.b82abf74.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/it-IT/carRentalConsole.72e77dff.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/it-IT/cashFundsAdmin.cfd69202.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/it-IT/cashFundsGuest.37d95ce9.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/it-IT/cashFundsShared.752786aa.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/it-IT/cashFundsTransfer.d1eeddbc.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/it-IT/catalogRegistry.05b6b969.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/it-IT/checkInAdmin.bd4bbddc.json',
    checklist: '/bliss-apps/joy-web/static/locales/it-IT/checklist.2a7f899e.json',
    collaboration: '/bliss-apps/joy-web/static/locales/it-IT/collaboration.0026c3c6.json',
    colors: '/bliss-apps/joy-web/static/locales/it-IT/colors.492d6bc6.json',
    combobox: '/bliss-apps/joy-web/static/locales/it-IT/combobox.c28668f0.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/it-IT/commandPaletteAdmin.67f14d43.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/it-IT/companyPolicies.0e2ae78f.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/it-IT/contactCollector.32861782.json',
    countries: '/bliss-apps/joy-web/static/locales/it-IT/countries.9bab4c1a.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/it-IT/createBabyRegistry.178b1b83.json',
    createEvent: '/bliss-apps/joy-web/static/locales/it-IT/createEvent.fbb3e843.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/it-IT/createGeneral.c9e0cbb1.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/it-IT/createRegistry.2fd3122f.json',
    createWedding: '/bliss-apps/joy-web/static/locales/it-IT/createWedding.ba899405.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/it-IT/curationsRegistry.32112bff.json',
    currencies: '/bliss-apps/joy-web/static/locales/it-IT/currencies.c89a2507.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/it-IT/currencySelectorV2.b2d2f131.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/it-IT/customBlockConfig.0ec57acb.json',
    customDomain: '/bliss-apps/joy-web/static/locales/it-IT/customDomain.daeb60e3.json',
    customPage: '/bliss-apps/joy-web/static/locales/it-IT/customPage.8cd99058.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/it-IT/customPhotoPreviewButton.63b50e68.json',
    dates: '/bliss-apps/joy-web/static/locales/it-IT/dates.1002b6a8.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/it-IT/discountedRates.f05c23e1.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/it-IT/emailPreferences.2380d828.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/it-IT/emailsAndEcards.8947a6a1.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/it-IT/emailTemplatesAdmin.acdbfb46.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/it-IT/emailVerification.6e7d3d5a.json',
    errors: '/bliss-apps/joy-web/static/locales/it-IT/errors.cd73ca01.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/it-IT/eventCountdown.8c366dfe.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/eventCountdownCustomComponent.913d5c7e.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/eventDetailsCustomComponent.54519c3e.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/eventDisplayNameCustomComponent.9304e420.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/it-IT/eventFormDisplay.cf955aa5.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/it-IT/eventMenu.5074bf91.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/it-IT/eventPersonGuest.0e883371.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/it-IT/eventPhotoPicker.379b93ba.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/it-IT/eventRedirect.912aa86b.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/it-IT/eventServiceCenter.6d2d5113.json',
    eventSite: '/bliss-apps/joy-web/static/locales/it-IT/eventSite.5cdc4516.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/it-IT/eventSiteApps.1f79e2c5.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/it-IT/eventWorkspace.520b5731.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/faqCustomComponent.d2598f24.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/it-IT/focusPoint.4c9f5b8a.json',
    form: '/bliss-apps/joy-web/static/locales/it-IT/form.af3b2250.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/formCustomComponent.6491d568.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/it-IT/generalEventSchedule.396c22c1.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/it-IT/generalEventScheduleEditor.10551f0b.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/it-IT/generalFormValidation.3411c95d.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/it-IT/getStartedOnboarding.eb89fe51.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/it-IT/giftNoteGuest.0947cad9.json',
    graphError: '/bliss-apps/joy-web/static/locales/it-IT/graphError.5c1bdbae.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/graphicAccentCustomComponent.ec2a07b5.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/it-IT/greetingMessageComponent.9640916f.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/it-IT/groupMessaging.b7dd16e1.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/it-IT/guestGuide.1fd4ce9d.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/it-IT/guestInAppBrowserBanner.a3fc161b.json',
    guestKit: '/bliss-apps/joy-web/static/locales/it-IT/guestKit.150ed246.json',
    guestList: '/bliss-apps/joy-web/static/locales/it-IT/guestList.3ef73176.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/it-IT/guestRegistry.22cc4a16.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/it-IT/guestSiteCustom.b3f91bce.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/it-IT/guestSiteTravel.35fba8d4.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/it-IT/guestSiteWelcome.2cb7c4b2.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/it-IT/guestUnlock.ffa679d3.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/it-IT/headerHelpMenu.0977cc15.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/it-IT/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/it-IT/hotelBlock.5779a725.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/it-IT/hotelReminder.0356bfb0.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/it-IT/hotelSearchGuest.960469aa.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/it-IT/hotelSuggestionDialog.ef022f26.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/it-IT/hotelTile.2563de3a.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/it-IT/imageFilePicker.8401fbc3.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/it-IT/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/it-IT/impermissible.38de9dfd.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/it-IT/inlineEditor.add6ba67.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/it-IT/instantRoomBlocksAdmin.7989c15a.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/it-IT/instantRoomBlocksGuest.73de6e05.json',
    joykit: '/bliss-apps/joy-web/static/locales/it-IT/joykit.37c60d52.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/it-IT/languagePickerV2.04314fbe.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/it-IT/layoutEngine.e85842b3.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/it-IT/locationDatesOccupants.04b906d9.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/it-IT/locationVenueSyncDialog.761b687e.json',
    marcom: '/bliss-apps/joy-web/static/locales/it-IT/marcom.cc2e7d61.json',
    message: '/bliss-apps/joy-web/static/locales/it-IT/message.a1e4a640.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/it-IT/messagesV2ServiceCenter.91bb8349.json',
    messaging: '/bliss-apps/joy-web/static/locales/it-IT/messaging.3e992f64.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/it-IT/mothersDayDialog.01becad3.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/it-IT/multiPhotoSelector.fab7631b.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/it-IT/pageNotFound.46094875.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/it-IT/pageSettingsDialog.698e90ae.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/it-IT/peoplePicker.9b15a046.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/it-IT/peoplePickerButton.85048528.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/it-IT/photoDownloadGuest.f072b259.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/it-IT/photoGalleryLayout.b7e659ce.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/it-IT/photoPickerDialog.5e729d7b.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/it-IT/photoUploader.5b51a07d.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/it-IT/pkpassGuest.4d02d2c8.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/it-IT/placeToStayComponent.4825ba08.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/it-IT/placeToStayGuest.4eb53392.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/it-IT/planningAccommodations.9b1138df.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/it-IT/postcardRecipientsCustomizer.f62a1683.json',
    postOffice: '/bliss-apps/joy-web/static/locales/it-IT/postOffice.a119b724.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/it-IT/productSelectionDialog.8b15d598.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/it-IT/promoCodeAdmin.b5931464.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/it-IT/promoCodeGuest.2056e551.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/it-IT/publishReminder.f4ee6b27.json',
    qrCode: '/bliss-apps/joy-web/static/locales/it-IT/qrCode.1904e8df.json',
    registration: '/bliss-apps/joy-web/static/locales/it-IT/registration.82f69b67.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/it-IT/registrationFormGuest.8f0bd5bc.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/it-IT/registrationPostRsvp.76e63fae.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/it-IT/registrationResumeGuest.1fb51a81.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/it-IT/registryChecklist.2c087b7d.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/it-IT/registryOnboardingSurvey.3d2946c1.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/it-IT/registryOnboardingSurveyV2.3eda1fc3.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/it-IT/registryOnboardingV3Admin.a8bc14b2.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/it-IT/registryOverview.b7c6abe5.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/it-IT/replaceDefaultPhotos.53898571.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/it-IT/richTextEditor.2cef1fd4.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/it-IT/rsvpAdmin.cdd04a37.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/rsvpCustomComponent.9411a743.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/it-IT/rsvpDeadlineStatus.ee56f37f.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/it-IT/rsvpReminder.933c88b4.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/it-IT/rsvpSettings.f1d28c69.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/it-IT/saveStateAdmin.efe99ad7.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/it-IT/scheduleEditor.1d77d22f.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/it-IT/seatingChart.24513eee.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/it-IT/serviceCenter.1e6ab5a0.json',
    settings: '/bliss-apps/joy-web/static/locales/it-IT/settings.d52995fb.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/it-IT/shareAccommodationsHost.9dcc892e.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/it-IT/sharedComponents.915fc8c2.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/it-IT/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/it-IT/sharedRegistry.456df95b.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/it-IT/shareEditor.7a8795cd.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/it-IT/shareRoomBlockHost.7774be59.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/it-IT/shareWebsiteDialog.70b4685f.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/it-IT/shareYourStayGuest.1cd31f54.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/it-IT/siteStatusIndicatorAdmin.565ab8bd.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/it-IT/slapAdsRegistry.91fbc37a.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/it-IT/ssrServer.b1243000.json',
    stationery: '/bliss-apps/joy-web/static/locales/it-IT/stationery.1b051c09.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/it-IT/stationeryCrossSell.e9860c1e.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/it-IT/stationeryTemplateCategory.15df879e.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/it-IT/stayAreasAdmin.ecfcc389.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/it-IT/stayAreasGuest.f09e4f4a.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/it-IT/stayBookingAssistant.900676f0.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/it-IT/stayDetailsGuest.ce791477.json',
    stays: '/bliss-apps/joy-web/static/locales/it-IT/stays.ab7cbdae.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/it-IT/staysRedesignGuest.e4e4b9e5.json',
    suggestions: '/bliss-apps/joy-web/static/locales/it-IT/suggestions.54e0b282.json',
    survey: '/bliss-apps/joy-web/static/locales/it-IT/survey.b3d829f9.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/it-IT/tagsAdmin.f953cfad.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/it-IT/textBlastAdmin.2ff27b7a.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/it-IT/thanksForRSVP.f6260035.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/thingsToDoCustomComponent.c69682d5.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/it-IT/ticketsAdmin.38083603.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/it-IT/ticketsGuest.4f8e03ea.json',
    timePicker: '/bliss-apps/joy-web/static/locales/it-IT/timePicker.a3aa36e4.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/it-IT/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/it-IT/timeZonePickerV2.74a1683c.json',
    tour: '/bliss-apps/joy-web/static/locales/it-IT/tour.aac677d1.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/it-IT/transferToBankDialog.55b9d786.json',
    translation: '/bliss-apps/joy-web/static/locales/it-IT/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/it-IT/travelAdmin.59c80bd3.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/it-IT/travelEditor.55d06c9d.json',
    travelMap: '/bliss-apps/joy-web/static/locales/it-IT/travelMap.384b2f4c.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/it-IT/travelNativeCheckout.6930fcdb.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/it-IT/unifiedWebsiteEditorAdmin.6fb4581c.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/it-IT/universalRecommendations.2e6520e7.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/it-IT/unpublishedWebsite.080c9752.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/it-IT/updateScheduleDialog.f4e014f3.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/it-IT/validateGuestIdentityAdmin.e928956e.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/it-IT/verifyEmail.3a509401.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/it-IT/videoBackground.06e4f813.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/it-IT/videoHelper.e92f73ed.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/it-IT/VIPCustomComponent.bad02402.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/it-IT/VIPForm.9e51d7d2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/it-IT/weatherReportGuest.78527a0a.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/it-IT/websiteCreate.2523d462.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/it-IT/websiteDesigner.65ac2270.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/it-IT/websiteEditor.0a4eb327.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/it-IT/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/it-IT/websiteOverview.6abc7ede.json',
    websitePages: '/bliss-apps/joy-web/static/locales/it-IT/websitePages.1220adb4.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/it-IT/websitePhotosAdmin.640e006a.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/it-IT/websitePreview.fdc914b0.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/it-IT/websiteV2Admin.11846281.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/it-IT/websiteV2Guest.d944a896.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/it-IT/weddingParty.fa8ba790.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/it-IT/yourRegistry.057666fd.json',
  },
  'ja-JP': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/accommodationsAdmin.bcb90931.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/ja-JP/accommodationsConsole.3c856651.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/ja-JP/accommodationsGuest.1b9112a6.json',
    accommodationsShared: '/bliss-apps/joy-web/static/locales/ja-JP/accommodationsShared.a4d706e1.json',
    account: '/bliss-apps/joy-web/static/locales/ja-JP/account.e9e664a3.json',
    actionBar: '/bliss-apps/joy-web/static/locales/ja-JP/actionBar.4ff4b88d.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/addFromFriendsRegistry.60b2d73a.json',
    addressDialog: '/bliss-apps/joy-web/static/locales/ja-JP/addressDialog.2ad3235a.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/ja-JP/addToCalendar.85f70159.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/ja-JP/adminDashboardV2.330d40c9.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/ja-JP/adminDashboardV3.a9cb61e0.json',
    adminHeaderBar: '/bliss-apps/joy-web/static/locales/ja-JP/adminHeaderBar.da68c531.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/ja-JP/aiReviewTextarea.dd6140b2.json',
    allyPartnershipAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/allyPartnershipAdmin.cd786205.json',
    artUpload: '/bliss-apps/joy-web/static/locales/ja-JP/artUpload.5d499615.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/ja-JP/autoPopulation.d13d8aae.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/ja-JP/bookmarklet.6ec98994.json',
    budget: '/bliss-apps/joy-web/static/locales/ja-JP/budget.c1566af3.json',
    cardGuest: '/bliss-apps/joy-web/static/locales/ja-JP/cardGuest.cb3e6d1a.json',
    carousel: '/bliss-apps/joy-web/static/locales/ja-JP/carousel.a683cce3.json',
    carRentalConsole: '/bliss-apps/joy-web/static/locales/ja-JP/carRentalConsole.1fdbbe6c.json',
    cashFundsAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/cashFundsAdmin.c02d0ba6.json',
    cashFundsGuest: '/bliss-apps/joy-web/static/locales/ja-JP/cashFundsGuest.38afb4db.json',
    cashFundsShared: '/bliss-apps/joy-web/static/locales/ja-JP/cashFundsShared.a29c6861.json',
    cashFundsTransfer: '/bliss-apps/joy-web/static/locales/ja-JP/cashFundsTransfer.699212e1.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/catalogRegistry.6ddad481.json',
    checkInAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/checkInAdmin.44275534.json',
    checklist: '/bliss-apps/joy-web/static/locales/ja-JP/checklist.7317853a.json',
    collaboration: '/bliss-apps/joy-web/static/locales/ja-JP/collaboration.3b3ca78c.json',
    colors: '/bliss-apps/joy-web/static/locales/ja-JP/colors.07f7ec05.json',
    combobox: '/bliss-apps/joy-web/static/locales/ja-JP/combobox.02c7f895.json',
    commandPaletteAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/commandPaletteAdmin.06f2e8a5.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/ja-JP/companyPolicies.19bfdf42.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/ja-JP/contactCollector.0e382302.json',
    countries: '/bliss-apps/joy-web/static/locales/ja-JP/countries.739545d4.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/createBabyRegistry.6335c21e.json',
    createEvent: '/bliss-apps/joy-web/static/locales/ja-JP/createEvent.97fd69be.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/ja-JP/createGeneral.2b80b250.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/createRegistry.ff37c072.json',
    createWedding: '/bliss-apps/joy-web/static/locales/ja-JP/createWedding.b29d8ee6.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/curationsRegistry.c6e18a85.json',
    currencies: '/bliss-apps/joy-web/static/locales/ja-JP/currencies.04ee72dd.json',
    currencySelectorV2: '/bliss-apps/joy-web/static/locales/ja-JP/currencySelectorV2.3f1958a5.json',
    customBlockConfig: '/bliss-apps/joy-web/static/locales/ja-JP/customBlockConfig.88cf2abb.json',
    customDomain: '/bliss-apps/joy-web/static/locales/ja-JP/customDomain.923898ff.json',
    customPage: '/bliss-apps/joy-web/static/locales/ja-JP/customPage.1b0ba3c3.json',
    customPhotoPreviewButton: '/bliss-apps/joy-web/static/locales/ja-JP/customPhotoPreviewButton.1f2a7879.json',
    dates: '/bliss-apps/joy-web/static/locales/ja-JP/dates.5cef61ab.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/ja-JP/discountedRates.fbce3140.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/ja-JP/emailPreferences.6e57c351.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/ja-JP/emailsAndEcards.83652001.json',
    emailTemplatesAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/emailTemplatesAdmin.fa79ff95.json',
    emailVerification: '/bliss-apps/joy-web/static/locales/ja-JP/emailVerification.19c1ddfe.json',
    errors: '/bliss-apps/joy-web/static/locales/ja-JP/errors.f89dd690.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/ja-JP/eventCountdown.f827a000.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/eventCountdownCustomComponent.1241f198.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/eventDetailsCustomComponent.da46f4b1.json',
    eventDisplayNameCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/eventDisplayNameCustomComponent.54f22caa.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/ja-JP/eventFormDisplay.f40685f1.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/ja-JP/eventMenu.e89e4a1b.json',
    eventPersonGuest: '/bliss-apps/joy-web/static/locales/ja-JP/eventPersonGuest.14f4dde6.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/ja-JP/eventPhotoPicker.50734e8c.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/ja-JP/eventRedirect.8e4694cc.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/ja-JP/eventServiceCenter.d6415b57.json',
    eventSite: '/bliss-apps/joy-web/static/locales/ja-JP/eventSite.8bb3aa69.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/ja-JP/eventSiteApps.8b085157.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/ja-JP/eventWorkspace.109ab144.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/faqCustomComponent.83fde3dd.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/ja-JP/focusPoint.43ab1376.json',
    form: '/bliss-apps/joy-web/static/locales/ja-JP/form.4fbee28c.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/formCustomComponent.77b89737.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/ja-JP/generalEventSchedule.ddef193f.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/ja-JP/generalEventScheduleEditor.b75d78fd.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/ja-JP/generalFormValidation.c0b29618.json',
    getStartedOnboarding: '/bliss-apps/joy-web/static/locales/ja-JP/getStartedOnboarding.2a06407b.json',
    giftNoteGuest: '/bliss-apps/joy-web/static/locales/ja-JP/giftNoteGuest.0616841f.json',
    graphError: '/bliss-apps/joy-web/static/locales/ja-JP/graphError.5104150d.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/graphicAccentCustomComponent.499eb3f4.json',
    greetingMessageComponent: '/bliss-apps/joy-web/static/locales/ja-JP/greetingMessageComponent.1e493c89.json',
    groupMessaging: '/bliss-apps/joy-web/static/locales/ja-JP/groupMessaging.4a08d1ea.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/ja-JP/guestGuide.163804f0.json',
    guestInAppBrowserBanner: '/bliss-apps/joy-web/static/locales/ja-JP/guestInAppBrowserBanner.32039352.json',
    guestKit: '/bliss-apps/joy-web/static/locales/ja-JP/guestKit.ba3f34d7.json',
    guestList: '/bliss-apps/joy-web/static/locales/ja-JP/guestList.5f1498e0.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/guestRegistry.50205b70.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/ja-JP/guestSiteCustom.dc4b769a.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/ja-JP/guestSiteTravel.14174712.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/ja-JP/guestSiteWelcome.5f94a7d2.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/ja-JP/guestUnlock.5d63d9e4.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/ja-JP/headerHelpMenu.2ea56b76.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/ja-JP/headerLayoutUpgrade.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/ja-JP/hotelBlock.59508de3.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/ja-JP/hotelReminder.5fb08870.json',
    hotelSearchGuest: '/bliss-apps/joy-web/static/locales/ja-JP/hotelSearchGuest.7671de6c.json',
    hotelSuggestionDialog: '/bliss-apps/joy-web/static/locales/ja-JP/hotelSuggestionDialog.4bfdfff2.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/ja-JP/hotelTile.fbef4474.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/ja-JP/imageFilePicker.b0efeba4.json',
    imagineYourCard: '/bliss-apps/joy-web/static/locales/ja-JP/imagineYourCard.99914b93.json',
    impermissible: '/bliss-apps/joy-web/static/locales/ja-JP/impermissible.b50bb494.json',
    inlineEditor: '/bliss-apps/joy-web/static/locales/ja-JP/inlineEditor.fe5cf5d3.json',
    instantRoomBlocksAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/instantRoomBlocksAdmin.296e5642.json',
    instantRoomBlocksGuest: '/bliss-apps/joy-web/static/locales/ja-JP/instantRoomBlocksGuest.bac6ff53.json',
    joykit: '/bliss-apps/joy-web/static/locales/ja-JP/joykit.c111821f.json',
    languagePickerV2: '/bliss-apps/joy-web/static/locales/ja-JP/languagePickerV2.d724e223.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/ja-JP/layoutEngine.14ad3d78.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/ja-JP/locationDatesOccupants.89a18ce8.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/ja-JP/locationVenueSyncDialog.bbb236ed.json',
    marcom: '/bliss-apps/joy-web/static/locales/ja-JP/marcom.8b17f0a9.json',
    message: '/bliss-apps/joy-web/static/locales/ja-JP/message.7f15fd3d.json',
    messagesV2ServiceCenter: '/bliss-apps/joy-web/static/locales/ja-JP/messagesV2ServiceCenter.5596bebf.json',
    messaging: '/bliss-apps/joy-web/static/locales/ja-JP/messaging.7223b675.json',
    mothersDayDialog: '/bliss-apps/joy-web/static/locales/ja-JP/mothersDayDialog.45fbc3cd.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/ja-JP/multiPhotoSelector.be6a2c34.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/ja-JP/pageNotFound.715b14bf.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/ja-JP/pageSettingsDialog.6ee2b668.json',
    peoplePicker: '/bliss-apps/joy-web/static/locales/ja-JP/peoplePicker.b6abf655.json',
    peoplePickerButton: '/bliss-apps/joy-web/static/locales/ja-JP/peoplePickerButton.351f05c3.json',
    photoDownloadGuest: '/bliss-apps/joy-web/static/locales/ja-JP/photoDownloadGuest.46b6be43.json',
    photoGalleryLayout: '/bliss-apps/joy-web/static/locales/ja-JP/photoGalleryLayout.d7006e1a.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/ja-JP/photoPickerDialog.224b93e8.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/ja-JP/photoUploader.9ad17e87.json',
    pkpassGuest: '/bliss-apps/joy-web/static/locales/ja-JP/pkpassGuest.3b76fca0.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/ja-JP/placeToStayComponent.cb23cf3c.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/ja-JP/placeToStayGuest.314968b0.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/ja-JP/planningAccommodations.c0d4b766.json',
    postcardRecipientsCustomizer: '/bliss-apps/joy-web/static/locales/ja-JP/postcardRecipientsCustomizer.c0371036.json',
    postOffice: '/bliss-apps/joy-web/static/locales/ja-JP/postOffice.966af27a.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/ja-JP/productSelectionDialog.0d705693.json',
    promoCodeAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/promoCodeAdmin.ce557e0b.json',
    promoCodeGuest: '/bliss-apps/joy-web/static/locales/ja-JP/promoCodeGuest.3720dd7f.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/ja-JP/publishReminder.cf061fe5.json',
    qrCode: '/bliss-apps/joy-web/static/locales/ja-JP/qrCode.05d3fefd.json',
    registration: '/bliss-apps/joy-web/static/locales/ja-JP/registration.fa12b65a.json',
    registrationFormGuest: '/bliss-apps/joy-web/static/locales/ja-JP/registrationFormGuest.412326a3.json',
    registrationPostRsvp: '/bliss-apps/joy-web/static/locales/ja-JP/registrationPostRsvp.936814d3.json',
    registrationResumeGuest: '/bliss-apps/joy-web/static/locales/ja-JP/registrationResumeGuest.89447bb4.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/ja-JP/registryChecklist.b2d1876e.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/ja-JP/registryOnboardingSurvey.b09d1883.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/ja-JP/registryOnboardingSurveyV2.732cd0d1.json',
    registryOnboardingV3Admin: '/bliss-apps/joy-web/static/locales/ja-JP/registryOnboardingV3Admin.6b99ecb7.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/ja-JP/registryOverview.18dd15e1.json',
    replaceDefaultPhotos: '/bliss-apps/joy-web/static/locales/ja-JP/replaceDefaultPhotos.d38d85df.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/ja-JP/richTextEditor.2e6ea102.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/rsvpAdmin.1c90ac11.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/rsvpCustomComponent.bf37656f.json',
    rsvpDeadlineStatus: '/bliss-apps/joy-web/static/locales/ja-JP/rsvpDeadlineStatus.db7c22b5.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/ja-JP/rsvpReminder.c0d80cac.json',
    rsvpSettings: '/bliss-apps/joy-web/static/locales/ja-JP/rsvpSettings.f1a1a6fc.json',
    saveStateAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/saveStateAdmin.17261024.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/ja-JP/scheduleEditor.f259263b.json',
    seatingChart: '/bliss-apps/joy-web/static/locales/ja-JP/seatingChart.15d48d27.json',
    serviceCenter: '/bliss-apps/joy-web/static/locales/ja-JP/serviceCenter.2aaa4f62.json',
    settings: '/bliss-apps/joy-web/static/locales/ja-JP/settings.51f1e208.json',
    shareAccommodationsHost: '/bliss-apps/joy-web/static/locales/ja-JP/shareAccommodationsHost.80e3d115.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/ja-JP/sharedComponents.8a0feaf8.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/ja-JP/shareDialog.99914b93.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/sharedRegistry.844548d8.json',
    shareEditor: '/bliss-apps/joy-web/static/locales/ja-JP/shareEditor.ccc757ab.json',
    shareRoomBlockHost: '/bliss-apps/joy-web/static/locales/ja-JP/shareRoomBlockHost.17f874ea.json',
    shareWebsiteDialog: '/bliss-apps/joy-web/static/locales/ja-JP/shareWebsiteDialog.aef93f22.json',
    shareYourStayGuest: '/bliss-apps/joy-web/static/locales/ja-JP/shareYourStayGuest.ae176df8.json',
    siteStatusIndicatorAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/siteStatusIndicatorAdmin.49f400c9.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/slapAdsRegistry.ab7a18d5.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/ja-JP/ssrServer.01cf6742.json',
    stationery: '/bliss-apps/joy-web/static/locales/ja-JP/stationery.4b31c5ba.json',
    stationeryCrossSell: '/bliss-apps/joy-web/static/locales/ja-JP/stationeryCrossSell.8175cca5.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/ja-JP/stationeryTemplateCategory.295cca4a.json',
    stayAreasAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/stayAreasAdmin.84e1d10d.json',
    stayAreasGuest: '/bliss-apps/joy-web/static/locales/ja-JP/stayAreasGuest.51aa81e2.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/ja-JP/stayBookingAssistant.d3117ca5.json',
    stayDetailsGuest: '/bliss-apps/joy-web/static/locales/ja-JP/stayDetailsGuest.a7689ba7.json',
    stays: '/bliss-apps/joy-web/static/locales/ja-JP/stays.1a47e162.json',
    staysRedesignGuest: '/bliss-apps/joy-web/static/locales/ja-JP/staysRedesignGuest.1fb4d7c5.json',
    suggestions: '/bliss-apps/joy-web/static/locales/ja-JP/suggestions.52dd3c6a.json',
    survey: '/bliss-apps/joy-web/static/locales/ja-JP/survey.05d2548d.json',
    tagsAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/tagsAdmin.c943ff83.json',
    textBlastAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/textBlastAdmin.b1e16888.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/ja-JP/thanksForRSVP.f3dc04dc.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/thingsToDoCustomComponent.61199d8e.json',
    ticketsAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/ticketsAdmin.e2e6160b.json',
    ticketsGuest: '/bliss-apps/joy-web/static/locales/ja-JP/ticketsGuest.fe391ab7.json',
    timePicker: '/bliss-apps/joy-web/static/locales/ja-JP/timePicker.8f26adc1.json',
    timeZonePicker: '/bliss-apps/joy-web/static/locales/ja-JP/timeZonePicker.99914b93.json',
    timeZonePickerV2: '/bliss-apps/joy-web/static/locales/ja-JP/timeZonePickerV2.86f7465c.json',
    tour: '/bliss-apps/joy-web/static/locales/ja-JP/tour.2e0e1203.json',
    transferToBankDialog: '/bliss-apps/joy-web/static/locales/ja-JP/transferToBankDialog.570590e6.json',
    translation: '/bliss-apps/joy-web/static/locales/ja-JP/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/travelAdmin.9234b4aa.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/ja-JP/travelEditor.42ca6be4.json',
    travelMap: '/bliss-apps/joy-web/static/locales/ja-JP/travelMap.77dc4f94.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/ja-JP/travelNativeCheckout.8cc65b2e.json',
    unifiedWebsiteEditorAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/unifiedWebsiteEditorAdmin.1c087729.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/ja-JP/universalRecommendations.020b9c61.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/ja-JP/unpublishedWebsite.eb9806a9.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/ja-JP/updateScheduleDialog.d4d306e2.json',
    validateGuestIdentityAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/validateGuestIdentityAdmin.90f0e484.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/ja-JP/verifyEmail.695c0219.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/ja-JP/videoBackground.d85ea50a.json',
    videoHelper: '/bliss-apps/joy-web/static/locales/ja-JP/videoHelper.83f71828.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/ja-JP/VIPCustomComponent.0cc2ada1.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/ja-JP/VIPForm.4b3e47b1.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/ja-JP/weatherReportGuest.864c388d.json',
    websiteCreate: '/bliss-apps/joy-web/static/locales/ja-JP/websiteCreate.75a5cfae.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/ja-JP/websiteDesigner.3defc884.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/ja-JP/websiteEditor.df0c3002.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/ja-JP/websiteHeader.1df51243.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/ja-JP/websiteOverview.5ef9a7ec.json',
    websitePages: '/bliss-apps/joy-web/static/locales/ja-JP/websitePages.7687a687.json',
    websitePhotosAdmin: '/bliss-apps/joy-web/static/locales/ja-JP/websitePhotosAdmin.5b5982c0.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/ja-JP/websitePreview.812caef9.json',
    websiteV2Admin: '/bliss-apps/joy-web/static/locales/ja-JP/websiteV2Admin.b808d846.json',
    websiteV2Guest: '/bliss-apps/joy-web/static/locales/ja-JP/websiteV2Guest.ba9f2f1a.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/ja-JP/weddingParty.91e34fea.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/ja-JP/yourRegistry.d63bf8b9.json',
  },
};
